require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/035fa71f751b1ddc93f5f9520f1c1dba/code.js', () => { 

BackendlessUI.Functions.Custom['fn_035fa71f751b1ddc93f5f9520f1c1dba'] = async function fn_035fa71f751b1ddc93f5f9520f1c1dba(Style, Component, Delay) {
var Counter;


  Style['opacity'] = 0;
  Component['display'] = true;
  for (var count2 = 0; count2 < 1; count2++) {
    Counter = 0;
    for (var count = 0; count < 100; count++) {
      Style['opacity'] = Counter;
      await new Promise(r => setTimeout(r, 10 || 0));
      Counter = Counter + 0.01;
    }
  }

}

})
define('./functions/04c9e63b986e313f0e38c54373e1b64d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_04c9e63b986e313f0e38c54373e1b64d'] = async function fn_04c9e63b986e313f0e38c54373e1b64d(Description, Polyline, Color, Opacity) {
var Polyline, newlist, Counter, Number2, Data, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Data = (await (async function(Data) {
  	function decode() {
  	  var encodedPolyline = Data;
  	  var coords = polyline.toGeoJSON(encodedPolyline);
  	  return coords
  	}
  	
  	var polyline = {};
  	
  	function encode(current, previous, factor) {
  	  current = Math.round(current * factor);
  	  previous = Math.round(previous * factor);
  	  var coordinate = current - previous;
  	  coordinate <<= 1;
  	  if (current - previous < 0) {
  	    coordinate = ~coordinate;
  	  }
  	  var output = '';
  	  while (coordinate >= 0x20) {
  	    output += String.fromCharCode((0x20 | (coordinate & 0x1f)) + 63);
  	    coordinate >>= 5;
  	  }
  	  output += String.fromCharCode(coordinate + 63);
  	  return output;
  	}
  	
  	/**
  	 * Decodes to a [latitude, longitude] coordinates array.
  	 *
  	 * This is adapted from the implementation in Project-OSRM.
  	 *
  	 * @param {String} str
  	 * @param {Number} precision
  	 * @returns {Array}
  	 *
  	 * @see https://github.com/Project-OSRM/osrm-frontend/blob/master/WebContent/routing/OSRM.RoutingGeometry.js
  	 */
  	polyline.decode = function(str, precision) {
  	  var index = 0,
  	    lat = 0,
  	    lng = 0,
  	    coordinates = [],
  	    shift = 0,
  	    result = 0,
  	    byte = null,
  	    latitude_change,
  	    longitude_change,
  	    factor = Math.pow(10, precision || 5);
  	
  	  // Coordinates have variable length when encoded, so just keep
  	  // track of whether we've hit the end of the string. In each
  	  // loop iteration, a single coordinate is decoded.
  	  while (index < str.length) {
  	
  	    // Reset shift, result, and byte
  	    byte = null;
  	    shift = 0;
  	    result = 0;
  	
  	    do {
  	      byte = str.charCodeAt(index++) - 63;
  	      result |= (byte & 0x1f) << shift;
  	      shift += 5;
  	    } while (byte >= 0x20);
  	
  	    latitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));
  	
  	    shift = result = 0;
  	
  	    do {
  	      byte = str.charCodeAt(index++) - 63;
  	      result |= (byte & 0x1f) << shift;
  	      shift += 5;
  	    } while (byte >= 0x20);
  	
  	    longitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));
  	
  	    lat += latitude_change;
  	    lng += longitude_change;
  	
  	    coordinates.push([lat / factor, lng / factor]);
  	  }
  	
  	  return coordinates;
  	};
  	
  	/**
  	 * Encodes the given [latitude, longitude] coordinates array.
  	 *
  	 * @param {Array.<Array.<Number>>} coordinates
  	 * @param {Number} precision
  	 * @returns {String}
  	 */
  	polyline.encode = function(coordinates, precision) {
  	  if (!coordinates.length) {
  	    return '';
  	  }
  	
  	  var factor = Math.pow(10, precision || 5),
  	    output = encode(coordinates[0][0], 0, factor) + encode(coordinates[0][1], 0, factor);
  	
  	  for (var i = 1; i < coordinates.length; i++) {
  	    var a = coordinates[i],
  	      b = coordinates[i - 1];
  	    output += encode(a[0], b[0], factor);
  	    output += encode(a[1], b[1], factor);
  	  }
  	
  	  return output;
  	};
  	
  	function flipped(coords) {
  	  var flipped = [];
  	  for (var i = 0; i < coords.length; i++) {
  	    flipped.push(coords[i].slice().reverse());
  	  }
  	  return flipped;
  	}
  	
  	/**
  	 * Encodes a GeoJSON LineString feature/geometry.
  	 *
  	 * @param {Object} geojson
  	 * @param {Number} precision
  	 * @returns {String}
  	 */
  	polyline.fromGeoJSON = function(geojson, precision) {
  	  if (geojson && geojson.type === 'Feature') {
  	    geojson = geojson.geometry;
  	  }
  	  if (!geojson || geojson.type !== 'LineString') {
  	    throw new Error('Input must be a GeoJSON LineString');
  	  }
  	  return polyline.encode(flipped(geojson.coordinates), precision);
  	};
  	
  	/**
  	 * Decodes to a GeoJSON LineString geometry.
  	 *
  	 * @param {String} str
  	 * @param {Number} precision
  	 * @returns {Object}
  	 */
  	polyline.toGeoJSON = function(str, precision) {
  	  var coords = polyline.decode(str, precision);
  	  return {
  	    type: 'LineString',
  	    coordinates: flipped(coords)
  	  };
  	};
  	
  	if (typeof module === 'object' && module.exports) {
  	  module.exports = polyline;
  	}
  	return decode()
  })(Polyline));
  newlist = (await Promise.all((getObjectProperty(Data, 'coordinates')).map(async item => {; return ({ [`lat`]: item.slice(-1)[0] * 1,[`lng`]: item[0] * 1 });})));
  Number2 = (getObjectProperty(Data, 'coordinates')).length;
  Counter = 0;
  for (var count = 0; count < Number2; count++) {
    addItemToList(newlist, ({ [`lat`]: (getObjectProperty(Data, 'coordinates'))[((Number2 - Counter) - 1)].slice(-1)[0] + 0,[`lng`]: (getObjectProperty(Data, 'coordinates'))[((Number2 - Counter) - 1)][0] + 0 }));
    Counter = Counter + 1;
  }
  Polyline = ({ [`color`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Color)) ? '#CC5500' : Color,[`description`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Description)) ? 'Polygon' : Description,[`opacity`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Opacity)) ? 0.5 : Opacity,[`polygon`]: ({ [`boundary`]: ({ [`points`]: newlist }) }),[`outlineWidth`]: 10,[`outlineColor`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Color)) ? '#CC5500' : Color });

return Polyline
}

})
define('./functions/082567e4c9a28272acac08042731a4be/code.js', () => { 

BackendlessUI.Functions.Custom['fn_082567e4c9a28272acac08042731a4be'] = async function fn_082567e4c9a28272acac08042731a4be(List, ReturnERROR) {
var List;


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](List))) {
    List = ReturnERROR;
  } else {
    if (List.length == 0) {
      List = ReturnERROR;
    } else {
      List = List;
    }
  }

return List
}

})
define('./functions/0c02346c0bf5755bd3f9c5d2b50c53a7/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0c02346c0bf5755bd3f9c5d2b50c53a7'] = async function fn_0c02346c0bf5755bd3f9c5d2b50c53a7(Phone) {
var Function2;


  if ((await BackendlessUI.Functions.Custom['fn_70b8ca4740171f42c0aa414f72c30dde'](Phone)).length == 12) {
    Function2 = true;
  } else {
    Function2 = false;
  }

return Function2
}

})
define('./functions/0d21bcaaf9225eaf120e4006b08f507d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0d21bcaaf9225eaf120e4006b08f507d'] = async function fn_0d21bcaaf9225eaf120e4006b08f507d(listToModify) {
  await (async function(array) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.reverse(array)
  })(listToModify);

}

})
define('./functions/0ea1d65b7a2db5c48adc82f4f78b00c1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_0ea1d65b7a2db5c48adc82f4f78b00c1'] = async function fn_0ea1d65b7a2db5c48adc82f4f78b00c1(listsToInspect, comparatorFunction) {
return (await (async function(arrays, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.xorWith(...arrays, comparator)
})(listsToInspect, comparatorFunction))
}

})
define('./functions/1084738faafcc22540e6efb456550d03/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1084738faafcc22540e6efb456550d03'] = async function fn_1084738faafcc22540e6efb456550d03(Style, Component, Delay) {
var Counter;


  for (var count2 = 0; count2 < 1; count2++) {
    Counter = 1;
    for (var count = 0; count < 100; count++) {
      Style['opacity'] = Counter;
      await new Promise(r => setTimeout(r, Delay || 0));
      Counter = Counter - 0.01;
    }
  }
  Component['display'] = false;

}

})
define('./functions/1146c137578b6687c02d444a29fa2a08/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1146c137578b6687c02d444a29fa2a08'] = async function fn_1146c137578b6687c02d444a29fa2a08(Points) {
var Result, Actual_Perimeter, Co_ordiante_2, Co_ordiante_1, Counter, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (Points.length > 2) {
    Counter = 0;
    Actual_Perimeter = 0;
    for (var j_index in Points) {
      j = Points[j_index];
      Counter = Counter + 1;
      Co_ordiante_1 = Points[(Counter - 1)];
      if (Points.length == Counter) {
        Co_ordiante_2 = Points[0];
      } else {
        Co_ordiante_2 = Points[((Counter + 1) - 1)];
      }
      Actual_Perimeter = Actual_Perimeter + (await (async function(lat1, lat2, lon1, lon2) {
      	const R = 6371e3; // metres
      	const φ1 = lat1 * Math.PI/180; // φ, λ in radians
      	const φ2 = lat2 * Math.PI/180;
      	const Δφ = (lat2-lat1) * Math.PI/180;
      	const Δλ = (lon2-lon1) * Math.PI/180;
      	
      	const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
      	          Math.cos(φ1) * Math.cos(φ2) *
      	          Math.sin(Δλ/2) * Math.sin(Δλ/2);
      	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      	
      	const d = R * c; // in metres
      	
      	return R * c
      })((getObjectProperty(Co_ordiante_1, 'lat')), (getObjectProperty(Co_ordiante_2, 'lat')), (getObjectProperty(Co_ordiante_1, 'lng')), (getObjectProperty(Co_ordiante_2, 'lng'))));
    }
    Result = Actual_Perimeter < 0 ? Actual_Perimeter * -1 : Actual_Perimeter;
  } else {
    Result = 0;
  }

return Result
}

})
define('./functions/143fc5aa9049a496f3f2f6656ab5e7a4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'] = async function fn_143fc5aa9049a496f3f2f6656ab5e7a4(Data) {
var Start_Date, Set_Date;


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Data))) {
    Start_Date = (new Date());
    Start_Date.setDate((((new Date((new Date())).getDate()) + 1) - (new Date((new Date())).getDate())));
    Start_Date.setHours(((new Date((new Date())).getHours()) - (new Date((new Date())).getHours())));
    Start_Date.setMinutes(((new Date((new Date())).getMinutes()) - (new Date((new Date())).getMinutes())));
    Start_Date.setSeconds(((new Date((new Date())).getSeconds()) - (new Date((new Date())).getSeconds())));
    Start_Date.setMilliseconds(((new Date((new Date())).getMilliseconds()) - (new Date((new Date())).getMilliseconds())));
  } else {
    Start_Date = Data;
    Set_Date = Data;
    Start_Date.setDate((((new Date(Set_Date).getDate()) + 1) - (new Date(Set_Date).getDate())));
    Start_Date.setHours(((new Date(Set_Date).getHours()) - (new Date(Set_Date).getHours())));
    Start_Date.setMinutes(((new Date(Set_Date).getMinutes()) - (new Date(Set_Date).getMinutes())));
    Start_Date.setSeconds(((new Date(Set_Date).getSeconds()) - (new Date(Set_Date).getSeconds())));
    Start_Date.setMilliseconds(((new Date(Set_Date).getMilliseconds()) - (new Date(Set_Date).getMilliseconds())));
  }

return Start_Date
}

})
define('./functions/15ca0e8cc5e67ed6b62edeb5642db8ca/code.js', () => { 

BackendlessUI.Functions.Custom['fn_15ca0e8cc5e67ed6b62edeb5642db8ca'] = async function fn_15ca0e8cc5e67ed6b62edeb5642db8ca(listToCompact) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.compact(array)
})(listToCompact))
}

})
define('./functions/15ceddbd38db9429a0f97a454e8b367a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_15ceddbd38db9429a0f97a454e8b367a'] = async function fn_15ceddbd38db9429a0f97a454e8b367a(listToQuery, numberOfElements) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.take(array, n)
})(listToQuery, numberOfElements))
}

})
define('./functions/16424e16271fba19226ae38e9f473baa/code.js', () => { 

BackendlessUI.Functions.Custom['fn_16424e16271fba19226ae38e9f473baa'] = async function fn_16424e16271fba19226ae38e9f473baa(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.head(array)
})(listToQuery))
}

})
define('./functions/17d82be7b0aab18330b24bb73712bf73/code.js', () => { 

BackendlessUI.Functions.Custom['fn_17d82be7b0aab18330b24bb73712bf73'] = async function fn_17d82be7b0aab18330b24bb73712bf73(Centre, Tangent) {
var Points, Calculated___Area, Calculated___Circumference, Distance, Object2, _CE_BB2, _CF_862, _CE_BB2ATAN2, _CE_BB1, _CF_861, _CE_B4, _CE_98, Co_ordiante_1, Co_ordiante_2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Co_ordiante_1 = Centre;
  Co_ordiante_2 = Tangent;
  Distance = (await (async function(lat1, lat2, lon1, lon2) {
  	const R = 6371e3; // metres
  	const φ1 = lat1 * Math.PI/180; // φ, λ in radians
  	const φ2 = lat2 * Math.PI/180;
  	const Δφ = (lat2-lat1) * Math.PI/180;
  	const Δλ = (lon2-lon1) * Math.PI/180;
  	
  	const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
  	          Math.cos(φ1) * Math.cos(φ2) *
  	          Math.sin(Δλ/2) * Math.sin(Δλ/2);
  	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  	
  	const d = R * c; // in metres
  	
  	return R * c
  })((getObjectProperty(Co_ordiante_1, 'lat')), (getObjectProperty(Co_ordiante_2, 'lat')), (getObjectProperty(Co_ordiante_1, 'lng')), (getObjectProperty(Co_ordiante_2, 'lng'))));
  Calculated___Circumference = 2 * Math.PI * Distance;
  Calculated___Area = (Math.PI * Distance * Distance) / 10000;
  _CE_B4 = (Distance / 17.5) / 6371;
  _CE_98 = 5;
  _CF_861 = (getObjectProperty(Co_ordiante_1, 'lat'));
  _CE_BB1 = (getObjectProperty(Co_ordiante_1, 'lng'));
  Points = [];
  for (var count = 0; count < 36; count++) {
    _CE_98 = _CE_98 + 10;
    _CF_862 = Math.asin(Math.sin(_CF_861 / 180 * Math.PI) * Math.cos(_CE_B4 / 180 * Math.PI) + Math.cos(_CF_861 / 180 * Math.PI) * Math.sin(_CE_B4 / 180 * Math.PI) * Math.cos(_CE_98 / 180 * Math.PI)) / Math.PI * 180;
    _CE_BB2ATAN2 = Math.atan((Math.cos(_CE_B4 / 180 * Math.PI) - Math.sin(_CF_861 / 180 * Math.PI) * Math.sin(_CF_862 / 180 * Math.PI)) / (Math.sin(_CE_98 / 180 * Math.PI) * Math.sin(_CE_B4 / 180 * Math.PI) * Math.cos(_CF_861 / 180 * Math.PI))) / Math.PI * 180;
    _CE_BB2 = _CE_BB1 + (_CE_BB2ATAN2 > 0 ? _CE_BB2ATAN2 - 90 : _CE_BB2ATAN2 + 90);
    Object2 = ({ [`lat`]: _CF_862,[`lng`]: _CE_BB2 });
    addItemToList(Points, Object2);
  }

return ({ [`Radius`]: Distance,[`Calculated - Circumference`]: Calculated___Circumference,[`Calculated - Area`]: Calculated___Area,[`Points`]: Points })
}

})
define('./functions/1c281acb3a51cd63d152afb639d9a49f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1c281acb3a51cd63d152afb639d9a49f'] = async function fn_1c281acb3a51cd63d152afb639d9a49f(listToQuery, numberOfElementsToDrop) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.dropRight(array, n)
})(listToQuery, numberOfElementsToDrop))
}

})
define('./functions/1db2862f0f34c40826936d930b7ac8c1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1db2862f0f34c40826936d930b7ac8c1'] = async function fn_1db2862f0f34c40826936d930b7ac8c1(TableName, WhereClause, Relations, RelationsPageSize, RelationsDepth) {
var resultList, j, tableList, offSet, pagesQuantity, i, numberOfObjects;


  resultList = [];
  numberOfObjects = (await Backendless.Data.of(TableName).getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause(WhereClause)));
  pagesQuantity = Math.ceil(numberOfObjects / 100);
  offSet = 0;
  var i_inc = 1;
  if (1 > pagesQuantity) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= pagesQuantity : i >= pagesQuantity; i += i_inc) {
    tableList = (await Backendless.Data.of(TableName).find(Backendless.DataQueryBuilder.create().setWhereClause(WhereClause).setRelated(Relations).setRelationsDepth(RelationsDepth).setRelationsPageSize(RelationsPageSize).setPageSize(100).setOffset(offSet)));
    offSet = offSet + 100;
    for (var j_index in tableList) {
      j = tableList[j_index];
      resultList.push(j);
    }
  }

return resultList
}

})
define('./functions/1ed75d6e7b29bf7892735d07bbe63dde/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1ed75d6e7b29bf7892735d07bbe63dde'] = async function fn_1ed75d6e7b29bf7892735d07bbe63dde(List, Value) {
var Label, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Label = (await asyncListFilter(List, async (item) => {


   return ((getObjectProperty(item, 'value')) == Value || (getObjectProperty(item, 'objectId')) == Value);
  }))[0];

return Label
}

})
define('./functions/1ee3ca4117e155dcd036a9ad569bd2ec/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1ee3ca4117e155dcd036a9ad569bd2ec'] = function fn_1ee3ca4117e155dcd036a9ad569bd2ec(Value) {
var Result;


  Result = Value * Value;

return Result
}

})
define('./functions/24a626fc74c34a9805e7999658bdcfd6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_24a626fc74c34a9805e7999658bdcfd6'] = async function fn_24a626fc74c34a9805e7999658bdcfd6(Point1, Point2) {
var Result, Co_ordiante_2, Co_ordiante_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Co_ordiante_1 = Point1;
  Co_ordiante_2 = Point2;
  Result = (await (async function(lat1, lat2, lon1, lon2) {
  	const R = 6371e3; // metres
  	const φ1 = lat1 * Math.PI/180; // φ, λ in radians
  	const φ2 = lat2 * Math.PI/180;
  	const Δφ = (lat2-lat1) * Math.PI/180;
  	const Δλ = (lon2-lon1) * Math.PI/180;
  	
  	const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
  	          Math.cos(φ1) * Math.cos(φ2) *
  	          Math.sin(Δλ/2) * Math.sin(Δλ/2);
  	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  	
  	const d = R * c; // in metres
  	
  	return R * c
  })((getObjectProperty(Co_ordiante_1, 'lat')), (getObjectProperty(Co_ordiante_2, 'lat')), (getObjectProperty(Co_ordiante_1, 'lng')), (getObjectProperty(Co_ordiante_2, 'lng'))));

return Result
}

})
define('./functions/26d5effe010a024af594e7ea0151369e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_26d5effe010a024af594e7ea0151369e'] = async function fn_26d5effe010a024af594e7ea0151369e(listsToInspect, comparatorFunction) {
return (await (async function(arrays, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.intersectionWith(...arrays, comparator)
})(listsToInspect, comparatorFunction))
}

})
define('./functions/27a3d5b5fe9f5c3e7f0c16ee16cd7b55/code.js', () => { 

BackendlessUI.Functions.Custom['fn_27a3d5b5fe9f5c3e7f0c16ee16cd7b55'] = async function fn_27a3d5b5fe9f5c3e7f0c16ee16cd7b55(propertyNamePathsList, propertyValuesList) {
return (await (async function(props, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zipObjectDeep(props, values)
})(propertyNamePathsList, propertyValuesList))
}

})
define('./functions/2a1538e41c7c2966c613c5082d9cc4a6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2a1538e41c7c2966c613c5082d9cc4a6'] = async function fn_2a1538e41c7c2966c613c5082d9cc4a6(listOfGroupedElements, combinerFunction) {
return (await (async function(array, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unzipWith(array, iteratee)
})(listOfGroupedElements, combinerFunction))
}

})
define('./functions/2b6f13dbf14cfe04d0ef145bee418ee6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2b6f13dbf14cfe04d0ef145bee418ee6'] = function fn_2b6f13dbf14cfe04d0ef145bee418ee6(Input) {
var error, Result;


  try {
    Result = Input;

  } catch (error) {

  } finally {
    if (error) {
      Result = null;
    }

  }

return Result
}

})
define('./functions/2bab1b7406627074e9c73f97d5958322/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2bab1b7406627074e9c73f97d5958322'] = async function fn_2bab1b7406627074e9c73f97d5958322(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.initial(array)
})(listToQuery))
}

})
define('./functions/2e66833af01e5634fce9da96cefcce33/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2e66833af01e5634fce9da96cefcce33'] = async function fn_2e66833af01e5634fce9da96cefcce33(Style_In, Component_In, Style_Out, Component_Out, Delay) {
var Counter_In, Counter_Out;


  Style_In['opacity'] = 0;
  Component_In['display'] = true;
  for (var count2 = 0; count2 < 1; count2++) {
    Counter_Out = 1;
    Counter_In = 0;
    for (var count = 0; count < 100; count++) {
      Style_Out['opacity'] = Counter_Out;
      Style_In['opacity'] = Counter_In;
      await new Promise(r => setTimeout(r, Delay || 0));
      Counter_Out = Counter_Out - 0.01;
      Counter_In = Counter_In + 0.01;
    }
  }
  Component_Out['display'] = false;

}

})
define('./functions/2efccffaf77561378618ce85676776ee/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2efccffaf77561378618ce85676776ee'] = async function fn_2efccffaf77561378618ce85676776ee(Lat, Lng, Distance, Heading) {
var Value;


  Value = ({ [`lat`]: (await (async function(Lat, Lng, Meters, Heading) {
  	const R = 6371e3; //rayon of the erth
  	let lat1 = Lat * Math.PI / 180; // latitude in rad
  	let long1 = Lng * Math.PI / 180; // longiture in rad
  	let d = Meters; //distance between the two points
  	let angle = (Heading)*Math.PI/180; // the angle between the 2 points in rad (20°)
  	const sigma = d / R;
  	const delLat = sigma * Math.cos(angle);
  	let lat2 = (lat1 + delLat) * 180 / Math.PI;//latitude of the destination point in deg
  	const del = Math.log(Math.tan(lat2 / 2 + Math.PI / 4) / Math.tan(lat1 / 2 + Math.PI / 4));
  	// const q = Math.abs(del) > 10e-12 ? delLat / del : Math.cos(lat1); 
  	const q = Math.cos(lat1)
  	const delLong = sigma * Math.sin(angle) / q;
  	let long2 = (long1 + delLong) * 180 / Math.PI; //longitude of the destination point in deg
  	
  	return lat2
  })(Distance, Heading, Lng, Lat)),[`lng`]: (await (async function(Lat, Lng, Meters, Heading) {
  	const R = 6371e3; //rayon of the erth
  	let lat1 = Lat * Math.PI / 180; // latitude in rad
  	let long1 = Lng * Math.PI / 180; // longiture in rad
  	let d = Meters; //distance between the two points
  	let angle = (Heading)*Math.PI/180; // the angle between the 2 points in rad (20°)
  	const sigma = d / R;
  	const delLat = sigma * Math.cos(angle);
  	let lat2 = (lat1 + delLat) * 180 / Math.PI;//latitude of the destination point in deg
  	const del = Math.log(Math.tan(lat2 / 2 + Math.PI / 4) / Math.tan(lat1 / 2 + Math.PI / 4));
  	// const q = Math.abs(del) > 10e-12 ? delLat / del : Math.cos(lat1); 
  	const q = Math.cos(lat1)
  	const delLong = sigma * Math.sin(angle) / q;
  	let long2 = (long1 + delLong) * 180 / Math.PI; //longitude of the destination point in deg
  	
  	return long2
  })(Distance, Heading, Lng, Lat)) });

return Value
}

})
define('./functions/31cae287c3a80d02a51434592a031855/code.js', () => { 

BackendlessUI.Functions.Custom['fn_31cae287c3a80d02a51434592a031855'] = function fn_31cae287c3a80d02a51434592a031855(Property, Data) {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(Data, Property)) == true) {
    Data[Property] = false;
  } else {
    Data[Property] = true;
  }

}

})
define('./functions/31ee787fb32733e8b48cc429f1cef5e6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_31ee787fb32733e8b48cc429f1cef5e6'] = async function fn_31ee787fb32733e8b48cc429f1cef5e6(UITable) {
var Item_List, properties, Where, tableName, filePath, j, UITable, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  UITable = UITable;
  Item_List = [];
  Where = (getObjectProperty(UITable, 'whereClause'));
  properties = (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(UITable, 'el')), 'dataManager')), 'columns')).map(async item => {; return (getObjectProperty(item, 'field'));})));
  tableName = (getObjectProperty(UITable, 'tableName'));
  filePath = String(getObjectProperty(UITable, 'title')) + String('.csv');
  var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(UITable, 'el')), 'dataManager')), 'columns'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    Item_List[(getObjectProperty(j, 'field'))] = (getObjectProperty(j, 'title'));
  }
  delete Item_List['Passer'];
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/table2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': filePath,'tableName': tableName,'tableOptions': ({ 'where': Where,'properties': properties,'columnsMapping': Item_List,'excludeProps': ['objectId'] }),'csvOptions': ({ 'header': true }) })), true, undefined);

}

})
define('./functions/33f4c01b8e8eda17aee5c5294b33b8fc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_33f4c01b8e8eda17aee5c5294b33b8fc'] = async function fn_33f4c01b8e8eda17aee5c5294b33b8fc(listsToProcess) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zip(...arrays)
})(listsToProcess))
}

})
define('./functions/343eca57258d3a15fcf855fe73fdf50a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_343eca57258d3a15fcf855fe73fdf50a'] = async function fn_343eca57258d3a15fcf855fe73fdf50a(List, Levels) {
var Return, list;


  if (Levels == 1) {
    Return = List;
  } else if (Levels == 2) {
    Return = (await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })(List, 2));
  } else if (Levels == 3) {
    Return = (await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })(List, 2)), 2));
  } else if (Levels == 4) {
    Return = (await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })(List, 2)), 2)), 2));
  } else if (Levels == 5) {
    Return = (await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })(List, 2)), 2)), 2)), 2));
  } else if (Levels == 6) {
    Return = (await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })(List, 2)), 2)), 2)), 2)), 2));
  } else if (Levels == 7) {
    Return = (await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })(List, 2)), 2)), 2)), 2)), 2)), 2));
  } else if (Levels == 8) {
    Return = (await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })(List, 2)), 2)), 2)), 2)), 2)), 2)), 2));
  } else if (Levels == 9) {
    Return = (await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })((await (async function(List, n) {
    	// Define the function to remove every Nth instance from a list
    	function removeEveryNth(list, n) {
    	  // Validate the inputs
    	  if (!Array.isArray(list)) {
    	    throw new Error('The first argument must be an array');
    	  }
    	  if (typeof n !== 'number' || n <= 0) {
    	    throw new Error('The second argument must be a positive number');
    	  }
    	
    	  // Counter to track instances
    	  let count = 0;
    	  const lastIndex = list.length - 1;
    	
    	  // Filter out every Nth instance, except the last item
    	  const filteredList = list.filter((item, index) => {
    	    count++;
    	    return (count % n !== 0) || (index === lastIndex);
    	  });
    	
    	  return filteredList;
    	}
    	
    	// Execute the function with the provided arguments and return the result
    	return removeEveryNth(List, n);

    })(List, 2)), 2)), 2)), 2)), 2)), 2)), 2)), 2));
  } else if (Levels == 10) {
    Return = [List[0], List.slice(-1)[0]];
  }

return Return
}

})
define('./functions/37a70893d34d348151130eb779d90624/code.js', () => { 

BackendlessUI.Functions.Custom['fn_37a70893d34d348151130eb779d90624'] = async function fn_37a70893d34d348151130eb779d90624(listsToProcess, combinerFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zipWith(...arrays, iteratee)
})(listsToProcess, combinerFunction))
}

})
define('./functions/38c2ffe50d0e5cca36f20903850cc95a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_38c2ffe50d0e5cca36f20903850cc95a'] = async function fn_38c2ffe50d0e5cca36f20903850cc95a(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.last(array)
})(listToQuery))
}

})
define('./functions/3a17163a8ed3566b1d770b133f9e456c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3a17163a8ed3566b1d770b133f9e456c'] = async function fn_3a17163a8ed3566b1d770b133f9e456c(sortedListToInspect, valueToEvaluate, filterFunction) {
return (await (async function(array, value, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedLastIndexBy(array, value, iteratee)
})(sortedListToInspect, valueToEvaluate, filterFunction))
}

})
define('./functions/3a793fed77a519bfe0e8407457e3fd8c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3a793fed77a519bfe0e8407457e3fd8c'] = async function fn_3a793fed77a519bfe0e8407457e3fd8c(Headers, Rows) {
var Result;


  Result = (await (async function(Headers, Rows) {
  	function createPopupDiv(Headers, Rows) {
  	    // Create the popup div
  	    let popupDiv = `
  	    <div class="popup" style="background-color: rgba(0, 0, 0, 0.8); border: 2px solid #CC6633; border-radius: 10px; padding: 10px; color: #ffffff; font-family: Arial, sans-serif; width: 330px;">
  	        <table style="width: 100%; border-collapse: collapse; table-layout: fixed;">
  	            <colgroup>
  	                <col style="width: 35%;">
  	                <col style="width: 65%;">
  	            </colgroup>
  	    `;
  	
  	    // Add the top part (unscrollable)
  	    Headers.forEach(header => {
  	        popupDiv += `
  	            <tr>
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left; background-color: ${header.Color};">${header.Label}</td>
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left; background-color: ${header.Color};">${header.Value}</td>
  	            </tr>
  	        `;
  	    });
  	
  	    popupDiv += `</table>
  	        <div class="scrollable-content" style="max-height: 200px; overflow-y: auto;">
  	            <table style="width: 100%; border-collapse: collapse; table-layout: fixed;">
  	                <colgroup>
  	                    <col style="width: 35%;">
  	                    <col style="width: 65%;">
  	                </colgroup>
  	    `;
  	
  	    // Add the scrollable part (rows)
  	    Rows.forEach(row => {
  	        popupDiv += `
  	            <tr style="background-color: ${row.Color};">
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left;">${row.Label}</td>
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left;">${row.Value}</td>
  	            </tr>
  	        `;
  	    });
  	
  	    // Close the tables and div
  	    popupDiv += `
  	            </table>
  	        </div>
  	    </div>
  	    `;
  	
  	    // Return the popup div HTML
  	    return popupDiv;
  	}
  	
  	try {
  	    const Headers = arguments[0]; // Retrieve the Headers from arguments
  	    const Rows = arguments[1]; // Retrieve the Rows from arguments
  	
  	    const popupHTML = createPopupDiv(Headers, Rows);
  	    return popupHTML;
  	} catch (error) {
  	    console.error("Error creating popup div:", error);
  	    return "Error creating popup div.";
  	}

  })(Headers, Rows));

return Result
}

})
define('./functions/3b22bf56ea095bef299e80632005db52/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3b22bf56ea095bef299e80632005db52'] = async function fn_3b22bf56ea095bef299e80632005db52(listToProcess, chunkLength) {
return (await (async function(array, size) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (size == null) {
	  size = 1
	}

	return _.chunk(array, size)
})(listToProcess, chunkLength))
}

})
define('./functions/3da675c9560df4688c120284991f799e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3da675c9560df4688c120284991f799e'] = async function fn_3da675c9560df4688c120284991f799e(listToInspect, valuesToExclude, comparatorFunction) {
return (await (async function(array, values, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.differenceWith(array, values, comparator)
})(listToInspect, valuesToExclude, comparatorFunction))
}

})
define('./functions/426948ad83d60a24cc6b41994344615f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_426948ad83d60a24cc6b41994344615f'] = async function fn_426948ad83d60a24cc6b41994344615f(UI_Table, Company) {
var Passer, Component, Title, List_Items, Company, List_Item, j, Columns;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  Company = Company;
  Component = UI_Table;
  List_Items = [];
  List_Item = ({ 'Test': null });
  var Columns_list = (getObjectProperty((getObjectProperty((getObjectProperty(Component, 'el')), 'dataManager')), 'columns'));
  for (var Columns_index in Columns_list) {
    Columns = Columns_list[Columns_index];
    List_Item[(getObjectProperty(Columns, 'title'))] = (getObjectProperty(Columns, 'title'));
  }
  delete List_Item['Test'];
  addItemToList(List_Items, List_Item);
  var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(Component, 'el')), 'dataManager')), 'data'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    List_Item = ({ 'Test': null });
    var Columns_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(Component, 'el')), 'dataManager')), 'columns'));
    for (var Columns_index2 in Columns_list2) {
      Columns = Columns_list2[Columns_index2];
      List_Item[(getObjectProperty(Columns, 'title'))] = ((getObjectProperty(j, (getObjectProperty(Columns, 'field')))) == null ? '-' : (getObjectProperty(j, (getObjectProperty(Columns, 'field')))));
    }
    delete List_Item['Test'];
    addItemToList(List_Items, List_Item);
  }
  Title = [(getObjectProperty(Component, 'title')),'-',(getObjectProperty(Company, 'Company')),'(',(generateUUID().short()),')'].join('');
  Passer = (await Backendless.Request.post(`${Backendless.appPath}/services/PDFGeneratorAPI/${'556004'}/data-output/${Title}`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'data': ({ 'Logo': (getObjectProperty(Company, 'Company_Logo')),'Company': (getObjectProperty(Company, 'Company')),'Date': String((new Date()).toLocaleDateString()),'Time': String((new Date()).toLocaleTimeString()),'line_items': List_Items,'Barcode': ['https://backendlessappcontent.com/CB411F83-2292-179C-FF6B-D25974153100/41B761B3-CE6D-4001-B01B-7353FAA89118/files/https:/develop.backendless.com/app/Dash/files/PDF_Storage/',Title,'.pdf'].join(''),'Header': (getObjectProperty(Component, 'title')) }) }));
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(Passer, 'fileUrl')), true, undefined);

}

})
define('./functions/42bc76f837a963e74c557b0fdf2ce4e3/code.js', () => { 

BackendlessUI.Functions.Custom['fn_42bc76f837a963e74c557b0fdf2ce4e3'] = async function fn_42bc76f837a963e74c557b0fdf2ce4e3(Company, Driver, Fuel, OtherGarageTF, Station, Tractor, Axles, Differential) {
var Fuel_Transaction_Step_2, Transaction_Step_1, Transaction_Step_2, Tyres, Station, Fuel_Transaction, Garage, Driver, Tractor, Company, Fuel, Fleetview, error;

/**
 * Describe this function...
 */
async function Fuel_Step(Company, Driver, Fuel, Garage, Station, Tractor, Tyres) {
  Transaction_Step_1 = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction_Step_1;

    Fuel_Transaction = (_uow.create('Fuel', Fuel));
    _uow.upsert('Tractors', Tractor);
    _uow.addToRelation('Tractors', Tractor, 'Fuel', [Fuel_Transaction]);
    _uow.setRelation('Tractors', Tractor, 'Fuel_Last', [Fuel_Transaction]);
    _uow.addToRelation('Employees', Driver, 'Driver_Transactions_Fuel', [Fuel_Transaction]);
    _uow.setRelation('Fuel', Fuel_Transaction, 'Company', [Company]);
    _uow.setRelation('Fuel', Fuel_Transaction, 'Tractor', [Tractor]);
    _uow.addToRelation('Fuel', Fuel_Transaction, 'Driver', [Driver]);
    if (Garage == true) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Station))) {
      } else {
        _uow.addToRelation('Fuel', Fuel_Transaction, 'Station_correct', [Station]);
      }
    } else {
      try {
        _uow.addToRelation('Fuel', Fuel_Transaction, 'Station_correct', [Station]);

      } catch (error) {
        console.log(error);

      }
    }
    _uow.bulkUpsert('Tyres', Tyres);

  })();

  Transaction_Step_2 = (await Transaction_Step_1.execute().then(function(result) {
      const error = result && result.error

      if (error) {
        throw error
      }

    return result
    }));
  return Fuel_Transaction_Step_2
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Tyres = (await BackendlessUI.Functions.Custom['fn_c8249d71574777eb2a08c21c7e28faee'](Axles, Differential));
  Fuel = await Fuel_Step(Company, Driver, Fuel, OtherGarageTF, Station, Tractor, Tyres);
  Fleetview = (await BackendlessUI.Functions.Custom['fn_88481472e3e169797cae85c104751a08']((getObjectProperty(Tractor, 'objectId')), Tractor));

return ({ [`Fuel`]: Fuel,[`Fleetview`]: Fleetview })
}

})
define('./functions/4305c6b3c9678eaff3f213c4ef4213e4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4305c6b3c9678eaff3f213c4ef4213e4'] = async function fn_4305c6b3c9678eaff3f213c4ef4213e4(listToQuery) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.tail(array)
})(listToQuery))
}

})
define('./functions/43777d156dae06be3af7f7bb2185fb44/code.js', () => { 

BackendlessUI.Functions.Custom['fn_43777d156dae06be3af7f7bb2185fb44'] = async function fn_43777d156dae06be3af7f7bb2185fb44(List) {
var Counter, list, New_List, Original_List;

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Halver() {
  Counter = 0;
  addItemToList(New_List, (List[0]));
  var repeat_end2 = List.length / 0;
  for (var count2 = 0; count2 < repeat_end2; count2++) {
    try {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((List[(Counter - 1)])))) {
      } else {
        addItemToList(New_List, (List[(Counter - 1)]));
      }
      Counter = Counter + 0;

    } catch (error) {

    }
  }
}


  Original_List = List;
  Counter = 0;
  var repeat_end = Math.floor(List.length / 2);
  for (var count = 0; count < repeat_end; count++) {
    removeItemInList(Original_List, (Original_List[(Counter - 1)]), '');
    Counter = Counter + 2;
  }

return Original_List
}

})
define('./functions/43b4a3c52591b241ead73df1fc683a4b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_43b4a3c52591b241ead73df1fc683a4b'] = async function fn_43b4a3c52591b241ead73df1fc683a4b(Start) {
return (await (async function(Start) {
	function getStartOfDayTimestamp(Start) {
	  const startDate = new Date(Start);
	  startDate.setHours(0, 0, 0, 0); // Set to the start of the day
	
	  return startDate.getTime();
	}
	
	// Directly execute and return the result
	return getStartOfDayTimestamp(Start);

})(Start))
}

})
define('./functions/45e840d979f666875cfc9d9849ef3d28/code.js', () => { 

BackendlessUI.Functions.Custom['fn_45e840d979f666875cfc9d9849ef3d28'] = async function fn_45e840d979f666875cfc9d9849ef3d28(sortedListToInspect, valueToEvaluate) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedIndex(array, value)
})(sortedListToInspect, valueToEvaluate))
}

})
define('./functions/461d17e665f8b6391823125f6307ab14/code.js', () => { 

BackendlessUI.Functions.Custom['fn_461d17e665f8b6391823125f6307ab14'] = async function fn_461d17e665f8b6391823125f6307ab14(listToInspect) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedUniq(array)
})(listToInspect))
}

})
define('./functions/486ef78363267883c1df0cc331fd1a59/code.js', () => { 

BackendlessUI.Functions.Custom['fn_486ef78363267883c1df0cc331fd1a59'] = async function fn_486ef78363267883c1df0cc331fd1a59(listToInspect, valuesToExclude) {
return (await (async function(array, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.without(array, ...values)
})(listToInspect, valuesToExclude))
}

})
define('./functions/4a474301931c8896b0d8fc0d039f07d4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4'] = async function fn_4a474301931c8896b0d8fc0d039f07d4(Device, Start, End) {
var Result, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Result = (getObjectProperty((await (async function(to, from, Device) {
  	// Define the function to execute the HTTP request
  	async function fetchFlespiMessages(start, end, device) {
  	  // Construct the URL with query parameters
  	  const url = `https://flespi.io/gw/devices/${device}/messages?data=%7B%22to%22%3A${end}%2C%22from%22%3A${start}%7D`;
  	
  	  const headers = {
  	    'Content-Type': 'application/json',
  	    'Authorization': 'FlespiToken 1rSTqs5yHq64EsaPeiYKanXoP7VR0ru8GuoNJMVM0VUfWoen391ae0kGfdbOXocW'
  	  };
  	
  	  // Perform the HTTP GET request using fetch
  	  const response = await fetch(url, { headers });
  	  if (!response.ok) {
  	    throw new Error(`HTTP error! status: ${response.status}`);
  	  }
  	
  	  // Parse and return the JSON response
  	  const result = await response.json();
  	  return result;
  	}
  	
  	// Retrieve the parameters passed to the custom code block
  	const start = from;
  	const end = to;
  	const device = arguments[2]; // Retrieve the device number from arguments
  	
  	// Call the function with the retrieved parameters
  	return fetchFlespiMessages(start, end, device);
  	

  })((End / 1000), (Start / 1000), Device)), 'result'));

return Result
}

})
define('./functions/4a82504ac5a365b515498484f6caee02/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4a82504ac5a365b515498484f6caee02'] = async function fn_4a82504ac5a365b515498484f6caee02(tableName, whereClause, propertiesToInclude, propertiesToExclude, propertiesToSortBy, relations) {
var allCustomers, loading, currentBatch, offset;


  loading = true;
  allCustomers = [];
  offset = 0;
  while (loading) {
    currentBatch = (await Backendless.Data.of(tableName).find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties(propertiesToInclude).excludeProperties(propertiesToExclude).setRelated(relations).setSortBy(propertiesToSortBy).setPageSize(100).setOffset(offset)));
    allCustomers = (allCustomers.concat(currentBatch));
    offset = offset + 100;
    if (currentBatch.length < 100) {
      loading = false;
    }
  }

return allCustomers
}

})
define('./functions/4c94c282f3fa96b6ee1128b33a8969cb/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb'] = async function fn_4c94c282f3fa96b6ee1128b33a8969cb(Value) {
var Content;


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Value))) {
  } else {
    Content = Value;
  }

return Content
}

})
define('./functions/4cf12a1449b890f2c42b8fe2a753bc14/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4cf12a1449b890f2c42b8fe2a753bc14'] = async function fn_4cf12a1449b890f2c42b8fe2a753bc14(sortedListToInspect, valueToEvaluate, filterFunction) {
return (await (async function(array, value, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedIndexBy(array, value, iteratee)
})(sortedListToInspect, valueToEvaluate, filterFunction))
}

})
define('./functions/4e84132425b7748ee8adf3583323c24e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4e84132425b7748ee8adf3583323c24e'] = async function fn_4e84132425b7748ee8adf3583323c24e(List, Database) {
var i, j, numberOfObjects, Object_Counter, offSet, pagesQuantity, resultList, tableList;


  numberOfObjects = List.length;
  Object_Counter = List.length;
  pagesQuantity = Math.ceil(numberOfObjects / 100);
  resultList = [];
  offSet = 1;
  var i_inc = 1;
  if (1 > pagesQuantity) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= pagesQuantity : i >= pagesQuantity; i += i_inc) {
    if (Object_Counter < 99) {
      tableList = (await Backendless.Data.of(Database).bulkUpsert( (List.slice((offSet - 1), offSet + (Object_Counter - 1))) ));
      offSet = offSet + 99;
      Object_Counter = Object_Counter - 99;
      for (var j_index in tableList) {
        j = tableList[j_index];
        resultList.push(j);
      }
    } else {
      tableList = (await Backendless.Data.of(Database).bulkUpsert( (List.slice((offSet - 1), offSet + 98)) ));
      offSet = offSet + 99;
      Object_Counter = Object_Counter - 99;
      for (var j_index2 in tableList) {
        j = tableList[j_index2];
        resultList.push(j);
      }
    }
  }

return resultList
}

})
define('./functions/4fdca0492369fbed477c812798921381/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4fdca0492369fbed477c812798921381'] = async function fn_4fdca0492369fbed477c812798921381(Points, Color, Description, Opacity) {
var Object2, item, Segmants, Segment, Counter, Point;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  Segmants = [];
  Counter = 1;
  for (var Point_index in Points) {
    Point = Points[Point_index];
    if ((getObjectProperty(Point, 'lat')) == (getObjectProperty((Points.slice(-1)[0]), 'lat')) && (getObjectProperty(Point, 'lng')) == (getObjectProperty((Points.slice(-1)[0]), 'lng'))) {
      console.log('CDE');
      Segment = ({ [`Order`]: Counter,[`Heading`]: (await BackendlessUI.Functions.Custom['fn_a0029e53d7d4c3e13bac42c9819788e1']((Points[((Counter - 1) - 1)]), (Points[(Counter - 1)]))),[`Point 1 (90)`]: (await BackendlessUI.Functions.Custom['fn_2efccffaf77561378618ce85676776ee']((getObjectProperty((Points[(Counter - 1)]), 'lat')), (getObjectProperty((Points[(Counter - 1)]), 'lng')), 4, ((await BackendlessUI.Functions.Custom['fn_a0029e53d7d4c3e13bac42c9819788e1']((Points[((Counter - 1) - 1)]), (Points[(Counter - 1)]))) + 90))),[`Point 1`]: Points[(Counter - 1)],[`Point 2`]: undefined,[`Distance`]: 0 });
      addItemToList(Segmants, Segment);
    } else {
      Segment = ({ [`Order`]: Counter,[`Heading`]: (await BackendlessUI.Functions.Custom['fn_a0029e53d7d4c3e13bac42c9819788e1']((Points[(Counter - 1)]), (Points[((Counter + 1) - 1)]))),[`Point 1 (90)`]: (await BackendlessUI.Functions.Custom['fn_2efccffaf77561378618ce85676776ee']((getObjectProperty((Points[(Counter - 1)]), 'lat')), (getObjectProperty((Points[(Counter - 1)]), 'lng')), 4, ((await BackendlessUI.Functions.Custom['fn_a0029e53d7d4c3e13bac42c9819788e1']((Points[(Counter - 1)]), (Points[((Counter + 1) - 1)]))) + 90))),[`Point 1`]: Points[(Counter - 1)],[`Point 2`]: Points[((Counter + 1) - 1)],[`Distance`]: (await BackendlessUI.Functions.Custom['fn_24a626fc74c34a9805e7999658bdcfd6']((Points[(Counter - 1)]), (Points[((Counter + 1) - 1)]))) });
      Counter = Counter + 1;
      addItemToList(Segmants, Segment);
    }
  }
  Object2 = ({ [`Distance`]: (await Promise.all(Segmants.map(async item => {; return (getObjectProperty(item, 'Distance'));}))).reduce(function(x, y) {return x + y;}),[`Polygon`]: ({ [`color`]: Description,[`description`]: Opacity,[`opacity`]: undefined,[`polygon`]: ({ [`boundary`]: ({ [`points`]: ((await Promise.all((await asyncListSort(Segmants, 1, async (item) => {


   return (getObjectProperty(item, 'Order'));
  })).map(async item => {; return ({ [`lat`]: (getObjectProperty((getObjectProperty(item, 'Point 1')), 'lat')),[`lng`]: (getObjectProperty((getObjectProperty(item, 'Point 1')), 'lng')) });}))).concat((await Promise.all((await asyncListSort(Segmants, -1, async (item) => {


   return (getObjectProperty(item, 'Order'));
  })).map(async item => {; return ({ [`lat`]: (getObjectProperty((getObjectProperty(item, 'Point 1 (90)')), 'lat')),[`lng`]: (getObjectProperty((getObjectProperty(item, 'Point 1 (90)')), 'lng')) });}))))) }) }) }) });

return Object2
}

})
define('./functions/520e5b11f44ee8f88266875f0285766e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_520e5b11f44ee8f88266875f0285766e'] = async function fn_520e5b11f44ee8f88266875f0285766e(propertyNamesList, propertyValuesList) {
return (await (async function(props, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.zipObject(props, values)
})(propertyNamesList, propertyValuesList))
}

})
define('./functions/52fdb524073bbad39dd107b4c7541e2d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_52fdb524073bbad39dd107b4c7541e2d'] = async function fn_52fdb524073bbad39dd107b4c7541e2d(listToQuery, valuePickerFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.takeWhile(array, predicate)
})(listToQuery, valuePickerFunction))
}

})
define('./functions/56599adc54c74c9fdbc667193c854a77/code.js', () => { 

BackendlessUI.Functions.Custom['fn_56599adc54c74c9fdbc667193c854a77'] = async function fn_56599adc54c74c9fdbc667193c854a77(listToQuery, numberOfElementsToDrop) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.drop(array, n)
})(listToQuery, numberOfElementsToDrop))
}

})
define('./functions/56884591a118bc7af84daa6bfc0ea942/code.js', () => { 

BackendlessUI.Functions.Custom['fn_56884591a118bc7af84daa6bfc0ea942'] = async function fn_56884591a118bc7af84daa6bfc0ea942(listToModify, valuesToRemove, filterFunction) {
  await (async function(array, values, iteratee) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pullAllBy(array, values, iteratee)
  })(listToModify, valuesToRemove, filterFunction);

}

})
define('./functions/58ac96052b6cbe4266b47f18e18aecef/code.js', () => { 

BackendlessUI.Functions.Custom['fn_58ac96052b6cbe4266b47f18e18aecef'] = async function fn_58ac96052b6cbe4266b47f18e18aecef(listToInspect, valueToSearchFor) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedLastIndexOf(array, value)
})(listToInspect, valueToSearchFor))
}

})
define('./functions/58b599fc79a1984718ac68445dc7b9e6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_58b599fc79a1984718ac68445dc7b9e6'] = async function fn_58b599fc79a1984718ac68445dc7b9e6(listToFill, valueToFillListWith, startPosition, endPosition) {
  await (async function(array, value, start, end) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	if (start == null) {
  	  start = 0
  	}
  	if (end == null) {
  	  end = array.length
  	}

  	_.fill(array, value, start, end)
  })(listToFill, valueToFillListWith, startPosition, endPosition);

}

})
define('./functions/58db38bddf2dcf8f42d5e5214a01acc1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_58db38bddf2dcf8f42d5e5214a01acc1'] = async function fn_58db38bddf2dcf8f42d5e5214a01acc1(listOfGroupedElements) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unzip(array)
})(listOfGroupedElements))
}

})
define('./functions/59242243104f0143a8cfead51a28beb3/code.js', () => { 

BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3'] = function fn_59242243104f0143a8cfead51a28beb3(Value) {
return (Math.round(Value * 100) / 100)
}

})
define('./functions/5aa80c3936bd19c8f14dd135542b64be/code.js', () => { 

BackendlessUI.Functions.Custom['fn_5aa80c3936bd19c8f14dd135542b64be'] = async function fn_5aa80c3936bd19c8f14dd135542b64be(listsTonspect, filterFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.xorBy(...arrays, iteratee)
})(listsTonspect, filterFunction))
}

})
define('./functions/601f96e6c6e413ff585a05b78783325d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_601f96e6c6e413ff585a05b78783325d'] = async function fn_601f96e6c6e413ff585a05b78783325d(listsToInspect, comparatorFunction) {
return (await (async function(arrays, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unionWith(...arrays, comparator)
})(listsToInspect, comparatorFunction))
}

})
define('./functions/6263de750acd072d3353de89f0beb633/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6263de750acd072d3353de89f0beb633'] = async function fn_6263de750acd072d3353de89f0beb633(IDTractor, Tractor, Monthend) {
var Conductor_2_Salary, Conductor_2, Conductor_1_Salary, Conductor_1, Driver_Salary, Driver, Fleetview, Tractor, error, Transaction_Result, Fleetview_Updater, Found_Loads, Created_Fleet_View, Found_Fuel, Tyre_CPK, item, Salary_3, Salary_2, Salary_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function mathMean(myList) {
  return myList.reduce(function(x, y) {return x + y;}) / myList.length;
}

/**
 * Describe this function...
 */
async function Fleetview_Recalculate() {
  Fleetview['Current_Mileage'] = (getObjectProperty(Tractor, 'Odometer'));
  Fleetview['Fuel_Consumption_5Tanks'] = ((await Promise.all(((await asyncListSort((getObjectProperty(Tractor, 'Fuel')), -1, async (item) => {


   return (getObjectProperty(item, 'created'));
  })).slice(0, 5)).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;}) / (await Promise.all(((await asyncListSort((getObjectProperty(Tractor, 'Fuel')), -1, async (item) => {


   return (getObjectProperty(item, 'created'));
  })).slice(0, 5)).map(async item => {; return (getObjectProperty(item, 'Litres'));}))).reduce(function(x, y) {return x + y;}));
  try {
    Fleetview['Distance_Travelled'] = ((await Promise.all((await asyncListFilter((getObjectProperty(Fleetview, 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) == 'Delivered');
    })).map(async item => {; return (getObjectProperty(item, 'Distance_Planned_LDP_To_DP'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Distance_Travelled'] = 0;
    }

  }
  try {
    Fleetview['Distance_Actual'] = ((await Promise.all((await asyncListFilter((getObjectProperty(Fleetview, 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) == 'Delivered');
    })).map(async item => {; return (getObjectProperty(item, 'Distance_Last_Delivery_Point_To_Load_Point'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Distance_Actual'] = 0;
    }

  }
  try {
    Fleetview['Distance_Travelled_Mileage'] = ((await Promise.all((getObjectProperty(Fleetview, 'Fuel')).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Distance_Travelled_Mileage'] = 0;
    }

  }
  Fleetview['Fuel_Consumption_Ideal'] = (getObjectProperty(Tractor, 'Ideal_Fuel_Consumption'));
  try {
    Fleetview['Fuel_Cost'] = ((await Promise.all((getObjectProperty(Fleetview, 'Fuel')).map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Fuel_Cost'] = 0;
    }

  }
  try {
    Fleetview['Fuel_Litres'] = ((await Promise.all((getObjectProperty(Fleetview, 'Fuel')).map(async item => {; return (getObjectProperty(item, 'Litres'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Fuel_Litres'] = 0;
    }

  }
  try {
    Fleetview['Gain_Loss_On_Loading_Delays'] = ((await Promise.all((getObjectProperty(Fleetview, 'Loads')).map(async item => {; return (getObjectProperty(item, 'Financial_Gain_Loss_Trip_Time_Differential'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Gain_Loss_On_Loading_Delays'] = 0;
    }

  }
  try {
    Fleetview['Gain_Loss_On_Loading_Mileage'] = ((await Promise.all((getObjectProperty(Fleetview, 'Loads')).map(async item => {; return (getObjectProperty(item, 'Financial_Gain_Loss_Distance_Differential'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Gain_Loss_On_Loading_Mileage'] = 0;
    }

  }
  try {
    Fleetview['Gain_Loss_On_Loading_Tonnage'] = ((await Promise.all((getObjectProperty(Fleetview, 'Loads')).map(async item => {; return (getObjectProperty(item, 'Financial_Gain_Loss_Tonnage_Differential'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Gain_Loss_On_Loading_Tonnage'] = 0;
    }

  }
  Fleetview['Licenses_Due'] = ({ [`Tractor`]: ['Tractor (',(getObjectProperty(Tractor, 'ID')),' - ',(getObjectProperty(Tractor, 'Registration')),') - ',(getObjectProperty(Tractor, 'License_Status'))].join(''),[`Trailer1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? null : ['Trailer 1 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'License_Status'))].join(''),[`Trailer2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? null : ['Trailer 2 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'License_Status'))].join(''),[`Trailer3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? null : ['Trailer 3 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'License_Status'))].join(''),[`Driver1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1')))) ? null : ['Driver (',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Company_ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Employee_Details_Nickname')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Driver_License_Expirey_Date_Status'))].join(''),[`Driver1PDP`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1')))) ? null : ['Driver (',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Company_ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Employee_Details_Nickname')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Driver_PDP_Expiry_Date_Status'))].join('') });
  try {
    Fleetview['Maintenance_Plan_Per_Km_Total'] = ((await Promise.all((getObjectProperty(Fleetview, 'Fuel')).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;}) * (getObjectProperty(Tractor, 'Maintenance_Plan_Rate_per_Km')));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Maintenance_Plan_Per_Km_Total'] = 0;
    }

  }
  Fleetview['Maintenance_Repairs_Tractor'] = ((getObjectProperty(Tractor, 'Maintenance')).length == 0 ? 0 : ((await asyncListFilter((getObjectProperty(Tractor, 'Maintenance')), async (item) => {


   return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)));
  })) == 0 ? 0 : ((await asyncListFilter((await asyncListFilter((getObjectProperty(Tractor, 'Maintenance')), async (item) => {


   return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)));
  })), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Repair');
  })) == 0 ? 0 : (await Promise.all((await asyncListFilter((getObjectProperty(Tractor, 'Maintenance')), async (item) => {


   return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)));
  })).map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;}))));
  try {
    Fleetview['Maintenance_Repairs_Trailers'] = ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? 0 : ((getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Maintenance')).length == 0 ? 0 : ((await asyncListFilter((getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Maintenance')), async (item) => {


     return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((new Date()))));
    })) == 0 ? 0 : (await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Maintenance')), async (item) => {


     return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((new Date()))));
    })).map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;}))), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? 0 : ((getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Maintenance')).length == 0 ? 0 : ((await asyncListFilter((getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Maintenance')), async (item) => {


     return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((new Date()))));
    })) == 0 ? 0 : (await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Maintenance')), async (item) => {


     return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((new Date()))));
    })).map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;}))), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? 0 : ((getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Maintenance')).length == 0 ? 0 : ((await asyncListFilter((getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Maintenance')), async (item) => {


     return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((new Date()))));
    })) == 0 ? 0 : (await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Maintenance')), async (item) => {


     return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((new Date()))));
    })).map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;})))].reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  }
  Fleetview['Mileage_Target'] = (getObjectProperty(Tractor, 'Monthly_Mileage_Target'));
  Fleetview['Now'] = (new Date());
  Fleetview['Profit_Target'] = (getObjectProperty(Tractor, 'Monthly_Profit_Target'));
  try {
    Fleetview['Projected_Commission'] = 0;

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Projected_Commission'] = 0;
    }

  }
  try {
    Salary_1 = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1')))) ? 0 : (getObjectProperty(Driver_Salary, 'Total'));

  } catch (error) {
    console.log(error);

  }
  try {
    Salary_2 = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor1')))) ? 0 : (getObjectProperty(Conductor_1_Salary, 'Total'));

  } catch (error) {
    console.log(error);

  }
  try {
    Salary_3 = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor2')))) ? 0 : (getObjectProperty(Conductor_2_Salary, 'Total'));

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Salary_Wages'] = (Salary_1 + Salary_2 + Salary_3);

  } catch (error) {
    if (error) {
      Fleetview['Salary_Wages'] = 0;
    }

  }
  Fleetview['Service_Notices'] = ({ [`Tractor`]: ['Tractor (',(getObjectProperty(Tractor, 'ID')),' - ',(getObjectProperty(Tractor, 'Registration')),') - ',(getObjectProperty(Tractor, 'Service_Status'))].join(''),[`Trailer1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? null : ['Trailer 1 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Service_Status'))].join(''),[`Trailer2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? null : ['Trailer 2 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Service_Status'))].join(''),[`Trailer3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? null : ['Trailer 3 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Service_Status'))].join('') });
  Fleetview['Toll_Fees'] = ((getObjectProperty(Tractor, 'Other')).length == 0 ? 0 : (await Promise.all((await asyncListFilter((await asyncListFilter((getObjectProperty(Tractor, 'Other')), async (item) => {


   return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)));
  })), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Toll Fee');
  })).map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;}));
  try {
    Fleetview['Toll_Fees_Per_Km_Total'] = ((await Promise.all((getObjectProperty(Fleetview, 'Fuel')).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;}) * (getObjectProperty(Tractor, 'Toll_Rate_per_Km')));

  } catch (error) {
    if (error) {
      Fleetview['Toll_Fees_Per_Km_Total'] = 0;
    }

  }
  try {
    Fleetview['Tonnage_Average'] = (mathMean(await Promise.all((getObjectProperty(Fleetview, 'Loads')).map(async item => {; return (getObjectProperty(item, 'Tonnage_Delivered'));}))));

  } catch (error) {
    if (error) {
      Fleetview['Tonnage_Average'] = 0;
    }

  }
  Fleetview['Tonnage_Permissible'] = (getObjectProperty(Tractor, 'Payload'));
  Fleetview['Tonnage_Target'] = (getObjectProperty(Tractor, 'Monthly_Tonnage_Target'));
  try {
    Fleetview['Tonnage_Total'] = ((await Promise.all((getObjectProperty(Fleetview, 'Loads')).map(async item => {; return (getObjectProperty(item, 'Tonnage_Delivered'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    if (error) {
      Fleetview['Tonnage_Total'] = 0;
    }

  }
  Fleetview['Tractor_Fixed_Expenses'] = (getObjectProperty(Tractor, 'Cost Fixed'));
  Fleetview['Trailer_Fixed_Expenses'] = ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? 0 : (getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Cost Fixed')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? 0 : (getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Cost Fixed')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? 0 : (getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Cost Fixed'))].reduce(function(x, y) {return x + y;}));
  try {
    Fleetview['Turnover'] = ((await Promise.all((getObjectProperty(Fleetview, 'Loads')).map(async item => {; return (getObjectProperty(item, 'Financial_Load_Value'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    if (error) {
      Fleetview['Turnover'] = 0;
    }

  }
  try {
    Tyre_CPK = [(await Promise.all((getObjectProperty(Tractor, 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;})].reduce(function(x, y) {return x + y;});

  } catch (error) {
    if (error) {
      Tyre_CPK = 0;
    }

  }
  Fleetview['Tyre_CPK_Estimated'] = Tyre_CPK;
  Fleetview['Tyre_Expenses_Actual'] = 0;
  Fleetview['Tyre_Expenses_Estimated'] = ((getObjectProperty(Fleetview, 'Mileage_Projected')) * Tyre_CPK);
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Tractor))) {
    Tractor = (await Backendless.Data.of('Tractors').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',IDTractor,'\''].join(''))).setRelated(['Other', 'Trailer1.Maintenance', 'Trailer2.Maintenance', 'Trailer3.Maintenance', 'Current_Fleetview', 'Current_Fleetview.Fuel', 'Current_Fleetview.Loads', 'Company', 'Trailer1', 'Trailer2', 'Trailer3', 'Trailer1.Axles_Data.Tyre L1.Transactions', 'Trailer1.Axles_Data.Tyre L2.Transactions', 'Trailer1.Axles_Data.Tyre L3.Transactions', 'Trailer1.Axles_Data.Tyre L4.Transactions', 'Trailer1.Axles_Data.Tyre R1.Transactions', 'Trailer1.Axles_Data.Tyre R2.Transactions', 'Trailer1.Axles_Data.Tyre R3.Transactions', 'Trailer1.Axles_Data.Tyre R4.Transactions', 'Trailer2.Axles_Data.Tyre L1.Transactions', 'Trailer2.Axles_Data.Tyre L2.Transactions', 'Trailer2.Axles_Data.Tyre L3.Transactions', 'Trailer2.Axles_Data.Tyre L4.Transactions', 'Trailer2.Axles_Data.Tyre R1.Transactions', 'Trailer2.Axles_Data.Tyre R2.Transactions', 'Trailer2.Axles_Data.Tyre R3.Transactions', 'Trailer2.Axles_Data.Tyre R4.Transactions', 'Trailer3.Axles_Data.Tyre L1.Transactions', 'Trailer3.Axles_Data.Tyre L2.Transactions', 'Trailer3.Axles_Data.Tyre L3.Transactions', 'Trailer3.Axles_Data.Tyre L4.Transactions', 'Trailer3.Axles_Data.Tyre R1.Transactions', 'Trailer3.Axles_Data.Tyre R2.Transactions', 'Trailer3.Axles_Data.Tyre R3.Transactions', 'Trailer3.Axles_Data.Tyre R4.Transactions', 'Axles_Data', 'Axles_Data.Tyre L1', 'Axles_Data.Tyre L2', 'Axles_Data.Tyre L3', 'Axles_Data.Tyre L4', 'Axles_Data.Tyre R1', 'Axles_Data.Tyre R2', 'Axles_Data.Tyre R3', 'Axles_Data.Tyre R4', 'Trailer1.Axles_Data', 'Trailer2.Axles_Data', 'Trailer3.Axles_Data', 'Breakdowns', 'Driver1', 'Conductor1', 'Conductor2', 'Driver1.Wages_Current', 'Conductor1.Wages_Current', 'Conductor2.Wages_Current', 'Fuel', 'Loads', 'Maintenance', 'Other', 'Tyres', 'Driver1.Wages_Current.Fuel', 'Driver1.Wages_Current.Loads']).setRelationsDepth(10).setRelationsPageSize(100).setPageSize(100)))[0];
    if ((new Date((new Date())).getMonth() + 1) == (new Date((getObjectProperty((getObjectProperty(Tractor, 'Current_Fleetview')), 'created'))).getMonth() + 1)) {
      Fleetview = (getObjectProperty(Tractor, 'Current_Fleetview'));
      try {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1'))))) {
        } else {
          Driver = (await BackendlessUI.Functions.Custom['fn_b7bebd6f2ccdf3d6bdb2577d4e1da8e4']((getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'ownerId'))));
          Driver_Salary = (getObjectProperty((getObjectProperty(Driver, 'Details')), 'Wages_Current'));
          console.log(Driver);
        }

      } catch (error) {

      }
      try {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor1'))))) {
        } else {
          Conductor_1 = (await BackendlessUI.Functions.Custom['fn_b7bebd6f2ccdf3d6bdb2577d4e1da8e4']((getObjectProperty((getObjectProperty(Tractor, 'Conductor1')), 'ownerId'))));
          Conductor_1_Salary = (getObjectProperty((getObjectProperty(Conductor_1, 'Details')), 'Wages_Current'));
        }

      } catch (error) {

      }
      try {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor2'))))) {
        } else {
          Conductor_2 = (await BackendlessUI.Functions.Custom['fn_b7bebd6f2ccdf3d6bdb2577d4e1da8e4']((getObjectProperty((getObjectProperty(Tractor, 'Conductor2')), 'ownerId'))));
          Conductor_2_Salary = (getObjectProperty((getObjectProperty(Conductor_2_Salary, 'Details')), 'Wages_Current'));
        }

      } catch (error) {

      }
      await Fleetview_Recalculate();
      Fleetview_Updater = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = Fleetview_Updater;

        Found_Fuel = (_uow.find('Fuel', Backendless.DataQueryBuilder.create().setWhereClause((['TObjectID = \'',(getObjectProperty(Tractor, 'objectId')),'\' AND ((Date_Actual IS NULL AND created >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND created <= \'',((new Date()).valueOf()),'\') OR (Date_Actual IS NOT NULL AND Date_Actual >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND Date_Actual <= \'',((new Date()).valueOf()),'\'))'].join(''))).setPageSize(100)));
        Found_Loads = (_uow.find('Loads', Backendless.DataQueryBuilder.create().setWhereClause((['TID = \'',IDTractor,'\' AND Date_Delivered >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND Date_Delivered <= \'',((new Date()).valueOf()),'\''].join(''))).setPageSize(100)));
        _uow.setRelation('Fleetview', Fleetview, 'Fuel', Found_Fuel);
        _uow.setRelation('Fleetview', Fleetview, 'Loads', Found_Loads);
        Fleetview = (await Backendless.Data.of('Fleetview').save(Fleetview, true));

      })();

      Transaction_Result = (await Fleetview_Updater.execute());
    } else {
      Fleetview_Updater = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = Fleetview_Updater;

        Found_Fuel = (_uow.find('Fuel', Backendless.DataQueryBuilder.create().setWhereClause((['TObjectID = \'',(getObjectProperty(Tractor, 'objectId')),'\' AND ((Date_Actual IS NULL AND created >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND created <= \'',((new Date()).valueOf()),'\') OR (Date_Actual IS NOT NULL AND Date_Actual >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND Date_Actual <= \'',((new Date()).valueOf()),'\'))'].join(''))).setPageSize(100)));
        Found_Loads = (_uow.find('Loads', Backendless.DataQueryBuilder.create().setWhereClause((['TID = \'',(getObjectProperty(Tractor, 'objectId')),'\' AND Date_Delivered >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND Date_Delivered <= \'',((new Date()).valueOf()),'\''].join(''))).setPageSize(100)));
        _uow.addToRelation('Tractors', Tractor, 'Fleetview_Historical', [(getObjectProperty(Tractor, 'Current_Fleetview'))]);
        try {
          Tyre_CPK = [(await Promise.all((getObjectProperty(Tractor, 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;})].reduce(function(x, y) {return x + y;});

        } catch (error) {
          console.log(error);

        } finally {
          if (error) {
            Tyre_CPK = 0;
          }

        }
        Created_Fleet_View = (_uow.create('Fleetview', ({ [`Current_Mileage`]: (getObjectProperty(Tractor, 'Odometer')),[`Distance_Actual`]: 0,[`Distance_Travelled`]: 0,[`Distance_Travelled_Mileage`]: 0,[`Fuel_Consumption_Ideal`]: (getObjectProperty(Tractor, 'Ideal_Fuel_Consumption')),[`Fuel_Cost`]: 0,[`Fuel_Litres`]: 0,[`Gain_Loss_On_Loading_Delays`]: 0,[`Gain_Loss_On_Loading_Mileage`]: 0,[`Gain_Loss_On_Loading_Tonnage`]: 0,[`Licenses_Due`]: ({ [`Tractor`]: ['Tractor (',(getObjectProperty(Tractor, 'ID')),' - ',(getObjectProperty(Tractor, 'Registration')),') - ',(getObjectProperty(Tractor, 'License_Status'))].join(''),[`Trailer1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? null : ['Trailer 1 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'License_Status'))].join(''),[`Trailer2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? null : ['Trailer 2 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'License_Status'))].join(''),[`Trailer3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? null : ['Trailer 3 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'License_Status'))].join(''),[`Driver1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1')))) ? null : ['Driver (',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Company_ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Employee_Details_Nickname')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Driver_License_Expirey_Date_Status'))].join(''),[`Driver1PDP`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1')))) ? null : ['Driver (',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Company_ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Employee_Details_Nickname')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Driver_PDP_Expiry_Date_Status'))].join('') }),[`Maintenance_Plan_Per_Km_Total`]: 0,[`Maintenance_Repairs_Tractor`]: 0,[`Maintenance_Repairs_Trailers`]: 0,[`Mileage_Target`]: (getObjectProperty(Tractor, 'Monthly_Mileage_Target')),[`Now`]: (new Date()),[`Profit_Target`]: (getObjectProperty(Tractor, 'Monthly_Profit_Target')),[`Projected_Commission`]: 0,[`Salary_Wages`]: ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Wages_Current')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Wages_Current')), 'Total')))) ? 0 : (getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Wages_Current')), 'Total'))))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(Tractor, 'Conductor1')), 'Wages_Current')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Conductor1')), 'Wages_Current')), 'Total')))) ? 0 : (getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Conductor1')), 'Wages_Current')), 'Total'))))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(Tractor, 'Conductor2')), 'Wages_Current')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Conductor2')), 'Wages_Current')), 'Total')))) ? 0 : (getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Conductor2')), 'Wages_Current')), 'Total'))))),[`Service_Notices`]: ({ [`Tractor`]: ['Tractor (',(getObjectProperty(Tractor, 'ID')),' - ',(getObjectProperty(Tractor, 'Registration')),') - ',(getObjectProperty(Tractor, 'Service_Status'))].join(''),[`Trailer1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? null : ['Trailer 1 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Service_Status'))].join(''),[`Trailer2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? null : ['Trailer 2 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Service_Status'))].join(''),[`Trailer3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? null : ['Trailer 3 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Service_Status'))].join('') }),[`Toll_Fees`]: 0,[`Toll_Fees_Per_Km_Total`]: 0,[`Tonnage_Average`]: 0,[`Tonnage_Permissible`]: (getObjectProperty(Tractor, 'Payload')),[`Tonnage_Target`]: (getObjectProperty(Tractor, 'Monthly_Tonnage_Target')),[`Tonnage_Total`]: 0,[`Tractor_Fixed_Expenses`]: (getObjectProperty(Tractor, 'Cost Fixed')),[`Trailer_Fixed_Expenses`]: [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? 0 : (getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Cost Fixed')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? 0 : (getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Cost Fixed')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? 0 : (getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Cost Fixed'))].reduce(function(x, y) {return x + y;}),[`Turnover`]: 0,[`Tyre_CPK_Estimated`]: Tyre_CPK,[`Tyre_Expenses_Actual`]: 0,[`Tyre_Expenses_Estimated`]: (getObjectProperty(Tractor, 'Monthly_Mileage_Target')) * Tyre_CPK,[`ownerId`]: (getObjectProperty(Tractor, 'ownerId')) })));
        _uow.setRelation('Tractors', Tractor, 'Fleetview_Current', [Created_Fleet_View]);
        _uow.setRelation('Tractors', Tractor, 'Current_Fleetview', [Created_Fleet_View]);
        _uow.addToRelation('Tractors', Tractor, 'Fleetview_Historical', [Created_Fleet_View]);
        _uow.setRelation('Fleetview', Created_Fleet_View, 'Fuel', Found_Fuel);
        _uow.setRelation('Fleetview', Created_Fleet_View, 'Loads', Found_Loads);

      })();

      Transaction_Result = (await Fleetview_Updater.execute());
      console.log(Transaction_Result);
      try {
        Fleetview = (getObjectProperty((getObjectProperty((getObjectProperty(Transaction_Result, 'results')), 'upsertFleetview1')), 'result'));

      } catch (error) {
        console.log(error);

      }
    }
  } else {
    Tractor = Tractor;
    if ((new Date((new Date())).getMonth() + 1) == (new Date((getObjectProperty((getObjectProperty(Tractor, 'Current_Fleetview')), 'created'))).getMonth() + 1)) {
      Fleetview = (getObjectProperty(Tractor, 'Current_Fleetview'));
      Found_Fuel = (await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['TObjectID = \'',(getObjectProperty(Tractor, 'objectId')),'\' AND ((Date_Actual IS NULL AND created >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND created <= \'',((new Date()).valueOf()),'\') OR (Date_Actual IS NOT NULL AND Date_Actual >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND Date_Actual <= \'',((new Date()).valueOf()),'\'))'].join(''))).setPageSize(100)));
      Found_Loads = (await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['TID = \'',(getObjectProperty(Tractor, 'objectId')),'\' AND Date_Delivered >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND Date_Delivered <= \'',((new Date()).valueOf()),'\''].join(''))).setPageSize(10)));
      Fleetview['Fuel'] = Found_Fuel;
      Fleetview['Loads'] = Found_Loads;
      try {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1'))))) {
        } else {
          Driver = (await BackendlessUI.Functions.Custom['fn_b7bebd6f2ccdf3d6bdb2577d4e1da8e4']((getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'ownerId'))));
          Driver_Salary = (getObjectProperty((getObjectProperty(Driver, 'Details')), 'Wages_Current'));
          console.log(Driver);
        }

      } catch (error) {

      }
      try {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor1'))))) {
        } else {
          Conductor_1 = (await BackendlessUI.Functions.Custom['fn_b7bebd6f2ccdf3d6bdb2577d4e1da8e4']((getObjectProperty((getObjectProperty(Tractor, 'Conductor1')), 'ownerId'))));
          Conductor_1_Salary = (getObjectProperty((getObjectProperty(Conductor_1, 'Details')), 'Wages_Current'));
        }

      } catch (error) {

      }
      try {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor2'))))) {
        } else {
          Conductor_2 = (await BackendlessUI.Functions.Custom['fn_b7bebd6f2ccdf3d6bdb2577d4e1da8e4']((getObjectProperty((getObjectProperty(Tractor, 'Conductor2')), 'ownerId'))));
          Conductor_2_Salary = (getObjectProperty((getObjectProperty(Conductor_2_Salary, 'Details')), 'Wages_Current'));
        }

      } catch (error) {

      }
      await Fleetview_Recalculate();
      Fleetview_Updater = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = Fleetview_Updater;

        Found_Fuel = (_uow.find('Fuel', Backendless.DataQueryBuilder.create().setWhereClause((['TObjectID = \'',IDTractor,'\' AND created >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND created <= \'',((new Date()).valueOf()),'\''].join(''))).setPageSize(100)));
        Found_Loads = (_uow.find('Loads', Backendless.DataQueryBuilder.create().setWhereClause((['TID = \'',IDTractor,'\' AND Date_Delivered >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND Date_Delivered <= \'',((new Date()).valueOf()),'\''].join(''))).setPageSize(100)));
        _uow.setRelation('Fleetview', Fleetview, 'Fuel', Found_Fuel);
        _uow.setRelation('Fleetview', Fleetview, 'Loads', Found_Loads);
        Fleetview = (await Backendless.Data.of('Fleetview').save(Fleetview, true));

      })();

      Transaction_Result = (await Fleetview_Updater.execute());
    } else {
      Fleetview_Updater = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = Fleetview_Updater;

        Found_Fuel = (_uow.find('Fuel', Backendless.DataQueryBuilder.create().setWhereClause((['TObjectID = \'',(getObjectProperty(Tractor, 'objectId')),'\' AND ((Date_Actual IS NULL AND created >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND created <= \'',((new Date()).valueOf()),'\') OR (Date_Actual IS NOT NULL AND Date_Actual >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND Date_Actual <= \'',((new Date()).valueOf()),'\'))'].join(''))).setPageSize(100)));
        Found_Loads = (_uow.find('Loads', Backendless.DataQueryBuilder.create().setWhereClause((['TID = \'',(getObjectProperty(Tractor, 'objectId')),'\' AND Date_Delivered >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND Date_Delivered <= \'',((new Date()).valueOf()),'\''].join(''))).setPageSize(100)));
        _uow.addToRelation('Tractors', Tractor, 'Fleetview_Historical', [(getObjectProperty(Tractor, 'Current_Fleetview'))]);
        try {
          Tyre_CPK = [(await Promise.all((getObjectProperty(Tractor, 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;})].reduce(function(x, y) {return x + y;});

        } catch (error) {
          console.log(error);

        } finally {
          if (error) {
            Tyre_CPK = 0;
          }

        }
        Created_Fleet_View = (_uow.create('Fleetview', ({ [`Current_Mileage`]: (getObjectProperty(Tractor, 'Odometer')),[`Distance_Actual`]: 0,[`Distance_Travelled`]: 0,[`Distance_Travelled_Mileage`]: 0,[`Fuel_Consumption_Ideal`]: (getObjectProperty(Tractor, 'Ideal_Fuel_Consumption')),[`Fuel_Cost`]: 0,[`Fuel_Litres`]: 0,[`Gain_Loss_On_Loading_Delays`]: 0,[`Gain_Loss_On_Loading_Mileage`]: 0,[`Gain_Loss_On_Loading_Tonnage`]: 0,[`Licenses_Due`]: ({ [`Tractor`]: ['Tractor (',(getObjectProperty(Tractor, 'ID')),' - ',(getObjectProperty(Tractor, 'Registration')),') - ',(getObjectProperty(Tractor, 'License_Status'))].join(''),[`Trailer1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? null : ['Trailer 1 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'License_Status'))].join(''),[`Trailer2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? null : ['Trailer 2 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'License_Status'))].join(''),[`Trailer3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? null : ['Trailer 3 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'License_Status'))].join(''),[`Driver1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1')))) ? null : ['Driver (',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Company_ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Employee_Details_Nickname')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Driver_License_Expirey_Date_Status'))].join(''),[`Driver1PDP`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1')))) ? null : ['Driver (',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Company_ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Employee_Details_Nickname')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Driver_PDP_Expiry_Date_Status'))].join('') }),[`Maintenance_Plan_Per_Km_Total`]: 0,[`Maintenance_Repairs_Tractor`]: 0,[`Maintenance_Repairs_Trailers`]: 0,[`Mileage_Target`]: (getObjectProperty(Tractor, 'Monthly_Mileage_Target')),[`Now`]: (new Date()),[`Profit_Target`]: (getObjectProperty(Tractor, 'Monthly_Profit_Target')),[`Projected_Commission`]: 0,[`Salary_Wages`]: ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Wages_Current')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Wages_Current')), 'Total')))) ? 0 : (getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Wages_Current')), 'Total'))))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(Tractor, 'Conductor1')), 'Wages_Current')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Conductor1')), 'Wages_Current')), 'Total')))) ? 0 : (getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Conductor1')), 'Wages_Current')), 'Total'))))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(Tractor, 'Conductor2')), 'Wages_Current')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Conductor2')), 'Wages_Current')), 'Total')))) ? 0 : (getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Conductor2')), 'Wages_Current')), 'Total'))))),[`Service_Notices`]: ({ [`Tractor`]: ['Tractor (',(getObjectProperty(Tractor, 'ID')),' - ',(getObjectProperty(Tractor, 'Registration')),') - ',(getObjectProperty(Tractor, 'Service_Status'))].join(''),[`Trailer1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? null : ['Trailer 1 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Service_Status'))].join(''),[`Trailer2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? null : ['Trailer 2 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Service_Status'))].join(''),[`Trailer3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? null : ['Trailer 3 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Service_Status'))].join('') }),[`Toll_Fees`]: 0,[`Toll_Fees_Per_Km_Total`]: 0,[`Tonnage_Average`]: 0,[`Tonnage_Permissible`]: (getObjectProperty(Tractor, 'Payload')),[`Tonnage_Target`]: (getObjectProperty(Tractor, 'Monthly_Tonnage_Target')),[`Tonnage_Total`]: 0,[`Tractor_Fixed_Expenses`]: (getObjectProperty(Tractor, 'Cost Fixed')),[`Trailer_Fixed_Expenses`]: [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? 0 : (getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Cost Fixed')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? 0 : (getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Cost Fixed')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? 0 : (getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Cost Fixed'))].reduce(function(x, y) {return x + y;}),[`Turnover`]: 0,[`Tyre_CPK_Estimated`]: Tyre_CPK,[`Tyre_Expenses_Actual`]: 0,[`Tyre_Expenses_Estimated`]: (getObjectProperty(Tractor, 'Monthly_Mileage_Target')) * Tyre_CPK,[`ownerId`]: (getObjectProperty(Tractor, 'ownerId')) })));
        _uow.setRelation('Tractors', Tractor, 'Fleetview_Current', [Created_Fleet_View]);
        _uow.setRelation('Tractors', Tractor, 'Current_Fleetview', [Created_Fleet_View]);
        _uow.addToRelation('Tractors', Tractor, 'Fleetview_Historical', [Created_Fleet_View]);
        _uow.setRelation('Fleetview', Created_Fleet_View, 'Fuel', Found_Fuel);
        _uow.setRelation('Fleetview', Created_Fleet_View, 'Loads', Found_Loads);

      })();

      Transaction_Result = (await Fleetview_Updater.execute());
      try {
        Fleetview = (getObjectProperty((getObjectProperty((getObjectProperty(Transaction_Result, 'results')), 'upsertFleetview1')), 'result'));

      } catch (error) {
        console.log(error);

      }
    }
  }

return ({ [`Tractor`]: Tractor,[`Fleetview`]: Fleetview,[`Driver`]: Driver,[`Driver Salary`]: Driver_Salary,[`Conductor 1`]: Conductor_1,[`Conductor 1 Salary`]: Conductor_1_Salary,[`Conductor 2`]: Conductor_2,[`Conductor 2 Salary`]: Conductor_2_Salary })
}

})
define('./functions/6611957448e6393c2b3f73da5bb66bcd/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd'] = async function fn_6611957448e6393c2b3f73da5bb66bcd(Timestamp) {
return (await (async function(Start) {
	function getStartOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const startOfMonth = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
	  startOfMonth.setHours(0, 0, 0, 0); // Set to the start of the day
	
	  return startOfMonth.getTime();
	}
	
	// Directly execute and return the result
	return getStartOfMonthTimestamp(Start);
})(Timestamp))
}

})
define('./functions/6fc870fc98c8afb7acb79fd769a3f969/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6fc870fc98c8afb7acb79fd769a3f969'] = async function fn_6fc870fc98c8afb7acb79fd769a3f969(APP, Type, Set, Keys) {
var Final_Value, Value, Tags, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (Set == true) {
    await Backendless.Hive((getObjectProperty((getObjectProperty((getObjectProperty(APP, 'User')), 'Company')), 'objectId'))).KeyValueStore.set(Keys);
  } else {
    Tags = ({ [`Customer`]: (getObjectProperty((getObjectProperty((getObjectProperty(APP, 'User')), 'Company')), 'ID Tag Customers')),[`Employee`]: (getObjectProperty((getObjectProperty((getObjectProperty(APP, 'User')), 'Company')), 'ID Tag Employees')),[`Fuel`]: (getObjectProperty((getObjectProperty((getObjectProperty(APP, 'User')), 'Company')), 'ID Tag Fuel')),[`Load`]: (getObjectProperty((getObjectProperty((getObjectProperty(APP, 'User')), 'Company')), 'ID Tag Loads')),[`Location`]: (getObjectProperty((getObjectProperty((getObjectProperty(APP, 'User')), 'Company')), 'ID Tag Locations')),[`Tractor`]: (getObjectProperty((getObjectProperty((getObjectProperty(APP, 'User')), 'Company')), 'ID Tag Tractors')),[`Trailer`]: (getObjectProperty((getObjectProperty((getObjectProperty(APP, 'User')), 'Company')), 'ID Tag Trailers')),[`Tyre`]: (getObjectProperty((getObjectProperty((getObjectProperty(APP, 'User')), 'Company')), 'ID Tag Tyres')) });
    if ((await asyncListFilter((await Backendless.Hive.getNames()), async (item) => {


     return (item == (getObjectProperty((getObjectProperty((getObjectProperty(APP, 'User')), 'Company')), 'objectId')));
    })).length == 0) {
      await Backendless.Hive((getObjectProperty((getObjectProperty((getObjectProperty(APP, 'User')), 'Company')), 'objectId'))).create();
      await Backendless.Hive((getObjectProperty((getObjectProperty((getObjectProperty(APP, 'User')), 'Company')), 'objectId'))).KeyValueStore.set(({ [`Customer`]: 0,[`Employee`]: 0,[`Fuel`]: 0,[`Load`]: 0,[`Location`]: 0,[`Tractor`]: 0,[`Trailer`]: 0,[`Tyre`]: 0 }));
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((await Backendless.Hive((getObjectProperty((getObjectProperty((getObjectProperty(APP, 'User')), 'Company')), 'objectId'))).KeyValueStore(Type).get())))) {
        Value = (await Backendless.Hive((getObjectProperty((getObjectProperty((getObjectProperty(APP, 'User')), 'Company')), 'objectId'))).KeyValueStore(Type).set(0));
        Final_Value = Value >= 10 ? (Value >= 100 ? (Value >= 1000 ? (Value >= 10000 ? [(getObjectProperty(Tags, Type)),' ',Value].join('') : [(getObjectProperty(Tags, Type)),' 0',Value].join('')) : [(getObjectProperty(Tags, Type)),' 00',Value].join('')) : [(getObjectProperty(Tags, Type)),' 000',Value].join('')) : [(getObjectProperty(Tags, Type)),' 0000',Value].join('');
      } else {
        Value = (await Backendless.Hive((getObjectProperty((getObjectProperty((getObjectProperty(APP, 'User')), 'Company')), 'objectId'))).KeyValueStore(Type).increment(1));
        Final_Value = Value >= 10 ? (Value >= 100 ? (Value >= 1000 ? (Value >= 10000 ? [(getObjectProperty(Tags, Type)),' ',Value].join('') : [(getObjectProperty(Tags, Type)),' 0',Value].join('')) : [(getObjectProperty(Tags, Type)),' 00',Value].join('')) : [(getObjectProperty(Tags, Type)),' 000',Value].join('')) : [(getObjectProperty(Tags, Type)),' 0000',Value].join('');
      }
    }
  }

return Final_Value
}

})
define('./functions/70b8ca4740171f42c0aa414f72c30dde/code.js', () => { 

BackendlessUI.Functions.Custom['fn_70b8ca4740171f42c0aa414f72c30dde'] = async function fn_70b8ca4740171f42c0aa414f72c30dde(Number) {
var Number2;

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  Number2 = Number;
  if (Number.startsWith('0')) {
    Number2 = String('+27') + String(subsequenceFromStartLast((await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Number2)), 1));
  } else if (Number.startsWith('27')) {
    Number2 = String('+27') + String(subsequenceFromStartLast((await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Number2)), 2));
  } else if (Number.startsWith('+27')) {
    Number2 = (await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Number2));
  }

return Number2
}

})
define('./functions/74c621ab98a12163bece4cad7be292b9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_74c621ab98a12163bece4cad7be292b9'] = async function fn_74c621ab98a12163bece4cad7be292b9(listToConcatenate, valuesToConcatenate) {
return (await (async function(array, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.concat(array, ...values)
})(listToConcatenate, valuesToConcatenate))
}

})
define('./functions/7508d2443aea24ba74d73b27671a9829/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7508d2443aea24ba74d73b27671a9829'] = async function fn_7508d2443aea24ba74d73b27671a9829(listToModify, indexesOfElementsToRemove) {
return (await (async function(array, indexes) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.pullAt(array, ...indexes)
})(listToModify, indexesOfElementsToRemove))
}

})
define('./functions/77bed231064ec0e2a7d4ac07f751667a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_77bed231064ec0e2a7d4ac07f751667a'] = async function fn_77bed231064ec0e2a7d4ac07f751667a(listToInspect, functionInvokedPerIteration, indexToSearchFrom) {
return (await (async function(array, predicate, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	  fromIndex = 0
	}

	return _.findIndex(array, predicate, fromIndex)
})(listToInspect, functionInvokedPerIteration, indexToSearchFrom))
}

})
define('./functions/79a6f77258336011dee2ccdfcf062c76/code.js', () => { 

BackendlessUI.Functions.Custom['fn_79a6f77258336011dee2ccdfcf062c76'] = async function fn_79a6f77258336011dee2ccdfcf062c76(listToInspect, valuesToExclude, filterFunction) {
return (await (async function(array, values, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.differenceBy(array, values, iteratee)
})(listToInspect, valuesToExclude, filterFunction))
}

})
define('./functions/7b787368d76d5cd2f383609f56ef4594/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7b787368d76d5cd2f383609f56ef4594'] = async function fn_7b787368d76d5cd2f383609f56ef4594(Timestamp) {
return (await (async function(Start) {
	function getEndOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
	  endDate.setHours(23, 59, 59, 999); // Set to the end of the day
	
	  return endDate.getTime();
	}
	
	// Directly execute and return the result
	return getEndOfMonthTimestamp(Start);
})(Timestamp))
}

})
define('./functions/7bd98f3e8e1d5a6571e78cd4492f75a8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7bd98f3e8e1d5a6571e78cd4492f75a8'] = async function fn_7bd98f3e8e1d5a6571e78cd4492f75a8(listToModify, valuesToRemove, comparatorFunction) {
  await (async function(array, values, comparator) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pullAllWith(array, values, comparator)
  })(listToModify, valuesToRemove, comparatorFunction);

}

})
define('./functions/7e649ea1525e52829e82c43fc4f84e2f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7e649ea1525e52829e82c43fc4f84e2f'] = async function fn_7e649ea1525e52829e82c43fc4f84e2f(listToFlatten) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.flatten(array)
})(listToFlatten))
}

})
define('./functions/82aff119219bba741c2f252f9c283851/code.js', () => { 

BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'] = async function fn_82aff119219bba741c2f252f9c283851(List, Value) {
var Label, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Label = (getObjectProperty(((await asyncListFilter(List, async (item) => {


   return ((getObjectProperty(item, 'value')) == Value);
  }))[0]), 'label'));

return Label
}

})
define('./functions/84c352dcf0d18e7fa2ca41bb0fa92c91/code.js', () => { 

BackendlessUI.Functions.Custom['fn_84c352dcf0d18e7fa2ca41bb0fa92c91'] = async function fn_84c352dcf0d18e7fa2ca41bb0fa92c91(listsToInspect, filterFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.intersectionBy(...arrays, iteratee)
})(listsToInspect, filterFunction))
}

})
define('./functions/854e825608123b86707265b1cfb74f87/code.js', () => { 

BackendlessUI.Functions.Custom['fn_854e825608123b86707265b1cfb74f87'] = async function fn_854e825608123b86707265b1cfb74f87(listToInspect, filterFunction) {
return (await (async function(array, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedUniqBy(array, iteratee)
})(listToInspect, filterFunction))
}

})
define('./functions/864caf316105397480e8aaf7c137edda/code.js', () => { 

BackendlessUI.Functions.Custom['fn_864caf316105397480e8aaf7c137edda'] = async function fn_864caf316105397480e8aaf7c137edda(IDTractor, Date) {
var Data_Extracted, Data_Extractor, error, Fleetview, Fleetview_Updater, Found_Fuel, Found_Loads, item, Tractor, Tractor_Operation, Transaction_Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function mathMean(myList) {
  return myList.reduce(function(x, y) {return x + y;}) / myList.length;
}

/**
 * Describe this function...
 */
async function Fleetview_Recalculate() {
  try {
    Fleetview['Current_Mileage'] = (getObjectProperty(((await asyncListSort(Found_Fuel, -1, async (item) => {


     return (getObjectProperty(item, 'created'));
    }))[0]), 'Mileage'));

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Fuel_Consumption_5Tanks'] = ((await Promise.all(((await asyncListSort(Found_Fuel, -1, async (item) => {


     return (getObjectProperty(item, 'created'));
    })).slice(0, 5)).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;}) / (await Promise.all(((await asyncListSort(Found_Fuel, -1, async (item) => {


     return (getObjectProperty(item, 'created'));
    })).slice(0, 5)).map(async item => {; return (getObjectProperty(item, 'Litres'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Distance_Travelled'] = ((await Promise.all((await asyncListFilter(Found_Loads, async (item) => {


     return ((getObjectProperty(item, 'Status')) == 'Delivered');
    })).map(async item => {; return (getObjectProperty(item, 'Distance_Planned_LDP_To_DP'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Distance_Travelled'] = 0;
    }

  }
  try {
    Fleetview['Distance_Actual'] = ((await Promise.all((await asyncListFilter(Found_Loads, async (item) => {


     return ((getObjectProperty(item, 'Status')) == 'Delivered');
    })).map(async item => {; return (getObjectProperty(item, 'Distance_Last_Delivery_Point_To_Load_Point'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Distance_Actual'] = 0;
    }

  }
  try {
    Fleetview['Distance_Travelled_Mileage'] = ((await Promise.all(Found_Fuel.map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Distance_Travelled_Mileage'] = 0;
    }

  }
  try {
    Fleetview['Fuel_Cost'] = ((await Promise.all(Found_Fuel.map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Fuel_Cost'] = 0;
    }

  }
  try {
    Fleetview['Fuel_Litres'] = ((await Promise.all(Found_Fuel.map(async item => {; return (getObjectProperty(item, 'Litres'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Fuel_Litres'] = 0;
    }

  }
  try {
    Fleetview['Gain_Loss_On_Loading_Delays'] = ((await Promise.all(Found_Loads.map(async item => {; return (getObjectProperty(item, 'Financial_Gain_Loss_Trip_Time_Differential'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Gain_Loss_On_Loading_Delays'] = 0;
    }

  }
  try {
    Fleetview['Gain_Loss_On_Loading_Mileage'] = ((await Promise.all(Found_Loads.map(async item => {; return (getObjectProperty(item, 'Financial_Gain_Loss_Distance_Differential'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Gain_Loss_On_Loading_Mileage'] = 0;
    }

  }
  try {
    Fleetview['Gain_Loss_On_Loading_Tonnage'] = ((await Promise.all(Found_Loads.map(async item => {; return (getObjectProperty(item, 'Financial_Gain_Loss_Tonnage_Differential'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Gain_Loss_On_Loading_Tonnage'] = 0;
    }

  }
  try {
    Fleetview['Maintenance_Plan_Per_Km_Total'] = ((await Promise.all(Found_Fuel.map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;}) * (getObjectProperty(Tractor, 'Maintenance_Plan_Rate_per_Km')));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Maintenance_Plan_Per_Km_Total'] = 0;
    }

  }
  try {
    Fleetview['Now'] = (await BackendlessUI.Functions.Custom['fn_7b787368d76d5cd2f383609f56ef4594'](Date));

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Tonnage_Average'] = (mathMean(await Promise.all(Found_Loads.map(async item => {; return (getObjectProperty(item, 'Tonnage_Delivered'));}))));

  } catch (error) {
    if (error) {
      Fleetview['Tonnage_Average'] = 0;
    }

  }
  try {
    Fleetview['Tonnage_Total'] = ((await Promise.all(Found_Loads.map(async item => {; return (getObjectProperty(item, 'Tonnage_Delivered'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    if (error) {
      Fleetview['Tonnage_Total'] = 0;
    }

  }
  try {
    Fleetview['Turnover'] = ((await Promise.all(Found_Loads.map(async item => {; return (getObjectProperty(item, 'Financial_Load_Value'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    if (error) {
      Fleetview['Turnover'] = 0;
    }

  }
}


  Data_Extractor = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Data_Extractor;

    Tractor_Operation = (_uow.find('Tractors', Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',IDTractor,'\''].join(''))).setRelated(['Fleetview_Historical']).setPageSize(100)));
    _uow.find('Fuel', Backendless.DataQueryBuilder.create().setWhereClause((['TObjectID = \'',IDTractor,'\' AND ((Date_Actual IS NULL AND created >= \'',(await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd'](Date)),'\' AND created <= \'',(await BackendlessUI.Functions.Custom['fn_7b787368d76d5cd2f383609f56ef4594'](Date)),'\') OR (Date_Actual IS NOT NULL AND Date_Actual >= \'',(await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd'](Date)),'\' AND Date_Actual <= \'',(await BackendlessUI.Functions.Custom['fn_7b787368d76d5cd2f383609f56ef4594'](Date)),'\'))'].join(''))).setPageSize(100));
    _uow.find('Loads', Backendless.DataQueryBuilder.create().setWhereClause((['TID = \'',IDTractor,'\' AND Date_Delivered >= \'',(await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd'](Date)),'\' AND Date_Delivered <= \'',(await BackendlessUI.Functions.Custom['fn_7b787368d76d5cd2f383609f56ef4594'](Date)),'\''].join(''))).setPageSize(100));

  })();

  Data_Extracted = (await Data_Extractor.execute());
  Tractor = (getObjectProperty((getObjectProperty((getObjectProperty(Data_Extracted, 'results')), 'findTractors1')), 'result'))[0];
  Found_Fuel = (getObjectProperty((getObjectProperty((getObjectProperty(Data_Extracted, 'results')), 'findFuel1')), 'result'));
  Found_Loads = (getObjectProperty((getObjectProperty((getObjectProperty(Data_Extracted, 'results')), 'findLoads1')), 'result'));
  Fleetview = (await asyncListFilter((getObjectProperty(Tractor, 'Fleetview_Historical')), async (item) => {


   return ((getObjectProperty(item, 'created')) >= (await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd'](Date)) && (getObjectProperty(item, 'created')) <= (await BackendlessUI.Functions.Custom['fn_7b787368d76d5cd2f383609f56ef4594'](Date)));
  }))[0];
  console.log(Found_Loads.length);
  console.log(Found_Fuel.length);
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Fleetview))) {
    Transaction_Result = 'NO DATA';
  } else {
    if (Found_Loads.length == 0 && Found_Fuel.length == 0) {
      Transaction_Result = 'NO DATA';
    } else {
      await Fleetview_Recalculate();
      Fleetview_Updater = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = Fleetview_Updater;

        _uow.setRelation('Fleetview', Fleetview, 'Fuel', Found_Fuel);
        _uow.setRelation('Fleetview', Fleetview, 'Loads', Found_Loads);
        _uow.update('Fleetview', Fleetview);

      })();

      Transaction_Result = (await Fleetview_Updater.execute());
    }
  }

return Transaction_Result
}

})
define('./functions/88481472e3e169797cae85c104751a08/code.js', () => { 

BackendlessUI.Functions.Custom['fn_88481472e3e169797cae85c104751a08'] = async function fn_88481472e3e169797cae85c104751a08(IDTractor, Tractor) {
var Conductor_2_Salary, Conductor_2, Conductor_1_Salary, Conductor_1, Driver_Salary, Driver, Fleetview, Tractor, error, Transaction_Result, Fleetview_Updater, Found_Loads, Created_Fleet_View, Found_Fuel, Tyre_CPK, item, Salary_3, Salary_2, Salary_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function mathMean(myList) {
  return myList.reduce(function(x, y) {return x + y;}) / myList.length;
}

/**
 * Describe this function...
 */
async function Fleetview_Recalculate() {
  try {
    Fleetview['Current_Mileage'] = (getObjectProperty(Tractor, 'Odometer'));

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Fuel_Consumption_5Tanks'] = ((await Promise.all(((await asyncListSort((getObjectProperty(Tractor, 'Fuel')), -1, async (item) => {


     return (getObjectProperty(item, 'created'));
    })).slice(0, 5)).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;}) / (await Promise.all(((await asyncListSort((getObjectProperty(Tractor, 'Fuel')), -1, async (item) => {


     return (getObjectProperty(item, 'created'));
    })).slice(0, 5)).map(async item => {; return (getObjectProperty(item, 'Litres'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  }
  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Fleetview, 'Loads'))))) {
      Fleetview['Distance_Travelled'] = 0;
    } else {
      if ((getObjectProperty(Fleetview, 'Loads')).length == 0) {
        Fleetview['Distance_Travelled'] = 0;
      } else {
        Fleetview['Distance_Travelled'] = ((await Promise.all((await asyncListFilter((getObjectProperty(Fleetview, 'Loads')), async (item) => {


         return ((getObjectProperty(item, 'Status')) == 'Delivered');
        })).map(async item => {; return (getObjectProperty(item, 'Distance_Planned_LDP_To_DP'));}))).reduce(function(x, y) {return x + y;}));
      }
    }

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Distance_Travelled'] = 0;
    }

  }
  try {
    Fleetview['Distance_Actual'] = ((await Promise.all((await asyncListFilter((getObjectProperty(Fleetview, 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) == 'Delivered');
    })).map(async item => {; return (getObjectProperty(item, 'Distance_Last_Delivery_Point_To_Load_Point'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Distance_Actual'] = 0;
    }

  }
  try {
    Fleetview['Distance_Travelled_Mileage'] = ((await Promise.all((getObjectProperty(Fleetview, 'Fuel')).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Distance_Travelled_Mileage'] = 0;
    }

  }
  try {
    Fleetview['Fuel_Consumption_Ideal'] = (getObjectProperty(Tractor, 'Ideal_Fuel_Consumption'));

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Fuel_Cost'] = ((await Promise.all((getObjectProperty(Fleetview, 'Fuel')).map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Fuel_Cost'] = 0;
    }

  }
  try {
    Fleetview['Fuel_Litres'] = ((await Promise.all((getObjectProperty(Fleetview, 'Fuel')).map(async item => {; return (getObjectProperty(item, 'Litres'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Fuel_Litres'] = 0;
    }

  }
  try {
    Fleetview['Gain_Loss_On_Loading_Delays'] = ((await Promise.all((getObjectProperty(Fleetview, 'Loads')).map(async item => {; return (getObjectProperty(item, 'Financial_Gain_Loss_Trip_Time_Differential'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Gain_Loss_On_Loading_Delays'] = 0;
    }

  }
  try {
    Fleetview['Gain_Loss_On_Loading_Mileage'] = ((await Promise.all((getObjectProperty(Fleetview, 'Loads')).map(async item => {; return (getObjectProperty(item, 'Financial_Gain_Loss_Distance_Differential'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Gain_Loss_On_Loading_Mileage'] = 0;
    }

  }
  try {
    Fleetview['Gain_Loss_On_Loading_Tonnage'] = ((await Promise.all((getObjectProperty(Fleetview, 'Loads')).map(async item => {; return (getObjectProperty(item, 'Financial_Gain_Loss_Tonnage_Differential'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Gain_Loss_On_Loading_Tonnage'] = 0;
    }

  }
  try {
    Fleetview['Licenses_Due'] = ({ [`Tractor`]: ['Tractor (',(getObjectProperty(Tractor, 'ID')),' - ',(getObjectProperty(Tractor, 'Registration')),') - ',(getObjectProperty(Tractor, 'License_Status'))].join(''),[`Trailer1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? null : ['Trailer 1 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'License_Status'))].join(''),[`Trailer2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? null : ['Trailer 2 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'License_Status'))].join(''),[`Trailer3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? null : ['Trailer 3 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'License_Status'))].join(''),[`Driver1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1')))) ? null : ['Driver (',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Company_ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Employee_Details_Nickname')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Driver_License_Expirey_Date_Status'))].join(''),[`Driver1PDP`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1')))) ? null : ['Driver (',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Company_ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Employee_Details_Nickname')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Driver_PDP_Expiry_Date_Status'))].join('') });

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Maintenance_Plan_Per_Km_Total'] = ((await Promise.all((getObjectProperty(Fleetview, 'Fuel')).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;}) * (getObjectProperty(Tractor, 'Maintenance_Plan_Rate_per_Km')));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Maintenance_Plan_Per_Km_Total'] = 0;
    }

  }
  try {
    Fleetview['Maintenance_Repairs_Tractor'] = ((getObjectProperty(Tractor, 'Maintenance')).length == 0 ? 0 : ((await asyncListFilter((getObjectProperty(Tractor, 'Maintenance')), async (item) => {


     return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)));
    })) == 0 ? 0 : ((await asyncListFilter((await asyncListFilter((getObjectProperty(Tractor, 'Maintenance')), async (item) => {


     return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)));
    })), async (item) => {


     return ((getObjectProperty(item, 'Type')) == 'Repair');
    })) == 0 ? 0 : (await Promise.all((await asyncListFilter((getObjectProperty(Tractor, 'Maintenance')), async (item) => {


     return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)));
    })).map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;}))));

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Maintenance_Repairs_Trailers'] = ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? 0 : ((getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Maintenance')).length == 0 ? 0 : ((await asyncListFilter((getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Maintenance')), async (item) => {


     return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((new Date()))));
    })) == 0 ? 0 : (await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Maintenance')), async (item) => {


     return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((new Date()))));
    })).map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;}))), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? 0 : ((getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Maintenance')).length == 0 ? 0 : ((await asyncListFilter((getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Maintenance')), async (item) => {


     return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((new Date()))));
    })) == 0 ? 0 : (await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Maintenance')), async (item) => {


     return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((new Date()))));
    })).map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;}))), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? 0 : ((getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Maintenance')).length == 0 ? 0 : ((await asyncListFilter((getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Maintenance')), async (item) => {


     return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((new Date()))));
    })) == 0 ? 0 : (await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Maintenance')), async (item) => {


     return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((new Date()))));
    })).map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;})))].reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Mileage_Target'] = (getObjectProperty(Tractor, 'Monthly_Mileage_Target'));

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Now'] = (new Date());

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Profit_Target'] = (getObjectProperty(Tractor, 'Monthly_Profit_Target'));

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Projected_Commission'] = 0;

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Fleetview['Projected_Commission'] = 0;
    }

  }
  try {
    Salary_1 = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1')))) ? 0 : (getObjectProperty(Driver_Salary, 'Total'));

  } catch (error) {
    console.log(error);

  }
  try {
    Salary_2 = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor1')))) ? 0 : (getObjectProperty(Conductor_1_Salary, 'Total'));

  } catch (error) {
    console.log(error);

  }
  try {
    Salary_3 = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor2')))) ? 0 : (getObjectProperty(Conductor_2_Salary, 'Total'));

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Salary_Wages'] = (Salary_1 + Salary_2 + Salary_3);

  } catch (error) {
    if (error) {
      Fleetview['Salary_Wages'] = 0;
    }

  }
  try {
    Fleetview['Service_Notices'] = ({ [`Tractor`]: ['Tractor (',(getObjectProperty(Tractor, 'ID')),' - ',(getObjectProperty(Tractor, 'Registration')),') - ',(getObjectProperty(Tractor, 'Service_Status'))].join(''),[`Trailer1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? null : ['Trailer 1 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Service_Status'))].join(''),[`Trailer2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? null : ['Trailer 2 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Service_Status'))].join(''),[`Trailer3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? null : ['Trailer 3 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Service_Status'))].join('') });

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Toll_Fees'] = ((getObjectProperty(Tractor, 'Other')).length == 0 ? 0 : (await Promise.all((await asyncListFilter((await asyncListFilter((getObjectProperty(Tractor, 'Other')), async (item) => {


     return ((getObjectProperty(item, 'created')) > (await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)));
    })), async (item) => {


     return ((getObjectProperty(item, 'Type')) == 'Toll Fee');
    })).map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Toll_Fees_Per_Km_Total'] = ((await Promise.all((getObjectProperty(Fleetview, 'Fuel')).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;}) * (getObjectProperty(Tractor, 'Toll_Rate_per_Km')));

  } catch (error) {
    if (error) {
      Fleetview['Toll_Fees_Per_Km_Total'] = 0;
    }

  }
  try {
    Fleetview['Tonnage_Average'] = (mathMean(await Promise.all((getObjectProperty(Fleetview, 'Loads')).map(async item => {; return (getObjectProperty(item, 'Tonnage_Delivered'));}))));

  } catch (error) {
    if (error) {
      Fleetview['Tonnage_Average'] = 0;
    }

  }
  try {
    Fleetview['Tonnage_Permissible'] = (getObjectProperty(Tractor, 'Payload'));

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Tonnage_Target'] = (getObjectProperty(Tractor, 'Monthly_Tonnage_Target'));

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Tonnage_Total'] = ((await Promise.all((getObjectProperty(Fleetview, 'Loads')).map(async item => {; return (getObjectProperty(item, 'Tonnage_Delivered'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    if (error) {
      Fleetview['Tonnage_Total'] = 0;
    }

  }
  try {
    Fleetview['Tractor_Fixed_Expenses'] = (getObjectProperty(Tractor, 'Cost Fixed'));

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Trailer_Fixed_Expenses'] = ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? 0 : (getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Cost Fixed')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? 0 : (getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Cost Fixed')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? 0 : (getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Cost Fixed'))].reduce(function(x, y) {return x + y;}));

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Turnover'] = ((await Promise.all((getObjectProperty(Fleetview, 'Loads')).map(async item => {; return (getObjectProperty(item, 'Financial_Load_Value'));}))).reduce(function(x, y) {return x + y;}));

  } catch (error) {
    if (error) {
      Fleetview['Turnover'] = 0;
    }

  }
  try {
    Tyre_CPK = [(await Promise.all((getObjectProperty(Tractor, 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;})].reduce(function(x, y) {return x + y;});

  } catch (error) {
    if (error) {
      Tyre_CPK = 0;
    }

  }
  try {
    Fleetview['Tyre_CPK_Estimated'] = Tyre_CPK;

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Tyre_Expenses_Actual'] = 0;

  } catch (error) {
    console.log(error);

  }
  try {
    Fleetview['Tyre_Expenses_Estimated'] = ((getObjectProperty(Fleetview, 'Mileage_Projected')) * Tyre_CPK);

  } catch (error) {
    console.log(error);

  }
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Tractor))) {
    Tractor = (await Backendless.Data.of('Tractors').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',IDTractor,'\''].join(''))).setRelated(['Other', 'Trailer1.Maintenance', 'Trailer2.Maintenance', 'Trailer3.Maintenance', 'Current_Fleetview', 'Current_Fleetview.Fuel', 'Current_Fleetview.Loads', 'Company', 'Trailer1', 'Trailer2', 'Trailer3', 'Trailer1.Axles_Data.Tyre L1.Transactions', 'Trailer1.Axles_Data.Tyre L2.Transactions', 'Trailer1.Axles_Data.Tyre L3.Transactions', 'Trailer1.Axles_Data.Tyre L4.Transactions', 'Trailer1.Axles_Data.Tyre R1.Transactions', 'Trailer1.Axles_Data.Tyre R2.Transactions', 'Trailer1.Axles_Data.Tyre R3.Transactions', 'Trailer1.Axles_Data.Tyre R4.Transactions', 'Trailer2.Axles_Data.Tyre L1.Transactions', 'Trailer2.Axles_Data.Tyre L2.Transactions', 'Trailer2.Axles_Data.Tyre L3.Transactions', 'Trailer2.Axles_Data.Tyre L4.Transactions', 'Trailer2.Axles_Data.Tyre R1.Transactions', 'Trailer2.Axles_Data.Tyre R2.Transactions', 'Trailer2.Axles_Data.Tyre R3.Transactions', 'Trailer2.Axles_Data.Tyre R4.Transactions', 'Trailer3.Axles_Data.Tyre L1.Transactions', 'Trailer3.Axles_Data.Tyre L2.Transactions', 'Trailer3.Axles_Data.Tyre L3.Transactions', 'Trailer3.Axles_Data.Tyre L4.Transactions', 'Trailer3.Axles_Data.Tyre R1.Transactions', 'Trailer3.Axles_Data.Tyre R2.Transactions', 'Trailer3.Axles_Data.Tyre R3.Transactions', 'Trailer3.Axles_Data.Tyre R4.Transactions', 'Axles_Data', 'Axles_Data.Tyre L1', 'Axles_Data.Tyre L2', 'Axles_Data.Tyre L3', 'Axles_Data.Tyre L4', 'Axles_Data.Tyre R1', 'Axles_Data.Tyre R2', 'Axles_Data.Tyre R3', 'Axles_Data.Tyre R4', 'Trailer1.Axles_Data', 'Trailer2.Axles_Data', 'Trailer3.Axles_Data', 'Breakdowns', 'Driver1', 'Conductor1', 'Conductor2', 'Driver1.Wages_Current', 'Conductor1.Wages_Current', 'Conductor2.Wages_Current', 'Fuel', 'Loads', 'Maintenance', 'Other', 'Tyres', 'Driver1.Wages_Current.Fuel', 'Driver1.Wages_Current.Loads']).setRelationsDepth(10).setRelationsPageSize(100).setPageSize(100)))[0];
    console.log(Tractor);
    if ((new Date((new Date())).getMonth() + 1) == (new Date((getObjectProperty((getObjectProperty(Tractor, 'Current_Fleetview')), 'created'))).getMonth() + 1)) {
      Fleetview = (getObjectProperty(Tractor, 'Current_Fleetview'));
      try {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1'))))) {
        } else {
          Driver = (await BackendlessUI.Functions.Custom['fn_b7bebd6f2ccdf3d6bdb2577d4e1da8e4']((getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'ownerId'))));
          Driver_Salary = (getObjectProperty((getObjectProperty(Driver, 'Details')), 'Wages_Current'));
          console.log(Driver);
        }

      } catch (error) {

      }
      try {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor1'))))) {
        } else {
          Conductor_1 = (await BackendlessUI.Functions.Custom['fn_b7bebd6f2ccdf3d6bdb2577d4e1da8e4']((getObjectProperty((getObjectProperty(Tractor, 'Conductor1')), 'ownerId'))));
          Conductor_1_Salary = (getObjectProperty((getObjectProperty(Conductor_1, 'Details')), 'Wages_Current'));
        }

      } catch (error) {

      }
      try {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor2'))))) {
        } else {
          Conductor_2 = (await BackendlessUI.Functions.Custom['fn_b7bebd6f2ccdf3d6bdb2577d4e1da8e4']((getObjectProperty((getObjectProperty(Tractor, 'Conductor2')), 'ownerId'))));
          Conductor_2_Salary = (getObjectProperty((getObjectProperty(Conductor_2_Salary, 'Details')), 'Wages_Current'));
        }

      } catch (error) {

      }
      await Fleetview_Recalculate();
      Fleetview_Updater = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = Fleetview_Updater;

        Found_Fuel = (_uow.find('Fuel', Backendless.DataQueryBuilder.create().setWhereClause((['TObjectID = \'',(getObjectProperty(Tractor, 'objectId')),'\' AND ((Date_Actual IS NULL AND created >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND created <= \'',((new Date()).valueOf()),'\') OR (Date_Actual IS NOT NULL AND Date_Actual >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND Date_Actual <= \'',((new Date()).valueOf()),'\'))'].join(''))).setPageSize(100)));
        Found_Loads = (_uow.find('Loads', Backendless.DataQueryBuilder.create().setWhereClause((['TID = \'',IDTractor,'\' AND Date_Delivered >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND Date_Delivered <= \'',((new Date()).valueOf()),'\''].join(''))).setPageSize(100)));
        _uow.setRelation('Fleetview', Fleetview, 'Fuel', Found_Fuel);
        _uow.setRelation('Fleetview', Fleetview, 'Loads', Found_Loads);
        Fleetview = (await Backendless.Data.of('Fleetview').save(Fleetview, true));

      })();

      Transaction_Result = (await Fleetview_Updater.execute());
    } else {
      Fleetview_Updater = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = Fleetview_Updater;

        Found_Fuel = (_uow.find('Fuel', Backendless.DataQueryBuilder.create().setWhereClause((['TObjectID = \'',(getObjectProperty(Tractor, 'objectId')),'\' AND ((Date_Actual IS NULL AND created >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND created <= \'',((new Date()).valueOf()),'\') OR (Date_Actual IS NOT NULL AND Date_Actual >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND Date_Actual <= \'',((new Date()).valueOf()),'\'))'].join(''))).setPageSize(100)));
        Found_Loads = (_uow.find('Loads', Backendless.DataQueryBuilder.create().setWhereClause((['TID = \'',(getObjectProperty(Tractor, 'objectId')),'\' AND Date_Delivered >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND Date_Delivered <= \'',((new Date()).valueOf()),'\''].join(''))).setPageSize(100)));
        _uow.addToRelation('Tractors', Tractor, 'Fleetview_Historical', [(getObjectProperty(Tractor, 'Current_Fleetview'))]);
        try {
          Tyre_CPK = [(await Promise.all((getObjectProperty(Tractor, 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;})].reduce(function(x, y) {return x + y;});

        } catch (error) {
          console.log(error);

        } finally {
          if (error) {
            Tyre_CPK = 0;
          }

        }
        Created_Fleet_View = (_uow.create('Fleetview', ({ [`Current_Mileage`]: (getObjectProperty(Tractor, 'Odometer')),[`Distance_Actual`]: 0,[`Distance_Travelled`]: 0,[`Distance_Travelled_Mileage`]: 0,[`Fuel_Consumption_Ideal`]: (getObjectProperty(Tractor, 'Ideal_Fuel_Consumption')),[`Fuel_Cost`]: 0,[`Fuel_Litres`]: 0,[`Gain_Loss_On_Loading_Delays`]: 0,[`Gain_Loss_On_Loading_Mileage`]: 0,[`Gain_Loss_On_Loading_Tonnage`]: 0,[`Licenses_Due`]: ({ [`Tractor`]: ['Tractor (',(getObjectProperty(Tractor, 'ID')),' - ',(getObjectProperty(Tractor, 'Registration')),') - ',(getObjectProperty(Tractor, 'License_Status'))].join(''),[`Trailer1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? null : ['Trailer 1 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'License_Status'))].join(''),[`Trailer2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? null : ['Trailer 2 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'License_Status'))].join(''),[`Trailer3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? null : ['Trailer 3 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'License_Status'))].join(''),[`Driver1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1')))) ? null : ['Driver (',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Company_ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Employee_Details_Nickname')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Driver_License_Expirey_Date_Status'))].join(''),[`Driver1PDP`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1')))) ? null : ['Driver (',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Company_ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Employee_Details_Nickname')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Driver_PDP_Expiry_Date_Status'))].join('') }),[`Maintenance_Plan_Per_Km_Total`]: 0,[`Maintenance_Repairs_Tractor`]: 0,[`Maintenance_Repairs_Trailers`]: 0,[`Mileage_Target`]: (getObjectProperty(Tractor, 'Monthly_Mileage_Target')),[`Now`]: (new Date()),[`Profit_Target`]: (getObjectProperty(Tractor, 'Monthly_Profit_Target')),[`Projected_Commission`]: 0,[`Salary_Wages`]: ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Wages_Current')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Wages_Current')), 'Total')))) ? 0 : (getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Wages_Current')), 'Total'))))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(Tractor, 'Conductor1')), 'Wages_Current')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Conductor1')), 'Wages_Current')), 'Total')))) ? 0 : (getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Conductor1')), 'Wages_Current')), 'Total'))))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(Tractor, 'Conductor2')), 'Wages_Current')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Conductor2')), 'Wages_Current')), 'Total')))) ? 0 : (getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Conductor2')), 'Wages_Current')), 'Total'))))),[`Service_Notices`]: ({ [`Tractor`]: ['Tractor (',(getObjectProperty(Tractor, 'ID')),' - ',(getObjectProperty(Tractor, 'Registration')),') - ',(getObjectProperty(Tractor, 'Service_Status'))].join(''),[`Trailer1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? null : ['Trailer 1 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Service_Status'))].join(''),[`Trailer2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? null : ['Trailer 2 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Service_Status'))].join(''),[`Trailer3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? null : ['Trailer 3 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Service_Status'))].join('') }),[`Toll_Fees`]: 0,[`Toll_Fees_Per_Km_Total`]: 0,[`Tonnage_Average`]: 0,[`Tonnage_Permissible`]: (getObjectProperty(Tractor, 'Payload')),[`Tonnage_Target`]: (getObjectProperty(Tractor, 'Monthly_Tonnage_Target')),[`Tonnage_Total`]: 0,[`Tractor_Fixed_Expenses`]: (getObjectProperty(Tractor, 'Cost Fixed')),[`Trailer_Fixed_Expenses`]: [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? 0 : (getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Cost Fixed')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? 0 : (getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Cost Fixed')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? 0 : (getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Cost Fixed'))].reduce(function(x, y) {return x + y;}),[`Turnover`]: 0,[`Tyre_CPK_Estimated`]: Tyre_CPK,[`Tyre_Expenses_Actual`]: 0,[`Tyre_Expenses_Estimated`]: (getObjectProperty(Tractor, 'Monthly_Mileage_Target')) * Tyre_CPK,[`ownerId`]: (getObjectProperty(Tractor, 'ownerId')) })));
        _uow.setRelation('Tractors', Tractor, 'Fleetview_Current', [Created_Fleet_View]);
        _uow.setRelation('Tractors', Tractor, 'Current_Fleetview', [Created_Fleet_View]);
        _uow.addToRelation('Tractors', Tractor, 'Fleetview_Historical', [Created_Fleet_View]);
        _uow.setRelation('Fleetview', Created_Fleet_View, 'Fuel', Found_Fuel);
        _uow.setRelation('Fleetview', Created_Fleet_View, 'Loads', Found_Loads);

      })();

      Transaction_Result = (await Fleetview_Updater.execute());
      console.log(Transaction_Result);
      try {
        Fleetview = (getObjectProperty((getObjectProperty((getObjectProperty(Transaction_Result, 'results')), 'upsertFleetview1')), 'result'));

      } catch (error) {
        console.log(error);

      }
    }
  } else {
    Tractor = Tractor;
    if ((new Date((new Date())).getMonth() + 1) == (new Date((getObjectProperty((getObjectProperty(Tractor, 'Current_Fleetview')), 'created'))).getMonth() + 1)) {
      Fleetview = (getObjectProperty(Tractor, 'Current_Fleetview'));
      Found_Fuel = (await Backendless.Data.of('Fuel').find(Backendless.DataQueryBuilder.create().setWhereClause((['TObjectID = \'',(getObjectProperty(Tractor, 'objectId')),'\' AND ((Date_Actual IS NULL AND created >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND created <= \'',((new Date()).valueOf()),'\') OR (Date_Actual IS NOT NULL AND Date_Actual >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND Date_Actual <= \'',((new Date()).valueOf()),'\'))'].join(''))).setPageSize(100)));
      Found_Loads = (await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['TID = \'',(getObjectProperty(Tractor, 'objectId')),'\' AND Date_Delivered >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND Date_Delivered <= \'',((new Date()).valueOf()),'\''].join(''))).setPageSize(10)));
      Fleetview['Fuel'] = Found_Fuel;
      Fleetview['Loads'] = Found_Loads;
      try {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1'))))) {
        } else {
          Driver = (await BackendlessUI.Functions.Custom['fn_b7bebd6f2ccdf3d6bdb2577d4e1da8e4']((getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'ownerId'))));
          Driver_Salary = (getObjectProperty((getObjectProperty(Driver, 'Details')), 'Wages_Current'));
          console.log(Driver);
        }

      } catch (error) {

      }
      try {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor1'))))) {
        } else {
          Conductor_1 = (await BackendlessUI.Functions.Custom['fn_b7bebd6f2ccdf3d6bdb2577d4e1da8e4']((getObjectProperty((getObjectProperty(Tractor, 'Conductor1')), 'ownerId'))));
          Conductor_1_Salary = (getObjectProperty((getObjectProperty(Conductor_1, 'Details')), 'Wages_Current'));
        }

      } catch (error) {

      }
      try {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor2'))))) {
        } else {
          Conductor_2 = (await BackendlessUI.Functions.Custom['fn_b7bebd6f2ccdf3d6bdb2577d4e1da8e4']((getObjectProperty((getObjectProperty(Tractor, 'Conductor2')), 'ownerId'))));
          Conductor_2_Salary = (getObjectProperty((getObjectProperty(Conductor_2_Salary, 'Details')), 'Wages_Current'));
        }

      } catch (error) {

      }
      await Fleetview_Recalculate();
      Fleetview_Updater = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = Fleetview_Updater;

        Found_Fuel = (_uow.find('Fuel', Backendless.DataQueryBuilder.create().setWhereClause((['TObjectID = \'',IDTractor,'\' AND created >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND created <= \'',((new Date()).valueOf()),'\''].join(''))).setPageSize(100)));
        Found_Loads = (_uow.find('Loads', Backendless.DataQueryBuilder.create().setWhereClause((['TID = \'',IDTractor,'\' AND Date_Delivered >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND Date_Delivered <= \'',((new Date()).valueOf()),'\''].join(''))).setPageSize(100)));
        _uow.setRelation('Fleetview', Fleetview, 'Fuel', Found_Fuel);
        _uow.setRelation('Fleetview', Fleetview, 'Loads', Found_Loads);
        Fleetview = (await Backendless.Data.of('Fleetview').save(Fleetview, true));

      })();

      Transaction_Result = (await Fleetview_Updater.execute());
    } else {
      Fleetview_Updater = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = Fleetview_Updater;

        Found_Fuel = (_uow.find('Fuel', Backendless.DataQueryBuilder.create().setWhereClause((['TObjectID = \'',(getObjectProperty(Tractor, 'objectId')),'\' AND ((Date_Actual IS NULL AND created >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND created <= \'',((new Date()).valueOf()),'\') OR (Date_Actual IS NOT NULL AND Date_Actual >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND Date_Actual <= \'',((new Date()).valueOf()),'\'))'].join(''))).setPageSize(100)));
        Found_Loads = (_uow.find('Loads', Backendless.DataQueryBuilder.create().setWhereClause((['TID = \'',(getObjectProperty(Tractor, 'objectId')),'\' AND Date_Delivered >= \'',((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf()),'\' AND Date_Delivered <= \'',((new Date()).valueOf()),'\''].join(''))).setPageSize(100)));
        _uow.addToRelation('Tractors', Tractor, 'Fleetview_Historical', [(getObjectProperty(Tractor, 'Current_Fleetview'))]);
        try {
          Tyre_CPK = [(await Promise.all((getObjectProperty(Tractor, 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;}), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Axles_Data')).map(async item => {; return ([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L1')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre L4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre L4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R4')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R4')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R3')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R3')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R2')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R2')), 'CPK_Expected')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tyre R1')))) ? 0 : (getObjectProperty((getObjectProperty(item, 'Tyre R1')), 'CPK_Expected'))].reduce(function(x, y) {return x + y;}));}))).reduce(function(x, y) {return x + y;})].reduce(function(x, y) {return x + y;});

        } catch (error) {
          console.log(error);

        } finally {
          if (error) {
            Tyre_CPK = 0;
          }

        }
        Created_Fleet_View = (_uow.create('Fleetview', ({ [`Current_Mileage`]: (getObjectProperty(Tractor, 'Odometer')),[`Distance_Actual`]: 0,[`Distance_Travelled`]: 0,[`Distance_Travelled_Mileage`]: 0,[`Fuel_Consumption_Ideal`]: (getObjectProperty(Tractor, 'Ideal_Fuel_Consumption')),[`Fuel_Cost`]: 0,[`Fuel_Litres`]: 0,[`Gain_Loss_On_Loading_Delays`]: 0,[`Gain_Loss_On_Loading_Mileage`]: 0,[`Gain_Loss_On_Loading_Tonnage`]: 0,[`Licenses_Due`]: ({ [`Tractor`]: ['Tractor (',(getObjectProperty(Tractor, 'ID')),' - ',(getObjectProperty(Tractor, 'Registration')),') - ',(getObjectProperty(Tractor, 'License_Status'))].join(''),[`Trailer1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? null : ['Trailer 1 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'License_Status'))].join(''),[`Trailer2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? null : ['Trailer 2 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'License_Status'))].join(''),[`Trailer3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? null : ['Trailer 3 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'License_Status'))].join(''),[`Driver1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1')))) ? null : ['Driver (',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Company_ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Employee_Details_Nickname')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Driver_License_Expirey_Date_Status'))].join(''),[`Driver1PDP`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1')))) ? null : ['Driver (',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Company_ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Employee_Details_Nickname')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Driver_PDP_Expiry_Date_Status'))].join('') }),[`Maintenance_Plan_Per_Km_Total`]: 0,[`Maintenance_Repairs_Tractor`]: 0,[`Maintenance_Repairs_Trailers`]: 0,[`Mileage_Target`]: (getObjectProperty(Tractor, 'Monthly_Mileage_Target')),[`Now`]: (new Date()),[`Profit_Target`]: (getObjectProperty(Tractor, 'Monthly_Profit_Target')),[`Projected_Commission`]: 0,[`Salary_Wages`]: ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Driver1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Wages_Current')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Wages_Current')), 'Total')))) ? 0 : (getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Driver1')), 'Wages_Current')), 'Total'))))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(Tractor, 'Conductor1')), 'Wages_Current')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Conductor1')), 'Wages_Current')), 'Total')))) ? 0 : (getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Conductor1')), 'Wages_Current')), 'Total'))))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Conductor2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(Tractor, 'Conductor2')), 'Wages_Current')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Conductor2')), 'Wages_Current')), 'Total')))) ? 0 : (getObjectProperty((getObjectProperty((getObjectProperty(Tractor, 'Conductor2')), 'Wages_Current')), 'Total'))))),[`Service_Notices`]: ({ [`Tractor`]: ['Tractor (',(getObjectProperty(Tractor, 'ID')),' - ',(getObjectProperty(Tractor, 'Registration')),') - ',(getObjectProperty(Tractor, 'Service_Status'))].join(''),[`Trailer1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? null : ['Trailer 1 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Service_Status'))].join(''),[`Trailer2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? null : ['Trailer 2 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Service_Status'))].join(''),[`Trailer3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? null : ['Trailer 3 (',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'ID')),' - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Registration')),') - ',(getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Service_Status'))].join('') }),[`Toll_Fees`]: 0,[`Toll_Fees_Per_Km_Total`]: 0,[`Tonnage_Average`]: 0,[`Tonnage_Permissible`]: (getObjectProperty(Tractor, 'Payload')),[`Tonnage_Target`]: (getObjectProperty(Tractor, 'Monthly_Tonnage_Target')),[`Tonnage_Total`]: 0,[`Tractor_Fixed_Expenses`]: (getObjectProperty(Tractor, 'Cost Fixed')),[`Trailer_Fixed_Expenses`]: [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer1')))) ? 0 : (getObjectProperty((getObjectProperty(Tractor, 'Trailer1')), 'Cost Fixed')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer2')))) ? 0 : (getObjectProperty((getObjectProperty(Tractor, 'Trailer2')), 'Cost Fixed')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, 'Trailer3')))) ? 0 : (getObjectProperty((getObjectProperty(Tractor, 'Trailer3')), 'Cost Fixed'))].reduce(function(x, y) {return x + y;}),[`Turnover`]: 0,[`Tyre_CPK_Estimated`]: Tyre_CPK,[`Tyre_Expenses_Actual`]: 0,[`Tyre_Expenses_Estimated`]: (getObjectProperty(Tractor, 'Monthly_Mileage_Target')) * Tyre_CPK,[`ownerId`]: (getObjectProperty(Tractor, 'ownerId')) })));
        _uow.setRelation('Tractors', Tractor, 'Fleetview_Current', [Created_Fleet_View]);
        _uow.setRelation('Tractors', Tractor, 'Current_Fleetview', [Created_Fleet_View]);
        _uow.addToRelation('Tractors', Tractor, 'Fleetview_Historical', [Created_Fleet_View]);
        _uow.setRelation('Fleetview', Created_Fleet_View, 'Fuel', Found_Fuel);
        _uow.setRelation('Fleetview', Created_Fleet_View, 'Loads', Found_Loads);

      })();

      Transaction_Result = (await Fleetview_Updater.execute());
      try {
        Fleetview = (getObjectProperty((getObjectProperty((getObjectProperty(Transaction_Result, 'results')), 'upsertFleetview1')), 'result'));

      } catch (error) {
        console.log(error);

      }
    }
  }

return ({ [`Tractor`]: Tractor,[`Fleetview`]: Fleetview,[`Driver`]: Driver,[`Driver Salary`]: Driver_Salary,[`Conductor 1`]: Conductor_1,[`Conductor 1 Salary`]: Conductor_1_Salary,[`Conductor 2`]: Conductor_2,[`Conductor 2 Salary`]: Conductor_2_Salary })
}

})
define('./functions/8993e6ad2137898be7180dfc9d639592/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8993e6ad2137898be7180dfc9d639592'] = function fn_8993e6ad2137898be7180dfc9d639592(List) {
var Sum, Average, Counter, Total;


  Total = List.length;
  Counter = -1;
  Sum = 0;
  var repeat_end = List.length + 1;
  for (var count = 0; count < repeat_end; count++) {
    Counter = Counter + 1;
    Sum = Sum + ((typeof (List[(Counter - 1)]) === 'undefined') ? 0 : List[(Counter - 1)]);
  }
  Average = Sum / List.length;

return ((typeof Average === 'number' && !isNaN(Average)) ? Average : 'Error')
}

})
define('./functions/8c6afca1481cdc048f1c296a77be1975/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8c6afca1481cdc048f1c296a77be1975'] = async function fn_8c6afca1481cdc048f1c296a77be1975(listToFlatten) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.flattenDeep(array)
})(listToFlatten))
}

})
define('./functions/8f4b34774e84b8b3681c852e49ed1ac5/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8f4b34774e84b8b3681c852e49ed1ac5'] = async function fn_8f4b34774e84b8b3681c852e49ed1ac5(listToSlice, startPosition, endPosition) {
return (await (async function(array, start, end) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (start == null) {
	  start = 0
	}

	if (end == null) {
	  end = array.length
	}

	return _.slice(array, start, end)
})(listToSlice, startPosition, endPosition))
}

})
define('./functions/8f6c1b262de382fab417b0f5ce24fcab/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'] = async function fn_8f6c1b262de382fab417b0f5ce24fcab(Map, PolylineMarkers, MarkerDensity, TrackingData, VehicleData, Geofences, Stations, GeofencingAdd, GeofencingColor, AppData) {
var Distance, End_Marker, error, Fuel_Loss_List, Idle_Markers, item, j, Marker, Markers, Max_Markers, Max_RPM, Max_Speed, Max_Temp, Over_Rev_Markers, Over_Speed_Markers, Over_Temp_Markers, PointColor, PointScale, PolylineColor, Refuel_List, Start_Marker, StrokeOpacity, StrokeWeight, Total_Idle;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Idle() {
  Idle_Markers = [];
  for (var j_index in TrackingData) {
    j = TrackingData[j_index];
    Marker = j;
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Marker))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Marker, 'idle.status'))))) {
      } else {
        if ((getObjectProperty(Marker, 'idle.status')) == true) {
          try {
            Marker['Idle_Time'] = (Number.parseFloat(((((getObjectProperty(((await asyncListFilter((await asyncListFilter(TrackingData, async (item) => {


             return ((getObjectProperty(item, 'idle.status')) == false);
            })), async (item) => {


             return ((getObjectProperty(item, 'timestamp')) > (getObjectProperty(Marker, 'timestamp')));
            }))[0]), 'timestamp')) - (getObjectProperty(Marker, 'timestamp'))) + 120) / 60)).toFixed(2));

          } catch (error) {
            console.log(error);

          }
          try {
            if ((getObjectProperty(Marker, 'Idle_Time')) < (getObjectProperty(VehicleData, 'Can Max Idle'))) {
              addItemToList(Idle_Markers, Marker);
            }

          } catch (error) {
            console.log(error);

          }
          Markers = (await asyncListFilter(Markers, async (item) => {


           return (!((getObjectProperty(item, 'lat')) == (getObjectProperty(Marker, 'position.latitude')) && (getObjectProperty(item, 'lng')) == (getObjectProperty(Marker, 'position.longitude'))));
          }));
        }
      }
    }
  }
  Idle_Markers = (await Promise.all(Idle_Markers.map(async item => {; return ({ [`Idle`]: (getObjectProperty(item, 'Idle_Time')),[`time`]: (getObjectProperty(item, 'timestamp')),[`lat`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.latitude')))) ? null : (getObjectProperty(item, 'position.latitude')),[`lng`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.longitude')))) ? null : (getObjectProperty(item, 'position.longitude')),[`Data`]: (await BackendlessUI.Functions.Custom['fn_3a793fed77a519bfe0e8407457e3fd8c']((await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'IDLE WARNING',[`Value`]: String(getObjectProperty(item, 'Idle_Time')) + String('m'),[`Color`]: 'rgba(150, 0, 0, 1)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Date',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toDateString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Time',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toLocaleTimeString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'ID')))) ? null : ({ [`Label`]: 'Fleet ID',[`Value`]: (getObjectProperty(VehicleData, 'ID')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Registration')))) ? null : ({ [`Label`]: 'Registration',[`Value`]: (getObjectProperty(VehicleData, 'Registration')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ({ [`Label`]: 'Driver',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Nickname')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')))) ? null : ({ [`Label`]: 'Driver Mobile',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }))], async (item) => {


   return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
  })), (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.vehicle.mileage')))) ? null : ({ [`Label`]: 'Odometer',[`Value`]: String(getObjectProperty(item, 'can.vehicle.mileage')) + String(' km'),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : ({ [`Label`]: 'Speed',[`Value`]: [(getObjectProperty(item, 'position.speed')),' km/h',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Speed')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max Speed')),')'].join('')].join(''),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ({ [`Label`]: 'Fuel Level',[`Value`]: String(((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) + String(' L'),[`Color`]: 'rgba(70, 130, 180, 0.5)' })), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Current_Fuel_Consumption_Last_5_Tanks')))) ? null : ({ [`Label`]: 'Range Est.',[`Value`]: String((((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) * (getObjectProperty(VehicleData, 'Current_Fuel_Consumption_Last_5_Tanks'))) + String(' km'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }))), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.altitude')))) ? null : ({ [`Label`]: 'Altitude',[`Value`]: String(getObjectProperty(item, 'position.altitude')) + String(' m'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.rpm')))) ? null : ({ [`Label`]: 'RPM',[`Value`]: [(getObjectProperty(item, 'can.engine.rpm')),' RPM',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max RPM')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max RPM')),')'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.temperature')))) ? null : ({ [`Label`]: 'Engine Temp.',[`Value`]: String(getObjectProperty(item, 'can.engine.temperature')) + String('°'),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.throttle.pedal.level')))) ? null : ({ [`Label`]: 'Throttle Pedal',[`Value`]: [(getObjectProperty(item, 'can.throttle.pedal.level')),'% - ',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Pedal')))) ? null : ['(',(getObjectProperty(VehicleData, 'Can Max Pedal')),'%)'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' })], async (item) => {


   return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
  })))),[`color`]: '#FF0000',[`Speed`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : (getObjectProperty(item, 'position.speed')),[`Direction`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.direction')))) ? null : (getObjectProperty(item, 'position.direction')) });})));
  console.log(Idle_Markers);
}

/**
 * Describe this function...
 */
async function Refuel_List2() {
  console.log('A');
  Refuel_List = [];
  for (var j_index2 in TrackingData) {
    j = TrackingData[j_index2];
    Start_Marker = TrackingData[((TrackingData.indexOf(j) + 1) - 1)];
    try {
      End_Marker = TrackingData[(((TrackingData.indexOf(j) + 1) - 1) - 1)];

    } catch (error) {

    }
    console.log(Start_Marker);
    console.log(End_Marker);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](End_Marker))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(End_Marker, 'can.fuel.level')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(End_Marker, 'can.fuel.volume'))))) {
      } else {
        if ((getObjectProperty(End_Marker, 'can.fuel.level')) - (getObjectProperty(Start_Marker, 'can.fuel.level')) < -4) {
          Start_Marker['FuelGain'] = ((getObjectProperty(Start_Marker, 'can.fuel.level')) - (getObjectProperty(End_Marker, 'can.fuel.level')));
          console.log(Start_Marker);
          addItemToList(Refuel_List, Start_Marker);
          Markers = (await asyncListFilter(Markers, async (item) => {


           return (!((getObjectProperty(item, 'lat')) == (getObjectProperty(Start_Marker, 'position.latitude')) && (getObjectProperty(item, 'lng')) == (getObjectProperty(Start_Marker, 'position.longitude'))));
          }));
        }
      }
    }
  }
  console.log('B');
  Refuel_List = (await Promise.all(Refuel_List.map(async item => {; return ({ [`lat`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.latitude')))) ? null : (getObjectProperty(item, 'position.latitude')),[`lng`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.longitude')))) ? null : (getObjectProperty(item, 'position.longitude')),[`Data`]: (await BackendlessUI.Functions.Custom['fn_3a793fed77a519bfe0e8407457e3fd8c']((await asyncListFilter([({ [`Label`]: 'Fuel Fill Detected',[`Value`]: String(((getObjectProperty(item, 'FuelGain')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) + String(' L'),[`Color`]: 'rgba(0, 255, 255, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Date',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toDateString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Time',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toLocaleTimeString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'ID')))) ? null : ({ [`Label`]: 'Fleet ID',[`Value`]: (getObjectProperty(VehicleData, 'ID')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Registration')))) ? null : ({ [`Label`]: 'Registration',[`Value`]: (getObjectProperty(VehicleData, 'Registration')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ({ [`Label`]: 'Driver',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Nickname')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')))) ? null : ({ [`Label`]: 'Driver Mobile',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }))], async (item) => {


   return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
  })), (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.vehicle.mileage')))) ? null : ({ [`Label`]: 'Odometer',[`Value`]: String(getObjectProperty(item, 'can.vehicle.mileage')) + String(' km'),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : ({ [`Label`]: 'Speed',[`Value`]: [(getObjectProperty(item, 'position.speed')),' km/h',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Speed')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max Speed')),')'].join('')].join(''),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ({ [`Label`]: 'Fuel Level',[`Value`]: String(((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) + String(' L'),[`Color`]: 'rgba(70, 130, 180, 0.5)' })), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Current_Fuel_Consumption_Last_5_Tanks')))) ? null : ({ [`Label`]: 'Range Est.',[`Value`]: String((((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) * (getObjectProperty(VehicleData, 'Current_Fuel_Consumption_Last_5_Tanks'))) + String(' km'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }))), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.altitude')))) ? null : ({ [`Label`]: 'Altitude',[`Value`]: String(getObjectProperty(item, 'position.altitude')) + String(' m'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.rpm')))) ? null : ({ [`Label`]: 'RPM',[`Value`]: [(getObjectProperty(item, 'can.engine.rpm')),' RPM',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max RPM')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max RPM')),')'].join('')].join(''),[`Color`]: 'rgba(70, 130, 180, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.temperature')))) ? null : ({ [`Label`]: 'Engine Temp.',[`Value`]: String(getObjectProperty(item, 'can.engine.temperature')) + String('°'),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.throttle.pedal.level')))) ? null : ({ [`Label`]: 'Throttle Pedal',[`Value`]: [(getObjectProperty(item, 'can.throttle.pedal.level')),'% - ',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Pedal')))) ? null : ['(',(getObjectProperty(VehicleData, 'Can Max Pedal')),'%)'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' })], async (item) => {


   return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
  })))),[`color`]: '#00FFFF',[`Speed`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : (getObjectProperty(item, 'position.speed')),[`Direction`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.direction')))) ? null : (getObjectProperty(item, 'position.direction')),[`FuelGain`]: (getObjectProperty(item, 'FuelGain')),[`Icon`]: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="512" height="512"> <path d="M0 0 C0.78947021 0.00054382 1.57894043 0.00108765 2.39233398 0.00164795 C15.79752181 0.04394094 28.58181608 1.08730699 41.625 4.375 C42.48432129 4.58930664 43.34364258 4.80361328 44.22900391 5.02441406 C72.06587781 12.19902759 98.05578693 26.00652071 118.90625 45.83203125 C120.82953855 47.63096924 122.73816204 49.32006401 124.76953125 50.984375 C128.52705784 54.13021121 131.5153661 57.60071153 134.625 61.375 C135.03943359 61.87708984 135.45386719 62.37917969 135.88085938 62.89648438 C142.52108414 70.99315094 148.43956071 79.25151337 153.625 88.375 C153.98835449 89.00744629 154.35170898 89.63989258 154.72607422 90.29150391 C164.614668 107.64398296 170.79799579 125.7921763 174.625 145.375 C174.81191406 146.30965088 174.99882812 147.24430176 175.19140625 148.20727539 C176.96041863 158.13822659 177.02275413 168.00770329 177 178.0625 C176.99918427 179.41852325 176.99918427 179.41852325 176.99835205 180.80194092 C176.95646369 195.98798049 175.9308543 210.5049887 172.625 225.375 C172.31151611 226.80537598 172.31151611 226.80537598 171.99169922 228.26464844 C166.8225256 251.13291763 158.82851627 273.28834948 148.625 294.375 C148.2861377 295.0777002 147.94727539 295.78040039 147.59814453 296.50439453 C145.65711121 300.50487463 143.66262729 304.47489902 141.62548828 308.42724609 C140.62275018 310.37937995 139.63748293 312.33971887 138.65234375 314.30078125 C128.43200244 334.38157557 115.8117704 353.14234637 102.625 371.375 C102.02236328 372.20966797 101.41972656 373.04433594 100.79882812 373.90429688 C94.00063609 383.29227636 87.0783687 392.49589222 79.625 401.375 C78.18601857 403.14462973 76.74856286 404.91550101 75.3125 406.6875 C66.5438027 417.38288338 57.48005065 427.72617734 47.9921875 437.7890625 C45.01489488 440.94771305 42.09742105 444.15422685 39.1875 447.375 C30.70021123 456.65326391 21.92157825 465.95921875 12.24609375 474.01171875 C10.6004455 475.35712863 10.6004455 475.35712863 9.09765625 476.89453125 C6.34191797 479.54793443 4.53854032 480.39173413 0.75 481.125 C-4.77138148 480.68991928 -7.62139713 477.11659134 -11.375 473.375 C-12.48665208 472.34048435 -13.6029283 471.31092537 -14.72265625 470.28515625 C-25.352756 460.5330795 -36.08802117 450.64748004 -45.4140625 439.6171875 C-47.67721051 437.02944456 -50.02816806 434.53634099 -52.38745117 432.03637695 C-57.87661737 426.21911274 -63.18656781 420.35287447 -68.1796875 414.09765625 C-70.1750892 411.62293208 -72.22547623 409.20574099 -74.30151367 406.79858398 C-81.05715536 398.9457604 -87.25326308 390.72701796 -93.375 382.375 C-93.89320313 381.67246094 -94.41140625 380.96992188 -94.9453125 380.24609375 C-108.43470052 361.93906715 -121.021493 343.08311694 -132.375 323.375 C-132.86709961 322.52389648 -133.35919922 321.67279297 -133.86621094 320.79589844 C-150.94985106 291.01901366 -164.01599985 258.95292052 -171.375 225.375 C-171.58527832 224.42915039 -171.79555664 223.48330078 -172.01220703 222.50878906 C-175.1238941 207.8397591 -175.76138866 193.37791975 -175.8125 178.4375 C-175.81876404 177.58198547 -175.82502808 176.72647095 -175.83148193 175.84503174 C-175.90806958 159.31916297 -174.04069392 143.30130326 -169.25 127.4375 C-168.952146 126.43734863 -168.65429199 125.43719727 -168.34741211 124.40673828 C-160.70511107 99.68429582 -147.74986342 76.84752991 -129.91796875 58.09375 C-128.11903076 56.17046145 -126.42993599 54.26183796 -124.765625 52.23046875 C-121.61978879 48.47294216 -118.14928847 45.4846339 -114.375 42.375 C-113.87291016 41.96056641 -113.37082031 41.54613281 -112.85351562 41.11914062 C-104.75684906 34.47891586 -96.49848663 28.56043929 -87.375 23.375 C-86.74255371 23.01164551 -86.11010742 22.64829102 -85.45849609 22.27392578 C-59.23740995 7.33141132 -30.13716622 -0.07839147 0 0 Z " fill="#4181F4" transform="translate(255.375,15.625)"/> <path d="M0 0 C0.93070313 0.2165625 1.86140625 0.433125 2.8203125 0.65625 C23.85594506 5.80783348 45.34172902 16.87170184 60 33 C60.78375 33.763125 61.5675 34.52625 62.375 35.3125 C63.24125 36.199375 64.1075 37.08625 65 38 C65.64582031 38.6496875 66.29164063 39.299375 66.95703125 39.96875 C91.80696338 66.08076274 99.98840721 100.95374078 99.13623047 136.02001953 C98.83731652 142.55862814 97.66684246 148.6686871 96 155 C95.83371094 155.64163086 95.66742188 156.28326172 95.49609375 156.94433594 C89.53400114 179.39051053 78.15504137 198.46259078 62 215 C61.27296875 215.78890625 60.5459375 216.5778125 59.796875 217.390625 C40.70840346 237.61026523 10.21147362 251.97257318 -17.64794922 253.10791016 C-54.27662676 253.84685182 -84.33187005 245.12690751 -113 222 C-113.70253906 221.44183594 -114.40507812 220.88367188 -115.12890625 220.30859375 C-138.23219506 201.34012173 -150.23029169 172.46621149 -156 144 C-156.26127686 142.84395264 -156.26127686 142.84395264 -156.52783203 141.66455078 C-159.13341452 126.96065871 -157.65292478 110.40432783 -154 96 C-153.75636719 94.82566406 -153.51273438 93.65132813 -153.26171875 92.44140625 C-146.00229625 60.47930433 -123.98025201 33.20630098 -96.6796875 15.89453125 C-67.73783242 -1.14754059 -33.05703213 -8.90314082 0 0 Z " fill="#8FB5F8" transform="translate(285,67)"/> <path d="M0 0 C0.78947021 0.00054382 1.57894043 0.00108765 2.39233398 0.00164795 C15.79752181 0.04394094 28.58181608 1.08730699 41.625 4.375 C42.48432129 4.58930664 43.34364258 4.80361328 44.22900391 5.02441406 C72.06587781 12.19902759 98.05578693 26.00652071 118.90625 45.83203125 C120.82953855 47.63096924 122.73816204 49.32006401 124.76953125 50.984375 C128.52705784 54.13021121 131.5153661 57.60071153 134.625 61.375 C135.03943359 61.87708984 135.45386719 62.37917969 135.88085938 62.89648438 C142.52108414 70.99315094 148.43956071 79.25151337 153.625 88.375 C153.98835449 89.00744629 154.35170898 89.63989258 154.72607422 90.29150391 C164.614668 107.64398296 170.79799579 125.7921763 174.625 145.375 C174.81191406 146.30965088 174.99882812 147.24430176 175.19140625 148.20727539 C176.96041863 158.13822659 177.02275413 168.00770329 177 178.0625 C176.99918427 179.41852325 176.99918427 179.41852325 176.99835205 180.80194092 C176.95646369 195.98798049 175.9308543 210.5049887 172.625 225.375 C172.31151611 226.80537598 172.31151611 226.80537598 171.99169922 228.26464844 C166.8225256 251.13291763 158.82851627 273.28834948 148.625 294.375 C148.2861377 295.0777002 147.94727539 295.78040039 147.59814453 296.50439453 C145.65711121 300.50487463 143.66262729 304.47489902 141.62548828 308.42724609 C140.62275018 310.37937995 139.63748293 312.33971887 138.65234375 314.30078125 C128.43200244 334.38157557 115.8117704 353.14234637 102.625 371.375 C102.02236328 372.20966797 101.41972656 373.04433594 100.79882812 373.90429688 C94.00063609 383.29227636 87.0783687 392.49589222 79.625 401.375 C78.18601857 403.14462973 76.74856286 404.91550101 75.3125 406.6875 C66.5438027 417.38288338 57.48005065 427.72617734 47.9921875 437.7890625 C45.01489488 440.94771305 42.09742105 444.15422685 39.1875 447.375 C30.70021123 456.65326391 21.92157825 465.95921875 12.24609375 474.01171875 C10.6004455 475.35712863 10.6004455 475.35712863 9.09765625 476.89453125 C6.34191797 479.54793443 4.53854032 480.39173413 0.75 481.125 C-4.77138148 480.68991928 -7.62139713 477.11659134 -11.375 473.375 C-12.48665208 472.34048435 -13.6029283 471.31092537 -14.72265625 470.28515625 C-25.352756 460.5330795 -36.08802117 450.64748004 -45.4140625 439.6171875 C-47.67721051 437.02944456 -50.02816806 434.53634099 -52.38745117 432.03637695 C-57.87661737 426.21911274 -63.18656781 420.35287447 -68.1796875 414.09765625 C-70.1750892 411.62293208 -72.22547623 409.20574099 -74.30151367 406.79858398 C-81.05715536 398.9457604 -87.25326308 390.72701796 -93.375 382.375 C-93.89320313 381.67246094 -94.41140625 380.96992188 -94.9453125 380.24609375 C-108.43470052 361.93906715 -121.021493 343.08311694 -132.375 323.375 C-132.86709961 322.52389648 -133.35919922 321.67279297 -133.86621094 320.79589844 C-150.94985106 291.01901366 -164.01599985 258.95292052 -171.375 225.375 C-171.58527832 224.42915039 -171.79555664 223.48330078 -172.01220703 222.50878906 C-175.1238941 207.8397591 -175.76138866 193.37791975 -175.8125 178.4375 C-175.81876404 177.58198547 -175.82502808 176.72647095 -175.83148193 175.84503174 C-175.90806958 159.31916297 -174.04069392 143.30130326 -169.25 127.4375 C-168.952146 126.43734863 -168.65429199 125.43719727 -168.34741211 124.40673828 C-160.70511107 99.68429582 -147.74986342 76.84752991 -129.91796875 58.09375 C-128.11903076 56.17046145 -126.42993599 54.26183796 -124.765625 52.23046875 C-121.61978879 48.47294216 -118.14928847 45.4846339 -114.375 42.375 C-113.87291016 41.96056641 -113.37082031 41.54613281 -112.85351562 41.11914062 C-104.75684906 34.47891586 -96.49848663 28.56043929 -87.375 23.375 C-86.74255371 23.01164551 -86.11010742 22.64829102 -85.45849609 22.27392578 C-59.23740995 7.33141132 -30.13716622 -0.07839147 0 0 Z M-29.32177734 20.92626953 C-31.40283782 21.38108394 -33.48968127 21.78429032 -35.58203125 22.18359375 C-46.81495063 24.44573389 -56.99651758 28.59060957 -67.375 33.375 C-68.03161621 33.6730957 -68.68823242 33.97119141 -69.36474609 34.27832031 C-91.35962197 44.35186985 -111.89392516 60.97734502 -126.375 80.375 C-127.10074219 81.34695312 -127.82648438 82.31890625 -128.57421875 83.3203125 C-143.11185714 103.56644764 -153.05011466 125.78678947 -157.375 150.375 C-157.71144531 152.17904297 -157.71144531 152.17904297 -158.0546875 154.01953125 C-170.17641004 229.32365692 -128.21124436 305.61169141 -85.76171875 364.3984375 C-79.54316396 372.94124998 -73.16914598 381.28121625 -66.375 389.375 C-64.93601857 391.14462973 -63.49856286 392.91550101 -62.0625 394.6875 C-53.76124204 404.81907004 -45.20858061 414.68838755 -36.26953125 424.26171875 C-34.47404016 426.18465844 -32.70535785 428.12228181 -30.94921875 430.08203125 C-21.20817765 440.9416608 -10.7314507 451.10762821 -0.375 461.375 C3.89232045 459.72300863 6.74526364 456.52491497 9.89453125 453.3359375 C10.79337288 452.43640854 10.79337288 452.43640854 11.71037292 451.51870728 C12.97766537 450.24839709 14.24252983 448.9756607 15.50512695 447.70068359 C17.41509818 445.7726141 19.33279036 443.85250968 21.25195312 441.93359375 C26.72958005 436.4399114 32.16894151 430.95642649 37.19897461 425.04394531 C39.54304072 422.3005733 42.03206641 419.69396635 44.5 417.0625 C48.90403724 412.323477 53.10901788 407.48103378 57.16015625 402.43359375 C59.04474341 400.09503314 60.94720516 397.77854639 62.87109375 395.47265625 C116.50007543 331.1238337 166.47231914 249.299566 160.42285156 162.47363281 C156.58389797 122.18635007 136.35333147 82.54904522 105.0625 56.5625 C103.26213225 55.1510529 101.44976314 53.75476318 99.625 52.375 C98.74199219 51.69953125 97.85898437 51.0240625 96.94921875 50.328125 C94.21175714 48.28394238 91.4375734 46.31443935 88.625 44.375 C87.6865625 43.72789063 86.748125 43.08078125 85.78125 42.4140625 C52.81161569 20.91582157 9.13067691 12.45925602 -29.32177734 20.92626953 Z " fill="#0444B7" transform="translate(255.375,15.625)"/> <path d="M0 0 C0.82175217 -0.00554901 1.64350433 -0.01109802 2.49015808 -0.01681519 C5.19911515 -0.02859978 7.90639499 -0.00434938 10.61523438 0.02148438 C12.50183028 0.02319588 14.38842856 0.02312939 16.27502441 0.0213623 C20.22606199 0.02301487 24.17653173 0.04170121 28.12744141 0.07324219 C33.1883391 0.11291954 38.24849319 0.11728702 43.30951691 0.10977936 C47.20435379 0.10670774 51.09902394 0.11883701 54.99382019 0.13591003 C56.85970514 0.14293428 58.72560898 0.14606527 60.59150696 0.1452179 C63.20067401 0.14701848 65.80895517 0.16842221 68.41796875 0.1953125 C69.18694992 0.1923819 69.95593109 0.18945129 70.74821472 0.18643188 C75.22812538 0.25756011 78.15074365 0.83251037 81.70898438 3.61523438 C83.12595631 6.44917824 82.82844367 8.82397176 82.82250977 11.99267578 C82.82265579 12.64645706 82.82280182 13.30023834 82.82295227 13.97383118 C82.82225473 16.13818664 82.81446977 18.30245641 82.80664062 20.46679688 C82.80477588 21.96609449 82.80335224 23.46539272 82.80235291 24.96469116 C82.79853217 28.9135506 82.78870565 32.86237334 82.77764893 36.81121826 C82.76742529 40.83963525 82.76285324 44.86805816 82.7578125 48.89648438 C82.747083 56.80275123 82.73001188 64.70898824 82.70898438 72.61523438 C83.95550781 72.74800781 85.20203125 72.88078125 86.48632812 73.01757812 C94.1106761 73.82968551 98.39921558 77.95891011 103.22851562 83.51757812 C106.52797413 88.19253649 106.97069445 92.30531837 107.05273438 97.96289062 C107.06735718 98.65660263 107.08197998 99.35031464 107.0970459 100.06504822 C107.15896843 103.01527107 107.19888893 105.96569471 107.24072266 108.91625977 C107.27453107 111.07785517 107.31961172 113.23901748 107.36523438 115.40039062 C107.38392578 116.68824463 107.40261719 117.97609863 107.421875 119.30297852 C107.68759001 122.36841691 107.98926318 124.10375659 109.70898438 126.61523438 C112.47998831 128.00073634 114.64245497 127.80298107 117.70898438 127.61523438 C120.95748415 125.89296941 120.95748415 125.89296941 121.70898438 122.61523438 C121.81637097 120.90347305 121.86769106 119.18792925 121.88598633 117.47290039 C121.89882156 116.4249379 121.9116568 115.3769754 121.92488098 114.29725647 C121.93226791 113.16597824 121.93965485 112.03470001 121.94726562 110.86914062 C121.95937325 109.12515236 121.95937325 109.12515236 121.97172546 107.34593201 C121.98556079 104.88550303 121.99628541 102.42505491 122.00415039 99.96459961 C122.02140038 96.19608505 122.06529719 92.42843927 122.109375 88.66015625 C122.11949863 86.27149083 122.12801576 83.88281796 122.13476562 81.49414062 C122.16102776 79.80025963 122.16102776 79.80025963 122.18782043 78.07215881 C122.18489487 77.02104416 122.1819693 75.9699295 122.17895508 74.88696289 C122.18482132 73.96335464 122.19068756 73.0397464 122.19673157 72.08815002 C121.44347568 68.26908492 119.03092021 66.57293091 115.9855957 64.36669922 C115.42638428 64.0233252 114.86717285 63.67995117 114.29101562 63.32617188 C113.67677734 62.94203125 113.06253906 62.55789062 112.4296875 62.16210938 C111.79998047 61.77539062 111.17027344 61.38867188 110.52148438 60.99023438 C103.84242051 56.88210665 103.84242051 56.88210665 102.70898438 54.61523438 C104.03710938 52.04882812 104.03710938 52.04882812 105.95898438 49.05273438 C106.89484375 47.56580078 106.89484375 47.56580078 107.84960938 46.04882812 C109.70898438 43.61523438 109.70898438 43.61523438 112.70898438 42.61523438 C115.40375109 43.97610655 117.86127722 45.37368537 120.39648438 46.99023438 C121.11529785 47.44487061 121.83411133 47.89950684 122.57470703 48.36791992 C129.77653273 53.07416852 135.86809414 58.28080253 138.70898438 66.61523438 C138.97640991 69.39581299 138.97640991 69.39581299 138.99951172 72.45605469 C139.01227142 73.60785217 139.02503113 74.75964966 139.03817749 75.9463501 C139.04040314 77.18286316 139.04262878 78.41937622 139.04492188 79.69335938 C139.05490707 81.61507965 139.05490707 81.61507965 139.06509399 83.57562256 C139.07704676 86.2856381 139.08077708 88.99552638 139.07958984 91.70556641 C139.07938718 95.15644515 139.10664224 98.60649549 139.14113426 102.0571785 C139.1689016 105.3734158 139.16755665 108.68950761 139.16992188 112.00585938 C139.18429291 113.23427551 139.19866394 114.46269165 139.21347046 115.72833252 C139.16909265 124.12612438 138.02895348 130.59567843 132.59570312 137.17382812 C125.81226371 142.96927104 120.16102573 145.17389744 111.18945312 144.91601562 C103.62610768 143.99888555 99.26410191 139.54391271 94.37304688 134.02929688 C90.91086075 129.00668883 90.46336421 124.15967114 90.43554688 118.16992188 C90.41527441 116.74934084 90.39442397 115.32876796 90.37304688 113.90820312 C90.35039559 111.69182369 90.33394638 109.47576754 90.328125 107.25927734 C90.31860275 105.10391499 90.28485865 102.94996677 90.24804688 100.79492188 C90.2398291 99.51343262 90.23161133 98.23194336 90.22314453 96.91162109 C89.62438623 93.07285822 88.77887122 91.91538763 85.70898438 89.61523438 C84.22398437 89.12023437 84.22398437 89.12023437 82.70898438 88.61523438 C82.70898438 112.37523437 82.70898438 136.13523438 82.70898438 160.61523438 C87.98898437 160.61523438 93.26898438 160.61523438 98.70898438 160.61523438 C98.70898438 165.89523437 98.70898438 171.17523438 98.70898438 176.61523438 C56.46898437 176.61523438 14.22898437 176.61523438 -29.29101562 176.61523438 C-29.29101562 171.33523438 -29.29101562 166.05523437 -29.29101562 160.61523438 C-24.01101562 160.61523438 -18.73101562 160.61523438 -13.29101562 160.61523438 C-13.30211868 158.68448563 -13.31322174 156.75373688 -13.32466125 154.76448059 C-13.42590757 136.59164899 -13.50121937 118.41887432 -13.55007648 100.24582386 C-13.57586339 90.90229278 -13.61102314 81.55897217 -13.66821289 72.21557617 C-13.71803305 64.072311 -13.75030311 55.92919824 -13.7614581 47.7857849 C-13.76797925 43.47341558 -13.78331555 39.16148232 -13.81966591 34.8492527 C-13.85360372 30.79033822 -13.86407325 26.73203941 -13.85655403 22.67299652 C-13.85792959 21.18344718 -13.86787591 19.69387726 -13.887043 18.20445061 C-13.91193859 16.17008744 -13.90295409 14.13539391 -13.89228821 12.10090637 C-13.89920166 10.39328487 -13.89920166 10.39328487 -13.90625477 8.65116596 C-12.36482928 1.0449166 -6.84497585 -0.11806087 0 0 Z " fill="#0444B7" transform="translate(213.291015625,95.384765625)"/> <path d="M0 0 C0.62471191 0.22026855 1.24942383 0.44053711 1.89306641 0.66748047 C38.57079076 13.80961589 67.38658854 41.9927723 83.92919922 76.96435547 C88.43499257 86.92794342 91.44145937 97.39266371 94 108 C94.24878906 109.02867187 94.49757813 110.05734375 94.75390625 111.1171875 C101.56890635 146.2883069 92.09428826 185.12725369 73 215 C51.455823 246.62193199 18.93655948 269.8212549 -18.8515625 277.5859375 C-38.75684434 281.13494124 -59.26185516 281.56335977 -79 277 C-80.22589844 276.73316406 -81.45179688 276.46632813 -82.71484375 276.19140625 C-108.0899139 270.09813967 -130.12223002 256.81511405 -149 239 C-149.73734375 238.32710937 -150.4746875 237.65421875 -151.234375 236.9609375 C-177.84772496 211.76319126 -190.94949544 174.45920041 -192.21484375 138.51953125 C-192.4841719 127.01223676 -191.6042336 116.20550082 -189 105 C-188.7215625 103.75089844 -188.443125 102.50179687 -188.15625 101.21484375 C-181.67042926 74.62856994 -167.69352483 52.67133998 -149 33 C-148.14535156 32.04867187 -148.14535156 32.04867187 -147.2734375 31.078125 C-111.26553557 -7.69961554 -48.15879558 -17.22843259 0 0 Z M-137 44 C-137.78375 44.763125 -138.5675 45.52625 -139.375 46.3125 C-140.24125 47.199375 -141.1075 48.08625 -142 49 C-142.96873047 49.97453125 -142.96873047 49.97453125 -143.95703125 50.96875 C-165.62645415 73.73872153 -176.46239383 105.28657299 -176.3125 136.375 C-176.30903564 137.55384766 -176.30557129 138.73269531 -176.30200195 139.94726562 C-176.19330597 148.66696514 -175.32287876 156.56881042 -173 165 C-172.7834375 165.928125 -172.566875 166.85625 -172.34375 167.8125 C-167.20683411 188.84939365 -156.1247658 210.34493942 -140 225 C-139.236875 225.78375 -138.47375 226.5675 -137.6875 227.375 C-136.800625 228.24125 -135.91375 229.1075 -135 230 C-134.02546875 230.96873047 -134.02546875 230.96873047 -133.03125 231.95703125 C-106.91923726 256.80696338 -72.04625922 264.98840721 -36.97998047 264.13623047 C-30.44055786 263.83727931 -24.33276047 262.66403387 -18 261 C-16.72640625 260.67128906 -15.4528125 260.34257812 -14.140625 260.00390625 C7.11243771 254.1220915 25.14438313 243.19934134 41 228 C41.81984375 227.24332031 42.6396875 226.48664063 43.484375 225.70703125 C64.07389897 206.10861791 78.94241973 175.95139279 80.10791016 147.35205078 C80.91904025 107.14505728 69.9635541 75.12808698 43 45 C40.46975487 42.4647936 37.81720473 40.20917493 35 38 C34.11828125 37.29359375 33.2365625 36.5871875 32.328125 35.859375 C13.88245425 21.51274219 -6.18798041 13.62368163 -29 9 C-29.77899658 8.82509033 -30.55799316 8.65018066 -31.3605957 8.4699707 C-68.7094107 1.81966371 -111.03613509 17.03556812 -137 44 Z " fill="#0545B7" transform="translate(304,56)"/> <path d="M0 0 C21.12 0 42.24 0 64 0 C64 29.04 64 58.08 64 88 C42.88 88 21.76 88 0 88 C0 58.96 0 29.92 0 0 Z " fill="#206DF3" transform="translate(216,168)"/> <path d="M0 0 C21.12 0 42.24 0 64 0 C64 13.2 64 26.4 64 40 C42.88 40 21.76 40 0 40 C0 26.8 0 13.6 0 0 Z " fill="#BBD1FB" transform="translate(216,112)"/> </svg>' });})));
  console.log(Refuel_List);
}

/**
 * Describe this function...
 */
async function Over_Temp() {
  Over_Temp_Markers = [];
  for (var j_index3 in TrackingData) {
    j = TrackingData[j_index3];
    Marker = j;
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Marker))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Marker, 'can.engine.temperature'))))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Temp'))))) {
        } else {
          if ((getObjectProperty(Marker, 'can.engine.temperature')) > (getObjectProperty(VehicleData, 'Can Max Temp'))) {
            addItemToList(Over_Temp_Markers, Marker);
            Markers = (await asyncListFilter(Markers, async (item) => {


             return (!((getObjectProperty(item, 'lat')) == (getObjectProperty(Marker, 'position.latitude')) && (getObjectProperty(item, 'lng')) == (getObjectProperty(Marker, 'position.longitude'))));
            }));
          }
        }
      }
    }
  }
  Over_Temp_Markers = (await Promise.all(Over_Temp_Markers.map(async item => {; return ({ [`lat`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.latitude')))) ? null : (getObjectProperty(item, 'position.latitude')),[`lng`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.longitude')))) ? null : (getObjectProperty(item, 'position.longitude')),[`Data`]: (await BackendlessUI.Functions.Custom['fn_3a793fed77a519bfe0e8407457e3fd8c']((await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.temperature')))) ? null : ({ [`Label`]: 'Engine Temp.',[`Value`]: String(getObjectProperty(item, 'can.engine.temperature')) + String('°'),[`Color`]: 'rgba(255, 255, 0, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Date',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toDateString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Time',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toLocaleTimeString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'ID')))) ? null : ({ [`Label`]: 'Fleet ID',[`Value`]: (getObjectProperty(VehicleData, 'ID')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Registration')))) ? null : ({ [`Label`]: 'Registration',[`Value`]: (getObjectProperty(VehicleData, 'Registration')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ({ [`Label`]: 'Driver',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Nickname')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')))) ? null : ({ [`Label`]: 'Driver Mobile',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }))], async (item) => {


   return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
  })), (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.vehicle.mileage')))) ? null : ({ [`Label`]: 'Odometer',[`Value`]: String(getObjectProperty(item, 'can.vehicle.mileage')) + String(' km'),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : ({ [`Label`]: 'Speed',[`Value`]: [(getObjectProperty(item, 'position.speed')),' km/h',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Speed')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max Speed')),')'].join('')].join(''),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ({ [`Label`]: 'Fuel Level',[`Value`]: String(((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) + String(' L'),[`Color`]: 'rgba(70, 130, 180, 0.5)' })), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(VehicleData, 'Current_Fleetview')), 'Fuel_Consumption_5Tanks')))) ? null : ({ [`Label`]: 'Range Est.',[`Value`]: String((((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) * (getObjectProperty((getObjectProperty(VehicleData, 'Current_Fleetview')), 'Fuel_Consumption_5Tanks'))) + String(' km'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }))), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.altitude')))) ? null : ({ [`Label`]: 'Altitude',[`Value`]: String(getObjectProperty(item, 'position.altitude')) + String(' m'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.rpm')))) ? null : ({ [`Label`]: 'RPM',[`Value`]: [(getObjectProperty(item, 'can.engine.rpm')),' RPM',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max RPM')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max RPM')),')'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.throttle.pedal.level')))) ? null : ({ [`Label`]: 'Throttle Pedal',[`Value`]: [(getObjectProperty(item, 'can.throttle.pedal.level')),'% - ',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Pedal')))) ? null : ['(',(getObjectProperty(VehicleData, 'Can Max Pedal')),'%)'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' })], async (item) => {


   return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
  })))),[`color`]: '#FFFF00',[`Speed`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : (getObjectProperty(item, 'position.speed')),[`Direction`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.direction')))) ? null : (getObjectProperty(item, 'position.direction')) });})));
}

/**
 * Describe this function...
 */
async function Code_Save() {
  await (async function(googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers, pointColor, pointScale, vehicleId, geofences, stations, stationIconSvg, canAddGeofences, polygonColor, appData) {
  	let existingMarkers = [];
  	let existingPolylines = [];
  	let existingGeofences = [];
  	let currentInfoWindow = null;
  	let selectedMarker = null;
  	let geofenceMarkers = [];
  	let geofencePolygon = null;
  	let addingGeofence = false;

  	appData = appData || {};
  	console.log('Assigned default appData:', appData);

  	function clearMap() {
  	  existingMarkers.forEach(marker => marker.setMap(null));
  	  existingMarkers = [];
  	  existingPolylines.forEach(polyline => polyline.setMap(null));
  	  existingPolylines = [];
  	  existingGeofences.forEach(polygon => polygon.setMap(null));
  	  existingGeofences = [];
  	  geofenceMarkers = [];
  	  geofencePolygon = null;
  	}

  	function addPolylineAndCustomMarkers(
  	  googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers,
  	  pointColor, pointScale, vehicleId, geofences, stations, stationIconSvg, enableGeofence, polygonColor, appData
  	) {
  	  if (!googleMapComponent || !googleMapComponent.map) {
  	    return;
  	  }

  	  const mapInstance = googleMapComponent.map.map;
  	  if (!(mapInstance instanceof google.maps.Map)) {
  	    return;
  	  }

  	  clearMap();

  	  // Polyline logic
  	  const polylineCoordinates = markers.map(marker => ({
  	    lat: marker.lat,
  	    lng: marker.lng
  	  }));

  	  const polyline = new google.maps.Polyline({
  	    path: polylineCoordinates,
  	    geodesic: true,
  	    strokeColor: polylineColor || '#FF0000',
  	    strokeOpacity: strokeOpacity || 1.0,
  	    strokeWeight: strokeWeight || 2
  	  });

  	  polyline.setMap(mapInstance);
  	  existingPolylines.push(polyline);

  	  function updatePolylinePath() {
  	    const newPath = existingMarkers.map(marker => marker.getPosition());
  	    polyline.setPath(newPath);
  	  }

  	  function calculateHeading(lat1, lng1, lng2, lat2) {
  	    const toRadians = degrees => degrees * Math.PI / 180;
  	    const toDegrees = radians => degrees * 180 / Math.PI;

  	    const dLng = toRadians(lng2 - lng1);
  	    const y = Math.sin(dLng) * Math.cos(toRadians(lat2));
  	    const x = Math.cos(toRadians(lat1)) * Math.sin(toRadians(lat2)) - Math.sin(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.cos(dLng);
  	    const bearing = toDegrees(Math.atan2(y, x));
  	    return (bearing + 360) % 360;
  	  }

  	  // Add custom markers to the map
  	  pointMarkers.forEach((marker, index) => {
  	    let icon;
  	    let iconColor = marker.color || pointColor || '#FF0000';

  	    if (marker.Speed === 0) {
  	      icon = {
  	        path: google.maps.SymbolPath.CIRCLE,
  	        fillColor: iconColor,
  	        fillOpacity: 1,
  	        strokeColor: 'black',
  	        strokeWeight: 2,
  	        scale: marker.scale || pointScale || 8
  	      };

  	      if (index === pointMarkers.length - 1 && vehicleId) {
  	        const crosshairSvg = `
  	        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  	        <circle cx="12" cy="12" r="10"></circle>
  	        <line x1="12" y1="2" x2="12" y2="6"></line>
  	        <line x1="12" y1="18" x2="12" y2="22"></line>
  	        <line x1="2" y1="12" x2="6" y2="12"></line>
  	        <line x1="18" y1="12" x2="22" y2="12"></line>
  	        </svg>
  	        `;

  	        icon = {
  	          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(crosshairSvg)}`,
  	          anchor: new google.maps.Point(25, 25),
  	          scaledSize: new google.maps.Size(50, 50) // Size of the crosshair
  	        };
  	      }

  	    } else {
  	      let heading = marker.Direction !== undefined ? marker.Direction: 0;
  	      if (marker.Direction === undefined && index < pointMarkers.length - 1) {
  	        const nextMarker = pointMarkers[index + 1];
  	        heading = calculateHeading(marker.lat, marker.lng, nextMarker.lng, nextMarker.lat);
  	      }

  	      heading = (heading - 90 + 360) % 360;

  	      const iconPath = "M 0 0 L -1 -1 L 1 0 L -1 1 Z";
  	      if (iconColor.toLowerCase() === '#000000' || iconColor.toLowerCase() === 'black') {
  	        icon = {
  	          path: iconPath,
  	          fillColor: iconColor,
  	          fillOpacity: 1,
  	          strokeColor: 'white',
  	          strokeWeight: 3,
  	          rotation: heading,
  	          scale: marker.scale || pointScale || 8,
  	          anchor: new google.maps.Point(0, 0)
  	        };
  	      } else {
  	        icon = {
  	          path: iconPath,
  	          fillColor: iconColor,
  	          fillOpacity: 1,
  	          strokeColor: 'black',
  	          strokeWeight: 2,
  	          rotation: heading,
  	          scale: marker.scale || pointScale || 8,
  	          anchor: new google.maps.Point(0, 0)
  	        };
  	      }
  	    }

  	    const pointMarker = new google.maps.Marker({
  	      position: {
  	        lat: marker.lat, lng: marker.lng
  	      },
  	      map: mapInstance,
  	      icon: icon,
  	      draggable: false
  	    });

  	    existingMarkers.push(pointMarker);

  	    if (marker.Data) {
  	      const infowindow = new google.maps.InfoWindow({
  	        content: marker.Data
  	      });

  	      pointMarker.addListener('click', function() {
  	        if (currentInfoWindow) {
  	          currentInfoWindow.close();
  	        }
  	        infowindow.open(mapInstance, pointMarker);
  	        currentInfoWindow = infowindow;

  	        selectedMarker = pointMarker;
  	      });
  	    }

  	    pointMarker.addListener('click',
  	      function() {
  	        selectedMarker = pointMarker;
  	      });
  	  });

  	  // Add Geofences
  	  if (geofences && Array.isArray(geofences)) {
  	    geofences.forEach(geofence => {
  	      try {
  	        if (geofence["Geo Fences"] && geofence["Geo Fences"].boundary && Array.isArray(geofence["Geo Fences"].boundary.points)) {
  	          const polygonCoords = geofence["Geo Fences"].boundary.points.map(point => ({
  	            lat: point.y,
  	            lng: point.x
  	          }));

  	          const polygon = new google.maps.Polygon({
  	            paths: polygonCoords,
  	            strokeColor: geofence.Color,
  	            strokeOpacity: 0.9,
  	            strokeWeight: 4,
  	            fillColor: geofence.Color,
  	            fillOpacity: 0.25
  	          });

  	          polygon.setMap(mapInstance);
  	          existingGeofences.push(polygon);

  	          google.maps.event.addListener(polygon, 'click', function(event) {
  	            const infowindow = new google.maps.InfoWindow({
  	              content: createGeofencePopupContent(geofence, polygon, mapInstance, appData)
  	            });

  	            infowindow.setPosition(event.latLng);
  	            infowindow.open(mapInstance);
  	            currentInfoWindow = infowindow;
  	          });
  	        } else {
  	          console.warn("Invalid geofence data:", geofence);
  	        }
  	      } catch (error) {
  	        console.error("Error processing geofence data:", error);
  	      }
  	    });
  	  }

  	  // Add Stations
  	  if (stations && Array.isArray(stations)) {
  	    stations.forEach(station => {
  	      try {
  	        if (station["Geo Fence"] && station["Geo Fence"].boundary && station["Geo Fence"].boundary.points) {
  	          const stationCoords = station["Geo Fence"].boundary.points.map(point => ({
  	            lat: point.y,
  	            lng: point.x
  	          }));

  	          const polygon = new google.maps.Polygon({
  	            paths: stationCoords,
  	            strokeColor: station.Color,
  	            strokeOpacity: 0.9,
  	            strokeWeight: 4,
  	            fillColor: station.Color,
  	            fillOpacity: 0.25
  	          });

  	          polygon.setMap(mapInstance);
  	          existingGeofences.push(polygon);

  	          // Check for station location
  	          if (station.Location && station.Location.x !== undefined && station.Location.y !== undefined) {
  	            const icon = {
  	              url: stationIconSvg,
  	              anchor: new google.maps.Point(25, 50),
  	              scaledSize: new google.maps.Size(50, 50)
  	            };

  	            const stationCenter = {
  	              lat: station.Location.y,
  	              lng: station.Location.x
  	            };
  	            const stationMarker = new google.maps.Marker({
  	              position: stationCenter,
  	              map: mapInstance,
  	              icon: icon
  	            });

  	            existingMarkers.push(stationMarker);

  	            google.maps.event.addListener(stationMarker, 'click', function(event) {
  	              const infowindow = new google.maps.InfoWindow({
  	                content: createStationPopupContent(station)
  	              });

  	              infowindow.open(mapInstance, stationMarker);
  	              currentInfoWindow = infowindow;
  	            });
  	          } else {
  	            console.warn("Invalid station location data:", station);
  	          }

  	        } else {
  	          console.warn("Invalid station geofence data:", station);
  	        }
  	      } catch (error) {
  	        console.error("Error processing station geofence data:", error);
  	      }
  	    });
  	  }

  	  if (pointMarkers.length > 0) {
  	    const latestMarker = pointMarkers[pointMarkers.length - 1];
  	    if (latestMarker) {
  	      mapInstance.setCenter({
  	        lat: latestMarker.lat, lng: latestMarker.lng
  	      });
  	    }
  	  }

  	  // Adding Geofence Markers
  	  if (enableGeofence) {
  	    google.maps.event.addListener(mapInstance, 'click', function(event) {
  	      addGeofenceMarker(event.latLng);
  	    });
  	  }

  	  function addGeofenceMarker(location) {
  	    const markerIndex = geofenceMarkers.length;

  	    const icon = {
  	      path: google.maps.SymbolPath.CIRCLE,
  	      fillColor: markerIndex === geofenceMarkers.length - 1 ? '#FFFFFF': polygonColor || '#FF0000',
  	      fillOpacity: 1,
  	      strokeColor: 'black',
  	      strokeWeight: 2,
  	      scale: 8
  	    };

  	    const marker = new google.maps.Marker({
  	      position: location,
  	      map: mapInstance,
  	      icon: icon,
  	      draggable: true
  	    });

  	    geofenceMarkers.push(marker);

  	    marker.addListener('dragend', updateGeofencePolygon);
  	    marker.addListener('click', function() {
  	      marker.setMap(null);
  	      const markerIndex = geofenceMarkers.indexOf(marker);
  	      if (markerIndex !== -1) {
  	        geofenceMarkers.splice(markerIndex, 1);
  	        updateGeofencePolygon();
  	      }
  	    });

  	    if (geofenceMarkers.length > 2) {
  	      const firstMarker = geofenceMarkers[0];
  	      if (location.equals(firstMarker.getPosition())) {
  	        createGeofencePolygon();
  	      }
  	    }

  	    updateGeofencePolygon();
  	  }

  	  function updateGeofencePolygon() {
  	    const path = geofenceMarkers.map(marker => marker.getPosition());

  	    if (geofencePolygon) {
  	      geofencePolygon.setPath(path);
  	    } else {
  	      geofencePolygon = new google.maps.Polygon({
  	        paths: path,
  	        strokeColor: polygonColor || '#FF0000',
  	        strokeOpacity: 0.8,
  	        strokeWeight: 2,
  	        fillColor: polygonColor || '#FF0000',
  	        fillOpacity: 0.35
  	      });

  	      geofencePolygon.setMap(mapInstance);
  	    }

  	    // Ensure the last marker is white
  	    geofenceMarkers.forEach((marker, index) => {
  	      const isLastMarker = index === geofenceMarkers.length - 1;
  	      const icon = marker.getIcon();
  	      icon.fillColor = isLastMarker ? '#FFFFFF': polygonColor || '#FF0000';
  	      marker.setIcon(icon);
  	    });

  	    // Initialize appData if it's null or undefined
  	    if (!appData) {
  	      appData = {};
  	    }

  	    // Save the created polygon to App Data, overriding the existing value
  	    appData.geofencePolygons = {
  	      path: path.map(latLng => ({
  	        lat: latLng.lat(), lng: latLng.lng()
  	      })),
  	      color: polygonColor || '#FF0000'
  	    };
  	  }

  	  function createGeofencePolygon() {
  	    const path = geofenceMarkers.map(marker => marker.getPosition());

  	    if (geofencePolygon) {
  	      geofencePolygon.setPath(path);
  	    } else {
  	      geofencePolygon = new google.maps.Polygon({
  	        paths: path,
  	        strokeColor: polygonColor || '#FF0000',
  	        strokeOpacity: 0.8,
  	        strokeWeight: 2,
  	        fillColor: polygonColor || '#FF0000',
  	        fillOpacity: 0.35
  	      });

  	      geofencePolygon.setMap(mapInstance);
  	    }
  	  }

  	  let currentInfoWindow = null;

  	  function createGeofencePopupContent(geofence, polygon, mapInstance, appData) {
  	    // Log the initial arguments received
  	    console.log('Received arguments:', {
  	      geofence,
  	      polygon,
  	      mapInstance,
  	      appData
  	    });

  	    // Log the appData structure for debugging
  	    console.log('appData:', appData);

  	    // Validate the appData structure step by step
  	    if (!appData) {
  	      console.error("appData is undefined or null.");
  	      return;
  	    }

  	    if (!appData.User) {
  	      console.error("appData.User is undefined or null.");
  	      return;
  	    }

  	    if (!appData.User.Company) {
  	      console.error("appData.User.Company is undefined or null.");
  	      return;
  	    }

  	    if (!Array.isArray(appData.User.Company.Locations)) {
  	      console.error("appData.User.Company.Locations is not an array.");
  	      return;
  	    }

  	    // If all checks pass, retrieve the locations array
  	    const geofences = appData.User.Company.Locations;

  	    const content = document.createElement('div');
  	    content.style.padding = '10px';
  	    content.style.fontFamily = 'Arial, sans-serif';
  	    content.style.color = 'white';

  	    const headerDiv = document.createElement('div');
  	    headerDiv.style.display = 'flex';
  	    headerDiv.style.justifyContent = 'space-between';
  	    headerDiv.style.alignItems = 'center';

  	    const title = document.createElement('h3');
  	    title.style.margin = '0';
  	    title.textContent = geofence.Name;

  	    const iconDiv = document.createElement('div');
  	    iconDiv.style.display = 'flex';
  	    iconDiv.style.gap = '10px';

  	    // Edit Icon
  	    const editIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  	    editIcon.setAttribute('width', '24');
  	    editIcon.setAttribute('height', '24');
  	    editIcon.setAttribute('viewBox', '0 0 24 24');
  	    editIcon.setAttribute('fill', 'none');
  	    editIcon.setAttribute('stroke', 'white');
  	    editIcon.setAttribute('stroke-width', '2');
  	    editIcon.setAttribute('stroke-linecap', 'round');
  	    editIcon.setAttribute('stroke-linejoin', 'round');
  	    editIcon.style.cursor = 'pointer';

  	    const editPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  	    editPath.setAttribute('d', 'M12 20h9');
  	    editIcon.appendChild(editPath);

  	    const editPath2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  	    editPath2.setAttribute('d', 'M16.5 3.5a2.121 2.121 0 010 3l-10 10-4 1 1-4 10-10a2.121 2.121 0 013 0z');
  	    editIcon.appendChild(editPath2);

  	    // Delete Icon
  	    const deleteIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  	    deleteIcon.setAttribute('width', '24');
  	    deleteIcon.setAttribute('height', '24');
  	    deleteIcon.setAttribute('viewBox', '0 0 24 24');
  	    deleteIcon.setAttribute('fill', 'none');
  	    deleteIcon.setAttribute('stroke', 'white');
  	    deleteIcon.setAttribute('stroke-width', '2');
  	    deleteIcon.setAttribute('stroke-linecap', 'round');
  	    deleteIcon.setAttribute('stroke-linejoin', 'round');
  	    deleteIcon.style.cursor = 'pointer';

  	    const polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
  	    polyline.setAttribute('points', '3 6 5 6 21 6');
  	    deleteIcon.appendChild(polyline);

  	    const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  	    path1.setAttribute('d', 'M19 6L17.707 18H6.293L5 6');
  	    deleteIcon.appendChild(path1);

  	    // Add Icons to iconDiv
  	    iconDiv.appendChild(editIcon);
  	    iconDiv.appendChild(deleteIcon);

  	    headerDiv.appendChild(title);
  	    headerDiv.appendChild(iconDiv);

  	    content.appendChild(headerDiv);

  	    const address = document.createElement('p');
  	    address.innerHTML = `<strong>Address:</strong> ${geofence.Address}`;
  	    content.appendChild(address);

  	    const contactName = document.createElement('p');
  	    contactName.innerHTML = `<strong>Contact Name:</strong> ${geofence.Contact_Name}`;
  	    content.appendChild(contactName);

  	    const phone = document.createElement('p');
  	    phone.innerHTML = `<strong>Phone:</strong> ${geofence.Phone}`;
  	    content.appendChild(phone);

  	    const infowindow = new google.maps.InfoWindow({
  	      content: content,
  	      disableAutoPan: true
  	    });

  	    // Add event listener to the polygon to handle the click
  	    polygon.addListener('click', function(event) {
  	      // Close the currently open InfoWindow if any
  	      if (currentInfoWindow) {
  	        currentInfoWindow.close();
  	      }

  	      // Open the new InfoWindow
  	      infowindow.setPosition(event.latLng);
  	      infowindow.open(mapInstance);
  	      currentInfoWindow = infowindow;
  	    });

  	    editIcon.addEventListener('click',
  	      async function () {
  	        // Step 1: Ensure the object has an objectId before proceeding
  	        if (!geofence.objectId) {
  	          console.error("Geofence object does not have an objectId. Edit operation will not proceed.");
  	          return;
  	        }

  	        const isEditable = polygon.getEditable();
  	        polygon.setEditable(!isEditable);

  	        if (!isEditable) {
  	          editIcon.innerHTML = ''; // Switch to save icon
  	          const checkPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  	          checkPath.setAttribute('d', 'M20 6L9 17l-5-5');
  	          editIcon.appendChild(checkPath);
  	        } else {
  	          const newPath = polygon.getPath().getArray().map(latLng => [latLng.lng(), latLng.lat()]);

  	          // Step 2: Find the correct location in geofences
  	          const updatedGeofence = geofences.find(loc => loc.objectId === geofence.objectId);
  	          if (!updatedGeofence) {
  	            console.error("Geofence object not found in geofences array.");
  	            return;
  	          }

  	          // Step 3: Update the Geo Fences property with a valid GeoJSON structure
  	          updatedGeofence["Geo Fences"] = {
  	            type: "Polygon",
  	            coordinates: [newPath],
  	            srs: {
  	              srsId: 4326,
  	              name: 'WGS 84'
  	            },
  	            holes: [] // Add holes if applicable or leave as an empty array
  	          };

  	          // Step 4: Sanitize the object before logging and saving
  	          const sanitizedGeofence = JSON.parse(JSON.stringify(updatedGeofence, (key, value) => {
  	            if (typeof value === 'function' || value instanceof Element) {
  	              return undefined; // Remove functions and DOM elements
  	            }
  	            return value;
  	          }));

  	          // Step 5: Console log the sanitized object before saving
  	          const timestamp = new Date().toISOString();
  	          console.log(`[${timestamp}] Object before saving to Backendless:`, sanitizedGeofence);

  	          // Step 6: Save the updated object to Backendless
  	          try {
  	            const result = await Backendless.Data.of('Locations').save(sanitizedGeofence, true);
  	            console.log(`[${timestamp}] Geofence successfully saved to Backendless:`, result);

  	            // Update the geofences array in appData
  	            const index = geofences.findIndex(loc => loc.objectId === geofence.objectId);
  	            if (index !== -1) {
  	              geofences[index] = result;
  	              console.log(`[${timestamp}] Geofence updated in geofences array.`);
  	            } else {
  	              console.warn(`[${timestamp}] Geofence with objectId ${geofence.objectId} not found in geofences.`);
  	            }

  	          } catch (error) {
  	            console.error(`[${timestamp}] Error saving geofence to Backendless:`, error);
  	            alert(`Failed to save the geofence. Error: ${error.message}`);
  	          }

  	          editIcon.innerHTML = '';
  	          editIcon.appendChild(editPath);
  	          editIcon.appendChild(editPath2);
  	        }
  	      });

  	    // Handling Delete Icon Click
  	    deleteIcon.addEventListener('click',
  	      async function() {
  	        const confirmation = confirm(`Are you sure you want to delete the location: ${geofence.Name}?`);
  	        if (confirmation) {
  	          try {
  	            await Backendless.Data.of('Locations').remove(geofence.objectId);
  	            console.log(`Location with objectId ${geofence.objectId} has been deleted from Backendless.`);

  	            // Remove from geofences array in appData
  	            appData.User.Company.Locations = await asyncListFilter(geofences, async (item) => {
  	              return (geofence.objectId !== item.objectId);
  	            });
  	            console.log("Location removed from geofences in appData.");

  	            polygon.setMap(null);
  	            infowindow.close();
  	          } catch (error) {
  	            console.error(`Error deleting location: ${error}`);
  	            alert('An error occurred while deleting the location. Please try again.');
  	          }
  	        }
  	      });

  	    return content;
  	  }

  	  // Supporting Functions

  	  async function asyncListFilter(sourceList,
  	    callback) {
  	    const list = await Promise.all(sourceList.map(async source => ({
  	      source,
  	      value: await callback(source),
  	    })));

  	    const resultList = list.filter(item => item.value);

  	    return resultList.map(item => item.source);
  	  }
  	}

  	// Helper function to create popup content for stations
  	function createStationPopupContent(station) {
  	  return `
  	  <div style="padding: 10px; font-family: Arial, sans-serif; color: white;">
  	  <table>
  	  <tr><td><strong>Station Name:</strong></td><td>${station.Station_Name}</td></tr>
  	  <tr><td><strong>Brand:</strong></td><td>${station.Brand}</td></tr>
  	  <tr><td><strong>Contact Name:</strong></td><td>${station.Contact_Name}</td></tr>
  	  <tr><td><strong>Phone:</strong></td><td>${station.Contact_Number}</td></tr>
  	  <tr><td><strong>Address:</strong></td><td>${station.Province}, ${station.Town}</td></tr>
  	  <tr><td><strong>Price:</strong></td><td>${station.Price}</td></tr>
  	  <tr><td><strong>Truck Stop:</strong></td><td>${station.Truck_Stop ? 'Yes': 'No'}</td></tr>
  	  </table>
  	  <p><strong>Services:</strong></p>
  	  <ul>
  	  ${(Array.isArray(station.Services) ? station.Services: []).map(service => `<li>${service}</li>`).join('')}
  	  </ul>
  	  </div>
  	  `;
  	}

  	try {
  	  const googleMapComponent = arguments[0];
  	  const polylineColor = arguments[1];
  	  const markers = arguments[2];
  	  const strokeOpacity = arguments[3];
  	  const strokeWeight = arguments[4];
  	  const pointMarkers = arguments[5];
  	  const pointColor = arguments[6];
  	  const pointScale = arguments[7];
  	  const vehicleId = arguments[8];
  	  const geofences = arguments[9];
  	  const stations = arguments[10];
  	  const stationIconSvg = arguments[11];
  	  const enableGeofence = arguments[12];
  	  const polygonColor = arguments[13];
  	  const appData = arguments[14];

  	  addPolylineAndCustomMarkers(
  	    googleMapComponent,
  	    polylineColor,
  	    markers,
  	    strokeOpacity,
  	    strokeWeight,
  	    pointMarkers,
  	    pointColor,
  	    pointScale,
  	    vehicleId,
  	    geofences,
  	    stations,
  	    stationIconSvg,
  	    enableGeofence,
  	    polygonColor,
  	    appData
  	  );
  	} catch (error) {
  	  console.error("Error in addPolylineAndCustomMarkers:",
  	    error);
  	}
  })(Map, PolylineColor, ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](TrackingData)) ? null : (await Promise.all(TrackingData.map(async item => {; return ({ [`lat`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.latitude')))) ? null : (getObjectProperty(item, 'position.latitude')),[`lng`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.longitude')))) ? null : (getObjectProperty(item, 'position.longitude')) });})))), StrokeOpacity, StrokeWeight, (Fuel_Loss_List.concat((await BackendlessUI.Functions.Custom['fn_343eca57258d3a15fcf855fe73fdf50a']((await Promise.all(TrackingData.map(async item => {; return ({ [`lat`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.latitude')))) ? null : (getObjectProperty(item, 'position.latitude')),[`lng`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.longitude')))) ? null : (getObjectProperty(item, 'position.longitude')),[`Data`]: (await BackendlessUI.Functions.Custom['fn_3a793fed77a519bfe0e8407457e3fd8c']((await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Date',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toDateString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Time',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toLocaleTimeString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'ID')))) ? null : ({ [`Label`]: 'Fleet ID',[`Value`]: (getObjectProperty(VehicleData, 'ID')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Registration')))) ? null : ({ [`Label`]: 'Registration',[`Value`]: (getObjectProperty(VehicleData, 'Registration')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ({ [`Label`]: 'Driver',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Nickname')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')))) ? null : ({ [`Label`]: 'Driver Mobile',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }))], async (item) => {


   return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
  })), (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.vehicle.mileage')))) ? null : ({ [`Label`]: 'Odometer',[`Value`]: String(getObjectProperty(item, 'can.vehicle.mileage')) + String(' km'),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : ({ [`Label`]: 'Speed',[`Value`]: [(getObjectProperty(item, 'position.speed')),' km/h',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Speed')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max Speed')),')'].join('')].join(''),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ({ [`Label`]: 'Fuel Level',[`Value`]: String(((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) + String(' L'),[`Color`]: 'rgba(70, 130, 180, 0.5)' })), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Current_Fuel_Consumption_Last_5_Tanks')))) ? null : ({ [`Label`]: 'Range Est.',[`Value`]: String((((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) * (getObjectProperty(VehicleData, 'Current_Fuel_Consumption_Last_5_Tanks'))) + String(' km'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }))), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.altitude')))) ? null : ({ [`Label`]: 'Altitude',[`Value`]: String(getObjectProperty(item, 'position.altitude')) + String(' m'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.rpm')))) ? null : ({ [`Label`]: 'RPM',[`Value`]: [(getObjectProperty(item, 'can.engine.rpm')),' RPM',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max RPM')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max RPM')),')'].join('')].join(''),[`Color`]: 'rgba(70, 130, 180, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.temperature')))) ? null : ({ [`Label`]: 'Engine Temp.',[`Value`]: String(getObjectProperty(item, 'can.engine.temperature')) + String('°'),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.throttle.pedal.level')))) ? null : ({ [`Label`]: 'Throttle Pedal',[`Value`]: [(getObjectProperty(item, 'can.throttle.pedal.level')),'% - ',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Pedal')))) ? null : ['(',(getObjectProperty(VehicleData, 'Can Max Pedal')),'%)'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' })], async (item) => {


   return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
  })))),[`color`]: (await BackendlessUI.Functions.Custom['fn_95b21da849de975107054e732dc24af2'](item, VehicleData)),[`Speed`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : (getObjectProperty(item, 'position.speed')),[`Direction`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.direction')))) ? null : (getObjectProperty(item, 'position.direction')) });}))), MarkerDensity)))), PointColor, PointScale, ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'ID')))) ? null : (getObjectProperty(VehicleData, 'ID'))), Geofences, Stations, 'data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22840%22%20height%3D%22840%22%3E%0A%3Cpath%20d%3D%22M0%200%20C1.47981857%20-0.01058945%201.47981857%20-0.01058945%202.98953247%20-0.02139282%20C43.74789262%20-0.24691352%2043.74789262%20-0.24691352%2061.3671875%203.203125%20C62.47320312%203.41243652%2063.57921875%203.62174805%2064.71875%203.83740234%20C132.81352715%2016.93897099%20198.28215198%2051.77158721%20241.3671875%20107.203125%20C242.90599137%20109.05966824%20244.44770872%20110.91380011%20245.9921875%20112.765625%20C250.05704348%20117.75399387%20253.81432453%20122.83886142%20257.3671875%20128.203125%20C257.77775391%20128.81526855%20258.18832031%20129.42741211%20258.61132812%20130.05810547%20C282.6181687%20166.05978019%20297.73387618%20205.71460903%20305.3671875%20248.203125%20C305.53234863%20249.06550781%20305.69750977%20249.92789063%20305.86767578%20250.81640625%20C311.3650026%20280.42351903%20311.0054916%20314.65197409%20305.3671875%20344.203125%20C305.20089844%20345.14236816%20305.03460937%20346.08161133%20304.86328125%20347.04931641%20C292.8447543%20414.38645211%20259.36520432%20468.63417829%20211.54402828%20516.25841546%20C208.87387347%20518.91982314%20206.20961449%20521.58712276%20203.54458618%20524.25366211%20C198.94155689%20528.85773323%20194.33491975%20533.45816788%20189.72571564%20538.05605698%20C183.0618271%20544.70359726%20176.40355741%20551.35674273%20169.74658677%20558.01120986%20C158.94239539%20568.81103866%20148.133758%20579.60640622%20137.32226562%20590.39892578%20C126.82836739%20600.87442783%20116.33660026%20611.35205681%20105.84765625%20621.83251953%20C105.1996439%20622.48000644%20104.55163154%20623.12749335%20103.88398245%20623.79460107%20C100.63266801%20627.04330518%2097.38139505%20630.29205079%2094.13014269%20633.54081702%20C67.21558299%20660.43468903%2040.29378261%20687.32130336%2013.3671875%20714.203125%20C7.78915659%20709.55605287%202.62674698%20704.60629427%20-2.50033569%20699.46931458%20C-3.36976323%20698.6021526%20-4.23919076%20697.73499062%20-5.13496459%20696.84155101%20C-7.53212068%20694.44960801%20-9.92703915%20692.05546511%20-12.32099724%20689.66032398%20C-14.90961357%20687.07150273%20-17.50109381%20684.48555089%20-20.09217834%20681.89920044%20C-25.16247623%20676.83719004%20-30.2300107%20671.77242206%20-35.29644559%20666.70654557%20C-39.41734341%20662.58612385%20-43.53903192%20658.46649473%20-47.66127396%20654.34741783%20C-59.3635092%20642.6539842%20-71.06365064%20630.95846133%20-82.76111059%20619.26025072%20C-83.70597218%20618.3153292%20-83.70597218%20618.3153292%20-84.66992188%20617.35131836%20C-85.30060352%20616.72059584%20-85.93128516%20616.08987331%20-86.58107837%20615.44003799%20C-96.79728863%20605.22342146%20-107.01847576%20595.01180022%20-117.2419378%20584.8024408%20C-127.75398064%20574.30478364%20-138.26226779%20563.80337978%20-148.76668894%20553.29809588%20C-154.65825706%20547.40619654%20-160.55133832%20541.51582969%20-166.44846725%20535.62949562%20C-171.47015365%20530.61694312%20-176.48832041%20525.6008991%20-181.50205801%20520.58039544%20C-184.05660035%20518.02260236%20-186.61267923%20515.46639966%20-189.17320824%20512.91459846%20C-191.95806076%20510.13914029%20-194.73500588%20507.35585209%20-197.51132202%20504.57185364%20C-198.3091036%20503.77921562%20-199.10688517%20502.98657761%20-199.92884195%20502.16992027%20C-204.79199415%20497.2771682%20-209.24310555%20492.16978774%20-213.55749381%20486.78659743%20C-215.66719988%20484.16031767%20-217.83083594%20481.5862548%20-220.0078125%20479.015625%20C-241.21127605%20452.99820352%20-258.5967139%20421.26270786%20-268.6328125%20389.203125%20C-268.9220459%20388.28208984%20-269.2112793%20387.36105469%20-269.50927734%20386.41210938%20C-273.17955011%20374.49985488%20-276.15020272%20362.51779317%20-278.4453125%20350.265625%20C-278.64012207%20349.22599609%20-278.83493164%20348.18636719%20-279.03564453%20347.11523438%20C-282.05401853%20330.08469069%20-283.00838503%20313.35723425%20-282.9453125%20296.078125%20C-282.94348969%20295.04065125%20-282.94166687%20294.00317749%20-282.93978882%20292.93426514%20C-282.89501524%20277.7984622%20-282.4165295%20263.11570064%20-279.6328125%20248.203125%20C-279.37540283%20246.71159912%20-279.37540283%20246.71159912%20-279.11279297%20245.18994141%20C-269.80291016%20191.43555998%20-245.73026405%20139.6924054%20-208.671875%2099.42578125%20C-206.82030955%2097.40750397%20-205.0344825%2095.34963365%20-203.2578125%2093.265625%20C-196.33141851%2085.32678827%20-188.717523%2077.95151971%20-180.6328125%2071.203125%20C-180.13313965%2070.77370605%20-179.6334668%2070.34428711%20-179.11865234%2069.90185547%20C-161.9127603%2055.13764179%20-142.81597778%2042.52099582%20-122.6328125%2032.203125%20C-121.83907227%2031.79400879%20-121.04533203%2031.38489258%20-120.22753906%2030.96337891%20C-100.651255%2020.97587009%20-79.97454661%2013.43696619%20-58.6328125%208.203125%20C-57.91109863%208.02442871%20-57.18938477%207.84573242%20-56.44580078%207.66162109%20C-37.98524368%203.15735909%20-19.0263901%200.09080073%200%200%20Z%20%22%20fill%3D%22%23818181%22%20transform%3D%22translate(407.6328125%2C124.796875)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.66%201.32%201.32%202%202%20C1.13181641%203.63001953%201.13181641%203.63001953%200.24609375%205.29296875%20C-2.33473545%2010.464846%20-4.1425797%2015.82731165%20-5.9375%2021.3125%20C-6.28449951%2022.3641333%20-6.63149902%2023.4157666%20-6.98901367%2024.49926758%20C-9.83416086%2033.24374576%20-12.32426706%2042.04450243%20-14.50488281%2050.9765625%20C-14.95619766%2052.82098926%20-15.42631849%2054.66078854%20-15.8984375%2056.5%20C-17.79809128%2064.17384893%20-18.92815569%2071.87566887%20-19.75732422%2079.72900391%20C-19.92295685%2081.27901875%20-20.09682125%2082.82817053%20-20.27783203%2084.37646484%20C-21.66526588%2096.29524936%20-22.18858118%20108.1336789%20-22.1875%20120.125%20C-22.18830566%20121.4361377%20-22.18911133%20122.74727539%20-22.18994141%20124.09814453%20C-22.23269393%20131.12780461%20-22.23269393%20131.12780461%20-21%20138%20C-20.93611284%20140.26799402%20-21.00037278%20142.51360664%20-21.0625%20144.78125%20C-20.99961768%20147.01357221%20-20.5972504%20148.85613849%20-20%20151%20C-19.87625%20151.845625%20-19.7525%20152.69125%20-19.625%20153.5625%20C-18.89434673%20156.41204775%20-18.2388101%20157.14164129%20-16%20159%20C-13.52481089%20160.19968218%20-13.52481089%20160.19968218%20-10.6875%20161.25%20C-1.29797706%20165.02857165%207.71904617%20169.41654921%2016.2109375%20174.9453125%20C19.29903346%20176.76580575%2022.61602798%20177.85676621%2026%20179%20C33.71117166%20181.71117166%2033.71117166%20181.71117166%2036%20184%20C38.57061311%20184.64767793%2038.57061311%20184.64767793%2041%20185%20C41%20185.66%2041%20186.32%2041%20187%20C42.2684375%20187.1546875%2042.2684375%20187.1546875%2043.5625%20187.3125%20C47.41442701%20188.0828854%2050.44075031%20189.36274514%2054%20191%20C54%20191.99%2054%20192.98%2054%20194%20C56.33497831%20194.94858494%2058.66958147%20195.881858%2061.04296875%20196.73046875%20C61.75066406%20196.98441406%2062.45835937%20197.23835937%2063.1875%20197.5%20C64.19876953%20197.85578125%2064.19876953%20197.85578125%2065.23046875%20198.21875%20C67%20199%2067%20199%2069%20201%20C72.77034424%20202.53369935%2076.36088307%20203.84323547%2080.3125%20204.8125%20C84.56680828%20206.18253148%2088.13707318%20208.15741439%2092.01953125%20210.34765625%20C96.03648785%20212.57461908%20100.1485122%20214.58747969%20104.2734375%20216.60546875%20C106.09795702%20217.53863991%20107.89139561%20218.53510032%20109.6484375%20219.58984375%20C112.03727266%20221.02235121%20114.48399665%20222.05597041%20117.05078125%20223.125%20C122.29635398%20225.47972603%20127.20879341%20228.46261315%20132%20231.625%20C135.38161704%20233.77876799%20138.67763459%20235.05434041%20142.53125%20236.12890625%20C145.4160769%20237.14681195%20148.03462197%20238.48926965%20150.75634766%20239.87866211%20C154.75853461%20241.8788846%20158.85241816%20243.67680277%20162.9375%20245.5%20C163.77990234%20245.87769531%20164.62230469%20246.25539063%20165.49023438%20246.64453125%20C168.83528777%20248.14323877%20172.1809045%20249.64003945%20175.53662109%20251.11474609%20C176.33535645%20251.46617676%20177.1340918%20251.81760742%20177.95703125%20252.1796875%20C178.66964111%20252.49147949%20179.38225098%20252.80327148%20180.11645508%20253.12451172%20C182.52176143%20254.24251931%20184.73852434%20255.6179871%20187%20257%20C187.763125%20257.28875%20188.52625%20257.5775%20189.3125%20257.875%20C191.75191605%20258.89615091%20193.57472122%20260.02684091%20195.75%20261.5%20C199.42372767%20263.87507536%20202.68968908%20264.76051126%20206.95703125%20265.5390625%20C209.70036662%20266.15801771%20211.71689772%20267.38839839%20214%20269%20C216.58921481%20270.72614321%20218.23496161%20271.49452235%20221.125%20272.375%20C227.64849001%20274.47866616%20234.37845496%20277.01051642%20240%20281%20C240%20281.66%20240%20282.32%20240%20283%20C240.845625%20283.2475%20241.69125%20283.495%20242.5625%20283.75%20C245.58791625%20284.85015136%20248.04892003%20286.20389442%20250.79296875%20287.8515625%20C254.800523%20289.93690931%20259.07052128%20291.39154712%20263.3046875%20292.94921875%20C266%20294%20266%20294%20267%20295%20C273.13743205%20295.61061186%20276.80374339%20294.00185471%20282%20291.125%20C286.95392148%20288.4392533%20291.49957861%20286.41946358%20297%20285%20C298.44520786%20284.47924741%20299.88463148%20283.94156907%20301.3125%20283.375%20C305%20282%20305%20282%20307%20282%20C307.3403125%20281.13375%20307.3403125%20281.13375%20307.6875%20280.25%20C310.81972092%20274.88047842%20316.07502144%20272.92372255%20321.625%20270.875%20C325.30994432%20269.48781054%20328.69887671%20268.20074886%20332%20266%20C333.6396875%20265.566875%20333.6396875%20265.566875%20335.3125%20265.125%20C339.15928549%20263.95140443%20341.71099107%20262.2657617%20345%20260%20C347.375%20259.25%20347.375%20259.25%20349%20259%20C349%20258.34%20349%20257.68%20349%20257%20C354.08940744%20254.94637945%20358.54520815%20253.56820748%20364%20253%20C364%20252.34%20364%20251.68%20364%20251%20C367.89581283%20248.83565954%20371.74372812%20247.40184924%20376%20246.0625%20C380.58249777%20244.57262388%20384.11905565%20242.91070826%20388%20240%20C392.47989074%20236.9566987%20396.75697008%20234.57791269%20401.875%20232.80859375%20C404.30571241%20231.88367193%20406.56223128%20230.75140767%20408.875%20229.5625%20C412.06072385%20227.92867188%20415.2079571%20226.49727486%20418.5625%20225.25%20C424.27661901%20223.05156311%20429.5800832%20220.11840113%20434.93579102%20217.17285156%20C438.89307319%20215.01824482%20442.66634014%20213.30793351%20447%20212%20C448.73581679%20211.37225952%20450.46552221%20210.72726352%20452.1875%20210.0625%20C453.02667969%20209.74410156%20453.86585938%20209.42570313%20454.73046875%20209.09765625%20C457.03403863%20207.98353725%20458.27050372%20206.84741648%20460%20205%20C462.9051282%20203.38603989%20465.68239862%20202.10194612%20468.84765625%20201.0859375%20C471.95700843%20200.01480998%20474.71245442%20198.70796112%20477.625%20197.1875%20C481.67359436%20195.12076996%20485.71746995%20193.25051202%20489.9375%20191.5625%20C495.51208858%20189.30925422%20500.67796114%20186.53262297%20505.89453125%20183.55078125%20C509.2110919%20181.89458681%20512.42931383%20180.97047319%20516%20180%20C518.33698333%20179.00414707%20520.60315043%20177.91605112%20522.88671875%20176.8046875%20C525%20176%20525%20176%20529%20176%20C528.54944444%20186.18255557%20525.6408532%20195.12287617%20520.8671875%20204.078125%20C519.60771065%20206.86939802%20519.13983813%20209.72236288%20518.5546875%20212.71484375%20C517.5843472%20216.71237245%20515.75552585%20220.29743639%20514%20224%20C513.30975354%20225.58213796%20512.62221082%20227.16545849%20511.9375%20228.75%20C510.87291521%20231.17558339%20509.85000942%20233.22498587%20508.375%20235.4375%20C506.98501794%20238.02792111%20506.71310956%20239.63126716%20506.3125%20242.5%20C505.05222459%20249.61684935%20500.91828972%20255.06408349%20497%20261%20C493.13348114%20267.15128001%20489.76222646%20273.27316614%20487%20280%20C487.33%20280.33%20487.66%20280.66%20488%20281%20C492.29930916%20277.10375108%20495.53914246%20272.66677891%20498.89453125%20267.9453125%20C500.23848332%20266.06527565%20501.6086063%20264.20349389%20503.01171875%20262.3671875%20C509.64149056%20253.64037588%20514.53807047%20244.17810246%20519.25%20234.3125%20C520.88310939%20231.22125723%20522.28028323%20229.17577342%20525%20227%20C525.66%20227%20526.32%20227%20527%20227%20C528.83402304%20221.03331172%20530.53889252%20215.06921567%20532%20209%20C532.66%20209%20533.32%20209%20534%20209%20C534.09796875%20208.44054687%20534.1959375%20207.88109375%20534.296875%20207.3046875%20C535.46966147%20201.01612555%20537.10605675%20194.94756748%20538.9375%20188.8203125%20C539.70101164%20186.07503902%20540.36117179%20183.39992479%20540.9375%20180.6171875%20C541.09492676%20179.88967285%20541.25235352%20179.1621582%20541.41455078%20178.41259766%20C541.7158578%20176.99744517%20541.996374%20175.57766634%20542.25341797%20174.15380859%20C542.6796875%20172.203125%20542.6796875%20172.203125%20544%20169%20C547.0703125%20167.734375%20547.0703125%20167.734375%20550%20167%20C550.33%20166.01%20550.66%20165.02%20551%20164%20C553.76673506%20161.52970084%20556.58169666%20160.34933027%20560%20159%20C564.97428397%20154.02571603%20563.22928068%20141.73411545%20563.30859375%20135.04296875%20C563.33121529%20133.17510963%20563.33121529%20133.17510963%20563.35429382%20131.26951599%20C563.39403524%20127.24215146%20563.41993878%20123.21500818%20563.4375%20119.1875%20C563.44095177%20118.5052813%20563.44440353%20117.82306259%20563.4479599%20117.12017059%20C563.5537795%2093.42364686%20562.53585673%2070.17939532%20555.91796875%2047.2512207%20C554.78964195%2043.25496325%20554.85542225%2040.12046576%20555%2036%20C556.98377095%2038.97565642%20557.59864225%2040.84854822%20558.40234375%2044.27734375%20C558.77613159%2045.8696582%20558.77613159%2045.8696582%20559.1574707%2047.49414062%20C559.41488037%2048.63044922%20559.67229004%2049.76675781%20559.9375%2050.9375%20C560.20328857%2052.10087891%20560.46907715%2053.26425781%20560.74291992%2054.46289062%20C564.50632294%2071.31222642%20567.12072075%2088.34566596%20567.203125%20105.6328125%20C567.21013931%20106.61953949%20567.21715363%20107.60626648%20567.22438049%20108.62289429%20C567.24179482%20111.79030976%20567.24823284%20114.95753841%20567.25%20118.125%20C567.25101212%20119.74619751%20567.25101212%20119.74619751%20567.25204468%20121.40014648%20C567.23671024%20136.8285943%20566.89923638%20151.8046912%20564%20167%20C563.75056641%20168.40886475%20563.75056641%20168.40886475%20563.49609375%20169.84619141%20C551.4775668%20237.18332711%20517.99801682%20291.43105329%20470.17684078%20339.05529046%20C467.50668597%20341.71669814%20464.84242699%20344.38399776%20462.17739868%20347.05053711%20C457.57436939%20351.65460823%20452.96773225%20356.25504288%20448.35852814%20360.85293198%20C441.6946396%20367.50047226%20435.03636991%20374.15361773%20428.37939927%20380.80808486%20C417.57520789%20391.60791366%20406.7665705%20402.40328122%20395.95507812%20413.19580078%20C385.46117989%20423.67130283%20374.96941276%20434.14893181%20364.48046875%20444.62939453%20C363.8324564%20445.27688144%20363.18444404%20445.92436835%20362.51679495%20446.59147607%20C359.26548051%20449.84018018%20356.01420755%20453.08892579%20352.76295519%20456.33769202%20C325.84839549%20483.23156403%20298.92659511%20510.11817836%20272%20537%20C266.42196909%20532.35292787%20261.25955948%20527.40316927%20256.13247681%20522.26618958%20C255.26304927%20521.3990276%20254.39362174%20520.53186562%20253.49784791%20519.63842601%20C251.10069182%20517.24648301%20248.70577335%20514.85234011%20246.31181526%20512.45719898%20C243.72319893%20509.86837773%20241.13171869%20507.28242589%20238.54063416%20504.69607544%20C233.47033627%20499.63406504%20228.4028018%20494.56929706%20223.33636691%20489.50342057%20C219.21546909%20485.38299885%20215.09378058%20481.26336973%20210.97153854%20477.14429283%20C199.2693033%20465.4508592%20187.56916186%20453.75533633%20175.87170191%20442.05712572%20C175.24179419%20441.42717804%20174.61188646%20440.79723036%20173.96289062%20440.14819336%20C173.33220898%20439.51747084%20172.70152734%20438.88674831%20172.05173413%20438.23691299%20C161.83552387%20428.02029646%20151.61433674%20417.80867522%20141.3908747%20407.5993158%20C130.87883186%20397.10165864%20120.37054471%20386.60025478%20109.86612356%20376.09497088%20C103.97455544%20370.20307154%2098.08147418%20364.31270469%2092.18434525%20358.42637062%20C87.16265885%20353.41381812%2082.14449209%20348.3977741%2077.13075449%20343.37727044%20C74.57621215%20340.81947736%2072.02013327%20338.26327466%2069.45960426%20335.71147346%20C66.67475174%20332.93601529%2063.89780662%20330.15272709%2061.12149048%20327.36872864%20C60.3237089%20326.57609062%2059.52592733%20325.78345261%2058.70397055%20324.96679527%20C53.84081835%20320.0740432%2049.38970695%20314.96666274%2045.07531869%20309.58347243%20C42.96561262%20306.95719267%2040.80197656%20304.3831298%2038.625%20301.8125%20C17.42153645%20275.79507852%200.0360986%20244.05958286%20-10%20212%20C-10.2892334%20211.07896484%20-10.5784668%20210.15792969%20-10.87646484%20209.20898438%20C-14.54673761%20197.29672988%20-17.51739022%20185.31466817%20-19.8125%20173.0625%20C-20.00730957%20172.02287109%20-20.20211914%20170.98324219%20-20.40283203%20169.91210938%20C-23.42120603%20152.88156569%20-24.37557253%20136.15410925%20-24.3125%20118.875%20C-24.31067719%20117.83752625%20-24.30885437%20116.80005249%20-24.30697632%20115.73114014%20C-24.26220274%20100.5953372%20-23.783717%2085.91257564%20-21%2071%20C-20.74259033%2069.50847412%20-20.74259033%2069.50847412%20-20.47998047%2067.98681641%20C-16.50308787%2045.02461524%20-10.48155578%2020.96311156%200%200%20Z%20%22%20fill%3D%22%23000000%22%20transform%3D%22translate(149%2C302)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.47981857%20-0.01058945%201.47981857%20-0.01058945%202.98953247%20-0.02139282%20C43.74789262%20-0.24691352%2043.74789262%20-0.24691352%2061.3671875%203.203125%20C62.47320312%203.41243652%2063.57921875%203.62174805%2064.71875%203.83740234%20C132.81352715%2016.93897099%20198.28215198%2051.77158721%20241.3671875%20107.203125%20C242.90599137%20109.05966824%20244.44770872%20110.91380011%20245.9921875%20112.765625%20C250.05704348%20117.75399387%20253.81432453%20122.83886142%20257.3671875%20128.203125%20C257.77775391%20128.81526855%20258.18832031%20129.42741211%20258.61132812%20130.05810547%20C273.25456882%20152.01772931%20284.61607775%20175.3220376%20293.3671875%20200.203125%20C293.66898926%20201.03900146%20293.97079102%20201.87487793%20294.28173828%20202.73608398%20C295.74331206%20206.89858025%20296.71449161%20210.56835709%20296.8671875%20215.015625%20C297.04785714%20220.23246088%20298.25627206%20224.96489026%20299.54736328%20229.99536133%20C305.16237495%20251.96547398%20305.82248993%20273.53882367%20305.7421875%20296.078125%20C305.74014187%20296.76350719%20305.73809624%20297.44888939%20305.73598862%20298.15504074%20C305.7205019%20302.79365822%20305.68629179%20307.43187676%20305.640625%20312.0703125%20C305.62451424%20313.85470985%20305.62451424%20313.85470985%20305.608078%20315.67515564%20C305.36594682%20332.81199595%20305.36594682%20332.81199595%20302.6171875%20336.640625%20C300.3671875%20338.203125%20300.3671875%20338.203125%20297.9921875%20339.140625%20C295.11225849%20340.14994567%20295.11225849%20340.14994567%20292.3046875%20342.765625%20C289.59418181%20345.01476802%20288.62389226%20345.57979871%20285.3671875%20346.203125%20C285.22023438%20347.11449219%20285.07328125%20348.02585937%20284.921875%20348.96484375%20C282.72831892%20361.6345211%20279.43392815%20374.00290304%20275.3671875%20386.203125%20C274.7071875%20386.203125%20274.0471875%20386.203125%20273.3671875%20386.203125%20C273.2434375%20387.87375%20273.2434375%20387.87375%20273.1171875%20389.578125%20C272.48799724%20394.8182469%20270.48087879%20399.40553734%20268.3671875%20404.203125%20C267.15179092%20400.55693526%20267.70731493%20399.74433232%20269.1171875%20396.265625%20C271.06463699%20391.20225632%20272.45232676%20386.15922013%20273.70703125%20380.88671875%20C274.43428645%20377.93036181%20275.3332248%20375.06640634%20276.3671875%20372.203125%20C277.0271875%20372.203125%20277.6871875%20372.203125%20278.3671875%20372.203125%20C278.41617188%20371.40390625%20278.46515625%20370.6046875%20278.515625%20369.78125%20C278.75598169%20366.25049313%20279.05526262%20362.72825198%20279.3671875%20359.203125%20C279.48126953%20357.57503906%20279.48126953%20357.57503906%20279.59765625%20355.9140625%20C280.19606445%20350.35238632%20280.954837%20346.92178598%20285.1796875%20343.078125%20C288.09922362%20340.90164771%20290.85412338%20339.24754947%20294.3671875%20338.203125%20C295.2953125%20337.831875%20296.2234375%20337.460625%20297.1796875%20337.078125%20C297.9015625%20336.789375%20298.6234375%20336.500625%20299.3671875%20336.203125%20C299.3465625%20335.254375%20299.3259375%20334.305625%20299.3046875%20333.328125%20C299.3046875%20329.5337073%20299.66476723%20325.82107335%20300.06884766%20322.05102539%20C302.13833292%20302.29607811%20302.39809913%20282.24622734%20299.68798828%20262.54101562%20C299.34052923%20260.0088483%20299.0238228%20257.47367687%20298.70703125%20254.9375%20C297.49419603%20245.55874845%20295.86379259%20236.54393017%20293.41015625%20227.40625%20C291.85328103%20221.41352766%20290.82795698%20215.30276155%20289.76196289%20209.20703125%20C289.53174438%20207.92892578%20289.53174438%20207.92892578%20289.296875%20206.625%20C289.16522949%20205.86799805%20289.03358398%20205.11099609%20288.89794922%20204.33105469%20C288.33444808%20202.07186614%20287.43411059%20200.26474543%20286.3671875%20198.203125%20C285.99050406%20196.54571785%20285.64661205%20194.87967229%20285.3671875%20193.203125%20C285.0371875%20193.203125%20284.7071875%20193.203125%20284.3671875%20193.203125%20C283.88758972%20190.97405105%20283.4085267%20188.74486203%20282.9296875%20186.515625%20C282.52943359%20184.65357422%20282.52943359%20184.65357422%20282.12109375%20182.75390625%20C281.51663614%20179.90700485%20280.92954066%20177.05856874%20280.3671875%20174.203125%20C279.7071875%20174.203125%20279.0471875%20174.203125%20278.3671875%20174.203125%20C278.1405542%20173.67356201%20277.9139209%20173.14399902%20277.68041992%20172.59838867%20C276.64588139%20170.19255257%20275.60042653%20167.79161251%20274.5546875%20165.390625%20C274.02004883%20164.14055664%20274.02004883%20164.14055664%20273.47460938%20162.86523438%20C273.12333984%20162.06279297%20272.77207031%20161.26035156%20272.41015625%20160.43359375%20C272.09071045%20159.69520264%20271.77126465%20158.95681152%20271.44213867%20158.19604492%20C270.31826308%20156.11242092%20269.06302297%20154.83316036%20267.3671875%20153.203125%20C266.31343933%20151.2520444%20265.31804547%20149.26886483%20264.3671875%20147.265625%20C262.61736191%20143.58825717%20260.80672185%20140.44857695%20258.3671875%20137.203125%20C258.3671875%20136.543125%20258.3671875%20135.883125%20258.3671875%20135.203125%20C257.7071875%20135.203125%20257.0471875%20135.203125%20256.3671875%20135.203125%20C256.3671875%20134.213125%20256.3671875%20133.223125%20256.3671875%20132.203125%20C255.7071875%20132.203125%20255.0471875%20132.203125%20254.3671875%20132.203125%20C254.0371875%20130.553125%20253.7071875%20128.903125%20253.3671875%20127.203125%20C252.0471875%20127.533125%20250.7271875%20127.863125%20249.3671875%20128.203125%20C249.3671875%20127.543125%20249.3671875%20126.883125%20249.3671875%20126.203125%20C246.3971875%20127.193125%20246.3971875%20127.193125%20243.3671875%20128.203125%20C243.0371875%20127.873125%20242.7071875%20127.543125%20242.3671875%20127.203125%20C240.913125%20128.13125%20240.913125%20128.13125%20239.4296875%20129.078125%20C236.56182877%20130.73846426%20234.0575715%20131.5966551%20230.8046875%20132.203125%20C226.55128503%20133.02081114%20223.92410355%20134.6836428%20220.3671875%20137.203125%20C218.13327788%20138.26454062%20215.86863506%20139.22915907%20213.59375%20140.19921875%20C211.56738138%20141.11286214%20209.70811522%20142.12269923%20207.8046875%20143.265625%20C204.6531682%20145.04193588%20201.6777702%20146.27504788%20198.29296875%20147.484375%20C194.53091824%20148.88846687%20191.21487436%20150.35543814%20188.3671875%20153.203125%20C185.21904358%20154.30844089%20182.06004869%20155.30162358%20178.86523438%20156.25976562%20C175.24432816%20157.39817003%20172.88488574%20158.36975206%20170.3671875%20161.203125%20C168.4296875%20162.08203125%20168.4296875%20162.08203125%20166.3671875%20162.765625%20C163.59146481%20163.69612295%20161.87156847%20164.53353769%20159.3671875%20166.203125%20C157.3671875%20166.86979167%20155.3671875%20167.53645833%20153.3671875%20168.203125%20C150.16168288%20169.64233116%20147.58135767%20171.02643461%20144.8671875%20173.265625%20C141.39495757%20175.9566032%20137.96450128%20176.83614275%20133.71484375%20177.8125%20C127.67328192%20179.27220621%20124.66144453%20180.56068497%20120.3671875%20185.203125%20C118.32046128%20186.14254036%20116.2855662%20186.85762648%20114.13671875%20187.52734375%20C112.15003587%20188.14807523%20112.15003587%20188.14807523%20110.3671875%20190.203125%20C108.52734375%20191.01953125%20108.52734375%20191.01953125%20106.4296875%20191.765625%20C105.74003906%20192.01441406%20105.05039062%20192.26320313%20104.33984375%20192.51953125%20C102.68633391%20193.09252971%20101.02736213%20193.64973346%2099.3671875%20194.203125%20C99.3671875%20194.863125%2099.3671875%20195.523125%2099.3671875%20196.203125%20C98.23796875%20196.6053125%2098.23796875%20196.6053125%2097.0859375%20197.015625%20C89.09712417%20199.96295419%2081.61030352%20203.48239116%2074.03515625%20207.34765625%20C69.88137148%20209.46520989%2065.65402715%20211.3718537%2061.3671875%20213.203125%20C54.94785028%20215.95730362%2054.94785028%20215.95730362%2048.8046875%20219.265625%20C45.71819086%20221.00528674%2042.85946863%20222.17862079%2039.546875%20223.3515625%20C36.16658181%20224.67217883%2032.980833%20226.35016829%2029.76171875%20228.01953125%20C27.3671875%20229.203125%2027.3671875%20229.203125%2024.74609375%20230.22265625%20C22.16115731%20231.17527769%2022.16115731%20231.17527769%2019.4921875%20233.328125%20C15.72013287%20235.59135778%2013.69979125%20235.7545473%209.3671875%20235.203125%20C6.7421875%20233.828125%206.7421875%20233.828125%204.3671875%20232.203125%20C2.7043708%20231.52691287%201.03722014%20230.86131433%20-0.6328125%20230.203125%20C-2.26703628%20229.43067839%20-3.89209365%20228.63856544%20-5.5078125%20227.828125%20C-6.38050781%20227.39113281%20-7.25320313%20226.95414063%20-8.15234375%20226.50390625%20C-10.23067185%20225.41401136%20-12.20497211%20224.25436832%20-14.1953125%20223.015625%20C-17.76240084%20221.1347966%20-20.77712251%20220.35950644%20-24.71484375%20219.6953125%20C-26.6328125%20219.203125%20-26.6328125%20219.203125%20-28.6328125%20217.203125%20C-30.45626077%20216.49400623%20-32.28296281%20215.79213946%20-34.125%20215.1328125%20C-39.02428254%20213.31656757%20-43.81897789%20211.23295859%20-48.6328125%20209.203125%20C-48.6328125%20208.543125%20-48.6328125%20207.883125%20-48.6328125%20207.203125%20C-49.2515625%20207.079375%20-49.8703125%20206.955625%20-50.5078125%20206.828125%20C-52.6328125%20206.203125%20-52.6328125%20206.203125%20-54.6328125%20204.203125%20C-56.36560738%20203.58966909%20-58.11996519%20203.03646625%20-59.8828125%20202.515625%20C-68.7027532%20199.68216579%20-77.20892625%20195.77914436%20-84.6328125%20190.203125%20C-86.26490446%20189.71349741%20-87.89962503%20189.22947671%20-89.55078125%20188.80859375%20C-93.69341661%20187.60388741%20-97.65124101%20185.85343431%20-101.6328125%20184.203125%20C-101.6328125%20183.543125%20-101.6328125%20182.883125%20-101.6328125%20182.203125%20C-102.47005859%20182.04070312%20-102.47005859%20182.04070312%20-103.32421875%20181.875%20C-106.0302118%20181.08746903%20-108.13608376%20179.87339681%20-110.5703125%20178.453125%20C-115.80792528%20175.51752752%20-121.13107522%20173.37810136%20-126.78515625%20171.37890625%20C-129.49569036%20170.25974196%20-131.34766524%20169.00237779%20-133.6328125%20167.203125%20C-135.51804919%20166.24217012%20-135.51804919%20166.24217012%20-137.3828125%20165.515625%20C-138.4553125%20165.0825%20-139.5278125%20164.649375%20-140.6328125%20164.203125%20C-140.6328125%20163.543125%20-140.6328125%20162.883125%20-140.6328125%20162.203125%20C-141.70825317%20162.01411621%20-141.70825317%20162.01411621%20-142.80541992%20161.82128906%20C-147.70769018%20160.74948626%20-152.28089994%20158.77640581%20-156.9453125%20156.953125%20C-157.95271484%20156.57027344%20-158.96011719%20156.18742188%20-159.99804688%20155.79296875%20C-165.31794698%20153.72046044%20-170.16448014%20151.51599833%20-174.88476562%20148.28857422%20C-177.39019427%20146.732829%20-180.04323816%20145.8452443%20-182.8203125%20144.890625%20C-184.6328125%20144.203125%20-184.6328125%20144.203125%20-187.3203125%20142.578125%20C-189.58358294%20141.05229377%20-189.58358294%20141.05229377%20-192.3203125%20140.703125%20C-194.6328125%20140.203125%20-194.6328125%20140.203125%20-196.6328125%20137.203125%20C-199.10437919%20136.11107481%20-199.10437919%20136.11107481%20-201.9453125%20135.265625%20C-206.19904083%20133.81980395%20-209.34799884%20132.37466923%20-212.6328125%20129.203125%20C-216.26763209%20131.33388131%20-217.23032126%20133.5435308%20-218.79125977%20137.35473633%20C-220.07411415%20140.17240112%20-221.86156416%20142.52958142%20-223.6953125%20145.015625%20C-232.95410331%20157.93052034%20-240.58729623%20172.52115691%20-246.6328125%20187.203125%20C-246.96313477%20187.95988525%20-247.29345703%20188.71664551%20-247.63378906%20189.49633789%20C-248.76169999%20192.55233702%20-249.35573886%20195.49254304%20-249.9296875%20198.69921875%20C-250.16324951%20199.96950928%20-250.39681152%20201.2397998%20-250.63745117%20202.54858398%20C-250.75881439%20203.21638885%20-250.88017761%20203.88419373%20-251.00521851%20204.57223511%20C-253.05536874%20215.802578%20-255.41384578%20226.81426548%20-258.58618164%20237.79052734%20C-260.50174571%20244.47302388%20-261.83519256%20251.12059571%20-262.89453125%20257.98828125%20C-263.65156078%20261.28476435%20-264.61402273%20263.49947997%20-266.6328125%20266.203125%20C-267.2928125%20266.203125%20-267.9528125%20266.203125%20-268.6328125%20266.203125%20C-264.27867699%20232.53822361%20-256.78713635%20200.76063367%20-241.6328125%20170.203125%20C-241.2625293%20169.4409668%20-240.89224609%20168.67880859%20-240.51074219%20167.89355469%20C-233.68732959%20153.93577433%20-225.29880066%20141.07706694%20-216.6328125%20128.203125%20C-221.02535023%20126.64040311%20-221.02535023%20126.64040311%20-225.6328125%20126.203125%20C-230.40459271%20130.53236108%20-233.95577705%20135.36232039%20-236.6328125%20141.203125%20C-237.51493414%20142.53051973%20-238.41569384%20143.84559789%20-239.328125%20145.15234375%20C-242.96366235%20150.5493738%20-245.92374888%20156.22760734%20-248.8828125%20162.015625%20C-249.41132813%20163.03849609%20-249.93984375%20164.06136719%20-250.484375%20165.11523438%20C-252.55763772%20169.13283866%20-254.61776182%20173.15597682%20-256.6328125%20177.203125%20C-257.6328125%20174.203125%20-257.6328125%20174.203125%20-256.91113281%20172.12866211%20C-256.51506836%20171.3372583%20-256.11900391%20170.54585449%20-255.7109375%20169.73046875%20C-255.0468689%20168.39471802%20-255.0468689%20168.39471802%20-254.36938477%20167.03198242%20C-253.87881592%20166.07783447%20-253.38824707%20165.12368652%20-252.8828125%20164.140625%20C-252.38128662%20163.15489502%20-251.87976074%20162.16916504%20-251.36303711%20161.15356445%20C-241.2260911%20141.50224155%20-228.98161564%20123.0358386%20-214.6328125%20106.203125%20C-213.72192614%20105.10737736%20-212.8118117%20104.0109877%20-211.90234375%20102.9140625%20C-202.37691071%2091.51289114%20-192.09501806%2080.68225002%20-180.6328125%2071.203125%20C-179.56769494%2070.28907811%20-178.5025923%2069.37501383%20-177.4375%2068.4609375%20C-160.70481556%2054.29943785%20-142.14537173%2042.17817414%20-122.6328125%2032.203125%20C-121.83907227%2031.79400879%20-121.04533203%2031.38489258%20-120.22753906%2030.96337891%20C-100.651255%2020.97587009%20-79.97454661%2013.43696619%20-58.6328125%208.203125%20C-57.91109863%208.02442871%20-57.18938477%207.84573242%20-56.44580078%207.66162109%20C-37.98524368%203.15735909%20-19.0263901%200.09080073%200%200%20Z%20%22%20fill%3D%22%23E76D0A%22%20transform%3D%22translate(407.6328125%2C124.796875)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.47981857%20-0.01058945%201.47981857%20-0.01058945%202.98953247%20-0.02139282%20C43.74789262%20-0.24691352%2043.74789262%20-0.24691352%2061.3671875%203.203125%20C62.47320312%203.41243652%2063.57921875%203.62174805%2064.71875%203.83740234%20C132.81352715%2016.93897099%20198.28215198%2051.77158721%20241.3671875%20107.203125%20C242.90599137%20109.05966824%20244.44770872%20110.91380011%20245.9921875%20112.765625%20C250.05704348%20117.75399387%20253.81432453%20122.83886142%20257.3671875%20128.203125%20C257.77775391%20128.81526855%20258.18832031%20129.42741211%20258.61132812%20130.05810547%20C273.25456882%20152.01772931%20284.61607775%20175.3220376%20293.3671875%20200.203125%20C293.66898926%20201.03900146%20293.97079102%20201.87487793%20294.28173828%20202.73608398%20C295.74331206%20206.89858025%20296.71449161%20210.56835709%20296.8671875%20215.015625%20C297.04785714%20220.23246088%20298.25627206%20224.96489026%20299.54736328%20229.99536133%20C305.16237495%20251.96547398%20305.82248993%20273.53882367%20305.7421875%20296.078125%20C305.74014187%20296.76350719%20305.73809624%20297.44888939%20305.73598862%20298.15504074%20C305.7205019%20302.79365822%20305.68629179%20307.43187676%20305.640625%20312.0703125%20C305.62451424%20313.85470985%20305.62451424%20313.85470985%20305.608078%20315.67515564%20C305.36594682%20332.81199595%20305.36594682%20332.81199595%20302.6171875%20336.640625%20C300.3671875%20338.203125%20300.3671875%20338.203125%20297.9921875%20339.140625%20C295.11225849%20340.14994567%20295.11225849%20340.14994567%20292.3046875%20342.765625%20C289.59418181%20345.01476802%20288.62389226%20345.57979871%20285.3671875%20346.203125%20C285.22023438%20347.11449219%20285.07328125%20348.02585937%20284.921875%20348.96484375%20C282.72831892%20361.6345211%20279.43392815%20374.00290304%20275.3671875%20386.203125%20C274.7071875%20386.203125%20274.0471875%20386.203125%20273.3671875%20386.203125%20C273.2434375%20387.87375%20273.2434375%20387.87375%20273.1171875%20389.578125%20C272.48799724%20394.8182469%20270.48087879%20399.40553734%20268.3671875%20404.203125%20C267.15179092%20400.55693526%20267.70731493%20399.74433232%20269.1171875%20396.265625%20C271.06463699%20391.20225632%20272.45232676%20386.15922013%20273.70703125%20380.88671875%20C274.43428645%20377.93036181%20275.3332248%20375.06640634%20276.3671875%20372.203125%20C277.0271875%20372.203125%20277.6871875%20372.203125%20278.3671875%20372.203125%20C278.41617188%20371.40390625%20278.46515625%20370.6046875%20278.515625%20369.78125%20C278.75598169%20366.25049313%20279.05526262%20362.72825198%20279.3671875%20359.203125%20C279.48126953%20357.57503906%20279.48126953%20357.57503906%20279.59765625%20355.9140625%20C280.19606445%20350.35238632%20280.954837%20346.92178598%20285.1796875%20343.078125%20C288.09922362%20340.90164771%20290.85412338%20339.24754947%20294.3671875%20338.203125%20C295.2953125%20337.831875%20296.2234375%20337.460625%20297.1796875%20337.078125%20C297.9015625%20336.789375%20298.6234375%20336.500625%20299.3671875%20336.203125%20C299.3465625%20335.254375%20299.3259375%20334.305625%20299.3046875%20333.328125%20C299.3046875%20329.5337073%20299.66476723%20325.82107335%20300.06884766%20322.05102539%20C302.13833292%20302.29607811%20302.39809913%20282.24622734%20299.68798828%20262.54101562%20C299.34052923%20260.0088483%20299.0238228%20257.47367687%20298.70703125%20254.9375%20C297.49419603%20245.55874845%20295.86379259%20236.54393017%20293.41015625%20227.40625%20C291.85328103%20221.41352766%20290.82795698%20215.30276155%20289.76196289%20209.20703125%20C289.53174438%20207.92892578%20289.53174438%20207.92892578%20289.296875%20206.625%20C289.16522949%20205.86799805%20289.03358398%20205.11099609%20288.89794922%20204.33105469%20C288.33444808%20202.07186614%20287.43411059%20200.26474543%20286.3671875%20198.203125%20C285.99050406%20196.54571785%20285.64661205%20194.87967229%20285.3671875%20193.203125%20C285.0371875%20193.203125%20284.7071875%20193.203125%20284.3671875%20193.203125%20C283.88758972%20190.97405105%20283.4085267%20188.74486203%20282.9296875%20186.515625%20C282.52943359%20184.65357422%20282.52943359%20184.65357422%20282.12109375%20182.75390625%20C281.51663614%20179.90700485%20280.92954066%20177.05856874%20280.3671875%20174.203125%20C279.7071875%20174.203125%20279.0471875%20174.203125%20278.3671875%20174.203125%20C278.1405542%20173.67356201%20277.9139209%20173.14399902%20277.68041992%20172.59838867%20C276.64588139%20170.19255257%20275.60042653%20167.79161251%20274.5546875%20165.390625%20C274.02004883%20164.14055664%20274.02004883%20164.14055664%20273.47460938%20162.86523438%20C273.12333984%20162.06279297%20272.77207031%20161.26035156%20272.41015625%20160.43359375%20C272.09071045%20159.69520264%20271.77126465%20158.95681152%20271.44213867%20158.19604492%20C270.31826308%20156.11242092%20269.06302297%20154.83316036%20267.3671875%20153.203125%20C266.31343933%20151.2520444%20265.31804547%20149.26886483%20264.3671875%20147.265625%20C262.61736191%20143.58825717%20260.80672185%20140.44857695%20258.3671875%20137.203125%20C258.3671875%20136.543125%20258.3671875%20135.883125%20258.3671875%20135.203125%20C257.7071875%20135.203125%20257.0471875%20135.203125%20256.3671875%20135.203125%20C256.3671875%20134.213125%20256.3671875%20133.223125%20256.3671875%20132.203125%20C255.7071875%20132.203125%20255.0471875%20132.203125%20254.3671875%20132.203125%20C254.0371875%20130.553125%20253.7071875%20128.903125%20253.3671875%20127.203125%20C252.0471875%20127.533125%20250.7271875%20127.863125%20249.3671875%20128.203125%20C249.3671875%20127.543125%20249.3671875%20126.883125%20249.3671875%20126.203125%20C246.3971875%20127.193125%20246.3971875%20127.193125%20243.3671875%20128.203125%20C243.0371875%20127.873125%20242.7071875%20127.543125%20242.3671875%20127.203125%20C241.2534375%20127.88375%20240.1396875%20128.564375%20238.9921875%20129.265625%20C237.09375%20130.42578125%20237.09375%20130.42578125%20235.3671875%20131.203125%20C234.7071875%20130.873125%20234.0471875%20130.543125%20233.3671875%20130.203125%20C234.0271875%20129.543125%20234.6871875%20128.883125%20235.3671875%20128.203125%20C236.29794876%20121.68779621%20233.95801661%20117.41625707%20230.3671875%20112.203125%20C228.01305984%20109.59897786%20228.01305984%20109.59897786%20225.3671875%20107.203125%20C224.27455229%20105.94028029%20223.19207896%20104.66860655%20222.1171875%20103.390625%20C218.83041914%2099.58715943%20215.23423395%2096.31008296%20211.44140625%2093.01953125%20C208.20341918%2090.18400585%20205.23891955%2087.10049623%20202.2421875%2084.015625%20C200.29677032%2082.02656274%20200.29677032%2082.02656274%20197.3671875%2080.203125%20C197.3671875%2079.543125%20197.3671875%2078.883125%20197.3671875%2078.203125%20C196.6040625%2077.935%20195.8409375%2077.666875%20195.0546875%2077.390625%20C192.47730132%2076.25177995%20191.09763886%2075.38895829%20189.3671875%2073.203125%20C189.3671875%2072.543125%20189.3671875%2071.883125%20189.3671875%2071.203125%20C188.7071875%2071.203125%20188.0471875%2071.203125%20187.3671875%2071.203125%20C187.3671875%2070.543125%20187.3671875%2069.883125%20187.3671875%2069.203125%20C185.7171875%2068.873125%20184.0671875%2068.543125%20182.3671875%2068.203125%20C182.3671875%2067.543125%20182.3671875%2066.883125%20182.3671875%2066.203125%20C181.7071875%2065.873125%20181.0471875%2065.543125%20180.3671875%2065.203125%20C180.6971875%2064.873125%20181.0271875%2064.543125%20181.3671875%2064.203125%20C179.3871875%2063.543125%20177.4071875%2062.883125%20175.3671875%2062.203125%20C175.6971875%2061.543125%20176.0271875%2060.883125%20176.3671875%2060.203125%20C173.7271875%2059.543125%20171.0871875%2058.883125%20168.3671875%2058.203125%20C168.3671875%2057.543125%20168.3671875%2056.883125%20168.3671875%2056.203125%20C170.0171875%2056.203125%20171.6671875%2056.203125%20173.3671875%2056.203125%20C170.7271875%2055.543125%20168.0871875%2054.883125%20165.3671875%2054.203125%20C165.3671875%2053.213125%20165.3671875%2052.223125%20165.3671875%2051.203125%20C163.3871875%2051.203125%20161.4071875%2051.203125%20159.3671875%2051.203125%20C159.0371875%2049.553125%20158.7071875%2047.903125%20158.3671875%2046.203125%20C155.0671875%2046.203125%20151.7671875%2046.203125%20148.3671875%2046.203125%20C148.3671875%2045.213125%20148.3671875%2044.223125%20148.3671875%2043.203125%20C150.0171875%2043.203125%20151.6671875%2043.203125%20153.3671875%2043.203125%20C152.7071875%2041.883125%20152.0471875%2040.563125%20151.3671875%2039.203125%20C145.0971875%2038.873125%20138.8271875%2038.543125%20132.3671875%2038.203125%20C132.3671875%2037.543125%20132.3671875%2036.883125%20132.3671875%2036.203125%20C130.3871875%2035.873125%20128.4071875%2035.543125%20126.3671875%2035.203125%20C126.3671875%2034.873125%20126.3671875%2034.543125%20126.3671875%2034.203125%20C125.6246875%2034.079375%20124.8821875%2033.955625%20124.1171875%2033.828125%20C121.51886196%2033.23759647%20119.7242986%2032.39449843%20117.3671875%2031.203125%20C114.41880853%2030.07178266%20111.42318753%2029.0831716%20108.4296875%2028.078125%20C107.23182617%2027.66240234%20107.23182617%2027.66240234%20106.00976562%2027.23828125%20C102.02777424%2025.89885416%2098.630054%2024.80697983%2094.3671875%2025.203125%20C94.3671875%2024.543125%2094.3671875%2023.883125%2094.3671875%2023.203125%20C93.55894531%2023.15414062%2092.75070312%2023.10515625%2091.91796875%2023.0546875%20C90.84933594%2022.97992188%2089.78070313%2022.90515625%2088.6796875%2022.828125%20C87.62394531%2022.75851563%2086.56820313%2022.68890625%2085.48046875%2022.6171875%20C82.45215258%2022.21442525%2080.15521895%2021.4042734%2077.3671875%2020.203125%20C76.7071875%2020.203125%2076.0471875%2020.203125%2075.3671875%2020.203125%20C75.3671875%2019.543125%2075.3671875%2018.883125%2075.3671875%2018.203125%20C74.3771875%2018.203125%2073.3871875%2018.203125%2072.3671875%2018.203125%20C72.3671875%2018.863125%2072.3671875%2019.523125%2072.3671875%2020.203125%20C74.3471875%2021.193125%2074.3471875%2021.193125%2076.3671875%2022.203125%20C72.93093062%2023.34854396%2070.71292872%2023.13752599%2067.1171875%2022.828125%20C66.01890625%2022.73789063%2064.920625%2022.64765625%2063.7890625%2022.5546875%20C60.29659536%2022.19587238%2056.83966562%2021.71956459%2053.3671875%2021.203125%20C52.20058594%2021.038125%2051.03398437%2020.873125%2049.83203125%2020.703125%20C48.66800781%2020.538125%2047.50398438%2020.373125%2046.3046875%2020.203125%20C45.13808594%2020.038125%2043.97148437%2019.873125%2042.76953125%2019.703125%20C40.75100177%2019.40648691%2038.73604725%2019.07827828%2036.73461914%2018.68237305%20C32.4975757%2018.07936309%2028.36012271%2018.04079307%2024.0859375%2018.03515625%20C23.19539673%2018.03182785%2022.30485596%2018.02849945%2021.3873291%2018.02507019%20C19.50464389%2018.02002104%2017.62194979%2018.01766124%2015.73925781%2018.01782227%20C12.90414009%2018.01565327%2010.06942311%2017.99752457%207.234375%2017.97851562%20C-1.91814364%2017.95106772%20-10.70785615%2018.16822493%20-19.74023438%2019.7722168%20C-22.74691385%2020.22012271%20-25.59771058%2020.22553498%20-28.6328125%2020.203125%20C-30.64674348%2020.6436724%20-32.64825675%2021.14496869%20-34.6328125%2021.703125%20C-38.79577608%2022.87395851%20-42.31603784%2023.25831104%20-46.6328125%2023.203125%20C-47.98259099%2023.83583367%20-49.31634131%2024.50374968%20-50.6328125%2025.203125%20C-53.71590046%2025.83232662%20-56.48513856%2026.203125%20-59.6328125%2026.203125%20C-60.2928125%2026.863125%20-60.9528125%2027.523125%20-61.6328125%2028.203125%20C-63.55549028%2028.4020227%20-65.47835037%2028.59941554%20-67.40234375%2028.78515625%20C-70.57239554%2029.37919398%20-73.08830827%2030.77714997%20-75.87109375%2032.36328125%20C-77.6328125%2033.203125%20-77.6328125%2033.203125%20-80.6328125%2033.203125%20C-81.6228125%2033.698125%20-81.6228125%2033.698125%20-82.6328125%2034.203125%20C-84.6328125%2035.203125%20-84.6328125%2035.203125%20-87.6328125%2035.203125%20C-89.55934395%2036.2222806%20-89.55934395%2036.2222806%20-91.5078125%2037.578125%20C-94.46837616%2039.56344416%20-97.31535749%2040.90693375%20-100.6328125%2042.203125%20C-102.59964549%2043.16510462%20-104.55765082%2044.14528274%20-106.5078125%2045.140625%20C-109.75897429%2046.7880391%20-112.94207861%2048.32892816%20-116.3203125%2049.703125%20C-121.35680043%2051.98379878%20-126.36235763%2054.91652946%20-130.28125%2058.86328125%20C-131.6328125%2060.203125%20-131.6328125%2060.203125%20-133.5078125%2060.640625%20C-136.50021546%2061.43273167%20-138.26537085%2063.23988071%20-140.6328125%2065.203125%20C-141.39464844%2065.656875%20-142.15648437%2066.110625%20-142.94140625%2066.578125%20C-157.70498456%2075.4919836%20-171.99095559%2087.79575204%20-183.69921875%20100.43359375%20C-185.6328125%20102.203125%20-185.6328125%20102.203125%20-187.953125%20103.01171875%20C-192.04647272%20104.8316474%20-194.54037955%20107.97598392%20-197.5078125%20111.265625%20C-198.12841553%20111.94085205%20-198.74901855%20112.6160791%20-199.38842773%20113.31176758%20C-203.2408562%20117.54189504%20-206.84351597%20121.88580199%20-210.24609375%20126.48828125%20C-211.6328125%20128.203125%20-211.6328125%20128.203125%20-214.3828125%20130.328125%20C-216.91730191%20132.44019951%20-217.57009092%20134.35625689%20-218.79345703%20137.35253906%20C-220.07267469%20140.17292006%20-221.86105231%20142.5288875%20-223.6953125%20145.015625%20C-232.95410331%20157.93052034%20-240.58729623%20172.52115691%20-246.6328125%20187.203125%20C-246.96313477%20187.95988525%20-247.29345703%20188.71664551%20-247.63378906%20189.49633789%20C-248.76169999%20192.55233702%20-249.35573886%20195.49254304%20-249.9296875%20198.69921875%20C-250.16324951%20199.96950928%20-250.39681152%20201.2397998%20-250.63745117%20202.54858398%20C-250.75881439%20203.21638885%20-250.88017761%20203.88419373%20-251.00521851%20204.57223511%20C-253.05536874%20215.802578%20-255.41384578%20226.81426548%20-258.58618164%20237.79052734%20C-260.50174571%20244.47302388%20-261.83519256%20251.12059571%20-262.89453125%20257.98828125%20C-263.65156078%20261.28476435%20-264.61402273%20263.49947997%20-266.6328125%20266.203125%20C-267.2928125%20266.203125%20-267.9528125%20266.203125%20-268.6328125%20266.203125%20C-264.27867699%20232.53822361%20-256.78713635%20200.76063367%20-241.6328125%20170.203125%20C-241.2625293%20169.4409668%20-240.89224609%20168.67880859%20-240.51074219%20167.89355469%20C-233.68732959%20153.93577433%20-225.29880066%20141.07706694%20-216.6328125%20128.203125%20C-221.02535023%20126.64040311%20-221.02535023%20126.64040311%20-225.6328125%20126.203125%20C-230.40459271%20130.53236108%20-233.95577705%20135.36232039%20-236.6328125%20141.203125%20C-237.51493414%20142.53051973%20-238.41569384%20143.84559789%20-239.328125%20145.15234375%20C-242.96366235%20150.5493738%20-245.92374888%20156.22760734%20-248.8828125%20162.015625%20C-249.41132813%20163.03849609%20-249.93984375%20164.06136719%20-250.484375%20165.11523438%20C-252.55763772%20169.13283866%20-254.61776182%20173.15597682%20-256.6328125%20177.203125%20C-257.6328125%20174.203125%20-257.6328125%20174.203125%20-256.91113281%20172.12866211%20C-256.51506836%20171.3372583%20-256.11900391%20170.54585449%20-255.7109375%20169.73046875%20C-255.0468689%20168.39471802%20-255.0468689%20168.39471802%20-254.36938477%20167.03198242%20C-253.87881592%20166.07783447%20-253.38824707%20165.12368652%20-252.8828125%20164.140625%20C-252.38128662%20163.15489502%20-251.87976074%20162.16916504%20-251.36303711%20161.15356445%20C-241.2260911%20141.50224155%20-228.98161564%20123.0358386%20-214.6328125%20106.203125%20C-213.72192614%20105.10737736%20-212.8118117%20104.0109877%20-211.90234375%20102.9140625%20C-202.37691071%2091.51289114%20-192.09501806%2080.68225002%20-180.6328125%2071.203125%20C-179.56769494%2070.28907811%20-178.5025923%2069.37501383%20-177.4375%2068.4609375%20C-160.70481556%2054.29943785%20-142.14537173%2042.17817414%20-122.6328125%2032.203125%20C-121.83907227%2031.79400879%20-121.04533203%2031.38489258%20-120.22753906%2030.96337891%20C-100.651255%2020.97587009%20-79.97454661%2013.43696619%20-58.6328125%208.203125%20C-57.91109863%208.02442871%20-57.18938477%207.84573242%20-56.44580078%207.66162109%20C-37.98524368%203.15735909%20-19.0263901%200.09080073%200%200%20Z%20M-72.6328125%2020.203125%20C-72.9628125%2020.863125%20-73.2928125%2021.523125%20-73.6328125%2022.203125%20C-72.9728125%2022.203125%20-72.3128125%2022.203125%20-71.6328125%2022.203125%20C-71.9628125%2021.543125%20-72.2928125%2020.883125%20-72.6328125%2020.203125%20Z%20M-77.6328125%2024.203125%20C-77.9628125%2024.863125%20-78.2928125%2025.523125%20-78.6328125%2026.203125%20C-77.6428125%2025.873125%20-76.6528125%2025.543125%20-75.6328125%2025.203125%20C-76.2928125%2024.873125%20-76.9528125%2024.543125%20-77.6328125%2024.203125%20Z%20%22%20fill%3D%22%23803B05%22%20transform%3D%22translate(407.6328125%2C124.796875)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C0.27832031%204.05273438%200.27832031%204.05273438%20-0.921875%206.59375%20C-1.5871521%208.00382324%20-1.5871521%208.00382324%20-2.26586914%209.44238281%20C-2.75563232%2010.45139648%20-3.24539551%2011.46041016%20-3.75%2012.5%20C-4.2442749%2013.52706055%20-4.7385498%2014.55412109%20-5.24780273%2015.61230469%20C-10.43624897%2026.20070279%20-16.46426349%2036.19639523%20-23%2046%20C-23.66%2046%20-24.32%2046%20-25%2046%20C-25.20625%2046.66%20-25.4125%2047.32%20-25.625%2048%20C-27.17458468%2051.38091203%20-29.13606916%2054.00506693%20-31.41015625%2056.9296875%20C-32.93105278%2058.91021616%20-34.34310898%2060.9376731%20-35.75%2063%20C-36.86375%2064.485%20-36.86375%2064.485%20-38%2066%20C-38.66%2066%20-39.32%2066%20-40%2066%20C-40.4021875%2067.2065625%20-40.4021875%2067.2065625%20-40.8125%2068.4375%20C-41.204375%2069.283125%20-41.59625%2070.12875%20-42%2071%20C-42.99%2071.33%20-43.98%2071.66%20-45%2072%20C-45.268125%2072.5775%20-45.53625%2073.155%20-45.8125%2073.75%20C-47.5763914%2077.09211003%20-49.98041507%2078.7353113%20-53%2081%20C-53.66%2081%20-54.32%2081%20-55%2081%20C-55.25789527%2081.5751919%20-55.51579054%2082.1503838%20-55.78150082%2082.74300575%20C-62.00387165%2094.26854091%20-74.89694891%20104.04520838%20-84.06420898%20113.20947266%20C-85.8949791%20115.04323841%20-87.72554515%20116.87720792%20-89.55592346%20118.71136475%20C-93.99087341%20123.15457074%20-98.42854988%20127.59504355%20-102.86734962%20132.03440328%20C-106.47290239%20135.64043286%20-110.07766104%20139.24725441%20-113.68187141%20142.8546257%20C-123.9090659%20153.09060672%20-134.13833353%20163.32450939%20-144.37029826%20173.55572207%20C-144.92026536%20174.10564922%20-145.47023246%20174.65557636%20-146.03686523%20175.22216797%20C-146.58750545%20175.7727673%20-147.13814566%20176.32336663%20-147.70547194%20176.89065079%20C-156.65730663%20185.84207779%20-165.60412416%20194.79850105%20-174.54871988%20203.75716098%20C-183.74128717%20212.96406825%20-192.93755345%20222.16726631%20-202.13772637%20231.36657369%20C-207.29991316%20236.52842808%20-212.46053916%20241.69182125%20-217.61718559%20246.85921097%20C-222.45612185%20251.70816489%20-227.3001548%20256.55197467%20-232.14775658%20261.39226532%20C-233.93055279%20263.17401002%20-235.7116238%20264.95748277%20-237.49088669%20266.74275589%20C-239.90895091%20269.16846229%20-242.33301125%20271.5880078%20-244.7587738%20274.00601196%20C-245.47052543%20274.72290715%20-246.18227705%20275.43980233%20-246.9155969%20276.17842162%20C-247.88511198%20277.1410385%20-247.88511198%20277.1410385%20-248.87421322%20278.12310219%20C-249.71329185%20278.96250688%20-249.71329185%20278.96250688%20-250.56932157%20279.81886923%20C-252%20281%20-252%20281%20-254%20281%20C-254.02705308%20278.58325776%20-254.04686438%20276.1668206%20-254.0625%20273.75%20C-254.07087891%20273.06808594%20-254.07925781%20272.38617187%20-254.08789062%20271.68359375%20C-254.12914302%20263.18560013%20-254.12914302%20263.18560013%20-251.42160696%20260.34268737%20C-250.42892564%20259.53962201%20-250.42892564%20259.53962201%20-249.41619015%20258.7203331%20C-245.17011392%20255.16745023%20-241.24953867%20251.39237888%20-237.34095764%20247.47467041%20C-236.61360002%20246.74957834%20-235.88624239%20246.02448627%20-235.13684362%20245.27742171%20C-232.72045367%20242.86731976%20-230.30760894%20240.45370104%20-227.89477539%20238.04003906%20C-226.15472448%20236.30298287%20-224.41446948%20234.56613112%20-222.67402649%20232.82946777%20C-218.44962296%20228.61296234%20-214.22759642%20224.39409095%20-210.00686104%20220.1739147%20C-206.57296242%20216.74049286%20-203.13827194%20213.30786517%20-199.70303154%20209.87578583%20C-189.94352032%20200.12507125%20-180.18609806%20190.37227321%20-170.43135983%20180.61678365%20C-169.90656236%20180.09194622%20-169.38176488%20179.56710878%20-168.84106445%20179.02636719%20C-168.31561983%20178.50088168%20-167.79017521%20177.97539618%20-167.24880802%20177.43398687%20C-158.73659027%20168.92136283%20-150.21939638%20160.41373705%20-141.69992847%20151.90836957%20C-132.93258821%20143.15542454%20-124.16901434%20134.39872391%20-115.40929979%20125.63814712%20C-110.49919776%20120.72771423%20-105.5875928%20115.8188075%20-100.67192268%20110.91394806%20C-96.04699604%20106.29912837%20-91.42732776%20101.67909076%20-86.81107903%2097.05558777%20C-85.12180212%2095.36526914%20-83.43083575%2093.67663688%20-81.73800659%2091.98987579%20C-73.36216405%2083.64210186%20-65.24187102%2075.36752399%20-58%2066%20C-57.03149715%2064.83160499%20-56.05705098%2063.66808611%20-55.07421875%2062.51171875%20C-54.28660156%2061.57972656%20-53.49898437%2060.64773438%20-52.6875%2059.6875%20C-51.88699219%2058.74261719%20-51.08648438%2057.79773438%20-50.26171875%2056.82421875%20C-47.91106319%2053.9868087%20-47.91106319%2053.9868087%20-45.83203125%2050.64453125%20C-45.22746094%2049.77183594%20-44.62289062%2048.89914062%20-44%2048%20C-43.34%2048%20-42.68%2048%20-42%2048%20C-41.71713135%2047.41839111%20-41.4342627%2046.83678223%20-41.14282227%2046.23754883%20C-40.08071647%2044.15803599%20-38.93965457%2042.1861787%20-37.71484375%2040.19921875%20C-37.048479%2039.11423096%20-37.048479%2039.11423096%20-36.36865234%2038.00732422%20C-35.89637207%2037.24178223%20-35.4240918%2036.47624023%20-34.9375%2035.6875%20C-32.03419688%2030.96758344%20-29.13518152%2026.24685103%20-26.30859375%2021.48046875%20C-25.6909314%2020.43983276%20-25.6909314%2020.43983276%20-25.06079102%2019.37817383%20C-24.28094395%2018.06076696%20-23.50400125%2016.74163575%20-22.73022461%2015.4206543%20C-21.84707315%2013.93081082%20-20.92759767%2012.46258424%20-20%2011%20C-19.67%2011%20-19.34%2011%20-19%2011%20C-18.42630491%2017.90759896%20-19.9080813%2021.56829125%20-23.625%2027.3125%20C-24.54685153%2028.80389793%20-25.46742564%2030.29608621%20-26.38671875%2031.7890625%20C-26.8357959%2032.50739258%20-27.28487305%2033.22572266%20-27.74755859%2033.96582031%20C-31.52316681%2040.09805573%20-34.85042862%2046.52588104%20-38%2053%20C-37.67%2053.33%20-37.34%2053.66%20-37%2054%20C-32.70069084%2050.10375108%20-29.46085754%2045.66677891%20-26.10546875%2040.9453125%20C-24.76151668%2039.06527565%20-23.3913937%2037.20349389%20-21.98828125%2035.3671875%20C-15.35850944%2026.64037588%20-10.46192953%2017.17810246%20-5.75%207.3125%20C-4.12504228%204.23668718%20-2.62415539%202.24927605%200%200%20Z%20%22%20fill%3D%22%232C2C2C%22%20transform%3D%22translate(674%2C529)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.47981857%20-0.01058945%201.47981857%20-0.01058945%202.98953247%20-0.02139282%20C43.74789262%20-0.24691352%2043.74789262%20-0.24691352%2061.3671875%203.203125%20C62.47320312%203.41243652%2063.57921875%203.62174805%2064.71875%203.83740234%20C132.81352715%2016.93897099%20198.28215198%2051.77158721%20241.3671875%20107.203125%20C242.90599137%20109.05966824%20244.44770872%20110.91380011%20245.9921875%20112.765625%20C250.05704348%20117.75399387%20253.81432453%20122.83886142%20257.3671875%20128.203125%20C257.77775391%20128.81526855%20258.18832031%20129.42741211%20258.61132812%20130.05810547%20C273.25456882%20152.01772931%20284.61607775%20175.3220376%20293.3671875%20200.203125%20C293.66898926%20201.03900146%20293.97079102%20201.87487793%20294.28173828%20202.73608398%20C295.74331206%20206.89858025%20296.71449161%20210.56835709%20296.8671875%20215.015625%20C297.04785714%20220.23246088%20298.25627206%20224.96489026%20299.54736328%20229.99536133%20C305.16237495%20251.96547398%20305.82248993%20273.53882367%20305.7421875%20296.078125%20C305.74014187%20296.76350719%20305.73809624%20297.44888939%20305.73598862%20298.15504074%20C305.7205019%20302.79365822%20305.68629179%20307.43187676%20305.640625%20312.0703125%20C305.62451424%20313.85470985%20305.62451424%20313.85470985%20305.608078%20315.67515564%20C305.36594682%20332.81199595%20305.36594682%20332.81199595%20302.6171875%20336.640625%20C300.3671875%20338.203125%20300.3671875%20338.203125%20297.9921875%20339.140625%20C295.11225849%20340.14994567%20295.11225849%20340.14994567%20292.3046875%20342.765625%20C289.59418181%20345.01476802%20288.62389226%20345.57979871%20285.3671875%20346.203125%20C285.22023438%20347.11449219%20285.07328125%20348.02585937%20284.921875%20348.96484375%20C282.72831892%20361.6345211%20279.43392815%20374.00290304%20275.3671875%20386.203125%20C274.7071875%20386.203125%20274.0471875%20386.203125%20273.3671875%20386.203125%20C273.2846875%20387.316875%20273.2021875%20388.430625%20273.1171875%20389.578125%20C272.48799724%20394.8182469%20270.48087879%20399.40553734%20268.3671875%20404.203125%20C267.15179092%20400.55693526%20267.70731493%20399.74433232%20269.1171875%20396.265625%20C271.06463699%20391.20225632%20272.45232676%20386.15922013%20273.70703125%20380.88671875%20C274.43428645%20377.93036181%20275.3332248%20375.06640634%20276.3671875%20372.203125%20C277.0271875%20372.203125%20277.6871875%20372.203125%20278.3671875%20372.203125%20C278.41617187%20371.40390625%20278.46515625%20370.6046875%20278.515625%20369.78125%20C278.75598169%20366.25049313%20279.05526262%20362.72825198%20279.3671875%20359.203125%20C279.48126953%20357.57503906%20279.48126953%20357.57503906%20279.59765625%20355.9140625%20C280.19606445%20350.35238632%20280.954837%20346.92178598%20285.1796875%20343.078125%20C288.09922362%20340.90164771%20290.85412338%20339.24754947%20294.3671875%20338.203125%20C295.2953125%20337.831875%20296.2234375%20337.460625%20297.1796875%20337.078125%20C298.2625%20336.645%20298.2625%20336.645%20299.3671875%20336.203125%20C299.3465625%20335.254375%20299.3259375%20334.305625%20299.3046875%20333.328125%20C299.3046875%20329.5337073%20299.66476723%20325.82107335%20300.06884766%20322.05102539%20C302.13833292%20302.29607811%20302.39809913%20282.24622734%20299.68798828%20262.54101562%20C299.34052923%20260.0088483%20299.0238228%20257.47367687%20298.70703125%20254.9375%20C297.49419603%20245.55874845%20295.86379259%20236.54393017%20293.41015625%20227.40625%20C291.85328103%20221.41352766%20290.82795698%20215.30276155%20289.76196289%20209.20703125%20C289.60848389%20208.35496094%20289.45500488%20207.50289062%20289.296875%20206.625%20C289.16522949%20205.86799805%20289.03358398%20205.11099609%20288.89794922%20204.33105469%20C288.33444808%20202.07186614%20287.43411059%20200.26474543%20286.3671875%20198.203125%20C285.99050406%20196.54571785%20285.64661205%20194.87967229%20285.3671875%20193.203125%20C285.0371875%20193.203125%20284.7071875%20193.203125%20284.3671875%20193.203125%20C283.88758972%20190.97405105%20283.4085267%20188.74486203%20282.9296875%20186.515625%20C282.52943359%20184.65357422%20282.52943359%20184.65357422%20282.12109375%20182.75390625%20C281.51663614%20179.90700485%20280.92954066%20177.05856874%20280.3671875%20174.203125%20C279.7071875%20174.203125%20279.0471875%20174.203125%20278.3671875%20174.203125%20C278.1405542%20173.67356201%20277.9139209%20173.14399902%20277.68041992%20172.59838867%20C276.64588139%20170.19255257%20275.60042653%20167.79161251%20274.5546875%20165.390625%20C274.19826172%20164.55724609%20273.84183594%20163.72386719%20273.47460938%20162.86523438%20C272.94770508%20161.66157227%20272.94770508%20161.66157227%20272.41015625%20160.43359375%20C271.93098755%20159.32600708%20271.93098755%20159.32600708%20271.44213867%20158.19604492%20C270.31826308%20156.11242092%20269.06302297%20154.83316036%20267.3671875%20153.203125%20C266.31343933%20151.2520444%20265.31804547%20149.26886483%20264.3671875%20147.265625%20C262.61736191%20143.58825717%20260.80672185%20140.44857695%20258.3671875%20137.203125%20C258.3671875%20136.543125%20258.3671875%20135.883125%20258.3671875%20135.203125%20C257.7071875%20135.203125%20257.0471875%20135.203125%20256.3671875%20135.203125%20C256.3671875%20134.213125%20256.3671875%20133.223125%20256.3671875%20132.203125%20C255.7071875%20132.203125%20255.0471875%20132.203125%20254.3671875%20132.203125%20C254.0371875%20130.553125%20253.7071875%20128.903125%20253.3671875%20127.203125%20C252.0471875%20127.533125%20250.7271875%20127.863125%20249.3671875%20128.203125%20C249.3671875%20127.543125%20249.3671875%20126.883125%20249.3671875%20126.203125%20C247.3871875%20126.863125%20245.4071875%20127.523125%20243.3671875%20128.203125%20C243.0371875%20127.873125%20242.7071875%20127.543125%20242.3671875%20127.203125%20C241.2534375%20127.88375%20240.1396875%20128.564375%20238.9921875%20129.265625%20C237.09375%20130.42578125%20237.09375%20130.42578125%20235.3671875%20131.203125%20C234.7071875%20130.873125%20234.0471875%20130.543125%20233.3671875%20130.203125%20C234.0271875%20129.543125%20234.6871875%20128.883125%20235.3671875%20128.203125%20C236.29794876%20121.68779621%20233.95801661%20117.41625707%20230.3671875%20112.203125%20C228.01305984%20109.59897786%20228.01305984%20109.59897786%20225.3671875%20107.203125%20C224.27455229%20105.94028029%20223.19207896%20104.66860655%20222.1171875%20103.390625%20C218.83041914%2099.58715943%20215.23423395%2096.31008296%20211.44140625%2093.01953125%20C208.20341918%2090.18400585%20205.23891955%2087.10049623%20202.2421875%2084.015625%20C200.29677032%2082.02656274%20200.29677032%2082.02656274%20197.3671875%2080.203125%20C197.3671875%2079.543125%20197.3671875%2078.883125%20197.3671875%2078.203125%20C196.6040625%2077.935%20195.8409375%2077.666875%20195.0546875%2077.390625%20C192.47730132%2076.25177995%20191.09763886%2075.38895829%20189.3671875%2073.203125%20C189.3671875%2072.543125%20189.3671875%2071.883125%20189.3671875%2071.203125%20C188.7071875%2071.203125%20188.0471875%2071.203125%20187.3671875%2071.203125%20C187.3671875%2070.543125%20187.3671875%2069.883125%20187.3671875%2069.203125%20C185.7171875%2068.873125%20184.0671875%2068.543125%20182.3671875%2068.203125%20C182.3671875%2067.543125%20182.3671875%2066.883125%20182.3671875%2066.203125%20C181.7071875%2065.873125%20181.0471875%2065.543125%20180.3671875%2065.203125%20C180.6971875%2064.873125%20181.0271875%2064.543125%20181.3671875%2064.203125%20C178.3971875%2063.213125%20178.3971875%2063.213125%20175.3671875%2062.203125%20C175.6971875%2061.543125%20176.0271875%2060.883125%20176.3671875%2060.203125%20C173.7271875%2059.543125%20171.0871875%2058.883125%20168.3671875%2058.203125%20C168.3671875%2057.543125%20168.3671875%2056.883125%20168.3671875%2056.203125%20C170.0171875%2056.203125%20171.6671875%2056.203125%20173.3671875%2056.203125%20C170.7271875%2055.543125%20168.0871875%2054.883125%20165.3671875%2054.203125%20C165.3671875%2053.213125%20165.3671875%2052.223125%20165.3671875%2051.203125%20C163.3871875%2051.203125%20161.4071875%2051.203125%20159.3671875%2051.203125%20C159.0371875%2049.553125%20158.7071875%2047.903125%20158.3671875%2046.203125%20C155.0671875%2046.203125%20151.7671875%2046.203125%20148.3671875%2046.203125%20C148.3671875%2045.213125%20148.3671875%2044.223125%20148.3671875%2043.203125%20C150.0171875%2043.203125%20151.6671875%2043.203125%20153.3671875%2043.203125%20C151.56300038%2038.77294825%20149.00601602%2037.41600341%20144.8984375%2035.2421875%20C141.02815676%2033.65346115%20137.53179101%2033.40143945%20133.3671875%2033.203125%20C133.0371875%2031.553125%20132.7071875%2029.903125%20132.3671875%2028.203125%20C131.5421875%2028.120625%20130.7171875%2028.038125%20129.8671875%2027.953125%20C126.3671875%2027.203125%20126.3671875%2027.203125%20123.06640625%2025.46875%20C116.89355896%2022.30645975%20110.25523632%2020.34607472%20103.6796875%2018.203125%20C102.3806848%2017.77396554%20101.0818555%2017.34428088%2099.78320312%2016.9140625%20C95.98353105%2015.65910654%2092.17681892%2014.42754253%2088.3671875%2013.203125%20C87.17222656%2012.81842041%2085.97726562%2012.43371582%2084.74609375%2012.03735352%20C83.616875%2011.68084717%2082.48765625%2011.32434082%2081.32421875%2010.95703125%20C80.33268799%2010.6432251%2079.34115723%2010.32941895%2078.31958008%2010.00610352%20C74.00017531%208.83133114%2069.65860224%208.25454115%2065.22265625%207.703125%20C62.41420394%207.33890829%2059.64482509%206.92850992%2056.85546875%206.453125%20C56.06027832%206.31914307%2055.26508789%206.18516113%2054.44580078%206.04711914%20C52.93135667%205.78966055%2051.41785701%205.52652801%2049.90576172%205.25561523%20C33.94271569%202.59628089%2017.43663787%202.94923184%201.3046875%202.640625%20C-0.83399043%202.59730302%20-2.97266238%202.55368509%20-5.11132812%202.50976562%20C-10.28509391%202.40414932%20-15.45892335%202.30250611%20-20.6328125%202.203125%20C-20.6328125%201.873125%20-20.6328125%201.543125%20-20.6328125%201.203125%20C-13.73896553%200.39879839%20-6.93832427%200.03311216%200%200%20Z%20%22%20fill%3D%22%23281201%22%20transform%3D%22translate(407.6328125%2C124.796875)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-3.39866721%203.82350061%20-7.43530459%206.71296575%20-12%209%20C-12.99%209%20-13.98%209%20-15%209%20C-16.89201175%2010.02117708%20-16.89201175%2010.02117708%20-18.8125%2011.375%20C-22.14450223%2013.54778105%20-25.22156648%2014.74052216%20-29%2016%20C-30.81048575%2017.10640796%20-32.61702305%2018.22025971%20-34.39453125%2019.37890625%20C-38.5355849%2021.95542389%20-42.82150889%2024.27590893%20-47.10107422%2026.61352539%20C-55.31955959%2030.85940802%20-55.31955959%2030.85940802%20-61.375%2037.4375%20C-63.54961586%2040.86670194%20-66.32685472%2042.38218034%20-69.73046875%2044.515625%20C-71.71539082%2045.81385286%20-73.38260558%2047.15319649%20-75.125%2048.75%20C-78%2051%20-78%2051%20-81.75%2052.0625%20C-85.04431167%2052.6195557%20-85.04431167%2052.6195557%20-86.125%2054.8125%20C-86.41375%2055.534375%20-86.7025%2056.25625%20-87%2057%20C-91.53136026%2062.08061605%20-97.45455039%2067.81818346%20-104%2070%20C-104.28746094%2070.58652344%20-104.57492188%2071.17304688%20-104.87109375%2071.77734375%20C-106.39488176%2074.77746617%20-108.50863539%2076.38219646%20-111.0625%2078.5625%20C-116.70591851%2083.57805127%20-121.39709044%2089.00634779%20-126%2095%20C-126.58910156%2095.75796875%20-127.17820313%2096.5159375%20-127.78515625%2097.296875%20C-131.19645117%20101.75586491%20-134.21362231%20106.05255878%20-136.328125%20111.2890625%20C-137.82798982%20114.81592021%20-139.78223415%20117.7211051%20-142.0625%20120.8125%20C-151.32129081%20133.72739534%20-158.95448373%20148.31803191%20-165%20163%20C-165.33032227%20163.75676025%20-165.66064453%20164.51352051%20-166.00097656%20165.29321289%20C-167.12888749%20168.34921202%20-167.72292636%20171.28941804%20-168.296875%20174.49609375%20C-168.53043701%20175.76638428%20-168.76399902%20177.0366748%20-169.00463867%20178.34545898%20C-169.12600189%20179.01326385%20-169.24736511%20179.68106873%20-169.37240601%20180.36911011%20C-171.42255624%20191.599453%20-173.78103328%20202.61114048%20-176.95336914%20213.58740234%20C-178.86893321%20220.26989888%20-180.20238006%20226.91747071%20-181.26171875%20233.78515625%20C-182.01874828%20237.08163935%20-182.98121023%20239.29635497%20-185%20242%20C-185.66%20242%20-186.32%20242%20-187%20242%20C-182.64586449%20208.33509861%20-175.15432385%20176.55750867%20-160%20146%20C-159.6297168%20145.2378418%20-159.25943359%20144.47568359%20-158.87792969%20143.69042969%20C-152.05451709%20129.73264933%20-143.66598816%20116.87394194%20-135%20104%20C-139.39253773%20102.43727811%20-139.39253773%20102.43727811%20-144%20102%20C-148.77178021%20106.32923608%20-152.32296455%20111.15919539%20-155%20117%20C-155.88212164%20118.32739473%20-156.78288134%20119.64247289%20-157.6953125%20120.94921875%20C-161.33084985%20126.3462488%20-164.29093638%20132.02448234%20-167.25%20137.8125%20C-167.77851563%20138.83537109%20-168.30703125%20139.85824219%20-168.8515625%20140.91210938%20C-170.92482522%20144.92971366%20-172.98494932%20148.95285182%20-175%20153%20C-176%20150%20-176%20150%20-175.27832031%20147.92553711%20C-174.88225586%20147.1341333%20-174.48619141%20146.34272949%20-174.078125%20145.52734375%20C-173.4140564%20144.19159302%20-173.4140564%20144.19159302%20-172.73657227%20142.82885742%20C-172.24600342%20141.87470947%20-171.75543457%20140.92056152%20-171.25%20139.9375%20C-170.74847412%20138.95177002%20-170.24694824%20137.96604004%20-169.73022461%20136.95043945%20C-159.5932786%20117.29911655%20-147.34880314%2098.8327136%20-133%2082%20C-132.08911364%2080.90425236%20-131.1789992%2079.8078627%20-130.26953125%2078.7109375%20C-120.74409821%2067.30976614%20-110.46220556%2056.47912502%20-99%2047%20C-97.93488244%2046.08595311%20-96.8697798%2045.17188883%20-95.8046875%2044.2578125%20C-76.30706687%2027.75624344%20-54.47709168%2014.37383114%20-31.5%203.3125%20C-30.77498291%202.96058594%20-30.04996582%202.60867187%20-29.30297852%202.24609375%20C-27.56400419%201.43299043%20-25.78456678%200.70745326%20-24%200%20C-23.01%200.495%20-23.01%200.495%20-22%201%20C-23.15113281%201.59425781%20-24.30226563%202.18851563%20-25.48828125%202.80078125%20C-48.39178415%2014.68633177%20-48.39178415%2014.68633177%20-69.8137207%2029.00390625%20C-73.81524379%2032%20-73.81524379%2032%20-76%2032%20C-76%2032.66%20-76%2033.32%20-76%2034%20C-75.12988281%2033.51080078%20-75.12988281%2033.51080078%20-74.2421875%2033.01171875%20C-69.87452784%2030.56842399%20-65.49738836%2028.1987232%20-61%2026%20C-59.39125%2025.1646875%20-59.39125%2025.1646875%20-57.75%2024.3125%20C-55%2023%20-55%2023%20-53%2023%20C-52.67%2022.01%20-52.34%2021.02%20-52%2020%20C-49.72360408%2018.51158728%20-47.62753547%2017.90591893%20-44.984375%2017.23828125%20C-40.01679263%2015.83473596%20-35.49783153%2013.51253007%20-30.875%2011.25%20C-29.00801257%2010.34984534%20-27.1408253%209.45010505%20-25.2734375%208.55078125%20C-24.37206055%208.11459473%20-23.47068359%207.6784082%20-22.54199219%207.22900391%20C-19.20249417%205.6144214%20-15.85673279%204.01600935%20-12.5%202.4375%20C-11.5409375%201.98246094%20-10.581875%201.52742187%20-9.59375%201.05859375%20C-3.14593698%20-1.57296849%20-3.14593698%20-1.57296849%200%200%20Z%20%22%20fill%3D%22%23663208%22%20transform%3D%22translate(326%2C149)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C0.27832031%204.05273438%200.27832031%204.05273438%20-0.921875%206.59375%20C-1.36523193%207.53371826%20-1.80858887%208.47368652%20-2.26538086%209.44213867%20C-2.75530518%2010.45123291%20-3.24522949%2011.46032715%20-3.75%2012.5%20C-4.49358765%2014.04167847%20-4.49358765%2014.04167847%20-5.25219727%2015.61450195%20C-8.53974693%2022.31243736%20-12.05140391%2028.81824986%20-15.9375%2035.1875%20C-16.38512695%2035.92226563%20-16.83275391%2036.65703125%20-17.29394531%2037.4140625%20C-19.54078287%2040.99681176%20-21.72130155%2044.25948963%20-25%2047%20C-25.66%2047%20-26.32%2047%20-27%2047%20C-27.37125%2047.804375%20-27.37125%2047.804375%20-27.75%2048.625%20C-29.92475988%2052.75704377%20-32.34489748%2057.00946158%20-36%2060%20C-36.66%2060%20-37.32%2060%20-38%2060%20C-38.22945312%2060.71027344%20-38.45890625%2061.42054688%20-38.6953125%2062.15234375%20C-40.2683714%2065.58575674%20-42.29525008%2067.81051159%20-44.875%2070.5625%20C-45.73867188%2071.49191406%20-46.60234375%2072.42132812%20-47.4921875%2073.37890625%20C-48.73355469%2074.67634766%20-48.73355469%2074.67634766%20-50%2076%20C-50.72445312%2076.77214844%20-51.44890625%2077.54429687%20-52.1953125%2078.33984375%20C-54%2080%20-54%2080%20-56%2080%20C-56.20625%2080.5775%20-56.4125%2081.155%20-56.625%2081.75%20C-58%2084%20-58%2084%20-60.59518719%2085.66448593%20C-64.87284998%2088.43106168%20-68.2800651%2092.01369833%20-71.852005%2095.6182251%20C-72.62413383%2096.38935064%20-73.39626266%2097.16047618%20-74.19178933%2097.95496917%20C-76.77366608%20100.53589453%20-79.348332%20103.12389405%20-81.9230957%20105.71191406%20C-83.7741142%20107.56513405%20-85.62558111%20109.41790623%20-87.47746277%20111.27026367%20C-91.46173755%20115.25689686%20-95.44239361%20119.24711372%20-99.42064857%20123.23975372%20C-105.17308193%20129.01288934%20-110.93152733%20134.77999794%20-116.69154193%20140.54556844%20C-126.03807008%20149.90134492%20-135.38048881%20159.26121327%20-144.7199707%20168.62402344%20C-145.27855096%20169.18399701%20-145.83713122%20169.74397058%20-146.41263815%20170.32091305%20C-146.97194264%20170.88161307%20-147.53124714%20171.4423131%20-148.10750026%20172.02000403%20C-156.0479098%20179.98020649%20-163.98930572%20187.93942315%20-171.93188477%20195.89746094%20C-172.49129819%20196.45796521%20-173.05071161%20197.01846949%20-173.62707696%20197.59595874%20C-182.94027591%20206.9271536%20-192.25548825%20216.25633683%20-201.57173795%20225.58448577%20C-207.32015364%20231.34050605%20-213.06647948%20237.09859886%20-218.81014737%20242.85935685%20C-223.20259797%20247.2646976%20-227.59744583%20251.66763915%20-231.99318123%20256.06970215%20C-233.80132857%20257.88133653%20-235.60860294%20259.69384266%20-237.41496658%20261.50725555%20C-239.86868631%20263.97034435%20-242.32540008%20266.43040639%20-244.78291321%20268.88970947%20C-245.50740593%20269.61847927%20-246.23189865%20270.34724907%20-246.97834569%20271.09810281%20C-247.63151492%20271.75051438%20-248.28468414%20272.40292595%20-248.95764637%20273.07510757%20C-249.52511359%20273.64403866%20-250.09258081%20274.21296975%20-250.67724401%20274.79914117%20C-252%20276%20-252%20276%20-253%20276%20C-253.55146384%20272.92571926%20-253.56727964%20270.82202449%20-251.75706899%20268.19891346%20C-249.84095591%20266.08789965%20-247.84898505%20264.08873108%20-245.80705261%20262.09898376%20C-245.03329436%20261.3215101%20-244.25953611%20260.54403643%20-243.46233064%20259.74300295%20C-240.85765777%20257.13311738%20-238.23209829%20254.54530436%20-235.60620117%20251.95678711%20C-233.73785638%20250.09340735%20-231.8707415%20248.22886829%20-230.00511169%20246.36277771%20C-225.98117272%20242.34251498%20-221.94650524%20238.33328573%20-217.90447044%20234.33122063%20C-212.05611167%20228.54048516%20-206.22535048%20222.7322884%20-200.39892534%20216.91949422%20C-190.93991558%20207.48337815%20-181.46831709%20198.06000672%20-171.98803711%20188.64526367%20C-162.78864476%20179.50938546%20-153.59267866%20170.37009174%20-144.40307617%20161.22436523%20C-143.83724322%20160.66123943%20-143.27141027%20160.09811363%20-142.68843087%20159.51792341%20C-136.51090509%20153.36968084%20-130.33478271%20147.22003126%20-124.16033649%20141.06869602%20C-123.61760412%20140.52800041%20-123.07487174%20139.9873048%20-122.51569292%20139.43022447%20C-120.34600246%20137.26863799%20-118.17632764%20135.10703586%20-116.00683276%20132.94525308%20C-109.65529194%20126.61635962%20-103.29941518%20120.29189582%20-96.93561564%20113.97532762%20C-92.9434891%20110.01262159%20-88.95460412%20106.04667396%20-84.9682438%20102.07816737%20C-82.66776069%2099.78832077%20-80.3650261%2097.50081648%20-78.0589447%2095.21660614%20C-75.55933097%2092.74032229%20-73.06591033%2090.25796279%20-70.57389832%2087.77403259%20C-69.84335666%2087.05340934%20-69.11281501%2086.33278609%20-68.36013573%2085.59032577%20C-65.01875588%2082.24753544%20-62.25935921%2079.1966964%20-60%2075%20C-59.34%2074.34%20-58.68%2073.68%20-58%2073%20C-57.67%2072.175%20-57.34%2071.35%20-57%2070.5%20C-56%2068%20-56%2068%20-54%2066%20C-53.71125%2065.236875%20-53.4225%2064.47375%20-53.125%2063.6875%20C-50.63974715%2057.75050709%20-46.43209376%2054.6980349%20-41.21875%2051.234375%20C-38.53235223%2048.52905893%20-37.49239595%2045.92017403%20-36.05371094%2042.4296875%20C-34.33405553%2038.46443944%20-32.10035916%2034.8229262%20-29.875%2031.125%20C-29.43285156%2030.37992188%20-28.99070312%2029.63484375%20-28.53515625%2028.8671875%20C-26.74712403%2025.86372552%20-24.93959466%2022.90939199%20-23%2020%20C-22.34%2020%20-21.68%2020%20-21%2020%20C-20.67%2018.35%20-20.34%2016.7%20-20%2015%20C-19.19568413%2017.30227069%20-18.81680608%2018.52470479%20-19.70922852%2020.84008789%20C-20.28821899%2021.77195923%20-20.28821899%2021.77195923%20-20.87890625%2022.72265625%20C-21.30292725%2023.42092529%20-21.72694824%2024.11919434%20-22.16381836%2024.83862305%20C-22.6253833%2025.57250244%20-23.08694824%2026.30638184%20-23.5625%2027.0625%20C-24.49347303%2028.59036327%20-25.42316168%2030.11900988%20-26.3515625%2031.6484375%20C-26.80692383%2032.3919043%20-27.26228516%2033.13537109%20-27.73144531%2033.90136719%20C-31.46989881%2040.08607587%20-34.83905875%2046.50250965%20-38%2053%20C-37.67%2053.33%20-37.34%2053.66%20-37%2054%20C-32.70069084%2050.10375108%20-29.46085754%2045.66677891%20-26.10546875%2040.9453125%20C-24.76151668%2039.06527565%20-23.3913937%2037.20349389%20-21.98828125%2035.3671875%20C-15.35850944%2026.64037588%20-10.46192953%2017.17810246%20-5.75%207.3125%20C-4.12504228%204.23668718%20-2.62415539%202.24927605%200%200%20Z%20%22%20fill%3D%22%23434343%22%20transform%3D%22translate(674%2C529)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.3271261%203.9813783%201.06915913%207.85045227%201%2012%20C1.66%2012.33%202.32%2012.66%203%2013%20C3%2016.63%203%2020.26%203%2024%20C3.33%2020.37%203.66%2016.74%204%2013%20C6.48769646%2016.73154469%206.27165211%2019.61354397%206.23046875%2023.9296875%20C6.23001053%2024.71586456%206.22955231%2025.50204163%206.2290802%2026.31204224%20C6.22605746%2027.98148094%206.2181705%2029.65091681%206.20581055%2031.3203125%20C6.18781655%2033.8308353%206.18529928%2036.34098261%206.18554688%2038.8515625%20C6.13449916%2064.70610866%206.13449916%2064.70610866%202%2070%20C1.34507223%2072.2181868%201.34507223%2072.2181868%201.0859375%2074.58984375%20C0.90417969%2075.89018555%200.90417969%2075.89018555%200.71875%2077.21679688%20C0.6053125%2078.11462891%200.491875%2079.01246094%200.375%2079.9375%20C0.1337214%2081.71757135%20-0.1084393%2083.4975234%20-0.3515625%2085.27734375%20C-0.4640332%2086.10347168%20-0.57650391%2086.92959961%20-0.69238281%2087.78076172%20C-1.38955479%2092.81035959%20-1.38955479%2092.81035959%20-2%2095%20C-2.99%2095.495%20-2.99%2095.495%20-4%2096%20C-4.54653131%2098.24455389%20-4.54653131%2098.24455389%20-4.875%20100.9375%20C-5.67653122%20105.82242257%20-7.04069561%20109.97992091%20-8.9921875%20114.51171875%20C-10.3479845%20117.85917102%20-11.27624991%20121.28333817%20-12.19140625%20124.7734375%20C-13.10407565%20127.28658514%20-14.2171907%20129.01305223%20-16%20131%20C-16.66%20131%20-17.32%20131%20-18%20131%20C-18.37898437%20131.99773437%20-18.37898437%20131.99773437%20-18.765625%20133.015625%20C-22.82565877%20142.83165602%20-27.73038898%20152.41641782%20-34%20161%20C-34.65097656%20161.90363281%20-35.30195312%20162.80726563%20-35.97265625%20163.73828125%20C-37.34747181%20165.63732555%20-38.73009295%20167.53074755%20-40.12109375%20169.41796875%20C-41.68020433%20171.56053028%20-43.15688296%20173.73296413%20-44.625%20175.9375%20C-47.22710693%20179.29284842%20-49.3747374%20180.89228919%20-53%20183%20C-51.40146817%20173.01366631%20-44.89521114%20164.006148%20-39.75976562%20155.45605469%20C-36.29814208%20149.64565933%20-33.3106558%20143.69871525%20-30.47265625%20137.5625%20C-29%20135%20-29%20135%20-26%20134%20C-25.1456164%20132.07503362%20-25.1456164%20132.07503362%20-24.625%20129.6875%20C-23.22444628%20124.53493657%20-21.30443573%20119.75606723%20-19.20703125%20114.8515625%20C-17.69155464%20111.2713103%20-16.33407306%20107.65114733%20-15%20104%20C-14.34%20104%20-13.68%20104%20-13%20104%20C-12.814375%20102.6696875%20-12.814375%20102.6696875%20-12.625%20101.3125%20C-12%2098%20-12%2098%20-11.09375%2095.90625%20C-9.53484024%2091.76400408%20-8.74709515%2087.51890591%20-7.875%2083.1875%20C-7.69324219%2082.30384766%20-7.51148438%2081.42019531%20-7.32421875%2080.50976562%20C-6.87867164%2078.34065469%20-6.43740023%2076.17076577%20-6%2074%20C-7.65%2073.67%20-9.3%2073.34%20-11%2073%20C-10.85377197%2072.04859131%20-10.70754395%2071.09718262%20-10.55688477%2070.11694336%20C-10.00447013%2066.51144655%20-9.46046153%2062.90471915%20-8.91870117%2059.29760742%20C-8.68523627%2057.75072245%20-8.44963585%2056.20415794%20-8.21166992%2054.65795898%20C-6.34648687%2042.52441091%20-4.73362857%2030.43357544%20-5.125%2018.125%20C-5.20512347%2011.40464375%20-3.0367836%205.90192291%200%200%20Z%20%22%20fill%3D%22%23A6A6A6%22%20transform%3D%22translate(688%2C402)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.495%200.99%200.495%202%201%20C-1.39635165%205.9036083%20-4.80863553%2010.7974534%20-8.3125%2015.625%20C-8.78300781%2016.27726563%20-9.25351562%2016.92953125%20-9.73828125%2017.6015625%20C-10.15464844%2018.06304688%20-10.57101562%2018.52453125%20-11%2019%20C-11.66%2019%20-12.32%2019%20-13%2019%20C-13.268125%2019.804375%20-13.53625%2020.60875%20-13.8125%2021.4375%20C-14.204375%2022.283125%20-14.59625%2023.12875%20-15%2024%20C-15.99%2024.33%20-16.98%2024.66%20-18%2025%20C-18.268125%2025.5775%20-18.53625%2026.155%20-18.8125%2026.75%20C-20.5763914%2030.09211003%20-22.98041507%2031.7353113%20-26%2034%20C-26.66%2034%20-27.32%2034%20-28%2034%20C-28.25789527%2034.5751919%20-28.51579054%2035.1503838%20-28.78150082%2035.74300575%20C-35.00387165%2047.26854091%20-47.89694891%2057.04520838%20-57.06420898%2066.20947266%20C-58.8949791%2068.04323841%20-60.72554515%2069.87720792%20-62.55592346%2071.71136475%20C-66.99087341%2076.15457074%20-71.42854988%2080.59504355%20-75.86734962%2085.03440328%20C-79.47290239%2088.64043286%20-83.07766104%2092.24725441%20-86.68187141%2095.8546257%20C-96.9090659%20106.09060672%20-107.13833353%20116.32450939%20-117.37029826%20126.55572207%20C-117.92026536%20127.10564922%20-118.47023246%20127.65557636%20-119.03686523%20128.22216797%20C-119.58750545%20128.7727673%20-120.13814566%20129.32336663%20-120.70547194%20129.89065079%20C-129.65730663%20138.84207779%20-138.60412416%20147.79850105%20-147.54871988%20156.75716098%20C-156.74128717%20165.96406825%20-165.93755345%20175.16726631%20-175.13772637%20184.36657369%20C-180.29991316%20189.52842808%20-185.46053916%20194.69182125%20-190.61718559%20199.85921097%20C-195.45612185%20204.70816489%20-200.3001548%20209.55197467%20-205.14775658%20214.39226532%20C-206.93055279%20216.17401002%20-208.7116238%20217.95748277%20-210.49088669%20219.74275589%20C-212.90895091%20222.16846229%20-215.33301125%20224.5880078%20-217.7587738%20227.00601196%20C-218.47052543%20227.72290715%20-219.18227705%20228.43980233%20-219.9155969%20229.17842162%20C-220.88511198%20230.1410385%20-220.88511198%20230.1410385%20-221.87421322%20231.12310219%20C-222.71329185%20231.96250688%20-222.71329185%20231.96250688%20-223.56932157%20232.81886923%20C-225%20234%20-225%20234%20-227%20234%20C-227%20229.05%20-227%20224.1%20-227%20219%20C-226.67%20219%20-226.34%20219%20-226%20219%20C-225.67%20221.97%20-225.34%20224.94%20-225%20228%20C-224.02539983%20227.02355624%20-223.05079966%20226.04711248%20-222.04666615%20225.04107952%20C-198.91690664%20201.86801423%20-175.78198829%20178.70011221%20-152.64069529%20155.53856463%20C-149.79305893%20152.68842682%20-146.94546618%20149.83824543%20-144.09790039%20146.98803711%20C-143.53099514%20146.42060723%20-142.96408988%20145.85317736%20-142.38000568%20145.26855264%20C-133.19812308%20136.07796493%20-124.01977947%20126.88385075%20-114.84273646%20117.68843087%20C-105.42776215%20108.25476049%20-96.00900031%2098.8248842%20-86.58670396%2089.39852697%20C-80.77170796%2083.58078531%20-74.95969447%2077.7600965%20-69.15144857%2071.93561564%20C-65.16946592%2067.94306973%20-61.18381376%2063.95421164%20-57.19524655%2059.9682438%20C-54.89339323%2057.66767279%20-52.59375357%2055.36496304%20-50.29735565%2053.0589447%20C-47.80762498%2050.55929414%20-45.31183486%2048.06585541%20-42.81440735%2045.57389832%20C-42.08969138%2044.84335666%20-41.36497541%2044.11281501%20-40.61829835%2043.36013573%20C-37.26250569%2040.02423453%20-34.19396461%2037.27110163%20-30%2035%20C-29.278125%2034.278125%20-28.55625%2033.55625%20-27.8125%2032.8125%20C-27.214375%2032.214375%20-26.61625%2031.61625%20-26%2031%20C-25.34%2031%20-24.68%2031%20-24%2031%20C-23.65388672%2030.19369141%20-23.65388672%2030.19369141%20-23.30078125%2029.37109375%20C-21.61466394%2026.29760064%20-19.44388073%2023.72429818%20-17.1875%2021.0625%20C-16.76146484%2020.55009766%20-16.33542969%2020.03769531%20-15.89648438%2019.50976562%20C-13.82636852%2017.04504372%20-11.70797361%2014.71238489%20-9.4140625%2012.453125%20C-7.00585848%2010.00595328%20-5.11546123%207.5227371%20-3.1875%204.6875%20C-2.58292969%203.80449219%20-1.97835937%202.92148437%20-1.35546875%202.01171875%20C-0.90816406%201.34785156%20-0.46085938%200.68398438%200%200%20Z%20%22%20fill%3D%22%23202020%22%20transform%3D%22translate(647%2C576)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.8125%201.5%201.8125%201.5%203%203%20C3%203.66%203%204.32%203%205%20C3.55816406%205.08636719%204.11632812%205.17273438%204.69140625%205.26171875%20C7.68792262%206.21999556%209.52171096%207.80616673%2011.9375%209.8125%20C12.77152344%2010.49957031%2013.60554687%2011.18664062%2014.46484375%2011.89453125%20C15.30144531%2012.58933594%2016.13804687%2013.28414062%2017%2014%20C20.17688918%2016.8605121%2020.17688918%2016.8605121%2024%2018.4375%20C27.1349991%2019.3192185%2028.74735613%2021.69542197%2031%2024%20C36.34501405%2028.97448948%2041.74740177%2033.88724178%2047.3671875%2038.55078125%20C49.6784106%2040.60212998%2051.82332418%2042.80698277%2054%2045%20C54.77859375%2045.75539062%2055.5571875%2046.51078125%2056.359375%2047.2890625%20C62.39432481%2053.1859579%2067.75191752%2059.4024106%2073%2066%20C73.78375%2066.928125%2074.5675%2067.85625%2075.375%2068.8125%20C76.1175%2069.699375%2076.86%2070.58625%2077.625%2071.5%20C78.29789063%2072.2940625%2078.97078125%2073.088125%2079.6640625%2073.90625%20C80.10492187%2074.5971875%2080.54578125%2075.288125%2081%2076%20C80%2079%2080%2079%2077.890625%2080.31640625%20C77.01921875%2080.72761719%2076.1478125%2081.13882813%2075.25%2081.5625%20C74.38890625%2081.97628906%2073.5278125%2082.39007813%2072.640625%2082.81640625%20C70.11729029%2083.94742758%2067.57571207%2084.99473108%2065%2086%20C65.99%2084.515%2065.99%2084.515%2067%2083%20C67.91312777%2076.47765877%2065.59803156%2072.22358851%2062%2067%20C59.64587234%2064.39585286%2059.64587234%2064.39585286%2057%2062%20C55.90736479%2060.73715529%2054.82489146%2059.46548155%2053.75%2058.1875%20C50.46323164%2054.38403443%2046.86704645%2051.10695796%2043.07421875%2047.81640625%20C39.83623168%2044.98088085%2036.87173205%2041.89737123%2033.875%2038.8125%20C31.92958282%2036.82343774%2031.92958282%2036.82343774%2029%2035%20C29%2034.34%2029%2033.68%2029%2033%20C28.236875%2032.731875%2027.47375%2032.46375%2026.6875%2032.1875%20C24.11011382%2031.04865495%2022.73045136%2030.18583329%2021%2028%20C21%2027.34%2021%2026.68%2021%2026%20C20.34%2026%2019.68%2026%2019%2026%20C19%2025.34%2019%2024.68%2019%2024%20C17.35%2023.67%2015.7%2023.34%2014%2023%20C14%2022.34%2014%2021.68%2014%2021%20C13.34%2020.67%2012.68%2020.34%2012%2020%20C12.495%2019.505%2012.495%2019.505%2013%2019%20C11.02%2018.34%209.04%2017.68%207%2017%20C7.33%2016.34%207.66%2015.68%208%2015%20C5.36%2014.34%202.72%2013.68%200%2013%20C0%2012.34%200%2011.68%200%2011%20C1.65%2011%203.3%2011%205%2011%20C2.36%2010.34%20-0.28%209.68%20-3%209%20C-3%208.01%20-3%207.02%20-3%206%20C-4.98%206%20-6.96%206%20-9%206%20C-9.33%204.35%20-9.66%202.7%20-10%201%20C-13.3%201%20-16.6%201%20-20%201%20C-20%200.01%20-20%20-0.98%20-20%20-2%20C-13.75510634%20-3.8734681%20-5.73272581%20-3.12694135%200%200%20Z%20%22%20fill%3D%22%237C3A05%22%20transform%3D%22translate(576%2C170)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.71193291%200.00068733%201.71193291%200.00068733%203.45845032%200.00138855%20C5.85764616%200.00438914%208.25684044%200.01220886%2010.65600586%200.0246582%20C14.27399836%200.0428342%2017.89173231%200.04516785%2021.50976562%200.04492188%20C52.89211127%200.09210932%2052.89211127%200.09210932%2064.61328125%202.23046875%20C64.61328125%202.89046875%2064.61328125%203.55046875%2064.61328125%204.23046875%20C63.60208725%204.23926811%2063.60208725%204.23926811%2062.57046509%204.24824524%20C55.46306057%204.3128906%2048.3560796%204.39747932%2041.24902344%204.49291992%20C38.60738743%204.52741965%2035.96601977%204.55399946%2033.32421875%204.5769043%20C18.42504023%204.70952956%204.2275587%205.31622285%20-10.38671875%208.23046875%20C-13.54744016%208.66719294%20-16.70989424%208.99939061%20-19.88671875%209.29296875%20C-29.70805505%2010.21485998%20-38.92329265%2012.25654748%20-48.32421875%2015.23046875%20C-54.56042384%2017.16427397%20-60.61704179%2018.74429789%20-67.078125%2019.7421875%20C-70.35583656%2020.43544291%20-73.18719116%2021.76900379%20-76.19140625%2023.22265625%20C-79.1300648%2024.57172014%20-82.15119501%2025.49913667%20-85.24609375%2026.421875%20C-87.47264542%2027.19009472%20-87.47264542%2027.19009472%20-89.65698242%2028.59375%20C-92.45275472%2030.27006317%20-95.29433314%2031.75580918%20-98.203125%2033.2265625%20C-99.29689453%2033.78537109%20-100.39066406%2034.34417969%20-101.51757812%2034.91992188%20C-103.80686494%2036.08606399%20-106.09854435%2037.24752091%20-108.39257812%2038.40429688%20C-109.48505859%2038.96439453%20-110.57753906%2039.52449219%20-111.703125%2040.1015625%20C-112.69771729%2040.6061499%20-113.69230957%2041.1107373%20-114.71704102%2041.63061523%20C-117.3944471%2043.2351001%20-119.24080534%2044.98654699%20-121.38671875%2047.23046875%20C-123.02706068%2047.95950961%20-124.69973793%2048.61702118%20-126.38671875%2049.23046875%20C-130.01951602%2050.90547108%20-133.50261329%2052.56141597%20-136.69921875%2054.98046875%20C-138.38671875%2056.23046875%20-138.38671875%2056.23046875%20-141.38671875%2056.23046875%20C-141.38671875%2055.57046875%20-141.38671875%2054.91046875%20-141.38671875%2054.23046875%20C-139.74462891%2052.87695312%20-139.74462891%2052.87695312%20-137.42578125%2051.32421875%20C-136.57056885%2050.75002197%20-135.71535645%2050.1758252%20-134.83422852%2049.58422852%20C-133.90280029%2048.97248779%20-132.97137207%2048.36074707%20-132.01171875%2047.73046875%20C-130.58653931%2046.78868774%20-130.58653931%2046.78868774%20-129.13256836%2045.82788086%20C-116.93765654%2037.86089079%20-104.25481555%2030.9606622%20-91.109375%2024.703125%20C-88.44505078%2023.45175815%20-88.44505078%2023.45175815%20-87.03710938%2021.76879883%20C-84.93260545%2019.80718948%20-82.96244611%2019.11632704%20-80.2578125%2018.14453125%20C-79.23179932%2017.77352295%20-78.20578613%2017.40251465%20-77.14868164%2017.02026367%20C-75.50307251%2016.44369019%20-75.50307251%2016.44369019%20-73.82421875%2015.85546875%20C-72.69685303%2015.45626221%20-71.5694873%2015.05705566%20-70.40795898%2014.64575195%20C-48.02063681%206.82267874%20-23.85074445%20-0.16078141%200%200%20Z%20%22%20fill%3D%22%23966E4D%22%20transform%3D%22translate(391.38671875%2C126.76953125)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-0.33%200.66%20-0.66%201.32%20-1%202%20C-1.66%202%20-2.32%202%20-3%202%20C-3.30744141%202.93779297%20-3.30744141%202.93779297%20-3.62109375%203.89453125%20C-5.60811654%206.92854056%20-7.57631886%206.91687048%20-11.0625%207.6875%20C-17.57116717%209.45866385%20-20.83959056%2012.12879552%20-25.09765625%2017.26953125%20C-26.03931641%2018.12611328%20-26.03931641%2018.12611328%20-27%2019%20C-29.109375%2018.65625%20-29.109375%2018.65625%20-31%2018%20C-32.68996005%2019.30368347%20-34.35135455%2020.64444707%20-36%2022%20C-38.09962967%2023.04981484%20-40.23999553%2023.9499689%20-42.40234375%2024.86328125%20C-46.4214103%2026.6220006%20-50.30293571%2028.64575186%20-54.21484375%2030.62890625%20C-56.3324393%2031.67136914%20-58.50117993%2032.61064946%20-60.6875%2033.5%20C-65.72398793%2035.78067378%20-70.72954513%2038.71340446%20-74.6484375%2042.66015625%20C-76%2044%20-76%2044%20-77.875%2044.4375%20C-80.86740296%2045.22960667%20-82.63255835%2047.03675571%20-85%2049%20C-85.76183594%2049.45375%20-86.52367187%2049.9075%20-87.30859375%2050.375%20C-102.07217206%2059.2888586%20-116.35814309%2071.59262704%20-128.06640625%2084.23046875%20C-130%2086%20-130%2086%20-132.3203125%2086.80859375%20C-136.41374609%2088.62856058%20-138.90736304%2091.77294581%20-141.875%2095.0625%20C-142.80372925%2096.07207764%20-142.80372925%2096.07207764%20-143.7512207%2097.10205078%20C-147.64511869%20101.37482837%20-151.31886196%20105.74214323%20-154.66796875%20110.4609375%20C-156%20112%20-156%20112%20-159%20113%20C-155.89219226%20104.02900859%20-148.07433253%2096.97746986%20-141.75%2090.0625%20C-141.25516113%2089.51916016%20-140.76032227%2088.97582031%20-140.25048828%2088.41601562%20C-137.3613545%2085.29881788%20-134.35672143%2082.59930736%20-131%2080%20C-129.8553125%2078.824375%20-129.8553125%2078.824375%20-128.6875%2077.625%20C-126.51144353%2075.49954949%20-124.43931103%2073.78486173%20-122%2072%20C-117.69187446%2068.83963023%20-114.13560574%2065.22077617%20-110.5%2061.3125%20C-108%2059%20-108%2059%20-105.7265625%2058.1328125%20C-102.3444344%2056.72763034%20-99.78384639%2054.78240909%20-96.875%2052.5625%20C-95.84117187%2051.78003906%20-94.80734375%2050.99757812%20-93.7421875%2050.19140625%20C-90.79760762%2047.83825908%20-88.35062014%2045.37725736%20-85.7890625%2042.62109375%20C-82.54998395%2039.57708576%20-79.16136009%2037.35960946%20-75.375%2035.0625%20C-74.67076904%2034.629375%20-73.96653809%2034.19625%20-73.2409668%2033.75%20C-59.60254074%2025.42308763%20-59.60254074%2025.42308763%20-53.48828125%2023.0078125%20C-50.157633%2021.65882153%20-47.17481789%2019.84724742%20-44.0859375%2018.0234375%20C-42%2017%20-42%2017%20-39%2017%20C-36.77275128%2015.72011641%20-36.77275128%2015.72011641%20-34.5%2014.0625%20C-31.9142008%2012.23951157%20-30.02125069%2011.00708356%20-27%2010%20C-27.33%209.34%20-27.66%208.68%20-28%208%20C-34.50062114%2010.0230027%20-40.68185046%2012.49210622%20-46.875%2015.3125%20C-47.74833984%2015.70550293%20-48.62167969%2016.09850586%20-49.52148438%2016.50341797%20C-55.18287452%2019.08050802%20-60.60108395%2021.84611969%20-65.90625%2025.1015625%20C-68.44195733%2026.18964587%20-69.42488547%2025.76621093%20-72%2025%20C-66.43423886%2022.05599176%20-60.86296181%2019.1227429%20-55.28564453%2016.20068359%20C-53.49806192%2015.26163945%20-51.71494561%2014.31409199%20-49.93359375%2013.36328125%20C-44.66632402%2010.61249953%20-39.34068782%208.65443488%20-33.6640625%206.89453125%20C-31.05951823%206.1005799%20-31.05951823%206.1005799%20-29.01953125%204.94921875%20C-26.39783881%203.71697259%20-23.92607322%203.40443909%20-21.0625%203%20C-17.05254193%202.43221833%20-13.73587344%201.53722006%20-10%200%20C-2.92993631%20-1.46496815%20-2.92993631%20-1.46496815%200%200%20Z%20M-17%204%20C-17.33%204.66%20-17.66%205.32%20-18%206%20C-17.34%206%20-16.68%206%20-16%206%20C-16.33%205.34%20-16.66%204.68%20-17%204%20Z%20M-22%208%20C-22.33%208.66%20-22.66%209.32%20-23%2010%20C-22.01%209.67%20-21.02%209.34%20-20%209%20C-20.66%208.67%20-21.32%208.34%20-22%208%20Z%20%22%20fill%3D%22%238A430A%22%20transform%3D%22translate(352%2C141)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.53398049%203.07455689%203.96293359%206.04527132%205.375%209.76171875%20C5.80296875%2010.88126953%206.2309375%2012.00082031%206.671875%2013.15429688%20C7.32929687%2014.90323242%207.32929687%2014.90323242%208%2016.6875%20C8.65742187%2018.40743164%208.65742187%2018.40743164%209.328125%2020.16210938%20C15.97036396%2037.63800014%2015.97036396%2037.63800014%2017%2044.0625%20C17.73728059%2048.44992384%2018.5337924%2052.81864763%2019.375%2057.1875%20C19.61854916%2058.514148%2019.86108246%2059.84098275%2020.1027832%2061.16796875%20C20.70415541%2064.45593374%2021.35289069%2067.73073605%2022.02270508%2071.00537109%20C25.17329004%2087.15716879%2025.52549066%20102.99926207%2025.33294678%20119.40063477%20C25.30536337%20122.14843613%2025.29707323%20124.89615402%2025.28938007%20127.64407253%20C25.27937475%20130.96980202%2025.25918288%20134.29541336%2025.23828125%20137.62109375%20C25.23089432%20138.83365341%2025.22350739%20140.04621307%2025.21589661%20141.29551697%20C25.02185949%20158.57669571%2025.02185949%20158.57669571%2022.25%20162.4375%20C20%20164%2020%20164%2017.625%20164.9375%20C14.74507099%20165.94682067%2014.74507099%20165.94682067%2011.9375%20168.5625%20C9.22699431%20170.81164302%208.25670476%20171.37667371%205%20172%20C4.85304688%20172.91136719%204.70609375%20173.82273437%204.5546875%20174.76171875%20C2.36113142%20187.4313961%20-0.93325935%20199.79977804%20-5%20212%20C-5.66%20212%20-6.32%20212%20-7%20212%20C-7.0825%20213.11375%20-7.165%20214.2275%20-7.25%20215.375%20C-7.87919026%20220.6151219%20-9.88630871%20225.20241234%20-12%20230%20C-13.21539658%20226.35381026%20-12.65987257%20225.54120732%20-11.25%20222.0625%20C-9.30255051%20216.99913132%20-7.91486074%20211.95609513%20-6.66015625%20206.68359375%20C-5.93290105%20203.72723681%20-5.0339627%20200.86328134%20-4%20198%20C-3.34%20198%20-2.68%20198%20-2%20198%20C-1.95101562%20197.20078125%20-1.90203125%20196.4015625%20-1.8515625%20195.578125%20C-1.61120581%20192.04736813%20-1.31192488%20188.52512698%20-1%20185%20C-0.92394531%20183.91460937%20-0.84789062%20182.82921875%20-0.76953125%20181.7109375%20C-0.17112305%20176.14926132%200.5876495%20172.71866098%204.8125%20168.875%20C7.73203612%20166.69852271%2010.48693588%20165.04442447%2014%20164%20C15.3921875%20163.443125%2015.3921875%20163.443125%2016.8125%20162.875%20C17.8953125%20162.441875%2017.8953125%20162.441875%2019%20162%20C18.979375%20161.05125%2018.95875%20160.1025%2018.9375%20159.125%20C18.9375%20155.3305823%2019.29757973%20151.61794835%2019.70166016%20147.84790039%20C21.77114542%20128.09295311%2022.03091163%20108.04310234%2019.32080078%2088.33789062%20C18.97334173%2085.8057233%2018.6566353%2083.27055187%2018.33984375%2080.734375%20C17.12700853%2071.35562345%2015.49660509%2062.34080517%2013.04296875%2053.203125%20C11.48609353%2047.21040266%2010.46076948%2041.09963655%209.39477539%2035.00390625%20C9.24129639%2034.15183594%209.08781738%2033.29976563%208.9296875%2032.421875%20C8.79804199%2031.66487305%208.66639648%2030.90787109%208.53076172%2030.12792969%20C7.96726058%2027.86874114%207.06692309%2026.06162043%206%2024%20C5.62331656%2022.34259285%205.27942455%2020.67654729%205%2019%20C4.67%2019%204.34%2019%204%2019%20C3.52040222%2016.77092605%203.0413392%2014.54173703%202.5625%2012.3125%20C2.29566406%2011.07113281%202.02882813%209.82976562%201.75390625%208.55078125%20C1.14944864%205.70387985%200.56235316%202.85544374%200%200%20Z%20%22%20fill%3D%22%234E4E4E%22%20transform%3D%22translate(688%2C299)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C3.38065149%20-0.01623768%206.45097596%200.01447008%209.72642517%200.89242554%20C13.17274839%201.74966224%2016.51133406%202.24574862%2020.03892517%202.64242554%20C30.21758718%204.1392876%2039.90780163%207.79699483%2049.63267517%2011.0496521%20C52.1171225%2011.87696638%2054.60602453%2012.68488939%2057.10142517%2013.47836304%20C63.72592195%2015.59895498%2070.08788827%2017.99541393%2076.36705017%2021.00180054%20C78.6372545%2022.11431658%2078.6372545%2022.11431658%2081.53892517%2023.01742554%20C82.22642517%2025.07992554%2082.22642517%2025.07992554%2082.53892517%2027.01742554%20C78.5767362%2027.26418108%2076.18724195%2026.61353606%2072.66392517%2024.82992554%20C61.52217552%2019.58242603%2049.78621365%2016.4570305%2037.91392517%2013.32992554%20C36.79437439%2013.03231323%2035.67482361%2012.73470093%2034.52134705%2012.42807007%20C27.9488537%2010.73296743%2021.42956906%209.42924472%2014.70982361%208.47470093%20C11.63665105%208.03151859%208.5879841%207.50588664%205.53111267%206.96273804%20C-0.73597808%205.91101936%20-7.00091572%205.35024712%20-13.33607483%204.89242554%20C-14.4801178%204.80823364%20-15.62416077%204.72404175%20-16.8028717%204.63729858%20C-37.93568326%203.15337108%20-61.94552908%202.43642122%20-82.02357483%2010.07992554%20C-86.5756237%2011.80457504%20-90.61634726%2012.65178572%20-95.46107483%2013.01742554%20C-95.46107483%2011.35075887%20-95.46107483%209.6840922%20-95.46107483%208.01742554%20C-94.36794983%207.89367554%20-93.27482483%207.76992554%20-92.14857483%207.64242554%20C-88.38725681%207.26277753%20-88.38725681%207.26277753%20-85.46107483%205.01742554%20C-67.3831784%200.35343922%20-48.36481456%200.37116718%20-29.83607483%200.26742554%20C-27.27615992%200.23915534%20-24.71626291%200.20921337%20-22.15638733%200.17758179%20C-14.77093938%200.09179892%20-7.38568677%200.05229405%200%200%20Z%20%22%20fill%3D%22%236D3407%22%20transform%3D%22translate(458.46107482910156%2C129.98257446289063)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.475%201.485%202.475%201.485%205%203%20C4.50848186%207.68990223%203.37299229%2010.34762678%200.5%2014.0625%20C-2.1477873%2017.49702738%20-3.23241035%2019.77186033%20-4%2024%20C-5.80726219%2028.06633992%20-7.88511951%2031.99414366%20-9.93798828%2035.94091797%20C-11.03988114%2038.07732358%20-12.11256425%2040.22688198%20-13.18359375%2042.37890625%20C-17.28895715%2050.51716968%20-21.37220323%2057.59927978%20-28%2064%20C-29.07314453%2065.10408203%20-29.07314453%2065.10408203%20-30.16796875%2066.23046875%20C-32%2068%20-32%2068%20-33%2068%20C-33.72345277%2057.14820842%20-29.27998505%2047.79955967%20-24.25%2038.4375%20C-23.74984375%2037.47392578%20-23.2496875%2036.51035156%20-22.734375%2035.51757812%20C-19.27735367%2028.97834008%20-15.33718208%2022.98281142%20-11%2017%20C-9.89140869%2015.39888787%20-8.78659558%2013.79514537%20-7.6875%2012.1875%20C-6.98173828%2011.15689453%20-6.98173828%2011.15689453%20-6.26171875%2010.10546875%20C-4.88908429%207.81491156%20-3.98371967%205.47782111%20-3%203%20C-1.375%201.1875%20-1.375%201.1875%200%200%20Z%20%22%20fill%3D%22%23A0A0A0%22%20transform%3D%22translate(194%2C253)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.3271261%203.9813783%201.06915913%207.85045227%201%2012%20C1.66%2012.33%202.32%2012.66%203%2013%20C3%2016.63%203%2020.26%203%2024%20C3.33%2020.37%203.66%2016.74%204%2013%20C6.48769646%2016.73154469%206.27165211%2019.61354397%206.23046875%2023.9296875%20C6.22978142%2025.10895309%206.22978142%2025.10895309%206.2290802%2026.31204224%20C6.22605746%2027.98148094%206.2181705%2029.65091681%206.20581055%2031.3203125%20C6.18781655%2033.8308353%206.18529928%2036.34098261%206.18554688%2038.8515625%20C6.13548781%2064.36647814%206.13548781%2064.36647814%203.51269531%2068.13964844%20C-0.2269066%2071.81681216%20-3.86405077%2072.79036942%20-9%2073%20C-8.88353525%2071.33271516%20-8.75630239%2069.666182%20-8.625%2068%20C-8.55539062%2067.071875%20-8.48578125%2066.14375%20-8.4140625%2065.1875%20C-8%2062%20-8%2062%20-7.04101562%2058.29516602%20C-6.01511701%2054.26100974%20-5.40061806%2050.22254671%20-4.9296875%2046.08984375%20C-4.84373322%2045.35987686%20-4.75777893%2044.62990997%20-4.66921997%2043.87782288%20C-4.4901306%2042.34114599%20-4.31380446%2040.80414475%20-4.14013672%2039.2668457%20C-3.87827809%2036.96629946%20-3.6017879%2034.66783722%20-3.32421875%2032.36914062%20C-2.33214447%2023.86151489%20-1.83912233%2015.60662106%20-2.12939453%207.04125977%20C-2.00246335%204.0578981%20-1.57240779%202.49457464%200%200%20Z%20%22%20fill%3D%22%23D4D4D4%22%20transform%3D%22translate(688%2C402)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.50282081%200.25845968%202.50282081%200.25845968%204.43188477%20-0.41772461%20C7.15600946%20-0.9967582%209.18038481%20-0.63011912%2011.91796875%20-0.13671875%20C12.92923828%200.04246094%2013.94050781%200.22164062%2014.98242188%200.40625%20C16.03236328%200.60089844%2017.08230469%200.79554688%2018.1640625%200.99609375%20C19.21787109%201.18300781%2020.27167969%201.36992187%2021.35742188%201.5625%20C29.11278823%202.95816899%2029.11278823%202.95816899%2032.6015625%204.12109375%20C32.6015625%205.11109375%2032.6015625%206.10109375%2032.6015625%207.12109375%20C33.9215625%207.78109375%2035.2415625%208.44109375%2036.6015625%209.12109375%20C33.16530562%2010.26651271%2030.94730372%2010.05549474%2027.3515625%209.74609375%20C26.25328125%209.65585938%2025.155%209.565625%2024.0234375%209.47265625%20C20.53097036%209.11384113%2017.07404062%208.63753334%2013.6015625%208.12109375%20C12.43496094%207.95609375%2011.26835937%207.79109375%2010.06640625%207.62109375%20C8.90238281%207.45609375%207.73835938%207.29109375%206.5390625%207.12109375%20C5.37246094%206.95609375%204.20585937%206.79109375%203.00390625%206.62109375%20C0.98537677%206.32445566%20-1.02957775%205.99624703%20-3.03100586%205.6003418%20C-7.2680493%204.99733184%20-11.40550229%204.95876182%20-15.6796875%204.953125%20C-16.57022827%204.9497966%20-17.46076904%204.9464682%20-18.3782959%204.94303894%20C-20.26098111%204.93798979%20-22.14367521%204.93562999%20-24.02636719%204.93579102%20C-26.86148491%204.93362202%20-29.69620189%204.91549332%20-32.53125%204.89648438%20C-41.68376864%204.86903647%20-50.47348115%205.08619368%20-59.50585938%206.69018555%20C-62.51253885%207.13809146%20-65.36333558%207.14350373%20-68.3984375%207.12109375%20C-70.41236848%207.56164115%20-72.41388175%208.06293744%20-74.3984375%208.62109375%20C-78.56289829%209.79234835%20-82.08111282%2010.16987708%20-86.3984375%2010.12109375%20C-88.59911171%2011.05392671%20-88.59911171%2011.05392671%20-90.3984375%2012.12109375%20C-91.0584375%2012.12109375%20-91.7184375%2012.12109375%20-92.3984375%2012.12109375%20C-92.3984375%2011.46109375%20-92.3984375%2010.80109375%20-92.3984375%2010.12109375%20C-86.55371914%206.70455692%20-82.22204258%204.68425704%20-75.4140625%205.1484375%20C-73.13271202%205.26864202%20-73.13271202%205.26864202%20-70.3984375%203.55859375%20C-67.21629427%202.03381679%20-66.5725065%202.03831047%20-63.2734375%202.55859375%20C-58.52449378%203.28314238%20-54.57262534%202.60887019%20-49.87890625%201.734375%20C-33.31680026%20-1.18397589%20-16.72552611%20-1.75034576%200%200%20Z%20%22%20fill%3D%22%23974606%22%20transform%3D%22translate(447.3984375%2C137.87890625)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.11353866%203.74626219%200.80746732%205.47543872%20-1%209%20C-1.43828125%209.4021875%20-1.8765625%209.804375%20-2.328125%2010.21875%20C-4.75363417%2012.80293734%20-6.30560597%2015.8512823%20-8%2018.9375%20C-11.6405367%2025.52741888%20-11.6405367%2025.52741888%20-13.67578125%2028.203125%20C-15.28419716%2030.18056911%20-15.28419716%2030.18056911%20-16.1875%2033.8125%20C-17.72505086%2038.18923208%20-20.28212184%2040.42881393%20-23.8671875%2043.26171875%20C-28.3054233%2046.87896221%20-31.91565079%2051.04948177%20-35.46127069%2055.5111261%20C-44.17080231%2066.44526518%20-53.8492967%2076.25436777%20-63.75537109%2086.09594727%20C-65.60042264%2087.94015041%20-67.44480952%2089.78501872%20-69.28858948%2091.63049316%20C-73.22479743%2095.56825825%20-77.16636773%2099.5005852%20-81.11185837%20103.42904854%20C-86.8160427%20109.10863195%20-92.51171647%20114.79669007%20-98.2054859%20120.48671209%20C-107.44817282%20129.7228672%20-116.69750943%20138.95233242%20-125.95117188%20148.17749023%20C-134.92901378%20157.12770621%20-143.903633%20166.08113387%20-152.87402344%20175.03881836%20C-153.7063585%20175.86997117%20-153.7063585%20175.86997117%20-154.55550842%20176.71791495%20C-157.33979273%20179.49828355%20-160.12401472%20182.27871455%20-162.90820575%20185.05917656%20C-185.92915358%20208.04913053%20-208.96095256%20231.02818408%20-232%20254%20C-232.33%20253.01%20-232.66%20252.02%20-233%20251%20C-232.51135686%20250.58199308%20-232.02271372%20250.16398616%20-231.51926321%20249.73331237%20C-226.60427497%20245.48694523%20-221.92737776%20241.07180088%20-217.34095764%20236.47467041%20C-216.61360002%20235.74957834%20-215.88624239%20235.02448627%20-215.13684362%20234.27742171%20C-212.72045367%20231.86731976%20-210.30760894%20229.45370104%20-207.89477539%20227.04003906%20C-206.15472448%20225.30298287%20-204.41446948%20223.56613112%20-202.67402649%20221.82946777%20C-198.44962296%20217.61296234%20-194.22759642%20213.39409095%20-190.00686104%20209.1739147%20C-186.57296242%20205.74049286%20-183.13827194%20202.30786517%20-179.70303154%20198.87578583%20C-169.94352032%20189.12507125%20-160.18609806%20179.37227321%20-150.43135983%20169.61678365%20C-149.90656236%20169.09194622%20-149.38176488%20168.56710878%20-148.84106445%20168.02636719%20C-148.31561983%20167.50088168%20-147.79017521%20166.97539618%20-147.24880802%20166.43398687%20C-138.73659027%20157.92136283%20-130.21939638%20149.41373705%20-121.69992847%20140.90836957%20C-112.93258821%20132.15542454%20-104.16901434%20123.39872391%20-95.40929979%20114.63814712%20C-90.49919776%20109.72771423%20-85.5875928%20104.8188075%20-80.67192268%2099.91394806%20C-76.04699604%2095.29912837%20-71.42732776%2090.67909076%20-66.81107903%2086.05558777%20C-65.12180212%2084.36526914%20-63.43083575%2082.67663688%20-61.73800659%2080.98987579%20C-53.36216405%2072.64210186%20-45.24187102%2064.36752399%20-38%2055%20C-37.03149715%2053.83160499%20-36.05705098%2052.66808611%20-35.07421875%2051.51171875%20C-34.28660156%2050.57972656%20-33.49898437%2049.64773438%20-32.6875%2048.6875%20C-31.88699219%2047.74261719%20-31.08648438%2046.79773438%20-30.26171875%2045.82421875%20C-27.91106319%2042.9868087%20-27.91106319%2042.9868087%20-25.83203125%2039.64453125%20C-25.22746094%2038.77183594%20-24.62289062%2037.89914062%20-24%2037%20C-23.34%2037%20-22.68%2037%20-22%2037%20C-21.71713135%2036.41839111%20-21.4342627%2035.83678223%20-21.14282227%2035.23754883%20C-20.08071647%2033.15803599%20-18.93965457%2031.1861787%20-17.71484375%2029.19921875%20C-17.27052002%2028.47589355%20-16.82619629%2027.75256836%20-16.3684082%2027.00732422%20C-15.66010864%2025.85901123%20-15.66010864%2025.85901123%20-14.9375%2024.6875%20C-9.90314187%2016.49086502%20-4.93288741%208.25801893%200%200%20Z%20%22%20fill%3D%22%23171717%22%20transform%3D%22translate(654%2C540)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.47981857%20-0.01058945%201.47981857%20-0.01058945%202.98953247%20-0.02139282%20C43.74789262%20-0.24691352%2043.74789262%20-0.24691352%2061.3671875%203.203125%20C62.47320312%203.41243652%2063.57921875%203.62174805%2064.71875%203.83740234%20C93.34015603%209.34421698%20120.39850853%2017.8043917%20146.3671875%2031.203125%20C146.3671875%2031.863125%20146.3671875%2032.523125%20146.3671875%2033.203125%20C143.24538349%2034.16973863%20140.84634955%2034.19301409%20137.6171875%2033.765625%20C136.81796875%2033.66378906%20136.01875%2033.56195313%20135.1953125%2033.45703125%20C134.59203125%2033.37324219%20133.98875%2033.28945312%20133.3671875%2033.203125%20C133.0371875%2031.553125%20132.7071875%2029.903125%20132.3671875%2028.203125%20C131.5421875%2028.120625%20130.7171875%2028.038125%20129.8671875%2027.953125%20C126.3671875%2027.203125%20126.3671875%2027.203125%20123.06640625%2025.46875%20C116.89355896%2022.30645975%20110.25523632%2020.34607472%20103.6796875%2018.203125%20C102.3806848%2017.77396554%20101.0818555%2017.34428088%2099.78320312%2016.9140625%20C95.98353105%2015.65910654%2092.17681892%2014.42754253%2088.3671875%2013.203125%20C87.17222656%2012.81842041%2085.97726562%2012.43371582%2084.74609375%2012.03735352%20C83.616875%2011.68084717%2082.48765625%2011.32434082%2081.32421875%2010.95703125%20C80.33268799%2010.6432251%2079.34115723%2010.32941895%2078.31958008%2010.00610352%20C74.00017531%208.83133114%2069.65860224%208.25454115%2065.22265625%207.703125%20C62.41420394%207.33890829%2059.64482509%206.92850992%2056.85546875%206.453125%20C56.06027832%206.31914307%2055.26508789%206.18516113%2054.44580078%206.04711914%20C52.93135667%205.78966055%2051.41785701%205.52652801%2049.90576172%205.25561523%20C33.94271569%202.59628089%2017.43663787%202.94923184%201.3046875%202.640625%20C-0.83399043%202.59730302%20-2.97266238%202.55368509%20-5.11132812%202.50976562%20C-10.28509391%202.40414932%20-15.45892335%202.30250611%20-20.6328125%202.203125%20C-20.6328125%201.873125%20-20.6328125%201.543125%20-20.6328125%201.203125%20C-13.73896553%200.39879839%20-6.93832427%200.03311216%200%200%20Z%20%22%20fill%3D%22%2346250B%22%20transform%3D%22translate(407.6328125%2C124.796875)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0%206.45312471%20-4.51308736%2011.81192953%20-8.125%2016.875%20C-17.33043556%2029.80042713%20-24.9622699%2044.33694118%20-31%2059%20C-31.33032227%2059.75676025%20-31.66064453%2060.51352051%20-32.00097656%2061.29321289%20C-33.12888749%2064.34921202%20-33.72292636%2067.28941804%20-34.296875%2070.49609375%20C-34.53043701%2071.76638428%20-34.76399902%2073.0366748%20-35.00463867%2074.34545898%20C-35.12600189%2075.01326385%20-35.24736511%2075.68106873%20-35.37240601%2076.36911011%20C-37.42255624%2087.599453%20-39.78103328%2098.61114048%20-42.95336914%20109.58740234%20C-44.86893321%20116.26989888%20-46.20238006%20122.91747071%20-47.26171875%20129.78515625%20C-48.01874828%20133.08163935%20-48.98121023%20135.29635497%20-51%20138%20C-51.66%20138%20-52.32%20138%20-53%20138%20C-48.64589603%20104.33534249%20-41.15462303%2072.55714776%20-26%2042%20C-25.62439941%2041.22720703%20-25.24879883%2040.45441406%20-24.86181641%2039.65820312%20C-18.28274248%2026.20517924%20-10.65910126%2010.65910126%200%200%20Z%20%22%20fill%3D%22%234D4D4D%22%20transform%3D%22translate(192%2C253)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C2.65636538%2020.20765766%20-8.03344802%2040.63106225%20-17.02734375%2058.10302734%20C-18.54194903%2061.05696384%20-20.01962086%2064.02876734%20-21.5%2067%20C-22.33333333%2068.66666667%20-23.16666667%2070.33333333%20-24%2072%20C-24.66%2072%20-25.32%2072%20-26%2072%20C-26.25910156%2072.69738281%20-26.51820313%2073.39476562%20-26.78515625%2074.11328125%20C-28.12366555%2077.29385479%20-29.71166233%2080.19975951%20-31.4375%2083.1875%20C-32.03433594%2084.23292969%20-32.63117187%2085.27835938%20-33.24609375%2086.35546875%20C-35%2089%20-35%2089%20-38%2091%20C-37.58742287%2085.49897163%20-35.45277325%2081.23798336%20-32%2077%20C-31.34%2077%20-30.68%2077%20-30%2077%20C-29.91363281%2076.154375%20-29.82726562%2075.30875%20-29.73828125%2074.4375%20C-28.87879337%2067.49851528%20-27.95848172%2061.26044054%20-23%2056%20C-22.34%2056%20-21.68%2056%20-21%2056%20C-20.76216797%2055.12601563%20-20.76216797%2055.12601563%20-20.51953125%2054.234375%20C-18.81403028%2048.24156497%20-16.65603138%2042.57822746%20-14.20703125%2036.8515625%20C-12.69155464%2033.2713103%20-11.33407306%2029.65114733%20-10%2026%20C-9.34%2026%20-8.68%2026%20-8%2026%20C-7.87625%2025.113125%20-7.7525%2024.22625%20-7.625%2023.3125%20C-7%2020%20-7%2020%20-6.0546875%2017.7109375%20C-4.43583303%2013.54988193%20-3.69018084%209.22516131%20-2.78125%204.86328125%20C-2%202%20-2%202%200%200%20Z%20%22%20fill%3D%22%23CDCDCD%22%20transform%3D%22translate(683%2C480)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200%201.32%200%202%200%20C2%200.66%202%201.32%202%202%20C1.21625%202.2475%200.4325%202.495%20-0.375%202.75%20C-3.09873976%203.71679916%20-3.09873976%203.71679916%20-3.9375%205.875%20C-5%208%20-5%208%20-7.57523537%209.65667343%20C-11.86404896%2012.42494354%20-15.27780759%2016.00808186%20-18.85873413%2019.6182251%20C-19.63156852%2020.38935064%20-20.40440292%2021.16047618%20-21.20065653%2021.95496917%20C-23.78486745%2024.53589011%20-26.3618727%2027.12388635%20-28.93896484%2029.71191406%20C-30.79161342%2031.56512686%20-32.64470266%2033.41789923%20-34.49819946%2035.27026367%20C-38.48581395%2039.25683101%20-42.46975901%2043.24703497%20-46.45121384%2047.23975372%20C-52.20768618%2053.01250105%20-57.96969307%2058.77969801%20-63.73305257%2064.54556844%20C-73.08425421%2073.90114404%20-82.43098359%2083.26117443%20-91.77490234%2092.62402344%20C-100.85002853%20101.71751615%20-109.92725925%20110.80889959%20-119.00732422%20119.89746094%20C-119.56730305%20120.45796521%20-120.12728187%20121.01846949%20-120.70422976%20121.59595874%20C-123.5135769%20124.40791601%20-126.32296542%20127.21983194%20-129.13237453%20130.03172731%20C-152.42800231%20153.3480783%20-175.71637228%20176.67166568%20-199%20200%20C-199%20197%20-199%20197%20-197.77875441%20195.40385759%20C-197.20016797%20194.82532616%20-196.62158152%20194.24679473%20-196.02546215%20193.65073204%20C-195.36198369%20192.98004704%20-194.69850523%20192.30936204%20-194.01492137%20191.61835325%20C-193.2737966%20190.88460277%20-192.53267184%20190.15085229%20-191.76908875%20189.39486694%20C-190.99124694%20188.61305073%20-190.21340514%20187.83123452%20-189.41199237%20187.02572691%20C-186.78658013%20184.39063986%20-184.15051236%20181.76647381%20-181.5144043%20179.14208984%20C-179.63688802%20177.26214731%20-177.75996803%20175.38162645%20-175.88375854%20173.50038147%20C-171.30494332%20168.9120615%20-166.71809931%20164.33184884%20-162.12846645%20159.75435232%20C-156.78762792%20154.42711274%20-151.45440578%20149.09227563%20-146.12142215%20143.75717469%20C-136.60747752%20134.24003768%20-127.08611332%20124.73035762%20-117.56079102%20115.22460938%20C-108.31121234%20105.99403323%20-99.06761384%2096.75752075%20-89.83032227%2087.51464844%20C-79.78000594%2077.45827818%20-69.72658912%2067.4050277%20-59.66755992%2057.35737193%20C-58.59550428%2056.28652362%20-57.52344932%2055.21567464%20-56.45139503%2054.14482498%20C-55.92387211%2053.6179056%20-55.39634919%2053.09098621%20-54.85284072%2052.54809957%20C-51.1300853%2048.82922834%20-47.40947586%2045.10821829%20-43.68961143%2041.38645554%20C-39.15775264%2036.85247746%20-34.62225293%2032.32217876%20-30.08207401%2027.79653166%20C-27.76430963%2025.48602516%20-25.44871535%2023.17341624%20-23.13632011%2020.85753441%20C-20.63275232%2018.35076382%20-18.12316112%2015.85018762%20-15.61186218%2013.35116577%20C-14.87742958%2012.61295385%20-14.14299698%2011.87474192%20-13.38630885%2011.11415994%20C-12.3793563%2010.11595568%20-12.3793563%2010.11595568%20-11.35206127%209.09758568%20C-10.77298777%208.51937895%20-10.19391426%207.94117223%20-9.59729308%207.34544408%20C-8%206%20-8%206%20-5%205%20C-4.154375%204.154375%20-3.30875%203.30875%20-2.4375%202.4375%20C-1.633125%201.633125%20-0.82875%200.82875%200%200%20Z%20%22%20fill%3D%22%23383838%22%20transform%3D%22translate(621%2C605)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.82929957%202.33240504%201.189039%203.52937167%200.25%205.8671875%20C-0.36875%206.86105469%20-0.36875%206.86105469%20-1%207.875%20C-3.46608258%2012.02218676%20-5.6749028%2016.24031343%20-7.8125%2020.5625%20C-8.28333008%2021.51068604%20-8.28333008%2021.51068604%20-8.76367188%2022.47802734%20C-9.51088873%2023.98447286%20-10.25570627%2025.4921081%20-11%2027%20C-11.66%2027%20-12.32%2027%20-13%2027%20C-13.2784375%2028.2065625%20-13.2784375%2028.2065625%20-13.5625%2029.4375%20C-15.50943992%2034.26252502%20-18.43348109%2038.21477946%20-22%2042%20C-22.66%2042%20-23.32%2042%20-24%2042%20C-24.2475%2042.53625%20-24.495%2043.0725%20-24.75%2043.625%20C-27.50577134%2048.86096554%20-30.78508581%2052.88310707%20-35%2057%20C-36.11125696%2058.28557177%20-37.21485675%2059.57778525%20-38.3125%2060.875%20C-41.84933069%2064.95476523%20-45.64045269%2068.79297669%20-50%2072%20C-50.66%2072%20-51.32%2072%20-52%2072%20C-50.8144174%2067.13911133%20-48.85475579%2064.39185091%20-45.4375%2060.90625%20C-43.81483891%2058.97038364%20-43.81483891%2058.97038364%20-43.0546875%2056.08203125%20C-41.8988643%2052.70445901%20-40.46819793%2050.85344028%20-38.125%2048.1875%20C-34.98129449%2044.40153208%20-32.93416671%2041.03757858%20-31.12890625%2036.49609375%20C-28.66196802%2031.04151406%20-25.18804886%2026.05374481%20-22%2021%20C-21.46503906%2020.04609375%20-20.93007813%2019.0921875%20-20.37890625%2018.109375%20C-19.92386719%2017.41328125%20-19.46882812%2016.7171875%20-19%2016%20C-18.34%2016%20-17.68%2016%20-17%2016%20C-16.67%2014.35%20-16.34%2012.7%20-16%2011%20C-15.19568413%2013.30227069%20-14.81680608%2014.52470479%20-15.70922852%2016.84008789%20C-16.09522217%2017.46133545%20-16.48121582%2018.08258301%20-16.87890625%2018.72265625%20C-17.30292725%2019.42092529%20-17.72694824%2020.11919434%20-18.16381836%2020.83862305%20C-18.85616577%2021.93944214%20-18.85616577%2021.93944214%20-19.5625%2023.0625%20C-20.49347303%2024.59036327%20-21.42316168%2026.11900988%20-22.3515625%2027.6484375%20C-22.80692383%2028.3919043%20-23.26228516%2029.13537109%20-23.73144531%2029.90136719%20C-27.46989881%2036.08607587%20-30.83905875%2042.50250965%20-34%2049%20C-33.505%2049.495%20-33.505%2049.495%20-33%2050%20C-28.70069084%2046.10375108%20-25.46085754%2041.66677891%20-22.10546875%2036.9453125%20C-20.76151668%2035.06527565%20-19.3913937%2033.20349389%20-17.98828125%2031.3671875%20C-12.39459424%2024.00418103%20-8.16539364%2016.22020162%20-4%208%20C-3.54109375%207.09765625%20-3.0821875%206.1953125%20-2.609375%205.265625%20C-1.72836785%203.51601926%20-0.86165686%201.7592161%200%200%20Z%20%22%20fill%3D%22%23727272%22%20transform%3D%22translate(670%2C533)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.98377095%202.97565642%202.59864225%204.84854822%203.40234375%208.27734375%20C3.65153564%209.33888672%203.90072754%2010.40042969%204.1574707%2011.49414062%20C4.41488037%2012.63044922%204.67229004%2013.76675781%204.9375%2014.9375%20C5.33618286%2016.68256836%205.33618286%2016.68256836%205.74291992%2018.46289062%20C9.54860787%2035.50154257%2012.16928947%2052.67888443%2012.1328125%2070.16015625%20C12.13424759%2071.70502968%2012.13424759%2071.70502968%2012.13571167%2073.28111267%20C12.13638775%2075.44334983%2012.13457368%2077.60558909%2012.13037109%2079.76782227%20C12.12500921%2083.05685017%2012.13033849%2086.34574187%2012.13671875%2089.63476562%20C12.13605797%2091.74739613%2012.13477682%2093.86002655%2012.1328125%2095.97265625%20C12.13483673%2096.94477554%2012.13686096%2097.91689484%2012.13894653%2098.91847229%20C12.1193409%20104.69063861%2011.73879355%20110.27416656%2011%20116%20C10.34%20116%209.68%20116%209%20116%20C9.12375%20117.36125%209.12375%20117.36125%209.25%20118.75%20C9%20122%209%20122%207.4375%20124.125%20C4.37347436%20126.4819428%201.48034608%20128.29146647%20-2%20130%20C-2.99%20129.67%20-3.98%20129.34%20-5%20129%20C-1.77332524%20126.23427878%201.04189917%20124.49765977%205%20123%20C9.97428397%20118.02571603%208.22928068%20105.73411545%208.30859375%2099.04296875%20C8.32367477%2097.79772934%208.3387558%2096.55248993%208.35429382%2095.26951599%20C8.39403524%2091.24215146%208.41993878%2087.21500818%208.4375%2083.1875%20C8.44095177%2082.5052813%208.44440353%2081.82306259%208.4479599%2081.12017059%20C8.5537795%2057.42364686%207.53585673%2034.17939532%200.91796875%2011.2512207%20C-0.21035805%207.25496325%20-0.14457775%204.12046576%200%200%20Z%20%22%20fill%3D%22%231A1A1A%22%20transform%3D%22translate(704%2C338)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.86625%200.4640625%200.86625%200.4640625%201.75%200.9375%20C3.88635294%202.07363436%203.88635294%202.07363436%205.9375%202.3125%20C9.06324596%203.35441532%2010.71071674%205.66116515%2013%208%20C18.34501405%2012.97448948%2023.74740177%2017.88724178%2029.3671875%2022.55078125%20C31.6784106%2024.60212998%2033.82332418%2026.80698277%2036%2029%20C37.16789063%2030.13308594%2037.16789063%2030.13308594%2038.359375%2031.2890625%20C44.39432481%2037.1859579%2049.75191752%2043.4024106%2055%2050%20C55.78375%2050.928125%2056.5675%2051.85625%2057.375%2052.8125%20C58.1175%2053.699375%2058.86%2054.58625%2059.625%2055.5%20C60.29789063%2056.2940625%2060.97078125%2057.088125%2061.6640625%2057.90625%20C62.10492187%2058.5971875%2062.54578125%2059.288125%2063%2060%20C62.67%2060.99%2062.34%2061.98%2062%2063%20C61.34%2063%2060.68%2063%2060%2063%20C58.96564444%2061.35443434%2057.97236487%2059.6829392%2057%2058%20C54.90869233%2055.04332364%2053.27755508%2053.17270094%2050.1875%2051.25%20C47.26328634%2049.18584918%2045.92380713%2047.74936468%2043.86328125%2044.93359375%20C39.95870721%2039.81009344%2035.58559758%2035.325005%2031%2030.8125%20C30.23171875%2030.04486328%2029.4634375%2029.27722656%2028.671875%2028.48632812%20C24.71986843%2024.5645665%2020.69384081%2020.82749645%2016.4296875%2017.24926758%20C14.75008274%2015.78162114%2013.36088882%2014.20240269%2012%2012.4375%20C9.94773886%209.93285871%207.93566242%208.12143791%205.25%206.3125%20C2.32393806%204.23049439%201.10586778%203.31760333%200%200%20Z%20%22%20fill%3D%22%235B2B04%22%20transform%3D%22translate(594%2C186)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.495%200.99%200.495%202%201%20C0.84886719%201.59425781%20-0.30226563%202.18851563%20-1.48828125%202.80078125%20C-24.39178415%2014.68633177%20-24.39178415%2014.68633177%20-45.8137207%2029.00390625%20C-49.81524379%2032%20-49.81524379%2032%20-52%2032%20C-52%2032.66%20-52%2033.32%20-52%2034%20C-50.88625%2033.319375%20-49.7725%2032.63875%20-48.625%2031.9375%20C-46.7265625%2030.77734375%20-46.7265625%2030.77734375%20-45%2030%20C-44.34%2030.33%20-43.68%2030.66%20-43%2031%20C-43.45850342%2031.34256836%20-43.91700684%2031.68513672%20-44.3894043%2032.03808594%20C-46.489416%2033.60786124%20-48.58846416%2035.17892009%20-50.6875%2036.75%20C-51.40873047%2037.28882813%20-52.12996094%2037.82765625%20-52.87304688%2038.3828125%20C-55.84522736%2040.60855496%20-58.79089445%2042.82579685%20-61.64453125%2045.203125%20C-64%2047%20-64%2047%20-66.890625%2048.36328125%20C-70.80931288%2050.42600766%20-73.6004151%2053.11393957%20-76.75%2056.1875%20C-82.74351211%2062%20-82.74351211%2062%20-85%2062%20C-83.44145796%2057.96281279%20-80.56742335%2055.62654856%20-77.375%2052.875%20C-73.54803442%2049.50178465%20-70.27936117%2046.24584183%20-67.3125%2042.0625%20C-61.66549986%2034.70393486%20-53.69503399%2029.98733981%20-46%2025%20C-45.28521484%2024.5344873%20-44.57042969%2024.06897461%20-43.83398438%2023.58935547%20C-15.29027837%205.17722613%20-15.29027837%205.17722613%200%200%20Z%20%22%20fill%3D%22%23573E2A%22%20transform%3D%22translate(302%2C149)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.70661294%203.5640514%20-6.51425647%204.28077891%20-10.625%205.4375%20C-15.93796494%207.00771169%20-20.96837723%208.71140235%20-25.98046875%2011.09765625%20C-28.86222776%2012.3852507%20-31.83761245%2013.29047334%20-34.859375%2014.19140625%20C-37.08592667%2014.95962597%20-37.08592667%2014.95962597%20-39.27026367%2016.36328125%20C-42.06603597%2018.03959442%20-44.90761439%2019.52534043%20-47.81640625%2020.99609375%20C-48.91017578%2021.55490234%20-50.00394531%2022.11371094%20-51.13085938%2022.68945312%20C-53.42014619%2023.85559524%20-55.7118256%2025.01705216%20-58.00585938%2026.17382812%20C-59.09833984%2026.73392578%20-60.19082031%2027.29402344%20-61.31640625%2027.87109375%20C-62.31099854%2028.37568115%20-63.30559082%2028.88026855%20-64.33032227%2029.40014648%20C-67.00772835%2031.00463135%20-68.85408659%2032.75607824%20-71%2035%20C-72.64034193%2035.72904086%20-74.31301918%2036.38655243%20-76%2037%20C-79.63279727%2038.67500233%20-83.11589454%2040.33094722%20-86.3125%2042.75%20C-88%2044%20-88%2044%20-91%2044%20C-91%2043.34%20-91%2042.68%20-91%2042%20C-89.35791016%2040.64648438%20-89.35791016%2040.64648438%20-87.0390625%2039.09375%20C-86.18393066%2038.51963379%20-85.32879883%2037.94551758%20-84.44775391%2037.35400391%20C-83.51624512%2036.74218262%20-82.58473633%2036.13036133%20-81.625%2035.5%20C-80.19873291%2034.55713135%20-80.19873291%2034.55713135%20-78.74365234%2033.59521484%20C-70.73556681%2028.36187826%20-62.54069505%2023.61011649%20-54.09472656%2019.12597656%20C-52.01163606%2018.00625472%20-49.9538746%2016.84927966%20-47.8984375%2015.6796875%20C-46.59909411%2014.9528822%20-45.29962141%2014.22630804%20-44%2013.5%20C-42.88625%2012.8709375%20-41.7725%2012.241875%20-40.625%2011.59375%20C-36.91809173%209.9639886%20-33.64506758%209.28328985%20-29.68994141%208.58105469%20C-23.84796282%207.31912793%20-18.33166077%204.89866037%20-12.77148438%202.74609375%20C-11.84013672%202.39417969%20-10.90878906%202.04226562%20-9.94921875%201.6796875%20C-9.11737061%201.35726074%20-8.28552246%201.03483398%20-7.4284668%200.70263672%20C-4.8387666%20-0.04665022%20-2.68157852%20-0.12850538%200%200%20Z%20%22%20fill%3D%22%23DAA982%22%20transform%3D%22translate(341%2C139)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-0.33%200.66%20-0.66%201.32%20-1%202%20C-1.66%202%20-2.32%202%20-3%202%20C-3.20496094%202.62519531%20-3.40992188%203.25039062%20-3.62109375%203.89453125%20C-5.60811654%206.92854056%20-7.57631886%206.91687048%20-11.0625%207.6875%20C-18.33088779%209.68226865%20-22.26850723%2013.2781948%20-27%2019%20C-27.99%2018.67%20-28.98%2018.34%20-30%2018%20C-29.01%2016.68%20-28.02%2015.36%20-27%2014%20C-30.10551666%2014%20-31.35261084%2014.5393715%20-34%2016%20C-32.9024777%2013.00675737%20-32.32317108%2012.15389099%20-29.375%2010.75%20C-28.59125%2010.5025%20-27.8075%2010.255%20-27%2010%20C-27.495%209.01%20-27.495%209.01%20-28%208%20C-34.50062114%2010.0230027%20-40.68185046%2012.49210622%20-46.875%2015.3125%20C-47.74833984%2015.70550293%20-48.62167969%2016.09850586%20-49.52148438%2016.50341797%20C-55.18287452%2019.08050802%20-60.60108395%2021.84611969%20-65.90625%2025.1015625%20C-68.44195733%2026.18964587%20-69.42488547%2025.76621093%20-72%2025%20C-66.43423886%2022.05599176%20-60.86296181%2019.1227429%20-55.28564453%2016.20068359%20C-53.49806192%2015.26163945%20-51.71494561%2014.31409199%20-49.93359375%2013.36328125%20C-44.66632402%2010.61249953%20-39.34068782%208.65443488%20-33.6640625%206.89453125%20C-31.05951823%206.1005799%20-31.05951823%206.1005799%20-29.01953125%204.94921875%20C-26.39783881%203.71697259%20-23.92607322%203.40443909%20-21.0625%203%20C-17.05254193%202.43221833%20-13.73587344%201.53722006%20-10%200%20C-2.92993631%20-1.46496815%20-2.92993631%20-1.46496815%200%200%20Z%20M-17%204%20C-17.33%204.66%20-17.66%205.32%20-18%206%20C-17.34%206%20-16.68%206%20-16%206%20C-16.33%205.34%20-16.66%204.68%20-17%204%20Z%20M-22%208%20C-22.33%208.66%20-22.66%209.32%20-23%2010%20C-22.01%209.67%20-21.02%209.34%20-20%209%20C-20.66%208.67%20-21.32%208.34%20-22%208%20Z%20%22%20fill%3D%22%23723A0D%22%20transform%3D%22translate(352%2C141)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.66%201.32%201.32%202%202%20C0.99319462%203.11697254%20-0.03138341%204.21793008%20-1.0625%205.3125%20C-1.63097656%205.92738281%20-2.19945312%206.54226562%20-2.78515625%207.17578125%20C-5.08157239%209.06718573%20-7.32824559%2010.11447817%20-10.07983398%2011.21166992%20C-13.48165409%2012.60829766%20-16.72535605%2014.3313117%20-20%2016%20C-33.1905551%2022.72162386%20-33.1905551%2022.72162386%20-37.4375%2023.375%20C-40.07953763%2024.01939942%20-41.55474832%2024.89911563%20-43.8125%2026.375%20C-47.75653346%2028.94947345%20-51.49735209%2030.60262651%20-56%2032%20C-56.66%2031.67%20-57.32%2031.34%20-58%2031%20C-51.54355918%2026.17318968%20-44.81695232%2022.10133714%20-37.77246094%2018.21508789%20C-34.19332911%2016.23973172%20-30.68303685%2014.22440215%20-27.25%2012%20C-24%2010%20-24%2010%20-22.08203125%209.53515625%20C-18.76141432%208.68163933%20-16.04848873%206.8012083%20-13.12109375%205.05859375%20C-11%204%20-11%204%20-8%204%20C-3.69382333%202.51638473%20-3.69382333%202.51638473%200%200%20Z%20%22%20fill%3D%22%237E3A05%22%20transform%3D%22translate(323%2C153)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C7.4803924%200.53096731%2014.03031238%202.37843991%2021.125%204.75%20C22.2279541%205.11198486%2023.3309082%205.47396973%2024.46728516%205.84692383%20C26.65582841%206.56632839%2028.8432069%207.2892879%2031.02929688%208.01611328%20C33.5410087%208.84798365%2036.05673437%209.66294942%2038.578125%2010.46484375%20C45.2051365%2012.59885054%2051.54567731%2014.9764152%2057.828125%2017.984375%20C60.09832933%2019.09689105%2060.09832933%2019.09689105%2063%2020%20C63.6875%2022.0625%2063.6875%2022.0625%2064%2024%20C60.03781103%2024.24675554%2057.64831678%2023.59611052%2054.125%2021.8125%20C45.13078934%2017.57644036%2035.90364666%2014.65645862%2026.24609375%2012.375%20C25.0446875%2012.08544434%2023.84328125%2011.79588867%2022.60546875%2011.49755859%20C20.19817932%2010.92489802%2017.78535327%2010.37493752%2015.3671875%209.85009766%20C7.95740896%208.08378851%204.28027913%206.39371463%200%200%20Z%20%22%20fill%3D%22%2363320A%22%20transform%3D%22translate(477%2C133)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C5.75%200.875%205.75%200.875%208%202%20C8%202.66%208%203.32%208%204%20C8.66%204%209.32%204%2010%204%20C10%204.66%2010%205.32%2010%206%20C10.7425%206.226875%2011.485%206.45375%2012.25%206.6875%20C15.54315164%208.25923147%2016.77478157%2010.14893889%2019%2013%20C20.65532623%2014.01866229%2022.32260138%2015.01810813%2024%2016%20C25.70884005%2017.62339805%2027.37446717%2019.29319053%2029%2021%20C31.69428798%2023.70829641%2034.40406964%2026.40049703%2037.12109375%2029.0859375%20C47.223714%2039.09357714%2047.223714%2039.09357714%2051.6015625%2044.453125%20C53.32621362%2046.36083964%2055.22359376%2047.96596007%2057.1875%2049.625%20C60.18827034%2052.1685101%2062.1819697%2054.46494109%2064%2058%20C64.66%2058.66%2065.32%2059.32%2066%2060%20C61.72886302%2062.18326108%2057.49797113%2064.31326082%2053%2066%20C53.99%2064.515%2053.99%2064.515%2055%2063%20C55.91312777%2056.47765877%2053.59803156%2052.22358851%2050%2047%20C47.64587234%2044.39585286%2047.64587234%2044.39585286%2045%2042%20C43.90736479%2040.73715529%2042.82489146%2039.46548155%2041.75%2038.1875%20C38.46323164%2034.38403443%2034.86704645%2031.10695796%2031.07421875%2027.81640625%20C27.83623168%2024.98088085%2024.87173205%2021.89737123%2021.875%2018.8125%20C19.92958282%2016.82343774%2019.92958282%2016.82343774%2017%2015%20C17%2014.34%2017%2013.68%2017%2013%20C16.236875%2012.731875%2015.47375%2012.46375%2014.6875%2012.1875%20C12.11011382%2011.04865495%2010.73045136%2010.18583329%209%208%20C9%207.34%209%206.68%209%206%20C8.34%206%207.68%206%207%206%20C7%205.34%207%204.68%207%204%20C5.35%203.67%203.7%203.34%202%203%20C2%202.34%202%201.68%202%201%20C1.34%200.67%200.68%200.34%200%200%20Z%20%22%20fill%3D%22%239C4906%22%20transform%3D%22translate(588%2C190)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C6.43068983%202.06700745%208.52188136%206.49122219%2012%2012%20C12.66902344%2013.051875%2013.33804688%2014.10375%2014.02734375%2015.1875%20C25.82752936%2034.11927885%2035.34158597%2054.06075837%2043%2075%20C43.39703125%2076.07717285%2043.7940625%2077.1543457%2044.203125%2078.26416016%20C44.57953125%2079.32812012%2044.9559375%2080.39208008%2045.34375%2081.48828125%20C45.85711914%2082.92941284%2045.85711914%2082.92941284%2046.38085938%2084.3996582%20C47.02010292%2087.08443066%2046.93300294%2088.4406582%2046%2091%20C45.71801758%2090.19892822%2045.43603516%2089.39785645%2045.14550781%2088.57250977%20C44.0823377%2085.55779991%2043.01587013%2082.54428157%2041.94726562%2079.53149414%20C41.4882899%2078.23540197%2041.03057363%2076.93886299%2040.57421875%2075.6418457%20C38.18601149%2068.85692792%2035.78305801%2062.15200426%2032.69042969%2055.65209961%20C32%2054%2032%2054%2032%2052%20C31.01%2052%2030.02%2052%2029%2052%20C28.7733667%2051.47043701%2028.5467334%2050.94087402%2028.31323242%2050.39526367%20C27.27869389%2047.98942757%2026.23323903%2045.58848751%2025.1875%2043.1875%20C24.83107422%2042.35412109%2024.47464844%2041.52074219%2024.10742188%2040.66210938%20C23.75615234%2039.85966797%2023.40488281%2039.05722656%2023.04296875%2038.23046875%20C22.72352295%2037.49207764%2022.40407715%2036.75368652%2022.07495117%2035.99291992%20C20.95107558%2033.90929592%2019.69583547%2032.63003536%2018%2031%20C16.94625183%2029.0489194%2015.95085797%2027.06573983%2015%2025.0625%20C13.25017441%2021.38513217%2011.43953435%2018.24545195%209%2015%20C9%2014.34%209%2013.68%209%2013%20C8.34%2013%207.68%2013%207%2013%20C7%2012.01%207%2011.02%207%2010%20C6.34%2010%205.68%2010%205%2010%20C4.67%208.35%204.34%206.7%204%205%20C2.68%205.33%201.36%205.66%200%206%20C0%205.34%200%204.68%200%204%20C-1.98%204.66%20-3.96%205.32%20-6%206%20C-4%204%20-2%202%200%200%20Z%20%22%20fill%3D%22%231E1E1E%22%20transform%3D%22translate(657%2C247)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.1875%20-0.25%202.1875%20-0.25%205%200%20C5.70125%200.5775%206.4025%201.155%207.125%201.75%20C10.63371448%204.49595046%2014.07837616%205.59727759%2018.28125%206.97265625%20C21.1106603%208.0418156%2023.41063599%209.44257371%2026%2011%20C28.63751316%2012.23517842%2031.31743526%2013.36659165%2034%2014.5%20C46.36140351%2019.72280702%2046.36140351%2019.72280702%2048%2023%20C50.20191812%2023.8836837%2052.4380464%2024.68298108%2054.6875%2025.4375%20C59.33886634%2027.00432773%2063.64601696%2028.73592882%2068%2031%20C69.53590854%2031.72073378%2071.07711285%2032.43036513%2072.625%2033.125%20C73.72714844%2033.62386719%2073.72714844%2033.62386719%2074.8515625%2034.1328125%20C76.88867895%2034.95506678%2078.85822352%2035.52512648%2081%2036%20C81%2036.66%2081%2037.32%2081%2038%20C82.32%2038%2083.64%2038%2085%2038%20C85%2038.66%2085%2039.32%2085%2040%20C85.64066406%2040.14695312%2086.28132813%2040.29390625%2086.94140625%2040.4453125%20C91.47976621%2041.62217484%2095.01727578%2042.64240593%2098.4375%2045.9375%20C101.99160303%2049.35620863%20105.79037478%2050.59984735%20110.44921875%2052.04296875%20C113.06031705%2053.02263044%20114.86591474%2054.2257605%20117%2056%20C110.25%2055.25%20110.25%2055.25%20108%2053%20C106.14640431%2052.23740958%20104.26749402%2051.53517233%20102.375%2050.875%20C101.37210937%2050.52179688%20100.36921875%2050.16859375%2099.3359375%2049.8046875%20C98.56507813%2049.53914063%2097.79421875%2049.27359375%2097%2049%20C97%2048.34%2097%2047.68%2097%2047%20C96.38125%2046.87625%2095.7625%2046.7525%2095.125%2046.625%20C93%2046%2093%2046%2091%2044%20C89.26720512%2043.38654409%2087.51284731%2042.83334125%2085.75%2042.3125%20C76.9300593%2039.47904079%2068.42388625%2035.57601936%2061%2030%20C59.36790804%2029.51037241%2057.73318747%2029.02635171%2056.08203125%2028.60546875%20C51.93939589%2027.40076241%2047.98157149%2025.65030931%2044%2024%20C44%2023.34%2044%2022.68%2044%2022%20C43.44183594%2021.89171875%2042.88367188%2021.7834375%2042.30859375%2021.671875%20C39.6026007%2020.88434403%2037.49672874%2019.67027181%2035.0625%2018.25%20C29.82488722%2015.31440252%2024.50173728%2013.17497636%2018.84765625%2011.17578125%20C16.13712214%2010.05661696%2014.28514726%208.79925279%2012%207%20C10.11476331%206.03904512%2010.11476331%206.03904512%208.25%205.3125%20C7.1775%204.879375%206.105%204.44625%205%204%20C5%203.34%205%202.68%205%202%20C3.35%201.67%201.7%201.34%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23BD7841%22%20transform%3D%22translate(262%2C285)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.66%201.32%201.32%202%202%20C1.13181641%203.63001953%201.13181641%203.63001953%200.24609375%205.29296875%20C-2.33473545%2010.464846%20-4.1425797%2015.82731165%20-5.9375%2021.3125%20C-6.28449951%2022.3641333%20-6.63149902%2023.4157666%20-6.98901367%2024.49926758%20C-9.83416086%2033.24374576%20-12.32426706%2042.04450243%20-14.50488281%2050.9765625%20C-14.95619766%2052.82098926%20-15.42631849%2054.66078854%20-15.8984375%2056.5%20C-17.79809128%2064.17384893%20-18.92815569%2071.87566887%20-19.75732422%2079.72900391%20C-19.92295685%2081.27901875%20-20.09682125%2082.82817053%20-20.27783203%2084.37646484%20C-21.66526588%2096.29524936%20-22.18858118%20108.1336789%20-22.1875%20120.125%20C-22.18830566%20121.4361377%20-22.18911133%20122.74727539%20-22.18994141%20124.09814453%20C-22.23269393%20131.12780461%20-22.23269393%20131.12780461%20-21%20138%20C-20.93611284%20140.26799402%20-21.00037278%20142.51360664%20-21.0625%20144.78125%20C-21.08580858%20147.00391922%20-21.08580858%20147.00391922%20-20.4375%20149.09375%20C-20%20151%20-20%20151%20-21%20154%20C-21%20153.34%20-21%20152.68%20-21%20152%20C-21.66%20152%20-22.32%20152%20-23%20152%20C-23.79245452%20145.17910826%20-24.16960708%20138.45062347%20-24.203125%20131.5859375%20C-24.21013931%20130.62149719%20-24.21715363%20129.65705688%20-24.22438049%20128.66339111%20C-24.24179381%20125.56721273%20-24.24823306%20122.47122556%20-24.25%20119.375%20C-24.25101212%20117.78881866%20-24.25101212%20117.78881866%20-24.25204468%20116.17059326%20C-24.23651363%20100.87439762%20-23.81341819%2086.07168712%20-21%2071%20C-20.74259033%2069.50847412%20-20.74259033%2069.50847412%20-20.47998047%2067.98681641%20C-16.50308787%2045.02461524%20-10.48155578%2020.96311156%200%200%20Z%20%22%20fill%3D%22%230E0E0E%22%20transform%3D%22translate(149%2C302)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.32%200.33%202.64%200.66%204%201%20C3.58113525%201.41362793%203.16227051%201.82725586%202.73071289%202.25341797%20C0.83870591%204.12466831%20-1.04943185%205.99977585%20-2.9375%207.875%20C-3.59685547%208.52597656%20-4.25621094%209.17695313%20-4.93554688%209.84765625%20C-5.56396484%2010.47285156%20-6.19238281%2011.09804687%20-6.83984375%2011.7421875%20C-7.42113037%2012.3182373%20-8.00241699%2012.89428711%20-8.60131836%2013.48779297%20C-10.09951936%2014.96652475%20-10.09951936%2014.96652475%20-11%2017%20C-9.68%2016.34%20-8.36%2015.68%20-7%2015%20C-7.20496094%2015.74765625%20-7.40992188%2016.4953125%20-7.62109375%2017.265625%20C-7.89050781%2018.25046875%20-8.15992188%2019.2353125%20-8.4375%2020.25%20C-8.83775391%2021.71179688%20-8.83775391%2021.71179688%20-9.24609375%2023.203125%20C-9.85544584%2025.46372653%20-10.44238255%2027.72622009%20-11%2030%20C-10.4225%2030.33773438%20-9.845%2030.67546875%20-9.25%2031.0234375%20C-8.5075%2031.46945312%20-7.765%2031.91546875%20-7%2032.375%20C-6.2575%2032.81585938%20-5.515%2033.25671875%20-4.75%2033.7109375%20C-4.1725%2034.13632812%20-3.595%2034.56171875%20-3%2035%20C-3%2035.66%20-3%2036.32%20-3%2037%20C-1.35%2037.33%200.3%2037.66%202%2038%20C-0.72415916%2039.36207958%20-2.12779357%2038.86166193%20-5%2038%20C-5.66%2037.01%20-6.32%2036.02%20-7%2035%20C-9.68314036%2033.90254806%20-12.40229086%2033.0978055%20-15.17578125%2032.2578125%20C-18.56408966%2030.74877335%20-20.52748422%2028.72922507%20-23%2026%20C-15.58747158%2017.08453767%20-7.93118613%208.45716357%200%200%20Z%20%22%20fill%3D%22%23D78542%22%20transform%3D%22translate(218%2C227)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C0.12973998%203.06697022%20-1.74595184%205.12854297%20-3.625%207.1875%20C-4.14707031%207.76564453%20-4.66914063%208.34378906%20-5.20703125%208.93945312%20C-7.78698864%2011.75829546%20-10.36935503%2014.38655409%20-13.3359375%2016.80078125%20C-16.02991581%2018.72228243%20-16.02991581%2018.72228243%20-17%2021%20C-16.53851563%2020.5875%20-16.07703125%2020.175%20-15.6015625%2019.75%20C-10.21239952%2014.97856717%20-4.65037266%2010.45777351%201%206%20C1.66%206.33%202.32%206.66%203%207%20C2.14019531%207.71542969%201.28039062%208.43085938%200.39453125%209.16796875%20C-6.5513419%2015.00487855%20-13.20574797%2020.97680438%20-19.47143555%2027.5456543%20C-23.03184248%2031.22712787%20-26.7046881%2034.19331605%20-31%2037%20C-31.66%2037%20-32.32%2037%20-33%2037%20C-33.00667764%2031.92499249%20-31.97230231%2029.5450622%20-28.46484375%2025.84375%20C-26.97087222%2024.38021368%20-25.46112323%2022.93264153%20-23.9375%2021.5%20C-23.19822266%2020.77941406%20-22.45894531%2020.05882812%20-21.69726562%2019.31640625%20C-16.93976172%2014.71290729%20-12.0220097%2010.31177226%20-7%206%20C-6.32573975%205.42000244%20-5.65147949%204.84000488%20-4.95678711%204.24243164%20C-3.30667209%202.82578268%20-1.65366396%201.41250464%200%200%20Z%20%22%20fill%3D%22%2373421A%22%20transform%3D%22translate(234%2C190)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.78474766%209.89252426%200.41894295%2020.89849144%20-0.75%2030.9375%20C-0.8382605%2031.71058502%20-0.926521%2032.48367004%20-1.01745605%2033.28018188%20C-2.36627096%2045.01173832%20-4.12176999%2056.53300914%20-7%2068%20C-5.71823966%2067.52611769%20-4.43711047%2067.05052799%20-3.15625%2066.57421875%20C-2.08600586%2066.17722778%20-2.08600586%2066.17722778%20-0.99414062%2065.7722168%20C1.07708267%2064.97015029%203.04684636%2064.05795822%205%2063%20C4.53722656%2063.46019531%204.07445312%2063.92039062%203.59765625%2064.39453125%20C1.22628374%2068.26178177%200.9957876%2072.23771659%200.4375%2076.6875%20C0.21517482%2078.42163641%20-0.01488344%2080.15480487%20-0.25390625%2081.88671875%20C-0.35002197%2082.65201904%20-0.4461377%2083.41731934%20-0.54516602%2084.20581055%20C-0.69526123%2084.79789307%20-0.84535645%2085.38997559%20-1%2086%20C-1.99%2086.495%20-1.99%2086.495%20-3%2087%20C-3%2082.71%20-3%2078.42%20-3%2074%20C-3.99%2074.495%20-3.99%2074.495%20-5%2075%20C-4.67%2073.02%20-4.34%2071.04%20-4%2069%20C-5.65%2068.67%20-7.3%2068.34%20-9%2068%20C-8.85377197%2067.04859131%20-8.70754395%2066.09718262%20-8.55688477%2065.11694336%20C-8.00447013%2061.51144655%20-7.46046153%2057.90471915%20-6.91870117%2054.29760742%20C-6.68523627%2052.75072245%20-6.44963585%2051.20415794%20-6.21166992%2049.65795898%20C-4.33841593%2037.47190715%20-2.81808203%2025.36292511%20-3.0625%2013%20C-3.11518159%208.58791724%20-2.52911368%205.13760172%20-1%201%20C-0.67%200.67%20-0.34%200.34%200%200%20Z%20%22%20fill%3D%22%23A9A9A9%22%20transform%3D%22translate(686%2C407)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C1.12371396%205.05362021%201.21439046%2010.10635702%201.2746582%2015.16113281%20C1.29978367%2016.88003901%201.33389047%2018.59883856%201.37719727%2020.31738281%20C1.43794029%2022.78998114%201.46622762%2025.26116606%201.48828125%2027.734375%20C1.51408768%2028.50118591%201.5398941%2029.26799683%201.56648254%2030.05804443%20C1.56852063%2033.94606363%201.35495665%2035.62299887%20-1.35473633%2038.50097656%20C-4.21979551%2040.12455417%20-5.76564365%2040.36964073%20-9%2040%20C-8.88557539%2038.39504433%20-8.75805306%2036.79101881%20-8.625%2035.1875%20C-8.55539062%2034.29417969%20-8.48578125%2033.40085937%20-8.4140625%2032.48046875%20C-8%2030%20-8%2030%20-6%2027%20C-5.39581458%2024.78550576%20-5.39581458%2024.78550576%20-5%2022.32421875%20C-4.835%2021.41349609%20-4.67%2020.50277344%20-4.5%2019.56445312%20C-4.335%2018.61505859%20-4.17%2017.66566406%20-4%2016.6875%20C-2.00332779%205.33922629%20-2.00332779%205.33922629%200%200%20Z%20%22%20fill%3D%22%23F9F9F9%22%20transform%3D%22translate(690%2C434)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C0.0625%204.625%200.0625%204.625%20-1%207%20C-1.66%207%20-2.32%207%20-3%207%20C-3.226875%208.134375%20-3.45375%209.26875%20-3.6875%2010.4375%20C-4.94790295%2015.4791118%20-7.37277782%2019.55856422%20-10%2024%20C-10.87842724%2025.60229251%20-11.75350704%2027.20642537%20-12.625%2028.8125%20C-13.83854243%2031.04818723%20-15.02845329%2033.03638404%20-16.59765625%2035.04296875%20C-18.25806819%2037.09590176%20-18.25806819%2037.09590176%20-18.8125%2040.5%20C-20.28237818%2044.83227252%20-22.06109515%2045.85929084%20-26%2048%20C-25.38329755%2043.56640942%20-23.7017138%2040.19312748%20-21.625%2036.25%20C-19.60069221%2032.34894793%20-17.71168284%2028.55338995%20-16.5%2024.3125%20C-13.93281416%2015.83921178%20-7.75481862%207.66347419%20-2%201%20C-1.34%200.67%20-0.68%200.34%200%200%20Z%20%22%20fill%3D%22%23AAAAAA%22%20transform%3D%22translate(190%2C266)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.66%201.32%201.32%202%202%20C1.66266846%202.61407715%201.32533691%203.2281543%200.9777832%203.86083984%20C-0.57923751%206.6978408%20-2.13338044%209.53640882%20-3.6875%2012.375%20C-4.48317383%2013.82326172%20-4.48317383%2013.82326172%20-5.29492188%2015.30078125%20C-7.84617796%2019.96504085%20-10.32764767%2024.63447762%20-12.640625%2029.421875%20C-14.417746%2033.01329676%20-16.28417863%2035.94754408%20-19.0625%2038.875%20C-19.71347656%2039.57367188%20-20.36445313%2040.27234375%20-21.03515625%2040.9921875%20C-21.68355469%2041.65476562%20-22.33195313%2042.31734375%20-23%2043%20C-24.08087891%2044.11761719%20-24.08087891%2044.11761719%20-25.18359375%2045.2578125%20C-27%2047%20-27%2047%20-28%2047%20C-28.77267674%2040.03625087%20-26.09667297%2035.18470616%20-23%2029.0625%20C-22.52304688%2028.09248047%20-22.04609375%2027.12246094%20-21.5546875%2026.12304688%20C-20.38192573%2023.74234047%20-19.19689392%2021.36864033%20-18%2019%20C-17.34%2019%20-16.68%2019%20-16%2019%20C-17.34849837%2023.35970831%20-19.04907846%2027.31341438%20-21.125%2031.375%20C-21.66382813%2032.43460937%20-22.20265625%2033.49421875%20-22.7578125%2034.5859375%20C-23.16773438%2035.38257813%20-23.57765625%2036.17921875%20-24%2037%20C-23.67%2037.33%20-23.34%2037.66%20-23%2038%20C-19.4438935%2034.91804103%20-18.39130023%2032.43476949%20-17%2028%20C-14.98260014%2024.24346232%20-12.78705297%2020.65845097%20-10.5%2017.0625%20C-8.39082423%2013.73698974%20-6.63245811%2010.33983119%20-4.9921875%206.76171875%20C-3.89900793%204.82067944%20-2.59603812%203.5399611%20-1%202%20C-0.67%201.34%20-0.34%200.68%200%200%20Z%20%22%20fill%3D%22%23979797%22%20transform%3D%22translate(189%2C274)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.53398049%203.07455689%203.96293359%206.04527132%205.375%209.76171875%20C6.01695312%2011.44104492%206.01695312%2011.44104492%206.671875%2013.15429688%20C7.11015625%2014.32025391%207.5484375%2015.48621094%208%2016.6875%20C8.43828125%2017.83412109%208.8765625%2018.98074219%209.328125%2020.16210938%20C15.97036396%2037.63800014%2015.97036396%2037.63800014%2017%2044.0625%20C17.55752328%2047.42670032%2018.14621411%2050.77542903%2018.82421875%2054.1171875%20C19.03788086%2055.18827759%2019.03788086%2055.18827759%2019.25585938%2056.28100586%20C19.53878623%2057.69451996%2019.82764131%2059.10686328%2020.12304688%2060.51782227%20C20.79844898%2063.95550019%2021.26833543%2066.67168354%2020%2070%20C19.67%2067.36%2019.34%2064.72%2019%2062%20C18.34%2062%2017.68%2062%2017%2062%20C16.49622232%2059.73000175%2015.99709981%2057.45896997%2015.5%2055.1875%20C15.2215625%2053.92292969%2014.943125%2052.65835938%2014.65625%2051.35546875%20C14%2048%2014%2048%2014%2045%20C13.34%2045%2012.68%2045%2012%2045%20C11.73445312%2043.81921875%2011.46890625%2042.6384375%2011.1953125%2041.421875%20C10.83880998%2039.86452189%2010.48202428%2038.30723358%2010.125%2036.75%20C9.95097656%2035.97269531%209.77695312%2035.19539063%209.59765625%2034.39453125%20C9.42363281%2033.64042969%209.24960937%2032.88632812%209.0703125%2032.109375%20C8.91320801%2031.41811523%208.75610352%2030.72685547%208.59423828%2030.01464844%20C7.95618048%2027.85143852%207.01899676%2026.00728544%206%2024%20C5.62331656%2022.34259285%205.27942455%2020.67654729%205%2019%20C4.67%2019%204.34%2019%204%2019%20C3.52040222%2016.77092605%203.0413392%2014.54173703%202.5625%2012.3125%20C2.16224609%2010.45044922%202.16224609%2010.45044922%201.75390625%208.55078125%20C1.14944864%205.70387985%200.56235316%202.85544374%200%200%20Z%20%22%20fill%3D%22%23444444%22%20transform%3D%22translate(688%2C299)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.50626953%200.01353516%201.50626953%200.01353516%203.04296875%200.02734375%20C5.48724126%200.05062254%207.93098408%200.08331513%2010.375%200.125%20C7.35587057%202.13775296%205.66884438%202.63274157%202.17578125%203.30859375%20C1.13832764%203.51266846%200.10087402%203.71674316%20-0.96801758%203.92700195%20C-2.62353638%204.24157349%20-2.62353638%204.24157349%20-4.3125%204.5625%20C-5.99605591%204.88963989%20-5.99605591%204.88963989%20-7.71362305%205.22338867%20C-9.9683032%205.66022183%20-12.22358961%206.09393832%20-14.47949219%206.52441406%20C-17.21969178%207.04761268%20-19.95783661%207.57996763%20-22.6953125%208.1171875%20C-33.05507523%2010.125%20-33.05507523%2010.125%20-37.625%2010.125%20C-37.625%209.465%20-37.625%208.805%20-37.625%208.125%20C-38.615%207.795%20-39.605%207.465%20-40.625%207.125%20C-37.66765359%206.32949203%20-34.70920743%205.53853132%20-31.75%204.75%20C-30.92757813%204.52828125%20-30.10515625%204.3065625%20-29.2578125%204.078125%20C-19.33200042%201.44158116%20-10.30767161%20-0.17890485%200%200%20Z%20%22%20fill%3D%22%23B58A67%22%20transform%3D%22translate(386.625%2C128.875)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.495%200.99%200.495%202%201%20C-6.01188558%206.39575968%20-14.8450892%2010.69917639%20-23.89453125%2014.08203125%20C-26.17042106%2014.80654511%20-26.17042106%2014.80654511%20-27%2017%20C-28.8984375%2017.859375%20-28.8984375%2017.859375%20-31.375%2018.75%20C-37.22403503%2020.9873816%20-42.54975904%2023.93855136%20-48%2027%20C-51.18152272%2028.71312762%20-53.893217%2029.97033805%20-57.375%2030.9375%20C-63.51438386%2032.73697458%20-68.63015316%2035.75836351%20-74%2039.1875%20C-78.46395308%2041.9308272%20-81.7906654%2042.80706168%20-87%2043%20C-84.96389987%2040.8034114%20-83.09557457%2039.35967225%20-80.41796875%2038.02734375%20C-79.73283203%2037.68509766%20-79.04769531%2037.34285156%20-78.34179688%2036.99023438%20C-77.63087891%2036.64283203%20-76.91996094%2036.29542969%20-76.1875%2035.9375%20C-75.48818359%2035.58623047%20-74.78886719%2035.23496094%20-74.06835938%2034.87304688%20C-70.11293224%2032.91568396%20-66.22374343%2031.31405351%20-62%2030%20C-60.26418321%2029.37225952%20-58.53447779%2028.72726352%20-56.8125%2028.0625%20C-55.97332031%2027.74410156%20-55.13414062%2027.42570312%20-54.26953125%2027.09765625%20C-51.96596137%2025.98353725%20-50.72949628%2024.84741648%20-49%2023%20C-46.0948718%2021.38603989%20-43.31760138%2020.10194612%20-40.15234375%2019.0859375%20C-37.04299157%2018.01480998%20-34.28754558%2016.70796112%20-31.375%2015.1875%20C-27.32640564%2013.12076996%20-23.28253005%2011.25051202%20-19.0625%209.5625%20C-13.2945687%207.23856467%20-8.00234643%204.3442705%20-2.6171875%201.2578125%20C-1.75351562%200.84273438%20-0.88984375%200.42765625%200%200%20Z%20%22%20fill%3D%22%23444444%22%20transform%3D%22translate(658%2C484)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.66991163%202.66991163%202.24937527%204.69014224%202.27789307%208.32092285%20C2.2738446%209.19470581%202.26979614%2010.06848877%202.265625%2010.96875%20C2.26753845%2011.87765991%202.2694519%2012.78656982%202.27142334%2013.72302246%20C2.27278787%2015.6599149%202.26907283%2017.5968164%202.26074219%2019.53369141%20C2.25024321%2022.43284063%202.26052379%2025.33134153%202.2734375%2028.23046875%20C2.28316888%2041.56818505%201.83460528%2054.9162264%20-1%2068%20C-1.33%2068%20-1.66%2068%20-2%2068%20C-1.99777939%2067.3927861%20-1.99555878%2066.7855722%20-1.99327087%2066.15995789%20C-1.97117688%2059.84989001%20-1.95607613%2053.53983309%20-1.94506836%2047.22973633%20C-1.94003425%2044.873612%20-1.93320654%2042.5174908%20-1.92456055%2040.16137695%20C-1.9124547%2036.7781497%20-1.90676251%2033.39496368%20-1.90234375%2030.01171875%20C-1.89718246%2028.95538742%20-1.89202118%2027.89905609%20-1.88670349%2026.81071472%20C-1.88662796%2025.82992447%20-1.88655243%2024.84913422%20-1.88647461%2023.83862305%20C-1.884254%2022.97480515%20-1.88203339%2022.11098724%20-1.87974548%2021.22099304%20C-1.91126684%2018.82540879%20-1.91126684%2018.82540879%20-3%2016%20C-3.42134358%209.78518213%20-2.4498235%205.71625482%200%200%20Z%20%22%20fill%3D%22%239B9B9B%22%20transform%3D%22translate(695%2C399)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.3271261%203.9813783%201.06915913%207.85045227%201%2012%20C1.66%2012.33%202.32%2012.66%203%2013%20C3.04254356%2014.99954746%203.04080783%2017.00041636%203%2019%20C2.67%2019.33%202.34%2019.66%202%2020%20C1.66812714%2021.81691816%201.38985875%2023.64365149%201.1328125%2025.47265625%20C0.34342167%2030.83363053%20-0.5397798%2036.1653641%20-1.5078125%2041.49609375%20C-1.63927673%2042.22518951%20-1.77074097%2042.95428528%20-1.90618896%2043.70547485%20C-2.44942231%2046.7159994%20-2.99453658%2049.72614935%20-3.54638672%2052.73510742%20C-3.95489276%2054.96711387%20-4.35683326%2057.20022458%20-4.7578125%2059.43359375%20C-4.88278107%2060.10555283%20-5.00774963%2060.7775119%20-5.13650513%2061.46983337%20C-5.82956697%2065.36162093%20-6.12137109%2069.04933291%20-6%2073%20C-6.99%2073%20-7.98%2073%20-9%2073%20C-8.88353525%2071.33271516%20-8.75630239%2069.666182%20-8.625%2068%20C-8.55539062%2067.071875%20-8.48578125%2066.14375%20-8.4140625%2065.1875%20C-8%2062%20-8%2062%20-7.04101562%2058.29516602%20C-6.01511701%2054.26100974%20-5.40061806%2050.22254671%20-4.9296875%2046.08984375%20C-4.84373322%2045.35987686%20-4.75777893%2044.62990997%20-4.66921997%2043.87782288%20C-4.4901306%2042.34114599%20-4.31380446%2040.80414475%20-4.14013672%2039.2668457%20C-3.87827809%2036.96629946%20-3.6017879%2034.66783722%20-3.32421875%2032.36914062%20C-2.33214447%2023.86151489%20-1.83912233%2015.60662106%20-2.12939453%207.04125977%20C-2.00246335%204.0578981%20-1.57240779%202.49457464%200%200%20Z%20%22%20fill%3D%22%23B7B7B7%22%20transform%3D%22translate(688%2C402)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.17119385%20-0.00201416%202.3423877%20-0.00402832%203.54907227%20-0.00610352%20C5.40036743%200.00078491%205.40036743%200.00078491%207.2890625%200.0078125%20C8.55097412%200.01047119%209.81288574%200.01312988%2011.11303711%200.01586914%20C19.75864975%200.05987426%2028.30249263%200.33482919%2036.9140625%201.1328125%20C37.86410156%201.205%2038.81414062%201.2771875%2039.79296875%201.3515625%20C45.89518674%201.83765668%2051.90799822%202.68384602%2057.94921875%203.66796875%20C60.33586199%204.04215919%2062.70005331%204.32566811%2065.1015625%204.5703125%20C66.0296875%204.7559375%2066.9578125%204.9415625%2067.9140625%205.1328125%20C68.9040625%206.6178125%2068.9040625%206.6178125%2069.9140625%208.1328125%20C64.10066313%208.35640478%2058.8466866%207.6677939%2053.12890625%206.63671875%20C48.86732396%205.96874291%2044.61757368%205.70255062%2040.3125%205.4765625%20C37.5297513%205.19508907%2035.02625897%204.73365431%2032.30957031%204.12353516%20C27.21004268%203.08989333%2022.37659634%202.87244191%2017.1875%202.9375%20C16.31380768%202.9403299%2015.44011536%202.94315979%2014.53994751%202.94607544%20C11.78950436%202.95713947%209.03940476%202.98221669%206.2890625%203.0078125%20C4.40755683%203.01786016%202.52604599%203.02698286%200.64453125%203.03515625%20C-3.93242107%203.05703338%20-8.50912135%203.09146531%20-13.0859375%203.1328125%20C-9.48946832%20-0.46365668%20-4.86495411%200.00521911%200%200%20Z%20%22%20fill%3D%22%23A74E07%22%20transform%3D%22translate(414.0859375%2C139.8671875)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C1.1404894%205.67704882%200.70442078%2010.86914183%20-0.375%2016.4375%20C-0.56449219%2017.51547852%20-0.56449219%2017.51547852%20-0.7578125%2018.61523438%20C-1.09965667%2020.42529925%20-1.54187051%2022.21581681%20-2%2024%20C-2.66%2024.33%20-3.32%2024.66%20-4%2025%20C-4.54653131%2027.24455389%20-4.54653131%2027.24455389%20-4.875%2029.9375%20C-5.67666359%2034.82322926%20-7.03801754%2038.98140958%20-8.99609375%2043.51171875%20C-10.04121068%2046.10214475%20-10.77748396%2048.6783964%20-11.5%2051.375%20C-12.58991359%2055.20475163%20-13.73420362%2057.5224993%20-17%2060%20C-17.41667463%2054.27072388%20-16.71718112%2050.74911704%20-14.2109375%2045.62109375%20C-11.72969872%2040.2504124%20-9.95751793%2034.57794406%20-8%2029%20C-5.19399538%2021.19399538%20-5.19399538%2021.19399538%20-4%2020%20C-3.71681717%2018.60187743%20-3.4865614%2017.19291089%20-3.28125%2015.78125%20C-3.15363281%2014.93175781%20-3.02601563%2014.08226562%20-2.89453125%2013.20703125%20C-2.76433594%2012.31371094%20-2.63414062%2011.42039062%20-2.5%2010.5%20C-2.24335071%208.73903015%20-1.98312456%206.97857663%20-1.71875%205.21875%20C-1.60466797%204.43435547%20-1.49058594%203.64996094%20-1.37304688%202.84179688%20C-1%201%20-1%201%200%200%20Z%20%22%20fill%3D%22%237D7D7D%22%20transform%3D%22translate(688%2C473)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C4.59939618%201.03486414%208.70876086%202.96245093%2013%204.875%20C13.80695313%205.22691406%2014.61390625%205.57882812%2015.4453125%205.94140625%20C19.28864569%207.64744029%2022.76447085%209.26101245%2026%2012%20C30.76252152%2015.17501435%2035.86556602%2016.89275706%2041.22265625%2018.78515625%20C46.79918324%2020.79918324%2046.79918324%2020.79918324%2049%2023%20C51.57061311%2023.64767793%2051.57061311%2023.64767793%2054%2024%20C54%2024.66%2054%2025.32%2054%2026%20C54.845625%2026.103125%2055.69125%2026.20625%2056.5625%2026.3125%20C60.41442701%2027.0828854%2063.44075031%2028.36274514%2067%2030%20C67%2030.66%2067%2031.32%2067%2032%20C65.60190528%2031.74109357%2064.20657858%2031.46722539%2062.8125%2031.1875%20C62.03519531%2031.03667969%2061.25789063%2030.88585937%2060.45703125%2030.73046875%20C57.62563734%2029.88870299%2055.52181087%2028.53123449%2053%2027%20C50.84907031%2026.12685032%2048.68103886%2025.29495809%2046.5%2024.5%20C42.34695447%2022.98627313%2038.77735394%2021.27250487%2035%2019%20C33.26436993%2018.35571308%2031.51318591%2017.75202882%2029.75%2017.1875%20C24.96646782%2015.5177765%2021.14477019%2013.35718877%2017.0703125%2010.3671875%20C14.80199747%208.86924361%2012.53046805%207.97454389%2010%207%20C8.66150329%206.00692179%207.32848691%205.00642948%206%204%20C4.01549844%202.96958573%202.01800895%201.96314063%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23323232%22%20transform%3D%22translate(136%2C463)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.86625%200.4640625%200.86625%200.4640625%201.75%200.9375%20C3.88635294%202.07363436%203.88635294%202.07363436%205.9375%202.3125%20C9.07744555%203.35914852%2010.83786745%205.60368181%2013%208%20C13.70769531%208.7734375%2014.41539062%209.546875%2015.14453125%2010.34375%20C18.41442189%2013.94442559%2021.66851089%2017.54840254%2024.75%2021.3125%20C27.03949528%2024.04717492%2029.46363505%2026.49201396%2032%2029%20C34.31481459%2031.28934255%2036.62669702%2033.58160888%2038.9375%2035.875%20C39.53240234%2036.46152344%2040.12730469%2037.04804688%2040.74023438%2037.65234375%20C44.71399509%2041.60438993%2048.40101891%2045.70320121%2052%2050%20C51.505%2050.99%2051.505%2050.99%2051%2052%20C47.54750388%2048.59682525%2044.24485776%2045.10100069%2041%2041.5%20C33.28371149%2033.01742263%2025.3586146%2024.59454831%2016.47265625%2017.32421875%20C14.79633991%2015.81686799%2013.42534514%2014.18289653%2012%2012.4375%20C9.94773886%209.93285871%207.93566242%208.12143791%205.25%206.3125%20C2.32393806%204.23049439%201.10586778%203.31760333%200%200%20Z%20%22%20fill%3D%22%23743605%22%20transform%3D%22translate(594%2C186)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.70189453%200.00451172%201.40378906%200.00902344%202.12695312%200.01367188%20C3.85550538%200.02543073%205.58401365%200.04336546%207.3125%200.0625%20C7.3125%201.0525%207.3125%202.0425%207.3125%203.0625%20C4.73282203%203.92939178%202.14973873%204.78123789%20-0.4375%205.625%20C-1.16710937%205.87185547%20-1.89671875%206.11871094%20-2.6484375%206.37304688%20C-3.35742188%206.60185547%20-4.06640625%206.83066406%20-4.796875%207.06640625%20C-5.44624023%207.28111572%20-6.09560547%207.4958252%20-6.76464844%207.71704102%20C-8.6875%208.0625%20-8.6875%208.0625%20-12.6875%207.0625%20C-9.0575%205.7425%20-5.4275%204.4225%20-1.6875%203.0625%20C-8.96442771%203.6913703%20-15.17058898%206.47380054%20-21.86132812%209.26757812%20C-27.44068295%2011.50174411%20-31.67417851%2012.50558685%20-37.6875%2012.0625%20C-35.27972659%209.65472659%20-33.3347619%209.06819207%20-30.12890625%207.93359375%20C-29.02095703%207.53849609%20-27.91300781%207.14339844%20-26.77148438%206.73632812%20C-25.60939453%206.32833984%20-24.44730469%205.92035156%20-23.25%205.5%20C-22.09177734%205.08814453%20-20.93355469%204.67628906%20-19.74023438%204.25195312%20C-12.88438654%201.81794788%20-7.31601913%20-0.08880322%200%200%20Z%20%22%20fill%3D%22%2399775A%22%20transform%3D%22translate(341.6875%2C136.9375)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C9.84631941%201.6783499%2018.6956622%2013.49113323%2025.4375%2020.1875%20C26.3140625%2021.05479736%2027.190625%2021.92209473%2028.09375%2022.81567383%20C35.06109845%2029.8173475%2035.06109845%2029.8173475%2037.34765625%2033.421875%20C39.02540874%2036.03964485%2040.44252763%2037.34919331%2043%2039.0625%20C46.26102363%2041.38658774%2048.7918633%2043.59578925%2051%2047%20C51%2047.99%2051%2048.98%2051%2050%20C47.23839009%2048.49535604%2047.23839009%2048.49535604%2046.09765625%2046.125%20C44.82641073%2043.66394105%2043.45745121%2042.48618841%2041.3125%2040.75%20C38.55173436%2038.41396753%2036.08565215%2036.07281617%2033.75%2033.3125%20C29.27927533%2028.03828104%2024.33058221%2023.24608158%2019.41064453%2018.39624023%20C18.05179508%2017.05126619%2016.70531823%2015.69382697%2015.359375%2014.3359375%20C13.41562108%2012.41149239%2011.45597885%2010.58465779%209.375%208.8125%20C8.52035156%208.07966797%208.52035156%208.07966797%207.6484375%207.33203125%20C5.82650009%205.81824745%205.82650009%205.81824745%203%204%20C3%203.34%203%202.68%203%202%20C2.01%201.67%201.02%201.34%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%238A4006%22%20transform%3D%22translate(603%2C199)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C1.54149658%201.34256836%201.08299316%201.68513672%200.6105957%202.03808594%20C-1.489416%203.60786124%20-3.58846416%205.17892009%20-5.6875%206.75%20C-6.7693457%207.55824219%20-6.7693457%207.55824219%20-7.87304688%208.3828125%20C-10.84522736%2010.60855496%20-13.79089445%2012.82579685%20-16.64453125%2015.203125%20C-19%2017%20-19%2017%20-21.890625%2018.36328125%20C-25.80931288%2020.42600766%20-28.6004151%2023.11393957%20-31.75%2026.1875%20C-37.74351211%2032%20-37.74351211%2032%20-40%2032%20C-38.42546727%2027.88496354%20-35.42520606%2025.44380092%20-32.1875%2022.625%20C-28.97495522%2019.81352694%20-25.99505236%2017.08500302%20-23.36328125%2013.7109375%20C-20.92101454%2010.90939519%20-20.42221899%2010.59871823%20-17%2010%20C-14.67227533%208.30105248%20-12.51305784%206.45803866%20-10.31640625%204.59375%20C-7.79185103%202.8567879%20-5.98441765%202.50468201%20-3%202%20C-2.01%201.34%20-1.02%200.68%200%200%20Z%20%22%20fill%3D%22%23905E35%22%20transform%3D%22translate(257%2C179)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.68416016%200.38285156%201.68416016%200.38285156%203.40234375%200.7734375%20C4.28019531%201.05445313%205.15804687%201.33546875%206.0625%201.625%20C6.5575%202.615%206.5575%202.615%207.0625%203.625%20C4.8127943%203.68032063%202.56266349%203.7183712%200.3125%203.75%20C-0.94046875%203.77320313%20-2.1934375%203.79640625%20-3.484375%203.8203125%20C-6.89859227%203.76940684%20-10.07864329%203.27339975%20-13.43164062%202.63867188%20C-19.80771546%201.55003089%20-26.02631014%201.28029908%20-32.484375%201.2109375%20C-33.62158997%201.19157135%20-34.75880493%201.1722052%20-35.93048096%201.1522522%20C-39.51608081%201.09309804%20-43.10171391%201.04633048%20-46.6875%201%20C-49.13803382%200.96176104%20-51.58855505%200.922706%20-54.0390625%200.8828125%20C-60.00509547%200.78745036%20-65.97120608%200.70222082%20-71.9375%200.625%20C-71.9375%200.295%20-71.9375%20-0.035%20-71.9375%20-0.375%20C-64.64380354%20-0.50622409%20-57.35009361%20-0.63667157%20-50.05636597%20-0.76615143%20C-46.66891811%20-0.82631005%20-43.28147531%20-0.88672741%20-39.89404297%20-0.94775391%20C-35.99187358%20-1.01792136%20-32.08968882%20-1.08717251%20-28.1875%20-1.15625%20C-26.37922729%20-1.18906067%20-26.37922729%20-1.18906067%20-24.53442383%20-1.22253418%20C-6.5276654%20-1.53860958%20-6.5276654%20-1.53860958%200%200%20Z%20%22%20fill%3D%22%2375441D%22%20transform%3D%22translate(470.9375%2C131.375)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.5992077%202.83286663%202.25141485%204.86831579%202.25878906%208.11572266%20C2.26509338%208.91821442%202.27139771%209.72070618%202.27789307%2010.54751587%20C2.2738446%2011.41097626%202.26979614%2012.27443665%202.265625%2013.1640625%20C2.26753845%2014.07014252%202.2694519%2014.97622253%202.27142334%2015.90975952%20C2.27278467%2017.83469926%202.26909187%2019.7596482%202.26074219%2021.68457031%20C2.25021562%2024.5659787%202.26054761%2027.4467383%202.2734375%2030.328125%20C2.28232924%2039.29544283%202.08873191%2048.21780593%201.234375%2057.1484375%20C1.17364807%2057.88712067%201.11292114%2058.62580383%201.050354%2059.38687134%20C0.67297659%2062.77095469%200.20935583%2064.74311417%20-1.96362305%2067.40942383%20C-4.89803107%2069.70143537%20-7.6438275%2071.35242441%20-11%2073%20C-11.99%2072.67%20-12.98%2072.34%20-14%2072%20C-10.77332524%2069.23427878%20-7.95810083%2067.49765977%20-4%2066%20C0.97133771%2061.02866229%20-0.78025624%2048.77947619%20-0.68359375%2042.08984375%20C-0.6524221%2040.27777184%20-0.6524221%2040.27777184%20-0.62062073%2038.42909241%20C-0.55562961%2034.59861527%20-0.49647635%2030.76807399%20-0.4375%2026.9375%20C-0.39426674%2024.32876961%20-0.35065097%2021.72004552%20-0.30664062%2019.11132812%20C-0.20000042%2012.74095175%20-0.09814361%206.37051263%200%200%20Z%20%22%20fill%3D%22%23333333%22%20transform%3D%22translate(713%2C395)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-2.71949889%205.26495699%20-7.43729263%209.52767929%20-12.25%2013.6875%20C-14.6901583%2015.79870335%20-16.96654803%2017.9728712%20-19.1875%2020.3125%20C-22%2023%20-22%2023%20-24.24609375%2023.7265625%20C-28.35389889%2025.62605821%20-30.87411053%2028.7360862%20-33.875%2032.0625%20C-34.80372925%2033.07207764%20-34.80372925%2033.07207764%20-35.7512207%2034.10205078%20C-39.64511869%2038.37482837%20-43.31886196%2042.74214323%20-46.66796875%2047.4609375%20C-48%2049%20-48%2049%20-51%2050%20C-48.67613198%2042.81713521%20-43.6011842%2038.57488342%20-38.03515625%2033.8515625%20C-36.01573782%2032.01431809%20-34.30719815%2030.0968762%20-32.5625%2028%20C-28.86531746%2023.63597404%20-24.5693866%2020.39989095%20-20%2017%20C-17.07453316%2014.68207932%20-14.29516806%2012.30314558%20-11.6875%209.625%20C-8.05034338%206.07242841%20-4.05141234%203.06283242%200%200%20Z%20%22%20fill%3D%22%239A551C%22%20transform%3D%22translate(244%2C204)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-1.98%200.66%20-3.96%201.32%20-6%202%20C-6.14695312%202.91136719%20-6.29390625%203.82273437%20-6.4453125%204.76171875%20C-8.63886858%2017.4313961%20-11.93325935%2029.79977804%20-16%2042%20C-16.66%2042%20-17.32%2042%20-18%2042%20C-18.0825%2043.11375%20-18.165%2044.2275%20-18.25%2045.375%20C-18.87919026%2050.6151219%20-20.88630871%2055.20241234%20-23%2060%20C-24.21539658%2056.35381026%20-23.65987257%2055.54120732%20-22.25%2052.0625%20C-20.30255051%2046.99913132%20-18.91486074%2041.95609513%20-17.66015625%2036.68359375%20C-16.93290105%2033.72723681%20-16.0339627%2030.86328134%20-15%2028%20C-14.34%2028%20-13.68%2028%20-13%2028%20C-12.95101562%2027.20078125%20-12.90203125%2026.4015625%20-12.8515625%2025.578125%20C-12.61119853%2022.0472611%20-12.31466545%2018.52500226%20-12%2015%20C-11.91234375%2013.87980469%20-11.8246875%2012.75960938%20-11.734375%2011.60546875%20C-10.86144056%203.91036187%20-10.86144056%203.91036187%20-8.41796875%201.328125%20C-5.21745497%20-0.63934874%20-3.60112646%20-1.20037549%200%200%20Z%20%22%20fill%3D%22%23343434%22%20transform%3D%22translate(699%2C469)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C1.57892613%207.06289877%200.45144587%2013.13792855%20-1.3125%2019.9375%20C-1.63190552%2021.19880737%20-1.63190552%2021.19880737%20-1.95776367%2022.4855957%20C-2.17408447%2023.28312256%20-2.39040527%2024.08064941%20-2.61328125%2024.90234375%20C-2.80704346%2025.61898193%20-3.00080566%2026.33562012%20-3.20043945%2027.07397461%20C-4.11409664%2029.27484226%20-5.27112205%2030.38978178%20-7%2032%20C-7.98628417%2034.03077684%20-7.98628417%2034.03077684%20-8.6875%2036.1875%20C-9.06455078%2037.26064453%20-9.06455078%2037.26064453%20-9.44921875%2038.35546875%20C-9.63097656%2038.89816406%20-9.81273437%2039.44085937%20-10%2040%20C-10.66%2039.67%20-11.32%2039.34%20-12%2039%20C-11.51080078%2037.63681641%20-11.51080078%2037.63681641%20-11.01171875%2036.24609375%20C-8.23240606%2028.31600117%20-6.21527696%2020.61240874%20-4.6875%2012.33984375%20C-2.70397644%202.70397644%20-2.70397644%202.70397644%200%200%20Z%20%22%20fill%3D%22%23D1D1D1%22%20transform%3D%22translate(683%2C480)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.03940231%20-0.0033284%202.07880463%20-0.0066568%203.14970398%20-0.01008606%20C5.32872072%20-0.01511422%207.50774505%20-0.01749567%209.68676758%20-0.01733398%20C13.0198209%20-0.0195366%2016.35255123%20-0.0377797%2019.68554688%20-0.05664062%20C21.81119679%20-0.0595722%2023.93684827%20-0.06155857%2026.0625%20-0.0625%20C27.05526443%20-0.06968552%2028.04802887%20-0.07687103%2029.07087708%20-0.08427429%20C37.55785594%20-0.05614748%2037.55785594%20-0.05614748%2041.69921875%202.16796875%20C41.69921875%202.49796875%2041.69921875%202.82796875%2041.69921875%203.16796875%20C28.00512734%203.25176025%2014.32666761%202.98651367%200.63671875%202.66796875%20C-1.50194919%202.6196171%20-3.64062105%202.57143893%20-5.77929688%202.5234375%20C-10.95317235%202.40694232%20-16.1269894%202.28811857%20-21.30078125%202.16796875%20C-21.30078125%201.83796875%20-21.30078125%201.50796875%20-21.30078125%201.16796875%20C-14.18190841%200.32157753%20-7.16587933%200.00811521%200%200%20Z%20%22%20fill%3D%22%23442F1E%22%20transform%3D%22translate(408.30078125%2C124.83203125)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C1.26803029%204.73520178%200.97905671%208.4805785%20-0.41015625%2013.0234375%20C-2.1215096%2019.07413138%20-2.93484112%2025.07362055%20-3.625%2031.3125%20C-5.60819642%2048.41229462%20-5.60819642%2048.41229462%20-8%2052%20C-8.66%2052%20-9.32%2052%20-10%2052%20C-8.50548549%2040.4448512%20-6.71778238%2028.9908676%20-4.4375%2017.5625%20C-4.22778564%2016.50361572%20-4.01807129%2015.44473145%20-3.80200195%2014.35375977%20C-2.80344868%209.44929816%20-1.75086903%204.70394766%200%200%20Z%20%22%20fill%3D%22%23474747%22%20transform%3D%22translate(149%2C339)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C1.56838149%205.70157679%20-0.25620159%209.09189196%20-3%2013.875%20C-3.3815625%2014.56335938%20-3.763125%2015.25171875%20-4.15625%2015.9609375%20C-5.09291108%2017.64692745%20-6.04493248%2019.32436814%20-7%2021%20C-7.66%2021%20-8.32%2021%20-9%2021%20C-9.38865234%2022.04607422%20-9.38865234%2022.04607422%20-9.78515625%2023.11328125%20C-11.12366555%2026.29385479%20-12.71166233%2029.19975951%20-14.4375%2032.1875%20C-15.03433594%2033.23292969%20-15.63117187%2034.27835938%20-16.24609375%2035.35546875%20C-18%2038%20-18%2038%20-21%2040%20C-20.58742287%2034.49897163%20-18.45277325%2030.23798336%20-15%2026%20C-14.34%2026%20-13.68%2026%20-13%2026%20C-12.34%2023.03%20-11.68%2020.06%20-11%2017%20C-9.68%2016.67%20-8.36%2016.34%20-7%2016%20C-6.00151966%2014.15279073%20-6.00151966%2014.15279073%20-5.5%2011.875%20C-4.21276252%207.43011921%20-2.4258573%203.93156182%200%200%20Z%20%22%20fill%3D%22%23E8E8E8%22%20transform%3D%22translate(666%2C531)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.58874022%202.58874022%202.54444016%204.21220177%203.0625%207.8125%20C3.29646484%209.36904297%203.29646484%209.36904297%203.53515625%2010.95703125%20C4.88345556%2021.89243306%205.16762485%2032.8077568%205.125%2043.8125%20C5.12267365%2044.87976822%205.12267365%2044.87976822%205.12030029%2045.96859741%20C5.09584462%2055.58706815%204.97118371%2065.19953293%204.625%2074.8125%20C4.57883545%2076.28650269%204.57883545%2076.28650269%204.53173828%2077.7902832%20C4.49290527%2078.69093506%204.45407227%2079.59158691%204.4140625%2080.51953125%20C4.36693115%2081.68125854%204.36693115%2081.68125854%204.31884766%2082.86645508%20C3.96457118%2085.23706925%203.1753591%2086.92471057%202%2089%20C0.68851843%2086.37703685%201.0642323%2084.8005525%201.33984375%2081.8828125%20C1.4805127%2080.28083008%201.4805127%2080.28083008%201.62402344%2078.64648438%20C1.77919434%2076.90334961%201.77919434%2076.90334961%201.9375%2075.125%20C3.56241813%2055.01056499%203.82534596%2035.06211075%201.24365234%2015.02929688%20C0.64428965%2010.03741037%200.34212678%205.01485835%200%200%20Z%20%22%20fill%3D%22%23606060%22%20transform%3D%22translate(706%2C372)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-0.90363281%200.47050781%20-1.80726563%200.94101562%20-2.73828125%201.42578125%20C-3.92983986%202.05439878%20-5.12123772%202.68332109%20-6.3125%203.3125%20C-6.90740234%203.62123047%20-7.50230469%203.92996094%20-8.11523438%204.24804688%20C-11.54528159%206.04855807%20-11.54528159%206.04855807%20-14.46875%208.546875%20C-16.92633345%2010.87907154%20-20.06230741%2011.77329503%20-23.1875%2012.9375%20C-29.5824562%2015.40574212%20-35.74539867%2017.93610648%20-41.5625%2021.625%20C-46.34214304%2024.3212089%20-51.62002345%2025.21268636%20-57%2026%20C-56.67%2025.34%20-56.34%2024.68%20-56%2024%20C-55.01%2024%20-54.02%2024%20-53%2024%20C-53%2023.34%20-53%2022.68%20-53%2022%20C-47.91059256%2019.94637945%20-43.45479185%2018.56820748%20-38%2018%20C-38%2017.34%20-38%2016.68%20-38%2016%20C-34.10418717%2013.83565954%20-30.25627188%2012.40184924%20-26%2011.0625%20C-21.41750223%209.57262388%20-17.88094435%207.91070826%20-14%205%20C-12.63453921%204.08969281%20-11.25888914%203.19453923%20-9.875%202.3125%20C-8.91207031%201.68794922%20-8.91207031%201.68794922%20-7.9296875%201.05078125%20C-5.03380059%20-0.52612883%20-3.04512148%20-1.52256074%200%200%20Z%20%22%20fill%3D%22%23313131%22%20transform%3D%22translate(551%2C537)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.02137894%203.17677233%200.94366995%205.23360036%200.14453125%208.45703125%20C-0.06389404%209.31498291%20-0.27231934%2010.17293457%20-0.48706055%2011.05688477%20C-0.71820557%2011.96623779%20-0.94935059%2012.87559082%20-1.1875%2013.8125%20C-1.41800049%2014.75085693%20-1.64850098%2015.68921387%20-1.88598633%2016.65600586%20C-3.24484308%2022.14627461%20-4.69364446%2027.60766385%20-6.1875%2033.0625%20C-7.89458878%2039.3241293%20-9.09090747%2045.57654358%20-10%2052%20C-10.66%2052%20-11.32%2052%20-12%2052%20C-7.61800699%2013.96634615%20-7.61800699%2013.96634615%200%200%20Z%20%22%20fill%3D%22%235B5B5B%22%20transform%3D%22translate(155%2C330)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C17.30295916%200.26508712%2034.28707284%203.64450989%2051%208%20C51%208.33%2051%208.66%2051%209%20C50.44054687%208.93941406%2049.88109375%208.87882813%2049.3046875%208.81640625%20C44.34967027%208.29859898%2039.41174142%207.90677784%2034.4375%207.625%20C26.16382662%207.06315142%2018.1352396%205.53369271%2010%204%20C8.00097316%203.66087938%206.0013358%203.32521707%204%203%20C4%202.34%204%201.68%204%201%20C2.68%200.67%201.36%200.34%200%200%20Z%20%22%20fill%3D%22%233D2713%22%20transform%3D%22translate(446%2C126)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C6.0005344%202.9335946%2010.45700082%206.96331944%2015.32421875%2011.5078125%20C17.42634085%2013.4657014%2019.55298635%2015.33990247%2021.75%2017.1875%20C28.52828437%2023.05441841%2034.70495567%2029.62503812%2041%2036%20C40.505%2036.99%2040.505%2036.99%2040%2038%20C39.43079834%2037.40985107%2038.86159668%2036.81970215%2038.27514648%2036.21166992%20C35.67330294%2033.52633064%2033.05568032%2030.85690957%2030.4375%2028.1875%20C29.54224609%2027.25873047%2028.64699219%2026.32996094%2027.72460938%2025.37304688%20C22.99781514%2020.57699558%2019.34331336%2017.2350331%2013%2015%20C10.890625%2013.24609375%2010.890625%2013.24609375%209.25%2011.4375%20C7.18519855%209.19419936%205.58181252%207.72120834%203%206%20C3%205.34%203%204.68%203%204%20C2.01%203.67%201.02%203.34%200%203%20C0%202.01%200%201.02%200%200%20Z%20%22%20fill%3D%22%23200E01%22%20transform%3D%22translate(599%2C185)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C4.88564575%203.94609849%209.05810377%208.11522946%2013%2013%20C13.78375%2013.969375%2014.5675%2014.93875%2015.375%2015.9375%20C15.91125%2016.618125%2016.4475%2017.29875%2017%2018%20C12.72886302%2020.18326108%208.49797113%2022.31326082%204%2024%20C4.66%2023.01%205.32%2022.02%206%2021%20C6.5871916%2015.91100618%205.77322116%2013.07753735%203.0234375%208.77734375%20C1.41455102%205.98328517%200.76410029%203.12007619%200%200%20Z%20%22%20fill%3D%22%2398490A%22%20transform%3D%22translate(637%2C232)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.66%201.32%201.32%202%202%20C0.99319462%203.11697254%20-0.03138341%204.21793008%20-1.0625%205.3125%20C-1.63097656%205.92738281%20-2.19945312%206.54226562%20-2.78515625%207.17578125%20C-5.08157239%209.06718573%20-7.32824559%2010.11447817%20-10.07983398%2011.21166992%20C-13.48165409%2012.60829766%20-16.72535605%2014.3313117%20-20%2016%20C-24.93716961%2018.5158757%20-29.88380436%2020.86825182%20-35%2023%20C-35%2022.01%20-35%2021.02%20-35%2020%20C-33.23002526%2019.18563132%20-31.45898848%2018.3735706%20-29.6875%2017.5625%20C-28.70136719%2017.11003906%20-27.71523438%2016.65757812%20-26.69921875%2016.19140625%20C-24%2015%20-24%2015%20-21%2014%20C-20.236875%2013.195625%20-19.47375%2012.39125%20-18.6875%2011.5625%20C-15.76523612%208.77615537%20-13.81618496%208.11305395%20-10%207%20C-6.33589668%205.03389578%20-3.19840612%202.65010793%200%200%20Z%20%22%20fill%3D%22%238E4206%22%20transform%3D%22translate(323%2C153)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.11353866%203.74626219%200.80746732%205.47543872%20-1%209%20C-1.43828125%209.4021875%20-1.8765625%209.804375%20-2.328125%2010.21875%20C-4.75363417%2012.80293734%20-6.30560597%2015.8512823%20-8%2018.9375%20C-11.63892169%2025.52449546%20-11.63892169%2025.52449546%20-13.6640625%2028.19140625%20C-15.08374114%2030.11336885%20-15.69041129%2031.72396479%20-16.375%2034%20C-17.72788088%2037.87777621%20-19.5056121%2039.73337001%20-23%2042%20C-22.86897997%2035.97307865%20-20.71183472%2032.84224997%20-17.16796875%2028.078125%20C-14.03628069%2023.63169222%20-11.36160686%2018.94590349%20-8.64086914%2014.24072266%20C-5.85635302%209.43054262%20-2.975039%204.69486038%200%200%20Z%20%22%20fill%3D%22%232B2B2B%22%20transform%3D%22translate(654%2C540)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C5.44693314%20-0.09688221%2010.63904667%20-0.12862175%2016%201%20C16%201.66%2016%202.32%2016%203%20C14.988806%203.00879936%2014.988806%203.00879936%2013.95718384%203.01777649%20C6.84977932%203.08242185%20-0.25720165%203.16701057%20-7.36425781%203.26245117%20C-10.00589382%203.2969509%20-12.64726148%203.32353071%20-15.2890625%203.34643555%20C-28.82817037%203.46695412%20-42.03301469%203.5953204%20-55.32275391%206.36791992%20C-59.33960982%207.05837537%20-62.93450004%207.10511795%20-67%207%20C-67%206.67%20-67%206.34%20-67%206%20C-44.81786128%201.21437817%20-22.58742725%201.18494682%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%238B5B34%22%20transform%3D%22translate(440%2C128)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.79540355%202.29443332%201.16371327%203.54502939%200.328125%205.8671875%20C-0.20554687%206.86105469%20-0.20554687%206.86105469%20-0.75%207.875%20C-2.67489773%2011.86982201%20-3.6541481%2015.64856188%20-4.5%2020%20C-6.14314994%2028.23351349%20-8.48832937%2034.59935024%20-14%2041%20C-15.0268343%2042.6502694%20-16.03567924%2044.31243867%20-17%2046%20C-17.6328125%2044.2109375%20-17.6328125%2044.2109375%20-18%2042%20C-16.84712785%2040.16896777%20-15.68454609%2038.34329798%20-14.47265625%2036.55078125%20C-12.05514348%2032.36341828%20-10.65874121%2027.83543414%20-9.11328125%2023.26953125%20C-8.15924073%2020.46766487%20-7.1033589%2017.74471925%20-6%2015%20C-5.50985567%2013.5244346%20-5.0303323%2012.0452905%20-4.5625%2010.5625%20C-3.34672387%206.85314221%20-1.85472925%203.44449719%200%200%20Z%20%22%20fill%3D%22%23808080%22%20transform%3D%22translate(673%2C498)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1%203%201%203%200.27734375%204.9453125%20C-1.10682751%207.17183874%20-2.64907663%208.95965627%20-4.4375%2010.875%20C-7.31703434%2014.09225751%20-9.15838884%2017.07656752%20-11%2021%20C-11.88414117%2022.32822474%20-12.7860293%2023.64470168%20-13.69921875%2024.953125%20C-17.33275141%2030.34903307%20-20.29186341%2036.02629564%20-23.25%2041.8125%20C-23.77851563%2042.83537109%20-24.30703125%2043.85824219%20-24.8515625%2044.91210938%20C-26.92482522%2048.92971366%20-28.98494932%2052.95285182%20-31%2057%20C-32%2054%20-32%2054%20-31.27832031%2051.92553711%20C-30.68422363%2050.7384314%20-30.68422363%2050.7384314%20-30.078125%2049.52734375%20C-29.63525146%2048.63660156%20-29.19237793%2047.74585938%20-28.73608398%2046.828125%20C-28.24567627%2045.87421875%20-27.75526855%2044.9203125%20-27.25%2043.9375%20C-26.74992432%2042.95394531%20-26.24984863%2041.97039062%20-25.73461914%2040.95703125%20C-18.29198818%2026.52170754%20-9.66350289%2013.03839219%200%200%20Z%20%22%20fill%3D%22%23171717%22%20transform%3D%22translate(182%2C245)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C8.72582538%2010.50381488%2013.03632531%2025.26107379%2017.625%2037.9375%20C18.07496338%2039.16404297%2018.52492676%2040.39058594%2018.98852539%2041.65429688%20C19.39707764%2042.80865234%2019.80562988%2043.96300781%2020.2265625%2045.15234375%20C20.59346191%2046.18351318%2020.96036133%2047.21468262%2021.33837891%2048.27709961%20C22.00807107%2051.03321648%2021.97910851%2052.38004338%2021%2055%20C20.71801758%2054.19892822%2020.43603516%2053.39785645%2020.14550781%2052.57250977%20C19.0823377%2049.55779991%2018.01587013%2046.54428157%2016.94726562%2043.53149414%20C16.4882899%2042.23540197%2016.03057363%2040.93886299%2015.57421875%2039.6418457%20C13.18601149%2032.85692792%2010.78305801%2026.15200426%207.69042969%2019.65209961%20C7%2018%207%2018%207%2016%20C6.01%2016%205.02%2016%204%2016%20C1.18150494%2010.45108785%20-0.5326514%206.258654%200%200%20Z%20%22%20fill%3D%22%23171717%22%20transform%3D%22translate(682%2C283)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C6.80840346%201.22023787%2013.31958043%202.85994951%2019.875%205.0625%20C21.21606812%205.51061035%2021.21606812%205.51061035%2022.58422852%205.96777344%20C34.44682324%2010.0456378%2045.82139361%2015.32995246%2057%2021%20C57%2021.33%2057%2021.66%2057%2022%20C51.36529617%2022.5497272%2048.61012242%2020.95047835%2044%2018%20C44%2017.34%2044%2016.68%2044%2016%20C43.443125%2015.81824219%2042.88625%2015.63648438%2042.3125%2015.44921875%20C38.56590898%2014.21512205%2034.85306199%2012.95850782%2031.1875%2011.5%20C26.77346597%209.80914019%2022.22914369%208.74215202%2017.63671875%207.6484375%20C15%207%2015%207%2012%206%20C12%205.34%2012%204.68%2012%204%20C11.30132812%203.87882813%2010.60265625%203.75765625%209.8828125%203.6328125%20C8.97273438%203.46523437%208.06265625%203.29765625%207.125%203.125%20C5.76761719%202.88136719%205.76761719%202.88136719%204.3828125%202.6328125%20C2%202%202%202%200%200%20Z%20%22%20fill%3D%22%231C0F04%22%20transform%3D%22translate(497%2C135)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.0625%200.4375%202.0625%200.4375%204%201%20C3.09378906%201.88300781%202.18757813%202.76601562%201.25390625%203.67578125%20C-5.34275937%2010.15908652%20-11.57199329%2016.57746187%20-17.1328125%2023.98828125%20C-19.12014768%2026.12944782%20-20.1433726%2026.66355277%20-23%2027%20C-18.93601985%2021.40272331%20-14.62224061%2016.14305645%20-10%2011%20C-9.20464844%2010.11183594%20-8.40929687%209.22367188%20-7.58984375%208.30859375%20C-1.29079861%201.29079861%20-1.29079861%201.29079861%200%200%20Z%20%22%20fill%3D%22%23B16527%22%20transform%3D%22translate(218%2C227)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.80431587%202.30227069%201.18319392%203.52470479%200.29077148%205.84008789%20C-0.09522217%206.46133545%20-0.48121582%207.08258301%20-0.87890625%207.72265625%20C-1.30300781%208.42108643%20-1.72710938%209.1195166%20-2.1640625%209.83911133%20C-2.62554688%2010.57282959%20-3.08703125%2011.30654785%20-3.5625%2012.0625%20C-4.49219679%2013.58774311%20-5.42058287%2015.11378592%20-6.34765625%2016.640625%20C-7.03045654%2017.7553418%20-7.03045654%2017.7553418%20-7.72705078%2018.89257812%20C-10.7108212%2023.83233767%20-13.55243327%2028.91335966%20-16.00390625%2034.140625%20C-17.48545114%2036.90617547%20-19.79025394%2038.79025394%20-22%2041%20C-23.01656081%2042.65661761%20-24.02065076%2044.32111559%20-25%2046%20C-25.99%2046.495%20-25.99%2046.495%20-27%2047%20C-26.48307868%2042.64860261%20-25.05803598%2040.50930988%20-22.1875%2037.25%20C-19.0170162%2033.43980796%20-16.94683817%2030.06945611%20-15.12890625%2025.49609375%20C-12.66196802%2020.04151406%20-9.18804886%2015.05374481%20-6%2010%20C-5.19755859%208.56914063%20-5.19755859%208.56914063%20-4.37890625%207.109375%20C-3.92386719%206.41328125%20-3.46882812%205.7171875%20-3%205%20C-2.34%205%20-1.68%205%20-1%205%20C-0.67%203.35%20-0.34%201.7%200%200%20Z%20%22%20fill%3D%22%235F5F5F%22%20transform%3D%22translate(654%2C544)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-3.96919341%202.95743823%20-7.35802067%205.25925775%20-12%207%20C-13.19465207%207.69620313%20-14.38172844%208.4055065%20-15.5625%209.125%20C-19%2011%20-19%2011%20-23%2011%20C-23%2011.66%20-23%2012.32%20-23%2013%20C-23.88042969%2013.32613281%20-24.76085937%2013.65226562%20-25.66796875%2013.98828125%20C-27.41013672%2014.64376953%20-27.41013672%2014.64376953%20-29.1875%2015.3125%20C-30.33605469%2015.74175781%20-31.48460937%2016.17101562%20-32.66796875%2016.61328125%20C-35.98994582%2017.88609653%20-35.98994582%2017.88609653%20-38.73828125%2019.73046875%20C-39.48464844%2020.14941406%20-40.23101563%2020.56835938%20-41%2021%20C-41.99%2020.67%20-42.98%2020.34%20-44%2020%20C-41.80632513%2017.56412127%20-39.82130477%2016.27807636%20-36.8125%2015%20C-35.61560547%2014.48953125%20-35.61560547%2014.48953125%20-34.39453125%2013.96875%20C-32.27374741%2013.11074936%20-30.14632163%2012.29142922%20-28%2011.5%20C-19.77168638%208.54850137%20-19.77168638%208.54850137%20-12.4375%203.9375%20C-9.17275888%201.34244937%20-4.05218466%20-2.02609233%200%200%20Z%20%22%20fill%3D%22%23A77D5B%22%20transform%3D%22translate(640%2C257)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-0.33%200.99%20-0.66%201.98%20-1%203%20C-1.598125%202.773125%20-2.19625%202.54625%20-2.8125%202.3125%20C-3.8953125%202.1578125%20-3.8953125%202.1578125%20-5%202%20C-5.4125%202.45375%20-5.825%202.9075%20-6.25%203.375%20C-8.6008259%205.55790976%20-10.70008139%205.35323051%20-13.79296875%205.6171875%20C-17.55448641%206.26962773%20-20.71450187%208.12132421%20-24%2010%20C-24%207%20-24%207%20-22.75%204.5%20C-18.50307113%200.63915557%20-13.52556264%200.07461665%20-8%20-1%20C-7.11183594%20-1.23203125%20-6.22367187%20-1.4640625%20-5.30859375%20-1.703125%20C-3%20-2%20-3%20-2%200%200%20Z%20%22%20fill%3D%22%238F4206%22%20transform%3D%22translate(354%2C148)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-3.4019487%202.09350689%20-6.05272412%202.17942163%20-10%202%20C-10.309375%202.8971875%20-10.309375%202.8971875%20-10.625%203.8125%20C-12.52919641%206.84190338%20-14.76615434%207.57710791%20-18%209%20C-18.680625%209.37125%20-19.36125%209.7425%20-20.0625%2010.125%20C-22.34149835%2011.15422506%20-24.54053584%2011.59008931%20-27%2012%20C-25.625%209.5%20-25.625%209.5%20-24%207%20C-23.34%207%20-22.68%207%20-22%207%20C-22.33%206.34%20-22.66%205.68%20-23%205%20C-25.02463255%204.34786708%20-25.02463255%204.34786708%20-27%204%20C-21.97290428%202.49515697%20-16.96607895%201.29482538%20-11.8125%200.3125%20C-10.76545898%200.09883789%20-10.76545898%200.09883789%20-9.69726562%20-0.11914062%20C-6.20395135%20-0.78722452%20-3.37880534%20-1.30088371%200%200%20Z%20%22%20fill%3D%22%23743E13%22%20transform%3D%22translate(373%2C136)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.53398049%203.07455689%203.96293359%206.04527132%205.375%209.76171875%20C6.01695312%2011.44104492%206.01695312%2011.44104492%206.671875%2013.15429688%20C7.11015625%2014.32025391%207.5484375%2015.48621094%208%2016.6875%20C8.43828125%2017.83412109%208.8765625%2018.98074219%209.328125%2020.16210938%20C16.44284814%2038.8811174%2016.44284814%2038.8811174%2016%2047%20C15.67%2047%2015.34%2047%2015%2047%20C14.1606242%2043.89743488%2013.3295495%2040.79270556%2012.5%2037.6875%20C12.26152344%2036.80642578%2012.02304687%2035.92535156%2011.77734375%2035.01757812%20C11.43896484%2033.74624023%2011.43896484%2033.74624023%2011.09375%2032.44921875%20C10.77954102%2031.27879028%2010.77954102%2031.27879028%2010.45898438%2030.0847168%20C10%2028%2010%2028%2010%2025%20C9.34%2025%208.68%2025%208%2025%20C7.67%2025.99%207.34%2026.98%207%2028%20C6.34%2025.03%205.68%2022.06%205%2019%20C4.67%2019%204.34%2019%204%2019%20C3.52040222%2016.77092605%203.0413392%2014.54173703%202.5625%2012.3125%20C2.16224609%2010.45044922%202.16224609%2010.45044922%201.75390625%208.55078125%20C1.14944864%205.70387985%200.56235316%202.85544374%200%200%20Z%20%22%20fill%3D%22%23313131%22%20transform%3D%22translate(688%2C299)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-0.73863281%200.30292969%20-1.47726562%200.60585937%20-2.23828125%200.91796875%20C-11.00924449%204.54003108%20-19.64196124%208.36957921%20-28.18359375%2012.50390625%20C-29.1176001%2012.95419189%20-30.05160645%2013.40447754%20-31.01391602%2013.8684082%20C-32.89580688%2014.77715642%20-34.77528465%2015.69092183%20-36.65209961%2016.61010742%20C-37.52745361%2017.03267822%20-38.40280762%2017.45524902%20-39.3046875%2017.890625%20C-40.4800708%2018.46345215%20-40.4800708%2018.46345215%20-41.67919922%2019.04785156%20C-44.10956605%2020.04495136%20-46.41405056%2020.56853156%20-49%2021%20C-46.77904818%2018.53628991%20-44.70339666%2017.20941712%20-41.69140625%2015.84375%20C-40.86189453%2015.46089844%20-40.03238281%2015.07804687%20-39.17773438%2014.68359375%20C-38.31470703%2014.29300781%20-37.45167969%2013.90242187%20-36.5625%2013.5%20C-34.85350032%2012.72306541%20-33.14639524%2011.94194702%20-31.44140625%2011.15625%20C-30.68545166%2010.81400391%20-29.92949707%2010.47175781%20-29.15063477%2010.11914062%20C-26.9415091%209.04515968%20-26.9415091%209.04515968%20-24.94311523%207.44750977%20C-22.09197766%205.32357527%20-18.85723512%204.47074615%20-15.5%203.4375%20C-10.51220766%201.93139001%20-10.51220766%201.93139001%20-5.78125%20-0.21484375%20C-3.49385575%20-1.22310306%20-2.30660977%20-0.8237892%200%200%20Z%20%22%20fill%3D%22%23A8774F%22%20transform%3D%22translate(329%2C146)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.70661294%203.5640514%20-6.51425647%204.28077891%20-10.625%205.4375%20C-15.93716393%207.00747495%20-20.96261018%208.72003291%20-25.98046875%2011.08984375%20C-31.07827274%2013.38730667%20-36.47686291%2015.10917144%20-42%2016%20C-36.8248121%2011.97485385%20-31.5893799%209.29968095%20-25.4375%207.0625%20C-24.38502075%206.67553955%20-24.38502075%206.67553955%20-23.3112793%206.28076172%20C-21.21016735%205.51294207%20-19.10576767%204.75494548%20-17%204%20C-15.83210938%203.57847656%20-14.66421875%203.15695313%20-13.4609375%202.72265625%20C-4.98202309%20-0.23339207%20-4.98202309%20-0.23339207%200%200%20Z%20%22%20fill%3D%22%23F6D1A9%22%20transform%3D%22translate(341%2C139)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.17041159%207.76139184%200.91086196%2015.90650309%200.125%2023.8125%20C0.04660889%2024.63693604%20-0.03178223%2025.46137207%20-0.11254883%2026.31079102%20C-0.56034316%2030.52469453%20-1.13341596%2034.13350448%20-3%2038%20C-4.27593588%2034.22890063%20-3.89166397%2030.86714893%20-3.5625%2026.9375%20C-3.1906014%2022.27772938%20-2.95871348%2017.67688012%20-3.0625%2013%20C-3.11518159%208.58791724%20-2.52911368%205.13760172%20-1%201%20C-0.67%200.67%20-0.34%200.34%200%200%20Z%20%22%20fill%3D%22%23A2A2A2%22%20transform%3D%22translate(686%2C407)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200%201.32%200%202%200%20C2.50546036%202.08201528%203.00416835%204.16567067%203.5%206.25%20C3.7784375%207.41015625%204.056875%208.5703125%204.34375%209.765625%20C5%2013%205%2013%205%2017%20C5.66%2017%206.32%2017%207%2017%20C10.09424624%2025.85912168%2010.33786247%2033.72755227%2010%2043%20C7.94597102%2039.35575504%207.62533506%2036.32989187%207.34375%2032.21875%20C7.11935065%2029.99471741%207.11935065%2029.99471741%206.05908203%2028.17773438%20C4.8909639%2025.77579484%204.30275497%2023.54053848%203.7109375%2020.9375%20C3.38222656%2019.49503906%203.38222656%2019.49503906%203.046875%2018.0234375%20C2.82515625%2017.02570313%202.6034375%2016.02796875%202.375%2015%20C2.14554688%2014.00226563%201.91609375%2013.00453125%201.6796875%2011.9765625%20C0.7482778%207.84065993%200%204.26265%200%200%20Z%20%22%20fill%3D%22%234F4F4F%22%20transform%3D%22translate(700%2C344)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-1.27227629%204.4246617%20-4.78775802%207.38732066%20-8.5%2010.3125%20C-9.35271484%2011.01342773%20-9.35271484%2011.01342773%20-10.22265625%2011.72851562%20C-11.90625%2013.05078125%20-11.90625%2013.05078125%20-15%2015%20C-17.19335938%2014.62182617%20-17.19335938%2014.62182617%20-19%2014%20C-16.58820862%2012.0356004%20-14.16974955%2010.07958512%20-11.75%208.125%20C-11.06808594%207.56941406%20-10.38617188%207.01382813%20-9.68359375%206.44140625%20C-9.01972656%205.90644531%20-8.35585937%205.37148437%20-7.671875%204.8203125%20C-7.0644043%204.32805176%20-6.45693359%203.83579102%20-5.83105469%203.32861328%20C-3.93762896%201.95474357%20-2.17245298%200.87245085%200%200%20Z%20M-21%2015%20C-20.34%2015.33%20-19.68%2015.66%20-19%2016%20C-19.99%2016%20-20.98%2016%20-22%2016%20C-21.67%2015.67%20-21.34%2015.34%20-21%2015%20Z%20M-23%2017%20C-23%2017.99%20-23%2018.98%20-23%2020%20C-23.99%2020%20-24.98%2020%20-26%2020%20C-25.01%2019.01%20-24.02%2018.02%20-23%2017%20Z%20M-28%2021%20C-27.34%2021.33%20-26.68%2021.66%20-26%2022%20C-28.86536704%2026.07763771%20-31.43041625%2028.02677065%20-36%2030%20C-36%2029.34%20-36%2028.68%20-36%2028%20C-34.25%2026.2734375%20-34.25%2026.2734375%20-32%2024.375%20C-31.2575%2023.74335938%20-30.515%2023.11171875%20-29.75%2022.4609375%20C-29.1725%2021.97882813%20-28.595%2021.49671875%20-28%2021%20Z%20%22%20fill%3D%22%23783806%22%20transform%3D%22translate(263%2C185)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C6.21394924%201.62620374%2011.68351561%203.74877755%2017.35546875%206.75%20C20.24760272%208.11703526%2023.1242254%209.02195093%2026.1875%209.9375%20C31.69799364%2011.66530639%2034.93508814%2013.93508814%2039%2018%20C38.01%2018.495%2038.01%2018.495%2037%2019%20C34.85546875%2018.21484375%2034.85546875%2018.21484375%2032.1875%2016.9375%20C31.20910156%2016.47601562%2030.23070312%2016.01453125%2029.22265625%2015.5390625%20C28.15917969%2015.03117188%2027.09570312%2014.52328125%2026%2014%20C23.70985973%2012.93421395%2021.41819384%2011.87169988%2019.125%2010.8125%20C18.07570313%2010.32394531%2017.02640625%209.83539062%2015.9453125%209.33203125%20C14.11267634%208.50321304%2012.26145622%207.71297252%2010.38671875%206.984375%20C7.97955344%205.99156705%205.88755178%204.82547994%203.6875%203.4375%20C2.99011719%203.00308594%202.29273438%202.56867187%201.57421875%202.12109375%20C1.05472656%201.75113281%200.53523438%201.38117187%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23434343%22%20transform%3D%22translate(276%2C530)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.1875%20-0.25%202.1875%20-0.25%205%200%20C5.70125%200.5775%206.4025%201.155%207.125%201.75%20C10.63371448%204.49595046%2014.07837616%205.59727759%2018.28125%206.97265625%20C21.1106603%208.0418156%2023.41063599%209.44257371%2026%2011%20C28.63751316%2012.23517842%2031.31743526%2013.36659165%2034%2014.5%20C38.53199822%2016.41481106%2042.8414498%2018.33592878%2047%2021%20C45%2022%2045%2022%2041.5%2020.875%20C37.43670661%2019.26722204%2033.58933968%2017.31110346%2029.703125%2015.3203125%20C26.84313039%2013.92337871%2023.94713047%2012.70152242%2021%2011.5%20C15.52061231%209.26423948%2010.24901872%206.72902522%205%204%20C5%203.34%205%202.68%205%202%20C3.35%201.67%201.7%201.34%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23C97633%22%20transform%3D%22translate(262%2C285)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66015625%201.78125%200.66015625%201.78125%201%204%20C-0.00390625%205.71875%20-0.00390625%205.71875%20-1.5625%207.5%20C-5.63519986%2012.53603168%20-8.2570965%2018.16403512%20-11%2024%20C-11.66%2024%20-12.32%2024%20-13%2024%20C-13.226875%2024.78375%20-13.45375%2025.5675%20-13.6875%2026.375%20C-15.40660933%2031.12301625%20-17.68084721%2035.52102552%20-20%2040%20C-21.07484617%2037.28809273%20-21.07012465%2036.18750568%20-20.03125%2033.40966797%20C-19.5259375%2032.44689941%20-19.020625%2031.48413086%20-18.5%2030.4921875%20C-17.94183594%2029.42226563%20-17.38367188%2028.35234375%20-16.80859375%2027.25%20C-16.21175781%2026.13625%20-15.61492187%2025.0225%20-15%2023.875%20C-14.43410156%2022.78445313%20-13.86820313%2021.69390625%20-13.28515625%2020.5703125%20C-5.15160206%205.15160206%20-5.15160206%205.15160206%200%200%20Z%20%22%20fill%3D%22%23767676%22%20transform%3D%22translate(184%2C269)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C0.27832031%204.05273438%200.27832031%204.05273438%20-0.921875%206.59375%20C-1.3653125%207.53379883%20-1.80875%208.47384766%20-2.265625%209.44238281%20C-2.75546875%2010.45139648%20-3.2453125%2011.46041016%20-3.75%2012.5%20C-4.245%2013.52706055%20-4.74%2014.55412109%20-5.25%2015.61230469%20C-16.81028149%2039.17805528%20-16.81028149%2039.17805528%20-24%2046%20C-23.41512359%2041.99251347%20-22.15605425%2039.14263232%20-20.0625%2035.6875%20C-19.53785156%2034.80449219%20-19.01320313%2033.92148437%20-18.47265625%2033.01171875%20C-17.98667969%2032.34785156%20-17.50070312%2031.68398438%20-17%2031%20C-16.34%2031%20-15.68%2031%20-15%2031%20C-14.73058594%2030.13503906%20-14.46117187%2029.27007813%20-14.18359375%2028.37890625%20C-13.02463335%2025.07032292%20-11.64688718%2022.06192764%20-10.0625%2018.9375%20C-9.55847656%2017.93589844%20-9.05445313%2016.93429687%20-8.53515625%2015.90234375%20C-7.5439635%2014.02840936%20-6.50480265%2012.17872676%20-5.41015625%2010.36328125%20C-4.20621086%208.34558884%20-3.24990652%206.42284477%20-2.375%204.25%20C-1%201%20-1%201%200%200%20Z%20%22%20fill%3D%22%232D2D2D%22%20transform%3D%22translate(674%2C529)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0%200.33%200%200.66%200%201%20C-0.74459473%201.13051758%20-1.48918945%201.26103516%20-2.25634766%201.39550781%20C-20.45947898%204.56957758%20-20.45947898%204.56957758%20-38.30078125%209.28515625%20C-42.00883761%2010.26717407%20-45.19258153%2010.30459348%20-49%2010%20C-45.95081311%207.96720874%20-43.97041483%207.36997777%20-40.44140625%206.5625%20C-39.33216797%206.30726563%20-38.22292969%206.05203125%20-37.08007812%205.7890625%20C-35.91927734%205.52867187%20-34.75847656%205.26828125%20-33.5625%205%20C-31.87350586%204.60941406%20-31.87350586%204.60941406%20-30.15039062%204.2109375%20C-9.97383413%20-0.383609%20-9.97383413%20-0.383609%200%200%20Z%20%22%20fill%3D%22%233D2C1F%22%20transform%3D%22translate(387%2C127)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.09375%203.76660156%201.09375%203.76660156%200.25%205.8671875%20C-0.1625%206.52976562%20-0.575%207.19234375%20-1%207.875%20C-3.46608258%2012.02218676%20-5.6749028%2016.24031343%20-7.8125%2020.5625%20C-8.12638672%2021.19462402%20-8.44027344%2021.82674805%20-8.76367188%2022.47802734%20C-9.51088873%2023.98447286%20-10.25570627%2025.4921081%20-11%2027%20C-11.66%2027%20-12.32%2027%20-13%2027%20C-13.185625%2027.804375%20-13.37125%2028.60875%20-13.5625%2029.4375%20C-15.53232435%2034.31923861%20-18.65622186%2037.97673753%20-22%2042%20C-22%2037.9410721%20-20.29808181%2036.3194515%20-18%2033%20C-16.64849159%2030.67529001%20-15.31608816%2028.34460363%20-14%2026%20C-13.40880371%2024.9488501%20-13.40880371%2024.9488501%20-12.80566406%2023.87646484%20C-11.53293587%2021.60744942%20-10.26588523%2019.33533939%20-9%2017.0625%20C-8.57460938%2016.30259766%20-8.14921875%2015.54269531%20-7.7109375%2014.75976562%20C-5.00531712%209.90043823%20-2.45323552%204.99165282%200%200%20Z%20%22%20fill%3D%22%23656565%22%20transform%3D%22translate(670%2C533)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.4123551%204.44700997%200.07203271%207.78682621%20-1.375%2012.0625%20C-1.60960937%2012.78244141%20-1.84421875%2013.50238281%20-2.0859375%2014.24414062%20C-2.71407251%2016.16601963%20-3.35630848%2018.08327526%20-4%2020%20C-4.33%2020.99%20-4.66%2021.98%20-5%2023%20C-5.66%2023%20-6.32%2023%20-7%2023%20C-7.12246094%2023.71542969%20-7.24492188%2024.43085938%20-7.37109375%2025.16796875%20C-8.01135375%2028.05112713%20-8.93551556%2030.58592473%20-10.0625%2033.3125%20C-10.42472656%2034.19550781%20-10.78695312%2035.07851563%20-11.16015625%2035.98828125%20C-11.43730469%2036.65214844%20-11.71445312%2037.31601562%20-12%2038%20C-13%2036%20-13%2036%20-12.58422852%2034.2512207%20C-12.33084717%2033.54570068%20-12.07746582%2032.84018066%20-11.81640625%2032.11328125%20C-11.53297363%2031.30842285%20-11.24954102%2030.50356445%20-10.95751953%2029.67431641%20C-10.64153809%2028.79179199%20-10.32555664%2027.90926758%20-10%2027%20C-9.34075707%2025.07740186%20-8.68327032%2023.15420084%20-8.02734375%2021.23046875%20C-7.33136335%2019.21592662%20-6.63474042%2017.20160637%20-5.9375%2015.1875%20C-5.58623047%2014.16462891%20-5.23496094%2013.14175781%20-4.87304688%2012.08789062%20C-4.53208984%2011.10369141%20-4.19113281%2010.11949219%20-3.83984375%209.10546875%20C-3.38146118%207.77745239%20-3.38146118%207.77745239%20-2.91381836%206.42260742%20C-2.07176672%204.19025946%20-1.1106119%202.10939666%200%200%20Z%20%22%20fill%3D%22%23979797%22%20transform%3D%22translate(680%2C483)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C6.25239269%201.10929548%2011.23641852%202.883608%2016.8359375%205.87890625%20C19.08261963%207.11398332%2019.08261963%207.11398332%2022%208%20C22%208.66%2022%209.32%2022%2010%20C22.515625%2010.0825%2023.03125%2010.165%2023.5625%2010.25%20C27.04455732%2011.32140225%2029.87200885%2013.13523605%2033%2015%20C31%2016%2031%2016%2028.2421875%2015.1796875%20C22.40281179%2012.91709877%2017.03179619%2010.64713329%2011.84765625%207.125%20C9.82757844%205.89501605%207.85890417%205.14228014%205.625%204.375%20C2%203%202%203%200%200%20Z%20%22%20fill%3D%22%23BA7944%22%20transform%3D%22translate(221%2C266)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C4.78014159%201.22046168%209.06239381%202.86159611%2013.53515625%204.93359375%20C16.2121779%206.09179805%2018.9224095%207.01080074%2021.6875%207.9375%20C24.9795933%209.10183258%2027.53253236%2010.15169829%2030.125%2012.5%20C33.30602625%2015.26610978%2036.26058841%2016.57661353%2040.14453125%2018.10546875%20C42%2019%2042%2019%2043%2021%20C36.7087879%2018.56469209%2030.52494952%2016.09409298%2024.875%2012.375%20C21.35449655%2010.09498891%2018.08082678%209.05538624%2014%208%20C10.63959614%206.73182997%207.31786958%205.37521355%204%204%20C4%203.34%204%202.68%204%202%20C2.68%201.67%201.36%201.34%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23A57D5C%22%20transform%3D%22translate(302%2C305)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C3.82177543%201.51428838%206.91288228%202.97942901%2010.3125%205.3125%20C11.25%208.0625%2011.25%208.0625%2011.3125%2010.3125%20C6.04832038%209.90756311%203.78980515%209.25344584%200.3125%205.3125%20C-0.595%204.77625%20-1.5025%204.24%20-2.4375%203.6875%20C-3.18%203.23375%20-3.9225%202.78%20-4.6875%202.3125%20C-4.6875%201.6525%20-4.6875%200.9925%20-4.6875%200.3125%20C-2.6875%20-0.6875%20-2.6875%20-0.6875%200%200%20Z%20%22%20fill%3D%22%233A1B03%22%20transform%3D%22translate(556.6875%2C157.6875)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.29228557%203.69112221%200.73540388%206.50968327%200.00390625%2010.3046875%20C-0.22490234%2011.52800781%20-0.45371094%2012.75132812%20-0.68945312%2014.01171875%20C-0.93630859%2015.28660156%20-1.18316406%2016.56148438%20-1.4375%2017.875%20C-1.92021788%2020.39230335%20-2.39825138%2022.91051049%20-2.87109375%2025.4296875%20C-3.08693115%2026.54585449%20-3.30276855%2027.66202148%20-3.52514648%2028.81201172%20C-3.98930844%2031.92822088%20-4.08569876%2034.85494453%20-4%2038%20C-4.99%2038%20-5.98%2038%20-7%2038%20C-6.60284212%2032.31437138%20-6.08970099%2026.94955238%20-4.53515625%2021.4453125%20C-3.60669904%2017.20287299%20-3.21815438%2012.86432827%20-2.78540039%208.54614258%20C-2.39420389%204.97567117%20-2.03176078%203.04764117%200%200%20Z%20%22%20fill%3D%22%23CACACA%22%20transform%3D%22translate(686%2C437)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-3.12501561%203.59873436%20-5.96746798%204.99669688%20-10.4375%206.5625%20C-13.75076265%207.73346768%20-16.71833564%208.83100139%20-19.734375%2010.640625%20C-22.37284877%2012.22370926%20-23.97629432%2012.25917477%20-27%2012%20C-23.73241674%208.13907042%20-20.07996204%206.56723785%20-15.4375%204.875%20C-2.09687576%20-0.11334464%20-2.09687576%20-0.11334464%200%200%20Z%20%22%20fill%3D%22%233E3E3E%22%20transform%3D%22translate(486%2C568)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C5.18546243%201.24451098%208.53593174%202.99160617%2013%206%20C15.7282504%206.78215588%2015.7282504%206.78215588%2018%207%20C18%207.66%2018%208.32%2018%209%20C19.2684375%209.1546875%2019.2684375%209.1546875%2020.5625%209.3125%20C24.41442701%2010.0828854%2027.44075031%2011.36274514%2031%2013%20C31%2013.66%2031%2014.32%2031%2015%20C29.60190528%2014.74109357%2028.20657858%2014.46722539%2026.8125%2014.1875%20C26.03519531%2014.03667969%2025.25789063%2013.88585937%2024.45703125%2013.73046875%20C21.62786606%2012.88936559%2019.52408715%2011.52276515%2017%2010%20C13.70848642%208.75107808%2010.39166258%207.60942057%207.05859375%206.4765625%20C3.63496185%204.82377469%202.12519166%203.10724845%200%200%20Z%20%22%20fill%3D%22%23444444%22%20transform%3D%22translate(172%2C480)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C7.81636537%201.91722169%207.81636537%201.91722169%2010%205%20C10%205.66%2010%206.32%2010%207%20C10.55300781%207.08378906%2011.10601563%207.16757813%2011.67578125%207.25390625%20C14.745867%208.23942958%2016.69629157%209.90258381%2019.1875%2011.9375%20C20.06792969%2012.64777344%2020.94835937%2013.35804688%2021.85546875%2014.08984375%20C24%2016%2024%2016%2025%2018%20C20.14408819%2017.53623314%2017.07023849%2015.13609784%2013.375%2012.1875%20C12.80265625%2011.74857422%2012.2303125%2011.30964844%2011.640625%2010.85742188%20C8.60406564%208.48113763%206.21761257%206.14103484%204%203%20C1.91665365%201.7483533%201.91665365%201.7483533%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23572803%22%20transform%3D%22translate(569%2C168)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.39985155%202.77877548%20-4.59462991%203.71352686%20-8%205%20C-11.63192396%206.67849872%20-15.11510306%208.33034826%20-18.3125%2010.75%20C-20%2012%20-20%2012%20-23%2012%20C-23%2011.34%20-23%2010.68%20-23%2010%20C-20.67638014%207.85605223%20-18.02409861%206.1242585%20-15.4375%204.3125%20C-14.73302734%203.78849609%20-14.02855469%203.26449219%20-13.30273438%202.72460938%20C-8.40963053%20-0.70732798%20-5.81436311%20-1.62741044%200%200%20Z%20%22%20fill%3D%22%23B9865D%22%20transform%3D%22translate(273%2C171)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.5625%202.125%202.5625%202.125%203.5625%205.125%20C0.60074877%204.51222388%20-0.81808783%203.87127478%20-3.4375%202.125%20C-6.63556665%201.6646236%20-6.63556665%201.6646236%20-10.125%201.5%20C-11.30449219%201.42523438%20-12.48398437%201.35046875%20-13.69921875%201.2734375%20C-14.60285156%201.22445312%20-15.50648438%201.17546875%20-16.4375%201.125%20C-16.4375%200.135%20-16.4375%20-0.855%20-16.4375%20-1.875%20C-10.44604247%20-3.56009743%20-5.36418941%20-2.9259215%200%200%20Z%20%22%20fill%3D%22%23602C04%22%20transform%3D%22translate(572.4375%2C169.875)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C6.75%201.75%206.75%201.75%209%204%20C12.83381338%205.55951731%2016.48549437%206.87137359%2020.5%207.875%20C24.83287789%209.26771075%2028.25834307%2011.45372957%2032%2014%20C31.01%2014.495%2031.01%2014.495%2030%2015%20C28%2014%2026%2013%2024%2012%20C20.7633037%2011.29241674%2020.7633037%2011.29241674%2018%2011%20C18%2010.34%2018%209.68%2018%209%20C17.3709375%208.84144531%2016.741875%208.68289063%2016.09375%208.51953125%20C10.10712074%206.88763382%204.9364462%204.83332973%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23292929%22%20transform%3D%22translate(209%2C499)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.32%200%202.64%200%204%200%20C3.51823215%2010.88795342%200.13818645%2020.45765373%20-5%2030%20C-6.51325464%2026.97349071%20-5.31701478%2025.08986403%20-4.34765625%2021.8984375%20C-3.98349609%2020.68671875%20-3.61933594%2019.475%20-3.24414062%2018.2265625%20C-2.85041716%2016.94266026%20-2.45653488%2015.6588067%20-2.0625%2014.375%20C-1.6718578%2013.08353527%20-1.28187539%2011.79187078%20-0.89257812%2010.5%20C0.06512499%207.33130327%201.02958499%204.16482239%202%201%20C1.34%200.67%200.68%200.34%200%200%20Z%20%22%20fill%3D%22%232F2F2F%22%20transform%3D%22translate(674%2C478)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.8197996%202.35361821%201.1148421%203.63151889%200.36328125%206.04296875%20C0.01652344%206.75066406%20-0.33023438%207.45835937%20-0.6875%208.1875%20C-1.86499008%2010.62745367%20-3.01366164%2013.03418027%20-4.01953125%2015.55078125%20C-4.34308594%2016.35902344%20-4.66664063%2017.16726563%20-5%2018%20C-5.28875%2018.7425%20-5.5775%2019.485%20-5.875%2020.25%20C-7%2022%20-7%2022%20-9.125%2022.75%20C-10.053125%2022.87375%20-10.053125%2022.87375%20-11%2023%20C-10.42365861%2018.24518354%20-8.44931479%2015.02951788%20-6%2011%20C-5.34%2011%20-4.68%2011%20-4%2011%20C-3.69255859%209.93458984%20-3.69255859%209.93458984%20-3.37890625%208.84765625%20C-3.10949219%207.92855469%20-2.84007812%207.00945313%20-2.5625%206.0625%20C-2.29566406%205.14597656%20-2.02882813%204.22945312%20-1.75390625%203.28515625%20C-1%201%20-1%201%200%200%20Z%20%22%20fill%3D%22%23C5C5C5%22%20transform%3D%22translate(666%2C525)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.95699576%202.55591031%201.10383443%203.71093178%200.16723633%206.31835938%20C-0.27338135%207.15173828%20-0.71399902%207.98511719%20-1.16796875%208.84375%20C-1.64943359%209.76027344%20-2.13089844%2010.67679688%20-2.62695312%2011.62109375%20C-3.14193359%2012.57113281%20-3.65691406%2013.52117188%20-4.1875%2014.5%20C-4.68314453%2015.45003906%20-5.17878906%2016.40007813%20-5.68945312%2017.37890625%20C-8.08987595%2021.88802284%20-10.2423659%2025.48686136%20-14%2029%20C-14.5775%2029.5775%20-15.155%2030.155%20-15.75%2030.75%20C-16.1625%2031.1625%20-16.575%2031.575%20-17%2032%20C-15.80100302%2028.9168649%20-14.52299523%2025.93720508%20-13%2023%20C-12.34%2023%20-11.68%2023%20-11%2023%20C-10.76539063%2022.19304688%20-10.53078125%2021.38609375%20-10.2890625%2020.5546875%20C-8.69999965%2016.1727263%20-6.59350886%2012.21537571%20-4.375%208.125%20C-3.95476563%207.34125%20-3.53453125%206.5575%20-3.1015625%205.75%20C-2.0718978%203.83107943%20-1.03652433%201.91522397%200%200%20Z%20%22%20fill%3D%22%23B1B1B1%22%20transform%3D%22translate(670%2C529)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C6.46326465%20-0.45356243%209.60931587%200.40621058%2015%204%20C15%204.33%2015%204.66%2015%205%20C9.39%205%203.78%205%20-2%205%20C-1.34%203.35%20-0.68%201.7%200%200%20Z%20%22%20fill%3D%22%236F3305%22%20transform%3D%22translate(542%2C158)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C5.04196983%200.50419698%2010.24504438%201.24504438%2014%205%20C16.26866501%205.01261445%2016.26866501%205.01261445%2018.875%204.75%20C19.75929688%204.68296875%2020.64359375%204.6159375%2021.5546875%204.546875%20C24.35567115%203.92045693%2025.10158994%203.05974803%2027%201%20C30.1875%200.3125%2030.1875%200.3125%2033%200%20C31.59625372%202.80749255%2029.89388208%202.84244717%2027%204%20C26.05125%204.70125%2025.1025%205.4025%2024.125%206.125%20C20.35294537%208.38823278%2018.33260375%208.5514223%2014%208%20C11.375%206.625%2011.375%206.625%209%205%20C8.154375%204.67%207.30875%204.34%206.4375%204%20C3.92982049%202.97120841%202.09290902%201.70533328%200%200%20Z%20%22%20fill%3D%22%23CD752E%22%20transform%3D%22translate(403%2C352)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C1.85481391%205.89200451%202.1344851%2011.58258171%202.09765625%2017.53125%20C2.0962413%2018.40777222%202.09482635%2019.28429443%202.09336853%2020.18737793%20C2.08781768%2022.95828821%202.07527461%2025.72911457%202.0625%2028.5%20C2.05747864%2030.39062382%202.05291685%2032.28124893%202.04882812%2034.171875%20C2.0378644%2038.78128183%202.02063425%2043.39062673%202%2048%20C1.67%2048%201.34%2048%201%2048%20C0.97494385%2046.92516357%200.9498877%2045.85032715%200.92407227%2044.74291992%20C0.82992505%2040.75646978%200.72972215%2036.77019091%200.62768555%2032.78393555%20C0.58436438%2031.05839035%200.54268727%2029.33280307%200.50268555%2027.60717773%20C0.44491474%2025.12731236%200.38123997%2022.64765828%200.31640625%2020.16796875%20C0.29969376%2019.39599655%200.28298126%2018.62402435%200.26576233%2017.82865906%20C0.17772105%2014.64817067%200.01254805%2012.03764416%20-1%209%20C-1.17812624%206.3071504%20-1.08727698%203.70558632%20-1%201%20C-0.67%200.67%20-0.34%200.34%200%200%20Z%20%22%20fill%3D%22%23B0B0B0%22%20transform%3D%22translate(693%2C406)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.31%201.32%20-4.62%202.64%20-7%204%20C-6.67%204.66%20-6.34%205.32%20-6%206%20C-15.41002278%2010.59225513%20-15.41002278%2010.59225513%20-20%2010%20C-18.57466888%205.72400664%20-15.47056527%204.73177414%20-11.6875%202.75%20C-11.01009766%202.37359375%20-10.33269531%201.9971875%20-9.63476562%201.609375%20C-5.95977798%20-0.34487063%20-3.97001703%20-1.33627897%200%200%20Z%20%22%20fill%3D%22%23E5B890%22%20transform%3D%22translate(308%2C150)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.86625%200.4640625%200.86625%200.4640625%201.75%200.9375%20C3.88635294%202.07363436%203.88635294%202.07363436%205.9375%202.3125%20C11.38911486%204.12970495%2015.37102101%2010.67266079%2019%2015%20C14.71007444%2014.48641736%2012.63121502%2013.18275773%209.5%2010.25%20C8.72785156%209.53199219%207.95570313%208.81398437%207.16015625%208.07421875%20C6.44730469%207.38972656%205.73445312%206.70523438%205%206%20C4.44183594%205.47019531%203.88367188%204.94039062%203.30859375%204.39453125%20C2.17528711%203.29351255%201.08183622%202.15163211%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23572803%22%20transform%3D%22translate(594%2C186)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.34605548%206.57512917%20-1.9857967%2013.9038939%20-4.7578125%2019.86328125%20C-9.53934384%2029.76967192%20-9.53934384%2029.76967192%20-12%2031%20C-11.39273759%2027.45045834%20-10.44448953%2024.39057509%20-9.00390625%2021.09375%20C-8.61009766%2020.18496094%20-8.21628906%2019.27617188%20-7.81054688%2018.33984375%20C-7.39869141%2017.40269531%20-6.98683594%2016.46554687%20-6.5625%2015.5%20C-5.75083982%2013.63561785%20-4.93962732%2011.77104072%20-4.12890625%209.90625%20C-3.76869385%209.08447266%20-3.40848145%208.26269531%20-3.03735352%207.41601562%20C-1.98267311%204.95964534%20-0.98260281%202.48597681%200%200%20Z%20%22%20fill%3D%22%232E2E2E%22%20transform%3D%22translate(667%2C509)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%201.32%200.66%202.64%201%204%20C1.99%203.01%202.98%202.02%204%201%20C4.66%201.33%205.32%201.66%206%202%20C4.700625%202.99%204.700625%202.99%203.375%204%20C0.05246904%206.73203375%20-2.27625701%209.89638452%20-4.703125%2013.42578125%20C-5.13109375%2013.94527344%20-5.5590625%2014.46476563%20-6%2015%20C-6.66%2015%20-7.32%2015%20-8%2015%20C-6.5320383%209.66195747%20-3.98519676%203.98519676%200%200%20Z%20%22%20fill%3D%22%237C7C7C%22%20transform%3D%22translate(635%2C580)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C0.34290238%203.00860317%20-1.32403781%205.00718923%20-3%207%20C-3.60070312%207.71929687%20-4.20140625%208.43859375%20-4.8203125%209.1796875%20C-5.43648437%209.90414062%20-6.05265625%2010.62859375%20-6.6875%2011.375%20C-7.55955078%2012.40753906%20-7.55955078%2012.40753906%20-8.44921875%2013.4609375%20C-10%2015%20-10%2015%20-12%2015%20C-12%2015.66%20-12%2016.32%20-12%2017%20C-13.65%2017.66%20-15.3%2018.32%20-17%2019%20C-15.60652624%2015.84795019%20-13.97514921%2013.73828227%20-11.5234375%2011.328125%20C-10.51796875%2010.33232422%20-10.51796875%2010.33232422%20-9.4921875%209.31640625%20C-8.79351562%208.63449219%20-8.09484375%207.95257813%20-7.375%207.25%20C-6.66859375%206.55261719%20-5.9621875%205.85523438%20-5.234375%205.13671875%20C-3.49401297%203.41987512%20-1.74915019%201.70788168%200%200%20Z%20%22%20fill%3D%22%233F2612%22%20transform%3D%22translate(219%2C203)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-10.30068337%2014.81776765%20-10.30068337%2014.81776765%20-18%2020%20C-14.61327514%2012.00356629%20-6.81301026%205.19940256%200%200%20Z%20%22%20fill%3D%22%2356371E%22%20transform%3D%22translate(234%2C190)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.47378124%202.47378124%20-4.56174345%203.03138231%20-7.875%204.125%20C-8.92429687%204.47820312%20-9.97359375%204.83140625%20-11.0546875%205.1953125%20C-14%206%20-14%206%20-18%206%20C-18%205.34%20-18%204.68%20-18%204%20C-18.99%203.67%20-19.98%203.34%20-21%203%20C-14.15939114%200.36899659%20-7.28555331%20-0.18680906%200%200%20Z%20%22%20fill%3D%22%23E2B791%22%20transform%3D%22translate(367%2C133)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.76646851%207.81797878%20-1.96083411%2013.87966848%20-5%2021%20C-6.37344385%2016.60155678%20-5.24307502%2013.07495445%20-4.0625%208.75%20C-3.76956055%207.63238281%20-3.76956055%207.63238281%20-3.47070312%206.4921875%20C-2.98895802%204.65920614%20-2.49560775%202.82928182%20-2%201%20C-3.04800781%201.45052734%20-3.04800781%201.45052734%20-4.1171875%201.91015625%20C-5.02726563%202.29042969%20-5.93734375%202.67070312%20-6.875%203.0625%20C-7.77992188%203.44535156%20-8.68484375%203.82820313%20-9.6171875%204.22265625%20C-12%205%20-12%205%20-14%204%20C-9.02495953%200.75099398%20-6.11774896%20-0.49940808%200%200%20Z%20%22%20fill%3D%22%235F5F5F%22%20transform%3D%22translate(680%2C477)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0%200.99%200%201.98%200%203%20C-0.99%203.33%20-1.98%203.66%20-3%204%20C-3%203.34%20-3%202.68%20-3%202%20C-3.99%201.67%20-4.98%201.34%20-6%201%20C-3.92446352%200.4465236%20-2.15634036%200%200%200%20Z%20M-5%204%20C-4.34%204.33%20-3.68%204.66%20-3%205%20C-6.63%208.96%20-10.26%2012.92%20-14%2017%20C-14.99%2016.67%20-15.98%2016.34%20-17%2016%20C-13.32167983%2011.47384007%20-9.58913637%207.60575001%20-5%204%20Z%20%22%20fill%3D%22%23803D09%22%20transform%3D%22translate(339%2C143)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-3.43968616%204.15628745%20-7.06078394%205.34464679%20-12%207%20C-13.41842394%207.53704819%20-14.83515415%208.07859498%20-16.25%208.625%20C-18.87538263%209.5876403%20-21.30043402%2010.36691594%20-24%2011%20C-23.67%2010.34%20-23.34%209.68%20-23%209%20C-22.34%209%20-21.68%209%20-21%209%20C-21%208.34%20-21%207.68%20-21%207%20C-19.2365625%206.38125%20-19.2365625%206.38125%20-17.4375%205.75%20C-14.53645395%204.6717351%20-11.90977369%203.45586332%20-9.25%201.875%20C-3.21428571%20-1.60714286%20-3.21428571%20-1.60714286%200%200%20Z%20%22%20fill%3D%22%23494949%22%20transform%3D%22translate(458%2C581)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C1.52312744%201.40395996%201.04625488%201.80791992%200.55493164%202.22412109%20C-1.31689955%204.36192924%20-1.52777965%205.61959509%20-1.87890625%208.4140625%20C-1.99556641%209.25710938%20-2.11222656%2010.10015625%20-2.23242188%2010.96875%20C-2.34134766%2011.8453125%20-2.45027344%2012.721875%20-2.5625%2013.625%20C-2.78485229%2015.36824198%20-3.01491397%2017.11052378%20-3.25390625%2018.8515625%20C-3.35002197%2019.62322754%20-3.4461377%2020.39489258%20-3.54516602%2021.18994141%20C-3.69526123%2021.78726074%20-3.84535645%2022.38458008%20-4%2023%20C-4.66%2023.33%20-5.32%2023.66%20-6%2024%20C-5.98259766%2022.58847656%20-5.98259766%2022.58847656%20-5.96484375%2021.1484375%20C-5.95582031%2019.90320313%20-5.94679688%2018.65796875%20-5.9375%2017.375%20C-5.92589844%2016.14523437%20-5.91429687%2014.91546875%20-5.90234375%2013.6484375%20C-5.99136076%2010.32276209%20-6.36313913%207.25952412%20-7%204%20C-5.824375%203.566875%20-5.824375%203.566875%20-4.625%203.125%20C-1.90328368%202.15087746%20-1.90328368%202.15087746%200%200%20Z%20%22%20fill%3D%22%23B5B5B5%22%20transform%3D%22translate(689%2C470)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-3.84985987%202.56657325%20-6.58358564%203.13343988%20-11.10546875%203.31640625%20C-12.08837891%203.35830078%20-13.07128906%203.40019531%20-14.08398438%203.44335938%20C-15.62022461%203.50233398%20-15.62022461%203.50233398%20-17.1875%203.5625%20C-18.22326172%203.60568359%20-19.25902344%203.64886719%20-20.32617188%203.69335938%20C-22.8839819%203.79944366%20-25.44188845%203.90150146%20-28%204%20C-19.14306412%20-0.54990673%20-9.76763586%20-0.25333926%200%200%20Z%20%22%20fill%3D%22%23CFA37F%22%20transform%3D%22translate(397%2C129)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.96846689%202.61486062%201.04559628%203.8442127%200.25%206.5625%20C-1%209%20-1%209%20-2.41015625%2010.359375%20C-4.29336106%2012.30273131%20-5.41046939%2014.30601048%20-6.6875%2016.6875%20C-7.12449219%2017.49574219%20-7.56148437%2018.30398438%20-8.01171875%2019.13671875%20C-8.50091797%2020.05904297%20-8.50091797%2020.05904297%20-9%2021%20C-9.66%2021%20-10.32%2021%20-11%2021%20C-11.33%2021.99%20-11.66%2022.98%20-12%2024%20C-12.33%2023.34%20-12.66%2022.68%20-13%2022%20C-12.13549805%2020.07641602%20-12.13549805%2020.07641602%20-10.76171875%2017.75390625%20C-10.02598633%2016.49803711%20-10.02598633%2016.49803711%20-9.27539062%2015.21679688%20C-8.75138672%2014.34087891%20-8.22738281%2013.46496094%20-7.6875%2012.5625%20C-7.17509766%2011.69044922%20-6.66269531%2010.81839844%20-6.13476562%209.91992188%20C-4.15456195%206.56106271%20-2.16330481%203.24495721%200%200%20Z%20%22%20fill%3D%22%23979797%22%20transform%3D%22translate(654%2C548)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.265625%201.55078125%201.265625%201.55078125%202%204%20C0.6936099%206.62176911%20-0.59633752%208.80456748%20-2.25%2011.1875%20C-2.67152344%2011.82880859%20-3.09304688%2012.47011719%20-3.52734375%2013.13085938%20C-6.68004712%2017.84002356%20-6.68004712%2017.84002356%20-9%2019%20C-8.58742287%2013.49897163%20-6.45277325%209.23798336%20-3%205%20C-2.34%205%20-1.68%205%20-1%205%20C-0.67%203.35%20-0.34%201.7%200%200%20Z%20%22%20fill%3D%22%23D6D6D6%22%20transform%3D%22translate(654%2C552)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.61225278%203.22450555%200.01296101%205.86335067%20-1.03125%209.1796875%20C-2.5226139%2013.52148078%20-4.22574697%2017.76701055%20-6%2022%20C-6.33%2022%20-6.66%2022%20-7%2022%20C-7.62260536%2013.59482769%20-5.28712118%206.60511414%200%200%20Z%20%22%20fill%3D%22%234C4C4C%22%20transform%3D%22translate(157%2C321)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C5.56442407%201.21721777%2011.93760485%203.93760485%2016%208%20C16.75%2010.6875%2016.75%2010.6875%2017%2013%20C12.98544787%2011.26102321%209.67974734%208.60214985%206.25%205.9375%20C5.64800781%205.47794922%205.04601562%205.01839844%204.42578125%204.54492188%20C2.92968619%203.38977365%201.46204799%202.19794972%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%232A1302%22%20transform%3D%22translate(583%2C176)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C0.91269147%202.73064947%200.80577876%205.4581619%200.6875%208.1875%20C0.66494141%208.95642578%200.64238281%209.72535156%200.61914062%2010.51757812%20C0.40261415%2015.10400245%20-0.04635224%2018.27363755%20-3%2022%20C-5.25%2023.0625%20-5.25%2023.0625%20-8%2024%20C-9.23921901%2024.71194872%20-10.46807554%2025.44215532%20-11.6875%2026.1875%20C-12.780625%2026.785625%20-13.87375%2027.38375%20-15%2028%20C-15.66%2027.67%20-16.32%2027.34%20-17%2027%20C-13.90565106%2023.41706964%20-10.29978541%2022.35680384%20-5.8125%2021.125%20C-2.35781957%2018.51479701%20-2.38357895%2017.41608444%20-1.6875%2013.25%20C-1.43748484%2011.1690657%20-1.20695309%209.0856571%20-1%207%20C-0.79915246%205.58225267%20-0.59251326%204.16528626%20-0.375%202.75%20C-0.25125%201.8425%20-0.1275%200.935%200%200%20Z%20%22%20fill%3D%22%23505050%22%20transform%3D%22translate(711%2C441)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.11991797%203.36315792%200.85748516%205.57005937%200.00390625%208.984375%20C-0.22490234%209.91894531%20-0.45371094%2010.85351562%20-0.68945312%2011.81640625%20C-0.93630859%2012.78449219%20-1.18316406%2013.75257813%20-1.4375%2014.75%20C-1.68048828%2015.73355469%20-1.92347656%2016.71710938%20-2.17382812%2017.73046875%20C-2.77428331%2020.15583673%20-3.38326726%2022.57872945%20-4%2025%20C-4.33%2025%20-4.66%2025%20-5%2025%20C-5.76397365%2015.57765837%20-3.8713719%208.57232349%200%200%20Z%20%22%20fill%3D%22%236C6C6C%22%20transform%3D%22translate(155%2C330)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C5.44693314%20-0.09688221%2010.63904667%20-0.12862175%2016%201%20C16%201.66%2016%202.32%2016%203%20C5.11%203%20-5.78%203%20-17%203%20C-17%202.67%20-17%202.34%20-17%202%20C-8.585%201.505%20-8.585%201.505%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%237C502C%22%20transform%3D%22translate(440%2C128)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.82408073%202.35602568%201.13166634%203.606532%200.328125%206.0078125%20C-0.02765625%206.70648438%20-0.3834375%207.40515625%20-0.75%208.125%20C-2.7334304%2012.24862678%20-4.0444892%2016.31445836%20-5.19140625%2020.73828125%20C-6.08629888%2023.24138673%20-7.31490765%2024.96015136%20-9%2027%20C-8.48709514%2022.64030869%20-7.72358363%2019.02169514%20-6%2015%20C-5.51326826%2013.5233054%20-5.03485249%2012.04385676%20-4.5625%2010.5625%20C-3.34672387%206.85314221%20-1.85472925%203.44449719%200%200%20Z%20%22%20fill%3D%22%23555555%22%20transform%3D%22translate(673%2C498)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.66%201.98%201.32%203%202%20C-0.25936256%207.70388447%20-3.72421249%2012.04315937%20-9%2016%20C-7.83200992%2012.88535978%20-6.5049138%209.8703574%20-5.0625%206.875%20C-4.74410156%206.21242188%20-4.42570313%205.54984375%20-4.09765625%204.8671875%20C-2.94685942%202.90960427%20-1.66740191%201.52963936%200%200%20Z%20%22%20fill%3D%22%23858585%22%20transform%3D%22translate(194%2C253)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.18222208%2010.03056466%20-2.18222208%2010.03056466%20-6.1875%2012.625%20C-7.115625%2013.07875%20-8.04375%2013.5325%20-9%2014%20C-8.40523781%209.24190251%20-6.5093872%205.05289706%20-4%201%20C-2%200%20-2%200%200%200%20Z%20%22%20fill%3D%22%23ABABAB%22%20transform%3D%22translate(173%2C300)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.64767247%200.28109113%203.29313145%200.57518526%204.9375%200.875%20C5.85402344%201.03742188%206.77054687%201.19984375%207.71484375%201.3671875%20C8.46894531%201.57601562%209.22304688%201.78484375%2010%202%20C10.33%202.66%2010.66%203.32%2011%204%20C2.92138585%204.09579384%20-4.98340366%204.12513633%20-13%203%20C-13%202.67%20-13%202.34%20-13%202%20C-6.565%201.505%20-6.565%201.505%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%236D3E17%22%20transform%3D%22translate(467%2C131)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200%201.32%200%202%200%20C6.59225513%2017.85649203%206.59225513%2017.85649203%206%2026%20C5.67%2026%205.34%2026%205%2026%20C4.15956003%2022.4182952%203.32889101%2018.83439357%202.5%2015.25%20C2.14228516%2013.72632813%202.14228516%2013.72632813%201.77734375%2012.171875%20C1.43896484%2010.70234375%201.43896484%2010.70234375%201.09375%209.203125%20C0.88427734%208.30239258%200.67480469%207.40166016%200.45898438%206.47363281%20C0%204%200%204%200%200%20Z%20%22%20fill%3D%22%23575757%22%20transform%3D%22translate(700%2C344)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.37562854%201.28965176%202.70766393%202.62689293%204%204%20C4%204.66%204%205.32%204%206%20C4.66%206%205.32%206%206%206%20C6.66%207.65%207.32%209.3%208%2011%20C5.03%2013.475%205.03%2013.475%202%2016%20C1.34%2015.67%200.68%2015.34%200%2015%20C0.66%2014.34%201.32%2013.68%202%2013%20C2.37076135%208.18010242%201.75210338%204.48976491%200%200%20Z%20%22%20fill%3D%22%23B25A13%22%20transform%3D%22translate(641%2C240)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-2.82637615%204.87363696%20-7.26107981%207.70443192%20-13%2010%20C-13.66%2010.66%20-14.32%2011.32%20-15%2012%20C-15.99%2011.67%20-16.98%2011.34%20-18%2011%20C-16.44704556%209.67621942%20-14.88219918%208.36638151%20-13.3125%207.0625%20C-12.44238281%206.33160156%20-11.57226562%205.60070312%20-10.67578125%204.84765625%20C-7.93761361%202.95692151%20-6.22632889%202.50829394%20-3%202%20C-2.01%201.34%20-1.02%200.68%200%200%20Z%20%22%20fill%3D%22%23A47148%22%20transform%3D%22translate(257%2C179)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.46015291%200.28241641%202.91809793%200.57626614%204.375%200.875%20C5.18710937%201.03742187%205.99921875%201.19984375%206.8359375%201.3671875%20C9%202%209%202%2011%204%20C12.0725%204.28875%2013.145%204.5775%2014.25%204.875%20C18.28182107%206.08454632%2020.6440368%207.54441717%2024%2010%20C23.01%2010.495%2023.01%2010.495%2022%2011%20C20.9790625%2010.3503125%2020.9790625%2010.3503125%2019.9375%209.6875%20C17.19954595%208.11463278%2015.47142948%207.58383182%2012.4375%207%20C8.88137035%206.29348417%206.75132717%205.44562415%204%203%20C2.68163705%202.30419733%201.35208914%201.62775567%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23555555%22%20transform%3D%22translate(341%2C561)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-1.37261112%203.83299334%20-4.97382375%205.27449589%20-9%207%20C-9.721875%207.5775%20-10.44375%208.155%20-11.1875%208.75%20C-13%2010%20-13%2010%20-15.25%209.6875%20C-15.8275%209.460625%20-16.405%209.23375%20-17%209%20C-13.12810696%204.05999854%20-9.37733787%202.96912047%20-3.328125%201.578125%20C-1.05395025%201.22590017%20-1.05395025%201.22590017%200%200%20Z%20%22%20fill%3D%22%23B77947%22%20transform%3D%22translate(545%2C300)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.33%201.98%200.66%203%201%20C2.42012094%204.36329858%201.42075735%205.6723487%20-1%208%20C-1.680625%209.2065625%20-1.680625%209.2065625%20-2.375%2010.4375%20C-4.21005459%2013.33123993%20-6.2486119%2014.99223031%20-9%2017%20C-7.69289187%2013.42597488%20-6.11587706%2010.49002567%20-3.9375%207.375%20C-2.16012171%204.82843844%20-0.98934061%202.96802184%200%200%20Z%20%22%20fill%3D%22%23919191%22%20transform%3D%22translate(199%2C257)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.66%201.32%201.32%202%202%20C1.21875%203.69270833%200.4375%205.38541667%20-0.34375%207.078125%20C-1.21542924%209.29242836%20-1.21542924%209.29242836%20-1%2013%20C-2.32%2012.67%20-3.64%2012.34%20-5%2012%20C-5%207.86021808%20-4.67617664%207.01426496%20-2.5%203.75%20C-2.0359375%203.04359375%20-1.571875%202.3371875%20-1.09375%201.609375%20C-0.7328125%201.07828125%20-0.371875%200.5471875%200%200%20Z%20%22%20fill%3D%22%23D17930%22%20transform%3D%22translate(208%2C245)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-1.65880729%205.91652229%20-5.4843021%209.24823902%20-11%2012%20C-11.66%2012%20-12.32%2012%20-13%2012%20C-12.60196439%209.11424181%20-12.20990931%208.17810487%20-9.9375%206.25%20C-9.298125%205.8375%20-8.65875%205.425%20-8%205%20C-8%205.66%20-8%206.32%20-8%207%20C-4.04%203.535%20-4.04%203.535%200%200%20Z%20%22%20fill%3D%22%234E4E4E%22%20transform%3D%22translate(626%2C598)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.32%200%202.64%200%204%200%20C4%200.66%204%201.32%204%202%20C-8.11069559%206.93044129%20-8.11069559%206.93044129%20-12%208%20C-12.66%207.67%20-13.32%207.34%20-14%207%20C-11.5860268%204.13840263%20-9.4583325%203.32568005%20-5.875%202.375%20C-2.65634118%201.7005259%20-2.65634118%201.7005259%200%200%20Z%20%22%20fill%3D%22%23AA7C57%22%20transform%3D%22translate(592%2C278)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C-2.23896927%208.14287275%20-4.49305699%2012.02943906%20-11%2015%20C-9.44476633%2011.50683117%20-7.34563239%208.77131239%20-4.9375%205.8125%20C-4.22464844%204.93207031%20-3.51179687%204.05164063%20-2.77734375%203.14453125%20C-1.88495567%202.06778168%20-0.98887464%200.98887464%200%200%20Z%20%22%20fill%3D%22%233A200A%22%20transform%3D%22translate(194%2C230)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C4.77295598%200.68587753%208.87632791%202.50631925%2013.25%204.4375%20C13.9821875%204.75009766%2014.714375%205.06269531%2015.46875%205.38476562%20C20.87660233%207.75320465%2020.87660233%207.75320465%2022%2010%20C14.16076983%208.18247357%206.82397217%205.24602713%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23393939%22%20transform%3D%22translate(367%2C574)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-4.03084689%204.45514656%20-8.05465225%206.30868049%20-14%207%20C-12.73164821%203.05401664%20-10.31064666%201.56019601%20-6.8203125%20-0.31640625%20C-4.27830339%20-1.27102341%20-2.51232148%20-0.91357145%200%200%20Z%20%22%20fill%3D%22%23CB9A71%22%20transform%3D%22translate(281%2C165)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-0.59167969%200.32613281%20-1.18335938%200.65226563%20-1.79296875%200.98828125%20C-2.58316406%201.42527344%20-3.37335937%201.86226562%20-4.1875%202.3125%20C-5.01121094%202.76625%20-5.83492187%203.22%20-6.68359375%203.6875%20C-8.40994924%204.66567107%20-10.09326072%205.7205582%20-11.75%206.8125%20C-14.3594536%208.18971162%20-16.09035405%208.24939822%20-19%208%20C-16.90584651%204.85876976%20-16.57988409%204.58414831%20-13.25%203.5%20C-10.52488345%202.57019617%20-8.26271606%201.6104915%20-5.6875%200.25%20C-3%20-1%20-3%20-1%200%200%20Z%20%22%20fill%3D%22%233E3E3E%22%20transform%3D%22translate(571%2C528)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C0.09950832%208.4646218%20-2.98068485%2016.09226984%20-6%2024%20C-6.66%2023.67%20-7.32%2023.34%20-8%2023%20C-5.36%2015.41%20-2.72%207.82%200%200%20Z%20%22%20fill%3D%22%23EEEEEE%22%20transform%3D%22translate(679%2C496)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-0.66%200%20-1.32%200%20-2%200%20C-2.2475%200.7425%20-2.495%201.485%20-2.75%202.25%20C-4.09147301%205.20124062%20-5.60905526%206.84814974%20-8%209%20C-8.99%208.67%20-9.98%208.34%20-11%208%20C-9.625%206%20-9.625%206%20-8%204%20C-7.34%204%20-6.68%204%20-6%204%20C-6.33%203.34%20-6.66%202.68%20-7%202%20C-9.02463255%201.34786708%20-9.02463255%201.34786708%20-11%201%20C-3.57142857%20-1.42857143%20-3.57142857%20-1.42857143%200%200%20Z%20%22%20fill%3D%22%237B4214%22%20transform%3D%22translate(357%2C139)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C9.27394893%200.58882215%2018.0146265%202.75886856%2027%205%20C27%205.33%2027%205.66%2027%206%20C24.57341455%205.76629198%2022.14773012%205.52633164%2019.72265625%205.27734375%20C18.10654948%205.11271881%2016.48955648%204.9559801%2014.87109375%204.81640625%20C9.6085934%204.29547187%204.92921004%202.81422314%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%231E1208%22%20transform%3D%22translate(470%2C129)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-1.88923398%201.01241247%20-3.78669944%202.00947425%20-5.6875%203%20C-7.27111328%203.8353125%20-7.27111328%203.8353125%20-8.88671875%204.6875%20C-11.92226262%205.9672274%20-13.76026826%206.28851043%20-17%206%20C-12.81923021%201.12243525%20-6.24558534%20-2.08186178%200%200%20Z%20%22%20fill%3D%22%23313131%22%20transform%3D%22translate(588%2C521)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.94026778%205.34512479%20-0.87461778%2010.05238894%20-3%2015%20C-4.23620214%2017.42245672%20-5.56151527%2019.68814954%20-7%2022%20C-7.33%2020.68%20-7.66%2019.36%20-8%2018%20C-7.01%2017.67%20-6.02%2017.34%20-5%2017%20C-4.89042969%2016.27554688%20-4.78085937%2015.55109375%20-4.66796875%2014.8046875%20C-3.77128895%209.33712777%20-2.84045685%204.77713197%200%200%20Z%20%22%20fill%3D%22%23616161%22%20transform%3D%22translate(679%2C511)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.95699723%203.91399445%20-0.75958054%208.999513%20-2%2013%20C-2.93861707%2015.69799795%20-3.94736792%2018.34335714%20-5%2021%20C-6.29814095%2017.34240017%20-5.7043336%2014.77223795%20-4.75%2011.0625%20C-4.49734375%2010.04285156%20-4.2446875%209.02320313%20-3.984375%207.97265625%20C-2.99590237%204.9876258%20-1.71896456%202.62190382%200%200%20Z%20%22%20fill%3D%22%236F6F6F%22%20transform%3D%22translate(162%2C309)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.495%200.99%200.495%202%201%20C1.98839844%201.81984375%201.97679688%202.6396875%201.96484375%203.484375%20C1.95582031%204.56203125%201.94679688%205.6396875%201.9375%206.75%20C1.92589844%207.81734375%201.91429688%208.8846875%201.90234375%209.984375%20C1.8870595%2012.8918999%201.8870595%2012.8918999%202.56640625%2015.203125%20C3%2017%203%2017%202%2020%20C2%2019.34%202%2018.68%202%2018%20C1.34%2018%200.68%2018%200%2018%20C0%2012.06%200%206.12%200%200%20Z%20%22%20fill%3D%22%230F0F0F%22%20transform%3D%22translate(126%2C436)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.35953094%202.35953094%20-3.77895617%202.49141413%20-7%203%20C-7%203.66%20-7%204.32%20-7%205%20C-12.17578125%208.22265625%20-12.17578125%208.22265625%20-14%209%20C-14.99%208.67%20-15.98%208.34%20-17%208%20C-7.19797688%20-0.63511561%20-7.19797688%20-0.63511561%200%200%20Z%20%22%20fill%3D%22%23B17B4F%22%20transform%3D%22translate(567%2C291)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-1.34003602%205.32239956%20-4.32751069%208.17477391%20-9%2011%20C-9.66%2010.34%20-10.32%209.68%20-11%209%20C-7.37%206.03%20-3.74%203.06%200%200%20Z%20%22%20fill%3D%22%23533922%22%20transform%3D%22translate(247%2C180)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C4.30689238%201.34307888%208.27523429%202.98890874%2012.3125%205%20C13.88451172%205.7734375%2013.88451172%205.7734375%2015.48828125%206.5625%20C18%208%2018%208%2019%2010%20C15.58978257%209.21302675%2012.31114834%208.12880057%209%207%20C9%206.34%209%205.68%209%205%20C8.443125%204.896875%207.88625%204.79375%207.3125%204.6875%20C4.54289253%203.86410318%202.39747583%202.59831722%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23292929%22%20transform%3D%22translate(254%2C520)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C2.04254356%202.99954746%202.04080783%205.00041636%202%207%20C1.67%207.33%201.34%207.66%201%208%20C0.60333773%2010.18019479%200.25684763%2012.3696463%20-0.0625%2014.5625%20C-0.23910156%2015.76003906%20-0.41570313%2016.95757812%20-0.59765625%2018.19140625%20C-0.73042969%2019.11824219%20-0.86320313%2020.04507812%20-1%2021%20C-1.33%2021%20-1.66%2021%20-2%2021%20C-1.86142159%2017.87463363%20-1.71290431%2014.74981783%20-1.5625%2011.625%20C-1.52318359%2010.73554688%20-1.48386719%209.84609375%20-1.44335938%208.9296875%20C-1.40146484%208.07890625%20-1.35957031%207.228125%20-1.31640625%206.3515625%20C-1.27974854%205.56604004%20-1.24309082%204.78051758%20-1.20532227%203.97119141%20C-1%202%20-1%202%200%200%20Z%20%22%20fill%3D%22%23C6C6C6%22%20transform%3D%22translate(689%2C414)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.58624235%200.42683239%203.1689098%200.86696158%204.75%201.3125%20C6.07257813%201.67794922%206.07257813%201.67794922%207.421875%202.05078125%20C10.08669915%203.03192105%2011.90271638%204.093824%2014%206%20C14%206.66%2014%207.32%2014%208%20C15.65%208.33%2017.3%208.66%2019%209%20C16.27584084%2010.36207958%2014.87220643%209.86166193%2012%209%20C11.34%208.01%2010.68%207.02%2010%206%20C8.11440217%205.10525628%208.11440217%205.10525628%206%204.5%20C2.54718806%203.43369043%202.1454907%203.21823605%200%200%20Z%20%22%20fill%3D%22%23AD7447%22%20transform%3D%22translate(201%2C256)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0%203.53922552%20-0.70481438%204.31891897%20-2.8125%207.0625%20C-3.33457031%207.75472656%20-3.85664062%208.44695313%20-4.39453125%209.16015625%20C-6%2011%20-6%2011%20-9%2013%20C-8.38297446%207.60102654%20-5.92102734%204.54749424%20-1.75%201.1875%20C-1.1725%200.795625%20-0.595%200.40375%200%200%20Z%20%22%20fill%3D%22%23363636%22%20transform%3D%22translate(630%2C582)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.22506359%203.59699524%200.82116076%206.41420962%200.1875%2010.125%20C0.01605469%2011.17945313%20-0.15539062%2012.23390625%20-0.33203125%2013.3203125%20C-1%2016%20-1%2016%20-3%2018%20C-3.2661431%2011.47949413%20-2.97164571%205.94329141%200%200%20Z%20%22%20fill%3D%22%23C4C4C4%22%20transform%3D%22translate(686%2C437)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-5.33251295%203.54532196%20-10.86159819%207.03876789%20-17%209%20C-17.66%208.67%20-18.32%208.34%20-19%208%20C-5.26890756%20-1.75630252%20-5.26890756%20-1.75630252%200%200%20Z%20%22%20fill%3D%22%23A27D5F%22%20transform%3D%22translate(443%2C351)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C7.07969902%201.62391487%2011.89563085%203.77731766%2017%209%20C16.01%209.495%2016.01%209.495%2015%2010%20C9.27272727%207.54545455%209.27272727%207.54545455%208%205%20C6.845%204.505%205.69%204.01%204.5%203.5%20C1%202%201%202%200%200%20Z%20%22%20fill%3D%22%23616161%22%20transform%3D%22translate(298%2C539)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.32%200%202.64%200%204%200%20C4%200.66%204%201.32%204%202%20C5.2684375%202.1546875%205.2684375%202.1546875%206.5625%202.3125%20C10.41442701%203.0828854%2013.44075031%204.36274514%2017%206%20C17%206.66%2017%207.32%2017%208%20C10.45959881%206.98563222%205.25798525%205.11183043%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23595959%22%20transform%3D%22translate(186%2C487)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.05710856%203.08566284%202.78346093%205.36985312%203.6875%208.9375%20C3.95949219%209.97777344%204.23148438%2011.01804687%204.51171875%2012.08984375%20C4.97828785%2014.8705956%204.93894816%2016.38480882%204%2019%20C1.30292366%2012.44995746%20-0.53699151%207.11513755%200%200%20Z%20%22%20fill%3D%22%23191919%22%20transform%3D%22translate(704%2C338)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200%201.32%200%202%200%20C1.49904971%204.34156921%20-1.10523005%206.89846077%20-4%2010%20C-4.99%2010.33%20-5.98%2010.66%20-7%2011%20C-5.51131293%206.39860359%20-3.25370145%203.49772906%200%200%20Z%20%22%20fill%3D%22%23884D1E%22%20transform%3D%22translate(200%2C243)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C3.71599191%20-0.20086443%204.77208445%20-0.1519437%208%202%20C9.9896995%202.39013716%2011.99019869%202.73202649%2014%203%20C10.8250906%204.9078584%208.89414789%205.1609041%205.25%204.625%20C4.45078125%204.51414063%203.6515625%204.40328125%202.828125%204.2890625%20C2.22484375%204.19367188%201.6215625%204.09828125%201%204%20C0.67%202.68%200.34%201.36%200%200%20Z%20%22%20fill%3D%22%23522604%22%20transform%3D%22translate(540%2C154)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C6.09897654%200.37340673%209.28103272%202.25052352%2014%206%20C14.99%206.66%2015.98%207.32%2017%208%20C12.76677156%207.37954537%209.47709705%205.89476441%205.6875%203.9375%20C4.61886719%203.38964844%203.55023438%202.84179688%202.44921875%202.27734375%20C1.64097656%201.85582031%200.83273437%201.43429687%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23474747%22%20transform%3D%22translate(389%2C584)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.625%201.8125%200.625%201.8125%201%204%20C0.01%205.485%200.01%205.485%20-1%207%20C-0.01%206.67%200.98%206.34%202%206%20C0.66667905%209.99996286%20-1.4957827%2010.83782337%20-5%2013%20C-4.39254603%208.14036821%20-2.27241033%204.2594482%200%200%20Z%20%22%20fill%3D%22%23959595%22%20transform%3D%22translate(640%2C572)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.51183868%203.9249658%200.46099883%206.76930452%20-0.75%2010.6875%20C-1.09546875%2011.84636719%20-1.4409375%2013.00523437%20-1.796875%2014.19921875%20C-2.19390625%2015.12347656%20-2.5909375%2016.04773438%20-3%2017%20C-3.99%2017.33%20-4.98%2017.66%20-6%2018%20C-5.31583566%2013.82423832%20-3.98634991%2010.11919593%20-2.4375%206.1875%20C-1.75494141%204.44533203%20-1.75494141%204.44533203%20-1.05859375%202.66796875%20C-0.70925781%201.78753906%20-0.35992188%200.90710938%200%200%20Z%20%22%20fill%3D%22%23969696%22%20transform%3D%22translate(677%2C511)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-3.88050703%204.04870549%20-9.68334326%206.96964605%20-16%209%20C-16.66%208.67%20-17.32%208.34%20-18%208%20C-13.70162066%205.4209724%20-9.81848695%203.46649603%20-5%202%20C-4.0925%201.608125%20-3.185%201.21625%20-2.25%200.8125%20C-1.5075%200.544375%20-0.765%200.27625%200%200%20Z%20%22%20fill%3D%22%23464646%22%20transform%3D%22translate(601%2C512)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.9375%200.6875%201.9375%200.6875%204%202%20C4.75%204.625%204.75%204.625%205%207%20C4.67%206.34%204.34%205.68%204%205%20C2.68%205.33%201.36%205.66%200%206%20C0%205.34%200%204.68%200%204%20C-1.98%204.66%20-3.96%205.32%20-6%206%20C-4%204%20-2%202%200%200%20Z%20%22%20fill%3D%22%233E3731%22%20transform%3D%22translate(657%2C247)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C0.44555348%202.46691458%20-1.11892175%203.92320641%20-2.6875%205.375%20C-3.55761719%206.18710938%20-4.42773438%206.99921875%20-5.32421875%207.8359375%20C-7.86371107%209.88977509%20-9.92025866%2010.9900668%20-13%2012%20C-11.68895551%208.06686654%20-9.17504178%206.63242994%20-5.9375%204.3125%20C-5.08575195%203.68891602%20-5.08575195%203.68891602%20-4.21679688%203.05273438%20C-2.81596827%202.02859918%20-1.40859652%201.01342465%200%200%20Z%20%22%20fill%3D%22%239C5011%22%20transform%3D%22translate(244%2C204)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0%200.33%200%200.66%200%201%20C-6.50422293%203.00865708%20-12.1781317%204.38614349%20-19%204%20C-13.06147771%200.04098514%20-6.91895619%20-0.24710558%200%200%20Z%20%22%20fill%3D%22%23614935%22%20transform%3D%22translate(357%2C133)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C4.31931387%200.61611835%208.25208775%201.64238578%2012.375%203.0625%20C13.43460937%203.42472656%2014.49421875%203.78695312%2015.5859375%204.16015625%20C16.38257813%204.43730469%2017.17921875%204.71445312%2018%205%20C18%205.99%2018%206.98%2018%208%20C17.31550781%207.72414063%2016.63101562%207.44828125%2015.92578125%207.1640625%20C12.68892291%205.87623368%209.43978124%204.62335037%206.1875%203.375%20C5.02605469%202.92898438%203.86460937%202.48296875%202.66796875%202.0234375%20C1.78753906%201.68570313%200.90710938%201.34796875%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%235B5B5B%22%20transform%3D%22translate(315%2C549)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C2.4140625%203.28515625%202.4140625%203.28515625%202.625%206.0625%20C2.69976563%206.98160156%202.77453125%207.90070313%202.8515625%208.84765625%20C2.90054688%209.55792969%202.94953125%2010.26820313%203%2011%20C2.34%2011%201.68%2011%201%2011%20C0.34%2012.98%20-0.32%2014.96%20-1%2017%20C-2.3357457%2013.22628488%20-1.72408671%2010.14168653%20-1.0625%206.25%20C-0.86785156%205.07953125%20-0.67320312%203.9090625%20-0.47265625%202.703125%20C-0.31667969%201.81109375%20-0.16070313%200.9190625%200%200%20Z%20%22%20fill%3D%22%23D8D8D8%22%20transform%3D%22translate(689%2C422)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C3.25524265%203.02272532%205.61820737%206.25718301%208%2010%20C7.67%2010.66%207.34%2011.32%207%2012%20C4.0625%2010.5%204.0625%2010.5%201%208%20C0.16104266%205.23513429%200.09752026%202.92560787%200%200%20Z%20%22%20fill%3D%22%23171717%22%20transform%3D%22translate(661%2C249)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C5.625%20-0.25%205.625%20-0.25%209%202%20C9%202.99%209%203.98%209%205%20C5.625%204.75%205.625%204.75%202%204%20C0.5625%201.9375%200.5625%201.9375%200%200%20Z%20%22%20fill%3D%22%23492203%22%20transform%3D%22translate(559%2C163)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.671875%201.67578125%200.671875%201.67578125%201%204%20C-0.109375%206.54296875%20-0.109375%206.54296875%20-1.75%209.1875%20C-2.54664063%2010.50814453%20-2.54664063%2010.50814453%20-3.359375%2011.85546875%20C-5%2014%20-5%2014%20-8%2015%20C-6.66749209%2011.4124787%20-5.169283%208.1635377%20-3%205%20C-2.34%205%20-1.68%205%20-1%205%20C-0.67%203.35%20-0.34%201.7%200%200%20Z%20%22%20fill%3D%22%23646464%22%20transform%3D%22translate(654%2C544)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C0.76110404%202.48847937%20-0.4915672%203.96550105%20-1.75%205.4375%20C-2.79414063%206.67306641%20-2.79414063%206.67306641%20-3.859375%207.93359375%20C-6.01343015%2010.01296451%20-7.08310781%2010.63867326%20-10%2011%20C-9.09066991%209.72390677%20-8.17217147%208.45434447%20-7.25%207.1875%20C-6.73953125%206.47980469%20-6.2290625%205.77210938%20-5.703125%205.04296875%20C-3.97517642%202.97022309%20-2.21473524%201.52624146%200%200%20Z%20%22%20fill%3D%22%23BC753C%22%20transform%3D%22translate(205%2C243)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C3.26008643%203.16952847%206.22237877%206.39937989%209%2010%20C8.67%2010.66%208.34%2011.32%208%2012%20C4.83769026%209.60690073%202.04092395%207.43734561%200%204%20C0%202.68%200%201.36%200%200%20Z%20%22%20fill%3D%22%23221002%22%20transform%3D%22translate(652%2C237)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C3.23861303%201.44424635%205.61969163%203.25772247%208.25%205.625%20C8.95640625%206.25664062%209.6628125%206.88828125%2010.390625%207.5390625%20C10.92171875%208.02117187%2011.4528125%208.50328125%2012%209%20C8.1544104%209%206.25466136%208.03416335%203%206%20C1.125%202.8125%201.125%202.8125%200%200%20Z%20%22%20fill%3D%22%23773805%22%20transform%3D%22translate(597%2C191)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.31%201.32%20-4.62%202.64%20-7%204%20C-6.67%204.66%20-6.34%205.32%20-6%206%20C-7.65%206.33%20-9.3%206.66%20-11%207%20C-11.66%206.01%20-12.32%205.02%20-13%204%20C-11.59248779%203.13083113%20-10.1735479%202.28014851%20-8.75%201.4375%20C-7.96109375%200.96183594%20-7.1721875%200.48617187%20-6.359375%20-0.00390625%20C-3.69155375%20-1.13022151%20-2.65498232%20-1.0169313%200%200%20Z%20%22%20fill%3D%22%23CB9F7B%22%20transform%3D%22translate(308%2C150)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0%200.99%200%201.98%200%203%20C-0.66%203.66%20-1.32%204.32%20-2%205%20C-2.433125%206.2065625%20-2.433125%206.2065625%20-2.875%207.4375%20C-4.14106224%2010.32130844%20-5.37684406%2011.3386679%20-8%2013%20C-7.48118887%208.8275894%20-6.28848726%206.74583179%20-3.4375%203.6875%20C-2.79683594%202.99011719%20-2.15617188%202.29273438%20-1.49609375%201.57421875%20C-1.00238281%201.05472656%20-0.50867188%200.53523437%200%200%20Z%20%22%20fill%3D%22%232A2A2A%22%20transform%3D%22translate(620%2C593)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0%204.144163%20-0.88134668%207.60168334%20-3.5%2010.875%20C-5%2012%20-5%2012%20-7%2012%20C-5.63855967%206.80177328%20-3.53269829%203.90456127%200%200%20Z%20%22%20fill%3D%22%23636363%22%20transform%3D%22translate(625%2C593)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-3.36736031%202.82858266%20-6.87451958%204.4998253%20-11%206%20C-11.99%205.67%20-12.98%205.34%20-14%205%20C-12.68%204.67%20-11.36%204.34%20-10%204%20C-10%203.34%20-10%202.68%20-10%202%20C-8.71211992%201.46987262%20-7.41953322%200.9511671%20-6.125%200.4375%20C-5.40570313%200.14746094%20-4.68640625%20-0.14257812%20-3.9453125%20-0.44140625%20C-2%20-1%20-2%20-1%200%200%20Z%20%22%20fill%3D%22%23595959%22%20transform%3D%22translate(508%2C557)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C0.0625%204.125%200.0625%204.125%20-1%206%20C-1.66%206%20-2.32%206%20-3%206%20C-3%206.66%20-3%207.32%20-3%208%20C-3.66%208%20-4.32%208%20-5%208%20C-5%206.02%20-5%204.04%20-5%202%20C-3.35%201.34%20-1.7%200.68%200%200%20Z%20%22%20fill%3D%22%23DDDDDD%22%20transform%3D%22translate(660%2C546)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C1.63019694%209.17286652%201.63019694%209.17286652%20-1%2012.625%20C-1.66%2013.07875%20-2.32%2013.5325%20-3%2014%20C-2.48594831%209.03083364%20-1.76615118%204.70973649%200%200%20Z%20%22%20fill%3D%22%23858585%22%20transform%3D%22translate(681%2C499)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.10348268%203.31044803%200.99444068%205.65506316%200%209%20C-0.99%209.495%20-0.99%209.495%20-2%2010%20C-2.65555119%2012.52733235%20-2.65555119%2012.52733235%20-3%2015%20C-3.33%2015%20-3.66%2015%20-4%2015%20C-4.1953125%208.9453125%20-4.1953125%208.9453125%20-4%207%20C-3.34%206.34%20-2.68%205.68%20-2%205%20C-1.29289322%203.35008418%20-0.62056011%201.68437744%200%200%20Z%20%22%20fill%3D%22%23727272%22%20transform%3D%22translate(686%2C488)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-5.57765673%202.94033413%20-10.85326729%205.53012914%20-17%207%20C-16.67%206.34%20-16.34%205.68%20-16%205%20C-15.01%205%20-14.02%205%20-13%205%20C-13%204.34%20-13%203.68%20-13%203%20C-11.21189234%202.30329584%20-9.41937948%201.61788811%20-7.625%200.9375%20C-6.62726563%200.55464844%20-5.62953125%200.17179687%20-4.6015625%20-0.22265625%20C-2%20-1%20-2%20-1%200%200%20Z%20%22%20fill%3D%22%23CB7630%22%20transform%3D%22translate(479%2C333)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1%203%201%203%200.375%204.9375%20C-1.36682788%207.55024181%20-3.48604256%209.14761031%20-6%2011%20C-5.39305845%207.84669446%20-4.3583335%205.81111133%20-2.4375%203.25%20C-1.98246094%202.63640625%20-1.52742187%202.0228125%20-1.05859375%201.390625%20C-0.70925781%200.93171875%20-0.35992187%200.4728125%200%200%20Z%20%22%20fill%3D%22%23242220%22%20transform%3D%22translate(182%2C245)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.33%201.98%200.66%203%201%20C2.0919838%202.13199353%201.17316174%203.25532363%200.25%204.375%20C-0.26046875%205.00148437%20-0.7709375%205.62796875%20-1.296875%206.2734375%20C-3.08199481%208.08312318%20-4.67949644%209.00117455%20-7%2010%20C-5.33248852%206.05860922%20-2.77289351%203.2107188%200%200%20Z%20%22%20fill%3D%22%23804D24%22%20transform%3D%22translate(215%2C210)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C4.97306516%200.49730652%208.63799813%201.55302334%2013%204%20C13%204.33%2013%204.66%2013%205%20C7.36529617%205.5497272%204.61012242%203.95047835%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23281303%22%20transform%3D%22translate(541%2C152)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.31%200.33%204.62%200.66%207%201%20C7%201.66%207%202.32%207%203%20C7.99%203.33%208.98%203.66%2010%204%20C6.19881294%205.26706235%204.6149628%204.57172296%201%203%20C0.67%202.01%200.34%201.02%200%200%20Z%20%22%20fill%3D%22%23CB7530%22%20transform%3D%22translate(379%2C340)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C0.07421875%204.34765625%200.07421875%204.34765625%20-1.3125%207.0625%20C-1.98732422%208.41021484%20-1.98732422%208.41021484%20-2.67578125%209.78515625%20C-4%2012%20-4%2012%20-6%2013%20C-3.10933941%203.40546697%20-3.10933941%203.40546697%200%200%20Z%20%22%20fill%3D%22%238F8F8F%22%20transform%3D%22translate(178%2C296)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-0.08291164%204.12436746%20-0.61276477%204.5365026%20-3.9375%205.75%20C-4.62714844%206.01296875%20-5.31679688%206.2759375%20-6.02734375%206.546875%20C-8%207%20-8%207%20-11%206%20C-9.21385682%204.96953278%20-7.42089982%203.95086764%20-5.625%202.9375%20C-4.62726562%202.36902344%20-3.62953125%201.80054688%20-2.6015625%201.21484375%20C-1.74304688%200.81394531%20-0.88453125%200.41304687%200%200%20Z%20%22%20fill%3D%22%23816B5B%22%20transform%3D%22translate(650%2C251)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200%201.32%200%202%200%20C0.76075855%204.95696581%20-0.78577758%207.11658466%20-5%2010%20C-4.49890042%205.61537866%20-3.01704885%203.1999003%200%200%20Z%20%22%20fill%3D%22%233F3F3F%22%20transform%3D%22translate(636%2C572)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C5.15464734%200.48324819%208.81550319%203.18610761%2013%206%20C12.01%206.495%2012.01%206.495%2011%207%20C9.16015625%206.328125%209.16015625%206.328125%207.0625%205.25%20C6.37285156%204.90453125%205.68320313%204.5590625%204.97265625%204.203125%20C2.99352409%202.99605034%201.56101565%201.70292617%200%200%20Z%20%22%20fill%3D%22%234E4E4E%22%20transform%3D%22translate(228%2C507)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0%203%200%203%20-1.0625%204.4375%20C-3.90375254%206.72883269%20-6.72378221%208.3618911%20-10%2010%20C-10.99%209.67%20-11.98%209.34%20-13%209%20C-9.76175819%206.22436416%20-6.93902299%204.5548775%20-3%203%20C-1.22722741%201.47992158%20-1.22722741%201.47992158%200%200%20Z%20%22%20fill%3D%22%231C1C1C%22%20transform%3D%22translate(712%2C458)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.33%201.98%200.66%203%201%20C2.58221009%206.7097955%200.42453429%209.60957142%20-3%2014%20C-3.33%2013.34%20-3.66%2012.68%20-4%2012%20C-2.75%209.6875%20-2.75%209.6875%20-1%207%20C-0.443125%206.071875%200.11375%205.14375%200.6875%204.1875%20C1.120625%203.465625%201.55375%202.74375%202%202%20C1.34%202%200.68%202%200%202%20C0%201.34%200%200.68%200%200%20Z%20%22%20fill%3D%22%239D9997%22%20transform%3D%22translate(196%2C255)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.66666667%201.66666667%203.33333333%203.33333333%205%205%20C5.8971875%205.804375%205.8971875%205.804375%206.8125%206.625%20C8%208%208%208%208%2011%20C4.71573897%209.94434467%203.42848444%208.38339648%201.75%205.5%20C0%202%200%202%200%200%20Z%20%22%20fill%3D%22%237E3B06%22%20transform%3D%22translate(646%2C238)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.99%200.66%201.98%201%203%20C1.66%202.34%202.32%201.68%203%201%20C2.38461538%206.53846154%202.38461538%206.53846154%200.4375%208.875%20C-0.036875%209.24625%20-0.51125%209.6175%20-1%2010%20C-2.15837626%205.94568308%20-1.83691257%203.78187881%200%200%20Z%20%22%20fill%3D%22%23D7D7D7%22%20transform%3D%22translate(668%2C524)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C7.57142857%204%207.57142857%204%2010%208%20C9.401875%207.67%208.80375%207.34%208.1875%207%20C5.94613529%205.79212012%205.94613529%205.79212012%203%206%20C3%205.34%203%204.68%203%204%20C2.01%203.67%201.02%203.34%200%203%20C0%202.01%200%201.02%200%200%20Z%20%22%20fill%3D%22%231F0E01%22%20transform%3D%22translate(599%2C185)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.32%200.33%202.64%200.66%204%201%20C-0.455%204.465%20-0.455%204.465%20-5%208%20C-5%205%20-5%205%20-2.75%202.25%20C-1.8425%201.5075%20-0.935%200.765%200%200%20Z%20%22%20fill%3D%22%236D4C31%22%20transform%3D%22translate(253%2C176)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-1.65%201.65%20-3.3%203.3%20-5%205%20C-5.99%204.67%20-6.98%204.34%20-8%204%20C-5.97675095%20-0.48005146%20-4.79569304%20-1.43870791%200%200%20Z%20%22%20fill%3D%22%236D3508%22%20transform%3D%22translate(361%2C139)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.65234375%201.734375%200.65234375%201.734375%201%204%20C0.00390625%206.140625%200.00390625%206.140625%20-1.4375%208.25%20C-1.91058594%208.95640625%20-2.38367188%209.6628125%20-2.87109375%2010.390625%20C-3.24363281%2010.92171875%20-3.61617187%2011.4528125%20-4%2012%20C-4.65234375%2010.265625%20-4.65234375%2010.265625%20-5%208%20C-4.00390625%205.859375%20-4.00390625%205.859375%20-2.5625%203.75%20C-2.08941406%203.04359375%20-1.61632812%202.3371875%20-1.12890625%201.609375%20C-0.75636719%201.07828125%20-0.38382813%200.5471875%200%200%20Z%20%22%20fill%3D%22%23646464%22%20transform%3D%22translate(660%2C532)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-1.95330868%201.03041513%20-3.91281528%202.0490893%20-5.875%203.0625%20C-6.96554687%203.63097656%20-8.05609375%204.19945312%20-9.1796875%204.78515625%20C-10.11039063%205.18605469%20-11.04109375%205.58695313%20-12%206%20C-12.66%205.67%20-13.32%205.34%20-14%205%20C-12.75443908%204.18071114%20-11.50333365%203.36984814%20-10.25%202.5625%20C-9.20585938%201.88380859%20-9.20585938%201.88380859%20-8.140625%201.19140625%20C-5.17385561%20-0.45980664%20-3.14566509%20-1.57283254%200%200%20Z%20%22%20fill%3D%22%23555555%22%20transform%3D%22translate(551%2C537)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.0169313%202.65498232%201.13022151%203.69155375%200.00390625%206.359375%20C-0.47175781%207.14828125%20-0.94742188%207.9371875%20-1.4375%208.75%20C-2.14712891%209.94882812%20-2.14712891%209.94882812%20-2.87109375%2011.171875%20C-3.24363281%2011.77515625%20-3.61617187%2012.3784375%20-4%2013%20C-5.0169313%2010.34501768%20-5.13022151%209.30844625%20-4.00390625%206.640625%20C-3.52824219%205.85171875%20-3.05257812%205.0628125%20-2.5625%204.25%20C-2.08941406%203.45078125%20-1.61632812%202.6515625%20-1.12890625%201.828125%20C-0.75636719%201.22484375%20-0.38382813%200.6215625%200%200%20Z%20%22%20fill%3D%22%239E9E9E%22%20transform%3D%22translate(670%2C529)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.66%201.32%201.32%202%202%20C0.02%205.63%20-1.96%209.26%20-4%2013%20C-5%209%20-5%209%20-4.00390625%206.640625%20C-3.52824219%205.85171875%20-3.05257812%205.0628125%20-2.5625%204.25%20C-2.08941406%203.45078125%20-1.61632812%202.6515625%20-1.12890625%201.828125%20C-0.75636719%201.22484375%20-0.38382813%200.6215625%200%200%20Z%20%22%20fill%3D%22%23939393%22%20transform%3D%22translate(189%2C274)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C3.465%201.98%203.465%201.98%207%204%20C7%205.98%207%207.96%207%2010%20C4.74754119%207.31158141%203.11786042%205.35358125%202%202%20C1.34%202%200.68%202%200%202%20C0%201.34%200%200.68%200%200%20Z%20%22%20fill%3D%22%23242424%22%20transform%3D%22translate(664%2C258)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C3.62613199%200.56959153%205.25517741%201.92374534%207.75%204.5625%20C8.36359375%205.20316406%208.9771875%205.84382812%209.609375%206.50390625%20C10.06828125%206.99761719%2010.5271875%207.49132812%2011%208%20C10.67%208.99%2010.34%209.98%2010%2011%20C9.61328125%2010.54109375%209.2265625%2010.0821875%208.828125%209.609375%20C5.99804049%206.274919%203.15638645%203.03498697%200%200%20Z%20%22%20fill%3D%22%233C1C02%22%20transform%3D%22translate(616%2C202)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.8125%20-0.1875%202.8125%20-0.1875%206%200%20C6.99%200.99%207.98%201.98%209%203%20C6.03%203%203.06%203%200%203%20C0%202.01%200%201.02%200%200%20Z%20%22%20fill%3D%22%23863E05%22%20transform%3D%22translate(556%2C168)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.45699392%202.63249349%20-4.56568654%204.78137264%20-8%206%20C-8.99%205.67%20-9.98%205.34%20-11%205%20C-4.85714286%20-0.71428571%20-4.85714286%20-0.71428571%200%200%20Z%20%22%20fill%3D%22%232B2B2B%22%20transform%3D%22translate(486%2C568)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C4.55712436%200.5425148%208.02568234%201.6893502%2012%204%20C12.33%204.66%2012.66%205.32%2013%206%20C8.14036821%205.39254603%204.2594482%203.27241033%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23C57738%22%20transform%3D%22translate(318%2C312)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.66%201.98%201.32%203%202%20C-0.465%204.97%20-0.465%204.97%20-4%208%20C-3.50168276%204.31245243%20-2.89932357%202.39509338%200%200%20Z%20%22%20fill%3D%22%23756F6A%22%20transform%3D%22translate(194%2C253)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.33%201.98%200.66%203%201%20C0.03%203.64%20-2.94%206.28%20-6%209%20C-6%206%20-6%206%20-4.6875%204.39453125%20C-4.130625%203.87246094%20-3.57375%203.35039062%20-3%202.8125%20C-2.443125%202.28269531%20-1.88625%201.75289062%20-1.3125%201.20703125%20C-0.6628125%200.60955078%20-0.6628125%200.60955078%200%200%20Z%20%22%20fill%3D%22%23B46D33%22%20transform%3D%22translate(209%2C237)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C0.00390625%204.3828125%200.00390625%204.3828125%20-1.4375%207.125%20C-1.91058594%208.03507813%20-2.38367188%208.94515625%20-2.87109375%209.8828125%20C-3.24363281%2010.58148437%20-3.61617187%2011.28015625%20-4%2012%20C-4.65234375%2010.265625%20-4.65234375%2010.265625%20-5%208%20C-4.00390625%205.859375%20-4.00390625%205.859375%20-2.5625%203.75%20C-2.08941406%203.04359375%20-1.61632812%202.3371875%20-1.12890625%201.609375%20C-0.75636719%201.07828125%20-0.38382813%200.5471875%200%200%20Z%20%22%20fill%3D%22%23979797%22%20transform%3D%22translate(660%2C536)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.92540704%200.62687294%205.4835249%201.35127493%208%203%20C8.75%205.125%208.75%205.125%209%207%20C5.18315774%205.44499019%202.80804268%202.96404505%200%200%20Z%20%22%20fill%3D%22%233E1D02%22%20transform%3D%22translate(591%2C182)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-7.42857143%204.42857143%20-7.42857143%204.42857143%20-11%205%20C-4.75324675%20-1.58441558%20-4.75324675%20-1.58441558%200%200%20Z%20%22%20fill%3D%22%23212121%22%20transform%3D%22translate(613%2C509)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C-3.75%206.875%20-3.75%206.875%20-6%208%20C-5.8125%205.6875%20-5.8125%205.6875%20-5%203%20C-2.4375%201.1875%20-2.4375%201.1875%200%200%20Z%20%22%20fill%3D%22%23A3A3A3%22%20transform%3D%22translate(170%2C306)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-4.30769231%203.93846154%20-4.30769231%203.93846154%20-7.8125%204.25%20C-8.534375%204.1675%20-9.25625%204.085%20-10%204%20C-6.87839899%200.56623888%20-4.64008112%20-1.54669371%200%200%20Z%20%22%20fill%3D%22%23AB7C55%22%20transform%3D%22translate(577%2C287)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C4.75481646%200.57634139%207.97048212%202.55068521%2012%205%20C10%206%2010%206%207.6875%205.3125%20C4.74961699%203.87771993%202.47613357%202.12240021%200%200%20Z%20%22%20fill%3D%22%23D0742B%22%20transform%3D%22translate(250%2C279)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-1.96%204.465%20-1.96%204.465%20-6%208%20C-6.66%207.67%20-7.32%207.34%20-8%207%20C-3.76744186%201.25581395%20-3.76744186%201.25581395%200%200%20Z%20%22%20fill%3D%22%23954709%22%20transform%3D%22translate(262%2C190)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-0.97%203.64%20-3.94%206.28%20-7%209%20C-7.66%208.67%20-8.32%208.34%20-9%208%20C-7.87811441%206.85111717%20-6.75238316%205.70598863%20-5.625%204.5625%20C-4.99851562%203.92441406%20-4.37203125%203.28632813%20-3.7265625%202.62890625%20C-2%201%20-2%201%200%200%20Z%20%22%20fill%3D%22%236A3206%22%20transform%3D%22translate(333%2C145)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%201.32%201.32%202.64%202%204%20C0.35%205.65%20-1.3%207.3%20-3%209%20C-2.5020163%205.26512223%20-2.12508244%203.18762365%200%200%20Z%20%22%20fill%3D%22%23C4C4C4%22%20transform%3D%22translate(648%2C562)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.40907283%202.81814566%200.50872691%204.17277204%20-0.4375%207.125%20C-0.72496094%208.03507812%20-1.01242188%208.94515625%20-1.30859375%209.8828125%20C-1.53675781%2010.58148438%20-1.76492187%2011.28015625%20-2%2012%20C-2.33%2012%20-2.66%2012%20-3%2012%20C-3.36923077%204.61538462%20-3.36923077%204.61538462%20-1.5%201.5%20C-1.005%201.005%20-0.51%200.51%200%200%20Z%20%22%20fill%3D%22%235D5D5D%22%20transform%3D%22translate(157%2C321)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-3.42346555%203.14958831%20-6.44262737%203.56179109%20-11%204%20C-9.71264403%201.42528807%20-8.71510189%201.29583343%20-6.0625%200.3125%20C-5.35222656%200.04050781%20-4.64195312%20-0.23148437%20-3.91015625%20-0.51171875%20C-2%20-1%20-2%20-1%200%200%20Z%20%22%20fill%3D%22%23BB7943%22%20transform%3D%22translate(640%2C257)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.33%201.98%200.66%203%201%20C2.0479279%202.00596297%201.08812654%203.00461563%200.125%204%20C-0.40867188%204.556875%20-0.94234375%205.11375%20-1.4921875%205.6875%20C-3%207%20-3%207%20-5%207%20C-3.70700306%204.11562221%20-2.34058637%202.12780579%200%200%20Z%20%22%20fill%3D%22%238A572E%22%20transform%3D%22translate(222%2C204)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C7.81636537%201.91722169%207.81636537%201.91722169%2010%205%20C10%205.66%2010%206.32%2010%207%20C9.01%207%208.02%207%207%207%20C5.98594743%205.67732273%204.98731742%204.34275169%204%203%20C1.91665365%201.7483533%201.91665365%201.7483533%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23472103%22%20transform%3D%22translate(569%2C168)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.515625%200.2475%201.03125%200.495%201.5625%200.75%20C-4.8375%204.81153846%20-4.8375%204.81153846%20-7.875%204.5%20C-8.390625%204.2525%20-8.90625%204.005%20-9.4375%203.75%20C-3.0375%20-0.31153846%20-3.0375%20-0.31153846%200%200%20Z%20%22%20fill%3D%22%238F5D34%22%20transform%3D%22translate(289.4375%2C162.25)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.81080836%201.14726872%204.1782406%201.94701628%206.0625%204.25%20C-1.5625%202.5%20-1.5625%202.5%20-4.9375%200.25%20C-2.9375%20-0.75%20-2.9375%20-0.75%200%200%20Z%20%22%20fill%3D%22%23200F02%22%20transform%3D%22translate(560.9375%2C159.75)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C0.73760288%201.86658615%20-0.53527501%202.71792059%20-1.8125%203.5625%20C-2.87404297%204.27599609%20-2.87404297%204.27599609%20-3.95703125%205.00390625%20C-6%206%20-6%206%20-9%205%20C-2.25%201.125%20-2.25%201.125%200%200%20Z%20%22%20fill%3D%22%23222222%22%20transform%3D%22translate(513%2C554)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C7.57142857%201.85714286%207.57142857%201.85714286%2010%205%20C5.2482602%204.56802365%203.07999946%203.67230705%200%200%20Z%20%22%20fill%3D%22%23A57D5D%22%20transform%3D%22translate(384%2C344)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1%202%201%202%200.375%204%20C-1.39265071%206.57112831%20-3.07589059%207.07659703%20-6%208%20C-4.55746343%204.63408134%20-2.66735273%202.48952921%200%200%20Z%20%22%20fill%3D%22%2339200B%22%20transform%3D%22translate(201%2C222)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-1.465%203.97%20-1.465%203.97%20-5%207%20C-5.33%205.68%20-5.66%204.36%20-6%203%20C-5.38125%202.87625%20-4.7625%202.7525%20-4.125%202.625%20C-1.80879168%202.12802644%20-1.80879168%202.12802644%200%200%20Z%20%22%20fill%3D%22%23888888%22%20transform%3D%22translate(639%2C581)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C0.75023244%204.65316671%200.32901247%205.78065836%20-3%208%20C-2.45276317%204.62537285%20-1.9451%202.91765%200%200%20Z%20%22%20fill%3D%22%23202020%22%20transform%3D%22translate(630%2C577)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C6.52307692%200.61538462%206.52307692%200.61538462%208.9375%202.5625%20C9.288125%203.036875%209.63875%203.51125%2010%204%20C6.39703406%204.41176754%205.21597933%204.1535853%202.1875%202%20C1.465625%201.34%200.74375%200.68%200%200%20Z%20%22%20fill%3D%22%235F5F5F%22%20transform%3D%22translate(268%2C526)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C0.22265625%204.1640625%200.22265625%204.1640625%20-0.9375%206.625%20C-1.31777344%207.44226563%20-1.69804688%208.25953125%20-2.08984375%209.1015625%20C-2.39019531%209.72804688%20-2.69054687%2010.35453125%20-3%2011%20C-3.83583327%208.62392051%20-4.1842383%207.45550373%20-3.22265625%205.078125%20C-1.61132812%202.5390625%20-1.61132812%202.5390625%200%200%20Z%20%22%20fill%3D%22%23606060%22%20transform%3D%22translate(668%2C514)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.91058531%203.07322544%201.08886184%205.80097361%201%209%20C0.01%209%20-0.98%209%20-2%209%20C-1.125%201.125%20-1.125%201.125%200%200%20Z%20%22%20fill%3D%22%23ADADAD%22%20transform%3D%22translate(688%2C402)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-5.17578125%203.22265625%20-5.17578125%203.22265625%20-7%204%20C-7.99%203.67%20-8.98%203.34%20-10%203%20C-3.375%20-1.125%20-3.375%20-1.125%200%200%20Z%20%22%20fill%3D%22%23A07E62%22%20transform%3D%22translate(467%2C340)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-0.66%200%20-1.32%200%20-2%200%20C-2%200.66%20-2%201.32%20-2%202%20C-4.31%202.66%20-6.62%203.32%20-9%204%20C-6.35287314%200.09233654%20-4.86783735%20-1.62261245%200%200%20Z%20%22%20fill%3D%22%23AB7C55%22%20transform%3D%22translate(527%2C311)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.32%200.33%202.64%200.66%204%201%20C2.02%201.99%202.02%201.99%200%203%20C0%202.01%200%201.02%200%200%20Z%20M-2%203%20C-1.34%203.33%20-0.68%203.66%200%204%20C-0.99%204.99%20-1.98%205.98%20-3%207%20C-3.66%206.67%20-4.32%206.34%20-5%206%20C-4.01%205.01%20-3.02%204.02%20-2%203%20Z%20%22%20fill%3D%22%236B3306%22%20transform%3D%22translate(339%2C143)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.53625%200.226875%201.0725%200.45375%201.625%200.6875%20C-3.79038462%203.76442308%20-3.79038462%203.76442308%20-6.75%203.375%20C-7.554375%203.0346875%20-7.554375%203.0346875%20-8.375%202.6875%20C-2.95961538%20-0.38942308%20-2.95961538%20-0.38942308%200%200%20Z%20%22%20fill%3D%22%23A57D5D%22%20transform%3D%22translate(451.375%2C346.3125)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.96713413%202.95070119%202.65358161%204.53581611%203%208%20C2.34%208.99%201.68%209.98%201%2011%20C-0.17571451%207.32589215%20-0.07366746%203.83070817%200%200%20Z%20%22%20fill%3D%22%23444444%22%20transform%3D%22translate(694%2C316)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.33%201.98%200.66%203%201%20C2.67%202.32%202.34%203.64%202%205%20C1.01%205%200.02%205%20-1%205%20C-0.67%203.35%20-0.34%201.7%200%200%20Z%20%22%20fill%3D%22%238D8B8A%22%20transform%3D%22translate(199%2C257)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2%203.75%202%203.75%202%206%20C0.0625%205.1875%200.0625%205.1875%20-2%204%20C-2.33%203.01%20-2.66%202.02%20-3%201%20C-2.01%200.67%20-1.02%200.34%200%200%20Z%20%22%20fill%3D%22%23C78D5E%22%20transform%3D%22translate(200%2C252)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.17424117%202.50037734%20-3.73045798%203.43628586%20-7%204%20C-7.33%203.01%20-7.66%202.02%20-8%201%20C-5.07175348%200.02391783%20-3.04386724%20-0.08226668%200%200%20Z%20%22%20fill%3D%22%23F2CBA4%22%20transform%3D%22translate(341%2C139)%22%2F%3E%0A%3C%2Fsvg%3E%0A', GeofencingAdd, GeofencingColor, AppData);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Max() {
  Max_Markers = [];
  try {
    addItemToList(Max_Markers, ((await Promise.all([(getObjectProperty(((await asyncListSort((await asyncListFilter((await Promise.all(TrackingData.map(async item => {; return ({ [`Value`]: (getObjectProperty(item, 'position.speed')),[`Item`]: item });}))), async (item) => {


     return ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Value')))) ? null : item);
    })), 1, async (item) => {


     return (getObjectProperty(item, 'Value'));
    })).slice(-1)[0]), 'Item'))].map(async item => {; return ({ [`lat`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.latitude')))) ? null : (getObjectProperty(item, 'position.latitude')),[`lng`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.longitude')))) ? null : (getObjectProperty(item, 'position.longitude')),[`Data`]: (await BackendlessUI.Functions.Custom['fn_3a793fed77a519bfe0e8407457e3fd8c']((await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Date',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toDateString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Time',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toLocaleTimeString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'ID')))) ? null : ({ [`Label`]: 'Fleet ID',[`Value`]: (getObjectProperty(VehicleData, 'ID')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Registration')))) ? null : ({ [`Label`]: 'Registration',[`Value`]: (getObjectProperty(VehicleData, 'Registration')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ({ [`Label`]: 'Driver',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Nickname')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')))) ? null : ({ [`Label`]: 'Driver Mobile',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }))], async (item) => {


     return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
    })), (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.vehicle.mileage')))) ? null : ({ [`Label`]: 'Odometer',[`Value`]: String(getObjectProperty(item, 'can.vehicle.mileage')) + String(' km'),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : ({ [`Label`]: 'Speed',[`Value`]: [(getObjectProperty(item, 'position.speed')),' km/h',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Speed')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max Speed')),')'].join('')].join(''),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ({ [`Label`]: 'Fuel Level',[`Value`]: String(((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) + String(' L'),[`Color`]: 'rgba(70, 130, 180, 0.5)' })), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Current_Fuel_Consumption_Last_5_Tanks')))) ? null : ({ [`Label`]: 'Range Est.',[`Value`]: String((((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) * (getObjectProperty(VehicleData, 'Current_Fuel_Consumption_Last_5_Tanks'))) + String(' km'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }))), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.altitude')))) ? null : ({ [`Label`]: 'Altitude',[`Value`]: String(getObjectProperty(item, 'position.altitude')) + String(' m'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.rpm')))) ? null : ({ [`Label`]: 'RPM',[`Value`]: [(getObjectProperty(item, 'can.engine.rpm')),' RPM',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max RPM')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max RPM')),')'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.temperature')))) ? null : ({ [`Label`]: 'Engine Temp.',[`Value`]: String(getObjectProperty(item, 'can.engine.temperature')) + String('°'),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.throttle.pedal.level')))) ? null : ({ [`Label`]: 'Throttle Pedal',[`Value`]: [(getObjectProperty(item, 'can.throttle.pedal.level')),'% - ',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Pedal')))) ? null : ['(',(getObjectProperty(VehicleData, 'Can Max Pedal')),'%)'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' })], async (item) => {


     return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
    })))),[`color`]: '#cc6633',[`Speed`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : (getObjectProperty(item, 'position.speed')),[`Direction`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.direction')))) ? null : (getObjectProperty(item, 'position.direction')) });})))[0]));

  } catch (error) {
    console.log(error);

  }
  try {
    addItemToList(Max_Markers, ((await Promise.all([(getObjectProperty(((await asyncListSort((await asyncListFilter((await Promise.all(TrackingData.map(async item => {; return ({ [`Value`]: (getObjectProperty(item, 'can.engine.rpm')),[`Item`]: item });}))), async (item) => {


     return ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Value')))) ? null : item);
    })), 1, async (item) => {


     return (getObjectProperty(item, 'Value'));
    })).slice(-1)[0]), 'Item'))].map(async item => {; return ({ [`lat`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.latitude')))) ? null : (getObjectProperty(item, 'position.latitude')),[`lng`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.longitude')))) ? null : (getObjectProperty(item, 'position.longitude')),[`Data`]: (await BackendlessUI.Functions.Custom['fn_3a793fed77a519bfe0e8407457e3fd8c']((await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Date',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toDateString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Time',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toLocaleTimeString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'ID')))) ? null : ({ [`Label`]: 'Fleet ID',[`Value`]: (getObjectProperty(VehicleData, 'ID')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Registration')))) ? null : ({ [`Label`]: 'Registration',[`Value`]: (getObjectProperty(VehicleData, 'Registration')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ({ [`Label`]: 'Driver',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Nickname')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')))) ? null : ({ [`Label`]: 'Driver Mobile',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }))], async (item) => {


     return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
    })), (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.vehicle.mileage')))) ? null : ({ [`Label`]: 'Odometer',[`Value`]: String(getObjectProperty(item, 'can.vehicle.mileage')) + String(' km'),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : ({ [`Label`]: 'Speed',[`Value`]: [(getObjectProperty(item, 'position.speed')),' km/h',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Speed')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max Speed')),')'].join('')].join(''),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ({ [`Label`]: 'Fuel Level',[`Value`]: String(((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) + String(' L'),[`Color`]: 'rgba(70, 130, 180, 0.5)' })), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(VehicleData, 'Current_Fleetview')), 'Fuel_Consumption_5Tanks')))) ? null : ({ [`Label`]: 'Range Est.',[`Value`]: String((((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) * (getObjectProperty((getObjectProperty(VehicleData, 'Current_Fleetview')), 'Fuel_Consumption_5Tanks'))) + String(' km'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }))), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.altitude')))) ? null : ({ [`Label`]: 'Altitude',[`Value`]: String(getObjectProperty(item, 'position.altitude')) + String(' m'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.rpm')))) ? null : ({ [`Label`]: 'RPM',[`Value`]: [(getObjectProperty(item, 'can.engine.rpm')),' RPM',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max RPM')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max RPM')),')'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.temperature')))) ? null : ({ [`Label`]: 'Engine Temp.',[`Value`]: String(getObjectProperty(item, 'can.engine.temperature')) + String('°'),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.throttle.pedal.level')))) ? null : ({ [`Label`]: 'Throttle Pedal',[`Value`]: [(getObjectProperty(item, 'can.throttle.pedal.level')),'% - ',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Pedal')))) ? null : ['(',(getObjectProperty(VehicleData, 'Can Max Pedal')),'%)'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' })], async (item) => {


     return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
    })))),[`color`]: '#A020F0',[`Speed`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : (getObjectProperty(item, 'position.speed')),[`Direction`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.direction')))) ? null : (getObjectProperty(item, 'position.direction')) });})))[0]));

  } catch (error) {
    console.log(error);

  }
  try {
    addItemToList(Max_Markers, ((await Promise.all([(getObjectProperty(((await asyncListSort((await asyncListFilter((await Promise.all(TrackingData.map(async item => {; return ({ [`Value`]: (getObjectProperty(item, 'can.engine.temperature')),[`Item`]: item });}))), async (item) => {


     return ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Value')))) ? null : item);
    })), 1, async (item) => {


     return (getObjectProperty(item, 'Value'));
    })).slice(-1)[0]), 'Item'))].map(async item => {; return ({ [`lat`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.latitude')))) ? null : (getObjectProperty(item, 'position.latitude')),[`lng`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.longitude')))) ? null : (getObjectProperty(item, 'position.longitude')),[`Data`]: (await BackendlessUI.Functions.Custom['fn_3a793fed77a519bfe0e8407457e3fd8c']((await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.temperature')))) ? null : ({ [`Label`]: 'Engine Temp.',[`Value`]: String(getObjectProperty(item, 'can.engine.temperature')) + String('°'),[`Color`]: 'rgba(255, 255, 0, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Date',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toDateString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Time',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toLocaleTimeString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'ID')))) ? null : ({ [`Label`]: 'Fleet ID',[`Value`]: (getObjectProperty(VehicleData, 'ID')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Registration')))) ? null : ({ [`Label`]: 'Registration',[`Value`]: (getObjectProperty(VehicleData, 'Registration')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ({ [`Label`]: 'Driver',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Nickname')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')))) ? null : ({ [`Label`]: 'Driver Mobile',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }))], async (item) => {


     return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
    })), (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.vehicle.mileage')))) ? null : ({ [`Label`]: 'Odometer',[`Value`]: String(getObjectProperty(item, 'can.vehicle.mileage')) + String(' km'),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : ({ [`Label`]: 'Speed',[`Value`]: [(getObjectProperty(item, 'position.speed')),' km/h',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Speed')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max Speed')),')'].join('')].join(''),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ({ [`Label`]: 'Fuel Level',[`Value`]: String(((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) + String(' L'),[`Color`]: 'rgba(70, 130, 180, 0.5)' })), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(VehicleData, 'Current_Fleetview')), 'Fuel_Consumption_5Tanks')))) ? null : ({ [`Label`]: 'Range Est.',[`Value`]: String((((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) * (getObjectProperty((getObjectProperty(VehicleData, 'Current_Fleetview')), 'Fuel_Consumption_5Tanks'))) + String(' km'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }))), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.altitude')))) ? null : ({ [`Label`]: 'Altitude',[`Value`]: String(getObjectProperty(item, 'position.altitude')) + String(' m'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.rpm')))) ? null : ({ [`Label`]: 'RPM',[`Value`]: [(getObjectProperty(item, 'can.engine.rpm')),' RPM',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max RPM')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max RPM')),')'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.throttle.pedal.level')))) ? null : ({ [`Label`]: 'Throttle Pedal',[`Value`]: [(getObjectProperty(item, 'can.throttle.pedal.level')),'% - ',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Pedal')))) ? null : ['(',(getObjectProperty(VehicleData, 'Can Max Pedal')),'%)'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' })], async (item) => {


     return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
    })))),[`color`]: '#FFFF00',[`Speed`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : (getObjectProperty(item, 'position.speed')),[`Direction`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.direction')))) ? null : (getObjectProperty(item, 'position.direction')) });})))[0]));

  } catch (error) {
    console.log(error);

  }
}

/**
 * Describe this function...
 */
async function Fuel_Loss() {
  Fuel_Loss_List = [];
  for (var j_index4 in TrackingData) {
    j = TrackingData[j_index4];
    Start_Marker = TrackingData[((TrackingData.indexOf(j) + 1) - 1)];
    try {
      End_Marker = TrackingData[(((TrackingData.indexOf(j) + 1) - 3) - 1)];

    } catch (error) {

    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](End_Marker))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(End_Marker, 'can.fuel.level'))))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Start_Marker, 'can.fuel.level'))))) {
        } else {
          if ((getObjectProperty(End_Marker, 'can.fuel.level')) - (getObjectProperty(Start_Marker, 'can.fuel.level')) > 3) {
            if ((((getObjectProperty(End_Marker, 'can.fuel.level')) - (getObjectProperty(Start_Marker, 'can.fuel.level'))) / 100) * (getObjectProperty(VehicleData, 'Tank_Capacity')) > 3) {
              Start_Marker['FuelLoss'] = ((getObjectProperty(End_Marker, 'can.fuel.level')) - (getObjectProperty(Start_Marker, 'can.fuel.level')));
              addItemToList(Fuel_Loss_List, Start_Marker);
              Markers = (await asyncListFilter(Markers, async (item) => {


               return (!((getObjectProperty(item, 'lat')) == (getObjectProperty(Start_Marker, 'position.latitude')) && (getObjectProperty(item, 'lng')) == (getObjectProperty(Start_Marker, 'position.longitude'))));
              }));
            }
          }
        }
      }
    }
  }
  Fuel_Loss_List = (await Promise.all(Fuel_Loss_List.map(async item => {; return ({ [`lat`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.latitude')))) ? null : (getObjectProperty(item, 'position.latitude')),[`lng`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.longitude')))) ? null : (getObjectProperty(item, 'position.longitude')),[`Data`]: (await BackendlessUI.Functions.Custom['fn_3a793fed77a519bfe0e8407457e3fd8c']((await asyncListFilter([({ [`Label`]: 'Fuel Loss',[`Value`]: String(((getObjectProperty(item, 'FuelLoss')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) + String(' L'),[`Color`]: 'rgba(255, 0, 0, 1)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Date',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toDateString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Time',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toLocaleTimeString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'ID')))) ? null : ({ [`Label`]: 'Fleet ID',[`Value`]: (getObjectProperty(VehicleData, 'ID')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Registration')))) ? null : ({ [`Label`]: 'Registration',[`Value`]: (getObjectProperty(VehicleData, 'Registration')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ({ [`Label`]: 'Driver',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Nickname')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')))) ? null : ({ [`Label`]: 'Driver Mobile',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }))], async (item) => {


   return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
  })), (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.vehicle.mileage')))) ? null : ({ [`Label`]: 'Odometer',[`Value`]: String(getObjectProperty(item, 'can.vehicle.mileage')) + String(' km'),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : ({ [`Label`]: 'Speed',[`Value`]: [(getObjectProperty(item, 'position.speed')),' km/h',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Speed')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max Speed')),')'].join('')].join(''),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ({ [`Label`]: 'Fuel Level',[`Value`]: String(((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) + String(' L'),[`Color`]: 'rgba(70, 130, 180, 0.5)' })), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Current_Fuel_Consumption_Last_5_Tanks')))) ? null : ({ [`Label`]: 'Range Est.',[`Value`]: String((((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) * (getObjectProperty(VehicleData, 'Current_Fuel_Consumption_Last_5_Tanks'))) + String(' km'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }))), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.altitude')))) ? null : ({ [`Label`]: 'Altitude',[`Value`]: String(getObjectProperty(item, 'position.altitude')) + String(' m'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.rpm')))) ? null : ({ [`Label`]: 'RPM',[`Value`]: [(getObjectProperty(item, 'can.engine.rpm')),' RPM',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max RPM')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max RPM')),')'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.temperature')))) ? null : ({ [`Label`]: 'Engine Temp.',[`Value`]: String(getObjectProperty(item, 'can.engine.temperature')) + String('°'),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.throttle.pedal.level')))) ? null : ({ [`Label`]: 'Throttle Pedal',[`Value`]: [(getObjectProperty(item, 'can.throttle.pedal.level')),'% - ',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Pedal')))) ? null : ['(',(getObjectProperty(VehicleData, 'Can Max Pedal')),'%)'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' })], async (item) => {


   return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
  })))),[`color`]: '#ff0000',[`Speed`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : (getObjectProperty(item, 'position.speed')),[`Direction`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.direction')))) ? null : (getObjectProperty(item, 'position.direction')),[`FuelLoss`]: (getObjectProperty(item, 'FuelLoss')),[`Icon`]: '<svg xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" id="svg22349" inkscape:version="0.48.3.1 r9886" viewBox="0 0 430.2 440" sodipodi:version="0.32" version="1.0" sodipodi:docname="_svgclean2.svg">   <sodipodi:namedview id="base" bordercolor="#666666" inkscape:pageshadow="2" guidetolerance="10.0" pagecolor="#ffffff" gridtolerance="10.0" inkscape:window-maximized="0" inkscape:window-width="743" inkscape:zoom="1" objecttolerance="10.0" showgrid="false" borderopacity="1.0" inkscape:current-layer="layer1" inkscape:cx="215.02547" inkscape:cy="218.71371" inkscape:window-y="0" inkscape:window-x="0" inkscape:window-height="484" showborder="false" inkscape:pageopacity="0.0"/>   <sodipodi:namedview id="namedview4" bordercolor="#666666" inkscape:pageshadow="2" inkscape:window-y="25" pagecolor="#ffffff" inkscape:window-width="1280" inkscape:zoom="1.4" inkscape:window-x="0" borderopacity="1.0" inkscape:current-layer="layer1" inkscape:cx="330.58005" inkscape:cy="240.69922" inkscape:window-height="949" inkscape:pageopacity="0.0" inkscape:document-units="px"/>   <g id="layer1" inkscape:label="Calque 1" inkscape:groupmode="layer" transform="translate(-5.5995 -3.6428)">     <path id="path22357" inkscape:connector-curvature="0" sodipodi:nodetypes="ccssssccccccc" style="fill-rule:evenodd;fill:#e43434" d="m60.709 3.6428c-11.428 8.5712-52.98 53.709-52.98 53.709 0.0005 0-5.5895 220.45 1.3424 232.17 12.594 21.27 157.02 106.64 170.92 106.98 5.23 0.12 97.26-54.56 98.79-59.63 5.63-18.77 4.73-186.19 0.88-205.16-3.51-17.32-81.07-91.603-81.07-91.603l-137.88-36.465zm10.359 32.265c30.002 6.429 68.922 17.021 71.072 29.163-1.79 5-4.51 7.048-8.41 10.649-5.81 0.469-35.581-15.019-49.08-19.911-3.499-4.892-13.582-19.187-13.582-19.901z"/>     <path id="path22359" inkscape:connector-curvature="0" sodipodi:nodetypes="ccccccccccccssscccccccsc" style="opacity:.25;fill-rule:evenodd;fill:#4a4a4a" d="m196.11 38.852c-8.7-4.751-35.53-6.651-40 5.714-4.27 11.806 8.23 75.614 25.65 108.58 32.32-3.16 66.92-4.78 95.05-23.45-6.75-13.78-71.26-85.699-80.7-90.848zm-127.72-2.929c-15.714 11.429-14.026 36.219-14.026 36.219s71.313 15.524 80.723 5.2c-21.3-3.895-33.14-13.076-50.809-20.649-7.552-6.83-6.71-15.301-15.888-20.77zm-37.806 72.677c-2.857 10 33.643 96.87 33.643 96.87s-32.806 65.3-34.235 71.02c-1.429 5.71 35.735-37.64 37.164-50.5 1.428-12.86 2.143-31.95-0.714-37.66-2.858-5.72-37.287-81.16-35.858-79.73zm90.833 35.04c-17.14 25.72-38.568 52.86-38.568 52.86s42.858-38.57 45.718-44.29c2.85-5.71-8.58-10-7.15-8.57zm-40.711 82.15c0 12.85 36.431 87.14 36.431 87.14s12.14 15.71 12.14 8.57-47.142-84.29-48.571-95.71z"/>     <path id="path22361" inkscape:connector-curvature="0" sodipodi:nodetypes="cssccccssccssccccccc" style="opacity:.25;fill-rule:evenodd;fill:#000000" d="m353.73 324.55c-6.06 10.6-2.02 11.11 9.09 20.71 11.11 9.59 25.25 13.13 18.69 3.53-6.57-9.59-27.28-24.75-27.78-24.24zm-83.07-191.2c2.21-1.02 4.02-3.33 7.91-2.82 6.17 46.97 5.78 90.83 1.44 161.21 32.31 3.87 42.13 5.12 48.56 6.19 25.71 4.28 100.71 52.86 107.14 80.71 0.91 3.94-5.36 13.4-10.56 18.75 10.51 13.93-2.7 25.72-22.36 13.93-9.67 6.07-56.08 32.32-63.51 32.32-15.71 0-150.71-37.14-179.29-45.71-28.57-8.57-163.1-103.02-148.81-108.73-0.593 11.82 157.92 103.78 167.12 105.93-1.43-43.25 1.31-167.85 4.55-237.2 18.9-7.73 38.49-4.92 33.61-11.34-4.87-6.42-16.28-38.72-16.28-38.72l53.54 3.03c7.07 7.07 13.46 12.61 16.94 22.45z"/>     <path id="path22363" inkscape:connector-curvature="0" sodipodi:nodetypes="ccsscsc" style="fill-rule:evenodd;fill:#474747" d="m201.93 73.888c21.43-11.429 21.08-10.332 21.08-10.332s23.54-9.25 32.11 13.607 0.23 30.447-8.05 36.217c-4.95 3.45-20.49 9.51-20.49 9.51s-26.59-3.53-28.01-20.68c-1.43-17.139 2.94-32.868 3.36-28.322z"/>     <path id="path22365" inkscape:connector-curvature="0" sodipodi:nodetypes="css" style="fill-rule:evenodd;fill:#000000" d="m232.94 66.413c-11.77 1.992-13.64 40.217 10.68 38.567 23.58-1.59 6.32-41.444-10.68-38.567z"/>     <path id="path29389" inkscape:connector-curvature="0" sodipodi:nodetypes="cscsccccccccccccccccsccssccccscccccc" style="opacity:.5;fill-rule:evenodd;fill:#ffffff" d="m130.71 52.571s16.78 7.143 12.5 13.215c-4.29 6.071-25.72 19.285-25.72 19.285s31.79-10.714 32.5-17.5c0.72-6.785-18.92-15.357-19.28-15zm-95.358 58.929 37.143 67.86-3.929 13.21-33.214-81.07zm27.5 116.79h9.286l-38.929 48.92 29.643-48.92zm65.718-73.93-49.646 49.64-1.072 18.93 56.788 102.86-52.502-111.08 46.432-60.35zm116.31-91.189s-15.4-2.02-18.69-0.758c-3.28 1.263-25 11.87-25 11.87l20.46-7.071s-2.78 11.616-2.02 15.657 2.27-14.142 5.3-16.162c3.03-2.021 20.21-3.536 19.95-3.536zm-185.96-57.028-51.429 51.428 0.3571 231.43s2.1428-223.57 3.5719-227.86c1.428-4.283 48.214-55.354 47.5-54.997zm3.647-0.694 130.38 33.933-34.19 6.566 12.09-6.819-108.28-33.68z"/>   </g>   <metadata id="metadata13">     <rdf:RDF>       <cc:Work>         <dc:format>image/svg+xml</dc:format>         <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/>         <cc:license rdf:resource="http://creativecommons.org/licenses/publicdomain/"/>         <dc:publisher>           <cc:Agent rdf:about="http://openclipart.org/">             <dc:title>Openclipart</dc:title>           </cc:Agent>         </dc:publisher>       </cc:Work>       <cc:License rdf:about="http://creativecommons.org/licenses/publicdomain/">         <cc:permits rdf:resource="http://creativecommons.org/ns#Reproduction"/>         <cc:permits rdf:resource="http://creativecommons.org/ns#Distribution"/>         <cc:permits rdf:resource="http://creativecommons.org/ns#DerivativeWorks"/>       </cc:License>     </rdf:RDF>   </metadata> </svg>' });})));
}

/**
 * Describe this function...
 */
async function Over_Rev() {
  Over_Rev_Markers = [];
  for (var j_index5 in TrackingData) {
    j = TrackingData[j_index5];
    Marker = j;
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Marker))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Marker, 'can.engine.rpm'))))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max RPM'))))) {
        } else {
          if ((getObjectProperty(Marker, 'can.engine.rpm')) > (getObjectProperty(VehicleData, 'Can Max RPM'))) {
            addItemToList(Over_Rev_Markers, Marker);
            Markers = (await asyncListFilter(Markers, async (item) => {


             return (!((getObjectProperty(item, 'lat')) == (getObjectProperty(Marker, 'position.latitude')) && (getObjectProperty(item, 'lng')) == (getObjectProperty(Marker, 'position.longitude'))));
            }));
          }
        }
      }
    }
  }
  console.log(Over_Rev_Markers);
  Over_Rev_Markers = (await Promise.all(Over_Rev_Markers.map(async item => {; return ({ [`lat`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.latitude')))) ? null : (getObjectProperty(item, 'position.latitude')),[`lng`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.longitude')))) ? null : (getObjectProperty(item, 'position.longitude')),[`Data`]: (await BackendlessUI.Functions.Custom['fn_3a793fed77a519bfe0e8407457e3fd8c']((await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Date',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toDateString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Time',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toLocaleTimeString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'ID')))) ? null : ({ [`Label`]: 'Fleet ID',[`Value`]: (getObjectProperty(VehicleData, 'ID')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Registration')))) ? null : ({ [`Label`]: 'Registration',[`Value`]: (getObjectProperty(VehicleData, 'Registration')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ({ [`Label`]: 'Driver',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Nickname')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')))) ? null : ({ [`Label`]: 'Driver Mobile',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }))], async (item) => {


   return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
  })), (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.vehicle.mileage')))) ? null : ({ [`Label`]: 'Odometer',[`Value`]: String(getObjectProperty(item, 'can.vehicle.mileage')) + String(' km'),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : ({ [`Label`]: 'Speed',[`Value`]: [(getObjectProperty(item, 'position.speed')),' km/h',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Speed')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max Speed')),')'].join('')].join(''),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ({ [`Label`]: 'Fuel Level',[`Value`]: String(((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) + String(' L'),[`Color`]: 'rgba(70, 130, 180, 0.5)' })), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(VehicleData, 'Current_Fleetview')), 'Fuel_Consumption_5Tanks')))) ? null : ({ [`Label`]: 'Range Est.',[`Value`]: String((((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) * (getObjectProperty((getObjectProperty(VehicleData, 'Current_Fleetview')), 'Fuel_Consumption_5Tanks'))) + String(' km'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }))), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.altitude')))) ? null : ({ [`Label`]: 'Altitude',[`Value`]: String(getObjectProperty(item, 'position.altitude')) + String(' m'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.rpm')))) ? null : ({ [`Label`]: 'RPM',[`Value`]: [(getObjectProperty(item, 'can.engine.rpm')),' RPM',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max RPM')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max RPM')),')'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.temperature')))) ? null : ({ [`Label`]: 'Engine Temp.',[`Value`]: String(getObjectProperty(item, 'can.engine.temperature')) + String('°'),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.throttle.pedal.level')))) ? null : ({ [`Label`]: 'Throttle Pedal',[`Value`]: [(getObjectProperty(item, 'can.throttle.pedal.level')),'% - ',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Pedal')))) ? null : ['(',(getObjectProperty(VehicleData, 'Can Max Pedal')),'%)'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' })], async (item) => {


   return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
  })))),[`color`]: '#A020F0',[`Speed`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : (getObjectProperty(item, 'position.speed')),[`Direction`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.direction')))) ? null : (getObjectProperty(item, 'position.direction')) });})));
}

/**
 * Describe this function...
 */
async function Markers2() {
  Markers = (await BackendlessUI.Functions.Custom['fn_343eca57258d3a15fcf855fe73fdf50a']((await Promise.all(TrackingData.map(async item => {; return ({ [`lat`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.latitude')))) ? null : (getObjectProperty(item, 'position.latitude')),[`lng`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.longitude')))) ? null : (getObjectProperty(item, 'position.longitude')),[`Data`]: (await BackendlessUI.Functions.Custom['fn_3a793fed77a519bfe0e8407457e3fd8c']((await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Date',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toDateString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Time',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toLocaleTimeString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'ID')))) ? null : ({ [`Label`]: 'Fleet ID',[`Value`]: (getObjectProperty(VehicleData, 'ID')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Registration')))) ? null : ({ [`Label`]: 'Registration',[`Value`]: (getObjectProperty(VehicleData, 'Registration')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ({ [`Label`]: 'Driver',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Nickname')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')))) ? null : ({ [`Label`]: 'Driver Mobile',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }))], async (item) => {


   return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
  })), (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.vehicle.mileage')))) ? null : ({ [`Label`]: 'Odometer',[`Value`]: String(getObjectProperty(item, 'can.vehicle.mileage')) + String(' km'),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : ({ [`Label`]: 'Speed',[`Value`]: [(getObjectProperty(item, 'position.speed')),' km/h',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Speed')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max Speed')),')'].join('')].join(''),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ({ [`Label`]: 'Fuel Level',[`Value`]: String(((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) + String(' L'),[`Color`]: 'rgba(70, 130, 180, 0.5)' })), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(VehicleData, 'Current_Fleetview')), 'Fuel_Consumption_5Tanks')))) ? null : ({ [`Label`]: 'Range Est.',[`Value`]: String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3'](((((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) * (getObjectProperty((getObjectProperty(VehicleData, 'Current_Fleetview')), 'Fuel_Consumption_5Tanks')))))) + String(' km'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }))), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.altitude')))) ? null : ({ [`Label`]: 'Altitude',[`Value`]: String(getObjectProperty(item, 'position.altitude')) + String(' m'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.rpm')))) ? null : ({ [`Label`]: 'RPM',[`Value`]: [(getObjectProperty(item, 'can.engine.rpm')),' RPM',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max RPM')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max RPM')),')'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.temperature')))) ? null : ({ [`Label`]: 'Engine Temp.',[`Value`]: String(getObjectProperty(item, 'can.engine.temperature')) + String('°'),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.throttle.pedal.level')))) ? null : ({ [`Label`]: 'Throttle Pedal',[`Value`]: [(getObjectProperty(item, 'can.throttle.pedal.level')),'% - ',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Pedal')))) ? null : ['(',(getObjectProperty(VehicleData, 'Can Max Pedal')),'%)'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' })], async (item) => {


   return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
  })))),[`color`]: (await BackendlessUI.Functions.Custom['fn_95b21da849de975107054e732dc24af2'](item, VehicleData)),[`Speed`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : (getObjectProperty(item, 'position.speed')),[`Direction`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.direction')))) ? null : (getObjectProperty(item, 'position.direction')) });}))), MarkerDensity));
}

/**
 * Describe this function...
 */
async function Over_Speed() {
  Over_Speed_Markers = [];
  for (var j_index6 in TrackingData) {
    j = TrackingData[j_index6];
    Marker = j;
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Marker))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Marker, 'position.speed'))))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Speed'))))) {
        } else {
          if ((getObjectProperty(Marker, 'position.speed')) > (getObjectProperty(VehicleData, 'Can Max Speed'))) {
            addItemToList(Over_Speed_Markers, Marker);
            Markers = (await asyncListFilter(Markers, async (item) => {


             return (!((getObjectProperty(item, 'lat')) == (getObjectProperty(Marker, 'position.latitude')) && (getObjectProperty(item, 'lng')) == (getObjectProperty(Marker, 'position.longitude'))));
            }));
          }
        }
      }
    }
  }
  Over_Speed_Markers = (await Promise.all(Over_Speed_Markers.map(async item => {; return ({ [`lat`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.latitude')))) ? null : (getObjectProperty(item, 'position.latitude')),[`lng`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.longitude')))) ? null : (getObjectProperty(item, 'position.longitude')),[`Data`]: (await BackendlessUI.Functions.Custom['fn_3a793fed77a519bfe0e8407457e3fd8c']((await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Date',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toDateString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'timestamp')))) ? null : ({ [`Label`]: 'Time',[`Value`]: String((new Date(((getObjectProperty(item, 'timestamp')) * 1000))).toLocaleTimeString()),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'ID')))) ? null : ({ [`Label`]: 'Fleet ID',[`Value`]: (getObjectProperty(VehicleData, 'ID')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Registration')))) ? null : ({ [`Label`]: 'Registration',[`Value`]: (getObjectProperty(VehicleData, 'Registration')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ({ [`Label`]: 'Driver',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Nickname')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Driver1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')))) ? null : ({ [`Label`]: 'Driver Mobile',[`Value`]: (getObjectProperty((getObjectProperty(VehicleData, 'Driver1')), 'Employee_Details_Phone')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }))], async (item) => {


   return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
  })), (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.vehicle.mileage')))) ? null : ({ [`Label`]: 'Odometer',[`Value`]: String(getObjectProperty(item, 'can.vehicle.mileage')) + String(' km'),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : ({ [`Label`]: 'Speed',[`Value`]: [(getObjectProperty(item, 'position.speed')),' km/h',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Speed')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max Speed')),')'].join('')].join(''),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ({ [`Label`]: 'Fuel Level',[`Value`]: String(((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) + String(' L'),[`Color`]: 'rgba(70, 130, 180, 0.5)' })), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.fuel.level')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Tank_Capacity')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Current_Fuel_Consumption_Last_5_Tanks')))) ? null : ({ [`Label`]: 'Range Est.',[`Value`]: String((((getObjectProperty(item, 'can.fuel.level')) * (getObjectProperty(VehicleData, 'Tank_Capacity'))) / 100) * (getObjectProperty(VehicleData, 'Current_Fuel_Consumption_Last_5_Tanks'))) + String(' km'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }))), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.altitude')))) ? null : ({ [`Label`]: 'Altitude',[`Value`]: String(getObjectProperty(item, 'position.altitude')) + String(' m'),[`Color`]: 'rgba(70, 130, 180, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.rpm')))) ? null : ({ [`Label`]: 'RPM',[`Value`]: [(getObjectProperty(item, 'can.engine.rpm')),' RPM',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max RPM')))) ? null : [' - ','(',(getObjectProperty(VehicleData, 'Can Max RPM')),')'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.engine.temperature')))) ? null : ({ [`Label`]: 'Engine Temp.',[`Value`]: String(getObjectProperty(item, 'can.engine.temperature')) + String('°'),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'can.throttle.pedal.level')))) ? null : ({ [`Label`]: 'Throttle Pedal',[`Value`]: [(getObjectProperty(item, 'can.throttle.pedal.level')),'% - ',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'Can Max Pedal')))) ? null : ['(',(getObjectProperty(VehicleData, 'Can Max Pedal')),'%)'].join('')].join(''),[`Color`]: 'rgba(128, 0, 128, 0.5)' })], async (item) => {


   return (item !== null && !Array.isArray(item) && (typeof item === 'object'));
  })))),[`color`]: '#cc6633',[`Speed`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.speed')))) ? null : (getObjectProperty(item, 'position.speed')),[`Direction`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.direction')))) ? null : (getObjectProperty(item, 'position.direction')) });})));
}


  StrokeOpacity = 1;
  PolylineColor = '#ffffff';
  StrokeWeight = 8;
  PointColor = '#ffffff';
  PointScale = 10;
  Map['display'] = false;
  Map['display'] = true;
  await Markers2();
  await Idle();
  await Fuel_Loss();
  await Refuel_List2();
  await Over_Rev();
  await Over_Speed();
  await Over_Temp();
  try {
    Distance = (getObjectProperty(((await asyncListSort((await asyncListFilter((await Promise.all(TrackingData.map(async item => {; return ({ [`Value`]: (getObjectProperty(item, 'can.vehicle.mileage')),[`Item`]: item });}))), async (item) => {


     return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Value')))));
    })), 1, async (item) => {


     return (getObjectProperty(item, 'Value'));
    })).slice(-1)[0]), 'Value')) - (getObjectProperty(((await asyncListSort((await asyncListFilter((await Promise.all(TrackingData.map(async item => {; return ({ [`Value`]: (getObjectProperty(item, 'can.vehicle.mileage')),[`Item`]: item });}))), async (item) => {


     return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Value')))));
    })), 1, async (item) => {


     return (getObjectProperty(item, 'Value'));
    }))[0]), 'Value'));

  } catch (error) {
    console.log(error);

  }
  try {
    Max_Speed = (await asyncListSort((await asyncListFilter((await Promise.all(TrackingData.map(async item => {; return ({ [`Value`]: (getObjectProperty(item, 'position.speed')),[`Item`]: item });}))), async (item) => {


     return ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Value')))) ? null : item);
    })), 1, async (item) => {


     return (getObjectProperty(item, 'Value'));
    })).slice(-1)[0];

  } catch (error) {
    console.log(error);

  }
  try {
    Max_RPM = (await asyncListSort((await asyncListFilter((await Promise.all(TrackingData.map(async item => {; return ({ [`Value`]: (getObjectProperty(item, 'can.engine.rpm')),[`Item`]: item });}))), async (item) => {


     return ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Value')))) ? null : item);
    })), 1, async (item) => {


     return (getObjectProperty(item, 'Value'));
    })).slice(-1)[0];

  } catch (error) {
    console.log(error);

  }
  try {
    Max_Temp = (await asyncListSort((await asyncListFilter((await Promise.all(TrackingData.map(async item => {; return ({ [`Value`]: (getObjectProperty(item, 'can.engine.temperature')),[`Item`]: item });}))), async (item) => {


     return ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Value')))) ? null : item);
    })), 1, async (item) => {


     return (getObjectProperty(item, 'Value'));
    })).slice(-1)[0];

  } catch (error) {
    console.log(error);

  }
  try {
    Total_Idle = String(Number.parseFloat(((await Promise.all(Idle_Markers.map(async item => {; return (Number((getObjectProperty(item, 'Idle'))));}))).reduce(function(x, y) {return x + y;}))).toFixed(2)) + String('m');

  } catch (error) {
    console.log(error);

  }
  try {
    AppData['Current Tracking Data'] = ({ [`Distance`]: Distance,[`Max Speed`]: Max_Speed,[`Max RPM`]: Max_RPM,[`Max Temp`]: Max_Temp,[`Idle`]: Total_Idle,[`Idle Events`]: Idle_Markers });

  } catch (error) {
    console.log(error);

  }
  try {
    await Max();

  } catch (error) {
    console.log(error);

  }
  console.log(getObjectProperty(AppData, 'Current Tracking Data'));
  await new Promise(r => setTimeout(r, 100 || 0));
  console.log(Max_Markers);
  await (async function(googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers, pointColor, pointScale, vehicleId, geofences, stations, stationIconSvg, canAddGeofences, polygonColor, appData) {
  	let existingMarkers = [];
  	let existingPolylines = [];
  	let existingGeofences = [];
  	let currentInfoWindow = null;
  	let selectedMarker = null;
  	let geofenceMarkers = [];
  	let geofencePolygon = null;
  	let addingGeofence = false;
  	
  	appData = appData || {};
  	
  	function addPolylineAndCustomMarkers(
  	  googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers,
  	  pointColor, pointScale, vehicleId, geofences, stations, stationIconSvg, enableGeofence, polygonColor, appData
  	) {
  	  if (!googleMapComponent || !googleMapComponent.map) {
  	    return;
  	  }
  	
  	  const mapInstance = googleMapComponent.map.map;
  	  if (!(mapInstance instanceof google.maps.Map)) {
  	    return;
  	  }
  	
  	  // Polyline logic
  	  const polylineCoordinates = markers.map(marker => ({
  	    lat: marker.lat,
  	    lng: marker.lng
  	  }));
  	
  	  const polyline = new google.maps.Polyline({
  	    path: polylineCoordinates,
  	    geodesic: true,
  	    strokeColor: polylineColor || '#FF0000',
  	    strokeOpacity: strokeOpacity || 1.0,
  	    strokeWeight: strokeWeight || 2
  	  });
  	
  	  polyline.setMap(mapInstance);
  	  existingPolylines.push(polyline);
  	
  	  function calculateHeading(lat1, lng1, lng2, lat2) {
  	    const toRadians = degrees => degrees * Math.PI / 180;
  	    const toDegrees = radians => degrees * 180 / Math.PI;
  	
  	    const dLng = toRadians(lng2 - lng1);
  	    const y = Math.sin(dLng) * Math.cos(toRadians(lat2));
  	    const x = Math.cos(toRadians(lat1)) * Math.sin(toRadians(lat2)) - Math.sin(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.cos(dLng);
  	    const bearing = toDegrees(Math.atan2(y, x));
  	    return (bearing + 360) % 360;
  	  }
  	
  	  // Add custom markers to the map
  	pointMarkers.forEach((marker, index) => {
  	  let icon;
  	  let markerOptions = {
  	    position: { lat: marker.lat, lng: marker.lng },
  	    map: mapInstance,
  	    draggable: false,
  	  };
  	
  	  // Check for Icon property and use it if available
  	  if (marker.Icon) {
  	    icon = {
  	      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(marker.Icon)}`,
  	      anchor: new google.maps.Point(25, 25),
  	      scaledSize: new google.maps.Size(50, 50) // Adjust size as needed
  	    };
  	
  	    // Set a high zIndex to ensure it sits on top of other markers
  	    markerOptions.zIndex = google.maps.Marker.MAX_ZINDEX + 1;
  	  } else {
  	    let iconColor = marker.color || pointColor || '#FF0000';
  	
  	    if (marker.Speed === 0) {
  	      icon = {
  	        path: google.maps.SymbolPath.CIRCLE,
  	        fillColor: iconColor,
  	        fillOpacity: 1,
  	        strokeColor: 'black',
  	        strokeWeight: 2,
  	        scale: marker.scale || pointScale || 8
  	      };
  	
  	      if (index === pointMarkers.length - 1 && vehicleId) {
  	        const crosshairSvg = `
  	        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  	        <circle cx="12" cy="12" r="10"></circle>
  	        <line x1="12" y1="2" x2="12" y2="6"></line>
  	        <line x1="12" y1="18" x2="12" y2="22"></line>
  	        <line x1="2" y1="12" x2="6" y2="12"></line>
  	        <line x1="18" y1="12" x2="22" y2="12"></line>
  	        </svg>
  	        `;
  	
  	        icon = {
  	          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(crosshairSvg)}`,
  	          anchor: new google.maps.Point(25, 25),
  	          scaledSize: new google.maps.Size(50, 50)
  	        };
  	      }
  	
  	    } else {
  	      let heading = marker.Direction !== undefined ? marker.Direction : 0;
  	      if (marker.Direction === undefined && index < pointMarkers.length - 1) {
  	        const nextMarker = pointMarkers[index + 1];
  	        heading = calculateHeading(marker.lat, marker.lng, nextMarker.lng, nextMarker.lat);
  	      }
  	
  	      heading = (heading - 90 + 360) % 360;
  	
  	      const iconPath = "M 0 0 L -1 -1 L 1 0 L -1 1 Z";
  	      if (iconColor.toLowerCase() === '#000000' || iconColor.toLowerCase() === 'black') {
  	        icon = {
  	          path: iconPath,
  	          fillColor: iconColor,
  	          fillOpacity: 1,
  	          strokeColor: 'white',
  	          strokeWeight: 3,
  	          rotation: heading,
  	          scale: marker.scale || pointScale || 8,
  	          anchor: new google.maps.Point(0, 0)
  	        };
  	      } else {
  	        icon = {
  	          path: iconPath,
  	          fillColor: iconColor,
  	          fillOpacity: 1,
  	          strokeColor: 'black',
  	          strokeWeight: 2,
  	          rotation: heading,
  	          scale: marker.scale || pointScale || 8,
  	          anchor: new google.maps.Point(0, 0)
  	        };
  	      }
  	    }
  	  }
  	
  	  // Apply the icon to the marker options
  	  markerOptions.icon = icon;
  	
  	  const pointMarker = new google.maps.Marker(markerOptions);
  	
  	  existingMarkers.push(pointMarker);
  	
  	  if (marker.Data) {
  	    const infowindow = new google.maps.InfoWindow({
  	      content: marker.Data
  	    });
  	
  	    pointMarker.addListener('click', function() {
  	      if (currentInfoWindow) {
  	        currentInfoWindow.close();
  	      }
  	      infowindow.open(mapInstance, pointMarker);
  	      currentInfoWindow = infowindow;
  	
  	      selectedMarker = pointMarker;
  	    });
  	  }
  	
  	  pointMarker.addListener('click', function() {
  	    selectedMarker = pointMarker;
  	  });
  	});
  	
  	
  	
  	  // Add Geofences
  	  if (geofences && Array.isArray(geofences)) {
  	    geofences.forEach(geofence => {
  	      if (geofence["Geo Fences"] && geofence["Geo Fences"].boundary && Array.isArray(geofence["Geo Fences"].boundary.points)) {
  	        const polygonCoords = geofence["Geo Fences"].boundary.points.map(point => ({
  	          lat: point.y,
  	          lng: point.x
  	        }));
  	
  	        const polygon = new google.maps.Polygon({
  	          paths: polygonCoords,
  	          strokeColor: geofence.Color,
  	          strokeOpacity: 0.9,
  	          strokeWeight: 4,
  	          fillColor: geofence.Color,
  	          fillOpacity: 0.25
  	        });
  	
  	        polygon.setMap(mapInstance);
  	        existingGeofences.push(polygon);
  	
  	        google.maps.event.addListener(polygon, 'click', function(event) {
  	          const infowindow = new google.maps.InfoWindow({
  	            content: createGeofencePopupContent(geofence, polygon, mapInstance, appData)
  	          });
  	
  	          infowindow.setPosition(event.latLng);
  	          infowindow.open(mapInstance);
  	          currentInfoWindow = infowindow;
  	        });
  	      }
  	    });
  	  }
  	
  	  // Add Stations
  	  if (stations && Array.isArray(stations)) {
  	    stations.forEach(station => {
  	      if (station["Geo Fence"] && station["Geo Fence"].boundary && station["Geo Fence"].boundary.points) {
  	        const stationCoords = station["Geo Fence"].boundary.points.map(point => ({
  	          lat: point.y,
  	          lng: point.x
  	        }));
  	
  	        const polygon = new google.maps.Polygon({
  	          paths: stationCoords,
  	          strokeColor: station.Color,
  	          strokeOpacity: 0.9,
  	          strokeWeight: 4,
  	          fillColor: station.Color,
  	          fillOpacity: 0.25
  	        });
  	
  	        polygon.setMap(mapInstance);
  	        existingGeofences.push(polygon);
  	
  	        // Check for station location
  	        if (station.Location && station.Location.x !== undefined && station.Location.y !== undefined) {
  	          const icon = {
  	            url: stationIconSvg,
  	            anchor: new google.maps.Point(25, 50),
  	            scaledSize: new google.maps.Size(50, 50)
  	          };
  	
  	          const stationCenter = {
  	            lat: station.Location.y,
  	            lng: station.Location.x
  	          };
  	          const stationMarker = new google.maps.Marker({
  	            position: stationCenter,
  	            map: mapInstance,
  	            icon: icon
  	          });
  	
  	          existingMarkers.push(stationMarker);
  	
  	          google.maps.event.addListener(stationMarker, 'click', function(event) {
  	            const infowindow = new google.maps.InfoWindow({
  	              content: createStationPopupContent(station)
  	            });
  	
  	            infowindow.open(mapInstance, stationMarker);
  	            currentInfoWindow = infowindow;
  	          });
  	        }
  	      }
  	    });
  	  }
  	
  	  if (pointMarkers.length > 0) {
  	    const latestMarker = pointMarkers[pointMarkers.length - 1];
  	    if (latestMarker) {
  	      mapInstance.setCenter({
  	        lat: latestMarker.lat, lng: latestMarker.lng
  	      });
  	    }
  	  }
  	
  	  // Adding Geofence Markers
  	  if (enableGeofence) {
  	    google.maps.event.addListener(mapInstance, 'click', function(event) {
  	      addGeofenceMarker(event.latLng);
  	    });
  	  }
  	
  	  function addGeofenceMarker(location) {
  	    const markerIndex = geofenceMarkers.length;
  	
  	    const icon = {
  	      path: google.maps.SymbolPath.CIRCLE,
  	      fillColor: markerIndex === geofenceMarkers.length - 1 ? '#FFFFFF' : polygonColor || '#FF0000',
  	      fillOpacity: 1,
  	      strokeColor: 'black',
  	      strokeWeight: 2,
  	      scale: 8
  	    };
  	
  	    const marker = new google.maps.Marker({
  	      position: location,
  	      map: mapInstance,
  	      icon: icon,
  	      draggable: true
  	    });
  	
  	    geofenceMarkers.push(marker);
  	
  	    marker.addListener('dragend', updateGeofencePolygon);
  	    marker.addListener('click', function() {
  	      marker.setMap(null);
  	      const markerIndex = geofenceMarkers.indexOf(marker);
  	      if (markerIndex !== -1) {
  	        geofenceMarkers.splice(markerIndex, 1);
  	        updateGeofencePolygon();
  	      }
  	    });
  	
  	    if (geofenceMarkers.length > 2) {
  	      const firstMarker = geofenceMarkers[0];
  	      if (location.equals(firstMarker.getPosition())) {
  	        createGeofencePolygon();
  	      }
  	    }
  	
  	    updateGeofencePolygon();
  	  }
  	
  	  function updateGeofencePolygon() {
  	    const path = geofenceMarkers.map(marker => marker.getPosition());
  	
  	    if (geofencePolygon) {
  	      geofencePolygon.setPath(path);
  	    } else {
  	      geofencePolygon = new google.maps.Polygon({
  	        paths: path,
  	        strokeColor: polygonColor || '#FF0000',
  	        strokeOpacity: 0.8,
  	        strokeWeight: 2,
  	        fillColor: polygonColor || '#FF0000',
  	        fillOpacity: 0.35
  	      });
  	
  	      geofencePolygon.setMap(mapInstance);
  	    }
  	
  	    // Save the created polygon to App Data, overriding the existing value
  	    appData.geofencePolygons = {
  	      path: path.map(latLng => ({
  	        lat: latLng.lat(), lng: latLng.lng()
  	      })),
  	      color: polygonColor || '#FF0000'
  	    };
  	  }
  	
  	  function createGeofencePolygon() {
  	    const path = geofenceMarkers.map(marker => marker.getPosition());
  	
  	    if (geofencePolygon) {
  	      geofencePolygon.setPath(path);
  	    } else {
  	      geofencePolygon = new google.maps.Polygon({
  	        paths: path,
  	        strokeColor: polygonColor || '#FF0000',
  	        strokeOpacity: 0.8,
  	        strokeWeight: 2,
  	        fillColor: polygonColor || '#FF0000',
  	        fillOpacity: 0.35
  	      });
  	
  	      geofencePolygon.setMap(mapInstance);
  	    }
  	  }
  	
  	  function createGeofencePopupContent(geofence, polygon, mapInstance, appData) {
  	    const geofences = appData.User.Company.Locations;
  	
  	    const content = document.createElement('div');
  	    content.style.padding = '10px';
  	    content.style.fontFamily = 'Arial, sans-serif';
  	    content.style.color = 'white';
  	
  	    const headerDiv = document.createElement('div');
  	    headerDiv.style.display = 'flex';
  	    headerDiv.style.justifyContent = 'space-between';
  	    headerDiv.style.alignItems = 'center';
  	
  	    const title = document.createElement('h3');
  	    title.style.margin = '0';
  	    title.textContent = geofence.Name;
  	
  	    const iconDiv = document.createElement('div');
  	    iconDiv.style.display = 'flex';
  	    iconDiv.style.gap = '10px';
  	
  	    // Edit Icon
  	    const editIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  	    editIcon.setAttribute('width', '24');
  	    editIcon.setAttribute('height', '24');
  	    editIcon.setAttribute('viewBox', '0 0 24 24');
  	    editIcon.setAttribute('fill', 'none');
  	    editIcon.setAttribute('stroke', 'white');
  	    editIcon.setAttribute('stroke-width', '2');
  	    editIcon.setAttribute('stroke-linecap', 'round');
  	    editIcon.setAttribute('stroke-linejoin', 'round');
  	    editIcon.style.cursor = 'pointer';
  	
  	    const editPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  	    editPath.setAttribute('d', 'M12 20h9');
  	    editIcon.appendChild(editPath);
  	
  	    const editPath2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  	    editPath2.setAttribute('d', 'M16.5 3.5a2.121 2.121 0 010 3l-10 10-4 1 1-4 10-10a2.121 2.121 0 013 0z');
  	    editIcon.appendChild(editPath2);
  	
  	    // Delete Icon
  	    const deleteIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  	    deleteIcon.setAttribute('width', '24');
  	    deleteIcon.setAttribute('height', '24');
  	    deleteIcon.setAttribute('viewBox', '0 0 24 24');
  	    deleteIcon.setAttribute('fill', 'none');
  	    deleteIcon.setAttribute('stroke', 'white');
  	    deleteIcon.setAttribute('stroke-width', '2');
  	    deleteIcon.setAttribute('stroke-linecap', 'round');
  	    deleteIcon.setAttribute('stroke-linejoin', 'round');
  	    deleteIcon.style.cursor = 'pointer';
  	
  	    const polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
  	    polyline.setAttribute('points', '3 6 5 6 21 6');
  	    deleteIcon.appendChild(polyline);
  	
  	    const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  	    path1.setAttribute('d', 'M19 6L17.707 18H6.293L5 6');
  	    deleteIcon.appendChild(path1);
  	
  	    // Add Icons to iconDiv
  	    iconDiv.appendChild(editIcon);
  	    iconDiv.appendChild(deleteIcon);
  	
  	    headerDiv.appendChild(title);
  	    headerDiv.appendChild(iconDiv);
  	
  	    content.appendChild(headerDiv);
  	
  	    const address = document.createElement('p');
  	    address.innerHTML = `<strong>Address:</strong> ${geofence.Address}`;
  	    content.appendChild(address);
  	
  	    const contactName = document.createElement('p');
  	    contactName.innerHTML = `<strong>Contact Name:</strong> ${geofence.Contact_Name}`;
  	    content.appendChild(contactName);
  	
  	    const phone = document.createElement('p');
  	    phone.innerHTML = `<strong>Phone:</strong> ${geofence.Phone}`;
  	    content.appendChild(phone);
  	
  	    const infowindow = new google.maps.InfoWindow({
  	      content: content,
  	      disableAutoPan: true
  	    });
  	
  	    // Add event listener to the polygon to handle the click
  	    polygon.addListener('click', function(event) {
  	      infowindow.setPosition(event.latLng);
  	      infowindow.open(mapInstance);
  	      currentInfoWindow = infowindow;
  	    });
  	
  	    editIcon.addEventListener('click',
  	      async function () {
  	        const isEditable = polygon.getEditable();
  	        polygon.setEditable(!isEditable);
  	
  	        if (!isEditable) {
  	          editIcon.innerHTML = ''; // Switch to save icon
  	          const checkPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  	          checkPath.setAttribute('d', 'M20 6L9 17l-5-5');
  	          editIcon.appendChild(checkPath);
  	        } else {
  	          const newPath = polygon.getPath().getArray().map(latLng => [latLng.lng(), latLng.lat()]);
  	
  	          const updatedGeofence = geofences.find(loc => loc.objectId === geofence.objectId);
  	
  	          updatedGeofence["Geo Fences"] = {
  	            type: "Polygon",
  	            coordinates: [newPath],
  	            srs: {
  	              srsId: 4326,
  	              name: 'WGS 84'
  	            },
  	            holes: [] // Add holes if applicable or leave as an empty array
  	          };
  	
  	          const sanitizedGeofence = JSON.parse(JSON.stringify(updatedGeofence, (key, value) => {
  	            if (typeof value === 'function' || value instanceof Element) {
  	              return undefined;
  	            }
  	            return value;
  	          }));
  	
  	          const result = await Backendless.Data.of('Locations').save(sanitizedGeofence, true);
  	
  	          const index = geofences.findIndex(loc => loc.objectId === geofence.objectId);
  	          if (index !== -1) {
  	            geofences[index] = result;
  	          }
  	
  	          editIcon.innerHTML = '';
  	          editIcon.appendChild(editPath);
  	          editIcon.appendChild(editPath2);
  	        }
  	      });
  	
  	    // Handling Delete Icon Click
  	    deleteIcon.addEventListener('click',
  	      async function() {
  	        const confirmation = confirm(`Are you sure you want to delete the location: ${geofence.Name}?`);
  	        if (confirmation) {
  	          await Backendless.Data.of('Locations').remove(geofence.objectId);
  	
  	          appData.User.Company.Locations = await asyncListFilter(geofences, async (item) => {
  	            return (geofence.objectId !== item.objectId);
  	          });
  	
  	          polygon.setMap(null);
  	          infowindow.close();
  	        }
  	      });
  	
  	    return content;
  	  }
  	
  	  // Supporting Functions
  	
  	  async function asyncListFilter(sourceList,
  	    callback) {
  	    const list = await Promise.all(sourceList.map(async source => ({
  	      source,
  	      value: await callback(source),
  	    })));
  	
  	    const resultList = list.filter(item => item.value);
  	
  	    return resultList.map(item => item.source);
  	  }
  	}
  	
  	// Helper function to create popup content for stations
  	function createStationPopupContent(station) {
  	  return `
  	  <div style="padding: 10px; font-family: Arial, sans-serif; color: white;">
  	  <table>
  	  <tr><td><strong>Station Name:</strong></td><td>${station.Station_Name}</td></tr>
  	  <tr><td><strong>Brand:</strong></td><td>${station.Brand}</td></tr>
  	  <tr><td><strong>Contact Name:</strong></td><td>${station.Contact_Name}</td></tr>
  	  <tr><td><strong>Phone:</strong></td><td>${station.Contact_Number}</td></tr>
  	  <tr><td><strong>Address:</strong></td><td>${station.Province}, ${station.Town}</td></tr>
  	  <tr><td><strong>Price:</strong></td><td>${station.Price}</td></tr>
  	  <tr><td><strong>Truck Stop:</strong></td><td>${station.Truck_Stop ? 'Yes': 'No'}</td></tr>
  	  </table>
  	  <p><strong>Services:</strong></p>
  	  <ul>
  	  ${(Array.isArray(station.Services) ? station.Services: []).map(service => `<li>${service}</li>`).join('')}
  	  </ul>
  	  </div>
  	  `;
  	}
  	
  	try {
  	  const googleMapComponent = arguments[0];
  	  const polylineColor = arguments[1];
  	  const markers = arguments[2];
  	  const strokeOpacity = arguments[3];
  	  const strokeWeight = arguments[4];
  	  const pointMarkers = arguments[5];
  	  const pointColor = arguments[6];
  	  const pointScale = arguments[7];
  	  const vehicleId = arguments[8];
  	  const geofences = arguments[9];
  	  const stations = arguments[10];
  	  const stationIconSvg = arguments[11];
  	  const enableGeofence = arguments[12];
  	  const polygonColor = arguments[13];
  	  const appData = arguments[14];
  	  addPolylineAndCustomMarkers(
  	    googleMapComponent,
  	    polylineColor,
  	    markers,
  	    strokeOpacity,
  	    strokeWeight,
  	    pointMarkers,
  	    pointColor,
  	    pointScale,
  	    vehicleId,
  	    geofences,
  	    stations,
  	    stationIconSvg,
  	    enableGeofence,
  	    polygonColor,
  	    appData// Pass the FuelLossSvg as the last argument
  	  );
  	} catch (error) {
  	  // No error handling
  	}
  })(Map, '#FFFFFF', ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](TrackingData)) ? null : (await Promise.all(TrackingData.map(async item => {; return ({ [`lat`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.latitude')))) ? null : (getObjectProperty(item, 'position.latitude')),[`lng`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'position.longitude')))) ? null : (getObjectProperty(item, 'position.longitude')) });})))), StrokeOpacity, StrokeWeight, (Markers.concat((Refuel_List.concat((Fuel_Loss_List.concat((Over_Rev_Markers.concat((Over_Speed_Markers.concat((Over_Temp_Markers.concat((Max_Markers.concat(Idle_Markers)))))))))))))), PointColor, PointScale, ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(VehicleData, 'ID')))) ? null : (getObjectProperty(VehicleData, 'ID'))), Geofences, Stations, 'data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%0A%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22840%22%20height%3D%22840%22%3E%0A%3Cpath%20d%3D%22M0%200%20C1.47981857%20-0.01058945%201.47981857%20-0.01058945%202.98953247%20-0.02139282%20C43.74789262%20-0.24691352%2043.74789262%20-0.24691352%2061.3671875%203.203125%20C62.47320312%203.41243652%2063.57921875%203.62174805%2064.71875%203.83740234%20C132.81352715%2016.93897099%20198.28215198%2051.77158721%20241.3671875%20107.203125%20C242.90599137%20109.05966824%20244.44770872%20110.91380011%20245.9921875%20112.765625%20C250.05704348%20117.75399387%20253.81432453%20122.83886142%20257.3671875%20128.203125%20C257.77775391%20128.81526855%20258.18832031%20129.42741211%20258.61132812%20130.05810547%20C282.6181687%20166.05978019%20297.73387618%20205.71460903%20305.3671875%20248.203125%20C305.53234863%20249.06550781%20305.69750977%20249.92789063%20305.86767578%20250.81640625%20C311.3650026%20280.42351903%20311.0054916%20314.65197409%20305.3671875%20344.203125%20C305.20089844%20345.14236816%20305.03460937%20346.08161133%20304.86328125%20347.04931641%20C292.8447543%20414.38645211%20259.36520432%20468.63417829%20211.54402828%20516.25841546%20C208.87387347%20518.91982314%20206.20961449%20521.58712276%20203.54458618%20524.25366211%20C198.94155689%20528.85773323%20194.33491975%20533.45816788%20189.72571564%20538.05605698%20C183.0618271%20544.70359726%20176.40355741%20551.35674273%20169.74658677%20558.01120986%20C158.94239539%20568.81103866%20148.133758%20579.60640622%20137.32226562%20590.39892578%20C126.82836739%20600.87442783%20116.33660026%20611.35205681%20105.84765625%20621.83251953%20C105.1996439%20622.48000644%20104.55163154%20623.12749335%20103.88398245%20623.79460107%20C100.63266801%20627.04330518%2097.38139505%20630.29205079%2094.13014269%20633.54081702%20C67.21558299%20660.43468903%2040.29378261%20687.32130336%2013.3671875%20714.203125%20C7.78915659%20709.55605287%202.62674698%20704.60629427%20-2.50033569%20699.46931458%20C-3.36976323%20698.6021526%20-4.23919076%20697.73499062%20-5.13496459%20696.84155101%20C-7.53212068%20694.44960801%20-9.92703915%20692.05546511%20-12.32099724%20689.66032398%20C-14.90961357%20687.07150273%20-17.50109381%20684.48555089%20-20.09217834%20681.89920044%20C-25.16247623%20676.83719004%20-30.2300107%20671.77242206%20-35.29644559%20666.70654557%20C-39.41734341%20662.58612385%20-43.53903192%20658.46649473%20-47.66127396%20654.34741783%20C-59.3635092%20642.6539842%20-71.06365064%20630.95846133%20-82.76111059%20619.26025072%20C-83.70597218%20618.3153292%20-83.70597218%20618.3153292%20-84.66992188%20617.35131836%20C-85.30060352%20616.72059584%20-85.93128516%20616.08987331%20-86.58107837%20615.44003799%20C-96.79728863%20605.22342146%20-107.01847576%20595.01180022%20-117.2419378%20584.8024408%20C-127.75398064%20574.30478364%20-138.26226779%20563.80337978%20-148.76668894%20553.29809588%20C-154.65825706%20547.40619654%20-160.55133832%20541.51582969%20-166.44846725%20535.62949562%20C-171.47015365%20530.61694312%20-176.48832041%20525.6008991%20-181.50205801%20520.58039544%20C-184.05660035%20518.02260236%20-186.61267923%20515.46639966%20-189.17320824%20512.91459846%20C-191.95806076%20510.13914029%20-194.73500588%20507.35585209%20-197.51132202%20504.57185364%20C-198.3091036%20503.77921562%20-199.10688517%20502.98657761%20-199.92884195%20502.16992027%20C-204.79199415%20497.2771682%20-209.24310555%20492.16978774%20-213.55749381%20486.78659743%20C-215.66719988%20484.16031767%20-217.83083594%20481.5862548%20-220.0078125%20479.015625%20C-241.21127605%20452.99820352%20-258.5967139%20421.26270786%20-268.6328125%20389.203125%20C-268.9220459%20388.28208984%20-269.2112793%20387.36105469%20-269.50927734%20386.41210938%20C-273.17955011%20374.49985488%20-276.15020272%20362.51779317%20-278.4453125%20350.265625%20C-278.64012207%20349.22599609%20-278.83493164%20348.18636719%20-279.03564453%20347.11523438%20C-282.05401853%20330.08469069%20-283.00838503%20313.35723425%20-282.9453125%20296.078125%20C-282.94348969%20295.04065125%20-282.94166687%20294.00317749%20-282.93978882%20292.93426514%20C-282.89501524%20277.7984622%20-282.4165295%20263.11570064%20-279.6328125%20248.203125%20C-279.37540283%20246.71159912%20-279.37540283%20246.71159912%20-279.11279297%20245.18994141%20C-269.80291016%20191.43555998%20-245.73026405%20139.6924054%20-208.671875%2099.42578125%20C-206.82030955%2097.40750397%20-205.0344825%2095.34963365%20-203.2578125%2093.265625%20C-196.33141851%2085.32678827%20-188.717523%2077.95151971%20-180.6328125%2071.203125%20C-180.13313965%2070.77370605%20-179.6334668%2070.34428711%20-179.11865234%2069.90185547%20C-161.9127603%2055.13764179%20-142.81597778%2042.52099582%20-122.6328125%2032.203125%20C-121.83907227%2031.79400879%20-121.04533203%2031.38489258%20-120.22753906%2030.96337891%20C-100.651255%2020.97587009%20-79.97454661%2013.43696619%20-58.6328125%208.203125%20C-57.91109863%208.02442871%20-57.18938477%207.84573242%20-56.44580078%207.66162109%20C-37.98524368%203.15735909%20-19.0263901%200.09080073%200%200%20Z%20%22%20fill%3D%22%23818181%22%20transform%3D%22translate(407.6328125%2C124.796875)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.66%201.32%201.32%202%202%20C1.13181641%203.63001953%201.13181641%203.63001953%200.24609375%205.29296875%20C-2.33473545%2010.464846%20-4.1425797%2015.82731165%20-5.9375%2021.3125%20C-6.28449951%2022.3641333%20-6.63149902%2023.4157666%20-6.98901367%2024.49926758%20C-9.83416086%2033.24374576%20-12.32426706%2042.04450243%20-14.50488281%2050.9765625%20C-14.95619766%2052.82098926%20-15.42631849%2054.66078854%20-15.8984375%2056.5%20C-17.79809128%2064.17384893%20-18.92815569%2071.87566887%20-19.75732422%2079.72900391%20C-19.92295685%2081.27901875%20-20.09682125%2082.82817053%20-20.27783203%2084.37646484%20C-21.66526588%2096.29524936%20-22.18858118%20108.1336789%20-22.1875%20120.125%20C-22.18830566%20121.4361377%20-22.18911133%20122.74727539%20-22.18994141%20124.09814453%20C-22.23269393%20131.12780461%20-22.23269393%20131.12780461%20-21%20138%20C-20.93611284%20140.26799402%20-21.00037278%20142.51360664%20-21.0625%20144.78125%20C-20.99961768%20147.01357221%20-20.5972504%20148.85613849%20-20%20151%20C-19.87625%20151.845625%20-19.7525%20152.69125%20-19.625%20153.5625%20C-18.89434673%20156.41204775%20-18.2388101%20157.14164129%20-16%20159%20C-13.52481089%20160.19968218%20-13.52481089%20160.19968218%20-10.6875%20161.25%20C-1.29797706%20165.02857165%207.71904617%20169.41654921%2016.2109375%20174.9453125%20C19.29903346%20176.76580575%2022.61602798%20177.85676621%2026%20179%20C33.71117166%20181.71117166%2033.71117166%20181.71117166%2036%20184%20C38.57061311%20184.64767793%2038.57061311%20184.64767793%2041%20185%20C41%20185.66%2041%20186.32%2041%20187%20C42.2684375%20187.1546875%2042.2684375%20187.1546875%2043.5625%20187.3125%20C47.41442701%20188.0828854%2050.44075031%20189.36274514%2054%20191%20C54%20191.99%2054%20192.98%2054%20194%20C56.33497831%20194.94858494%2058.66958147%20195.881858%2061.04296875%20196.73046875%20C61.75066406%20196.98441406%2062.45835937%20197.23835937%2063.1875%20197.5%20C64.19876953%20197.85578125%2064.19876953%20197.85578125%2065.23046875%20198.21875%20C67%20199%2067%20199%2069%20201%20C72.77034424%20202.53369935%2076.36088307%20203.84323547%2080.3125%20204.8125%20C84.56680828%20206.18253148%2088.13707318%20208.15741439%2092.01953125%20210.34765625%20C96.03648785%20212.57461908%20100.1485122%20214.58747969%20104.2734375%20216.60546875%20C106.09795702%20217.53863991%20107.89139561%20218.53510032%20109.6484375%20219.58984375%20C112.03727266%20221.02235121%20114.48399665%20222.05597041%20117.05078125%20223.125%20C122.29635398%20225.47972603%20127.20879341%20228.46261315%20132%20231.625%20C135.38161704%20233.77876799%20138.67763459%20235.05434041%20142.53125%20236.12890625%20C145.4160769%20237.14681195%20148.03462197%20238.48926965%20150.75634766%20239.87866211%20C154.75853461%20241.8788846%20158.85241816%20243.67680277%20162.9375%20245.5%20C163.77990234%20245.87769531%20164.62230469%20246.25539063%20165.49023438%20246.64453125%20C168.83528777%20248.14323877%20172.1809045%20249.64003945%20175.53662109%20251.11474609%20C176.33535645%20251.46617676%20177.1340918%20251.81760742%20177.95703125%20252.1796875%20C178.66964111%20252.49147949%20179.38225098%20252.80327148%20180.11645508%20253.12451172%20C182.52176143%20254.24251931%20184.73852434%20255.6179871%20187%20257%20C187.763125%20257.28875%20188.52625%20257.5775%20189.3125%20257.875%20C191.75191605%20258.89615091%20193.57472122%20260.02684091%20195.75%20261.5%20C199.42372767%20263.87507536%20202.68968908%20264.76051126%20206.95703125%20265.5390625%20C209.70036662%20266.15801771%20211.71689772%20267.38839839%20214%20269%20C216.58921481%20270.72614321%20218.23496161%20271.49452235%20221.125%20272.375%20C227.64849001%20274.47866616%20234.37845496%20277.01051642%20240%20281%20C240%20281.66%20240%20282.32%20240%20283%20C240.845625%20283.2475%20241.69125%20283.495%20242.5625%20283.75%20C245.58791625%20284.85015136%20248.04892003%20286.20389442%20250.79296875%20287.8515625%20C254.800523%20289.93690931%20259.07052128%20291.39154712%20263.3046875%20292.94921875%20C266%20294%20266%20294%20267%20295%20C273.13743205%20295.61061186%20276.80374339%20294.00185471%20282%20291.125%20C286.95392148%20288.4392533%20291.49957861%20286.41946358%20297%20285%20C298.44520786%20284.47924741%20299.88463148%20283.94156907%20301.3125%20283.375%20C305%20282%20305%20282%20307%20282%20C307.3403125%20281.13375%20307.3403125%20281.13375%20307.6875%20280.25%20C310.81972092%20274.88047842%20316.07502144%20272.92372255%20321.625%20270.875%20C325.30994432%20269.48781054%20328.69887671%20268.20074886%20332%20266%20C333.6396875%20265.566875%20333.6396875%20265.566875%20335.3125%20265.125%20C339.15928549%20263.95140443%20341.71099107%20262.2657617%20345%20260%20C347.375%20259.25%20347.375%20259.25%20349%20259%20C349%20258.34%20349%20257.68%20349%20257%20C354.08940744%20254.94637945%20358.54520815%20253.56820748%20364%20253%20C364%20252.34%20364%20251.68%20364%20251%20C367.89581283%20248.83565954%20371.74372812%20247.40184924%20376%20246.0625%20C380.58249777%20244.57262388%20384.11905565%20242.91070826%20388%20240%20C392.47989074%20236.9566987%20396.75697008%20234.57791269%20401.875%20232.80859375%20C404.30571241%20231.88367193%20406.56223128%20230.75140767%20408.875%20229.5625%20C412.06072385%20227.92867188%20415.2079571%20226.49727486%20418.5625%20225.25%20C424.27661901%20223.05156311%20429.5800832%20220.11840113%20434.93579102%20217.17285156%20C438.89307319%20215.01824482%20442.66634014%20213.30793351%20447%20212%20C448.73581679%20211.37225952%20450.46552221%20210.72726352%20452.1875%20210.0625%20C453.02667969%20209.74410156%20453.86585938%20209.42570313%20454.73046875%20209.09765625%20C457.03403863%20207.98353725%20458.27050372%20206.84741648%20460%20205%20C462.9051282%20203.38603989%20465.68239862%20202.10194612%20468.84765625%20201.0859375%20C471.95700843%20200.01480998%20474.71245442%20198.70796112%20477.625%20197.1875%20C481.67359436%20195.12076996%20485.71746995%20193.25051202%20489.9375%20191.5625%20C495.51208858%20189.30925422%20500.67796114%20186.53262297%20505.89453125%20183.55078125%20C509.2110919%20181.89458681%20512.42931383%20180.97047319%20516%20180%20C518.33698333%20179.00414707%20520.60315043%20177.91605112%20522.88671875%20176.8046875%20C525%20176%20525%20176%20529%20176%20C528.54944444%20186.18255557%20525.6408532%20195.12287617%20520.8671875%20204.078125%20C519.60771065%20206.86939802%20519.13983813%20209.72236288%20518.5546875%20212.71484375%20C517.5843472%20216.71237245%20515.75552585%20220.29743639%20514%20224%20C513.30975354%20225.58213796%20512.62221082%20227.16545849%20511.9375%20228.75%20C510.87291521%20231.17558339%20509.85000942%20233.22498587%20508.375%20235.4375%20C506.98501794%20238.02792111%20506.71310956%20239.63126716%20506.3125%20242.5%20C505.05222459%20249.61684935%20500.91828972%20255.06408349%20497%20261%20C493.13348114%20267.15128001%20489.76222646%20273.27316614%20487%20280%20C487.33%20280.33%20487.66%20280.66%20488%20281%20C492.29930916%20277.10375108%20495.53914246%20272.66677891%20498.89453125%20267.9453125%20C500.23848332%20266.06527565%20501.6086063%20264.20349389%20503.01171875%20262.3671875%20C509.64149056%20253.64037588%20514.53807047%20244.17810246%20519.25%20234.3125%20C520.88310939%20231.22125723%20522.28028323%20229.17577342%20525%20227%20C525.66%20227%20526.32%20227%20527%20227%20C528.83402304%20221.03331172%20530.53889252%20215.06921567%20532%20209%20C532.66%20209%20533.32%20209%20534%20209%20C534.09796875%20208.44054687%20534.1959375%20207.88109375%20534.296875%20207.3046875%20C535.46966147%20201.01612555%20537.10605675%20194.94756748%20538.9375%20188.8203125%20C539.70101164%20186.07503902%20540.36117179%20183.39992479%20540.9375%20180.6171875%20C541.09492676%20179.88967285%20541.25235352%20179.1621582%20541.41455078%20178.41259766%20C541.7158578%20176.99744517%20541.996374%20175.57766634%20542.25341797%20174.15380859%20C542.6796875%20172.203125%20542.6796875%20172.203125%20544%20169%20C547.0703125%20167.734375%20547.0703125%20167.734375%20550%20167%20C550.33%20166.01%20550.66%20165.02%20551%20164%20C553.76673506%20161.52970084%20556.58169666%20160.34933027%20560%20159%20C564.97428397%20154.02571603%20563.22928068%20141.73411545%20563.30859375%20135.04296875%20C563.33121529%20133.17510963%20563.33121529%20133.17510963%20563.35429382%20131.26951599%20C563.39403524%20127.24215146%20563.41993878%20123.21500818%20563.4375%20119.1875%20C563.44095177%20118.5052813%20563.44440353%20117.82306259%20563.4479599%20117.12017059%20C563.5537795%2093.42364686%20562.53585673%2070.17939532%20555.91796875%2047.2512207%20C554.78964195%2043.25496325%20554.85542225%2040.12046576%20555%2036%20C556.98377095%2038.97565642%20557.59864225%2040.84854822%20558.40234375%2044.27734375%20C558.77613159%2045.8696582%20558.77613159%2045.8696582%20559.1574707%2047.49414062%20C559.41488037%2048.63044922%20559.67229004%2049.76675781%20559.9375%2050.9375%20C560.20328857%2052.10087891%20560.46907715%2053.26425781%20560.74291992%2054.46289062%20C564.50632294%2071.31222642%20567.12072075%2088.34566596%20567.203125%20105.6328125%20C567.21013931%20106.61953949%20567.21715363%20107.60626648%20567.22438049%20108.62289429%20C567.24179482%20111.79030976%20567.24823284%20114.95753841%20567.25%20118.125%20C567.25101212%20119.74619751%20567.25101212%20119.74619751%20567.25204468%20121.40014648%20C567.23671024%20136.8285943%20566.89923638%20151.8046912%20564%20167%20C563.75056641%20168.40886475%20563.75056641%20168.40886475%20563.49609375%20169.84619141%20C551.4775668%20237.18332711%20517.99801682%20291.43105329%20470.17684078%20339.05529046%20C467.50668597%20341.71669814%20464.84242699%20344.38399776%20462.17739868%20347.05053711%20C457.57436939%20351.65460823%20452.96773225%20356.25504288%20448.35852814%20360.85293198%20C441.6946396%20367.50047226%20435.03636991%20374.15361773%20428.37939927%20380.80808486%20C417.57520789%20391.60791366%20406.7665705%20402.40328122%20395.95507812%20413.19580078%20C385.46117989%20423.67130283%20374.96941276%20434.14893181%20364.48046875%20444.62939453%20C363.8324564%20445.27688144%20363.18444404%20445.92436835%20362.51679495%20446.59147607%20C359.26548051%20449.84018018%20356.01420755%20453.08892579%20352.76295519%20456.33769202%20C325.84839549%20483.23156403%20298.92659511%20510.11817836%20272%20537%20C266.42196909%20532.35292787%20261.25955948%20527.40316927%20256.13247681%20522.26618958%20C255.26304927%20521.3990276%20254.39362174%20520.53186562%20253.49784791%20519.63842601%20C251.10069182%20517.24648301%20248.70577335%20514.85234011%20246.31181526%20512.45719898%20C243.72319893%20509.86837773%20241.13171869%20507.28242589%20238.54063416%20504.69607544%20C233.47033627%20499.63406504%20228.4028018%20494.56929706%20223.33636691%20489.50342057%20C219.21546909%20485.38299885%20215.09378058%20481.26336973%20210.97153854%20477.14429283%20C199.2693033%20465.4508592%20187.56916186%20453.75533633%20175.87170191%20442.05712572%20C175.24179419%20441.42717804%20174.61188646%20440.79723036%20173.96289062%20440.14819336%20C173.33220898%20439.51747084%20172.70152734%20438.88674831%20172.05173413%20438.23691299%20C161.83552387%20428.02029646%20151.61433674%20417.80867522%20141.3908747%20407.5993158%20C130.87883186%20397.10165864%20120.37054471%20386.60025478%20109.86612356%20376.09497088%20C103.97455544%20370.20307154%2098.08147418%20364.31270469%2092.18434525%20358.42637062%20C87.16265885%20353.41381812%2082.14449209%20348.3977741%2077.13075449%20343.37727044%20C74.57621215%20340.81947736%2072.02013327%20338.26327466%2069.45960426%20335.71147346%20C66.67475174%20332.93601529%2063.89780662%20330.15272709%2061.12149048%20327.36872864%20C60.3237089%20326.57609062%2059.52592733%20325.78345261%2058.70397055%20324.96679527%20C53.84081835%20320.0740432%2049.38970695%20314.96666274%2045.07531869%20309.58347243%20C42.96561262%20306.95719267%2040.80197656%20304.3831298%2038.625%20301.8125%20C17.42153645%20275.79507852%200.0360986%20244.05958286%20-10%20212%20C-10.2892334%20211.07896484%20-10.5784668%20210.15792969%20-10.87646484%20209.20898438%20C-14.54673761%20197.29672988%20-17.51739022%20185.31466817%20-19.8125%20173.0625%20C-20.00730957%20172.02287109%20-20.20211914%20170.98324219%20-20.40283203%20169.91210938%20C-23.42120603%20152.88156569%20-24.37557253%20136.15410925%20-24.3125%20118.875%20C-24.31067719%20117.83752625%20-24.30885437%20116.80005249%20-24.30697632%20115.73114014%20C-24.26220274%20100.5953372%20-23.783717%2085.91257564%20-21%2071%20C-20.74259033%2069.50847412%20-20.74259033%2069.50847412%20-20.47998047%2067.98681641%20C-16.50308787%2045.02461524%20-10.48155578%2020.96311156%200%200%20Z%20%22%20fill%3D%22%23000000%22%20transform%3D%22translate(149%2C302)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.47981857%20-0.01058945%201.47981857%20-0.01058945%202.98953247%20-0.02139282%20C43.74789262%20-0.24691352%2043.74789262%20-0.24691352%2061.3671875%203.203125%20C62.47320312%203.41243652%2063.57921875%203.62174805%2064.71875%203.83740234%20C132.81352715%2016.93897099%20198.28215198%2051.77158721%20241.3671875%20107.203125%20C242.90599137%20109.05966824%20244.44770872%20110.91380011%20245.9921875%20112.765625%20C250.05704348%20117.75399387%20253.81432453%20122.83886142%20257.3671875%20128.203125%20C257.77775391%20128.81526855%20258.18832031%20129.42741211%20258.61132812%20130.05810547%20C273.25456882%20152.01772931%20284.61607775%20175.3220376%20293.3671875%20200.203125%20C293.66898926%20201.03900146%20293.97079102%20201.87487793%20294.28173828%20202.73608398%20C295.74331206%20206.89858025%20296.71449161%20210.56835709%20296.8671875%20215.015625%20C297.04785714%20220.23246088%20298.25627206%20224.96489026%20299.54736328%20229.99536133%20C305.16237495%20251.96547398%20305.82248993%20273.53882367%20305.7421875%20296.078125%20C305.74014187%20296.76350719%20305.73809624%20297.44888939%20305.73598862%20298.15504074%20C305.7205019%20302.79365822%20305.68629179%20307.43187676%20305.640625%20312.0703125%20C305.62451424%20313.85470985%20305.62451424%20313.85470985%20305.608078%20315.67515564%20C305.36594682%20332.81199595%20305.36594682%20332.81199595%20302.6171875%20336.640625%20C300.3671875%20338.203125%20300.3671875%20338.203125%20297.9921875%20339.140625%20C295.11225849%20340.14994567%20295.11225849%20340.14994567%20292.3046875%20342.765625%20C289.59418181%20345.01476802%20288.62389226%20345.57979871%20285.3671875%20346.203125%20C285.22023438%20347.11449219%20285.07328125%20348.02585937%20284.921875%20348.96484375%20C282.72831892%20361.6345211%20279.43392815%20374.00290304%20275.3671875%20386.203125%20C274.7071875%20386.203125%20274.0471875%20386.203125%20273.3671875%20386.203125%20C273.2434375%20387.87375%20273.2434375%20387.87375%20273.1171875%20389.578125%20C272.48799724%20394.8182469%20270.48087879%20399.40553734%20268.3671875%20404.203125%20C267.15179092%20400.55693526%20267.70731493%20399.74433232%20269.1171875%20396.265625%20C271.06463699%20391.20225632%20272.45232676%20386.15922013%20273.70703125%20380.88671875%20C274.43428645%20377.93036181%20275.3332248%20375.06640634%20276.3671875%20372.203125%20C277.0271875%20372.203125%20277.6871875%20372.203125%20278.3671875%20372.203125%20C278.41617188%20371.40390625%20278.46515625%20370.6046875%20278.515625%20369.78125%20C278.75598169%20366.25049313%20279.05526262%20362.72825198%20279.3671875%20359.203125%20C279.48126953%20357.57503906%20279.48126953%20357.57503906%20279.59765625%20355.9140625%20C280.19606445%20350.35238632%20280.954837%20346.92178598%20285.1796875%20343.078125%20C288.09922362%20340.90164771%20290.85412338%20339.24754947%20294.3671875%20338.203125%20C295.2953125%20337.831875%20296.2234375%20337.460625%20297.1796875%20337.078125%20C297.9015625%20336.789375%20298.6234375%20336.500625%20299.3671875%20336.203125%20C299.3465625%20335.254375%20299.3259375%20334.305625%20299.3046875%20333.328125%20C299.3046875%20329.5337073%20299.66476723%20325.82107335%20300.06884766%20322.05102539%20C302.13833292%20302.29607811%20302.39809913%20282.24622734%20299.68798828%20262.54101562%20C299.34052923%20260.0088483%20299.0238228%20257.47367687%20298.70703125%20254.9375%20C297.49419603%20245.55874845%20295.86379259%20236.54393017%20293.41015625%20227.40625%20C291.85328103%20221.41352766%20290.82795698%20215.30276155%20289.76196289%20209.20703125%20C289.53174438%20207.92892578%20289.53174438%20207.92892578%20289.296875%20206.625%20C289.16522949%20205.86799805%20289.03358398%20205.11099609%20288.89794922%20204.33105469%20C288.33444808%20202.07186614%20287.43411059%20200.26474543%20286.3671875%20198.203125%20C285.99050406%20196.54571785%20285.64661205%20194.87967229%20285.3671875%20193.203125%20C285.0371875%20193.203125%20284.7071875%20193.203125%20284.3671875%20193.203125%20C283.88758972%20190.97405105%20283.4085267%20188.74486203%20282.9296875%20186.515625%20C282.52943359%20184.65357422%20282.52943359%20184.65357422%20282.12109375%20182.75390625%20C281.51663614%20179.90700485%20280.92954066%20177.05856874%20280.3671875%20174.203125%20C279.7071875%20174.203125%20279.0471875%20174.203125%20278.3671875%20174.203125%20C278.1405542%20173.67356201%20277.9139209%20173.14399902%20277.68041992%20172.59838867%20C276.64588139%20170.19255257%20275.60042653%20167.79161251%20274.5546875%20165.390625%20C274.02004883%20164.14055664%20274.02004883%20164.14055664%20273.47460938%20162.86523438%20C273.12333984%20162.06279297%20272.77207031%20161.26035156%20272.41015625%20160.43359375%20C272.09071045%20159.69520264%20271.77126465%20158.95681152%20271.44213867%20158.19604492%20C270.31826308%20156.11242092%20269.06302297%20154.83316036%20267.3671875%20153.203125%20C266.31343933%20151.2520444%20265.31804547%20149.26886483%20264.3671875%20147.265625%20C262.61736191%20143.58825717%20260.80672185%20140.44857695%20258.3671875%20137.203125%20C258.3671875%20136.543125%20258.3671875%20135.883125%20258.3671875%20135.203125%20C257.7071875%20135.203125%20257.0471875%20135.203125%20256.3671875%20135.203125%20C256.3671875%20134.213125%20256.3671875%20133.223125%20256.3671875%20132.203125%20C255.7071875%20132.203125%20255.0471875%20132.203125%20254.3671875%20132.203125%20C254.0371875%20130.553125%20253.7071875%20128.903125%20253.3671875%20127.203125%20C252.0471875%20127.533125%20250.7271875%20127.863125%20249.3671875%20128.203125%20C249.3671875%20127.543125%20249.3671875%20126.883125%20249.3671875%20126.203125%20C246.3971875%20127.193125%20246.3971875%20127.193125%20243.3671875%20128.203125%20C243.0371875%20127.873125%20242.7071875%20127.543125%20242.3671875%20127.203125%20C240.913125%20128.13125%20240.913125%20128.13125%20239.4296875%20129.078125%20C236.56182877%20130.73846426%20234.0575715%20131.5966551%20230.8046875%20132.203125%20C226.55128503%20133.02081114%20223.92410355%20134.6836428%20220.3671875%20137.203125%20C218.13327788%20138.26454062%20215.86863506%20139.22915907%20213.59375%20140.19921875%20C211.56738138%20141.11286214%20209.70811522%20142.12269923%20207.8046875%20143.265625%20C204.6531682%20145.04193588%20201.6777702%20146.27504788%20198.29296875%20147.484375%20C194.53091824%20148.88846687%20191.21487436%20150.35543814%20188.3671875%20153.203125%20C185.21904358%20154.30844089%20182.06004869%20155.30162358%20178.86523438%20156.25976562%20C175.24432816%20157.39817003%20172.88488574%20158.36975206%20170.3671875%20161.203125%20C168.4296875%20162.08203125%20168.4296875%20162.08203125%20166.3671875%20162.765625%20C163.59146481%20163.69612295%20161.87156847%20164.53353769%20159.3671875%20166.203125%20C157.3671875%20166.86979167%20155.3671875%20167.53645833%20153.3671875%20168.203125%20C150.16168288%20169.64233116%20147.58135767%20171.02643461%20144.8671875%20173.265625%20C141.39495757%20175.9566032%20137.96450128%20176.83614275%20133.71484375%20177.8125%20C127.67328192%20179.27220621%20124.66144453%20180.56068497%20120.3671875%20185.203125%20C118.32046128%20186.14254036%20116.2855662%20186.85762648%20114.13671875%20187.52734375%20C112.15003587%20188.14807523%20112.15003587%20188.14807523%20110.3671875%20190.203125%20C108.52734375%20191.01953125%20108.52734375%20191.01953125%20106.4296875%20191.765625%20C105.74003906%20192.01441406%20105.05039062%20192.26320313%20104.33984375%20192.51953125%20C102.68633391%20193.09252971%20101.02736213%20193.64973346%2099.3671875%20194.203125%20C99.3671875%20194.863125%2099.3671875%20195.523125%2099.3671875%20196.203125%20C98.23796875%20196.6053125%2098.23796875%20196.6053125%2097.0859375%20197.015625%20C89.09712417%20199.96295419%2081.61030352%20203.48239116%2074.03515625%20207.34765625%20C69.88137148%20209.46520989%2065.65402715%20211.3718537%2061.3671875%20213.203125%20C54.94785028%20215.95730362%2054.94785028%20215.95730362%2048.8046875%20219.265625%20C45.71819086%20221.00528674%2042.85946863%20222.17862079%2039.546875%20223.3515625%20C36.16658181%20224.67217883%2032.980833%20226.35016829%2029.76171875%20228.01953125%20C27.3671875%20229.203125%2027.3671875%20229.203125%2024.74609375%20230.22265625%20C22.16115731%20231.17527769%2022.16115731%20231.17527769%2019.4921875%20233.328125%20C15.72013287%20235.59135778%2013.69979125%20235.7545473%209.3671875%20235.203125%20C6.7421875%20233.828125%206.7421875%20233.828125%204.3671875%20232.203125%20C2.7043708%20231.52691287%201.03722014%20230.86131433%20-0.6328125%20230.203125%20C-2.26703628%20229.43067839%20-3.89209365%20228.63856544%20-5.5078125%20227.828125%20C-6.38050781%20227.39113281%20-7.25320313%20226.95414063%20-8.15234375%20226.50390625%20C-10.23067185%20225.41401136%20-12.20497211%20224.25436832%20-14.1953125%20223.015625%20C-17.76240084%20221.1347966%20-20.77712251%20220.35950644%20-24.71484375%20219.6953125%20C-26.6328125%20219.203125%20-26.6328125%20219.203125%20-28.6328125%20217.203125%20C-30.45626077%20216.49400623%20-32.28296281%20215.79213946%20-34.125%20215.1328125%20C-39.02428254%20213.31656757%20-43.81897789%20211.23295859%20-48.6328125%20209.203125%20C-48.6328125%20208.543125%20-48.6328125%20207.883125%20-48.6328125%20207.203125%20C-49.2515625%20207.079375%20-49.8703125%20206.955625%20-50.5078125%20206.828125%20C-52.6328125%20206.203125%20-52.6328125%20206.203125%20-54.6328125%20204.203125%20C-56.36560738%20203.58966909%20-58.11996519%20203.03646625%20-59.8828125%20202.515625%20C-68.7027532%20199.68216579%20-77.20892625%20195.77914436%20-84.6328125%20190.203125%20C-86.26490446%20189.71349741%20-87.89962503%20189.22947671%20-89.55078125%20188.80859375%20C-93.69341661%20187.60388741%20-97.65124101%20185.85343431%20-101.6328125%20184.203125%20C-101.6328125%20183.543125%20-101.6328125%20182.883125%20-101.6328125%20182.203125%20C-102.47005859%20182.04070312%20-102.47005859%20182.04070312%20-103.32421875%20181.875%20C-106.0302118%20181.08746903%20-108.13608376%20179.87339681%20-110.5703125%20178.453125%20C-115.80792528%20175.51752752%20-121.13107522%20173.37810136%20-126.78515625%20171.37890625%20C-129.49569036%20170.25974196%20-131.34766524%20169.00237779%20-133.6328125%20167.203125%20C-135.51804919%20166.24217012%20-135.51804919%20166.24217012%20-137.3828125%20165.515625%20C-138.4553125%20165.0825%20-139.5278125%20164.649375%20-140.6328125%20164.203125%20C-140.6328125%20163.543125%20-140.6328125%20162.883125%20-140.6328125%20162.203125%20C-141.70825317%20162.01411621%20-141.70825317%20162.01411621%20-142.80541992%20161.82128906%20C-147.70769018%20160.74948626%20-152.28089994%20158.77640581%20-156.9453125%20156.953125%20C-157.95271484%20156.57027344%20-158.96011719%20156.18742188%20-159.99804688%20155.79296875%20C-165.31794698%20153.72046044%20-170.16448014%20151.51599833%20-174.88476562%20148.28857422%20C-177.39019427%20146.732829%20-180.04323816%20145.8452443%20-182.8203125%20144.890625%20C-184.6328125%20144.203125%20-184.6328125%20144.203125%20-187.3203125%20142.578125%20C-189.58358294%20141.05229377%20-189.58358294%20141.05229377%20-192.3203125%20140.703125%20C-194.6328125%20140.203125%20-194.6328125%20140.203125%20-196.6328125%20137.203125%20C-199.10437919%20136.11107481%20-199.10437919%20136.11107481%20-201.9453125%20135.265625%20C-206.19904083%20133.81980395%20-209.34799884%20132.37466923%20-212.6328125%20129.203125%20C-216.26763209%20131.33388131%20-217.23032126%20133.5435308%20-218.79125977%20137.35473633%20C-220.07411415%20140.17240112%20-221.86156416%20142.52958142%20-223.6953125%20145.015625%20C-232.95410331%20157.93052034%20-240.58729623%20172.52115691%20-246.6328125%20187.203125%20C-246.96313477%20187.95988525%20-247.29345703%20188.71664551%20-247.63378906%20189.49633789%20C-248.76169999%20192.55233702%20-249.35573886%20195.49254304%20-249.9296875%20198.69921875%20C-250.16324951%20199.96950928%20-250.39681152%20201.2397998%20-250.63745117%20202.54858398%20C-250.75881439%20203.21638885%20-250.88017761%20203.88419373%20-251.00521851%20204.57223511%20C-253.05536874%20215.802578%20-255.41384578%20226.81426548%20-258.58618164%20237.79052734%20C-260.50174571%20244.47302388%20-261.83519256%20251.12059571%20-262.89453125%20257.98828125%20C-263.65156078%20261.28476435%20-264.61402273%20263.49947997%20-266.6328125%20266.203125%20C-267.2928125%20266.203125%20-267.9528125%20266.203125%20-268.6328125%20266.203125%20C-264.27867699%20232.53822361%20-256.78713635%20200.76063367%20-241.6328125%20170.203125%20C-241.2625293%20169.4409668%20-240.89224609%20168.67880859%20-240.51074219%20167.89355469%20C-233.68732959%20153.93577433%20-225.29880066%20141.07706694%20-216.6328125%20128.203125%20C-221.02535023%20126.64040311%20-221.02535023%20126.64040311%20-225.6328125%20126.203125%20C-230.40459271%20130.53236108%20-233.95577705%20135.36232039%20-236.6328125%20141.203125%20C-237.51493414%20142.53051973%20-238.41569384%20143.84559789%20-239.328125%20145.15234375%20C-242.96366235%20150.5493738%20-245.92374888%20156.22760734%20-248.8828125%20162.015625%20C-249.41132813%20163.03849609%20-249.93984375%20164.06136719%20-250.484375%20165.11523438%20C-252.55763772%20169.13283866%20-254.61776182%20173.15597682%20-256.6328125%20177.203125%20C-257.6328125%20174.203125%20-257.6328125%20174.203125%20-256.91113281%20172.12866211%20C-256.51506836%20171.3372583%20-256.11900391%20170.54585449%20-255.7109375%20169.73046875%20C-255.0468689%20168.39471802%20-255.0468689%20168.39471802%20-254.36938477%20167.03198242%20C-253.87881592%20166.07783447%20-253.38824707%20165.12368652%20-252.8828125%20164.140625%20C-252.38128662%20163.15489502%20-251.87976074%20162.16916504%20-251.36303711%20161.15356445%20C-241.2260911%20141.50224155%20-228.98161564%20123.0358386%20-214.6328125%20106.203125%20C-213.72192614%20105.10737736%20-212.8118117%20104.0109877%20-211.90234375%20102.9140625%20C-202.37691071%2091.51289114%20-192.09501806%2080.68225002%20-180.6328125%2071.203125%20C-179.56769494%2070.28907811%20-178.5025923%2069.37501383%20-177.4375%2068.4609375%20C-160.70481556%2054.29943785%20-142.14537173%2042.17817414%20-122.6328125%2032.203125%20C-121.83907227%2031.79400879%20-121.04533203%2031.38489258%20-120.22753906%2030.96337891%20C-100.651255%2020.97587009%20-79.97454661%2013.43696619%20-58.6328125%208.203125%20C-57.91109863%208.02442871%20-57.18938477%207.84573242%20-56.44580078%207.66162109%20C-37.98524368%203.15735909%20-19.0263901%200.09080073%200%200%20Z%20%22%20fill%3D%22%23E76D0A%22%20transform%3D%22translate(407.6328125%2C124.796875)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.47981857%20-0.01058945%201.47981857%20-0.01058945%202.98953247%20-0.02139282%20C43.74789262%20-0.24691352%2043.74789262%20-0.24691352%2061.3671875%203.203125%20C62.47320312%203.41243652%2063.57921875%203.62174805%2064.71875%203.83740234%20C132.81352715%2016.93897099%20198.28215198%2051.77158721%20241.3671875%20107.203125%20C242.90599137%20109.05966824%20244.44770872%20110.91380011%20245.9921875%20112.765625%20C250.05704348%20117.75399387%20253.81432453%20122.83886142%20257.3671875%20128.203125%20C257.77775391%20128.81526855%20258.18832031%20129.42741211%20258.61132812%20130.05810547%20C273.25456882%20152.01772931%20284.61607775%20175.3220376%20293.3671875%20200.203125%20C293.66898926%20201.03900146%20293.97079102%20201.87487793%20294.28173828%20202.73608398%20C295.74331206%20206.89858025%20296.71449161%20210.56835709%20296.8671875%20215.015625%20C297.04785714%20220.23246088%20298.25627206%20224.96489026%20299.54736328%20229.99536133%20C305.16237495%20251.96547398%20305.82248993%20273.53882367%20305.7421875%20296.078125%20C305.74014187%20296.76350719%20305.73809624%20297.44888939%20305.73598862%20298.15504074%20C305.7205019%20302.79365822%20305.68629179%20307.43187676%20305.640625%20312.0703125%20C305.62451424%20313.85470985%20305.62451424%20313.85470985%20305.608078%20315.67515564%20C305.36594682%20332.81199595%20305.36594682%20332.81199595%20302.6171875%20336.640625%20C300.3671875%20338.203125%20300.3671875%20338.203125%20297.9921875%20339.140625%20C295.11225849%20340.14994567%20295.11225849%20340.14994567%20292.3046875%20342.765625%20C289.59418181%20345.01476802%20288.62389226%20345.57979871%20285.3671875%20346.203125%20C285.22023438%20347.11449219%20285.07328125%20348.02585937%20284.921875%20348.96484375%20C282.72831892%20361.6345211%20279.43392815%20374.00290304%20275.3671875%20386.203125%20C274.7071875%20386.203125%20274.0471875%20386.203125%20273.3671875%20386.203125%20C273.2434375%20387.87375%20273.2434375%20387.87375%20273.1171875%20389.578125%20C272.48799724%20394.8182469%20270.48087879%20399.40553734%20268.3671875%20404.203125%20C267.15179092%20400.55693526%20267.70731493%20399.74433232%20269.1171875%20396.265625%20C271.06463699%20391.20225632%20272.45232676%20386.15922013%20273.70703125%20380.88671875%20C274.43428645%20377.93036181%20275.3332248%20375.06640634%20276.3671875%20372.203125%20C277.0271875%20372.203125%20277.6871875%20372.203125%20278.3671875%20372.203125%20C278.41617188%20371.40390625%20278.46515625%20370.6046875%20278.515625%20369.78125%20C278.75598169%20366.25049313%20279.05526262%20362.72825198%20279.3671875%20359.203125%20C279.48126953%20357.57503906%20279.48126953%20357.57503906%20279.59765625%20355.9140625%20C280.19606445%20350.35238632%20280.954837%20346.92178598%20285.1796875%20343.078125%20C288.09922362%20340.90164771%20290.85412338%20339.24754947%20294.3671875%20338.203125%20C295.2953125%20337.831875%20296.2234375%20337.460625%20297.1796875%20337.078125%20C297.9015625%20336.789375%20298.6234375%20336.500625%20299.3671875%20336.203125%20C299.3465625%20335.254375%20299.3259375%20334.305625%20299.3046875%20333.328125%20C299.3046875%20329.5337073%20299.66476723%20325.82107335%20300.06884766%20322.05102539%20C302.13833292%20302.29607811%20302.39809913%20282.24622734%20299.68798828%20262.54101562%20C299.34052923%20260.0088483%20299.0238228%20257.47367687%20298.70703125%20254.9375%20C297.49419603%20245.55874845%20295.86379259%20236.54393017%20293.41015625%20227.40625%20C291.85328103%20221.41352766%20290.82795698%20215.30276155%20289.76196289%20209.20703125%20C289.53174438%20207.92892578%20289.53174438%20207.92892578%20289.296875%20206.625%20C289.16522949%20205.86799805%20289.03358398%20205.11099609%20288.89794922%20204.33105469%20C288.33444808%20202.07186614%20287.43411059%20200.26474543%20286.3671875%20198.203125%20C285.99050406%20196.54571785%20285.64661205%20194.87967229%20285.3671875%20193.203125%20C285.0371875%20193.203125%20284.7071875%20193.203125%20284.3671875%20193.203125%20C283.88758972%20190.97405105%20283.4085267%20188.74486203%20282.9296875%20186.515625%20C282.52943359%20184.65357422%20282.52943359%20184.65357422%20282.12109375%20182.75390625%20C281.51663614%20179.90700485%20280.92954066%20177.05856874%20280.3671875%20174.203125%20C279.7071875%20174.203125%20279.0471875%20174.203125%20278.3671875%20174.203125%20C278.1405542%20173.67356201%20277.9139209%20173.14399902%20277.68041992%20172.59838867%20C276.64588139%20170.19255257%20275.60042653%20167.79161251%20274.5546875%20165.390625%20C274.02004883%20164.14055664%20274.02004883%20164.14055664%20273.47460938%20162.86523438%20C273.12333984%20162.06279297%20272.77207031%20161.26035156%20272.41015625%20160.43359375%20C272.09071045%20159.69520264%20271.77126465%20158.95681152%20271.44213867%20158.19604492%20C270.31826308%20156.11242092%20269.06302297%20154.83316036%20267.3671875%20153.203125%20C266.31343933%20151.2520444%20265.31804547%20149.26886483%20264.3671875%20147.265625%20C262.61736191%20143.58825717%20260.80672185%20140.44857695%20258.3671875%20137.203125%20C258.3671875%20136.543125%20258.3671875%20135.883125%20258.3671875%20135.203125%20C257.7071875%20135.203125%20257.0471875%20135.203125%20256.3671875%20135.203125%20C256.3671875%20134.213125%20256.3671875%20133.223125%20256.3671875%20132.203125%20C255.7071875%20132.203125%20255.0471875%20132.203125%20254.3671875%20132.203125%20C254.0371875%20130.553125%20253.7071875%20128.903125%20253.3671875%20127.203125%20C252.0471875%20127.533125%20250.7271875%20127.863125%20249.3671875%20128.203125%20C249.3671875%20127.543125%20249.3671875%20126.883125%20249.3671875%20126.203125%20C246.3971875%20127.193125%20246.3971875%20127.193125%20243.3671875%20128.203125%20C243.0371875%20127.873125%20242.7071875%20127.543125%20242.3671875%20127.203125%20C241.2534375%20127.88375%20240.1396875%20128.564375%20238.9921875%20129.265625%20C237.09375%20130.42578125%20237.09375%20130.42578125%20235.3671875%20131.203125%20C234.7071875%20130.873125%20234.0471875%20130.543125%20233.3671875%20130.203125%20C234.0271875%20129.543125%20234.6871875%20128.883125%20235.3671875%20128.203125%20C236.29794876%20121.68779621%20233.95801661%20117.41625707%20230.3671875%20112.203125%20C228.01305984%20109.59897786%20228.01305984%20109.59897786%20225.3671875%20107.203125%20C224.27455229%20105.94028029%20223.19207896%20104.66860655%20222.1171875%20103.390625%20C218.83041914%2099.58715943%20215.23423395%2096.31008296%20211.44140625%2093.01953125%20C208.20341918%2090.18400585%20205.23891955%2087.10049623%20202.2421875%2084.015625%20C200.29677032%2082.02656274%20200.29677032%2082.02656274%20197.3671875%2080.203125%20C197.3671875%2079.543125%20197.3671875%2078.883125%20197.3671875%2078.203125%20C196.6040625%2077.935%20195.8409375%2077.666875%20195.0546875%2077.390625%20C192.47730132%2076.25177995%20191.09763886%2075.38895829%20189.3671875%2073.203125%20C189.3671875%2072.543125%20189.3671875%2071.883125%20189.3671875%2071.203125%20C188.7071875%2071.203125%20188.0471875%2071.203125%20187.3671875%2071.203125%20C187.3671875%2070.543125%20187.3671875%2069.883125%20187.3671875%2069.203125%20C185.7171875%2068.873125%20184.0671875%2068.543125%20182.3671875%2068.203125%20C182.3671875%2067.543125%20182.3671875%2066.883125%20182.3671875%2066.203125%20C181.7071875%2065.873125%20181.0471875%2065.543125%20180.3671875%2065.203125%20C180.6971875%2064.873125%20181.0271875%2064.543125%20181.3671875%2064.203125%20C179.3871875%2063.543125%20177.4071875%2062.883125%20175.3671875%2062.203125%20C175.6971875%2061.543125%20176.0271875%2060.883125%20176.3671875%2060.203125%20C173.7271875%2059.543125%20171.0871875%2058.883125%20168.3671875%2058.203125%20C168.3671875%2057.543125%20168.3671875%2056.883125%20168.3671875%2056.203125%20C170.0171875%2056.203125%20171.6671875%2056.203125%20173.3671875%2056.203125%20C170.7271875%2055.543125%20168.0871875%2054.883125%20165.3671875%2054.203125%20C165.3671875%2053.213125%20165.3671875%2052.223125%20165.3671875%2051.203125%20C163.3871875%2051.203125%20161.4071875%2051.203125%20159.3671875%2051.203125%20C159.0371875%2049.553125%20158.7071875%2047.903125%20158.3671875%2046.203125%20C155.0671875%2046.203125%20151.7671875%2046.203125%20148.3671875%2046.203125%20C148.3671875%2045.213125%20148.3671875%2044.223125%20148.3671875%2043.203125%20C150.0171875%2043.203125%20151.6671875%2043.203125%20153.3671875%2043.203125%20C152.7071875%2041.883125%20152.0471875%2040.563125%20151.3671875%2039.203125%20C145.0971875%2038.873125%20138.8271875%2038.543125%20132.3671875%2038.203125%20C132.3671875%2037.543125%20132.3671875%2036.883125%20132.3671875%2036.203125%20C130.3871875%2035.873125%20128.4071875%2035.543125%20126.3671875%2035.203125%20C126.3671875%2034.873125%20126.3671875%2034.543125%20126.3671875%2034.203125%20C125.6246875%2034.079375%20124.8821875%2033.955625%20124.1171875%2033.828125%20C121.51886196%2033.23759647%20119.7242986%2032.39449843%20117.3671875%2031.203125%20C114.41880853%2030.07178266%20111.42318753%2029.0831716%20108.4296875%2028.078125%20C107.23182617%2027.66240234%20107.23182617%2027.66240234%20106.00976562%2027.23828125%20C102.02777424%2025.89885416%2098.630054%2024.80697983%2094.3671875%2025.203125%20C94.3671875%2024.543125%2094.3671875%2023.883125%2094.3671875%2023.203125%20C93.55894531%2023.15414062%2092.75070312%2023.10515625%2091.91796875%2023.0546875%20C90.84933594%2022.97992188%2089.78070313%2022.90515625%2088.6796875%2022.828125%20C87.62394531%2022.75851563%2086.56820313%2022.68890625%2085.48046875%2022.6171875%20C82.45215258%2022.21442525%2080.15521895%2021.4042734%2077.3671875%2020.203125%20C76.7071875%2020.203125%2076.0471875%2020.203125%2075.3671875%2020.203125%20C75.3671875%2019.543125%2075.3671875%2018.883125%2075.3671875%2018.203125%20C74.3771875%2018.203125%2073.3871875%2018.203125%2072.3671875%2018.203125%20C72.3671875%2018.863125%2072.3671875%2019.523125%2072.3671875%2020.203125%20C74.3471875%2021.193125%2074.3471875%2021.193125%2076.3671875%2022.203125%20C72.93093062%2023.34854396%2070.71292872%2023.13752599%2067.1171875%2022.828125%20C66.01890625%2022.73789063%2064.920625%2022.64765625%2063.7890625%2022.5546875%20C60.29659536%2022.19587238%2056.83966562%2021.71956459%2053.3671875%2021.203125%20C52.20058594%2021.038125%2051.03398437%2020.873125%2049.83203125%2020.703125%20C48.66800781%2020.538125%2047.50398438%2020.373125%2046.3046875%2020.203125%20C45.13808594%2020.038125%2043.97148437%2019.873125%2042.76953125%2019.703125%20C40.75100177%2019.40648691%2038.73604725%2019.07827828%2036.73461914%2018.68237305%20C32.4975757%2018.07936309%2028.36012271%2018.04079307%2024.0859375%2018.03515625%20C23.19539673%2018.03182785%2022.30485596%2018.02849945%2021.3873291%2018.02507019%20C19.50464389%2018.02002104%2017.62194979%2018.01766124%2015.73925781%2018.01782227%20C12.90414009%2018.01565327%2010.06942311%2017.99752457%207.234375%2017.97851562%20C-1.91814364%2017.95106772%20-10.70785615%2018.16822493%20-19.74023438%2019.7722168%20C-22.74691385%2020.22012271%20-25.59771058%2020.22553498%20-28.6328125%2020.203125%20C-30.64674348%2020.6436724%20-32.64825675%2021.14496869%20-34.6328125%2021.703125%20C-38.79577608%2022.87395851%20-42.31603784%2023.25831104%20-46.6328125%2023.203125%20C-47.98259099%2023.83583367%20-49.31634131%2024.50374968%20-50.6328125%2025.203125%20C-53.71590046%2025.83232662%20-56.48513856%2026.203125%20-59.6328125%2026.203125%20C-60.2928125%2026.863125%20-60.9528125%2027.523125%20-61.6328125%2028.203125%20C-63.55549028%2028.4020227%20-65.47835037%2028.59941554%20-67.40234375%2028.78515625%20C-70.57239554%2029.37919398%20-73.08830827%2030.77714997%20-75.87109375%2032.36328125%20C-77.6328125%2033.203125%20-77.6328125%2033.203125%20-80.6328125%2033.203125%20C-81.6228125%2033.698125%20-81.6228125%2033.698125%20-82.6328125%2034.203125%20C-84.6328125%2035.203125%20-84.6328125%2035.203125%20-87.6328125%2035.203125%20C-89.55934395%2036.2222806%20-89.55934395%2036.2222806%20-91.5078125%2037.578125%20C-94.46837616%2039.56344416%20-97.31535749%2040.90693375%20-100.6328125%2042.203125%20C-102.59964549%2043.16510462%20-104.55765082%2044.14528274%20-106.5078125%2045.140625%20C-109.75897429%2046.7880391%20-112.94207861%2048.32892816%20-116.3203125%2049.703125%20C-121.35680043%2051.98379878%20-126.36235763%2054.91652946%20-130.28125%2058.86328125%20C-131.6328125%2060.203125%20-131.6328125%2060.203125%20-133.5078125%2060.640625%20C-136.50021546%2061.43273167%20-138.26537085%2063.23988071%20-140.6328125%2065.203125%20C-141.39464844%2065.656875%20-142.15648437%2066.110625%20-142.94140625%2066.578125%20C-157.70498456%2075.4919836%20-171.99095559%2087.79575204%20-183.69921875%20100.43359375%20C-185.6328125%20102.203125%20-185.6328125%20102.203125%20-187.953125%20103.01171875%20C-192.04647272%20104.8316474%20-194.54037955%20107.97598392%20-197.5078125%20111.265625%20C-198.12841553%20111.94085205%20-198.74901855%20112.6160791%20-199.38842773%20113.31176758%20C-203.2408562%20117.54189504%20-206.84351597%20121.88580199%20-210.24609375%20126.48828125%20C-211.6328125%20128.203125%20-211.6328125%20128.203125%20-214.3828125%20130.328125%20C-216.91730191%20132.44019951%20-217.57009092%20134.35625689%20-218.79345703%20137.35253906%20C-220.07267469%20140.17292006%20-221.86105231%20142.5288875%20-223.6953125%20145.015625%20C-232.95410331%20157.93052034%20-240.58729623%20172.52115691%20-246.6328125%20187.203125%20C-246.96313477%20187.95988525%20-247.29345703%20188.71664551%20-247.63378906%20189.49633789%20C-248.76169999%20192.55233702%20-249.35573886%20195.49254304%20-249.9296875%20198.69921875%20C-250.16324951%20199.96950928%20-250.39681152%20201.2397998%20-250.63745117%20202.54858398%20C-250.75881439%20203.21638885%20-250.88017761%20203.88419373%20-251.00521851%20204.57223511%20C-253.05536874%20215.802578%20-255.41384578%20226.81426548%20-258.58618164%20237.79052734%20C-260.50174571%20244.47302388%20-261.83519256%20251.12059571%20-262.89453125%20257.98828125%20C-263.65156078%20261.28476435%20-264.61402273%20263.49947997%20-266.6328125%20266.203125%20C-267.2928125%20266.203125%20-267.9528125%20266.203125%20-268.6328125%20266.203125%20C-264.27867699%20232.53822361%20-256.78713635%20200.76063367%20-241.6328125%20170.203125%20C-241.2625293%20169.4409668%20-240.89224609%20168.67880859%20-240.51074219%20167.89355469%20C-233.68732959%20153.93577433%20-225.29880066%20141.07706694%20-216.6328125%20128.203125%20C-221.02535023%20126.64040311%20-221.02535023%20126.64040311%20-225.6328125%20126.203125%20C-230.40459271%20130.53236108%20-233.95577705%20135.36232039%20-236.6328125%20141.203125%20C-237.51493414%20142.53051973%20-238.41569384%20143.84559789%20-239.328125%20145.15234375%20C-242.96366235%20150.5493738%20-245.92374888%20156.22760734%20-248.8828125%20162.015625%20C-249.41132813%20163.03849609%20-249.93984375%20164.06136719%20-250.484375%20165.11523438%20C-252.55763772%20169.13283866%20-254.61776182%20173.15597682%20-256.6328125%20177.203125%20C-257.6328125%20174.203125%20-257.6328125%20174.203125%20-256.91113281%20172.12866211%20C-256.51506836%20171.3372583%20-256.11900391%20170.54585449%20-255.7109375%20169.73046875%20C-255.0468689%20168.39471802%20-255.0468689%20168.39471802%20-254.36938477%20167.03198242%20C-253.87881592%20166.07783447%20-253.38824707%20165.12368652%20-252.8828125%20164.140625%20C-252.38128662%20163.15489502%20-251.87976074%20162.16916504%20-251.36303711%20161.15356445%20C-241.2260911%20141.50224155%20-228.98161564%20123.0358386%20-214.6328125%20106.203125%20C-213.72192614%20105.10737736%20-212.8118117%20104.0109877%20-211.90234375%20102.9140625%20C-202.37691071%2091.51289114%20-192.09501806%2080.68225002%20-180.6328125%2071.203125%20C-179.56769494%2070.28907811%20-178.5025923%2069.37501383%20-177.4375%2068.4609375%20C-160.70481556%2054.29943785%20-142.14537173%2042.17817414%20-122.6328125%2032.203125%20C-121.83907227%2031.79400879%20-121.04533203%2031.38489258%20-120.22753906%2030.96337891%20C-100.651255%2020.97587009%20-79.97454661%2013.43696619%20-58.6328125%208.203125%20C-57.91109863%208.02442871%20-57.18938477%207.84573242%20-56.44580078%207.66162109%20C-37.98524368%203.15735909%20-19.0263901%200.09080073%200%200%20Z%20M-72.6328125%2020.203125%20C-72.9628125%2020.863125%20-73.2928125%2021.523125%20-73.6328125%2022.203125%20C-72.9728125%2022.203125%20-72.3128125%2022.203125%20-71.6328125%2022.203125%20C-71.9628125%2021.543125%20-72.2928125%2020.883125%20-72.6328125%2020.203125%20Z%20M-77.6328125%2024.203125%20C-77.9628125%2024.863125%20-78.2928125%2025.523125%20-78.6328125%2026.203125%20C-77.6428125%2025.873125%20-76.6528125%2025.543125%20-75.6328125%2025.203125%20C-76.2928125%2024.873125%20-76.9528125%2024.543125%20-77.6328125%2024.203125%20Z%20%22%20fill%3D%22%23803B05%22%20transform%3D%22translate(407.6328125%2C124.796875)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C0.27832031%204.05273438%200.27832031%204.05273438%20-0.921875%206.59375%20C-1.5871521%208.00382324%20-1.5871521%208.00382324%20-2.26586914%209.44238281%20C-2.75563232%2010.45139648%20-3.24539551%2011.46041016%20-3.75%2012.5%20C-4.2442749%2013.52706055%20-4.7385498%2014.55412109%20-5.24780273%2015.61230469%20C-10.43624897%2026.20070279%20-16.46426349%2036.19639523%20-23%2046%20C-23.66%2046%20-24.32%2046%20-25%2046%20C-25.20625%2046.66%20-25.4125%2047.32%20-25.625%2048%20C-27.17458468%2051.38091203%20-29.13606916%2054.00506693%20-31.41015625%2056.9296875%20C-32.93105278%2058.91021616%20-34.34310898%2060.9376731%20-35.75%2063%20C-36.86375%2064.485%20-36.86375%2064.485%20-38%2066%20C-38.66%2066%20-39.32%2066%20-40%2066%20C-40.4021875%2067.2065625%20-40.4021875%2067.2065625%20-40.8125%2068.4375%20C-41.204375%2069.283125%20-41.59625%2070.12875%20-42%2071%20C-42.99%2071.33%20-43.98%2071.66%20-45%2072%20C-45.268125%2072.5775%20-45.53625%2073.155%20-45.8125%2073.75%20C-47.5763914%2077.09211003%20-49.98041507%2078.7353113%20-53%2081%20C-53.66%2081%20-54.32%2081%20-55%2081%20C-55.25789527%2081.5751919%20-55.51579054%2082.1503838%20-55.78150082%2082.74300575%20C-62.00387165%2094.26854091%20-74.89694891%20104.04520838%20-84.06420898%20113.20947266%20C-85.8949791%20115.04323841%20-87.72554515%20116.87720792%20-89.55592346%20118.71136475%20C-93.99087341%20123.15457074%20-98.42854988%20127.59504355%20-102.86734962%20132.03440328%20C-106.47290239%20135.64043286%20-110.07766104%20139.24725441%20-113.68187141%20142.8546257%20C-123.9090659%20153.09060672%20-134.13833353%20163.32450939%20-144.37029826%20173.55572207%20C-144.92026536%20174.10564922%20-145.47023246%20174.65557636%20-146.03686523%20175.22216797%20C-146.58750545%20175.7727673%20-147.13814566%20176.32336663%20-147.70547194%20176.89065079%20C-156.65730663%20185.84207779%20-165.60412416%20194.79850105%20-174.54871988%20203.75716098%20C-183.74128717%20212.96406825%20-192.93755345%20222.16726631%20-202.13772637%20231.36657369%20C-207.29991316%20236.52842808%20-212.46053916%20241.69182125%20-217.61718559%20246.85921097%20C-222.45612185%20251.70816489%20-227.3001548%20256.55197467%20-232.14775658%20261.39226532%20C-233.93055279%20263.17401002%20-235.7116238%20264.95748277%20-237.49088669%20266.74275589%20C-239.90895091%20269.16846229%20-242.33301125%20271.5880078%20-244.7587738%20274.00601196%20C-245.47052543%20274.72290715%20-246.18227705%20275.43980233%20-246.9155969%20276.17842162%20C-247.88511198%20277.1410385%20-247.88511198%20277.1410385%20-248.87421322%20278.12310219%20C-249.71329185%20278.96250688%20-249.71329185%20278.96250688%20-250.56932157%20279.81886923%20C-252%20281%20-252%20281%20-254%20281%20C-254.02705308%20278.58325776%20-254.04686438%20276.1668206%20-254.0625%20273.75%20C-254.07087891%20273.06808594%20-254.07925781%20272.38617187%20-254.08789062%20271.68359375%20C-254.12914302%20263.18560013%20-254.12914302%20263.18560013%20-251.42160696%20260.34268737%20C-250.42892564%20259.53962201%20-250.42892564%20259.53962201%20-249.41619015%20258.7203331%20C-245.17011392%20255.16745023%20-241.24953867%20251.39237888%20-237.34095764%20247.47467041%20C-236.61360002%20246.74957834%20-235.88624239%20246.02448627%20-235.13684362%20245.27742171%20C-232.72045367%20242.86731976%20-230.30760894%20240.45370104%20-227.89477539%20238.04003906%20C-226.15472448%20236.30298287%20-224.41446948%20234.56613112%20-222.67402649%20232.82946777%20C-218.44962296%20228.61296234%20-214.22759642%20224.39409095%20-210.00686104%20220.1739147%20C-206.57296242%20216.74049286%20-203.13827194%20213.30786517%20-199.70303154%20209.87578583%20C-189.94352032%20200.12507125%20-180.18609806%20190.37227321%20-170.43135983%20180.61678365%20C-169.90656236%20180.09194622%20-169.38176488%20179.56710878%20-168.84106445%20179.02636719%20C-168.31561983%20178.50088168%20-167.79017521%20177.97539618%20-167.24880802%20177.43398687%20C-158.73659027%20168.92136283%20-150.21939638%20160.41373705%20-141.69992847%20151.90836957%20C-132.93258821%20143.15542454%20-124.16901434%20134.39872391%20-115.40929979%20125.63814712%20C-110.49919776%20120.72771423%20-105.5875928%20115.8188075%20-100.67192268%20110.91394806%20C-96.04699604%20106.29912837%20-91.42732776%20101.67909076%20-86.81107903%2097.05558777%20C-85.12180212%2095.36526914%20-83.43083575%2093.67663688%20-81.73800659%2091.98987579%20C-73.36216405%2083.64210186%20-65.24187102%2075.36752399%20-58%2066%20C-57.03149715%2064.83160499%20-56.05705098%2063.66808611%20-55.07421875%2062.51171875%20C-54.28660156%2061.57972656%20-53.49898437%2060.64773438%20-52.6875%2059.6875%20C-51.88699219%2058.74261719%20-51.08648438%2057.79773438%20-50.26171875%2056.82421875%20C-47.91106319%2053.9868087%20-47.91106319%2053.9868087%20-45.83203125%2050.64453125%20C-45.22746094%2049.77183594%20-44.62289062%2048.89914062%20-44%2048%20C-43.34%2048%20-42.68%2048%20-42%2048%20C-41.71713135%2047.41839111%20-41.4342627%2046.83678223%20-41.14282227%2046.23754883%20C-40.08071647%2044.15803599%20-38.93965457%2042.1861787%20-37.71484375%2040.19921875%20C-37.048479%2039.11423096%20-37.048479%2039.11423096%20-36.36865234%2038.00732422%20C-35.89637207%2037.24178223%20-35.4240918%2036.47624023%20-34.9375%2035.6875%20C-32.03419688%2030.96758344%20-29.13518152%2026.24685103%20-26.30859375%2021.48046875%20C-25.6909314%2020.43983276%20-25.6909314%2020.43983276%20-25.06079102%2019.37817383%20C-24.28094395%2018.06076696%20-23.50400125%2016.74163575%20-22.73022461%2015.4206543%20C-21.84707315%2013.93081082%20-20.92759767%2012.46258424%20-20%2011%20C-19.67%2011%20-19.34%2011%20-19%2011%20C-18.42630491%2017.90759896%20-19.9080813%2021.56829125%20-23.625%2027.3125%20C-24.54685153%2028.80389793%20-25.46742564%2030.29608621%20-26.38671875%2031.7890625%20C-26.8357959%2032.50739258%20-27.28487305%2033.22572266%20-27.74755859%2033.96582031%20C-31.52316681%2040.09805573%20-34.85042862%2046.52588104%20-38%2053%20C-37.67%2053.33%20-37.34%2053.66%20-37%2054%20C-32.70069084%2050.10375108%20-29.46085754%2045.66677891%20-26.10546875%2040.9453125%20C-24.76151668%2039.06527565%20-23.3913937%2037.20349389%20-21.98828125%2035.3671875%20C-15.35850944%2026.64037588%20-10.46192953%2017.17810246%20-5.75%207.3125%20C-4.12504228%204.23668718%20-2.62415539%202.24927605%200%200%20Z%20%22%20fill%3D%22%232C2C2C%22%20transform%3D%22translate(674%2C529)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.47981857%20-0.01058945%201.47981857%20-0.01058945%202.98953247%20-0.02139282%20C43.74789262%20-0.24691352%2043.74789262%20-0.24691352%2061.3671875%203.203125%20C62.47320312%203.41243652%2063.57921875%203.62174805%2064.71875%203.83740234%20C132.81352715%2016.93897099%20198.28215198%2051.77158721%20241.3671875%20107.203125%20C242.90599137%20109.05966824%20244.44770872%20110.91380011%20245.9921875%20112.765625%20C250.05704348%20117.75399387%20253.81432453%20122.83886142%20257.3671875%20128.203125%20C257.77775391%20128.81526855%20258.18832031%20129.42741211%20258.61132812%20130.05810547%20C273.25456882%20152.01772931%20284.61607775%20175.3220376%20293.3671875%20200.203125%20C293.66898926%20201.03900146%20293.97079102%20201.87487793%20294.28173828%20202.73608398%20C295.74331206%20206.89858025%20296.71449161%20210.56835709%20296.8671875%20215.015625%20C297.04785714%20220.23246088%20298.25627206%20224.96489026%20299.54736328%20229.99536133%20C305.16237495%20251.96547398%20305.82248993%20273.53882367%20305.7421875%20296.078125%20C305.74014187%20296.76350719%20305.73809624%20297.44888939%20305.73598862%20298.15504074%20C305.7205019%20302.79365822%20305.68629179%20307.43187676%20305.640625%20312.0703125%20C305.62451424%20313.85470985%20305.62451424%20313.85470985%20305.608078%20315.67515564%20C305.36594682%20332.81199595%20305.36594682%20332.81199595%20302.6171875%20336.640625%20C300.3671875%20338.203125%20300.3671875%20338.203125%20297.9921875%20339.140625%20C295.11225849%20340.14994567%20295.11225849%20340.14994567%20292.3046875%20342.765625%20C289.59418181%20345.01476802%20288.62389226%20345.57979871%20285.3671875%20346.203125%20C285.22023438%20347.11449219%20285.07328125%20348.02585937%20284.921875%20348.96484375%20C282.72831892%20361.6345211%20279.43392815%20374.00290304%20275.3671875%20386.203125%20C274.7071875%20386.203125%20274.0471875%20386.203125%20273.3671875%20386.203125%20C273.2846875%20387.316875%20273.2021875%20388.430625%20273.1171875%20389.578125%20C272.48799724%20394.8182469%20270.48087879%20399.40553734%20268.3671875%20404.203125%20C267.15179092%20400.55693526%20267.70731493%20399.74433232%20269.1171875%20396.265625%20C271.06463699%20391.20225632%20272.45232676%20386.15922013%20273.70703125%20380.88671875%20C274.43428645%20377.93036181%20275.3332248%20375.06640634%20276.3671875%20372.203125%20C277.0271875%20372.203125%20277.6871875%20372.203125%20278.3671875%20372.203125%20C278.41617187%20371.40390625%20278.46515625%20370.6046875%20278.515625%20369.78125%20C278.75598169%20366.25049313%20279.05526262%20362.72825198%20279.3671875%20359.203125%20C279.48126953%20357.57503906%20279.48126953%20357.57503906%20279.59765625%20355.9140625%20C280.19606445%20350.35238632%20280.954837%20346.92178598%20285.1796875%20343.078125%20C288.09922362%20340.90164771%20290.85412338%20339.24754947%20294.3671875%20338.203125%20C295.2953125%20337.831875%20296.2234375%20337.460625%20297.1796875%20337.078125%20C298.2625%20336.645%20298.2625%20336.645%20299.3671875%20336.203125%20C299.3465625%20335.254375%20299.3259375%20334.305625%20299.3046875%20333.328125%20C299.3046875%20329.5337073%20299.66476723%20325.82107335%20300.06884766%20322.05102539%20C302.13833292%20302.29607811%20302.39809913%20282.24622734%20299.68798828%20262.54101562%20C299.34052923%20260.0088483%20299.0238228%20257.47367687%20298.70703125%20254.9375%20C297.49419603%20245.55874845%20295.86379259%20236.54393017%20293.41015625%20227.40625%20C291.85328103%20221.41352766%20290.82795698%20215.30276155%20289.76196289%20209.20703125%20C289.60848389%20208.35496094%20289.45500488%20207.50289062%20289.296875%20206.625%20C289.16522949%20205.86799805%20289.03358398%20205.11099609%20288.89794922%20204.33105469%20C288.33444808%20202.07186614%20287.43411059%20200.26474543%20286.3671875%20198.203125%20C285.99050406%20196.54571785%20285.64661205%20194.87967229%20285.3671875%20193.203125%20C285.0371875%20193.203125%20284.7071875%20193.203125%20284.3671875%20193.203125%20C283.88758972%20190.97405105%20283.4085267%20188.74486203%20282.9296875%20186.515625%20C282.52943359%20184.65357422%20282.52943359%20184.65357422%20282.12109375%20182.75390625%20C281.51663614%20179.90700485%20280.92954066%20177.05856874%20280.3671875%20174.203125%20C279.7071875%20174.203125%20279.0471875%20174.203125%20278.3671875%20174.203125%20C278.1405542%20173.67356201%20277.9139209%20173.14399902%20277.68041992%20172.59838867%20C276.64588139%20170.19255257%20275.60042653%20167.79161251%20274.5546875%20165.390625%20C274.19826172%20164.55724609%20273.84183594%20163.72386719%20273.47460938%20162.86523438%20C272.94770508%20161.66157227%20272.94770508%20161.66157227%20272.41015625%20160.43359375%20C271.93098755%20159.32600708%20271.93098755%20159.32600708%20271.44213867%20158.19604492%20C270.31826308%20156.11242092%20269.06302297%20154.83316036%20267.3671875%20153.203125%20C266.31343933%20151.2520444%20265.31804547%20149.26886483%20264.3671875%20147.265625%20C262.61736191%20143.58825717%20260.80672185%20140.44857695%20258.3671875%20137.203125%20C258.3671875%20136.543125%20258.3671875%20135.883125%20258.3671875%20135.203125%20C257.7071875%20135.203125%20257.0471875%20135.203125%20256.3671875%20135.203125%20C256.3671875%20134.213125%20256.3671875%20133.223125%20256.3671875%20132.203125%20C255.7071875%20132.203125%20255.0471875%20132.203125%20254.3671875%20132.203125%20C254.0371875%20130.553125%20253.7071875%20128.903125%20253.3671875%20127.203125%20C252.0471875%20127.533125%20250.7271875%20127.863125%20249.3671875%20128.203125%20C249.3671875%20127.543125%20249.3671875%20126.883125%20249.3671875%20126.203125%20C247.3871875%20126.863125%20245.4071875%20127.523125%20243.3671875%20128.203125%20C243.0371875%20127.873125%20242.7071875%20127.543125%20242.3671875%20127.203125%20C241.2534375%20127.88375%20240.1396875%20128.564375%20238.9921875%20129.265625%20C237.09375%20130.42578125%20237.09375%20130.42578125%20235.3671875%20131.203125%20C234.7071875%20130.873125%20234.0471875%20130.543125%20233.3671875%20130.203125%20C234.0271875%20129.543125%20234.6871875%20128.883125%20235.3671875%20128.203125%20C236.29794876%20121.68779621%20233.95801661%20117.41625707%20230.3671875%20112.203125%20C228.01305984%20109.59897786%20228.01305984%20109.59897786%20225.3671875%20107.203125%20C224.27455229%20105.94028029%20223.19207896%20104.66860655%20222.1171875%20103.390625%20C218.83041914%2099.58715943%20215.23423395%2096.31008296%20211.44140625%2093.01953125%20C208.20341918%2090.18400585%20205.23891955%2087.10049623%20202.2421875%2084.015625%20C200.29677032%2082.02656274%20200.29677032%2082.02656274%20197.3671875%2080.203125%20C197.3671875%2079.543125%20197.3671875%2078.883125%20197.3671875%2078.203125%20C196.6040625%2077.935%20195.8409375%2077.666875%20195.0546875%2077.390625%20C192.47730132%2076.25177995%20191.09763886%2075.38895829%20189.3671875%2073.203125%20C189.3671875%2072.543125%20189.3671875%2071.883125%20189.3671875%2071.203125%20C188.7071875%2071.203125%20188.0471875%2071.203125%20187.3671875%2071.203125%20C187.3671875%2070.543125%20187.3671875%2069.883125%20187.3671875%2069.203125%20C185.7171875%2068.873125%20184.0671875%2068.543125%20182.3671875%2068.203125%20C182.3671875%2067.543125%20182.3671875%2066.883125%20182.3671875%2066.203125%20C181.7071875%2065.873125%20181.0471875%2065.543125%20180.3671875%2065.203125%20C180.6971875%2064.873125%20181.0271875%2064.543125%20181.3671875%2064.203125%20C178.3971875%2063.213125%20178.3971875%2063.213125%20175.3671875%2062.203125%20C175.6971875%2061.543125%20176.0271875%2060.883125%20176.3671875%2060.203125%20C173.7271875%2059.543125%20171.0871875%2058.883125%20168.3671875%2058.203125%20C168.3671875%2057.543125%20168.3671875%2056.883125%20168.3671875%2056.203125%20C170.0171875%2056.203125%20171.6671875%2056.203125%20173.3671875%2056.203125%20C170.7271875%2055.543125%20168.0871875%2054.883125%20165.3671875%2054.203125%20C165.3671875%2053.213125%20165.3671875%2052.223125%20165.3671875%2051.203125%20C163.3871875%2051.203125%20161.4071875%2051.203125%20159.3671875%2051.203125%20C159.0371875%2049.553125%20158.7071875%2047.903125%20158.3671875%2046.203125%20C155.0671875%2046.203125%20151.7671875%2046.203125%20148.3671875%2046.203125%20C148.3671875%2045.213125%20148.3671875%2044.223125%20148.3671875%2043.203125%20C150.0171875%2043.203125%20151.6671875%2043.203125%20153.3671875%2043.203125%20C151.56300038%2038.77294825%20149.00601602%2037.41600341%20144.8984375%2035.2421875%20C141.02815676%2033.65346115%20137.53179101%2033.40143945%20133.3671875%2033.203125%20C133.0371875%2031.553125%20132.7071875%2029.903125%20132.3671875%2028.203125%20C131.5421875%2028.120625%20130.7171875%2028.038125%20129.8671875%2027.953125%20C126.3671875%2027.203125%20126.3671875%2027.203125%20123.06640625%2025.46875%20C116.89355896%2022.30645975%20110.25523632%2020.34607472%20103.6796875%2018.203125%20C102.3806848%2017.77396554%20101.0818555%2017.34428088%2099.78320312%2016.9140625%20C95.98353105%2015.65910654%2092.17681892%2014.42754253%2088.3671875%2013.203125%20C87.17222656%2012.81842041%2085.97726562%2012.43371582%2084.74609375%2012.03735352%20C83.616875%2011.68084717%2082.48765625%2011.32434082%2081.32421875%2010.95703125%20C80.33268799%2010.6432251%2079.34115723%2010.32941895%2078.31958008%2010.00610352%20C74.00017531%208.83133114%2069.65860224%208.25454115%2065.22265625%207.703125%20C62.41420394%207.33890829%2059.64482509%206.92850992%2056.85546875%206.453125%20C56.06027832%206.31914307%2055.26508789%206.18516113%2054.44580078%206.04711914%20C52.93135667%205.78966055%2051.41785701%205.52652801%2049.90576172%205.25561523%20C33.94271569%202.59628089%2017.43663787%202.94923184%201.3046875%202.640625%20C-0.83399043%202.59730302%20-2.97266238%202.55368509%20-5.11132812%202.50976562%20C-10.28509391%202.40414932%20-15.45892335%202.30250611%20-20.6328125%202.203125%20C-20.6328125%201.873125%20-20.6328125%201.543125%20-20.6328125%201.203125%20C-13.73896553%200.39879839%20-6.93832427%200.03311216%200%200%20Z%20%22%20fill%3D%22%23281201%22%20transform%3D%22translate(407.6328125%2C124.796875)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-3.39866721%203.82350061%20-7.43530459%206.71296575%20-12%209%20C-12.99%209%20-13.98%209%20-15%209%20C-16.89201175%2010.02117708%20-16.89201175%2010.02117708%20-18.8125%2011.375%20C-22.14450223%2013.54778105%20-25.22156648%2014.74052216%20-29%2016%20C-30.81048575%2017.10640796%20-32.61702305%2018.22025971%20-34.39453125%2019.37890625%20C-38.5355849%2021.95542389%20-42.82150889%2024.27590893%20-47.10107422%2026.61352539%20C-55.31955959%2030.85940802%20-55.31955959%2030.85940802%20-61.375%2037.4375%20C-63.54961586%2040.86670194%20-66.32685472%2042.38218034%20-69.73046875%2044.515625%20C-71.71539082%2045.81385286%20-73.38260558%2047.15319649%20-75.125%2048.75%20C-78%2051%20-78%2051%20-81.75%2052.0625%20C-85.04431167%2052.6195557%20-85.04431167%2052.6195557%20-86.125%2054.8125%20C-86.41375%2055.534375%20-86.7025%2056.25625%20-87%2057%20C-91.53136026%2062.08061605%20-97.45455039%2067.81818346%20-104%2070%20C-104.28746094%2070.58652344%20-104.57492188%2071.17304688%20-104.87109375%2071.77734375%20C-106.39488176%2074.77746617%20-108.50863539%2076.38219646%20-111.0625%2078.5625%20C-116.70591851%2083.57805127%20-121.39709044%2089.00634779%20-126%2095%20C-126.58910156%2095.75796875%20-127.17820313%2096.5159375%20-127.78515625%2097.296875%20C-131.19645117%20101.75586491%20-134.21362231%20106.05255878%20-136.328125%20111.2890625%20C-137.82798982%20114.81592021%20-139.78223415%20117.7211051%20-142.0625%20120.8125%20C-151.32129081%20133.72739534%20-158.95448373%20148.31803191%20-165%20163%20C-165.33032227%20163.75676025%20-165.66064453%20164.51352051%20-166.00097656%20165.29321289%20C-167.12888749%20168.34921202%20-167.72292636%20171.28941804%20-168.296875%20174.49609375%20C-168.53043701%20175.76638428%20-168.76399902%20177.0366748%20-169.00463867%20178.34545898%20C-169.12600189%20179.01326385%20-169.24736511%20179.68106873%20-169.37240601%20180.36911011%20C-171.42255624%20191.599453%20-173.78103328%20202.61114048%20-176.95336914%20213.58740234%20C-178.86893321%20220.26989888%20-180.20238006%20226.91747071%20-181.26171875%20233.78515625%20C-182.01874828%20237.08163935%20-182.98121023%20239.29635497%20-185%20242%20C-185.66%20242%20-186.32%20242%20-187%20242%20C-182.64586449%20208.33509861%20-175.15432385%20176.55750867%20-160%20146%20C-159.6297168%20145.2378418%20-159.25943359%20144.47568359%20-158.87792969%20143.69042969%20C-152.05451709%20129.73264933%20-143.66598816%20116.87394194%20-135%20104%20C-139.39253773%20102.43727811%20-139.39253773%20102.43727811%20-144%20102%20C-148.77178021%20106.32923608%20-152.32296455%20111.15919539%20-155%20117%20C-155.88212164%20118.32739473%20-156.78288134%20119.64247289%20-157.6953125%20120.94921875%20C-161.33084985%20126.3462488%20-164.29093638%20132.02448234%20-167.25%20137.8125%20C-167.77851563%20138.83537109%20-168.30703125%20139.85824219%20-168.8515625%20140.91210938%20C-170.92482522%20144.92971366%20-172.98494932%20148.95285182%20-175%20153%20C-176%20150%20-176%20150%20-175.27832031%20147.92553711%20C-174.88225586%20147.1341333%20-174.48619141%20146.34272949%20-174.078125%20145.52734375%20C-173.4140564%20144.19159302%20-173.4140564%20144.19159302%20-172.73657227%20142.82885742%20C-172.24600342%20141.87470947%20-171.75543457%20140.92056152%20-171.25%20139.9375%20C-170.74847412%20138.95177002%20-170.24694824%20137.96604004%20-169.73022461%20136.95043945%20C-159.5932786%20117.29911655%20-147.34880314%2098.8327136%20-133%2082%20C-132.08911364%2080.90425236%20-131.1789992%2079.8078627%20-130.26953125%2078.7109375%20C-120.74409821%2067.30976614%20-110.46220556%2056.47912502%20-99%2047%20C-97.93488244%2046.08595311%20-96.8697798%2045.17188883%20-95.8046875%2044.2578125%20C-76.30706687%2027.75624344%20-54.47709168%2014.37383114%20-31.5%203.3125%20C-30.77498291%202.96058594%20-30.04996582%202.60867187%20-29.30297852%202.24609375%20C-27.56400419%201.43299043%20-25.78456678%200.70745326%20-24%200%20C-23.01%200.495%20-23.01%200.495%20-22%201%20C-23.15113281%201.59425781%20-24.30226563%202.18851563%20-25.48828125%202.80078125%20C-48.39178415%2014.68633177%20-48.39178415%2014.68633177%20-69.8137207%2029.00390625%20C-73.81524379%2032%20-73.81524379%2032%20-76%2032%20C-76%2032.66%20-76%2033.32%20-76%2034%20C-75.12988281%2033.51080078%20-75.12988281%2033.51080078%20-74.2421875%2033.01171875%20C-69.87452784%2030.56842399%20-65.49738836%2028.1987232%20-61%2026%20C-59.39125%2025.1646875%20-59.39125%2025.1646875%20-57.75%2024.3125%20C-55%2023%20-55%2023%20-53%2023%20C-52.67%2022.01%20-52.34%2021.02%20-52%2020%20C-49.72360408%2018.51158728%20-47.62753547%2017.90591893%20-44.984375%2017.23828125%20C-40.01679263%2015.83473596%20-35.49783153%2013.51253007%20-30.875%2011.25%20C-29.00801257%2010.34984534%20-27.1408253%209.45010505%20-25.2734375%208.55078125%20C-24.37206055%208.11459473%20-23.47068359%207.6784082%20-22.54199219%207.22900391%20C-19.20249417%205.6144214%20-15.85673279%204.01600935%20-12.5%202.4375%20C-11.5409375%201.98246094%20-10.581875%201.52742187%20-9.59375%201.05859375%20C-3.14593698%20-1.57296849%20-3.14593698%20-1.57296849%200%200%20Z%20%22%20fill%3D%22%23663208%22%20transform%3D%22translate(326%2C149)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C0.27832031%204.05273438%200.27832031%204.05273438%20-0.921875%206.59375%20C-1.36523193%207.53371826%20-1.80858887%208.47368652%20-2.26538086%209.44213867%20C-2.75530518%2010.45123291%20-3.24522949%2011.46032715%20-3.75%2012.5%20C-4.49358765%2014.04167847%20-4.49358765%2014.04167847%20-5.25219727%2015.61450195%20C-8.53974693%2022.31243736%20-12.05140391%2028.81824986%20-15.9375%2035.1875%20C-16.38512695%2035.92226563%20-16.83275391%2036.65703125%20-17.29394531%2037.4140625%20C-19.54078287%2040.99681176%20-21.72130155%2044.25948963%20-25%2047%20C-25.66%2047%20-26.32%2047%20-27%2047%20C-27.37125%2047.804375%20-27.37125%2047.804375%20-27.75%2048.625%20C-29.92475988%2052.75704377%20-32.34489748%2057.00946158%20-36%2060%20C-36.66%2060%20-37.32%2060%20-38%2060%20C-38.22945312%2060.71027344%20-38.45890625%2061.42054688%20-38.6953125%2062.15234375%20C-40.2683714%2065.58575674%20-42.29525008%2067.81051159%20-44.875%2070.5625%20C-45.73867188%2071.49191406%20-46.60234375%2072.42132812%20-47.4921875%2073.37890625%20C-48.73355469%2074.67634766%20-48.73355469%2074.67634766%20-50%2076%20C-50.72445312%2076.77214844%20-51.44890625%2077.54429687%20-52.1953125%2078.33984375%20C-54%2080%20-54%2080%20-56%2080%20C-56.20625%2080.5775%20-56.4125%2081.155%20-56.625%2081.75%20C-58%2084%20-58%2084%20-60.59518719%2085.66448593%20C-64.87284998%2088.43106168%20-68.2800651%2092.01369833%20-71.852005%2095.6182251%20C-72.62413383%2096.38935064%20-73.39626266%2097.16047618%20-74.19178933%2097.95496917%20C-76.77366608%20100.53589453%20-79.348332%20103.12389405%20-81.9230957%20105.71191406%20C-83.7741142%20107.56513405%20-85.62558111%20109.41790623%20-87.47746277%20111.27026367%20C-91.46173755%20115.25689686%20-95.44239361%20119.24711372%20-99.42064857%20123.23975372%20C-105.17308193%20129.01288934%20-110.93152733%20134.77999794%20-116.69154193%20140.54556844%20C-126.03807008%20149.90134492%20-135.38048881%20159.26121327%20-144.7199707%20168.62402344%20C-145.27855096%20169.18399701%20-145.83713122%20169.74397058%20-146.41263815%20170.32091305%20C-146.97194264%20170.88161307%20-147.53124714%20171.4423131%20-148.10750026%20172.02000403%20C-156.0479098%20179.98020649%20-163.98930572%20187.93942315%20-171.93188477%20195.89746094%20C-172.49129819%20196.45796521%20-173.05071161%20197.01846949%20-173.62707696%20197.59595874%20C-182.94027591%20206.9271536%20-192.25548825%20216.25633683%20-201.57173795%20225.58448577%20C-207.32015364%20231.34050605%20-213.06647948%20237.09859886%20-218.81014737%20242.85935685%20C-223.20259797%20247.2646976%20-227.59744583%20251.66763915%20-231.99318123%20256.06970215%20C-233.80132857%20257.88133653%20-235.60860294%20259.69384266%20-237.41496658%20261.50725555%20C-239.86868631%20263.97034435%20-242.32540008%20266.43040639%20-244.78291321%20268.88970947%20C-245.50740593%20269.61847927%20-246.23189865%20270.34724907%20-246.97834569%20271.09810281%20C-247.63151492%20271.75051438%20-248.28468414%20272.40292595%20-248.95764637%20273.07510757%20C-249.52511359%20273.64403866%20-250.09258081%20274.21296975%20-250.67724401%20274.79914117%20C-252%20276%20-252%20276%20-253%20276%20C-253.55146384%20272.92571926%20-253.56727964%20270.82202449%20-251.75706899%20268.19891346%20C-249.84095591%20266.08789965%20-247.84898505%20264.08873108%20-245.80705261%20262.09898376%20C-245.03329436%20261.3215101%20-244.25953611%20260.54403643%20-243.46233064%20259.74300295%20C-240.85765777%20257.13311738%20-238.23209829%20254.54530436%20-235.60620117%20251.95678711%20C-233.73785638%20250.09340735%20-231.8707415%20248.22886829%20-230.00511169%20246.36277771%20C-225.98117272%20242.34251498%20-221.94650524%20238.33328573%20-217.90447044%20234.33122063%20C-212.05611167%20228.54048516%20-206.22535048%20222.7322884%20-200.39892534%20216.91949422%20C-190.93991558%20207.48337815%20-181.46831709%20198.06000672%20-171.98803711%20188.64526367%20C-162.78864476%20179.50938546%20-153.59267866%20170.37009174%20-144.40307617%20161.22436523%20C-143.83724322%20160.66123943%20-143.27141027%20160.09811363%20-142.68843087%20159.51792341%20C-136.51090509%20153.36968084%20-130.33478271%20147.22003126%20-124.16033649%20141.06869602%20C-123.61760412%20140.52800041%20-123.07487174%20139.9873048%20-122.51569292%20139.43022447%20C-120.34600246%20137.26863799%20-118.17632764%20135.10703586%20-116.00683276%20132.94525308%20C-109.65529194%20126.61635962%20-103.29941518%20120.29189582%20-96.93561564%20113.97532762%20C-92.9434891%20110.01262159%20-88.95460412%20106.04667396%20-84.9682438%20102.07816737%20C-82.66776069%2099.78832077%20-80.3650261%2097.50081648%20-78.0589447%2095.21660614%20C-75.55933097%2092.74032229%20-73.06591033%2090.25796279%20-70.57389832%2087.77403259%20C-69.84335666%2087.05340934%20-69.11281501%2086.33278609%20-68.36013573%2085.59032577%20C-65.01875588%2082.24753544%20-62.25935921%2079.1966964%20-60%2075%20C-59.34%2074.34%20-58.68%2073.68%20-58%2073%20C-57.67%2072.175%20-57.34%2071.35%20-57%2070.5%20C-56%2068%20-56%2068%20-54%2066%20C-53.71125%2065.236875%20-53.4225%2064.47375%20-53.125%2063.6875%20C-50.63974715%2057.75050709%20-46.43209376%2054.6980349%20-41.21875%2051.234375%20C-38.53235223%2048.52905893%20-37.49239595%2045.92017403%20-36.05371094%2042.4296875%20C-34.33405553%2038.46443944%20-32.10035916%2034.8229262%20-29.875%2031.125%20C-29.43285156%2030.37992188%20-28.99070312%2029.63484375%20-28.53515625%2028.8671875%20C-26.74712403%2025.86372552%20-24.93959466%2022.90939199%20-23%2020%20C-22.34%2020%20-21.68%2020%20-21%2020%20C-20.67%2018.35%20-20.34%2016.7%20-20%2015%20C-19.19568413%2017.30227069%20-18.81680608%2018.52470479%20-19.70922852%2020.84008789%20C-20.28821899%2021.77195923%20-20.28821899%2021.77195923%20-20.87890625%2022.72265625%20C-21.30292725%2023.42092529%20-21.72694824%2024.11919434%20-22.16381836%2024.83862305%20C-22.6253833%2025.57250244%20-23.08694824%2026.30638184%20-23.5625%2027.0625%20C-24.49347303%2028.59036327%20-25.42316168%2030.11900988%20-26.3515625%2031.6484375%20C-26.80692383%2032.3919043%20-27.26228516%2033.13537109%20-27.73144531%2033.90136719%20C-31.46989881%2040.08607587%20-34.83905875%2046.50250965%20-38%2053%20C-37.67%2053.33%20-37.34%2053.66%20-37%2054%20C-32.70069084%2050.10375108%20-29.46085754%2045.66677891%20-26.10546875%2040.9453125%20C-24.76151668%2039.06527565%20-23.3913937%2037.20349389%20-21.98828125%2035.3671875%20C-15.35850944%2026.64037588%20-10.46192953%2017.17810246%20-5.75%207.3125%20C-4.12504228%204.23668718%20-2.62415539%202.24927605%200%200%20Z%20%22%20fill%3D%22%23434343%22%20transform%3D%22translate(674%2C529)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.3271261%203.9813783%201.06915913%207.85045227%201%2012%20C1.66%2012.33%202.32%2012.66%203%2013%20C3%2016.63%203%2020.26%203%2024%20C3.33%2020.37%203.66%2016.74%204%2013%20C6.48769646%2016.73154469%206.27165211%2019.61354397%206.23046875%2023.9296875%20C6.23001053%2024.71586456%206.22955231%2025.50204163%206.2290802%2026.31204224%20C6.22605746%2027.98148094%206.2181705%2029.65091681%206.20581055%2031.3203125%20C6.18781655%2033.8308353%206.18529928%2036.34098261%206.18554688%2038.8515625%20C6.13449916%2064.70610866%206.13449916%2064.70610866%202%2070%20C1.34507223%2072.2181868%201.34507223%2072.2181868%201.0859375%2074.58984375%20C0.90417969%2075.89018555%200.90417969%2075.89018555%200.71875%2077.21679688%20C0.6053125%2078.11462891%200.491875%2079.01246094%200.375%2079.9375%20C0.1337214%2081.71757135%20-0.1084393%2083.4975234%20-0.3515625%2085.27734375%20C-0.4640332%2086.10347168%20-0.57650391%2086.92959961%20-0.69238281%2087.78076172%20C-1.38955479%2092.81035959%20-1.38955479%2092.81035959%20-2%2095%20C-2.99%2095.495%20-2.99%2095.495%20-4%2096%20C-4.54653131%2098.24455389%20-4.54653131%2098.24455389%20-4.875%20100.9375%20C-5.67653122%20105.82242257%20-7.04069561%20109.97992091%20-8.9921875%20114.51171875%20C-10.3479845%20117.85917102%20-11.27624991%20121.28333817%20-12.19140625%20124.7734375%20C-13.10407565%20127.28658514%20-14.2171907%20129.01305223%20-16%20131%20C-16.66%20131%20-17.32%20131%20-18%20131%20C-18.37898437%20131.99773437%20-18.37898437%20131.99773437%20-18.765625%20133.015625%20C-22.82565877%20142.83165602%20-27.73038898%20152.41641782%20-34%20161%20C-34.65097656%20161.90363281%20-35.30195312%20162.80726563%20-35.97265625%20163.73828125%20C-37.34747181%20165.63732555%20-38.73009295%20167.53074755%20-40.12109375%20169.41796875%20C-41.68020433%20171.56053028%20-43.15688296%20173.73296413%20-44.625%20175.9375%20C-47.22710693%20179.29284842%20-49.3747374%20180.89228919%20-53%20183%20C-51.40146817%20173.01366631%20-44.89521114%20164.006148%20-39.75976562%20155.45605469%20C-36.29814208%20149.64565933%20-33.3106558%20143.69871525%20-30.47265625%20137.5625%20C-29%20135%20-29%20135%20-26%20134%20C-25.1456164%20132.07503362%20-25.1456164%20132.07503362%20-24.625%20129.6875%20C-23.22444628%20124.53493657%20-21.30443573%20119.75606723%20-19.20703125%20114.8515625%20C-17.69155464%20111.2713103%20-16.33407306%20107.65114733%20-15%20104%20C-14.34%20104%20-13.68%20104%20-13%20104%20C-12.814375%20102.6696875%20-12.814375%20102.6696875%20-12.625%20101.3125%20C-12%2098%20-12%2098%20-11.09375%2095.90625%20C-9.53484024%2091.76400408%20-8.74709515%2087.51890591%20-7.875%2083.1875%20C-7.69324219%2082.30384766%20-7.51148438%2081.42019531%20-7.32421875%2080.50976562%20C-6.87867164%2078.34065469%20-6.43740023%2076.17076577%20-6%2074%20C-7.65%2073.67%20-9.3%2073.34%20-11%2073%20C-10.85377197%2072.04859131%20-10.70754395%2071.09718262%20-10.55688477%2070.11694336%20C-10.00447013%2066.51144655%20-9.46046153%2062.90471915%20-8.91870117%2059.29760742%20C-8.68523627%2057.75072245%20-8.44963585%2056.20415794%20-8.21166992%2054.65795898%20C-6.34648687%2042.52441091%20-4.73362857%2030.43357544%20-5.125%2018.125%20C-5.20512347%2011.40464375%20-3.0367836%205.90192291%200%200%20Z%20%22%20fill%3D%22%23A6A6A6%22%20transform%3D%22translate(688%2C402)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.495%200.99%200.495%202%201%20C-1.39635165%205.9036083%20-4.80863553%2010.7974534%20-8.3125%2015.625%20C-8.78300781%2016.27726563%20-9.25351562%2016.92953125%20-9.73828125%2017.6015625%20C-10.15464844%2018.06304688%20-10.57101562%2018.52453125%20-11%2019%20C-11.66%2019%20-12.32%2019%20-13%2019%20C-13.268125%2019.804375%20-13.53625%2020.60875%20-13.8125%2021.4375%20C-14.204375%2022.283125%20-14.59625%2023.12875%20-15%2024%20C-15.99%2024.33%20-16.98%2024.66%20-18%2025%20C-18.268125%2025.5775%20-18.53625%2026.155%20-18.8125%2026.75%20C-20.5763914%2030.09211003%20-22.98041507%2031.7353113%20-26%2034%20C-26.66%2034%20-27.32%2034%20-28%2034%20C-28.25789527%2034.5751919%20-28.51579054%2035.1503838%20-28.78150082%2035.74300575%20C-35.00387165%2047.26854091%20-47.89694891%2057.04520838%20-57.06420898%2066.20947266%20C-58.8949791%2068.04323841%20-60.72554515%2069.87720792%20-62.55592346%2071.71136475%20C-66.99087341%2076.15457074%20-71.42854988%2080.59504355%20-75.86734962%2085.03440328%20C-79.47290239%2088.64043286%20-83.07766104%2092.24725441%20-86.68187141%2095.8546257%20C-96.9090659%20106.09060672%20-107.13833353%20116.32450939%20-117.37029826%20126.55572207%20C-117.92026536%20127.10564922%20-118.47023246%20127.65557636%20-119.03686523%20128.22216797%20C-119.58750545%20128.7727673%20-120.13814566%20129.32336663%20-120.70547194%20129.89065079%20C-129.65730663%20138.84207779%20-138.60412416%20147.79850105%20-147.54871988%20156.75716098%20C-156.74128717%20165.96406825%20-165.93755345%20175.16726631%20-175.13772637%20184.36657369%20C-180.29991316%20189.52842808%20-185.46053916%20194.69182125%20-190.61718559%20199.85921097%20C-195.45612185%20204.70816489%20-200.3001548%20209.55197467%20-205.14775658%20214.39226532%20C-206.93055279%20216.17401002%20-208.7116238%20217.95748277%20-210.49088669%20219.74275589%20C-212.90895091%20222.16846229%20-215.33301125%20224.5880078%20-217.7587738%20227.00601196%20C-218.47052543%20227.72290715%20-219.18227705%20228.43980233%20-219.9155969%20229.17842162%20C-220.88511198%20230.1410385%20-220.88511198%20230.1410385%20-221.87421322%20231.12310219%20C-222.71329185%20231.96250688%20-222.71329185%20231.96250688%20-223.56932157%20232.81886923%20C-225%20234%20-225%20234%20-227%20234%20C-227%20229.05%20-227%20224.1%20-227%20219%20C-226.67%20219%20-226.34%20219%20-226%20219%20C-225.67%20221.97%20-225.34%20224.94%20-225%20228%20C-224.02539983%20227.02355624%20-223.05079966%20226.04711248%20-222.04666615%20225.04107952%20C-198.91690664%20201.86801423%20-175.78198829%20178.70011221%20-152.64069529%20155.53856463%20C-149.79305893%20152.68842682%20-146.94546618%20149.83824543%20-144.09790039%20146.98803711%20C-143.53099514%20146.42060723%20-142.96408988%20145.85317736%20-142.38000568%20145.26855264%20C-133.19812308%20136.07796493%20-124.01977947%20126.88385075%20-114.84273646%20117.68843087%20C-105.42776215%20108.25476049%20-96.00900031%2098.8248842%20-86.58670396%2089.39852697%20C-80.77170796%2083.58078531%20-74.95969447%2077.7600965%20-69.15144857%2071.93561564%20C-65.16946592%2067.94306973%20-61.18381376%2063.95421164%20-57.19524655%2059.9682438%20C-54.89339323%2057.66767279%20-52.59375357%2055.36496304%20-50.29735565%2053.0589447%20C-47.80762498%2050.55929414%20-45.31183486%2048.06585541%20-42.81440735%2045.57389832%20C-42.08969138%2044.84335666%20-41.36497541%2044.11281501%20-40.61829835%2043.36013573%20C-37.26250569%2040.02423453%20-34.19396461%2037.27110163%20-30%2035%20C-29.278125%2034.278125%20-28.55625%2033.55625%20-27.8125%2032.8125%20C-27.214375%2032.214375%20-26.61625%2031.61625%20-26%2031%20C-25.34%2031%20-24.68%2031%20-24%2031%20C-23.65388672%2030.19369141%20-23.65388672%2030.19369141%20-23.30078125%2029.37109375%20C-21.61466394%2026.29760064%20-19.44388073%2023.72429818%20-17.1875%2021.0625%20C-16.76146484%2020.55009766%20-16.33542969%2020.03769531%20-15.89648438%2019.50976562%20C-13.82636852%2017.04504372%20-11.70797361%2014.71238489%20-9.4140625%2012.453125%20C-7.00585848%2010.00595328%20-5.11546123%207.5227371%20-3.1875%204.6875%20C-2.58292969%203.80449219%20-1.97835937%202.92148437%20-1.35546875%202.01171875%20C-0.90816406%201.34785156%20-0.46085938%200.68398438%200%200%20Z%20%22%20fill%3D%22%23202020%22%20transform%3D%22translate(647%2C576)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.8125%201.5%201.8125%201.5%203%203%20C3%203.66%203%204.32%203%205%20C3.55816406%205.08636719%204.11632812%205.17273438%204.69140625%205.26171875%20C7.68792262%206.21999556%209.52171096%207.80616673%2011.9375%209.8125%20C12.77152344%2010.49957031%2013.60554687%2011.18664062%2014.46484375%2011.89453125%20C15.30144531%2012.58933594%2016.13804687%2013.28414062%2017%2014%20C20.17688918%2016.8605121%2020.17688918%2016.8605121%2024%2018.4375%20C27.1349991%2019.3192185%2028.74735613%2021.69542197%2031%2024%20C36.34501405%2028.97448948%2041.74740177%2033.88724178%2047.3671875%2038.55078125%20C49.6784106%2040.60212998%2051.82332418%2042.80698277%2054%2045%20C54.77859375%2045.75539062%2055.5571875%2046.51078125%2056.359375%2047.2890625%20C62.39432481%2053.1859579%2067.75191752%2059.4024106%2073%2066%20C73.78375%2066.928125%2074.5675%2067.85625%2075.375%2068.8125%20C76.1175%2069.699375%2076.86%2070.58625%2077.625%2071.5%20C78.29789063%2072.2940625%2078.97078125%2073.088125%2079.6640625%2073.90625%20C80.10492187%2074.5971875%2080.54578125%2075.288125%2081%2076%20C80%2079%2080%2079%2077.890625%2080.31640625%20C77.01921875%2080.72761719%2076.1478125%2081.13882813%2075.25%2081.5625%20C74.38890625%2081.97628906%2073.5278125%2082.39007813%2072.640625%2082.81640625%20C70.11729029%2083.94742758%2067.57571207%2084.99473108%2065%2086%20C65.99%2084.515%2065.99%2084.515%2067%2083%20C67.91312777%2076.47765877%2065.59803156%2072.22358851%2062%2067%20C59.64587234%2064.39585286%2059.64587234%2064.39585286%2057%2062%20C55.90736479%2060.73715529%2054.82489146%2059.46548155%2053.75%2058.1875%20C50.46323164%2054.38403443%2046.86704645%2051.10695796%2043.07421875%2047.81640625%20C39.83623168%2044.98088085%2036.87173205%2041.89737123%2033.875%2038.8125%20C31.92958282%2036.82343774%2031.92958282%2036.82343774%2029%2035%20C29%2034.34%2029%2033.68%2029%2033%20C28.236875%2032.731875%2027.47375%2032.46375%2026.6875%2032.1875%20C24.11011382%2031.04865495%2022.73045136%2030.18583329%2021%2028%20C21%2027.34%2021%2026.68%2021%2026%20C20.34%2026%2019.68%2026%2019%2026%20C19%2025.34%2019%2024.68%2019%2024%20C17.35%2023.67%2015.7%2023.34%2014%2023%20C14%2022.34%2014%2021.68%2014%2021%20C13.34%2020.67%2012.68%2020.34%2012%2020%20C12.495%2019.505%2012.495%2019.505%2013%2019%20C11.02%2018.34%209.04%2017.68%207%2017%20C7.33%2016.34%207.66%2015.68%208%2015%20C5.36%2014.34%202.72%2013.68%200%2013%20C0%2012.34%200%2011.68%200%2011%20C1.65%2011%203.3%2011%205%2011%20C2.36%2010.34%20-0.28%209.68%20-3%209%20C-3%208.01%20-3%207.02%20-3%206%20C-4.98%206%20-6.96%206%20-9%206%20C-9.33%204.35%20-9.66%202.7%20-10%201%20C-13.3%201%20-16.6%201%20-20%201%20C-20%200.01%20-20%20-0.98%20-20%20-2%20C-13.75510634%20-3.8734681%20-5.73272581%20-3.12694135%200%200%20Z%20%22%20fill%3D%22%237C3A05%22%20transform%3D%22translate(576%2C170)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.71193291%200.00068733%201.71193291%200.00068733%203.45845032%200.00138855%20C5.85764616%200.00438914%208.25684044%200.01220886%2010.65600586%200.0246582%20C14.27399836%200.0428342%2017.89173231%200.04516785%2021.50976562%200.04492188%20C52.89211127%200.09210932%2052.89211127%200.09210932%2064.61328125%202.23046875%20C64.61328125%202.89046875%2064.61328125%203.55046875%2064.61328125%204.23046875%20C63.60208725%204.23926811%2063.60208725%204.23926811%2062.57046509%204.24824524%20C55.46306057%204.3128906%2048.3560796%204.39747932%2041.24902344%204.49291992%20C38.60738743%204.52741965%2035.96601977%204.55399946%2033.32421875%204.5769043%20C18.42504023%204.70952956%204.2275587%205.31622285%20-10.38671875%208.23046875%20C-13.54744016%208.66719294%20-16.70989424%208.99939061%20-19.88671875%209.29296875%20C-29.70805505%2010.21485998%20-38.92329265%2012.25654748%20-48.32421875%2015.23046875%20C-54.56042384%2017.16427397%20-60.61704179%2018.74429789%20-67.078125%2019.7421875%20C-70.35583656%2020.43544291%20-73.18719116%2021.76900379%20-76.19140625%2023.22265625%20C-79.1300648%2024.57172014%20-82.15119501%2025.49913667%20-85.24609375%2026.421875%20C-87.47264542%2027.19009472%20-87.47264542%2027.19009472%20-89.65698242%2028.59375%20C-92.45275472%2030.27006317%20-95.29433314%2031.75580918%20-98.203125%2033.2265625%20C-99.29689453%2033.78537109%20-100.39066406%2034.34417969%20-101.51757812%2034.91992188%20C-103.80686494%2036.08606399%20-106.09854435%2037.24752091%20-108.39257812%2038.40429688%20C-109.48505859%2038.96439453%20-110.57753906%2039.52449219%20-111.703125%2040.1015625%20C-112.69771729%2040.6061499%20-113.69230957%2041.1107373%20-114.71704102%2041.63061523%20C-117.3944471%2043.2351001%20-119.24080534%2044.98654699%20-121.38671875%2047.23046875%20C-123.02706068%2047.95950961%20-124.69973793%2048.61702118%20-126.38671875%2049.23046875%20C-130.01951602%2050.90547108%20-133.50261329%2052.56141597%20-136.69921875%2054.98046875%20C-138.38671875%2056.23046875%20-138.38671875%2056.23046875%20-141.38671875%2056.23046875%20C-141.38671875%2055.57046875%20-141.38671875%2054.91046875%20-141.38671875%2054.23046875%20C-139.74462891%2052.87695312%20-139.74462891%2052.87695312%20-137.42578125%2051.32421875%20C-136.57056885%2050.75002197%20-135.71535645%2050.1758252%20-134.83422852%2049.58422852%20C-133.90280029%2048.97248779%20-132.97137207%2048.36074707%20-132.01171875%2047.73046875%20C-130.58653931%2046.78868774%20-130.58653931%2046.78868774%20-129.13256836%2045.82788086%20C-116.93765654%2037.86089079%20-104.25481555%2030.9606622%20-91.109375%2024.703125%20C-88.44505078%2023.45175815%20-88.44505078%2023.45175815%20-87.03710938%2021.76879883%20C-84.93260545%2019.80718948%20-82.96244611%2019.11632704%20-80.2578125%2018.14453125%20C-79.23179932%2017.77352295%20-78.20578613%2017.40251465%20-77.14868164%2017.02026367%20C-75.50307251%2016.44369019%20-75.50307251%2016.44369019%20-73.82421875%2015.85546875%20C-72.69685303%2015.45626221%20-71.5694873%2015.05705566%20-70.40795898%2014.64575195%20C-48.02063681%206.82267874%20-23.85074445%20-0.16078141%200%200%20Z%20%22%20fill%3D%22%23966E4D%22%20transform%3D%22translate(391.38671875%2C126.76953125)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-0.33%200.66%20-0.66%201.32%20-1%202%20C-1.66%202%20-2.32%202%20-3%202%20C-3.30744141%202.93779297%20-3.30744141%202.93779297%20-3.62109375%203.89453125%20C-5.60811654%206.92854056%20-7.57631886%206.91687048%20-11.0625%207.6875%20C-17.57116717%209.45866385%20-20.83959056%2012.12879552%20-25.09765625%2017.26953125%20C-26.03931641%2018.12611328%20-26.03931641%2018.12611328%20-27%2019%20C-29.109375%2018.65625%20-29.109375%2018.65625%20-31%2018%20C-32.68996005%2019.30368347%20-34.35135455%2020.64444707%20-36%2022%20C-38.09962967%2023.04981484%20-40.23999553%2023.9499689%20-42.40234375%2024.86328125%20C-46.4214103%2026.6220006%20-50.30293571%2028.64575186%20-54.21484375%2030.62890625%20C-56.3324393%2031.67136914%20-58.50117993%2032.61064946%20-60.6875%2033.5%20C-65.72398793%2035.78067378%20-70.72954513%2038.71340446%20-74.6484375%2042.66015625%20C-76%2044%20-76%2044%20-77.875%2044.4375%20C-80.86740296%2045.22960667%20-82.63255835%2047.03675571%20-85%2049%20C-85.76183594%2049.45375%20-86.52367187%2049.9075%20-87.30859375%2050.375%20C-102.07217206%2059.2888586%20-116.35814309%2071.59262704%20-128.06640625%2084.23046875%20C-130%2086%20-130%2086%20-132.3203125%2086.80859375%20C-136.41374609%2088.62856058%20-138.90736304%2091.77294581%20-141.875%2095.0625%20C-142.80372925%2096.07207764%20-142.80372925%2096.07207764%20-143.7512207%2097.10205078%20C-147.64511869%20101.37482837%20-151.31886196%20105.74214323%20-154.66796875%20110.4609375%20C-156%20112%20-156%20112%20-159%20113%20C-155.89219226%20104.02900859%20-148.07433253%2096.97746986%20-141.75%2090.0625%20C-141.25516113%2089.51916016%20-140.76032227%2088.97582031%20-140.25048828%2088.41601562%20C-137.3613545%2085.29881788%20-134.35672143%2082.59930736%20-131%2080%20C-129.8553125%2078.824375%20-129.8553125%2078.824375%20-128.6875%2077.625%20C-126.51144353%2075.49954949%20-124.43931103%2073.78486173%20-122%2072%20C-117.69187446%2068.83963023%20-114.13560574%2065.22077617%20-110.5%2061.3125%20C-108%2059%20-108%2059%20-105.7265625%2058.1328125%20C-102.3444344%2056.72763034%20-99.78384639%2054.78240909%20-96.875%2052.5625%20C-95.84117187%2051.78003906%20-94.80734375%2050.99757812%20-93.7421875%2050.19140625%20C-90.79760762%2047.83825908%20-88.35062014%2045.37725736%20-85.7890625%2042.62109375%20C-82.54998395%2039.57708576%20-79.16136009%2037.35960946%20-75.375%2035.0625%20C-74.67076904%2034.629375%20-73.96653809%2034.19625%20-73.2409668%2033.75%20C-59.60254074%2025.42308763%20-59.60254074%2025.42308763%20-53.48828125%2023.0078125%20C-50.157633%2021.65882153%20-47.17481789%2019.84724742%20-44.0859375%2018.0234375%20C-42%2017%20-42%2017%20-39%2017%20C-36.77275128%2015.72011641%20-36.77275128%2015.72011641%20-34.5%2014.0625%20C-31.9142008%2012.23951157%20-30.02125069%2011.00708356%20-27%2010%20C-27.33%209.34%20-27.66%208.68%20-28%208%20C-34.50062114%2010.0230027%20-40.68185046%2012.49210622%20-46.875%2015.3125%20C-47.74833984%2015.70550293%20-48.62167969%2016.09850586%20-49.52148438%2016.50341797%20C-55.18287452%2019.08050802%20-60.60108395%2021.84611969%20-65.90625%2025.1015625%20C-68.44195733%2026.18964587%20-69.42488547%2025.76621093%20-72%2025%20C-66.43423886%2022.05599176%20-60.86296181%2019.1227429%20-55.28564453%2016.20068359%20C-53.49806192%2015.26163945%20-51.71494561%2014.31409199%20-49.93359375%2013.36328125%20C-44.66632402%2010.61249953%20-39.34068782%208.65443488%20-33.6640625%206.89453125%20C-31.05951823%206.1005799%20-31.05951823%206.1005799%20-29.01953125%204.94921875%20C-26.39783881%203.71697259%20-23.92607322%203.40443909%20-21.0625%203%20C-17.05254193%202.43221833%20-13.73587344%201.53722006%20-10%200%20C-2.92993631%20-1.46496815%20-2.92993631%20-1.46496815%200%200%20Z%20M-17%204%20C-17.33%204.66%20-17.66%205.32%20-18%206%20C-17.34%206%20-16.68%206%20-16%206%20C-16.33%205.34%20-16.66%204.68%20-17%204%20Z%20M-22%208%20C-22.33%208.66%20-22.66%209.32%20-23%2010%20C-22.01%209.67%20-21.02%209.34%20-20%209%20C-20.66%208.67%20-21.32%208.34%20-22%208%20Z%20%22%20fill%3D%22%238A430A%22%20transform%3D%22translate(352%2C141)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.53398049%203.07455689%203.96293359%206.04527132%205.375%209.76171875%20C5.80296875%2010.88126953%206.2309375%2012.00082031%206.671875%2013.15429688%20C7.32929687%2014.90323242%207.32929687%2014.90323242%208%2016.6875%20C8.65742187%2018.40743164%208.65742187%2018.40743164%209.328125%2020.16210938%20C15.97036396%2037.63800014%2015.97036396%2037.63800014%2017%2044.0625%20C17.73728059%2048.44992384%2018.5337924%2052.81864763%2019.375%2057.1875%20C19.61854916%2058.514148%2019.86108246%2059.84098275%2020.1027832%2061.16796875%20C20.70415541%2064.45593374%2021.35289069%2067.73073605%2022.02270508%2071.00537109%20C25.17329004%2087.15716879%2025.52549066%20102.99926207%2025.33294678%20119.40063477%20C25.30536337%20122.14843613%2025.29707323%20124.89615402%2025.28938007%20127.64407253%20C25.27937475%20130.96980202%2025.25918288%20134.29541336%2025.23828125%20137.62109375%20C25.23089432%20138.83365341%2025.22350739%20140.04621307%2025.21589661%20141.29551697%20C25.02185949%20158.57669571%2025.02185949%20158.57669571%2022.25%20162.4375%20C20%20164%2020%20164%2017.625%20164.9375%20C14.74507099%20165.94682067%2014.74507099%20165.94682067%2011.9375%20168.5625%20C9.22699431%20170.81164302%208.25670476%20171.37667371%205%20172%20C4.85304688%20172.91136719%204.70609375%20173.82273437%204.5546875%20174.76171875%20C2.36113142%20187.4313961%20-0.93325935%20199.79977804%20-5%20212%20C-5.66%20212%20-6.32%20212%20-7%20212%20C-7.0825%20213.11375%20-7.165%20214.2275%20-7.25%20215.375%20C-7.87919026%20220.6151219%20-9.88630871%20225.20241234%20-12%20230%20C-13.21539658%20226.35381026%20-12.65987257%20225.54120732%20-11.25%20222.0625%20C-9.30255051%20216.99913132%20-7.91486074%20211.95609513%20-6.66015625%20206.68359375%20C-5.93290105%20203.72723681%20-5.0339627%20200.86328134%20-4%20198%20C-3.34%20198%20-2.68%20198%20-2%20198%20C-1.95101562%20197.20078125%20-1.90203125%20196.4015625%20-1.8515625%20195.578125%20C-1.61120581%20192.04736813%20-1.31192488%20188.52512698%20-1%20185%20C-0.92394531%20183.91460937%20-0.84789062%20182.82921875%20-0.76953125%20181.7109375%20C-0.17112305%20176.14926132%200.5876495%20172.71866098%204.8125%20168.875%20C7.73203612%20166.69852271%2010.48693588%20165.04442447%2014%20164%20C15.3921875%20163.443125%2015.3921875%20163.443125%2016.8125%20162.875%20C17.8953125%20162.441875%2017.8953125%20162.441875%2019%20162%20C18.979375%20161.05125%2018.95875%20160.1025%2018.9375%20159.125%20C18.9375%20155.3305823%2019.29757973%20151.61794835%2019.70166016%20147.84790039%20C21.77114542%20128.09295311%2022.03091163%20108.04310234%2019.32080078%2088.33789062%20C18.97334173%2085.8057233%2018.6566353%2083.27055187%2018.33984375%2080.734375%20C17.12700853%2071.35562345%2015.49660509%2062.34080517%2013.04296875%2053.203125%20C11.48609353%2047.21040266%2010.46076948%2041.09963655%209.39477539%2035.00390625%20C9.24129639%2034.15183594%209.08781738%2033.29976563%208.9296875%2032.421875%20C8.79804199%2031.66487305%208.66639648%2030.90787109%208.53076172%2030.12792969%20C7.96726058%2027.86874114%207.06692309%2026.06162043%206%2024%20C5.62331656%2022.34259285%205.27942455%2020.67654729%205%2019%20C4.67%2019%204.34%2019%204%2019%20C3.52040222%2016.77092605%203.0413392%2014.54173703%202.5625%2012.3125%20C2.29566406%2011.07113281%202.02882813%209.82976562%201.75390625%208.55078125%20C1.14944864%205.70387985%200.56235316%202.85544374%200%200%20Z%20%22%20fill%3D%22%234E4E4E%22%20transform%3D%22translate(688%2C299)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C3.38065149%20-0.01623768%206.45097596%200.01447008%209.72642517%200.89242554%20C13.17274839%201.74966224%2016.51133406%202.24574862%2020.03892517%202.64242554%20C30.21758718%204.1392876%2039.90780163%207.79699483%2049.63267517%2011.0496521%20C52.1171225%2011.87696638%2054.60602453%2012.68488939%2057.10142517%2013.47836304%20C63.72592195%2015.59895498%2070.08788827%2017.99541393%2076.36705017%2021.00180054%20C78.6372545%2022.11431658%2078.6372545%2022.11431658%2081.53892517%2023.01742554%20C82.22642517%2025.07992554%2082.22642517%2025.07992554%2082.53892517%2027.01742554%20C78.5767362%2027.26418108%2076.18724195%2026.61353606%2072.66392517%2024.82992554%20C61.52217552%2019.58242603%2049.78621365%2016.4570305%2037.91392517%2013.32992554%20C36.79437439%2013.03231323%2035.67482361%2012.73470093%2034.52134705%2012.42807007%20C27.9488537%2010.73296743%2021.42956906%209.42924472%2014.70982361%208.47470093%20C11.63665105%208.03151859%208.5879841%207.50588664%205.53111267%206.96273804%20C-0.73597808%205.91101936%20-7.00091572%205.35024712%20-13.33607483%204.89242554%20C-14.4801178%204.80823364%20-15.62416077%204.72404175%20-16.8028717%204.63729858%20C-37.93568326%203.15337108%20-61.94552908%202.43642122%20-82.02357483%2010.07992554%20C-86.5756237%2011.80457504%20-90.61634726%2012.65178572%20-95.46107483%2013.01742554%20C-95.46107483%2011.35075887%20-95.46107483%209.6840922%20-95.46107483%208.01742554%20C-94.36794983%207.89367554%20-93.27482483%207.76992554%20-92.14857483%207.64242554%20C-88.38725681%207.26277753%20-88.38725681%207.26277753%20-85.46107483%205.01742554%20C-67.3831784%200.35343922%20-48.36481456%200.37116718%20-29.83607483%200.26742554%20C-27.27615992%200.23915534%20-24.71626291%200.20921337%20-22.15638733%200.17758179%20C-14.77093938%200.09179892%20-7.38568677%200.05229405%200%200%20Z%20%22%20fill%3D%22%236D3407%22%20transform%3D%22translate(458.46107482910156%2C129.98257446289063)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.475%201.485%202.475%201.485%205%203%20C4.50848186%207.68990223%203.37299229%2010.34762678%200.5%2014.0625%20C-2.1477873%2017.49702738%20-3.23241035%2019.77186033%20-4%2024%20C-5.80726219%2028.06633992%20-7.88511951%2031.99414366%20-9.93798828%2035.94091797%20C-11.03988114%2038.07732358%20-12.11256425%2040.22688198%20-13.18359375%2042.37890625%20C-17.28895715%2050.51716968%20-21.37220323%2057.59927978%20-28%2064%20C-29.07314453%2065.10408203%20-29.07314453%2065.10408203%20-30.16796875%2066.23046875%20C-32%2068%20-32%2068%20-33%2068%20C-33.72345277%2057.14820842%20-29.27998505%2047.79955967%20-24.25%2038.4375%20C-23.74984375%2037.47392578%20-23.2496875%2036.51035156%20-22.734375%2035.51757812%20C-19.27735367%2028.97834008%20-15.33718208%2022.98281142%20-11%2017%20C-9.89140869%2015.39888787%20-8.78659558%2013.79514537%20-7.6875%2012.1875%20C-6.98173828%2011.15689453%20-6.98173828%2011.15689453%20-6.26171875%2010.10546875%20C-4.88908429%207.81491156%20-3.98371967%205.47782111%20-3%203%20C-1.375%201.1875%20-1.375%201.1875%200%200%20Z%20%22%20fill%3D%22%23A0A0A0%22%20transform%3D%22translate(194%2C253)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.3271261%203.9813783%201.06915913%207.85045227%201%2012%20C1.66%2012.33%202.32%2012.66%203%2013%20C3%2016.63%203%2020.26%203%2024%20C3.33%2020.37%203.66%2016.74%204%2013%20C6.48769646%2016.73154469%206.27165211%2019.61354397%206.23046875%2023.9296875%20C6.22978142%2025.10895309%206.22978142%2025.10895309%206.2290802%2026.31204224%20C6.22605746%2027.98148094%206.2181705%2029.65091681%206.20581055%2031.3203125%20C6.18781655%2033.8308353%206.18529928%2036.34098261%206.18554688%2038.8515625%20C6.13548781%2064.36647814%206.13548781%2064.36647814%203.51269531%2068.13964844%20C-0.2269066%2071.81681216%20-3.86405077%2072.79036942%20-9%2073%20C-8.88353525%2071.33271516%20-8.75630239%2069.666182%20-8.625%2068%20C-8.55539062%2067.071875%20-8.48578125%2066.14375%20-8.4140625%2065.1875%20C-8%2062%20-8%2062%20-7.04101562%2058.29516602%20C-6.01511701%2054.26100974%20-5.40061806%2050.22254671%20-4.9296875%2046.08984375%20C-4.84373322%2045.35987686%20-4.75777893%2044.62990997%20-4.66921997%2043.87782288%20C-4.4901306%2042.34114599%20-4.31380446%2040.80414475%20-4.14013672%2039.2668457%20C-3.87827809%2036.96629946%20-3.6017879%2034.66783722%20-3.32421875%2032.36914062%20C-2.33214447%2023.86151489%20-1.83912233%2015.60662106%20-2.12939453%207.04125977%20C-2.00246335%204.0578981%20-1.57240779%202.49457464%200%200%20Z%20%22%20fill%3D%22%23D4D4D4%22%20transform%3D%22translate(688%2C402)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.50282081%200.25845968%202.50282081%200.25845968%204.43188477%20-0.41772461%20C7.15600946%20-0.9967582%209.18038481%20-0.63011912%2011.91796875%20-0.13671875%20C12.92923828%200.04246094%2013.94050781%200.22164062%2014.98242188%200.40625%20C16.03236328%200.60089844%2017.08230469%200.79554688%2018.1640625%200.99609375%20C19.21787109%201.18300781%2020.27167969%201.36992187%2021.35742188%201.5625%20C29.11278823%202.95816899%2029.11278823%202.95816899%2032.6015625%204.12109375%20C32.6015625%205.11109375%2032.6015625%206.10109375%2032.6015625%207.12109375%20C33.9215625%207.78109375%2035.2415625%208.44109375%2036.6015625%209.12109375%20C33.16530562%2010.26651271%2030.94730372%2010.05549474%2027.3515625%209.74609375%20C26.25328125%209.65585938%2025.155%209.565625%2024.0234375%209.47265625%20C20.53097036%209.11384113%2017.07404062%208.63753334%2013.6015625%208.12109375%20C12.43496094%207.95609375%2011.26835937%207.79109375%2010.06640625%207.62109375%20C8.90238281%207.45609375%207.73835938%207.29109375%206.5390625%207.12109375%20C5.37246094%206.95609375%204.20585937%206.79109375%203.00390625%206.62109375%20C0.98537677%206.32445566%20-1.02957775%205.99624703%20-3.03100586%205.6003418%20C-7.2680493%204.99733184%20-11.40550229%204.95876182%20-15.6796875%204.953125%20C-16.57022827%204.9497966%20-17.46076904%204.9464682%20-18.3782959%204.94303894%20C-20.26098111%204.93798979%20-22.14367521%204.93562999%20-24.02636719%204.93579102%20C-26.86148491%204.93362202%20-29.69620189%204.91549332%20-32.53125%204.89648438%20C-41.68376864%204.86903647%20-50.47348115%205.08619368%20-59.50585938%206.69018555%20C-62.51253885%207.13809146%20-65.36333558%207.14350373%20-68.3984375%207.12109375%20C-70.41236848%207.56164115%20-72.41388175%208.06293744%20-74.3984375%208.62109375%20C-78.56289829%209.79234835%20-82.08111282%2010.16987708%20-86.3984375%2010.12109375%20C-88.59911171%2011.05392671%20-88.59911171%2011.05392671%20-90.3984375%2012.12109375%20C-91.0584375%2012.12109375%20-91.7184375%2012.12109375%20-92.3984375%2012.12109375%20C-92.3984375%2011.46109375%20-92.3984375%2010.80109375%20-92.3984375%2010.12109375%20C-86.55371914%206.70455692%20-82.22204258%204.68425704%20-75.4140625%205.1484375%20C-73.13271202%205.26864202%20-73.13271202%205.26864202%20-70.3984375%203.55859375%20C-67.21629427%202.03381679%20-66.5725065%202.03831047%20-63.2734375%202.55859375%20C-58.52449378%203.28314238%20-54.57262534%202.60887019%20-49.87890625%201.734375%20C-33.31680026%20-1.18397589%20-16.72552611%20-1.75034576%200%200%20Z%20%22%20fill%3D%22%23974606%22%20transform%3D%22translate(447.3984375%2C137.87890625)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.11353866%203.74626219%200.80746732%205.47543872%20-1%209%20C-1.43828125%209.4021875%20-1.8765625%209.804375%20-2.328125%2010.21875%20C-4.75363417%2012.80293734%20-6.30560597%2015.8512823%20-8%2018.9375%20C-11.6405367%2025.52741888%20-11.6405367%2025.52741888%20-13.67578125%2028.203125%20C-15.28419716%2030.18056911%20-15.28419716%2030.18056911%20-16.1875%2033.8125%20C-17.72505086%2038.18923208%20-20.28212184%2040.42881393%20-23.8671875%2043.26171875%20C-28.3054233%2046.87896221%20-31.91565079%2051.04948177%20-35.46127069%2055.5111261%20C-44.17080231%2066.44526518%20-53.8492967%2076.25436777%20-63.75537109%2086.09594727%20C-65.60042264%2087.94015041%20-67.44480952%2089.78501872%20-69.28858948%2091.63049316%20C-73.22479743%2095.56825825%20-77.16636773%2099.5005852%20-81.11185837%20103.42904854%20C-86.8160427%20109.10863195%20-92.51171647%20114.79669007%20-98.2054859%20120.48671209%20C-107.44817282%20129.7228672%20-116.69750943%20138.95233242%20-125.95117188%20148.17749023%20C-134.92901378%20157.12770621%20-143.903633%20166.08113387%20-152.87402344%20175.03881836%20C-153.7063585%20175.86997117%20-153.7063585%20175.86997117%20-154.55550842%20176.71791495%20C-157.33979273%20179.49828355%20-160.12401472%20182.27871455%20-162.90820575%20185.05917656%20C-185.92915358%20208.04913053%20-208.96095256%20231.02818408%20-232%20254%20C-232.33%20253.01%20-232.66%20252.02%20-233%20251%20C-232.51135686%20250.58199308%20-232.02271372%20250.16398616%20-231.51926321%20249.73331237%20C-226.60427497%20245.48694523%20-221.92737776%20241.07180088%20-217.34095764%20236.47467041%20C-216.61360002%20235.74957834%20-215.88624239%20235.02448627%20-215.13684362%20234.27742171%20C-212.72045367%20231.86731976%20-210.30760894%20229.45370104%20-207.89477539%20227.04003906%20C-206.15472448%20225.30298287%20-204.41446948%20223.56613112%20-202.67402649%20221.82946777%20C-198.44962296%20217.61296234%20-194.22759642%20213.39409095%20-190.00686104%20209.1739147%20C-186.57296242%20205.74049286%20-183.13827194%20202.30786517%20-179.70303154%20198.87578583%20C-169.94352032%20189.12507125%20-160.18609806%20179.37227321%20-150.43135983%20169.61678365%20C-149.90656236%20169.09194622%20-149.38176488%20168.56710878%20-148.84106445%20168.02636719%20C-148.31561983%20167.50088168%20-147.79017521%20166.97539618%20-147.24880802%20166.43398687%20C-138.73659027%20157.92136283%20-130.21939638%20149.41373705%20-121.69992847%20140.90836957%20C-112.93258821%20132.15542454%20-104.16901434%20123.39872391%20-95.40929979%20114.63814712%20C-90.49919776%20109.72771423%20-85.5875928%20104.8188075%20-80.67192268%2099.91394806%20C-76.04699604%2095.29912837%20-71.42732776%2090.67909076%20-66.81107903%2086.05558777%20C-65.12180212%2084.36526914%20-63.43083575%2082.67663688%20-61.73800659%2080.98987579%20C-53.36216405%2072.64210186%20-45.24187102%2064.36752399%20-38%2055%20C-37.03149715%2053.83160499%20-36.05705098%2052.66808611%20-35.07421875%2051.51171875%20C-34.28660156%2050.57972656%20-33.49898437%2049.64773438%20-32.6875%2048.6875%20C-31.88699219%2047.74261719%20-31.08648438%2046.79773438%20-30.26171875%2045.82421875%20C-27.91106319%2042.9868087%20-27.91106319%2042.9868087%20-25.83203125%2039.64453125%20C-25.22746094%2038.77183594%20-24.62289062%2037.89914062%20-24%2037%20C-23.34%2037%20-22.68%2037%20-22%2037%20C-21.71713135%2036.41839111%20-21.4342627%2035.83678223%20-21.14282227%2035.23754883%20C-20.08071647%2033.15803599%20-18.93965457%2031.1861787%20-17.71484375%2029.19921875%20C-17.27052002%2028.47589355%20-16.82619629%2027.75256836%20-16.3684082%2027.00732422%20C-15.66010864%2025.85901123%20-15.66010864%2025.85901123%20-14.9375%2024.6875%20C-9.90314187%2016.49086502%20-4.93288741%208.25801893%200%200%20Z%20%22%20fill%3D%22%23171717%22%20transform%3D%22translate(654%2C540)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.47981857%20-0.01058945%201.47981857%20-0.01058945%202.98953247%20-0.02139282%20C43.74789262%20-0.24691352%2043.74789262%20-0.24691352%2061.3671875%203.203125%20C62.47320312%203.41243652%2063.57921875%203.62174805%2064.71875%203.83740234%20C93.34015603%209.34421698%20120.39850853%2017.8043917%20146.3671875%2031.203125%20C146.3671875%2031.863125%20146.3671875%2032.523125%20146.3671875%2033.203125%20C143.24538349%2034.16973863%20140.84634955%2034.19301409%20137.6171875%2033.765625%20C136.81796875%2033.66378906%20136.01875%2033.56195313%20135.1953125%2033.45703125%20C134.59203125%2033.37324219%20133.98875%2033.28945312%20133.3671875%2033.203125%20C133.0371875%2031.553125%20132.7071875%2029.903125%20132.3671875%2028.203125%20C131.5421875%2028.120625%20130.7171875%2028.038125%20129.8671875%2027.953125%20C126.3671875%2027.203125%20126.3671875%2027.203125%20123.06640625%2025.46875%20C116.89355896%2022.30645975%20110.25523632%2020.34607472%20103.6796875%2018.203125%20C102.3806848%2017.77396554%20101.0818555%2017.34428088%2099.78320312%2016.9140625%20C95.98353105%2015.65910654%2092.17681892%2014.42754253%2088.3671875%2013.203125%20C87.17222656%2012.81842041%2085.97726562%2012.43371582%2084.74609375%2012.03735352%20C83.616875%2011.68084717%2082.48765625%2011.32434082%2081.32421875%2010.95703125%20C80.33268799%2010.6432251%2079.34115723%2010.32941895%2078.31958008%2010.00610352%20C74.00017531%208.83133114%2069.65860224%208.25454115%2065.22265625%207.703125%20C62.41420394%207.33890829%2059.64482509%206.92850992%2056.85546875%206.453125%20C56.06027832%206.31914307%2055.26508789%206.18516113%2054.44580078%206.04711914%20C52.93135667%205.78966055%2051.41785701%205.52652801%2049.90576172%205.25561523%20C33.94271569%202.59628089%2017.43663787%202.94923184%201.3046875%202.640625%20C-0.83399043%202.59730302%20-2.97266238%202.55368509%20-5.11132812%202.50976562%20C-10.28509391%202.40414932%20-15.45892335%202.30250611%20-20.6328125%202.203125%20C-20.6328125%201.873125%20-20.6328125%201.543125%20-20.6328125%201.203125%20C-13.73896553%200.39879839%20-6.93832427%200.03311216%200%200%20Z%20%22%20fill%3D%22%2346250B%22%20transform%3D%22translate(407.6328125%2C124.796875)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0%206.45312471%20-4.51308736%2011.81192953%20-8.125%2016.875%20C-17.33043556%2029.80042713%20-24.9622699%2044.33694118%20-31%2059%20C-31.33032227%2059.75676025%20-31.66064453%2060.51352051%20-32.00097656%2061.29321289%20C-33.12888749%2064.34921202%20-33.72292636%2067.28941804%20-34.296875%2070.49609375%20C-34.53043701%2071.76638428%20-34.76399902%2073.0366748%20-35.00463867%2074.34545898%20C-35.12600189%2075.01326385%20-35.24736511%2075.68106873%20-35.37240601%2076.36911011%20C-37.42255624%2087.599453%20-39.78103328%2098.61114048%20-42.95336914%20109.58740234%20C-44.86893321%20116.26989888%20-46.20238006%20122.91747071%20-47.26171875%20129.78515625%20C-48.01874828%20133.08163935%20-48.98121023%20135.29635497%20-51%20138%20C-51.66%20138%20-52.32%20138%20-53%20138%20C-48.64589603%20104.33534249%20-41.15462303%2072.55714776%20-26%2042%20C-25.62439941%2041.22720703%20-25.24879883%2040.45441406%20-24.86181641%2039.65820312%20C-18.28274248%2026.20517924%20-10.65910126%2010.65910126%200%200%20Z%20%22%20fill%3D%22%234D4D4D%22%20transform%3D%22translate(192%2C253)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C2.65636538%2020.20765766%20-8.03344802%2040.63106225%20-17.02734375%2058.10302734%20C-18.54194903%2061.05696384%20-20.01962086%2064.02876734%20-21.5%2067%20C-22.33333333%2068.66666667%20-23.16666667%2070.33333333%20-24%2072%20C-24.66%2072%20-25.32%2072%20-26%2072%20C-26.25910156%2072.69738281%20-26.51820313%2073.39476562%20-26.78515625%2074.11328125%20C-28.12366555%2077.29385479%20-29.71166233%2080.19975951%20-31.4375%2083.1875%20C-32.03433594%2084.23292969%20-32.63117187%2085.27835938%20-33.24609375%2086.35546875%20C-35%2089%20-35%2089%20-38%2091%20C-37.58742287%2085.49897163%20-35.45277325%2081.23798336%20-32%2077%20C-31.34%2077%20-30.68%2077%20-30%2077%20C-29.91363281%2076.154375%20-29.82726562%2075.30875%20-29.73828125%2074.4375%20C-28.87879337%2067.49851528%20-27.95848172%2061.26044054%20-23%2056%20C-22.34%2056%20-21.68%2056%20-21%2056%20C-20.76216797%2055.12601563%20-20.76216797%2055.12601563%20-20.51953125%2054.234375%20C-18.81403028%2048.24156497%20-16.65603138%2042.57822746%20-14.20703125%2036.8515625%20C-12.69155464%2033.2713103%20-11.33407306%2029.65114733%20-10%2026%20C-9.34%2026%20-8.68%2026%20-8%2026%20C-7.87625%2025.113125%20-7.7525%2024.22625%20-7.625%2023.3125%20C-7%2020%20-7%2020%20-6.0546875%2017.7109375%20C-4.43583303%2013.54988193%20-3.69018084%209.22516131%20-2.78125%204.86328125%20C-2%202%20-2%202%200%200%20Z%20%22%20fill%3D%22%23CDCDCD%22%20transform%3D%22translate(683%2C480)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200%201.32%200%202%200%20C2%200.66%202%201.32%202%202%20C1.21625%202.2475%200.4325%202.495%20-0.375%202.75%20C-3.09873976%203.71679916%20-3.09873976%203.71679916%20-3.9375%205.875%20C-5%208%20-5%208%20-7.57523537%209.65667343%20C-11.86404896%2012.42494354%20-15.27780759%2016.00808186%20-18.85873413%2019.6182251%20C-19.63156852%2020.38935064%20-20.40440292%2021.16047618%20-21.20065653%2021.95496917%20C-23.78486745%2024.53589011%20-26.3618727%2027.12388635%20-28.93896484%2029.71191406%20C-30.79161342%2031.56512686%20-32.64470266%2033.41789923%20-34.49819946%2035.27026367%20C-38.48581395%2039.25683101%20-42.46975901%2043.24703497%20-46.45121384%2047.23975372%20C-52.20768618%2053.01250105%20-57.96969307%2058.77969801%20-63.73305257%2064.54556844%20C-73.08425421%2073.90114404%20-82.43098359%2083.26117443%20-91.77490234%2092.62402344%20C-100.85002853%20101.71751615%20-109.92725925%20110.80889959%20-119.00732422%20119.89746094%20C-119.56730305%20120.45796521%20-120.12728187%20121.01846949%20-120.70422976%20121.59595874%20C-123.5135769%20124.40791601%20-126.32296542%20127.21983194%20-129.13237453%20130.03172731%20C-152.42800231%20153.3480783%20-175.71637228%20176.67166568%20-199%20200%20C-199%20197%20-199%20197%20-197.77875441%20195.40385759%20C-197.20016797%20194.82532616%20-196.62158152%20194.24679473%20-196.02546215%20193.65073204%20C-195.36198369%20192.98004704%20-194.69850523%20192.30936204%20-194.01492137%20191.61835325%20C-193.2737966%20190.88460277%20-192.53267184%20190.15085229%20-191.76908875%20189.39486694%20C-190.99124694%20188.61305073%20-190.21340514%20187.83123452%20-189.41199237%20187.02572691%20C-186.78658013%20184.39063986%20-184.15051236%20181.76647381%20-181.5144043%20179.14208984%20C-179.63688802%20177.26214731%20-177.75996803%20175.38162645%20-175.88375854%20173.50038147%20C-171.30494332%20168.9120615%20-166.71809931%20164.33184884%20-162.12846645%20159.75435232%20C-156.78762792%20154.42711274%20-151.45440578%20149.09227563%20-146.12142215%20143.75717469%20C-136.60747752%20134.24003768%20-127.08611332%20124.73035762%20-117.56079102%20115.22460938%20C-108.31121234%20105.99403323%20-99.06761384%2096.75752075%20-89.83032227%2087.51464844%20C-79.78000594%2077.45827818%20-69.72658912%2067.4050277%20-59.66755992%2057.35737193%20C-58.59550428%2056.28652362%20-57.52344932%2055.21567464%20-56.45139503%2054.14482498%20C-55.92387211%2053.6179056%20-55.39634919%2053.09098621%20-54.85284072%2052.54809957%20C-51.1300853%2048.82922834%20-47.40947586%2045.10821829%20-43.68961143%2041.38645554%20C-39.15775264%2036.85247746%20-34.62225293%2032.32217876%20-30.08207401%2027.79653166%20C-27.76430963%2025.48602516%20-25.44871535%2023.17341624%20-23.13632011%2020.85753441%20C-20.63275232%2018.35076382%20-18.12316112%2015.85018762%20-15.61186218%2013.35116577%20C-14.87742958%2012.61295385%20-14.14299698%2011.87474192%20-13.38630885%2011.11415994%20C-12.3793563%2010.11595568%20-12.3793563%2010.11595568%20-11.35206127%209.09758568%20C-10.77298777%208.51937895%20-10.19391426%207.94117223%20-9.59729308%207.34544408%20C-8%206%20-8%206%20-5%205%20C-4.154375%204.154375%20-3.30875%203.30875%20-2.4375%202.4375%20C-1.633125%201.633125%20-0.82875%200.82875%200%200%20Z%20%22%20fill%3D%22%23383838%22%20transform%3D%22translate(621%2C605)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.82929957%202.33240504%201.189039%203.52937167%200.25%205.8671875%20C-0.36875%206.86105469%20-0.36875%206.86105469%20-1%207.875%20C-3.46608258%2012.02218676%20-5.6749028%2016.24031343%20-7.8125%2020.5625%20C-8.28333008%2021.51068604%20-8.28333008%2021.51068604%20-8.76367188%2022.47802734%20C-9.51088873%2023.98447286%20-10.25570627%2025.4921081%20-11%2027%20C-11.66%2027%20-12.32%2027%20-13%2027%20C-13.2784375%2028.2065625%20-13.2784375%2028.2065625%20-13.5625%2029.4375%20C-15.50943992%2034.26252502%20-18.43348109%2038.21477946%20-22%2042%20C-22.66%2042%20-23.32%2042%20-24%2042%20C-24.2475%2042.53625%20-24.495%2043.0725%20-24.75%2043.625%20C-27.50577134%2048.86096554%20-30.78508581%2052.88310707%20-35%2057%20C-36.11125696%2058.28557177%20-37.21485675%2059.57778525%20-38.3125%2060.875%20C-41.84933069%2064.95476523%20-45.64045269%2068.79297669%20-50%2072%20C-50.66%2072%20-51.32%2072%20-52%2072%20C-50.8144174%2067.13911133%20-48.85475579%2064.39185091%20-45.4375%2060.90625%20C-43.81483891%2058.97038364%20-43.81483891%2058.97038364%20-43.0546875%2056.08203125%20C-41.8988643%2052.70445901%20-40.46819793%2050.85344028%20-38.125%2048.1875%20C-34.98129449%2044.40153208%20-32.93416671%2041.03757858%20-31.12890625%2036.49609375%20C-28.66196802%2031.04151406%20-25.18804886%2026.05374481%20-22%2021%20C-21.46503906%2020.04609375%20-20.93007813%2019.0921875%20-20.37890625%2018.109375%20C-19.92386719%2017.41328125%20-19.46882812%2016.7171875%20-19%2016%20C-18.34%2016%20-17.68%2016%20-17%2016%20C-16.67%2014.35%20-16.34%2012.7%20-16%2011%20C-15.19568413%2013.30227069%20-14.81680608%2014.52470479%20-15.70922852%2016.84008789%20C-16.09522217%2017.46133545%20-16.48121582%2018.08258301%20-16.87890625%2018.72265625%20C-17.30292725%2019.42092529%20-17.72694824%2020.11919434%20-18.16381836%2020.83862305%20C-18.85616577%2021.93944214%20-18.85616577%2021.93944214%20-19.5625%2023.0625%20C-20.49347303%2024.59036327%20-21.42316168%2026.11900988%20-22.3515625%2027.6484375%20C-22.80692383%2028.3919043%20-23.26228516%2029.13537109%20-23.73144531%2029.90136719%20C-27.46989881%2036.08607587%20-30.83905875%2042.50250965%20-34%2049%20C-33.505%2049.495%20-33.505%2049.495%20-33%2050%20C-28.70069084%2046.10375108%20-25.46085754%2041.66677891%20-22.10546875%2036.9453125%20C-20.76151668%2035.06527565%20-19.3913937%2033.20349389%20-17.98828125%2031.3671875%20C-12.39459424%2024.00418103%20-8.16539364%2016.22020162%20-4%208%20C-3.54109375%207.09765625%20-3.0821875%206.1953125%20-2.609375%205.265625%20C-1.72836785%203.51601926%20-0.86165686%201.7592161%200%200%20Z%20%22%20fill%3D%22%23727272%22%20transform%3D%22translate(670%2C533)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.98377095%202.97565642%202.59864225%204.84854822%203.40234375%208.27734375%20C3.65153564%209.33888672%203.90072754%2010.40042969%204.1574707%2011.49414062%20C4.41488037%2012.63044922%204.67229004%2013.76675781%204.9375%2014.9375%20C5.33618286%2016.68256836%205.33618286%2016.68256836%205.74291992%2018.46289062%20C9.54860787%2035.50154257%2012.16928947%2052.67888443%2012.1328125%2070.16015625%20C12.13424759%2071.70502968%2012.13424759%2071.70502968%2012.13571167%2073.28111267%20C12.13638775%2075.44334983%2012.13457368%2077.60558909%2012.13037109%2079.76782227%20C12.12500921%2083.05685017%2012.13033849%2086.34574187%2012.13671875%2089.63476562%20C12.13605797%2091.74739613%2012.13477682%2093.86002655%2012.1328125%2095.97265625%20C12.13483673%2096.94477554%2012.13686096%2097.91689484%2012.13894653%2098.91847229%20C12.1193409%20104.69063861%2011.73879355%20110.27416656%2011%20116%20C10.34%20116%209.68%20116%209%20116%20C9.12375%20117.36125%209.12375%20117.36125%209.25%20118.75%20C9%20122%209%20122%207.4375%20124.125%20C4.37347436%20126.4819428%201.48034608%20128.29146647%20-2%20130%20C-2.99%20129.67%20-3.98%20129.34%20-5%20129%20C-1.77332524%20126.23427878%201.04189917%20124.49765977%205%20123%20C9.97428397%20118.02571603%208.22928068%20105.73411545%208.30859375%2099.04296875%20C8.32367477%2097.79772934%208.3387558%2096.55248993%208.35429382%2095.26951599%20C8.39403524%2091.24215146%208.41993878%2087.21500818%208.4375%2083.1875%20C8.44095177%2082.5052813%208.44440353%2081.82306259%208.4479599%2081.12017059%20C8.5537795%2057.42364686%207.53585673%2034.17939532%200.91796875%2011.2512207%20C-0.21035805%207.25496325%20-0.14457775%204.12046576%200%200%20Z%20%22%20fill%3D%22%231A1A1A%22%20transform%3D%22translate(704%2C338)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.86625%200.4640625%200.86625%200.4640625%201.75%200.9375%20C3.88635294%202.07363436%203.88635294%202.07363436%205.9375%202.3125%20C9.06324596%203.35441532%2010.71071674%205.66116515%2013%208%20C18.34501405%2012.97448948%2023.74740177%2017.88724178%2029.3671875%2022.55078125%20C31.6784106%2024.60212998%2033.82332418%2026.80698277%2036%2029%20C37.16789063%2030.13308594%2037.16789063%2030.13308594%2038.359375%2031.2890625%20C44.39432481%2037.1859579%2049.75191752%2043.4024106%2055%2050%20C55.78375%2050.928125%2056.5675%2051.85625%2057.375%2052.8125%20C58.1175%2053.699375%2058.86%2054.58625%2059.625%2055.5%20C60.29789063%2056.2940625%2060.97078125%2057.088125%2061.6640625%2057.90625%20C62.10492187%2058.5971875%2062.54578125%2059.288125%2063%2060%20C62.67%2060.99%2062.34%2061.98%2062%2063%20C61.34%2063%2060.68%2063%2060%2063%20C58.96564444%2061.35443434%2057.97236487%2059.6829392%2057%2058%20C54.90869233%2055.04332364%2053.27755508%2053.17270094%2050.1875%2051.25%20C47.26328634%2049.18584918%2045.92380713%2047.74936468%2043.86328125%2044.93359375%20C39.95870721%2039.81009344%2035.58559758%2035.325005%2031%2030.8125%20C30.23171875%2030.04486328%2029.4634375%2029.27722656%2028.671875%2028.48632812%20C24.71986843%2024.5645665%2020.69384081%2020.82749645%2016.4296875%2017.24926758%20C14.75008274%2015.78162114%2013.36088882%2014.20240269%2012%2012.4375%20C9.94773886%209.93285871%207.93566242%208.12143791%205.25%206.3125%20C2.32393806%204.23049439%201.10586778%203.31760333%200%200%20Z%20%22%20fill%3D%22%235B2B04%22%20transform%3D%22translate(594%2C186)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.495%200.99%200.495%202%201%20C0.84886719%201.59425781%20-0.30226563%202.18851563%20-1.48828125%202.80078125%20C-24.39178415%2014.68633177%20-24.39178415%2014.68633177%20-45.8137207%2029.00390625%20C-49.81524379%2032%20-49.81524379%2032%20-52%2032%20C-52%2032.66%20-52%2033.32%20-52%2034%20C-50.88625%2033.319375%20-49.7725%2032.63875%20-48.625%2031.9375%20C-46.7265625%2030.77734375%20-46.7265625%2030.77734375%20-45%2030%20C-44.34%2030.33%20-43.68%2030.66%20-43%2031%20C-43.45850342%2031.34256836%20-43.91700684%2031.68513672%20-44.3894043%2032.03808594%20C-46.489416%2033.60786124%20-48.58846416%2035.17892009%20-50.6875%2036.75%20C-51.40873047%2037.28882813%20-52.12996094%2037.82765625%20-52.87304688%2038.3828125%20C-55.84522736%2040.60855496%20-58.79089445%2042.82579685%20-61.64453125%2045.203125%20C-64%2047%20-64%2047%20-66.890625%2048.36328125%20C-70.80931288%2050.42600766%20-73.6004151%2053.11393957%20-76.75%2056.1875%20C-82.74351211%2062%20-82.74351211%2062%20-85%2062%20C-83.44145796%2057.96281279%20-80.56742335%2055.62654856%20-77.375%2052.875%20C-73.54803442%2049.50178465%20-70.27936117%2046.24584183%20-67.3125%2042.0625%20C-61.66549986%2034.70393486%20-53.69503399%2029.98733981%20-46%2025%20C-45.28521484%2024.5344873%20-44.57042969%2024.06897461%20-43.83398438%2023.58935547%20C-15.29027837%205.17722613%20-15.29027837%205.17722613%200%200%20Z%20%22%20fill%3D%22%23573E2A%22%20transform%3D%22translate(302%2C149)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.70661294%203.5640514%20-6.51425647%204.28077891%20-10.625%205.4375%20C-15.93796494%207.00771169%20-20.96837723%208.71140235%20-25.98046875%2011.09765625%20C-28.86222776%2012.3852507%20-31.83761245%2013.29047334%20-34.859375%2014.19140625%20C-37.08592667%2014.95962597%20-37.08592667%2014.95962597%20-39.27026367%2016.36328125%20C-42.06603597%2018.03959442%20-44.90761439%2019.52534043%20-47.81640625%2020.99609375%20C-48.91017578%2021.55490234%20-50.00394531%2022.11371094%20-51.13085938%2022.68945312%20C-53.42014619%2023.85559524%20-55.7118256%2025.01705216%20-58.00585938%2026.17382812%20C-59.09833984%2026.73392578%20-60.19082031%2027.29402344%20-61.31640625%2027.87109375%20C-62.31099854%2028.37568115%20-63.30559082%2028.88026855%20-64.33032227%2029.40014648%20C-67.00772835%2031.00463135%20-68.85408659%2032.75607824%20-71%2035%20C-72.64034193%2035.72904086%20-74.31301918%2036.38655243%20-76%2037%20C-79.63279727%2038.67500233%20-83.11589454%2040.33094722%20-86.3125%2042.75%20C-88%2044%20-88%2044%20-91%2044%20C-91%2043.34%20-91%2042.68%20-91%2042%20C-89.35791016%2040.64648438%20-89.35791016%2040.64648438%20-87.0390625%2039.09375%20C-86.18393066%2038.51963379%20-85.32879883%2037.94551758%20-84.44775391%2037.35400391%20C-83.51624512%2036.74218262%20-82.58473633%2036.13036133%20-81.625%2035.5%20C-80.19873291%2034.55713135%20-80.19873291%2034.55713135%20-78.74365234%2033.59521484%20C-70.73556681%2028.36187826%20-62.54069505%2023.61011649%20-54.09472656%2019.12597656%20C-52.01163606%2018.00625472%20-49.9538746%2016.84927966%20-47.8984375%2015.6796875%20C-46.59909411%2014.9528822%20-45.29962141%2014.22630804%20-44%2013.5%20C-42.88625%2012.8709375%20-41.7725%2012.241875%20-40.625%2011.59375%20C-36.91809173%209.9639886%20-33.64506758%209.28328985%20-29.68994141%208.58105469%20C-23.84796282%207.31912793%20-18.33166077%204.89866037%20-12.77148438%202.74609375%20C-11.84013672%202.39417969%20-10.90878906%202.04226562%20-9.94921875%201.6796875%20C-9.11737061%201.35726074%20-8.28552246%201.03483398%20-7.4284668%200.70263672%20C-4.8387666%20-0.04665022%20-2.68157852%20-0.12850538%200%200%20Z%20%22%20fill%3D%22%23DAA982%22%20transform%3D%22translate(341%2C139)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-0.33%200.66%20-0.66%201.32%20-1%202%20C-1.66%202%20-2.32%202%20-3%202%20C-3.20496094%202.62519531%20-3.40992188%203.25039062%20-3.62109375%203.89453125%20C-5.60811654%206.92854056%20-7.57631886%206.91687048%20-11.0625%207.6875%20C-18.33088779%209.68226865%20-22.26850723%2013.2781948%20-27%2019%20C-27.99%2018.67%20-28.98%2018.34%20-30%2018%20C-29.01%2016.68%20-28.02%2015.36%20-27%2014%20C-30.10551666%2014%20-31.35261084%2014.5393715%20-34%2016%20C-32.9024777%2013.00675737%20-32.32317108%2012.15389099%20-29.375%2010.75%20C-28.59125%2010.5025%20-27.8075%2010.255%20-27%2010%20C-27.495%209.01%20-27.495%209.01%20-28%208%20C-34.50062114%2010.0230027%20-40.68185046%2012.49210622%20-46.875%2015.3125%20C-47.74833984%2015.70550293%20-48.62167969%2016.09850586%20-49.52148438%2016.50341797%20C-55.18287452%2019.08050802%20-60.60108395%2021.84611969%20-65.90625%2025.1015625%20C-68.44195733%2026.18964587%20-69.42488547%2025.76621093%20-72%2025%20C-66.43423886%2022.05599176%20-60.86296181%2019.1227429%20-55.28564453%2016.20068359%20C-53.49806192%2015.26163945%20-51.71494561%2014.31409199%20-49.93359375%2013.36328125%20C-44.66632402%2010.61249953%20-39.34068782%208.65443488%20-33.6640625%206.89453125%20C-31.05951823%206.1005799%20-31.05951823%206.1005799%20-29.01953125%204.94921875%20C-26.39783881%203.71697259%20-23.92607322%203.40443909%20-21.0625%203%20C-17.05254193%202.43221833%20-13.73587344%201.53722006%20-10%200%20C-2.92993631%20-1.46496815%20-2.92993631%20-1.46496815%200%200%20Z%20M-17%204%20C-17.33%204.66%20-17.66%205.32%20-18%206%20C-17.34%206%20-16.68%206%20-16%206%20C-16.33%205.34%20-16.66%204.68%20-17%204%20Z%20M-22%208%20C-22.33%208.66%20-22.66%209.32%20-23%2010%20C-22.01%209.67%20-21.02%209.34%20-20%209%20C-20.66%208.67%20-21.32%208.34%20-22%208%20Z%20%22%20fill%3D%22%23723A0D%22%20transform%3D%22translate(352%2C141)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.66%201.32%201.32%202%202%20C0.99319462%203.11697254%20-0.03138341%204.21793008%20-1.0625%205.3125%20C-1.63097656%205.92738281%20-2.19945312%206.54226562%20-2.78515625%207.17578125%20C-5.08157239%209.06718573%20-7.32824559%2010.11447817%20-10.07983398%2011.21166992%20C-13.48165409%2012.60829766%20-16.72535605%2014.3313117%20-20%2016%20C-33.1905551%2022.72162386%20-33.1905551%2022.72162386%20-37.4375%2023.375%20C-40.07953763%2024.01939942%20-41.55474832%2024.89911563%20-43.8125%2026.375%20C-47.75653346%2028.94947345%20-51.49735209%2030.60262651%20-56%2032%20C-56.66%2031.67%20-57.32%2031.34%20-58%2031%20C-51.54355918%2026.17318968%20-44.81695232%2022.10133714%20-37.77246094%2018.21508789%20C-34.19332911%2016.23973172%20-30.68303685%2014.22440215%20-27.25%2012%20C-24%2010%20-24%2010%20-22.08203125%209.53515625%20C-18.76141432%208.68163933%20-16.04848873%206.8012083%20-13.12109375%205.05859375%20C-11%204%20-11%204%20-8%204%20C-3.69382333%202.51638473%20-3.69382333%202.51638473%200%200%20Z%20%22%20fill%3D%22%237E3A05%22%20transform%3D%22translate(323%2C153)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C7.4803924%200.53096731%2014.03031238%202.37843991%2021.125%204.75%20C22.2279541%205.11198486%2023.3309082%205.47396973%2024.46728516%205.84692383%20C26.65582841%206.56632839%2028.8432069%207.2892879%2031.02929688%208.01611328%20C33.5410087%208.84798365%2036.05673437%209.66294942%2038.578125%2010.46484375%20C45.2051365%2012.59885054%2051.54567731%2014.9764152%2057.828125%2017.984375%20C60.09832933%2019.09689105%2060.09832933%2019.09689105%2063%2020%20C63.6875%2022.0625%2063.6875%2022.0625%2064%2024%20C60.03781103%2024.24675554%2057.64831678%2023.59611052%2054.125%2021.8125%20C45.13078934%2017.57644036%2035.90364666%2014.65645862%2026.24609375%2012.375%20C25.0446875%2012.08544434%2023.84328125%2011.79588867%2022.60546875%2011.49755859%20C20.19817932%2010.92489802%2017.78535327%2010.37493752%2015.3671875%209.85009766%20C7.95740896%208.08378851%204.28027913%206.39371463%200%200%20Z%20%22%20fill%3D%22%2363320A%22%20transform%3D%22translate(477%2C133)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C5.75%200.875%205.75%200.875%208%202%20C8%202.66%208%203.32%208%204%20C8.66%204%209.32%204%2010%204%20C10%204.66%2010%205.32%2010%206%20C10.7425%206.226875%2011.485%206.45375%2012.25%206.6875%20C15.54315164%208.25923147%2016.77478157%2010.14893889%2019%2013%20C20.65532623%2014.01866229%2022.32260138%2015.01810813%2024%2016%20C25.70884005%2017.62339805%2027.37446717%2019.29319053%2029%2021%20C31.69428798%2023.70829641%2034.40406964%2026.40049703%2037.12109375%2029.0859375%20C47.223714%2039.09357714%2047.223714%2039.09357714%2051.6015625%2044.453125%20C53.32621362%2046.36083964%2055.22359376%2047.96596007%2057.1875%2049.625%20C60.18827034%2052.1685101%2062.1819697%2054.46494109%2064%2058%20C64.66%2058.66%2065.32%2059.32%2066%2060%20C61.72886302%2062.18326108%2057.49797113%2064.31326082%2053%2066%20C53.99%2064.515%2053.99%2064.515%2055%2063%20C55.91312777%2056.47765877%2053.59803156%2052.22358851%2050%2047%20C47.64587234%2044.39585286%2047.64587234%2044.39585286%2045%2042%20C43.90736479%2040.73715529%2042.82489146%2039.46548155%2041.75%2038.1875%20C38.46323164%2034.38403443%2034.86704645%2031.10695796%2031.07421875%2027.81640625%20C27.83623168%2024.98088085%2024.87173205%2021.89737123%2021.875%2018.8125%20C19.92958282%2016.82343774%2019.92958282%2016.82343774%2017%2015%20C17%2014.34%2017%2013.68%2017%2013%20C16.236875%2012.731875%2015.47375%2012.46375%2014.6875%2012.1875%20C12.11011382%2011.04865495%2010.73045136%2010.18583329%209%208%20C9%207.34%209%206.68%209%206%20C8.34%206%207.68%206%207%206%20C7%205.34%207%204.68%207%204%20C5.35%203.67%203.7%203.34%202%203%20C2%202.34%202%201.68%202%201%20C1.34%200.67%200.68%200.34%200%200%20Z%20%22%20fill%3D%22%239C4906%22%20transform%3D%22translate(588%2C190)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C6.43068983%202.06700745%208.52188136%206.49122219%2012%2012%20C12.66902344%2013.051875%2013.33804688%2014.10375%2014.02734375%2015.1875%20C25.82752936%2034.11927885%2035.34158597%2054.06075837%2043%2075%20C43.39703125%2076.07717285%2043.7940625%2077.1543457%2044.203125%2078.26416016%20C44.57953125%2079.32812012%2044.9559375%2080.39208008%2045.34375%2081.48828125%20C45.85711914%2082.92941284%2045.85711914%2082.92941284%2046.38085938%2084.3996582%20C47.02010292%2087.08443066%2046.93300294%2088.4406582%2046%2091%20C45.71801758%2090.19892822%2045.43603516%2089.39785645%2045.14550781%2088.57250977%20C44.0823377%2085.55779991%2043.01587013%2082.54428157%2041.94726562%2079.53149414%20C41.4882899%2078.23540197%2041.03057363%2076.93886299%2040.57421875%2075.6418457%20C38.18601149%2068.85692792%2035.78305801%2062.15200426%2032.69042969%2055.65209961%20C32%2054%2032%2054%2032%2052%20C31.01%2052%2030.02%2052%2029%2052%20C28.7733667%2051.47043701%2028.5467334%2050.94087402%2028.31323242%2050.39526367%20C27.27869389%2047.98942757%2026.23323903%2045.58848751%2025.1875%2043.1875%20C24.83107422%2042.35412109%2024.47464844%2041.52074219%2024.10742188%2040.66210938%20C23.75615234%2039.85966797%2023.40488281%2039.05722656%2023.04296875%2038.23046875%20C22.72352295%2037.49207764%2022.40407715%2036.75368652%2022.07495117%2035.99291992%20C20.95107558%2033.90929592%2019.69583547%2032.63003536%2018%2031%20C16.94625183%2029.0489194%2015.95085797%2027.06573983%2015%2025.0625%20C13.25017441%2021.38513217%2011.43953435%2018.24545195%209%2015%20C9%2014.34%209%2013.68%209%2013%20C8.34%2013%207.68%2013%207%2013%20C7%2012.01%207%2011.02%207%2010%20C6.34%2010%205.68%2010%205%2010%20C4.67%208.35%204.34%206.7%204%205%20C2.68%205.33%201.36%205.66%200%206%20C0%205.34%200%204.68%200%204%20C-1.98%204.66%20-3.96%205.32%20-6%206%20C-4%204%20-2%202%200%200%20Z%20%22%20fill%3D%22%231E1E1E%22%20transform%3D%22translate(657%2C247)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.1875%20-0.25%202.1875%20-0.25%205%200%20C5.70125%200.5775%206.4025%201.155%207.125%201.75%20C10.63371448%204.49595046%2014.07837616%205.59727759%2018.28125%206.97265625%20C21.1106603%208.0418156%2023.41063599%209.44257371%2026%2011%20C28.63751316%2012.23517842%2031.31743526%2013.36659165%2034%2014.5%20C46.36140351%2019.72280702%2046.36140351%2019.72280702%2048%2023%20C50.20191812%2023.8836837%2052.4380464%2024.68298108%2054.6875%2025.4375%20C59.33886634%2027.00432773%2063.64601696%2028.73592882%2068%2031%20C69.53590854%2031.72073378%2071.07711285%2032.43036513%2072.625%2033.125%20C73.72714844%2033.62386719%2073.72714844%2033.62386719%2074.8515625%2034.1328125%20C76.88867895%2034.95506678%2078.85822352%2035.52512648%2081%2036%20C81%2036.66%2081%2037.32%2081%2038%20C82.32%2038%2083.64%2038%2085%2038%20C85%2038.66%2085%2039.32%2085%2040%20C85.64066406%2040.14695312%2086.28132813%2040.29390625%2086.94140625%2040.4453125%20C91.47976621%2041.62217484%2095.01727578%2042.64240593%2098.4375%2045.9375%20C101.99160303%2049.35620863%20105.79037478%2050.59984735%20110.44921875%2052.04296875%20C113.06031705%2053.02263044%20114.86591474%2054.2257605%20117%2056%20C110.25%2055.25%20110.25%2055.25%20108%2053%20C106.14640431%2052.23740958%20104.26749402%2051.53517233%20102.375%2050.875%20C101.37210937%2050.52179688%20100.36921875%2050.16859375%2099.3359375%2049.8046875%20C98.56507813%2049.53914063%2097.79421875%2049.27359375%2097%2049%20C97%2048.34%2097%2047.68%2097%2047%20C96.38125%2046.87625%2095.7625%2046.7525%2095.125%2046.625%20C93%2046%2093%2046%2091%2044%20C89.26720512%2043.38654409%2087.51284731%2042.83334125%2085.75%2042.3125%20C76.9300593%2039.47904079%2068.42388625%2035.57601936%2061%2030%20C59.36790804%2029.51037241%2057.73318747%2029.02635171%2056.08203125%2028.60546875%20C51.93939589%2027.40076241%2047.98157149%2025.65030931%2044%2024%20C44%2023.34%2044%2022.68%2044%2022%20C43.44183594%2021.89171875%2042.88367188%2021.7834375%2042.30859375%2021.671875%20C39.6026007%2020.88434403%2037.49672874%2019.67027181%2035.0625%2018.25%20C29.82488722%2015.31440252%2024.50173728%2013.17497636%2018.84765625%2011.17578125%20C16.13712214%2010.05661696%2014.28514726%208.79925279%2012%207%20C10.11476331%206.03904512%2010.11476331%206.03904512%208.25%205.3125%20C7.1775%204.879375%206.105%204.44625%205%204%20C5%203.34%205%202.68%205%202%20C3.35%201.67%201.7%201.34%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23BD7841%22%20transform%3D%22translate(262%2C285)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.66%201.32%201.32%202%202%20C1.13181641%203.63001953%201.13181641%203.63001953%200.24609375%205.29296875%20C-2.33473545%2010.464846%20-4.1425797%2015.82731165%20-5.9375%2021.3125%20C-6.28449951%2022.3641333%20-6.63149902%2023.4157666%20-6.98901367%2024.49926758%20C-9.83416086%2033.24374576%20-12.32426706%2042.04450243%20-14.50488281%2050.9765625%20C-14.95619766%2052.82098926%20-15.42631849%2054.66078854%20-15.8984375%2056.5%20C-17.79809128%2064.17384893%20-18.92815569%2071.87566887%20-19.75732422%2079.72900391%20C-19.92295685%2081.27901875%20-20.09682125%2082.82817053%20-20.27783203%2084.37646484%20C-21.66526588%2096.29524936%20-22.18858118%20108.1336789%20-22.1875%20120.125%20C-22.18830566%20121.4361377%20-22.18911133%20122.74727539%20-22.18994141%20124.09814453%20C-22.23269393%20131.12780461%20-22.23269393%20131.12780461%20-21%20138%20C-20.93611284%20140.26799402%20-21.00037278%20142.51360664%20-21.0625%20144.78125%20C-21.08580858%20147.00391922%20-21.08580858%20147.00391922%20-20.4375%20149.09375%20C-20%20151%20-20%20151%20-21%20154%20C-21%20153.34%20-21%20152.68%20-21%20152%20C-21.66%20152%20-22.32%20152%20-23%20152%20C-23.79245452%20145.17910826%20-24.16960708%20138.45062347%20-24.203125%20131.5859375%20C-24.21013931%20130.62149719%20-24.21715363%20129.65705688%20-24.22438049%20128.66339111%20C-24.24179381%20125.56721273%20-24.24823306%20122.47122556%20-24.25%20119.375%20C-24.25101212%20117.78881866%20-24.25101212%20117.78881866%20-24.25204468%20116.17059326%20C-24.23651363%20100.87439762%20-23.81341819%2086.07168712%20-21%2071%20C-20.74259033%2069.50847412%20-20.74259033%2069.50847412%20-20.47998047%2067.98681641%20C-16.50308787%2045.02461524%20-10.48155578%2020.96311156%200%200%20Z%20%22%20fill%3D%22%230E0E0E%22%20transform%3D%22translate(149%2C302)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.32%200.33%202.64%200.66%204%201%20C3.58113525%201.41362793%203.16227051%201.82725586%202.73071289%202.25341797%20C0.83870591%204.12466831%20-1.04943185%205.99977585%20-2.9375%207.875%20C-3.59685547%208.52597656%20-4.25621094%209.17695313%20-4.93554688%209.84765625%20C-5.56396484%2010.47285156%20-6.19238281%2011.09804687%20-6.83984375%2011.7421875%20C-7.42113037%2012.3182373%20-8.00241699%2012.89428711%20-8.60131836%2013.48779297%20C-10.09951936%2014.96652475%20-10.09951936%2014.96652475%20-11%2017%20C-9.68%2016.34%20-8.36%2015.68%20-7%2015%20C-7.20496094%2015.74765625%20-7.40992188%2016.4953125%20-7.62109375%2017.265625%20C-7.89050781%2018.25046875%20-8.15992188%2019.2353125%20-8.4375%2020.25%20C-8.83775391%2021.71179688%20-8.83775391%2021.71179688%20-9.24609375%2023.203125%20C-9.85544584%2025.46372653%20-10.44238255%2027.72622009%20-11%2030%20C-10.4225%2030.33773438%20-9.845%2030.67546875%20-9.25%2031.0234375%20C-8.5075%2031.46945312%20-7.765%2031.91546875%20-7%2032.375%20C-6.2575%2032.81585938%20-5.515%2033.25671875%20-4.75%2033.7109375%20C-4.1725%2034.13632812%20-3.595%2034.56171875%20-3%2035%20C-3%2035.66%20-3%2036.32%20-3%2037%20C-1.35%2037.33%200.3%2037.66%202%2038%20C-0.72415916%2039.36207958%20-2.12779357%2038.86166193%20-5%2038%20C-5.66%2037.01%20-6.32%2036.02%20-7%2035%20C-9.68314036%2033.90254806%20-12.40229086%2033.0978055%20-15.17578125%2032.2578125%20C-18.56408966%2030.74877335%20-20.52748422%2028.72922507%20-23%2026%20C-15.58747158%2017.08453767%20-7.93118613%208.45716357%200%200%20Z%20%22%20fill%3D%22%23D78542%22%20transform%3D%22translate(218%2C227)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C0.12973998%203.06697022%20-1.74595184%205.12854297%20-3.625%207.1875%20C-4.14707031%207.76564453%20-4.66914063%208.34378906%20-5.20703125%208.93945312%20C-7.78698864%2011.75829546%20-10.36935503%2014.38655409%20-13.3359375%2016.80078125%20C-16.02991581%2018.72228243%20-16.02991581%2018.72228243%20-17%2021%20C-16.53851563%2020.5875%20-16.07703125%2020.175%20-15.6015625%2019.75%20C-10.21239952%2014.97856717%20-4.65037266%2010.45777351%201%206%20C1.66%206.33%202.32%206.66%203%207%20C2.14019531%207.71542969%201.28039062%208.43085938%200.39453125%209.16796875%20C-6.5513419%2015.00487855%20-13.20574797%2020.97680438%20-19.47143555%2027.5456543%20C-23.03184248%2031.22712787%20-26.7046881%2034.19331605%20-31%2037%20C-31.66%2037%20-32.32%2037%20-33%2037%20C-33.00667764%2031.92499249%20-31.97230231%2029.5450622%20-28.46484375%2025.84375%20C-26.97087222%2024.38021368%20-25.46112323%2022.93264153%20-23.9375%2021.5%20C-23.19822266%2020.77941406%20-22.45894531%2020.05882812%20-21.69726562%2019.31640625%20C-16.93976172%2014.71290729%20-12.0220097%2010.31177226%20-7%206%20C-6.32573975%205.42000244%20-5.65147949%204.84000488%20-4.95678711%204.24243164%20C-3.30667209%202.82578268%20-1.65366396%201.41250464%200%200%20Z%20%22%20fill%3D%22%2373421A%22%20transform%3D%22translate(234%2C190)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.78474766%209.89252426%200.41894295%2020.89849144%20-0.75%2030.9375%20C-0.8382605%2031.71058502%20-0.926521%2032.48367004%20-1.01745605%2033.28018188%20C-2.36627096%2045.01173832%20-4.12176999%2056.53300914%20-7%2068%20C-5.71823966%2067.52611769%20-4.43711047%2067.05052799%20-3.15625%2066.57421875%20C-2.08600586%2066.17722778%20-2.08600586%2066.17722778%20-0.99414062%2065.7722168%20C1.07708267%2064.97015029%203.04684636%2064.05795822%205%2063%20C4.53722656%2063.46019531%204.07445312%2063.92039062%203.59765625%2064.39453125%20C1.22628374%2068.26178177%200.9957876%2072.23771659%200.4375%2076.6875%20C0.21517482%2078.42163641%20-0.01488344%2080.15480487%20-0.25390625%2081.88671875%20C-0.35002197%2082.65201904%20-0.4461377%2083.41731934%20-0.54516602%2084.20581055%20C-0.69526123%2084.79789307%20-0.84535645%2085.38997559%20-1%2086%20C-1.99%2086.495%20-1.99%2086.495%20-3%2087%20C-3%2082.71%20-3%2078.42%20-3%2074%20C-3.99%2074.495%20-3.99%2074.495%20-5%2075%20C-4.67%2073.02%20-4.34%2071.04%20-4%2069%20C-5.65%2068.67%20-7.3%2068.34%20-9%2068%20C-8.85377197%2067.04859131%20-8.70754395%2066.09718262%20-8.55688477%2065.11694336%20C-8.00447013%2061.51144655%20-7.46046153%2057.90471915%20-6.91870117%2054.29760742%20C-6.68523627%2052.75072245%20-6.44963585%2051.20415794%20-6.21166992%2049.65795898%20C-4.33841593%2037.47190715%20-2.81808203%2025.36292511%20-3.0625%2013%20C-3.11518159%208.58791724%20-2.52911368%205.13760172%20-1%201%20C-0.67%200.67%20-0.34%200.34%200%200%20Z%20%22%20fill%3D%22%23A9A9A9%22%20transform%3D%22translate(686%2C407)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C1.12371396%205.05362021%201.21439046%2010.10635702%201.2746582%2015.16113281%20C1.29978367%2016.88003901%201.33389047%2018.59883856%201.37719727%2020.31738281%20C1.43794029%2022.78998114%201.46622762%2025.26116606%201.48828125%2027.734375%20C1.51408768%2028.50118591%201.5398941%2029.26799683%201.56648254%2030.05804443%20C1.56852063%2033.94606363%201.35495665%2035.62299887%20-1.35473633%2038.50097656%20C-4.21979551%2040.12455417%20-5.76564365%2040.36964073%20-9%2040%20C-8.88557539%2038.39504433%20-8.75805306%2036.79101881%20-8.625%2035.1875%20C-8.55539062%2034.29417969%20-8.48578125%2033.40085937%20-8.4140625%2032.48046875%20C-8%2030%20-8%2030%20-6%2027%20C-5.39581458%2024.78550576%20-5.39581458%2024.78550576%20-5%2022.32421875%20C-4.835%2021.41349609%20-4.67%2020.50277344%20-4.5%2019.56445312%20C-4.335%2018.61505859%20-4.17%2017.66566406%20-4%2016.6875%20C-2.00332779%205.33922629%20-2.00332779%205.33922629%200%200%20Z%20%22%20fill%3D%22%23F9F9F9%22%20transform%3D%22translate(690%2C434)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C0.0625%204.625%200.0625%204.625%20-1%207%20C-1.66%207%20-2.32%207%20-3%207%20C-3.226875%208.134375%20-3.45375%209.26875%20-3.6875%2010.4375%20C-4.94790295%2015.4791118%20-7.37277782%2019.55856422%20-10%2024%20C-10.87842724%2025.60229251%20-11.75350704%2027.20642537%20-12.625%2028.8125%20C-13.83854243%2031.04818723%20-15.02845329%2033.03638404%20-16.59765625%2035.04296875%20C-18.25806819%2037.09590176%20-18.25806819%2037.09590176%20-18.8125%2040.5%20C-20.28237818%2044.83227252%20-22.06109515%2045.85929084%20-26%2048%20C-25.38329755%2043.56640942%20-23.7017138%2040.19312748%20-21.625%2036.25%20C-19.60069221%2032.34894793%20-17.71168284%2028.55338995%20-16.5%2024.3125%20C-13.93281416%2015.83921178%20-7.75481862%207.66347419%20-2%201%20C-1.34%200.67%20-0.68%200.34%200%200%20Z%20%22%20fill%3D%22%23AAAAAA%22%20transform%3D%22translate(190%2C266)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.66%201.32%201.32%202%202%20C1.66266846%202.61407715%201.32533691%203.2281543%200.9777832%203.86083984%20C-0.57923751%206.6978408%20-2.13338044%209.53640882%20-3.6875%2012.375%20C-4.48317383%2013.82326172%20-4.48317383%2013.82326172%20-5.29492188%2015.30078125%20C-7.84617796%2019.96504085%20-10.32764767%2024.63447762%20-12.640625%2029.421875%20C-14.417746%2033.01329676%20-16.28417863%2035.94754408%20-19.0625%2038.875%20C-19.71347656%2039.57367188%20-20.36445313%2040.27234375%20-21.03515625%2040.9921875%20C-21.68355469%2041.65476562%20-22.33195313%2042.31734375%20-23%2043%20C-24.08087891%2044.11761719%20-24.08087891%2044.11761719%20-25.18359375%2045.2578125%20C-27%2047%20-27%2047%20-28%2047%20C-28.77267674%2040.03625087%20-26.09667297%2035.18470616%20-23%2029.0625%20C-22.52304688%2028.09248047%20-22.04609375%2027.12246094%20-21.5546875%2026.12304688%20C-20.38192573%2023.74234047%20-19.19689392%2021.36864033%20-18%2019%20C-17.34%2019%20-16.68%2019%20-16%2019%20C-17.34849837%2023.35970831%20-19.04907846%2027.31341438%20-21.125%2031.375%20C-21.66382813%2032.43460937%20-22.20265625%2033.49421875%20-22.7578125%2034.5859375%20C-23.16773438%2035.38257813%20-23.57765625%2036.17921875%20-24%2037%20C-23.67%2037.33%20-23.34%2037.66%20-23%2038%20C-19.4438935%2034.91804103%20-18.39130023%2032.43476949%20-17%2028%20C-14.98260014%2024.24346232%20-12.78705297%2020.65845097%20-10.5%2017.0625%20C-8.39082423%2013.73698974%20-6.63245811%2010.33983119%20-4.9921875%206.76171875%20C-3.89900793%204.82067944%20-2.59603812%203.5399611%20-1%202%20C-0.67%201.34%20-0.34%200.68%200%200%20Z%20%22%20fill%3D%22%23979797%22%20transform%3D%22translate(189%2C274)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.53398049%203.07455689%203.96293359%206.04527132%205.375%209.76171875%20C6.01695312%2011.44104492%206.01695312%2011.44104492%206.671875%2013.15429688%20C7.11015625%2014.32025391%207.5484375%2015.48621094%208%2016.6875%20C8.43828125%2017.83412109%208.8765625%2018.98074219%209.328125%2020.16210938%20C15.97036396%2037.63800014%2015.97036396%2037.63800014%2017%2044.0625%20C17.55752328%2047.42670032%2018.14621411%2050.77542903%2018.82421875%2054.1171875%20C19.03788086%2055.18827759%2019.03788086%2055.18827759%2019.25585938%2056.28100586%20C19.53878623%2057.69451996%2019.82764131%2059.10686328%2020.12304688%2060.51782227%20C20.79844898%2063.95550019%2021.26833543%2066.67168354%2020%2070%20C19.67%2067.36%2019.34%2064.72%2019%2062%20C18.34%2062%2017.68%2062%2017%2062%20C16.49622232%2059.73000175%2015.99709981%2057.45896997%2015.5%2055.1875%20C15.2215625%2053.92292969%2014.943125%2052.65835938%2014.65625%2051.35546875%20C14%2048%2014%2048%2014%2045%20C13.34%2045%2012.68%2045%2012%2045%20C11.73445312%2043.81921875%2011.46890625%2042.6384375%2011.1953125%2041.421875%20C10.83880998%2039.86452189%2010.48202428%2038.30723358%2010.125%2036.75%20C9.95097656%2035.97269531%209.77695312%2035.19539063%209.59765625%2034.39453125%20C9.42363281%2033.64042969%209.24960937%2032.88632812%209.0703125%2032.109375%20C8.91320801%2031.41811523%208.75610352%2030.72685547%208.59423828%2030.01464844%20C7.95618048%2027.85143852%207.01899676%2026.00728544%206%2024%20C5.62331656%2022.34259285%205.27942455%2020.67654729%205%2019%20C4.67%2019%204.34%2019%204%2019%20C3.52040222%2016.77092605%203.0413392%2014.54173703%202.5625%2012.3125%20C2.16224609%2010.45044922%202.16224609%2010.45044922%201.75390625%208.55078125%20C1.14944864%205.70387985%200.56235316%202.85544374%200%200%20Z%20%22%20fill%3D%22%23444444%22%20transform%3D%22translate(688%2C299)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.50626953%200.01353516%201.50626953%200.01353516%203.04296875%200.02734375%20C5.48724126%200.05062254%207.93098408%200.08331513%2010.375%200.125%20C7.35587057%202.13775296%205.66884438%202.63274157%202.17578125%203.30859375%20C1.13832764%203.51266846%200.10087402%203.71674316%20-0.96801758%203.92700195%20C-2.62353638%204.24157349%20-2.62353638%204.24157349%20-4.3125%204.5625%20C-5.99605591%204.88963989%20-5.99605591%204.88963989%20-7.71362305%205.22338867%20C-9.9683032%205.66022183%20-12.22358961%206.09393832%20-14.47949219%206.52441406%20C-17.21969178%207.04761268%20-19.95783661%207.57996763%20-22.6953125%208.1171875%20C-33.05507523%2010.125%20-33.05507523%2010.125%20-37.625%2010.125%20C-37.625%209.465%20-37.625%208.805%20-37.625%208.125%20C-38.615%207.795%20-39.605%207.465%20-40.625%207.125%20C-37.66765359%206.32949203%20-34.70920743%205.53853132%20-31.75%204.75%20C-30.92757813%204.52828125%20-30.10515625%204.3065625%20-29.2578125%204.078125%20C-19.33200042%201.44158116%20-10.30767161%20-0.17890485%200%200%20Z%20%22%20fill%3D%22%23B58A67%22%20transform%3D%22translate(386.625%2C128.875)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.495%200.99%200.495%202%201%20C-6.01188558%206.39575968%20-14.8450892%2010.69917639%20-23.89453125%2014.08203125%20C-26.17042106%2014.80654511%20-26.17042106%2014.80654511%20-27%2017%20C-28.8984375%2017.859375%20-28.8984375%2017.859375%20-31.375%2018.75%20C-37.22403503%2020.9873816%20-42.54975904%2023.93855136%20-48%2027%20C-51.18152272%2028.71312762%20-53.893217%2029.97033805%20-57.375%2030.9375%20C-63.51438386%2032.73697458%20-68.63015316%2035.75836351%20-74%2039.1875%20C-78.46395308%2041.9308272%20-81.7906654%2042.80706168%20-87%2043%20C-84.96389987%2040.8034114%20-83.09557457%2039.35967225%20-80.41796875%2038.02734375%20C-79.73283203%2037.68509766%20-79.04769531%2037.34285156%20-78.34179688%2036.99023438%20C-77.63087891%2036.64283203%20-76.91996094%2036.29542969%20-76.1875%2035.9375%20C-75.48818359%2035.58623047%20-74.78886719%2035.23496094%20-74.06835938%2034.87304688%20C-70.11293224%2032.91568396%20-66.22374343%2031.31405351%20-62%2030%20C-60.26418321%2029.37225952%20-58.53447779%2028.72726352%20-56.8125%2028.0625%20C-55.97332031%2027.74410156%20-55.13414062%2027.42570312%20-54.26953125%2027.09765625%20C-51.96596137%2025.98353725%20-50.72949628%2024.84741648%20-49%2023%20C-46.0948718%2021.38603989%20-43.31760138%2020.10194612%20-40.15234375%2019.0859375%20C-37.04299157%2018.01480998%20-34.28754558%2016.70796112%20-31.375%2015.1875%20C-27.32640564%2013.12076996%20-23.28253005%2011.25051202%20-19.0625%209.5625%20C-13.2945687%207.23856467%20-8.00234643%204.3442705%20-2.6171875%201.2578125%20C-1.75351562%200.84273438%20-0.88984375%200.42765625%200%200%20Z%20%22%20fill%3D%22%23444444%22%20transform%3D%22translate(658%2C484)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.66991163%202.66991163%202.24937527%204.69014224%202.27789307%208.32092285%20C2.2738446%209.19470581%202.26979614%2010.06848877%202.265625%2010.96875%20C2.26753845%2011.87765991%202.2694519%2012.78656982%202.27142334%2013.72302246%20C2.27278787%2015.6599149%202.26907283%2017.5968164%202.26074219%2019.53369141%20C2.25024321%2022.43284063%202.26052379%2025.33134153%202.2734375%2028.23046875%20C2.28316888%2041.56818505%201.83460528%2054.9162264%20-1%2068%20C-1.33%2068%20-1.66%2068%20-2%2068%20C-1.99777939%2067.3927861%20-1.99555878%2066.7855722%20-1.99327087%2066.15995789%20C-1.97117688%2059.84989001%20-1.95607613%2053.53983309%20-1.94506836%2047.22973633%20C-1.94003425%2044.873612%20-1.93320654%2042.5174908%20-1.92456055%2040.16137695%20C-1.9124547%2036.7781497%20-1.90676251%2033.39496368%20-1.90234375%2030.01171875%20C-1.89718246%2028.95538742%20-1.89202118%2027.89905609%20-1.88670349%2026.81071472%20C-1.88662796%2025.82992447%20-1.88655243%2024.84913422%20-1.88647461%2023.83862305%20C-1.884254%2022.97480515%20-1.88203339%2022.11098724%20-1.87974548%2021.22099304%20C-1.91126684%2018.82540879%20-1.91126684%2018.82540879%20-3%2016%20C-3.42134358%209.78518213%20-2.4498235%205.71625482%200%200%20Z%20%22%20fill%3D%22%239B9B9B%22%20transform%3D%22translate(695%2C399)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.3271261%203.9813783%201.06915913%207.85045227%201%2012%20C1.66%2012.33%202.32%2012.66%203%2013%20C3.04254356%2014.99954746%203.04080783%2017.00041636%203%2019%20C2.67%2019.33%202.34%2019.66%202%2020%20C1.66812714%2021.81691816%201.38985875%2023.64365149%201.1328125%2025.47265625%20C0.34342167%2030.83363053%20-0.5397798%2036.1653641%20-1.5078125%2041.49609375%20C-1.63927673%2042.22518951%20-1.77074097%2042.95428528%20-1.90618896%2043.70547485%20C-2.44942231%2046.7159994%20-2.99453658%2049.72614935%20-3.54638672%2052.73510742%20C-3.95489276%2054.96711387%20-4.35683326%2057.20022458%20-4.7578125%2059.43359375%20C-4.88278107%2060.10555283%20-5.00774963%2060.7775119%20-5.13650513%2061.46983337%20C-5.82956697%2065.36162093%20-6.12137109%2069.04933291%20-6%2073%20C-6.99%2073%20-7.98%2073%20-9%2073%20C-8.88353525%2071.33271516%20-8.75630239%2069.666182%20-8.625%2068%20C-8.55539062%2067.071875%20-8.48578125%2066.14375%20-8.4140625%2065.1875%20C-8%2062%20-8%2062%20-7.04101562%2058.29516602%20C-6.01511701%2054.26100974%20-5.40061806%2050.22254671%20-4.9296875%2046.08984375%20C-4.84373322%2045.35987686%20-4.75777893%2044.62990997%20-4.66921997%2043.87782288%20C-4.4901306%2042.34114599%20-4.31380446%2040.80414475%20-4.14013672%2039.2668457%20C-3.87827809%2036.96629946%20-3.6017879%2034.66783722%20-3.32421875%2032.36914062%20C-2.33214447%2023.86151489%20-1.83912233%2015.60662106%20-2.12939453%207.04125977%20C-2.00246335%204.0578981%20-1.57240779%202.49457464%200%200%20Z%20%22%20fill%3D%22%23B7B7B7%22%20transform%3D%22translate(688%2C402)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.17119385%20-0.00201416%202.3423877%20-0.00402832%203.54907227%20-0.00610352%20C5.40036743%200.00078491%205.40036743%200.00078491%207.2890625%200.0078125%20C8.55097412%200.01047119%209.81288574%200.01312988%2011.11303711%200.01586914%20C19.75864975%200.05987426%2028.30249263%200.33482919%2036.9140625%201.1328125%20C37.86410156%201.205%2038.81414062%201.2771875%2039.79296875%201.3515625%20C45.89518674%201.83765668%2051.90799822%202.68384602%2057.94921875%203.66796875%20C60.33586199%204.04215919%2062.70005331%204.32566811%2065.1015625%204.5703125%20C66.0296875%204.7559375%2066.9578125%204.9415625%2067.9140625%205.1328125%20C68.9040625%206.6178125%2068.9040625%206.6178125%2069.9140625%208.1328125%20C64.10066313%208.35640478%2058.8466866%207.6677939%2053.12890625%206.63671875%20C48.86732396%205.96874291%2044.61757368%205.70255062%2040.3125%205.4765625%20C37.5297513%205.19508907%2035.02625897%204.73365431%2032.30957031%204.12353516%20C27.21004268%203.08989333%2022.37659634%202.87244191%2017.1875%202.9375%20C16.31380768%202.9403299%2015.44011536%202.94315979%2014.53994751%202.94607544%20C11.78950436%202.95713947%209.03940476%202.98221669%206.2890625%203.0078125%20C4.40755683%203.01786016%202.52604599%203.02698286%200.64453125%203.03515625%20C-3.93242107%203.05703338%20-8.50912135%203.09146531%20-13.0859375%203.1328125%20C-9.48946832%20-0.46365668%20-4.86495411%200.00521911%200%200%20Z%20%22%20fill%3D%22%23A74E07%22%20transform%3D%22translate(414.0859375%2C139.8671875)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C1.1404894%205.67704882%200.70442078%2010.86914183%20-0.375%2016.4375%20C-0.56449219%2017.51547852%20-0.56449219%2017.51547852%20-0.7578125%2018.61523438%20C-1.09965667%2020.42529925%20-1.54187051%2022.21581681%20-2%2024%20C-2.66%2024.33%20-3.32%2024.66%20-4%2025%20C-4.54653131%2027.24455389%20-4.54653131%2027.24455389%20-4.875%2029.9375%20C-5.67666359%2034.82322926%20-7.03801754%2038.98140958%20-8.99609375%2043.51171875%20C-10.04121068%2046.10214475%20-10.77748396%2048.6783964%20-11.5%2051.375%20C-12.58991359%2055.20475163%20-13.73420362%2057.5224993%20-17%2060%20C-17.41667463%2054.27072388%20-16.71718112%2050.74911704%20-14.2109375%2045.62109375%20C-11.72969872%2040.2504124%20-9.95751793%2034.57794406%20-8%2029%20C-5.19399538%2021.19399538%20-5.19399538%2021.19399538%20-4%2020%20C-3.71681717%2018.60187743%20-3.4865614%2017.19291089%20-3.28125%2015.78125%20C-3.15363281%2014.93175781%20-3.02601563%2014.08226562%20-2.89453125%2013.20703125%20C-2.76433594%2012.31371094%20-2.63414062%2011.42039062%20-2.5%2010.5%20C-2.24335071%208.73903015%20-1.98312456%206.97857663%20-1.71875%205.21875%20C-1.60466797%204.43435547%20-1.49058594%203.64996094%20-1.37304688%202.84179688%20C-1%201%20-1%201%200%200%20Z%20%22%20fill%3D%22%237D7D7D%22%20transform%3D%22translate(688%2C473)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C4.59939618%201.03486414%208.70876086%202.96245093%2013%204.875%20C13.80695313%205.22691406%2014.61390625%205.57882812%2015.4453125%205.94140625%20C19.28864569%207.64744029%2022.76447085%209.26101245%2026%2012%20C30.76252152%2015.17501435%2035.86556602%2016.89275706%2041.22265625%2018.78515625%20C46.79918324%2020.79918324%2046.79918324%2020.79918324%2049%2023%20C51.57061311%2023.64767793%2051.57061311%2023.64767793%2054%2024%20C54%2024.66%2054%2025.32%2054%2026%20C54.845625%2026.103125%2055.69125%2026.20625%2056.5625%2026.3125%20C60.41442701%2027.0828854%2063.44075031%2028.36274514%2067%2030%20C67%2030.66%2067%2031.32%2067%2032%20C65.60190528%2031.74109357%2064.20657858%2031.46722539%2062.8125%2031.1875%20C62.03519531%2031.03667969%2061.25789063%2030.88585937%2060.45703125%2030.73046875%20C57.62563734%2029.88870299%2055.52181087%2028.53123449%2053%2027%20C50.84907031%2026.12685032%2048.68103886%2025.29495809%2046.5%2024.5%20C42.34695447%2022.98627313%2038.77735394%2021.27250487%2035%2019%20C33.26436993%2018.35571308%2031.51318591%2017.75202882%2029.75%2017.1875%20C24.96646782%2015.5177765%2021.14477019%2013.35718877%2017.0703125%2010.3671875%20C14.80199747%208.86924361%2012.53046805%207.97454389%2010%207%20C8.66150329%206.00692179%207.32848691%205.00642948%206%204%20C4.01549844%202.96958573%202.01800895%201.96314063%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23323232%22%20transform%3D%22translate(136%2C463)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.86625%200.4640625%200.86625%200.4640625%201.75%200.9375%20C3.88635294%202.07363436%203.88635294%202.07363436%205.9375%202.3125%20C9.07744555%203.35914852%2010.83786745%205.60368181%2013%208%20C13.70769531%208.7734375%2014.41539062%209.546875%2015.14453125%2010.34375%20C18.41442189%2013.94442559%2021.66851089%2017.54840254%2024.75%2021.3125%20C27.03949528%2024.04717492%2029.46363505%2026.49201396%2032%2029%20C34.31481459%2031.28934255%2036.62669702%2033.58160888%2038.9375%2035.875%20C39.53240234%2036.46152344%2040.12730469%2037.04804688%2040.74023438%2037.65234375%20C44.71399509%2041.60438993%2048.40101891%2045.70320121%2052%2050%20C51.505%2050.99%2051.505%2050.99%2051%2052%20C47.54750388%2048.59682525%2044.24485776%2045.10100069%2041%2041.5%20C33.28371149%2033.01742263%2025.3586146%2024.59454831%2016.47265625%2017.32421875%20C14.79633991%2015.81686799%2013.42534514%2014.18289653%2012%2012.4375%20C9.94773886%209.93285871%207.93566242%208.12143791%205.25%206.3125%20C2.32393806%204.23049439%201.10586778%203.31760333%200%200%20Z%20%22%20fill%3D%22%23743605%22%20transform%3D%22translate(594%2C186)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.70189453%200.00451172%201.40378906%200.00902344%202.12695312%200.01367188%20C3.85550538%200.02543073%205.58401365%200.04336546%207.3125%200.0625%20C7.3125%201.0525%207.3125%202.0425%207.3125%203.0625%20C4.73282203%203.92939178%202.14973873%204.78123789%20-0.4375%205.625%20C-1.16710937%205.87185547%20-1.89671875%206.11871094%20-2.6484375%206.37304688%20C-3.35742188%206.60185547%20-4.06640625%206.83066406%20-4.796875%207.06640625%20C-5.44624023%207.28111572%20-6.09560547%207.4958252%20-6.76464844%207.71704102%20C-8.6875%208.0625%20-8.6875%208.0625%20-12.6875%207.0625%20C-9.0575%205.7425%20-5.4275%204.4225%20-1.6875%203.0625%20C-8.96442771%203.6913703%20-15.17058898%206.47380054%20-21.86132812%209.26757812%20C-27.44068295%2011.50174411%20-31.67417851%2012.50558685%20-37.6875%2012.0625%20C-35.27972659%209.65472659%20-33.3347619%209.06819207%20-30.12890625%207.93359375%20C-29.02095703%207.53849609%20-27.91300781%207.14339844%20-26.77148438%206.73632812%20C-25.60939453%206.32833984%20-24.44730469%205.92035156%20-23.25%205.5%20C-22.09177734%205.08814453%20-20.93355469%204.67628906%20-19.74023438%204.25195312%20C-12.88438654%201.81794788%20-7.31601913%20-0.08880322%200%200%20Z%20%22%20fill%3D%22%2399775A%22%20transform%3D%22translate(341.6875%2C136.9375)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C9.84631941%201.6783499%2018.6956622%2013.49113323%2025.4375%2020.1875%20C26.3140625%2021.05479736%2027.190625%2021.92209473%2028.09375%2022.81567383%20C35.06109845%2029.8173475%2035.06109845%2029.8173475%2037.34765625%2033.421875%20C39.02540874%2036.03964485%2040.44252763%2037.34919331%2043%2039.0625%20C46.26102363%2041.38658774%2048.7918633%2043.59578925%2051%2047%20C51%2047.99%2051%2048.98%2051%2050%20C47.23839009%2048.49535604%2047.23839009%2048.49535604%2046.09765625%2046.125%20C44.82641073%2043.66394105%2043.45745121%2042.48618841%2041.3125%2040.75%20C38.55173436%2038.41396753%2036.08565215%2036.07281617%2033.75%2033.3125%20C29.27927533%2028.03828104%2024.33058221%2023.24608158%2019.41064453%2018.39624023%20C18.05179508%2017.05126619%2016.70531823%2015.69382697%2015.359375%2014.3359375%20C13.41562108%2012.41149239%2011.45597885%2010.58465779%209.375%208.8125%20C8.52035156%208.07966797%208.52035156%208.07966797%207.6484375%207.33203125%20C5.82650009%205.81824745%205.82650009%205.81824745%203%204%20C3%203.34%203%202.68%203%202%20C2.01%201.67%201.02%201.34%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%238A4006%22%20transform%3D%22translate(603%2C199)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C1.54149658%201.34256836%201.08299316%201.68513672%200.6105957%202.03808594%20C-1.489416%203.60786124%20-3.58846416%205.17892009%20-5.6875%206.75%20C-6.7693457%207.55824219%20-6.7693457%207.55824219%20-7.87304688%208.3828125%20C-10.84522736%2010.60855496%20-13.79089445%2012.82579685%20-16.64453125%2015.203125%20C-19%2017%20-19%2017%20-21.890625%2018.36328125%20C-25.80931288%2020.42600766%20-28.6004151%2023.11393957%20-31.75%2026.1875%20C-37.74351211%2032%20-37.74351211%2032%20-40%2032%20C-38.42546727%2027.88496354%20-35.42520606%2025.44380092%20-32.1875%2022.625%20C-28.97495522%2019.81352694%20-25.99505236%2017.08500302%20-23.36328125%2013.7109375%20C-20.92101454%2010.90939519%20-20.42221899%2010.59871823%20-17%2010%20C-14.67227533%208.30105248%20-12.51305784%206.45803866%20-10.31640625%204.59375%20C-7.79185103%202.8567879%20-5.98441765%202.50468201%20-3%202%20C-2.01%201.34%20-1.02%200.68%200%200%20Z%20%22%20fill%3D%22%23905E35%22%20transform%3D%22translate(257%2C179)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.68416016%200.38285156%201.68416016%200.38285156%203.40234375%200.7734375%20C4.28019531%201.05445313%205.15804687%201.33546875%206.0625%201.625%20C6.5575%202.615%206.5575%202.615%207.0625%203.625%20C4.8127943%203.68032063%202.56266349%203.7183712%200.3125%203.75%20C-0.94046875%203.77320313%20-2.1934375%203.79640625%20-3.484375%203.8203125%20C-6.89859227%203.76940684%20-10.07864329%203.27339975%20-13.43164062%202.63867188%20C-19.80771546%201.55003089%20-26.02631014%201.28029908%20-32.484375%201.2109375%20C-33.62158997%201.19157135%20-34.75880493%201.1722052%20-35.93048096%201.1522522%20C-39.51608081%201.09309804%20-43.10171391%201.04633048%20-46.6875%201%20C-49.13803382%200.96176104%20-51.58855505%200.922706%20-54.0390625%200.8828125%20C-60.00509547%200.78745036%20-65.97120608%200.70222082%20-71.9375%200.625%20C-71.9375%200.295%20-71.9375%20-0.035%20-71.9375%20-0.375%20C-64.64380354%20-0.50622409%20-57.35009361%20-0.63667157%20-50.05636597%20-0.76615143%20C-46.66891811%20-0.82631005%20-43.28147531%20-0.88672741%20-39.89404297%20-0.94775391%20C-35.99187358%20-1.01792136%20-32.08968882%20-1.08717251%20-28.1875%20-1.15625%20C-26.37922729%20-1.18906067%20-26.37922729%20-1.18906067%20-24.53442383%20-1.22253418%20C-6.5276654%20-1.53860958%20-6.5276654%20-1.53860958%200%200%20Z%20%22%20fill%3D%22%2375441D%22%20transform%3D%22translate(470.9375%2C131.375)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.5992077%202.83286663%202.25141485%204.86831579%202.25878906%208.11572266%20C2.26509338%208.91821442%202.27139771%209.72070618%202.27789307%2010.54751587%20C2.2738446%2011.41097626%202.26979614%2012.27443665%202.265625%2013.1640625%20C2.26753845%2014.07014252%202.2694519%2014.97622253%202.27142334%2015.90975952%20C2.27278467%2017.83469926%202.26909187%2019.7596482%202.26074219%2021.68457031%20C2.25021562%2024.5659787%202.26054761%2027.4467383%202.2734375%2030.328125%20C2.28232924%2039.29544283%202.08873191%2048.21780593%201.234375%2057.1484375%20C1.17364807%2057.88712067%201.11292114%2058.62580383%201.050354%2059.38687134%20C0.67297659%2062.77095469%200.20935583%2064.74311417%20-1.96362305%2067.40942383%20C-4.89803107%2069.70143537%20-7.6438275%2071.35242441%20-11%2073%20C-11.99%2072.67%20-12.98%2072.34%20-14%2072%20C-10.77332524%2069.23427878%20-7.95810083%2067.49765977%20-4%2066%20C0.97133771%2061.02866229%20-0.78025624%2048.77947619%20-0.68359375%2042.08984375%20C-0.6524221%2040.27777184%20-0.6524221%2040.27777184%20-0.62062073%2038.42909241%20C-0.55562961%2034.59861527%20-0.49647635%2030.76807399%20-0.4375%2026.9375%20C-0.39426674%2024.32876961%20-0.35065097%2021.72004552%20-0.30664062%2019.11132812%20C-0.20000042%2012.74095175%20-0.09814361%206.37051263%200%200%20Z%20%22%20fill%3D%22%23333333%22%20transform%3D%22translate(713%2C395)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-2.71949889%205.26495699%20-7.43729263%209.52767929%20-12.25%2013.6875%20C-14.6901583%2015.79870335%20-16.96654803%2017.9728712%20-19.1875%2020.3125%20C-22%2023%20-22%2023%20-24.24609375%2023.7265625%20C-28.35389889%2025.62605821%20-30.87411053%2028.7360862%20-33.875%2032.0625%20C-34.80372925%2033.07207764%20-34.80372925%2033.07207764%20-35.7512207%2034.10205078%20C-39.64511869%2038.37482837%20-43.31886196%2042.74214323%20-46.66796875%2047.4609375%20C-48%2049%20-48%2049%20-51%2050%20C-48.67613198%2042.81713521%20-43.6011842%2038.57488342%20-38.03515625%2033.8515625%20C-36.01573782%2032.01431809%20-34.30719815%2030.0968762%20-32.5625%2028%20C-28.86531746%2023.63597404%20-24.5693866%2020.39989095%20-20%2017%20C-17.07453316%2014.68207932%20-14.29516806%2012.30314558%20-11.6875%209.625%20C-8.05034338%206.07242841%20-4.05141234%203.06283242%200%200%20Z%20%22%20fill%3D%22%239A551C%22%20transform%3D%22translate(244%2C204)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-1.98%200.66%20-3.96%201.32%20-6%202%20C-6.14695312%202.91136719%20-6.29390625%203.82273437%20-6.4453125%204.76171875%20C-8.63886858%2017.4313961%20-11.93325935%2029.79977804%20-16%2042%20C-16.66%2042%20-17.32%2042%20-18%2042%20C-18.0825%2043.11375%20-18.165%2044.2275%20-18.25%2045.375%20C-18.87919026%2050.6151219%20-20.88630871%2055.20241234%20-23%2060%20C-24.21539658%2056.35381026%20-23.65987257%2055.54120732%20-22.25%2052.0625%20C-20.30255051%2046.99913132%20-18.91486074%2041.95609513%20-17.66015625%2036.68359375%20C-16.93290105%2033.72723681%20-16.0339627%2030.86328134%20-15%2028%20C-14.34%2028%20-13.68%2028%20-13%2028%20C-12.95101562%2027.20078125%20-12.90203125%2026.4015625%20-12.8515625%2025.578125%20C-12.61119853%2022.0472611%20-12.31466545%2018.52500226%20-12%2015%20C-11.91234375%2013.87980469%20-11.8246875%2012.75960938%20-11.734375%2011.60546875%20C-10.86144056%203.91036187%20-10.86144056%203.91036187%20-8.41796875%201.328125%20C-5.21745497%20-0.63934874%20-3.60112646%20-1.20037549%200%200%20Z%20%22%20fill%3D%22%23343434%22%20transform%3D%22translate(699%2C469)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C1.57892613%207.06289877%200.45144587%2013.13792855%20-1.3125%2019.9375%20C-1.63190552%2021.19880737%20-1.63190552%2021.19880737%20-1.95776367%2022.4855957%20C-2.17408447%2023.28312256%20-2.39040527%2024.08064941%20-2.61328125%2024.90234375%20C-2.80704346%2025.61898193%20-3.00080566%2026.33562012%20-3.20043945%2027.07397461%20C-4.11409664%2029.27484226%20-5.27112205%2030.38978178%20-7%2032%20C-7.98628417%2034.03077684%20-7.98628417%2034.03077684%20-8.6875%2036.1875%20C-9.06455078%2037.26064453%20-9.06455078%2037.26064453%20-9.44921875%2038.35546875%20C-9.63097656%2038.89816406%20-9.81273437%2039.44085937%20-10%2040%20C-10.66%2039.67%20-11.32%2039.34%20-12%2039%20C-11.51080078%2037.63681641%20-11.51080078%2037.63681641%20-11.01171875%2036.24609375%20C-8.23240606%2028.31600117%20-6.21527696%2020.61240874%20-4.6875%2012.33984375%20C-2.70397644%202.70397644%20-2.70397644%202.70397644%200%200%20Z%20%22%20fill%3D%22%23D1D1D1%22%20transform%3D%22translate(683%2C480)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.03940231%20-0.0033284%202.07880463%20-0.0066568%203.14970398%20-0.01008606%20C5.32872072%20-0.01511422%207.50774505%20-0.01749567%209.68676758%20-0.01733398%20C13.0198209%20-0.0195366%2016.35255123%20-0.0377797%2019.68554688%20-0.05664062%20C21.81119679%20-0.0595722%2023.93684827%20-0.06155857%2026.0625%20-0.0625%20C27.05526443%20-0.06968552%2028.04802887%20-0.07687103%2029.07087708%20-0.08427429%20C37.55785594%20-0.05614748%2037.55785594%20-0.05614748%2041.69921875%202.16796875%20C41.69921875%202.49796875%2041.69921875%202.82796875%2041.69921875%203.16796875%20C28.00512734%203.25176025%2014.32666761%202.98651367%200.63671875%202.66796875%20C-1.50194919%202.6196171%20-3.64062105%202.57143893%20-5.77929688%202.5234375%20C-10.95317235%202.40694232%20-16.1269894%202.28811857%20-21.30078125%202.16796875%20C-21.30078125%201.83796875%20-21.30078125%201.50796875%20-21.30078125%201.16796875%20C-14.18190841%200.32157753%20-7.16587933%200.00811521%200%200%20Z%20%22%20fill%3D%22%23442F1E%22%20transform%3D%22translate(408.30078125%2C124.83203125)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C1.26803029%204.73520178%200.97905671%208.4805785%20-0.41015625%2013.0234375%20C-2.1215096%2019.07413138%20-2.93484112%2025.07362055%20-3.625%2031.3125%20C-5.60819642%2048.41229462%20-5.60819642%2048.41229462%20-8%2052%20C-8.66%2052%20-9.32%2052%20-10%2052%20C-8.50548549%2040.4448512%20-6.71778238%2028.9908676%20-4.4375%2017.5625%20C-4.22778564%2016.50361572%20-4.01807129%2015.44473145%20-3.80200195%2014.35375977%20C-2.80344868%209.44929816%20-1.75086903%204.70394766%200%200%20Z%20%22%20fill%3D%22%23474747%22%20transform%3D%22translate(149%2C339)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C1.56838149%205.70157679%20-0.25620159%209.09189196%20-3%2013.875%20C-3.3815625%2014.56335938%20-3.763125%2015.25171875%20-4.15625%2015.9609375%20C-5.09291108%2017.64692745%20-6.04493248%2019.32436814%20-7%2021%20C-7.66%2021%20-8.32%2021%20-9%2021%20C-9.38865234%2022.04607422%20-9.38865234%2022.04607422%20-9.78515625%2023.11328125%20C-11.12366555%2026.29385479%20-12.71166233%2029.19975951%20-14.4375%2032.1875%20C-15.03433594%2033.23292969%20-15.63117187%2034.27835938%20-16.24609375%2035.35546875%20C-18%2038%20-18%2038%20-21%2040%20C-20.58742287%2034.49897163%20-18.45277325%2030.23798336%20-15%2026%20C-14.34%2026%20-13.68%2026%20-13%2026%20C-12.34%2023.03%20-11.68%2020.06%20-11%2017%20C-9.68%2016.67%20-8.36%2016.34%20-7%2016%20C-6.00151966%2014.15279073%20-6.00151966%2014.15279073%20-5.5%2011.875%20C-4.21276252%207.43011921%20-2.4258573%203.93156182%200%200%20Z%20%22%20fill%3D%22%23E8E8E8%22%20transform%3D%22translate(666%2C531)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.58874022%202.58874022%202.54444016%204.21220177%203.0625%207.8125%20C3.29646484%209.36904297%203.29646484%209.36904297%203.53515625%2010.95703125%20C4.88345556%2021.89243306%205.16762485%2032.8077568%205.125%2043.8125%20C5.12267365%2044.87976822%205.12267365%2044.87976822%205.12030029%2045.96859741%20C5.09584462%2055.58706815%204.97118371%2065.19953293%204.625%2074.8125%20C4.57883545%2076.28650269%204.57883545%2076.28650269%204.53173828%2077.7902832%20C4.49290527%2078.69093506%204.45407227%2079.59158691%204.4140625%2080.51953125%20C4.36693115%2081.68125854%204.36693115%2081.68125854%204.31884766%2082.86645508%20C3.96457118%2085.23706925%203.1753591%2086.92471057%202%2089%20C0.68851843%2086.37703685%201.0642323%2084.8005525%201.33984375%2081.8828125%20C1.4805127%2080.28083008%201.4805127%2080.28083008%201.62402344%2078.64648438%20C1.77919434%2076.90334961%201.77919434%2076.90334961%201.9375%2075.125%20C3.56241813%2055.01056499%203.82534596%2035.06211075%201.24365234%2015.02929688%20C0.64428965%2010.03741037%200.34212678%205.01485835%200%200%20Z%20%22%20fill%3D%22%23606060%22%20transform%3D%22translate(706%2C372)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-0.90363281%200.47050781%20-1.80726563%200.94101562%20-2.73828125%201.42578125%20C-3.92983986%202.05439878%20-5.12123772%202.68332109%20-6.3125%203.3125%20C-6.90740234%203.62123047%20-7.50230469%203.92996094%20-8.11523438%204.24804688%20C-11.54528159%206.04855807%20-11.54528159%206.04855807%20-14.46875%208.546875%20C-16.92633345%2010.87907154%20-20.06230741%2011.77329503%20-23.1875%2012.9375%20C-29.5824562%2015.40574212%20-35.74539867%2017.93610648%20-41.5625%2021.625%20C-46.34214304%2024.3212089%20-51.62002345%2025.21268636%20-57%2026%20C-56.67%2025.34%20-56.34%2024.68%20-56%2024%20C-55.01%2024%20-54.02%2024%20-53%2024%20C-53%2023.34%20-53%2022.68%20-53%2022%20C-47.91059256%2019.94637945%20-43.45479185%2018.56820748%20-38%2018%20C-38%2017.34%20-38%2016.68%20-38%2016%20C-34.10418717%2013.83565954%20-30.25627188%2012.40184924%20-26%2011.0625%20C-21.41750223%209.57262388%20-17.88094435%207.91070826%20-14%205%20C-12.63453921%204.08969281%20-11.25888914%203.19453923%20-9.875%202.3125%20C-8.91207031%201.68794922%20-8.91207031%201.68794922%20-7.9296875%201.05078125%20C-5.03380059%20-0.52612883%20-3.04512148%20-1.52256074%200%200%20Z%20%22%20fill%3D%22%23313131%22%20transform%3D%22translate(551%2C537)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.02137894%203.17677233%200.94366995%205.23360036%200.14453125%208.45703125%20C-0.06389404%209.31498291%20-0.27231934%2010.17293457%20-0.48706055%2011.05688477%20C-0.71820557%2011.96623779%20-0.94935059%2012.87559082%20-1.1875%2013.8125%20C-1.41800049%2014.75085693%20-1.64850098%2015.68921387%20-1.88598633%2016.65600586%20C-3.24484308%2022.14627461%20-4.69364446%2027.60766385%20-6.1875%2033.0625%20C-7.89458878%2039.3241293%20-9.09090747%2045.57654358%20-10%2052%20C-10.66%2052%20-11.32%2052%20-12%2052%20C-7.61800699%2013.96634615%20-7.61800699%2013.96634615%200%200%20Z%20%22%20fill%3D%22%235B5B5B%22%20transform%3D%22translate(155%2C330)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C17.30295916%200.26508712%2034.28707284%203.64450989%2051%208%20C51%208.33%2051%208.66%2051%209%20C50.44054687%208.93941406%2049.88109375%208.87882813%2049.3046875%208.81640625%20C44.34967027%208.29859898%2039.41174142%207.90677784%2034.4375%207.625%20C26.16382662%207.06315142%2018.1352396%205.53369271%2010%204%20C8.00097316%203.66087938%206.0013358%203.32521707%204%203%20C4%202.34%204%201.68%204%201%20C2.68%200.67%201.36%200.34%200%200%20Z%20%22%20fill%3D%22%233D2713%22%20transform%3D%22translate(446%2C126)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C6.0005344%202.9335946%2010.45700082%206.96331944%2015.32421875%2011.5078125%20C17.42634085%2013.4657014%2019.55298635%2015.33990247%2021.75%2017.1875%20C28.52828437%2023.05441841%2034.70495567%2029.62503812%2041%2036%20C40.505%2036.99%2040.505%2036.99%2040%2038%20C39.43079834%2037.40985107%2038.86159668%2036.81970215%2038.27514648%2036.21166992%20C35.67330294%2033.52633064%2033.05568032%2030.85690957%2030.4375%2028.1875%20C29.54224609%2027.25873047%2028.64699219%2026.32996094%2027.72460938%2025.37304688%20C22.99781514%2020.57699558%2019.34331336%2017.2350331%2013%2015%20C10.890625%2013.24609375%2010.890625%2013.24609375%209.25%2011.4375%20C7.18519855%209.19419936%205.58181252%207.72120834%203%206%20C3%205.34%203%204.68%203%204%20C2.01%203.67%201.02%203.34%200%203%20C0%202.01%200%201.02%200%200%20Z%20%22%20fill%3D%22%23200E01%22%20transform%3D%22translate(599%2C185)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C4.88564575%203.94609849%209.05810377%208.11522946%2013%2013%20C13.78375%2013.969375%2014.5675%2014.93875%2015.375%2015.9375%20C15.91125%2016.618125%2016.4475%2017.29875%2017%2018%20C12.72886302%2020.18326108%208.49797113%2022.31326082%204%2024%20C4.66%2023.01%205.32%2022.02%206%2021%20C6.5871916%2015.91100618%205.77322116%2013.07753735%203.0234375%208.77734375%20C1.41455102%205.98328517%200.76410029%203.12007619%200%200%20Z%20%22%20fill%3D%22%2398490A%22%20transform%3D%22translate(637%2C232)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.66%201.32%201.32%202%202%20C0.99319462%203.11697254%20-0.03138341%204.21793008%20-1.0625%205.3125%20C-1.63097656%205.92738281%20-2.19945312%206.54226562%20-2.78515625%207.17578125%20C-5.08157239%209.06718573%20-7.32824559%2010.11447817%20-10.07983398%2011.21166992%20C-13.48165409%2012.60829766%20-16.72535605%2014.3313117%20-20%2016%20C-24.93716961%2018.5158757%20-29.88380436%2020.86825182%20-35%2023%20C-35%2022.01%20-35%2021.02%20-35%2020%20C-33.23002526%2019.18563132%20-31.45898848%2018.3735706%20-29.6875%2017.5625%20C-28.70136719%2017.11003906%20-27.71523438%2016.65757812%20-26.69921875%2016.19140625%20C-24%2015%20-24%2015%20-21%2014%20C-20.236875%2013.195625%20-19.47375%2012.39125%20-18.6875%2011.5625%20C-15.76523612%208.77615537%20-13.81618496%208.11305395%20-10%207%20C-6.33589668%205.03389578%20-3.19840612%202.65010793%200%200%20Z%20%22%20fill%3D%22%238E4206%22%20transform%3D%22translate(323%2C153)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.11353866%203.74626219%200.80746732%205.47543872%20-1%209%20C-1.43828125%209.4021875%20-1.8765625%209.804375%20-2.328125%2010.21875%20C-4.75363417%2012.80293734%20-6.30560597%2015.8512823%20-8%2018.9375%20C-11.63892169%2025.52449546%20-11.63892169%2025.52449546%20-13.6640625%2028.19140625%20C-15.08374114%2030.11336885%20-15.69041129%2031.72396479%20-16.375%2034%20C-17.72788088%2037.87777621%20-19.5056121%2039.73337001%20-23%2042%20C-22.86897997%2035.97307865%20-20.71183472%2032.84224997%20-17.16796875%2028.078125%20C-14.03628069%2023.63169222%20-11.36160686%2018.94590349%20-8.64086914%2014.24072266%20C-5.85635302%209.43054262%20-2.975039%204.69486038%200%200%20Z%20%22%20fill%3D%22%232B2B2B%22%20transform%3D%22translate(654%2C540)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C5.44693314%20-0.09688221%2010.63904667%20-0.12862175%2016%201%20C16%201.66%2016%202.32%2016%203%20C14.988806%203.00879936%2014.988806%203.00879936%2013.95718384%203.01777649%20C6.84977932%203.08242185%20-0.25720165%203.16701057%20-7.36425781%203.26245117%20C-10.00589382%203.2969509%20-12.64726148%203.32353071%20-15.2890625%203.34643555%20C-28.82817037%203.46695412%20-42.03301469%203.5953204%20-55.32275391%206.36791992%20C-59.33960982%207.05837537%20-62.93450004%207.10511795%20-67%207%20C-67%206.67%20-67%206.34%20-67%206%20C-44.81786128%201.21437817%20-22.58742725%201.18494682%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%238B5B34%22%20transform%3D%22translate(440%2C128)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.79540355%202.29443332%201.16371327%203.54502939%200.328125%205.8671875%20C-0.20554687%206.86105469%20-0.20554687%206.86105469%20-0.75%207.875%20C-2.67489773%2011.86982201%20-3.6541481%2015.64856188%20-4.5%2020%20C-6.14314994%2028.23351349%20-8.48832937%2034.59935024%20-14%2041%20C-15.0268343%2042.6502694%20-16.03567924%2044.31243867%20-17%2046%20C-17.6328125%2044.2109375%20-17.6328125%2044.2109375%20-18%2042%20C-16.84712785%2040.16896777%20-15.68454609%2038.34329798%20-14.47265625%2036.55078125%20C-12.05514348%2032.36341828%20-10.65874121%2027.83543414%20-9.11328125%2023.26953125%20C-8.15924073%2020.46766487%20-7.1033589%2017.74471925%20-6%2015%20C-5.50985567%2013.5244346%20-5.0303323%2012.0452905%20-4.5625%2010.5625%20C-3.34672387%206.85314221%20-1.85472925%203.44449719%200%200%20Z%20%22%20fill%3D%22%23808080%22%20transform%3D%22translate(673%2C498)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1%203%201%203%200.27734375%204.9453125%20C-1.10682751%207.17183874%20-2.64907663%208.95965627%20-4.4375%2010.875%20C-7.31703434%2014.09225751%20-9.15838884%2017.07656752%20-11%2021%20C-11.88414117%2022.32822474%20-12.7860293%2023.64470168%20-13.69921875%2024.953125%20C-17.33275141%2030.34903307%20-20.29186341%2036.02629564%20-23.25%2041.8125%20C-23.77851563%2042.83537109%20-24.30703125%2043.85824219%20-24.8515625%2044.91210938%20C-26.92482522%2048.92971366%20-28.98494932%2052.95285182%20-31%2057%20C-32%2054%20-32%2054%20-31.27832031%2051.92553711%20C-30.68422363%2050.7384314%20-30.68422363%2050.7384314%20-30.078125%2049.52734375%20C-29.63525146%2048.63660156%20-29.19237793%2047.74585938%20-28.73608398%2046.828125%20C-28.24567627%2045.87421875%20-27.75526855%2044.9203125%20-27.25%2043.9375%20C-26.74992432%2042.95394531%20-26.24984863%2041.97039062%20-25.73461914%2040.95703125%20C-18.29198818%2026.52170754%20-9.66350289%2013.03839219%200%200%20Z%20%22%20fill%3D%22%23171717%22%20transform%3D%22translate(182%2C245)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C8.72582538%2010.50381488%2013.03632531%2025.26107379%2017.625%2037.9375%20C18.07496338%2039.16404297%2018.52492676%2040.39058594%2018.98852539%2041.65429688%20C19.39707764%2042.80865234%2019.80562988%2043.96300781%2020.2265625%2045.15234375%20C20.59346191%2046.18351318%2020.96036133%2047.21468262%2021.33837891%2048.27709961%20C22.00807107%2051.03321648%2021.97910851%2052.38004338%2021%2055%20C20.71801758%2054.19892822%2020.43603516%2053.39785645%2020.14550781%2052.57250977%20C19.0823377%2049.55779991%2018.01587013%2046.54428157%2016.94726562%2043.53149414%20C16.4882899%2042.23540197%2016.03057363%2040.93886299%2015.57421875%2039.6418457%20C13.18601149%2032.85692792%2010.78305801%2026.15200426%207.69042969%2019.65209961%20C7%2018%207%2018%207%2016%20C6.01%2016%205.02%2016%204%2016%20C1.18150494%2010.45108785%20-0.5326514%206.258654%200%200%20Z%20%22%20fill%3D%22%23171717%22%20transform%3D%22translate(682%2C283)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C6.80840346%201.22023787%2013.31958043%202.85994951%2019.875%205.0625%20C21.21606812%205.51061035%2021.21606812%205.51061035%2022.58422852%205.96777344%20C34.44682324%2010.0456378%2045.82139361%2015.32995246%2057%2021%20C57%2021.33%2057%2021.66%2057%2022%20C51.36529617%2022.5497272%2048.61012242%2020.95047835%2044%2018%20C44%2017.34%2044%2016.68%2044%2016%20C43.443125%2015.81824219%2042.88625%2015.63648438%2042.3125%2015.44921875%20C38.56590898%2014.21512205%2034.85306199%2012.95850782%2031.1875%2011.5%20C26.77346597%209.80914019%2022.22914369%208.74215202%2017.63671875%207.6484375%20C15%207%2015%207%2012%206%20C12%205.34%2012%204.68%2012%204%20C11.30132812%203.87882813%2010.60265625%203.75765625%209.8828125%203.6328125%20C8.97273438%203.46523437%208.06265625%203.29765625%207.125%203.125%20C5.76761719%202.88136719%205.76761719%202.88136719%204.3828125%202.6328125%20C2%202%202%202%200%200%20Z%20%22%20fill%3D%22%231C0F04%22%20transform%3D%22translate(497%2C135)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.0625%200.4375%202.0625%200.4375%204%201%20C3.09378906%201.88300781%202.18757813%202.76601562%201.25390625%203.67578125%20C-5.34275937%2010.15908652%20-11.57199329%2016.57746187%20-17.1328125%2023.98828125%20C-19.12014768%2026.12944782%20-20.1433726%2026.66355277%20-23%2027%20C-18.93601985%2021.40272331%20-14.62224061%2016.14305645%20-10%2011%20C-9.20464844%2010.11183594%20-8.40929687%209.22367188%20-7.58984375%208.30859375%20C-1.29079861%201.29079861%20-1.29079861%201.29079861%200%200%20Z%20%22%20fill%3D%22%23B16527%22%20transform%3D%22translate(218%2C227)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.80431587%202.30227069%201.18319392%203.52470479%200.29077148%205.84008789%20C-0.09522217%206.46133545%20-0.48121582%207.08258301%20-0.87890625%207.72265625%20C-1.30300781%208.42108643%20-1.72710938%209.1195166%20-2.1640625%209.83911133%20C-2.62554688%2010.57282959%20-3.08703125%2011.30654785%20-3.5625%2012.0625%20C-4.49219679%2013.58774311%20-5.42058287%2015.11378592%20-6.34765625%2016.640625%20C-7.03045654%2017.7553418%20-7.03045654%2017.7553418%20-7.72705078%2018.89257812%20C-10.7108212%2023.83233767%20-13.55243327%2028.91335966%20-16.00390625%2034.140625%20C-17.48545114%2036.90617547%20-19.79025394%2038.79025394%20-22%2041%20C-23.01656081%2042.65661761%20-24.02065076%2044.32111559%20-25%2046%20C-25.99%2046.495%20-25.99%2046.495%20-27%2047%20C-26.48307868%2042.64860261%20-25.05803598%2040.50930988%20-22.1875%2037.25%20C-19.0170162%2033.43980796%20-16.94683817%2030.06945611%20-15.12890625%2025.49609375%20C-12.66196802%2020.04151406%20-9.18804886%2015.05374481%20-6%2010%20C-5.19755859%208.56914063%20-5.19755859%208.56914063%20-4.37890625%207.109375%20C-3.92386719%206.41328125%20-3.46882812%205.7171875%20-3%205%20C-2.34%205%20-1.68%205%20-1%205%20C-0.67%203.35%20-0.34%201.7%200%200%20Z%20%22%20fill%3D%22%235F5F5F%22%20transform%3D%22translate(654%2C544)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-3.96919341%202.95743823%20-7.35802067%205.25925775%20-12%207%20C-13.19465207%207.69620313%20-14.38172844%208.4055065%20-15.5625%209.125%20C-19%2011%20-19%2011%20-23%2011%20C-23%2011.66%20-23%2012.32%20-23%2013%20C-23.88042969%2013.32613281%20-24.76085937%2013.65226562%20-25.66796875%2013.98828125%20C-27.41013672%2014.64376953%20-27.41013672%2014.64376953%20-29.1875%2015.3125%20C-30.33605469%2015.74175781%20-31.48460937%2016.17101562%20-32.66796875%2016.61328125%20C-35.98994582%2017.88609653%20-35.98994582%2017.88609653%20-38.73828125%2019.73046875%20C-39.48464844%2020.14941406%20-40.23101563%2020.56835938%20-41%2021%20C-41.99%2020.67%20-42.98%2020.34%20-44%2020%20C-41.80632513%2017.56412127%20-39.82130477%2016.27807636%20-36.8125%2015%20C-35.61560547%2014.48953125%20-35.61560547%2014.48953125%20-34.39453125%2013.96875%20C-32.27374741%2013.11074936%20-30.14632163%2012.29142922%20-28%2011.5%20C-19.77168638%208.54850137%20-19.77168638%208.54850137%20-12.4375%203.9375%20C-9.17275888%201.34244937%20-4.05218466%20-2.02609233%200%200%20Z%20%22%20fill%3D%22%23A77D5B%22%20transform%3D%22translate(640%2C257)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-0.33%200.99%20-0.66%201.98%20-1%203%20C-1.598125%202.773125%20-2.19625%202.54625%20-2.8125%202.3125%20C-3.8953125%202.1578125%20-3.8953125%202.1578125%20-5%202%20C-5.4125%202.45375%20-5.825%202.9075%20-6.25%203.375%20C-8.6008259%205.55790976%20-10.70008139%205.35323051%20-13.79296875%205.6171875%20C-17.55448641%206.26962773%20-20.71450187%208.12132421%20-24%2010%20C-24%207%20-24%207%20-22.75%204.5%20C-18.50307113%200.63915557%20-13.52556264%200.07461665%20-8%20-1%20C-7.11183594%20-1.23203125%20-6.22367187%20-1.4640625%20-5.30859375%20-1.703125%20C-3%20-2%20-3%20-2%200%200%20Z%20%22%20fill%3D%22%238F4206%22%20transform%3D%22translate(354%2C148)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-3.4019487%202.09350689%20-6.05272412%202.17942163%20-10%202%20C-10.309375%202.8971875%20-10.309375%202.8971875%20-10.625%203.8125%20C-12.52919641%206.84190338%20-14.76615434%207.57710791%20-18%209%20C-18.680625%209.37125%20-19.36125%209.7425%20-20.0625%2010.125%20C-22.34149835%2011.15422506%20-24.54053584%2011.59008931%20-27%2012%20C-25.625%209.5%20-25.625%209.5%20-24%207%20C-23.34%207%20-22.68%207%20-22%207%20C-22.33%206.34%20-22.66%205.68%20-23%205%20C-25.02463255%204.34786708%20-25.02463255%204.34786708%20-27%204%20C-21.97290428%202.49515697%20-16.96607895%201.29482538%20-11.8125%200.3125%20C-10.76545898%200.09883789%20-10.76545898%200.09883789%20-9.69726562%20-0.11914062%20C-6.20395135%20-0.78722452%20-3.37880534%20-1.30088371%200%200%20Z%20%22%20fill%3D%22%23743E13%22%20transform%3D%22translate(373%2C136)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.53398049%203.07455689%203.96293359%206.04527132%205.375%209.76171875%20C6.01695312%2011.44104492%206.01695312%2011.44104492%206.671875%2013.15429688%20C7.11015625%2014.32025391%207.5484375%2015.48621094%208%2016.6875%20C8.43828125%2017.83412109%208.8765625%2018.98074219%209.328125%2020.16210938%20C16.44284814%2038.8811174%2016.44284814%2038.8811174%2016%2047%20C15.67%2047%2015.34%2047%2015%2047%20C14.1606242%2043.89743488%2013.3295495%2040.79270556%2012.5%2037.6875%20C12.26152344%2036.80642578%2012.02304687%2035.92535156%2011.77734375%2035.01757812%20C11.43896484%2033.74624023%2011.43896484%2033.74624023%2011.09375%2032.44921875%20C10.77954102%2031.27879028%2010.77954102%2031.27879028%2010.45898438%2030.0847168%20C10%2028%2010%2028%2010%2025%20C9.34%2025%208.68%2025%208%2025%20C7.67%2025.99%207.34%2026.98%207%2028%20C6.34%2025.03%205.68%2022.06%205%2019%20C4.67%2019%204.34%2019%204%2019%20C3.52040222%2016.77092605%203.0413392%2014.54173703%202.5625%2012.3125%20C2.16224609%2010.45044922%202.16224609%2010.45044922%201.75390625%208.55078125%20C1.14944864%205.70387985%200.56235316%202.85544374%200%200%20Z%20%22%20fill%3D%22%23313131%22%20transform%3D%22translate(688%2C299)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-0.73863281%200.30292969%20-1.47726562%200.60585937%20-2.23828125%200.91796875%20C-11.00924449%204.54003108%20-19.64196124%208.36957921%20-28.18359375%2012.50390625%20C-29.1176001%2012.95419189%20-30.05160645%2013.40447754%20-31.01391602%2013.8684082%20C-32.89580688%2014.77715642%20-34.77528465%2015.69092183%20-36.65209961%2016.61010742%20C-37.52745361%2017.03267822%20-38.40280762%2017.45524902%20-39.3046875%2017.890625%20C-40.4800708%2018.46345215%20-40.4800708%2018.46345215%20-41.67919922%2019.04785156%20C-44.10956605%2020.04495136%20-46.41405056%2020.56853156%20-49%2021%20C-46.77904818%2018.53628991%20-44.70339666%2017.20941712%20-41.69140625%2015.84375%20C-40.86189453%2015.46089844%20-40.03238281%2015.07804687%20-39.17773438%2014.68359375%20C-38.31470703%2014.29300781%20-37.45167969%2013.90242187%20-36.5625%2013.5%20C-34.85350032%2012.72306541%20-33.14639524%2011.94194702%20-31.44140625%2011.15625%20C-30.68545166%2010.81400391%20-29.92949707%2010.47175781%20-29.15063477%2010.11914062%20C-26.9415091%209.04515968%20-26.9415091%209.04515968%20-24.94311523%207.44750977%20C-22.09197766%205.32357527%20-18.85723512%204.47074615%20-15.5%203.4375%20C-10.51220766%201.93139001%20-10.51220766%201.93139001%20-5.78125%20-0.21484375%20C-3.49385575%20-1.22310306%20-2.30660977%20-0.8237892%200%200%20Z%20%22%20fill%3D%22%23A8774F%22%20transform%3D%22translate(329%2C146)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.70661294%203.5640514%20-6.51425647%204.28077891%20-10.625%205.4375%20C-15.93716393%207.00747495%20-20.96261018%208.72003291%20-25.98046875%2011.08984375%20C-31.07827274%2013.38730667%20-36.47686291%2015.10917144%20-42%2016%20C-36.8248121%2011.97485385%20-31.5893799%209.29968095%20-25.4375%207.0625%20C-24.38502075%206.67553955%20-24.38502075%206.67553955%20-23.3112793%206.28076172%20C-21.21016735%205.51294207%20-19.10576767%204.75494548%20-17%204%20C-15.83210938%203.57847656%20-14.66421875%203.15695313%20-13.4609375%202.72265625%20C-4.98202309%20-0.23339207%20-4.98202309%20-0.23339207%200%200%20Z%20%22%20fill%3D%22%23F6D1A9%22%20transform%3D%22translate(341%2C139)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.17041159%207.76139184%200.91086196%2015.90650309%200.125%2023.8125%20C0.04660889%2024.63693604%20-0.03178223%2025.46137207%20-0.11254883%2026.31079102%20C-0.56034316%2030.52469453%20-1.13341596%2034.13350448%20-3%2038%20C-4.27593588%2034.22890063%20-3.89166397%2030.86714893%20-3.5625%2026.9375%20C-3.1906014%2022.27772938%20-2.95871348%2017.67688012%20-3.0625%2013%20C-3.11518159%208.58791724%20-2.52911368%205.13760172%20-1%201%20C-0.67%200.67%20-0.34%200.34%200%200%20Z%20%22%20fill%3D%22%23A2A2A2%22%20transform%3D%22translate(686%2C407)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200%201.32%200%202%200%20C2.50546036%202.08201528%203.00416835%204.16567067%203.5%206.25%20C3.7784375%207.41015625%204.056875%208.5703125%204.34375%209.765625%20C5%2013%205%2013%205%2017%20C5.66%2017%206.32%2017%207%2017%20C10.09424624%2025.85912168%2010.33786247%2033.72755227%2010%2043%20C7.94597102%2039.35575504%207.62533506%2036.32989187%207.34375%2032.21875%20C7.11935065%2029.99471741%207.11935065%2029.99471741%206.05908203%2028.17773438%20C4.8909639%2025.77579484%204.30275497%2023.54053848%203.7109375%2020.9375%20C3.38222656%2019.49503906%203.38222656%2019.49503906%203.046875%2018.0234375%20C2.82515625%2017.02570313%202.6034375%2016.02796875%202.375%2015%20C2.14554688%2014.00226563%201.91609375%2013.00453125%201.6796875%2011.9765625%20C0.7482778%207.84065993%200%204.26265%200%200%20Z%20%22%20fill%3D%22%234F4F4F%22%20transform%3D%22translate(700%2C344)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-1.27227629%204.4246617%20-4.78775802%207.38732066%20-8.5%2010.3125%20C-9.35271484%2011.01342773%20-9.35271484%2011.01342773%20-10.22265625%2011.72851562%20C-11.90625%2013.05078125%20-11.90625%2013.05078125%20-15%2015%20C-17.19335938%2014.62182617%20-17.19335938%2014.62182617%20-19%2014%20C-16.58820862%2012.0356004%20-14.16974955%2010.07958512%20-11.75%208.125%20C-11.06808594%207.56941406%20-10.38617188%207.01382813%20-9.68359375%206.44140625%20C-9.01972656%205.90644531%20-8.35585937%205.37148437%20-7.671875%204.8203125%20C-7.0644043%204.32805176%20-6.45693359%203.83579102%20-5.83105469%203.32861328%20C-3.93762896%201.95474357%20-2.17245298%200.87245085%200%200%20Z%20M-21%2015%20C-20.34%2015.33%20-19.68%2015.66%20-19%2016%20C-19.99%2016%20-20.98%2016%20-22%2016%20C-21.67%2015.67%20-21.34%2015.34%20-21%2015%20Z%20M-23%2017%20C-23%2017.99%20-23%2018.98%20-23%2020%20C-23.99%2020%20-24.98%2020%20-26%2020%20C-25.01%2019.01%20-24.02%2018.02%20-23%2017%20Z%20M-28%2021%20C-27.34%2021.33%20-26.68%2021.66%20-26%2022%20C-28.86536704%2026.07763771%20-31.43041625%2028.02677065%20-36%2030%20C-36%2029.34%20-36%2028.68%20-36%2028%20C-34.25%2026.2734375%20-34.25%2026.2734375%20-32%2024.375%20C-31.2575%2023.74335938%20-30.515%2023.11171875%20-29.75%2022.4609375%20C-29.1725%2021.97882813%20-28.595%2021.49671875%20-28%2021%20Z%20%22%20fill%3D%22%23783806%22%20transform%3D%22translate(263%2C185)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C6.21394924%201.62620374%2011.68351561%203.74877755%2017.35546875%206.75%20C20.24760272%208.11703526%2023.1242254%209.02195093%2026.1875%209.9375%20C31.69799364%2011.66530639%2034.93508814%2013.93508814%2039%2018%20C38.01%2018.495%2038.01%2018.495%2037%2019%20C34.85546875%2018.21484375%2034.85546875%2018.21484375%2032.1875%2016.9375%20C31.20910156%2016.47601562%2030.23070312%2016.01453125%2029.22265625%2015.5390625%20C28.15917969%2015.03117188%2027.09570312%2014.52328125%2026%2014%20C23.70985973%2012.93421395%2021.41819384%2011.87169988%2019.125%2010.8125%20C18.07570313%2010.32394531%2017.02640625%209.83539062%2015.9453125%209.33203125%20C14.11267634%208.50321304%2012.26145622%207.71297252%2010.38671875%206.984375%20C7.97955344%205.99156705%205.88755178%204.82547994%203.6875%203.4375%20C2.99011719%203.00308594%202.29273438%202.56867187%201.57421875%202.12109375%20C1.05472656%201.75113281%200.53523438%201.38117187%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23434343%22%20transform%3D%22translate(276%2C530)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.1875%20-0.25%202.1875%20-0.25%205%200%20C5.70125%200.5775%206.4025%201.155%207.125%201.75%20C10.63371448%204.49595046%2014.07837616%205.59727759%2018.28125%206.97265625%20C21.1106603%208.0418156%2023.41063599%209.44257371%2026%2011%20C28.63751316%2012.23517842%2031.31743526%2013.36659165%2034%2014.5%20C38.53199822%2016.41481106%2042.8414498%2018.33592878%2047%2021%20C45%2022%2045%2022%2041.5%2020.875%20C37.43670661%2019.26722204%2033.58933968%2017.31110346%2029.703125%2015.3203125%20C26.84313039%2013.92337871%2023.94713047%2012.70152242%2021%2011.5%20C15.52061231%209.26423948%2010.24901872%206.72902522%205%204%20C5%203.34%205%202.68%205%202%20C3.35%201.67%201.7%201.34%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23C97633%22%20transform%3D%22translate(262%2C285)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66015625%201.78125%200.66015625%201.78125%201%204%20C-0.00390625%205.71875%20-0.00390625%205.71875%20-1.5625%207.5%20C-5.63519986%2012.53603168%20-8.2570965%2018.16403512%20-11%2024%20C-11.66%2024%20-12.32%2024%20-13%2024%20C-13.226875%2024.78375%20-13.45375%2025.5675%20-13.6875%2026.375%20C-15.40660933%2031.12301625%20-17.68084721%2035.52102552%20-20%2040%20C-21.07484617%2037.28809273%20-21.07012465%2036.18750568%20-20.03125%2033.40966797%20C-19.5259375%2032.44689941%20-19.020625%2031.48413086%20-18.5%2030.4921875%20C-17.94183594%2029.42226563%20-17.38367188%2028.35234375%20-16.80859375%2027.25%20C-16.21175781%2026.13625%20-15.61492187%2025.0225%20-15%2023.875%20C-14.43410156%2022.78445313%20-13.86820313%2021.69390625%20-13.28515625%2020.5703125%20C-5.15160206%205.15160206%20-5.15160206%205.15160206%200%200%20Z%20%22%20fill%3D%22%23767676%22%20transform%3D%22translate(184%2C269)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C0.27832031%204.05273438%200.27832031%204.05273438%20-0.921875%206.59375%20C-1.3653125%207.53379883%20-1.80875%208.47384766%20-2.265625%209.44238281%20C-2.75546875%2010.45139648%20-3.2453125%2011.46041016%20-3.75%2012.5%20C-4.245%2013.52706055%20-4.74%2014.55412109%20-5.25%2015.61230469%20C-16.81028149%2039.17805528%20-16.81028149%2039.17805528%20-24%2046%20C-23.41512359%2041.99251347%20-22.15605425%2039.14263232%20-20.0625%2035.6875%20C-19.53785156%2034.80449219%20-19.01320313%2033.92148437%20-18.47265625%2033.01171875%20C-17.98667969%2032.34785156%20-17.50070312%2031.68398438%20-17%2031%20C-16.34%2031%20-15.68%2031%20-15%2031%20C-14.73058594%2030.13503906%20-14.46117187%2029.27007813%20-14.18359375%2028.37890625%20C-13.02463335%2025.07032292%20-11.64688718%2022.06192764%20-10.0625%2018.9375%20C-9.55847656%2017.93589844%20-9.05445313%2016.93429687%20-8.53515625%2015.90234375%20C-7.5439635%2014.02840936%20-6.50480265%2012.17872676%20-5.41015625%2010.36328125%20C-4.20621086%208.34558884%20-3.24990652%206.42284477%20-2.375%204.25%20C-1%201%20-1%201%200%200%20Z%20%22%20fill%3D%22%232D2D2D%22%20transform%3D%22translate(674%2C529)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0%200.33%200%200.66%200%201%20C-0.74459473%201.13051758%20-1.48918945%201.26103516%20-2.25634766%201.39550781%20C-20.45947898%204.56957758%20-20.45947898%204.56957758%20-38.30078125%209.28515625%20C-42.00883761%2010.26717407%20-45.19258153%2010.30459348%20-49%2010%20C-45.95081311%207.96720874%20-43.97041483%207.36997777%20-40.44140625%206.5625%20C-39.33216797%206.30726563%20-38.22292969%206.05203125%20-37.08007812%205.7890625%20C-35.91927734%205.52867187%20-34.75847656%205.26828125%20-33.5625%205%20C-31.87350586%204.60941406%20-31.87350586%204.60941406%20-30.15039062%204.2109375%20C-9.97383413%20-0.383609%20-9.97383413%20-0.383609%200%200%20Z%20%22%20fill%3D%22%233D2C1F%22%20transform%3D%22translate(387%2C127)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.09375%203.76660156%201.09375%203.76660156%200.25%205.8671875%20C-0.1625%206.52976562%20-0.575%207.19234375%20-1%207.875%20C-3.46608258%2012.02218676%20-5.6749028%2016.24031343%20-7.8125%2020.5625%20C-8.12638672%2021.19462402%20-8.44027344%2021.82674805%20-8.76367188%2022.47802734%20C-9.51088873%2023.98447286%20-10.25570627%2025.4921081%20-11%2027%20C-11.66%2027%20-12.32%2027%20-13%2027%20C-13.185625%2027.804375%20-13.37125%2028.60875%20-13.5625%2029.4375%20C-15.53232435%2034.31923861%20-18.65622186%2037.97673753%20-22%2042%20C-22%2037.9410721%20-20.29808181%2036.3194515%20-18%2033%20C-16.64849159%2030.67529001%20-15.31608816%2028.34460363%20-14%2026%20C-13.40880371%2024.9488501%20-13.40880371%2024.9488501%20-12.80566406%2023.87646484%20C-11.53293587%2021.60744942%20-10.26588523%2019.33533939%20-9%2017.0625%20C-8.57460938%2016.30259766%20-8.14921875%2015.54269531%20-7.7109375%2014.75976562%20C-5.00531712%209.90043823%20-2.45323552%204.99165282%200%200%20Z%20%22%20fill%3D%22%23656565%22%20transform%3D%22translate(670%2C533)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.4123551%204.44700997%200.07203271%207.78682621%20-1.375%2012.0625%20C-1.60960937%2012.78244141%20-1.84421875%2013.50238281%20-2.0859375%2014.24414062%20C-2.71407251%2016.16601963%20-3.35630848%2018.08327526%20-4%2020%20C-4.33%2020.99%20-4.66%2021.98%20-5%2023%20C-5.66%2023%20-6.32%2023%20-7%2023%20C-7.12246094%2023.71542969%20-7.24492188%2024.43085938%20-7.37109375%2025.16796875%20C-8.01135375%2028.05112713%20-8.93551556%2030.58592473%20-10.0625%2033.3125%20C-10.42472656%2034.19550781%20-10.78695312%2035.07851563%20-11.16015625%2035.98828125%20C-11.43730469%2036.65214844%20-11.71445312%2037.31601562%20-12%2038%20C-13%2036%20-13%2036%20-12.58422852%2034.2512207%20C-12.33084717%2033.54570068%20-12.07746582%2032.84018066%20-11.81640625%2032.11328125%20C-11.53297363%2031.30842285%20-11.24954102%2030.50356445%20-10.95751953%2029.67431641%20C-10.64153809%2028.79179199%20-10.32555664%2027.90926758%20-10%2027%20C-9.34075707%2025.07740186%20-8.68327032%2023.15420084%20-8.02734375%2021.23046875%20C-7.33136335%2019.21592662%20-6.63474042%2017.20160637%20-5.9375%2015.1875%20C-5.58623047%2014.16462891%20-5.23496094%2013.14175781%20-4.87304688%2012.08789062%20C-4.53208984%2011.10369141%20-4.19113281%2010.11949219%20-3.83984375%209.10546875%20C-3.38146118%207.77745239%20-3.38146118%207.77745239%20-2.91381836%206.42260742%20C-2.07176672%204.19025946%20-1.1106119%202.10939666%200%200%20Z%20%22%20fill%3D%22%23979797%22%20transform%3D%22translate(680%2C483)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C6.25239269%201.10929548%2011.23641852%202.883608%2016.8359375%205.87890625%20C19.08261963%207.11398332%2019.08261963%207.11398332%2022%208%20C22%208.66%2022%209.32%2022%2010%20C22.515625%2010.0825%2023.03125%2010.165%2023.5625%2010.25%20C27.04455732%2011.32140225%2029.87200885%2013.13523605%2033%2015%20C31%2016%2031%2016%2028.2421875%2015.1796875%20C22.40281179%2012.91709877%2017.03179619%2010.64713329%2011.84765625%207.125%20C9.82757844%205.89501605%207.85890417%205.14228014%205.625%204.375%20C2%203%202%203%200%200%20Z%20%22%20fill%3D%22%23BA7944%22%20transform%3D%22translate(221%2C266)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C4.78014159%201.22046168%209.06239381%202.86159611%2013.53515625%204.93359375%20C16.2121779%206.09179805%2018.9224095%207.01080074%2021.6875%207.9375%20C24.9795933%209.10183258%2027.53253236%2010.15169829%2030.125%2012.5%20C33.30602625%2015.26610978%2036.26058841%2016.57661353%2040.14453125%2018.10546875%20C42%2019%2042%2019%2043%2021%20C36.7087879%2018.56469209%2030.52494952%2016.09409298%2024.875%2012.375%20C21.35449655%2010.09498891%2018.08082678%209.05538624%2014%208%20C10.63959614%206.73182997%207.31786958%205.37521355%204%204%20C4%203.34%204%202.68%204%202%20C2.68%201.67%201.36%201.34%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23A57D5C%22%20transform%3D%22translate(302%2C305)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C3.82177543%201.51428838%206.91288228%202.97942901%2010.3125%205.3125%20C11.25%208.0625%2011.25%208.0625%2011.3125%2010.3125%20C6.04832038%209.90756311%203.78980515%209.25344584%200.3125%205.3125%20C-0.595%204.77625%20-1.5025%204.24%20-2.4375%203.6875%20C-3.18%203.23375%20-3.9225%202.78%20-4.6875%202.3125%20C-4.6875%201.6525%20-4.6875%200.9925%20-4.6875%200.3125%20C-2.6875%20-0.6875%20-2.6875%20-0.6875%200%200%20Z%20%22%20fill%3D%22%233A1B03%22%20transform%3D%22translate(556.6875%2C157.6875)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.29228557%203.69112221%200.73540388%206.50968327%200.00390625%2010.3046875%20C-0.22490234%2011.52800781%20-0.45371094%2012.75132812%20-0.68945312%2014.01171875%20C-0.93630859%2015.28660156%20-1.18316406%2016.56148438%20-1.4375%2017.875%20C-1.92021788%2020.39230335%20-2.39825138%2022.91051049%20-2.87109375%2025.4296875%20C-3.08693115%2026.54585449%20-3.30276855%2027.66202148%20-3.52514648%2028.81201172%20C-3.98930844%2031.92822088%20-4.08569876%2034.85494453%20-4%2038%20C-4.99%2038%20-5.98%2038%20-7%2038%20C-6.60284212%2032.31437138%20-6.08970099%2026.94955238%20-4.53515625%2021.4453125%20C-3.60669904%2017.20287299%20-3.21815438%2012.86432827%20-2.78540039%208.54614258%20C-2.39420389%204.97567117%20-2.03176078%203.04764117%200%200%20Z%20%22%20fill%3D%22%23CACACA%22%20transform%3D%22translate(686%2C437)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-3.12501561%203.59873436%20-5.96746798%204.99669688%20-10.4375%206.5625%20C-13.75076265%207.73346768%20-16.71833564%208.83100139%20-19.734375%2010.640625%20C-22.37284877%2012.22370926%20-23.97629432%2012.25917477%20-27%2012%20C-23.73241674%208.13907042%20-20.07996204%206.56723785%20-15.4375%204.875%20C-2.09687576%20-0.11334464%20-2.09687576%20-0.11334464%200%200%20Z%20%22%20fill%3D%22%233E3E3E%22%20transform%3D%22translate(486%2C568)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C5.18546243%201.24451098%208.53593174%202.99160617%2013%206%20C15.7282504%206.78215588%2015.7282504%206.78215588%2018%207%20C18%207.66%2018%208.32%2018%209%20C19.2684375%209.1546875%2019.2684375%209.1546875%2020.5625%209.3125%20C24.41442701%2010.0828854%2027.44075031%2011.36274514%2031%2013%20C31%2013.66%2031%2014.32%2031%2015%20C29.60190528%2014.74109357%2028.20657858%2014.46722539%2026.8125%2014.1875%20C26.03519531%2014.03667969%2025.25789063%2013.88585937%2024.45703125%2013.73046875%20C21.62786606%2012.88936559%2019.52408715%2011.52276515%2017%2010%20C13.70848642%208.75107808%2010.39166258%207.60942057%207.05859375%206.4765625%20C3.63496185%204.82377469%202.12519166%203.10724845%200%200%20Z%20%22%20fill%3D%22%23444444%22%20transform%3D%22translate(172%2C480)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C7.81636537%201.91722169%207.81636537%201.91722169%2010%205%20C10%205.66%2010%206.32%2010%207%20C10.55300781%207.08378906%2011.10601563%207.16757813%2011.67578125%207.25390625%20C14.745867%208.23942958%2016.69629157%209.90258381%2019.1875%2011.9375%20C20.06792969%2012.64777344%2020.94835937%2013.35804688%2021.85546875%2014.08984375%20C24%2016%2024%2016%2025%2018%20C20.14408819%2017.53623314%2017.07023849%2015.13609784%2013.375%2012.1875%20C12.80265625%2011.74857422%2012.2303125%2011.30964844%2011.640625%2010.85742188%20C8.60406564%208.48113763%206.21761257%206.14103484%204%203%20C1.91665365%201.7483533%201.91665365%201.7483533%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23572803%22%20transform%3D%22translate(569%2C168)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.39985155%202.77877548%20-4.59462991%203.71352686%20-8%205%20C-11.63192396%206.67849872%20-15.11510306%208.33034826%20-18.3125%2010.75%20C-20%2012%20-20%2012%20-23%2012%20C-23%2011.34%20-23%2010.68%20-23%2010%20C-20.67638014%207.85605223%20-18.02409861%206.1242585%20-15.4375%204.3125%20C-14.73302734%203.78849609%20-14.02855469%203.26449219%20-13.30273438%202.72460938%20C-8.40963053%20-0.70732798%20-5.81436311%20-1.62741044%200%200%20Z%20%22%20fill%3D%22%23B9865D%22%20transform%3D%22translate(273%2C171)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.5625%202.125%202.5625%202.125%203.5625%205.125%20C0.60074877%204.51222388%20-0.81808783%203.87127478%20-3.4375%202.125%20C-6.63556665%201.6646236%20-6.63556665%201.6646236%20-10.125%201.5%20C-11.30449219%201.42523438%20-12.48398437%201.35046875%20-13.69921875%201.2734375%20C-14.60285156%201.22445312%20-15.50648438%201.17546875%20-16.4375%201.125%20C-16.4375%200.135%20-16.4375%20-0.855%20-16.4375%20-1.875%20C-10.44604247%20-3.56009743%20-5.36418941%20-2.9259215%200%200%20Z%20%22%20fill%3D%22%23602C04%22%20transform%3D%22translate(572.4375%2C169.875)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C6.75%201.75%206.75%201.75%209%204%20C12.83381338%205.55951731%2016.48549437%206.87137359%2020.5%207.875%20C24.83287789%209.26771075%2028.25834307%2011.45372957%2032%2014%20C31.01%2014.495%2031.01%2014.495%2030%2015%20C28%2014%2026%2013%2024%2012%20C20.7633037%2011.29241674%2020.7633037%2011.29241674%2018%2011%20C18%2010.34%2018%209.68%2018%209%20C17.3709375%208.84144531%2016.741875%208.68289063%2016.09375%208.51953125%20C10.10712074%206.88763382%204.9364462%204.83332973%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23292929%22%20transform%3D%22translate(209%2C499)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.32%200%202.64%200%204%200%20C3.51823215%2010.88795342%200.13818645%2020.45765373%20-5%2030%20C-6.51325464%2026.97349071%20-5.31701478%2025.08986403%20-4.34765625%2021.8984375%20C-3.98349609%2020.68671875%20-3.61933594%2019.475%20-3.24414062%2018.2265625%20C-2.85041716%2016.94266026%20-2.45653488%2015.6588067%20-2.0625%2014.375%20C-1.6718578%2013.08353527%20-1.28187539%2011.79187078%20-0.89257812%2010.5%20C0.06512499%207.33130327%201.02958499%204.16482239%202%201%20C1.34%200.67%200.68%200.34%200%200%20Z%20%22%20fill%3D%22%232F2F2F%22%20transform%3D%22translate(674%2C478)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.8197996%202.35361821%201.1148421%203.63151889%200.36328125%206.04296875%20C0.01652344%206.75066406%20-0.33023438%207.45835937%20-0.6875%208.1875%20C-1.86499008%2010.62745367%20-3.01366164%2013.03418027%20-4.01953125%2015.55078125%20C-4.34308594%2016.35902344%20-4.66664063%2017.16726563%20-5%2018%20C-5.28875%2018.7425%20-5.5775%2019.485%20-5.875%2020.25%20C-7%2022%20-7%2022%20-9.125%2022.75%20C-10.053125%2022.87375%20-10.053125%2022.87375%20-11%2023%20C-10.42365861%2018.24518354%20-8.44931479%2015.02951788%20-6%2011%20C-5.34%2011%20-4.68%2011%20-4%2011%20C-3.69255859%209.93458984%20-3.69255859%209.93458984%20-3.37890625%208.84765625%20C-3.10949219%207.92855469%20-2.84007812%207.00945313%20-2.5625%206.0625%20C-2.29566406%205.14597656%20-2.02882813%204.22945312%20-1.75390625%203.28515625%20C-1%201%20-1%201%200%200%20Z%20%22%20fill%3D%22%23C5C5C5%22%20transform%3D%22translate(666%2C525)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.95699576%202.55591031%201.10383443%203.71093178%200.16723633%206.31835938%20C-0.27338135%207.15173828%20-0.71399902%207.98511719%20-1.16796875%208.84375%20C-1.64943359%209.76027344%20-2.13089844%2010.67679688%20-2.62695312%2011.62109375%20C-3.14193359%2012.57113281%20-3.65691406%2013.52117188%20-4.1875%2014.5%20C-4.68314453%2015.45003906%20-5.17878906%2016.40007813%20-5.68945312%2017.37890625%20C-8.08987595%2021.88802284%20-10.2423659%2025.48686136%20-14%2029%20C-14.5775%2029.5775%20-15.155%2030.155%20-15.75%2030.75%20C-16.1625%2031.1625%20-16.575%2031.575%20-17%2032%20C-15.80100302%2028.9168649%20-14.52299523%2025.93720508%20-13%2023%20C-12.34%2023%20-11.68%2023%20-11%2023%20C-10.76539063%2022.19304688%20-10.53078125%2021.38609375%20-10.2890625%2020.5546875%20C-8.69999965%2016.1727263%20-6.59350886%2012.21537571%20-4.375%208.125%20C-3.95476563%207.34125%20-3.53453125%206.5575%20-3.1015625%205.75%20C-2.0718978%203.83107943%20-1.03652433%201.91522397%200%200%20Z%20%22%20fill%3D%22%23B1B1B1%22%20transform%3D%22translate(670%2C529)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C6.46326465%20-0.45356243%209.60931587%200.40621058%2015%204%20C15%204.33%2015%204.66%2015%205%20C9.39%205%203.78%205%20-2%205%20C-1.34%203.35%20-0.68%201.7%200%200%20Z%20%22%20fill%3D%22%236F3305%22%20transform%3D%22translate(542%2C158)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C5.04196983%200.50419698%2010.24504438%201.24504438%2014%205%20C16.26866501%205.01261445%2016.26866501%205.01261445%2018.875%204.75%20C19.75929688%204.68296875%2020.64359375%204.6159375%2021.5546875%204.546875%20C24.35567115%203.92045693%2025.10158994%203.05974803%2027%201%20C30.1875%200.3125%2030.1875%200.3125%2033%200%20C31.59625372%202.80749255%2029.89388208%202.84244717%2027%204%20C26.05125%204.70125%2025.1025%205.4025%2024.125%206.125%20C20.35294537%208.38823278%2018.33260375%208.5514223%2014%208%20C11.375%206.625%2011.375%206.625%209%205%20C8.154375%204.67%207.30875%204.34%206.4375%204%20C3.92982049%202.97120841%202.09290902%201.70533328%200%200%20Z%20%22%20fill%3D%22%23CD752E%22%20transform%3D%22translate(403%2C352)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C1.85481391%205.89200451%202.1344851%2011.58258171%202.09765625%2017.53125%20C2.0962413%2018.40777222%202.09482635%2019.28429443%202.09336853%2020.18737793%20C2.08781768%2022.95828821%202.07527461%2025.72911457%202.0625%2028.5%20C2.05747864%2030.39062382%202.05291685%2032.28124893%202.04882812%2034.171875%20C2.0378644%2038.78128183%202.02063425%2043.39062673%202%2048%20C1.67%2048%201.34%2048%201%2048%20C0.97494385%2046.92516357%200.9498877%2045.85032715%200.92407227%2044.74291992%20C0.82992505%2040.75646978%200.72972215%2036.77019091%200.62768555%2032.78393555%20C0.58436438%2031.05839035%200.54268727%2029.33280307%200.50268555%2027.60717773%20C0.44491474%2025.12731236%200.38123997%2022.64765828%200.31640625%2020.16796875%20C0.29969376%2019.39599655%200.28298126%2018.62402435%200.26576233%2017.82865906%20C0.17772105%2014.64817067%200.01254805%2012.03764416%20-1%209%20C-1.17812624%206.3071504%20-1.08727698%203.70558632%20-1%201%20C-0.67%200.67%20-0.34%200.34%200%200%20Z%20%22%20fill%3D%22%23B0B0B0%22%20transform%3D%22translate(693%2C406)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.31%201.32%20-4.62%202.64%20-7%204%20C-6.67%204.66%20-6.34%205.32%20-6%206%20C-15.41002278%2010.59225513%20-15.41002278%2010.59225513%20-20%2010%20C-18.57466888%205.72400664%20-15.47056527%204.73177414%20-11.6875%202.75%20C-11.01009766%202.37359375%20-10.33269531%201.9971875%20-9.63476562%201.609375%20C-5.95977798%20-0.34487063%20-3.97001703%20-1.33627897%200%200%20Z%20%22%20fill%3D%22%23E5B890%22%20transform%3D%22translate(308%2C150)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.86625%200.4640625%200.86625%200.4640625%201.75%200.9375%20C3.88635294%202.07363436%203.88635294%202.07363436%205.9375%202.3125%20C11.38911486%204.12970495%2015.37102101%2010.67266079%2019%2015%20C14.71007444%2014.48641736%2012.63121502%2013.18275773%209.5%2010.25%20C8.72785156%209.53199219%207.95570313%208.81398437%207.16015625%208.07421875%20C6.44730469%207.38972656%205.73445312%206.70523438%205%206%20C4.44183594%205.47019531%203.88367188%204.94039062%203.30859375%204.39453125%20C2.17528711%203.29351255%201.08183622%202.15163211%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23572803%22%20transform%3D%22translate(594%2C186)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.34605548%206.57512917%20-1.9857967%2013.9038939%20-4.7578125%2019.86328125%20C-9.53934384%2029.76967192%20-9.53934384%2029.76967192%20-12%2031%20C-11.39273759%2027.45045834%20-10.44448953%2024.39057509%20-9.00390625%2021.09375%20C-8.61009766%2020.18496094%20-8.21628906%2019.27617188%20-7.81054688%2018.33984375%20C-7.39869141%2017.40269531%20-6.98683594%2016.46554687%20-6.5625%2015.5%20C-5.75083982%2013.63561785%20-4.93962732%2011.77104072%20-4.12890625%209.90625%20C-3.76869385%209.08447266%20-3.40848145%208.26269531%20-3.03735352%207.41601562%20C-1.98267311%204.95964534%20-0.98260281%202.48597681%200%200%20Z%20%22%20fill%3D%22%232E2E2E%22%20transform%3D%22translate(667%2C509)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%201.32%200.66%202.64%201%204%20C1.99%203.01%202.98%202.02%204%201%20C4.66%201.33%205.32%201.66%206%202%20C4.700625%202.99%204.700625%202.99%203.375%204%20C0.05246904%206.73203375%20-2.27625701%209.89638452%20-4.703125%2013.42578125%20C-5.13109375%2013.94527344%20-5.5590625%2014.46476563%20-6%2015%20C-6.66%2015%20-7.32%2015%20-8%2015%20C-6.5320383%209.66195747%20-3.98519676%203.98519676%200%200%20Z%20%22%20fill%3D%22%237C7C7C%22%20transform%3D%22translate(635%2C580)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C0.34290238%203.00860317%20-1.32403781%205.00718923%20-3%207%20C-3.60070312%207.71929687%20-4.20140625%208.43859375%20-4.8203125%209.1796875%20C-5.43648437%209.90414062%20-6.05265625%2010.62859375%20-6.6875%2011.375%20C-7.55955078%2012.40753906%20-7.55955078%2012.40753906%20-8.44921875%2013.4609375%20C-10%2015%20-10%2015%20-12%2015%20C-12%2015.66%20-12%2016.32%20-12%2017%20C-13.65%2017.66%20-15.3%2018.32%20-17%2019%20C-15.60652624%2015.84795019%20-13.97514921%2013.73828227%20-11.5234375%2011.328125%20C-10.51796875%2010.33232422%20-10.51796875%2010.33232422%20-9.4921875%209.31640625%20C-8.79351562%208.63449219%20-8.09484375%207.95257813%20-7.375%207.25%20C-6.66859375%206.55261719%20-5.9621875%205.85523438%20-5.234375%205.13671875%20C-3.49401297%203.41987512%20-1.74915019%201.70788168%200%200%20Z%20%22%20fill%3D%22%233F2612%22%20transform%3D%22translate(219%2C203)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-10.30068337%2014.81776765%20-10.30068337%2014.81776765%20-18%2020%20C-14.61327514%2012.00356629%20-6.81301026%205.19940256%200%200%20Z%20%22%20fill%3D%22%2356371E%22%20transform%3D%22translate(234%2C190)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.47378124%202.47378124%20-4.56174345%203.03138231%20-7.875%204.125%20C-8.92429687%204.47820312%20-9.97359375%204.83140625%20-11.0546875%205.1953125%20C-14%206%20-14%206%20-18%206%20C-18%205.34%20-18%204.68%20-18%204%20C-18.99%203.67%20-19.98%203.34%20-21%203%20C-14.15939114%200.36899659%20-7.28555331%20-0.18680906%200%200%20Z%20%22%20fill%3D%22%23E2B791%22%20transform%3D%22translate(367%2C133)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.76646851%207.81797878%20-1.96083411%2013.87966848%20-5%2021%20C-6.37344385%2016.60155678%20-5.24307502%2013.07495445%20-4.0625%208.75%20C-3.76956055%207.63238281%20-3.76956055%207.63238281%20-3.47070312%206.4921875%20C-2.98895802%204.65920614%20-2.49560775%202.82928182%20-2%201%20C-3.04800781%201.45052734%20-3.04800781%201.45052734%20-4.1171875%201.91015625%20C-5.02726563%202.29042969%20-5.93734375%202.67070312%20-6.875%203.0625%20C-7.77992188%203.44535156%20-8.68484375%203.82820313%20-9.6171875%204.22265625%20C-12%205%20-12%205%20-14%204%20C-9.02495953%200.75099398%20-6.11774896%20-0.49940808%200%200%20Z%20%22%20fill%3D%22%235F5F5F%22%20transform%3D%22translate(680%2C477)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0%200.99%200%201.98%200%203%20C-0.99%203.33%20-1.98%203.66%20-3%204%20C-3%203.34%20-3%202.68%20-3%202%20C-3.99%201.67%20-4.98%201.34%20-6%201%20C-3.92446352%200.4465236%20-2.15634036%200%200%200%20Z%20M-5%204%20C-4.34%204.33%20-3.68%204.66%20-3%205%20C-6.63%208.96%20-10.26%2012.92%20-14%2017%20C-14.99%2016.67%20-15.98%2016.34%20-17%2016%20C-13.32167983%2011.47384007%20-9.58913637%207.60575001%20-5%204%20Z%20%22%20fill%3D%22%23803D09%22%20transform%3D%22translate(339%2C143)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-3.43968616%204.15628745%20-7.06078394%205.34464679%20-12%207%20C-13.41842394%207.53704819%20-14.83515415%208.07859498%20-16.25%208.625%20C-18.87538263%209.5876403%20-21.30043402%2010.36691594%20-24%2011%20C-23.67%2010.34%20-23.34%209.68%20-23%209%20C-22.34%209%20-21.68%209%20-21%209%20C-21%208.34%20-21%207.68%20-21%207%20C-19.2365625%206.38125%20-19.2365625%206.38125%20-17.4375%205.75%20C-14.53645395%204.6717351%20-11.90977369%203.45586332%20-9.25%201.875%20C-3.21428571%20-1.60714286%20-3.21428571%20-1.60714286%200%200%20Z%20%22%20fill%3D%22%23494949%22%20transform%3D%22translate(458%2C581)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C1.52312744%201.40395996%201.04625488%201.80791992%200.55493164%202.22412109%20C-1.31689955%204.36192924%20-1.52777965%205.61959509%20-1.87890625%208.4140625%20C-1.99556641%209.25710938%20-2.11222656%2010.10015625%20-2.23242188%2010.96875%20C-2.34134766%2011.8453125%20-2.45027344%2012.721875%20-2.5625%2013.625%20C-2.78485229%2015.36824198%20-3.01491397%2017.11052378%20-3.25390625%2018.8515625%20C-3.35002197%2019.62322754%20-3.4461377%2020.39489258%20-3.54516602%2021.18994141%20C-3.69526123%2021.78726074%20-3.84535645%2022.38458008%20-4%2023%20C-4.66%2023.33%20-5.32%2023.66%20-6%2024%20C-5.98259766%2022.58847656%20-5.98259766%2022.58847656%20-5.96484375%2021.1484375%20C-5.95582031%2019.90320313%20-5.94679688%2018.65796875%20-5.9375%2017.375%20C-5.92589844%2016.14523437%20-5.91429687%2014.91546875%20-5.90234375%2013.6484375%20C-5.99136076%2010.32276209%20-6.36313913%207.25952412%20-7%204%20C-5.824375%203.566875%20-5.824375%203.566875%20-4.625%203.125%20C-1.90328368%202.15087746%20-1.90328368%202.15087746%200%200%20Z%20%22%20fill%3D%22%23B5B5B5%22%20transform%3D%22translate(689%2C470)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-3.84985987%202.56657325%20-6.58358564%203.13343988%20-11.10546875%203.31640625%20C-12.08837891%203.35830078%20-13.07128906%203.40019531%20-14.08398438%203.44335938%20C-15.62022461%203.50233398%20-15.62022461%203.50233398%20-17.1875%203.5625%20C-18.22326172%203.60568359%20-19.25902344%203.64886719%20-20.32617188%203.69335938%20C-22.8839819%203.79944366%20-25.44188845%203.90150146%20-28%204%20C-19.14306412%20-0.54990673%20-9.76763586%20-0.25333926%200%200%20Z%20%22%20fill%3D%22%23CFA37F%22%20transform%3D%22translate(397%2C129)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.96846689%202.61486062%201.04559628%203.8442127%200.25%206.5625%20C-1%209%20-1%209%20-2.41015625%2010.359375%20C-4.29336106%2012.30273131%20-5.41046939%2014.30601048%20-6.6875%2016.6875%20C-7.12449219%2017.49574219%20-7.56148437%2018.30398438%20-8.01171875%2019.13671875%20C-8.50091797%2020.05904297%20-8.50091797%2020.05904297%20-9%2021%20C-9.66%2021%20-10.32%2021%20-11%2021%20C-11.33%2021.99%20-11.66%2022.98%20-12%2024%20C-12.33%2023.34%20-12.66%2022.68%20-13%2022%20C-12.13549805%2020.07641602%20-12.13549805%2020.07641602%20-10.76171875%2017.75390625%20C-10.02598633%2016.49803711%20-10.02598633%2016.49803711%20-9.27539062%2015.21679688%20C-8.75138672%2014.34087891%20-8.22738281%2013.46496094%20-7.6875%2012.5625%20C-7.17509766%2011.69044922%20-6.66269531%2010.81839844%20-6.13476562%209.91992188%20C-4.15456195%206.56106271%20-2.16330481%203.24495721%200%200%20Z%20%22%20fill%3D%22%23979797%22%20transform%3D%22translate(654%2C548)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.265625%201.55078125%201.265625%201.55078125%202%204%20C0.6936099%206.62176911%20-0.59633752%208.80456748%20-2.25%2011.1875%20C-2.67152344%2011.82880859%20-3.09304688%2012.47011719%20-3.52734375%2013.13085938%20C-6.68004712%2017.84002356%20-6.68004712%2017.84002356%20-9%2019%20C-8.58742287%2013.49897163%20-6.45277325%209.23798336%20-3%205%20C-2.34%205%20-1.68%205%20-1%205%20C-0.67%203.35%20-0.34%201.7%200%200%20Z%20%22%20fill%3D%22%23D6D6D6%22%20transform%3D%22translate(654%2C552)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.61225278%203.22450555%200.01296101%205.86335067%20-1.03125%209.1796875%20C-2.5226139%2013.52148078%20-4.22574697%2017.76701055%20-6%2022%20C-6.33%2022%20-6.66%2022%20-7%2022%20C-7.62260536%2013.59482769%20-5.28712118%206.60511414%200%200%20Z%20%22%20fill%3D%22%234C4C4C%22%20transform%3D%22translate(157%2C321)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C5.56442407%201.21721777%2011.93760485%203.93760485%2016%208%20C16.75%2010.6875%2016.75%2010.6875%2017%2013%20C12.98544787%2011.26102321%209.67974734%208.60214985%206.25%205.9375%20C5.64800781%205.47794922%205.04601562%205.01839844%204.42578125%204.54492188%20C2.92968619%203.38977365%201.46204799%202.19794972%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%232A1302%22%20transform%3D%22translate(583%2C176)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C0.91269147%202.73064947%200.80577876%205.4581619%200.6875%208.1875%20C0.66494141%208.95642578%200.64238281%209.72535156%200.61914062%2010.51757812%20C0.40261415%2015.10400245%20-0.04635224%2018.27363755%20-3%2022%20C-5.25%2023.0625%20-5.25%2023.0625%20-8%2024%20C-9.23921901%2024.71194872%20-10.46807554%2025.44215532%20-11.6875%2026.1875%20C-12.780625%2026.785625%20-13.87375%2027.38375%20-15%2028%20C-15.66%2027.67%20-16.32%2027.34%20-17%2027%20C-13.90565106%2023.41706964%20-10.29978541%2022.35680384%20-5.8125%2021.125%20C-2.35781957%2018.51479701%20-2.38357895%2017.41608444%20-1.6875%2013.25%20C-1.43748484%2011.1690657%20-1.20695309%209.0856571%20-1%207%20C-0.79915246%205.58225267%20-0.59251326%204.16528626%20-0.375%202.75%20C-0.25125%201.8425%20-0.1275%200.935%200%200%20Z%20%22%20fill%3D%22%23505050%22%20transform%3D%22translate(711%2C441)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.11991797%203.36315792%200.85748516%205.57005937%200.00390625%208.984375%20C-0.22490234%209.91894531%20-0.45371094%2010.85351562%20-0.68945312%2011.81640625%20C-0.93630859%2012.78449219%20-1.18316406%2013.75257813%20-1.4375%2014.75%20C-1.68048828%2015.73355469%20-1.92347656%2016.71710938%20-2.17382812%2017.73046875%20C-2.77428331%2020.15583673%20-3.38326726%2022.57872945%20-4%2025%20C-4.33%2025%20-4.66%2025%20-5%2025%20C-5.76397365%2015.57765837%20-3.8713719%208.57232349%200%200%20Z%20%22%20fill%3D%22%236C6C6C%22%20transform%3D%22translate(155%2C330)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C5.44693314%20-0.09688221%2010.63904667%20-0.12862175%2016%201%20C16%201.66%2016%202.32%2016%203%20C5.11%203%20-5.78%203%20-17%203%20C-17%202.67%20-17%202.34%20-17%202%20C-8.585%201.505%20-8.585%201.505%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%237C502C%22%20transform%3D%22translate(440%2C128)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.82408073%202.35602568%201.13166634%203.606532%200.328125%206.0078125%20C-0.02765625%206.70648438%20-0.3834375%207.40515625%20-0.75%208.125%20C-2.7334304%2012.24862678%20-4.0444892%2016.31445836%20-5.19140625%2020.73828125%20C-6.08629888%2023.24138673%20-7.31490765%2024.96015136%20-9%2027%20C-8.48709514%2022.64030869%20-7.72358363%2019.02169514%20-6%2015%20C-5.51326826%2013.5233054%20-5.03485249%2012.04385676%20-4.5625%2010.5625%20C-3.34672387%206.85314221%20-1.85472925%203.44449719%200%200%20Z%20%22%20fill%3D%22%23555555%22%20transform%3D%22translate(673%2C498)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.66%201.98%201.32%203%202%20C-0.25936256%207.70388447%20-3.72421249%2012.04315937%20-9%2016%20C-7.83200992%2012.88535978%20-6.5049138%209.8703574%20-5.0625%206.875%20C-4.74410156%206.21242188%20-4.42570313%205.54984375%20-4.09765625%204.8671875%20C-2.94685942%202.90960427%20-1.66740191%201.52963936%200%200%20Z%20%22%20fill%3D%22%23858585%22%20transform%3D%22translate(194%2C253)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.18222208%2010.03056466%20-2.18222208%2010.03056466%20-6.1875%2012.625%20C-7.115625%2013.07875%20-8.04375%2013.5325%20-9%2014%20C-8.40523781%209.24190251%20-6.5093872%205.05289706%20-4%201%20C-2%200%20-2%200%200%200%20Z%20%22%20fill%3D%22%23ABABAB%22%20transform%3D%22translate(173%2C300)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.64767247%200.28109113%203.29313145%200.57518526%204.9375%200.875%20C5.85402344%201.03742188%206.77054687%201.19984375%207.71484375%201.3671875%20C8.46894531%201.57601562%209.22304688%201.78484375%2010%202%20C10.33%202.66%2010.66%203.32%2011%204%20C2.92138585%204.09579384%20-4.98340366%204.12513633%20-13%203%20C-13%202.67%20-13%202.34%20-13%202%20C-6.565%201.505%20-6.565%201.505%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%236D3E17%22%20transform%3D%22translate(467%2C131)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200%201.32%200%202%200%20C6.59225513%2017.85649203%206.59225513%2017.85649203%206%2026%20C5.67%2026%205.34%2026%205%2026%20C4.15956003%2022.4182952%203.32889101%2018.83439357%202.5%2015.25%20C2.14228516%2013.72632813%202.14228516%2013.72632813%201.77734375%2012.171875%20C1.43896484%2010.70234375%201.43896484%2010.70234375%201.09375%209.203125%20C0.88427734%208.30239258%200.67480469%207.40166016%200.45898438%206.47363281%20C0%204%200%204%200%200%20Z%20%22%20fill%3D%22%23575757%22%20transform%3D%22translate(700%2C344)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.37562854%201.28965176%202.70766393%202.62689293%204%204%20C4%204.66%204%205.32%204%206%20C4.66%206%205.32%206%206%206%20C6.66%207.65%207.32%209.3%208%2011%20C5.03%2013.475%205.03%2013.475%202%2016%20C1.34%2015.67%200.68%2015.34%200%2015%20C0.66%2014.34%201.32%2013.68%202%2013%20C2.37076135%208.18010242%201.75210338%204.48976491%200%200%20Z%20%22%20fill%3D%22%23B25A13%22%20transform%3D%22translate(641%2C240)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-2.82637615%204.87363696%20-7.26107981%207.70443192%20-13%2010%20C-13.66%2010.66%20-14.32%2011.32%20-15%2012%20C-15.99%2011.67%20-16.98%2011.34%20-18%2011%20C-16.44704556%209.67621942%20-14.88219918%208.36638151%20-13.3125%207.0625%20C-12.44238281%206.33160156%20-11.57226562%205.60070312%20-10.67578125%204.84765625%20C-7.93761361%202.95692151%20-6.22632889%202.50829394%20-3%202%20C-2.01%201.34%20-1.02%200.68%200%200%20Z%20%22%20fill%3D%22%23A47148%22%20transform%3D%22translate(257%2C179)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.46015291%200.28241641%202.91809793%200.57626614%204.375%200.875%20C5.18710937%201.03742187%205.99921875%201.19984375%206.8359375%201.3671875%20C9%202%209%202%2011%204%20C12.0725%204.28875%2013.145%204.5775%2014.25%204.875%20C18.28182107%206.08454632%2020.6440368%207.54441717%2024%2010%20C23.01%2010.495%2023.01%2010.495%2022%2011%20C20.9790625%2010.3503125%2020.9790625%2010.3503125%2019.9375%209.6875%20C17.19954595%208.11463278%2015.47142948%207.58383182%2012.4375%207%20C8.88137035%206.29348417%206.75132717%205.44562415%204%203%20C2.68163705%202.30419733%201.35208914%201.62775567%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23555555%22%20transform%3D%22translate(341%2C561)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-1.37261112%203.83299334%20-4.97382375%205.27449589%20-9%207%20C-9.721875%207.5775%20-10.44375%208.155%20-11.1875%208.75%20C-13%2010%20-13%2010%20-15.25%209.6875%20C-15.8275%209.460625%20-16.405%209.23375%20-17%209%20C-13.12810696%204.05999854%20-9.37733787%202.96912047%20-3.328125%201.578125%20C-1.05395025%201.22590017%20-1.05395025%201.22590017%200%200%20Z%20%22%20fill%3D%22%23B77947%22%20transform%3D%22translate(545%2C300)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.33%201.98%200.66%203%201%20C2.42012094%204.36329858%201.42075735%205.6723487%20-1%208%20C-1.680625%209.2065625%20-1.680625%209.2065625%20-2.375%2010.4375%20C-4.21005459%2013.33123993%20-6.2486119%2014.99223031%20-9%2017%20C-7.69289187%2013.42597488%20-6.11587706%2010.49002567%20-3.9375%207.375%20C-2.16012171%204.82843844%20-0.98934061%202.96802184%200%200%20Z%20%22%20fill%3D%22%23919191%22%20transform%3D%22translate(199%2C257)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.66%201.32%201.32%202%202%20C1.21875%203.69270833%200.4375%205.38541667%20-0.34375%207.078125%20C-1.21542924%209.29242836%20-1.21542924%209.29242836%20-1%2013%20C-2.32%2012.67%20-3.64%2012.34%20-5%2012%20C-5%207.86021808%20-4.67617664%207.01426496%20-2.5%203.75%20C-2.0359375%203.04359375%20-1.571875%202.3371875%20-1.09375%201.609375%20C-0.7328125%201.07828125%20-0.371875%200.5471875%200%200%20Z%20%22%20fill%3D%22%23D17930%22%20transform%3D%22translate(208%2C245)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-1.65880729%205.91652229%20-5.4843021%209.24823902%20-11%2012%20C-11.66%2012%20-12.32%2012%20-13%2012%20C-12.60196439%209.11424181%20-12.20990931%208.17810487%20-9.9375%206.25%20C-9.298125%205.8375%20-8.65875%205.425%20-8%205%20C-8%205.66%20-8%206.32%20-8%207%20C-4.04%203.535%20-4.04%203.535%200%200%20Z%20%22%20fill%3D%22%234E4E4E%22%20transform%3D%22translate(626%2C598)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.32%200%202.64%200%204%200%20C4%200.66%204%201.32%204%202%20C-8.11069559%206.93044129%20-8.11069559%206.93044129%20-12%208%20C-12.66%207.67%20-13.32%207.34%20-14%207%20C-11.5860268%204.13840263%20-9.4583325%203.32568005%20-5.875%202.375%20C-2.65634118%201.7005259%20-2.65634118%201.7005259%200%200%20Z%20%22%20fill%3D%22%23AA7C57%22%20transform%3D%22translate(592%2C278)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C-2.23896927%208.14287275%20-4.49305699%2012.02943906%20-11%2015%20C-9.44476633%2011.50683117%20-7.34563239%208.77131239%20-4.9375%205.8125%20C-4.22464844%204.93207031%20-3.51179687%204.05164063%20-2.77734375%203.14453125%20C-1.88495567%202.06778168%20-0.98887464%200.98887464%200%200%20Z%20%22%20fill%3D%22%233A200A%22%20transform%3D%22translate(194%2C230)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C4.77295598%200.68587753%208.87632791%202.50631925%2013.25%204.4375%20C13.9821875%204.75009766%2014.714375%205.06269531%2015.46875%205.38476562%20C20.87660233%207.75320465%2020.87660233%207.75320465%2022%2010%20C14.16076983%208.18247357%206.82397217%205.24602713%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23393939%22%20transform%3D%22translate(367%2C574)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-4.03084689%204.45514656%20-8.05465225%206.30868049%20-14%207%20C-12.73164821%203.05401664%20-10.31064666%201.56019601%20-6.8203125%20-0.31640625%20C-4.27830339%20-1.27102341%20-2.51232148%20-0.91357145%200%200%20Z%20%22%20fill%3D%22%23CB9A71%22%20transform%3D%22translate(281%2C165)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-0.59167969%200.32613281%20-1.18335938%200.65226563%20-1.79296875%200.98828125%20C-2.58316406%201.42527344%20-3.37335937%201.86226562%20-4.1875%202.3125%20C-5.01121094%202.76625%20-5.83492187%203.22%20-6.68359375%203.6875%20C-8.40994924%204.66567107%20-10.09326072%205.7205582%20-11.75%206.8125%20C-14.3594536%208.18971162%20-16.09035405%208.24939822%20-19%208%20C-16.90584651%204.85876976%20-16.57988409%204.58414831%20-13.25%203.5%20C-10.52488345%202.57019617%20-8.26271606%201.6104915%20-5.6875%200.25%20C-3%20-1%20-3%20-1%200%200%20Z%20%22%20fill%3D%22%233E3E3E%22%20transform%3D%22translate(571%2C528)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C0.09950832%208.4646218%20-2.98068485%2016.09226984%20-6%2024%20C-6.66%2023.67%20-7.32%2023.34%20-8%2023%20C-5.36%2015.41%20-2.72%207.82%200%200%20Z%20%22%20fill%3D%22%23EEEEEE%22%20transform%3D%22translate(679%2C496)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-0.66%200%20-1.32%200%20-2%200%20C-2.2475%200.7425%20-2.495%201.485%20-2.75%202.25%20C-4.09147301%205.20124062%20-5.60905526%206.84814974%20-8%209%20C-8.99%208.67%20-9.98%208.34%20-11%208%20C-9.625%206%20-9.625%206%20-8%204%20C-7.34%204%20-6.68%204%20-6%204%20C-6.33%203.34%20-6.66%202.68%20-7%202%20C-9.02463255%201.34786708%20-9.02463255%201.34786708%20-11%201%20C-3.57142857%20-1.42857143%20-3.57142857%20-1.42857143%200%200%20Z%20%22%20fill%3D%22%237B4214%22%20transform%3D%22translate(357%2C139)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C9.27394893%200.58882215%2018.0146265%202.75886856%2027%205%20C27%205.33%2027%205.66%2027%206%20C24.57341455%205.76629198%2022.14773012%205.52633164%2019.72265625%205.27734375%20C18.10654948%205.11271881%2016.48955648%204.9559801%2014.87109375%204.81640625%20C9.6085934%204.29547187%204.92921004%202.81422314%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%231E1208%22%20transform%3D%22translate(470%2C129)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-1.88923398%201.01241247%20-3.78669944%202.00947425%20-5.6875%203%20C-7.27111328%203.8353125%20-7.27111328%203.8353125%20-8.88671875%204.6875%20C-11.92226262%205.9672274%20-13.76026826%206.28851043%20-17%206%20C-12.81923021%201.12243525%20-6.24558534%20-2.08186178%200%200%20Z%20%22%20fill%3D%22%23313131%22%20transform%3D%22translate(588%2C521)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.94026778%205.34512479%20-0.87461778%2010.05238894%20-3%2015%20C-4.23620214%2017.42245672%20-5.56151527%2019.68814954%20-7%2022%20C-7.33%2020.68%20-7.66%2019.36%20-8%2018%20C-7.01%2017.67%20-6.02%2017.34%20-5%2017%20C-4.89042969%2016.27554688%20-4.78085937%2015.55109375%20-4.66796875%2014.8046875%20C-3.77128895%209.33712777%20-2.84045685%204.77713197%200%200%20Z%20%22%20fill%3D%22%23616161%22%20transform%3D%22translate(679%2C511)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.95699723%203.91399445%20-0.75958054%208.999513%20-2%2013%20C-2.93861707%2015.69799795%20-3.94736792%2018.34335714%20-5%2021%20C-6.29814095%2017.34240017%20-5.7043336%2014.77223795%20-4.75%2011.0625%20C-4.49734375%2010.04285156%20-4.2446875%209.02320313%20-3.984375%207.97265625%20C-2.99590237%204.9876258%20-1.71896456%202.62190382%200%200%20Z%20%22%20fill%3D%22%236F6F6F%22%20transform%3D%22translate(162%2C309)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.495%200.99%200.495%202%201%20C1.98839844%201.81984375%201.97679688%202.6396875%201.96484375%203.484375%20C1.95582031%204.56203125%201.94679688%205.6396875%201.9375%206.75%20C1.92589844%207.81734375%201.91429688%208.8846875%201.90234375%209.984375%20C1.8870595%2012.8918999%201.8870595%2012.8918999%202.56640625%2015.203125%20C3%2017%203%2017%202%2020%20C2%2019.34%202%2018.68%202%2018%20C1.34%2018%200.68%2018%200%2018%20C0%2012.06%200%206.12%200%200%20Z%20%22%20fill%3D%22%230F0F0F%22%20transform%3D%22translate(126%2C436)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.35953094%202.35953094%20-3.77895617%202.49141413%20-7%203%20C-7%203.66%20-7%204.32%20-7%205%20C-12.17578125%208.22265625%20-12.17578125%208.22265625%20-14%209%20C-14.99%208.67%20-15.98%208.34%20-17%208%20C-7.19797688%20-0.63511561%20-7.19797688%20-0.63511561%200%200%20Z%20%22%20fill%3D%22%23B17B4F%22%20transform%3D%22translate(567%2C291)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-1.34003602%205.32239956%20-4.32751069%208.17477391%20-9%2011%20C-9.66%2010.34%20-10.32%209.68%20-11%209%20C-7.37%206.03%20-3.74%203.06%200%200%20Z%20%22%20fill%3D%22%23533922%22%20transform%3D%22translate(247%2C180)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C4.30689238%201.34307888%208.27523429%202.98890874%2012.3125%205%20C13.88451172%205.7734375%2013.88451172%205.7734375%2015.48828125%206.5625%20C18%208%2018%208%2019%2010%20C15.58978257%209.21302675%2012.31114834%208.12880057%209%207%20C9%206.34%209%205.68%209%205%20C8.443125%204.896875%207.88625%204.79375%207.3125%204.6875%20C4.54289253%203.86410318%202.39747583%202.59831722%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23292929%22%20transform%3D%22translate(254%2C520)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C2.04254356%202.99954746%202.04080783%205.00041636%202%207%20C1.67%207.33%201.34%207.66%201%208%20C0.60333773%2010.18019479%200.25684763%2012.3696463%20-0.0625%2014.5625%20C-0.23910156%2015.76003906%20-0.41570313%2016.95757812%20-0.59765625%2018.19140625%20C-0.73042969%2019.11824219%20-0.86320313%2020.04507812%20-1%2021%20C-1.33%2021%20-1.66%2021%20-2%2021%20C-1.86142159%2017.87463363%20-1.71290431%2014.74981783%20-1.5625%2011.625%20C-1.52318359%2010.73554688%20-1.48386719%209.84609375%20-1.44335938%208.9296875%20C-1.40146484%208.07890625%20-1.35957031%207.228125%20-1.31640625%206.3515625%20C-1.27974854%205.56604004%20-1.24309082%204.78051758%20-1.20532227%203.97119141%20C-1%202%20-1%202%200%200%20Z%20%22%20fill%3D%22%23C6C6C6%22%20transform%3D%22translate(689%2C414)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.58624235%200.42683239%203.1689098%200.86696158%204.75%201.3125%20C6.07257813%201.67794922%206.07257813%201.67794922%207.421875%202.05078125%20C10.08669915%203.03192105%2011.90271638%204.093824%2014%206%20C14%206.66%2014%207.32%2014%208%20C15.65%208.33%2017.3%208.66%2019%209%20C16.27584084%2010.36207958%2014.87220643%209.86166193%2012%209%20C11.34%208.01%2010.68%207.02%2010%206%20C8.11440217%205.10525628%208.11440217%205.10525628%206%204.5%20C2.54718806%203.43369043%202.1454907%203.21823605%200%200%20Z%20%22%20fill%3D%22%23AD7447%22%20transform%3D%22translate(201%2C256)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0%203.53922552%20-0.70481438%204.31891897%20-2.8125%207.0625%20C-3.33457031%207.75472656%20-3.85664062%208.44695313%20-4.39453125%209.16015625%20C-6%2011%20-6%2011%20-9%2013%20C-8.38297446%207.60102654%20-5.92102734%204.54749424%20-1.75%201.1875%20C-1.1725%200.795625%20-0.595%200.40375%200%200%20Z%20%22%20fill%3D%22%23363636%22%20transform%3D%22translate(630%2C582)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.22506359%203.59699524%200.82116076%206.41420962%200.1875%2010.125%20C0.01605469%2011.17945313%20-0.15539062%2012.23390625%20-0.33203125%2013.3203125%20C-1%2016%20-1%2016%20-3%2018%20C-3.2661431%2011.47949413%20-2.97164571%205.94329141%200%200%20Z%20%22%20fill%3D%22%23C4C4C4%22%20transform%3D%22translate(686%2C437)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-5.33251295%203.54532196%20-10.86159819%207.03876789%20-17%209%20C-17.66%208.67%20-18.32%208.34%20-19%208%20C-5.26890756%20-1.75630252%20-5.26890756%20-1.75630252%200%200%20Z%20%22%20fill%3D%22%23A27D5F%22%20transform%3D%22translate(443%2C351)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C7.07969902%201.62391487%2011.89563085%203.77731766%2017%209%20C16.01%209.495%2016.01%209.495%2015%2010%20C9.27272727%207.54545455%209.27272727%207.54545455%208%205%20C6.845%204.505%205.69%204.01%204.5%203.5%20C1%202%201%202%200%200%20Z%20%22%20fill%3D%22%23616161%22%20transform%3D%22translate(298%2C539)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.32%200%202.64%200%204%200%20C4%200.66%204%201.32%204%202%20C5.2684375%202.1546875%205.2684375%202.1546875%206.5625%202.3125%20C10.41442701%203.0828854%2013.44075031%204.36274514%2017%206%20C17%206.66%2017%207.32%2017%208%20C10.45959881%206.98563222%205.25798525%205.11183043%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23595959%22%20transform%3D%22translate(186%2C487)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.05710856%203.08566284%202.78346093%205.36985312%203.6875%208.9375%20C3.95949219%209.97777344%204.23148438%2011.01804687%204.51171875%2012.08984375%20C4.97828785%2014.8705956%204.93894816%2016.38480882%204%2019%20C1.30292366%2012.44995746%20-0.53699151%207.11513755%200%200%20Z%20%22%20fill%3D%22%23191919%22%20transform%3D%22translate(704%2C338)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200%201.32%200%202%200%20C1.49904971%204.34156921%20-1.10523005%206.89846077%20-4%2010%20C-4.99%2010.33%20-5.98%2010.66%20-7%2011%20C-5.51131293%206.39860359%20-3.25370145%203.49772906%200%200%20Z%20%22%20fill%3D%22%23884D1E%22%20transform%3D%22translate(200%2C243)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C3.71599191%20-0.20086443%204.77208445%20-0.1519437%208%202%20C9.9896995%202.39013716%2011.99019869%202.73202649%2014%203%20C10.8250906%204.9078584%208.89414789%205.1609041%205.25%204.625%20C4.45078125%204.51414063%203.6515625%204.40328125%202.828125%204.2890625%20C2.22484375%204.19367188%201.6215625%204.09828125%201%204%20C0.67%202.68%200.34%201.36%200%200%20Z%20%22%20fill%3D%22%23522604%22%20transform%3D%22translate(540%2C154)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C6.09897654%200.37340673%209.28103272%202.25052352%2014%206%20C14.99%206.66%2015.98%207.32%2017%208%20C12.76677156%207.37954537%209.47709705%205.89476441%205.6875%203.9375%20C4.61886719%203.38964844%203.55023438%202.84179688%202.44921875%202.27734375%20C1.64097656%201.85582031%200.83273437%201.43429687%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23474747%22%20transform%3D%22translate(389%2C584)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.625%201.8125%200.625%201.8125%201%204%20C0.01%205.485%200.01%205.485%20-1%207%20C-0.01%206.67%200.98%206.34%202%206%20C0.66667905%209.99996286%20-1.4957827%2010.83782337%20-5%2013%20C-4.39254603%208.14036821%20-2.27241033%204.2594482%200%200%20Z%20%22%20fill%3D%22%23959595%22%20transform%3D%22translate(640%2C572)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.51183868%203.9249658%200.46099883%206.76930452%20-0.75%2010.6875%20C-1.09546875%2011.84636719%20-1.4409375%2013.00523437%20-1.796875%2014.19921875%20C-2.19390625%2015.12347656%20-2.5909375%2016.04773438%20-3%2017%20C-3.99%2017.33%20-4.98%2017.66%20-6%2018%20C-5.31583566%2013.82423832%20-3.98634991%2010.11919593%20-2.4375%206.1875%20C-1.75494141%204.44533203%20-1.75494141%204.44533203%20-1.05859375%202.66796875%20C-0.70925781%201.78753906%20-0.35992188%200.90710938%200%200%20Z%20%22%20fill%3D%22%23969696%22%20transform%3D%22translate(677%2C511)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-3.88050703%204.04870549%20-9.68334326%206.96964605%20-16%209%20C-16.66%208.67%20-17.32%208.34%20-18%208%20C-13.70162066%205.4209724%20-9.81848695%203.46649603%20-5%202%20C-4.0925%201.608125%20-3.185%201.21625%20-2.25%200.8125%20C-1.5075%200.544375%20-0.765%200.27625%200%200%20Z%20%22%20fill%3D%22%23464646%22%20transform%3D%22translate(601%2C512)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.9375%200.6875%201.9375%200.6875%204%202%20C4.75%204.625%204.75%204.625%205%207%20C4.67%206.34%204.34%205.68%204%205%20C2.68%205.33%201.36%205.66%200%206%20C0%205.34%200%204.68%200%204%20C-1.98%204.66%20-3.96%205.32%20-6%206%20C-4%204%20-2%202%200%200%20Z%20%22%20fill%3D%22%233E3731%22%20transform%3D%22translate(657%2C247)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C0.44555348%202.46691458%20-1.11892175%203.92320641%20-2.6875%205.375%20C-3.55761719%206.18710938%20-4.42773438%206.99921875%20-5.32421875%207.8359375%20C-7.86371107%209.88977509%20-9.92025866%2010.9900668%20-13%2012%20C-11.68895551%208.06686654%20-9.17504178%206.63242994%20-5.9375%204.3125%20C-5.08575195%203.68891602%20-5.08575195%203.68891602%20-4.21679688%203.05273438%20C-2.81596827%202.02859918%20-1.40859652%201.01342465%200%200%20Z%20%22%20fill%3D%22%239C5011%22%20transform%3D%22translate(244%2C204)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0%200.33%200%200.66%200%201%20C-6.50422293%203.00865708%20-12.1781317%204.38614349%20-19%204%20C-13.06147771%200.04098514%20-6.91895619%20-0.24710558%200%200%20Z%20%22%20fill%3D%22%23614935%22%20transform%3D%22translate(357%2C133)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C4.31931387%200.61611835%208.25208775%201.64238578%2012.375%203.0625%20C13.43460937%203.42472656%2014.49421875%203.78695312%2015.5859375%204.16015625%20C16.38257813%204.43730469%2017.17921875%204.71445312%2018%205%20C18%205.99%2018%206.98%2018%208%20C17.31550781%207.72414063%2016.63101562%207.44828125%2015.92578125%207.1640625%20C12.68892291%205.87623368%209.43978124%204.62335037%206.1875%203.375%20C5.02605469%202.92898438%203.86460937%202.48296875%202.66796875%202.0234375%20C1.78753906%201.68570313%200.90710938%201.34796875%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%235B5B5B%22%20transform%3D%22translate(315%2C549)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C2.4140625%203.28515625%202.4140625%203.28515625%202.625%206.0625%20C2.69976563%206.98160156%202.77453125%207.90070313%202.8515625%208.84765625%20C2.90054688%209.55792969%202.94953125%2010.26820313%203%2011%20C2.34%2011%201.68%2011%201%2011%20C0.34%2012.98%20-0.32%2014.96%20-1%2017%20C-2.3357457%2013.22628488%20-1.72408671%2010.14168653%20-1.0625%206.25%20C-0.86785156%205.07953125%20-0.67320312%203.9090625%20-0.47265625%202.703125%20C-0.31667969%201.81109375%20-0.16070313%200.9190625%200%200%20Z%20%22%20fill%3D%22%23D8D8D8%22%20transform%3D%22translate(689%2C422)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C3.25524265%203.02272532%205.61820737%206.25718301%208%2010%20C7.67%2010.66%207.34%2011.32%207%2012%20C4.0625%2010.5%204.0625%2010.5%201%208%20C0.16104266%205.23513429%200.09752026%202.92560787%200%200%20Z%20%22%20fill%3D%22%23171717%22%20transform%3D%22translate(661%2C249)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C5.625%20-0.25%205.625%20-0.25%209%202%20C9%202.99%209%203.98%209%205%20C5.625%204.75%205.625%204.75%202%204%20C0.5625%201.9375%200.5625%201.9375%200%200%20Z%20%22%20fill%3D%22%23492203%22%20transform%3D%22translate(559%2C163)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.671875%201.67578125%200.671875%201.67578125%201%204%20C-0.109375%206.54296875%20-0.109375%206.54296875%20-1.75%209.1875%20C-2.54664063%2010.50814453%20-2.54664063%2010.50814453%20-3.359375%2011.85546875%20C-5%2014%20-5%2014%20-8%2015%20C-6.66749209%2011.4124787%20-5.169283%208.1635377%20-3%205%20C-2.34%205%20-1.68%205%20-1%205%20C-0.67%203.35%20-0.34%201.7%200%200%20Z%20%22%20fill%3D%22%23646464%22%20transform%3D%22translate(654%2C544)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C0.76110404%202.48847937%20-0.4915672%203.96550105%20-1.75%205.4375%20C-2.79414063%206.67306641%20-2.79414063%206.67306641%20-3.859375%207.93359375%20C-6.01343015%2010.01296451%20-7.08310781%2010.63867326%20-10%2011%20C-9.09066991%209.72390677%20-8.17217147%208.45434447%20-7.25%207.1875%20C-6.73953125%206.47980469%20-6.2290625%205.77210938%20-5.703125%205.04296875%20C-3.97517642%202.97022309%20-2.21473524%201.52624146%200%200%20Z%20%22%20fill%3D%22%23BC753C%22%20transform%3D%22translate(205%2C243)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C3.26008643%203.16952847%206.22237877%206.39937989%209%2010%20C8.67%2010.66%208.34%2011.32%208%2012%20C4.83769026%209.60690073%202.04092395%207.43734561%200%204%20C0%202.68%200%201.36%200%200%20Z%20%22%20fill%3D%22%23221002%22%20transform%3D%22translate(652%2C237)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C3.23861303%201.44424635%205.61969163%203.25772247%208.25%205.625%20C8.95640625%206.25664062%209.6628125%206.88828125%2010.390625%207.5390625%20C10.92171875%208.02117187%2011.4528125%208.50328125%2012%209%20C8.1544104%209%206.25466136%208.03416335%203%206%20C1.125%202.8125%201.125%202.8125%200%200%20Z%20%22%20fill%3D%22%23773805%22%20transform%3D%22translate(597%2C191)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.31%201.32%20-4.62%202.64%20-7%204%20C-6.67%204.66%20-6.34%205.32%20-6%206%20C-7.65%206.33%20-9.3%206.66%20-11%207%20C-11.66%206.01%20-12.32%205.02%20-13%204%20C-11.59248779%203.13083113%20-10.1735479%202.28014851%20-8.75%201.4375%20C-7.96109375%200.96183594%20-7.1721875%200.48617187%20-6.359375%20-0.00390625%20C-3.69155375%20-1.13022151%20-2.65498232%20-1.0169313%200%200%20Z%20%22%20fill%3D%22%23CB9F7B%22%20transform%3D%22translate(308%2C150)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0%200.99%200%201.98%200%203%20C-0.66%203.66%20-1.32%204.32%20-2%205%20C-2.433125%206.2065625%20-2.433125%206.2065625%20-2.875%207.4375%20C-4.14106224%2010.32130844%20-5.37684406%2011.3386679%20-8%2013%20C-7.48118887%208.8275894%20-6.28848726%206.74583179%20-3.4375%203.6875%20C-2.79683594%202.99011719%20-2.15617188%202.29273438%20-1.49609375%201.57421875%20C-1.00238281%201.05472656%20-0.50867188%200.53523437%200%200%20Z%20%22%20fill%3D%22%232A2A2A%22%20transform%3D%22translate(620%2C593)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0%204.144163%20-0.88134668%207.60168334%20-3.5%2010.875%20C-5%2012%20-5%2012%20-7%2012%20C-5.63855967%206.80177328%20-3.53269829%203.90456127%200%200%20Z%20%22%20fill%3D%22%23636363%22%20transform%3D%22translate(625%2C593)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-3.36736031%202.82858266%20-6.87451958%204.4998253%20-11%206%20C-11.99%205.67%20-12.98%205.34%20-14%205%20C-12.68%204.67%20-11.36%204.34%20-10%204%20C-10%203.34%20-10%202.68%20-10%202%20C-8.71211992%201.46987262%20-7.41953322%200.9511671%20-6.125%200.4375%20C-5.40570313%200.14746094%20-4.68640625%20-0.14257812%20-3.9453125%20-0.44140625%20C-2%20-1%20-2%20-1%200%200%20Z%20%22%20fill%3D%22%23595959%22%20transform%3D%22translate(508%2C557)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C0.0625%204.125%200.0625%204.125%20-1%206%20C-1.66%206%20-2.32%206%20-3%206%20C-3%206.66%20-3%207.32%20-3%208%20C-3.66%208%20-4.32%208%20-5%208%20C-5%206.02%20-5%204.04%20-5%202%20C-3.35%201.34%20-1.7%200.68%200%200%20Z%20%22%20fill%3D%22%23DDDDDD%22%20transform%3D%22translate(660%2C546)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200%200.66%200%201%200%20C1.63019694%209.17286652%201.63019694%209.17286652%20-1%2012.625%20C-1.66%2013.07875%20-2.32%2013.5325%20-3%2014%20C-2.48594831%209.03083364%20-1.76615118%204.70973649%200%200%20Z%20%22%20fill%3D%22%23858585%22%20transform%3D%22translate(681%2C499)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.10348268%203.31044803%200.99444068%205.65506316%200%209%20C-0.99%209.495%20-0.99%209.495%20-2%2010%20C-2.65555119%2012.52733235%20-2.65555119%2012.52733235%20-3%2015%20C-3.33%2015%20-3.66%2015%20-4%2015%20C-4.1953125%208.9453125%20-4.1953125%208.9453125%20-4%207%20C-3.34%206.34%20-2.68%205.68%20-2%205%20C-1.29289322%203.35008418%20-0.62056011%201.68437744%200%200%20Z%20%22%20fill%3D%22%23727272%22%20transform%3D%22translate(686%2C488)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-5.57765673%202.94033413%20-10.85326729%205.53012914%20-17%207%20C-16.67%206.34%20-16.34%205.68%20-16%205%20C-15.01%205%20-14.02%205%20-13%205%20C-13%204.34%20-13%203.68%20-13%203%20C-11.21189234%202.30329584%20-9.41937948%201.61788811%20-7.625%200.9375%20C-6.62726563%200.55464844%20-5.62953125%200.17179687%20-4.6015625%20-0.22265625%20C-2%20-1%20-2%20-1%200%200%20Z%20%22%20fill%3D%22%23CB7630%22%20transform%3D%22translate(479%2C333)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1%203%201%203%200.375%204.9375%20C-1.36682788%207.55024181%20-3.48604256%209.14761031%20-6%2011%20C-5.39305845%207.84669446%20-4.3583335%205.81111133%20-2.4375%203.25%20C-1.98246094%202.63640625%20-1.52742187%202.0228125%20-1.05859375%201.390625%20C-0.70925781%200.93171875%20-0.35992187%200.4728125%200%200%20Z%20%22%20fill%3D%22%23242220%22%20transform%3D%22translate(182%2C245)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.33%201.98%200.66%203%201%20C2.0919838%202.13199353%201.17316174%203.25532363%200.25%204.375%20C-0.26046875%205.00148437%20-0.7709375%205.62796875%20-1.296875%206.2734375%20C-3.08199481%208.08312318%20-4.67949644%209.00117455%20-7%2010%20C-5.33248852%206.05860922%20-2.77289351%203.2107188%200%200%20Z%20%22%20fill%3D%22%23804D24%22%20transform%3D%22translate(215%2C210)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C4.97306516%200.49730652%208.63799813%201.55302334%2013%204%20C13%204.33%2013%204.66%2013%205%20C7.36529617%205.5497272%204.61012242%203.95047835%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23281303%22%20transform%3D%22translate(541%2C152)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.31%200.33%204.62%200.66%207%201%20C7%201.66%207%202.32%207%203%20C7.99%203.33%208.98%203.66%2010%204%20C6.19881294%205.26706235%204.6149628%204.57172296%201%203%20C0.67%202.01%200.34%201.02%200%200%20Z%20%22%20fill%3D%22%23CB7530%22%20transform%3D%22translate(379%2C340)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C0.07421875%204.34765625%200.07421875%204.34765625%20-1.3125%207.0625%20C-1.98732422%208.41021484%20-1.98732422%208.41021484%20-2.67578125%209.78515625%20C-4%2012%20-4%2012%20-6%2013%20C-3.10933941%203.40546697%20-3.10933941%203.40546697%200%200%20Z%20%22%20fill%3D%22%238F8F8F%22%20transform%3D%22translate(178%2C296)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-0.08291164%204.12436746%20-0.61276477%204.5365026%20-3.9375%205.75%20C-4.62714844%206.01296875%20-5.31679688%206.2759375%20-6.02734375%206.546875%20C-8%207%20-8%207%20-11%206%20C-9.21385682%204.96953278%20-7.42089982%203.95086764%20-5.625%202.9375%20C-4.62726562%202.36902344%20-3.62953125%201.80054688%20-2.6015625%201.21484375%20C-1.74304688%200.81394531%20-0.88453125%200.41304687%200%200%20Z%20%22%20fill%3D%22%23816B5B%22%20transform%3D%22translate(650%2C251)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200%201.32%200%202%200%20C0.76075855%204.95696581%20-0.78577758%207.11658466%20-5%2010%20C-4.49890042%205.61537866%20-3.01704885%203.1999003%200%200%20Z%20%22%20fill%3D%22%233F3F3F%22%20transform%3D%22translate(636%2C572)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C5.15464734%200.48324819%208.81550319%203.18610761%2013%206%20C12.01%206.495%2012.01%206.495%2011%207%20C9.16015625%206.328125%209.16015625%206.328125%207.0625%205.25%20C6.37285156%204.90453125%205.68320313%204.5590625%204.97265625%204.203125%20C2.99352409%202.99605034%201.56101565%201.70292617%200%200%20Z%20%22%20fill%3D%22%234E4E4E%22%20transform%3D%22translate(228%2C507)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0%203%200%203%20-1.0625%204.4375%20C-3.90375254%206.72883269%20-6.72378221%208.3618911%20-10%2010%20C-10.99%209.67%20-11.98%209.34%20-13%209%20C-9.76175819%206.22436416%20-6.93902299%204.5548775%20-3%203%20C-1.22722741%201.47992158%20-1.22722741%201.47992158%200%200%20Z%20%22%20fill%3D%22%231C1C1C%22%20transform%3D%22translate(712%2C458)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.33%201.98%200.66%203%201%20C2.58221009%206.7097955%200.42453429%209.60957142%20-3%2014%20C-3.33%2013.34%20-3.66%2012.68%20-4%2012%20C-2.75%209.6875%20-2.75%209.6875%20-1%207%20C-0.443125%206.071875%200.11375%205.14375%200.6875%204.1875%20C1.120625%203.465625%201.55375%202.74375%202%202%20C1.34%202%200.68%202%200%202%20C0%201.34%200%200.68%200%200%20Z%20%22%20fill%3D%22%239D9997%22%20transform%3D%22translate(196%2C255)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.66666667%201.66666667%203.33333333%203.33333333%205%205%20C5.8971875%205.804375%205.8971875%205.804375%206.8125%206.625%20C8%208%208%208%208%2011%20C4.71573897%209.94434467%203.42848444%208.38339648%201.75%205.5%20C0%202%200%202%200%200%20Z%20%22%20fill%3D%22%237E3B06%22%20transform%3D%22translate(646%2C238)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.99%200.66%201.98%201%203%20C1.66%202.34%202.32%201.68%203%201%20C2.38461538%206.53846154%202.38461538%206.53846154%200.4375%208.875%20C-0.036875%209.24625%20-0.51125%209.6175%20-1%2010%20C-2.15837626%205.94568308%20-1.83691257%203.78187881%200%200%20Z%20%22%20fill%3D%22%23D7D7D7%22%20transform%3D%22translate(668%2C524)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C7.57142857%204%207.57142857%204%2010%208%20C9.401875%207.67%208.80375%207.34%208.1875%207%20C5.94613529%205.79212012%205.94613529%205.79212012%203%206%20C3%205.34%203%204.68%203%204%20C2.01%203.67%201.02%203.34%200%203%20C0%202.01%200%201.02%200%200%20Z%20%22%20fill%3D%22%231F0E01%22%20transform%3D%22translate(599%2C185)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.32%200.33%202.64%200.66%204%201%20C-0.455%204.465%20-0.455%204.465%20-5%208%20C-5%205%20-5%205%20-2.75%202.25%20C-1.8425%201.5075%20-0.935%200.765%200%200%20Z%20%22%20fill%3D%22%236D4C31%22%20transform%3D%22translate(253%2C176)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-1.65%201.65%20-3.3%203.3%20-5%205%20C-5.99%204.67%20-6.98%204.34%20-8%204%20C-5.97675095%20-0.48005146%20-4.79569304%20-1.43870791%200%200%20Z%20%22%20fill%3D%22%236D3508%22%20transform%3D%22translate(361%2C139)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.65234375%201.734375%200.65234375%201.734375%201%204%20C0.00390625%206.140625%200.00390625%206.140625%20-1.4375%208.25%20C-1.91058594%208.95640625%20-2.38367188%209.6628125%20-2.87109375%2010.390625%20C-3.24363281%2010.92171875%20-3.61617187%2011.4528125%20-4%2012%20C-4.65234375%2010.265625%20-4.65234375%2010.265625%20-5%208%20C-4.00390625%205.859375%20-4.00390625%205.859375%20-2.5625%203.75%20C-2.08941406%203.04359375%20-1.61632812%202.3371875%20-1.12890625%201.609375%20C-0.75636719%201.07828125%20-0.38382813%200.5471875%200%200%20Z%20%22%20fill%3D%22%23646464%22%20transform%3D%22translate(660%2C532)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-1.95330868%201.03041513%20-3.91281528%202.0490893%20-5.875%203.0625%20C-6.96554687%203.63097656%20-8.05609375%204.19945312%20-9.1796875%204.78515625%20C-10.11039063%205.18605469%20-11.04109375%205.58695313%20-12%206%20C-12.66%205.67%20-13.32%205.34%20-14%205%20C-12.75443908%204.18071114%20-11.50333365%203.36984814%20-10.25%202.5625%20C-9.20585938%201.88380859%20-9.20585938%201.88380859%20-8.140625%201.19140625%20C-5.17385561%20-0.45980664%20-3.14566509%20-1.57283254%200%200%20Z%20%22%20fill%3D%22%23555555%22%20transform%3D%22translate(551%2C537)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.0169313%202.65498232%201.13022151%203.69155375%200.00390625%206.359375%20C-0.47175781%207.14828125%20-0.94742188%207.9371875%20-1.4375%208.75%20C-2.14712891%209.94882812%20-2.14712891%209.94882812%20-2.87109375%2011.171875%20C-3.24363281%2011.77515625%20-3.61617187%2012.3784375%20-4%2013%20C-5.0169313%2010.34501768%20-5.13022151%209.30844625%20-4.00390625%206.640625%20C-3.52824219%205.85171875%20-3.05257812%205.0628125%20-2.5625%204.25%20C-2.08941406%203.45078125%20-1.61632812%202.6515625%20-1.12890625%201.828125%20C-0.75636719%201.22484375%20-0.38382813%200.6215625%200%200%20Z%20%22%20fill%3D%22%239E9E9E%22%20transform%3D%22translate(670%2C529)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.66%201.32%201.32%202%202%20C0.02%205.63%20-1.96%209.26%20-4%2013%20C-5%209%20-5%209%20-4.00390625%206.640625%20C-3.52824219%205.85171875%20-3.05257812%205.0628125%20-2.5625%204.25%20C-2.08941406%203.45078125%20-1.61632812%202.6515625%20-1.12890625%201.828125%20C-0.75636719%201.22484375%20-0.38382813%200.6215625%200%200%20Z%20%22%20fill%3D%22%23939393%22%20transform%3D%22translate(189%2C274)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C3.465%201.98%203.465%201.98%207%204%20C7%205.98%207%207.96%207%2010%20C4.74754119%207.31158141%203.11786042%205.35358125%202%202%20C1.34%202%200.68%202%200%202%20C0%201.34%200%200.68%200%200%20Z%20%22%20fill%3D%22%23242424%22%20transform%3D%22translate(664%2C258)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C3.62613199%200.56959153%205.25517741%201.92374534%207.75%204.5625%20C8.36359375%205.20316406%208.9771875%205.84382812%209.609375%206.50390625%20C10.06828125%206.99761719%2010.5271875%207.49132812%2011%208%20C10.67%208.99%2010.34%209.98%2010%2011%20C9.61328125%2010.54109375%209.2265625%2010.0821875%208.828125%209.609375%20C5.99804049%206.274919%203.15638645%203.03498697%200%200%20Z%20%22%20fill%3D%22%233C1C02%22%20transform%3D%22translate(616%2C202)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.8125%20-0.1875%202.8125%20-0.1875%206%200%20C6.99%200.99%207.98%201.98%209%203%20C6.03%203%203.06%203%200%203%20C0%202.01%200%201.02%200%200%20Z%20%22%20fill%3D%22%23863E05%22%20transform%3D%22translate(556%2C168)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.45699392%202.63249349%20-4.56568654%204.78137264%20-8%206%20C-8.99%205.67%20-9.98%205.34%20-11%205%20C-4.85714286%20-0.71428571%20-4.85714286%20-0.71428571%200%200%20Z%20%22%20fill%3D%22%232B2B2B%22%20transform%3D%22translate(486%2C568)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C4.55712436%200.5425148%208.02568234%201.6893502%2012%204%20C12.33%204.66%2012.66%205.32%2013%206%20C8.14036821%205.39254603%204.2594482%203.27241033%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23C57738%22%20transform%3D%22translate(318%2C312)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.66%201.98%201.32%203%202%20C-0.465%204.97%20-0.465%204.97%20-4%208%20C-3.50168276%204.31245243%20-2.89932357%202.39509338%200%200%20Z%20%22%20fill%3D%22%23756F6A%22%20transform%3D%22translate(194%2C253)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.33%201.98%200.66%203%201%20C0.03%203.64%20-2.94%206.28%20-6%209%20C-6%206%20-6%206%20-4.6875%204.39453125%20C-4.130625%203.87246094%20-3.57375%203.35039062%20-3%202.8125%20C-2.443125%202.28269531%20-1.88625%201.75289062%20-1.3125%201.20703125%20C-0.6628125%200.60955078%20-0.6628125%200.60955078%200%200%20Z%20%22%20fill%3D%22%23B46D33%22%20transform%3D%22translate(209%2C237)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C0.00390625%204.3828125%200.00390625%204.3828125%20-1.4375%207.125%20C-1.91058594%208.03507813%20-2.38367188%208.94515625%20-2.87109375%209.8828125%20C-3.24363281%2010.58148437%20-3.61617187%2011.28015625%20-4%2012%20C-4.65234375%2010.265625%20-4.65234375%2010.265625%20-5%208%20C-4.00390625%205.859375%20-4.00390625%205.859375%20-2.5625%203.75%20C-2.08941406%203.04359375%20-1.61632812%202.3371875%20-1.12890625%201.609375%20C-0.75636719%201.07828125%20-0.38382813%200.5471875%200%200%20Z%20%22%20fill%3D%22%23979797%22%20transform%3D%22translate(660%2C536)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.92540704%200.62687294%205.4835249%201.35127493%208%203%20C8.75%205.125%208.75%205.125%209%207%20C5.18315774%205.44499019%202.80804268%202.96404505%200%200%20Z%20%22%20fill%3D%22%233E1D02%22%20transform%3D%22translate(591%2C182)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-7.42857143%204.42857143%20-7.42857143%204.42857143%20-11%205%20C-4.75324675%20-1.58441558%20-4.75324675%20-1.58441558%200%200%20Z%20%22%20fill%3D%22%23212121%22%20transform%3D%22translate(613%2C509)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C-3.75%206.875%20-3.75%206.875%20-6%208%20C-5.8125%205.6875%20-5.8125%205.6875%20-5%203%20C-2.4375%201.1875%20-2.4375%201.1875%200%200%20Z%20%22%20fill%3D%22%23A3A3A3%22%20transform%3D%22translate(170%2C306)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-4.30769231%203.93846154%20-4.30769231%203.93846154%20-7.8125%204.25%20C-8.534375%204.1675%20-9.25625%204.085%20-10%204%20C-6.87839899%200.56623888%20-4.64008112%20-1.54669371%200%200%20Z%20%22%20fill%3D%22%23AB7C55%22%20transform%3D%22translate(577%2C287)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C4.75481646%200.57634139%207.97048212%202.55068521%2012%205%20C10%206%2010%206%207.6875%205.3125%20C4.74961699%203.87771993%202.47613357%202.12240021%200%200%20Z%20%22%20fill%3D%22%23D0742B%22%20transform%3D%22translate(250%2C279)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-1.96%204.465%20-1.96%204.465%20-6%208%20C-6.66%207.67%20-7.32%207.34%20-8%207%20C-3.76744186%201.25581395%20-3.76744186%201.25581395%200%200%20Z%20%22%20fill%3D%22%23954709%22%20transform%3D%22translate(262%2C190)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-0.97%203.64%20-3.94%206.28%20-7%209%20C-7.66%208.67%20-8.32%208.34%20-9%208%20C-7.87811441%206.85111717%20-6.75238316%205.70598863%20-5.625%204.5625%20C-4.99851562%203.92441406%20-4.37203125%203.28632813%20-3.7265625%202.62890625%20C-2%201%20-2%201%200%200%20Z%20%22%20fill%3D%22%236A3206%22%20transform%3D%22translate(333%2C145)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%201.32%201.32%202.64%202%204%20C0.35%205.65%20-1.3%207.3%20-3%209%20C-2.5020163%205.26512223%20-2.12508244%203.18762365%200%200%20Z%20%22%20fill%3D%22%23C4C4C4%22%20transform%3D%22translate(648%2C562)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.40907283%202.81814566%200.50872691%204.17277204%20-0.4375%207.125%20C-0.72496094%208.03507812%20-1.01242188%208.94515625%20-1.30859375%209.8828125%20C-1.53675781%2010.58148438%20-1.76492187%2011.28015625%20-2%2012%20C-2.33%2012%20-2.66%2012%20-3%2012%20C-3.36923077%204.61538462%20-3.36923077%204.61538462%20-1.5%201.5%20C-1.005%201.005%20-0.51%200.51%200%200%20Z%20%22%20fill%3D%22%235D5D5D%22%20transform%3D%22translate(157%2C321)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-3.42346555%203.14958831%20-6.44262737%203.56179109%20-11%204%20C-9.71264403%201.42528807%20-8.71510189%201.29583343%20-6.0625%200.3125%20C-5.35222656%200.04050781%20-4.64195312%20-0.23148437%20-3.91015625%20-0.51171875%20C-2%20-1%20-2%20-1%200%200%20Z%20%22%20fill%3D%22%23BB7943%22%20transform%3D%22translate(640%2C257)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.33%201.98%200.66%203%201%20C2.0479279%202.00596297%201.08812654%203.00461563%200.125%204%20C-0.40867188%204.556875%20-0.94234375%205.11375%20-1.4921875%205.6875%20C-3%207%20-3%207%20-5%207%20C-3.70700306%204.11562221%20-2.34058637%202.12780579%200%200%20Z%20%22%20fill%3D%22%238A572E%22%20transform%3D%22translate(222%2C204)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C7.81636537%201.91722169%207.81636537%201.91722169%2010%205%20C10%205.66%2010%206.32%2010%207%20C9.01%207%208.02%207%207%207%20C5.98594743%205.67732273%204.98731742%204.34275169%204%203%20C1.91665365%201.7483533%201.91665365%201.7483533%200%201%20C0%200.67%200%200.34%200%200%20Z%20%22%20fill%3D%22%23472103%22%20transform%3D%22translate(569%2C168)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.515625%200.2475%201.03125%200.495%201.5625%200.75%20C-4.8375%204.81153846%20-4.8375%204.81153846%20-7.875%204.5%20C-8.390625%204.2525%20-8.90625%204.005%20-9.4375%203.75%20C-3.0375%20-0.31153846%20-3.0375%20-0.31153846%200%200%20Z%20%22%20fill%3D%22%238F5D34%22%20transform%3D%22translate(289.4375%2C162.25)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2.81080836%201.14726872%204.1782406%201.94701628%206.0625%204.25%20C-1.5625%202.5%20-1.5625%202.5%20-4.9375%200.25%20C-2.9375%20-0.75%20-2.9375%20-0.75%200%200%20Z%20%22%20fill%3D%22%23200F02%22%20transform%3D%22translate(560.9375%2C159.75)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C0.73760288%201.86658615%20-0.53527501%202.71792059%20-1.8125%203.5625%20C-2.87404297%204.27599609%20-2.87404297%204.27599609%20-3.95703125%205.00390625%20C-6%206%20-6%206%20-9%205%20C-2.25%201.125%20-2.25%201.125%200%200%20Z%20%22%20fill%3D%22%23222222%22%20transform%3D%22translate(513%2C554)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C7.57142857%201.85714286%207.57142857%201.85714286%2010%205%20C5.2482602%204.56802365%203.07999946%203.67230705%200%200%20Z%20%22%20fill%3D%22%23A57D5D%22%20transform%3D%22translate(384%2C344)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1%202%201%202%200.375%204%20C-1.39265071%206.57112831%20-3.07589059%207.07659703%20-6%208%20C-4.55746343%204.63408134%20-2.66735273%202.48952921%200%200%20Z%20%22%20fill%3D%22%2339200B%22%20transform%3D%22translate(201%2C222)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C-1.465%203.97%20-1.465%203.97%20-5%207%20C-5.33%205.68%20-5.66%204.36%20-6%203%20C-5.38125%202.87625%20-4.7625%202.7525%20-4.125%202.625%20C-1.80879168%202.12802644%20-1.80879168%202.12802644%200%200%20Z%20%22%20fill%3D%22%23888888%22%20transform%3D%22translate(639%2C581)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.66%200.33%201.32%200.66%202%201%20C0.75023244%204.65316671%200.32901247%205.78065836%20-3%208%20C-2.45276317%204.62537285%20-1.9451%202.91765%200%200%20Z%20%22%20fill%3D%22%23202020%22%20transform%3D%22translate(630%2C577)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C6.52307692%200.61538462%206.52307692%200.61538462%208.9375%202.5625%20C9.288125%203.036875%209.63875%203.51125%2010%204%20C6.39703406%204.41176754%205.21597933%204.1535853%202.1875%202%20C1.465625%201.34%200.74375%200.68%200%200%20Z%20%22%20fill%3D%22%235F5F5F%22%20transform%3D%22translate(268%2C526)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.33%200.66%200.66%201.32%201%202%20C0.22265625%204.1640625%200.22265625%204.1640625%20-0.9375%206.625%20C-1.31777344%207.44226563%20-1.69804688%208.25953125%20-2.08984375%209.1015625%20C-2.39019531%209.72804688%20-2.69054687%2010.35453125%20-3%2011%20C-3.83583327%208.62392051%20-4.1842383%207.45550373%20-3.22265625%205.078125%20C-1.61132812%202.5390625%20-1.61132812%202.5390625%200%200%20Z%20%22%20fill%3D%22%23606060%22%20transform%3D%22translate(668%2C514)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.91058531%203.07322544%201.08886184%205.80097361%201%209%20C0.01%209%20-0.98%209%20-2%209%20C-1.125%201.125%20-1.125%201.125%200%200%20Z%20%22%20fill%3D%22%23ADADAD%22%20transform%3D%22translate(688%2C402)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-5.17578125%203.22265625%20-5.17578125%203.22265625%20-7%204%20C-7.99%203.67%20-8.98%203.34%20-10%203%20C-3.375%20-1.125%20-3.375%20-1.125%200%200%20Z%20%22%20fill%3D%22%23A07E62%22%20transform%3D%22translate(467%2C340)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-0.66%200%20-1.32%200%20-2%200%20C-2%200.66%20-2%201.32%20-2%202%20C-4.31%202.66%20-6.62%203.32%20-9%204%20C-6.35287314%200.09233654%20-4.86783735%20-1.62261245%200%200%20Z%20%22%20fill%3D%22%23AB7C55%22%20transform%3D%22translate(527%2C311)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.32%200.33%202.64%200.66%204%201%20C2.02%201.99%202.02%201.99%200%203%20C0%202.01%200%201.02%200%200%20Z%20M-2%203%20C-1.34%203.33%20-0.68%203.66%200%204%20C-0.99%204.99%20-1.98%205.98%20-3%207%20C-3.66%206.67%20-4.32%206.34%20-5%206%20C-4.01%205.01%20-3.02%204.02%20-2%203%20Z%20%22%20fill%3D%22%236B3306%22%20transform%3D%22translate(339%2C143)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.53625%200.226875%201.0725%200.45375%201.625%200.6875%20C-3.79038462%203.76442308%20-3.79038462%203.76442308%20-6.75%203.375%20C-7.554375%203.0346875%20-7.554375%203.0346875%20-8.375%202.6875%20C-2.95961538%20-0.38942308%20-2.95961538%20-0.38942308%200%200%20Z%20%22%20fill%3D%22%23A57D5D%22%20transform%3D%22translate(451.375%2C346.3125)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C1.96713413%202.95070119%202.65358161%204.53581611%203%208%20C2.34%208.99%201.68%209.98%201%2011%20C-0.17571451%207.32589215%20-0.07366746%203.83070817%200%200%20Z%20%22%20fill%3D%22%23444444%22%20transform%3D%22translate(694%2C316)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C0.99%200.33%201.98%200.66%203%201%20C2.67%202.32%202.34%203.64%202%205%20C1.01%205%200.02%205%20-1%205%20C-0.67%203.35%20-0.34%201.7%200%200%20Z%20%22%20fill%3D%22%238D8B8A%22%20transform%3D%22translate(199%2C257)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C2%203.75%202%203.75%202%206%20C0.0625%205.1875%200.0625%205.1875%20-2%204%20C-2.33%203.01%20-2.66%202.02%20-3%201%20C-2.01%200.67%20-1.02%200.34%200%200%20Z%20%22%20fill%3D%22%23C78D5E%22%20transform%3D%22translate(200%2C252)%22%2F%3E%0A%3Cpath%20d%3D%22M0%200%20C-2.17424117%202.50037734%20-3.73045798%203.43628586%20-7%204%20C-7.33%203.01%20-7.66%202.02%20-8%201%20C-5.07175348%200.02391783%20-3.04386724%20-0.08226668%200%200%20Z%20%22%20fill%3D%22%23F2CBA4%22%20transform%3D%22translate(341%2C139)%22%2F%3E%0A%3C%2Fsvg%3E%0A', GeofencingAdd, GeofencingColor, AppData);

}

})
define('./functions/90136c37dea4943c2e93237c0dc62f72/code.js', () => { 

BackendlessUI.Functions.Custom['fn_90136c37dea4943c2e93237c0dc62f72'] = async function fn_90136c37dea4943c2e93237c0dc62f72(Min, Max, Input, Target) {
return (await (async function(Input) {
	function interpolateColor(value) {
	    // Ensure the input value is within the range [0, 100]
	    value = Math.min(100, Math.max(0, value));
	
	    let red, green, blue;
	
	    if (value <= 50) {
	        // Formula for the green value from 0 to 50
	        green = Math.round((255 / 50) * value);
	        red = 255;
	        blue = 0;
	    } else {
	        // Formula for the red value from 50 to 100
	        red = Math.round((255 / 50) * (100 - value));
	        green = 255;
	        blue = 0;
	    }
	
	    return `rgb(${red}, ${green}, ${blue})`;
	}
	
	// Example usage:
	const inputValue = Input; // Replace this with your input value
	const resultColor = interpolateColor(inputValue);
	
	return resultColor
})((await (async function(Min, Max, Input, Target) {
	function calculateScore(min, target, max, input) {
	  if (input < min || input > max) {
	    return 0;
	  } else if (target === input) {
	    return 100;
	  } else if (input >= min && input <= target) {
	    return ((input - min) / (target - min)) * 100;
	  } else {
	    return ((max - input) / (max - target)) * 100;
	  }
	}
	
	// Example usage with your provided values
	const min = Min;
	const target = Target;
	const max = Max;
	const input = Input;
	
	const result = calculateScore(min, target, max, input);
	
	return result
})(Min, Max, Input, Target))))
}

})
define('./functions/91894a831f2a6a0b26cbd0bea5bbaef8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8'] = async function fn_91894a831f2a6a0b26cbd0bea5bbaef8(Value, ErrorValue) {
var Value;


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Value))) {
    Value = ErrorValue;
  } else {
    Value = Value;
  }

return Value
}

})
define('./functions/9458f55be4fb02eee2e72e0b6b1c347c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9458f55be4fb02eee2e72e0b6b1c347c'] = async function fn_9458f55be4fb02eee2e72e0b6b1c347c(listToInspect, filterFunction) {
return (await (async function(array, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.uniqBy(array, iteratee)
})(listToInspect, filterFunction))
}

})
define('./functions/95a8a1ed4f6da56382e43a6149f25d0c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_95a8a1ed4f6da56382e43a6149f25d0c'] = async function fn_95a8a1ed4f6da56382e43a6149f25d0c(listToQuery, valuePickerFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.takeRightWhile(array, predicate)
})(listToQuery, valuePickerFunction))
}

})
define('./functions/95b21da849de975107054e732dc24af2/code.js', () => { 

BackendlessUI.Functions.Custom['fn_95b21da849de975107054e732dc24af2'] = async function fn_95b21da849de975107054e732dc24af2(CanData, VehicleData) {
var Return;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Return = (getObjectProperty(CanData, 'can.engine.rpm')) > (getObjectProperty(VehicleData, 'Can Max RPM')) ? '#0055ff' : ((getObjectProperty(CanData, 'can.maintenance.required.status')) == true || (getObjectProperty(CanData, 'can.lights.failure.indicator.status')) == true || (getObjectProperty(CanData, 'can.oil.pressure.indicator.status')) == true ? '#9900ff' : ((getObjectProperty(CanData, 'position.speed')) > (getObjectProperty(VehicleData, 'Can Max Speed')) ? '#CC6633' : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(CanData, 'position.speed')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(CanData, 'can.engine.rpm')))) ? '#000000' : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(CanData, 'can.engine.rpm')))) ? '#000000' : ((getObjectProperty(CanData, 'can.engine.rpm')) == 0 ? '#000000' : ' #00ff00'))) : ((getObjectProperty(CanData, 'position.speed')) == 0 ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(CanData, 'can.engine.rpm')))) ? '#000000' : ((getObjectProperty(CanData, 'can.engine.rpm')) == 0 ? '#000000' : ' #00ff00')) : '#ffffff'))));

return Return
}

})
define('./functions/9743fcc6f0cc18c8ec28a5f4d0d17e34/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9743fcc6f0cc18c8ec28a5f4d0d17e34'] = async function fn_9743fcc6f0cc18c8ec28a5f4d0d17e34(listToModify, valuePickerFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.remove(array, predicate)
})(listToModify, valuePickerFunction))
}

})
define('./functions/99fc0a91978b9ede09a701f93999c4e8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_99fc0a91978b9ede09a701f93999c4e8'] = async function fn_99fc0a91978b9ede09a701f93999c4e8(Points) {
var Result, Cartesian_Perimeter, Actual_Perimeter, Y, X, my_2, my_1, Counter, j, Co_ordiante_2, Co_ordiante_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (Points.length > 2) {
    Counter = 0;
    Actual_Perimeter = 0;
    for (var j_index in Points) {
      j = Points[j_index];
      Counter = Counter + 1;
      Co_ordiante_1 = Points[(Counter - 1)];
      if (Points.length == Counter) {
        Co_ordiante_2 = Points[0];
      } else {
        Co_ordiante_2 = Points[((Counter + 1) - 1)];
      }
      Actual_Perimeter = Actual_Perimeter + (await (async function(lat1, lat2, lon1, lon2) {
      	const R = 6371e3; // metres
      	const φ1 = lat1 * Math.PI/180; // φ, λ in radians
      	const φ2 = lat2 * Math.PI/180;
      	const Δφ = (lat2-lat1) * Math.PI/180;
      	const Δλ = (lon2-lon1) * Math.PI/180;
      	
      	const a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
      	          Math.cos(φ1) * Math.cos(φ2) *
      	          Math.sin(Δλ/2) * Math.sin(Δλ/2);
      	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
      	
      	const d = R * c; // in metres
      	
      	return R * c
      })((getObjectProperty(Co_ordiante_1, 'lat')), (getObjectProperty(Co_ordiante_2, 'lat')), (getObjectProperty(Co_ordiante_1, 'lng')), (getObjectProperty(Co_ordiante_2, 'lng'))));
    }
    Counter = 0;
    Cartesian_Perimeter = 0;
    for (var j_index2 in Points) {
      j = Points[j_index2];
      Counter = Counter + 1;
      my_1 = Points[(Counter - 1)];
      if (Points.length == Counter) {
        my_2 = Points[0];
      } else {
        my_2 = Points[((Counter + 1) - 1)];
      }
      Cartesian_Perimeter = Cartesian_Perimeter + Math.sqrt((await BackendlessUI.Functions.Custom['fn_1ee3ca4117e155dcd036a9ad569bd2ec'](((getObjectProperty(my_2, 'lat')) - (getObjectProperty(my_1, 'lat'))))) + (await BackendlessUI.Functions.Custom['fn_1ee3ca4117e155dcd036a9ad569bd2ec'](((getObjectProperty(my_2, 'lng')) - (getObjectProperty(my_1, 'lng'))))));
    }
    Counter = 0;
    X = 0;
    for (var j_index3 in Points) {
      j = Points[j_index3];
      Counter = Counter + 1;
      my_1 = (getObjectProperty((Points[(Counter - 1)]), 'lng'));
      if (Points.length == Counter) {
        my_2 = (getObjectProperty((Points[0]), 'lat'));
      } else {
        my_2 = (getObjectProperty((Points[((Counter + 1) - 1)]), 'lat'));
      }
      X = X + my_1 * my_2;
    }
    Counter = 0;
    Y = 0;
    for (var j_index4 in Points) {
      j = Points[j_index4];
      Counter = Counter + 1;
      my_1 = (getObjectProperty((Points[(Counter - 1)]), 'lat'));
      if (Points.length == Counter) {
        my_2 = (getObjectProperty((Points[0]), 'lng'));
      } else {
        my_2 = (getObjectProperty((Points[((Counter + 1) - 1)]), 'lng'));
      }
      Y = Y + my_1 * my_2;
    }
    Result = ((X - Y) / 2) * (Actual_Perimeter / Cartesian_Perimeter) * 10 < 0 ? ((X - Y) / 2) * (Actual_Perimeter / Cartesian_Perimeter) * 10 * -1 : ((X - Y) / 2) * (Actual_Perimeter / Cartesian_Perimeter) * 10;
  } else {
    Result = 0;
  }

return 
}

})
define('./functions/9be1a86f7a3a2b8ee987b8cb91164058/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9be1a86f7a3a2b8ee987b8cb91164058'] = function fn_9be1a86f7a3a2b8ee987b8cb91164058(Component, Data, Property) {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(Data, Property)) == true) {
    Data[Property] = false;
    Component['icon'] = 'arrow drop down';
  } else {
    Data[Property] = true;
    Component['icon'] = 'arrow drop up';
  }

}

})
define('./functions/9d311a5c4af73beb5f41d0d88f7591ab/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9d311a5c4af73beb5f41d0d88f7591ab'] = async function fn_9d311a5c4af73beb5f41d0d88f7591ab(Decleration) {
  if (await Backendless.UserService.isValidLogin()) {
    if (!Decleration) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
    }
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  }

}

})
define('./functions/9e6128abb3b88ef952f18155d3c2eb8a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9e6128abb3b88ef952f18155d3c2eb8a'] = async function fn_9e6128abb3b88ef952f18155d3c2eb8a(Company, Component) {
var Passer, Component, Title, List_Items, Company, List_Item, j, Columns;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  Company = Company;
  Component = Component;
  List_Items = [];
  List_Item = ({ [`Test`]: null });
  var Columns_list = (getObjectProperty((getObjectProperty((getObjectProperty(Component, 'el')), 'dataManager')), 'columns'));
  for (var Columns_index in Columns_list) {
    Columns = Columns_list[Columns_index];
    List_Item[(getObjectProperty(Columns, 'title'))] = (getObjectProperty(Columns, 'title'));
  }
  delete List_Item['Test'];
  addItemToList(List_Items, List_Item);
  var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(Component, 'el')), 'dataManager')), 'data'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    List_Item = ({ [`Test`]: null });
    var Columns_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(Component, 'el')), 'dataManager')), 'columns'));
    for (var Columns_index2 in Columns_list2) {
      Columns = Columns_list2[Columns_index2];
      List_Item[(getObjectProperty(Columns, 'title'))] = ((getObjectProperty(j, (getObjectProperty(Columns, 'field')))) == null ? '-' : (getObjectProperty(j, (getObjectProperty(Columns, 'field')))));
    }
    delete List_Item['Test'];
    addItemToList(List_Items, List_Item);
  }
  Title = (generateUUID().long());
  Passer = (await Backendless.Request.post(`${Backendless.appPath}/services/PDFGeneratorAPI/${'1368809'}/data-output/${Title}`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'data': ({ [`Logo`]: ((getObjectProperty(Company, 'Company_Logo')) === null) ? null : (getObjectProperty(Company, 'Company_Logo')),[`Company`]: (getObjectProperty(Company, 'Company')),[`Date`]: String((new Date()).toLocaleDateString()),[`Time`]: String((new Date()).toLocaleTimeString()),[`line_items`]: List_Items,[`Barcode`]: undefined,[`Header`]: (getObjectProperty(Component, 'title')) }) }));
  console.log('abc');
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(Passer, 'fileUrl')), true, undefined);

}

})
define('./functions/9ef225438f774527c9eb1feb6044ce26/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9ef225438f774527c9eb1feb6044ce26'] = async function fn_9ef225438f774527c9eb1feb6044ce26(listsToInspect, filterFunction) {
return (await (async function(arrays, iteratee) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.unionBy(...arrays, iteratee)
})(listsToInspect, filterFunction))
}

})
define('./functions/a0029e53d7d4c3e13bac42c9819788e1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a0029e53d7d4c3e13bac42c9819788e1'] = async function fn_a0029e53d7d4c3e13bac42c9819788e1(Point1, Point2) {
var Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Result = (await (async function(startLat, startLng, destLat, destLng) {
  	  y = Math.sin(destLng - startLng) * Math.cos(destLat);
  	  x = Math.cos(startLat) * Math.sin(destLat) -
  	        Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng);
  	  brng = Math.atan2(y, x);
  	  
  	  return brng
  })(((getObjectProperty(Point1, 'lat')) * (Math.PI / 180)), ((getObjectProperty(Point1, 'lng')) * (Math.PI / 180)), ((getObjectProperty(Point2, 'lat')) * (Math.PI / 180)), ((getObjectProperty(Point2, 'lng')) * (Math.PI / 180)))) * (180 / Math.PI);

return Result
}

})
define('./functions/a1856c74d27745ecf1c18a8269e6103d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a1856c74d27745ecf1c18a8269e6103d'] = async function fn_a1856c74d27745ecf1c18a8269e6103d(listToInspect, functionInvokedPerIteration, indexToSearchFrom) {
return (await (async function(array, predicate, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	    fromIndex = array.length - 1
	}

	return _.findLastIndex(array, predicate, fromIndex)
})(listToInspect, functionInvokedPerIteration, indexToSearchFrom))
}

})
define('./functions/a376d7d6007e9dbebe6eea15750b4b61/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a376d7d6007e9dbebe6eea15750b4b61'] = async function fn_a376d7d6007e9dbebe6eea15750b4b61(listToInspect, comparatorFunction) {
return (await (async function(array, comparator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.uniqWith(array, comparator)
})(listToInspect, comparatorFunction))
}

})
define('./functions/a3ba58b7eb1904ecefbc1692317c470e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a3ba58b7eb1904ecefbc1692317c470e'] = function fn_a3ba58b7eb1904ecefbc1692317c470e(Text) {
var Check;


  if ((Text.indexOf('"') !== -1) || (Text.indexOf('"') !== -1) || (Text.indexOf('!') !== -1) || (Text.indexOf('#') !== -1) || (Text.indexOf('$') !== -1) || (Text.indexOf('%') !== -1) || (Text.indexOf('&') !== -1) || (Text.indexOf('\'') !== -1) || (Text.indexOf('(') !== -1) || (Text.indexOf(')') !== -1) || (Text.indexOf('*') !== -1) || (Text.indexOf('+') !== -1) || (Text.indexOf(',') !== -1) || (Text.indexOf('-') !== -1) || (Text.indexOf('.') !== -1) || (Text.indexOf('/') !== -1) || (Text.indexOf(':') !== -1) || (Text.indexOf(';') !== -1) || (Text.indexOf('<') !== -1) || (Text.indexOf('=') !== -1) || (Text.indexOf('>') !== -1) || (Text.indexOf('?') !== -1) || (Text.indexOf('@') !== -1) || (Text.indexOf('[') !== -1) || (Text.indexOf(']') !== -1) || (Text.indexOf('^') !== -1) || (Text.indexOf('_') !== -1) || (Text.indexOf('{') !== -1) || (Text.indexOf('|') !== -1) || (Text.indexOf('}') !== -1) || (Text.indexOf('~') !== -1) || (Text.indexOf('"') !== -1) || (Text.indexOf('1') !== -1) || (Text.indexOf('2') !== -1) || (Text.indexOf('3') !== -1) || (Text.indexOf('4') !== -1) || (Text.indexOf('5') !== -1) || (Text.indexOf('6') !== -1) || (Text.indexOf('7') !== -1) || (Text.indexOf('8') !== -1) || (Text.indexOf('9') !== -1) || (Text.indexOf('-') !== -1)) {
    Check = true;
  } else {
    Check = false;
  }

return Check
}

})
define('./functions/a868a6a4f6678dfcdaf2fbd8ee89f031/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a868a6a4f6678dfcdaf2fbd8ee89f031'] = async function fn_a868a6a4f6678dfcdaf2fbd8ee89f031(listToModify, valuesToRemove) {
  await (async function(array, values) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pullAll(array, values)
  })(listToModify, valuesToRemove);

}

})
define('./functions/ad46038e80ca69b957c4484dc2a56c18/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ad46038e80ca69b957c4484dc2a56c18'] = async function fn_ad46038e80ca69b957c4484dc2a56c18(PlaceId) {
return (await Backendless.Request.get(`${Backendless.appPath}/services/GoogleAPI/PlaceDetails`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'placeId': JSON.stringify(PlaceId) }).send())
}

})
define('./functions/ad96c6069277798e0c016698de7c2be1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ad96c6069277798e0c016698de7c2be1'] = async function fn_ad96c6069277798e0c016698de7c2be1(Point, Find, Distance) {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



return (await Backendless.Request.get(`${Backendless.appPath}/services/GoogleAPI/Nearby`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'location': JSON.stringify(([(getObjectProperty(Point, 'lat')),' ',(getObjectProperty(Point, 'lng'))].join(''))),'radius': JSON.stringify(Distance),'keyword': JSON.stringify(Find) }).send())
}

})
define('./functions/b10683b89d3a8232328807d905aa7ecc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b10683b89d3a8232328807d905aa7ecc'] = async function fn_b10683b89d3a8232328807d905aa7ecc(sortedListToInspect, valueToEvaluate) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedLastIndex(array, value)
})(sortedListToInspect, valueToEvaluate))
}

})
define('./functions/b3cdf4a3ed5a52efed2ea82b1ec2cb92/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b3cdf4a3ed5a52efed2ea82b1ec2cb92'] = async function fn_b3cdf4a3ed5a52efed2ea82b1ec2cb92(App, Position, Axle, Type, Cost, Mileage) {
var Returned_ID, New_Tyre_Number, Last_tyre_number_of_digits, New_Tyre, error, item, Transaction_Result, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence, Tyre_Sequence_List, j, k;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function Tyre_ID() {
  if ((getObjectProperty((getObjectProperty((getObjectProperty(App, 'User')), 'Company')), 'TyreAvailable')) === null) {
    New_Tyre_Number = (getObjectProperty((getObjectProperty((getObjectProperty(App, 'User')), 'Company')), 'TyreNext'));
    (getObjectProperty((getObjectProperty(App, 'User')), 'Company'))['TyreNext'] = ((getObjectProperty((getObjectProperty((getObjectProperty(App, 'User')), 'Company')), 'TyreNext')) + 1);
  } else {
    New_Tyre_Number = (getObjectProperty((getObjectProperty((getObjectProperty(App, 'User')), 'Company')), 'TyreAvailable'));
    (getObjectProperty((getObjectProperty(App, 'User')), 'Company'))['TyreAvailable'] = null;
  }
  Last_tyre_number_of_digits = getValueLength(New_Tyre_Number);
  Returned_ID = String(getObjectProperty((getObjectProperty((getObjectProperty(App, 'User')), 'Company')), 'ID Tag Tyres')) + String(Last_tyre_number_of_digits == 1 ? String('00000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 2 ? String('0000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 3 ? String('000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 4 ? String('00') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 5 ? String('0') + String(New_Tyre_Number) : New_Tyre_Number)))));
  return Returned_ID
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Redundant_Code() {
}

/**
 * Describe this function...
 */
async function Axle_Update_Code() {
  var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(App, 'User')), 'Company')), 'Tractors'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    var k_list = (getObjectProperty(j, 'Axles_Data'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      k['Parent ID (Tractor)'] = (getObjectProperty(j, 'objectId'));
    }
    console.log((await Backendless.Data.of('Axles').bulkUpsert( (getObjectProperty(j, 'Axles_Data')) )));
  }
  var j_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(App, 'User')), 'Company')), 'Trailers'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    var k_list2 = (getObjectProperty(j, 'Axles_Data'));
    for (var k_index2 in k_list2) {
      k = k_list2[k_index2];
      k['Parent ID (Trailer)'] = (getObjectProperty(j, 'objectId'));
    }
    console.log((await Backendless.Data.of('Axles').bulkUpsert( (getObjectProperty(j, 'Axles_Data')) )));
  }
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Axle))) {
    Tyre_Creation_API_Call = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tyre_Creation_API_Call;

      New_Tyre = ({ [`Cost_New`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Cost)) ? 5500 : Cost,[`Cost_Total`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Cost)) ? 5500 : Cost,[`ID`]: await Tyre_ID(),[`Make`]: 'System',[`Model`]: 'Generated',[`Mileage1`]: 0,[`Mileage2`]: 0,[`Mileage3`]: 0,[`Mileage4`]: 0,[`Mileage_Expected`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Mileage)) ? 80000 : Mileage,[`Selected Tyre Position`]: undefined,[`State`]: 'New',[`Status`]: 'All In Order',[`Type`]: Type,[`Tractor_ObjectId`]: undefined,[`Trailer_ObjectId`]: undefined,[`Warehouse`]: 'In',[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(App, 'User')), 'Company')), 'ownerId')) });
      _uow.create('Tyres', New_Tyre).setOpResultId('New Tyre Operation Refrence');
      _uow.update('Companies', (getObjectProperty((getObjectProperty(App, 'User')), 'Company')));
      New_Tyre_Operation_Refrence = 'New Tyre Operation Refrence';
      _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(App, 'User')), 'Company')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);

    })();

    Transaction_Result = (await Tyre_Creation_API_Call.execute());
    console.log(Transaction_Result);
    New_Tyre = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Transaction_Result, 'results')), 'New Tyre Operation Refrence')), 'result')), 'objectId')), Backendless.DataQueryBuilder.create().setRelated(['Axle'])));
    try {
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(App, 'User')), 'Company')), 'Tyres')), New_Tyre);

    } catch (error) {

    }
  } else {
    Tyre_Creation_API_Call = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tyre_Creation_API_Call;

      New_Tyre = ({ [`Cost_New`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Cost)) ? 5500 : Cost,[`Cost_Total`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Cost)) ? 5500 : Cost,[`ID`]: await Tyre_ID(),[`Make`]: 'System',[`Model`]: 'Generated',[`Mileage1`]: 0,[`Mileage2`]: 0,[`Mileage3`]: 0,[`Mileage4`]: 0,[`Mileage_Expected`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Mileage)) ? 80000 : Mileage,[`Selected Tyre Position`]: Position,[`State`]: 'New',[`Status`]: 'All In Order',[`Type`]: (getObjectProperty(Axle, 'Type')),[`Tractor_ObjectId`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Axle, 'Parent ID (Tractor)')))) ? null : (getObjectProperty(Axle, 'Parent ID (Tractor)')),[`Trailer_ObjectId`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Axle, 'Parent ID (Trailer)')))) ? null : (getObjectProperty(Axle, 'Parent ID (Trailer)')),[`Warehouse`]: 'Out',[`ownerId`]: (getObjectProperty(Axle, 'ownerId')) });
      _uow.create('Tyres', New_Tyre).setOpResultId('New Tyre Operation Refrence');
      _uow.update('Companies', (getObjectProperty((getObjectProperty(App, 'User')), 'Company')));
      New_Tyre_Operation_Refrence = 'New Tyre Operation Refrence';
      _uow.setRelation('Tyres', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)), 'Axle', [(getObjectProperty(Axle, 'objectId'))]);
      _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(App, 'User')), 'Company')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Axle, 'Parent ID (Tractor)'))))) {
        _uow.addToRelation('Trailers', (getObjectProperty(Axle, 'Parent ID (Trailer)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
      } else {
        _uow.addToRelation('Tractors', (getObjectProperty(Axle, 'Parent ID (Tractor)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
      }
      _uow.setRelation('Axles', (getObjectProperty(Axle, 'objectId')), Position, (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)));

    })();

    Transaction_Result = (await Tyre_Creation_API_Call.execute());
    console.log(Transaction_Result);
    New_Tyre = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Transaction_Result, 'results')), 'New Tyre Operation Refrence')), 'result')), 'objectId')), Backendless.DataQueryBuilder.create().setRelated(['Axle'])));
    try {
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(App, 'User')), 'Company')), 'Tyres')), New_Tyre);

    } catch (error) {

    }
    try {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Axle, 'Parent ID (Tractor)'))))) {
        addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(App, 'User')), 'Company')), 'Trailers')), async (item) => {


         return ((getObjectProperty(Axle, 'Parent ID (Trailer)')) == (getObjectProperty(item, 'objectId')));
        }))[0]), 'Tyres')), New_Tyre);
      } else {
        addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(App, 'User')), 'Company')), 'Tractors')), async (item) => {


         return ((getObjectProperty(Axle, 'Parent ID (Tractor)')) == (getObjectProperty(item, 'objectId')));
        }))[0]), 'Tyres')), New_Tyre);
      }

    } catch (error) {
      console.log(error);

    }
    try {
      Axle[Position] = New_Tyre;

    } catch (error) {

    }
  }

}

})
define('./functions/b55a0b2dad43d733ad63285e237240c8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b55a0b2dad43d733ad63285e237240c8'] = async function fn_b55a0b2dad43d733ad63285e237240c8(listToQuery, filterFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.dropRightWhile(array, predicate)
})(listToQuery, filterFunction))
}

})
define('./functions/b665c075565aa28862ac1e9374ca2b96/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b665c075565aa28862ac1e9374ca2b96'] = async function fn_b665c075565aa28862ac1e9374ca2b96(listToQuery, filterFunction) {
return (await (async function(array, predicate) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.dropWhile(array, predicate)
})(listToQuery, filterFunction))
}

})
define('./functions/b7bebd6f2ccdf3d6bdb2577d4e1da8e4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b7bebd6f2ccdf3d6bdb2577d4e1da8e4'] = async function fn_b7bebd6f2ccdf3d6bdb2577d4e1da8e4(IDEmployee) {
var User, Salary_Updater, Created_Wage, Details, Salary_Currnent, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function mathMean(myList) {
  return myList.reduce(function(x, y) {return x + y;}) / myList.length;
}

/**
 * Describe this function...
 */
async function Salary_Updater2() {
  Salary_Currnent['Bargaining_Council_and_Union_Levies'] = ((getObjectProperty(Details, 'Wages_Deduction_Bargaining_Council_Fee')) + (getObjectProperty(Details, 'Wages_Deduction_Union_Fee')));
  Salary_Currnent['Basic_Salary'] = (getObjectProperty(Details, 'Wages_Rate_Basic'));
  Salary_Currnent['Contractor_Per_Km'] = ((getObjectProperty(Details, 'Wages_Rate_Contractor_Mileage')) * (await Promise.all((await BackendlessUI.Functions.Custom['fn_082567e4c9a28272acac08042731a4be']((getObjectProperty(Salary_Currnent, 'Loads')), [({ [`Distance_Planned_LDP_To_DP`]: 0 })])).map(async item => {; return (getObjectProperty(item, 'Distance_Planned_LDP_To_DP'));}))).reduce(function(x, y) {return x + y;}));
  Salary_Currnent['Contractor_Tonnage'] = ((getObjectProperty(Details, 'Wages_Rate_Contractor_Tonnage')) * (await Promise.all((await BackendlessUI.Functions.Custom['fn_082567e4c9a28272acac08042731a4be']((getObjectProperty(Salary_Currnent, 'Loads')), [({ [`Tonnage_Delivered`]: 0 })])).map(async item => {; return (getObjectProperty(item, 'Tonnage_Delivered'));}))).reduce(function(x, y) {return x + y;}));
  Salary_Currnent['Distance Traveled'] = ((await Promise.all((await BackendlessUI.Functions.Custom['fn_082567e4c9a28272acac08042731a4be']((getObjectProperty(Salary_Currnent, 'Loads')), [({ [`Distance_Last_Delivery_To_Delivery_Point`]: 0 })])).map(async item => {; return (getObjectProperty(item, 'Distance_Last_Delivery_To_Delivery_Point'));}))).reduce(function(x, y) {return x + y;}));
  Salary_Currnent['Good_Driving_Bonus'] = ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Details, 'Wages_Rate_Good_Driving')))) ? 0 : (await Promise.all((await BackendlessUI.Functions.Custom['fn_082567e4c9a28272acac08042731a4be']((getObjectProperty(Salary_Currnent, 'Loads')), [({ [`Distance_Planned_LDP_To_DP`]: 0 })])).map(async item => {; return (getObjectProperty(item, 'Distance_Planned_LDP_To_DP'));}))).reduce(function(x, y) {return x + y;}) * mathMean(await Promise.all((await BackendlessUI.Functions.Custom['fn_082567e4c9a28272acac08042731a4be']((getObjectProperty(Salary_Currnent, 'Fuel')), [({ [`Fuel_Consumption_Ideal`]: 0.1,[`Fuel_Consumption_Actual`]: 0,[`Mileage_Differential`]: 0 })])).map(async item => {; return ((getObjectProperty(item, 'Fuel_Consumption_Actual')) / (getObjectProperty(item, 'Fuel_Consumption_Ideal')) > 0.98 ? ((getObjectProperty(item, 'Fuel_Consumption_Actual')) / (getObjectProperty(item, 'Fuel_Consumption_Ideal'))) * (getObjectProperty(Details, 'Wages_Rate_Good_Driving')) : ((getObjectProperty(item, 'Fuel_Consumption_Actual')) / (getObjectProperty(item, 'Fuel_Consumption_Ideal')) > 0.95 ? ((getObjectProperty(item, 'Fuel_Consumption_Actual')) / (getObjectProperty(item, 'Fuel_Consumption_Ideal'))) * (getObjectProperty(Details, 'Wages_Rate_Good_Driving')) * 0.5 : ((getObjectProperty(item, 'Fuel_Consumption_Actual')) / (getObjectProperty(item, 'Fuel_Consumption_Ideal')) <= 0.95 ? ((getObjectProperty(item, 'Fuel_Consumption_Actual')) / (getObjectProperty(item, 'Fuel_Consumption_Ideal'))) * (getObjectProperty(Details, 'Wages_Rate_Good_Driving')) * 0 : 0)));}))));
  Salary_Currnent['Mileage'] = ((await Promise.all((await BackendlessUI.Functions.Custom['fn_082567e4c9a28272acac08042731a4be']((getObjectProperty(Salary_Currnent, 'Loads')), [({ [`Distance_Planned_LDP_To_DP`]: 0 })])).map(async item => {; return (getObjectProperty(item, 'Distance_Planned_LDP_To_DP'));}))).reduce(function(x, y) {return x + y;}));
  Salary_Currnent['Sleep_Out_Pay'] = ((await Promise.all((await BackendlessUI.Functions.Custom['fn_082567e4c9a28272acac08042731a4be']((getObjectProperty(Salary_Currnent, 'Other')), [({ [`Type`]: 'Sleep Out',[`Cost`]: 0 })])).map(async item => {; return ((getObjectProperty(item, 'Type')) == 'Sleep Out' ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Cost')))) ? (getObjectProperty(Details, 'Wages_Rate_Sleep_Out')) : (getObjectProperty(item, 'Cost'))) : 0);}))).reduce(function(x, y) {return x + y;}));
  Salary_Currnent['Medical_Aid'] = (getObjectProperty(Details, 'Wages_Deduction_Medical_Aid_Fee'));
  Salary_Currnent['Provident_Pension_Fund'] = ((getObjectProperty(Details, 'Wages_Deduction_Pension_Fee')) + (getObjectProperty(Details, 'Wages_Deduction_Provident_Fund_Fee')));
  Salary_Currnent['Target Mileage'] = (getObjectProperty(Details, 'Wages_Rate_Target_Mileage'));
  Salary_Currnent['Target Tonnage'] = (getObjectProperty(Details, 'Wages_Rate_Target_Tonnage'));
  Salary_Currnent['Target_Mileage_Bonus'] = ((await Promise.all((await BackendlessUI.Functions.Custom['fn_082567e4c9a28272acac08042731a4be']((getObjectProperty(Salary_Currnent, 'Loads')), [({ [`Distance_Planned_LDP_To_DP`]: 0 })])).map(async item => {; return (getObjectProperty(item, 'Distance_Planned_LDP_To_DP'));}))).reduce(function(x, y) {return x + y;}) - (getObjectProperty(Details, 'Wages_Rate_Target_Mileage_Start')) > 0 ? (await Promise.all((await BackendlessUI.Functions.Custom['fn_082567e4c9a28272acac08042731a4be']((getObjectProperty(Salary_Currnent, 'Loads')), [({ [`Distance_Planned_LDP_To_DP`]: 0 })])).map(async item => {; return (getObjectProperty(item, 'Distance_Planned_LDP_To_DP'));}))).reduce(function(x, y) {return x + y;}) - (getObjectProperty(Details, 'Wages_Rate_Target_Mileage_Start')) : 0);
  Salary_Currnent['Target_Tonnage_Bonus'] = ((await Promise.all((await BackendlessUI.Functions.Custom['fn_082567e4c9a28272acac08042731a4be']((getObjectProperty(Salary_Currnent, 'Loads')), [({ [`Tonnage_Delivered`]: 0 })])).map(async item => {; return (getObjectProperty(item, 'Tonnage_Delivered'));}))).reduce(function(x, y) {return x + y;}) - (getObjectProperty(Details, 'Wages_Rate_Target_Tonnage_Start')) > 0 ? (await Promise.all((await BackendlessUI.Functions.Custom['fn_082567e4c9a28272acac08042731a4be']((getObjectProperty(Salary_Currnent, 'Loads')), [({ [`Tonnage_Delivered`]: 0 })])).map(async item => {; return (getObjectProperty(item, 'Tonnage_Delivered'));}))).reduce(function(x, y) {return x + y;}) - (getObjectProperty(Details, 'Wages_Rate_Target_Tonnage_Start')) : 0);
  Salary_Currnent['Tonnage Moved'] = ((await Promise.all((await BackendlessUI.Functions.Custom['fn_082567e4c9a28272acac08042731a4be']((getObjectProperty(Salary_Currnent, 'Loads')), [({ [`Tonnage_Delivered`]: 0 })])).map(async item => {; return (getObjectProperty(item, 'Tonnage_Delivered'));}))).reduce(function(x, y) {return x + y;}));
  Salary_Currnent['Wages_Rate_Target_Mileage_Start'] = (getObjectProperty(Details, 'Wages_Rate_Target_Mileage_Start'));
  Salary_Currnent['Wages_Rate_Target_Tonnage_Start'] = (getObjectProperty(Details, 'Wages_Rate_Target_Tonnage_Start'));
}


  User = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',IDEmployee,'\''].join(''))).setRelated(['Details.Wages_Current', 'Details.Wages_Current.Fuel', 'Details.Wages_Current.Loads', 'Details.Wages_Current.Other']).setRelationsDepth(10).setRelationsPageSize(100).setPageSize(100)))[0];
  Details = (getObjectProperty(User, 'Details'));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(User, 'Details')), 'Wages_Current'))))) {
    Salary_Updater = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Salary_Updater;

      Created_Wage = (_uow.create('Salaries', ({ [`Bargaining_Council_and_Union_Levies`]: (getObjectProperty(Details, 'Wages_Deduction_Bargaining_Council_Fee')) + (getObjectProperty(Details, 'Wages_Deduction_Union_Fee')),[`Basic_Salary`]: (getObjectProperty(Details, 'Wages_Rate_Basic')),[`Contractor_Per_Km`]: 0,[`Contractor_Tonnage`]: 0,[`Distance Traveled`]: 0,[`Good_Driving_Bonus`]: 0,[`Mileage`]: 0,[`Sleep_Out_Pay`]: 0,[`Medical_Aid`]: (getObjectProperty(Details, 'Wages_Deduction_Medical_Aid_Fee')),[`Provident_Pension_Fund`]: (getObjectProperty(Details, 'Wages_Deduction_Pension_Fee')) + (getObjectProperty(Details, 'Wages_Deduction_Provident_Fund_Fee')),[`Target Mileage`]: (getObjectProperty(Details, 'Wages_Rate_Target_Mileage')),[`Target Tonnage`]: (getObjectProperty(Details, 'Wages_Rate_Target_Tonnage')),[`Target_Mileage_Bonus`]: 0,[`Target_Tonnage_Bonus`]: 0,[`Tonnage Moved`]: 0,[`Wages_Rate_Target_Mileage_Start`]: (getObjectProperty(Details, 'Wages_Rate_Target_Mileage_Start')),[`Wages_Rate_Target_Tonnage_Start`]: (getObjectProperty(Details, 'Wages_Rate_Target_Tonnage_Start')) })));
      _uow.setRelation('Employees', Details, 'Wages_Current', [Created_Wage]);

    })();

    console.log((await Salary_Updater.execute()));
    User = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',IDEmployee,'\''].join(''))).setRelated(['Details.Wages_Current', 'Details.Wages_Current.Fuel', 'Details.Wages_Current.Loads', 'Details.Wages_Current.Other']).setRelationsDepth(10).setRelationsPageSize(100).setPageSize(100)))[0];
  } else {
    if ((new Date((new Date())).getMonth() + 1) == (new Date((getObjectProperty((getObjectProperty((getObjectProperty(User, 'Details')), 'Wages_Current')), 'created'))).getMonth() + 1)) {
      Salary_Currnent = (getObjectProperty((getObjectProperty(User, 'Details')), 'Wages_Current'));
      await Salary_Updater2();
      (getObjectProperty(User, 'Details'))['Wages_Current'] = (await Backendless.Data.of('Salaries').save(Salary_Currnent, true));
      User = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',IDEmployee,'\''].join(''))).setRelated(['Details.Wages_Current', 'Details.Wages_Current.Fuel', 'Details.Wages_Current.Loads', 'Details.Wages_Current.Other']).setRelationsDepth(10).setRelationsPageSize(100).setPageSize(100)))[0];
    } else {
      Salary_Updater = (new Backendless.UnitOfWork('REPEATABLE_READ'));
      await ( async () => {
        const _uow = Salary_Updater;

        _uow.addToRelation('Employees', Details, 'Wages_Historical', [(getObjectProperty((getObjectProperty(User, 'Details')), 'Wages_Current'))]);
        Created_Wage = (_uow.create('Salaries', ({ [`propName`]: undefined })));
        _uow.setRelation('Employees', Details, 'Wages_Current', [Created_Wage]);

      })();

      console.log((await Salary_Updater.execute()));
      User = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',IDEmployee,'\''].join(''))).setRelated(['Details.Wages_Current', 'Details.Wages_Current.Fuel', 'Details.Wages_Current.Loads', 'Details.Wages_Current.Other']).setRelationsDepth(10).setRelationsPageSize(100).setPageSize(100)))[0];
    }
  }

return User
}

})
define('./functions/b8d6305d8b24558eb58f8fe7c0212833/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b8d6305d8b24558eb58f8fe7c0212833'] = async function fn_b8d6305d8b24558eb58f8fe7c0212833(listToFlatten, maxRecursionDepth) {
return (await (async function(array, depth) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (depth == null) {
	  depth = 1
	}

	return _.flattenDepth(array, depth)
})(listToFlatten, maxRecursionDepth))
}

})
define('./functions/b91213ddd54e86f99f851edb9dc3c82a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b91213ddd54e86f99f851edb9dc3c82a'] = async function fn_b91213ddd54e86f99f851edb9dc3c82a(Origin, Destination, Waypoints, Avoid, Departure, Description, Color, Opacity, LineWidth, LineColor, PointsOnly) {
var Route, item, Avoid_List, Waypoint_List, Waypoint, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Waypoint_List = [];
  if (Waypoints == null) {
    Waypoint_List = [];
  } else {
    Waypoint_List = [];
    try {
      for (var j_index in Waypoints) {
        j = Waypoints[j_index];
        Waypoint = [(getObjectProperty(j, 'lat')),' ',(getObjectProperty(j, 'lng'))].join('');
        addItemToList(Waypoint_List, Waypoint);
      }

    } catch (error) {

    }
  }
  if (Avoid == null) {
    Avoid_List = [];
  } else {
    Avoid_List = Avoid;
  }
  Route = (await Backendless.Request.get(`${Backendless.appPath}/services/GoogleAPI/Directions`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'origin': JSON.stringify(([(getObjectProperty(Origin, 'lat')),' ',(getObjectProperty(Origin, 'lng'))].join(''))),'destination': JSON.stringify(([(getObjectProperty(Destination, 'lat')),' ',(getObjectProperty(Destination, 'lng'))].join(''))),'waypoints': JSON.stringify((Waypoint_List.join(' | '))),'avoid': JSON.stringify((Avoid_List.join(' | '))),'units': JSON.stringify('metric') }).send());

return ({ [`Distance`]: (await Promise.all((getObjectProperty(((getObjectProperty(Route, 'routes'))[0]), 'legs')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'distance')), 'value'));}))).reduce(function(x, y) {return x + y;}),[`Duration`]: (await Promise.all((getObjectProperty(((getObjectProperty(Route, 'routes'))[0]), 'legs')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'duration')), 'value'));}))).reduce(function(x, y) {return x + y;}),[`Polyline`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](PointsOnly)) ? (await BackendlessUI.Functions.Custom['fn_04c9e63b986e313f0e38c54373e1b64d'](Description, (getObjectProperty((getObjectProperty(((getObjectProperty(Route, 'routes'))[0]), 'overview_polyline')), 'points')), Color, Opacity)) : (PointsOnly == true ? (await Promise.all((getObjectProperty((await (async function(Data) {
	function decode() {
	  var encodedPolyline = Data;
	  var coords = polyline.toGeoJSON(encodedPolyline);
	  return coords
	}
	
	var polyline = {};
	
	function encode(current, previous, factor) {
	  current = Math.round(current * factor);
	  previous = Math.round(previous * factor);
	  var coordinate = current - previous;
	  coordinate <<= 1;
	  if (current - previous < 0) {
	    coordinate = ~coordinate;
	  }
	  var output = '';
	  while (coordinate >= 0x20) {
	    output += String.fromCharCode((0x20 | (coordinate & 0x1f)) + 63);
	    coordinate >>= 5;
	  }
	  output += String.fromCharCode(coordinate + 63);
	  return output;
	}
	
	/**
	 * Decodes to a [latitude, longitude] coordinates array.
	 *
	 * This is adapted from the implementation in Project-OSRM.
	 *
	 * @param {String} str
	 * @param {Number} precision
	 * @returns {Array}
	 *
	 * @see https://github.com/Project-OSRM/osrm-frontend/blob/master/WebContent/routing/OSRM.RoutingGeometry.js
	 */
	polyline.decode = function(str, precision) {
	  var index = 0,
	    lat = 0,
	    lng = 0,
	    coordinates = [],
	    shift = 0,
	    result = 0,
	    byte = null,
	    latitude_change,
	    longitude_change,
	    factor = Math.pow(10, precision || 5);
	
	  // Coordinates have variable length when encoded, so just keep
	  // track of whether we've hit the end of the string. In each
	  // loop iteration, a single coordinate is decoded.
	  while (index < str.length) {
	
	    // Reset shift, result, and byte
	    byte = null;
	    shift = 0;
	    result = 0;
	
	    do {
	      byte = str.charCodeAt(index++) - 63;
	      result |= (byte & 0x1f) << shift;
	      shift += 5;
	    } while (byte >= 0x20);
	
	    latitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));
	
	    shift = result = 0;
	
	    do {
	      byte = str.charCodeAt(index++) - 63;
	      result |= (byte & 0x1f) << shift;
	      shift += 5;
	    } while (byte >= 0x20);
	
	    longitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));
	
	    lat += latitude_change;
	    lng += longitude_change;
	
	    coordinates.push([lat / factor, lng / factor]);
	  }
	
	  return coordinates;
	};
	
	/**
	 * Encodes the given [latitude, longitude] coordinates array.
	 *
	 * @param {Array.<Array.<Number>>} coordinates
	 * @param {Number} precision
	 * @returns {String}
	 */
	polyline.encode = function(coordinates, precision) {
	  if (!coordinates.length) {
	    return '';
	  }
	
	  var factor = Math.pow(10, precision || 5),
	    output = encode(coordinates[0][0], 0, factor) + encode(coordinates[0][1], 0, factor);
	
	  for (var i = 1; i < coordinates.length; i++) {
	    var a = coordinates[i],
	      b = coordinates[i - 1];
	    output += encode(a[0], b[0], factor);
	    output += encode(a[1], b[1], factor);
	  }
	
	  return output;
	};
	
	function flipped(coords) {
	  var flipped = [];
	  for (var i = 0; i < coords.length; i++) {
	    flipped.push(coords[i].slice().reverse());
	  }
	  return flipped;
	}
	
	/**
	 * Encodes a GeoJSON LineString feature/geometry.
	 *
	 * @param {Object} geojson
	 * @param {Number} precision
	 * @returns {String}
	 */
	polyline.fromGeoJSON = function(geojson, precision) {
	  if (geojson && geojson.type === 'Feature') {
	    geojson = geojson.geometry;
	  }
	  if (!geojson || geojson.type !== 'LineString') {
	    throw new Error('Input must be a GeoJSON LineString');
	  }
	  return polyline.encode(flipped(geojson.coordinates), precision);
	};
	
	/**
	 * Decodes to a GeoJSON LineString geometry.
	 *
	 * @param {String} str
	 * @param {Number} precision
	 * @returns {Object}
	 */
	polyline.toGeoJSON = function(str, precision) {
	  var coords = polyline.decode(str, precision);
	  return {
	    type: 'LineString',
	    coordinates: flipped(coords)
	  };
	};
	
	if (typeof module === 'object' && module.exports) {
	  module.exports = polyline;
	}
	return decode()
})((getObjectProperty((getObjectProperty(((getObjectProperty(Route, 'routes'))[0]), 'overview_polyline')), 'points')))), 'coordinates')).map(async item => {; return ({ [`lat`]: item.slice(-1)[0] * 1,[`lng`]: item[0] * 1 });}))) : (await BackendlessUI.Functions.Custom['fn_04c9e63b986e313f0e38c54373e1b64d'](Description, (getObjectProperty((getObjectProperty(((getObjectProperty(Route, 'routes'))[0]), 'overview_polyline')), 'points')), Color, Opacity))),[`Route`]: Route })
}

})
define('./functions/b93bcd5de56aa56928854fbb554683b1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b93bcd5de56aa56928854fbb554683b1'] = async function fn_b93bcd5de56aa56928854fbb554683b1(listToQuery, elementIndex) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 0
	}

	return _.nth(array, n)
})(listToQuery, elementIndex))
}

})
define('./functions/baa947591c610deb3e63b2bad24a09a4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_baa947591c610deb3e63b2bad24a09a4'] = async function fn_baa947591c610deb3e63b2bad24a09a4(Property, Component, Style) {
  if (Property == true) {
    await (async function() {
    	if (document.exitFullscreen) {
    	    document.exitFullscreen();
    	} else if (document.mozCancelFullScreen) {
    	    document.mozCancelFullScreen();
    	} else if (document.webkitCancelFullScreen) {
    	    document.webkitCancelFullScreen();
    	}
    })();
    Component['icon'] = 'fullscreen';
    Style['color'] = 'Grey';
  } else {
    await (async function() {
    	function requestFullScreen(element) {
    	    // Supports most browsers and their versions.
    	    var requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen;
    	
    	    if (requestMethod) { // Native full screen.
    	        requestMethod.call(element);
    	    } else if (typeof window.ActiveXObject !== "undefined") { // Older IE.
    	        var wscript = new ActiveXObject("WScript.Shell");
    	        if (wscript !== null) {
    	            wscript.SendKeys("{F11}");
    	        }
    	    }
    	}
    	
    	var elem = document.body; // Make the body go full screen.
    	requestFullScreen(elem);
    })();
    Component['icon'] = 'fullscreen exit';
    Style['color'] = 'Red';
  }

}

})
define('./functions/bcf9d70e458eba763b0a8beee84d9873/code.js', () => { 

BackendlessUI.Functions.Custom['fn_bcf9d70e458eba763b0a8beee84d9873'] = async function fn_bcf9d70e458eba763b0a8beee84d9873() {
var Polyline, Step_3, Counter, NCoord, Coordinate, Number2, j, Step_2, Step_1;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    Step_1 = [];
    Step_2 = [];
    Step_3 = [];
    var j_list = (getObjectProperty(((getObjectProperty(((getObjectProperty(Device, 'routes'))[0]), 'legs'))[0]), 'steps'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      addItemToList(Step_1, (await (async function(Data) {
      	function decode() {
      	  var encodedPolyline = Data;
      	  var coords = polyline.toGeoJSON(encodedPolyline);
      	  return coords
      	}
      	
      	var polyline = {};
      	
      	function encode(current, previous, factor) {
      	  current = Math.round(current * factor);
      	  previous = Math.round(previous * factor);
      	  var coordinate = current - previous;
      	  coordinate <<= 1;
      	  if (current - previous < 0) {
      	    coordinate = ~coordinate;
      	  }
      	  var output = '';
      	  while (coordinate >= 0x20) {
      	    output += String.fromCharCode((0x20 | (coordinate & 0x1f)) + 63);
      	    coordinate >>= 5;
      	  }
      	  output += String.fromCharCode(coordinate + 63);
      	  return output;
      	}
      	
      	polyline.decode = function(str, precision) {
      	  var index = 0,
      	    lat = 0,
      	    lng = 0,
      	    coordinates = [],
      	    shift = 0,
      	    result = 0,
      	    byte = null,
      	    latitude_change,
      	    longitude_change,
      	    factor = Math.pow(10, precision || 5);
      	
      	  while (index < str.length) {
      	
      	    byte = null;
      	    shift = 0;
      	    result = 0;
      	
      	    do {
      	      byte = str.charCodeAt(index++) - 63;
      	      result |= (byte & 0x1f) << shift;
      	      shift += 5;
      	    } while (byte >= 0x20);
      	
      	    latitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));
      	
      	    shift = result = 0;
      	
      	    do {
      	      byte = str.charCodeAt(index++) - 63;
      	      result |= (byte & 0x1f) << shift;
      	      shift += 5;
      	    } while (byte >= 0x20);
      	
      	    longitude_change = ((result & 1) ? ~(result >> 1) : (result >> 1));
      	
      	    lat += latitude_change;
      	    lng += longitude_change;
      	
      	    coordinates.push([lat / factor, lng / factor]);
      	  }
      	
      	  return coordinates;
      	};
      	
      	
      	polyline.encode = function(coordinates, precision) {
      	  if (!coordinates.length) {
      	    return '';
      	  }
      	
      	  var factor = Math.pow(10, precision || 5),
      	    output = encode(coordinates[0][0], 0, factor) + encode(coordinates[0][1], 0, factor);
      	
      	  for (var i = 1; i < coordinates.length; i++) {
      	    var a = coordinates[i],
      	      b = coordinates[i - 1];
      	    output += encode(a[0], b[0], factor);
      	    output += encode(a[1], b[1], factor);
      	  }
      	
      	  return output;
      	};
      	
      	function flipped(coords) {
      	  var flipped = [];
      	  for (var i = 0; i < coords.length; i++) {
      	    flipped.push(coords[i].slice().reverse());
      	  }
      	  return flipped;
      	}
      	
      	polyline.fromGeoJSON = function(geojson, precision) {
      	  if (geojson && geojson.type === 'Feature') {
      	    geojson = geojson.geometry;
      	  }
      	  if (!geojson || geojson.type !== 'LineString') {
      	    throw new Error('Input must be a GeoJSON LineString');
      	  }
      	  return polyline.encode(flipped(geojson.coordinates), precision);
      	};
      	
      	polyline.toGeoJSON = function(str, precision) {
      	  var coords = polyline.decode(str, precision);
      	  return {
      	    type: 'LineString',
      	    coordinates: flipped(coords)
      	  };
      	};
      	
      	if (typeof module === 'object' && module.exports) {
      	  module.exports = polyline;
      	}
      	return decode()
      })((getObjectProperty((getObjectProperty(j, 'polyline')), 'points')))));
    }
    for (var j_index2 in Step_1) {
      j = Step_1[j_index2];
      addItemToList(Step_2, (getObjectProperty(j, 'coordinates')));
    }
    for (var j_index3 in Step_2) {
      j = Step_2[j_index3];
      Coordinate = ({ [`lat`]: j.slice(-1)[0],[`lng`]: j[0] });
      addItemToList(Step_3, Coordinate);
    }
    Counter = Step_3.length;
    Number2 = Counter;
    for (var count = 0; count < Number2; count++) {
      Coordinate = Step_3[(Counter - 1)];
      NCoord = ({ [`lat`]: (getObjectProperty(Coordinate, 'lat')),[`lng`]: (getObjectProperty(Coordinate, 'lng')) });
      addItemToList(Step_3, NCoord);
      Counter = Counter - 1;
    }

  } catch (error) {

  }
  Polyline = [({ [`description`]: 'Polygon',[`polygon`]: ({ [`boundary`]: ({ [`points`]: Step_3 }) }) })];

return Polyline
}

})
define('./functions/c1083dfc958bfce9f511282469f18202/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c1083dfc958bfce9f511282469f18202'] = async function fn_c1083dfc958bfce9f511282469f18202(listsToInspect) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.union(...arrays)
})(listsToInspect))
}

})
define('./functions/c58e08966457701101ab34279f33af6d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c58e08966457701101ab34279f33af6d'] = async function fn_c58e08966457701101ab34279f33af6d(keyValuePairsList) {
return (await (async function(pairs) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.fromPairs(pairs)
})(keyValuePairsList))
}

})
define('./functions/c8249d71574777eb2a08c21c7e28faee/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c8249d71574777eb2a08c21c7e28faee'] = async function fn_c8249d71574777eb2a08c21c7e28faee(Axles, Difference) {
var Tyres, Mileage_Difference, j, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Tyres = [];
  Mileage_Difference = Difference;
  var j_list = (await asyncListFilter(Axles, async (item) => {


   return ((getObjectProperty(item, 'Type')) != 'Spare');
  }));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(j, 'Tyre L1')) === null) {
    } else {
      addItemToList(Tyres, (getObjectProperty(j, 'Tyre L1')));
    }
    if ((getObjectProperty(j, 'Tyre L2')) === null) {
    } else {
      addItemToList(Tyres, (getObjectProperty(j, 'Tyre L2')));
    }
    if ((getObjectProperty(j, 'Tyre L3')) === null) {
    } else {
      addItemToList(Tyres, (getObjectProperty(j, 'Tyre L3')));
    }
    if ((getObjectProperty(j, 'Tyre L4')) === null) {
    } else {
      addItemToList(Tyres, (getObjectProperty(j, 'Tyre L4')));
    }
    if ((getObjectProperty(j, 'Tyre R4')) === null) {
    } else {
      addItemToList(Tyres, (getObjectProperty(j, 'Tyre R4')));
    }
    if ((getObjectProperty(j, 'Tyre R3')) === null) {
    } else {
      addItemToList(Tyres, (getObjectProperty(j, 'Tyre R3')));
    }
    if ((getObjectProperty(j, 'Tyre R2')) === null) {
    } else {
      addItemToList(Tyres, (getObjectProperty(j, 'Tyre R2')));
    }
    if ((getObjectProperty(j, 'Tyre R1')) === null) {
    } else {
      addItemToList(Tyres, (getObjectProperty(j, 'Tyre R1')));
    }
  }
  for (var j_index2 in Tyres) {
    j = Tyres[j_index2];
    if ((getObjectProperty(j, 'State')) == 'New') {
      if ((getObjectProperty((getObjectProperty(j, 'Axle')), 'Tag')) == 'True') {
        j['Mileage1'] = ((getObjectProperty(j, 'Mileage1')) + Mileage_Difference * (getObjectProperty((getObjectProperty(j, 'Axle')), 'Tag Rate')));
      } else {
        j['Mileage1'] = ((getObjectProperty(j, 'Mileage1')) + Mileage_Difference);
      }
    } else if ((getObjectProperty(j, 'State')) == 'Cap 1') {
      if ((getObjectProperty((getObjectProperty(j, 'Axle')), 'Tag')) == 'True') {
        j['Mileage2'] = ((getObjectProperty(j, 'Mileage2')) + Mileage_Difference * (getObjectProperty((getObjectProperty(j, 'Axle')), 'Tag Rate')));
      } else {
        j['Mileage2'] = ((getObjectProperty(j, 'Mileage2')) + Mileage_Difference);
      }
    } else if ((getObjectProperty(j, 'State')) == 'Cap 2') {
      if ((getObjectProperty((getObjectProperty(j, 'Axle')), 'Tag')) == 'True') {
        j['Mileage3'] = ((getObjectProperty(j, 'Mileage3')) + Mileage_Difference * (getObjectProperty((getObjectProperty(j, 'Axle')), 'Tag Rate')));
      } else {
        j['Mileage3'] = ((getObjectProperty(j, 'Mileage3')) + Mileage_Difference);
      }
    } else if ((getObjectProperty(j, 'State')) == 'Cap 3') {
      if ((getObjectProperty((getObjectProperty(j, 'Axle')), 'Tag')) == 'True') {
        j['Mileage4'] = ((getObjectProperty(j, 'Mileage4')) + Mileage_Difference * (getObjectProperty((getObjectProperty(j, 'Axle')), 'Tag Rate')));
      } else {
        j['Mileage4'] = ((getObjectProperty(j, 'Mileage3')) + Mileage_Difference);
      }
    }
  }

return Tyres
}

})
define('./functions/cab97651610a7df89b05dbc568adb257/code.js', () => { 

BackendlessUI.Functions.Custom['fn_cab97651610a7df89b05dbc568adb257'] = async function fn_cab97651610a7df89b05dbc568adb257(listToInspect, valueToSearchFor, indexToSearchFrom) {
return (await (async function(array, value, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	  fromIndex = array.length - 1
	}

	return _.lastIndexOf(array, value, fromIndex);
})(listToInspect, valueToSearchFor, indexToSearchFrom))
}

})
define('./functions/cb78437d58c15169785a28715edd2cd9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_cb78437d58c15169785a28715edd2cd9'] = function fn_cb78437d58c15169785a28715edd2cd9(x, y) {
var Result;


  Result = Math.atan(y / x) / Math.PI * 180;

return Result
}

})
define('./functions/cc11a9a5370e6f074e8acef24d8be4cb/code.js', () => { 

BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb'] = function fn_cc11a9a5370e6f074e8acef24d8be4cb(Property) {
var Viewer, error;


  try {
    if (Property == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

return Viewer
}

})
define('./functions/ce6a7744410fa122d5ca861572a6cbf6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ce6a7744410fa122d5ca861572a6cbf6'] = async function fn_ce6a7744410fa122d5ca861572a6cbf6(tableName, dataModel, whereClause, propertiesToInclude, propertiesToExclude, propertiesToSortBy, relations) {
var loadedData, offset;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function init_offset_var() {
  offset = (getObjectProperty(dataModel, 'offset'));
  if (offset == null) {
    offset = 0;
  }
}

/**
 * Describe this function...
 */
async function load_data() {
  loadedData = (await Backendless.Data.of(tableName).find(Backendless.DataQueryBuilder.create().setWhereClause(whereClause).setProperties(propertiesToInclude).excludeProperties(propertiesToExclude).setRelated(relations).setSortBy(propertiesToSortBy).setPageSize(100).setOffset(offset)));
}

/**
 * Describe this function...
 */
async function adjust_page_data_state() {
  if (loadedData.length < 100) {
    dataModel['loadingData'] = false;
  } else {
    dataModel['offset'] = (offset + loadedData.length);
  }
}


  await init_offset_var();
  await load_data();
  await adjust_page_data_state();

return loadedData
}

})
define('./functions/cf0cee815db7c56daa3d4a3f0704a8ac/code.js', () => { 

BackendlessUI.Functions.Custom['fn_cf0cee815db7c56daa3d4a3f0704a8ac'] = async function fn_cf0cee815db7c56daa3d4a3f0704a8ac(listsToInspect) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.intersection(...arrays)
})(listsToInspect))
}

})
define('./functions/d1490e4c930834a26d0815f4661fa18b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b'] = async function fn_d1490e4c930834a26d0815f4661fa18b(Value, Leader, Follower) {
return (await (async function(Value, Leader, Follower) {
	/**
	 * Inputs (automatically supplied by Backendless Codeless):
	 *   Value    -> Number or string to convert/format (e.g. 7000.1)
	 *   Leader   -> String to prepend (e.g. "R"), may be null/empty
	 *   Follower -> String to append (e.g. "$"), may be null/empty
	 *
	 * Output: Always a string, e.g. "R 7000.10", "3000.00 $", or "3000.00"
	 */
	
	// 1) Convert Value to a number (fall back to 0 if invalid)
	var numericValue = parseFloat(Value) || 0;
	
	// 2) Convert to a string with exactly two decimals
	//    e.g. 7000.1 -> "7000.10", 3000 -> "3000.00"
	var formattedValue = numericValue.toFixed(2);
	
	// 3) Build our final string, starting with the numeric portion
	var finalString = formattedValue;
	
	// 4) If Leader is not null/empty, prepend it + a space
	if (Leader && Leader.trim() !== "") {
	  finalString = Leader + " " + finalString;
	}
	
	// 5) If Follower is not null/empty, append it + a space
	if (Follower && Follower.trim() !== "") {
	  finalString = finalString + " " + Follower;
	}
	
	// 6) Return the final string
	return finalString;

})(Value, Leader, Follower))
}

})
define('./functions/d1ef11f72ed2119bde5d1ddb12b64273/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'] = async function fn_d1ef11f72ed2119bde5d1ddb12b64273(Text) {
return (await (async function(Text) {
	var str = Text;
	const allSpacesRemoved = str.replaceAll(' ', '');
	
	return allSpacesRemoved
})(Text))
}

})
define('./functions/d47cae3b23b596aa0043c941a238585f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d47cae3b23b596aa0043c941a238585f'] = async function fn_d47cae3b23b596aa0043c941a238585f(email) {
return (await (async function(email) {
	if (!(typeof email === 'string' || email instanceof String)) {
	  console.error(`string expected, ${typeof email} provided`)

	  return false
	}

	const expression = /\S+@\S+\.\S+/

	return expression.test(email)
})(email))
}

})
define('./functions/d535622b38bb7a25aa31ae757fe6869c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d535622b38bb7a25aa31ae757fe6869c'] = async function fn_d535622b38bb7a25aa31ae757fe6869c(listToQuery, numberOfElements) {
return (await (async function(array, n) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (n == null) {
	  n = 1
	}

	return _.takeRight(array, n)
})(listToQuery, numberOfElements))
}

})
define('./functions/d813cd0b8767bda332b7d73f1ea8155b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d813cd0b8767bda332b7d73f1ea8155b'] = async function fn_d813cd0b8767bda332b7d73f1ea8155b(listToConvert, elementSeparator) {
return (await (async function(array, separator) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.join(array, separator)
})(listToConvert, elementSeparator))
}

})
define('./functions/d9cddabaf65b23287834be321d0afe88/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d9cddabaf65b23287834be321d0afe88'] = function fn_d9cddabaf65b23287834be321d0afe88(Data, Switch) {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(Data, Switch)) == true) {
      delete Data[Switch];
    } else {
      Data[Switch] = true;
    }

  } catch (error) {

  }

}

})
define('./functions/dfe6f4741626a11429b6777d44ba18e7/code.js', () => { 

BackendlessUI.Functions.Custom['fn_dfe6f4741626a11429b6777d44ba18e7'] = async function fn_dfe6f4741626a11429b6777d44ba18e7(listToInspect, valuesToExclude) {
return (await (async function(array, values) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.difference(array, values)
})(listToInspect, valuesToExclude))
}

})
define('./functions/dfef9391c409b8519db2242d696ca08c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_dfef9391c409b8519db2242d696ca08c'] = async function fn_dfef9391c409b8519db2242d696ca08c(listToInspect) {
return (await (async function(array) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.uniq(array)
})(listToInspect))
}

})
define('./functions/e04783eefccc55279cd3ffc580231f28/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e04783eefccc55279cd3ffc580231f28'] = async function fn_e04783eefccc55279cd3ffc580231f28(listToInspect, valueToSearchFor) {
return (await (async function(array, value) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.sortedIndexOf(array, value)
})(listToInspect, valueToSearchFor))
}

})
define('./functions/e6b811bbecc5e5fc06b8a6eb4f360192/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'] = function fn_e6b811bbecc5e5fc06b8a6eb4f360192(Object) {
return ((Object === null) == true || (typeof Object === 'undefined') == true)
}

})
define('./functions/e75a0abb24beebf84d14556f362a5ac1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e75a0abb24beebf84d14556f362a5ac1'] = async function fn_e75a0abb24beebf84d14556f362a5ac1(Data, Email, Error) {
  if ((await BackendlessUI.Functions.Custom['fn_d47cae3b23b596aa0043c941a238585f'](Email)) == true) {
    Data[(String(Email) + String(' - Viewer'))] = false;
    Data[Error] = false;
  } else {
    Data[(String(Email) + String(' - Viewer'))] = true;
    Data[Error] = true;
  }

}

})
define('./functions/eab6964cdd451a9c2dbbbeb2cbcc36de/code.js', () => { 

BackendlessUI.Functions.Custom['fn_eab6964cdd451a9c2dbbbeb2cbcc36de'] = async function fn_eab6964cdd451a9c2dbbbeb2cbcc36de(listToModify, valuesToRemove) {
  await (async function(array, values) {
  	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

  	_.pull(array, ...values)
  })(listToModify, valuesToRemove);

}

})
define('./functions/ec97791f4918eb07b6dff2a5bfec059a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ec97791f4918eb07b6dff2a5bfec059a'] = async function fn_ec97791f4918eb07b6dff2a5bfec059a(listsToInspect) {
return (await (async function(arrays) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	return _.xor(...arrays)
})(listsToInspect))
}

})
define('./functions/f1c97833e26b0995f236b863812bfed2/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f1c97833e26b0995f236b863812bfed2'] = async function fn_f1c97833e26b0995f236b863812bfed2(listToInspect, valueToSearchFor, indexToSearchFrom) {
return (await (async function(array, value, fromIndex) {
	if (typeof _ === 'undefined' || typeof _.VERSION !== 'string') throw new Error('The Lodash Library is not installed. In the UI Container -> Settings -> Libraries Tab add the JS Library Link: https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.21/lodash.min.js')

	if (fromIndex == null) {
	  fromIndex = 0
	}

	return _.indexOf(array, value, fromIndex)
})(listToInspect, valueToSearchFor, indexToSearchFrom))
}

})
define('./functions/f4df84546016cedc7395d748e8d7078c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f4df84546016cedc7395d748e8d7078c'] = async function fn_f4df84546016cedc7395d748e8d7078c(Text) {
return (await (async function(Text) {
	var list = Text; // Assuming 'Text' is your input JSON string
	// Convert the JSON string into an array
	const itemsArray = JSON.parse(list);

	// Process each item, removing the '/n' and joining them with a newline
	const formattedText = itemsArray.map(item => item.replace('/n', '')).join('\n');

	// Return the formatted text
	return formattedText;
})(Text))
}

})
define('./functions/f93a70853ae43c949fdb97c43719532e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f93a70853ae43c949fdb97c43719532e'] = async function fn_f93a70853ae43c949fdb97c43719532e(Devices) {
var Result, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Result = (getObjectProperty((await (async function(devices) {
  	// Function to fetch the latest message for the provided devices
  	async function fetchLatestMessages(deviceIds) {
  	  // Ensure deviceIds is an array
  	  if (!Array.isArray(deviceIds)) {
  	    throw new Error('deviceIds must be an array');
  	  }
  	
  	  // Join the device IDs into a comma-separated list
  	  const devicesList = deviceIds.join(',');
  	
  	  // Construct the URL dynamically with the device IDs
  	  const url = `https://flespi.io/gw/devices/${devicesList}/messages?data=%7B%22count%22%3A1%2C%22reverse%22%3Atrue%7D`;
  	
  	  // Define headers
  	  const headers = {
  	    'Content-Type': 'application/json',
  	    'Authorization': 'FlespiToken 1rSTqs5yHq64EsaPeiYKanXoP7VR0ru8GuoNJMVM0VUfWoen391ae0kGfdbOXocW'
  	  };
  	
  	  try {
  	    // Perform the HTTP GET request using fetch
  	    const response = await fetch(url, {
  	      method: 'GET',
  	      headers: headers
  	    });
  	
  	    if (!response.ok) {
  	      // Handle HTTP errors
  	      const errorText = await response.text();
  	      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
  	    }
  	
  	    // Parse and return the JSON response
  	    const result = await response.json();
  	    return result;
  	  } catch (error) {
  	    // Handle errors
  	    console.error('Fetch error details:', error);
  	    throw new Error(`Fetch error: ${error.message}`);
  	  }
  	}
  	
  	// Use 'devices' directly from the Backendless Codeless custom block input
  	const deviceIds = devices; // 'devices' is the input list of device IDs passed to the Custom Code block
  	
  	// Call the function and return the result
  	return fetchLatestMessages(deviceIds);

  })(Devices)), 'result'));
  for (var j_index in Result) {
    j = Result[j_index];
    if ((getObjectProperty(j, 'movement.status')) == false) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'can.vehicle.mileage'))))) {
        j['can.vehicle.mileage'] = (getObjectProperty(j, 'vehicle.mileage'));
      }
    }
  }

return Result
}

})
define('./pages/404/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    ___arguments.context.pageData['error'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ___arguments.context.pageData['user'] = (
        await (async function(userIdentity){
          var userColumns = await Backendless.UserService.describeUserClass()
          var identityColumn = userColumns.find(column => column.identity)
          var whereClause = `${identityColumn.name} = '${userIdentity}'`
          var query = Backendless.DataQueryBuilder.create().setWhereClause(whereClause)
          var users = await Backendless.Data.of(Backendless.User).find(query)

          return users[0]
       })((getObjectProperty(___arguments.context.pageData, 'userIdentity')))
    );

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter *//* content */
}));

define('./pages/404/components/3665111f5a5b9f8f4b064bbdf6ce7a5c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/63528a0a331c876df799faff6331827e/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('63528a0a331c876df799faff6331827e'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('63528a0a331c876df799faff6331827e'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('e97e3d4bdd01f07b4327e42bc27e1fb8', undefined);
  await new Promise(r => setTimeout(r, 300 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cbea0f239d6860ff11d95851956f5343', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/cf94581d4c9e1546f48f8b99068a6dd7/bundle.js', [], () => ({
  /* content */
  /* handler:themeLogic */
  ['themeLogic'](___arguments) {
      return ({ [`forecastIconColor`]: 'rgb(255, 95, 31)',[`todayIconColor`]: 'rgb(255, 95, 31)' })

  },
  /* handler:themeLogic */
  /* content */
}))

define('./pages/Assets/components/b5ae0b0e84058609dce18402a42b1041/bundle.js', [], () => ({
  /* content */
  /* handler:onMarkerClick */
  async ['onMarkerClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, marker, popupContent) { ___arguments.context.getComponentByUid(componentUid).map.showInfoWindow(marker, { content: popupContent }) })('b5ae0b0e84058609dce18402a42b1041', ___arguments.point, (['<!DOCTYPE html> <html> <head>     <style>         body {             background-color: black;             color: #CC6633;         }         table {             width: 100%;             border-collapse: collapse;         }         th, td {             border: 1px solid #CC6633;             padding: 5px;             text-align: left;             background-color: black;         }         th {             color: #CC6633;         }     </style> </head> <body>  <table>     <tr>         <th>ID</th>         <td>',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'ID')))) ? null : (getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'ID'))),'</td>     </tr>     <tr>         <th>Registration</th>         <td>',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Registration')))) ? null : (getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Registration'))),'</td>     </tr>     <tr>         <th>Odometer</th>         <td>',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Odometer')))) ? null : (getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Odometer'))),'</td>     </tr>     <tr>         <th>Fuel</th>         <td>',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Tank_Litres')))) ? null : (getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Tank_Litres'))),'l</td>     </tr>     <tr>         <th>Driver</th>         <td>',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Driver1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Driver1')), 'Employee_Details_Nickname')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Driver1')), 'Employee_Details_Nickname')))),'</td>     </tr>     <tr>         <th>Mobile</th>         <td>',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Driver1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Driver1')), 'Employee_Details_Phone')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Driver1')), 'Employee_Details_Phone')))),'</a></td>     </tr>     <tr>         <th>Trailer1</th>         <td>',[(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer1')), 'ID')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer1')), 'ID')))),' - ',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer1')), 'Registration')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer1')), 'Registration'))))].join(''),'</td>     </tr>     <tr>         <th>Trailer2</th>         <td>',[(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer2')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer2')), 'ID')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer2')), 'ID')))),' - ',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer2')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer2')), 'Registration')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer2')), 'Registration'))))].join(''),'</td>     </tr>     <tr>         <th>Trailer3</th>         <td>',[(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer3')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer3')), 'ID')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer3')), 'ID')))),' - ',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer3')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer3')), 'Registration')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer3')), 'Registration'))))].join(''),'</td>     </tr> </table>  </body> </html>'].join('')));

  },
  /* handler:onMarkerClick */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var Centre, error, item, j, Last_Location_Data, New_List, Tracking_Data, Zoom_Level;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors'))))) {
      } else {
        Last_Location_Data = (await BackendlessUI.Functions.Custom['fn_f93a70853ae43c949fdb97c43719532e']((await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


         return (getObjectProperty(item, 'Device ID'));
        })).map(async item => {; return (getObjectProperty(item, 'Device ID'));})))));
        var j_list = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


         return (getObjectProperty(item, 'Device ID'));
        }));
        for (var j_index in j_list) {
          j = j_list[j_index];
          try {
            Tracking_Data = (await asyncListFind(Last_Location_Data, async (item) => {


             return ((getObjectProperty(item, 'device.id')) == (getObjectProperty(j, 'Device ID')));
            }));

          } catch (error) {

          }
          try {
            j['Tracking Live'] = Tracking_Data;

          } catch (error) {

          }
          try {
            (getObjectProperty(j, 'Location'))['y'] = (getObjectProperty(Tracking_Data, 'position.latitude'));

          } catch (error) {

          }
          try {
            (getObjectProperty(j, 'Location'))['x'] = (getObjectProperty(Tracking_Data, 'position.longitude'));

          } catch (error) {

          }
          try {
            (getObjectProperty(j, 'Location'))['lat'] = (getObjectProperty(Tracking_Data, 'position.latitude'));

          } catch (error) {

          }
          try {
            (getObjectProperty(j, 'Location'))['lng'] = (getObjectProperty(Tracking_Data, 'position.longitude'));

          } catch (error) {

          }
          try {
            (getObjectProperty(j, 'Location'))['movement'] = (getObjectProperty(Tracking_Data, 'movement.status'));

          } catch (error) {

          }
        }
        New_List = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


         return (getObjectProperty(item, 'Device ID'));
        }));
        await new Promise(r => setTimeout(r, 5000 || 0));
        await (async function(googleMapComponent, locations) {
        	function addNumberPlateMarkers(googleMapComponent, locations) {
        	  // Check if the Google Map component and map instance are valid
        	  if (
        	    !googleMapComponent ||
        	    !googleMapComponent.map ||
        	    !(googleMapComponent.map.map instanceof google.maps.Map)
        	  ) {
        	    console.error('Invalid Google Map component.');
        	    return;
        	  }
        	
        	  const mapInstance = googleMapComponent.map.map; // Get the actual map instance
        	
        	  // Define a fixed size for the South African number plates
        	  const plateWidth = 150;  // Fixed width for all number plates
        	  const plateHeight = 40;  // Fixed height for all number plates
        	
        	  // Function to create the SVG for a South African number plate with an inverted triangle.
        	  // It now accepts a `color` parameter to dynamically set the color.
        	  function createNumberPlateSVG(id, color) {
        	    return `
        	      <svg xmlns="http://www.w3.org/2000/svg" width="${plateWidth}" height="${plateHeight + 30}" viewBox="0 0 ${plateWidth} ${plateHeight + 45}">
        	        <!-- Number plate box with dynamic color for the stroke -->
        	        <rect width="${plateWidth}" height="${plateHeight}" rx="8" ry="8" fill="white" stroke="${color}" stroke-width="4" />
        	        
        	        <!-- Bold dynamic text (vehicle ID) with proper centering -->
        	        <text x="${plateWidth / 2}" y="${plateHeight / 2 + 10}" font-family="Arial" font-size="20" fill="${color}" font-weight="bold" text-anchor="middle">
        	          ${id}
        	        </text>
        	        
        	        <!-- Inverted triangle below the number plate with dynamic color -->
        	        <polygon points="${plateWidth / 2},${plateHeight + 20} ${(plateWidth / 2) - 7.5},${plateHeight} ${(plateWidth / 2) + 7.5},${plateHeight}" fill="${color}" stroke="none" />
        	      </svg>
        	    `;
        	  }
        	
        	  // Loop through each location in the array and create a marker
        	  locations.forEach(location => {
        	    const { lat, lng, ID, movement } = location; // Extract lat, lng, ID, and movement from the location object
        	
        	    // Determine the color based on movement.status: if false, use '#EE4B2B', otherwise default to '#cc6633'
        	    const plateColor = movement === false ? '#cc6633' : '#006400' ;
        	
        	    // Create the custom SVG icon for the marker with fixed size
        	    const numberPlateIcon = {
        	      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(createNumberPlateSVG(ID, plateColor))}`,
        	      anchor: new google.maps.Point(plateWidth / 2, plateHeight + 20), // Adjusted anchor to the lower triangle position
        	      scaledSize: new google.maps.Size(plateWidth, plateHeight + 30) // Adjusted height to fit the inverted triangle and box
        	    };
        	
        	    // Create a new marker on the map with the custom SVG icon
        	    const marker = new google.maps.Marker({
        	      position: { lat, lng },
        	      map: mapInstance,
        	      icon: numberPlateIcon,
        	      draggable: false // Markers are static and not draggable
        	    });
        	
        	    // Set the `currentTracking` property in appData with the marker's Registration ID on click
        	    marker.addListener('click', () => {
        	      ___arguments.context.appData.currentTracking = ID;
        	      console.log(`currentTracking is now set to: ${ID}`);
        	    });
        	
        	    // Add hover event listeners to change the zIndex
        	    marker.addListener('mouseover', () => {
        	      marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1); // Bring the marker to the top on hover
        	    });
        	
        	    marker.addListener('mouseout', () => {
        	      marker.setZIndex(undefined); // Reset the zIndex to its default after hover
        	    });
        	  });
        	}
        	
        	// Example of how the function will be used in Backendless Custom Code Block
        	try {
        	  const googleMapComponent = arguments[0]; // Pass Google Map component
        	  const locations = arguments[1]; // Pass array of objects [{ lat, lng, ID, movement: { status: boolean } }, ... ]
        	
        	  // Call the function to add markers with fixed number plate size, dynamic color based on movement status, centered text, adjusted triangle, and zIndex on hover
        	  addNumberPlateMarkers(googleMapComponent, locations);
        	} catch (error) {
        	  console.error('Error adding number plate markers:', error);
        	}

        })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b5ae0b0e84058609dce18402a42b1041')), (await Promise.all(New_List.map(async item => {; return ({ [`lat`]: (getObjectProperty((getObjectProperty(item, 'Location')), 'lat')),[`lng`]: (getObjectProperty((getObjectProperty(item, 'Location')), 'lng')),[`ID`]: (getObjectProperty(item, 'Registration')),[`movement`]: (getObjectProperty((getObjectProperty(item, 'Location')), 'movement')) });}))));
        for (var count = 0; count < 100; count++) {
          await new Promise(r => setTimeout(r, 300000 || 0));
          Zoom_Level = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).zoom })('b5ae0b0e84058609dce18402a42b1041'));
          Centre = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('b5ae0b0e84058609dce18402a42b1041'));
          Last_Location_Data = (await BackendlessUI.Functions.Custom['fn_f93a70853ae43c949fdb97c43719532e']((await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


           return (getObjectProperty(item, 'Device ID'));
          })).map(async item => {; return (getObjectProperty(item, 'Device ID'));})))));
          var j_list2 = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


           return (getObjectProperty(item, 'Device ID'));
          }));
          for (var j_index2 in j_list2) {
            j = j_list2[j_index2];
            try {
              Tracking_Data = (await asyncListFind(Last_Location_Data, async (item) => {


               return ((getObjectProperty(item, 'device.id')) == (getObjectProperty(j, 'Device ID')));
              }));

            } catch (error) {
              console.log(error);

            }
            try {
              j['Tracking Live'] = Tracking_Data;

            } catch (error) {
              console.log(error);

            }
            try {
              (getObjectProperty(j, 'Location'))['y'] = (getObjectProperty(Tracking_Data, 'position.latitude'));

            } catch (error) {
              console.log(error);

            }
            try {
              (getObjectProperty(j, 'Location'))['x'] = (getObjectProperty(Tracking_Data, 'position.longitude'));

            } catch (error) {
              console.log(error);

            }
            try {
              (getObjectProperty(j, 'Location'))['lat'] = (getObjectProperty(Tracking_Data, 'position.latitude'));

            } catch (error) {
              console.log(error);

            }
            try {
              (getObjectProperty(j, 'Location'))['lng'] = (getObjectProperty(Tracking_Data, 'position.longitude'));

            } catch (error) {
              console.log(error);

            }
            try {
              (getObjectProperty(j, 'Location'))['movement'] = (getObjectProperty(Tracking_Data, 'movement.status'));

            } catch (error) {
              console.log(error);

            }
          }
          New_List = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


           return (getObjectProperty(item, 'Device ID'));
          }));
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5ae0b0e84058609dce18402a42b1041', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5ae0b0e84058609dce18402a42b1041', true);
          (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('b5ae0b0e84058609dce18402a42b1041', Zoom_Level);
          (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('b5ae0b0e84058609dce18402a42b1041', (getObjectProperty(Centre, 'lat')), (getObjectProperty(Centre, 'lng')));
          await new Promise(r => setTimeout(r, 300 || 0));
          await (async function(googleMapComponent, locations) {
          	function addNumberPlateMarkers(googleMapComponent, locations) {
          	  // Check if the Google Map component and map instance are valid
          	  if (
          	    !googleMapComponent ||
          	    !googleMapComponent.map ||
          	    !(googleMapComponent.map.map instanceof google.maps.Map)
          	  ) {
          	    console.error('Invalid Google Map component.');
          	    return;
          	  }
          	
          	  const mapInstance = googleMapComponent.map.map; // Get the actual map instance
          	
          	  // Define a fixed size for the South African number plates
          	  const plateWidth = 150;  // Fixed width for all number plates
          	  const plateHeight = 40;  // Fixed height for all number plates
          	
          	  // Function to create the SVG for a South African number plate with an inverted triangle.
          	  // It now accepts a `color` parameter to dynamically set the color.
          	  function createNumberPlateSVG(id, color) {
          	    return `
          	      <svg xmlns="http://www.w3.org/2000/svg" width="${plateWidth}" height="${plateHeight + 30}" viewBox="0 0 ${plateWidth} ${plateHeight + 45}">
          	        <!-- Number plate box with dynamic color for the stroke -->
          	        <rect width="${plateWidth}" height="${plateHeight}" rx="8" ry="8" fill="white" stroke="${color}" stroke-width="4" />
          	        
          	        <!-- Bold dynamic text (vehicle ID) with proper centering -->
          	        <text x="${plateWidth / 2}" y="${plateHeight / 2 + 10}" font-family="Arial" font-size="20" fill="${color}" font-weight="bold" text-anchor="middle">
          	          ${id}
          	        </text>
          	        
          	        <!-- Inverted triangle below the number plate with dynamic color -->
          	        <polygon points="${plateWidth / 2},${plateHeight + 20} ${(plateWidth / 2) - 7.5},${plateHeight} ${(plateWidth / 2) + 7.5},${plateHeight}" fill="${color}" stroke="none" />
          	      </svg>
          	    `;
          	  }
          	
          	  // Loop through each location in the array and create a marker
          	  locations.forEach(location => {
          	    const { lat, lng, ID, movement } = location; // Extract lat, lng, ID, and movement from the location object
          	
          	    // Determine the color based on movement.status: if false, use '#EE4B2B', otherwise default to '#cc6633'
          	    const plateColor = movement === false ? '#cc6633' : '#006400' ;
          	
          	    // Create the custom SVG icon for the marker with fixed size
          	    const numberPlateIcon = {
          	      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(createNumberPlateSVG(ID, plateColor))}`,
          	      anchor: new google.maps.Point(plateWidth / 2, plateHeight + 20), // Adjusted anchor to the lower triangle position
          	      scaledSize: new google.maps.Size(plateWidth, plateHeight + 30) // Adjusted height to fit the inverted triangle and box
          	    };
          	
          	    // Create a new marker on the map with the custom SVG icon
          	    const marker = new google.maps.Marker({
          	      position: { lat, lng },
          	      map: mapInstance,
          	      icon: numberPlateIcon,
          	      draggable: false // Markers are static and not draggable
          	    });
          	
          	    // Set the `currentTracking` property in appData with the marker's Registration ID on click
          	    marker.addListener('click', () => {
          	      ___arguments.context.appData.currentTracking = ID;
          	      console.log(`currentTracking is now set to: ${ID}`);
          	    });
          	
          	    // Add hover event listeners to change the zIndex
          	    marker.addListener('mouseover', () => {
          	      marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1); // Bring the marker to the top on hover
          	    });
          	
          	    marker.addListener('mouseout', () => {
          	      marker.setZIndex(undefined); // Reset the zIndex to its default after hover
          	    });
          	  });
          	}
          	
          	// Example of how the function will be used in Backendless Custom Code Block
          	try {
          	  const googleMapComponent = arguments[0]; // Pass Google Map component
          	  const locations = arguments[1]; // Pass array of objects [{ lat, lng, ID, movement: { status: boolean } }, ... ]
          	
          	  // Call the function to add markers with fixed number plate size, dynamic color based on movement status, centered text, adjusted triangle, and zIndex on hover
          	  addNumberPlateMarkers(googleMapComponent, locations);
          	} catch (error) {
          	  console.error('Error adding number plate markers:', error);
          	}

          })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b5ae0b0e84058609dce18402a42b1041')), (await Promise.all(New_List.map(async item => {; return ({ [`lat`]: (getObjectProperty((getObjectProperty(item, 'Location')), 'lat')),[`lng`]: (getObjectProperty((getObjectProperty(item, 'Location')), 'lng')),[`ID`]: (getObjectProperty(item, 'Registration')),[`movement`]: (getObjectProperty((getObjectProperty(item, 'Location')), 'movement')) });}))));
        }
      }
    }
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Assets/components/720178ef686ed0a2676436ca610d5137/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('50a47f3c60ef8698af8798187f726b12');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('50a47f3c60ef8698af8798187f726b12');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/Assets/components/e9327729d82a78cb8f8e49d586f7cacb/bundle.js', [], () => ({
  /* content */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    var j_list = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe63d7114a2242e76e3c1f3c973f0e57')), 'el')), 'children'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      ((getObjectProperty(j, 'children'))[4])['scrollLeft'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e9327729d82a78cb8f8e49d586f7cacb')), 'el')), 'scrollLeft'));
    }

  } catch (error) {

  }

  },
  /* handler:onScroll */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var Counter, j;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Assets/components/5a4731f51162cf49c58bc6858d77a8d7/bundle.js', [], () => ({
  /* content */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e9327729d82a78cb8f8e49d586f7cacb')), 'el'))['scrollLeft'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5a4731f51162cf49c58bc6858d77a8d7')), 'el')), 'scrollLeft'));

  } catch (error) {

  }
  try {
    var j_list = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe63d7114a2242e76e3c1f3c973f0e57')), 'el')), 'children'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      ((getObjectProperty(j, 'children'))[5])['scrollLeft'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e9327729d82a78cb8f8e49d586f7cacb')), 'el')), 'scrollLeft'));
    }

  } catch (error) {

  }

  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/Assets/components/fe63d7114a2242e76e3c1f3c973f0e57/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item, Sorter, Tractors, Tractor_objectId, j, Fleetview, Tractor_Data, User, Counter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Old_Code_2() {
  Tractors = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors'));
  for (var j_index in Tractors) {
    j = Tractors[j_index];
    Tractor_Data = j;
    j['Tractor'] = (JSON.stringify(Tractor_Data));
  }
  for (var j_index2 in Tractors) {
    j = Tractors[j_index2];
    Tractor_objectId = (getObjectProperty(j, 'objectId'));
    Fleetview = (getObjectProperty(j, 'Fleetview_Current'));
    Fleetview['objectId (Fleetview)'] = (getObjectProperty(Fleetview, 'objectId'));
    delete Fleetview['objectId'];
    j = (Object.assign(j, Fleetview));
    j['objectId (Tractor)'] = Tractor_objectId;
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Fleetview Sorter'))))) {
    Sorter = 'ID';
  } else {
    Sorter = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Fleetview Sorter')), 'Property'));
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  Tractors = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors'));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Fleetview Sorter'))))) {
    Sorter = 'ID';
  } else {
    Sorter = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Fleetview Sorter')), 'Property'));
  }

  return ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Fleetview Sorter')))) ? (await asyncListSort(Tractors, 1, async (item) => {


 return (getObjectProperty(item, Sorter));
})) : ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Fleetview Sorter')), 'Direction')) == 'Up' ? (await asyncListSort(Tractors, -1, async (item) => {


 return (getObjectProperty(item, Sorter));
})) : (await asyncListSort(Tractors, 1, async (item) => {


 return (getObjectProperty(item, Sorter));
}))))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Assets/components/93b872fa6eec6ff554271f7e75e4a6f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Image_Front')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/e08c9c7419e9f1156c8806cfceb73651/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5a4731f51162cf49c58bc6858d77a8d7'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/f9b47c6585a48a4fe0bab28327772494/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Content = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + String(' km');

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/de451104a43493f757bc49f3f9417d3a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('023810ea19d611d8668de6cb90ac1585', undefined);
  console.log(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'));

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('d056f3514347c3cb0b761d24505d7495');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('d056f3514347c3cb0b761d24505d7495');

  },
  /* handler:onMouseOut */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/a8576f727141f44d9ad3af71c7dd40a7/bundle.js', [], () => ({
  /* content */
  /* handler:imagesDataLogic */
  ['imagesDataLogic'](___arguments) {
    var Image_Data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Image_Data = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Image_Front')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Image_Interior')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Image_Left')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Image_Rear')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Image_Right'))];

  return (Image_Data.join(','))

  },
  /* handler:imagesDataLogic */
  /* content */
}))

define('./pages/Assets/components/98efecf200ce8372e8c7a079a8837814/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/ec1c059a2781de335f441a37553ca37c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/9aef0bf4680a7a17b335d677e27d7ccb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j;


  var j_list = (Object.keys(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')));
  for (var j_index in j_list) {
    j = j_list[j_index];
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')[j];
  }
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('023810ea19d611d8668de6cb90ac1585', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/62e19d2e3ddab64e57933eb624b28b22/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var View, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    View = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Status')).includes('Active'));

  } catch (error) {

  }

  return View

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/3ec16c62696de85f941cfd2d136a37aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var View, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    View = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Status')).includes('In For Service'));

  } catch (error) {

  }

  return View

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/47161524e7de0757c041ae5f1eac6728/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var View, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    View = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Status')).includes('Broken Down'));

  } catch (error) {

  }

  return View

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/0193f1885a7e98294446dc7e9eacc40f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var View, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    View = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Status')).includes('Decommissioned'));

  } catch (error) {

  }

  return View

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/ef96d5968592b8243e1749f994acd2bc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var View, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    View = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Status')).includes('For Sale'));

  } catch (error) {

  }

  return View

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/53c6424f97abaead2b33fad223c91e65/bundle.js', [], () => ({
  /* content */
  /* handler:MinLogic */
  ['MinLogic'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Input = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Profit_Target')) * 0.9;

  return Input

  },
  /* handler:MinLogic */
  /* handler:MaxLogic */
  ['MaxLogic'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Input = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Profit_Target')) * 3;

  return Input

  },
  /* handler:MaxLogic */
  /* handler:TargetLogic */
  ['TargetLogic'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Input = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Profit_Target'));

  return Input

  },
  /* handler:TargetLogic */
  /* handler:InputLogic */
  ['InputLogic'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Profit_Loss_Projected'));

  } catch (error) {

  }

  return Input

  },
  /* handler:InputLogic */
  /* handler:LeadLogic */
  ['LeadLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Profit_Loss_Projected')) < 0 ? '( R ' : 'R ')

  },
  /* handler:LeadLogic */
  /* handler:FollowLogic */
  ['FollowLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Profit_Loss_Projected')) < 0 ? ' )' : null)

  },
  /* handler:FollowLogic */
  /* content */
}))

define('./pages/Assets/components/e32b6b2ffb2ad979b70c5101d012a701/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  ['InputLogic'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Distance_Travelled'));

  } catch (error) {

  }

  return Input

  },
  /* handler:InputLogic */
  /* handler:MaxLogic */
  ['MaxLogic'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * (new Date((new Date())).getDate()) * 1.1;

  } catch (error) {

  }

  return Input

  },
  /* handler:MaxLogic */
  /* handler:MinLogic */
  ['MinLogic'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * (new Date((new Date())).getDate()) * 0.95;

  } catch (error) {

  }

  return Input

  },
  /* handler:MinLogic */
  /* handler:TargetLogic */
  ['TargetLogic'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * (new Date((new Date())).getDate());

  } catch (error) {

  }

  return Input

  },
  /* handler:TargetLogic */
  /* content */
}))

define('./pages/Assets/components/22bcbb1b99b8b6cda25421162561503c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8fa2ddba7c2d5c5d7eab08d2ce864b56', undefined);
  await new Promise(r => setTimeout(r, 200 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b2f6db22db758c1a86475775605eb8c3', true);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('22bcbb1b99b8b6cda25421162561503c');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('22bcbb1b99b8b6cda25421162561503c');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/Assets/components/20ea30b7d19a7e9c87659c1907c71d29/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('ccae1dcbcaf4892cdddddf977b919acd');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('ccae1dcbcaf4892cdddddf977b919acd');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('e9b3c46d01dbdf48702a683c74c9707c', undefined);
  await new Promise(r => setTimeout(r, 300 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fa2a9b712c4e546f68ddbbc501a3ade2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/dd4626f7cbf91d0fdc5bffb85a772cf5/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  ['InputLogic'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Consumption_Actual'));

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:InputLogic */
  /* handler:MinLogic */
  ['MinLogic'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Consumption_Ideal')) * 0.95;

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:MinLogic */
  /* handler:MaxLogic */
  ['MaxLogic'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Consumption_Ideal')) * 1.2;

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:MaxLogic */
  /* handler:TargetLogic */
  ['TargetLogic'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Consumption_Ideal'));

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:TargetLogic */
  /* content */
}))

define('./pages/Assets/components/62bc3d5fe1ba731c46134bad6d020288/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('478885e5cc12094b1bc7f1579efbcedb');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('478885e5cc12094b1bc7f1579efbcedb');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('613cf84205d517eee86a85f97ef4da98', undefined);
  await new Promise(r => setTimeout(r, 200 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d5861392d64ba64bce6f38e591ebc467', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/57fea8da3d51d0ee43685be81deeb932/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  ['InputLogic'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Tonnage_Total'));

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:InputLogic */
  /* handler:TargetLogic */
  ['TargetLogic'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Tonnage_Projected_Ideal_For Today'));

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:TargetLogic */
  /* handler:MinLogic */
  ['MinLogic'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Tonnage_Projected_Ideal_For Today')) * 0.9;

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:MinLogic */
  /* handler:MaxLogic */
  ['MaxLogic'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Tonnage_Projected_Ideal_For Today')) * 1.3;

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:MaxLogic */
  /* handler:FollowLogic */
  ['FollowLogic'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = String(' ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Units'));

  } catch (error) {

  }

  return Input

  },
  /* handler:FollowLogic */
  /* content */
}))

define('./pages/Assets/components/112c54a8154307d7fd03ad01766b21d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('12ffcd2a0f5af80bebf447edfaf53caf', undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('de1c4a0e7ec79398c89aa7bbdd889b09');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('de1c4a0e7ec79398c89aa7bbdd889b09');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/Assets/components/9ec83f542cc866282fbb5c3d74e1b2f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'License_Status')) == 'License Overdue' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'License_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f44a28e8f6f3fc877238de766fd33d18', undefined);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b6aae70451c6ec06f5a1a9a6bef954a3', ({ [`Item`]: ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'),[`Type`]: 'Tractor' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/0c558a0366c259cf3ff176e8e8139fd1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'License_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/5e4492bc1373d799729ff7126841eeed/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'License_Status')) == 'License Overdue') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/8da96b7652827102cb02a8d50f1cdfa5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'License_Status')) == 'License Overdue' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'License_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f44a28e8f6f3fc877238de766fd33d18', undefined);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b6aae70451c6ec06f5a1a9a6bef954a3', ({ [`Item`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')),[`Type`]: 'Trailer',[`Number`]: 'Trailer1' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/ca634544cb410fc150361a130d31a7ae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'License_Status')) == 'License Overdue') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/b2939cb5553e1053cb389a2af3f9aca8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'License_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/83b6e7ba1aa220feb6c648e25754c678/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'License_Status')) == 'License Overdue' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'License_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f44a28e8f6f3fc877238de766fd33d18', undefined);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b6aae70451c6ec06f5a1a9a6bef954a3', ({ [`Item`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')),[`Type`]: 'Trailer',[`Number`]: 'Trailer2' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/76a434cd1db5864872ed2d9655c690ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'License_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/bfc562c97473f896bd938c83dcc2c49a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'License_Status')) == 'License Overdue') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/b39803a78df15f2ce0bb81c6616e10eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'License_Status')) == 'License Overdue' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'License_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f44a28e8f6f3fc877238de766fd33d18', undefined);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b6aae70451c6ec06f5a1a9a6bef954a3', ({ [`Item`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')),[`Type`]: 'Trailer',[`Number`]: 'Trailer2' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/b49bd8f13e1cfc543314798a6932f2b5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'License_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/37b3bd8716ccdf58f02dbf662b192561/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'License_Status')) == 'License Overdue') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/eee7650841338caf805fede14d1858b5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_License_Expirey_Date_Status')) == 'License Overdue' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_License_Expirey_Date_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f44a28e8f6f3fc877238de766fd33d18', undefined);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b6aae70451c6ec06f5a1a9a6bef954a3', ({ [`Item`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')),[`Type`]: 'Driver' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/818860caf27c853a38d9028861f110ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_License_Expirey_Date_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/be7b322166bb75ae6aea8a557b85db38/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_License_Expirey_Date_Status')) == 'License Overdue') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/ce7ee0c78eb7c3fb79e92a82a53a9fee/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_PDP_Expiry_Date_Status')) == 'License Overdue' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_PDP_Expiry_Date_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f44a28e8f6f3fc877238de766fd33d18', undefined);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b6aae70451c6ec06f5a1a9a6bef954a3', ({ [`Item`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')),[`Type`]: 'PDP' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/52916abf60ee01dc1299a21fc48cd0b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_PDP_Expiry_Date_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/64c80f023024f806216ab67ce1ac7024/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_PDP_Expiry_Date_Status')) == 'License Overdue') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/ff243b89c93b7b2a041d3f2991983fe1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service_Status')) == 'Service Due') {
      Viewer = true;
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service_Status')) == 'Scheduled') {
        if ((getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


         return ((getObjectProperty(item, 'Service_ID')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_ID')));
        }))[0]), 'Status')) == 'Delivered') {
          Viewer = true;
        } else {
          Viewer = false;
        }
      } else {
        Viewer = false;
      }
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Unscheduled Services')) == false) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_ID'))))) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f3e9c22366f902aef4819ddad8b9b81a', undefined);
    } else {
      await new Promise(r => setTimeout(r, 300 || 0));
      ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Service Item'] = ((await Backendless.Data.of('Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Service_ID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_ID')),'\''].join(''))).setPageSize(10)))[0]);
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Tractor',[`Vehicle`]: ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'),[`Odometer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) }));
    }
  } else {
    await new Promise(r => setTimeout(r, 300 || 0));
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Tractor',[`Vehicle`]: ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'),[`Odometer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/8a46254eda548eae2acbf8d91c48ffb9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Service_Status')) == 'Service Due' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Service_Status')) == 'Scheduled') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 300 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Trailer1',[`Vehicle`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')),[`Odometer`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Odometer')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/d55def9ccaa104ce0caf27cee21d7bf2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Service_Status')) == 'Service Due' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Service_Status')) == 'Scheduled') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 300 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Trailer2',[`Vehicle`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')),[`Odometer`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Odometer')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/0809a87a23b9414e11cd8fa66c22bc81/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Service_Status')) == 'Service Due' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Service_Status')) == 'Scheduled') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 300 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Trailer3',[`Vehicle`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')),[`Odometer`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Odometer')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/e6eab1d960ba7b1f4b96a96a50a65755/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var item, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Current Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Current Load')).length)) > 0 == true || ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Current Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Current Load')).length)) > 0 == true || ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Current Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Current Load')).length)) > 0 == true || ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? 0 : (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) == 'Loaded');
    })).length) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('2df6d67298abaf23f0d613c201e151d7', true);
  try {
    await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('856f6a28c99b0a8403476af7237cad34', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/c6c928fd318663e8f5e9b3ba20d8c89f/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  async ['onContainerDataAssignment'](___arguments) {
    var Data_Model, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    Data_Model = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Axles_Data')), 1, async (item) => {


     return (getObjectProperty(item, 'Position Number'));
    }));

  } catch (error) {

  } finally {
    if (error) {
      Data_Model = null;
    }

  }

  return Data_Model

  },
  /* handler:onContainerDataAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
      Viewer = false;
    } else {
      Viewer = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/a89417b6d0668a1d1471a008db6be484/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Make'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Make'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/a66d3ba626acf5f2c5b74b8b01253c53/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.appData);
  console.log(___arguments.context.pageData);
  console.log(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'));
  console.log(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'));
  console.log(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'));
  console.log(___arguments.event);

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Model'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Model'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/fd9dd904fd4ccfb7782f198b3425892f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      delete ___arguments.context.appData['Network'];
  delete ___arguments.context.appData['User'];
  await Backendless.UserService.logout();
  console.log((function () { return window.location.href })());
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/ae6f79f55593fcf49f6d5fde6a6cb8bd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payloadview'))))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration'))))) {
        Content = '';
      } else {
        Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration'));
      }
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
        Content = [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload_Override')))) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload_Override')),'kg','\n','No Trailers'].join('');
      } else {
        if (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) && !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
          Content = [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload_Override')))) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload_Override')),'kg','\n',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Type')),'\n','(Superlink)'].join('');
        } else {
          Content = [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload_Override')))) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload_Override')),'kg','\n',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Type'))].join('');
        }
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('93b872fa6eec6ff554271f7e75e4a6f1', undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Payloadview'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('3b23308492819449e525edaab38fb7f8');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      delete ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Payloadview'];
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('3b23308492819449e525edaab38fb7f8');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/Assets/components/9dfca5496c0ae199f6e4868fbb64fcfb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var item, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Next Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Next Load')).length)) > 0 == true || ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Next Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Next Load')).length)) > 0 == true || ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Next Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Next Load')).length)) > 0 == true || ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? 0 : (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) == 'Planned');
    })).length) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('856f6a28c99b0a8403476af7237cad34', true);
  try {
    await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('2df6d67298abaf23f0d613c201e151d7', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/1a79f6851bf5eb241d92f5da73557e8b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('54a992b40b6d0efed5942c26ed6fb97b', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/076b52d3e4041543b4af8ac958dca3aa/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('9b8fefbb70dae96eab3e3732d53bf786');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('9b8fefbb70dae96eab3e3732d53bf786');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/Assets/components/d8c186fb87fe5bb74aaea30b3a818014/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('39b977aba67b2fae9fe845d6294de453');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('39b977aba67b2fae9fe845d6294de453');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('99f282ff0c2737e9f9837e2932fc5155', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/62fd2db16dc48499896efab14c1e4e44/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('1a5f10e9652a5288229acd221fb9b7fd');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('1a5f10e9652a5288229acd221fb9b7fd');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/Assets/components/852100c47438a0b1c81d9c34926a302e/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('852100c47438a0b1c81d9c34926a302e'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('852100c47438a0b1c81d9c34926a302e'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('d6fa4831d4b8222782da812481678bb4', undefined);
  ___arguments.context.pageData['Asset Drawer Data'] = 'Tractors';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/bb94094b79c8a35baf56f5c38151f29d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Time_Now, Time_Start, item, Points_List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  console.log(getObjectProperty((await (async function(to, from, Device) {
  	// Define the function to execute the HTTP request
  	async function fetchFlespiMessages(start, end, device) {
  	  console.log(`Fetching messages for device ${device} from ${start} to ${end}`);
  	
  	  // Construct the URL with query parameters
  	  const url = `https://flespi.io/gw/devices/${device}/messages?data=%7B%22to%22%3A${end}%2C%22from%22%3A${start}%7D`;
  	
  	  const headers = {
  	    'Content-Type': 'application/json',
  	    'Authorization': 'FlespiToken 1rSTqs5yHq64EsaPeiYKanXoP7VR0ru8GuoNJMVM0VUfWoen391ae0kGfdbOXocW'
  	  };
  	
  	  // Perform the HTTP GET request using fetch
  	  const response = await fetch(url, { headers });
  	  if (!response.ok) {
  	    throw new Error(`HTTP error! status: ${response.status}`);
  	  }
  	
  	  // Parse and return the JSON response
  	  const result = await response.json();
  	  return result;
  	}
  	
  	// Retrieve the parameters passed to the custom code block
  	const start = from;
  	const end = to;
  	const device = arguments[2]; // Retrieve the device number from arguments
  	
  	// Print the parameters for debugging
  	console.log(`Start (from): ${start}`);
  	console.log(`End (to): ${end}`);
  	console.log(`Device: ${device}`);
  	
  	// Call the function with the retrieved parameters
  	return fetchFlespiMessages(start, end, device);

  })((1 / 1000), (1 / 1000), null)), 'result'));
  await (async function(googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers, pointColor, pointScale) {
  	function addPolylineAndCustomMarkers(googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers) {
  	  // Ensure googleMapComponent is valid
  	  if (!googleMapComponent) {
  	    console.error("Invalid googleMapComponent.");
  	    return;
  	  }
  	
  	  // Retrieve the map instance from googleMapComponent
  	  const mapInstance = googleMapComponent.map.map;
  	
  	  // Ensure mapInstance is valid
  	  if (!(mapInstance instanceof google.maps.Map)) {
  	    console.error("Invalid map instance. Map is:", mapInstance);
  	    return;
  	  }
  	
  	  // Generate coordinates for the polyline from markers
  	  const polylineCoordinates = markers.map(marker => ({
  	    lat: marker.lat,
  	    lng: marker.lng
  	  }));
  	
  	  // Create a new Polyline object
  	  const polyline = new google.maps.Polyline({
  	    path: polylineCoordinates,
  	    geodesic: true,
  	    strokeColor: polylineColor || '#FF0000',
  	    strokeOpacity: strokeOpacity || 1.0,
  	    strokeWeight: strokeWeight || 2
  	  });
  	
  	  // Set the polyline on the map
  	  polyline.setMap(mapInstance);
  	
  	  // Function to calculate the bearing between two points
  	  function calculateHeading(lat1, lng1, lat2, lng2) {
  	    const toRadians = degrees => degrees * Math.PI / 180;
  	    const toDegrees = radians => radians * 180 / Math.PI;
  	
  	    const dLng = toRadians(lng2 - lng1);
  	    const y = Math.sin(dLng) * Math.cos(toRadians(lat2));
  	    const x = Math.cos(toRadians(lat1)) * Math.sin(toRadians(lat2)) - Math.sin(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.cos(dLng);
  	    const bearing = toDegrees(Math.atan2(y, x));
  	    return (bearing + 360) % 360;  // Normalize to 0-360
  	  }
  	
  	  // Add custom markers to the map
  	  pointMarkers.forEach((marker, index) => {
  	    let icon;
  	    if (marker.Speed === 0) {
  	      // Create a dot for the marker if Speed is 0
  	      icon = {
  	        path: google.maps.SymbolPath.CIRCLE,
  	        fillColor: marker.color || pointColor || '#FF0000',
  	        fillOpacity: 1,
  	        strokeColor: 'black',
  	        strokeWeight: 2,  // Increased stroke weight for better visibility
  	        scale: marker.scale || pointScale || 8,  // Increased scale for better visibility
  	      };
  	    } else {
  	      // Create an arrow for other markers
  	      let heading = marker.Direction !== undefined ? marker.Direction : 0;
  	      if (marker.Direction === undefined && index < pointMarkers.length - 1) {
  	        const nextMarker = pointMarkers[index + 1];
  	        heading = calculateHeading(marker.lat, marker.lng, nextMarker.lat, nextMarker.lng);
  	      }
  	
  	      // Adjust the heading by subtracting 90 degrees
  	      heading = (heading - 90 + 360) % 360;
  	
  	      icon = {
  	        path: "M 0 0 L -2 -2 L 1 0 L -2 2 Z",
  	        fillColor: marker.color || pointColor || '#FF0000',
  	        fillOpacity: 1,
  	        strokeColor: 'black', // Outline color
  	        strokeWeight: 2, // Increased stroke weight for better visibility
  	        rotation: heading,
  	        scale: marker.scale || pointScale || 8, // Increased scale for better visibility
  	        anchor: new google.maps.Point(0, 0),
  	      };
  	    }
  	
  	    const pointMarker = new google.maps.Marker({
  	      position: { lat: marker.lat, lng: marker.lng },
  	      map: mapInstance,
  	      icon: icon
  	    });
  	
  	    // Add an event listener for the marker to show a popup with the data
  	    if (marker.Data) {
  	      const infowindow = new google.maps.InfoWindow({
  	        content: marker.Data
  	      });
  	
  	      pointMarker.addListener('click', function() {
  	        infowindow.open(mapInstance, pointMarker);
  	      });
  	    }
  	  });
  	}
  	
  	try {
  	  const googleMapComponent = arguments[0]; // Retrieve the Google Map component from arguments
  	  const polylineColor = arguments[1]; // Retrieve the polyline color from arguments
  	  const markers = arguments[2]; // Retrieve the list of markers from arguments
  	  const strokeOpacity = arguments[3]; // Retrieve the stroke opacity from arguments
  	  const strokeWeight = arguments[4]; // Retrieve the stroke weight from arguments
  	  const pointMarkers = arguments[5]; // Retrieve the list of point markers from arguments
  	
  	  addPolylineAndCustomMarkers(googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers);
  	} catch (error) {
  	  console.error("Error adding polyline and custom markers:", error);
  	}

  })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), '#CC6633', (await Promise.all(Points_List.map(async item => {; return ({ [`lat`]: (getObjectProperty(item, 'position.latitude')),[`lng`]: (getObjectProperty(item, 'position.longitude')) });}))), 1, 8, (await Promise.all(Points_List.map(async item => {; return ({ [`lat`]: (getObjectProperty(item, 'position.latitude')),[`lng`]: (getObjectProperty(item, 'position.longitude')),[`Data`]: (await (async function(Headers, Rows) {
  	function createPopupDiv(Headers, Rows) {
  	    // Create the popup div
  	    let popupDiv = `
  	    <div class="popup" style="background-color: rgba(0, 0, 0, 0.8); border: 2px solid #CC6633; border-radius: 10px; padding: 10px; color: #ffffff; font-family: Arial, sans-serif; width: 350px;">
  	        <table style="width: 100%; border-collapse: collapse; table-layout: fixed;">
  	            <colgroup>
  	                <col style="width: 50%;">
  	                <col style="width: 50%;">
  	            </colgroup>
  	    `;
  	
  	    // Add the top part (unscrollable)
  	    Headers.forEach(header => {
  	        popupDiv += `
  	            <tr>
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left; background-color: ${header.Color};">${header.Label}</td>
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left; background-color: ${header.Color};">${header.Value}</td>
  	            </tr>
  	        `;
  	    });
  	
  	    popupDiv += `</table>
  	        <div class="scrollable-content" style="max-height: 200px; overflow-y: auto;">
  	            <table style="width: 100%; border-collapse: collapse; table-layout: fixed;">
  	                <colgroup>
  	                    <col style="width: 50%;">
  	                    <col style="width: 50%;">
  	                </colgroup>
  	    `;
  	
  	    // Add the scrollable part (rows)
  	    Rows.forEach(row => {
  	        popupDiv += `
  	            <tr style="background-color: ${row.Color};">
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left;">${row.Label}</td>
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left;">${row.Value}</td>
  	            </tr>
  	        `;
  	    });
  	
  	    // Close the tables and div
  	    popupDiv += `
  	            </table>
  	        </div>
  	    </div>
  	    `;
  	
  	    // Return the popup div HTML
  	    return popupDiv;
  	}
  	
  	try {
  	    const Headers = arguments[0]; // Retrieve the Headers from arguments
  	    const Rows = arguments[1]; // Retrieve the Rows from arguments
  	
  	    const popupHTML = createPopupDiv(Headers, Rows);
  	    return popupHTML;
  	} catch (error) {
  	    console.error("Error creating popup div:", error);
  	    return "Error creating popup div.";
  	}

  })([({ [`Label`]: 'Registration',[`Value`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), ({ [`Label`]: 'Fleet ID',[`Value`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID')),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), ({ [`Label`]: 'Driver',[`Value`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Nickname')),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), ({ [`Label`]: 'Mobile',[`Value`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Phone')),[`Color`]: 'rgba(204, 102, 51, 0.5)' })], [({ [`Label`]: 'Odometer',[`Value`]: (getObjectProperty(item, 'can.vehicle.mileage')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), ({ [`Label`]: 'Speed',[`Value`]: (getObjectProperty(item, 'position.speed')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), ({ [`Label`]: 'Low Fuel',[`Value`]: (getObjectProperty(item, 'can.fuel.level.low.indicator.status')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), ({ [`Label`]: 'RPM',[`Value`]: (getObjectProperty(item, 'can.engine.rpm')),[`Color`]: 'rgba(70, 130, 180, 0.5)' }), ({ [`Label`]: 'Altitude',[`Value`]: (getObjectProperty(item, 'position.altitude')),[`Color`]: 'rgba(70, 130, 180, 0.5)' }), ({ [`Label`]: 'Lights Failure ',[`Value`]: (getObjectProperty(item, 'can.lights.failure.indicator.status')),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), ({ [`Label`]: 'Maintenance Req.',[`Value`]: (getObjectProperty(item, 'can.lights.failure.indicator.status')),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), ({ [`Label`]: 'Oil Level Warning',[`Value`]: (getObjectProperty(item, 'can.maintenance.required.status')),[`Color`]: 'rgba(128, 0, 128, 0.5)' })])),[`color`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), 'position.speed')))) || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), 'position.speed')) == 0 ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), 'can.engine.rpm')))) || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), 'can.engine.rpm')) == 0 ? '#808080' : '#FFFF00') : '#CC6633',[`Speed`]: (getObjectProperty(item, 'position.speed')),[`Direction`]: (getObjectProperty(item, 'position.direction')) });}))), '#CC6633', 12);
  console.log((await (async function(Headers, Rows) {
  	function createPopupDiv(Headers, Rows) {
  	    // Create the popup div
  	    let popupDiv = `
  	    <div class="popup" style="background-color: rgba(0, 0, 0, 0.8); border: 2px solid #CC6633; border-radius: 10px; padding: 10px; color: #ffffff; font-family: Arial, sans-serif; width: 350px;">
  	        <table style="width: 100%; border-collapse: collapse; table-layout: fixed;">
  	            <colgroup>
  	                <col style="width: 50%;">
  	                <col style="width: 50%;">
  	            </colgroup>
  	    `;
  	
  	    // Add the top part (unscrollable)
  	    Headers.forEach(header => {
  	        const label = header.Label != null ? header.Label : '-';
  	        const value = header.Value != null ? header.Value : '-';
  	        const color = header.Color != null ? header.Color : '#000000'; // Default to black if color is not provided
  	        popupDiv += `
  	            <tr>
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left; background-color: ${color};">${label}</td>
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left; background-color: ${color};">${value}</td>
  	            </tr>
  	        `;
  	    });
  	
  	    popupDiv += `</table>
  	        <div class="scrollable-content" style="max-height: 200px; overflow-y: auto;">
  	            <table style="width: 100%; border-collapse: collapse; table-layout: fixed;">
  	                <colgroup>
  	                    <col style="width: 50%;">
  	                    <col style="width: 50%;">
  	                </colgroup>
  	    `;
  	
  	    // Add the scrollable part (rows)
  	    Rows.forEach(row => {
  	        const label = row.Label != null ? row.Label : '-';
  	        const value = row.Value != null ? row.Value : '-';
  	        const color = row.Color != null ? row.Color : '#000000'; // Default to black if color is not provided
  	        popupDiv += `
  	            <tr style="background-color: ${color};">
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left;">${label}</td>
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left;">${value}</td>
  	            </tr>
  	        `;
  	    });
  	
  	    // Close the tables and div
  	    popupDiv += `
  	            </table>
  	        </div>
  	    </div>
  	    `;
  	
  	    // Return the popup div HTML
  	    return popupDiv;
  	}
  	
  	try {
  	    const Headers = arguments[0]; // Retrieve the Headers from arguments
  	    const Rows = arguments[1]; // Retrieve the Rows from arguments
  	
  	    const popupHTML = createPopupDiv(Headers, Rows);
  	    return popupHTML;
  	} catch (error) {
  	    console.error("Error creating popup div:", error);
  	    return "Error creating popup div.";
  	}

  })(null, null)));
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7c844bedb74f9916e6928cd1a10ace5f');
  Time_Now = (new Date());
  Time_Start = (new Date((new Date()).getTime() - (900 * 1000)));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
  await new Promise(r => setTimeout(r, 500 || 0));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live'))], ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/7c844bedb74f9916e6928cd1a10ace5f/bundle.js', [], () => ({
  /* content */
  /* handler:modalVisibilityLogic */
  async ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'Track IT Close')) == true) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7c844bedb74f9916e6928cd1a10ace5f');
    delete ___arguments.context.appData['Track IT Close'];
  }

  },
  /* handler:modalVisibilityLogic */
  /* content */
}))

define('./pages/Assets/components/1feb80e94055fb0653b5ac8571fe79dc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('91ce77bf29654236309c47e9151fd443');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('91ce77bf29654236309c47e9151fd443');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      delete ___arguments.context.appData['Current Tracking Data'];
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7c844bedb74f9916e6928cd1a10ace5f');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/e367b5edcff49236a58d5a3599cdd4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Points_List, Time_Now, Time_Start, Live_Start;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Track_It_Function() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live'))], ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  }
}


  if (___arguments.value == 'Historical') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('4857dff971b24802ce5833ad7e5b56c6');
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('e367b5edcff49236a58d5a3599cdd4d5', null);
  } else if (___arguments.value == '15 Minutes') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (900 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '30 Minutes') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (1800 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '1 Hour') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (3600 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '2 Hours') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (7200 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '4 Hours') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (14400 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '6 Hours') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (21600 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == 'Live') {
    Time_Now = (new Date());
    Live_Start = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (300 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
    while (___arguments.value == 'Live') {
      if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e367b5edcff49236a58d5a3599cdd4d5')) == 'Live') {
        await new Promise(r => setTimeout(r, 60000 || 0));
        Time_Now = (new Date());
        Time_Start = Live_Start;
        Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
        ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
        await Track_It_Function();
      } else {
      }
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/6ac7003b52d73c7b3f9db0ff9552622a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Points_List, To, From;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  From = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'From'));
  To = From + (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'To')) * 1000;
  Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), From, To));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
  await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : 5)))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4857dff971b24802ce5833ad7e5b56c6');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/7fb75eae7b7b411ea4549a4fe3812d6b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 100 || 0));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Density'] = ___arguments.value;
  await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points'))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')))) ? [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live'))] : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points'))), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/4707bc0a4ece663933c7175ba3875eef/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
    var Maximum;


  Maximum = (new Date((new Date()).getTime() - (21600 * 1000)));

  return Maximum

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/Assets/components/68c155d83df98ee44433d316e5a125d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments.context.appData);
  console.log(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'created'));
  console.log((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'created')))));
  console.log(new Date((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'created')).getFullYear(), (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'created')).getMonth() + 1, 0).getDate());

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/fc96be21cf223812ebb3f1aa22b75653/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/30f560e713165cb86a236197f8ada466/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('170921392d8863bdc1263682b2041699');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('170921392d8863bdc1263682b2041699');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/Assets/components/a3831b4e28410e685174d8da9c366071/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('aabe2c13c4fd13c136c825ef9fe41209');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('aabe2c13c4fd13c136c825ef9fe41209');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Zoom, Centre, Time_Start;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e05ae79169330a652453cd9554b2a019', false);
  Zoom = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).zoom })('00a10794c3394968e50d921a03174098'));
  Centre = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('00a10794c3394968e50d921a03174098'));
  Time_Start = (new Date());
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']('5806738', (Time_Start - 900000), Time_Start));
  await new Promise(r => setTimeout(r, 100 || 0));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : 5)))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, null);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : 5)))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, null);
  }
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty(Centre, 'lat')), (getObjectProperty(Centre, 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', Zoom);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/8e7f5b851c869307b79fa534817e6f65/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Zoom, Centre, Time_Start;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Zoom = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).zoom })('00a10794c3394968e50d921a03174098'));
  Centre = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('00a10794c3394968e50d921a03174098'));
  Time_Start = (new Date());
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']('5806738', (Time_Start - 900000), Time_Start));
  await new Promise(r => setTimeout(r, 100 || 0));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live'))], ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), true, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f')), ___arguments.context.appData);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), true, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f')), ___arguments.context.appData);
  }
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty(Centre, 'lat')), (getObjectProperty(Centre, 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', Zoom);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/c677cffcef812bd62009ab82ffebc39f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var error;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'New Customer') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24713758b56f92727e7597b92b6ba90c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95478b25e6e94196eb632a0e6be7fe11', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dc48734547b319ff2a1d3af8d56d1f8', true);
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24713758b56f92727e7597b92b6ba90c', false);

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95478b25e6e94196eb632a0e6be7fe11', false);

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dc48734547b319ff2a1d3af8d56d1f8', false);

    } catch (error) {
      console.log(error);

    }
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) == 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0 && getValueLength(___arguments.value) > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
    } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) != 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);
    }
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Customer')) });}))), ({ [`value`]: 'New Customer',[`label`]: 'New Customer' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Assets/components/d598fd450f8626b35e41e328909a87bc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'Load/Offload Point') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c677cffcef812bd62009ab82ffebc39f', true);
    if (___arguments.value == 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0 && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f'))) > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
    }
  } else if (___arguments.value != 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/47460d949ad29456821b4bf8d56d8f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) == 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength(___arguments.value) > 0) {
    if (getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f'))) > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c677cffcef812bd62009ab82ffebc39f', true);
    }
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) != 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength(___arguments.value) > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/e587223e046dab92231b76ac8107599f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) == 'Load/Offload Point' && getValueLength(___arguments.value) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0 && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f'))) > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) != 'Load/Offload Point' && getValueLength(___arguments.value) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/6756de42fd718227da45ff47f046b81d/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('7448c9eda24219d3805f149b160978d1');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('7448c9eda24219d3805f149b160978d1');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e05ae79169330a652453cd9554b2a019', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/bcfc8832cc1525e208a9606351c2b5b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'))))) {
      Content = '';
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'))) {
        Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration'));
      } else {
        Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'));
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/31a9a6d861969bf2e4e9e2bda371ab1d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'geofencePolygons'))))) {
    Viewer = false;
  } else {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path')).length >= 3) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Zoom, Centre, j, TrackitModal_Keys, error, Location, Results, New_Customer, Location_Transaction, Location_Refrence, Customer_Refrence, ID, ID_Number_Variable, ID_Start, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function do_something() {
  Zoom = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).zoom })('00a10794c3394968e50d921a03174098'));
  Centre = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('00a10794c3394968e50d921a03174098'));
  try {
    ID_Number_Variable = String((Number((subsequenceFromEndLast((getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), 1, async (item) => {


     return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 3))));
    })).slice(-1)[0]), 'ID')), 3)))) + 1);

  } catch (error) {
    console.log(error);

  } finally {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](ID_Number_Variable))) {
      ID_Number_Variable = 1;
    }

  }
  try {
    ID_Start = subsequenceFirstFromEnd((getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), 1, async (item) => {


     return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 3))));
    })).slice(-1)[0]), 'ID')), 4);

  } catch (error) {
    console.log(error);

  } finally {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](ID_Start))) {
      ID_Start = String((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')).slice(0, 5)) + String(' Lo ');
    }

  }
  ID = String(ID_Start) + String(getValueLength(ID_Number_Variable) == 1 ? String('000') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 2 ? String('00') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 3 ? String('0') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 4 ? ID_Number_Variable : ID_Number_Variable))));
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f')) == 'New Customer') {
    Location = ({ [`Address`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)')),[`Color`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f')),[`Contact_Name`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIT - GeoFence (Contact Name)')),[`Geo Fences`]: (new Backendless.Data.Polygon((await Promise.all((addItemToList((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path')), ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]))).map(async item => {; return (new Backendless.Data.Point().setX((getObjectProperty(item, 'lng'))).setY((getObjectProperty(item, 'lat'))));}))), )),[`ID`]: ID,[`Name`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)')),[`Phone`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIT - GeoFence (Contact Number)')),[`Point`]: (new Backendless.Data.Point().setX((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]), 'lng'))).setY((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]), 'lat')))),[`Type`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')) });
  } else {
    Location = ({ [`Address`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)')),[`Color`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f')),[`Contact_Name`]: '',[`Geo Fences`]: (new Backendless.Data.Polygon((await Promise.all((addItemToList((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path')), ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]))).map(async item => {; return (new Backendless.Data.Point().setX((getObjectProperty(item, 'lng'))).setY((getObjectProperty(item, 'lat'))));}))), )),[`ID`]: ID,[`Name`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)')),[`Phone`]: '',[`Point`]: (new Backendless.Data.Point().setX((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]), 'lng'))).setY((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]), 'lat')))),[`Type`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')) });
  }
  Location_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Location_Transaction;

    Location_Refrence = (_uow.create('Locations', Location));
    _uow.setRelation('Locations', Location_Refrence, 'Company', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')));
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations', [Location_Refrence]);
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) == 'Load/Offload Point') {
      if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f')) == 'New Customer') {
        try {
          ID_Number_Variable = String((Number((subsequenceFromEndLast((getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), 1, async (item) => {


           return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 3))));
          })).slice(-1)[0]), 'ID')), 3)))) + 1);

        } catch (error) {
          console.log(error);

        } finally {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](ID_Number_Variable))) {
            ID_Number_Variable = 1;
          }

        }
        try {
          ID_Start = subsequenceFirstFromEnd((getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), 1, async (item) => {


           return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 3))));
          })).slice(-1)[0]), 'ID')), 4);

        } catch (error) {
          console.log(error);

        } finally {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](ID_Start))) {
            ID_Start = String((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')).slice(0, 5)) + String(' C ');
          }

        }
        console.log(ID_Number_Variable);
        console.log(ID_Start);
        ID = String(ID_Start) + String(getValueLength(ID_Number_Variable) == 1 ? String('000') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 2 ? String('00') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 3 ? String('0') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 4 ? ID_Number_Variable : ID_Number_Variable))));
        New_Customer = ({ [`Customer`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIT - GeoFence (Customer Name)')),[`Contact_Name`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIT - GeoFence (Contact Name)')),[`Contact_Phone`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIT - GeoFence (Contact Number)')),[`ID`]: ID,[`Customer_Location`]: (new Backendless.Data.Point().setX((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]), 'lng'))).setY((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]), 'lat')))),[`Name`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIT - GeoFence (Customer Name)')),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')) });
        Customer_Refrence = (_uow.create('Customers', New_Customer));
        _uow.addToRelation('Customers', Customer_Refrence, 'Locations', [Location_Refrence]);
        _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers', [Customer_Refrence]);
      } else {
        _uow.addToRelation('Customers', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f')), 'Locations', [Location_Refrence]);
      }
    }

  })();

  Results = (await Location_Transaction.execute().then(function(result) {
      const error = result && result.error

      if (error) {
        throw error
      }

    return result
    }));
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f')) == 'New Customer') {
    try {
      New_Customer['objectId'] = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Results, 'results')), 'createCustomers1')), 'result')), 'objectId'));

    } catch (error) {
      console.log(error);

    }
    try {
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), New_Customer);

    } catch (error) {
      console.log(error);

    }
  }
  Location['objectId'] = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Results, 'results')), 'createLocations1')), 'result')), 'objectId'));
  addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), Location);
  delete ___arguments.context.appData['geofencePolygons'];
  delete ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['TrackIT - Geofence Add'];
  await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live'))], ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('e367b5edcff49236a58d5a3599cdd4d5', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('d598fd450f8626b35e41e328909a87bc', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('e587223e046dab92231b76ac8107599f', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('c677cffcef812bd62009ab82ffebc39f', null);

  } catch (error) {
    console.log(error);

  }
  TrackitModal_Keys = (Object.keys(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')));
  for (var j_index in TrackitModal_Keys) {
    j = TrackitModal_Keys[j_index];
    delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')[j];
  }
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty(Centre, 'lat')), (getObjectProperty(Centre, 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', Zoom);
}


  await do_something();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e05ae79169330a652453cd9554b2a019', false);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))['Locations'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ('geofence.objectId' != (getObjectProperty(item, 'objectId')));
  }));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/Assets/components/24713758b56f92727e7597b92b6ba90c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) == 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0 && getValueLength(___arguments.value) > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/4d9be81d318b5546859677df5fbb2eac/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('1a421334079fb8f535fdae14b0cfb104');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('1a421334079fb8f535fdae14b0cfb104');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/Assets/components/055ded3887ec3629f8d3cb828ea5ac07/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('b40de5e80bdca6cc712a33297d45c664');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('b40de5e80bdca6cc712a33297d45c664');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('ca6753afdf05f48744fa68bdba662cc2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/34e632d41bfbfee251dacad7b228e867/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('ca6753afdf05f48744fa68bdba662cc2', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/77628deda5ef5ad1c109a73bbb0d6b29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('ca6753afdf05f48744fa68bdba662cc2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/3dcca805ba5e92f6ee45491e4a1dccc6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, item, Fuel_List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel'))))) {
    Content = ' - ';
  } else {
    Fuel_List = (await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel')), -1, async (item) => {


     return (getObjectProperty(item, 'Mileage'));
    })).slice(0, 5);
    ___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234')['CPK (Fuel)'] = (Math.round(((await Promise.all(Fuel_List.map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;}) / (await Promise.all(Fuel_List.map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;})) * 100) / 100);
    Content = String('R ') + String(Math.round(((await Promise.all(Fuel_List.map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;}) / (await Promise.all(Fuel_List.map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;})) * 100) / 100);
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel'));
  console.log(await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel')), 1, async (item) => {


   return (getObjectProperty(item, 'Mileage'));
  }));
  console.log(await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel')), -1, async (item) => {


   return (getObjectProperty(item, 'Mileage'));
  }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/319387e1e4d4c605e0bef3df435453c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/0daa356c63e9f46c418e7e85a5872c46/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item, Trailer_1_Return, Trailer__, Trailer, Content, CPK_Breakdown_List, Driver_1_Varaibles, Trailer_3_Variables, Trailer_2_Variables, Trailer_1_Variables, Tractor_Varialbles;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Tractor() {
  return [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Annual_License_Fee')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Annual_License_Fee')) / 12) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Commission_Rate')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Turnover')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Commission_Rate')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Turnover'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Depreciation')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Depreciation')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fixed_Maintenance_Plan_Cost')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fixed_Maintenance_Plan_Cost')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fixed_Monthly_Sundry_Cost')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fixed_Monthly_Sundry_Cost')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Instalment')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Instalment')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Insurance_Premium')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Insurance_Premium')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Maintenance_Plan_Rate_per_Km')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Maintenance_Plan_Rate_per_Km')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Profit_Target')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Profit_Target')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tyres')))) ? 0 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tyres')).length == 0 ? 0 : (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tyres')).map(async item => {; return (getObjectProperty(item, 'CPK_Expected'));}))).reduce(function(x, y) {return x + y;}))]
}

/**
 * Describe this function...
 */
async function Wages() {
  return [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Basic')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Basic')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Contractor_Mileage')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Contractor_Mileage')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Good_Driving')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Good_Driving')), null, null, null, null, null]
}

/**
 * Describe this function...
 */
async function Trailer_Function(Trailer) {
  Trailer__ = Trailer;
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__))))) {
    Trailer_1_Return = [0];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Tyres'))))) {
      Trailer_1_Return = [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Annual_License_Fee')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Annual_License_Fee')) / 12) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Depreciation')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Depreciation')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Fixed_Maintenance_Plan_Cost')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Fixed_Maintenance_Plan_Cost')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Installment')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Installment')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Insurance')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Insurance')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Tracking')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Tracking')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target'))];
    } else {
      Trailer_1_Return = [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Annual_License_Fee')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Annual_License_Fee')) / 12) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Depreciation')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Depreciation')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Fixed_Maintenance_Plan_Cost')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Fixed_Maintenance_Plan_Cost')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Installment')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Installment')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Insurance')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Insurance')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Tracking')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Tracking')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Tyres')))) ? 0 : ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Tyres')).length == 0 ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Tyres')).map(async item => {; return (getObjectProperty(item, 'CPK_Expected'));}))).reduce(function(x, y) {return x + y;}))];
    }
  }
  return Trailer_1_Return
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Tractor_Varialbles = await Tractor();
  CPK_Breakdown_List = Tractor_Varialbles;
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
  } else {
    Trailer_1_Variables = await Trailer_Function('Trailer1');
    CPK_Breakdown_List = (CPK_Breakdown_List.concat(Trailer_1_Variables));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
  } else {
    Trailer_2_Variables = await Trailer_Function('Trailer2');
    CPK_Breakdown_List = (CPK_Breakdown_List.concat(Trailer_2_Variables));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3'))))) {
  } else {
    Trailer_3_Variables = await Trailer_Function('Trailer3');
    CPK_Breakdown_List = (CPK_Breakdown_List.concat(Trailer_3_Variables));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))))) {
  } else {
    Driver_1_Varaibles = await Wages();
    CPK_Breakdown_List = (CPK_Breakdown_List.concat(Driver_1_Varaibles));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](CPK_Breakdown_List))) {
    Content = ' - ';
  } else {
    ___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234')['CPK (Fixed)'] = ((await asyncListFilter(CPK_Breakdown_List, async (item) => {


     return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](item)));
    })).reduce(function(x, y) {return x + y;}));
    Content = String('R ') + String(Math.round((await asyncListFilter(CPK_Breakdown_List, async (item) => {


     return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](item)));
    })).reduce(function(x, y) {return x + y;}) * 100) / 100);
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'CPK (Fixed)'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/600ecc76a12bcc017beea364a4e90b2d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, item, Fuel_List, CPK_Breakdown_List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CPK_Breakdown_List = (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'CPK (Fuel)')) + (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'CPK (Fixed)'));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](CPK_Breakdown_List)) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Trip'))))) {
    Content = 'R 0.00';
  } else {
    Content = String('R ') + String(Math.round((CPK_Breakdown_List * (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Trip')) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Profit')))) ? 0 : (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Profit'))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Tolls')))) ? 0 : (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Tolls')))) * 100) / 100);
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/ee088f5e935a0bcc877af4b53824f7bc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, CPK_Breakdown_List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CPK_Breakdown_List = (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'CPK (Fuel)')) + (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'CPK (Fixed)'));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](CPK_Breakdown_List))) {
    Content = ' - ';
  } else {
    Content = String('R ') + String(Math.round(CPK_Breakdown_List * 100) / 100);
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/9e6ce3a9b2eb3ece23181a6abf248ae7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, CPK_Breakdown_List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CPK_Breakdown_List = (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'CPK (Fuel)')) + (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'CPK (Fixed)'));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](CPK_Breakdown_List)) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Trip'))))) {
    Content = 'R -';
  } else {
    Content = String('R ') + String((typeof (Math.round(((Math.round((CPK_Breakdown_List * (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Trip')) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Profit')))) ? 0 : (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Profit'))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Tolls')))) ? 0 : (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Tolls')))) * 100) / 100) / (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Trip'))) * 100) / 100) === 'number' && !isNaN((Math.round(((Math.round((CPK_Breakdown_List * (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Trip')) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Profit')))) ? 0 : (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Profit'))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Tolls')))) ? 0 : (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Tolls')))) * 100) / 100) / (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Trip'))) * 100) / 100))) ? Math.round(((Math.round((CPK_Breakdown_List * (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Trip')) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Profit')))) ? 0 : (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Profit'))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Tolls')))) ? 0 : (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Tolls')))) * 100) / 100) / (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Trip'))) * 100) / 100 : '-');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/d5861392d64ba64bce6f38e591ebc467/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Selected Delivered Tonnage Record'] = ___arguments.selectedRecord;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('1c0dfc47bd9b8ccc6f8df1239bfc6079', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND TID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),'\' AND created >= ',(await (async function(Start) {
	function getStartOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const startOfMonth = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
	  startOfMonth.setHours(0, 0, 0, 0); // Set to the start of the day
	
	  return startOfMonth.getTime();
	}
	
	// Directly execute and return the result
	return getStartOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created')))),' AND created <= ',(await (async function(Start) {
	function getEndOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
	  endDate.setHours(23, 59, 59, 999); // Set to the end of the day
	
	  return endDate.getTime();
	}
	
	// Directly execute and return the result
	return getEndOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created'))))].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Assets/components/fa2a9b712c4e546f68ddbbc501a3ade2/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    var error, Refuel_List, New_Refuel_List, j, End_Marker, Start_Marker, Selected_Record, Slected_Record_Position, Fuel_List, Previous_Record, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.selectedRecord, 'Admin')) == true) {
    try {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('d28223acefc220231951e14c341c8341', undefined);

    } catch (error) {
      console.log(error);

    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Selected Fuel Consumption Record'] = ___arguments.selectedRecord;
    Selected_Record = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record'));
    await new Promise(r => setTimeout(r, 1000 || 0));
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('d28223acefc220231951e14c341c8341', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
  } else {
    try {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('d28223acefc220231951e14c341c8341', undefined);

    } catch (error) {
      console.log(error);

    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Selected Fuel Consumption Record'] = ___arguments.selectedRecord;
    Selected_Record = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record'));
    Fuel_List = (await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel')), -1, async (item) => {


     return (getObjectProperty(item, 'created'));
    }));
    Slected_Record_Position = Fuel_List.indexOf(Selected_Record) + 1;
    Previous_Record = Fuel_List[((Slected_Record_Position + 2) - 1)];
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), ((new Date((new Date((getObjectProperty(Selected_Record, 'created')))).getTime() - (1500 * 1000))).valueOf()), ((new Date((new Date((getObjectProperty(Selected_Record, 'created')))).getTime() + (3000 * 1000))).valueOf())));
    Refuel_List = [];
    var j_list = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      Start_Marker = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points'))[(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).indexOf(j) + 1) - 1)];
      try {
        End_Marker = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points'))[((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).indexOf(j) + 1) - 1) - 1)];

      } catch (error) {

      }
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](End_Marker))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(End_Marker, 'can.fuel.level'))))) {
        } else {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Start_Marker, 'can.fuel.level'))))) {
          } else {
            if ((getObjectProperty(End_Marker, 'can.fuel.level')) - (getObjectProperty(Start_Marker, 'can.fuel.level')) < -2) {
              Start_Marker['FuelGain'] = ((getObjectProperty(Start_Marker, 'can.fuel.level')) - (getObjectProperty(End_Marker, 'can.fuel.level')));
              addItemToList(Refuel_List, Start_Marker);
              addItemToList(Refuel_List, End_Marker);
            }
          }
        }
      }
    }
    try {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record'))['Refuel List'] = Refuel_List;

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
      }

    }
    try {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record'))['Available Capacity'] = (Math.ceil(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tank_Capacity')) / 100) * (100 - (getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Refuel List'))[1]), 'can.fuel.level'))) * 100) / 100);

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
      }

    }
    try {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record'))['Litres Filled'] = (Math.ceil((getObjectProperty(___arguments.selectedRecord, 'Litres')) * 100) / 100);

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
      }

    }
    try {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record'))['Detected Fill'] = (Math.ceil(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tank_Capacity')) / 100) * ((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Refuel List'))[0]), 'can.fuel.level')) - (getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Refuel List'))[1]), 'can.fuel.level'))) * 100) / 100);

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
      }

    }
    try {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record'))['Gain/Loss'] = (Math.ceil((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tank_Capacity')) / 100) * ((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Refuel List'))[0]), 'can.fuel.level')) - (getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Refuel List'))[1]), 'can.fuel.level'))) - (getObjectProperty(___arguments.selectedRecord, 'Litres'))) * -1 * 100) / 100);

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
      }

    }
    await new Promise(r => setTimeout(r, 1000 || 0));
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('d28223acefc220231951e14c341c8341', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    var Tractor;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND TObjectID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),'\' AND ((Date_Actual IS NULL AND created >= \'',(await (async function(Start) {
	function getStartOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const startOfMonth = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
	  startOfMonth.setHours(0, 0, 0, 0); // Set to the start of the day
	
	  return startOfMonth.getTime();
	}
	
	// Directly execute and return the result
	return getStartOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created')))),'\' AND created <= \'',(await (async function(Start) {
	function getEndOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
	  endDate.setHours(23, 59, 59, 999); // Set to the end of the day
	
	  return endDate.getTime();
	}
	
	// Directly execute and return the result
	return getEndOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created')))),'\') OR (Date_Actual IS NOT NULL AND Date_Actual >= \'',(await (async function(Start) {
	function getStartOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const startOfMonth = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
	  startOfMonth.setHours(0, 0, 0, 0); // Set to the start of the day
	
	  return startOfMonth.getTime();
	}
	
	// Directly execute and return the result
	return getStartOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created')))),'\' AND Date_Actual <= \'',(await (async function(Start) {
	function getEndOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
	  endDate.setHours(23, 59, 59, 999); // Set to the end of the day
	
	  return endDate.getTime();
	}
	
	// Directly execute and return the result
	return getEndOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created')))),'\'))'].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Assets/components/b2f6db22db758c1a86475775605eb8c3/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    var Time_Start, Time_Now;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Selected Mileage Completion Record'] = ___arguments.selectedRecord;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('cbdbee8ccbdf727cef2540178c78f753', undefined);
  await new Promise(r => setTimeout(r, 1000 || 0));
  Time_Now = (new Date());
  Time_Start = (new Date((new Date()).getTime() - (900 * 1000)));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']('5806738', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Date_Loaded')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Date_Delivered'))));
  await new Promise(r => setTimeout(r, 100 || 0));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ca66e348fff7cc79482ce628df861df')), [], 10, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), null, null, null, null, ___arguments.context.appData);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ca66e348fff7cc79482ce628df861df')), [], 10, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), null, null, null, null, ___arguments.context.appData);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND TID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),'\' AND created >= ',(await (async function(Start) {
	function getStartOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const startOfMonth = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
	  startOfMonth.setHours(0, 0, 0, 0); // Set to the start of the day
	
	  return startOfMonth.getTime();
	}
	
	// Directly execute and return the result
	return getStartOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created')))),' AND created <= ',(await (async function(Start) {
	function getEndOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
	  endDate.setHours(23, 59, 59, 999); // Set to the end of the day
	
	  return endDate.getTime();
	}
	
	// Directly execute and return the result
	return getEndOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created'))))].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Assets/components/458bec9d41eb73f7fb15ea67239da244/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('e25fdd0e0d39a66b1713639f4af1fb5d');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('e25fdd0e0d39a66b1713639f4af1fb5d');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('cbdbee8ccbdf727cef2540178c78f753', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/d8e188b835a2c98344dd1d74cfd4dd8a/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('b7feb8b70eeb5a55a81136599685ff3f');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('b7feb8b70eeb5a55a81136599685ff3f');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('e97e3d4bdd01f07b4327e42bc27e1fb8', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/cbea0f239d6860ff11d95851956f5343/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
      ___arguments.context.pageData['HR - Selected Record'] = ___arguments.selectedRecord;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('46f43621a885b19fc42c9a22cc79360b', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['CID = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Assets/components/a3ad3a9d9b9ed452197e729562af0fb6/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('6afe640fafbe4981859d1be2c26f749d');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('6afe640fafbe4981859d1be2c26f749d');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('46f43621a885b19fc42c9a22cc79360b', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/d084ff8472c4bef171a3800b60d8ed7f/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Company_ID'))))) {
  } else {
    Value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Company_ID'));
  }

  return Value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Assets/components/0687cdd8ce752b67f6ef687564ece302/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Employee_Details_Nickname'))))) {
  } else {
    Value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Employee_Details_Nickname'));
  }

  return Value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Assets/components/64935b970e66931dd21b49020b2f0d7b/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Employee_Details_Forenames'))))) {
  } else {
    Value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Employee_Details_Forenames'));
  }

  return Value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Assets/components/e00428bd7c4f7c4e6f3d282d4df95d0d/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Employee_Details_Surname'))))) {
  } else {
    Value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Employee_Details_Surname'));
  }

  return Value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Assets/components/f71571b4a1e7a64245c95ec5f9d9f72e/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Employee_Details_ID_Number'))))) {
  } else {
    Value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Employee_Details_ID_Number'));
  }

  return Value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Assets/components/edf36e685d891271cddffe64bb47d2b5/bundle.js', [], () => ({
  /* content */
  /* handler:imageUrlLogic */
  async ['imageUrlLogic'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Avatar'))))) {
  } else {
    URL2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Avatar'));
  }

  return URL2

  },
  /* handler:imageUrlLogic */
  /* content */
}))

define('./pages/Assets/components/84d24684f81da5a9f85e07e29aff6014/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var PDF_Data, File_Name, Wage_Data, Employee_Data, URL2, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function do_something() {
  Employee_Data = (getObjectProperty(___arguments.context.pageData, 'HR - Selected Record'));
  Wage_Data = 0;
  File_Name = ['Payslip','(',(getObjectProperty(Employee_Data, 'Employee_Details_ID_Number')),')'].join('');
  URL2 = ['https://backendlessappcontent.com/FB172318-89F2-E225-FF10-9AC9657A9000/15CB006B-69A7-477E-9D2F-3B75BC06A165/files/pdf/',['Payslip','%28',(getObjectProperty(Employee_Data, 'Employee_Details_ID_Number')),'%29'].join(''),'.pdf'].join('');
  console.log(URL2);
  PDF_Data = ({ [`DATE`]: undefined,[`START`]: undefined,[`QR`]: URL2,[`CLOGO`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Logo')),[`CNAME`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Registered_Name')),[`A1`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Physical_Address')),[`A2`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Postal_Code')),[`Phone`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Phone_1')),[`Email`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Email_Admin')),[`AVATAR`]: (getObjectProperty(Employee_Data, 'Avatar')),[`EFORE`]: (getObjectProperty(Employee_Data, 'Employee_Details_Forenames')),[`ESUR`]: (getObjectProperty(Employee_Data, 'Employee_Details_Surname')),[`NICKNAME`]: (getObjectProperty(Employee_Data, 'Employee_Details_Nickname')),[`CID`]: (getObjectProperty(Employee_Data, 'Company_ID')),[`ID`]: (getObjectProperty(Employee_Data, 'Employee_Details_ID_Number')),[`TAX`]: (getObjectProperty(Employee_Data, 'Employee_Details_Tax_Reference_Number')),[`CUIF`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_UIF_Number')),[`CPAYE`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_PAYE_Number')),[`ED1`]: undefined,[`ED2`]: (getObjectProperty(Wage_Data, 'Wages_Rate_Basic')),[`ED3`]: undefined,[`ED4`]: undefined,[`ED5`]: undefined,[`ED6`]: undefined,[`ED7`]: undefined,[`ED8`]: undefined,[`ED9`]: undefined,[`ED10`]: undefined,[`EU1`]: undefined,[`EU2`]: undefined,[`EU3`]: undefined,[`EU4`]: undefined,[`EU5`]: undefined,[`EU6`]: undefined,[`EU7`]: undefined,[`EU8`]: undefined,[`EU9`]: undefined,[`EU10`]: undefined,[`EV1`]: (getObjectProperty(Wage_Data, 'Wages_Rate_Basic')),[`EV2`]: undefined,[`EV3`]: undefined,[`EV4`]: undefined,[`EV5`]: undefined,[`EV6`]: undefined,[`EV7`]: undefined,[`EV8`]: undefined,[`EV9`]: undefined,[`EV10`]: undefined,[`DD1`]: undefined,[`DD2`]: undefined,[`DD3`]: undefined,[`DD4`]: undefined,[`DD5`]: undefined,[`DD6`]: undefined,[`DD7`]: undefined,[`DD8`]: undefined,[`DD9`]: undefined,[`DD10`]: undefined,[`DU1`]: undefined,[`DU2`]: undefined,[`DU3`]: undefined,[`DU4`]: undefined,[`DU5`]: undefined,[`DU6`]: undefined,[`DU7`]: undefined,[`DU8`]: undefined,[`DU9`]: undefined,[`DU10`]: undefined,[`DV1`]: undefined,[`DV2`]: undefined,[`DV3`]: undefined,[`DV4`]: undefined,[`DV5`]: undefined,[`DV6`]: undefined,[`DV7`]: undefined,[`DV8`]: undefined,[`DV9`]: undefined,[`DV10`]: undefined,[`ETOTAL`]: undefined,[`DTOTAL`]: undefined,[`NETT`]: undefined,[`TEARN`]: undefined,[`CCONTR`]: undefined,[`ADDDATA`]: undefined });
  ___arguments.context.pageData['PDF Test'] = (await Backendless.Request.post(`${Backendless.appPath}/services/PDFGeneratorAPI/${'1169565'}/data-output/${File_Name}`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'data': PDF_Data }));
  console.log(getObjectProperty(___arguments.context.pageData, 'PDF Test'));
}


  console.log((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


   return ((getObjectProperty(item, 'Company_ID')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Company_ID')));
  }))[0]);
  console.log(getObjectProperty(___arguments.context.pageData, 'HR - Selected Record'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/acbc7c6c62b1f72ac32a1ad7769254f1/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('4eaa957f1c4dbcc2a80d848f0b91fad3');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('4eaa957f1c4dbcc2a80d848f0b91fad3');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('8fa2ddba7c2d5c5d7eab08d2ce864b56', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/ebc56b675a5fae2b157eff618039c017/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('2333c2063288a3a30f6ff848f2926a7e');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('2333c2063288a3a30f6ff848f2926a7e');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('e9b3c46d01dbdf48702a683c74c9707c', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/7dcd6cc1891a095f2746cb9f3f2e007f/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('b2faca129bf92493b8adc3f3cc5fd6e3');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('b2faca129bf92493b8adc3f3cc5fd6e3');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('613cf84205d517eee86a85f97ef4da98', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/f74bc443a164aeda4ee5446b34788514/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('613cf84205d517eee86a85f97ef4da98', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/fd776ed34adbbf0c8d8db64ea14c7728/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('1c0dfc47bd9b8ccc6f8df1239bfc6079', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/0a2ffb5fbef908515ae4488f00cf95e4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Current Load'));
  await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('2df6d67298abaf23f0d613c201e151d7', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/7d9b8b418c4b1e96c2f85ecc4d8cb0e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('856f6a28c99b0a8403476af7237cad34', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/c093dd6e1362177865bd6dc559b4ba06/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Current Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Current Load')).length)) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/fea3580b3157223894bc5cd3fc564d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Current Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Current Load')).length)) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/8675b4a639b9a865201ecc890a37fa99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Current Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Current Load')).length)) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/800f21e9497811fd83477d7af86698a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Next Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Next Load')).length)) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/414466022103b71ef09b89e36b7f84cc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Next Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Next Load')).length)) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/9bab833834c511880794bf48e74ab4d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Next Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Next Load')).length)) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/8a61925ed0adb1c64754a826b4781708/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var List, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Next Load'))))) {
      List = [];
    } else {
      List = (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Next Load')).map(async item => {; return ({ [`Customer`]: (getObjectProperty(item, 'Customer Name')),[`Tonnage`]: (getObjectProperty(item, 'Tonnage_Planned')),[`Product`]: (getObjectProperty(item, 'Load_Product')) });})));
    }

  } catch (error) {

  }

  return List

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Assets/components/de0aa898f57a3836148f4d2ba58cc5bd/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var List, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Next Load'))))) {
      List = [];
    } else {
      List = (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Next Load')).map(async item => {; return ({ [`Customer`]: (getObjectProperty(item, 'Customer Name')),[`Tonnage`]: (getObjectProperty(item, 'Tonnage_Planned')),[`Product`]: (getObjectProperty(item, 'Load_Product')) });})));
    }

  } catch (error) {

  }

  return List

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Assets/components/e19b47f1e5d678078fcb3e4198af831e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Next Load'))))) {
      List = [];
    } else {
      List = (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Next Load')).map(async item => {; return ({ [`Customer`]: (getObjectProperty(item, 'Customer Name')),[`Tonnage`]: (getObjectProperty(item, 'Tonnage_Planned')),[`Product`]: (getObjectProperty(item, 'Load_Product')) });})));
    }

  } catch (error) {

  }

  return List

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Assets/components/24347ceab88984edf634962d45bbdf79/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Current Load'))))) {
      List = [];
    } else {
      List = (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Current Load')).map(async item => {; return ({ [`Customer`]: (getObjectProperty(item, 'Customer Name')),[`Tonnage`]: (getObjectProperty(item, 'Tonnage_Loaded')),[`Product`]: (getObjectProperty(item, 'Load_Product')) });})));
    }

  } catch (error) {

  }

  return List

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Assets/components/f7936d9e62d98f4d743ddf36a01a9ae9/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Current Load'))))) {
      List = [];
    } else {
      List = (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Current Load')).map(async item => {; return ({ [`Customer`]: (getObjectProperty(item, 'Customer Name')),[`Tonnage`]: (getObjectProperty(item, 'Tonnage_Loaded')),[`Product`]: (getObjectProperty(item, 'Load_Product')) });})));
    }

  } catch (error) {

  }

  return List

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Assets/components/41eb49d2373ce759b95563e2d1eee702/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Current Load'))))) {
      List = [];
    } else {
      List = (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Current Load')).map(async item => {; return ({ [`Customer`]: (getObjectProperty(item, 'Customer Name')),[`Tonnage`]: (getObjectProperty(item, 'Tonnage_Loaded')),[`Product`]: (getObjectProperty(item, 'Load_Product')) });})));
    }

  } catch (error) {

  }

  return List

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Assets/components/6daecd654291f16dd3dae579e9036f61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Time_Start, Time_Now;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7c844bedb74f9916e6928cd1a10ace5f');
  Time_Now = (new Date());
  Time_Start = (new Date((new Date()).getTime() - (900 * 1000)));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Date_Loaded')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Date_Delivered'))));
  await new Promise(r => setTimeout(r, 100 || 0));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/5dab0315c8cd3eef16a2cf3fa5c994bc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Time_Start, Time_Now;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7c844bedb74f9916e6928cd1a10ace5f');
  Time_Now = (new Date());
  Time_Start = (new Date((new Date()).getTime() - (900 * 1000)));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']('5806738', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Date_Loaded')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Date_Delivered'))));
  await new Promise(r => setTimeout(r, 100 || 0));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/b533fdbd6ef4edf2d3ac18d2ed96c248/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('2368b1fbce92bc7a219b211242bbc07b');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('2368b1fbce92bc7a219b211242bbc07b');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/Assets/components/d8f71a89a574ff8e9b6daeea1fa7144c/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('4e992e95c036c39ce2a88f72a44be41c');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('4e992e95c036c39ce2a88f72a44be41c');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/Assets/components/191764f4afe551f3037fd6eee5d7e769/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/dc2f00cc207f3d2b3c1ae74e24c666d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('d28223acefc220231951e14c341c8341', undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('03d7b70496a37067125378af1b254cc1');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('03d7b70496a37067125378af1b254cc1');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/Assets/components/25457f03e5a836b353536ee68efa04ff/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('4aceddf6f5435c5357a7ffbde732c5c4');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('4aceddf6f5435c5357a7ffbde732c5c4');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7c844bedb74f9916e6928cd1a10ace5f');
  await new Promise(r => setTimeout(r, 100 || 0));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Admin')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/efc66485baa4425eecafebae62cd8477/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Available Capacity'))))) {
    Content = null;
  } else {
    Content = String(Math.round((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Available Capacity')) * 1000) / 1000) + String(' L');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/2ad381f2c57e822ec3117f5737a505c1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Litres Filled'))))) {
    Content = null;
  } else {
    Content = String(Math.round((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Litres Filled')) * 1000) / 1000) + String(' L');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/6defb4fb7f7342050b9294944e31818a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Detected Fill'))))) {
    Content = null;
  } else {
    Content = String(Math.round((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Detected Fill')) * 1000) / 1000) + String(' L');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/bc4c0dc7304bef853b4bc54630fd240c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Gain/Loss'))))) {
    Content = null;
  } else {
    Content = String(Math.round((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Gain/Loss')) * 1000) / 1000) + String(' L');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/bef8d93676da228c63b90e9e526e6f12/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = ['(',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Fuel_Consumption')),'km/l)'].join('');

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/db73deedbf8e8e27224c5ab3e79298bc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = ['(',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')),'km',')'].join('');

  } catch (error) {

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/f215fa5c40ce4803bf3d87991a2f6e0c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = ['(',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Tonnage_Target')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Units')),')'].join('');

  } catch (error) {

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/977d5d495aace08d26653e281613cb19/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Mileage_Target')) + String(' km');

  } catch (error) {

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/59698e373f5d6acd681ee9d552e7a0f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((new Date()))) == (await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created'))))) {
    try {
      Input = String(Math.ceil(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Mileage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * ((new Date((new Date())).getDate()) - 1))) + String(' km');

    } catch (error) {

    }
  } else {
    try {
      Input = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Mileage_Target')) + String(' km');

    } catch (error) {

    }
  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/acbe2d9a29b978789c5a727854b46458/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((new Date()))) == (await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created'))))) {
    try {
      Input = String(Math.round((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Distance_Travelled')) - ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Mileage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * ((new Date((new Date())).getDate()) - 1))) + String(' km');

    } catch (error) {

    }
  } else {
    try {
      Input = String((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Distance_Travelled')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Mileage_Target'))) + String(' km');

    } catch (error) {

    }
  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/1b947fd2e431cf6f0f3629ca0c92e5fc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Distance_Travelled'))))) + String(' km');

  } catch (error) {

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/2d0793b7bb9b4acf15982df88cd2970a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = [Math.round(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Tonnage_Target')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Units'))].join('');

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/2fbac1abf43fc0a9ba0a313b1695b8ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = [Math.round(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Tonnage_Projected_Ideal_For Today')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Units'))].join('');

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/ba1dcead5be6c1c8e565879862ff9236/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = [Math.round(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Tonnage_Total')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Units'))].join('');

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/23baec169d3da8a1a76b8ce256a9f82e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = [Math.round((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Tonnage_Total')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Tonnage_Projected_Ideal_For Today'))),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Units'))].join('');

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/3e8309b241d185655467e7a8c82d5ac9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('a3f7a8b832570fb7c4515b28d5477cde', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/0ee1a9e62cab568976e6b4b1f4e29ab7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('a3f7a8b832570fb7c4515b28d5477cde', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/3a3288d2a60314b69fb24cfc00851318/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'))))) {
    } else {
      Content = String((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Mileage_Target'));}))).reduce(function(x, y) {return x + y;})) + String(' km');
    }

  } catch (error) {
    console.log(error);

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/c7c454c796c37b2eb23ab6162576b7d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'))))) {
    } else {
      Content = String((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Distance_Travelled'));}))).reduce(function(x, y) {return x + y;})) + String(' km');
    }

  } catch (error) {
    console.log(error);

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/79cf9cf6497a5722c30f9cabb0bee256/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Input, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'))))) {
    } else {
      Input = ['(',Math.round((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Distance_Travelled'));}))).reduce(function(x, y) {return x + y;}) - ((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Mileage_Target'));}))).reduce(function(x, y) {return x + y;}) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * ((new Date((new Date())).getDate()) - 1)),' km',')'].join('');
    }

  } catch (error) {

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/0876fa57db8e7bc82cb2a1acc09df495/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('f56e986ba15e5645842622c9ff3c8f36', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/ac2867592926e5e163eccd3c3b0c2614/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Input;


  await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('f56e986ba15e5645842622c9ff3c8f36', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/7ef6e00671c59fdc167ba0d20b36e65a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'))))) {
    } else {
      Content = String((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tonnage_Total'));}))).reduce(function(x, y) {return x + y;}));
    }

  } catch (error) {
    console.log(error);

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/e01f5068d6556f7e88eefc9ff3bd60ef/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'))))) {
    } else {
      Content = String((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tonnage_Target'));}))).reduce(function(x, y) {return x + y;}));
    }

  } catch (error) {
    console.log(error);

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/768879b7ae4f6592e9db75e30ee6e09f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Input, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'))))) {
    } else {
      Input = ['(',Math.round((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tonnage_Total'));}))).reduce(function(x, y) {return x + y;}) - ((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tonnage_Target'));}))).reduce(function(x, y) {return x + y;}) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * ((new Date((new Date())).getDate()) - 1)),')'].join('');
    }

  } catch (error) {

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/a4e2305a2a63db8be04c9722d68c4ade/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('9c34a73aec23ca58a2e22cd9409d62ad');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('9c34a73aec23ca58a2e22cd9409d62ad');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f3e9c22366f902aef4819ddad8b9b81a', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/b16784365653f91541e2e8185fab58c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    delete ___arguments.context.pageData['Admin Capture Load'];

  } catch (error) {

  }
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Quick Load'];

  } catch (error) {

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('318b7c7d84ce11ee39e9730176875287', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30e6591fbe6ca3bad316b55f32edf195', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64c99a9b58ffea63cdef471e3503be85', false);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('a33ad288329dce04e064dc9f21064b9c');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('a33ad288329dce04e064dc9f21064b9c');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/Assets/components/d51a38aa2a4acd1c7a3e9cffb8b7da6e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64c99a9b58ffea63cdef471e3503be85', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('318b7c7d84ce11ee39e9730176875287', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30e6591fbe6ca3bad316b55f32edf195', false);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('8a1d2416b60c7a4812c39a837f533a83');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('8a1d2416b60c7a4812c39a837f533a83');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/Assets/components/617d36f9b5c460c6206667e6e125aaa1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Created_Load, Deliver_Time, error, item, Load_Counter_To_Text, Load_ID_Tag, Load_Time, Load_Value, Load_Variable, Loaded_Seconds, Loads_Counter, Mileage, Mileage__Delivered_, Mileage__Load_, Products, Rate_Per_Km, Rate_Per_Unit, Result, Return_Seconds, Speed_Ratio, Temp_Tractor, Trailers, Transaction, Trip_Seconds, Units;

/**
 * Describe this function...
 */
async function Clear_Form() {
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('f2d16fe6a3be499586bb7fdc4543df79', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('b7fe71f8c531da3db4857a3ee4949857', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('63f67df81e19e45952c1293ae53fdacd', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('553b5e2755e9ca0c28314bbb81bda93c', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('4e6d0de6d6e12919048c9901804c1cd9', null);

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c51eb91741c7599e2dfd5ca19eeb4a69'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('870a5425bf92b9e2a7ba615516d1d9d2'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('987c655ea23a663398670f995087ec02'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  await new Promise(r => setTimeout(r, 200 || 0));
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('927a186b22a2cd4700a92c6daeff9ca7', false);

  } catch (error) {
    console.log(error);

  }
  await new Promise(r => setTimeout(r, 200 || 0));
  try {
    delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Products'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Delivery Date'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Load Date'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Route'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Dead Leg'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Loaded Leg'];

  } catch (error) {
    console.log(error);

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('927a186b22a2cd4700a92c6daeff9ca7', true);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Admin_Capture_Function() {
  Load_Value = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value')))) ? (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder')) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value'));
  Rate_Per_Km = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value'));
  Mileage__Load_ = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('870a5425bf92b9e2a7ba615516d1d9d2')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('870a5425bf92b9e2a7ba615516d1d9d2')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('870a5425bf92b9e2a7ba615516d1d9d2')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('870a5425bf92b9e2a7ba615516d1d9d2')), 'value'));
  Mileage__Delivered_ = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('987c655ea23a663398670f995087ec02')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('987c655ea23a663398670f995087ec02')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('987c655ea23a663398670f995087ec02')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('987c655ea23a663398670f995087ec02')), 'value'));
  Rate_Per_Unit = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value'));
  Mileage = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value'));
  Load_Variable = ({ [`Tonnage_Delivered`]: (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;}),[`Tonnage_Loaded`]: (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;}),[`Mileage_Load_Point`]: Mileage__Load_,[`Mileage_Delivery_Point`]: Mileage__Delivered_,[`Mileage_Last_Delivery_Point`]: undefined,[`Delivery (Client)`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]), 'Name')),[`Customer Name`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value')));
  }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value')));
  }))[0]), 'Name')),[`Date_Planned_Delivery`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Delivery Date')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Delivery Date')),[`Date_Delivered`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Delivery Date')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Delivery Date')),[`Date_Planned_Loading`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')),[`Date_Loaded`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')),[`Distance_Planned_LDP_To_DP`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Distance')) / 1000,[`Distance_Planned_LDP_To_LP`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Dead Leg')) / 1000,[`Distance_Planned_LP_To_DP`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Loaded Leg')) / 1000,[`Financial_Billing_Type`]: 'Per Km',[`Financial_Target_Ideal_Rate_Per_Km`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km')),[`Financial_Target_Ideal_Rate_Per_Tonne`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Tonne')),[`ID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c51eb91741c7599e2dfd5ca19eeb4a69')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c51eb91741c7599e2dfd5ca19eeb4a69')), 'value')),[`Load Planner Name`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name')),[`Load Point (Delivery Name)`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]), 'Contact_Name')),[`Load Point (Load Name)`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
  }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
  }))[0]), 'Contact_Name')),[`CID`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value')),[`LLPID`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
  }))[0]), 'objectId')),[`LDPID`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]), 'objectId')),[`LLDPID`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6')), 'value')));
  }))[0]), 'objectId')),[`Load_Broker`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')),[`Load_Notes`]: undefined,[`Load_Product`]: Products,[`Load_Type`]: 'Standard',[`Rig_Cost_Per_Hour`]: undefined,[`Rig_CPK`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Rig_CPK')),[`Rig_Payload`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')),[`Status`]: 'Delivered',[`Tonnage_Planned`]: (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;}),[`Planned Rate Per Unit`]: Rate_Per_Unit,[`Planned Mileage`]: Mileage,[`Planned_Load_Value`]: Load_Value,[`Planned Rate Per Km`]: Rate_Per_Km,[`ownerId`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')));
  }))[0]), 'ownerId')),[`objectId`]: (generateUUID().long()),[`TID`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) });
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Created_Load = (_uow.create('Loads', Load_Variable));
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')));
    }))[0])))) {
    } else {
      _uow.setRelation('Loads', Created_Load, 'Load_Planner', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')));
      }))[0]), 'objectId'))]);
    }
    _uow.setRelation('Loads', Created_Load, 'Location_Delivery_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
    }))[0]), 'objectId'))]);
    _uow.setRelation('Loads', Created_Load, 'Location_Last_Delivery_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6')), 'value')));
    }))[0]), 'objectId'))]);
    _uow.setRelation('Loads', Created_Load, 'Location_Load_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
    }))[0]), 'objectId'))]);
    _uow.setRelation('Loads', Created_Load, 'Rig_Tractor', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'))]);
    Trailers = (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'objectId'))], async (item) => {


     return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](item)));
    }));
    _uow.setRelation('Loads', Created_Load, 'Rig_Trailers', Trailers);
    _uow.setRelation('Loads', Created_Load, 'Customer', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value'))]);
    _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), 'Loads', [Created_Load]);

  })();

  Result = (await Transaction.execute());
  addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')));
  }))[0]), 'Loads')), (getObjectProperty((getObjectProperty((getObjectProperty(Result, 'results')), 'createLoads1')), 'result')));
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? [] : (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'Status')) != 'Delivered');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  }))));
  delete ___arguments.context.pageData['Admin Capture Load'];
}

/**
 * Describe this function...
 */
async function Load_Planner() {
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route'))))) {
    Trip_Seconds = 0;
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('a13a790952de1b1c1d7d2cdc9dce8d79'))))) {
      Load_Time = 0;
    } else {
      Load_Time = (Number(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('a13a790952de1b1c1d7d2cdc9dce8d79'))));
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('afc8038b258ee9fd9b4741e478d21e4d'))))) {
      Deliver_Time = 0;
    } else {
      Deliver_Time = (Number(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('afc8038b258ee9fd9b4741e478d21e4d'))));
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed'))))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration'))))) {
        Trip_Seconds = 0;
      } else {
        Trip_Seconds = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) * 1.5;
        Loaded_Seconds = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'Loaded Leg')), 'Duration')) * 1.5;
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'Return Leg'))))) {
        } else {
          Return_Seconds = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'Return Leg')), 'Duration')) * 1.5;
        }
      }
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration'))))) {
        Trip_Seconds = 0;
      } else {
        Speed_Ratio = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120;
        Trip_Seconds = ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) * 1.5) / Speed_Ratio;
        Loaded_Seconds = ((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'Loaded Leg')), 'Duration')) * 1.5) / Speed_Ratio;
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'Return Leg'))))) {
        } else {
          Return_Seconds = ((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'Return Leg')), 'Duration')) * 1.5) / Speed_Ratio;
        }
      }
    }
  }
  Load_Value = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value')))) ? (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder')) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value'));
  Rate_Per_Km = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value'));
  Rate_Per_Unit = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value'));
  Mileage = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value'));
  Load_Variable = ({ [`Time_Delivering`]: Deliver_Time,[`Time_Loading`]: Load_Time,[`Date_Planned_Return`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Return')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de8e8f4bbb67b6b91e39d5ee272b6c7a')), 'value')) + (Loaded_Seconds + Return_Seconds + Load_Time + Deliver_Time) * 1000,[`Distance_Planned_DP_To_RP`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'Return Leg')))) ? 0 : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'Return Leg')), 'Distance')) / 1000,[`LRPID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Return')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Return')), 'objectId')),[`RP_NAME`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Return')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Return')), 'Name')),[`Route(Json)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')),[`BilledRoute(Json)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route')),[`Geoline(Billed)`]: (new Backendless.Data.LineString((await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route')), 'Polyline')).map(async item => {; return (new Backendless.Data.Point().setX((getObjectProperty(item, 'lng'))).setY((getObjectProperty(item, 'lat'))));}))))),[`Geoline(Route)`]: (new Backendless.Data.LineString((await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Polyline')).map(async item => {; return (new Backendless.Data.Point().setX((getObjectProperty(item, 'lng'))).setY((getObjectProperty(item, 'lat'))));}))))),[`Mileage(Billed)`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route')), 'Distance')) / 1000,[`LDP_NAME`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6')), 'value')));
  }))[0]), 'Name')),[`LP_NAME`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
  }))[0]), 'Name')),[`DP_NAME`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]), 'Name')),[`Load_Product_JSON`]: ({ [`Planned`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')) }),[`Delivery (Client)`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]), 'Name')),[`Customer Name`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value')));
  }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value')));
  }))[0]), 'Name')),[`Date_Planned_Delivery`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de8e8f4bbb67b6b91e39d5ee272b6c7a')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de8e8f4bbb67b6b91e39d5ee272b6c7a')), 'value')) + (Load_Time + Loaded_Seconds) * 1000,[`Date_Planned_Loading`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de8e8f4bbb67b6b91e39d5ee272b6c7a')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de8e8f4bbb67b6b91e39d5ee272b6c7a')), 'value')),[`Distance_Planned_LDP_To_DP`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Distance')) / 1000,[`Distance_Planned_LDP_To_LP`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Dead Leg')) / 1000,[`Distance_Planned_LP_To_DP`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Loaded Leg')) / 1000,[`Financial_Billing_Type`]: 'Per Km',[`Financial_Target_Ideal_Rate_Per_Km`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km')),[`Financial_Target_Ideal_Rate_Per_Tonne`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Tonne')),[`ID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c51eb91741c7599e2dfd5ca19eeb4a69')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c51eb91741c7599e2dfd5ca19eeb4a69')), 'value')),[`Load Planner Name`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name')),[`Load Point (Delivery Name)`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]), 'Contact_Name')),[`Load Point (Load Name)`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
  }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
  }))[0]), 'Contact_Name')),[`CID`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value')),[`LLPID`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
  }))[0]), 'objectId')),[`LDPID`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]), 'objectId')),[`LLDPID`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6')), 'value')));
  }))[0]), 'objectId')),[`Load_Broker`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')),[`Load_Notes`]: undefined,[`Load_Product`]: Products,[`Load_Type`]: 'Standard',[`Rig_Cost_Per_Hour`]: undefined,[`Rig_CPK`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Rig_CPK')),[`Rig_Payload`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')),[`Status`]: 'Planned',[`Tonnage_Planned`]: (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;}),[`Planned Rate Per Unit`]: Rate_Per_Unit,[`Planned Mileage`]: Mileage,[`Planned_Load_Value`]: Load_Value,[`Planned Rate Per Km`]: Rate_Per_Km,[`ownerId`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')));
  }))[0]), 'ownerId')),[`objectId`]: (generateUUID().long()),[`TID`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) });
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Created_Load = (_uow.create('Loads', Load_Variable));
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')));
    }))[0])))) {
    } else {
      _uow.setRelation('Loads', Created_Load, 'Load_Planner', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')));
      }))[0]), 'objectId'))]);
    }
    _uow.setRelation('Loads', Created_Load, 'Location_Delivery_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
    }))[0]), 'objectId'))]);
    _uow.setRelation('Loads', Created_Load, 'Location_Last_Delivery_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6')), 'value')));
    }))[0]), 'objectId'))]);
    _uow.setRelation('Loads', Created_Load, 'Location_Load_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
    }))[0]), 'objectId'))]);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'Return Leg'))))) {
    } else {
      _uow.setRelation('Loads', Created_Load, 'Location_Return_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aa02e8765bcb0dfd35ad2daad32f98a9')), 'value')));
      }))[0]), 'objectId'))]);
    }
    _uow.setRelation('Loads', Created_Load, 'Rig_Tractor', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'))]);
    Trailers = (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'objectId'))], async (item) => {


     return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](item)));
    }));
    _uow.setRelation('Loads', Created_Load, 'Rig_Trailers', Trailers);
    _uow.setRelation('Loads', Created_Load, 'Customer', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value'))]);
    _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), 'Loads', [Created_Load]);

  })();

  Result = (await Transaction.execute());
  addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')));
  }))[0]), 'Loads')), (getObjectProperty((getObjectProperty((getObjectProperty(Result, 'results')), 'createLoads1')), 'result')));
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? [] : (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'Status')) != 'Delivered');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  }))));
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('617d36f9b5c460c6206667e6e125aaa1'))['disabled'] = true;
  Products = (await BackendlessUI.Functions.Custom['fn_f4df84546016cedc7395d748e8d7078c']((JSON.stringify((await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return ([(getObjectProperty(item, 'Mass')) / (getObjectProperty(item, 'Unit mass')),' ',' X ',' ',(getObjectProperty((getObjectProperty(item, 'Product')), 'Product')),'/n'].join(''));})))))));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Admin Capture Load'))))) {
    await Load_Planner();
  } else {
    await Admin_Capture_Function();
  }
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Clear_Form();
  Loads_Counter = (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Load Ref Counter')) + 1;
  Load_Counter_To_Text = getValueLength(String(Loads_Counter)) == 1 ? String('000000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 2 ? String('00000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 3 ? String('0000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 4 ? String('000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 5 ? String('00') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 6 ? String('0') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 7 ? String(Loads_Counter) : 'Hidden Easter Egg'))))));
  await new Promise(r => setTimeout(r, 1000 || 0));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads'))))) {
    Load_ID_Tag = [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Registered_Name')).slice(0, 3),' L ',Load_Counter_To_Text].join('');
  } else {
    Load_ID_Tag = [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' ',Load_Counter_To_Text].join('');
  }
  await new Promise(r => setTimeout(r, 1000 || 0));
  ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Load Ref'] = Load_ID_Tag;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('617d36f9b5c460c6206667e6e125aaa1'))['disabled'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('927a186b22a2cd4700a92c6daeff9ca7', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('927a186b22a2cd4700a92c6daeff9ca7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('617d36f9b5c460c6206667e6e125aaa1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4ad1276182a224733317d57e58ceb38', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/6bcdc7fa9a4f7f6e44535a7c13afbcd4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'));
  console.log(___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/4f21871ae8df6043181f3985d821f9e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/a0914ba91547234f9717b59ffc85bb97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Type'))))) {
        Content = '';
      } else {
        Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Type'));
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/14da434b89292c1e31e90bcc413b58b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload'))))) {
        Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload'));
      } else {
        Content = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Units'))].join('');
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/7d251fd885cb18bac8cfdf5aad5a408f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Nickname'))))) {
        Content = '';
      } else {
        Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Nickname'));
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/d8367fe4547cdbbee9b5a5619a367ad7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Phone'))))) {
        Content = '';
      } else {
        Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Phone'));
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/79649812af4e5728727f2de97fa6d475/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Company'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Company')), 'Name'))))) {
        Content = '';
      } else {
        Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Company')), 'Name'));
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/d066840de59da8347c661b2ed6cf6001/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Company'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Company')), 'Contact_Phone'))))) {
        Content = '';
      } else {
        Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Company')), 'Contact_Phone'));
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/d87cd6ca309b23bbb6010ba380cbfd73/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Tonne'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Tonne'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/0d5d94d4fef9e1d4668ce4498206d0fe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/f3f81bce376325c2eb220b9932d6b5ad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function mathMean(myList) {
  return myList.reduce(function(x, y) {return x + y;}) / myList.length;
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads'))))) {
      Content = '';
    } else {
      Content = Math.round(mathMean(await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')).map(async item => {; return (getObjectProperty(item, 'Financial_Rate_Per_Km'));}))) * 100) / 100;
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/71089fa2e5c583b1798c164546a55d84/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads'))))) {
      Content = '';
    } else {
      Content = Math.round(((await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')).map(async item => {; return (getObjectProperty(item, 'Financial_Load_Value'));}))).reduce(function(x, y) {return x + y;}) / (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')).map(async item => {; return (getObjectProperty(item, 'Distance_Last_Delivery_To_Delivery_Point'));}))).reduce(function(x, y) {return x + y;})) * 100) / 100;
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/427d58a66c462a6cd874e96902a6b4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tonnage_Target'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tonnage_Target'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/b141704c93e18616ed9f00b385cb201b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads'))))) {
      Content = '';
    } else {
      Content = (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')).map(async item => {; return (getObjectProperty(item, 'Tonnage_Delivered'));}))).reduce(function(x, y) {return x + y;});
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/9405fb0c911f58379e0f18c280948515/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function roundDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tonnage_Target'))))) {
        Content = '';
      } else {
        Content = String(roundDecimals((((await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')).map(async item => {; return (getObjectProperty(item, 'Tonnage_Delivered'));}))).reduce(function(x, y) {return x + y;}) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tonnage_Target'))) * 100),2)) + String(' %');
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/ec5131e9e596fd42ab789278b21423f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tonnage_Target_Completion'))))) {
      Content = '';
    } else {
      Content = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tonnage_Target_Completion')) + String(' %');
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/7fa7345db61d2ae7be11b5ec55d790c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Target'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Target'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/c7853c710497869de66b680f43af6b2a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Distance_Travelled'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Distance_Travelled'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/25c4f5b23a97f7838e9c0e42abd2acd1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Target')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Distance_Travelled')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Target')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Distance_Travelled'))))) {
      Content = '';
    } else {
      Content = String(Math.round(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Distance_Travelled')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Target'))) * 100 * 100) / 100) + String(' %');
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/8d5c1973e6efc1ffc3c6564457339207/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Completion'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Completion'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/a714dfe565d68e11dabe9b49688fd578/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Turnover'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Turnover'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/de8e8f4bbb67b6b91e39d5ee272b6c7a/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Last_Location_ID, Last_Load, item, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968b3289c278ef666606e2f7c75a8bfb', false);

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Load Date'] = ___arguments.value;
  Last_Load = (await asyncListFilter((await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Loads')), -1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  })), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')) > (getObjectProperty(item, 'Action Date')));
  })).slice(-1)[0];
  if ((getObjectProperty(Last_Load, 'Status')) == 'Delivered') {
    Last_Location_ID = (getObjectProperty(Last_Load, 'LDPID'));
  } else if ((getObjectProperty(Last_Load, 'Status')) == 'Loaded') {
    Last_Location_ID = (getObjectProperty(Last_Load, 'LLPID'));
  } else if ((getObjectProperty(Last_Load, 'Status')) == 'Planned') {
    Last_Location_ID = (getObjectProperty(Last_Load, 'LLDPID'));
  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6', Last_Location_ID);

  } catch (error) {

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/15114357cfe123ca1b0df1992faaf3db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Last_Location_ID, Last_Load, item;

/**
 * Describe this function...
 */
async function Old_Code() {
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).collapse() })('d61f789cbe5390a5384b6ff24a317035');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73e16762de28a8a6d036f699f32180c4', true);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).expand() })('73e16762de28a8a6d036f699f32180c4');
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968b3289c278ef666606e2f7c75a8bfb', true);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('968b3289c278ef666606e2f7c75a8bfb')));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date'))))) {
    ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Load Date'] = ((getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')).length == 0 ? (await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), 1, async (item) => {


     return ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Date_Planned_Return')))) ? (getObjectProperty(item, 'Date_Planned_Delivery')) : (getObjectProperty(item, 'Date_Planned_Return')));
    })).slice(-1)[0] : ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')).slice(-1)[0]), 'Date_Planned_Delivery')) + 900000);
  }
  Last_Load = (await asyncListFilter((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')).length == 0 ? (await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), 1, async (item) => {


   return (getObjectProperty(item, 'Sequence'));
  })) : ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34'))), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')) > (getObjectProperty(item, 'Sequence')));
  })).slice(-1)[0];
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Last_Load))) {
    Last_Load = (await asyncListFilter((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')).length == 0 ? (await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), 1, async (item) => {


     return (getObjectProperty(item, 'Sequence'));
    })) : ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34'))), async (item) => {


     return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')) < (getObjectProperty(item, 'Sequence')));
    }))[0];
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Last_Load, 'Date_Planned_Return'))))) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')) > (getObjectProperty(Last_Load, 'Date_Planned_Loading'))) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')) > (getObjectProperty(Last_Load, 'Date_Planned_Delivery'))) {
        Last_Location_ID = (getObjectProperty(Last_Load, 'LDPID'));
      } else {
        Last_Location_ID = (getObjectProperty(Last_Load, 'LLPID'));
      }
    } else {
      Last_Location_ID = (getObjectProperty(Last_Load, 'LLDPID'));
    }
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')) > (getObjectProperty(Last_Load, 'Date_Planned_Loading'))) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')) > (getObjectProperty(Last_Load, 'Date_Planned_Delivery'))) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')) > (getObjectProperty(Last_Load, 'Date_Planned_Return'))) {
          Last_Location_ID = (getObjectProperty(Last_Load, 'LRPID'));
        } else {
          Last_Location_ID = (getObjectProperty(Last_Load, 'LDPID'));
        }
      } else {
        Last_Location_ID = (getObjectProperty(Last_Load, 'LLPID'));
      }
    } else {
      Last_Location_ID = (getObjectProperty(Last_Load, 'LLDPID'));
    }
  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6', Last_Location_ID);

  } catch (error) {

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/70d48a227277558475b891578278b33a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Load_ID_Tag, Load_Counter_To_Text, Loads_Counter, item, Result, Transaction, Created_Load, Trailers, Load_Variable, Rate_Per_Km, Load_Value, Mileage, Rate_Per_Unit, Products, Units;

/**
 * Describe this function...
 */
async function Old_Code() {
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).collapse() })('73e16762de28a8a6d036f699f32180c4');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6b646888bea5a3add178e38e5bbea6b8', true);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).expand() })('6b646888bea5a3add178e38e5bbea6b8');
}

/**
 * Describe this function...
 */
async function Clear_Form() {
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('397cc61daa269e6aeaee6ff2d5364dcd', true);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('397cc61daa269e6aeaee6ff2d5364dcd')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/8b0751df4ceaba4475b9dcfd53a1d4d7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Load_ID_Tag, Load_Counter_To_Text, Loads_Counter, item, Result, Transaction, Created_Load, Trailers, Load_Variable, Rate_Per_Km, Load_Value, Mileage, Rate_Per_Unit, Products;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function do_something() {
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).collapse() })('6b646888bea5a3add178e38e5bbea6b8');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9dce7182539aedbd1062b9ddf0cf6ddd', true);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).expand() })('9dce7182539aedbd1062b9ddf0cf6ddd');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('617d36f9b5c460c6206667e6e125aaa1', true);
}

/**
 * Describe this function...
 */
async function Clear_Form() {
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Quick Load'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a9fd41eaa5e8cbd930cffcfb77be20fe', true);
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('617d36f9b5c460c6206667e6e125aaa1', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a9fd41eaa5e8cbd930cffcfb77be20fe', true);
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('617d36f9b5c460c6206667e6e125aaa1', true);
    Products = (await BackendlessUI.Functions.Custom['fn_f4df84546016cedc7395d748e8d7078c']((JSON.stringify((await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return ([(getObjectProperty(item, 'Mass')) / (getObjectProperty(item, 'Unit mass')),' ',' X ',' ',(getObjectProperty((getObjectProperty(item, 'Product')), 'Product')),'/n'].join(''));})))))));
    Load_Value = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value')))) ? (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder')) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value'));
    Rate_Per_Km = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value'));
    Rate_Per_Unit = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value'));
    Mileage = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value'));
    Load_Variable = ({ [`Load_Product_JSON`]: ({ [`Planned`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')) }),[`Delivery (Client)`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
    }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
    }))[0]), 'Name')),[`Customer Name`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value')));
    }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value')));
    }))[0]), 'Name')),[`Date_Planned_Delivery`]: (new Date((new Date()).getTime() + (((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Distance')) / 1000) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed'))) * 2.5 * 60 * 60) * 1000))),[`Date_Planned_Loading`]: (new Date()),[`Distance_Planned_LDP_To_DP`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Distance')) / 1000,[`Distance_Planned_LDP_To_LP`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Dead Leg')) / 1000,[`Distance_Planned_LP_To_DP`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Loaded Leg')) / 1000,[`Financial_Billing_Type`]: 'Per Km',[`Financial_Target_Ideal_Rate_Per_Km`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km')),[`Financial_Target_Ideal_Rate_Per_Tonne`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Tonne')),[`ID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c51eb91741c7599e2dfd5ca19eeb4a69')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c51eb91741c7599e2dfd5ca19eeb4a69')), 'value')),[`Load Planner Name`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name')),[`Load Point (Delivery Name)`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
    }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
    }))[0]), 'Contact_Name')),[`Load Point (Load Name)`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
    }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
    }))[0]), 'Contact_Name')),[`CID`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value')),[`LLPID`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
    }))[0]), 'objectId')),[`LDPID`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
    }))[0]), 'objectId')),[`LLDPID`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6')), 'value')));
    }))[0]), 'objectId')),[`Load_Broker`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')),[`Load_Notes`]: undefined,[`Load_Product`]: Products,[`Load_Type`]: 'Standard',[`Rig_Cost_Per_Hour`]: undefined,[`Rig_CPK`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Rig_CPK')),[`Rig_Payload`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')),[`Status`]: 'Planned',[`Tonnage_Planned`]: (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;}),[`Planned Rate Per Unit`]: Rate_Per_Unit,[`Planned Mileage`]: Mileage,[`Planned_Load_Value`]: Load_Value,[`Planned Rate Per Km`]: Rate_Per_Km,[`ownerId`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(item, 'Registration')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')));
    }))[0]), 'ownerId')),[`objectId`]: (generateUUID().long()),[`TID`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) });
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Transaction;

      Created_Load = (_uow.create('Loads', Load_Variable));
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')));
      }))[0])))) {
      } else {
        _uow.setRelation('Loads', Created_Load, 'Load_Planner', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


         return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')));
        }))[0]), 'objectId'))]);
      }
      _uow.setRelation('Loads', Created_Load, 'Location_Delivery_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
      }))[0]), 'objectId'))]);
      _uow.setRelation('Loads', Created_Load, 'Location_Last_Delivery_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6')), 'value')));
      }))[0]), 'objectId'))]);
      _uow.setRelation('Loads', Created_Load, 'Location_Load_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
      }))[0]), 'objectId'))]);
      _uow.setRelation('Loads', Created_Load, 'Rig_Tractor', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'))]);
      Trailers = (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'objectId'))], async (item) => {


       return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](item)));
      }));
      _uow.setRelation('Loads', Created_Load, 'Rig_Trailers', Trailers);
      _uow.setRelation('Loads', Created_Load, 'Customer', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value'))]);
      _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), 'Loads', [Created_Load]);

    })();

    Result = (await Transaction.execute());
    addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')));
    }))[0]), 'Loads')), (getObjectProperty((getObjectProperty((getObjectProperty(Result, 'results')), 'createLoads1')), 'result')));
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? [] : (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) != 'Delivered');
    })), 1, async (item) => {


     return (getObjectProperty(item, 'Action Date'));
    }))));
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Clear_Form();
    Loads_Counter = (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Load Ref Counter')) + 1;
    Load_Counter_To_Text = getValueLength(String(Loads_Counter)) == 1 ? String('000000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 2 ? String('00000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 3 ? String('0000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 4 ? String('000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 5 ? String('00') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 6 ? String('0') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 7 ? String(Loads_Counter) : 'Hidden Easter Egg'))))));
    await new Promise(r => setTimeout(r, 1000 || 0));
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads'))))) {
      Load_ID_Tag = [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Registered_Name')).slice(0, 3),' L ',Load_Counter_To_Text].join('');
    } else {
      Load_ID_Tag = [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' ',Load_Counter_To_Text].join('');
    }
    await new Promise(r => setTimeout(r, 1000 || 0));
    ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Load Ref'] = Load_ID_Tag;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('617d36f9b5c460c6206667e6e125aaa1'))['disabled'] = false;
    await new Promise(r => setTimeout(r, 1000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('318b7c7d84ce11ee39e9730176875287', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30e6591fbe6ca3bad316b55f32edf195', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64c99a9b58ffea63cdef471e3503be85', false);
    try {
      delete ___arguments.context.pageData['Admin Capture Load'];

    } catch (error) {

    }
    try {
      delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Quick Load'];

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/d61e6a7afbfa7a89b177f9da477b5786/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Delivery Date'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onMinDateAssignment */
  async ['onMinDateAssignment'](___arguments) {
    var Minimum_Date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date'))))) {
    Minimum_Date = (new Date());
  } else {
    Minimum_Date = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date'));
  }

  return Minimum_Date

  },
  /* handler:onMinDateAssignment */
  /* handler:onMaxDateAssignment */
  async ['onMaxDateAssignment'](___arguments) {
    var Maximum_Date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Admin Capture Load'))))) {
    Maximum_Date = (new Date((new Date()).getTime() + (31536000 * 1000)));
  } else {
    Maximum_Date = (new Date());
  }

  return Maximum_Date

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/Assets/components/6ff5a7aa2a75a83cbe53dbbd19fa9bc6/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;


  try {
    delete ___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb')['Load Planner - Markers'];

  } catch (error) {
    console.log(error);

  }
  delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Route'];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', false);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/b7fe71f8c531da3db4857a3ee4949857/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;


  try {
    delete ___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb')['Load Planner - Markers'];

  } catch (error) {
    console.log(error);

  }
  delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Route'];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', false);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/553b5e2755e9ca0c28314bbb81bda93c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;


  try {
    delete ___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb')['Load Planner - Markers'];

  } catch (error) {
    console.log(error);

  }
  delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Route'];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', false);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/20ff94828c490151c41885ce733dce8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, Waypoints_Deliver_to_Return, Waypoints_Load_To_Deliver, Waypoints_Start_To_Load, Route, Loaded_Leg, Start_Leg, Billing_Route, item, Delivery_Point, Load_Point, Return_Point, Start_Point, Return_Leg;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Waypoint_Processing() {
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('75b2c06d94c8b6b4491d6763d22d18ef'))))) {
    Waypoints_Start_To_Load = [];
  } else {
    Waypoints_Start_To_Load = [];
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('75b2c06d94c8b6b4491d6763d22d18ef'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      addItemToList(Waypoints_Start_To_Load, j);
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c73ededba8ad18875b317c46b82b4d46'))))) {
    Waypoints_Load_To_Deliver = [];
  } else {
    Waypoints_Load_To_Deliver = [];
    var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c73ededba8ad18875b317c46b82b4d46'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      addItemToList(Waypoints_Load_To_Deliver, j);
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ac6af178b324c6c1d70518e72bd48a63'))))) {
    Waypoints_Deliver_to_Return = [];
  } else {
    Waypoints_Deliver_to_Return = [];
    var j_list3 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ac6af178b324c6c1d70518e72bd48a63'));
    for (var j_index3 in j_list3) {
      j = j_list3[j_index3];
      addItemToList(Waypoints_Deliver_to_Return, j);
    }
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', false);
  await new Promise(r => setTimeout(r, 200 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', true);
  Route = null;
  Start_Point = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6')));
  }))[0];
  Load_Point = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b7fe71f8c531da3db4857a3ee4949857')));
  }))[0];
  Delivery_Point = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('553b5e2755e9ca0c28314bbb81bda93c')));
  }))[0];
  Return_Point = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('aa02e8765bcb0dfd35ad2daad32f98a9')));
  }))[0];
  await Waypoint_Processing();
  Start_Leg = (await BackendlessUI.Functions.Custom['fn_b91213ddd54e86f99f851edb9dc3c82a']((getObjectProperty(Start_Point, 'Point')), (getObjectProperty(Load_Point, 'Point')), (Waypoints_Start_To_Load.length == 0 ? [] : (await Promise.all(Waypoints_Start_To_Load.map(async item => {; return (getObjectProperty(item, 'Point'));})))), null, null, null, null, null, null, null, true));
  Loaded_Leg = (await BackendlessUI.Functions.Custom['fn_b91213ddd54e86f99f851edb9dc3c82a']((getObjectProperty(Load_Point, 'Point')), (getObjectProperty(Delivery_Point, 'Point')), (Waypoints_Load_To_Deliver.length == 0 ? [] : (await Promise.all(Waypoints_Load_To_Deliver.map(async item => {; return (getObjectProperty(item, 'Point'));})))), null, null, null, null, null, null, null, true));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Return_Point))) {
    Route = ({ [`Distance`]: (getObjectProperty(Start_Leg, 'Distance')) + (getObjectProperty(Loaded_Leg, 'Distance')),[`Duration`]: (getObjectProperty(Start_Leg, 'Duration')) + (getObjectProperty(Loaded_Leg, 'Duration')),[`Polyline`]: ((getObjectProperty(Start_Leg, 'Polyline')).concat((getObjectProperty(Loaded_Leg, 'Polyline')))),[`Route`]: ({ [`Start Leg`]: Start_Leg,[`Loaded Leg`]: Loaded_Leg }),[`PointList`]: ({ [`Origin`]: Start_Point,[`Waypoints`]: ((Waypoints_Start_To_Load.length == 0 ? [] : Waypoints_Start_To_Load).concat(([Load_Point].concat(((Waypoints_Load_To_Deliver.length == 0 ? [] : Waypoints_Load_To_Deliver).concat(([Delivery_Point].concat((Waypoints_Deliver_to_Return.length == 0 ? [] : Waypoints_Deliver_to_Return))))))))),[`Destination `]: Delivery_Point }) });
  } else {
    Return_Leg = (await BackendlessUI.Functions.Custom['fn_b91213ddd54e86f99f851edb9dc3c82a']((getObjectProperty(Delivery_Point, 'Point')), (getObjectProperty(Return_Point, 'Point')), (Waypoints_Deliver_to_Return.length == 0 ? [] : (await Promise.all(Waypoints_Deliver_to_Return.map(async item => {; return (getObjectProperty(item, 'Point'));})))), null, null, null, null, null, null, null, true));
    Route = ({ [`Distance`]: (getObjectProperty(Start_Leg, 'Distance')) + (getObjectProperty(Loaded_Leg, 'Distance')) + (getObjectProperty(Return_Leg, 'Distance')),[`Duration`]: (getObjectProperty(Start_Leg, 'Duration')) + (getObjectProperty(Loaded_Leg, 'Duration')) + (getObjectProperty(Return_Leg, 'Duration')),[`Polyline`]: ((getObjectProperty(Start_Leg, 'Polyline')).concat(((getObjectProperty(Loaded_Leg, 'Polyline')).concat((getObjectProperty(Return_Leg, 'Polyline')))))),[`Route`]: ({ [`Start Leg`]: Start_Leg,[`Loaded Leg`]: Loaded_Leg,[`Return Leg`]: Return_Leg }),[`PointList`]: ({ [`Origin`]: Start_Point,[`Waypoints`]: ((Waypoints_Start_To_Load.length == 0 ? [] : Waypoints_Start_To_Load).concat(([Load_Point].concat(((Waypoints_Load_To_Deliver.length == 0 ? [] : Waypoints_Load_To_Deliver).concat(([Delivery_Point].concat((Waypoints_Deliver_to_Return.length == 0 ? [] : Waypoints_Deliver_to_Return))))))))),[`Destination `]: Return_Point }),[`Return`]: Return_Point });
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(1)') {
    Billing_Route = ({ [`Distance`]: (getObjectProperty(Start_Leg, 'Distance')) + (getObjectProperty(Loaded_Leg, 'Distance')),[`Duration`]: (getObjectProperty(Start_Leg, 'Duration')) + (getObjectProperty(Loaded_Leg, 'Duration')),[`Polyline`]: ((getObjectProperty(Start_Leg, 'Polyline')).concat((getObjectProperty(Loaded_Leg, 'Polyline')))),[`Route`]: ({ [`Start Leg`]: Start_Leg,[`Loaded Leg`]: Loaded_Leg }) });
    Billing_Route['PointList'] = ({ [`Origin`]: Start_Point,[`Waypoints`]: ((Waypoints_Start_To_Load.length == 0 ? [] : Waypoints_Start_To_Load).concat(([Load_Point].concat((Waypoints_Load_To_Deliver.length == 0 ? [] : Waypoints_Load_To_Deliver))))),[`Destination `]: Delivery_Point });
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(2)') {
    Billing_Route = Loaded_Leg;
    Billing_Route['PointList'] = ({ [`Origin`]: Load_Point,[`Waypoints`]: Waypoints_Load_To_Deliver.length == 0 ? [] : Waypoints_Load_To_Deliver,[`Destination `]: Delivery_Point });
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(3)') {
    Billing_Route = ({ [`Distance`]: (getObjectProperty(Loaded_Leg, 'Distance')) + (getObjectProperty(Return_Leg, 'Distance')),[`Duration`]: (getObjectProperty(Loaded_Leg, 'Duration')) + (getObjectProperty(Return_Leg, 'Duration')),[`Polyline`]: ((getObjectProperty(Loaded_Leg, 'Polyline')).concat((getObjectProperty(Return_Leg, 'Polyline')))),[`Route`]: ({ [`Loaded Leg`]: Loaded_Leg,[`Return Leg`]: Return_Leg }) });
    Billing_Route['PointList'] = ({ [`Origin`]: Load_Point,[`Waypoints`]: ((Waypoints_Load_To_Deliver.length == 0 ? [] : Waypoints_Load_To_Deliver).concat(([Delivery_Point].concat((Waypoints_Deliver_to_Return.length == 0 ? [] : Waypoints_Deliver_to_Return))))),[`Destination `]: Return_Point });
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(4)') {
    Billing_Route = ({ [`Distance`]: (getObjectProperty(Start_Leg, 'Distance')) + (getObjectProperty(Loaded_Leg, 'Distance')) + (getObjectProperty(Return_Leg, 'Distance')),[`Duration`]: (getObjectProperty(Start_Leg, 'Duration')) + (getObjectProperty(Loaded_Leg, 'Duration')) + (getObjectProperty(Return_Leg, 'Duration')),[`Polyline`]: ((getObjectProperty(Start_Leg, 'Polyline')).concat(((getObjectProperty(Loaded_Leg, 'Polyline')).concat((getObjectProperty(Return_Leg, 'Polyline')))))),[`Route`]: ({ [`Start Leg`]: Start_Leg,[`Loaded Leg`]: Loaded_Leg,[`Return Leg`]: Return_Leg }) });
    Billing_Route['PointList'] = ({ [`Origin`]: Start_Point,[`Waypoints`]: ((Waypoints_Start_To_Load.length == 0 ? [] : Waypoints_Start_To_Load).concat(([Load_Point].concat(((Waypoints_Load_To_Deliver.length == 0 ? [] : Waypoints_Load_To_Deliver).concat(([Delivery_Point].concat((Waypoints_Deliver_to_Return.length == ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Return_Point)) ? Delivery_Point : null) ? [] : Waypoints_Deliver_to_Return))))))))),[`Destination `]: Return_Point });
  }
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('ecf24f5838fdd0b26cecd573c5c2e6c9', (getObjectProperty(((getObjectProperty(Route, 'Polyline'))[0]), 'lat')), (getObjectProperty(((getObjectProperty(Route, 'Polyline'))[0]), 'lng')));
  ___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb')['Load Planner - Markers'] = (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Return_Point)) ? ((Waypoints_Start_To_Load.length == 0 ? [] : (await Promise.all(Waypoints_Start_To_Load.map(async item => {; return (getObjectProperty(item, 'Point'));})))).concat(([(getObjectProperty(Load_Point, 'Point'))].concat((Waypoints_Load_To_Deliver.length == 0 ? [] : (await Promise.all(Waypoints_Load_To_Deliver.map(async item => {; return (getObjectProperty(item, 'Point'));})))))))) : ((Waypoints_Start_To_Load.length == 0 ? [] : (await Promise.all(Waypoints_Start_To_Load.map(async item => {; return (getObjectProperty(item, 'Point'));})))).concat(([(getObjectProperty(Load_Point, 'Point'))].concat(((Waypoints_Load_To_Deliver.length == 0 ? [] : (await Promise.all(Waypoints_Load_To_Deliver.map(async item => {; return (getObjectProperty(item, 'Point'));})))).concat(([(getObjectProperty(Delivery_Point, 'Point'))].concat((Waypoints_Deliver_to_Return.length == 0 ? [] : (await Promise.all(Waypoints_Deliver_to_Return.map(async item => {; return (getObjectProperty(item, 'Point'));}))))))))))))).concat([(getObjectProperty(Route, 'Polyline'))[0], (getObjectProperty(Route, 'Polyline')).slice(-1)[0]]));
  await (async function(googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers, pointColor, pointScale, vehicleId, geofences, stations, stationIconSvg, canAddGeofences, polygonColor, appData) {
  	let existingMarkers = [];
  	let existingPolylines = [];
  	let existingGeofences = [];
  	let currentInfoWindow = null;
  	let selectedMarker = null;
  	let geofenceMarkers = [];
  	let geofencePolygon = null;
  	let addingGeofence = false;
  	
  	appData = appData || {};
  	
  	function addPolylineAndCustomMarkers(
  	  googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers,
  	  pointColor, pointScale, vehicleId, geofences, stations, stationIconSvg, enableGeofence, polygonColor, appData
  	) {
  	  if (!googleMapComponent || !googleMapComponent.map) {
  	    return;
  	  }
  	
  	  const mapInstance = googleMapComponent.map.map;
  	  if (!(mapInstance instanceof google.maps.Map)) {
  	    return;
  	  }
  	
  	  // Polyline logic
  	  const polylineCoordinates = markers.map(marker => ({
  	    lat: marker.lat,
  	    lng: marker.lng
  	  }));
  	
  	  const polyline = new google.maps.Polyline({
  	    path: polylineCoordinates,
  	    geodesic: true,
  	    strokeColor: polylineColor || '#FF0000',
  	    strokeOpacity: strokeOpacity || 1.0,
  	    strokeWeight: strokeWeight || 2
  	  });
  	
  	  polyline.setMap(mapInstance);
  	  existingPolylines.push(polyline);
  	
  	  function calculateHeading(lat1, lng1, lng2, lat2) {
  	    const toRadians = degrees => degrees * Math.PI / 180;
  	    const toDegrees = radians => degrees * 180 / Math.PI;
  	
  	    const dLng = toRadians(lng2 - lng1);
  	    const y = Math.sin(dLng) * Math.cos(toRadians(lat2));
  	    const x = Math.cos(toRadians(lat1)) * Math.sin(toRadians(lat2)) - Math.sin(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.cos(dLng);
  	    const bearing = toDegrees(Math.atan2(y, x));
  	    return (bearing + 360) % 360;
  	  }
  	
  	  // Add custom markers to the map
  	pointMarkers.forEach((marker, index) => {
  	  let icon;
  	  let markerOptions = {
  	    position: { lat: marker.lat, lng: marker.lng },
  	    map: mapInstance,
  	    draggable: false,
  	  };
  	
  	  // Check for Icon property and use it if available
  	  if (marker.Icon) {
  	    icon = {
  	      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(marker.Icon)}`,
  	      anchor: new google.maps.Point(25, 25),
  	      scaledSize: new google.maps.Size(50, 50) // Adjust size as needed
  	    };
  	
  	    // Set a high zIndex to ensure it sits on top of other markers
  	    markerOptions.zIndex = google.maps.Marker.MAX_ZINDEX + 1;
  	  } else {
  	    let iconColor = marker.color || pointColor || '#FF0000';
  	
  	    if (marker.Speed === 0) {
  	      icon = {
  	        path: google.maps.SymbolPath.CIRCLE,
  	        fillColor: iconColor,
  	        fillOpacity: 1,
  	        strokeColor: 'black',
  	        strokeWeight: 2,
  	        scale: marker.scale || pointScale || 8
  	      };
  	
  	      if (index === pointMarkers.length - 1 && vehicleId) {
  	        const crosshairSvg = `
  	        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  	        <circle cx="12" cy="12" r="10"></circle>
  	        <line x1="12" y1="2" x2="12" y2="6"></line>
  	        <line x1="12" y1="18" x2="12" y2="22"></line>
  	        <line x1="2" y1="12" x2="6" y2="12"></line>
  	        <line x1="18" y1="12" x2="22" y2="12"></line>
  	        </svg>
  	        `;
  	
  	        icon = {
  	          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(crosshairSvg)}`,
  	          anchor: new google.maps.Point(25, 25),
  	          scaledSize: new google.maps.Size(50, 50)
  	        };
  	      }
  	
  	    } else {
  	      let heading = marker.Direction !== undefined ? marker.Direction : 0;
  	      if (marker.Direction === undefined && index < pointMarkers.length - 1) {
  	        const nextMarker = pointMarkers[index + 1];
  	        heading = calculateHeading(marker.lat, marker.lng, nextMarker.lng, nextMarker.lat);
  	      }
  	
  	      heading = (heading - 90 + 360) % 360;
  	
  	      const iconPath = "M 0 0 L -1 -1 L 1 0 L -1 1 Z";
  	      if (iconColor.toLowerCase() === '#000000' || iconColor.toLowerCase() === 'black') {
  	        icon = {
  	          path: iconPath,
  	          fillColor: iconColor,
  	          fillOpacity: 1,
  	          strokeColor: 'white',
  	          strokeWeight: 3,
  	          rotation: heading,
  	          scale: marker.scale || pointScale || 8,
  	          anchor: new google.maps.Point(0, 0)
  	        };
  	      } else {
  	        icon = {
  	          path: iconPath,
  	          fillColor: iconColor,
  	          fillOpacity: 1,
  	          strokeColor: 'black',
  	          strokeWeight: 2,
  	          rotation: heading,
  	          scale: marker.scale || pointScale || 8,
  	          anchor: new google.maps.Point(0, 0)
  	        };
  	      }
  	    }
  	  }
  	
  	  // Apply the icon to the marker options
  	  markerOptions.icon = icon;
  	
  	  const pointMarker = new google.maps.Marker(markerOptions);
  	
  	  existingMarkers.push(pointMarker);
  	
  	  if (marker.Data) {
  	    const infowindow = new google.maps.InfoWindow({
  	      content: marker.Data
  	    });
  	
  	    pointMarker.addListener('click', function() {
  	      if (currentInfoWindow) {
  	        currentInfoWindow.close();
  	      }
  	      infowindow.open(mapInstance, pointMarker);
  	      currentInfoWindow = infowindow;
  	
  	      selectedMarker = pointMarker;
  	    });
  	  }
  	
  	  pointMarker.addListener('click', function() {
  	    selectedMarker = pointMarker;
  	  });
  	});
  	
  	
  	
  	  // Add Geofences
  	  if (geofences && Array.isArray(geofences)) {
  	    geofences.forEach(geofence => {
  	      if (geofence["Geo Fences"] && geofence["Geo Fences"].boundary && Array.isArray(geofence["Geo Fences"].boundary.points)) {
  	        const polygonCoords = geofence["Geo Fences"].boundary.points.map(point => ({
  	          lat: point.y,
  	          lng: point.x
  	        }));
  	
  	        const polygon = new google.maps.Polygon({
  	          paths: polygonCoords,
  	          strokeColor: geofence.Color,
  	          strokeOpacity: 0.9,
  	          strokeWeight: 4,
  	          fillColor: geofence.Color,
  	          fillOpacity: 0.25
  	        });
  	
  	        polygon.setMap(mapInstance);
  	        existingGeofences.push(polygon);
  	
  	        google.maps.event.addListener(polygon, 'click', function(event) {
  	          const infowindow = new google.maps.InfoWindow({
  	            content: createGeofencePopupContent(geofence, polygon, mapInstance, appData)
  	          });
  	
  	          infowindow.setPosition(event.latLng);
  	          infowindow.open(mapInstance);
  	          currentInfoWindow = infowindow;
  	        });
  	      }
  	    });
  	  }
  	
  	  // Add Stations
  	  if (stations && Array.isArray(stations)) {
  	    stations.forEach(station => {
  	      if (station["Geo Fence"] && station["Geo Fence"].boundary && station["Geo Fence"].boundary.points) {
  	        const stationCoords = station["Geo Fence"].boundary.points.map(point => ({
  	          lat: point.y,
  	          lng: point.x
  	        }));
  	
  	        const polygon = new google.maps.Polygon({
  	          paths: stationCoords,
  	          strokeColor: station.Color,
  	          strokeOpacity: 0.9,
  	          strokeWeight: 4,
  	          fillColor: station.Color,
  	          fillOpacity: 0.25
  	        });
  	
  	        polygon.setMap(mapInstance);
  	        existingGeofences.push(polygon);
  	
  	        // Check for station location
  	        if (station.Location && station.Location.x !== undefined && station.Location.y !== undefined) {
  	          const icon = {
  	            url: stationIconSvg,
  	            anchor: new google.maps.Point(25, 50),
  	            scaledSize: new google.maps.Size(50, 50)
  	          };
  	
  	          const stationCenter = {
  	            lat: station.Location.y,
  	            lng: station.Location.x
  	          };
  	          const stationMarker = new google.maps.Marker({
  	            position: stationCenter,
  	            map: mapInstance,
  	            icon: icon
  	          });
  	
  	          existingMarkers.push(stationMarker);
  	
  	          google.maps.event.addListener(stationMarker, 'click', function(event) {
  	            const infowindow = new google.maps.InfoWindow({
  	              content: createStationPopupContent(station)
  	            });
  	
  	            infowindow.open(mapInstance, stationMarker);
  	            currentInfoWindow = infowindow;
  	          });
  	        }
  	      }
  	    });
  	  }
  	
  	  if (pointMarkers.length > 0) {
  	    const latestMarker = pointMarkers[pointMarkers.length - 1];
  	    if (latestMarker) {
  	      mapInstance.setCenter({
  	        lat: latestMarker.lat, lng: latestMarker.lng
  	      });
  	    }
  	  }
  	
  	  // Adding Geofence Markers
  	  if (enableGeofence) {
  	    google.maps.event.addListener(mapInstance, 'click', function(event) {
  	      addGeofenceMarker(event.latLng);
  	    });
  	  }
  	
  	  function addGeofenceMarker(location) {
  	    const markerIndex = geofenceMarkers.length;
  	
  	    const icon = {
  	      path: google.maps.SymbolPath.CIRCLE,
  	      fillColor: markerIndex === geofenceMarkers.length - 1 ? '#FFFFFF' : polygonColor || '#FF0000',
  	      fillOpacity: 1,
  	      strokeColor: 'black',
  	      strokeWeight: 2,
  	      scale: 8
  	    };
  	
  	    const marker = new google.maps.Marker({
  	      position: location,
  	      map: mapInstance,
  	      icon: icon,
  	      draggable: true
  	    });
  	
  	    geofenceMarkers.push(marker);
  	
  	    marker.addListener('dragend', updateGeofencePolygon);
  	    marker.addListener('click', function() {
  	      marker.setMap(null);
  	      const markerIndex = geofenceMarkers.indexOf(marker);
  	      if (markerIndex !== -1) {
  	        geofenceMarkers.splice(markerIndex, 1);
  	        updateGeofencePolygon();
  	      }
  	    });
  	
  	    if (geofenceMarkers.length > 2) {
  	      const firstMarker = geofenceMarkers[0];
  	      if (location.equals(firstMarker.getPosition())) {
  	        createGeofencePolygon();
  	      }
  	    }
  	
  	    updateGeofencePolygon();
  	  }
  	
  	  function updateGeofencePolygon() {
  	    const path = geofenceMarkers.map(marker => marker.getPosition());
  	
  	    if (geofencePolygon) {
  	      geofencePolygon.setPath(path);
  	    } else {
  	      geofencePolygon = new google.maps.Polygon({
  	        paths: path,
  	        strokeColor: polygonColor || '#FF0000',
  	        strokeOpacity: 0.8,
  	        strokeWeight: 2,
  	        fillColor: polygonColor || '#FF0000',
  	        fillOpacity: 0.35
  	      });
  	
  	      geofencePolygon.setMap(mapInstance);
  	    }
  	
  	    // Save the created polygon to App Data, overriding the existing value
  	    appData.geofencePolygons = {
  	      path: path.map(latLng => ({
  	        lat: latLng.lat(), lng: latLng.lng()
  	      })),
  	      color: polygonColor || '#FF0000'
  	    };
  	  }
  	
  	  function createGeofencePolygon() {
  	    const path = geofenceMarkers.map(marker => marker.getPosition());
  	
  	    if (geofencePolygon) {
  	      geofencePolygon.setPath(path);
  	    } else {
  	      geofencePolygon = new google.maps.Polygon({
  	        paths: path,
  	        strokeColor: polygonColor || '#FF0000',
  	        strokeOpacity: 0.8,
  	        strokeWeight: 2,
  	        fillColor: polygonColor || '#FF0000',
  	        fillOpacity: 0.35
  	      });
  	
  	      geofencePolygon.setMap(mapInstance);
  	    }
  	  }
  	
  	  function createGeofencePopupContent(geofence, polygon, mapInstance, appData) {
  	    const geofences = appData.User.Company.Locations;
  	
  	    const content = document.createElement('div');
  	    content.style.padding = '10px';
  	    content.style.fontFamily = 'Arial, sans-serif';
  	    content.style.color = 'white';
  	
  	    const headerDiv = document.createElement('div');
  	    headerDiv.style.display = 'flex';
  	    headerDiv.style.justifyContent = 'space-between';
  	    headerDiv.style.alignItems = 'center';
  	
  	    const title = document.createElement('h3');
  	    title.style.margin = '0';
  	    title.textContent = geofence.Name;
  	
  	    const iconDiv = document.createElement('div');
  	    iconDiv.style.display = 'flex';
  	    iconDiv.style.gap = '10px';
  	
  	    // Edit Icon
  	    const editIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  	    editIcon.setAttribute('width', '24');
  	    editIcon.setAttribute('height', '24');
  	    editIcon.setAttribute('viewBox', '0 0 24 24');
  	    editIcon.setAttribute('fill', 'none');
  	    editIcon.setAttribute('stroke', 'white');
  	    editIcon.setAttribute('stroke-width', '2');
  	    editIcon.setAttribute('stroke-linecap', 'round');
  	    editIcon.setAttribute('stroke-linejoin', 'round');
  	    editIcon.style.cursor = 'pointer';
  	
  	    const editPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  	    editPath.setAttribute('d', 'M12 20h9');
  	    editIcon.appendChild(editPath);
  	
  	    const editPath2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  	    editPath2.setAttribute('d', 'M16.5 3.5a2.121 2.121 0 010 3l-10 10-4 1 1-4 10-10a2.121 2.121 0 013 0z');
  	    editIcon.appendChild(editPath2);
  	
  	    // Delete Icon
  	    const deleteIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  	    deleteIcon.setAttribute('width', '24');
  	    deleteIcon.setAttribute('height', '24');
  	    deleteIcon.setAttribute('viewBox', '0 0 24 24');
  	    deleteIcon.setAttribute('fill', 'none');
  	    deleteIcon.setAttribute('stroke', 'white');
  	    deleteIcon.setAttribute('stroke-width', '2');
  	    deleteIcon.setAttribute('stroke-linecap', 'round');
  	    deleteIcon.setAttribute('stroke-linejoin', 'round');
  	    deleteIcon.style.cursor = 'pointer';
  	
  	    const polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
  	    polyline.setAttribute('points', '3 6 5 6 21 6');
  	    deleteIcon.appendChild(polyline);
  	
  	    const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  	    path1.setAttribute('d', 'M19 6L17.707 18H6.293L5 6');
  	    deleteIcon.appendChild(path1);
  	
  	    // Add Icons to iconDiv
  	    iconDiv.appendChild(editIcon);
  	    iconDiv.appendChild(deleteIcon);
  	
  	    headerDiv.appendChild(title);
  	    headerDiv.appendChild(iconDiv);
  	
  	    content.appendChild(headerDiv);
  	
  	    const address = document.createElement('p');
  	    address.innerHTML = `<strong>Address:</strong> ${geofence.Address}`;
  	    content.appendChild(address);
  	
  	    const contactName = document.createElement('p');
  	    contactName.innerHTML = `<strong>Contact Name:</strong> ${geofence.Contact_Name}`;
  	    content.appendChild(contactName);
  	
  	    const phone = document.createElement('p');
  	    phone.innerHTML = `<strong>Phone:</strong> ${geofence.Phone}`;
  	    content.appendChild(phone);
  	
  	    const infowindow = new google.maps.InfoWindow({
  	      content: content,
  	      disableAutoPan: true
  	    });
  	
  	    // Add event listener to the polygon to handle the click
  	    polygon.addListener('click', function(event) {
  	      infowindow.setPosition(event.latLng);
  	      infowindow.open(mapInstance);
  	      currentInfoWindow = infowindow;
  	    });
  	
  	    editIcon.addEventListener('click',
  	      async function () {
  	        const isEditable = polygon.getEditable();
  	        polygon.setEditable(!isEditable);
  	
  	        if (!isEditable) {
  	          editIcon.innerHTML = ''; // Switch to save icon
  	          const checkPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  	          checkPath.setAttribute('d', 'M20 6L9 17l-5-5');
  	          editIcon.appendChild(checkPath);
  	        } else {
  	          const newPath = polygon.getPath().getArray().map(latLng => [latLng.lng(), latLng.lat()]);
  	
  	          const updatedGeofence = geofences.find(loc => loc.objectId === geofence.objectId);
  	
  	          updatedGeofence["Geo Fences"] = {
  	            type: "Polygon",
  	            coordinates: [newPath],
  	            srs: {
  	              srsId: 4326,
  	              name: 'WGS 84'
  	            },
  	            holes: [] // Add holes if applicable or leave as an empty array
  	          };
  	
  	          const sanitizedGeofence = JSON.parse(JSON.stringify(updatedGeofence, (key, value) => {
  	            if (typeof value === 'function' || value instanceof Element) {
  	              return undefined;
  	            }
  	            return value;
  	          }));
  	
  	          const result = await Backendless.Data.of('Locations').save(sanitizedGeofence, true);
  	
  	          const index = geofences.findIndex(loc => loc.objectId === geofence.objectId);
  	          if (index !== -1) {
  	            geofences[index] = result;
  	          }
  	
  	          editIcon.innerHTML = '';
  	          editIcon.appendChild(editPath);
  	          editIcon.appendChild(editPath2);
  	        }
  	      });
  	
  	    // Handling Delete Icon Click
  	    deleteIcon.addEventListener('click',
  	      async function() {
  	        const confirmation = confirm(`Are you sure you want to delete the location: ${geofence.Name}?`);
  	        if (confirmation) {
  	          await Backendless.Data.of('Locations').remove(geofence.objectId);
  	
  	          appData.User.Company.Locations = await asyncListFilter(geofences, async (item) => {
  	            return (geofence.objectId !== item.objectId);
  	          });
  	
  	          polygon.setMap(null);
  	          infowindow.close();
  	        }
  	      });
  	
  	    return content;
  	  }
  	
  	  // Supporting Functions
  	
  	  async function asyncListFilter(sourceList,
  	    callback) {
  	    const list = await Promise.all(sourceList.map(async source => ({
  	      source,
  	      value: await callback(source),
  	    })));
  	
  	    const resultList = list.filter(item => item.value);
  	
  	    return resultList.map(item => item.source);
  	  }
  	}
  	
  	// Helper function to create popup content for stations
  	function createStationPopupContent(station) {
  	  return `
  	  <div style="padding: 10px; font-family: Arial, sans-serif; color: white;">
  	  <table>
  	  <tr><td><strong>Station Name:</strong></td><td>${station.Station_Name}</td></tr>
  	  <tr><td><strong>Brand:</strong></td><td>${station.Brand}</td></tr>
  	  <tr><td><strong>Contact Name:</strong></td><td>${station.Contact_Name}</td></tr>
  	  <tr><td><strong>Phone:</strong></td><td>${station.Contact_Number}</td></tr>
  	  <tr><td><strong>Address:</strong></td><td>${station.Province}, ${station.Town}</td></tr>
  	  <tr><td><strong>Price:</strong></td><td>${station.Price}</td></tr>
  	  <tr><td><strong>Truck Stop:</strong></td><td>${station.Truck_Stop ? 'Yes': 'No'}</td></tr>
  	  </table>
  	  <p><strong>Services:</strong></p>
  	  <ul>
  	  ${(Array.isArray(station.Services) ? station.Services: []).map(service => `<li>${service}</li>`).join('')}
  	  </ul>
  	  </div>
  	  `;
  	}
  	
  	try {
  	  const googleMapComponent = arguments[0];
  	  const polylineColor = arguments[1];
  	  const markers = arguments[2];
  	  const strokeOpacity = arguments[3];
  	  const strokeWeight = arguments[4];
  	  const pointMarkers = arguments[5];
  	  const pointColor = arguments[6];
  	  const pointScale = arguments[7];
  	  const vehicleId = arguments[8];
  	  const geofences = arguments[9];
  	  const stations = arguments[10];
  	  const stationIconSvg = arguments[11];
  	  const enableGeofence = arguments[12];
  	  const polygonColor = arguments[13];
  	  const appData = arguments[14];
  	  addPolylineAndCustomMarkers(
  	    googleMapComponent,
  	    polylineColor,
  	    markers,
  	    strokeOpacity,
  	    strokeWeight,
  	    pointMarkers,
  	    pointColor,
  	    pointScale,
  	    vehicleId,
  	    geofences,
  	    stations,
  	    stationIconSvg,
  	    enableGeofence,
  	    polygonColor,
  	    appData// Pass the FuelLossSvg as the last argument
  	  );
  	} catch (error) {
  	  // No error handling
  	}
  })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ecf24f5838fdd0b26cecd573c5c2e6c9')), '#FFFFFF', (getObjectProperty(Route, 'Polyline')), 1, 7, null, null, null, null, null, null, null, null, null, null);
  ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Billing Route'] = Billing_Route;
  ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Route'] = Route;
  ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Dead Leg'] = (getObjectProperty(Start_Leg, 'Distance'));
  ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Loaded Leg'] = (getObjectProperty(Loaded_Leg, 'Distance'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('397cc61daa269e6aeaee6ff2d5364dcd', true);
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('83d5b29d01583bf8c39eb277734e949a')));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c51eb91741c7599e2dfd5ca19eeb4a69'))['value'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Ref'));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Start')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Delivery')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Customer'))))) {
    Viewer = false;
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(1)' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(2)') {
      Viewer = true;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(3)' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(4)') {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Return'))))) {
        Viewer = false;
      } else {
        Viewer = true;
      }
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/ecf24f5838fdd0b26cecd573c5c2e6c9/bundle.js', [], () => ({
  /* content */
  /* handler:onPointsAssignment */
  async ['onPointsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Planner - Markers')))) ? [] : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Planner - Markers')))

  },
  /* handler:onPointsAssignment */
  /* content */
}))

define('./pages/Assets/components/f2d16fe6a3be499586bb7fdc4543df79/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Route'];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', false);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/b00978c234091f93502f72fc23f34b9c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route'))))) {
    Content = '-';
  } else {
    Content = String((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Distance')) / 1000) + String(' km');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/170dab069a0e87796e9c4c2cb6039dce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route'))))) {
    Content = '-';
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed'))))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration'))))) {
        Content = '-';
      } else {
        Content = Math.round(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / 60);
      }
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration'))))) {
        Content = '-';
      } else {
        Content = [Math.floor(Math.round((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120)) / 60) / 60) < 10 ? String('0') + String(Math.floor(Math.round((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120)) / 60) / 60)) : Math.floor(Math.round((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120)) / 60) / 60),'hh : ',Math.ceil((Math.round((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120)) / 60) / 60 - Math.floor(Math.round((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120)) / 60) / 60)) * 60) < 10 ? String('0') + String(Math.ceil((Math.round((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120)) / 60) / 60 - Math.floor(Math.round((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120)) / 60) / 60)) * 60)) : Math.ceil((Math.round((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120)) / 60) / 60 - Math.floor(Math.round((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120)) / 60) / 60)) * 60),'mm'].join('');
      }
    }
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/b1ab76f29f18941905fcc838ce857fb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7c844bedb74f9916e6928cd1a10ace5f');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/4b1cccf17476c13b43ad10d99d8fb755/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  async ['onPlaceholderAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route'))))) {
    Content = null;
  } else {
    Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Distance')) / 1000;
  }

  return Content

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Mileage, Load_Value, Units, Rate_Per_Km, Rate_Per_Unit;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2'))['value'] = null;
  Load_Value = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value'));
  Rate_Per_Km = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value'));
  Rate_Per_Unit = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value'));
  Mileage = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.value)) ? (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder')) : ___arguments.value;
  Units = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Rate_Per_Km * Mileage)));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3'](((Rate_Per_Km * Mileage) / Units)));
  if ((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Load_Value / Mileage))) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba(255, 0, 0, 0.8)';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba(100, 100, 100, 0.5)';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/8b9a9cdf470fd7766e140edd727775de/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, list, Load_Value, Mileage, Product, Product__Selected_, Rate_Per_Km, Rate_Per_Unit, Units, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something2() {
  Load_Value = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value'));
  Rate_Per_Km = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value'));
  Rate_Per_Unit = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value'));
  Mileage = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value'));
  Units = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['placeholder'] = (Load_Value / Mileage);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['placeholder'] = (Load_Value / Units);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = null;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Product__Selected_ = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products')), async (item) => {


   return ((getObjectProperty(item, 'Product')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('4e6d0de6d6e12919048c9901804c1cd9')));
  }))[0];
  console.log(Product__Selected_);
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  Load_Value = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value'));
  Rate_Per_Km = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value'));
  Rate_Per_Unit = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value'));
  Mileage = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value'));
  Units = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.value)) ? (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'placeholder')) : ___arguments.value;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Load_Value / Units)));
  if ((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Load_Value / Mileage))) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba(255, 0, 0, 0.8)';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba(100, 100, 100, 0.5)';
  }

  },
  /* handler:onChange */
  /* handler:onPlaceholderAssignment */
  async ['onPlaceholderAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload'))))) {
    Content = null;
  } else {
    Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload'));
  }

  return Content

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var item, Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b9f9523fe84ee598f7862a8e9a83b3c3')).length == 0) {
    Value = 0;
  } else {
    Value = (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;});
  }

  return Value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Assets/components/c24b02f58ea9319a54b7187fa795f487/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  async ['onPlaceholderAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload'))))) {
    Content = null;
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))))) {
      Content = null;
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route'))))) {
        Content = null;
      } else {
        Content = Math.round(((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route')), 'Distance')) / 1000) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload'))) * 100) / 100;
      }
    }
  }

  return Content

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Mileage, Load_Value, Units, Rate_Per_Unit, Rate_Per_Km;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2'))['value'] = null;
  Load_Value = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value'));
  Rate_Per_Km = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value'));
  Rate_Per_Unit = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.value)) ? (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder')) : ___arguments.value;
  Mileage = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'value'));
  Units = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3'](((Rate_Per_Unit * Units) / Mileage)));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Rate_Per_Unit * Units)));
  if ((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Load_Value / Mileage))) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba (255, 0, 0, 0.8)';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba(100, 100, 100, 0.5)';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/f38cc5c9d03ac407dcb285c5f8cec9da/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  async ['onPlaceholderAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))))) {
    Content = null;
  } else {
    Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'));
  }

  return Content

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Mileage, Load_Value, Units, Rate_Per_Km, Rate_Per_Unit;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2'))['value'] = null;
  Load_Value = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value'));
  Rate_Per_Km = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.value)) ? (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder')) : ___arguments.value;
  Rate_Per_Unit = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value'));
  Mileage = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'value'));
  Units = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Rate_Per_Km * Mileage)));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3'](((Rate_Per_Km * Mileage) / Units)));
  if ((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Load_Value / Mileage))) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba (255, 0, 0, 0.8)';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba(100, 100, 100, 0.5)';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/793178d98ab737baa9abac4267f6add2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Mileage, Load_Value, Units, Rate_Per_Unit, Rate_Per_Km;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value'))))) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder'))))) {
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((___arguments.value / (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder')))));
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value'))))) {
        ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((___arguments.value / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')))));
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((___arguments.value / (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value')))));
      }
    }
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = (___arguments.value / (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value')));
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value'))))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((___arguments.value / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')))));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((___arguments.value / (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value')))));
    }
  }
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = null;
  Load_Value = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.value)) ? (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder')) : ___arguments.value;
  Rate_Per_Km = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value'));
  Rate_Per_Unit = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value'));
  Mileage = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'value'));
  Units = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Load_Value / Mileage)));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Load_Value / Units)));
  console.log((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Load_Value / Mileage))));
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'));
  if ((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Load_Value / Mileage))) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba (255, 0, 0, 0.8)';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba(100, 100, 100, 0.5)';
  }

  },
  /* handler:onChange */
  /* handler:onPlaceholderAssignment */
  async ['onPlaceholderAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))))) {
    Content = null;
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route'))))) {
      Content = null;
    } else {
      Content = Math.round(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route')), 'Distance')) / 1000) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km')) * 100) / 100;
    }
  }

  return Content

  },
  /* handler:onPlaceholderAssignment */
  /* content */
}))

define('./pages/Assets/components/87e71a09d57a8136b39f799de8ae7f1a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'Load_Type')) == 'Service' ? ({ [`backgroundColor`]: 'rgba(255, 255, 0, 0.25)' }) : ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Loaded' ? ({ [`backgroundColor`]: 'rgba(255, 0, 0, 0.25)' }) : ({ [`backgroundColor`]: 'rgb(0, 0, 0)' })))

  },
  /* handler:onStyleAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('0b075fa4a8c36ad9b91b0f94a7527d45', (getObjectProperty(___arguments.context.dataModel, 'LDPID')));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Assets/components/d0c24cea931ac6d606a94e3a8d55616a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Assets/components/2c422ad8ca445c067e789945fd4649e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Date_Planned_Loading')))).toDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/b5473a4d815c49e618e46584af19ce26/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Assets/components/0b075fa4a8c36ad9b91b0f94a7527d45/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Route, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Route = (await BackendlessUI.Functions.Custom['fn_b91213ddd54e86f99f851edb9dc3c82a']((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b5473a4d815c49e618e46584af19ce26')), 'value')));
  }))[0]), 'Point')), (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0b075fa4a8c36ad9b91b0f94a7527d45')), 'value')));
  }))[0]), 'Point')), [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b5473a4d815c49e618e46584af19ce26')), 'value')));
  }))[0]), 'Point'))], null, null, null, null, null, null, null, true));
  ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['Planned_Load_Value'] = (((getObjectProperty(Route, 'Distance')) / 1000) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Planned Rate Per Km')));
  ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['Planned Mileage'] = ((getObjectProperty(Route, 'Distance')) / 1000);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/a009b6edcf3da17d812b4964164b8596/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Transaction, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ('edit' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a009b6edcf3da17d812b4964164b8596')), 'icon'))) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0b075fa4a8c36ad9b91b0f94a7527d45'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7a3d4cd6cd8dd56b3a38abec6a425ee9'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d0c24cea931ac6d606a94e3a8d55616a'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b8cf711e16a3a39de9ec1629b26cfcc1'))['display'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a009b6edcf3da17d812b4964164b8596'))['icon'] = 'check';
  } else {
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['LDPID'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0b075fa4a8c36ad9b91b0f94a7527d45')), 'value'));
    ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['Customer Name'] = (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d0c24cea931ac6d606a94e3a8d55616a')), 'value')));
    }))[0]), 'Customer'));
    await ( async () => {
      const _uow = Transaction;

      _uow.upsert('Loads', ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'));
      _uow.setRelation('Loads', ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Location_Delivery_Point', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0b075fa4a8c36ad9b91b0f94a7527d45')), 'value'))]);
      _uow.setRelation('Loads', ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Customer', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d0c24cea931ac6d606a94e3a8d55616a')), 'value'))]);

    })();

    console.log((await Transaction.execute()));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0b075fa4a8c36ad9b91b0f94a7527d45'))['disabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7a3d4cd6cd8dd56b3a38abec6a425ee9'))['disabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b8cf711e16a3a39de9ec1629b26cfcc1'))['display'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a009b6edcf3da17d812b4964164b8596'))['icon'] = 'edit';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/7a3d4cd6cd8dd56b3a38abec6a425ee9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['Planned Load Value'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Planned Mileage')) * ___arguments.value);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/28c7c5c42a02a1938d76a09caf08b319/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'DELETE') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('27f47492a5a39b264b8c95ce5a744f0f', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('27f47492a5a39b264b8c95ce5a744f0f', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/b8cf711e16a3a39de9ec1629b26cfcc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Status')) == 'Loaded') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('74e3173ac4597894b2bc3012ce47e98f');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Status')) == 'Planned') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('e319ea6acf9a6477338b64b409e3b82c');
  }

  },
  /* handler:onClick */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    var Icon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Status')) == 'Loaded') {
    Icon = 'playlist add check';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Status')) == 'Planned') {
    Icon = 'delete outline';
  }

  return Icon

  },
  /* handler:onIconAssignment */
  /* content */
}))

define('./pages/Assets/components/209c1a52519d6e9e7b1d77b1f6692b82/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('e319ea6acf9a6477338b64b409e3b82c');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/27f47492a5a39b264b8c95ce5a744f0f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Delete_Transaction, Maintenance_Item, Trailer, Tractor;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('27f47492a5a39b264b8c95ce5a744f0f', false);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Load_Type')) == 'Service') {
    Maintenance_Item = (await Backendless.Data.of('Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Service_ID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Service_ID')),'\''].join(''))).setPageSize(10)))[0];
    if ((getObjectProperty(Maintenance_Item, 'Vehicle Type')) == 'Tractor') {
      Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(Maintenance_Item, 'Tractor ID')), ));
      Tractor['Last_Service_Scheduled'] = ((getObjectProperty(Tractor, 'Last_Service_Scheduled')) - (getObjectProperty(Tractor, 'Service_Interval')));
      ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Last_Service_Scheduled'));
    } else {
      Trailer = (await Backendless.Data.of('Trailers').findById((getObjectProperty(Maintenance_Item, 'Trailer ID')), ));
      Trailer['Last_Service_Scheduled'] = ((getObjectProperty(Trailer, 'Last_Service_Scheduled')) - (getObjectProperty(Tractor, 'Service_Interval')));
    }
    Delete_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Delete_Transaction;

      if ((getObjectProperty(Maintenance_Item, 'Vehicle Type')) == 'Tractor') {
        _uow.update('Tractors', Tractor);
      } else {
        _uow.update('Trailers', Trailer);
      }
      _uow.delete('Loads', ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'));
      _uow.delete('Maintenance', Maintenance_Item);

    })();

    console.log((await Delete_Transaction.execute()));
  } else {
    Delete_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Delete_Transaction;

      _uow.delete('Loads', ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'));

    })();

    console.log((await Delete_Transaction.execute()));
  }
  removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), '');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'Status')) != 'Delivered');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  })));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('e319ea6acf9a6477338b64b409e3b82c');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/fbaf1ddcacca5443d75cc29830c2e0bd/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('14e218dc02fd2c57dcace34701b2d85b');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('14e218dc02fd2c57dcace34701b2d85b');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('f3e9c22366f902aef4819ddad8b9b81a', undefined);
  try {
    delete ___arguments.context.pageData['Admin Capture Load'];

  } catch (error) {

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/8059d0fc723c18a6b09dd354a0ce3cd3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Location;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Location = (await Backendless.Request.get(`${Backendless.appPath}/services/GoogleAPI/PlaceDetails`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'placeId': JSON.stringify((getObjectProperty(___arguments.value, 'place_id'))) }).send());
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Location, 'result')), 'geometry')), 'location')), 'lat')), (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Location, 'result')), 'geometry')), 'location')), 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', 18);
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('00a10794c3394968e50d921a03174098', [(getObjectProperty((getObjectProperty((getObjectProperty(Location, 'result')), 'geometry')), 'location'))]);
  console.log(Location);

  },
  /* handler:onChange */
  /* handler:onPlacesPredictionsAssignment */
  ['onPlacesPredictionsAssignment'](___arguments) {
      return ({ [`componentRestrictions`]: ({ [`country`]: ['za'] }) })

  },
  /* handler:onPlacesPredictionsAssignment */
  /* content */
}))

define('./pages/Assets/components/1d543af3cf028fdd8705e2b7dcb3495d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Assets/components/f3e9c22366f902aef4819ddad8b9b81a/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  getRTSubscriptions().remove((getObjectProperty(___arguments.context.pageData, 'Loads Update Listener')));
  getRTSubscriptions().remove((getObjectProperty(___arguments.context.pageData, 'Loads Upsert Listener')));

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/Assets/components/4e6d0de6d6e12919048c9901804c1cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'Product')),[`label`]: (getObjectProperty(item, 'Product')) });}))), 1, async (item) => {


         return (getObjectProperty(item, 'value'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, Product;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Product = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products')), async (item) => {


   return ((getObjectProperty(item, 'Product')) == ___arguments.value);
  }))[0];
  ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Product'] = Product;
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6'), 'Units'))))) {
    ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Unit mass'] = (getObjectProperty(Product, 'Mass'));
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).length == 1) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f1179b2329bd3782ae820f91603f29e4'))['value'] = (Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')) / (getObjectProperty(Product, 'Mass'))));
      ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Units'] = (Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')) / (getObjectProperty(Product, 'Mass'))));
      ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Mass'] = ((getObjectProperty(Product, 'Mass')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6'), 'Units')));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f1179b2329bd3782ae820f91603f29e4'))['value'] = (Math.floor(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')) - (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;})) / (getObjectProperty(Product, 'Mass'))));
      ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Units'] = (Math.floor(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')) - (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;})) / (getObjectProperty(Product, 'Mass'))));
      ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Mass'] = ((getObjectProperty(Product, 'Mass')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6'), 'Units')));
    }
  } else {
    ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Mass'] = ((getObjectProperty(Product, 'Mass')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6'), 'Units')));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/0bebf7c60731fc54b03d64640424f93a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var PDF_Data, File_Name, Delivery_Location, Load_Location, Customer, URL2, Load_Data, item, Last_Delivery_Location;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function PDF_Generation() {
  Load_Data = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record'));
  Last_Delivery_Location = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'LLDPID')));
  }))[0];
  Load_Location = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'LLPID')));
  }))[0];
  Delivery_Location = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'LDPID')));
  }))[0];
  Customer = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'CID')));
  }))[0];
  File_Name = ['deliverynote','(',(getObjectProperty(Load_Data, 'ID')),')'].join('');
  URL2 = ['https://backendlessappcontent.com/FB172318-89F2-E225-FF10-9AC9657A9000/15CB006B-69A7-477E-9D2F-3B75BC06A165/files/pdf/',['deliverynote','%28',(getObjectProperty(Load_Data, 'ID')),'%29'].join(''),'.pdf'].join('');
  PDF_Data = ({ [`DATE`]: (getObjectProperty(Load_Data, 'Date_Delivered')),[`DID`]: (getObjectProperty(Load_Data, 'ID')),[`QR`]: URL2,[`CLOGO`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Logo')),[`CNAME`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Registered_Name')),[`A1`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Physical_Address')),[`A2`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Postal_Code')),[`Phone`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Phone_1')),[`Email`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Email_Admin')),[`CUSLOGO`]: (getObjectProperty(Customer, 'Customer Logo')),[`CID`]: (getObjectProperty(Customer, 'ID')),[`CUST`]: (getObjectProperty(Customer, 'Customer_Registered_Name')),[`CA1`]: (getObjectProperty(Customer, 'Address Line 1')),[`CA2`]: (getObjectProperty(Customer, 'Address Line 2')),[`CEMAIL`]: (getObjectProperty(Customer, 'Customer_Admin_Email')),[`CLAND`]: (getObjectProperty(Customer, 'Customer_Phone')),[`CMOBILE`]: (getObjectProperty(Customer, 'Contact_Phone')),[`CVAT`]: (getObjectProperty(Customer, 'Customer_Vat_Number')),[`ED1`]: 'Vehicle Registration:',[`ED2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? null : 'Trailer 1 Registration:',[`ED3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? null : 'Trailer 2 Registration:',[`ED4`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? null : 'Trailer 3 Registration:',[`ED5`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')))) ? null : 'Driver:',[`ED6`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')))) ? null : 'Driver ID#:',[`ED7`]: 'Product:',[`ED8`]: 'Units Loaded:',[`ED9`]: 'Load Time:',[`ED10`]: 'Load Location:',[`ED11`]: 'Location Contact:',[`ED12`]: 'Location Contact Phone:',[`EV1`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')),[`EV2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Registration')),[`EV3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Registration')),[`EV4`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Registration')),[`EV5`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')))) ? null : [(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Nickname')),' ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Surname'))].join(''),[`EV6`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_ID_Number')),[`EV7`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Product')),[`EV8`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Tonnage_Loaded')),[`EV9`]: (new Date((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Date_Loaded')))),[`EV10`]: (getObjectProperty(Load_Location, 'Name')),[`EV11`]: (getObjectProperty(Load_Location, 'Contact_Name')),[`EV12`]: (getObjectProperty(Load_Location, 'Phone')),[`DD1`]: 'Vehicle Registration:',[`DD2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? null : 'Trailer 1 Registration:',[`DD3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? null : 'Trailer 2 Registration:',[`DD4`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? null : 'Trailer 3 Registration:',[`DD5`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')))) ? null : 'Driver:',[`DD6`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')))) ? null : 'Driver ID#:',[`DD7`]: 'Product:',[`DD8`]: 'Units Delivered:',[`DD9`]: 'Delivery Time:',[`DD10`]: 'Delivery Location:',[`DD11`]: 'Location Contact:',[`DD12`]: 'Location Contact Phone:',[`DV1`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')),[`DV2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Registration')),[`DV3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Registration')),[`DV4`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Registration')),[`DV5`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')))) ? null : [(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Nickname')),' ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Surname'))].join(''),[`DV6`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_ID_Number')),[`DV7`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Product')),[`DV8`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Tonnage_Delivered')),[`DV9`]: (new Date((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Date_Delivered')))),[`DV10`]: (getObjectProperty(Delivery_Location, 'Name')),[`DV11`]: (getObjectProperty(Delivery_Location, 'Contact_Name')),[`DV12`]: (getObjectProperty(Delivery_Location, 'Phone')),[`LI1`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Load_Image_1')),[`LI2`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Load_Image_2')),[`LI3`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Load_Image_3')),[`DI1`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Delivery_Image_1')),[`DI2`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Delivery_Image_2')),[`DI3`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Delivery_Image_3')),[`DSL`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Signature Load Driver')),[`DSD`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Signature Delivery Driver')),[`LSL`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Signature Load Depot')),[`RSD`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Signature Delivery Depot')) });
  console.log((await (async function(ID, Name, Data) {
  	async function generatePDF({ ID, Name, Data }) {
  	    if (!ID || !Name || !Data) {
  	        console.error("❌ Missing required parameters:", { ID, Name, Data });
  	        return { error: "Missing ID, Name, or Data" };
  	    }
  	
  	    const fileName = `${Name}(${ID})`;
  	
  	    console.log("📡 Sending API Request to Backendless PDF Generator...");
  	    
  	    try {
  	        const response = await fetch(
  	            `${Backendless.appPath}/services/PDFGeneratorAPI/generateDocument/${ID}/${fileName}`,
  	            {
  	                method: "POST",
  	                headers: {
  	                    "Content-Type": "application/json",
  	                    "user-token": Backendless.getCurrentUserToken(),
  	                },
  	                body: JSON.stringify({ data: Data }),
  	            }
  	        );
  	
  	        if (!response.ok) {
  	            throw new Error(`API request failed: ${response.status} ${response.statusText}`);
  	        }
  	
  	        const result = await response.json();
  	        console.log("✅ API Response:", result);
  	
  	        if (!result || !result.fileUrl) {
  	            throw new Error("API returned an invalid response: Missing fileUrl");
  	        }
  	
  	        return result; // Return the response with fileUrl
  	
  	    } catch (error) {
  	        console.error("🚨 Error generating PDF:", error);
  	        return { error: error.message || "Unknown error occurred" };
  	    }
  	}

  })('1186526', File_Name, PDF_Data)));
  console.log(getObjectProperty(___arguments.context.pageData, 'PDF Test'));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record'))['Delivery Noted'] = true;
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record'))['Delivery Note'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'PDF Test')), 'fileUrl'));
  await Backendless.Data.of('Loads').save((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), true);
}


  await PDF_Generation();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Delivery Note'))))) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/d3235b339e6e127d61b43af82adb14f9/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('8c4784111a8c65c7992b2fc432dde829');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('8c4784111a8c65c7992b2fc432dde829');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('b60663c4b5eb29e9c2dc2d7f8097446c', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/61912e7d62cd56249f5eaacc60c9a0d4/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('c46daa3a211d8887e3632556d2dd7ff8');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('c46daa3a211d8887e3632556d2dd7ff8');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Admin Capture Load'] = true;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f3e9c22366f902aef4819ddad8b9b81a', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64c99a9b58ffea63cdef471e3503be85', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('318b7c7d84ce11ee39e9730176875287', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/b96a8582ecb3383616c5179d0f83a325/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('96d5aa1c285d30648f6103b4de798a03');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('96d5aa1c285d30648f6103b4de798a03');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('5365d977708581532eba1f2c1e4df6ed', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))))) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/bf5a2f066b83fe23bb9ef5ad17cfa95e/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('1aa9ea644fab97e59be83971d4df16c2');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('1aa9ea644fab97e59be83971d4df16c2');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('395ad40c1f2ebd1c06742226703b6e28', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/395ad40c1f2ebd1c06742226703b6e28/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
      ___arguments.context.pageData['Fleet Data (Selected Item)'] = ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd');

  },
  /* handler:onOpen */
  /* handler:onClose */
  ['onClose'](___arguments) {
      delete ___arguments.context.pageData['Fleet Data (Selected Item)'];

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/Assets/components/5365d977708581532eba1f2c1e4df6ed/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
      ___arguments.context.pageData['Fleet Data (Selected Item)'] = ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd');

  },
  /* handler:onOpen */
  /* handler:onClose */
  ['onClose'](___arguments) {
      delete ___arguments.context.pageData['Fleet Data (Selected Item)'];

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/Assets/components/2873a923fb3f187cad255927c462c267/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
      ___arguments.context.pageData['Fleet Data (Selected Item)'] = ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd');

  },
  /* handler:onOpen */
  /* handler:onClose */
  ['onClose'](___arguments) {
      delete ___arguments.context.pageData['Fleet Data (Selected Item)'];

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/Assets/components/b60663c4b5eb29e9c2dc2d7f8097446c/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
      ___arguments.context.pageData['Fleet Data (Selected Item)'] = ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd');

  },
  /* handler:onOpen */
  /* handler:onClose */
  ['onClose'](___arguments) {
      delete ___arguments.context.pageData['Fleet Data (Selected Item)'];

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/Assets/components/2bcc437cab5a1a6e06e2fcc88fae33ba/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('6d23d369c1225d2c3d2ee0d5fffaf176', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/ac7f451cd45d74f1dd3cb49db27bf22d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Delivery Note'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:pdfUrlLogic */
  ['pdfUrlLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Delivery Note'))

  },
  /* handler:pdfUrlLogic */
  /* content */
}))

define('./pages/Assets/components/12ffcd2a0f5af80bebf447edfaf53caf/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  async ['onOpen'](___arguments) {
    var error;


  try {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('54e46ad5dd540d7d78dfc97bb49bf491', undefined);

  } catch (error) {
    console.log(error);

  }
  try {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('f10bd64cc129f88548e7cbe1e2c695a4', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onOpen */
  /* content */
}))

define('./pages/Assets/components/edeb83e1a80ce4f5742876fa8c0605bf/bundle.js', [], () => ({
  /* content */
  /* handler:isOpenLogic */
  async ['isOpenLogic'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'currentTracking'))))) {
    Viewer = false;
  } else {
    console.log('abc');
    Viewer = true;
  }

  return Viewer

  },
  /* handler:isOpenLogic */
  /* content */
}))

define('./pages/Assets/components/863620f21f2b7c16616f20380861aba2/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('863620f21f2b7c16616f20380861aba2'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('863620f21f2b7c16616f20380861aba2'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('5a14f32994e6caf42a31da219928469c', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/188332f3e6750b1abf98b8b841aa75ef/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('188332f3e6750b1abf98b8b841aa75ef'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('188332f3e6750b1abf98b8b841aa75ef'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('85d5161ed299299a8631f2b2be646e4f', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/cc5af7767f4ee0f487f6dad487b70ec6/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectDelete */
  ['onObjectDelete'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  try {
    removeItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), ___arguments.deletedObject, 'objectId');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onObjectCreate */
  async ['onObjectCreate'](___arguments) {
    var error, Customer_Result, Transaction, New_Customer, ID, ID_Number_Variable, ID_Start, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    ID_Number_Variable = String((Number((subsequenceFromEndLast((getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), 1, async (item) => {


     return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 3))));
    })).slice(-1)[0]), 'ID')), 3)))) + 1);

  } catch (error) {
    console.log(error);

  } finally {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](ID_Number_Variable))) {
      ID_Number_Variable = 1;
    }

  }
  try {
    ID_Start = subsequenceFirstFromEnd((getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), 1, async (item) => {


     return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 3))));
    })).slice(-1)[0]), 'ID')), 4);

  } catch (error) {
    console.log(error);

  } finally {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](ID_Start))) {
      ID_Start = String((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')).slice(0, 5)) + String(' C ');
    }

  }
  ID = String(ID_Start) + String(getValueLength(ID_Number_Variable) == 1 ? String('000') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 2 ? String('00') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 3 ? String('0') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 4 ? ID_Number_Variable : ID_Number_Variable))));
  New_Customer = ___arguments.newObject;
  New_Customer['ownerId'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId'));
  New_Customer['ID'] = ID;
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    _uow.upsert('Customers', New_Customer);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers', [New_Customer]);

  })();

  Customer_Result = (getObjectProperty((getObjectProperty((getObjectProperty((await Transaction.execute()), 'results')), 'upsertCustomers1')), 'result'));
  console.log(Customer_Result);
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), Customer_Result);

  } catch (error) {
    console.log(error);

  }
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('cc5af7767f4ee0f487f6dad487b70ec6');

  },
  /* handler:onObjectCreate */
  /* handler:onObjectUpdate */
  async ['onObjectUpdate'](___arguments) {
    var error, item, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    Object.assign(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.newObject, 'objectId')));
    }))[0]), ___arguments.newObject);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onObjectUpdate */
  /* content */
}))

define('./pages/Assets/components/a5e27ab8d29f802997a689db551fbc2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Add'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/aeefc82aed02445d3ad24a5c936b97f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7e6344e80f63fee1c27a29e135d8f3da', (removeItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products')), ___arguments.context.getComponentDataStoreByUid('0afd2daf30efd41463d4f84b0ea3da4c'), 'Product')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Edit'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/f05b94c73b1cca3dfd1a9e5efdeec0ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Edit'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/d4447d1339666adea5427303c2d4505c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products'))))) {
    (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))['Products'] = [];
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7e6344e80f63fee1c27a29e135d8f3da', (addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products')), (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product')))));
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['New Product'];
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6e6c7b4ffab7f4feaf0ec6a4e115387f'))['value'] = 0;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('626fc977a4e98e5df10dcb9ae13c8255'))['value'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9e7252e717740cc82f31260fe3719aa9'))['value'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e6344e80f63fee1c27a29e135d8f3da', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e6344e80f63fee1c27a29e135d8f3da', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product'))))) {
    Viewer = false;
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product')), 'Product'))))) {
      Viewer = false;
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product')), 'Mass'))))) {
        Viewer = false;
      } else {
        Viewer = true;
      }
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/c46483291b3508e59064ee84fcfc4ede/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('85d5161ed299299a8631f2b2be646e4f', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/626fc977a4e98e5df10dcb9ae13c8255/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product'))))) {
    ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['New Product'] = ({ [`Product`]: ___arguments.value });
  } else {
    (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product'))['Product'] = ___arguments.value;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/85d5161ed299299a8631f2b2be646e4f/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  async ['onOpen'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    List = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      List = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products'))))) {
        List = [];
      } else {
        List = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products'));
      }
    }
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7e6344e80f63fee1c27a29e135d8f3da', (await asyncListSort(List, 1, async (item) => {


   return (getObjectProperty(item, 'Product'));
  })));

  },
  /* handler:onOpen */
  /* content */
}))

define('./pages/Assets/components/c51eb91741c7599e2dfd5ca19eeb4a69/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      console.log(___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/6bcfe306c83bf336c5d377bd4a474c34/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? [] : (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'Status')) != 'Delivered');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Sequence'));
  }))));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Assets/components/05a35c369a85e4fc3136c775d0e78beb/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('c738c7870c59eb12b8e39a1bab335683');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('c738c7870c59eb12b8e39a1bab335683');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('1737c0e26f8e706cbad9f399d099912f', undefined);
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailer (Unhitch)'] = 'Trailer1';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/4d24ea755c2988676d42c73d36fc014f/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      await new Promise(r => setTimeout(r, 100 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5b89c33aa35935fcf14c2517974cad48', true);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Assets/components/a82a71555895d0a85b45d9f151c8f0e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('b60663c4b5eb29e9c2dc2d7f8097446c', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/8046e538a0fd7681824fb7c6576e5278/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      await new Promise(r => setTimeout(r, 100 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7a1d4ba21383765d555b14c5a027f713', true);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Assets/components/d9191f1cb10c03430e8cfde1e6542e2b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('2873a923fb3f187cad255927c462c267', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/207cccbb4d4d1a7be6f6bfa125959bf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('5365d977708581532eba1f2c1e4df6ed', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/063e6166a8f451ecf5ad5416d7d691de/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      await new Promise(r => setTimeout(r, 100 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d18abed0dbd0076da3f21ee6fd333cb', true);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Assets/components/82b25d28e054a2f3b05d0eceb078f14b/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      await new Promise(r => setTimeout(r, 100 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5098edb6b468e14e6c9122bd51552a07', undefined);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Assets/components/17a63fce61d3bf5597bf72843edf132c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('395ad40c1f2ebd1c06742226703b6e28', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/e1a210fc708f554b9eaabeaece02dbc3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Transaction_Step_1, Transaction_Step_2, Tyres, Fuel_Transaction, Tractor, Fuel, item, Fleetview_Current, ObjectId, Mileage_Differential, Axle_List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

/**
 * Describe this function...
 */
async function Fuel_Transaction2() {
  Mileage_Differential = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'));
  Tractor = (await Backendless.Data.of('Tractors').findById(ObjectId, ));
  Fuel = ({ [`Admin`]: true,[`Location_Submitted`]: undefined,[`Fuel_Consumption_Ideal`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Consumption_Ideal')),[`TObjectID`]: ObjectId,[`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost')),[`Description`]: ((new Date()).toDateString()),[`Fuel_Count`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))),[`Litres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres')),[`Mileage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')),[`Mileage_last`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Fuel_Transaction_Mileage')),[`Station_Unknown`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other')),[`Station`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other')))) ? (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('c9a8d33d1d9b9b0bb095331ba6ddee7f')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c9a8d33d1d9b9b0bb095331ba6ddee7f')))) : null,[`Wages_Contractor_Km_Rate`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Contractor_Mileage')),[`Wages_Good_Driving_Rate`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Good_Driving')),[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ownerId')) });
  Fleetview_Current = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current'));
  Fleetview_Current['Current_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  Fleetview_Current['Distance_Travelled'] = ((getObjectProperty(Fleetview_Current, 'Distance_Travelled')) + ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Fuel_Transaction_Mileage'))));
  Fleetview_Current['Fuel_Cost'] = ((getObjectProperty(Fleetview_Current, 'Fuel_Cost')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost')));
  Fleetview_Current['Fuel_Litres'] = ((Number((getObjectProperty(Fleetview_Current, 'Fuel_Litres')))) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres')));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Now'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Odometer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Fuel_Transaction_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Fuel_Counter'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))));
  (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty(item, 'objectId')));
  }))['Now'] = (new Date());
  (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty(item, 'objectId')));
  }))['Odometer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty(item, 'objectId')));
  }))['Last_Fuel_Transaction_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty(item, 'objectId')));
  }))['Fuel_Counter'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))));
  Tractor['Now'] = (new Date());
  Tractor['Odometer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  Tractor['Last_Fuel_Transaction_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  Tractor['Fuel_Counter'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))));
  Fuel_Transaction = (await Backendless.Data.of('Fuel').save( Fuel ));
  Transaction_Step_1 = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction_Step_1;

    _uow.upsert('Tractors', Tractor);
    _uow.addToRelation('Tractors', Tractor, 'Fuel', [Fuel_Transaction]);
    _uow.setRelation('Tractors', Tractor, 'Fuel_Last', [Fuel_Transaction]);
    _uow.addToRelation('Employees', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_Transactions_Fuel', [Fuel_Transaction]);
    _uow.addToRelation('Employees', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_Transactions_Fuel', [Fuel_Transaction]);
    _uow.setRelation('Fuel', Fuel_Transaction, 'Company', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')));
    _uow.setRelation('Fuel', Fuel_Transaction, 'Tractor', Tractor);
    _uow.addToRelation('Fuel', Fuel_Transaction, 'Driver', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')));
    _uow.bulkUpsert('Tyres', Tyres);

  })();

  Transaction_Step_2 = (await Transaction_Step_1.execute());
}

/**
 * Describe this function...
 */
async function Tyre_Function() {
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Axles_Data'))))) {
    Axle_List = [];
  } else {
    Axle_List = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Axles_Data'));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
  } else {
    Axle_List = (Axle_List.concat((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Axles_Data'))));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
  } else {
    Axle_List = (Axle_List.concat((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Axles_Data'))));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3'))))) {
  } else {
    Axle_List = (Axle_List.concat((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Axles_Data'))));
  }
  Tyres = (await BackendlessUI.Functions.Custom['fn_c8249d71574777eb2a08c21c7e28faee'](Axle_List, ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')))));
}

/**
 * Describe this function...
 */
async function Form_Terms() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Mileage'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station'))))) {
        try {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

        } catch (error) {

        }
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost'))))) {
          try {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

          } catch (error) {

          }
        } else {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres'))))) {
            try {
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

            } catch (error) {

            }
          } else {
            if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'))))) {
              try {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

              } catch (error) {

              }
            } else {
              if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c8fcfc52fa25fba8393a975589bf0e6')), 'display')) == true) {
                if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other'))))) {
                  try {
                    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

                  } catch (error) {

                  }
                }
              } else {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
              }
            }
          }
        }
      }
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

      } catch (error) {

      }
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4852d7ed351145bad171b1acc629153', false);

      } catch (error) {

      }
    }
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

    } catch (error) {

    }
  }
}

/**
 * Describe this function...
 */
async function Clear_Form() {
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('c9a8d33d1d9b9b0bb095331ba6ddee7f', null);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea62b7b7a6950b8e6fe481f980059575'))['value'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('72654496dd632229449b515574ee7ead'))['value'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e006439ffb574701488344546dbe8137'))['value'] = null;
  await new Promise(r => setTimeout(r, 200 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('800fe80c414539252fbae03db5de918b', false);
  await new Promise(r => setTimeout(r, 200 || 0));
  delete ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Cost'];
  delete ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Mileage'];
  delete ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Litres'];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('800fe80c414539252fbae03db5de918b', true);
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4852d7ed351145bad171b1acc629153', false);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e1a210fc708f554b9eaabeaece02dbc3'))['disabled'] = true;
  ObjectId = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'));
  await Tyre_Function();
  await Fuel_Transaction2();
  console.log((await BackendlessUI.Functions.Custom['fn_88481472e3e169797cae85c104751a08']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'))));
  await Clear_Form();
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e1a210fc708f554b9eaabeaece02dbc3'))['disabled'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4852d7ed351145bad171b1acc629153', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/a72258bd0e8e322ec511ea54048e7b02/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Tractor, Driver_TX, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Driver_Disembark() {
  Driver_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Driver_TX;

    console.log('abc');
    (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'objectId')) == (getObjectProperty(item, 'objectId')));
    }))['Driver_Warehouse_Status'] = 'In';
    _uow.update('Employees', (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'objectId')) == (getObjectProperty(item, 'objectId')));
    }))).setOpResultId('Driver Update Details');
    console.log('abc');
    _uow.deleteRelation('Employees', (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'objectId')) == (getObjectProperty(item, 'objectId')));
    })), 'Driver_Tractor', [Tractor]).setOpResultId('Employee Tractor Delete Operation');
    ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(Tractor, 'objectId')) == (getObjectProperty(item, 'objectId')));
    }))[0])['Warehouse'] = 'In';
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Warehouse'] = 'In';
    console.log('abc');
    Tractor['Warehouse'] = 'In';
    _uow.update('Tractors', Tractor).setOpResultId('Tractor Warehouse Update');
    console.log('abc');
    _uow.deleteRelation('Tractors', Tractor, 'Driver1', (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'objectId')) == (getObjectProperty(item, 'objectId')));
    }))).setOpResultId('Driver  Tractor Delete Operation');
    try {
      (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty(item, 'objectId')));
      }))['Driver1'] = null;

    } catch (error) {
      console.log(error);

    }
    console.log('abc');
    try {
      ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Driver1'] = null;

    } catch (error) {
      console.log(error);

    }

  })();

  console.log((await Driver_TX.execute()));
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a72258bd0e8e322ec511ea54048e7b02'))['disabled'] = true;
  delete ___arguments.context.getComponentDataStoreByUid('5098edb6b468e14e6c9122bd51552a07')['Mileage'];
  Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), ));
  await Driver_Disembark();
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('395ad40c1f2ebd1c06742226703b6e28', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/b6d383a8cecf3111daedc6e2c1116e5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Tractor, Driver_TX, Employee_TX, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

/**
 * Describe this function...
 */
async function Driver_Board() {
  Driver_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Driver_TX;

    ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('f947aaa106414ff718daf48ad2ea595d')));
    }))[0])['Driver_Warehouse_Status'] = 'Out';
    Employee_TX = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('f947aaa106414ff718daf48ad2ea595d')));
    }))[0];
    delete Employee_TX['Tractor'];
    _uow.update('Employees', Employee_TX).setOpResultId('Driver Update Details');
    _uow.setRelation('Employees', ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('f947aaa106414ff718daf48ad2ea595d')));
    }))[0]), 'Driver_Tractor', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'))]).setOpResultId('Employee Tractor Set Operation');
    (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')));
    }))['Warehouse'] = 'Out';
    Tractor['Warehouse'] = 'Out';
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Warehouse'] = 'Out';
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Driver1'] = Employee_TX;
    (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')));
    }))['Driver1'] = Employee_TX;
    _uow.update('Tractors', Tractor).setOpResultId('Tractor Warehouse Update');
    _uow.setRelation('Tractors', Tractor, 'Driver1', [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('f947aaa106414ff718daf48ad2ea595d'))]).setOpResultId('Driver  Tractor Set Operation');

  })();

  console.log((await Driver_TX.execute()));
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b6d383a8cecf3111daedc6e2c1116e5d'))['disabled'] = true;
  Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), ));
  await Driver_Board();
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('5365d977708581532eba1f2c1e4df6ed', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/f947aaa106414ff718daf48ad2ea595d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees'))))) {
        Options = [];
      } else {
        Options = (await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


         return ((getObjectProperty(item, 'Employee_Details_Position')) == 'Driver' && (getObjectProperty(item, 'Driver_Warehouse_Status')) == 'In');
        })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Employee_Details_Nickname')),'  - (',(getObjectProperty(item, 'Company_ID')),')'].join('') });})));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var List_Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb')['Driver'] = ___arguments.value;
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb'), 'Odometer'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc74e843e6b696d498c194ba5b5aa1f', false);
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb'), 'Odometer')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc74e843e6b696d498c194ba5b5aa1f', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb'), 'Odometer')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc74e843e6b696d498c194ba5b5aa1f', true);
    } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb'), 'Mileage'))))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc74e843e6b696d498c194ba5b5aa1f', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc74e843e6b696d498c194ba5b5aa1f', false);
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb'), 'Odometer')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb'), 'Odometer')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb'), 'Driver'))))) {
          try {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d383a8cecf3111daedc6e2c1116e5d', false);

          } catch (error) {

          }
        } else {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d383a8cecf3111daedc6e2c1116e5d', true);
        }
      } else {
        try {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d383a8cecf3111daedc6e2c1116e5d', false);

        } catch (error) {

        }
      }
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d383a8cecf3111daedc6e2c1116e5d', false);

      } catch (error) {

      }
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/7ccd445ef12702e15a8d811e883faa8d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec59abf5a54e06ed1345d4a340677077', true);
  } else if (___arguments.value > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec59abf5a54e06ed1345d4a340677077', true);
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Mileage'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec59abf5a54e06ed1345d4a340677077', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec59abf5a54e06ed1345d4a340677077', false);
  }
  if (___arguments.value > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a72258bd0e8e322ec511ea54048e7b02', true);
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a72258bd0e8e322ec511ea54048e7b02', false);

      } catch (error) {

      }
    }
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a72258bd0e8e322ec511ea54048e7b02', false);

    } catch (error) {

    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/9c5d62098833038ff1167cdf678b56e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var List_Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb')['Odometer'] = ___arguments.value;
  if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc74e843e6b696d498c194ba5b5aa1f', true);
  } else if (___arguments.value > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc74e843e6b696d498c194ba5b5aa1f', true);
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb'), 'Mileage'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc74e843e6b696d498c194ba5b5aa1f', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc74e843e6b696d498c194ba5b5aa1f', false);
  }
  if (___arguments.value > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb'), 'Driver'))))) {
        try {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d383a8cecf3111daedc6e2c1116e5d', false);

        } catch (error) {

        }
      } else {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d383a8cecf3111daedc6e2c1116e5d', true);
      }
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d383a8cecf3111daedc6e2c1116e5d', false);

      } catch (error) {

      }
    }
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d383a8cecf3111daedc6e2c1116e5d', false);

    } catch (error) {

    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/c9a8d33d1d9b9b0bb095331ba6ddee7f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))) {
        Options = [];
      } else {
        Options = (addItemToList((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Province')),'  - (',(getObjectProperty(item, 'Station_Name')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        })), ({ [`value`]: 'Other Station',[`label`]: 'Other Station' })));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Form_Terms() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Mileage'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station'))))) {
        try {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

        } catch (error) {

        }
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost'))))) {
          try {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

          } catch (error) {

          }
        } else {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres'))))) {
            try {
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

            } catch (error) {

            }
          } else {
            if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'))))) {
              try {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

              } catch (error) {

              }
            } else {
              if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c8fcfc52fa25fba8393a975589bf0e6')), 'display')) == true) {
                if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other'))))) {
                  try {
                    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

                  } catch (error) {

                  }
                } else {
                  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
                }
              } else {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
              }
            }
          }
        }
      }
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

      } catch (error) {

      }
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4852d7ed351145bad171b1acc629153', false);

      } catch (error) {

      }
    }
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

    } catch (error) {

    }
  }
}


  if (___arguments.value == 'Other Station') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c8fcfc52fa25fba8393a975589bf0e6', true);
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c8fcfc52fa25fba8393a975589bf0e6', false);

    } catch (error) {

    }
  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4852d7ed351145bad171b1acc629153', false);

  } catch (error) {

  }
  ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Station'] = ___arguments.value;
  await Form_Terms();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/e006439ffb574701488344546dbe8137/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4852d7ed351145bad171b1acc629153', false);

  } catch (error) {

  }
  ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Mileage'] = ___arguments.value;
  if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if (___arguments.value > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Mileage'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  }
  if (___arguments.value > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station'))))) {
        try {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

        } catch (error) {

        }
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost'))))) {
          try {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

          } catch (error) {

          }
        } else {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres'))))) {
            try {
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

            } catch (error) {

            }
          } else {
            if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'))))) {
              try {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

              } catch (error) {

              }
            } else {
              if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c8fcfc52fa25fba8393a975589bf0e6')), 'display')) == true) {
                if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other'))))) {
                  try {
                    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

                  } catch (error) {

                  }
                } else {
                  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
                }
              } else {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
              }
            }
          }
        }
      }
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

      } catch (error) {

      }
    }
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

    } catch (error) {

    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/72654496dd632229449b515574ee7ead/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Station, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function roundDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4852d7ed351145bad171b1acc629153', false);

  } catch (error) {

  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other'))))) {
    Station = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c9a8d33d1d9b9b0bb095331ba6ddee7f')));
    }))[0];
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea62b7b7a6950b8e6fe481f980059575'))['value'] = (roundDecimals((___arguments.value * (getObjectProperty(Station, 'Price'))),2));
    ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Cost'] = (roundDecimals((___arguments.value * (getObjectProperty(Station, 'Price'))),2));
    ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Litres'] = ___arguments.value;
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
    } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Mileage'))))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station'))))) {
          try {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

          } catch (error) {

          }
        } else {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost'))))) {
            try {
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

            } catch (error) {

            }
          } else {
            if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres'))))) {
              try {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

              } catch (error) {

              }
            } else {
              if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'))))) {
                try {
                  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

                } catch (error) {

                }
              } else {
                if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c8fcfc52fa25fba8393a975589bf0e6')), 'display')) == true) {
                  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other'))))) {
                    try {
                      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

                    } catch (error) {

                    }
                  } else {
                    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
                  }
                } else {
                  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
                }
              }
            }
          }
        }
      } else {
        try {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

        } catch (error) {

        }
      }
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

      } catch (error) {

      }
    }
  } else {
    ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Litres'] = ___arguments.value;
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
    } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Mileage'))))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station'))))) {
          try {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

          } catch (error) {

          }
        } else {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost'))))) {
            try {
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

            } catch (error) {

            }
          } else {
            if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres'))))) {
              try {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

              } catch (error) {

              }
            } else {
              if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'))))) {
                try {
                  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

                } catch (error) {

                }
              } else {
                if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c8fcfc52fa25fba8393a975589bf0e6')), 'display')) == true) {
                  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other'))))) {
                    try {
                      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

                    } catch (error) {

                    }
                  }
                } else {
                  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
                }
              }
            }
          }
        }
      } else {
        try {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

        } catch (error) {

        }
      }
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

      } catch (error) {

      }
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/ea62b7b7a6950b8e6fe481f980059575/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4852d7ed351145bad171b1acc629153', false);

  } catch (error) {

  }
  ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Cost'] = ___arguments.value;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Mileage'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station'))))) {
        try {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

        } catch (error) {

        }
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost'))))) {
          try {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

          } catch (error) {

          }
        } else {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres'))))) {
            try {
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

            } catch (error) {

            }
          } else {
            if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'))))) {
              try {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

              } catch (error) {

              }
            } else {
              if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c8fcfc52fa25fba8393a975589bf0e6')), 'display')) == true) {
                if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other'))))) {
                  try {
                    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

                  } catch (error) {

                  }
                } else {
                  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
                }
              } else {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
              }
            }
          }
        }
      }
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

      } catch (error) {

      }
    }
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

    } catch (error) {

    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/11f3192f32f514bfec1d7301319cc547/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var Next_Load, error, Next_Load_Step_1, Transaction, Last_Load, Created_Load__Transaction_, Trailers, item, Loads;

/**
 * Describe this function...
 */
async function Last_Load_Function(Loads) {
}


  console.log(___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/1b25478b9c9c973ec4bae2053bb51565/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Customer'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/3f4a753e67d77774526f0f0ddf6d9a1b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Delivery (Units)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/1768476b2666130ce9cf65554b0d7765/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Delivery (Point)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/d3f34c0b43268ebcb18b6cff2c763833/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Delivery (Mileage)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/24c3cc71f9650437e487b2415126cf3e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Delivery (Date)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/384fc76acd1db82351e875bc257239d9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Invoice (Load Reference)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/c5bec1c6d2e7de5a799bb2a70e8567c8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Invoice (Product)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/3945cba3f8f556fcadb2626e93d92bd1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Loading (Point)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/a47a99cc64971b743af262b260d8271e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Loading (Mileage)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/34c39d75c55f95b9b2a85bb85036be08/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Loading (Date)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/c3d22f3c7bb22bee487ec33bbb215595/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Loading (Units)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/53216099bfcebd1abae17dce3de958e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b25478b9c9c973ec4bae2053bb51565'));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('384fc76acd1db82351e875bc257239d9'));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c5bec1c6d2e7de5a799bb2a70e8567c8'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).collapse() })('72fb3673b8d68b375f2f40296684cf96');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('034aff73e9a8d4533827c9497d19af8a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('72fb3673b8d68b375f2f40296684cf96', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/37d950a1fd299f07c2dbfb3d83bd6dae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e2e9d66be7c6886f2891b67956f025c', true);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).collapse() })('034aff73e9a8d4533827c9497d19af8a');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/61bc15fe8afd29a6515b87f32bede60a/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('61bc15fe8afd29a6515b87f32bede60a'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('61bc15fe8afd29a6515b87f32bede60a'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('d6fa4831d4b8222782da812481678bb4', undefined);
  ___arguments.context.pageData['Asset Drawer Data'] = 'Trailers';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/d8d8ab464126405ce189515e68266c4b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8d8ab464126405ce189515e68266c4b'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8d8ab464126405ce189515e68266c4b'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('d6fa4831d4b8222782da812481678bb4', undefined);
  ___arguments.context.pageData['Asset Drawer Data'] = 'Tyres';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/fade00ef4ac3039fb35f8cb90e3f57a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Asset Drawer Data')) == 'Tractors') {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onObjectUpdate */
  async ['onObjectUpdate'](___arguments) {
    var item, objectId, Tractor, Updated_Data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Updater(objectId) {
  Tractor = (await Backendless.Data.of('Tractors').findById(objectId, Backendless.DataQueryBuilder.create().setRelated(['Other', 'Trailer1.Maintenance', 'Trailer2.Maintenance', 'Trailer3.Maintenance', 'Current_Fleetview', 'Current_Fleetview.Fuel', 'Current_Fleetview.Loads', 'Company', 'Trailer1', 'Trailer2', 'Trailer3', 'Trailer1.Axles_Data.Tyre L1.Transactions', 'Trailer1.Axles_Data.Tyre L2.Transactions', 'Trailer1.Axles_Data.Tyre L3.Transactions', 'Trailer1.Axles_Data.Tyre L4.Transactions', 'Trailer1.Axles_Data.Tyre R1.Transactions', 'Trailer1.Axles_Data.Tyre R2.Transactions', 'Trailer1.Axles_Data.Tyre R3.Transactions', 'Trailer1.Axles_Data.Tyre R4.Transactions', 'Trailer2.Axles_Data.Tyre L1.Transactions', 'Trailer2.Axles_Data.Tyre L2.Transactions', 'Trailer2.Axles_Data.Tyre L3.Transactions', 'Trailer2.Axles_Data.Tyre L4.Transactions', 'Trailer2.Axles_Data.Tyre R1.Transactions', 'Trailer2.Axles_Data.Tyre R2.Transactions', 'Trailer2.Axles_Data.Tyre R3.Transactions', 'Trailer2.Axles_Data.Tyre R4.Transactions', 'Trailer3.Axles_Data.Tyre L1.Transactions', 'Trailer3.Axles_Data.Tyre L2.Transactions', 'Trailer3.Axles_Data.Tyre L3.Transactions', 'Trailer3.Axles_Data.Tyre L4.Transactions', 'Trailer3.Axles_Data.Tyre R1.Transactions', 'Trailer3.Axles_Data.Tyre R2.Transactions', 'Trailer3.Axles_Data.Tyre R3.Transactions', 'Trailer3.Axles_Data.Tyre R4.Transactions', 'Axles_Data', 'Axles_Data.Tyre L1', 'Axles_Data.Tyre L2', 'Axles_Data.Tyre L3', 'Axles_Data.Tyre L4', 'Axles_Data.Tyre R1', 'Axles_Data.Tyre R2', 'Axles_Data.Tyre R3', 'Axles_Data.Tyre R4', 'Trailer1.Axles_Data', 'Trailer2.Axles_Data', 'Trailer3.Axles_Data', 'Breakdowns', 'Driver1', 'Conductor1', 'Conductor2', 'Driver1.Wages_Current', 'Conductor1.Wages_Current', 'Conductor2.Wages_Current', 'Fuel', 'Loads', 'Maintenance', 'Other', 'Tyres', 'Driver1.Wages_Current.Fuel', 'Driver1.Wages_Current.Loads'])));
  Updated_Data = (await BackendlessUI.Functions.Custom['fn_88481472e3e169797cae85c104751a08']((getObjectProperty(Tractor, 'objectId')), Tractor));
  console.log(Updated_Data);
  ((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(Tractor, 'objectId')));
  }))[0])['Current_Fleetview'] = (getObjectProperty(Updated_Data, 'Fleetview'));
  ((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(Tractor, 'objectId')));
  }))[0])['Current_Fleetview'] = (getObjectProperty(Updated_Data, 'Fleetview'));
  ((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(Tractor, 'objectId')));
  }))[0])['Fleetview_Current'] = (getObjectProperty(Updated_Data, 'Fleetview'));
  Object.assign(((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(Tractor, 'objectId')));
  }))[0]), (getObjectProperty(Updated_Data, 'Tractor')));
}


  await Updater((getObjectProperty(___arguments.newObject, 'objectId')));

  },
  /* handler:onObjectUpdate */
  /* content */
}))

define('./pages/Assets/components/fddd48f147591336f036f652e48e5c5b/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Status = \'All In Order\' AND Warehouse = \'Out\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    var item, j, Vehicle;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.selectedRecord, 'Tractor_ObjectId'))))) {
    Vehicle = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return ((getObjectProperty(___arguments.selectedRecord, 'Trailer_ObjectId')) == (getObjectProperty(item, 'objectId')));
    }))[0];
  } else {
    Vehicle = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(___arguments.selectedRecord, 'Tractor_ObjectId')) == (getObjectProperty(item, 'objectId')));
    }))[0];
  }
  ___arguments.context.pageData['Assets Drawer - Selected Tyre Vehicle'] = Vehicle;
  ___arguments.context.pageData['Assets Drawer - Selected Tyre objectId'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));
  await new Promise(r => setTimeout(r, 1000 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('0d79046be1317947dd77a45864f33585', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Road')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/d007637a200c7a7b00e7a7f8effa9352/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Asset Drawer Data')) == 'Trailers') {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Assets/components/123e913ad49ef847d58b813578987293/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Viewer;


  delete ___arguments.context.pageData['Asset Drawer Data'];
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('d6fa4831d4b8222782da812481678bb4', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/a4b90a597df4c0d157c6e0fa19b37a38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('5a14f32994e6caf42a31da219928469c', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/f45ceee83cb71f76dac6684e57e89779/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service_Status')) == 'Service Due' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Service_Status')) == 'Service Due' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Service_Status')) == 'Service Due' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Service_Status')) == 'Service Due') {
      await new Promise(r => setTimeout(r, 100 || 0));
      if (1 <= (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')), async (item) => {


       return ((getObjectProperty(item, 'Load_Type')) == 'Service');
      })).length) {
        Viewer = false;
      } else {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Unscheduled Services')) == true) {
          if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? true : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Unscheduled Services'))) == true) {
            if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? true : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Unscheduled Services'))) == true) {
              if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? true : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Unscheduled Services'))) == true) {
                Viewer = false;
              } else {
                Viewer = false;
              }
            } else {
              Viewer = true;
            }
          } else {
            Viewer = true;
          }
        } else {
          Viewer = true;
        }
      }
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Service Schedule')) == true) {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Service Schedule'];
  } else {
    ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Service Schedule'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/626126ee345973bebff79412d554483d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Service Schedule')) == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/0e0e41ad2c9fd751a88e531855ba39bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Create_Service, Created_Load, error, item, Load_Variable, Result, Service, Service_ID, Tractor, Trailer, Trailer_Position, Trailers, Transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Trailer_Service_Function(Trailer, Trailer_Position) {
  Load_Variable = ({ [`Service_ID`]: Service_ID,[`Delivery (Client)`]: undefined,[`Customer Name`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('bb84aeddef21b0140a946968e896f37d')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')))),[`Date_Planned_Delivery`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')),[`Date_Planned_Loading`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')),[`Distance_Planned_LDP_To_DP`]: undefined,[`Distance_Planned_LDP_To_LP`]: undefined,[`Distance_Planned_LP_To_DP`]: undefined,[`Financial_Billing_Type`]: undefined,[`Financial_Target_Ideal_Rate_Per_Km`]: undefined,[`Financial_Target_Ideal_Rate_Per_Tonne`]: undefined,[`ID`]: 'Service',[`Load Planner Name`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name')),[`Load Point (Delivery Name)`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('bb84aeddef21b0140a946968e896f37d')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')))),[`Load Point (Load Name)`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('bb84aeddef21b0140a946968e896f37d')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')))),[`CID`]: undefined,[`LLPID`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')),[`LDPID`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')),[`LLDPID`]: undefined,[`Load_Broker`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')),[`Load_Notes`]: 'Service',[`Load_Product`]: 'Service',[`Load_Type`]: 'Service',[`Rig_Cost_Per_Hour`]: undefined,[`Rig_CPK`]: undefined,[`Rig_Payload`]: undefined,[`Status`]: 'Planned',[`Tonnage_Planned`]: undefined,[`Planned Rate Per Unit`]: undefined,[`Planned Mileage`]: undefined,[`Planned Load Value`]: undefined,[`Planned Rate Per Km`]: undefined,[`ownerId`]: (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')));
  }))[0],[`TID`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId (Tractor)')) });
  Service = ({ [`Service_ID`]: Service_ID,[`Vehicle Type`]: 'Trailer',[`Date_Scheduled`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')),[`Status`]: 'Scheduled',[`Supplier`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('bb84aeddef21b0140a946968e896f37d')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')))),[`Type`]: 'Service',[`Trailer ID`]: (getObjectProperty(Trailer, 'objectId')),[`ownerId`]: (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')));
  }))[0] });
  Trailer = (await Backendless.Data.of('Trailers').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId (Tractor)')), ));
  Trailer['Last_Service_Scheduled'] = (getObjectProperty(Trailer, 'Next_Service'));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer_Position))['Last_Service_ID'] = Service_ID;
  Trailer['Last_Service_ID'] = Service_ID;
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Created_Load = (_uow.create('Loads', Load_Variable));
    Create_Service = (_uow.create('Maintenance', Service));
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')));
    }))[0])))) {
    } else {
      _uow.setRelation('Loads', Created_Load, 'Load_Planner', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')));
      }))[0]), 'objectId'))]);
    }
    _uow.setRelation('Loads', Created_Load, 'Location_Delivery_Point', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value'))]);
    _uow.setRelation('Loads', Created_Load, 'Location_Load_Point', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value'))]);
    _uow.setRelation('Loads', Created_Load, 'Rig_Tractor', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId (Tractor)'))]);
    Trailers = (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'objectId'))], async (item) => {


     return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](item)));
    }));
    _uow.setRelation('Loads', Created_Load, 'Rig_Trailers', Trailers);
    _uow.addToRelation('Trailers', (getObjectProperty(Trailer, 'objectId')), 'Maintenance', [Create_Service]);
    _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId (Tractor)')), 'Loads', [Created_Load]);

  })();

  Result = (await Transaction.execute());
  addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')));
  }))[0]), 'Loads')), (getObjectProperty((getObjectProperty((getObjectProperty(Result, 'results')), 'createLoads1')), 'result')));
  await new Promise(r => setTimeout(r, 500 || 0));
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Service Schedule'];
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? [] : (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'Status')) != 'Delivered');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  }))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('318b7c7d84ce11ee39e9730176875287', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64c99a9b58ffea63cdef471e3503be85', false);
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

/**
 * Describe this function...
 */
async function Tractor_Service_Function() {
  Service_ID = (generateUUID().long());
  Load_Variable = ({ [`Delivery (Client)`]: undefined,[`Customer Name`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('bb84aeddef21b0140a946968e896f37d')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')))),[`Date_Planned_Delivery`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')),[`Date_Planned_Loading`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')),[`Distance_Planned_LDP_To_DP`]: undefined,[`Distance_Planned_LDP_To_LP`]: undefined,[`Distance_Planned_LP_To_DP`]: undefined,[`Financial_Billing_Type`]: undefined,[`Financial_Target_Ideal_Rate_Per_Km`]: undefined,[`Financial_Target_Ideal_Rate_Per_Tonne`]: undefined,[`ID`]: 'Service',[`Load Planner Name`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name')),[`Load Point (Delivery Name)`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('bb84aeddef21b0140a946968e896f37d')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')))),[`Load Point (Load Name)`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('bb84aeddef21b0140a946968e896f37d')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')))),[`CID`]: undefined,[`LLPID`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')),[`LDPID`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')),[`LLDPID`]: undefined,[`Load_Broker`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')),[`Load_Notes`]: 'Service',[`Load_Product`]: 'Service',[`Load_Type`]: 'Service',[`Rig_Cost_Per_Hour`]: undefined,[`Rig_CPK`]: undefined,[`Rig_Payload`]: undefined,[`Status`]: 'Planned',[`Tonnage_Planned`]: undefined,[`Planned Rate Per Unit`]: undefined,[`Planned Mileage`]: undefined,[`Planned Load Value`]: undefined,[`Planned Rate Per Km`]: undefined,[`ownerId`]: (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')));
  }))[0],[`TID`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId (Tractor)')),[`Service_ID`]: Service_ID });
  Service = ({ [`Vehicle Type`]: 'Tractor',[`Date_Scheduled`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')),[`Status`]: 'Scheduled',[`Supplier`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('bb84aeddef21b0140a946968e896f37d')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')))),[`Type`]: 'Service',[`TractorId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),[`Service_ID`]: Service_ID,[`ownerId`]: (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')));
  }))[0] });
  Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), ));
  Tractor['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Next_Service'));
  Tractor['Last_Service_ID'] = Service_ID;
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Created_Load = (_uow.create('Loads', Load_Variable));
    Create_Service = (_uow.create('Maintenance', Service));
    try {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loadplanner_ID'))))) {
      } else {
        _uow.setRelation('Loads', Created_Load, 'Load_Planner', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loadplanner_ID'))]);
      }

    } catch (error) {
      console.log(error);

    }
    _uow.setRelation('Loads', Created_Load, 'Location_Delivery_Point', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value'))]);
    _uow.setRelation('Loads', Created_Load, 'Location_Load_Point', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value'))]);
    _uow.setRelation('Loads', Created_Load, 'Rig_Tractor', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'))]);
    _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), 'Loads', [Created_Load]);
    _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), 'Maintenance', [Create_Service]);
    _uow.update('Tractors', Tractor);

  })();

  Result = (await Transaction.execute());
  addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')));
  }))[0]), 'Loads')), (getObjectProperty((getObjectProperty((getObjectProperty(Result, 'results')), 'createLoads1')), 'result')));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Next_Service'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Service_ID'] = Service_ID;
  await new Promise(r => setTimeout(r, 500 || 0));
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Service Schedule'];
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? [] : (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'Status')) != 'Delivered');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  }))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('318b7c7d84ce11ee39e9730176875287', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64c99a9b58ffea63cdef471e3503be85', false);
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service_Status')) == 'Service Due') {
    await Tractor_Service_Function();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/bb84aeddef21b0140a946968e896f37d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
      } else {
        List = (await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


         return ((getObjectProperty(item, 'Type')) == 'Service Centre');
        })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Name')) });})));
      }
    }
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Assets/components/7b8d908ad42a1b66e3ad2293a64a5989/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Trailer, Transaction, Financial_Transaction, Create_Service, Trans, Service, Tractor, Load, Trailer_Position;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Trailer_Service_Function(Trailer, Trailer_Position) {
  Service = ({ [`CapturedBy`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name')),[`Vehicle Type`]: 'Trailer',[`Date_Scheduled`]: (new Date()),[`Date_Started`]: (new Date()),[`Date_Completed`]: (new Date()),[`Status`]: 'Completed',[`Supplier`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('06f5b14abd6aea05bcc6c64ad3f45589')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06f5b14abd6aea05bcc6c64ad3f45589')), 'value')))),[`Type`]: 'Service',[`Mileage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Odometer')),[`Mileage Due`]: (getObjectProperty(Trailer, 'Last_Service_Scheduled')),[`Notes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Comment')),[`TrailerId`]: (getObjectProperty(Trailer, 'objectId')),[`Invoice`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Invoice')),[`ownerId`]: (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')));
  }))[0] });
  Trans = ({ [`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Cost')),[`Description`]: ['Service - (',(getObjectProperty(Trailer, 'objectId')),')'].join(''),[`ownerId`]: (getObjectProperty(Trailer, 'ownerId')) });
  Trailer['Last_Service_Scheduled'] = (getObjectProperty(Trailer, 'Next_Service'));
  Trailer['Last_Service_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Odometer'));
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Create_Service = (_uow.create('Maintenance', Service));
    Financial_Transaction = (_uow.create('Transactions', Trans));
    _uow.addToRelation('Trailers', (getObjectProperty(Trailer, 'objectId')), 'Maintenance', [Create_Service]);
    _uow.addToRelation('Maintenance', Create_Service, 'Transaction', [Financial_Transaction]);

  })();

  console.log((await Transaction.execute()));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type'))))['Last_Service_Scheduled'] = (getObjectProperty(Trailer, 'Next_Service'));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type'))))['Last_Service_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Odometer'));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type'))))['Service_Status'] = 'All In Order';
}

/**
 * Describe this function...
 */
async function Tractor_Service_Function____Service_Item_(Load) {
  console.log('1');
  Trans = ({ [`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Cost')),[`Description`]: ['Service - (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId (Tractor)')),')'].join(''),[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ownerId')) });
  console.log('2');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))['CapturedBy'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name'));
  console.log('3');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))['Date_Scheduled'] = (getObjectProperty(Load, 'Date_Planned_Loading'));
  console.log('4');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))['Date_Started'] = (getObjectProperty(Load, 'Date_Loaded'));
  console.log('5');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))['Date_Completed'] = (getObjectProperty(Load, 'Date_Delivered'));
  console.log('6');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))['Status'] = 'Completed';
  console.log('7');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))['Mileage'] = (getObjectProperty(Load, 'Mileage_Load_Point'));
  console.log('8');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))['Mileage Due'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_Scheduled'));
  console.log('9');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))['Notes'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Comment'));
  console.log('1');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))['Invoice'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Invoice'));
  console.log('2');
  Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), ));
  console.log('3');
  Tractor['Last_Service_ID'] = null;
  console.log('4');
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Service_ID'] = null;
  console.log('5');
  Tractor['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Next_Service'));
  console.log('6');
  Tractor['Last_Service_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Odometer'));
  console.log('7');
  Tractor['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Next_Service'));
  console.log('8');
  console.log(Tractor);
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  console.log('9');
  await ( async () => {
    const _uow = Transaction;

    Financial_Transaction = (_uow.create('Transactions', Trans));
    _uow.addToRelation('Maintenance', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item')), 'Transaction', [Financial_Transaction]);
    _uow.update('Tractors', Tractor);
    _uow.update('Maintenance', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item')));

  })();

  console.log((await Transaction.execute()));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Next_Service'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Service_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Odometer'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Service_Status'] = 'All In Order';
}

/**
 * Describe this function...
 */
async function Tractor_Service_Function() {
  console.log('1');
  Service = ({ [`CapturedBy`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name')),[`Vehicle Type`]: 'Tractor',[`Date_Scheduled`]: (new Date()),[`Date_Started`]: (new Date()),[`Date_Completed`]: (new Date()),[`Status`]: 'Completed',[`Supplier`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('06f5b14abd6aea05bcc6c64ad3f45589')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06f5b14abd6aea05bcc6c64ad3f45589')), 'value')))),[`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Cost')),[`Type`]: 'Service',[`Mileage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Odometer')),[`Mileage Due`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_Scheduled')),[`Notes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Comment')),[`TractorId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),[`Invoice`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Invoice')),[`ownerId`]: (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')));
  }))[0] });
  console.log('2');
  Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), ));
  console.log('3');
  Trans = ({ [`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Cost')),[`Description`]: ['Service - (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),')'].join(''),[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ownerId')) });
  console.log('4');
  Tractor['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Next_Service'));
  console.log('5');
  Tractor['Last_Service_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Odometer'));
  console.log('6');
  Tractor['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Next_Service'));
  console.log('7');
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  console.log('8');
  await ( async () => {
    const _uow = Transaction;

    Create_Service = (_uow.create('Maintenance', Service));
    Financial_Transaction = (_uow.create('Transactions', Trans));
    _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), 'Maintenance', [Create_Service]);
    _uow.addToRelation('Maintenance', Create_Service, 'Transaction', [Financial_Transaction]);
    _uow.update('Tractors', Tractor);

  })();

  console.log('9');
  console.log((await Transaction.execute()));
  console.log('10');
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Next_Service'));
  console.log('11');
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Service_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Odometer'));
  console.log('12');
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Service_Status'] = 'All In Order';
  console.log('13');
}


  console.log('1');
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type')) == 'Tractor') {
    console.log('2');
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))))) {
      console.log('3');
      await Tractor_Service_Function();
    } else {
      console.log('4');
      await Tractor_Service_Function____Service_Item_((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


       return ((getObjectProperty(item, 'Service_ID')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_ID')));
      }))[0]);
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type')) == 'Trailer1') {
    console.log('5');
    await Trailer_Service_Function((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Trailer1');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type')) == 'Trailer2') {
    console.log('6');
    await Trailer_Service_Function((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Trailer2');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type')) == 'Trailer3') {
    console.log('7');
    await Trailer_Service_Function((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Trailer3');
  }
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/48ef96f430c7d032be6ccdf44d58a10e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/5217d211b7e3b874aff5186195cc1c36/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/8a0bebc3c37233918e89c8247e02694b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/e499d3836633ec150465ef049a814831/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/e96cc43573bcce37609bde165107b32c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3'))))) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
      Viewer = false;
    } else {
      if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'FIF_Leader_Select')) == true || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'FIF_Dolly_Select')) == true) {
        Viewer = true;
      }
    }
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('3219e54f18daa02c098161bb21b7aaf3', undefined);
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailer (HItch)'] = 'Trailer3';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/0c4c49b1cb3eb50fe4770223df65ceb6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
      Viewer = false;
    } else {
      if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'FIF_Leader_Select')) == true || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'FIF_Dolly_Select')) == true) {
        Viewer = true;
      }
    }
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('3219e54f18daa02c098161bb21b7aaf3', undefined);
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailer (HItch)'] = 'Trailer2';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/4dcb755e1beeb2cbe6c38f371c71f1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('3219e54f18daa02c098161bb21b7aaf3', undefined);
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailer (HItch)'] = 'Trailer1';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/e6faa40caf032f81ae079ad6cbbda283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Year'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Year'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/39f2280e63e1b4d52c9fd553d6bb98bf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'VIN'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'VIN'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/447b716416f29af38cead1abaf69aa1c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Engine_Number'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Engine_Number'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/69d5a4d357d9157a99e5e2cb8cb9dbdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'));
    }

  } catch (error) {

  }

  return (String(Content) + String(' km'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/d0ce0a61b4cf801e45e550fa550f47ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Registration'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Registration'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/6b8e29fcbfd77cce233aa72ff8849851/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'ID'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'ID'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/af94c7080f11351266743708107d778c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Make'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Make'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/3d45726240d327a48b9ca72e6285f43b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Model'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Model'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/ebbf52fb35b4d8010c76329525492f2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Year'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Year'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/2c4a18abe0c7e23111a7185bd58278c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'VIN'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'VIN'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/8d03147713447a876c1e536434aab86d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Type'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Type'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/b802dd64af5c3399ca788f311d51f279/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Odometer'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Odometer'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/e14d9a0d789f3b0f9a47c2c6e465e8ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Odometer'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Odometer'));
    }

  } catch (error) {

  }

  return (String(Content) + String(' km'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/61e69d7a3a167f916b6e800c5a5330b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Nickname'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Nickname'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/08725f6db21f457b507a068e347cd16c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Company_ID'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Company_ID'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/30bcf656bc9f8605f2eafb933637f8c6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Forenames'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Forenames'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/f18e8779217bafa89f7261add48f96d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Surname'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Surname'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/ee4e7236088d2af146ea99cc0c1bc093/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_ID_Number'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_ID_Number'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/1fec8f38b4293518ee49d74cea2dce6a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Phone'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Phone'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/4d4985af4fafda64d70d5a5bc4b7aa0a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Emergency_ICE_Name'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Emergency_ICE_Name'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/80fe3d1ae9fe3a26f041fdacda1be533/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Emergency_ICE_Phone'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Emergency_ICE_Phone'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/bd87e2987cf84027f5252b5fb6975185/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Registration'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Registration'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/7c9f892cde7c6937ade43d8c1605c2f6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'ID'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'ID'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/c47164fc3908f11241c4be4644f6a26a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Make'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Make'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/2fc28c0ac8611d886f3f74baa3cd3622/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Model'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Model'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/be2299e8f2fbe22a40d23b0734ea7b6a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Year'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Year'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/288a539ef5b16f7950c7d5b952531036/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'VIN'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'VIN'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/2e1b9b87bd5ee2bd8335cc22c49377c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Type'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Type'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/abaf7c17668189cfc4b70d8d523a163f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Registration'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Registration'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/f69609116f593e1c47ddb8a5cdf75699/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'ID'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'ID'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/1bf8af6639db112c79a2b543c32efd4e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Make'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Make'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/a073d098c42af506c2e2389243195bd9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Model'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Model'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/1bb5e9b95fb17d667e92881262034c0a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Year'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Year'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/a9f661ddaa8a030664fd328ffe362c53/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'VIN'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'VIN'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/12d6eb3a09dc3dea30e41e81b80eccab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Type'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Type'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/4dc786ac8e3e8bd5584961fd9b13739c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Odometer'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Odometer'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/162873332045e32ee6898ae8f8484c9e/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var List, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  console.log(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers'));
  console.log((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Dropside');
  })).length);
  List = (await asyncListFilter([0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Abnormal');
  })).length ? 'Abnormal' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Dropside');
  })).length ? 'Dropside' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Dropside Side Tipper');
  })).length ? 'Dropside Side Tipper' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Side Tipper');
  })).length ? 'Side Tipper' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Flat Deck');
  })).length ? 'Flat Deck' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Hopper Bottom');
  })).length ? 'Hopper Bottom' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Tanker');
  })).length ? 'Tanker' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Skeletal');
  })).length ? 'Skeletal' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Live Stock');
  })).length ? 'Live Stock' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Automotive');
  })).length ? 'Automotive' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Sloper Tipper');
  })).length ? 'Sloper Tipper' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Dry Van');
  })).length ? 'Dry Van' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Refrigerated');
  })).length ? 'Refrigerated' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Tautliner');
  })).length ? 'Tautliner' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Dry Bulk Tanker');
  })).length ? 'Dry Bulk Tanker' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Cargo Floor');
  })).length ? 'Cargo Floor' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Other');
  })).length ? 'Other' : '-'], async (item) => {


   return (item != '-');
  })).slice().sort(listsGetSortCompare("IGNORE_CASE", -1));
  List = (await Promise.all(List.map(async item => {; return ({ [`value`]: item,[`label`]: item });})));

  return List

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, List, Position, Verdict;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (HItch)')) == 'Trailer1') {
    Position = 'T1';
    List = (await asyncListFilter((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return (___arguments.value == (getObjectProperty(item, 'Type')));
    })), async (item) => {
       Verdict = ((getObjectProperty(item, 'Position')).indexOf(Position) !== -1);


     return (Verdict == true ? item : null);
    }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('32666ab6d0631fa30775fa62f8d207c4', List);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (HItch)')) == 'Trailer2') {
    Position = 'T2';
    List = (await asyncListFilter((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return (___arguments.value == (getObjectProperty(item, 'Type')));
    })), async (item) => {
       Verdict = ((getObjectProperty(item, 'Position')).indexOf(Position) !== -1);


     return (Verdict == true ? item : null);
    }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('32666ab6d0631fa30775fa62f8d207c4', List);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (HItch)')) == 'Trailer3') {
    Position = 'T3';
    List = (await asyncListFilter((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return (___arguments.value == (getObjectProperty(item, 'Type')));
    })), async (item) => {
       Verdict = ((getObjectProperty(item, 'Position')).indexOf(Position) !== -1);


     return (Verdict == true ? item : null);
    }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('32666ab6d0631fa30775fa62f8d207c4', List);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/ebc924cdf01ad7f37aefaacb2a2579fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('54a992b40b6d0efed5942c26ed6fb97b', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/e42859c265f75e35e56540e923898d5e/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('3c29a70b17d832044f5c88d13482f6bf');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('3c29a70b17d832044f5c88d13482f6bf');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/Assets/components/d536225493d801fe4394c153028a72d8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Odometer'] = ___arguments.value;
  if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f4b5657441e76d6909e5d9459f035cb8', true);
  } else if (___arguments.value > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f4b5657441e76d6909e5d9459f035cb8', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f4b5657441e76d6909e5d9459f035cb8', false);
  }
  if (___arguments.value >= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f50e6e8668d4e13ab7a322a88fdbae33', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f50e6e8668d4e13ab7a322a88fdbae33', false);
    }
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f50e6e8668d4e13ab7a322a88fdbae33', false);

    } catch (error) {

    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/f50e6e8668d4e13ab7a322a88fdbae33/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Tractor, Transaction, Trailer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Trailer = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (Unhitch)'))));
  Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), ));
  await new Promise(r => setTimeout(r, 750 || 0));
  Tractor['Trailers_Tare'] = (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Tare')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Tare')))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Tare')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Tare')))) + (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Tare')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Tare')))) - ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Trailer, 'Tare')))) ? 0 : (getObjectProperty(Trailer, 'Tare')))));
  Tractor['Trailers_GVM'] = (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'GVM')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'GVM')))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'GVM')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'GVM')))) + (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'GVM')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'GVM')))) - ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Trailer, 'GVM')))) ? 0 : (getObjectProperty(Trailer, 'GVM')))));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailers_Tare'] = (getObjectProperty(Tractor, 'Trailers_Tare'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailers_GVM'] = (getObjectProperty(Tractor, 'Trailers_GVM'));
  Trailer['Warehouse'] = 'In';
  Trailer['Now'] = (new Date());
  Trailer['Odometer'] = ((getObjectProperty(Trailer, 'Odometer')) + ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Fuel_Transaction_Mileage'))));
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (Unhitch)'));
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (Unhitch)')), [(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (Unhitch)')))), 'objectId'))]);
    _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (Unhitch)')))), 'objectId')), 'Tractor', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'))]);
    _uow.upsert('Trailers', Trailer);
    _uow.upsert('Tractors', Tractor);
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')[(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (Unhitch)'))] = null;

  })();

  console.log((await Transaction.execute()));
  console.log((await BackendlessUI.Functions.Custom['fn_88481472e3e169797cae85c104751a08']((getObjectProperty(Tractor, 'objectId')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'))));
  delete ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailer (Unhitch)'];
  await BackendlessUI.Functions.Custom['fn_1084738faafcc22540e6efb456550d03'](((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('023810ea19d611d8668de6cb90ac1585')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('023810ea19d611d8668de6cb90ac1585')), 0.1);
  await BackendlessUI.Functions.Custom['fn_035fa71f751b1ddc93f5f9520f1c1dba'](((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('023810ea19d611d8668de6cb90ac1585')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('023810ea19d611d8668de6cb90ac1585')), 0.1);
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('3219e54f18daa02c098161bb21b7aaf3', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/4c22de9d21d62341059826d3910d2e3a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var error, item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    List = (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Registration')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });})));

  } catch (error) {
    console.log(error);

  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Trailer Id'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/3cc4e08fa32bd305d518605fbc049252/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Odometer'] = ___arguments.value;
  if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aaa4019ed44e318174cdd0f330fcb4e2', true);
  } else if (___arguments.value > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aaa4019ed44e318174cdd0f330fcb4e2', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aaa4019ed44e318174cdd0f330fcb4e2', false);
  }
  if (___arguments.value >= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e314b6aaa4de26b251ceb4388a5930ee', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e314b6aaa4de26b251ceb4388a5930ee', false);
    }
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e314b6aaa4de26b251ceb4388a5930ee', false);

    } catch (error) {

    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/e314b6aaa4de26b251ceb4388a5930ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Tractor, Trailer, Transaction, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Trailer = (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Trailer Id')));
  }));
  Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), ));
  await new Promise(r => setTimeout(r, 750 || 0));
  Tractor['Trailers_Tare'] = (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Tare')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Tare')))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Tare')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Tare')))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Tare')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Tare')))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Trailer, 'Tare')))) ? 0 : (getObjectProperty(Trailer, 'Tare'))));
  Tractor['Trailers_GVM'] = (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'GVM')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'GVM')))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'GVM')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'GVM')))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'GVM')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'GVM')))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Trailer, 'GVM')))) ? 0 : (getObjectProperty(Trailer, 'GVM'))));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailers_Tare'] = (getObjectProperty(Tractor, 'Trailers_Tare'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailers_GVM'] = (getObjectProperty(Tractor, 'Trailers_GVM'));
  Trailer['Warehouse'] = 'Out';
  Trailer['Now'] = (new Date());
  Trailer['Odometer'] = ((getObjectProperty(Trailer, 'Odometer')) + ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Fuel_Transaction_Mileage'))));
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (HItch)')), [(getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Trailer Id'))]);
    _uow.addToRelation('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Trailer Id')), 'Tractor', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'))]);
    delete Trailer['Item Select'];
    _uow.upsert('Trailers', Trailer);
    _uow.upsert('Tractors', Tractor);

  })();

  console.log((await Transaction.execute()));
  await new Promise(r => setTimeout(r, 500 || 0));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')[(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (HItch)'))] = Trailer;
  delete ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailer (HItch)'];
  console.log((await BackendlessUI.Functions.Custom['fn_88481472e3e169797cae85c104751a08']((getObjectProperty(Tractor, 'objectId')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'))));
  await BackendlessUI.Functions.Custom['fn_1084738faafcc22540e6efb456550d03'](((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('023810ea19d611d8668de6cb90ac1585')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('023810ea19d611d8668de6cb90ac1585')), 0.1);
  await BackendlessUI.Functions.Custom['fn_035fa71f751b1ddc93f5f9520f1c1dba'](((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('023810ea19d611d8668de6cb90ac1585')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('023810ea19d611d8668de6cb90ac1585')), 0.1);
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('3219e54f18daa02c098161bb21b7aaf3', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/04839cafca3e57ed1b79fb49f7552202/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('1737c0e26f8e706cbad9f399d099912f', undefined);
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailer (Unhitch)'] = 'Trailer2';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/99cd506433f3a2e2a877169c84a4b92d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('1737c0e26f8e706cbad9f399d099912f', undefined);
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailer (Unhitch)'] = 'Trailer3';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/2d61ce751d85f3af3c9732b5f23b7f6d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var item;


  ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Registration',[`Direction`]: 'Down' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/ff742e095dd7028c0c1c0bc167d27cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var item;


  ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Registration',[`Direction`]: 'Up' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/f258040bf06d425308e84b11ea4723a2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'ID',[`Direction`]: 'Up' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/b3c3f8764e36d84d9e3cd6e896321e1a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'ID',[`Direction`]: 'Down' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/70165c2a6f7a060d6d6cf7b3d52f48fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Odometer',[`Direction`]: 'Down' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/affd7be5992ca4eec38fc9249161ac1e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Odometer',[`Direction`]: 'Up' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/8fd3a93307c379ab2e78717d89487669/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Distance_Travelled',[`Direction`]: 'Up' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/e6095cd7c06d7e04951fd22c0459c345/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Distance_Travelled',[`Direction`]: 'Down' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/f6ffd89d79f4829e6c74822b5bff5efc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Fuel_Consumption_Actual',[`Direction`]: 'Up' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/e3bae3235c4aa95e32e80e3c8208fd65/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Fuel_Consumption_Actual',[`Direction`]: 'Down' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/f7c45f63303f136881e9d47807382eeb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Tonnage_Total',[`Direction`]: 'Down' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/0ca99284016efcd2d4622518638d2554/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Tonnage_Total',[`Direction`]: 'Up' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/8f53aa752134cd1255ffb6a481d8334f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Profit_Loss',[`Direction`]: 'Up' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/51c2d0320471372e97c71517abee4ed5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Profit_Loss',[`Direction`]: 'Down' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/2c68263b95328b2f1713439e3ca6414d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var error, Text2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Text2 = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('cbdcc6bf0f487e0ece36b58566754bed'), 'Registration')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('cbdcc6bf0f487e0ece36b58566754bed'), 'ID'))].join('');

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Text2 = '';
    }

  }

  return Text2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/cbdcc6bf0f487e0ece36b58566754bed/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, Repeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.dataModel, 'Item Select'))))) {
    Repeater = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'));
    for (var j_index in Repeater) {
      j = Repeater[j_index];
      try {
        delete j['Item Select'];

      } catch (error) {

      }
    }
    ___arguments.context.dataModel['Item Select'] = true;
    ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Trailer Id'] = (getObjectProperty(___arguments.context.dataModel, 'objectId'));
  } else {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Trailer Id'];
    delete ___arguments.context.dataModel['Item Select'];
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var j, Repeater, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Style = ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cbdcc6bf0f487e0ece36b58566754bed'));
  if ((getObjectProperty(___arguments.context.dataModel, 'Item Select')) == true) {
    Style['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';
  } else {
    Style['boxShadow'] = null;
  }

  return Style

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Assets/components/aed9f88b7a17d7119e867c74a0b508d6/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var object, item;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Fleetview - Load Planner (Listener Update) '] = (generateUUID().long());
  await new Promise(r => setTimeout(r, 1000 || 0));

  ;(function(whereClause) {
    const callback = async object => {
        console.log('abc');
    replaceItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), object, 'objectId');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) != 'Delivered');
    })), 1, async (item) => {


     return (getObjectProperty(item, 'Action Date'));
    })));
    console.log(object);

    };

    const rtHandlers = Backendless.Data.of('Loads').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpdateListener.apply(rtHandlers, options);

    getRTSubscriptions().add((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - Load Planner (Listener Update) ')), () => rtHandlers.removeUpdateListener(callback));

  })((['TID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),'\''].join('')));
    console.log(getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - Load Planner (Listener Update) '));
  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Fleetview - Load Planner (Listener Upsert) '] = (generateUUID().long());
  await new Promise(r => setTimeout(r, 1000 || 0));

  ;(function(whereClause) {
    const callback = async object => {
        console.log('abc');
    replaceItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), object, 'objectId');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) != 'Delivered');
    })), 1, async (item) => {


     return (getObjectProperty(item, 'Action Date'));
    })));
    console.log(object);

    };

    const rtHandlers = Backendless.Data.of('Loads').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - Load Planner (Listener Upsert) ')), () => rtHandlers.removeUpsertListener(callback));

  })((['TID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),'\''].join('')));
    console.log(getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - Load Planner (Listener Upsert) '));

  },
  /* handler:onMounted */
  /* handler:onBeforeUnmount */
  ['onBeforeUnmount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  getRTSubscriptions().remove((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - Load Planner (Listener Update) ')));
  getRTSubscriptions().remove((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - Load Planner (Listener Upsert) ')));

  },
  /* handler:onBeforeUnmount */
  /* content */
}))

define('./pages/Assets/components/23cd61ab0f96d7dded927dcf7be6f7e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? 0 : (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) == 'Planned');
    })).length) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/b6db8091ad43822cccb69f76a06373a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var List, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads'))))) {
      List = [];
    } else {
      List = (await Promise.all((await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


       return ((getObjectProperty(item, 'Status')) == 'Planned');
      })), 1, async (item) => {


       return (getObjectProperty(item, 'Action Date'));
      })).map(async item => {; return ({ [`Customer`]: (getObjectProperty(item, 'Customer Name')),[`Tonnage`]: (getObjectProperty(item, 'Tonnage_Planned')),[`Product`]: (getObjectProperty(item, 'Load_Product')) });})));
    }

  } catch (error) {

  }

  return List

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Assets/components/0c7e0c0beb824cacb711210e038c2008/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var item, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? 0 : (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) == 'Loaded');
    })).length) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/202e6f381478a79b838edf74751aa2af/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads'))))) {
      List = [];
    } else {
      List = (await Promise.all((await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


       return ((getObjectProperty(item, 'Status')) == 'Loaded');
      })), 1, async (item) => {


       return (getObjectProperty(item, 'Action Date'));
      })).map(async item => {; return ({ [`Customer`]: (getObjectProperty(item, 'Customer Name')),[`Tonnage`]: (getObjectProperty(item, 'Tonnage_Planned')),[`Product`]: (getObjectProperty(item, 'Load_Product')) });})));
    }

  } catch (error) {

  }

  return List

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Assets/components/df25f1ce96461ed6fd8c75fe6ed69ec3/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
    
  },
  /* handler:onOpen */
  /* content */
}))

define('./pages/Assets/components/db2229c1f443cd9b599ae117b1ee22b9/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      console.log(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Assets/components/06f5b14abd6aea05bcc6c64ad3f45589/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
      } else {
        List = (await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


         return ((getObjectProperty(item, 'Type')) == 'Service Centre');
        })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Name')) });})));
      }
    }
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type')) == 'Tractor') {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))))) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/ed029dab54290ec4675e42a6144f6f0e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/d5dff5c6720ea4ad32b1f104708ea4fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Directory')) + String('/Invoices'))

  },
  /* handler:onDirectoryAssignment */
  /* content */
}))

define('./pages/Assets/components/ed46e734f0cff692570fa7b718f18d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Transaction, Tractor;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Type')) == 'Tractor') {
    Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item')), 'objectId')), ));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['License_Expiry_Date'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Date'));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['License_Status'] = 'All In Order';
    Tractor['License_Expiry_Date'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Date'));
    Tractor['Annual_License_Fee'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Cost'));
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Transaction;

      _uow.upsert('Tractors', Tractor);
      _uow.create('Transactions', ({ [`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Cost')),[`Description`]: ['License Renewal - (',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item')), 'ID')),')'].join(''),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item')), 'ownerId')) }));

    })();

    console.log((await Transaction.execute()));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Type')) == 'Trailer') {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item'))['License_Expiry_Date'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Date'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item'))['Annual_License_Fee'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Cost'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Number'))))['License_Expiry_Date'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Date'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Number'))))['License_Status'] = 'All In Order';
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Transaction;

      _uow.upsert('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item')));
      _uow.create('Transactions', ({ [`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Cost')),[`Description`]: ['License Renewal - (',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item')), 'ID')),')'].join(''),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item')), 'ownerId')) }));

    })();

    console.log((await Transaction.execute()));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Type')) == 'Driver') {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item'))['Driver_License_Expiry_Date'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Date'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))['Driver_License_Expiry_Date'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Date'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))['Driver_License_Expirey_Date_Status'] = 'All In Order';
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Transaction;

      _uow.upsert('Employees', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item')));

    })();

    console.log((await Transaction.execute()));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Type')) == 'PDP') {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item'))['Driver_PDP_Expiry_Date'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Date'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))['Driver_PDP_Expiry_Date'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Date'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))['Driver_PDP_Expiry_Date_Status'] = 'All In Order';
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Transaction;

      _uow.upsert('Employees', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item')));

    })();

    console.log((await Transaction.execute()));
  }
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('f44a28e8f6f3fc877238de766fd33d18', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/58d9626f5a3152ce3ce5dd1ba7ca4b8b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('f44a28e8f6f3fc877238de766fd33d18', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/e08f14d99aec84b58434fc6dc7d7c358/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/67132021793ba0afdb38e1057477d3dc/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var error, list, Options_List, Trailer_List, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Options_List = [];
  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Trailer List'] = [];
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service_Status')) == 'Service Due') {
    addItemToList(Options_List, ({ [`label`]: [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')),' (Tractor)'].join(''),[`value`]: 'Tractor' }));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
  } else {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Service_Status')) == 'Service Due') {
      addItemToList(Options_List, ({ [`label`]: [(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'ID')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Registration')),' (Trailer 1)'].join(''),[`value`]: 'Tailer1' }));
      addItemToList((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Trailer List')), 'Tailer1');
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
  } else {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Service_Status')) == 'Service Due') {
      addItemToList(Options_List, ({ [`label`]: [(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'ID')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Registration')),' (Trailer 2)'].join(''),[`value`]: 'Tailer2' }));
      addItemToList((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Trailer List')), 'Tailer2');
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
  } else {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Service_Status')) == 'Service Due') {
      addItemToList(Options_List, ({ [`label`]: [(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'ID')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Registration')),' (Trailer 3)'].join(''),[`value`]: 'Tailer3' }));
      addItemToList((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Trailer List')), 'Tailer3');
    }
  }
  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Trailer List')).length > 0) {
    addItemToList(Options_List, ({ [`label`]: 'All Trailers',[`value`]: 'All Trailers' }));
  }

  return Options_List

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Assets/components/9701b0799f7e018274e5ba646626a0e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type')) == 'Tractor') {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))))) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/a3659f8763b7b164af4ba798ad1f5901/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type')) == 'Tractor') {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))))) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/9e7252e717740cc82f31260fe3719aa9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var List;


  List = [({ [`value`]: 'kg',[`label`]: 'kg' }), ({ [`value`]: 'l',[`label`]: 'l' }), ({ [`value`]: 'm³',[`label`]: 'm³' }), ({ [`value`]: 't',[`label`]: 't' })];

  return List

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product'))))) {
    ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['New Product'] = ({ [`Unit`]: ___arguments.value });
  } else {
    (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product'))['Unit'] = ___arguments.value;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/bb53dfa268cf640b407d5f438858526d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Edit'];
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Add'];
  await Backendless.Data.of('Companies').save((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Edit')) == true || (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Add')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/6e6c7b4ffab7f4feaf0ec6a4e115387f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product'))))) {
    ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['New Product'] = ({ [`Mass`]: ___arguments.value });
  } else {
    (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product'))['Mass'] = ___arguments.value;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/6898e321c38c9cd7a5e28fc8331acdf6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8b0751df4ceaba4475b9dcfd53a1d4d7', true);
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products'))))) {
    ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Products'] = [({ [`Mass`]: 0 })];
  } else {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')), ({ [`Mass`]: 0 }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/f1179b2329bd3782ae820f91603f29e4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6'), 'Unit mass'))))) {
    ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Units'] = ___arguments.value;
  } else {
    ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Units'] = ___arguments.value;
    ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Mass'] = (___arguments.value * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6'), 'Unit mass')));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/64b7d4030788f5b8140edb6e30540fec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')), ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6'), '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/b05e3abc4ae446a18da2861449799845/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Admin Capture Load'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/64c99a9b58ffea63cdef471e3503be85/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var Load_ID_Tag, Load_Counter_To_Text, Loads_Counter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Load Ref Counter'] = (1 + (await Backendless.Data.of('Loads').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ownerId')),'\''].join(''))))));
  Loads_Counter = (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Load Ref Counter'));
  Load_Counter_To_Text = getValueLength(String(Loads_Counter)) == 1 ? String('000000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 2 ? String('00000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 3 ? String('0000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 4 ? String('000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 5 ? String('00') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 6 ? String('0') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 7 ? String(Loads_Counter) : 'Hidden Easter Egg'))))));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads'))))) {
    Load_ID_Tag = [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Registered_Name')).slice(0, 3),' L ',Load_Counter_To_Text].join('');
  } else {
    Load_ID_Tag = [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' ',Load_Counter_To_Text].join('');
  }
  ___arguments.context.dataModel['Load Ref'] = Load_ID_Tag;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Assets/components/d6557f66205c502c58c2718b3e6fd268/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Admin Capture Load'))))) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de8e8f4bbb67b6b91e39d5ee272b6c7a'))['value'] = (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')).length == 0 ? ((new Date()).valueOf()) + 900000 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')).slice(-1)[0]), 'Date_Planned_Return')))) ? (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')).slice(-1)[0]), 'Date_Planned_Delivery')) : (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')).slice(-1)[0]), 'Date_Planned_Return'))) + 900000);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Assets/components/7c89faf9084b806d4d2bb4ec8e6604c6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, Last_Load, Last_Location_ID, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Load Date'] = ___arguments.value;
  Last_Load = (await asyncListFilter((await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Loads')), -1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  })), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')) > (getObjectProperty(item, 'Action Date')));
  })).slice(-1)[0];
  if ((getObjectProperty(Last_Load, 'Status')) == 'Delivered') {
    Last_Location_ID = (getObjectProperty(Last_Load, 'LDPID'));
  } else if ((getObjectProperty(Last_Load, 'Status')) == 'Loaded') {
    Last_Location_ID = (getObjectProperty(Last_Load, 'LLPID'));
  } else if ((getObjectProperty(Last_Load, 'Status')) == 'Planned') {
    Last_Location_ID = (getObjectProperty(Last_Load, 'LLDPID'));
  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6', Last_Location_ID);

  } catch (error) {

  }

  },
  /* handler:onChange */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (5256000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/Assets/components/677480d417bccc03f44eca6619cbba16/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Delivery Date'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date'))

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./pages/Assets/components/8549715c2ed49c6dd4535947b02ccfd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route'));
  console.log(getObjectProperty(((getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'routes'))[0]), 'legs'))[0]), 'distance'));
  console.log(getObjectProperty(((getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'routes'))[0]), 'legs')).slice(-1)[0]), 'distance'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/fd6cd4a18a419db763ef7692e597efa6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Turnover'))))))))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('99a457935c8e264aa892775f6b25d371', undefined);
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('12ffcd2a0f5af80bebf447edfaf53caf', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/521746a3f3726607f3c2b28bc2a8fe7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Turnover'))))))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('99a457935c8e264aa892775f6b25d371', undefined);
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('12ffcd2a0f5af80bebf447edfaf53caf', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/48225d4b23a414d57afedb776b69624c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Fuel_Cost'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/9dd2ce2fff414cfb156e79f83cd471e6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb'](((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Toll_Fees')) + (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Toll_Fees_Per_Km_Total')))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/1341b09b5522cb727781f7821df3383f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Profit_Target'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/b942ed4940a97b3a9365f822d8276e85/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb'](((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Maintenance_Repairs_Trailers')) + (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Maintenance_Repairs_Tractor')))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/115726132571ea5a4d6a1c7bfe12e0a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Salary_Wages'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/00cdbf7ab1f5a88b29f64a39271527cf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Turnover')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Total_Expenses')) < 0 ? ['( R ',(await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Turnover')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Total_Expenses'))) * -1))))),' )'].join('') : String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb'](((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Turnover')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Total_Expenses')))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/c7ee8cdeb0ed5c7ad557facbc2fdd9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('12ffcd2a0f5af80bebf447edfaf53caf', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/52bea79387ae26d4d73775c8aea21107/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Product')), ''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/cb51e55b87071d627f63f40fea92159e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Rig_Payload')) + String(' kg')), ''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/d08f91b94c120ed2e2884e2fcadf250a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Tonnage_Planned')) + String(' kg')), ''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/ca4649afcc8acca75714c726b67aaaa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Tonnage_Loaded')) + String(' kg')), ''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/8ba54673e044a57f20147299d88d544d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Tonnage_Delivered')) + String(' kg')), ''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/fcc68773c305c8e37c6c66fe5bb6dcc4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String((await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Tonnage_Differential_Planned_To_Loaded')), 0))) + String(' kg'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/0645ff4f9cb390e58dc40e92377b92b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((Number.parseFloat((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Financial_Gain_Loss_Tonnage_Differential')) * 100 + 1) / 100)).toFixed(2)), 0))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/3afdce2c3d6e4d497f7d81a923769def/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Broker')), ''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/8e24e4749b081679795b04b587ee49b4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load Planner Name')), ''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/b75a686d743812a466331f9d154a35ba/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var Note_Length, Notes;


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd4de9f714144bc16e6aff4d68e4e9dc', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/cd4de9f714144bc16e6aff4d68e4e9dc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Notes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Notes = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Notes'));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Notes))) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record'))['Load_Notes'] = (String('● ') + String(getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Notes')));
  } else {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record'))['Load_Notes'] = ([Notes,'\n','● ',(getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Notes'))].join(''));
  }
  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Notes'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('325807b83c25e78b816ae7a87ba98c06', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd4de9f714144bc16e6aff4d68e4e9dc', false);
  await Backendless.Data.of('Loads').save((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('325807b83c25e78b816ae7a87ba98c06', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/1c0dfc47bd9b8ccc6f8df1239bfc6079/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
    
  },
  /* handler:onOpen */
  /* content */
}))

define('./pages/Assets/components/344e413bcfa345643b7aae6ed6426c15/bundle.js', [], () => ({
  /* content */
  /* handler:onAfterRender */
  ['onAfterRender'](___arguments) {
    
  },
  /* handler:onAfterRender */
  /* content */
}))

define('./pages/Assets/components/228732b4d85fd0236a09771fee89694f/bundle.js', [], () => ({
  /* content */
  /* handler:imagesDataLogic */
  async ['imagesDataLogic'](___arguments) {
    var Images, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Images = (await Promise.all((await asyncListFilter([(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Load_Image_1')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Load_Image_2')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Load_Image_3')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Delivery_Image_1')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Delivery_Image_2')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Delivery_Image_3'))], async (item) => {


   return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](item)));
  })).map(async item => {; return ({ [`url`]: item,[`title`]: undefined,[`content`]: undefined });})));

  return Images

  },
  /* handler:imagesDataLogic */
  /* content */
}))

define('./pages/Assets/components/4d3789a3e3c908e9c0e8522183222c9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record'));

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Fuel_Consumption_Ideal')) + String(' km/l')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/c232a6388ec3013988c856d4684c3406/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Fuel_Consumption_Actual')) + String(' km/l')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/d109bac322a80d156ee726b320a4e859/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Mileage')) + String(' km')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/d003b8010592a3173b85f49c0b9fd3b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Mileage_Differential')) + String(' km')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/496a1f85d639d4564c88f1dde0e328b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String('R ') + String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Cost'))), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/68491e9dd57919637662440de884dafe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String('R ') + String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Cost_Ideal'))), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/0ee42f4a64e2648c8fca6d3e7b6fef8e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String('R ') + String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Cost_Fuel_Per_Km'))), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/60f1d022ae8c8c12cdf4b5b3fd2a5e37/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(Number.parseFloat((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tank_Capacity')) - Math.round((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Available Capacity')) * 1000) / 1000) * (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Fuel_Consumption_Ideal')))).toFixed(2)) + String(' km')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/541f9dd30e7b597aeafb6cdca9f855d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Closest_Station_Distance')) + String(' km')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/7d1f23262d7747256d76cf01c4179f19/bundle.js', [], () => ({
  /* content */
  /* handler:onMapCenterAssignment */
  async ['onMapCenterAssignment'](___arguments) {
    var Location;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Admin')) == true) {
    Location = null;
  } else {
    Location = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Location_Submitted')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Location_Submitted'));
  }

  return Location

  },
  /* handler:onMapCenterAssignment */
  /* handler:onPointsAssignment */
  async ['onPointsAssignment'](___arguments) {
    var Location;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Admin')) == true) {
    Location = null;
  } else {
    Location = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Location_Submitted')))) ? [] : [(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Location_Submitted'))];
  }

  return Location

  },
  /* handler:onPointsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Admin')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/dd5604188936a015c24c2f8dd7b9a9fc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Fuel_Consumption')) + String(' km/l')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/151cd2ad1f5308d6a2ca3c42b3f5d7df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Consumption_Actual')) + String(' km/l')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/48ea13b9d3129dc8791d024e07ea1673/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(Number.parseFloat((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Litres'))).toFixed(2)) + String(' l')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/77f465e71b87db0c63d2956c14cad4a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String('R ') + String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Cost'))), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/6e6e463621575b39ef7e345142b6aa87/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String('R ') + String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Price_Per_Litre'))), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/989590ee9f2b6fc7a6b7d4f2d5b43436/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Consumption_5Tanks')) + String(' km/l')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/de8951d1330858482c1c8a1c7cd80015/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Image'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/dae53fcd87ac26abe238df72c6f843c8/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var Image2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Image'))))) {
  } else {
    Image2 = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Image'));
  }

  return Image2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/Assets/components/3e5e7579755f988eb78bba88086a9619/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/640654114287f343125bb2226bfafc5f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Mileage_Last_Delivery_Point'))))) {
    Content = '';
  } else {
    Content = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Mileage_Last_Delivery_Point')) + String(' km');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/909a2be929459e6aba59f3dad886a817/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Mileage_Load_Point'))))) {
    Content = '';
  } else {
    Content = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Mileage_Load_Point')) + String(' km');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/aa28786cf8895645260af4b9b95afef5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Mileage_Delivery_Point'))))) {
    Content = '';
  } else {
    Content = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Mileage_Delivery_Point')) + String(' km');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/9de6b67b620e644393380384191dca7b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Planned Mileage'))))) {
    Content = '';
  } else {
    Content = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Planned Mileage')) + String(' km');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/5a1f859b5153db6dcd3122d4d5d34176/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Distance_Last_Delivery_To_Delivery_Point'))))) {
    Content = '';
  } else {
    Content = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Distance_Last_Delivery_To_Delivery_Point')) + String(' km');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/bc8d004de601b2d3503f4212f92a14f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Distance_Differential_LDP_To_LP'))))) {
    Content = '';
  } else {
    Content = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Distance_Differential_LDP_To_LP')) + String(' km');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/cb0ce90325cc1de584a54a087e53ba43/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Distance_Differential_LP_To_DP'))))) {
    Content = '';
  } else {
    Content = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Distance_Differential_LP_To_DP')) + String(' km');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/e45a09ea1b5acd82b6472a9d96d28ec9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Distance_Differential_LDP_To_DP'))))) {
    Content = '';
  } else {
    Content = String('R') + String((await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b'](((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Distance_Differential_LDP_To_DP')) * (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Cost Per Km (Variables)'))), null, null)));
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/fdae0c99d6f6d3861ed4b5e2c1fbc17f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('98ba53adc16ea73716acbe6a98bbf982', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/2955543dd4af818bc80e40576e2a5649/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('5872de4f15ebcbf90d7d677c1de9e0b2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/f61dd8c12da2ada204b1eb53868d0d45/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  async ['onContainerDataAssignment'](___arguments) {
    var item, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  var j_list = (await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Axles_Data')), 1, async (item) => {


   return (getObjectProperty(item, 'Position Number'));
  }));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['Vehicle Id '] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectid'));
  }

  return (await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Axles_Data')), 1, async (item) => {


 return (getObjectProperty(item, 'Position Number'));
}))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/Assets/components/d4852d7ed351145bad171b1acc629153/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Fleetview, ObjectId, Axle_List, Tyres, Transaction_Step_1, Transaction_Step_2, Fuel_Transaction, Tractor, Fuel, item, Fleetview_Current, Mileage_Differential;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Tyre_Function() {
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Axles_Data'))))) {
    Axle_List = [];
  } else {
    Axle_List = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Axles_Data'));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
  } else {
    Axle_List = (Axle_List.concat((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Axles_Data'))));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
  } else {
    Axle_List = (Axle_List.concat((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Axles_Data'))));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3'))))) {
  } else {
    Axle_List = (Axle_List.concat((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Axles_Data'))));
  }
  Tyres = (await BackendlessUI.Functions.Custom['fn_c8249d71574777eb2a08c21c7e28faee'](Axle_List, ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')))));
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

/**
 * Describe this function...
 */
async function Fuel_Transaction2() {
  Mileage_Differential = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'));
  Tractor = (await Backendless.Data.of('Tractors').findById(ObjectId, ));
  Fuel = ({ [`Fuel_Consumption_Ideal`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Consumption_Ideal')),[`TObjectID`]: ObjectId,[`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost')),[`Description`]: ((new Date()).toDateString()),[`Fuel_Count`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))),[`Litres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres')),[`Mileage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')),[`Mileage_last`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Fuel_Transaction_Mileage')),[`Station_Unknown`]: (getObjectProperty(___arguments.context.appData, 'Garage - Other')) == true ? (getObjectProperty(___arguments.context.appData, 'Garage')) : null,[`Wages_Contractor_Km_Rate`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Contractor_Mileage')),[`Wages_Good_Driving_Rate`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Good_Driving')),[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'ownerId')) });
  Fleetview_Current = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current'));
  Fleetview_Current['Current_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  Fleetview_Current['Distance_Travelled'] = ((getObjectProperty(Fleetview_Current, 'Distance_Travelled')) + ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Fuel_Transaction_Mileage'))));
  Fleetview_Current['Fuel_Cost'] = ((getObjectProperty(Fleetview_Current, 'Fuel_Cost')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost')));
  Fleetview_Current['Fuel_Litres'] = ((Number((getObjectProperty(Fleetview_Current, 'Fuel_Litres')))) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres')));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Now'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Odometer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Fuel_Transaction_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Fuel_Counter'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))));
  (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty(item, 'objectId')));
  }))['Now'] = (new Date());
  (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty(item, 'objectId')));
  }))['Odometer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty(item, 'objectId')));
  }))['Last_Fuel_Transaction_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty(item, 'objectId')));
  }))['Fuel_Counter'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))));
  Tractor['Now'] = (new Date());
  Tractor['Odometer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  Tractor['Last_Fuel_Transaction_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  Tractor['Fuel_Counter'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))));
  Fuel_Transaction = (await Backendless.Data.of('Fuel').save( Fuel ));
  Transaction_Step_1 = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction_Step_1;

    _uow.upsert('Tractors', Tractor);
    _uow.addToRelation('Tractors', Tractor, 'Fuel', [Fuel_Transaction]);
    _uow.setRelation('Tractors', Tractor, 'Fuel_Last', [Fuel_Transaction]);
    _uow.addToRelation('Employees', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_Transactions_Fuel', [Fuel_Transaction]);
    _uow.addToRelation('Employees', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_Transactions_Fuel', [Fuel_Transaction]);
    _uow.setRelation('Fuel', Fuel_Transaction, 'Company', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')));
    _uow.setRelation('Fuel', Fuel_Transaction, 'Tractor', Tractor);
    _uow.addToRelation('Fuel', Fuel_Transaction, 'Driver', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')));
    _uow.bulkUpsert('Tyres', Tyres);

  })();

  Transaction_Step_2 = (await Transaction_Step_1.execute());
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('800fe80c414539252fbae03db5de918b', false);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4852d7ed351145bad171b1acc629153'))['disabled'] = true;
  ObjectId = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'));
  Fleetview = (getObjectProperty((await BackendlessUI.Functions.Custom['fn_88481472e3e169797cae85c104751a08'](ObjectId)), 'Fleetview'));
  console.log(Fleetview);
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Current_Fleetview'] = Fleetview;
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Fleetview_Current'] = Fleetview;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('b60663c4b5eb29e9c2dc2d7f8097446c', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/5c8fcfc52fa25fba8393a975589bf0e6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Form_Terms() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Mileage'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station'))))) {
        try {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

        } catch (error) {

        }
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost'))))) {
          try {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

          } catch (error) {

          }
        } else {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres'))))) {
            try {
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

            } catch (error) {

            }
          } else {
            if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'))))) {
              try {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

              } catch (error) {

              }
            } else {
              if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c8fcfc52fa25fba8393a975589bf0e6')), 'display')) == true) {
                if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other'))))) {
                  try {
                    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

                  } catch (error) {

                  }
                } else {
                  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
                }
              } else {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
              }
            }
          }
        }
      }
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

      } catch (error) {

      }
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4852d7ed351145bad171b1acc629153', false);

      } catch (error) {

      }
    }
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

    } catch (error) {

    }
  }
}


  ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Station - Other'] = ___arguments.value;
  await Form_Terms();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/b4ad1276182a224733317d57e58ceb38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Fleetview, ObjectId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4ad1276182a224733317d57e58ceb38'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4ad1276182a224733317d57e58ceb38'))['disabled'] = true;
  await new Promise(r => setTimeout(r, 400 || 0));
  ObjectId = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'));
  Fleetview = (getObjectProperty((await BackendlessUI.Functions.Custom['fn_88481472e3e169797cae85c104751a08'](ObjectId, ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'))), 'Fleetview'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Current_Fleetview'] = Fleetview;
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Fleetview_Current'] = Fleetview;
  console.log(Fleetview);
  await new Promise(r => setTimeout(r, 400 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4ad1276182a224733317d57e58ceb38'))['disabled'] = false;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('f3e9c22366f902aef4819ddad8b9b81a', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/e6d42ad792dc2d07daafbde7b6c4735d/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contracts'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Assets/components/72c1a84a9203610cb2ccff4a7a7937bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8e311797ed6c3552dd0784037dcb8d8b', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/f172f71b051402655953065849412c33/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await BackendlessUI.Functions.Custom['fn_88481472e3e169797cae85c104751a08']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/aee18d9611e77efd62fb75e42fee60c9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var j, item, k, List, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.appData['Month'] = ___arguments.value;
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    try {
      delete j['View'];

    } catch (error) {
      console.log(error);

    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Current_Fleetview_Save'))))) {
      j['Current_Fleetview_Save'] = (getObjectProperty(j, 'Fleetview_Current'));
    } else {
      j['Fleetview_Current'] = (getObjectProperty(j, 'Current_Fleetview_Save'));
    }
    if (((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4']((new Date()))).valueOf()) == ___arguments.value) {
      j['Current_Fleetview'] = (getObjectProperty(j, 'Fleetview_Current'));
    } else {
      List = (await asyncListFilter((getObjectProperty(j, 'Fleetview_Historical')), async (item) => {


       return ((getObjectProperty(item, 'created')) >= ___arguments.value && (getObjectProperty(item, 'created')) <= (await (async function(Start) {
      	function getEndOfMonthTimestamp(Start) {
      	  const startDate = new Date(Start);
      	  const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
      	  endDate.setHours(23, 59, 59, 999); // Set to the end of the day
      	
      	  return endDate.getTime();
      	}
      	
      	// Directly execute and return the result
      	return getEndOfMonthTimestamp(Start);
      })(___arguments.value)));
      }));
      if (List.length > 0) {
        j['Current_Fleetview'] = (List[0]);
        j['Fleetview_Current'] = (List[0]);
      } else {
        j['View'] = false;
      }
    }
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fe63d7114a2242e76e3c1f3c973f0e57', false);
  await new Promise(r => setTimeout(r, 200 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fe63d7114a2242e76e3c1f3c973f0e57', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(Start, End) {
	function generateMonthList(Start, End) {
	  const resultList = [];
	  const startDate = new Date(Start);
	  const endDate = new Date(End);
	
	  let current = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
	
	  while (current <= endDate) {
	    const value = current.getTime();
	    const label = current.toLocaleString('default', { month: 'long', year: 'numeric' });
	
	    resultList.push({ value, label });
	
	    // Move to the next month
	    current.setMonth(current.getMonth() + 1);
	  }
	
	  return resultList;
	}
	
	// Ensure to invoke the function correctly and capture the results
	const monthList = generateMonthList(Start, End);
	return monthList;
})((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'created')), (new Date())))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Assets/components/21bcac8bbbd7ed3b8b7e9bde738d92f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Current_Month, Current_Year, Date_Select_List, End_Month, End_Year, Start_Month, Start_Year, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  Date_Select_List = [];
  Start_Year = (new Date((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'created'))).getFullYear());
  End_Year = (new Date((new Date())).getFullYear());
  Current_Year = Start_Year;
  console.log('abc');
  console.log('abc');
  console.log(new Date((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'created'))).getMonth());
  console.log(new Date((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'created'))));
}


  console.log((await (async function(Start, End) {
  	function generateMonthList(Start, End) {
  	  const resultList = [];
  	  const startDate = new Date(Start);
  	  const endDate = new Date(End);
  	
  	  let current = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
  	
  	  while (current <= endDate) {
  	    const value = current.getTime();
  	    const label = current.toLocaleString('default', { month: 'long', year: 'numeric' });
  	
  	    resultList.push({ value, label });
  	
  	    // Move to the next month
  	    current.setMonth(current.getMonth() + 1);
  	  }
  	
  	  return resultList;
  	}
  	
  	// Ensure to invoke the function correctly and capture the results
  	const monthList = generateMonthList(Start, End);
  	return monthList;
  })((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'created')), (new Date()))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/f464d5d69fa415ca6c74204ee7f881cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.dataModel, 'View'))))) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/36bfd6de388fa4c2b4aec47f80d638ac/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['TractorId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),'\' AND Type = \'Service\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Assets/components/b6771da64fea415bd3e2d08913f79b1d/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Type = \'Repair\' AND TractorId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Assets/components/3fb22dd6000819bccae9ae3a3d2895f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('4d18d34d2b471c9918d3340864b9ab53', undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3fb22dd6000819bccae9ae3a3d2895f8'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3fb22dd6000819bccae9ae3a3d2895f8'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/Assets/components/d50b33f98d7b3139170bea669054c0f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getComponentDataStoreByUid('72c1a84a9203610cb2ccff4a7a7937bb')))) {
    Content = '';
  } else {
    Content = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('72c1a84a9203610cb2ccff4a7a7937bb'), 'id')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('72c1a84a9203610cb2ccff4a7a7937bb'), 'customer'))].join('');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/94895df400aff3ed1b4fbaf10b0f0152/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
    Content = '';
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'Current Tracking Data'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Distance'))))) {
        Content = '';
      } else {
        Content = String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Distance')) + String(' km');
      }
    }
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/19583bb76fd7c7f3a05df892db1bc933/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
    Content = '';
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'Current Tracking Data'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Speed'))))) {
        Content = '';
      } else {
        Content = String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Speed')), 'Value')) + String(' kph');
        if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Speed')), 'Value')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed'))) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19583bb76fd7c7f3a05df892db1bc933'))['color'] = 'rgb(255, 165, 0)';
        } else {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19583bb76fd7c7f3a05df892db1bc933'))['color'] = 'rgb(255, 255, 255)';
        }
      }
    }
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'Current Tracking Data'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Speed'))))) {
      } else {
        if ((getObjectProperty((getObjectProperty(AppData, 'Current Tracking Data')), 'Max Speed')) > (getObjectProperty(VehicleData, 'Can Max Speed'))) {
          Content = ({ [`color`]: 'rgb(255, 0, 0)' });
        } else {
          Content = ({ [`color`]: 'rgb(255, 255, 255)' });
        }
      }
    }
  }

  return Content

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Assets/components/0816922d47abeb786133d728b7ed93f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
    Content = '';
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'Current Tracking Data'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max RPM'))))) {
        Content = '';
      } else {
        Content = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max RPM')), 'Value'));
        if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max RPM')), 'Value')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max RPM'))) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0816922d47abeb786133d728b7ed93f1'))['color'] = 'rgb(255, 165, 0)';
        } else {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0816922d47abeb786133d728b7ed93f1'))['color'] = 'rgb(255, 255, 255)';
        }
      }
    }
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/d349b0f47f75d121cc434ad3d9898713/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
    Content = '';
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'Current Tracking Data'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Temp'))))) {
        Content = '';
      } else {
        Content = String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Temp')), 'Value')) + String('°C');
        if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Temp')), 'Value')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Temp'))) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d349b0f47f75d121cc434ad3d9898713'))['color'] = 'rgb(255, 165, 0)';
        } else {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d349b0f47f75d121cc434ad3d9898713'))['color'] = 'rgb(255, 255, 255)';
        }
      }
    }
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/fd27b5e77e1cb4ded88a09fdd383e333/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Distance'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/a9740276b4a4396fa63648c3e00c09f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19583bb76fd7c7f3a05df892db1bc933'));
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Speed')), 'Item')), 'position.latitude')), (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Speed')), 'Item')), 'position.longitude')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', 18);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/8615911897f633bcaad59bde0de4ea5e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max RPM')), 'Item')), 'position.latitude')), (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max RPM')), 'Item')), 'position.longitude')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', 18);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/2371a6e40222902ea267cb0c4bfd0e8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Temp')), 'Item')), 'position.latitude')), (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Temp')), 'Item')), 'position.longitude')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', 18);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/787e874e6a5bb793c51d269786c7b94b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('013f31913099c835aaa7b3e9bb839aca', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/571f248a4d288a73408147380ab4a7d6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Transaction, Repair, Financial_Transaction, objectId;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function New_Repair_Function() {
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    objectId = (generateUUID().long());
    Repair = (_uow.create('Maintenance', ({ [`CapturedBy`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name')),[`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Cost')),[`Date_Completed`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Date')),[`Date_Scheduled`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'DateSch')),[`Date_Started`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'DateStart')),[`Description`]: ['Repair (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Component')),')'].join(''),[`Invoice`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'File')),[`Mileage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Mileage')),[`Mileage Due`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Mileage')),[`Notes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Notes')),[`Repair_Component`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Component')),[`Status`]: 'Completed',[`Supplier`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('1c3e26f8092b560aa158d5a903273868')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c3e26f8092b560aa158d5a903273868')), 'value')))),[`TractorId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),[`TrailerId`]: undefined,[`Type`]: 'Repair',[`Vehicle Type`]: 'Tractor',[`objectId`]: objectId,[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ownerId')) })));
    Financial_Transaction = (_uow.create('Transactions', ({ [`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Cost')),[`Description`]: ['Repair (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Component')),') - ',objectId].join(''),[`objectId`]: objectId,[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ownerId')) })));
    _uow.setRelation('Maintenance', Repair, 'Transaction', [Financial_Transaction]);
    _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), 'Maintenance', [Repair]);

  })();

  return (await Transaction.execute())
}


  console.log(await New_Repair_Function());
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('013f31913099c835aaa7b3e9bb839aca', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0bcad0c4c147b7d2435a3ccfd35f2fe4')), 'value')))) && !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('853ddd6acc6f5ccdc61948140a4b1ebd')), 'value')))) && !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bbbaa52e73fc704c2fcdc68b0e531b5b')), 'value')))) && !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('64defe47907a9f9baf4e7f96a20fb7fe')), 'value')))) && !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4a8d26cc2f99d65bd092dc2cf4e283f')), 'value')))) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('057a1472ad9d2f6f840174e8ec49f2e5')), 'display')) == false) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/853ddd6acc6f5ccdc61948140a4b1ebd/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/Assets/components/bbbaa52e73fc704c2fcdc68b0e531b5b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range')) || ___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) - 5000) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('057a1472ad9d2f6f840174e8ec49f2e5', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('057a1472ad9d2f6f840174e8ec49f2e5', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/d2364cfe77d9529e1659e353ee73748c/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tanks'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/Assets/components/ab36dfab509650711dc842cc072eaac7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`height`]: 200 * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3e3dc51578caefef68326f05f6d5eefa'), 'Level')) / 100) })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/Assets/components/2f388c265d1be50c9bb302d37972646f/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`backgroundColor`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3e3dc51578caefef68326f05f6d5eefa'), 'Color')) })

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2f388c265d1be50c9bb302d37972646f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/2f15adf52a6f741ab6c8fb412385dccd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('99f282ff0c2737e9f9837e2932fc5155', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/502de53da6dfd035e7f390217196542f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('99f282ff0c2737e9f9837e2932fc5155', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/1c3e26f8092b560aa158d5a903273868/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
      } else {
        List = (await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


         return ((getObjectProperty(item, 'Type')) == 'Service Centre');
        })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Name')) });})));
      }
    }
  }

  return ([({ [`value`]: 'In House',[`label`]: 'In House' })].concat(List))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Assets/components/7b91288aa6dd47a1228e1bb7d7fba318/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/Assets/components/52fae095c4b1c574dfb7b96ef353491a/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/Assets/components/746112dd8af8b83be97e23c2a449dd2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Unscheduled Services')) == false) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_ID'))))) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f3e9c22366f902aef4819ddad8b9b81a', undefined);
    } else {
      await new Promise(r => setTimeout(r, 300 || 0));
      ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Service Item'] = ((await Backendless.Data.of('Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Service_ID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_ID')),'\''].join(''))).setPageSize(10)))[0]);
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Tractor',[`Vehicle`]: ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'),[`Odometer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) }));
    }
  } else {
    await new Promise(r => setTimeout(r, 300 || 0));
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Tractor',[`Vehicle`]: ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'),[`Odometer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/61ac86def8c54d1cb399ca223973a45a/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  async ['onContainerDataAssignment'](___arguments) {
    var item, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  var j_list = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Assets Drawer - Selected Tyre Vehicle')), 'Axles_Data')), 1, async (item) => {


   return (getObjectProperty(item, 'Position Number'));
  }));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['Vehicle Id '] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Assets Drawer - Selected Tyre Vehicle')), 'objectid'));
  }

  return (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Assets Drawer - Selected Tyre Vehicle')), 'Axles_Data')), 1, async (item) => {


 return (getObjectProperty(item, 'Position Number'));
}))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/Assets/components/8072aef91067aa86d66c855f221a650b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Unscheduled Services')) == false) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Last_Service_ID'))))) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f3e9c22366f902aef4819ddad8b9b81a', undefined);
    } else {
      await new Promise(r => setTimeout(r, 300 || 0));
      ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Service Item'] = ((await Backendless.Data.of('Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Service_ID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_ID')),'\''].join(''))).setPageSize(10)))[0]);
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Trailer1',[`Vehicle`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')),[`Odometer`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Odometer')) }));
    }
  } else {
    await new Promise(r => setTimeout(r, 300 || 0));
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Trailer1',[`Vehicle`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')),[`Odometer`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Odometer')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/93c6c4767b98a228e3aed8f441e5a90c/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['TrailerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'objectId')),'\' AND Type = \'Service\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Assets/components/1dffe62541f10f45400dfa130391d9d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Unscheduled Services')) == false) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Last_Service_ID'))))) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f3e9c22366f902aef4819ddad8b9b81a', undefined);
    } else {
      await new Promise(r => setTimeout(r, 300 || 0));
      ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Service Item'] = ((await Backendless.Data.of('Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Service_ID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_ID')),'\''].join(''))).setPageSize(10)))[0]);
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Trailer',[`Vehicle`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')),[`Odometer`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Odometer')) }));
    }
  } else {
    await new Promise(r => setTimeout(r, 300 || 0));
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Trailer',[`Vehicle`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')),[`Odometer`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Odometer')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/bbf57a4d28ae11aa80679d38929fe3ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('6c0c70c60321bbe1081cec3d9873d795', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/160246081a7efe03b909109a85b4d45d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('869b391ff70a54fcd53832025a3c7a85', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/66096308fbdad78fe78d9c338c260c16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('ac14a4d75a16a708740c4a175513728b', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/f62acc4a838defe856eb77e637549c56/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('51bce592fcaee421316c7753054507b9', undefined);
  ___arguments.context.appData['Trailer Repair Data'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/10b1229e8784cb6bfabba6d7d25c9adf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('51bce592fcaee421316c7753054507b9', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/6b4557f2538a229ac9795e5c3ef4f831/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['TrailerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'objectId')),'\' AND Type = \'Repair\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Assets/components/48343fb5b3030e1e3d3ff3e6326dba19/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Asset Drawer Data')) == 'Tyres') {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/fc02ba775a55a0b219030d66faff0309/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Road'] = true;
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['House'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Retread'];

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/b013a1833365e719232fb03973284167/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'House')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Status = \'All In Order\' AND Warehouse = \'In\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Assets/components/06f6535726c19eb2611a6d8946712956/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Retread')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Status = \'In For Retread\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
      ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Retread Tyre'] = ___arguments.selectedRecord;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('d6b4c70246e4305a053c674ed16e94d9');

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/Assets/components/e1471dcb75a1a0a611d1fce8cb85856a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['House'] = true;
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Road'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Retread'];

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/cbd7fd23544b22ee8b7bdd5e2e139443/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Retread'] = true;
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['House'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Road'];

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/85c3d4b9fde675b92857f0248c81cf21/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('d6b4c70246e4305a053c674ed16e94d9');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/d409a0d297652997669f2aaef735e2dc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Tyre = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Retread Tyre')), 'objectId')), ));
  if ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Retread Tyre')), 'State')) == 'Cap 1') {
    Tyre['Cost_Cap1'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7e57b29c7c97671d139e968677f4c6fb')), 'value'));
    Tyre['Mileage_Expected'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b8afaa6e651e3182186880cbe4b5b9ee')), 'value'));
    Tyre['Status'] = 'All In Order';
    Tyre['Warehouse'] = 'In';
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Retread Tyre')), 'State')) == 'Cap 2') {
    Tyre['Cost_Cap2'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7e57b29c7c97671d139e968677f4c6fb')), 'value'));
    Tyre['Mileage_Expected'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b8afaa6e651e3182186880cbe4b5b9ee')), 'value'));
    Tyre['Status'] = 'All In Order';
    Tyre['Warehouse'] = 'In';
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Retread Tyre')), 'State')) == 'Cap 3') {
    Tyre['Cost_Cap3'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7e57b29c7c97671d139e968677f4c6fb')), 'value'));
    Tyre['Mileage_Expected'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b8afaa6e651e3182186880cbe4b5b9ee')), 'value'));
    Tyre['Status'] = 'All In Order';
    Tyre['Warehouse'] = 'In';
  }
  await Backendless.Data.of('Tyres').save( Tyre );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('06f6535726c19eb2611a6d8946712956');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('b013a1833365e719232fb03973284167');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('d6b4c70246e4305a053c674ed16e94d9');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/7265fec2bd6f39c8ca73bb6660543fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var error;


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Road'] = true;
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['House'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Retread'];

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onMounted */
  /* handler:onBeforeUnmount */
  ['onBeforeUnmount'](___arguments) {
    var error;


  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Road'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['House'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Retread'];

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onBeforeUnmount */
  /* content */
}))

define('./pages/Assets/components/25642d33cef2bbd45843b5fc49464034/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  var repeat_end = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fc9e678e1659eeae97c20b3d138e6f9b')), 'value'));
  for (var count = 0; count < repeat_end; count++) {
    await BackendlessUI.Functions.Custom['fn_b3cdf4a3ed5a52efed2ea82b1ec2cb92'](___arguments.context.appData, null, null, 'Steer', (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('640329050f47c54f50b7596f467f6e1c')), 'value')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0edce35130418084cb7bdb773db8cb91')), 'value')));
  }
  var repeat_end2 = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9fcfef8d30f930e463b57425ce738d74')), 'value'));
  for (var count2 = 0; count2 < repeat_end2; count2++) {
    await BackendlessUI.Functions.Custom['fn_b3cdf4a3ed5a52efed2ea82b1ec2cb92'](___arguments.context.appData, null, null, 'Drive', (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a2ea461f751ca335f1a75c660ce6357a')), 'value')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ab72353e108c6138c897f795340dbbb4')), 'value')));
  }
  var repeat_end3 = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c276669585d5193152042a77a868d34b')), 'value'));
  for (var count3 = 0; count3 < repeat_end3; count3++) {
    await BackendlessUI.Functions.Custom['fn_b3cdf4a3ed5a52efed2ea82b1ec2cb92'](___arguments.context.appData, null, null, 'Trailer', (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('106fcf5158bd592f5438548ab0414e19')), 'value')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56a578fb1c7d81b9102e3057e12562f3')), 'value')));
  }
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('06f6535726c19eb2611a6d8946712956');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('b013a1833365e719232fb03973284167');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7e94eb266677922f143fd0e412b2797c');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/fae1946bb9353d06d049d40a84ec5c27/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7e94eb266677922f143fd0e412b2797c');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/366a1ddb107df96c9e6a0e714e1fad59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7e94eb266677922f143fd0e412b2797c');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/847d796244369b94e1f3efbdb7bdd5d5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Admin')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/192c87edffbab503c7bd2ae20c4c5b35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('99a457935c8e264aa892775f6b25d371', undefined);
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('12ffcd2a0f5af80bebf447edfaf53caf', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/14557f87afd9edb143b71d23f35513ad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Tractor_Fixed_Expenses'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/f9173e45b5dbfb11396be3d3b87d617f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Tractor_Fixed_Expenses'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/8f1c31582c87db11f66a5569583d87e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Trailer_Fixed_Expenses'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/7f8fb7a6e20629b1aed83fc3bf5b3a65/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Trailer_Fixed_Expenses'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/4106b032e6188a1636ef765f9c8b1c36/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Total_Expenses'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/2934715d06446c22520f5fbbc5fd7e6a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb'](((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Tyre_CPK_Estimated')) * (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Distance_Travelled_Mileage')))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/a22e6ec71565610242645e7c3a896484/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Projected_Commission'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/201c780c0df7bd0821e373cf5adf3f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item, j, list, Maint__Item, Trailer_Cost_List, Trailer_Maint__Cost, Trailer_Maint__List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Trailer_Maint__List = (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')).map(async item => {; return (getObjectProperty(item, 'Maintenance'));})));
  Trailer_Cost_List = [];
  for (var j_index in Trailer_Maint__List) {
    j = Trailer_Maint__List[j_index];
    try {
      if (0 <= (getObjectProperty(j, 'Cost'))) {
        addItemToList(Trailer_Cost_List, (getObjectProperty(j, 'Cost')));
      }

    } catch (error) {

    }
  }
  if (Trailer_Cost_List.length == 0) {
    Trailer_Maint__Cost = 0;
  } else {
    Trailer_Maint__Cost = Trailer_Maint__List.reduce(function(x, y) {return x + y;});
  }
  ___arguments.context.pageData['Finances'] = ({ [`Turnover`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Turnover'));}))).reduce(function(x, y) {return x + y;}),[`Tractor_Fixed_Expenses`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tractor_Fixed_Expenses'));}))).reduce(function(x, y) {return x + y;}),[`Trailer_Fixed_Expenses`]: true ? (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')).map(async item => {; return (getObjectProperty(item, 'Cost Fixed'));}))).reduce(function(x, y) {return x + y;}) : (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Trailer_Fixed_Expenses'));}))).reduce(function(x, y) {return x + y;}),[`Fuel_Cost`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Fuel_Cost'));}))).reduce(function(x, y) {return x + y;}),[`Toll_Fees`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Toll_Fees'));}))).reduce(function(x, y) {return x + y;}),[`Toll_Fees_Per_Km_Total`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Toll_Fees_Per_Km_Total'));}))).reduce(function(x, y) {return x + y;}),[`Maintenance_Plan_Per_Km_Total`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Maintenance_Plan_Per_Km_Total'));}))).reduce(function(x, y) {return x + y;}),[`Maintenance_Repairs_Tractor`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Maintenance_Repairs_Tractor'));}))).reduce(function(x, y) {return x + y;}),[`Maintenance_Repairs_Trailers`]: Trailer_Maint__Cost,[`Tyres`]: true ? (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tyre_Expenses_Actual'));}))).reduce(function(x, y) {return x + y;}) : (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return ((getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Distance_Travelled_Mileage')) * (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tyre_CPK_Estimated')));}))).reduce(function(x, y) {return x + y;}),[`Salary_Wages`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Salary_Wages'));}))).reduce(function(x, y) {return x + y;}),[`Profit_Target`]: true ? 0 : (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Profit_Target'));}))).reduce(function(x, y) {return x + y;}),[`Projected_Commission`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Projected_Commission'));}))).reduce(function(x, y) {return x + y;}),[`Total_Costs`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tractor_Fixed_Expenses'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Trailer_Fixed_Expenses'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Fuel_Cost'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Toll_Fees'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Toll_Fees_Per_Km_Total'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Maintenance_Plan_Per_Km_Total'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Maintenance_Repairs_Tractor'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Maintenance_Repairs_Trailers'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return ((getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Distance_Travelled_Mileage')) * (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tyre_CPK_Estimated')));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Salary_Wages'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Profit_Target'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Projected_Commission'));}))).reduce(function(x, y) {return x + y;}),[`Profit_Loss`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Turnover'));}))).reduce(function(x, y) {return x + y;}) - ((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tractor_Fixed_Expenses'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Trailer_Fixed_Expenses'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Fuel_Cost'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Toll_Fees'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Toll_Fees_Per_Km_Total'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Maintenance_Plan_Per_Km_Total'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Maintenance_Repairs_Tractor'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Maintenance_Repairs_Trailers'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return ((getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Distance_Travelled_Mileage')) * (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tyre_CPK_Estimated')));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Salary_Wages'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Profit_Target'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Projected_Commission'));}))).reduce(function(x, y) {return x + y;})) });
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f813fb43f2122249c3b3202a6f0b4ede', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/8f02235da2375e9add26df83fe141b7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('f813fb43f2122249c3b3202a6f0b4ede', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/2de26ebd615a90e7bed2029aa664854c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Turnover'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/4ab8e7af9cae6fac98634a030e1e3d4f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Tractor_Fixed_Expenses'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/48d5f955fefad0b1a33fc319fc582f02/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Trailer_Fixed_Expenses'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/891a306c7ca2f02d42a3e366f93d3d05/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Fuel_Cost'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/ddcf8662c8bbf492627c1511fdb2ef8e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3'](((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Toll_Fees')) + (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Toll_Fees_Per_Km_Total')))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/5b8f32d160141f4244c607b12bfa2ebc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3'](((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Maintenance_Plan_Per_Km_Total')) + (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Maintenance_Repairs_Tractor')) + (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Maintenance_Repairs_Trailers')))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/635f6eab79b7951b97fe3b0410464f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Tyres'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/3c0740245c0912f954ae918c265cf8d3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Salary_Wages'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/1e8a2709c56ea76f856c12f6cd927dfd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Profit_Target'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/508559aa1da6b7d5f66b2959309eca6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Projected_Commission'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/44fb297ae51581e63279fb53e5a6f586/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Total_Costs'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/c17c32e4f98bf4d137916cea51b51c91/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Profit_Loss')) < 0 ? ['( R ',(await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3'](((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Profit_Loss')) * -1))))),' )'].join('') : String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Profit_Loss'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/a87518aa0381d35961abedec014e3c84/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Employee;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  Employee = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


   return ((getObjectProperty(item, 'Company_ID')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Company_ID')));
  }))[0];

  return ([({ [`value`]: (getObjectProperty((getObjectProperty(Employee, 'Wages_Current')), 'objectId')),[`label`]: (getObjectProperty((getObjectProperty(Employee, 'Wages_Current')), 'Month_Year')),[`Data`]: (getObjectProperty(Employee, 'Wages_Current')) })].concat((await Promise.all((await asyncListSort((getObjectProperty(Employee, 'Wages_Historical')), 1, async (item) => {


 return (getObjectProperty(item, 'created'));
})).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Month_Year')),[`Data`]: item });})))))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Salary, Payslip, PDF_Data, File_Name, item, Employee, Employee_Data, URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  Salary = (getObjectProperty(((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('a87518aa0381d35961abedec014e3c84')), async (item) => {


   return ((getObjectProperty(item, 'value')) == ___arguments.value);
  }))[0]), 'Data'));
  Employee = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


   return ((getObjectProperty(item, 'Company_ID')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Company_ID')));
  }))[0];
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Salary, 'Payslip'))))) {
    Employee_Data = (getObjectProperty(___arguments.context.pageData, 'HR - Selected Record'));
    File_Name = ['Payslip','(',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](([(getObjectProperty(Employee_Data, 'Employee_Details_ID_Number')),'(',(getObjectProperty(Salary, 'created')),')'].join('')))),')'].join('');
    URL2 = ['https://backendlessappcontent.com/FB172318-89F2-E225-FF10-9AC9657A9000/15CB006B-69A7-477E-9D2F-3B75BC06A165/files/pdf/',['Payslip','%28',(getObjectProperty(Salary, 'objectId')),'%29'].join(''),'.pdf'].join('');
    PDF_Data = ({ [`DATE`]: ((new Date((await BackendlessUI.Functions.Custom['fn_7b787368d76d5cd2f383609f56ef4594']((getObjectProperty(Salary, 'created')))))).toLocaleDateString()),[`START`]: ((new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Commencement')))).toLocaleDateString()),[`QR`]: URL2,[`CLOGO`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Logo')),[`CNAME`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Registered_Name')),[`A1`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Physical_Address')),[`A2`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Postal_Code')),[`Phone`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Phone_1')),[`Email`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Email_Admin')),[`AVATAR`]: (getObjectProperty(Employee_Data, 'Avatar')),[`EFORE`]: (getObjectProperty(Employee_Data, 'Employee_Details_Forenames')),[`ESUR`]: (getObjectProperty(Employee_Data, 'Employee_Details_Surname')),[`NICKNAME`]: (getObjectProperty(Employee_Data, 'Employee_Details_Nickname')),[`CID`]: (getObjectProperty(Employee_Data, 'Company_ID')),[`ID`]: (getObjectProperty(Employee_Data, 'Employee_Details_ID_Number')),[`TAX`]: (getObjectProperty(Employee_Data, 'Employee_Details_Tax_Reference_Number')),[`CUIF`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_UIF_Number')),[`CPAYE`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_PAYE_Number')),[`ED1`]: 'Basic Salary',[`ED2`]: 'Per Km',[`ED3`]: 'Per Unit',[`ED4`]: 'Good Driving Bonus',[`ED5`]: 'Target Mileage Bonus',[`ED6`]: 'Target Unit Bonus',[`ED7`]: 'Sleep Out Pay',[`ED8`]: undefined,[`ED9`]: 'Medical Aid',[`ED10`]: 'Provident Fund (Emplorer)',[`EU1`]: undefined,[`EU2`]: [(getObjectProperty(Salary, 'Distance Traveled')),'km @ R',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Wages_Rate_Contractor_Mileage')))) ? '0.00' : (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Wages_Rate_Contractor_Mileage')), null, null))].join(''),[`EU3`]: [(getObjectProperty(Salary, 'Tonnage Moved')),' @ R',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Wages_Rate_Contractor_Tonnage')))) ? '0.00' : (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Wages_Rate_Contractor_Tonnage')), null, null))].join(''),[`EU4`]: undefined,[`EU5`]: [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Salary, 'Wages_Rate_Target_Mileage_Start')))) ? '0' : (getObjectProperty(Salary, 'Distance Traveled')) - (getObjectProperty(Salary, 'Wages_Rate_Target_Mileage_Start')),' @ R',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Wages_Rate_Target_Mileage')))) ? '0.00' : (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Wages_Rate_Target_Mileage')), null, null))].join(''),[`EU6`]: [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Salary, 'Wages_Rate_Target_Tonnage_Start')))) ? '0' : (getObjectProperty(Salary, 'Distance Traveled')) - (getObjectProperty(Salary, 'Wages_Rate_Target_Tonnage_Start')),' @ R',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Wages_Rate_Target_Tonnage')))) ? '0.00' : (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Wages_Rate_Target_Tonnage')), null, null))].join(''),[`EU7`]: undefined,[`EU8`]: undefined,[`EU9`]: undefined,[`EU10`]: undefined,[`EV1`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Basic_Salary')), 'R', null)),[`EV2`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Contractor_Per_Km')), 'R', null)),[`EV3`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Contractor_Tonnage')), 'R', null)),[`EV4`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Good_Driving_Bonus')), 'R', null)),[`EV5`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Target_Mileage_Bonus')), 'R', null)),[`EV6`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Target_Tonnage_Bonus')), 'R', null)),[`EV7`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Sleep_Out_Pay')), 'R', null)),[`EV8`]: undefined,[`EV9`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Medical_Aid')), 'R', null)),[`EV10`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b'](((getObjectProperty(Salary, 'Provident_Pension_Fund')) * 0.5161), 'R', null)),[`DD1`]: 'Provident Fund',[`DD2`]: 'UIF',[`DD3`]: 'Council & Union Levies',[`DD4`]: undefined,[`DD5`]: 'Calculated Tax',[`DD6`]: undefined,[`DD7`]: undefined,[`DD8`]: undefined,[`DD9`]: undefined,[`DD10`]: undefined,[`DU1`]: undefined,[`DU2`]: undefined,[`DU3`]: undefined,[`DU4`]: undefined,[`DU5`]: undefined,[`DU6`]: undefined,[`DU7`]: undefined,[`DU8`]: undefined,[`DU9`]: undefined,[`DU10`]: undefined,[`DV1`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Provident_Pension_Fund')), 'R', null)),[`DV2`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b'](((getObjectProperty(Salary, 'UIF_EMPLOYEE')) * 1), 'R', null)),[`DV3`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b'](((getObjectProperty(Salary, 'Bargaining_Council_and_Union_Levies')) * 1), 'R', null)),[`DV4`]: undefined,[`DV5`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b'](((getObjectProperty(Salary, 'Tax')) * 1), 'R', null)),[`DV6`]: undefined,[`DV7`]: undefined,[`DV8`]: undefined,[`DV9`]: undefined,[`DV10`]: undefined,[`ETOTAL`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Taxable')), 'R', null)),[`DTOTAL`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Deductions')), 'R', null)),[`NETT`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Nett')), 'R', null)),[`TEARN`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((([(getObjectProperty((getObjectProperty(Employee, 'Wages_Current')), 'Taxable'))].concat((await Promise.all((await asyncListSort((getObjectProperty(Employee, 'Wages_Historical')), 1, async (item) => {


     return (getObjectProperty(item, 'created'));
    })).map(async item => {; return (getObjectProperty(item, 'Taxable'));}))))).reduce(function(x, y) {return x + y;})), 'R', null)),[`CCONTR`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((([(getObjectProperty((getObjectProperty(Employee, 'Wages_Current')), 'Company_Contribution'))].concat((await Promise.all((await asyncListSort((getObjectProperty(Employee, 'Wages_Historical')), 1, async (item) => {


     return (getObjectProperty(item, 'created'));
    })).map(async item => {; return (getObjectProperty(item, 'Company_Contribution'));}))))).reduce(function(x, y) {return x + y;})), 'R', null)),[`ADDDATA`]: undefined });
    console.log(PDF_Data);
    ___arguments.context.pageData['PDF Test'] = (await Backendless.Request.post(`${Backendless.appPath}/services/PDFGeneratorAPI/${'1169565'}/data-output/${File_Name}`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'data': PDF_Data }));
    console.log(getObjectProperty(___arguments.context.pageData, 'PDF Test'));
    Salary['Payslip'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'PDF Test')), 'fileUrl'));
    await Backendless.Data.of('Salaries').save(Salary, true);
    ___arguments.context.pageData['Payslip_PDF'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'PDF Test')), 'fileUrl'));
  } else {
    ___arguments.context.pageData['Payslip_PDF'] = (getObjectProperty(Salary, 'Payslip'));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/4076ef5f73d9a3c54c1b6f928d55fe12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Payslip_PDF'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:pdfUrlLogic */
  ['pdfUrlLogic'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Payslip_PDF'))

  },
  /* handler:pdfUrlLogic */
  /* content */
}))

define('./pages/Assets/components/b085b36aaa41d90c2ea457b9fa09e664/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Admin')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/29349af3a54c1bea4a565902c1e5ec55/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Admin')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/62d42f136808620cffeebaa2e72457dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Admin')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/8084fe54cf25f761165b327de312a32a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Admin')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/919998ef469e8d657ab8c57dfdea4a0c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Litres')) + String(' l')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/e553964d7aa94eaccb879f14e3710654/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'FIF')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('103b3004da69835bc0b3e0e9f2e54c71', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/934b5c16dfde1dfb644420b91dd66057/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectCreate */
  async ['onObjectCreate'](___arguments) {
    var Axles, Bulk_Created_Axles, Created_Fleet_View, Double_Wheel_Axles, Double_Wheel_Text, ID, Single_Wheel_Axles, Single_Wheel_Text, Steer_Wheel_Axles, Steer_Wheel_Text, Transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Axles = [];
  Steer_Wheel_Axles = [];
  Single_Wheel_Axles = [];
  Double_Wheel_Axles = [];
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Steer1'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Steer1'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 1,[`Type`]: 'Steer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Steer1')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      addItemToList(Steer_Wheel_Axles, true);
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Steer2'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Steer2'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 2,[`Type`]: 'Steer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Steer2')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      addItemToList(Steer_Wheel_Axles, true);
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Drive1'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Drive1'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 3,[`Type`]: 'Drive',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Drive1')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Drive1')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Drive1')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Drive2'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Drive2'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 4,[`Type`]: 'Drive',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Drive2')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Drive2')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Drive2')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Drive3'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Drive3'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 5,[`Type`]: 'Drive',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Drive3')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Drive3')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Drive3')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Spare_1'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Spare_1'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 7,[`Type`]: 'Spare',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Spare_1')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Spare_2'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Spare_2'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 8,[`Type`]: 'Spare',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Spare_2')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Spare_3'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Spare_3'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 9,[`Type`]: 'Spare',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Spare_3')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
    }
  }
  if (Steer_Wheel_Axles.length == 0) {
    Steer_Wheel_Text = null;
  } else if (Steer_Wheel_Axles.length == 1) {
    Steer_Wheel_Text = 'Steer Axle (1)';
  } else if (Steer_Wheel_Axles.length == 2) {
    Steer_Wheel_Text = 'Steer Axle (2)';
  }
  if (Single_Wheel_Axles.length == 0) {
    Single_Wheel_Text = null;
  } else if (Single_Wheel_Axles.length == 1) {
    Single_Wheel_Text = 'Drive Axle Single Wheel (1)';
  } else if (Single_Wheel_Axles.length == 2) {
    Single_Wheel_Text = 'Drive Axle Single Wheel (2)';
  } else if (Single_Wheel_Axles.length == 3) {
    Single_Wheel_Text = 'Drive Axle Single Wheel (3)';
  }
  if (Double_Wheel_Axles.length == 0) {
    Double_Wheel_Text = null;
  } else if (Double_Wheel_Axles.length == 1) {
    Double_Wheel_Text = 'Drive Axle Double Wheel (1)';
  } else if (Double_Wheel_Axles.length == 2) {
    Double_Wheel_Text = 'Drive Axle Double Wheel (2)';
  } else if (Double_Wheel_Axles.length == 3) {
    Double_Wheel_Text = 'Drive Axle Double Wheel (3)';
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Steer_Wheel_Text))) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Single_Wheel_Text))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Double_Wheel_Text))) {
      } else {
        ___arguments.newObject['Axles'] = Double_Wheel_Text;
      }
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Single_Wheel_Text))) {
      } else {
        ___arguments.newObject['Axles'] = ([Single_Wheel_Text,',',Double_Wheel_Text].join(''));
      }
    }
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Single_Wheel_Text))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Double_Wheel_Text))) {
        ___arguments.newObject['Axles'] = Steer_Wheel_Text;
      } else {
        ___arguments.newObject['Axles'] = ([Steer_Wheel_Text,',',Double_Wheel_Text].join(''));
      }
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Double_Wheel_Text))) {
        ___arguments.newObject['Axles'] = ([Steer_Wheel_Text,',',Single_Wheel_Text].join(''));
      } else {
        ___arguments.newObject['Axles'] = ([Steer_Wheel_Text,',',Single_Wheel_Text,',',Double_Wheel_Text].join(''));
      }
    }
  }
  ___arguments.newObject['ownerId'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId'));
  ID = (generateUUID().short());
  ___arguments.newObject['ID'] = ID;
  ___arguments.newObject['Registration'] = ID;
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Bulk_Created_Axles = (_uow.bulkCreate('Axles', Axles));
    _uow.update('Tractors', ___arguments.newObject);
    _uow.setRelation('Tractors', ___arguments.newObject, 'Axles_Data', Bulk_Created_Axles);
    _uow.setRelation('Tractors', ___arguments.newObject, 'Company', [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'objectId'))]);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors', [___arguments.newObject]);
    Created_Fleet_View = (_uow.create('Fleetview', ({ [`Current_Mileage`]: 0,[`Distance_Travelled`]: 0,[`Distance_Travelled_Mileage`]: 0,[`Fuel_Consumption_Ideal`]: 0,[`Fuel_Cost`]: 0,[`Fuel_Litres`]: 0,[`Gain_Loss_On_Loading_Delays`]: 0,[`Gain_Loss_On_Loading_Mileage`]: 0,[`Gain_Loss_On_Loading_Tonnage`]: 0,[`Licenses_Due`]: undefined,[`Maintenance_Plan_Per_Km_Total`]: 0,[`Maintenance_Repairs_Tractor`]: 0,[`Maintenance_Repairs_Trailers`]: 0,[`Mileage_Target`]: 0,[`Now`]: (new Date()),[`Profit_Target`]: 0,[`Projected_Commission`]: 0,[`Salary_Wages`]: 0,[`Service_Notices`]: undefined,[`Toll_Fees`]: 0,[`Toll_Fees_Per_Km_Total`]: 0,[`Tonnage_Average`]: 0,[`Tonnage_Permissible`]: 0,[`Tonnage_Target`]: 0,[`Tonnage_Total`]: 0,[`Tractor_Fixed_Expenses`]: 0,[`Trailer_Fixed_Expenses`]: 0,[`Turnover`]: 0,[`Tyre_CPK_Estimated`]: 0,[`Tyre_Expenses_Actual`]: 0,[`Tyre_Expenses_Estimated`]: 0,[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) })));
    _uow.setRelation('Tractors', ___arguments.newObject, 'Fleetview_Current', [Created_Fleet_View]);
    _uow.setRelation('Tractors', ___arguments.newObject, 'Current_Fleetview', [Created_Fleet_View]);
    _uow.addToRelation('Tractors', ___arguments.newObject, 'Fleetview_Historical', [Created_Fleet_View]);

  })();

  console.log((await Transaction.execute()));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);

  },
  /* handler:onObjectCreate */
  /* content */
}))

define('./pages/Assets/components/d199b4da0198f033af7edb25813bfd04/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var j, object, error;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Fleetview - (Listener Update)'] = (generateUUID().long());
  try {

    ;(function(whereClause) {
      const callback = async object => {
          console.log(object);
      var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if ((getObjectProperty(object, 'objectId')) == (getObjectProperty((getObjectProperty(j, 'Current_Fleetview')), 'objectId'))) {
          Object.assign((getObjectProperty(j, 'Current_Fleetview')), object);
          Object.assign((getObjectProperty(j, 'Fleetview_Current')), object);
        }
      }

      };

      const rtHandlers = Backendless.Data.of('Fleetview').rt();

      const options = [callback];

      if (whereClause) {
         options.unshift(whereClause);
      }

      rtHandlers.addUpdateListener.apply(rtHandlers, options);

      getRTSubscriptions().add((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - (Listener Update)')), () => rtHandlers.removeUpdateListener(callback));

    })((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\''].join('')));

  } catch (error) {

  }
  await new Promise(r => setTimeout(r, 1000 || 0));
  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Fleetview - (Listener Upsert)'] = (generateUUID().long());
  await new Promise(r => setTimeout(r, 1000 || 0));
  try {

    ;(function(whereClause) {
      const callback = async object => {
          console.log(object);
      var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'));
      for (var j_index2 in j_list2) {
        j = j_list2[j_index2];
        if ((getObjectProperty(object, 'objectId')) == (getObjectProperty((getObjectProperty(j, 'Current_Fleetview')), 'objectId'))) {
          Object.assign((getObjectProperty(j, 'Current_Fleetview')), object);
          Object.assign((getObjectProperty(j, 'Fleetview_Current')), object);
        }
      }

      };

      const rtHandlers = Backendless.Data.of('Fleetview').rt();

      const options = [callback];

      if (whereClause) {
         options.unshift(whereClause);
      }

      rtHandlers.addUpsertListener.apply(rtHandlers, options);

      getRTSubscriptions().add((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - (Listener Upsert)')), () => rtHandlers.removeUpsertListener(callback));

    })((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\''].join('')));

  } catch (error) {

  }

  },
  /* handler:onMounted */
  /* handler:onBeforeUnmount */
  ['onBeforeUnmount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  getRTSubscriptions().remove((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - Load Planner (Listener Update) ')));
  getRTSubscriptions().remove((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - (Listener Upsert)')));

  },
  /* handler:onBeforeUnmount */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fe63d7114a2242e76e3c1f3c973f0e57', false);
  await new Promise(r => setTimeout(r, 200 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fe63d7114a2242e76e3c1f3c973f0e57', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/4856c30fd8fe6206aabb2098a2cc5df3/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectCreate */
  async ['onObjectCreate'](___arguments) {
    var Axles, Bulk_Created_Axles, Double_Wheel_Axles, Double_Wheel_Text, ID, Single_Wheel_Axles, Single_Wheel_Text, Transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Axles = [];
  Single_Wheel_Axles = [];
  Double_Wheel_Axles = [];
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer1'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer1'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 1,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer1')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer1')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer1')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer2'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer2'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 2,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer2')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer2')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer2')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer3'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer3'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 3,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer3')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer3')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer3')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer4'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer4'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 4,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer4')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer4')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer4')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer5'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer5'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 5,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer5')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer5')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer5')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer6'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer6'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 6,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer6')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer6')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer6')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer7'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer7'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 7,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer7')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer7')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer7')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer8'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer8'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 8,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer8')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer8')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer8')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer9'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer9'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 9,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer9')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer9')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer9')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer10'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer10'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 10,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer10')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer10')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer10')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare1'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare1'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 11,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare1')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare2'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare2'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 12,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare2')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare3'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare3'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 13,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare3')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
    }
  }
  if (Single_Wheel_Axles.length == 0) {
    Single_Wheel_Text = null;
  } else if (Single_Wheel_Axles.length == 1) {
    Single_Wheel_Text = 'Single Wheel (1)';
  } else if (Single_Wheel_Axles.length == 2) {
    Single_Wheel_Text = 'Single Wheel (2)';
  } else if (Single_Wheel_Axles.length == 3) {
    Single_Wheel_Text = 'Single Wheel (3)';
  } else if (Single_Wheel_Axles.length == 4) {
    Single_Wheel_Text = 'Single Wheel (4)';
  } else if (Single_Wheel_Axles.length == 5) {
    Single_Wheel_Text = 'Single Wheel (5)';
  } else if (Single_Wheel_Axles.length == 6) {
    Single_Wheel_Text = 'Single Wheel (6)';
  } else if (Single_Wheel_Axles.length == 7) {
  } else if (Single_Wheel_Axles.length == 8) {
  } else if (Single_Wheel_Axles.length == 9) {
  } else if (Single_Wheel_Axles.length == 10) {
  }
  if (Double_Wheel_Axles.length == 0) {
    Double_Wheel_Axles = null;
  } else if (Double_Wheel_Axles.length == 1) {
    Double_Wheel_Text = 'Double Wheel (1)';
  } else if (Double_Wheel_Axles.length == 2) {
    Double_Wheel_Text = 'Double Wheel (2)';
  } else if (Double_Wheel_Axles.length == 3) {
    Double_Wheel_Text = 'Double Wheel (3)';
  } else if (Double_Wheel_Axles.length == 4) {
    Double_Wheel_Text = 'Double Wheel (4)';
  } else if (Double_Wheel_Axles.length == 5) {
    Double_Wheel_Text = 'Double Wheel (5)';
  } else if (Double_Wheel_Axles.length == 6) {
    Double_Wheel_Text = 'Double Wheel (6)';
  } else if (Single_Wheel_Axles.length == 7) {
  } else if (Single_Wheel_Axles.length == 8) {
  } else if (Single_Wheel_Axles.length == 9) {
  } else if (Single_Wheel_Axles.length == 10) {
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Single_Wheel_Text))) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Double_Wheel_Axles))) {
    } else {
      ___arguments.newObject['Axles'] = Double_Wheel_Axles;
    }
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Double_Wheel_Axles))) {
    } else {
      ___arguments.newObject['Axles'] = ([Single_Wheel_Text,',',Double_Wheel_Text].join(''));
    }
  }
  if ((getObjectProperty(___arguments.newObject, 'FIF_Dolly_Select')) == true) {
    ___arguments.newObject['Position'] = 'T2';
  }
  if ((getObjectProperty(___arguments.newObject, 'FIF_Follower_Select')) == true) {
    ___arguments.newObject['Position'] = 'T1,T2,T3';
  }
  if ((getObjectProperty(___arguments.newObject, 'FIF_Leader_Select')) == true) {
    ___arguments.newObject['Position'] = ['T1'];
  }
  ___arguments.newObject['ownerId'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId'));
  ID = (generateUUID().short());
  ___arguments.newObject['ID'] = ID;
  ___arguments.newObject['Registration'] = ID;
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Bulk_Created_Axles = (_uow.bulkCreate('Axles', Axles));
    _uow.update('Trailers', ___arguments.newObject);
    _uow.setRelation('Trailers', ___arguments.newObject, 'Axles_Data', Bulk_Created_Axles);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers', [___arguments.newObject]);

  })();

  console.log((await Transaction.execute()));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);

  },
  /* handler:onObjectCreate */
  /* content */
}))

define('./pages/Assets/components/6861900d258c4b88706e5c87c799f649/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectCreate */
  async ['onObjectCreate'](___arguments) {
    var Axles, Bowser, Bowsers, Bulk_Created_Bowsers, ID, list, Transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Bowsers = [];
  var repeat_end = (getObjectProperty(___arguments.newObject, 'BowserNumber'));
  for (var count = 0; count < repeat_end; count++) {
    Bowser = ({ [`Name`]: (generateUUID().short()),[`Meter`]: 0,[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')),[`objectId`]: (generateUUID().long()) });
    addItemToList(Bowsers, Bowser);
  }
  ___arguments.newObject['ownerId'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId'));
  ID = (generateUUID().short());
  ___arguments.newObject['Name'] = ID;
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Bulk_Created_Bowsers = (_uow.bulkCreate('Bowsers', Bowsers));
    _uow.update('Tanks', ___arguments.newObject);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tanks', [___arguments.newObject]);
    _uow.setRelation('Tanks', ___arguments.newObject, 'Bowsers', Bulk_Created_Bowsers);

  })();

  console.log((await Transaction.execute()));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);

  },
  /* handler:onObjectCreate */
  /* content */
}))

define('./pages/Assets/components/3c5758390996eca3a9354351427b0d67/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Employee_ID, Employee_Email, Employee_Number, Transaction, Employee_Details, User;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Conductor() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Employee_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')).length;
  Employee_ID = Employee_Number <= 10 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0000',Employee_Number].join('') : (Employee_Number <= 100 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 000',Employee_Number].join('') : (Employee_Number <= 1000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 00',Employee_Number].join('') : (Employee_Number <= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0',Employee_Number].join('') : (Employee_Number <= 100000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('')))));
  Employee_Email = [(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Employee_ID)),'@',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name'))))].join('');
}

/**
 * Describe this function...
 */
async function Admin() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Employee_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')).length;
  Employee_ID = Employee_Number <= 10 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0000',Employee_Number].join('') : (Employee_Number <= 100 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 000',Employee_Number].join('') : (Employee_Number <= 1000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 00',Employee_Number].join('') : (Employee_Number <= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0',Employee_Number].join('') : (Employee_Number <= 100000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('')))));
  Employee_Email = [(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Employee_ID)),'@',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name'))))].join('');
}

/**
 * Describe this function...
 */
async function Load_Planner() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Employee_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')).length;
  Employee_ID = Employee_Number <= 10 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0000',Employee_Number].join('') : (Employee_Number <= 100 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 000',Employee_Number].join('') : (Employee_Number <= 1000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 00',Employee_Number].join('') : (Employee_Number <= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0',Employee_Number].join('') : (Employee_Number <= 100000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('')))));
  Employee_Email = [(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Employee_ID)),'@',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name'))))].join('');
}

/**
 * Describe this function...
 */
async function Mechanic() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Employee_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')).length;
  Employee_ID = Employee_Number <= 10 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0000',Employee_Number].join('') : (Employee_Number <= 100 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 000',Employee_Number].join('') : (Employee_Number <= 1000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 00',Employee_Number].join('') : (Employee_Number <= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0',Employee_Number].join('') : (Employee_Number <= 100000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('')))));
  Employee_Email = [(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Employee_ID)),'@',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name'))))].join('');
}

/**
 * Describe this function...
 */
async function Attendant() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Employee_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')).length;
  Employee_ID = Employee_Number <= 10 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0000',Employee_Number].join('') : (Employee_Number <= 100 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 000',Employee_Number].join('') : (Employee_Number <= 1000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 00',Employee_Number].join('') : (Employee_Number <= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0',Employee_Number].join('') : (Employee_Number <= 100000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('')))));
  Employee_Email = [(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Employee_ID)),'@',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name'))))].join('');
}

/**
 * Describe this function...
 */
async function Driver() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Employee_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')).length;
  Employee_ID = Employee_Number <= 10 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0000',Employee_Number].join('') : (Employee_Number <= 100 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 000',Employee_Number].join('') : (Employee_Number <= 1000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 00',Employee_Number].join('') : (Employee_Number <= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0',Employee_Number].join('') : (Employee_Number <= 100000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('')))));
  Employee_Email = [(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Employee_ID)),'@',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')))),'.co.za'].join('').toLowerCase();
  console.log(Employee_Email);
  User = (await Backendless.UserService.register( new Backendless.User({ 'Email': Employee_Email,'password': '12345','App': 'Commercial','Level': 'Road','Name': Employee_ID,'Now': (new Date()),'Username': Employee_Email,'ownerId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }) ));
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    _uow.setRelation('Users', User, 'Company', [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))]);
    Employee_Details = (_uow.create('Employees', ({ [`Commencement`]: (new Date()),[`CID`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')),[`Company_ID`]: Employee_ID,[`Driver Ratings`]: ['Monthly Tonnage', 'Monthly Mileage', 'Fuel Consumption', 'Ideal Garages', 'Correct Loading'],[`Driver Target Mileage`]: 0,[`Driver Target Tonnage`]: 0,[`Driver_License_Code`]: 'EB',[`Driver_License_Expiry_Date`]: (new Date()),[`Driver_PDP_Expiry_Date`]: (new Date()),[`Driver_Warehouse_Status`]: 'In',[`Employee_Details_Nickname`]: Employee_ID,[`Employee_Details_Position`]: 'Driver',[`Now`]: (new Date()),[`Wages_Rate_Basic`]: 0,[`Wages_Rate_Contractor_Mileage`]: 0,[`Wages_Rate_Contractor_Tonnage`]: 0,[`Wages_Rate_Good_Driving`]: 0,[`Wages_Rate_Good_Planning_Mileage`]: 0,[`Wages_Rate_Good_Planning_Tonnage`]: 0,[`Wages_Rate_Sleep_Out`]: 0,[`Wages_Rate_Target_Mileage`]: 0,[`Wages_Rate_Target_Mileage_Start`]: 0,[`Wages_Rate_Target_Tonnage`]: 0,[`Wages_Rate_Target_Tonnage_Start`]: 0,[`ownerId`]: (getObjectProperty(User, 'objectId')) })));
    _uow.setRelation('Employees', Employee_Details, 'Company', [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))]);
    _uow.setRelation('Users', User, 'Details', [Employee_Details]);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees', [Employee_Details]);

  })();

  console.log((await Transaction.execute()));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
}


  if ('Driver' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c38359b6b32a2eb91939164745d67a2e')), 'value'))) {
    await Driver();
  } else if ('Conductor' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c38359b6b32a2eb91939164745d67a2e')), 'value'))) {
    await Conductor();
  } else if ('Load Planner' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c38359b6b32a2eb91939164745d67a2e')), 'value'))) {
    await Load_Planner();
  } else if ('Admin' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c38359b6b32a2eb91939164745d67a2e')), 'value'))) {
    await Admin();
  } else if ('Mechanic' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c38359b6b32a2eb91939164745d67a2e')), 'value'))) {
    await Mechanic();
  } else if ('Attendant' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c38359b6b32a2eb91939164745d67a2e')), 'value'))) {
    await Attendant();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/f0bc1b77c4e2b07e3083e2dc7e041175/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Profit_Loss_Projected')) < 0) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/f07872789a9af38f5ecca54dcd46ae33/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Profit_Loss_Projected')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Profit_Target')) * 1.5) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Assets/components/7aea89598cfaaafeb48d77cfffdf1fdb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Profit_Target'))))) {
    Content = 'No Target Set';
  } else {
    Content = ['(R ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Profit_Target')),')'].join('');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/70ba960fb4f21f47f2d7d24d6ad36cd4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('99a457935c8e264aa892775f6b25d371', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/5882489891b8b06153186b63b17b88fa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Distance_Actual')) + String(' km');

  } catch (error) {
    if (error) {
      Input = '0 km';
    }

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/eef77f316ba162a9887725ecf06bc7d3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Distance_Unplanned')) + String(' km');

  } catch (error) {

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/14c8be2367b28de91d9ba874ad077ddd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))))) {
    Content = 'No Ideal Rate Set';
  } else {
    Content = String('R ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'));
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/7282a2b99e92ff48fe668ad49f21bb28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, error, Unplanned_Mileage_Cost, k;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    Unplanned_Mileage_Cost = [];
    var k_list = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Loads'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if ((getObjectProperty(k, 'Status')) == 'Delivered') {
        addItemToList(Unplanned_Mileage_Cost, ((getObjectProperty(k, 'Distance_Differential_LDP_To_DP')) * (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Cost Per Km (Variables)'))));
      }
    }
    Content = String('R ') + String((await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((Unplanned_Mileage_Cost.reduce(function(x, y) {return x + y;})), null, null)));

  } catch (error) {
    console.log(error);

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/2ff2a8380042d96e1bd587bba75c1797/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Unplanned_Mileage_Cost, error, Content, j, k;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    Unplanned_Mileage_Cost = [];
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      var k_list = (getObjectProperty((getObjectProperty(j, 'Current_Fleetview')), 'Loads'));
      for (var k_index in k_list) {
        k = k_list[k_index];
        if ((getObjectProperty(k, 'Status')) == 'Delivered') {
          addItemToList(Unplanned_Mileage_Cost, ((getObjectProperty(k, 'Distance_Differential_LDP_To_DP')) * (getObjectProperty((getObjectProperty(j, 'Current_Fleetview')), 'Cost Per Km (Variables)'))));
        }
      }
    }
    Content = String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Unplanned_Mileage_Cost.reduce(function(x, y) {return x + y;})))));

  } catch (error) {
    console.log(error);

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/30e6591fbe6ca3bad316b55f32edf195/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Last_Location_ID, Last_Load, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Quick Load'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64c99a9b58ffea63cdef471e3503be85', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30e6591fbe6ca3bad316b55f32edf195', false);
  await new Promise(r => setTimeout(r, 200 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2fe7d4153d2a8742bcc1be3a9978b527', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968b3289c278ef666606e2f7c75a8bfb', true);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('968b3289c278ef666606e2f7c75a8bfb')));
  Last_Load = (await asyncListFilter((await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Loads')), -1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  })), async (item) => {


   return ((new Date()) > (getObjectProperty(item, 'Action Date')));
  })).slice(-1)[0];
  if ((getObjectProperty(Last_Load, 'Status')) == 'Delivered') {
    Last_Location_ID = (getObjectProperty(Last_Load, 'LDPID'));
  } else if ((getObjectProperty(Last_Load, 'Status')) == 'Loaded') {
    Last_Location_ID = (getObjectProperty(Last_Load, 'LLPID'));
  } else if ((getObjectProperty(Last_Load, 'Status')) == 'Planned') {
    Last_Location_ID = (getObjectProperty(Last_Load, 'LLDPID'));
  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6', Last_Location_ID);

  } catch (error) {

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('664377fad813557d34317e83353fed92');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('664377fad813557d34317e83353fed92');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/Assets/components/325807b83c25e78b816ae7a87ba98c06/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Notes')), ''))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/Assets/components/572ad1ce59198071b015ab120f8cd87a/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('e94dd6878423bcafa2b99aa1c3573869');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('e94dd6878423bcafa2b99aa1c3573869');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('e3390c24d856e493716ad361d0896502', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/573e39ba835cbede34b34b5d9593e779/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b44c14361f47de7c7d87142cc9d351f7')), ({ [`New Delivery`]: (generateUUID().short()) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/0d177aaf43b7f14ac3bbfa2bc00bd0e4/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Assets/components/4c0b8487d6ce981359966ade78114cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Assets/components/05e69e4ed89121be124244774811b26d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Assets/components/ecf14b0776f8f5c902ac3e156d577a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/Assets/components/12d24b66f551ff3b7f0d6607a86e3539/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Open AI Session'] = (getObjectProperty((await Backendless.Request.post(`${Backendless.appPath}/services/OpenAI/session`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'aiModel': 'gpt-3.5-turbo' })), 'sessionId'));
  ___arguments.event['Start Point'] = ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ecf14b0776f8f5c902ac3e156d577a9d')));
  }))[0]);
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b44c14361f47de7c7d87142cc9d351f7'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['Customer Data'] = ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'Customer')));
    }))[0]);
    j['Load Point Data'] = ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'Load')));
    }))[0]);
    j['Delivery Point Data'] = ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'Delivery')));
    }))[0]);
    console.log(j);
  }
  console.log({ [`Start Point`]: ({ [`Name`]: (getObjectProperty((getObjectProperty(___arguments.event, 'Start Point')), 'Name')),[`Location`]: (getObjectProperty((getObjectProperty(___arguments.event, 'Start Point')), 'Point')),[`objectId`]: (getObjectProperty((getObjectProperty(___arguments.event, 'Start Point')), 'objectId')) }),[`Loads`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b44c14361f47de7c7d87142cc9d351f7')).map(async item => {; return ({ [`Load`]: ({ [`Name`]: (getObjectProperty((getObjectProperty(item, 'Load Point Data')), 'Name')),[`Location`]: (getObjectProperty((getObjectProperty(item, 'Load Point Data')), 'Point')),[`objectId`]: (getObjectProperty((getObjectProperty(item, 'Load Point Data')), 'objectId')) }),[`Delivery`]: ({ [`Name`]: (getObjectProperty((getObjectProperty(item, 'Delivery Point Data')), 'Name')),[`Location`]: (getObjectProperty((getObjectProperty(item, 'Delivery Point Data')), 'Point')),[`objectId`]: (getObjectProperty((getObjectProperty(item, 'Delivery Point Data')), 'objectId')) }) });}))) });
  console.log((await (async function(message, apiKey) {
  	async function reorderLocations(apiKey, promptMessage) {
  	  try {
  	    // Call the Chat Completions endpoint
  	    const response = await fetch('https://api.openai.com/v1/chat/completions', {
  	      method: 'POST',
  	      headers: {
  	        'Content-Type': 'application/json',
  	        // Use apiKey in Bearer token
  	        'Authorization': `Bearer ${apiKey}`
  	      },
  	      body: JSON.stringify({
  	        model: 'gpt-4-turbo',  // Chat model
  	        messages: [
  	          {
  	            role: 'user',
  	            content: promptMessage // The prompt text we pass in
  	          }
  	        ],
  	        max_tokens: 1500,
  	        temperature: 0.5
  	      })
  	    });
  	
  	    if (!response.ok) {
  	      throw new Error(`OpenAI request failed: ${response.status} ${response.statusText}`);
  	    }
  	
  	    // Parse response JSON
  	    const data = await response.json();
  	
  	    // Chat Completions store output in data.choices[0].message.content
  	    const resultText = data.choices?.[0]?.message?.content?.trim() ?? '';
  	    return resultText;
  	
  	  } catch (error) {
  	    console.error('Error in reorderLocations:', error);
  	    throw error;
  	  }
  	}
  	
  	// In Backendless Codeless, you define two input variables: apiKey and message.
  	// Then reference them directly:
  	return await reorderLocations(apiKey, message);

  })(([' Instruction Message: You are given a JSON dataset containing multiple locations. Your task is to reorder these locations into the most logically efficient travel sequence while maintaining key constraints.  🔹 Input Data Contains: One Start Point (always appears first). Multiple Load locations (places where items are picked up). Multiple Delivery locations (places where items are dropped off). A location can be both a Load and a Delivery. If a location plays both roles, it must appear each time it is required. Each Load must occur before any Delivery that depends on it. A single Load location may be the source for multiple Deliveries. A single Delivery location may receive goods from multiple Loads. A location may appear multiple times in the route if necessary, but avoid unnecessary backtracking.','Strict Rules for Reordering the Locations: 1️⃣ Start at the designated "Start Point"  The first entry in the final JSON must be the Start Point exactly as provided in the input. 2️⃣ Maintain Logical Order of Loads and Deliveries  Each Load location must be visited before its corresponding Delivery location(s). If multiple Loads are required before certain Deliveries, optimize the sequence to minimize distance. 3️⃣ Handling Locations that Serve as Both Load & Delivery  If a location is both a Load and a Delivery, it must appear twice: Once as a Delivery (for a previous Load). Once as a Load (for a future Delivery). Example: If "Location A" is a Delivery from a previous Load AND a Load for another Delivery, it must appear in the list two times in the correct sequence. 4️⃣ Avoid Unnecessary Backtracking  The travel sequence must be as geographically efficient as possible. The solution should not return to a location unless absolutely required to pick up a Load before a necessary Delivery. 5️⃣ Ensure the Correct Total Number of Objects in the JSON  The total number of objects in the returned JSON must be: (Total Load-Delivery Pairs × 2) + 1 (Start Point) = Total Objects Example: If the input contains 5 Load-Delivery pairs, the output must contain 11 locations. 6️⃣ Maintain the Original "Type" Labels  The "Type" of each location must remain unchanged: The Start Point stays "Start Point" Loads remain "Load" Deliveries remain "Delivery" Example Output Format:','{    "Name": "Location Name",     "Coordinates": [Latitude, Longitude],     "Type": "Start Point / Load / Delivery",     "objectId": "objectId" }',(JSON.stringify(({ [`Start Point`]: ({ [`Name`]: (getObjectProperty((getObjectProperty(___arguments.event, 'Start Point')), 'Name')),[`Location`]: (getObjectProperty((getObjectProperty(___arguments.event, 'Start Point')), 'Point')),[`objectId`]: (getObjectProperty((getObjectProperty(___arguments.event, 'Start Point')), 'objectId')) }),[`Loads`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b44c14361f47de7c7d87142cc9d351f7')).map(async item => {; return ({ [`Load`]: ({ [`Name`]: (getObjectProperty((getObjectProperty(item, 'Load Point Data')), 'Name')),[`Location`]: (getObjectProperty((getObjectProperty(item, 'Load Point Data')), 'Point')),[`objectId`]: (getObjectProperty((getObjectProperty(item, 'Load Point Data')), 'objectId')) }),[`Delivery`]: ({ [`Name`]: (getObjectProperty((getObjectProperty(item, 'Delivery Point Data')), 'Name')),[`Location`]: (getObjectProperty((getObjectProperty(item, 'Delivery Point Data')), 'Point')),[`objectId`]: (getObjectProperty((getObjectProperty(item, 'Delivery Point Data')), 'objectId')) }) });}))) })))].join('')), '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')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/0c8493f3df69b3a61cf5bdc66f32d3e7/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND TID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),'\' AND created >= ',(await (async function(Start) {
	function getStartOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const startOfMonth = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
	  startOfMonth.setHours(0, 0, 0, 0); // Set to the start of the day
	
	  return startOfMonth.getTime();
	}
	
	// Directly execute and return the result
	return getStartOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created')))),' AND created <= ',(await (async function(Start) {
	function getEndOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
	  endDate.setHours(23, 59, 59, 999); // Set to the end of the day
	
	  return endDate.getTime();
	}
	
	// Directly execute and return the result
	return getEndOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created'))))].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/Assets/components/e8aeeabb35e345512e272c1fbc32e45a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Deliver, Maintenance_Item, Trailer, Tractor;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Service() {
  Maintenance_Item = (await Backendless.Data.of('Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Service_ID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Service_ID')),'\''].join(''))).setPageSize(10)))[0];
  if ((getObjectProperty(Maintenance_Item, 'Vehicle Type')) == 'Tractor') {
    Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(Maintenance_Item, 'Tractor ID')), ));
    Tractor['Last_Service_Scheduled'] = ((getObjectProperty(Tractor, 'Last_Service_Scheduled')) - (getObjectProperty(Tractor, 'Service_Interval')));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Last_Service_Scheduled'));
  } else {
    Trailer = (await Backendless.Data.of('Trailers').findById((getObjectProperty(Maintenance_Item, 'Trailer ID')), ));
    Trailer['Last_Service_Scheduled'] = ((getObjectProperty(Trailer, 'Last_Service_Scheduled')) - (getObjectProperty(Tractor, 'Service_Interval')));
  }
  Deliver = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Deliver;

    if ((getObjectProperty(Maintenance_Item, 'Vehicle Type')) == 'Tractor') {
      _uow.update('Tractors', Tractor);
    } else {
      _uow.update('Trailers', Trailer);
    }
    _uow.delete('Loads', ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'));
    _uow.delete('Maintenance', Maintenance_Item);

  })();

  console.log((await Deliver.execute()));
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8aeeabb35e345512e272c1fbc32e45a', false);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Load_Type')) == 'Service') {
    await Service();
  } else {
    Deliver = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    console.log(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'));
    ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['Status'] = 'Delivered';
    ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['Mileage_Delivery_Point'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Mileage_Load_Point')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Planned Mileage'))) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Distance_Last_Delivery_Point_To_Load_Point')));
    await Backendless.Data.of('Loads').save(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), true);
  }
  removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), '');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'Status')) != 'Delivered');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  })));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('e319ea6acf9a6477338b64b409e3b82c');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/8b312a145f429d646c13cc7ef8decd79/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'DELIVER') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8aeeabb35e345512e272c1fbc32e45a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8aeeabb35e345512e272c1fbc32e45a', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/0629424d0ba703623f740d5f2951e4fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('74e3173ac4597894b2bc3012ce47e98f');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/b92afe52281f1db72a2391f12c1c1c94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('75b2c06d94c8b6b4491d6763d22d18ef')), ({ [`ID`]: (generateUUID().short()) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/18a316eac50536d9d81f7c32925444ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c73ededba8ad18875b317c46b82b4d46')), ({ [`ID`]: (generateUUID().short()) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/e63c7882d917983a7159969a1ecee5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ac6af178b324c6c1d70518e72bd48a63')), ({ [`ID`]: (generateUUID().short()) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/1cc9068975aadeddb4e6ed04486e0a2d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('75b2c06d94c8b6b4491d6763d22d18ef')), ___arguments.context.getComponentDataStoreByUid('898356667d73f03a20971ce35c080171'), '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/63346022e592d1cf37ab13fa323f0ceb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c73ededba8ad18875b317c46b82b4d46')), ___arguments.context.getComponentDataStoreByUid('865c87375549ff4750dfe37b7a4d4661'), '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/2c246ec8bd61a8c56336182eb0aa9ba6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ac6af178b324c6c1d70518e72bd48a63')), ___arguments.context.getComponentDataStoreByUid('3eaf86a7f3b4c8749c4c193e3c5bb9b3'), '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Assets/components/aa02e8765bcb0dfd35ad2daad32f98a9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;


  try {
    delete ___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb')['Load Planner - Markers'];

  } catch (error) {
    console.log(error);

  }
  delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Route'];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', false);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/f7c75b76c869c166dd4e68f293e95109/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Point;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Point = (await ( async function (placeId, fields) {
   if (!window.google || !window.google.maps || !window.google.maps.places) {
     return Promise.reject('Google Maps library was not initialized')
   }

   if (!placeId) {
     return Promise.reject('Place ID is empty')
   }

   const Status = google.maps.places.PlacesServiceStatus
   const StatusMessages = {
     [Status.INVALID_REQUEST] : 'The API request was malformed',
     [Status.NOT_FOUND]       : 'The referenced location, place ID, was not found in the Places database.',
     [Status.OVER_QUERY_LIMIT]: 'Any of the following:\n - You have exceeded the QPS limits.\n - Billing has not been enabled on your account.\n - The monthly $200 credit, or a self-imposed usage cap, has been exceeded.\n - The provided method of payment is no longer valid (for example, a credit card has expired).',
     [Status.REQUEST_DENIED]  : 'Your request was denied, generally because:\n - The request is missing an API key.\n - The key parameter is invalid.',
     [Status.UNKNOWN_ERROR]   : 'An unknown error.',
     [Status.ZERO_RESULTS]    : 'The referenced location, place ID , was valid but no longer refers to a valid result. This may occur if the establishment is no longer in business.',
   }

   const enrichPlaceWithLocation = place => {
     if (place.geometry) {
       const lat = place.geometry.location.lat()
       const lng = place.geometry.location.lng()

       place.location = { lat, lng }
     }

     return place
   }

   const service = new google.maps.places.PlacesService(document.createElement('div'))
   const request = { placeId, fields }

   return new Promise((resolve, reject) => {
     service.getDetails(request, callback)

     function callback(place, status) {
       if (status === Status.OK) {
         resolve(enrichPlaceWithLocation(place))
       } else {
         const errorLocationMessage = 'An error occurred while retrieving Google Place Details.\n'
         const errorMessage = StatusMessages[status] ? errorLocationMessage + StatusMessages[status] : errorLocationMessage + 'An unknown error.'

         reject(new Error(errorMessage))
       }
     }
   })
   })((getObjectProperty(___arguments.value, 'place_id')), ['geometry.location', 'name', 'place_id', 'formatted_address']));
  ___arguments.context.getComponentDataStoreByUid('898356667d73f03a20971ce35c080171')['Point'] = (getObjectProperty(Point, 'location'));
  ___arguments.context.getComponentDataStoreByUid('898356667d73f03a20971ce35c080171')['Data'] = Point;

  },
  /* handler:onChange */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('f7c75b76c869c166dd4e68f293e95109', undefined, ({ [`country`]: ['za'] }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/Assets/components/0437c27d47cfb775f8ded47573b57bb2/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('0437c27d47cfb775f8ded47573b57bb2', undefined, ({ [`country`]: ['za'] }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

  },
  /* handler:onMounted */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Point;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Point = (await ( async function (placeId, fields) {
   if (!window.google || !window.google.maps || !window.google.maps.places) {
     return Promise.reject('Google Maps library was not initialized')
   }

   if (!placeId) {
     return Promise.reject('Place ID is empty')
   }

   const Status = google.maps.places.PlacesServiceStatus
   const StatusMessages = {
     [Status.INVALID_REQUEST] : 'The API request was malformed',
     [Status.NOT_FOUND]       : 'The referenced location, place ID, was not found in the Places database.',
     [Status.OVER_QUERY_LIMIT]: 'Any of the following:\n - You have exceeded the QPS limits.\n - Billing has not been enabled on your account.\n - The monthly $200 credit, or a self-imposed usage cap, has been exceeded.\n - The provided method of payment is no longer valid (for example, a credit card has expired).',
     [Status.REQUEST_DENIED]  : 'Your request was denied, generally because:\n - The request is missing an API key.\n - The key parameter is invalid.',
     [Status.UNKNOWN_ERROR]   : 'An unknown error.',
     [Status.ZERO_RESULTS]    : 'The referenced location, place ID , was valid but no longer refers to a valid result. This may occur if the establishment is no longer in business.',
   }

   const enrichPlaceWithLocation = place => {
     if (place.geometry) {
       const lat = place.geometry.location.lat()
       const lng = place.geometry.location.lng()

       place.location = { lat, lng }
     }

     return place
   }

   const service = new google.maps.places.PlacesService(document.createElement('div'))
   const request = { placeId, fields }

   return new Promise((resolve, reject) => {
     service.getDetails(request, callback)

     function callback(place, status) {
       if (status === Status.OK) {
         resolve(enrichPlaceWithLocation(place))
       } else {
         const errorLocationMessage = 'An error occurred while retrieving Google Place Details.\n'
         const errorMessage = StatusMessages[status] ? errorLocationMessage + StatusMessages[status] : errorLocationMessage + 'An unknown error.'

         reject(new Error(errorMessage))
       }
     }
   })
   })((getObjectProperty(___arguments.value, 'place_id')), ['geometry.location', 'name', 'place_id', 'formatted_address']));
  ___arguments.context.getComponentDataStoreByUid('865c87375549ff4750dfe37b7a4d4661')['Point'] = (getObjectProperty(Point, 'location'));
  ___arguments.context.getComponentDataStoreByUid('865c87375549ff4750dfe37b7a4d4661')['Data'] = Point;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/41dab0ab05413bef10e18bf5400ed315/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('41dab0ab05413bef10e18bf5400ed315', undefined, ({ [`country`]: ['za'] }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

  },
  /* handler:onMounted */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Point;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Point = (await ( async function (placeId, fields) {
   if (!window.google || !window.google.maps || !window.google.maps.places) {
     return Promise.reject('Google Maps library was not initialized')
   }

   if (!placeId) {
     return Promise.reject('Place ID is empty')
   }

   const Status = google.maps.places.PlacesServiceStatus
   const StatusMessages = {
     [Status.INVALID_REQUEST] : 'The API request was malformed',
     [Status.NOT_FOUND]       : 'The referenced location, place ID, was not found in the Places database.',
     [Status.OVER_QUERY_LIMIT]: 'Any of the following:\n - You have exceeded the QPS limits.\n - Billing has not been enabled on your account.\n - The monthly $200 credit, or a self-imposed usage cap, has been exceeded.\n - The provided method of payment is no longer valid (for example, a credit card has expired).',
     [Status.REQUEST_DENIED]  : 'Your request was denied, generally because:\n - The request is missing an API key.\n - The key parameter is invalid.',
     [Status.UNKNOWN_ERROR]   : 'An unknown error.',
     [Status.ZERO_RESULTS]    : 'The referenced location, place ID , was valid but no longer refers to a valid result. This may occur if the establishment is no longer in business.',
   }

   const enrichPlaceWithLocation = place => {
     if (place.geometry) {
       const lat = place.geometry.location.lat()
       const lng = place.geometry.location.lng()

       place.location = { lat, lng }
     }

     return place
   }

   const service = new google.maps.places.PlacesService(document.createElement('div'))
   const request = { placeId, fields }

   return new Promise((resolve, reject) => {
     service.getDetails(request, callback)

     function callback(place, status) {
       if (status === Status.OK) {
         resolve(enrichPlaceWithLocation(place))
       } else {
         const errorLocationMessage = 'An error occurred while retrieving Google Place Details.\n'
         const errorMessage = StatusMessages[status] ? errorLocationMessage + StatusMessages[status] : errorLocationMessage + 'An unknown error.'

         reject(new Error(errorMessage))
       }
     }
   })
   })((getObjectProperty(___arguments.value, 'place_id')), ['geometry.location', 'name', 'place_id', 'formatted_address']));
  ___arguments.context.getComponentDataStoreByUid('3eaf86a7f3b4c8749c4c193e3c5bb9b3')['Point'] = (getObjectProperty(Point, 'location'));
  ___arguments.context.getComponentDataStoreByUid('3eaf86a7f3b4c8749c4c193e3c5bb9b3')['Data'] = Point;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/Assets/components/0e2168af68225154ffa1e11f33d43963/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route'))))) {
    Content = '-';
  } else {
    Content = String((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route')), 'Distance')) / 1000) + String(' km');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/Assets/components/a32e2b289ee5bf7257873e7a1efec907/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route'))))) {
    Content = null;
  } else {
    Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route')), 'Distance')) / 1000;
  }

  return Content

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/FIF/components/b80abc2989b4045a394d6f8d512ea70c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Menu View')) == true) {
    console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4331407ae8680bbdb9be5842e7c716d2'));
    Viewer = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4331407ae8680bbdb9be5842e7c716d2'))['opacity'] = 0.8;
  } else {
    Viewer = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4331407ae8680bbdb9be5842e7c716d2'))['opacity'] = 1;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/7dab1f6deb9f168dca5a32416584f1ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Menu_View() {
  if ((getObjectProperty(___arguments.context.pageData, 'Menu View')) == true) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7dab1f6deb9f168dca5a32416584f1ee'))['icon'] = 'menu';
    ___arguments.context.pageData['Menu View'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7dab1f6deb9f168dca5a32416584f1ee'))['icon'] = 'menu open';
    ___arguments.context.pageData['Menu View'] = true;
  }
}


  await Menu_View();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/1f2c1089422104959eda36c566955a12/bundle.js', [], () => ({
  /* content */
  /* handler:stepListLogic */
  ['stepListLogic'](___arguments) {
      return (['Director,','Company,','Admin,'].join(''))

  },
  /* handler:stepListLogic */
  /* content */
}))

define('./pages/FIF/components/16d93905eaf2d09257383efa3036814e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'New Customer View')) == true) {
  } else {
    ___arguments.context.pageData['New Customer View'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7dab1f6deb9f168dca5a32416584f1ee'))['icon'] = 'menu';
    ___arguments.context.pageData['Menu View'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/c4afa8f9aa7f0bf5b54a3b923eaa95bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['New Customer View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/a30990329542f90c15042e66bea14df6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'New Customer View')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/bac8dfb9d07979089bae3b661c5b3f05/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7dab1f6deb9f168dca5a32416584f1ee'))['icon'] = 'menu';
  ___arguments.context.pageData['Menu View'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/76579339102a96ebe7ee82c525789ad5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'View Full Screen ')) == true) {
    await BackendlessUI.Functions.Custom['fn_baa947591c610deb3e63b2bad24a09a4']((getObjectProperty(___arguments.context.pageData, 'View Full Screen ')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('76579339102a96ebe7ee82c525789ad5')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('76579339102a96ebe7ee82c525789ad5')));
    ___arguments.context.pageData['View Full Screen '] = false;
  } else {
    await BackendlessUI.Functions.Custom['fn_baa947591c610deb3e63b2bad24a09a4']((getObjectProperty(___arguments.context.pageData, 'View Full Screen ')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('76579339102a96ebe7ee82c525789ad5')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('76579339102a96ebe7ee82c525789ad5')));
    ___arguments.context.pageData['View Full Screen '] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/fa142e74f86bd762700fb3e28bab49ce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Director Contact And User Details - Viewer')) == true) {
    ___arguments.context.pageData['Director Contact And User Details - Viewer'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('29bbee39f24691820767ab17ee3835d6'))['icon'] = 'arrow drop down';
  } else {
    ___arguments.context.pageData['Director Contact And User Details - Viewer'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('29bbee39f24691820767ab17ee3835d6'))['icon'] = 'arrow drop up';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/4b64858cdffb596ae87ee6867fc6fe08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Director Contact And User Details - Viewer')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/a05931b1c7a218ee37a1a329a08d0c9d/bundle.js', [], () => ({
  /* content */
  /* handler:leftListItemsLogic */
  ['leftListItemsLogic'](___arguments) {
      return [({ 'label': 'Com Director Dashboard','value': 'Com Director Dashboard' }), ({ 'label': 'Com Financial Overview','value': 'Com Financial Overview' }), ({ 'label': 'Com CPK Overview','value': 'Com CPK Overview' }), ({ 'label': 'Com Salary Overview','value': 'Com Salary Overview' }), ({ 'label': 'Com Targets','value': 'Com Targets' }), ({ 'label': 'Com Fleet Overview','value': 'Com Fleet Overview' }), ({ 'label': 'Com Broker Overview','value': 'Com Broker Overview' }), ({ 'label': 'Com Broker Level (Broker)','value': 'Com Broker Level (Broker)' }), ({ 'label': 'Com Broker Level (Director)','value': 'Com Broker Level (Director)' }), ({ 'label': 'Com Load Planner','value': 'Com Load Planner' }), ({ 'label': 'Com Maintenance Hub ','value': 'Com Maintenance Hub ' }), ({ 'label': 'Com (Admin) Add Load ','value': 'Com (Admin) Add Load ' }), ({ 'label': 'Com (Admin) Add Fuel ','value': 'Com (Admin) Add Fuel ' }), ({ 'label': 'Com (Admin) Board Truck','value': 'Com (Admin) Board Truck' }), ({ 'label': 'Com (Admin) Leave Truck','value': 'Com (Admin) Leave Truck' }), ({ 'label': 'Com (Admin) Swap Trailer','value': 'Com (Admin) Swap Trailer' }), ({ 'label': 'Com (Admin) Swap Tyre','value': 'Com (Admin) Swap Tyre' })]

  },
  /* handler:leftListItemsLogic */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Director Permissions Commercial - Viewer')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Director Permissions'] = ((await Promise.all(___arguments['rightItems'].map(async item => {; return (getObjectProperty(item, 'value'));}))).join(','));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIF/components/eab6d7386e2a0141a634f6b2902f2855/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Director Permissions - Viewer')) == true) {
    ___arguments.context.pageData['Director Permissions - Viewer'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eef2e1b637c6988d352d4d4355c17a49'))['icon'] = 'arrow drop down';
  } else {
    ___arguments.context.pageData['Director Permissions - Viewer'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eef2e1b637c6988d352d4d4355c17a49'))['icon'] = 'arrow drop up';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/027da93efbb687129121b481d66505d1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Director Permissions - Viewer')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/af69be79cd7d63bc140741e4fa7955b1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Commercial') {
    ___arguments.context.pageData['Director Permissions Commercial - Viewer'] = true;
    ___arguments.context.pageData['Director Permissions Agri - Viewer'] = false;
  } else if (___arguments.value == 'Agri') {
    ___arguments.context.pageData['Director Permissions Commercial - Viewer'] = false;
    ___arguments.context.pageData['Director Permissions Agri - Viewer'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIF/components/c71af9e80b48cac5482dd70676d8134c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Director Permissions Agri - Viewer')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:leftListItemsLogic */
  ['leftListItemsLogic'](___arguments) {
      return [({ 'label': 'Agri Farm Log','value': 'Agri Farm Log' }), ({ 'label': 'Agri Log Book','value': 'Agri Log Book' })]

  },
  /* handler:leftListItemsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Director Permissions'] = ((await Promise.all(___arguments['rightItems'].map(async item => {; return (getObjectProperty(item, 'value'));}))).join(','));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIF/components/16992df4f2ea046147747f07f17faee9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;


  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getCurrentStep() })('1f2c1089422104959eda36c566955a12')) == 1) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/45bd682fd0df04bcbf2dbd7b0ebe4593/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Result, Transaction, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function do_something2() {
  ___arguments.context.pageData['Step 1 - Completed'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goNextStep() })('1f2c1089422104959eda36c566955a12');
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    try {
      ___arguments.context.pageData['New Director'] = (await Backendless.UserService.register( new Backendless.User({ 'Name': (getObjectProperty(___arguments.context.pageData, 'Director Name')),'Username': (getObjectProperty(___arguments.context.pageData, 'Director Username')),'Phone': (await BackendlessUI.Functions.Custom['fn_70b8ca4740171f42c0aa414f72c30dde']((getObjectProperty(___arguments.context.pageData, 'Director Phone')))),'App': ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('af69be79cd7d63bc140741e4fa7955b1')),'Level': 'Office','Permissions': (getObjectProperty(___arguments.context.pageData, 'Director Permissions')),'password': (getObjectProperty(___arguments.context.pageData, 'Director Password')),'email': (getObjectProperty(___arguments.context.pageData, 'Director Email')) }) ));

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        ___arguments.context.pageData['Step 1 Error'] = 'Director Registration Error';
      }

    }
    try {
      await Backendless.Files.createDirectory(encodePath((String('users/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'ownerId')))));

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        ___arguments.context.pageData['Step 1 Error'] = 'User File Directory Creation Error';
      }

    }
    _uow.create('Companies', ({ [`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'ownerId')),[`Directory`]: String('users/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'ownerId')),[`Step`]: 1 })).setOpResultId('NewCompany');
    _uow.setRelation('Users', (getObjectProperty(___arguments.context.pageData, 'New Director')), 'Company', (Transaction.getOpResultById('NewCompany')));
    _uow.setRelation('Users', (getObjectProperty(___arguments.context.pageData, 'New Director')), 'Company', (Transaction.getOpResultById('NewCompany')));

  })();

  Result = (await Transaction.execute().then(function(result) {
      const error = result && result.error

      if (error) {
        throw error
      }

    return result
    }));
  ___arguments.context.pageData['New Company'] = (getObjectProperty((getObjectProperty((getObjectProperty(Result, 'results')), 'NewCompany')), 'result'));
  console.log(getObjectProperty(___arguments.context.pageData, 'New Company'));
  console.log(Result);
}

/**
 * Describe this function...
 */
async function Old_Code() {
  ___arguments.context.pageData['Step 1 - Completed'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goNextStep() })('1f2c1089422104959eda36c566955a12');
  ___arguments.context.pageData['New Director'] = (await Backendless.UserService.register( new Backendless.User({ 'Name': (getObjectProperty(___arguments.context.pageData, 'Director Name')),'Username': (getObjectProperty(___arguments.context.pageData, 'Director Username')),'Phone': (await BackendlessUI.Functions.Custom['fn_70b8ca4740171f42c0aa414f72c30dde']((getObjectProperty(___arguments.context.pageData, 'Director Phone')))),'App': ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('af69be79cd7d63bc140741e4fa7955b1')),'Level': 'Office','Permissions': (getObjectProperty(___arguments.context.pageData, 'Director Permissions')),'password': (getObjectProperty(___arguments.context.pageData, 'Director Password')),'email': (getObjectProperty(___arguments.context.pageData, 'Director Email')) }) ));
  ___arguments.context.pageData['New Company'] = (await Backendless.Data.of('Companies').save( ({ [`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'ownerId')),[`Directory`]: String('users/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'ownerId')) }) ));
  await Backendless.Files.createDirectory(encodePath((String('users/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'ownerId')))));
  await Backendless.Data.of('Users').setRelation((getObjectProperty(___arguments.context.pageData, 'New Director')), 'Company', [(getObjectProperty(___arguments.context.pageData, 'New Company'))]);
}


  await do_something2();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Director Password')) != (getObjectProperty(___arguments.context.pageData, 'Director Password Confirm')) || !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 1 - Password Lock')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Director Phone')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Director Email')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Director Password')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Director Username')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Director Name')))) || !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 1 - Password Lock')))) || !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 1 - Username Lock')))) || !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 1 - Password Confirm Lock')))) || !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 1 - Email Lock')))) || !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 1 - Phone Lock')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Director Permissions Commercial - Viewer')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Director Permissions Agri - Viewer'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/e5bbf50a0f01674c14a2ca2a0fec46f9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;


  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getCurrentStep() })('1f2c1089422104959eda36c566955a12')) == 2) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/6bacf4514c945ad1aeeda25af8432353/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Data = (await Backendless.Request.get(`${Backendless.appPath}/services/GoogleAPI/PlaceDetails`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'placeId': JSON.stringify((getObjectProperty(___arguments.value, 'place_id'))) }).send());
  ___arguments.context.pageData['Step 2 Company Details - Mapbox Search'] = Data;
  await ( async function (componentUid, center, eventData) {  ___arguments.context.getComponentByUid(componentUid).setCenter(center, eventData) })('177aa7dc81a54e2803b83f429bb98969', ({ 'lat': (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Data, 'result')), 'geometry')), 'location')), 'lat')),'lng': (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Data, 'result')), 'geometry')), 'location')), 'lng')) }), undefined);
  await ( async function (componentUid, zoom, eventData) {  ___arguments.context.getComponentByUid(componentUid).setZoom(zoom, eventData) })('177aa7dc81a54e2803b83f429bb98969', 17, undefined);

  },
  /* handler:onChange */
  /* handler:onPlacesPredictionsAssignment */
  ['onPlacesPredictionsAssignment'](___arguments) {
      return ({ 'componentRestrictions': ({ 'country': 'za' }) })

  },
  /* handler:onPlacesPredictionsAssignment */
  /* handler:onQueryPredictionsAssignment */
  ['onQueryPredictionsAssignment'](___arguments) {
      return ({ 'componentRestrictions': ({ 'country': 'za' }) })

  },
  /* handler:onQueryPredictionsAssignment */
  /* content */
}))

define('./pages/FIF/components/177aa7dc81a54e2803b83f429bb98969/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Step 2 - Company Location'] = [({ 'color': '#CC6633','description': (getObjectProperty(___arguments.context.pageData, 'Company Name')),'coordinates': ___arguments['coordinates'] })];

  },
  /* handler:onClick */
  /* handler:markersLogic */
  async ['markersLogic'](___arguments) {
    var Markers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 2 - Company Location'))))) {
    Markers = null;
  } else {
    Markers = (getObjectProperty(___arguments.context.pageData, 'Step 2 - Company Location'));
  }

  return Markers

  },
  /* handler:markersLogic */
  /* content */
}))

define('./pages/FIF/components/11b296debc97eef6c8df498c0b696ef5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'New Company Logo')) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var fileExt, Name;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split(',').slice(-1)[0];
  Name = [(generateUUID().long()),'.',fileExt].join('');
  ___arguments.context.pageData['New Company Logo File Path'] = (String((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'New Company')))) ? Name : String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Directory')) + String('/Logo/')) + String(''));

  return Name

  },
  /* handler:onFileNameAssignment */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var Directory;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'New Company')))) ? null : String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Directory')) + String('/Logo')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('11b296debc97eef6c8df498c0b696ef5');

  },
  /* handler:onUploadFail */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var File2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var File2_list = ___arguments.files;
  for (var File2_index in File2_list) {
    File2 = File2_list[File2_index];
    if ((getObjectProperty(File2, 'size')) > 4 * 1024 * 1024) {
      ___arguments.context.pageData['New Company Logo Large Image'] = (['(',(getObjectProperty(File2, 'size')) / (1024 * 1024),' MB)'].join(''));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2b5ecaa92763d31d7f7c478cf6bc3e1d');
      while (!((getObjectProperty(___arguments.context.pageData, 'New Company Logo Large Image Confirm')) == true || (getObjectProperty(___arguments.context.pageData, 'New Company Logo Large Image Confirm')) == false)) {
        await new Promise(r => setTimeout(r, 5 || 0));
      }
      if ((getObjectProperty(___arguments.context.pageData, 'New Company Logo Large Image Confirm')) == false) {
        throw (new Error('File Size'))
      }
    }
  }

  },
  /* handler:onBeforeUpload */
  /* content */
}))

define('./pages/FIF/components/2b5ecaa92763d31d7f7c478cf6bc3e1d/bundle.js', [], () => ({
  /* content */
  /* handler:contentLogic */
  ['contentLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Large Image Detected.','\n\n',(getObjectProperty(___arguments.context.pageData, 'New Company Logo Large Image')),' Do you wish to proceed'].join(''))

  },
  /* handler:contentLogic */
  /* handler:titleLogic */
  ['titleLogic'](___arguments) {
      return 'Upload Warning'

  },
  /* handler:titleLogic */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
      ___arguments.context.pageData['New Company Logo Large Image Confirm'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2b5ecaa92763d31d7f7c478cf6bc3e1d');

  },
  /* handler:onSubmit */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      ___arguments.context.pageData['New Company Logo Large Image Confirm'] = false;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2b5ecaa92763d31d7f7c478cf6bc3e1d');

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/FIF/components/b5c90b47c937b3fcc082be58a7316cba/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Director Password')).length >= 8 == false && (await BackendlessUI.Functions.Custom['fn_a3ba58b7eb1904ecefbc1692317c470e']((getObjectProperty(___arguments.context.pageData, 'Director Password')))) == false) {
    ___arguments.context.pageData['Step 1 - Password Lock'] = 'Please ensure password contains special characters and is 8 or more characters';
  } else if ((getObjectProperty(___arguments.context.pageData, 'Director Password')).length >= 8 == false) {
    ___arguments.context.pageData['Step 1 - Password Lock'] = 'Please ensure password is 8 or more characters';
  } else if ((await BackendlessUI.Functions.Custom['fn_a3ba58b7eb1904ecefbc1692317c470e']((getObjectProperty(___arguments.context.pageData, 'Director Password')))) == false) {
    ___arguments.context.pageData['Step 1 - Password Lock'] = 'Please ensure password contains special characters';
  } else {
    ___arguments.context.pageData['Step 1 - Password Lock'] = undefined;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/FIF/components/c7bcd30a4041296220759db554dbff8f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b5c90b47c937b3fcc082be58a7316cba'))['type'] = 'text';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ba4d11e755bf3a753248caf65ca6d97e'))['type'] = 'text';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b5c90b47c937b3fcc082be58a7316cba'))['type'] = 'password';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ba4d11e755bf3a753248caf65ca6d97e'))['type'] = 'password';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIF/components/577bcf9bee6ada814cc7d13594c5be5f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 1 - Password Confirm Lock'))))) {
    Content = null;
  } else {
    Content = (getObjectProperty(___arguments.context.pageData, 'Step 1 - Password Confirm Lock'));
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 1 - Password Confirm Lock'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/ba4d11e755bf3a753248caf65ca6d97e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Director Password')) == (getObjectProperty(___arguments.context.pageData, 'Director Password Confirm'))) {
    ___arguments.context.pageData['Step 1 - Password Confirm Lock'] = undefined;
  } else {
    ___arguments.context.pageData['Step 1 - Password Confirm Lock'] = 'Passwords do not match';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIF/components/ec57804dadd3eaae2782532b4bd9455e/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var New_Username, Checker;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}


  if ((await Backendless.Data.of('users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Username = \'',(getObjectProperty(___arguments.context.pageData, 'Director Username')),'\''].join(''))))) == 0) {
    ___arguments.context.pageData['Step 1 - Username Lock'] = undefined;
  } else {
    New_Username = String(getObjectProperty(___arguments.context.pageData, 'Director Username')) + String(mathRandomInt(1, 1000));
    Checker = (await Backendless.Data.of('users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Username = \'',New_Username,'\''].join('')))));
    if (Checker == 0) {
      ___arguments.context.pageData['Step 1 - Username Lock'] = (['Username is taken ',New_Username,' is available'].join(''));
    } else {
      New_Username = String(getObjectProperty(___arguments.context.pageData, 'Director Username')) + String(mathRandomInt(1, 1000));
      Checker = (await Backendless.Data.of('users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Username = \'',New_Username,'\''].join('')))));
      if (Checker == 0) {
        ___arguments.context.pageData['Step 1 - Username Lock'] = (['Username is taken ',New_Username,' is available'].join(''));
      } else {
        New_Username = String(getObjectProperty(___arguments.context.pageData, 'Director Username')) + String(mathRandomInt(1, 1000));
        Checker = (await Backendless.Data.of('users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Username = \'',New_Username,'\''].join('')))));
        if (Checker == 0) {
          ___arguments.context.pageData['Step 1 - Username Lock'] = (['Username is taken ',New_Username,' is available'].join(''));
        } else {
          New_Username = String(getObjectProperty(___arguments.context.pageData, 'Director Username')) + String(mathRandomInt(1, 1000));
          Checker = (await Backendless.Data.of('users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Username = \'',New_Username,'\''].join('')))));
          if (Checker == 0) {
            ___arguments.context.pageData['Step 1 - Username Lock'] = (['Username is taken ',New_Username,' is available'].join(''));
          } else {
          }
        }
      }
    }
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/FIF/components/e0a690e3d9c1f48e1c3a511b6c52132b/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.Data.of('users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Email = \'',(getObjectProperty(___arguments.context.pageData, 'Director Email')),'\''].join(''))))) == 0) {
    if ((await BackendlessUI.Functions.Custom['fn_d47cae3b23b596aa0043c941a238585f']((getObjectProperty(___arguments.context.pageData, 'Director Email')))) == true) {
      ___arguments.context.pageData['Step 1 - Email Lock'] = undefined;
    } else {
      ___arguments.context.pageData['Step 1 - Email Lock'] = (String('Invalid Email Adress'));
    }
  } else {
    ___arguments.context.pageData['Step 1 - Email Lock'] = (String('This Email Address is already in use please use another.'));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/FIF/components/efaa6e058d98bdb6223291054f5469f3/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var Preformated_Text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Director Phone')).startsWith('0')) {
    Preformated_Text = (await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty(___arguments.context.pageData, 'Director Phone'))));
    if (Preformated_Text.length != 10) {
      ___arguments.context.pageData['Step 1 - Phone Lock'] = (String('This Phone Number is invalid'));
    } else {
      if ((await Backendless.Data.of('users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Phone = \'',(await BackendlessUI.Functions.Custom['fn_70b8ca4740171f42c0aa414f72c30dde']((getObjectProperty(___arguments.context.pageData, 'Director Phone')))),'\''].join(''))))) == 0) {
        ___arguments.context.pageData['Step 1 - Phone Lock'] = undefined;
      } else {
        ___arguments.context.pageData['Step 1 - Phone Lock'] = (String('This Phone Number is already in use please use another.'));
      }
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'Director Phone')).startsWith('+27')) {
    Preformated_Text = (await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty(___arguments.context.pageData, 'Director Phone'))));
    if (Preformated_Text.length != 12) {
      ___arguments.context.pageData['Step 1 - Phone Lock'] = (String('This Phone Number is invalid'));
    } else {
      if ((await Backendless.Data.of('users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Phone = \'',(await BackendlessUI.Functions.Custom['fn_70b8ca4740171f42c0aa414f72c30dde']((getObjectProperty(___arguments.context.pageData, 'Director Phone')))),'\''].join(''))))) == 0) {
        ___arguments.context.pageData['Step 1 - Phone Lock'] = undefined;
      } else {
        ___arguments.context.pageData['Step 1 - Phone Lock'] = (String('This Phone Number is already in use please use another.'));
      }
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'Director Phone')).startsWith('27')) {
    Preformated_Text = (await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty(___arguments.context.pageData, 'Director Phone'))));
    if (Preformated_Text.length != 11) {
      ___arguments.context.pageData['Step 1 - Phone Lock'] = (String('This Phone Number is invalid'));
    } else {
      if ((await Backendless.Data.of('users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Phone = \'',(await BackendlessUI.Functions.Custom['fn_70b8ca4740171f42c0aa414f72c30dde']((getObjectProperty(___arguments.context.pageData, 'Director Phone')))),'\''].join(''))))) == 0) {
        ___arguments.context.pageData['Step 1 - Phone Lock'] = undefined;
      } else {
        ___arguments.context.pageData['Step 1 - Phone Lock'] = (String('This Phone Number is already in use please use another.'));
      }
    }
  } else {
    ___arguments.context.pageData['Step 1 - Phone Lock'] = (String('This Phone Number is invalid'));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/FIF/components/ddb79d61e97a893b0896633c076a3782/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_9be1a86f7a3a2b8ee987b8cb91164058'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('404abdf5e12e3a371e7a2e811674851f')), ___arguments.context.pageData, 'Company Details Block - Viewer');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/4d77df496e7545bdf5e6ad8de14d7764/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Company Details Block - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/5c5d5f6b88394dd811c4b8b42bbb113d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_9be1a86f7a3a2b8ee987b8cb91164058'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d5445125de4352e6ad96ecf209a87411')), ___arguments.context.pageData, 'Company Emergency Data Block - Viewer');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/a923b0dddf8aa3d9f27b60a4e1d41c9e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Company Emergency Data Block - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/1ac3748d06eb93418439a942929342d6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_9be1a86f7a3a2b8ee987b8cb91164058'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f127f85eb5fb24913e5be446b583c35c')), ___arguments.context.pageData, 'Company Representative Data Block - Viewer');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/97123b09437663ae18191d1ee21b5b3d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Company Representative Data Block - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/dc12c4f7a693d9b26f36eb0f0582f63c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Company_Updater() {
  try {
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Company_Logo'] = (getObjectProperty(___arguments.context.pageData, 'New Company Logo'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 2 Error'] = 'Error - Failed to set company logo';
    }

  }
  try {
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Company_Email_Billing'] = (getObjectProperty(___arguments.context.pageData, 'Company Billing Email'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 2 Error'] = 'Error - Failed to set company billing email';
    }

  }
  try {
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Company_Location'] = (new Backendless.Data.Point().setX((getObjectProperty((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Step 2 - Company Location'))[0]), 'coordinates')), 'lng'))).setY((getObjectProperty((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'Step 2 - Company Location'))[0]), 'coordinates')), 'lat'))));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 2 Error'] = 'Error - Failed to set company location';
    }

  }
  try {
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Company_Phone_1'] = (getObjectProperty(___arguments.context.pageData, 'Company Phone Line 1'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 2 Error'] = 'Error - Failed to set company phone line 1';
    }

  }
  try {
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Company_Phone_2'] = (getObjectProperty(___arguments.context.pageData, 'Company Phone Line 2'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 2 Error'] = 'Error - Failed to set company phone line 2';
    }

  }
  try {
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Company_Physical_Address'] = (getObjectProperty(___arguments.context.pageData, 'Company Physical Address'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 2 Error'] = 'Error - Failed to set company physical address';
    }

  }
  try {
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Company_Postal_Address'] = (getObjectProperty(___arguments.context.pageData, 'Company Postal Address'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 2 Error'] = 'Error - Failed to set company postal address';
    }

  }
  try {
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Company_Postal_Code'] = (getObjectProperty(___arguments.context.pageData, 'Company Postal Address Code'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 2 Error'] = 'Error - Failed to set company postal address code';
    }

  }
  try {
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Company_Registered_Name'] = (getObjectProperty(___arguments.context.pageData, 'Company Registered Name'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 2 Error'] = 'Error - Failed to set company registered name';
    }

  }
  try {
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Company_Vat_Number'] = (getObjectProperty(___arguments.context.pageData, 'Company Vat Number'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 2 Error'] = 'Error - Failed to set company vat number';
    }

  }
  try {
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Contact_Name'] = (getObjectProperty(___arguments.context.pageData, 'Company Representative Contact Name'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 2 Error'] = 'Error - Failed to set company representative contact name';
    }

  }
  try {
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Contact_Phone'] = (getObjectProperty(___arguments.context.pageData, 'Company Representative Contact Phone'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 2 Error'] = 'Error - Failed to set company representative contact phone';
    }

  }
  try {
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Contact_Email'] = (getObjectProperty(___arguments.context.pageData, 'Company Representative Contact Email'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 2 Error'] = 'Error - Failed to set company representative contact email';
    }

  }
  try {
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Emergency_Contact_Name'] = (getObjectProperty(___arguments.context.pageData, 'Company Emergency Contact Name'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 2 Error'] = 'Error - Failed to set company emergency contact name';
    }

  }
  try {
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Emergency_Contact_Phone'] = (getObjectProperty(___arguments.context.pageData, 'Company Emergency Contact Phone'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 2 Error'] = 'Error - Failed to set company emergency contact phone';
    }

  }
  try {
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Emergency_Contact_Email'] = (getObjectProperty(___arguments.context.pageData, 'Company Emergency Contact Email'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 2 Error'] = 'Error - Failed to set company emergency contact email';
    }

  }
  try {
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Name'] = (getObjectProperty(___arguments.context.pageData, 'Company Name'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 2 Error'] = 'Error - Failed to set company name';
    }

  }
  try {
    ___arguments.context.pageData['New Company'] = (await Backendless.Data.of('Companies').save( (getObjectProperty(___arguments.context.pageData, 'New Company')) ));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 2 Error'] = 'Error - Failed to save new company';
    }

  }
}


  ___arguments.context.pageData['Step 2 - Completed'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goNextStep() })('1f2c1089422104959eda36c566955a12');
  await Company_Updater();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Step 2 - Error')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/560f6ee410fbb89aa4952ad4b03e615d/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_d47cae3b23b596aa0043c941a238585f']((getObjectProperty(___arguments.context.pageData, 'Company Representative Contact Email')))) == true) {
    ___arguments.context.pageData['Company Representative Contact Email - Viewer'] = false;
    ___arguments.context.pageData['Step 2 - Error'] = false;
  } else {
    ___arguments.context.pageData['Company Representative Contact Email - Viewer'] = true;
    ___arguments.context.pageData['Step 2 - Error'] = true;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/FIF/components/ca7e85174a94a908d7d9a1fa2612e364/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_d47cae3b23b596aa0043c941a238585f']((getObjectProperty(___arguments.context.pageData, 'Company Billing Email')))) == true) {
    ___arguments.context.pageData['Company Billing Email - Viewer'] = false;
    ___arguments.context.pageData['Step 2 - Error'] = false;
  } else {
    ___arguments.context.pageData['Company Billing Email - Viewer'] = true;
    ___arguments.context.pageData['Step 2 - Error'] = true;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/FIF/components/b81dceb527c168182d4fd67e85cd62de/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Company Billing Email - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/72ccfedc1afbd43c897b3bf8416c6b1d/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_0c02346c0bf5755bd3f9c5d2b50c53a7']((getObjectProperty(___arguments.context.pageData, 'Company Phone Line 1')))) == true) {
    ___arguments.context.pageData['Company Phone Line 1 - Viewer'] = false;
    ___arguments.context.pageData['Step 2 - Error'] = false;
  } else {
    ___arguments.context.pageData['Company Phone Line 1 - Viewer'] = true;
    ___arguments.context.pageData['Step 2 - Error'] = true;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/FIF/components/657cfcc311562b6fc35ca74560ab4fdd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Company Phone Line 1 - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/d342e09107f5f28c20b393c25216837a/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_0c02346c0bf5755bd3f9c5d2b50c53a7']((getObjectProperty(___arguments.context.pageData, 'Company Phone Line 2')))) == true) {
    ___arguments.context.pageData['Company Phone Line 2 - Viewer'] = false;
    ___arguments.context.pageData['Step 2 - Error'] = false;
  } else {
    ___arguments.context.pageData['Company Phone Line 2 - Viewer'] = true;
    ___arguments.context.pageData['Step 2 - Error'] = true;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/FIF/components/ea3503b81cb3074c80d6b95c38f26759/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Company Phone Line 2 - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/11530f192ab4c33c552f5e114f7ef3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_d47cae3b23b596aa0043c941a238585f']((getObjectProperty(___arguments.context.pageData, 'Company Emergency Contact Email')))) == true) {
    ___arguments.context.pageData['Company Emergency Contact Email - Viewer'] = false;
    ___arguments.context.pageData['Step 2 - Error'] = false;
  } else {
    ___arguments.context.pageData['Company Emergency Contact Email - Viewer'] = true;
    ___arguments.context.pageData['Step 2 - Error'] = true;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/FIF/components/26887554ff023c52bdfd53d4e1ff84b5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Company Representative Contact Email - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/f9c628cfe8699d7d0b0469960ea7dd9b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Company Emergency Contact Email - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/ac7cc36b30728b45099ba14988ed7786/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_0c02346c0bf5755bd3f9c5d2b50c53a7']((getObjectProperty(___arguments.context.pageData, 'Company Emergency Contact Phone')))) == true) {
    ___arguments.context.pageData['Company Emergency Contact Phone - Viewer'] = false;
    ___arguments.context.pageData['Step 2 - Error'] = false;
  } else {
    ___arguments.context.pageData['Company Emergency Contact Phone - Viewer'] = true;
    ___arguments.context.pageData['Step 2 - Error'] = true;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/FIF/components/3bbec56a16fb9b25476901dd24d86642/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_0c02346c0bf5755bd3f9c5d2b50c53a7']((getObjectProperty(___arguments.context.pageData, 'Company Representative Contact Phone')))) == true) {
    ___arguments.context.pageData['Company Representative Contact Phone - Viewer'] = false;
    ___arguments.context.pageData['Step 2 - Error'] = false;
  } else {
    ___arguments.context.pageData['Company Representative Contact Phone - Viewer'] = true;
    ___arguments.context.pageData['Step 2 - Error'] = true;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/FIF/components/344d20b88ec2199510b8f7f5d742feb3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Company Representative Contact Phone - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/2b8c58fb26aeee05d0464289f1caaaec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Company Emergency Contact Phone - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/b3811bcb6ca66e2a0b452242a19314c8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;


  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getCurrentStep() })('1f2c1089422104959eda36c566955a12')) == 3) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/1476eeff4a474e342e24d9549a643f3e/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.Data.of('users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Email = \'',(getObjectProperty(___arguments.context.pageData, 'Admin Details - Email Address')),'\''].join(''))))) == 0) {
    if ((await BackendlessUI.Functions.Custom['fn_d47cae3b23b596aa0043c941a238585f']((getObjectProperty(___arguments.context.pageData, 'Admin Details - Email Address')))) == true) {
      ___arguments.context.pageData['Admin Details - Email Address - Viewer'] = false;
      ___arguments.context.pageData['Step 3 - Error'] = false;
    } else {
      ___arguments.context.pageData['Admin Details - Email Address - Viewer'] = true;
      ___arguments.context.pageData['Step 3 - Error'] = true;
      ___arguments.context.pageData['Step 3 - Email Lock'] = (String('Invalid Email Adress'));
    }
  } else {
    ___arguments.context.pageData['Step 3 - Email Lock'] = (String('This Email Address is already in use please use another.'));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/FIF/components/b1e12fee225df73350326ad53abb795a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 1 - Email Lock'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Admin Details - Email Address - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/d64b8ece979aa62f1086d1935e451cbc/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_0c02346c0bf5755bd3f9c5d2b50c53a7']((getObjectProperty(___arguments.context.pageData, 'Admin Details - Phone Number')))) == true) {
    ___arguments.context.pageData['Admin Details - Phone Number - Viewer'] = false;
    ___arguments.context.pageData['Step 3 - Error'] = false;
  } else {
    ___arguments.context.pageData['Admin Details - Phone Number - Viewer'] = true;
    ___arguments.context.pageData['Step 3 - Error'] = true;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/FIF/components/7b5b8877a0b6e59cd85a9c31c25b02e2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Admin Details - Phone Number - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/855ee77b2a4b38fc1184d48683f4970f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_9be1a86f7a3a2b8ee987b8cb91164058'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f939daed0bc843544a55786272d1438')), ___arguments.context.pageData, 'Admin Details - Drop Down - Viewer');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/9676c04dcef3c8f39ab8e93191284848/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Admin Details - Drop Down - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/896bf31e69096d67cde2a10129d823f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_9be1a86f7a3a2b8ee987b8cb91164058'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e56456ace03b9b5bb72d7e52e6a8160e')), ___arguments.context.pageData, 'Admin Details Permissions - Drop Down - Viewer');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/e19b74fa6ba81c2c785f9202b70a55d9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Admin Details Permissions - Drop Down - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/3f13098c3675238ed81635f5691ec13e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_9be1a86f7a3a2b8ee987b8cb91164058'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ccc90f47d7ca8303bf3bc7c569a115e8')), ___arguments.context.pageData, 'Admin Details Wages - Drop Down - Viewer');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/8fd613b199b52d7be56992b149f3c971/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Admin Details Wages - Drop Down - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/4b661a8e3ea2b66e6acd96857f08809c/bundle.js', [], () => ({
  /* content */
  /* handler:leftListItemsLogic */
  ['leftListItemsLogic'](___arguments) {
      return [({ 'label': 'Com Director Dashboard','value': 'Com Director Dashboard' }), ({ 'label': 'Com Financial Overview','value': 'Com Financial Overview' }), ({ 'label': 'Com CPK Overview','value': 'Com CPK Overview' }), ({ 'label': 'Com Salary Overview','value': 'Com Salary Overview' }), ({ 'label': 'Com Targets','value': 'Com Targets' }), ({ 'label': 'Com Fleet Overview','value': 'Com Fleet Overview' }), ({ 'label': 'Com Broker Overview','value': 'Com Broker Overview' }), ({ 'label': 'Com Broker Level (Broker)','value': 'Com Broker Level (Broker)' }), ({ 'label': 'Com Broker Level (Director)','value': 'Com Broker Level (Director)' }), ({ 'label': 'Com Load Planner','value': 'Com Load Planner' }), ({ 'label': 'Com Maintenance Hub ','value': 'Com Maintenance Hub ' }), ({ 'label': 'Com (Admin) Add Load ','value': 'Com (Admin) Add Load ' }), ({ 'label': 'Com (Admin) Add Fuel ','value': 'Com (Admin) Add Fuel ' }), ({ 'label': 'Com (Admin) Board Truck','value': 'Com (Admin) Board Truck' }), ({ 'label': 'Com (Admin) Leave Truck','value': 'Com (Admin) Leave Truck' }), ({ 'label': 'Com (Admin) Swap Trailer','value': 'Com (Admin) Swap Trailer' }), ({ 'label': 'Com (Admin) Swap Tyre','value': 'Com (Admin) Swap Tyre' })]

  },
  /* handler:leftListItemsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Admin Permissions'] = ((await Promise.all(___arguments['rightItems'].map(async item => {; return (getObjectProperty(item, 'value'));}))).join(','));

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Admin Permissions Commercial - Viewer')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/280d968355c8a5e4025739d5f4f55fdf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Admin Permissions Agri - Viewer')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:leftListItemsLogic */
  ['leftListItemsLogic'](___arguments) {
      return [({ 'label': 'Agri Farm Log','value': 'Agri Farm Log' }), ({ 'label': 'Agri Log Book','value': 'Agri Log Book' })]

  },
  /* handler:leftListItemsLogic */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Admin Permissions'] = ((await Promise.all(___arguments['rightItems'].map(async item => {; return (getObjectProperty(item, 'value'));}))).join(','));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIF/components/ffef25f4731e17bb1cf5d24809f8ab27/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'Commercial') {
    ___arguments.context.pageData['Admin Permissions Commercial - Viewer'] = true;
    ___arguments.context.pageData['Admin Permissions Agri - Viewer'] = false;
  } else if (___arguments.value == 'Agri') {
    ___arguments.context.pageData['Admin Permissions Commercial - Viewer'] = false;
    ___arguments.context.pageData['Admin Permissions Agri - Viewer'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIF/components/04096aa516076246bbf7603c5ec6ebc7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Transaction, Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Step_3_Code() {
  ___arguments.context.pageData['Step 3 - Completed'] = true;
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    try {
      ___arguments.context.pageData['New Admin'] = (await Backendless.UserService.register( new Backendless.User({ 'Name': [(getObjectProperty(___arguments.context.pageData, 'Admin Details - Forenames')),' ',(getObjectProperty(___arguments.context.pageData, 'Admin Details - Surname'))].join(''),'Username': (getObjectProperty(___arguments.context.pageData, 'Admin Username')),'Phone': (await BackendlessUI.Functions.Custom['fn_70b8ca4740171f42c0aa414f72c30dde']((getObjectProperty(___arguments.context.pageData, 'Admin Details - Phone Number')))),'App': ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ffef25f4731e17bb1cf5d24809f8ab27')),'Level': 'Office','Permissions': (getObjectProperty(___arguments.context.pageData, 'Admin Permissions')),'password': (getObjectProperty(___arguments.context.pageData, 'Admin Password')),'email': (getObjectProperty(___arguments.context.pageData, 'Admin Details - Email Address')),'ownerId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'objectId')) }) ));

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        ___arguments.context.pageData['Step 3 Error'] = 'Admin Registration Error';
      }

    }
    _uow.create('Employees', ({ [`Company_ID`]: undefined,[`Driver_License_Code`]: undefined,[`Driver_License_Expiry_Date`]: undefined,[`Driver_License_Number`]: undefined,[`Driver_PDP_Document`]: undefined,[`Driver_PDP_Expiry_Date`]: undefined,[`Driver_Permit_1_Document`]: undefined,[`Driver_Permit_1_Expiry_Date`]: undefined,[`Driver_Permit_1_Name`]: undefined,[`Driver_Permit_2_Document`]: undefined,[`Driver_Permit_2_Expiry_Date`]: undefined,[`Driver_Permit_2_Name`]: undefined,[`Driver_Permit_3_Document`]: undefined,[`Driver_Permit_3_Expiry_Date`]: undefined,[`Driver_Permit_3_Name`]: undefined,[`Driver_Warehouse_Status`]: undefined,[`Emergency_ICE_Name`]: undefined,[`Emergency_ICE_Phone`]: undefined,[`Emergency_Medical_Aid_Name`]: undefined,[`Emergency_Medical_Aid_Number`]: undefined,[`Emergency_Medical_Aid_Document`]: undefined,[`Employee_Details_Forenames`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details - Forenames')),[`Employee_Details_ID_Document`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details - ID Photo Image')),[`Employee_Details_ID_Number`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details - ID Number')),[`Employee_Details_Nickname`]: undefined,[`Employee_Details_Passport_Document`]: undefined,[`Employee_Details_Passport_Expiry_Date`]: undefined,[`Employee_Details_Passport_Number`]: undefined,[`Employee_Details_Phone`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details - Phone Number')),[`Employee_Details_Position`]: 'Admin',[`Employee_Details_Profile_Photo`]: undefined,[`Employee_Details_Surname`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details - Surname')),[`Employee_Details_Tax_Reference_Number`]: undefined,[`Star_Rating`]: undefined,[`Star_Rating_Fuel`]: undefined,[`Star_Rating_Loading`]: undefined,[`Wages_Deduction_Bargaining_Council_Fee`]: undefined,[`Wages_Deduction_Bargaining_Council_Name`]: undefined,[`Wages_Deduction_Medical_Aid_Fee`]: undefined,[`Wages_Deduction_Pension_Fee`]: undefined,[`Wages_Deduction_Pension_Name`]: undefined,[`Wages_Deduction_Provident_Fund_Fee`]: undefined,[`Wages_Deduction_Provident_Fund_Name`]: undefined,[`Wages_Deduction_Union_Fee`]: undefined,[`Wages_Deduction_Union_Name`]: undefined,[`Wages_Rate_Basic`]: undefined,[`Wages_Rate_Contractor_Mileage`]: undefined,[`Wages_Rate_Contractor_Tonnage`]: undefined,[`Wages_Rate_Good_Driving`]: undefined,[`Wages_Rate_Good_Planning_Mileage`]: undefined,[`Wages_Rate_Good_Planning_Tonnage`]: undefined,[`Wages_Rate_Sleep_Out`]: undefined,[`Wages_Rate_Target_Mileage`]: undefined,[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Admin')), 'objectId')) })).setOpResultId('New Admin Details');
    _uow.setRelation('Users', (getObjectProperty(___arguments.context.pageData, 'New Admin')), 'Company', [(getObjectProperty(___arguments.context.pageData, 'New Company'))]);
    _uow.setRelation('Users', (getObjectProperty(___arguments.context.pageData, 'New Admin')), 'Details', (Transaction.getOpResultById('New Admin Details')));
    _uow.setRelation('Companies', (getObjectProperty(___arguments.context.pageData, 'New Company')), 'Company_Admin', (Transaction.getOpResultById('New Admin Details')));
    _uow.addToRelation('Companies', (getObjectProperty(___arguments.context.pageData, 'New Company')), 'Employees', (Transaction.getOpResultById('New Admin Details')));
    _uow.addToRelation('Employees', (Transaction.getOpResultById('New Admin Details')), 'Company', [(getObjectProperty(___arguments.context.pageData, 'New Company'))]);

  })();

  try {
    Result = (await Transaction.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      }));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      while (!((getObjectProperty(Result, 'success')) == true)) {
        Result = (await Transaction.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));
      }
    }

  }
  try {
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Company_Email_Admin'] = (getObjectProperty(___arguments.context.pageData, 'Admin Details - Email Address'));
    (getObjectProperty(___arguments.context.pageData, 'New Company'))['Step'] = 3;
    await Backendless.Data.of('Companies').save( (getObjectProperty(___arguments.context.pageData, 'New Company')) );

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      ___arguments.context.pageData['Step 3 Error'] = 'Failed to update Company Admin Details';
    }

  }
  ___arguments.context.pageData['New Customer View'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7dab1f6deb9f168dca5a32416584f1ee'))['icon'] = 'menu';
  ___arguments.context.pageData['Menu View'] = true;
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function Old_Code() {
  ___arguments.context.pageData['Step 3 - Completed'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goNextStep() })('1f2c1089422104959eda36c566955a12');
  ___arguments.context.pageData['New Admin'] = (await Backendless.UserService.register( new Backendless.User({ 'Name': [(getObjectProperty(___arguments.context.pageData, 'Admin Details - Forenames')),' ',(getObjectProperty(___arguments.context.pageData, 'Admin Details - Surname'))].join(''),'Username': (getObjectProperty(___arguments.context.pageData, 'Admin Username')),'Phone': (await BackendlessUI.Functions.Custom['fn_70b8ca4740171f42c0aa414f72c30dde']((getObjectProperty(___arguments.context.pageData, 'Admin Details - Phone Number')))),'App': ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ffef25f4731e17bb1cf5d24809f8ab27')),'Level': 'Office','Permissions': (getObjectProperty(___arguments.context.pageData, 'Admin Permissions')),'password': (getObjectProperty(___arguments.context.pageData, 'Admin Password')),'email': (getObjectProperty(___arguments.context.pageData, 'Admin Details - Email Address')),'ownerId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'objectId')) }) ));
  console.log('1');
  ___arguments.context.pageData['New Admin Details'] = (await Backendless.Data.of('Employees').save( ({ [`Company_ID`]: undefined,[`Driver_License_Code`]: undefined,[`Driver_License_Expiry_Date`]: undefined,[`Driver_License_Number`]: undefined,[`Driver_PDP_Document`]: undefined,[`Driver_PDP_Expiry_Date`]: undefined,[`Driver_Permit_1_Document`]: undefined,[`Driver_Permit_1_Expiry_Date`]: undefined,[`Driver_Permit_1_Name`]: undefined,[`Driver_Permit_2_Document`]: undefined,[`Driver_Permit_2_Expiry_Date`]: undefined,[`Driver_Permit_2_Name`]: undefined,[`Driver_Permit_3_Document`]: undefined,[`Driver_Permit_3_Expiry_Date`]: undefined,[`Driver_Permit_3_Name`]: undefined,[`Driver_Warehouse_Status`]: undefined,[`Emergency_ICE_Name`]: undefined,[`Emergency_ICE_Phone`]: undefined,[`Emergency_Medical_Aid_Name`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details Wages - Medical Aid Name')),[`Emergency_Medical_Aid_Number`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details Wages - Medical Aid Number')),[`Emergency_Medical_Aid_Document`]: undefined,[`Employee_Details_Forenames`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details - Forenames')),[`Employee_Details_ID_Document`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details - ID Photo Image')),[`Employee_Details_ID_Number`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details - ID Number')),[`Employee_Details_Nickname`]: undefined,[`Employee_Details_Passport_Document`]: undefined,[`Employee_Details_Passport_Expiry_Date`]: undefined,[`Employee_Details_Passport_Number`]: undefined,[`Employee_Details_Phone`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details - Phone Number')),[`Employee_Details_Position`]: 'Admin',[`Employee_Details_Profile_Photo`]: undefined,[`Employee_Details_Surname`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details - Surname')),[`Employee_Details_Tax_Reference_Number`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details Wages - Tax Reference Number')),[`Star_Rating`]: undefined,[`Star_Rating_Fuel`]: undefined,[`Star_Rating_Loading`]: undefined,[`Wages_Deduction_Bargaining_Council_Fee`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details Wages - Bargaining Council Rate')),[`Wages_Deduction_Bargaining_Council_Name`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details Wages - Bargaining Council Name')),[`Wages_Deduction_Medical_Aid_Fee`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details Wages - Medical Aid Rate')),[`Wages_Deduction_Pension_Fee`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details Wages - Pension Rate')),[`Wages_Deduction_Pension_Name`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details Wages - Pension Name')),[`Wages_Deduction_Provident_Fund_Fee`]: undefined,[`Wages_Deduction_Provident_Fund_Name`]: undefined,[`Wages_Deduction_Union_Fee`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details Wages - Union Rate')),[`Wages_Deduction_Union_Name`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details Wages - Union Name')),[`Wages_Rate_Basic`]: (getObjectProperty(___arguments.context.pageData, 'Admin Details Wages - Wage Basic')),[`Wages_Rate_Contractor_Mileage`]: undefined,[`Wages_Rate_Contractor_Tonnage`]: undefined,[`Wages_Rate_Good_Driving`]: undefined,[`Wages_Rate_Good_Planning_Mileage`]: undefined,[`Wages_Rate_Good_Planning_Tonnage`]: undefined,[`Wages_Rate_Sleep_Out`]: undefined,[`Wages_Rate_Target_Mileage`]: undefined,[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Admin')), 'objectId')) }) ));
  console.log('1');
  await Backendless.Files.createDirectory(encodePath((String('users/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Admin')), 'objectId')))));
  console.log('1');
  await Backendless.Data.of('Users').setRelation((getObjectProperty(___arguments.context.pageData, 'New Director')), 'Company', [(getObjectProperty(___arguments.context.pageData, 'New Company'))]);
  console.log('1');
  await Backendless.Data.of('Companies').setRelation((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Company_Admin', [(getObjectProperty(___arguments.context.pageData, 'New Admin Details'))]);
  console.log('1');
  (getObjectProperty(___arguments.context.pageData, 'New Company'))['Company_Email_Admin'] = (getObjectProperty(___arguments.context.pageData, 'Admin Details - Email Address'));
  console.log('1');
  await Backendless.Data.of('Companies').save( (getObjectProperty(___arguments.context.pageData, 'New Company')) );
  console.log('1');
}


  await Step_3_Code();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/0b8b8eae4ff7c9e659969d526fdeb764/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Admin Password')).length >= 8 == false && (await BackendlessUI.Functions.Custom['fn_a3ba58b7eb1904ecefbc1692317c470e']((getObjectProperty(___arguments.context.pageData, 'Admin Password')))) == false) {
    ___arguments.context.pageData['Step 3 - Password Lock'] = 'Please ensure password contains special characters and is 8 or more characters';
  } else if ((getObjectProperty(___arguments.context.pageData, 'Admin Password')).length >= 8 == false) {
    ___arguments.context.pageData['Step 3 - Password Lock'] = 'Please ensure password is 8  or more characters';
  } else if ((await BackendlessUI.Functions.Custom['fn_a3ba58b7eb1904ecefbc1692317c470e']((getObjectProperty(___arguments.context.pageData, 'Admin Password')))) == false) {
    ___arguments.context.pageData['Step 3 - Password Lock'] = 'Please ensure password contains special characters';
  } else {
    ___arguments.context.pageData['Step 3 - Password Lock'] = undefined;
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/FIF/components/10def09d471134f4c56560f8eabc4e49/bundle.js', [], () => ({
  /* content */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var New_Username, Checker;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}


  if ((await Backendless.Data.of('users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Username = \'',(getObjectProperty(___arguments.context.pageData, 'Admin Username')),'\''].join(''))))) == 0) {
    ___arguments.context.pageData['Step 3 - Username Lock'] = undefined;
  } else {
    New_Username = String(getObjectProperty(___arguments.context.pageData, 'Admin Username')) + String(mathRandomInt(1, 100));
    Checker = (await Backendless.Data.of('users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Username = \'',New_Username,'\''].join('')))));
    if (Checker == 0) {
      ___arguments.context.pageData['Step 3 - Username Lock'] = (['Username is taken ',New_Username,' is available'].join(''));
    } else {
      New_Username = String(getObjectProperty(___arguments.context.pageData, 'Admin Username')) + String(mathRandomInt(1, 100));
      Checker = (await Backendless.Data.of('users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Username = \'',New_Username,'\''].join('')))));
      if (Checker == 0) {
        ___arguments.context.pageData['Step 3 - Username Lock'] = (['Username is taken ',New_Username,' is available'].join(''));
      } else {
        New_Username = String(getObjectProperty(___arguments.context.pageData, 'Admin Username')) + String(mathRandomInt(1, 100));
        Checker = (await Backendless.Data.of('users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Username = \'',New_Username,'\''].join('')))));
        if (Checker == 0) {
          ___arguments.context.pageData['Step 3 - Username Lock'] = (['Username is taken ',New_Username,' is available'].join(''));
        } else {
          New_Username = String(getObjectProperty(___arguments.context.pageData, 'Admin Username')) + String(mathRandomInt(1, 100));
          Checker = (await Backendless.Data.of('users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['Username = \'',New_Username,'\''].join('')))));
          if (Checker == 0) {
            ___arguments.context.pageData['Step 3 - Username Lock'] = (['Username is taken ',New_Username,' is available'].join(''));
          } else {
          }
        }
      }
    }
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/FIF/components/b7d1aae1a581b68139aa7cf8236dca7a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Admin Password')) == (getObjectProperty(___arguments.context.pageData, 'Admin Password Confirm'))) {
    ___arguments.context.pageData['Step 3 - Password Confirm Lock'] = false;
  } else {
    ___arguments.context.pageData['Step 3 - Password Confirm Lock'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIF/components/cd140548e34109988dde7f245ddb2908/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0b8b8eae4ff7c9e659969d526fdeb764'))['type'] = 'text';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7d1aae1a581b68139aa7cf8236dca7a'))['type'] = 'text';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0b8b8eae4ff7c9e659969d526fdeb764'))['type'] = 'password';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7d1aae1a581b68139aa7cf8236dca7a'))['type'] = 'password';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIF/components/c9230b06d72721dec8fa653f4232d4f7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 3 - Username Lock'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 3 - Username Lock'))))) {
    Content = null;
  } else {
    Content = (getObjectProperty(___arguments.context.pageData, 'Step 3 - Username Lock'));
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIF/components/4eacf19504af54c8de951ba1164eb1ee/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 3 - Password Lock'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 3 - Password Lock'))))) {
    Content = null;
  } else {
    Content = (getObjectProperty(___arguments.context.pageData, 'Step 3 - Password Lock'));
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIF/components/208df08601d526483fd25888f547261e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Step 3 - Password Confirm Lock'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/57ef55683abec099c2faf00ce3d472d6/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('57ef55683abec099c2faf00ce3d472d6');
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('57ef55683abec099c2faf00ce3d472d6'))['buttonLabel'] = 'Upload Failed - Please try again';

  },
  /* handler:onUploadFail */
  /* handler:onBeforeUpload */
  ['onBeforeUpload'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('57ef55683abec099c2faf00ce3d472d6'));

  },
  /* handler:onBeforeUpload */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'New Company')))) ? null : String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Directory')) + String('/Employees/Admin/Profile/Photo')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  async ['onFileNameAssignment'](___arguments) {
    var fileExt, Name;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split(',').slice(-1)[0];
  Name = [(generateUUID().long()),'.',fileExt].join('');
  ___arguments.context.pageData['New Company Logo File Path'] = (String((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'New Company')))) ? Name : String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Directory')) + String('/Employees/Admin/Profile/Photo/')) + String(''));

  return Name

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/FIF/components/7fbafd36b7f130b5a83b1baa933f3199/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 1 - Username Lock'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 1 - Username Lock'))))) {
    Content = null;
  } else {
    Content = (getObjectProperty(___arguments.context.pageData, 'Step 1 - Username Lock'));
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIF/components/7bd5caaeddc70655ec0d26fa8f98296b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 1 - Password Lock'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 1 - Password Lock'))))) {
    Content = null;
  } else {
    Content = (getObjectProperty(___arguments.context.pageData, 'Step 1 - Password Lock'));
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIF/components/9c71da1ba8277acd1ba941a75d5ae99d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 1 - Email Lock'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return (getObjectProperty(___arguments.context.pageData, 'Step 1 - Email Lock'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 1 - Email Lock'))))) {
    Content = null;
  } else {
    Content = (getObjectProperty(___arguments.context.pageData, 'Step 1 - Email Lock'));
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIF/components/3ce723be7ad7a234e12bc5b5436a1799/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 1 - Phone Lock'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Step 1 - Phone Lock'))))) {
    Content = null;
  } else {
    Content = (getObjectProperty(___arguments.context.pageData, 'Step 1 - Phone Lock'));
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIF/components/9284730dea5b56d3e8b8062fe1240ac7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_31cae287c3a80d02a51434592a031855']('Add Employee Load Planner Drop Down - Viewer', ___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/6d8480a2203e79d1893ca601d02ab66f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Add Employee Load Planner Drop Down - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/7d128d4d7c52adcf8eb92b91d4c5f0bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_31cae287c3a80d02a51434592a031855']('Add Employee Mechanic Drop Down - Viewer', ___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/dbb893556858fb32ba9355e1504fb453/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_31cae287c3a80d02a51434592a031855']('Add Employee Driver Drop Down - Viewer', ___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/1a1dff93970a872345ae1844594fbbaf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_31cae287c3a80d02a51434592a031855']('Add Employee Conductor Drop Down - Viewer', ___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/3a3cab8d00c704643817ff08383198ae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Add Employee Mechanic Drop Down - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/9de9a4c96ad79b624b6fc90e8ca8c6bd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Add Employee Driver Drop Down - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/b80af271eafb772e8a8643c9b17c954a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Add Employee Conductor Drop Down - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/255ed49ebc4d2bae92b4fabfd7ea3812/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;


  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getCurrentStep() })('1f2c1089422104959eda36c566955a12')) == 5) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/543f5e58bbdfdd8fbc46014fc1b20f8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_9be1a86f7a3a2b8ee987b8cb91164058'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e9e700c65b197bf91f73396889c371cd')), ___arguments.context.pageData, 'Add Employee Load Planner Details Drop Down - Viewer');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/4bdbe8afbd7fac04d28e85c30f0e02c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Add Employee Load Planner Details Drop Down - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/169e1a41c59e176b068ec78cad0291e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_9be1a86f7a3a2b8ee987b8cb91164058'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6ab8e6448ebd2633c82c0a2e1beb61ed')), ___arguments.context.pageData, 'Add Employee Load Planner Permissions Drop Down - Viewer');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/fa99649f570e2557af1ef67177097636/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Add Employee Load Planner Permissions Drop Down - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/f76e826e18b8d51c21d23a2544b21c1c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_9be1a86f7a3a2b8ee987b8cb91164058'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8af4c6a71d46a8a995892756397273a3')), ___arguments.context.pageData, 'Add Employee Load Planner Wage Details Drop Down - Viewer');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/1be91f1496fc145e7472dc3799efbdd1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Add Employee Load Planner Wage Details Drop Down - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/3122e017dc092c680dabb88ccc1822d4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;


  if ((await ( async function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).getCurrentStep() })('1f2c1089422104959eda36c566955a12')) == 4) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/bc8dcf96c7d7d6e4822d33722bf5e2a7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Counter, Counter___Value, error, New_Bowser_Attendant, New_Conductor, New_Driver, New_Load_Planner, New_Mechanic, New_Tractor, Result, Second_Result, Transaction;

/**
 * Describe this function...
 */
async function Step_4_Code() {
  await Event_API();
  await Drivers_API();
  await Conductors_API();
  await Load_Planner_API();
  await Bowser_Attendants_API();
  await Mechanics_API();
  await Trailer_API();
  await Tank_API();
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Event_API() {
  ___arguments.event['Step 4 - Number Of Drivers'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('3122e017dc092c680dabb88ccc1822d4')), 'Step 4 - Number Of Drivers'));
  ___arguments.event['Step 4 - Number Of Conductors'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('3122e017dc092c680dabb88ccc1822d4')), 'Step 4 - Number Of Conductors'));
  ___arguments.event['Step 4 - Number Of Bowser Attendants'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('3122e017dc092c680dabb88ccc1822d4')), 'Step 4 - Number Of Bowser Attendants'));
  ___arguments.event['Step 4 - Number Of Mechanics'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('3122e017dc092c680dabb88ccc1822d4')), 'Step 4 - Number Of Mechanics'));
  ___arguments.event['Step 4 - Number Of Load Planners'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('3122e017dc092c680dabb88ccc1822d4')), 'Step 4 - Number Of Load Planners'));
  ___arguments.event['Step 4 - Number Of Tractors'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('3122e017dc092c680dabb88ccc1822d4')), 'Step 4 - Number Of Tractors'));
  ___arguments.event['Step 4 - Number Of Trailers'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('3122e017dc092c680dabb88ccc1822d4')), 'Step 4 - Number Of Trailers'));
  ___arguments.event['Step 4 - Number of Tanks'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('3122e017dc092c680dabb88ccc1822d4')), 'Step 4 - Number of Tanks'));
  ___arguments.context.pageData['Step 4 - Completed'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goNextStep() })('1f2c1089422104959eda36c566955a12');
  ___arguments.context.pageData['New Company - ID'] = (String((await (async function(Text) {
  	const D = Text
  	const result = D.split(" ").join("");
  	return result
  })(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Name')).slice(0, 5))))));
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function Drivers_API() {
  Counter = 0;
  var repeat_end = (getObjectProperty(___arguments.event, 'Step 4 - Number Of Drivers'));
  for (var count = 0; count < repeat_end; count++) {
    Counter = Counter + 1;
    if (Counter <= 9) {
      Counter___Value = String('000') + String(Counter);
    } else if (Counter <= 99) {
      Counter___Value = String('00') + String(Counter);
    } else if (Counter <= 999) {
      Counter___Value = String('0') + String(Counter);
    } else if (Counter <= 9999) {
      Counter___Value = String(Counter);
    }
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Transaction;

      try {
        New_Driver = (await Backendless.UserService.register( new Backendless.User({ 'Name': [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' D ',Counter___Value].join(''),'Username': [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' D ',Counter___Value].join(''),'App': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'App')),'Level': 'Road','Permissions': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'App')) == 'Agri' ? ['Agri Farm Log', 'Agri Log Book'].join(',') : ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'App')) == 'Commercial' ? ['Com (Driver) Add Fuel ', 'Com (Driver) Add Load', 'Com (Driver) Board Truck', 'Com (Driver) Leave Truck', 'Com (Driver) Swap Trailer', 'Com (Driver) Swap Tyre'].join(',') : ['FC Delivery Capture', 'FC Sales Capture', 'FC Pump Stats', 'FC Meter Readings'].join(',')),'password': [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' D ',Counter___Value].join(''),'email': (String((await (async function(Text) {
        	const D = Text
        	const result = D.split(" ").join("");
        	return result
        })(([(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' D ',Counter___Value].join(''))))) + String(subsequenceFromStartLast((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'Email')), (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'Email')).indexOf('@') + 1) - 1)))).toLowerCase(),'ownerId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'objectId')) }) ));

      } catch (error) {

      } finally {
        if (error) {
          ___arguments.context.pageData['Step 4 Error'] = 'Driver Registration Error';
        }

      }
      _uow.create('Employees', ({ [`Company_ID`]: [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' D ',Counter___Value].join(''),[`Driver_License_Code`]: undefined,[`Driver_License_Expiry_Date`]: undefined,[`Driver_License_Number`]: undefined,[`Driver_PDP_Document`]: undefined,[`Driver_PDP_Expiry_Date`]: undefined,[`Driver_Permit_1_Document`]: undefined,[`Driver_Permit_1_Expiry_Date`]: undefined,[`Driver_Permit_1_Name`]: undefined,[`Driver_Permit_2_Document`]: undefined,[`Driver_Permit_2_Expiry_Date`]: undefined,[`Driver_Permit_2_Name`]: undefined,[`Driver_Permit_3_Document`]: undefined,[`Driver_Permit_3_Expiry_Date`]: undefined,[`Driver_Permit_3_Name`]: undefined,[`Driver_Warehouse_Status`]: undefined,[`Emergency_ICE_Name`]: undefined,[`Emergency_ICE_Phone`]: undefined,[`Emergency_Medical_Aid_Name`]: undefined,[`Emergency_Medical_Aid_Number`]: undefined,[`Emergency_Medical_Aid_Document`]: undefined,[`Employee_Details_Forenames`]: undefined,[`Employee_Details_ID_Document`]: undefined,[`Employee_Details_ID_Number`]: undefined,[`Employee_Details_Nickname`]: undefined,[`Employee_Details_Passport_Document`]: undefined,[`Employee_Details_Passport_Expiry_Date`]: undefined,[`Employee_Details_Passport_Number`]: undefined,[`Employee_Details_Phone`]: undefined,[`Employee_Details_Position`]: 'Driver',[`Employee_Details_Profile_Photo`]: undefined,[`Employee_Details_Surname`]: undefined,[`Employee_Details_Tax_Reference_Number`]: undefined,[`Star_Rating`]: undefined,[`Star_Rating_Fuel`]: undefined,[`Star_Rating_Loading`]: undefined,[`Wages_Deduction_Bargaining_Council_Fee`]: undefined,[`Wages_Deduction_Bargaining_Council_Name`]: undefined,[`Wages_Deduction_Medical_Aid_Fee`]: undefined,[`Wages_Deduction_Pension_Fee`]: undefined,[`Wages_Deduction_Pension_Name`]: undefined,[`Wages_Deduction_Provident_Fund_Fee`]: undefined,[`Wages_Deduction_Provident_Fund_Name`]: undefined,[`Wages_Deduction_Union_Fee`]: undefined,[`Wages_Deduction_Union_Name`]: undefined,[`Wages_Rate_Basic`]: undefined,[`Wages_Rate_Contractor_Mileage`]: undefined,[`Wages_Rate_Contractor_Tonnage`]: undefined,[`Wages_Rate_Good_Driving`]: undefined,[`Wages_Rate_Good_Planning_Mileage`]: undefined,[`Wages_Rate_Good_Planning_Tonnage`]: undefined,[`Wages_Rate_Sleep_Out`]: undefined,[`Wages_Rate_Target_Mileage`]: undefined,[`ownerId`]: (getObjectProperty(New_Driver, 'objectId')) })).setOpResultId('New Driver Details');
      _uow.setRelation('Users', New_Driver, 'Company', [(getObjectProperty(___arguments.context.pageData, 'New Company'))]);
      _uow.setRelation('Users', New_Driver, 'Details', (Transaction.getOpResultById('New Driver Details')));
      _uow.addToRelation('Employees', (Transaction.getOpResultById('New Driver Details')), 'Company', [(getObjectProperty(___arguments.context.pageData, 'New Company'))]);

    })();

    try {
      Result = (await Transaction.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        }));
      Second_Result = (await Backendless.Data.of('Employees').findLast());
      await Backendless.Data.of('Companies').addRelation((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Employees', [Second_Result]);

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        while (!((getObjectProperty(Result, 'success')) == true)) {
          Result = (await Transaction.execute().then(function(result) {
              const error = result && result.error

              if (error) {
                throw error
              }

            return result
            }));
          Second_Result = (await Backendless.Data.of('Employees').findLast());
          await Backendless.Data.of('Companies').addRelation((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Employees', [Second_Result]);
        }
      }

    }
  }
}

/**
 * Describe this function...
 */
async function Conductors_API() {
  Counter = 0;
  var repeat_end2 = (getObjectProperty(___arguments.event, 'Step 4 - Number Of Conductors'));
  for (var count2 = 0; count2 < repeat_end2; count2++) {
    Counter = Counter + 1;
    if (Counter <= 9) {
      Counter___Value = String('000') + String(Counter);
    } else if (Counter <= 99) {
      Counter___Value = String('00') + String(Counter);
    } else if (Counter <= 999) {
      Counter___Value = String('0') + String(Counter);
    } else if (Counter <= 9999) {
      Counter___Value = String(Counter);
    }
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Transaction;

      try {
        New_Conductor = (await Backendless.UserService.register( new Backendless.User({ 'Name': [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' C ',Counter___Value].join(''),'Username': [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' C ',Counter___Value].join(''),'App': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'App')),'Level': 'Road','Permissions': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'App')) == 'Agri' ? ['Agri Farm Log', 'Agri Log Book'].join(',') : ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'App')) == 'Commercial' ? ['Com (Driver) Add Fuel ', 'Com (Driver) Add Load', 'Com (Driver) Board Truck', 'Com (Driver) Leave Truck', 'Com (Driver) Swap Trailer', 'Com (Driver) Swap Tyre'].join(',') : ['FC Delivery Capture', 'FC Sales Capture', 'FC Pump Stats', 'FC Meter Readings'].join(',')),'password': [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' C ',Counter___Value].join(''),'email': (String((await (async function(Text) {
        	const D = Text
        	const result = D.split(" ").join("");
        	return result
        })(([(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' C ',Counter___Value].join(''))))) + String(subsequenceFromStartLast((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'Email')), (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'Email')).indexOf('@') + 1) - 1)))).toLowerCase(),'ownerId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'objectId')) }) ));

      } catch (error) {

      } finally {
        if (error) {
          ___arguments.context.pageData['Step 4 Error'] = 'Driver Registration Error';
        }

      }
      _uow.create('Employees', ({ [`Company_ID`]: [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' C ',Counter___Value].join(''),[`Driver_License_Code`]: undefined,[`Driver_License_Expiry_Date`]: undefined,[`Driver_License_Number`]: undefined,[`Driver_PDP_Document`]: undefined,[`Driver_PDP_Expiry_Date`]: undefined,[`Driver_Permit_1_Document`]: undefined,[`Driver_Permit_1_Expiry_Date`]: undefined,[`Driver_Permit_1_Name`]: undefined,[`Driver_Permit_2_Document`]: undefined,[`Driver_Permit_2_Expiry_Date`]: undefined,[`Driver_Permit_2_Name`]: undefined,[`Driver_Permit_3_Document`]: undefined,[`Driver_Permit_3_Expiry_Date`]: undefined,[`Driver_Permit_3_Name`]: undefined,[`Driver_Warehouse_Status`]: undefined,[`Emergency_ICE_Name`]: undefined,[`Emergency_ICE_Phone`]: undefined,[`Emergency_Medical_Aid_Name`]: undefined,[`Emergency_Medical_Aid_Number`]: undefined,[`Emergency_Medical_Aid_Document`]: undefined,[`Employee_Details_Forenames`]: undefined,[`Employee_Details_ID_Document`]: undefined,[`Employee_Details_ID_Number`]: undefined,[`Employee_Details_Nickname`]: undefined,[`Employee_Details_Passport_Document`]: undefined,[`Employee_Details_Passport_Expiry_Date`]: undefined,[`Employee_Details_Passport_Number`]: undefined,[`Employee_Details_Phone`]: undefined,[`Employee_Details_Position`]: 'Conductor',[`Employee_Details_Profile_Photo`]: undefined,[`Employee_Details_Surname`]: undefined,[`Employee_Details_Tax_Reference_Number`]: undefined,[`Star_Rating`]: undefined,[`Star_Rating_Fuel`]: undefined,[`Star_Rating_Loading`]: undefined,[`Wages_Deduction_Bargaining_Council_Fee`]: undefined,[`Wages_Deduction_Bargaining_Council_Name`]: undefined,[`Wages_Deduction_Medical_Aid_Fee`]: undefined,[`Wages_Deduction_Pension_Fee`]: undefined,[`Wages_Deduction_Pension_Name`]: undefined,[`Wages_Deduction_Provident_Fund_Fee`]: undefined,[`Wages_Deduction_Provident_Fund_Name`]: undefined,[`Wages_Deduction_Union_Fee`]: undefined,[`Wages_Deduction_Union_Name`]: undefined,[`Wages_Rate_Basic`]: undefined,[`Wages_Rate_Contractor_Mileage`]: undefined,[`Wages_Rate_Contractor_Tonnage`]: undefined,[`Wages_Rate_Good_Driving`]: undefined,[`Wages_Rate_Good_Planning_Mileage`]: undefined,[`Wages_Rate_Good_Planning_Tonnage`]: undefined,[`Wages_Rate_Sleep_Out`]: undefined,[`Wages_Rate_Target_Mileage`]: undefined,[`ownerId`]: (getObjectProperty(New_Conductor, 'objectId')) })).setOpResultId('New Conductor Details');
      _uow.setRelation('Users', New_Conductor, 'Company', [(getObjectProperty(___arguments.context.pageData, 'New Company'))]);
      _uow.setRelation('Users', New_Conductor, 'Details', (Transaction.getOpResultById('New Conductor Details')));
      _uow.addToRelation('Employees', (Transaction.getOpResultById('New Conductor Details')), 'Company', [(getObjectProperty(___arguments.context.pageData, 'New Company'))]);

    })();

    try {
      Result = (await Transaction.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        }));
      Second_Result = (await Backendless.Data.of('Employees').findLast());
      await Backendless.Data.of('Companies').addRelation((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Employees', [Second_Result]);

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        while (!((getObjectProperty(Result, 'success')) == true)) {
          Result = (await Transaction.execute().then(function(result) {
              const error = result && result.error

              if (error) {
                throw error
              }

            return result
            }));
          Second_Result = (await Backendless.Data.of('Employees').findLast());
          await Backendless.Data.of('Companies').addRelation((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Employees', [Second_Result]);
        }
      }

    }
  }
}

/**
 * Describe this function...
 */
async function Bowser_Attendants_API() {
  Counter = 0;
  var repeat_end3 = (getObjectProperty(___arguments.event, 'Step 4 - Number Of Bowser Attendants'));
  for (var count3 = 0; count3 < repeat_end3; count3++) {
    Counter = Counter + 1;
    if (Counter <= 9) {
      Counter___Value = String('000') + String(Counter);
    } else if (Counter <= 99) {
      Counter___Value = String('00') + String(Counter);
    } else if (Counter <= 999) {
      Counter___Value = String('0') + String(Counter);
    } else if (Counter <= 9999) {
      Counter___Value = String(Counter);
    }
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Transaction;

      try {
        New_Bowser_Attendant = (await Backendless.UserService.register( new Backendless.User({ 'Name': [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' A ',Counter___Value].join(''),'Username': [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' A ',Counter___Value].join(''),'App': 'Forecourt','Level': 'Road','Permissions': ['FC Delivery Capture', 'FC Sales Capture', 'FC Pump Stats', 'FC Meter Readings'].join(','),'password': [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' A ',Counter___Value].join(''),'email': (String((await (async function(Text) {
        	const D = Text
        	const result = D.split(" ").join("");
        	return result
        })(([(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' A ',Counter___Value].join(''))))) + String(subsequenceFromStartLast((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'Email')), (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'Email')).indexOf('@') + 1) - 1)))).toLowerCase(),'ownerId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'objectId')) }) ));

      } catch (error) {

      } finally {
        if (error) {
          ___arguments.context.pageData['Step 4 Error'] = 'New Bowser Attendant Registration Error';
        }

      }
      _uow.create('Employees', ({ [`Company_ID`]: [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' A ',Counter___Value].join(''),[`Driver_License_Code`]: undefined,[`Driver_License_Expiry_Date`]: undefined,[`Driver_License_Number`]: undefined,[`Driver_PDP_Document`]: undefined,[`Driver_PDP_Expiry_Date`]: undefined,[`Driver_Permit_1_Document`]: undefined,[`Driver_Permit_1_Expiry_Date`]: undefined,[`Driver_Permit_1_Name`]: undefined,[`Driver_Permit_2_Document`]: undefined,[`Driver_Permit_2_Expiry_Date`]: undefined,[`Driver_Permit_2_Name`]: undefined,[`Driver_Permit_3_Document`]: undefined,[`Driver_Permit_3_Expiry_Date`]: undefined,[`Driver_Permit_3_Name`]: undefined,[`Driver_Warehouse_Status`]: undefined,[`Emergency_ICE_Name`]: undefined,[`Emergency_ICE_Phone`]: undefined,[`Emergency_Medical_Aid_Name`]: undefined,[`Emergency_Medical_Aid_Number`]: undefined,[`Emergency_Medical_Aid_Document`]: undefined,[`Employee_Details_Forenames`]: undefined,[`Employee_Details_ID_Document`]: undefined,[`Employee_Details_ID_Number`]: undefined,[`Employee_Details_Nickname`]: undefined,[`Employee_Details_Passport_Document`]: undefined,[`Employee_Details_Passport_Expiry_Date`]: undefined,[`Employee_Details_Passport_Number`]: undefined,[`Employee_Details_Phone`]: undefined,[`Employee_Details_Position`]: 'Attendant',[`Employee_Details_Profile_Photo`]: undefined,[`Employee_Details_Surname`]: undefined,[`Employee_Details_Tax_Reference_Number`]: undefined,[`Star_Rating`]: undefined,[`Star_Rating_Fuel`]: undefined,[`Star_Rating_Loading`]: undefined,[`Wages_Deduction_Bargaining_Council_Fee`]: undefined,[`Wages_Deduction_Bargaining_Council_Name`]: undefined,[`Wages_Deduction_Medical_Aid_Fee`]: undefined,[`Wages_Deduction_Pension_Fee`]: undefined,[`Wages_Deduction_Pension_Name`]: undefined,[`Wages_Deduction_Provident_Fund_Fee`]: undefined,[`Wages_Deduction_Provident_Fund_Name`]: undefined,[`Wages_Deduction_Union_Fee`]: undefined,[`Wages_Deduction_Union_Name`]: undefined,[`Wages_Rate_Basic`]: undefined,[`Wages_Rate_Contractor_Mileage`]: undefined,[`Wages_Rate_Contractor_Tonnage`]: undefined,[`Wages_Rate_Good_Driving`]: undefined,[`Wages_Rate_Good_Planning_Mileage`]: undefined,[`Wages_Rate_Good_Planning_Tonnage`]: undefined,[`Wages_Rate_Sleep_Out`]: undefined,[`Wages_Rate_Target_Mileage`]: undefined,[`ownerId`]: (getObjectProperty(New_Bowser_Attendant, 'objectId')) })).setOpResultId('New Bowser Attendant Details');
      _uow.setRelation('Users', New_Bowser_Attendant, 'Company', [(getObjectProperty(___arguments.context.pageData, 'New Company'))]);
      _uow.setRelation('Users', New_Bowser_Attendant, 'Details', (Transaction.getOpResultById('New Bowser Attendant Details')));
      _uow.addToRelation('Employees', (Transaction.getOpResultById('New Bowser Attendant Details')), 'Company', [(getObjectProperty(___arguments.context.pageData, 'New Company'))]);

    })();

    try {
      Result = (await Transaction.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        }));
      Second_Result = (await Backendless.Data.of('Employees').findLast());
      await Backendless.Data.of('Companies').addRelation((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Employees', [Second_Result]);

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        while (!((getObjectProperty(Result, 'success')) == true)) {
          Result = (await Transaction.execute().then(function(result) {
              const error = result && result.error

              if (error) {
                throw error
              }

            return result
            }));
          Second_Result = (await Backendless.Data.of('Employees').findLast());
          await Backendless.Data.of('Companies').addRelation((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Employees', [Second_Result]);
        }
      }

    }
  }
}

/**
 * Describe this function...
 */
async function Mechanics_API() {
  Counter = 0;
  var repeat_end4 = (getObjectProperty(___arguments.event, 'Step 4 - Number Of Mechanics'));
  for (var count4 = 0; count4 < repeat_end4; count4++) {
    Counter = Counter + 1;
    if (Counter <= 9) {
      Counter___Value = String('000') + String(Counter);
    } else if (Counter <= 99) {
      Counter___Value = String('00') + String(Counter);
    } else if (Counter <= 999) {
      Counter___Value = String('0') + String(Counter);
    } else if (Counter <= 9999) {
      Counter___Value = String(Counter);
    }
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Transaction;

      try {
        New_Mechanic = (await Backendless.UserService.register( new Backendless.User({ 'Name': [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' M ',Counter___Value].join(''),'Username': [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' M ',Counter___Value].join(''),'App': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'App')),'Level': 'Office','Permissions': ['Com Maintenance Hub '].join(','),'password': [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' M ',Counter___Value].join(''),'email': (String((await (async function(Text) {
        	const D = Text
        	const result = D.split(" ").join("");
        	return result
        })(([(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' M ',Counter___Value].join(''))))) + String(subsequenceFromStartLast((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'Email')), (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'Email')).indexOf('@') + 1) - 1)))).toLowerCase(),'ownerId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'objectId')) }) ));

      } catch (error) {

      } finally {
        if (error) {
          ___arguments.context.pageData['Step 4 Error'] = 'Mechanic Registration Error';
        }

      }
      _uow.create('Employees', ({ [`Company_ID`]: [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' M',Counter___Value].join(''),[`Driver_License_Code`]: undefined,[`Driver_License_Expiry_Date`]: undefined,[`Driver_License_Number`]: undefined,[`Driver_PDP_Document`]: undefined,[`Driver_PDP_Expiry_Date`]: undefined,[`Driver_Permit_1_Document`]: undefined,[`Driver_Permit_1_Expiry_Date`]: undefined,[`Driver_Permit_1_Name`]: undefined,[`Driver_Permit_2_Document`]: undefined,[`Driver_Permit_2_Expiry_Date`]: undefined,[`Driver_Permit_2_Name`]: undefined,[`Driver_Permit_3_Document`]: undefined,[`Driver_Permit_3_Expiry_Date`]: undefined,[`Driver_Permit_3_Name`]: undefined,[`Driver_Warehouse_Status`]: undefined,[`Emergency_ICE_Name`]: undefined,[`Emergency_ICE_Phone`]: undefined,[`Emergency_Medical_Aid_Name`]: undefined,[`Emergency_Medical_Aid_Number`]: undefined,[`Emergency_Medical_Aid_Document`]: undefined,[`Employee_Details_Forenames`]: undefined,[`Employee_Details_ID_Document`]: undefined,[`Employee_Details_ID_Number`]: undefined,[`Employee_Details_Nickname`]: undefined,[`Employee_Details_Passport_Document`]: undefined,[`Employee_Details_Passport_Expiry_Date`]: undefined,[`Employee_Details_Passport_Number`]: undefined,[`Employee_Details_Phone`]: undefined,[`Employee_Details_Position`]: 'Mechanic',[`Employee_Details_Profile_Photo`]: undefined,[`Employee_Details_Surname`]: undefined,[`Employee_Details_Tax_Reference_Number`]: undefined,[`Star_Rating`]: undefined,[`Star_Rating_Fuel`]: undefined,[`Star_Rating_Loading`]: undefined,[`Wages_Deduction_Bargaining_Council_Fee`]: undefined,[`Wages_Deduction_Bargaining_Council_Name`]: undefined,[`Wages_Deduction_Medical_Aid_Fee`]: undefined,[`Wages_Deduction_Pension_Fee`]: undefined,[`Wages_Deduction_Pension_Name`]: undefined,[`Wages_Deduction_Provident_Fund_Fee`]: undefined,[`Wages_Deduction_Provident_Fund_Name`]: undefined,[`Wages_Deduction_Union_Fee`]: undefined,[`Wages_Deduction_Union_Name`]: undefined,[`Wages_Rate_Basic`]: undefined,[`Wages_Rate_Contractor_Mileage`]: undefined,[`Wages_Rate_Contractor_Tonnage`]: undefined,[`Wages_Rate_Good_Driving`]: undefined,[`Wages_Rate_Good_Planning_Mileage`]: undefined,[`Wages_Rate_Good_Planning_Tonnage`]: undefined,[`Wages_Rate_Sleep_Out`]: undefined,[`Wages_Rate_Target_Mileage`]: undefined,[`ownerId`]: (getObjectProperty(New_Mechanic, 'objectId')) })).setOpResultId('New Mechanic Details');
      _uow.setRelation('Users', New_Mechanic, 'Company', [(getObjectProperty(___arguments.context.pageData, 'New Company'))]);
      _uow.setRelation('Users', New_Mechanic, 'Details', (Transaction.getOpResultById('New Mechanic Details')));
      _uow.addToRelation('Employees', (Transaction.getOpResultById('New Mechanic Details')), 'Company', [(getObjectProperty(___arguments.context.pageData, 'New Company'))]);

    })();

    try {
      Result = (await Transaction.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        }));
      Second_Result = (await Backendless.Data.of('Employees').findLast());
      await Backendless.Data.of('Companies').addRelation((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Employees', [Second_Result]);

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        while (!((getObjectProperty(Result, 'success')) == true)) {
          Result = (await Transaction.execute().then(function(result) {
              const error = result && result.error

              if (error) {
                throw error
              }

            return result
            }));
          Second_Result = (await Backendless.Data.of('Employees').findLast());
          await Backendless.Data.of('Companies').addRelation((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Employees', [Second_Result]);
        }
      }

    }
  }
}

/**
 * Describe this function...
 */
async function Load_Planner_API() {
  Counter = 0;
  var repeat_end5 = (getObjectProperty(___arguments.event, 'Step 4 - Number Of Load Planners'));
  for (var count5 = 0; count5 < repeat_end5; count5++) {
    Counter = Counter + 1;
    if (Counter <= 9) {
      Counter___Value = String('000') + String(Counter);
    } else if (Counter <= 99) {
      Counter___Value = String('00') + String(Counter);
    } else if (Counter <= 999) {
      Counter___Value = String('0') + String(Counter);
    } else if (Counter <= 9999) {
      Counter___Value = String(Counter);
    }
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Transaction;

      try {
        New_Load_Planner = (await Backendless.UserService.register( new Backendless.User({ 'Name': [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' L ',Counter___Value].join(''),'Username': [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' L ',Counter___Value].join(''),'App': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'App')),'Level': 'Office','Permissions': ['Com Broker Level (Broker)'].join(','),'password': [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' L ',Counter___Value].join(''),'email': (String((await (async function(Text) {
        	const D = Text
        	const result = D.split(" ").join("");
        	return result
        })(([(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' L ',Counter___Value].join(''))))) + String(subsequenceFromStartLast((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'Email')), (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'Email')).indexOf('@') + 1) - 1)))).toLowerCase(),'ownerId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'objectId')) }) ));

      } catch (error) {

      } finally {
        if (error) {
          ___arguments.context.pageData['Step 4 Error'] = 'Planner Registration Error';
        }

      }
      _uow.create('Employees', ({ [`Company_ID`]: [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' L ',Counter___Value].join(''),[`Driver_License_Code`]: undefined,[`Driver_License_Expiry_Date`]: undefined,[`Driver_License_Number`]: undefined,[`Driver_PDP_Document`]: undefined,[`Driver_PDP_Expiry_Date`]: undefined,[`Driver_Permit_1_Document`]: undefined,[`Driver_Permit_1_Expiry_Date`]: undefined,[`Driver_Permit_1_Name`]: undefined,[`Driver_Permit_2_Document`]: undefined,[`Driver_Permit_2_Expiry_Date`]: undefined,[`Driver_Permit_2_Name`]: undefined,[`Driver_Permit_3_Document`]: undefined,[`Driver_Permit_3_Expiry_Date`]: undefined,[`Driver_Permit_3_Name`]: undefined,[`Driver_Warehouse_Status`]: undefined,[`Emergency_ICE_Name`]: undefined,[`Emergency_ICE_Phone`]: undefined,[`Emergency_Medical_Aid_Name`]: undefined,[`Emergency_Medical_Aid_Number`]: undefined,[`Emergency_Medical_Aid_Document`]: undefined,[`Employee_Details_Forenames`]: undefined,[`Employee_Details_ID_Document`]: undefined,[`Employee_Details_ID_Number`]: undefined,[`Employee_Details_Nickname`]: undefined,[`Employee_Details_Passport_Document`]: undefined,[`Employee_Details_Passport_Expiry_Date`]: undefined,[`Employee_Details_Passport_Number`]: undefined,[`Employee_Details_Phone`]: undefined,[`Employee_Details_Position`]: 'Load Planner',[`Employee_Details_Profile_Photo`]: undefined,[`Employee_Details_Surname`]: undefined,[`Employee_Details_Tax_Reference_Number`]: undefined,[`Star_Rating`]: undefined,[`Star_Rating_Fuel`]: undefined,[`Star_Rating_Loading`]: undefined,[`Wages_Deduction_Bargaining_Council_Fee`]: undefined,[`Wages_Deduction_Bargaining_Council_Name`]: undefined,[`Wages_Deduction_Medical_Aid_Fee`]: undefined,[`Wages_Deduction_Pension_Fee`]: undefined,[`Wages_Deduction_Pension_Name`]: undefined,[`Wages_Deduction_Provident_Fund_Fee`]: undefined,[`Wages_Deduction_Provident_Fund_Name`]: undefined,[`Wages_Deduction_Union_Fee`]: undefined,[`Wages_Deduction_Union_Name`]: undefined,[`Wages_Rate_Basic`]: undefined,[`Wages_Rate_Contractor_Mileage`]: undefined,[`Wages_Rate_Contractor_Tonnage`]: undefined,[`Wages_Rate_Good_Driving`]: undefined,[`Wages_Rate_Good_Planning_Mileage`]: undefined,[`Wages_Rate_Good_Planning_Tonnage`]: undefined,[`Wages_Rate_Sleep_Out`]: undefined,[`Wages_Rate_Target_Mileage`]: undefined,[`ownerId`]: (getObjectProperty(New_Load_Planner, 'objectId')) })).setOpResultId('New Load Planner Details');
      _uow.setRelation('Users', New_Load_Planner, 'Company', [(getObjectProperty(___arguments.context.pageData, 'New Company'))]);
      _uow.setRelation('Users', New_Load_Planner, 'Details', (Transaction.getOpResultById('New Load Planner Details')));
      _uow.addToRelation('Employees', (Transaction.getOpResultById('New Load Planner Details')), 'Company', [(getObjectProperty(___arguments.context.pageData, 'New Company'))]);

    })();

    try {
      Result = (await Transaction.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        }));
      Second_Result = (await Backendless.Data.of('Employees').findLast());
      await Backendless.Data.of('Companies').addRelation((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Employees', [Second_Result]);

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        while (!((getObjectProperty(Result, 'success')) == true)) {
          Result = (await Transaction.execute().then(function(result) {
              const error = result && result.error

              if (error) {
                throw error
              }

            return result
            }));
          Second_Result = (await Backendless.Data.of('Employees').findLast());
          await Backendless.Data.of('Companies').addRelation((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Employees', [Second_Result]);
        }
      }

    }
  }
}

/**
 * Describe this function...
 */
async function Trailer_API() {
  Counter = 0;
  var repeat_end6 = (getObjectProperty(___arguments.event, 'Step 4 - Number Of Trailers'));
  for (var count6 = 0; count6 < repeat_end6; count6++) {
    Counter = Counter + 1;
    if (Counter <= 9) {
      Counter___Value = String('000') + String(Counter);
    } else if (Counter <= 99) {
      Counter___Value = String('00') + String(Counter);
    } else if (Counter <= 999) {
      Counter___Value = String('0') + String(Counter);
    } else if (Counter <= 9999) {
      Counter___Value = String(Counter);
    }
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Transaction;

      _uow.create('Tractors', ({ [`Annual_License_Fee`]: 0,[`Axles`]: ['Single Wheel (3)'].join(','),[`Depreciation`]: 0,[`Fixed_Maintenance_Plan_Cost`]: 0,[`ID`]: [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' T ',Counter___Value].join(''),[`Instalment`]: 0,[`Insurance_Premium`]: 0,[`Last_Service_Mileage`]: 0,[`Last_Service_Scheduled`]: 0,[`License_Expiry_Date`]: (new Date()),[`Maintenance_Plan_Rate_per_Km`]: 0,[`Make`]: 'Initiated Trailer',[`Model`]: 'Initiated Trailer',[`Odometer`]: 0,[`Price`]: 0,[`Position`]: undefined,[`Registration`]: [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' T ',Counter___Value].join(''),[`Service_Interval`]: 20000,[`Service_Warning_Duration_in_KM`]: 5000,[`Status`]: 'Active',[`Tare`]: 2000,[`Tracking`]: 0,[`Type`]: undefined,[`VIN`]: undefined,[`Warehouse`]: 'In',[`Year`]: undefined,[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'objectId')) })).setOpResultId('New Trailer');
      _uow.setRelation('Trailers', (Transaction.getOpResultById('New Trailer')), 'Company', [(getObjectProperty(___arguments.context.pageData, 'New Company'))]);

    })();

    try {
      Result = (await Transaction.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        }));
      Second_Result = (await Backendless.Data.of('Trailers').findLast());
      await Backendless.Data.of('Companies').addRelation((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Trailers', [Second_Result]);

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        while (!((getObjectProperty(Result, 'success')) == true)) {
          Result = (await Transaction.execute().then(function(result) {
              const error = result && result.error

              if (error) {
                throw error
              }

            return result
            }));
          Second_Result = (await Backendless.Data.of('Trailers').findLast());
          await Backendless.Data.of('Companies').addRelation((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Trailers', [Second_Result]);
        }
      }

    }
  }
}

/**
 * Describe this function...
 */
async function Tank_API() {
  Counter = 0;
  var repeat_end7 = (getObjectProperty(___arguments.event, 'Step 4 - Number of Tanks'));
  for (var count7 = 0; count7 < repeat_end7; count7++) {
    Counter = Counter + 1;
    if (Counter <= 9) {
      Counter___Value = String('000') + String(Counter);
    } else if (Counter <= 99) {
      Counter___Value = String('00') + String(Counter);
    } else if (Counter <= 999) {
      Counter___Value = String('0') + String(Counter);
    } else if (Counter <= 9999) {
      Counter___Value = String(Counter);
    }
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Transaction;

      _uow.create('Tanks', ({ [`Capacity`]: 1000,[`Litres`]: 0,[`Meter`]: 0,[`Name`]: [(getObjectProperty(___arguments.context.pageData, 'New Company - ID')),' Tank ',Counter___Value].join(''),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'New Director')), 'objectId')) })).setOpResultId('New Tank');
      _uow.setRelation('Tanks', (Transaction.getOpResultById('New Tank')), 'Company', [(getObjectProperty(___arguments.context.pageData, 'New Company'))]);

    })();

    try {
      Result = (await Transaction.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        }));
      Second_Result = (await Backendless.Data.of('Tanks').findLast());
      await Backendless.Data.of('Companies').addRelation((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Tanks', [Second_Result]);

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        while (!((getObjectProperty(Result, 'success')) == true)) {
          Result = (await Transaction.execute().then(function(result) {
              const error = result && result.error

              if (error) {
                throw error
              }

            return result
            }));
          Second_Result = (await Backendless.Data.of('Tanks').findLast());
          await Backendless.Data.of('Companies').addRelation((getObjectProperty(___arguments.context.pageData, 'New Company')), 'Tanks', [Second_Result]);
        }
      }

    }
  }
}


  await Step_4_Code();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/9fbbf9761d273db4c383bd869cbbfdab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_9be1a86f7a3a2b8ee987b8cb91164058'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e088911da5aaaafcfd23e73b7bf9e911')), ___arguments.context.pageData, 'Employee Bulk Create - Drop Down - Viewer');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/b1b7260cf02f8316a289065af0cf5ea1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Employee Bulk Create - Drop Down - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/757f04f34c42dac7e477bf9436cdbfd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_9be1a86f7a3a2b8ee987b8cb91164058'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0b4327ee73fecd3f58fb7429e561f249')), ___arguments.context.pageData, 'Asset Bulk Create - Drop Down - Viewer');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/c4084e08c60bbc1a52e81e29122a332c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Asset Bulk Create - Drop Down - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/c29dc5fa2ed3033b595a08562de631e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_9be1a86f7a3a2b8ee987b8cb91164058'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('18f89b8a6e755e3dcb1e337e0905f515')), ___arguments.context.pageData, 'Tank Bulk Create - Drop Down - Viewer');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/f4bb6dd18127844ff4ca886113bdf59e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_cc11a9a5370e6f074e8acef24d8be4cb']((getObjectProperty(___arguments.context.pageData, 'Tank Bulk Create - Drop Down - Viewer'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/0a5e323c47882ae85836d1d1920845b3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Manage Customer View')) == true) {
  } else {
    ___arguments.context.pageData['Manage Customer View'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7dab1f6deb9f168dca5a32416584f1ee'))['icon'] = 'menu';
    ___arguments.context.pageData['Menu View'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/bfdf70e4b08b1098f0d73ec50c0a18bc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Manage Customer View')) == true) {
    ___arguments.context.pageData['Manage Customer View'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7dab1f6deb9f168dca5a32416584f1ee'))['icon'] = 'menu';
    ___arguments.context.pageData['Menu View'] = false;
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIF/components/2f03c65c1a7d92c57c6693f4763addea/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Manage Customer View')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIF/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Customers List'] = (await Promise.all((await Backendless.Data.of('Companies').find(Backendless.DataQueryBuilder.create().setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'ownerId')),[`label`]: (getObjectProperty(item, 'Company_Registered_Name')) });})));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/FIFCapture/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['Customers List'] = (await Promise.all((await Backendless.Data.of('Companies').find(Backendless.DataQueryBuilder.create().setPageSize(100))).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'ownerId')),[`label`]: (getObjectProperty(item, 'Company_Registered_Name')) });})));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/FIFCapture/components/f6c7c2ab482c8d324f19d24743c99e6e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[___arguments.value] = true;
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, ___arguments.prevValue))))) {
  } else {
    if ((getObjectProperty(___arguments.context.pageData, ___arguments.prevValue)) == true) {
      delete ___arguments.context.pageData[___arguments.prevValue];
    }
    ___arguments.context.pageData[___arguments.value] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFCapture/components/c616ad3f339af02ecd71929eae712802/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Whereclause'] = (['ownerid = \'',___arguments.value,'\''].join(''));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFCapture/components/9bc94183d622558e1594041515f256ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Counter, Conductor_Transactions, Employee_Salaries, Employee_Details, Company, Employee, Interger, Data, ownerId, Director, error, Step_1, Attendants_Transaction, Admin_Transaction, Company_Transaction, Driver_Transactions, Load_Planner_Transaction, Mechanics_Transaction, Fleetview_Current_, Tractor_Transactions, Tractors, Trailer_Transcations, Trailers, Tank_Transaction, Tanks, Bowser_Transaction, Bowsers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Conductors() {
  Counter = 1;
  var repeat_end = (Number((getObjectProperty(Data, 'Conductors'))));
  for (var count = 0; count < repeat_end; count++) {
    Conductor_Transactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Conductor_Transactions;

      Employee = (await Backendless.UserService.register( new Backendless.User({ 'Username': ['User Conductor ',Counter,' ',Interger].join(''),'password': '1234','Level': 'Office' }) ));
      Employee_Details = (_uow.create('Employees', ({ [`Company_ID`]: undefined,[`ownerId`]: (getObjectProperty(Employee, 'objectId')),[`Now`]: (new Date()) })).setOpResultId((['User Conductor ',Counter,' ',Interger].join(''))));
      Employee_Salaries = (_uow.create('Salaries', ({ [`ownerId`]: (getObjectProperty(Employee, 'objectId')) })));
      _uow.setRelation('Users', Employee, 'Company', [Company]);
      _uow.setRelation('Employees', Employee_Details, 'Company', [Company]);
      _uow.setRelation('Salaries', Employee_Salaries, 'Employee', [Employee_Details]);
      _uow.setRelation('Employees', Employee_Details, 'Wages_Current', [Employee_Salaries]);
      _uow.addToRelation('Employees', Employee_Details, 'Wages_Historical', [Employee_Salaries]);

    })();

    console.log((await Conductor_Transactions.execute()));
    Counter = Counter + 1;
    await new Promise(r => setTimeout(r, 3000 || 0));
  }
}

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}

/**
 * Describe this function...
 */
async function Attendants() {
  Counter = 1;
  var repeat_end2 = (Number((getObjectProperty(Data, 'Attendants'))));
  for (var count2 = 0; count2 < repeat_end2; count2++) {
    Attendants_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Attendants_Transaction;

      Employee = (await Backendless.UserService.register( new Backendless.User({ 'Username': ['User Attendant ',Counter,' ',Interger].join(''),'password': '1234','Level': 'Forecourt' }) ));
      Employee_Details = (_uow.create('Employees', ({ [`Company_ID`]: ['User Attendant ',Counter,' ',Interger].join(''),[`ownerId`]: (getObjectProperty(Employee, 'objectId')),[`Now`]: (new Date()) })));
      Employee_Salaries = (_uow.create('Salaries', ({ [`ownerId`]: (getObjectProperty(Employee, 'objectId')) })));
      _uow.setRelation('Users', Employee, 'Company', [Company]);
      _uow.setRelation('Employees', Employee_Details, 'Company', [Company]);
      _uow.setRelation('Salaries', Employee_Salaries, 'Employee', [Employee_Details]);
      _uow.setRelation('Employees', Employee_Details, 'Wages_Current', [Employee_Salaries]);
      _uow.addToRelation('Employees', Employee_Details, 'Wages_Historical', [Employee_Salaries]);

    })();

    console.log((await Attendants_Transaction.execute()));
    Counter = Counter + 1;
    await new Promise(r => setTimeout(r, 3000 || 0));
  }
}

/**
 * Describe this function...
 */
async function Admin() {
  Counter = 1;
  var repeat_end3 = (Number((getObjectProperty(Data, 'Admins'))));
  for (var count3 = 0; count3 < repeat_end3; count3++) {
    Admin_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Admin_Transaction;

      Employee = (await Backendless.UserService.register( new Backendless.User({ 'Username': ['User Admin ',Counter,' ',Interger].join(''),'password': '1234','Level': 'Office','ownerId': (getObjectProperty(Company, 'ownerId')) }) ));
      Employee_Details = (_uow.create('Employees', ({ [`Company_ID`]: ['User Admin ',Counter,' ',Interger].join(''),[`ownerId`]: (getObjectProperty(Employee, 'objectId')),[`Now`]: (new Date()) })));
      Employee_Salaries = (_uow.create('Salaries', ({ [`ownerId`]: (getObjectProperty(Company, 'ownerId')) })));
      _uow.setRelation('Users', Employee, 'Company', [Company]);
      _uow.setRelation('Employees', Employee_Details, 'Company', [Company]);
      _uow.setRelation('Salaries', Employee_Salaries, 'Employee', [Employee_Details]);
      _uow.setRelation('Employees', Employee_Details, 'Wages_Current', [Employee_Salaries]);
      _uow.addToRelation('Employees', Employee_Details, 'Wages_Historical', [Employee_Salaries]);

    })();

    console.log((await Admin_Transaction.execute()));
    Counter = Counter + 1;
    await new Promise(r => setTimeout(r, 3000 || 0));
  }
}

/**
 * Describe this function...
 */
async function Company2() {
  Company_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Company_Transaction;

    Director = (await Backendless.UserService.register( new Backendless.User({ 'Username': [(getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Company Name')),' - (',Interger,')'].join(''),'password': '1234','Level': 'Office' }) ));
    Company = (_uow.create('Companies', ({ [`Name`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Company Name')),[`ownerId`]: (getObjectProperty(Director, 'objectId')),[`Directory`]: String('users/') + String(getObjectProperty(Director, 'objectId')) })));
    _uow.setRelation('Users', Director, 'Company', [Company]);

  })();

  return { [`Result`]: (await Company_Transaction.execute()),[`Director`]: Director }
}

/**
 * Describe this function...
 */
async function Drivers() {
  Counter = 1;
  var repeat_end4 = (Number((getObjectProperty(Data, 'Drivers'))));
  for (var count4 = 0; count4 < repeat_end4; count4++) {
    Driver_Transactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Driver_Transactions;

      Employee = (await Backendless.UserService.register( new Backendless.User({ 'Username': ['User Driver',Counter,' ',Interger].join(''),'password': '1234','Level': 'Road' }) ));
      Employee_Details = (_uow.create('Employees', ({ [`Company_ID`]: ['User Driver',Counter,' ',Interger].join(''),[`ownerId`]: (getObjectProperty(Employee, 'objectId')),[`Now`]: (new Date()) })).setOpResultId((['User Driver',Counter,' ',Interger].join(''))));
      Employee_Salaries = (_uow.create('Salaries', ({ [`ownerId`]: (getObjectProperty(Employee, 'objectId')) })));
      _uow.setRelation('Users', Employee, 'Company', [Company]);
      _uow.setRelation('Employees', Employee_Details, 'Company', [Company]);
      _uow.setRelation('Salaries', Employee_Salaries, 'Employee', [Employee_Details]);
      _uow.setRelation('Employees', Employee_Details, 'Wages_Current', [Employee_Salaries]);
      _uow.addToRelation('Employees', Employee_Details, 'Wages_Historical', [Employee_Salaries]);

    })();

    console.log((await Driver_Transactions.execute().then(function(result) {
        const error = result && result.error

        if (error) {
          throw error
        }

      return result
      })));
    Counter = Counter + 1;
    await new Promise(r => setTimeout(r, 3000 || 0));
  }
}

/**
 * Describe this function...
 */
async function Load_Planners() {
  Counter = 1;
  var repeat_end5 = (Number((getObjectProperty(Data, 'Load Planners'))));
  for (var count5 = 0; count5 < repeat_end5; count5++) {
    Load_Planner_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Load_Planner_Transaction;

      Employee = (await Backendless.UserService.register( new Backendless.User({ 'Username': ['User Load Planner',Counter,' ',Interger].join(''),'password': '1234','Level': 'Office' }) ));
      Employee_Details = (_uow.create('Employees', ({ [`Company_ID`]: undefined,[`ownerId`]: (getObjectProperty(Employee, 'objectId')),[`Now`]: (new Date()) })).setOpResultId((['User Load Planner',Counter,' ',Interger].join(''))));
      Employee_Salaries = (_uow.create('Salaries', ({ [`ownerId`]: (getObjectProperty(Employee, 'objectId')) })));
      _uow.setRelation('Users', Employee, 'Company', [Company]);
      _uow.setRelation('Employees', Employee_Details, 'Company', [Company]);
      _uow.setRelation('Salaries', Employee_Salaries, 'Employee', [Employee_Details]);
      _uow.setRelation('Employees', Employee_Details, 'Wages_Current', [Employee_Salaries]);
      _uow.addToRelation('Employees', Employee_Details, 'Wages_Historical', [Employee_Salaries]);

    })();

    console.log((await Load_Planner_Transaction.execute()));
    Counter = Counter + 1;
    await new Promise(r => setTimeout(r, 3000 || 0));
  }
}

/**
 * Describe this function...
 */
async function Mechanics() {
  Counter = 1;
  var repeat_end6 = (Number((getObjectProperty(Data, 'Mechanics'))));
  for (var count6 = 0; count6 < repeat_end6; count6++) {
    Mechanics_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Mechanics_Transaction;

      Employee = (await Backendless.UserService.register( new Backendless.User({ 'Username': ['User Mechanic',Counter,' ',Interger].join(''),'password': '1234','Level': 'Office' }) ));
      Employee_Details = (_uow.create('Employees', ({ [`Company_ID`]: undefined,[`ownerId`]: (getObjectProperty(Employee, 'objectId')),[`Now`]: (new Date()) })).setOpResultId((['User Mechanic',Counter,' ',Interger].join(''))));
      Employee_Salaries = (_uow.create('Salaries', ({ [`ownerId`]: (getObjectProperty(Employee, 'objectId')) })));
      _uow.setRelation('Users', Employee, 'Company', [Company]);
      _uow.setRelation('Employees', Employee_Details, 'Company', [Company]);
      _uow.setRelation('Salaries', Employee_Salaries, 'Employee', [Employee_Details]);
      _uow.setRelation('Employees', Employee_Details, 'Wages_Current', [Employee_Salaries]);
      _uow.addToRelation('Employees', Employee_Details, 'Wages_Historical', [Employee_Salaries]);

    })();

    console.log((await Mechanics_Transaction.execute()));
    Counter = Counter + 1;
    await new Promise(r => setTimeout(r, 3000 || 0));
  }
}

/**
 * Describe this function...
 */
async function Tractors2() {
  Counter = 1;
  var repeat_end7 = (Number((getObjectProperty(Data, 'Tractors'))));
  for (var count7 = 0; count7 < repeat_end7; count7++) {
    Tractor_Transactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    console.log('Tractor Start');
    await ( async () => {
      const _uow = Tractor_Transactions;

      Tractors = (_uow.create('Tractors', ({ [`ID`]: ['Tractor ',Counter,' ',Interger].join(''),[`Registration`]: ['Tractor ',Counter,' ',Interger].join(''),[`ownerId`]: (getObjectProperty(Director, 'objectId')) })));
      Fleetview_Current_ = (_uow.create('Fleetview', ({ [`Now`]: (new Date()),[`ownerId`]: (getObjectProperty(Director, 'objectId')) })));
      _uow.setRelation('Companies', Company, 'Tractors', [Tractors]);
      _uow.setRelation('Companies', Company, 'Fleetviews', [Fleetview_Current_]);
      _uow.setRelation('Tractors', Tractors, 'Fleetview_Current', [Fleetview_Current_]);
      _uow.setRelation('Tractors', Tractors, 'Current_Fleetview', [Fleetview_Current_]);

    })();

    console.log((await Tractor_Transactions.execute()));
    console.log(Fleetview_Current_);
    Counter = Counter + 1;
    await new Promise(r => setTimeout(r, 3000 || 0));
  }
}

/**
 * Describe this function...
 */
async function Trailers2() {
  Counter = 1;
  var repeat_end8 = (Number((getObjectProperty(Data, 'Tractors'))));
  for (var count8 = 0; count8 < repeat_end8; count8++) {
    Trailer_Transcations = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Trailer_Transcations;

      Trailers = (_uow.create('Trailers', ({ [`ID`]: ['Trailers ',Counter,' ',Interger].join(''),[`Registration`]: ['Trailers ',Counter,' ',Interger].join('') })));
      _uow.setRelation('Companies', Company, 'Trailers', [Trailers]);

    })();

    await Trailer_Transcations.execute();
    Counter = Counter + 1;
    await new Promise(r => setTimeout(r, 3000 || 0));
  }
}

/**
 * Describe this function...
 */
async function Tanks2() {
  Counter = 1;
  var repeat_end9 = (Number((getObjectProperty(Data, 'Tanks'))));
  for (var count9 = 0; count9 < repeat_end9; count9++) {
    Tank_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tank_Transaction;

      Tanks = (_uow.create('Tanks', ({ [`Name`]: ['Tanks ',Counter,' ',Interger].join('') })));
      _uow.setRelation('Companies', Company, 'Tanks', [Tanks]);

    })();

    await Tank_Transaction.execute();
    Counter = Counter + 1;
    await new Promise(r => setTimeout(r, 3000 || 0));
  }
}

/**
 * Describe this function...
 */
async function Bowsers2() {
  Counter = 1;
  var repeat_end10 = (Number((getObjectProperty(Data, 'Bowsers'))));
  for (var count10 = 0; count10 < repeat_end10; count10++) {
    Bowser_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Bowser_Transaction;

      Bowsers = (_uow.create('Bowsers', ({ [`Name`]: ['User Bowser',Counter,' ',Interger].join('') })));
      _uow.setRelation('Companies', Company, 'Company', [Bowsers]);

    })();

    await Bowser_Transaction.execute();
    Counter = Counter + 1;
    await new Promise(r => setTimeout(r, 3000 || 0));
  }
}

/**
 * Describe this function...
 */
async function Farms() {
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8dddab94422390c464cffc97b51f2906', true);
  Data = ({ [`Drivers`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Driver')),[`Conductors`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Conductors')),[`Load Planners`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Load Planners')),[`Admins`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Admins')),[`Mechanics`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Mechanics')),[`Attendants`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Attendants')),[`Bowsers`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Bowsers')),[`Tanks`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Tanks')),[`Tractors`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Tractors')),[`Trailers`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Trailers')),[`Farms`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Farms')) });
  Interger = mathRandomInt(10000, 99999);
  try {
    console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 1 (Company) Started', 'color: #ffee58', undefined);
    Step_1 = await Company2();
    Company = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Step_1, 'Result')), 'results')), 'createCompanies1')), 'result'));
    Director = (getObjectProperty(Step_1, 'Director'));
    ownerId = (getObjectProperty((getObjectProperty(Step_1, 'Director')), 'ownerId'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 1 Failed', 'color: #ef5350', undefined);
    } else {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 1 Completed', 'color: #4caf50', JSON.parse(JSON.stringify(({ [`Company`]: Company,[`Director`]: Director,[`ownerId`]: ownerId }))));
    }

  }
  try {
    console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 2 (Admin) Started', 'color: #ffee58', undefined);
    await Admin();

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 2 (Admin) Failed', 'color: #ef5350', undefined);
    } else {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 2 (Admin) Completed', 'color: #4caf50', JSON.parse(JSON.stringify(({ [`Company`]: Company,[`Director`]: Director,[`ownerId`]: ownerId }))));
    }

  }
  try {
    console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 3 (Attendants) Started', 'color: #ffee58', undefined);
    await Attendants();

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 3 (Attendants) Failed', 'color: #ef5350', undefined);
    } else {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 3 (Attendants) Completed', 'color: #4caf50', JSON.parse(JSON.stringify(({ [`Company`]: Company,[`Director`]: Director,[`ownerId`]: ownerId }))));
    }

  }
  try {
    console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 4 (Conductors) Started', 'color: #ffee58', undefined);
    await Conductors();

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 4 (Conductors) Failed', 'color: #ef5350', undefined);
    } else {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 4 (Conductors) Completed', 'color: #4caf50', JSON.parse(JSON.stringify(({ [`Company`]: Company,[`Director`]: Director,[`ownerId`]: ownerId }))));
    }

  }
  try {
    console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 5 (Drivers) Started', 'color: #ffee58', undefined);
    await Drivers();

  } catch (error) {
    console.log(error);
    if (error) {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 5 (Drivers) Failed', 'color: #ef5350', undefined);
    } else {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 5 (Drivers) Completed', 'color: #4caf50', JSON.parse(JSON.stringify(({ [`Company`]: Company,[`Director`]: Director,[`ownerId`]: ownerId }))));
    }

  }
  try {
    console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 6 (Load Planners) Started', 'color: #ffee58', undefined);
    await Load_Planners();

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 6 (Load Planners) Failed', 'color: #ef5350', undefined);
    } else {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 6 (Load Planners) Completed', 'color: #4caf50', JSON.parse(JSON.stringify(({ [`Company`]: Company,[`Director`]: Director,[`ownerId`]: ownerId }))));
    }

  }
  try {
    console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 7 (Mechanics) Started', 'color: #ffee58', undefined);
    await Mechanics();

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 7 (Mechanics) Failed', 'color: #ef5350', undefined);
    } else {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 7 (Mechanics) Completed', 'color: #4caf50', JSON.parse(JSON.stringify(({ [`Company`]: Company,[`Director`]: Director,[`ownerId`]: ownerId }))));
    }

  }
  try {
    console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 8 (Tractors) Started', 'color: #ffee58', undefined);
    await Tractors2();

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 8 (Tractors) Failed', 'color: #ef5350', undefined);
    } else {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 8 (Tractors) Completed', 'color: #4caf50', JSON.parse(JSON.stringify(({ [`Company`]: Company,[`Director`]: Director,[`ownerId`]: ownerId }))));
    }

  }
  try {
    console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 9 (Trailers) Started', 'color: #ffee58', undefined);
    await Trailers2();

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 9 (Trailers) Failed', 'color: #ef5350', undefined);
    } else {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 9 (Trailers) Completed', 'color: #4caf50', JSON.parse(JSON.stringify(({ [`Company`]: Company,[`Director`]: Director,[`ownerId`]: ownerId }))));
    }

  }
  try {
    console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 10 (Tanks) Started', 'color: #ffee58', undefined);
    await Tanks2();

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 10 (Tanks) Failed', 'color: #ef5350', undefined);
    } else {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 10 (Tanks) Completed', 'color: #4caf50', JSON.parse(JSON.stringify(({ [`Company`]: Company,[`Director`]: Director,[`ownerId`]: ownerId }))));
    }

  }
  try {
    console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 11 (Bowsers) Started', 'color: #ffee58', undefined);
    await Bowsers2();

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 11 (Bowsers) Failed', 'color: #ef5350', undefined);
    } else {
      console.log('%c>> 🔒 [8:22:09 PM]: ' + 'Step 11 (Bowsers) Completed', 'color: #4caf50', JSON.parse(JSON.stringify(({ [`Company`]: Company,[`Director`]: Director,[`ownerId`]: ownerId }))));
    }

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8dddab94422390c464cffc97b51f2906', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/f29d3eb28c7305cdea26955542d64836/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log(___arguments.context.appData);
  await new Promise(r => setTimeout(r, 50 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('b66aa5cab573ca48d796800e9905aafc', undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('461dcafc5d2caaf4c8889feaa184e96c');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('461dcafc5d2caaf4c8889feaa184e96c');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFDRIVER/components/530de4969ed54f6adbf18d012ba6331a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('b66aa5cab573ca48d796800e9905aafc', undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('8392d462ea84fb9c3c38b2dda61a1b86');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('8392d462ea84fb9c3c38b2dda61a1b86');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFDRIVER/components/dbcda5fed6f779ebf7aebc8a2658abb1/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dbcda5fed6f779ebf7aebc8a2658abb1'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dbcda5fed6f779ebf7aebc8a2658abb1'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('fc2190d3351237db401c77969434d387');
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('b66aa5cab573ca48d796800e9905aafc', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/63528a0a331c876df799faff6331827e/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('63528a0a331c876df799faff6331827e'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('63528a0a331c876df799faff6331827e'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('73cf5f0f617ec0e753b6b35d2eb42bcf');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/24067817733980987c04d374c69c3db1/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('24067817733980987c04d374c69c3db1'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('24067817733980987c04d374c69c3db1'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFDRIVER/components/6b9a2b5c4325bc3e65c586869fa42476/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
    var Tractors;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Tractors = (await Backendless.Data.of('Tractors').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')),'\''].join(''))).setPageSize(100)));
  (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))['Tractors'] = Tractors;
  console.log(Tractors);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6b9a2b5c4325bc3e65c586869fa42476'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6b9a2b5c4325bc3e65c586869fa42476'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))))) {
        Visability = true;
      } else {
        Visability = false;
      }
    }
  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('d9b3599f980657c8f696499e571be3fa');
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('b66aa5cab573ca48d796800e9905aafc', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/2c47fb58a038bb71e16fabe3ca8a28b1/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2c47fb58a038bb71e16fabe3ca8a28b1'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2c47fb58a038bb71e16fabe3ca8a28b1'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('1dbd05f78241034e153331a5456c4c3b');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/c21441411c2a1bf82819282563ea1bde/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c21441411c2a1bf82819282563ea1bde'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c21441411c2a1bf82819282563ea1bde'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))))) {
        Visability = false;
      } else {
        Visability = true;
      }
    }
  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('966a129f2cd2f463dfeda026bb1c78d4');
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('b66aa5cab573ca48d796800e9905aafc', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/bad6b23cfad68cd8b3816c2a7cba884d/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bad6b23cfad68cd8b3816c2a7cba884d'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bad6b23cfad68cd8b3816c2a7cba884d'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  try {
    delete ___arguments.context.appData['Network'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.appData['User'];

  } catch (error) {
    console.log(error);

  }
  await Backendless.UserService.logout();
  console.log((function () { return window.location.href })());
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/0cbe127ca95da78f5c8f2317bb2b3588/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors'))))) {
          List = [];
        } else {
          List = (await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


           return ((getObjectProperty(item, 'Warehouse')) == 'In');
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });})));
        }
      }
    }
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')) !== null && !Array.isArray((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))) && (typeof (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')) === 'object')) {
    delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Selected Tractor'];
    delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Step 2'];
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Selected Tractor'] = ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ___arguments.value);
    }))[0]);
  } else {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Selected Tractor'] = ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ___arguments.value);
    }))[0]);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFDRIVER/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, item, object;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

/**
 * Describe this function...
 */
async function Listners() {
  ___arguments.context.appData['Driver Load data Listener (Update)'] = (generateUUID().long());
  ___arguments.context.appData['Driver Load data Listener (Upsert)'] = (generateUUID().long());
  ___arguments.context.appData['Driver Load data Listener (Delete)'] = (generateUUID().long());
  ___arguments.context.appData['Driver Load data Listener (Create)'] = (generateUUID().long());

  ;(function(whereClause) {
    const callback = async object => {
        console.log('Create');
    await Updated_Loads_Function();

    };

    const rtHandlers = Backendless.Data.of('Loads').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addCreateListener.apply(rtHandlers, options);

    getRTSubscriptions().add((getObjectProperty(___arguments.context.appData, 'Driver Load data Listener (Create)')), () => rtHandlers.removeCreateListener(callback));

  })((['TID = \'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')),'\''].join('')));

  ;(function(whereClause) {
    const callback = async object => {
        console.log('Delete');
    await Updated_Loads_Function();

    };

    const rtHandlers = Backendless.Data.of('Loads').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add((getObjectProperty(___arguments.context.appData, 'Driver Load data Listener (Delete)')), () => rtHandlers.removeDeleteListener(callback));

  })((['TID = \'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')),'\''].join('')));

  ;(function(whereClause) {
    const callback = async object => {
        console.log('Update');
    await Updated_Loads_Function();

    };

    const rtHandlers = Backendless.Data.of('Loads').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpdateListener.apply(rtHandlers, options);

    getRTSubscriptions().add((getObjectProperty(___arguments.context.appData, 'Driver Load data Listener (Update)')), () => rtHandlers.removeUpdateListener(callback));

  })((['TID = \'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')),'\''].join('')));

  ;(function(whereClause) {
    const callback = async object => {
        console.log('Upsert');
    await Updated_Loads_Function();

    };

    const rtHandlers = Backendless.Data.of('Loads').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add((getObjectProperty(___arguments.context.appData, 'Driver Load data Listener (Upsert)')), () => rtHandlers.removeUpsertListener(callback));

  })((['TID = \'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')),'\''].join('')));
    }

/**
 * Describe this function...
 */
async function Updated_Loads_Function() {
  delete (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))['Loads'];
  (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))['Loads'] = (await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['TID = \'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')),'\' AND (Status = \'Loaded\' OR Status = \'Planned\' OR Status = \'Transferred\' OR Status = \'Depot\')'].join(''))).setPageSize(100)));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b0080736167702cb4ed87a24dfa855b5', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b0080736167702cb4ed87a24dfa855b5', true);
}


  if ((await Backendless.UserService.isValidLogin()) == false) {
    try {
      await Backendless.UserService.logout();

    } catch (error) {
      console.log(error);

    }
    try {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

    } catch (error) {
      console.log(error);

    }
    try {
      ___arguments.context.pageData['Driver Load Data'] = ((await asyncListSort((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')), async (item) => {


       return ((getObjectProperty(item, 'Status')) != 'Delivered');
      })), 1, async (item) => {


       return (getObjectProperty(item, 'Action Date'));
      }))[0]);

    } catch (error) {
      console.log(error);

    }
  }
  await Listners();

  },
  /* handler:onEnter */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  try {
    getRTSubscriptions().remove((getObjectProperty(___arguments.context.appData, 'Driver Load data Listener (Update)')));

  } catch (error) {
    console.log(error);

  }
  try {
    getRTSubscriptions().remove((getObjectProperty(___arguments.context.appData, 'Driver Load data Listener (Upsert)')));

  } catch (error) {
    console.log(error);

  }
  try {
    getRTSubscriptions().remove((getObjectProperty(___arguments.context.appData, 'Driver Load data Listener (Delete)')));

  } catch (error) {
    console.log(error);

  }
  try {
    getRTSubscriptions().remove((getObjectProperty(___arguments.context.appData, 'Driver Load data Listener (Create)')));

  } catch (error) {
    console.log(error);

  }
  delete ___arguments.context.appData['Driver Load data Listner (Update)'];
  delete ___arguments.context.appData['Driver Load data Listner (Upsert)'];
  delete ___arguments.context.appData['Driver Load data Listener (Delete)'];
  delete ___arguments.context.appData['Driver Load data Listener (Create)'];

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/FIFDRIVER/components/472f5ad621b351ecc0e617abbbf5db28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))))) {
      Viewer = false;
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Step 2'))))) {
        Viewer = true;
      } else {
        Viewer = false;
      }
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/c0a720dca9745e7bf88988dadbbd0574/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  async ['InputLogic'](___arguments) {
    var Data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
  } else {
    if (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')) {
      Data = (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Odometer'));
    } else {
      Data = '';
    }
  }

  return Data

  },
  /* handler:InputLogic */
  /* content */
}))

define('./pages/FIFDRIVER/components/3fbcfc8d2ec80514cc990cd4ded32561/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  async ['InputLogic'](___arguments) {
    var Data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
  } else {
    if (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')) {
      Data = (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Ideal_Fuel_Consumption'));
    } else {
      Data = '';
    }
  }

  return Data

  },
  /* handler:InputLogic */
  /* content */
}))

define('./pages/FIFDRIVER/components/72746242d36862baaede6944556d15b4/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  async ['InputLogic'](___arguments) {
    var Data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))))) {
      Data = 0;
    } else {
      Data = (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Current_Fuel_Consumption_Last_5_Tanks'));
    }
  }

  return Data

  },
  /* handler:InputLogic */
  /* handler:MaxLogic */
  async ['MaxLogic'](___arguments) {
    var Data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))))) {
      Data = 0;
    } else {
      Data = (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Ideal_Fuel_Consumption')) * 1.05;
    }
  }

  return Data

  },
  /* handler:MaxLogic */
  /* handler:MinLogic */
  async ['MinLogic'](___arguments) {
    var Data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))))) {
      Data = 0;
    } else {
      Data = (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Ideal_Fuel_Consumption')) * 1.05;
    }
  }

  return Data

  },
  /* handler:MinLogic */
  /* handler:TargetLogic */
  async ['TargetLogic'](___arguments) {
    var Data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))))) {
      Data = 0;
    } else {
      Data = (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Ideal_Fuel_Consumption'));
    }
  }

  return Data

  },
  /* handler:TargetLogic */
  /* content */
}))

define('./pages/FIFDRIVER/components/9d7d2f1d8829a6f5190b3ace1411b5f7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var Data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['New Odometer'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFDRIVER/components/d4a91253b2e824f97819ec5ca944bf2f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'New Odometer'))))) {
        } else {
          if ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'New Odometer')) > (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Odometer')) + (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Tractor_Range')) || (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'New Odometer')) < (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Odometer'))) {
            Viewer = false;
          } else {
            Viewer = true;
          }
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Step 2'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/49d2d389fb2642edd5d6af26ce55bd73/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'New Odometer'))))) {
        } else {
          if ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'New Odometer')) > (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Odometer')) + (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Tractor_Range')) || (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'New Odometer')) < (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Odometer'))) {
            Viewer = true;
          } else {
            Viewer = false;
          }
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/de4f76bf8237c3e81ed17ba8989210e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))))) {
        Viewer = false;
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Step 2'))))) {
          Viewer = false;
        } else {
          Viewer = true;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/8246883d627f6fdb1cea1f1c18831707/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1'))))) {
          Viewer = false;
        } else {
          Viewer = true;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/18a68fcc34bc35687c588388d47dd774/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2'))))) {
          Viewer = false;
        } else {
          Viewer = true;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/705d7f614cfcc07c6a776417c0df79b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3'))))) {
          Viewer = false;
        } else {
          Viewer = true;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/ef167ac920154df2d9d21a092421893b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3'))))) {
          Viewer = true;
        } else {
          Viewer = false;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/880a6ea2e0b458feb01f5efbc87e01dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Board Truck Form - Is This Correct Select'))))) {
      } else {
        if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Board Truck Form - Is This Correct Select')) == 'Yes') {
          Viewer = false;
        } else {
          Viewer = true;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.value == 'None') {
    delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['T1'];
  } else {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['T1'] = ((await asyncListFilter((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1 Options List')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ___arguments.value);
    }))[0]);
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1 Options List'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'))))) {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))))) {
          Options = (addItemToList((await Promise.all((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1 Options List')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        } else {
          Options = (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1 Options List')), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        }
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))))) {
          Options = (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1 Options List')), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        } else {
          Options = (addItemToList((await Promise.all((await asyncListFilter((await asyncListFilter((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1 Options List')), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        }
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/43967ffb9228e9a1e4669df829d30e91/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Board Truck Form - Is This Correct Select'))))) {
      } else {
        if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Board Truck Form - Is This Correct Select')) == 'Yes') {
          Viewer = false;
        } else {
          Viewer = true;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2 Options List'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'))))) {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))))) {
          Options = (addItemToList((await Promise.all((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2 Options List')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        } else {
          Options = (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2 Options List')), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        }
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))))) {
          Options = (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2 Options List')), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        } else {
          Options = (addItemToList((await Promise.all((await asyncListFilter((await asyncListFilter((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2 Options List')), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        }
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.value == 'None') {
    delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['T2'];
  } else {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['T2'] = ((await asyncListFilter((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2 Options List')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ___arguments.value);
    }))[0]);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFDRIVER/components/ab36c4638d6ca39ce9bb1868ac1993dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Board Truck Form - Is This Correct Select'))))) {
      } else {
        if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Board Truck Form - Is This Correct Select')) == 'Yes') {
          Viewer = false;
        } else {
          Viewer = true;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3 Options List'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'))))) {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'))))) {
          Options = (addItemToList((await Promise.all((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3 Options List')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        } else {
          Options = (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3 Options List')), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        }
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'))))) {
          Options = (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3 Options List')), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        } else {
          Options = (addItemToList((await Promise.all((await asyncListFilter((await asyncListFilter((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3 Options List')), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        }
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.value == 'None') {
    delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['T3'];
  } else {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['T3'] = ((await asyncListFilter((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3 Options List')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ___arguments.value);
    }))[0]);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFDRIVER/components/768b7c3a672faf1c5041a9a9da389d8a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Tractor, error, j, Data_Modal_List, Driver_TX, item, Tractor_TX, Tractor_TX_Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

/**
 * Describe this function...
 */
async function Yes_Function() {
  Driver_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Driver_TX;

    (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details'))['Driver_Warehouse_Status'] = 'Out';
    try {
      replaceItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'objectId');

    } catch (error) {
      console.log(error);

    }
    Tractor['Warehouse'] = 'Out';
    Tractor['Odometer'] = (getObjectProperty(Tractor, 'New Odometer'));
    delete Tractor['New Odometer'];
    try {
      replaceItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'objectId');

    } catch (error) {
      console.log(error);

    }
    _uow.update('Employees', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details'))).setOpResultId('Driver Update Details');
    _uow.setRelation('Employees', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Driver_Tractor', Tractor).setOpResultId('Employee Tractor Set Operation');
    console.log('10');
    _uow.update('Tractors', Tractor).setOpResultId('Tractor Warehouse Update');
    _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Driver1', [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'objectId'))]).setOpResultId('Driver  Tractor Set Operation');

  })();

  console.log((await Driver_TX.execute().then(function(result) {
      const error = result && result.error

      if (error) {
        throw error
      }

    return result
    })));
  Data_Modal_List = (Object.keys(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')));
  for (var j_index in Data_Modal_List) {
    j = Data_Modal_List[j_index];
    try {
      delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')[j];

    } catch (error) {
      console.log(error);

    }
  }
  (getObjectProperty(___arguments.context.appData, 'User'))['Tractor'] = Tractor;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29c7859cd43d900430953e0bcbfce656', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('29c7859cd43d900430953e0bcbfce656', true);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('d9b3599f980657c8f696499e571be3fa');
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Clear_Function() {
  try {
    Tractor_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tractor_TX;

      try {
        (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1'))['Warehouse'] = 'In';
        (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1'))['Odometer'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1')), 'Odometer')) + ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'New Odometer')) - (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Odometer'))));
        replaceItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1')), 'objectId');
        console.log(getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1'));
        _uow.update('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1'))).setOpResultId('Trailer 1 Tractor Warehouse Operation');
        _uow.bulkUpsert('Tyres', [null, null, null]).setOpResultId('Trailer 1 Tyre Mileage Update Operation');

      } catch (error) {

      }
      try {
        (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2'))['Warehouse'] = 'In';
        (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2'))['Odometer'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2')), 'Odometer')) + ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'New Odometer')) - (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Odometer'))));
        replaceItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2')), 'objectId');
        _uow.update('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2'))).setOpResultId('Trailer 2 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3'))['Warehouse'] = 'In';
        (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3'))['Odometer'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3')), 'Odometer')) + ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'New Odometer')) - (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Odometer'))));
        replaceItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3')), 'objectId');
        _uow.update('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailer 3 Tractor WarehouseOperation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 1 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1'))).setOpResultId('Trailers Operation 1');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        Tractor_TX_Result = (await Tractor_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['Trailer1'] = null;
    (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['Trailer2'] = null;
    (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['Trailer3'] = null;

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}


  if (___arguments.value == 'No') {
    await Clear_Function();
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Board Truck Form - Is This Correct Select'] = ___arguments.value;
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['T1 Options List'] = (await asyncListFilter((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return (((getObjectProperty(item, 'Position')).indexOf('T1') !== -1) == true);
    })), async (item) => {


     return ((getObjectProperty(item, 'Warehouse')) == 'In');
    }));
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['T2 Options List'] = (await asyncListFilter((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return (((getObjectProperty(item, 'Position')).indexOf('T2') !== -1) == true);
    })), async (item) => {


     return ((getObjectProperty(item, 'Warehouse')) == 'In');
    }));
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['T3 Options List'] = (await asyncListFilter((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return (((getObjectProperty(item, 'Position')).indexOf('T3') !== -1) == true);
    })), async (item) => {


     return ((getObjectProperty(item, 'Warehouse')) == 'In');
    }));
  } else {
    console.log(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'));
    Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), ));
    console.log(Tractor);
    await Yes_Function();
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFDRIVER/components/e3b306e7abda0eda37fe7e962b4e7389/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Board Truck Form - Is This Correct Select'))))) {
      } else {
        if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Board Truck Form - Is This Correct Select')) == 'Yes') {
          Viewer = false;
        } else {
          Viewer = true;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Tractor_TX, Tractor_TX_Result, T1_TX, T1_TX_Result, Driver_TX;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function T4() {
  try {
    Tractor_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tractor_TX;

      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 1 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'))).setOpResultId('Trailers Operation 1');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'))).setOpResultId('Trailer 1 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        Tractor_TX_Result = (await Tractor_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['Trailer1'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'));

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}

/**
 * Describe this function...
 */
async function Clear_Function() {
  try {
    Tractor_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tractor_TX;

      try {
        _uow.setRelation('Employees', ((getObjectProperty(___arguments.context.appData, 'Details'))[0]), 'Driver_Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Employee Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Driver1', ((getObjectProperty(___arguments.context.appData, 'Details'))[0])).setOpResultId('Driver  Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 1 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1'))).setOpResultId('Trailers Operation 1');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        Tractor_TX_Result = (await Tractor_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    console.log(Tractor_TX_Result);

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}

/**
 * Describe this function...
 */
async function T1() {
  try {
    T1_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = T1_TX;

      console.log(getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'));
      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 1 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'))).setOpResultId('Trailers Operation 1');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'))).setOpResultId('Trailer 1 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        T1_TX_Result = (await T1_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['Trailer1'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'));

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}

/**
 * Describe this function...
 */
async function T2() {
  try {
    Tractor_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tractor_TX;

      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Employees', ((getObjectProperty(___arguments.context.appData, 'Details'))[0]), 'Driver_Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Employee Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Driver1', ((getObjectProperty(___arguments.context.appData, 'Details'))[0])).setOpResultId('Driver  Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'))).setOpResultId('Trailer 2 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        Tractor_TX_Result = (await Tractor_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    console.log(Tractor_TX_Result);
    (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['Trailer2'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'));

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}

/**
 * Describe this function...
 */
async function T3() {
  try {
    Tractor_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tractor_TX;

      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Employees', ((getObjectProperty(___arguments.context.appData, 'Details'))[0]), 'Driver_Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Employee Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Driver1', ((getObjectProperty(___arguments.context.appData, 'Details'))[0])).setOpResultId('Driver  Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))).setOpResultId('Trailer 3 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        Tractor_TX_Result = (await Tractor_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    console.log(Tractor_TX_Result);
    (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['Trailer3'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'));

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}

/**
 * Describe this function...
 */
async function T1T2() {
  try {
    Tractor_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tractor_TX;

      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 1 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Employees', ((getObjectProperty(___arguments.context.appData, 'Details'))[0]), 'Driver_Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Employee Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Driver1', ((getObjectProperty(___arguments.context.appData, 'Details'))[0])).setOpResultId('Driver  Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'))).setOpResultId('Trailers Operation 1');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'))).setOpResultId('Trailer 1 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'))).setOpResultId('Trailer 2 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        Tractor_TX_Result = (await Tractor_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    console.log(Tractor_TX_Result);
    (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['Trailer1'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'));
    (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['Trailer2'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'));

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}

/**
 * Describe this function...
 */
async function T1T3() {
  try {
    Tractor_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tractor_TX;

      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Employees', ((getObjectProperty(___arguments.context.appData, 'Details'))[0]), 'Driver_Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Employee Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Driver1', ((getObjectProperty(___arguments.context.appData, 'Details'))[0])).setOpResultId('Driver  Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 1 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'))).setOpResultId('Trailers Operation 1');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'))).setOpResultId('Trailer 1 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))).setOpResultId('Trailer 3 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        Tractor_TX_Result = (await Tractor_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    console.log(Tractor_TX_Result);
    (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['Trailer1'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'));
    (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['Trailer3'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'));

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}

/**
 * Describe this function...
 */
async function T2T3() {
  try {
    Tractor_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tractor_TX;

      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Employees', ((getObjectProperty(___arguments.context.appData, 'Details'))[0]), 'Driver_Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Employee Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Driver1', ((getObjectProperty(___arguments.context.appData, 'Details'))[0])).setOpResultId('Driver  Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3', (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'))).setOpResultId('Trailer 2 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))).setOpResultId('Trailer 3 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        Tractor_TX_Result = (await Tractor_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    console.log(Tractor_TX_Result);
    (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['Trailer2'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'));
    (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['Trailer3'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'));

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}

/**
 * Describe this function...
 */
async function T1T2T3() {
  try {
    Tractor_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tractor_TX;

      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 1 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Employees', ((getObjectProperty(___arguments.context.appData, 'Details'))[0]), 'Driver_Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Employee Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Driver1', ((getObjectProperty(___arguments.context.appData, 'Details'))[0])).setOpResultId('Driver  Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3')), 'Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'))).setOpResultId('Trailers Operation 1');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'))).setOpResultId('Trailer 1 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'))).setOpResultId('Trailer 2 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))).setOpResultId('Trailer 3 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        Tractor_TX_Result = (await Tractor_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    console.log(Tractor_TX_Result);
    (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['Trailer1'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'));
    (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['Trailer2'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'));
    (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['Trailer3'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'));

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

/**
 * Describe this function...
 */
async function Driver_Board() {
  try {
    Driver_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Driver_TX;

      try {
        ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details'))[0])['Driver_Warehouse_Status'] = 'Out';
        replaceItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details'))[0]), 'objectId');
        _uow.update('Employees', ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details'))[0])).setOpResultId('Driver Update Details');
        console.log('Raymond');
        try {
          _uow.setRelation('Employees', ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details'))[0]), 'Driver_Tractor', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Employee Tractor Set Operation');

        } catch (error) {

        }

      } catch (error) {
        console.log(error);

      }
      try {
        (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['Warehouse'] = 'Out';
        (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['Odometer'] = (getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'New Odometer'));
        (getObjectProperty(___arguments.context.appData, 'User'))['Tractor'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'));
        delete (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['New Odometer'];
        replaceItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'objectId');
        _uow.update('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))).setOpResultId('Tractor Warehouse Update');
        try {
          _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Driver1', ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details'))[0])).setOpResultId('Driver  Tractor Set Operation');

        } catch (error) {

        }

      } catch (error) {
        console.log(error);

      }
      console.log(___arguments.context.appData);
      console.log((await Driver_TX.execute()));

    })();


  } catch (error) {
    console.log(error);

  }
}

/**
 * Describe this function...
 */
async function Reset_Function() {
  delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Board Truck Form'];
  delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Board Truck Form - Is This Correct Select'];
  delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Selected Tractor'];
  delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Step 2'];
  delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['T1'];
  delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['T1 Options List'];
  delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['T2'];
  delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['T2 Options List'];
  delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['T3'];
  delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['T3 Options List'];
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('d9b3599f980657c8f696499e571be3fa');
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))))) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3'))))) {
    } else {
      await Clear_Function();
    }
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))))) {
    await T1();
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'))))) {
    await T3();
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))))) {
    await T2();
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T1'))))) {
    await T2T3();
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T2'))))) {
    await T1T3();
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'T3'))))) {
    await T1T2();
  } else {
    await T1T2T3();
  }
  await Driver_Board();
  await Reset_Function();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/38ee6f8d945dea3dc312000ced5e28ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Conent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1'))))) {
      Conent = '';
    } else {
      Conent = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer1')), 'Registration'));
    }
  }

  return Conent

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/d09e53c1b7be2fdfa467e287d94d9c5d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Conent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2'))))) {
      Conent = '';
    } else {
      Conent = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer2')), 'Registration'));
    }
  }

  return Conent

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/1915977f1eae041d2b44eb55ed7f86b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Conent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3'))))) {
      Conent = '';
    } else {
      Conent = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Trailer3')), 'Registration'));
    }
  }

  return Conent

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/103b618512126396d5c67c94cbe42ddd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Driver_TX;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

/**
 * Describe this function...
 */
async function Driver_Disembark() {
  Driver_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  console.log('abc');
  await ( async () => {
    const _uow = Driver_TX;

    (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details'))['Driver_Warehouse_Status'] = 'In';
    replaceItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'objectId');
    _uow.update('Employees', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details'))).setOpResultId('Driver Update Details');
    _uow.deleteRelation('Employees', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'objectId')), 'Driver_Tractor', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))).setOpResultId('Employee Tractor Delete Operation');
    (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))['Warehouse'] = 'In';
    (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))['Odometer'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Odometer'));
    replaceItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId');
    _uow.update('Tractors', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))).setOpResultId('Tractor Warehouse Update');
    _uow.deleteRelation('Tractors', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')), 'Driver1', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details'))).setOpResultId('Driver  Tractor Delete Operation');
    delete (getObjectProperty(___arguments.context.appData, 'User'))['Tractor'];

  })();

  console.log((await Driver_TX.execute()));
}


  await Driver_Disembark();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('966a129f2cd2f463dfeda026bb1c78d4');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Odometer'))))) {
      } else {
        if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')) > (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Odometer')) + (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Tractor_Range')) || (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Odometer')) < (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer'))) {
          Viewer = false;
        } else {
          Viewer = true;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/31b31bf4fb6ad868fd8f7a095736cb11/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Odometer'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFDRIVER/components/6386c56cc6452214be2d4c5f8d6df49f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Odometer'))))) {
      } else {
        if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')) > (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Odometer')) + (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Tractor_Range')) || (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Odometer')) < (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer'))) {
          Viewer = true;
        } else {
          Viewer = false;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/eb53601ff966c1b512d22c1a51985d7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Mileage_Differential, Axles, Ideal_Station, Fuel, Geo_Location, Ideal_Stations_Price, Distance, error, Transaction_Step_2, Transaction_Step_2___Tractor, Fuel_Transaction, Transaction_Step_2___Fuel, Transaction_Step_1, Fleetview_Current;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function New_Approach() {
  Mileage_Differential = (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer')) - (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer'));
  (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))['Odometer'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer'));
  Geo_Location = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
  try {
    Ideal_Stations_Price = (getObjectProperty(((await asyncListSort((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Ideal Stations')), 1, async (item) => {


     return (getObjectProperty(item, 'Distance'));
    }))[0]), 'Price'));

  } catch (error) {
    console.log(error);

  }
  try {
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Garage - Other')) == true) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Ideal_Station))) {
        Ideal_Station = null;
      } else {
        Ideal_Station = Ideal_Station;
      }
    } else {
      Ideal_Station = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('f0fa2fe615f648ca24bac5d98baac028'));
    }

  } catch (error) {
    console.log(error);

  }
  try {
    Distance = (getObjectProperty(((await asyncListSort((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Ideal Stations')), 1, async (item) => {


     return (getObjectProperty(item, 'Distance'));
    }))[0]), 'Distance'));

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Distance = 0;
    }

  }
  Fuel = ({ [`TObjectID`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')),[`Cost`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Cost')),[`Closest_Station_Distance`]: Distance,[`Description`]: (new Date()),[`Fuel_Consumption_Ideal`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Fuel_Consumption')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Fuel_Consumption')),[`Fuel_Count`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))),[`Fuel_Price_Per_Litre_Ideal`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Ideal Stations')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListSort((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Ideal Stations')), 1, async (item) => {


   return (getObjectProperty(item, 'Distance'));
  }))[0]))) ? null : Ideal_Stations_Price),[`Image`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Image')),[`Litres`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Litres')),[`Location_Submitted`]: (new Backendless.Data.Point().setX((getObjectProperty(Geo_Location, 'lng'))).setY((getObjectProperty(Geo_Location, 'lat')))),[`Mileage`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer')),[`Mileage_last`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Last_Fuel_Transaction_Mileage')),[`Station_Unknown`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Garage - Other')) == true ? (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Garage')) : null,[`Wages_Contractor_Km_Rate`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Wages_Rate_Contractor_Mileage')),[`Wages_Good_Driving_Rate`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Wages_Rate_Good_Driving')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'ownerId')) });
  Axles = (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Axles_Data')))) ? [] : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Axles_Data'))).concat((((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')))) ? [] : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Axles_Data')))) ? [] : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Axles_Data')))).concat((((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')))) ? [] : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Axles_Data')))) ? [] : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Axles_Data')))).concat(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')))) ? [] : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Axles_Data')))) ? [] : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Axles_Data'))))))))));
  (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))['Last_Fuel_Transaction_Mileage'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer'));
  console.log((await BackendlessUI.Functions.Custom['fn_42bc76f837a963e74c557b0fdf2ce4e3']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), Fuel, ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Garage - Other')) == true), Ideal_Station, (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), Axles, Mileage_Differential)));
  if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Service_Status')) == 'All In Order') {
  } else {
    console.log((await Backendless.Messaging.sendEmail((['Service Notice for (',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Registration')),')'].join('')), new Backendless.Bodyparts({ textmessage: (['To Whom it may concern,','\n\nPlease note Vehicle (',[(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), ' ID')),' - ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Registration'))].join(''),') is due for service. \n \nThe current mileage/hours is ',(getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer')),'.','\n\nCompany:\t\t',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')),'\nContact:\t\t',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Name')),'\nNumber:\t\t',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Phone')),'\n\nMake:\t\t',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Make')),'\nModel:\t\t',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Model')),'\nVIN:\t\t',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'VIN')),'\n\nKind Regards, \nThe Fleet In Form Team','\n\nPlease note this email address is not attended.'].join('')) }), ensureArray((await asyncListFilter([(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Email')), 'raymondewoodley@gmail.com', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Email_Admin')), (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Mechanic_Email')), (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Company_Third_Party_Mechanic_Email'))], async (item) => {


     return (!(item === null));
    }))), undefined)));
  }
}

/**
 * Describe this function...
 */
async function Old_Approach() {
  Mileage_Differential = (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer')) - (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer'));
  Geo_Location = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
  try {
    Ideal_Stations_Price = (getObjectProperty(((await asyncListSort((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Ideal Stations')), 1, async (item) => {


     return (getObjectProperty(item, 'Distance'));
    }))[0]), 'Price'));

  } catch (error) {
    console.log(error);

  }
  Fuel = ({ [`TObjectID`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')),[`Cost`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Cost')),[`Closest_Station_Distance`]: (getObjectProperty(((await asyncListSort((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Ideal Stations')), 1, async (item) => {


   return (getObjectProperty(item, 'Distance'));
  }))[0]), 'Distance')),[`Description`]: (new Date()),[`Fuel_Consumption_Ideal`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Fuel_Consumption')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Fuel_Consumption')),[`Fuel_Count`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))),[`Fuel_Price_Per_Litre_Ideal`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Ideal_Stations_Price)) ? null : Ideal_Stations_Price,[`Image`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Image')),[`Litres`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Litres')),[`Location_Submitted`]: (new Backendless.Data.Point().setX((getObjectProperty(Geo_Location, 'lng'))).setY((getObjectProperty(Geo_Location, 'lat')))),[`Mileage`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer')),[`Mileage_last`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Last_Fuel_Transaction_Mileage')),[`Station_Unknown`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Garage - Other')) == true ? (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Garage')) : null,[`Wages_Contractor_Km_Rate`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Wages_Rate_Contractor_Mileage')),[`Wages_Good_Driving_Rate`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Wages_Rate_Good_Driving')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'ownerId')) });
  Fleetview_Current = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fleetview_Current'));
  Fleetview_Current['Current_Mileage'] = (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer'));
  Fleetview_Current['Distance_Travelled'] = ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Fleetview_Current, 'Distance_Travelled')))) ? (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer')) - (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Last_Fuel_Transaction_Mileage')) : (getObjectProperty(Fleetview_Current, 'Distance_Travelled')) + ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer')) - (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Last_Fuel_Transaction_Mileage'))));
  Fleetview_Current['Fuel_Cost'] = ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Fleetview_Current, 'Fuel_Cost')))) ? (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Cost')) : (Number((getObjectProperty(Fleetview_Current, 'Fuel_Cost')))) + (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Cost')));
  Fleetview_Current['Fuel_Litres'] = ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Fleetview_Current, 'Fuel_Litres')))) ? (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Litres')) : (getObjectProperty(Fleetview_Current, 'Fuel_Litres')) + (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Litres')));
  Object.assign((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), ({ [`Now`]: (new Date()),[`Odometer`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer')),[`Last_Fuel_Transaction_Mileage`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer')),[`Fuel_Counter`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))) }));
  Fuel_Transaction = (await Backendless.Data.of('Fuel').save( Fuel ));
  Transaction_Step_1 = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction_Step_1;

    _uow.upsert('Tractors', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')));
    _uow.addToRelation('Tractors', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel', [Fuel_Transaction]);
    _uow.setRelation('Tractors', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Last', [Fuel_Transaction]);
    _uow.addToRelation('Employees', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Driver_Transactions_Fuel', [Fuel_Transaction]);
    _uow.setRelation('Fuel', Fuel_Transaction, 'Company', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')));
    _uow.setRelation('Fuel', Fuel_Transaction, 'Tractor', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')));
    _uow.addToRelation('Fuel', Fuel_Transaction, 'Driver', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')));
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Garage - Other')) == true) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListSort((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Ideal Stations')), 1, async (item) => {


       return (getObjectProperty(item, 'Distance'));
      }))[0])))) {
      } else {
        _uow.addToRelation('Fuel', Fuel_Transaction, 'Station_correct', ((await asyncListSort((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Ideal Stations')), 1, async (item) => {


         return (getObjectProperty(item, 'Distance'));
        }))[0]));
      }
    } else {
      _uow.addToRelation('Fuel', Fuel_Transaction, 'Station_correct', [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('f0fa2fe615f648ca24bac5d98baac028'))]);
    }

  })();

  Transaction_Step_2 = (await Transaction_Step_1.execute());
  Transaction_Step_2___Fuel = Fuel_Transaction;
  Transaction_Step_2___Tractor = (getObjectProperty((getObjectProperty((getObjectProperty(Transaction_Step_2, 'results')), 'upsertTractors1')), 'result'));
}

/**
 * Describe this function...
 */
async function Clear_Form_Function() {
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Geo - Loction'];
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Ideal Stations'];
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Cost'];
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Garage'];
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Image'];
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Litres'];
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Odometer'];
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb53601ff966c1b512d22c1a51985d7a'))['disabled'] = true;
  if (false) {
    await Old_Approach();
  } else {
    await New_Approach();
  }
  await Clear_Form_Function();
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb53601ff966c1b512d22c1a51985d7a'))['disabled'] = false;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('76945b97db95226206c71b41243153cc', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Garage')) === null) || (typeof (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Garage')) === 'undefined') || ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Cost')) === null) || (typeof (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Cost')) === 'undefined') || ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Litres')) === null) || (typeof (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Litres')) === 'undefined')) {
      Viewer = false;
    } else {
      Viewer = true;
    }

  } catch (error) {
    console.log(error);

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/0471fb9e6c254cb904dad6d30db4d2b7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Odometer'))))) {
      } else {
        if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Odometer')) > (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')) + (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Tractor_Range')) || (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Odometer')) < (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer'))) {
          Viewer = true;
        } else {
          Viewer = false;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/055534791c51155e44e67b9441b9f781/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Odometer'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'imei'))))) {
    Viewer = true;
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Tracking Live'))[0]), 'can.vehicle.mileage'))))) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
      console.log(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'));

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/FIFDRIVER/components/8928187c736fbf61492556ee2d353897/bundle.js', [], () => ({
  /* content */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    var fileExt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split('.').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['users/',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'/','FuelImages'].join(''))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Check_Frequency')) == (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) + 1) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer'))))) {
        } else {
          if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer')) > (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')) + (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Tractor_Range')) || (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer')) < (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer'))) {
            Viewer = false;
          } else {
            Viewer = true;
          }
        }
      }
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/8f36f35f6c19286bc911bf5ed708c884/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Geo - Loction'] = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Ideal Stations'] = (await asyncListSort((await asyncListFilter((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')).map(async item => {  item['Distance'] = (await BackendlessUI.Functions.Custom['fn_24a626fc74c34a9805e7999658bdcfd6']((getObjectProperty(item, 'Location')), (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Geo - Loction'))));
  ; return item;}))), async (item) => {


   return ((getObjectProperty(item, 'Distance')) < 500000);
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Distance'));
  }));
  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Closest Station'] = ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Ideal Stations'))[0]);
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'imei'))))) {
  } else {
    ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Odometer'] = (getObjectProperty(((await BackendlessUI.Functions.Custom['fn_f93a70853ae43c949fdb97c43719532e']([(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Device ID'))]))[0]), 'can.vehicle.mileage'));
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/FIFDRIVER/components/f0fa2fe615f648ca24bac5d98baac028/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var List, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Ideal Stations'))))) {
      } else {
        List = (await Promise.all((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Ideal Stations')).map(async item => {; return ({ [`label`]: [(getObjectProperty(item, 'Town')),' - ',(getObjectProperty(item, 'Station_Name')),' (',(getObjectProperty(item, 'Brand')),')'].join(''),[`value`]: (getObjectProperty(item, 'objectId')) });})));
        addItemToList(List, ({ [`label`]: 'Other',[`value`]: 'Other' }));
      }
    }

  } catch (error) {

  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Ideal Stations')).length > 0) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {
    console.log(error);

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    if (___arguments.value == 'Other') {
      ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Garage - Other'] = true;
    } else {
      ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Garage'] = (getObjectProperty(((await asyncListFilter((await Promise.all((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Ideal Stations')).map(async item => {; return ({ [`label`]: [(getObjectProperty(item, 'Town')),' - ',(getObjectProperty(item, 'Station_Name')),' (',(getObjectProperty(item, 'Brand')),')'].join(''),[`value`]: (getObjectProperty(item, 'objectId')) });}))), async (item) => {


       return ((getObjectProperty(item, 'value')) == ___arguments.value);
      }))[0]), 'label'));
      delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Garage - Other'];
    }

  } catch (error) {

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFDRIVER/components/6b2c6c7ec319aefeb42ef242d1e38dc7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Check_Frequency')) == (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter')) + 1) {
      console.log('1');
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')))) {
        console.log('2');
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Image'))))) {
          console.log('3');
          Viewer = true;
        } else {
          console.log('4');
          Viewer = false;
        }
      }
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer'))))) {
        console.log('5');
        Viewer = true;
      } else {
        Viewer = true;
        console.log('6');
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/9b38d14d4ada8ea70df913c5d77d59a9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Ideal Stations')).length > 0) {
      if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Garage - Other')) == true) {
        Viewer = true;
      } else {
        Viewer = false;
      }
    } else {
      Viewer = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/f376e0d6b9ab0dc5b1358a6bf6fb8b33/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function mathMean(myList) {
  return myList.reduce(function(x, y) {return x + y;}) / myList.length;
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  console.log([mathMean(await Promise.all(((await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Fuel')), 1, async (item) => {


   return (getObjectProperty(item, 'created'));
  })).slice(0, 10)[0]).map(async item => {; return ((getObjectProperty(item, 'Fuel_Consumption_Actual')) / (getObjectProperty(item, 'Fuel_Consumption_Ideal')) >= 1.5 ? 0 : ((getObjectProperty(item, 'Fuel_Consumption_Actual')) / (getObjectProperty(item, 'Fuel_Consumption_Ideal')) <= 0.9 ? 0 : ((getObjectProperty(item, 'Fuel_Consumption_Actual')) / (getObjectProperty(item, 'Fuel_Consumption_Ideal'))) * 5));}))), mathMean(await Promise.all(((await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Fuel')), 1, async (item) => {


   return (getObjectProperty(item, 'created'));
  })).slice(0, 10)[0]).map(async item => {; return ((getObjectProperty(item, 'Fuel_Price_Per_Litre_Actual')) / (getObjectProperty(item, 'Fuel_Price_Per_Litre_Ideal')) >= 1.5 ? 0 : ((getObjectProperty(item, 'Fuel_Price_Per_Litre_Actual')) / (getObjectProperty(item, 'Fuel_Price_Per_Litre_Ideal')) <= 0.9 ? 0 : ((getObjectProperty(item, 'Fuel_Price_Per_Litre_Actual')) / (getObjectProperty(item, 'Fuel_Price_Per_Litre_Ideal'))) * 5));}))), ((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Fuel')).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;}) / ((new Date((new Date())).getDate()) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate()))) / (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Target Mileage')), (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Target Tonnage')) / ((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Loads')).map(async item => {; return (getObjectProperty(item, 'Tonnage_Loaded'));}))).reduce(function(x, y) {return x + y;}) / ((new Date((new Date())).getDate()) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate()))), mathMean(await Promise.all(((await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Loads')), 1, async (item) => {


   return (getObjectProperty(item, 'created'));
  })).slice(0, 10)[0]).map(async item => {; return ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tonnage_Planned')))) ? ((getObjectProperty(item, 'Tonnage_Delivered')) / (getObjectProperty(item, 'Rig_Payload')) >= 1.5 ? 0 : ((getObjectProperty(item, 'Tonnage_Delivered')) / (getObjectProperty(item, 'Rig_Payload')) <= 0.9 ? 0 : ((getObjectProperty(item, 'Tonnage_Delivered')) / (getObjectProperty(item, 'Rig_Payload'))) * 5)) : ((getObjectProperty(item, 'Tonnage_Delivered')) / (getObjectProperty(item, 'Tonnage_Planned')) >= 1.5 ? 0 : ((getObjectProperty(item, 'Tonnage_Delivered')) / (getObjectProperty(item, 'Tonnage_Planned')) <= 0.9 ? 0 : ((getObjectProperty(item, 'Tonnage_Delivered')) / (getObjectProperty(item, 'Tonnage_Planned'))) * 5)));})))].reduce(function(x, y) {return x + y;}));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/68c155d83df98ee44433d316e5a125d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Loads, x, Tag;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function do_something(Loads, Tag) {
  if (false) {
  }
}


  console.log(await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')), async (item) => {


   return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'ID')))));
  }));
  console.log((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).length == 0 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' ','00001'].join('') : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


   return item;
  }))[0]))) ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' ','00001'].join('') : ((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


   return item;
  }))[0] >= 10 ? ((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


   return item;
  }))[0] >= 100 ? ((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


   return item;
  }))[0] >= 1000 ? ((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


   return item;
  }))[0] >= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' ',(await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


   return item;
  }))[0] + 1].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' 0',(await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


   return item;
  }))[0] + 1].join('')) : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' 00',(await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


   return item;
  }))[0] + 1].join('')) : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' 000',(await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


   return item;
  }))[0] + 1].join('')) : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' 0000',(await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


   return item;
  }))[0] + 1].join(''))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/87b992a69347e6be8c14a1983a924359/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var error, Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Registration'));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/7ff68bcda9b24121b502974e445482e5/bundle.js', [], () => ({
  /* content */
  /* handler:defaultValue */
  async ['defaultValue'](___arguments) {
    var Return, error, Input, item;

function mathMean(myList) {
  return myList.reduce(function(x, y) {return x + y;}) / myList.length;
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    Input = mathMean([mathMean(await Promise.all(((await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Fuel')), 1, async (item) => {


     return (getObjectProperty(item, 'created'));
    })).slice(0, 10)[0]).map(async item => {; return ((getObjectProperty(item, 'Fuel_Consumption_Actual')) / (getObjectProperty(item, 'Fuel_Consumption_Ideal')) >= 1.5 ? 0 : ((getObjectProperty(item, 'Fuel_Consumption_Actual')) / (getObjectProperty(item, 'Fuel_Consumption_Ideal')) <= 0.9 ? 0 : ((getObjectProperty(item, 'Fuel_Consumption_Actual')) / (getObjectProperty(item, 'Fuel_Consumption_Ideal'))) * 5));}))), mathMean(await Promise.all(((await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Fuel')), 1, async (item) => {


     return (getObjectProperty(item, 'created'));
    })).slice(0, 10)[0]).map(async item => {; return ((getObjectProperty(item, 'Fuel_Price_Per_Litre_Actual')) / (getObjectProperty(item, 'Fuel_Price_Per_Litre_Ideal')) >= 1.5 ? 0 : ((getObjectProperty(item, 'Fuel_Price_Per_Litre_Actual')) / (getObjectProperty(item, 'Fuel_Price_Per_Litre_Ideal')) <= 0.9 ? 0 : ((getObjectProperty(item, 'Fuel_Price_Per_Litre_Actual')) / (getObjectProperty(item, 'Fuel_Price_Per_Litre_Ideal'))) * 5));}))), ((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Fuel')).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;}) / ((new Date((new Date())).getDate()) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate()))) / (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Target Mileage')), (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Target Tonnage')) / ((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Loads')).map(async item => {; return (getObjectProperty(item, 'Tonnage_Loaded'));}))).reduce(function(x, y) {return x + y;}) / ((new Date((new Date())).getDate()) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate()))), mathMean(await Promise.all(((await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Loads')), 1, async (item) => {


     return (getObjectProperty(item, 'created'));
    })).slice(0, 10)[0]).map(async item => {; return ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tonnage_Planned')))) ? ((getObjectProperty(item, 'Tonnage_Delivered')) / (getObjectProperty(item, 'Rig_Payload')) >= 1.5 ? 0 : ((getObjectProperty(item, 'Tonnage_Delivered')) / (getObjectProperty(item, 'Rig_Payload')) <= 0.9 ? 0 : ((getObjectProperty(item, 'Tonnage_Delivered')) / (getObjectProperty(item, 'Rig_Payload'))) * 5)) : ((getObjectProperty(item, 'Tonnage_Delivered')) / (getObjectProperty(item, 'Tonnage_Planned')) >= 1.5 ? 0 : ((getObjectProperty(item, 'Tonnage_Delivered')) / (getObjectProperty(item, 'Tonnage_Planned')) <= 0.9 ? 0 : ((getObjectProperty(item, 'Tonnage_Delivered')) / (getObjectProperty(item, 'Tonnage_Planned'))) * 5)));})))]);
    if (Input >= 5) {
      Return = 5;
    } else if (Input >= 4.5) {
      Return = 4.5;
    } else if (Input >= 4) {
      Return = 4;
    } else if (Input >= 3.5) {
      Return = 3.5;
    } else if (Input >= 3) {
      Return = 3;
    } else if (Input >= 2.5) {
      Return = 2.5;
    } else if (Input >= 2) {
      Return = 2;
    } else if (Input >= 1.5) {
      Return = 1.5;
    } else if (Input >= 1) {
      Return = 1;
    } else if (Input > 0.5) {
      Return = 0.5;
    } else if (Input >= 0) {
      Return = 0;
    }

  } catch (error) {

  } finally {
    if (error) {
      Return = 0;
    }

  }

  return Return

  },
  /* handler:defaultValue */
  /* content */
}))

define('./pages/FIFDRIVER/components/c745b9b9a881211408f6f151b0fbd23a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var error, Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Employee_Details_Nickname'));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/a51352629d749c499699c86e27b2c76e/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  ['InputLogic'](___arguments) {
    var error, Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Fuel_Consumption'));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:InputLogic */
  /* content */
}))

define('./pages/FIFDRIVER/components/4e476e8d18ea296d71c2ebc2e50f3506/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  async ['InputLogic'](___arguments) {
    var error, Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload_Override')))) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload_Override'));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:InputLogic */
  /* content */
}))

define('./pages/FIFDRIVER/components/e11ac67c7e68cfc64f3cffaaab3b6385/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  ['InputLogic'](___arguments) {
    var error, Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Wages_Rate_Target_Mileage'));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:InputLogic */
  /* content */
}))

define('./pages/FIFDRIVER/components/6015b092e796ee7f4bbe85fe8216bb35/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  ['InputLogic'](___arguments) {
    var error, Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Wages_Rate_Target_Tonnage'));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:InputLogic */
  /* content */
}))

define('./pages/FIFDRIVER/components/f2a9d3eb88332c656f4ff41bb27736e9/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  ['InputLogic'](___arguments) {
    var Input, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Fleetview Current')), 'Fuel_Consumption_5Tanks'));

  } catch (error) {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:InputLogic */
  /* handler:TargetLogic */
  ['TargetLogic'](___arguments) {
    var Input, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Fleetview Current')), 'Fuel_Consumption_Ideal'));

  } catch (error) {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:TargetLogic */
  /* handler:MaxLogic */
  ['MaxLogic'](___arguments) {
    var Input, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Fleetview Current')), 'Fuel_Consumption_Ideal')) * 1.5;

  } catch (error) {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:MaxLogic */
  /* handler:MinLogic */
  ['MinLogic'](___arguments) {
    var Input, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Fleetview Current')), 'Fuel_Consumption_Ideal')) * 0.9;

  } catch (error) {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:MinLogic */
  /* content */
}))

define('./pages/FIFDRIVER/components/d52a9f975bb874b83b5113aff4cba2f8/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  async ['InputLogic'](___arguments) {
    var error, Input, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Fuel')).map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;});

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:InputLogic */
  /* handler:TargetLogic */
  ['TargetLogic'](___arguments) {
    var error, Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Target Mileage')).reduce(function(x, y) {return x + y;}) * ((new Date((new Date())).getDate()) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate()));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:TargetLogic */
  /* handler:MaxLogic */
  ['MaxLogic'](___arguments) {
    var error, Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Target Mileage')).reduce(function(x, y) {return x + y;}) * ((new Date((new Date())).getDate()) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * 1.5;

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:MaxLogic */
  /* handler:MinLogic */
  ['MinLogic'](___arguments) {
    var error, Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Target Mileage')).reduce(function(x, y) {return x + y;}) * ((new Date((new Date())).getDate()) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * 0.9;

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:MinLogic */
  /* content */
}))

define('./pages/FIFDRIVER/components/a13ab328301723eac88dbe65136a662b/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  async ['InputLogic'](___arguments) {
    var error, Input, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Loads')).map(async item => {; return (getObjectProperty(item, 'Tonnage_Loaded'));}))).reduce(function(x, y) {return x + y;}) / 1000;

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:InputLogic */
  /* handler:TargetLogic */
  ['TargetLogic'](___arguments) {
    var error, Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Target Tonnage')) * ((new Date((new Date())).getDate()) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate()))) / 1000;

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:TargetLogic */
  /* handler:MaxLogic */
  ['MaxLogic'](___arguments) {
    var error, Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Target Tonnage')) * ((new Date((new Date())).getDate()) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * 1.5) / 1000;

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:MaxLogic */
  /* handler:MinLogic */
  ['MinLogic'](___arguments) {
    var error, Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Target Tonnage')) * ((new Date((new Date())).getDate()) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * 0.9) / 1000;

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:MinLogic */
  /* content */
}))

define('./pages/FIFDRIVER/components/3e6dc426e5d319f513dc4151c63105cc/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  async ['InputLogic'](___arguments) {
    var error, Input, item;

function mathMean(myList) {
  return myList.reduce(function(x, y) {return x + y;}) / myList.length;
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    Input = mathMean(await Promise.all(((await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Loads')), 1, async (item) => {


     return (getObjectProperty(item, 'created'));
    })).slice(0, 10)[0]).map(async item => {; return (getObjectProperty(item, 'Tonnage_Delivered'));})));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:InputLogic */
  /* handler:TargetLogic */
  async ['TargetLogic'](___arguments) {
    var error, Input, item;

function mathMean(myList) {
  return myList.reduce(function(x, y) {return x + y;}) / myList.length;
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    Input = mathMean(await Promise.all(((await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Loads')), 1, async (item) => {


     return (getObjectProperty(item, 'created'));
    })).slice(0, 10)[0]).map(async item => {; return ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tonnage_Planned')))) ? (getObjectProperty(item, 'Rig_Payload')) : (getObjectProperty(item, 'Tonnage_Planned')));}))) / 1000;

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:TargetLogic */
  /* handler:MaxLogic */
  async ['MaxLogic'](___arguments) {
    var error, Input, item;

function mathMean(myList) {
  return myList.reduce(function(x, y) {return x + y;}) / myList.length;
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    Input = (mathMean(await Promise.all(((await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Loads')), 1, async (item) => {


     return (getObjectProperty(item, 'created'));
    })).slice(0, 10)[0]).map(async item => {; return ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tonnage_Planned')))) ? (getObjectProperty(item, 'Rig_Payload')) : (getObjectProperty(item, 'Tonnage_Planned')));}))) + (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), ' Load_Tolerance'))) / 1000;

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:MaxLogic */
  /* handler:MinLogic */
  async ['MinLogic'](___arguments) {
    var error, Input, item;

function mathMean(myList) {
  return myList.reduce(function(x, y) {return x + y;}) / myList.length;
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    Input = (mathMean(await Promise.all(((await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Loads')), 1, async (item) => {


     return (getObjectProperty(item, 'created'));
    })).slice(0, 10)[0]).map(async item => {; return ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tonnage_Planned')))) ? (getObjectProperty(item, 'Rig_Payload')) : (getObjectProperty(item, 'Tonnage_Planned')));}))) - (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), ' Load_Tolerance'))) / 1000;

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:MinLogic */
  /* content */
}))

define('./pages/FIFDRIVER/components/57bfcef9eb1f9781075537034162bafa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Location, PDF, Transaction, ESP_Result, item, ESP_s, Distance, j, error, Emegency_Contact_List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function ESP() {
  ___arguments.context.appData['ESP\'s'] = (getObjectProperty((getObjectProperty(ESP_Result, 'opResult')), 'result'));
  ESP_s = (getObjectProperty((await BackendlessUI.Functions.Custom['fn_ad96c6069277798e0c016698de7c2be1'](({ [`lat`]: (getObjectProperty((getObjectProperty(((getObjectProperty(___arguments.context.appData, 'ESP\'s'))[0]), 'Location')), 'coordinates')).slice(-1)[0],[`lng`]: (getObjectProperty((getObjectProperty(((getObjectProperty(___arguments.context.appData, 'ESP\'s'))[0]), 'Location')), 'coordinates'))[0] }), 'Ambulance', (await BackendlessUI.Functions.Custom['fn_24a626fc74c34a9805e7999658bdcfd6'](({ [`lat`]: (getObjectProperty((getObjectProperty(((getObjectProperty(___arguments.context.appData, 'ESP\'s'))[0]), 'Location')), 'coordinates')).slice(-1)[0],[`lng`]: (getObjectProperty((getObjectProperty(((getObjectProperty(___arguments.context.appData, 'ESP\'s'))[0]), 'Location')), 'coordinates'))[0] }), Location)))), 'results'));
  for (var j_index in ESP_s) {
    j = ESP_s[j_index];
    Distance = (await BackendlessUI.Functions.Custom['fn_24a626fc74c34a9805e7999658bdcfd6']((getObjectProperty((getObjectProperty(j, 'geometry')), 'location')), Location)) / 1000;
    j['Distance'] = Distance;
  }
  console.log(await asyncListSort(ESP_s, 1, async (item) => {


   return (getObjectProperty(item, 'Distance'));
  }));
  console.log((await Backendless.Request.get(`${Backendless.appPath}/services/GoogleAPI/Nearby`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'location': JSON.stringify((new Backendless.Data.Point().setX((getObjectProperty(Location, 'lng'))).setY((getObjectProperty(Location, 'lat'))))),'radius': JSON.stringify('50000'),'keyword': JSON.stringify('Ambulance') }).send()));
}

/**
 * Describe this function...
 */
async function Emergency_Messaging() {
  Emegency_Contact_List = [({ [`Mobile`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Phone')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Phone'))),[`Email`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Email')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Email'))) }), ({ [`Mobile`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Emergency_Contact_Phone')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Emergency_Contact_Phone'))),[`Email`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Emergency_Contact_Email')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Emergency_Contact_Email'))) }), ({ [`Mobile`]: '+27764810153',[`Email`]: 'raymondewoodley@gmail.com' }), ({ [`Mobile`]: undefined,[`Email`]: undefined }), ({ [`Mobile`]: undefined,[`Email`]: undefined })];
  for (var j_index2 in Emegency_Contact_List) {
    j = Emegency_Contact_List[j_index2];
    try {
      await Backendless.Request.post(`${Backendless.appPath}/services/WhatsApp/Send_WhatsApp`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'To': (getObjectProperty(j, 'Mobile')),'Body': (['To Whom it may concern,',' \n\n','An SOS has been activated. Please click the link below for the system generated SOS Report.\n',(getObjectProperty(PDF, 'fileUrl')),' \n\n','Click the following link to open Google Maps\n',String('https://maps.google.com/?q=') + String([(getObjectProperty(Location, 'lat')),',',(getObjectProperty(Location, 'lng'))].join('')),' \n\n','This email has been sent to all relevant parties as per our SOS Protocol.',' \n\n','Kind Regards,\n\n','The Fleet In Form Team'].join('')) });

    } catch (error) {
      console.log(error);

    }
    try {
      await Backendless.Request.post(`${Backendless.appPath}/services/Twilio/sendMessage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'phoneNumber': (String(getObjectProperty(j, 'Mobile'))),'message': (['To Whom it may concern,',' \n\n','An SOS has been activated. Please click the link below for the system generated SOS Report.\n',(getObjectProperty(PDF, 'fileUrl')),' \n\n','Click the following link to open Google Maps\n',String('https://maps.google.com/?q=') + String([(getObjectProperty(Location, 'lat')),',',(getObjectProperty(Location, 'lng'))].join('')),' \n\n','This email has been sent to all relevant parties as per our SOS Protocol.',' \n\n','Kind Regards,\n\n','The Fleet In Form Team'].join('')) });

    } catch (error) {
      console.log('SMS');

    }
  }
}


  Location = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
  if (getObjectProperty(___arguments.context.appData, 'Network')) {
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Transaction;

      _uow.create('Emergencies', ({ [`Emergency_Contact_Name`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Emergency_Contact_Name')),[`Emergency_Contact_Phone`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Emergency_Contact_Phone')),[`Emergency_Trigged`]: ((new Date()).valueOf()),[`ICE_Name`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Emergency_ICE_Name')),[`ICE_Phone`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Emergency_ICE_Phone')),[`Location_Live`]: (new Backendless.Data.Point().setX((getObjectProperty(Location, 'lng'))).setY((getObjectProperty(Location, 'lat')))),[`Status`]: 'Active',[`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Emergency Type')),[`User Object Id`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')) })).setOpResultId('Emergency');
      _uow.setRelation('Emergencies', (Transaction.getOpResultById('Emergency')), 'Tractor', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))).setOpResultId('Emergency Relation (Tractor)');
      _uow.setRelation('Emergencies', (Transaction.getOpResultById('Emergency')), 'Driver', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details'))).setOpResultId('Emergency Relation (Driver)');
      _uow.setRelation('Emergencies', (Transaction.getOpResultById('Emergency')), 'Company', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))).setOpResultId('Emergency Relation (Company)');
      ESP_Result = ((_uow.find('ESP', Backendless.DataQueryBuilder.create().setPageSize(100)).setOpResultId('ESP')).resolveTo(0));

    })();

    await Transaction.execute();
    PDF = (await Backendless.Request.post(`${Backendless.appPath}/services/PDFGeneratorAPI/${'1107959'}/data-output/${(['EMERGENY ','(',(generateUUID().short()),')'].join(''))}`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'data': ({ [`C_City`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Physical_Address')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Physical_Address'))),[`C_Company`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name'))),[`C_Company_Logo`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Logo')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Logo'))),[`C_Contact_Name`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Name')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Name'))),[`C_Emergency_Contact_Name`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Emergency_Contact_Name')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Emergency_Contact_Name'))),[`C_Emergency_Contact_Number`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'C_Emergency_Contact_Number')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'C_Emergency_Contact_Number'))),[`C_Land_Line`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), ' Company_Phone_1')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), ' Company_Phone_1'))),[`C_Mobile`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Phone_2')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Phone_2'))),[`C_Postal_Address`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), ' Company_Postal_Address')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), ' Company_Postal_Address'))),[`C_Postal_Code`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Postal_Code')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Postal_Code'))),[`C_Registered_Name`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Registered_Name')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Registered_Name'))),[`D_Cellphone`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Phone')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Phone'))),[`D_displayName`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Name')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Name'))),[`D_email`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Email')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Email'))),[`E_Call_Sign`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Employee_Details_Nickname')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Employee_Details_Nickname'))),[`E_Cellphone_Number`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Employee_Details_Phone')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Employee_Details_Phone'))),[`E_Company_ID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Company_ID')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Company_ID'))),[`E_Currently_Aboard`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Registration')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Registration'))),[`E_ICE_Cellphone_Number`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Emergency_ICE_Phone')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Emergency_ICE_Phone'))),[`E_ICE_NAME`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Emergency_ICE_Name')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Emergency_ICE_Name'))),[` E_ID_Attachment`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Employee_Details_ID_Document')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Employee_Details_ID_Document'))),[`E_ID_Number`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Employee_Details_ID_Number')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Employee_Details_ID_Number'))),[`E_License_Attachment`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Driver_License_Document')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Driver_License_Document'))),[`E_License_Number`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Driver_License_Number')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Driver_License_Number'))),[`E_Medical_Aid_Name`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Emergency_Medical_Aid_Name')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Emergency_Medical_Aid_Name'))),[`E_Medical_Aid_Number`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Emergency_Medical_Aid_Name')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Emergency_Medical_Aid_Name'))),[`E_Medical_Aid_Document`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Emergency_Medical_Aid_Document')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Emergency_Medical_Aid_Document'))),[` E_Name`]: [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Employee_Details_Forenames')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Employee_Details_Forenames'))),' ',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Employee_Details_Surname')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Employee_Details_Surname')))].join(''),[`E_Profile_Photo`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Avatar')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Avatar')),[`Emergeny_Location`]: Location,[`G_Address`]: undefined,[`G_CoOrdinates`]: Location,[`G_Time`]: ((new Date()).toLocaleTimeString()),[`G_Type`]: (getObjectProperty(___arguments.context.appData, 'Emergency Type')),[`G_URL`]: String('https://maps.google.com/?q=') + String([(getObjectProperty(Location, 'lat')),',',(getObjectProperty(Location, 'lng'))].join('')),[`H_Date`]: undefined,[`H_ENG`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Engine_Number')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Engine_Number'))),[`H_ID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'ID')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'ID'))),[`H_Image`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Image_Front')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Image_Front'))),[`H_Make`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Make')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Make'))),[`H_Model`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Model')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Model'))),[`H_Pay`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload'))),[`H_Reg`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Registration')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Registration'))),[`H_VIN`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'VIN')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'VIN'))),[` T1_Date`]: undefined,[`T1_ID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'ID')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'ID')))),[`T1_Image`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Image_Front')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Image_Front')))),[`T1_Make`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Make')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Make')))),[`T1_Model`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Model')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Model')))),[`T1_Reg`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Registration')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Registration')))),[`T1_VIN`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'VIN')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'VIN')))),[`T1_Year`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Year')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Year')))),[`T2_Date`]: undefined,[`T2_ID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'ID')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'ID')))),[`T2_Image`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Image_Front')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Image_Front')))),[`T2_Make`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Make')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Make')))),[`T2_Model`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Model')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Model')))),[`T2_Reg`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Registration')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Registration')))),[`T2_VIN`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'VIN')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'VIN')))),[`T2_Year`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Year')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Year')))),[`T3_Date`]: undefined,[`T3_ID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'ID')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'ID')))),[`T3_Image`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Image_Front')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Image_Front')))),[`T3_Make`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Make')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Make')))),[`T3_Model`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Model')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Model')))),[`T3_Reg`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Registration')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Registration')))),[`T3_VIN`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'VIN')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'VIN')))),[`T3_Year`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Year')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Year')))),[`L_REF`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load'))[0]))) ? null : (getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load'))[0]), 'ID'))))),[`L_CN`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load'))[0]))) ? null : (getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load'))[0]), 'Customer Name'))))),[`L_LT`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load'))[0]))) ? null : (getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load'))[0]), 'Tonnage_Loaded'))))),[`L_LPLAN`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load'))[0]))) ? null : (getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load'))[0]), 'Load Planner Name'))))),[`L_LP`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load'))[0]))) ? null : (getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load'))[0]), 'Load Point (Load Name)'))))),[`L_DP`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load'))[0]))) ? null : (getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load'))[0]), 'Load Point (Delivery Name)'))))),[`L_P`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load'))[0]))) ? null : (getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load'))[0]), 'Load_Product'))))) }) }));
    await Emergency_Messaging();
  } else {
    localStorage.setItem('Key123', JSON.stringify(({ [`Company`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')),[`Driver`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')),[`Tractor`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')),[`Emergency_Contact_Name`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Emergency_Contact_Name')),[`Emergency_Contact_Phone`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Emergency_Contact_Phone')),[`Emergency_Trigged`]: ((new Date()).valueOf()),[`ICE_Name`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Emergency_ICE_Name')),[`ICE_Phone`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Emergency_ICE_Phone')),[`Location_Live`]: (new Backendless.Data.Point().setX((getObjectProperty(Location, 'lng'))).setY((getObjectProperty(Location, 'lat')))),[`Status`]: 'Active',[`Type`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Emergency Type')),[`User Object Id`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')) })));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/8b4d9d2461188166108401fdd7823cea/bundle.js', [], () => ({
  /* content */
  /* handler:On Network Change */
  async ['On Network Change'](___arguments) {
    var Location, PDF, Transaction, ESP_Result, error, j, Emegency_Contact_List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Emergency_Messaging() {
  Emegency_Contact_List = [({ [`Mobile`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Phone')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Phone'))),[`Email`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Email')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contact_Email'))) }), ({ [`Mobile`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Emergency_Contact_Phone')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Emergency_Contact_Phone'))),[`Email`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Emergency_Contact_Email')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Emergency_Contact_Email'))) }), ({ [`Mobile`]: '+27764810153',[`Email`]: 'raymondewoodley@gmail.com' }), ({ [`Mobile`]: undefined,[`Email`]: undefined }), ({ [`Mobile`]: undefined,[`Email`]: undefined })];
  for (var j_index in Emegency_Contact_List) {
    j = Emegency_Contact_List[j_index];
    try {
      await Backendless.Request.post(`${Backendless.appPath}/services/WhatsApp/Send_WhatsApp`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'To': (getObjectProperty(j, 'Mobile')),'Body': (['To Whom it may concern,',' \n\n','An SOS has been activated. Please click the link below for the system generated SOS Report.\n',(getObjectProperty(PDF, 'fileUrl')),' \n\n','Click the following link to open Google Maps\n',String('https://maps.google.com/?q=') + String([(getObjectProperty(Location, 'lat')),',',(getObjectProperty(Location, 'lng'))].join('')),' \n\n','This email has been sent to all relevant parties as per our SOS Protocol.',' \n\n','Kind Regards,\n\n','The Fleet In Form Team'].join('')) });

    } catch (error) {
      console.log(error);

    }
    try {
      await Backendless.Request.post(`${Backendless.appPath}/services/Twilio/sendMessage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'phoneNumber': (String(getObjectProperty(j, 'Mobile'))),'message': (['To Whom it may concern,',' \n\n','An SOS has been activated. Please click the link below for the system generated SOS Report.\n',(getObjectProperty(PDF, 'fileUrl')),' \n\n','Click the following link to open Google Maps\n',String('https://maps.google.com/?q=') + String([(getObjectProperty(Location, 'lat')),',',(getObjectProperty(Location, 'lng'))].join('')),' \n\n','This email has been sent to all relevant parties as per our SOS Protocol.',' \n\n','Kind Regards,\n\n','The Fleet In Form Team'].join('')) });

    } catch (error) {
      console.log('SMS');

    }
  }
}

/**
 * Describe this function...
 */
async function ESP() {
}


  if (___arguments['Network']) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('2fba8ab521d4506e08937205d6a51f68');
  } else {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('2fba8ab521d4506e08937205d6a51f68');
  }
  ___arguments.context.appData['Network'] = ___arguments['Network'];

  },
  /* handler:On Network Change */
  /* content */
}))

define('./pages/FIFDRIVER/components/ace4ac96f2a6474ebe1216e8b187c475/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('ef4bed043bb707b6fd6e6e3839de9553');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('ef4bed043bb707b6fd6e6e3839de9553');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.appData['Data - Driver Viewer'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/1c18eeefd04e7e3848022fd81278bbd1/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('461dcafc5d2caaf4c8889feaa184e96c');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('461dcafc5d2caaf4c8889feaa184e96c');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await new Promise(r => setTimeout(r, 50 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('b66aa5cab573ca48d796800e9905aafc', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/7d241c1bbf7c6466b85849d473aa9ec2/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('ef4bed043bb707b6fd6e6e3839de9553');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('ef4bed043bb707b6fd6e6e3839de9553');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'Data - Driver Viewer')) == true) {
    delete ___arguments.context.appData['Data - Driver Viewer'];
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('ef4bed043bb707b6fd6e6e3839de9553');
  } else {
    ___arguments.context.appData['Data - Driver Viewer'] = true;
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('ef4bed043bb707b6fd6e6e3839de9553');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/a69f399eb0de2e0b8fa870ac3b12375a/bundle.js', [], () => ({
  /* content */
  /* handler:onIconAssignment */
  async ['onIconAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'Trailer Swap Model (Close)')) == true) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('1dbd05f78241034e153331a5456c4c3b');
    delete ___arguments.context.appData['Trailer Swap Model (Close)'];
  }

  },
  /* handler:onIconAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/2ed3ab43d0768d670fde789a0b35febf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('1a46a2f281712eae875f181adf8b7874');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Signature Load Depot'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/67abf8a65294e0ed040424d7a4076dd6/bundle.js', [], () => ({
  /* content */
  /* handler:onSaveSignatureClick */
  async ['onSaveSignatureClick'](___arguments) {
    var error, Loading_Transaction, Mass, item, Loaded_Product, j, Next_Load, Created_Load__Transaction_, Transaction, Next_Load_Step_1, Last_Load, Trailers, Mass_List, Load_List, Date_Now, Loads;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Load_Planner_Capture() {
  Mass = [0];
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('224be73f2558c83276e980db05bdfd6f'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Loaded'))))) {
      addItemToList(Mass, 0);
    } else {
      addItemToList(Mass, ((getObjectProperty(j, 'Loaded')) * (getObjectProperty(j, 'Unit mass'))));
    }
  }
  Loaded_Product = (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('224be73f2558c83276e980db05bdfd6f')).map(async item => {; return ({ [`Mass`]: (getObjectProperty(item, 'Units')) * (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')),[`Units`]: (getObjectProperty(item, 'Units')),[`Product`]: (getObjectProperty(item, 'Product')),[`Unit mass`]: (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')) });})));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Product_JSON'))['Loaded'] = (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('224be73f2558c83276e980db05bdfd6f')).map(async item => {; return ({ [`Mass`]: (getObjectProperty(item, 'Units')) * (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')),[`Units`]: (getObjectProperty(item, 'Units')),[`Product`]: (getObjectProperty(item, 'Product')),[`Unit mass`]: (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')) });})));
  ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Load_Product'] = (await BackendlessUI.Functions.Custom['fn_f4df84546016cedc7395d748e8d7078c']((JSON.stringify((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('224be73f2558c83276e980db05bdfd6f')).map(async item => {; return ([(getObjectProperty(item, 'Units')),' ',' X ',' ',(getObjectProperty((getObjectProperty(item, 'Product')), 'Product')),'/n'].join(''));})))))));
  delete (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))['Loads'];
  ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Status'] = 'Loaded';
  ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Date_Loaded'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Mileage_Load_Point'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Mileage'));
  ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Tonnage_Loaded'] = (Mass.reduce(function(x, y) {return x + y;}));
  delete ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Mileage'];
  Loading_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  try {
    delete ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Load Point - Load Form Location'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Load Point - Load Form Location'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Load Form - Load Point Select'];

  } catch (error) {
    console.log(error);

  }
  delete ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Save Procedure'];
  await Backendless.Data.of('Loads').save(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), true);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Driver_Capture() {
  try {
    Last_Load = await Last_Load_Function((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')));

  } catch (error) {
    console.log(error);

  }
  Loaded_Product = (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c658ed913b97ff2119318bd43699c20d')).map(async item => {; return ({ [`Mass`]: (getObjectProperty(item, 'Units')) * (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')),[`Units`]: (getObjectProperty(item, 'Units')),[`Product`]: (getObjectProperty(item, 'Product')),[`Unit mass`]: (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')) });})));
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  Mass_List = [];
  var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c658ed913b97ff2119318bd43699c20d'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    try {
      addItemToList(Mass_List, ((getObjectProperty((getObjectProperty(j, 'Product')), 'Mass')) * (getObjectProperty(j, 'Units'))));

    } catch (error) {
      console.log(error);

    }
  }
  Created_Load__Transaction_ = (await Backendless.Data.of('Loads').save( ({ [`Load_Notes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Notes')),[`DP_NAME`]: (await BackendlessUI.Functions.Custom['fn_f4df84546016cedc7395d748e8d7078c']((JSON.stringify((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c658ed913b97ff2119318bd43699c20d')).map(async item => {; return ([(getObjectProperty(item, 'Units')),' ',' X ',' ',(getObjectProperty((getObjectProperty(item, 'Product')), 'Product')),'/n'].join(''));}))))))),[`Load_Product_JSON`]: ({ [`Planned`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c658ed913b97ff2119318bd43699c20d')).map(async item => {; return ({ [`Mass`]: (getObjectProperty(item, 'Units')) * (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')),[`Units`]: (getObjectProperty(item, 'Units')),[`Product`]: (getObjectProperty(item, 'Product')),[`Unit mass`]: (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')) });}))),[`Loaded`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c658ed913b97ff2119318bd43699c20d')).map(async item => {; return ({ [`Mass`]: (getObjectProperty(item, 'Units')) * (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')),[`Units`]: (getObjectProperty(item, 'Units')),[`Product`]: (getObjectProperty(item, 'Product')),[`Unit mass`]: (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')) });}))) }),[`Load_Product`]: (await BackendlessUI.Functions.Custom['fn_f4df84546016cedc7395d748e8d7078c']((JSON.stringify((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c658ed913b97ff2119318bd43699c20d')).map(async item => {; return ([(getObjectProperty(item, 'Units')),' ',' X ',' ',(getObjectProperty((getObjectProperty(item, 'Product')), 'Product')),'/n'].join(''));}))))))),[`Signature Load Driver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Signature Load Driver')),[`Signature Load Depot`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Signature Load Depot')),[`Date_Loaded`]: (new Date()),[`Date_Planned_Loading`]: (new Date()),[`Status`]: 'Loaded',[`Financial_Target_Ideal_Rate_Per_Km`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Rate_Per_Km')),[`Financial_Target_Ideal_Rate_Per_Tonne`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Rate_Per_Tonne')),[`Financial_Rate_Per_Km`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Rate_Per_Km')),[`Financial_Rate_Per_Tonne`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Rate_Per_Tonne')),[`ID`]: (await BackendlessUI.Functions.Custom['fn_6fc870fc98c8afb7acb79fd769a3f969'](___arguments.context.appData, 'Load', false, ({ [`Customer`]: 0,[`Employee`]: 0,[`Fuel`]: 0,[`Load`]: 0,[`Location`]: 0,[`Tractor`]: 0,[`Trailer`]: 0,[`Tyre`]: 0 }))),[`LLDPID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Last_Load)) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Last_Load, 'LDPID')))) ? null : (getObjectProperty(Last_Load, 'LDPID'))),[`LLPID`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('369640e21c33ea49a10b263fdef81ee4')), 'value')),[`Load Point (Load Name)`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('369640e21c33ea49a10b263fdef81ee4')), 'value')) == (getObjectProperty(item, 'objectId')));
  }))[0]), 'Name')),[`Load_Type`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Last_Load)) ? 'Standard' : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Last_Load, 'Status')))) ? 'Standard' : ((getObjectProperty(Last_Load, 'Status')) == 'Loaded' ? 'Split Load' : ((getObjectProperty(Last_Load, 'Status')) == 'Delivered' ? 'Standard' : ((getObjectProperty(Last_Load, 'Status')) == 'Planned' ? 'Standard' : 'Standard')))),[`Location_Captured_Load_Point`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Location')).length == 0 ? (new Backendless.Data.Point().setX((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Location')), 'lng'))).setY((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Location')), 'lat')))) : (new Backendless.Data.Point().setX((getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Location')).slice(-1)[0]), 'position.longitude'))).setY((getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Location')).slice(-1)[0]), 'position.latitude')))),[`Mileage_Load_Point`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Mileage')),[`Planned Rate Per Km`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Rate_Per_Km')),[`Planned Rate Per Unit`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Rate_Per_Tonne')),[`Load_Load_Image_1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Load_Image_1')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Load_Image_1'))[0],[`Load_Load_Image_2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Load_Image_2')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Load_Image_2'))[0],[`Load_Load_Image_3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Load_Image_3')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Load_Image_3'))[0],[`Rig_Cost_Per_Hour`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Cost Per Hour')),[`Rig_CPK`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Rig_CPK')),[`Rig_Payload`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload_Override')))) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload_Override')),[`Tonnage_Planned`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload_Override')))) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload_Override')),[`Tonnage_Loaded`]: Mass_List.reduce(function(x, y) {return x + y;}),[`Wages_Driver_Tonnage_Rate`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Wages_Rate_Contractor_Tonnage')),[`Wages_Driver_Tonnage_Target_Rate`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Wages_Rate_Target_Tonnage')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'ownerId')),[`TID`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')) }) ));
  await ( async () => {
    const _uow = Transaction;

    _uow.addToRelation('Tractors', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads', [Created_Load__Transaction_]);
    _uow.addToRelation('Employees', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Driver_Transactions_Load', [Created_Load__Transaction_]);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1'))))) {
    } else {
      _uow.addToRelation('Trailers', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load', [Created_Load__Transaction_]);
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2'))))) {
    } else {
      _uow.addToRelation('Trailers', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Current Load', [Created_Load__Transaction_]);
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3'))))) {
    } else {
      _uow.addToRelation('Trailers', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Current Load', [Created_Load__Transaction_]);
    }
    _uow.setRelation('Loads', Created_Load__Transaction_, 'Rig_Tractor', [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId'))]);
    Trailers = (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'objectId'))], async (item) => {


     return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](item)));
    }));
    _uow.setRelation('Loads', Created_Load__Transaction_, 'Rig_Trailers', Trailers);
    _uow.setRelation('Loads', Created_Load__Transaction_, 'Location_Load_Point', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('369640e21c33ea49a10b263fdef81ee4')), 'value'))]);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Last_Load))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Last_Load, 'Status'))))) {
      } else {
        if ((getObjectProperty(Last_Load, 'Status')) == 'Loaded') {
          Last_Load['Load_Type'] = 'Split Load';
          delete Last_Load['Time Differential Action Date'];
          _uow.upsert('Loads', Last_Load);
        }
      }
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Last_Load))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Last_Load, 'LDPID'))))) {
        _uow.setRelation('Loads', Created_Load__Transaction_, 'Location_Last_Delivery_Point', [(getObjectProperty(Last_Load, 'LLPID'))]);
      } else {
        _uow.setRelation('Loads', Created_Load__Transaction_, 'Location_Last_Delivery_Point', [(getObjectProperty(Last_Load, 'LDPID'))]);
      }
    }

  })();

  Next_Load_Step_1 = (await Transaction.execute());
  Next_Load = Created_Load__Transaction_;
  try {
    addItemToList((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Loads')), Next_Load);

  } catch (error) {
    console.log(error);

  }
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Loads')), Next_Load);

  } catch (error) {
    console.log(error);

  }
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')), Next_Load);

  } catch (error) {
    console.log(error);

  }
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')), Next_Load);

  } catch (error) {
    console.log(error);

  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load'))))) {
      (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1'))['Current Load'] = [Next_Load];
    } else {
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load')), Next_Load);
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2'))))) {
      (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2'))['Current Load'] = [Next_Load];
    } else {
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Current Load')), Next_Load);
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3'))))) {
      (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3'))['Current Load'] = [Next_Load];
    } else {
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Current Load')), Next_Load);
    }
  }
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['New Load'];
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Last_Load_Function(Loads) {
  Load_List = (await asyncListSort((await asyncListFilter(Loads, async (item) => {


   return ((getObjectProperty(item, 'Status')) == 'Delivered' || (getObjectProperty(item, 'Status')) == 'Loaded');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Sequence'));
  }));
  Date_Now = (new Date());
  for (var j_index3 in Load_List) {
    j = Load_List[j_index3];
    j['Time Differential Action Date'] = (Date_Now - (getObjectProperty(j, 'Sequence')));
  }
  return (await asyncListSort((await asyncListFilter(Load_List, async (item) => {


 return ((getObjectProperty(item, 'Time Differential Action Date')) > 0);
})), 1, async (item) => {


 return (getObjectProperty(item, 'Time Differential Action Date'));
}))[0]
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Save Procedure'))))) {
    ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Save Procedure'] = true;
    ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Signature Load Driver'] = (await Backendless.Files.saveFile(encodePath((['users/',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'/','signatures'].join(''))), (String(generateUUID().long()) + String('.png')), ___arguments['signature'], false));
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ed3ab43d0768d670fde789a0b35febf', false);
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('1a46a2f281712eae875f181adf8b7874');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('37ad3ef2d599972beb9890f3fe0b5e3d', true);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2332ab25b99c04ae9b22b9a934fb89ca'))['disabled'] = true;
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'New Load'))))) {
      await Load_Planner_Capture();
    } else {
      await Driver_Capture();
    }
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Load Initiated'];
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('bed46198bd14dda817628f44ec924a1a', undefined);
    ___arguments.context.pageData['Flash'] = true;
  }

  },
  /* handler:onSaveSignatureClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/aa391e954529709bb18988d6f407c9a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('56972e127876126bd3d527377dd22673');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/5b8eea6aa7c32712ef025d5ad2ec970f/bundle.js', [], () => ({
  /* content */
  /* handler:onSaveSignatureClick */
  async ['onSaveSignatureClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8')['Signature Delivery Depot'] = (await Backendless.Files.saveFile(encodePath((['users/',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'/','signatures'].join(''))), (String(generateUUID().long()) + String('.png')), ___arguments['signature'], false));
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2d217683bfdfe18d8cb7bb6e93ca8f44', false);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('ef1d26a4fe6963ae8b4b910f8c5cf64f');

  },
  /* handler:onSaveSignatureClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/ca2e238ae33caf560a5875cdb053285a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Location_Data, j, Last_Point, item, Last_ID, Time_Now, Time_Start;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Load Initiated'] = true;
  Time_Now = (new Date());
  Time_Start = (new Date((new Date()).getTime() - (2700 * 1000)));
  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['New Load'] = true;
  Location_Data = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Device ID')), Time_Start, Time_Now));
  try {
    Last_ID = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0];

  } catch (error) {

  }
  if (Location_Data.length > 0) {
    Last_Point = (await Promise.all(Location_Data.map(async item => {; return ({ [`lat`]: (getObjectProperty(item, 'position.latitude')),[`lng`]: (getObjectProperty(item, 'position.longitude')) });}))).slice(-1)[0];
    var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['Distance'] = (await BackendlessUI.Functions.Custom['fn_24a626fc74c34a9805e7999658bdcfd6'](Last_Point, (getObjectProperty(j, 'Point'))));
    }
  } else {
    Last_Point = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Location'));
    var j_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      j['Distance'] = (await BackendlessUI.Functions.Custom['fn_24a626fc74c34a9805e7999658bdcfd6'](Last_Point, (getObjectProperty(j, 'Point'))));
    }
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd853ab68db6498d0766ca6e0eb64aa3', true);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('fd853ab68db6498d0766ca6e0eb64aa3', ({ [`Mileage`]: Location_Data.length > 0 ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((Location_Data.slice(-1)[0]), 'can.vehicle.mileage')))) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')) : (getObjectProperty((Location_Data.slice(-1)[0]), 'can.vehicle.mileage'))) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')),[`Location`]: Location_Data,[`TID`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')) }));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Location_Data, j, Last_Point, item, Last_ID, Time_Now, Time_Start;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function do_something() {
  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Load Initiated'] = true;
  Time_Now = (new Date());
  Time_Start = (new Date((new Date()).getTime() - (2700 * 1000)));
  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['New Load'] = true;
  Location_Data = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Device ID')), Time_Start, Time_Now));
  try {
    Last_ID = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0];

  } catch (error) {

  }
  if (Location_Data.length > 0) {
    Last_Point = (await Promise.all(Location_Data.map(async item => {; return ({ [`lat`]: (getObjectProperty(item, 'position.latitude')),[`lng`]: (getObjectProperty(item, 'position.longitude')) });}))).slice(-1)[0];
    var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['Distance'] = (await BackendlessUI.Functions.Custom['fn_24a626fc74c34a9805e7999658bdcfd6'](Last_Point, (getObjectProperty(j, 'Point'))));
    }
  } else {
    Last_Point = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Location'));
    var j_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      j['Distance'] = (await BackendlessUI.Functions.Custom['fn_24a626fc74c34a9805e7999658bdcfd6'](Last_Point, (getObjectProperty(j, 'Point'))));
    }
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd853ab68db6498d0766ca6e0eb64aa3', true);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('fd853ab68db6498d0766ca6e0eb64aa3', ({ [`Mileage`]: Location_Data.length > 0 ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((Location_Data.slice(-1)[0]), 'can.vehicle.mileage')))) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')) : (getObjectProperty((Location_Data.slice(-1)[0]), 'can.vehicle.mileage'))) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')),[`Location`]: Location_Data,[`TID`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')) }));
}

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/2cbe6c39ff57d23177a8098b4b1dcac5/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('8fba5d5c3f09942bc381b26b9f43c20f');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('8fba5d5c3f09942bc381b26b9f43c20f');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('bed46198bd14dda817628f44ec924a1a', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/f1978fdcec57a7be3b6faa77f4513c9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Next_Load, Location_Data, item, j, Last_Point, Time_Now, Time_Start, Last_Load;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Load Initiated'] = true;
  Last_Load = (await asyncListSort((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'Status')) == 'Delivered');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  }))[0];
  Next_Load = ___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689');
  Time_Now = (new Date());
  Time_Start = (new Date((new Date()).getTime() - (2700 * 1000)));
  Location_Data = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Device ID')), Time_Start, Time_Now));
  if (Location_Data.length > 0) {
    Last_Point = (await Promise.all(Location_Data.map(async item => {; return ({ [`lat`]: (getObjectProperty(item, 'position.latitude')),[`lng`]: (getObjectProperty(item, 'position.longitude')) });}))).slice(-1)[0];
    var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Point'))))) {
      } else {
        j['Distance'] = (await BackendlessUI.Functions.Custom['fn_24a626fc74c34a9805e7999658bdcfd6'](Last_Point, (getObjectProperty(j, 'Point'))));
      }
    }
  } else {
    Last_Point = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Location'));
    var j_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Point'))))) {
      } else {
        j['Distance'] = (await BackendlessUI.Functions.Custom['fn_24a626fc74c34a9805e7999658bdcfd6'](Last_Point, (getObjectProperty(j, 'Point'))));
      }
    }
  }
  if ((getObjectProperty(Next_Load, 'Status')) == 'Planned') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd853ab68db6498d0766ca6e0eb64aa3', true);
    await new Promise(r => setTimeout(r, 500 || 0));
    Next_Load['Mileage'] = (Location_Data.length > 0 ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((Location_Data.slice(-1)[0]), 'can.vehicle.mileage')))) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')) : (getObjectProperty((Location_Data.slice(-1)[0]), 'can.vehicle.mileage'))) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')));
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('fd853ab68db6498d0766ca6e0eb64aa3', Next_Load);
  } else if ((getObjectProperty(Next_Load, 'Status')) == 'Loaded' || (getObjectProperty(Next_Load, 'Status')) == 'Transferred ') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc6315ac2726b292499170c40f7c02c8', true);
    await new Promise(r => setTimeout(r, 500 || 0));
    Next_Load['Mileage'] = (Location_Data.length > 0 ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((Location_Data.slice(-1)[0]), 'can.vehicle.mileage')))) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')) : (getObjectProperty((Location_Data.slice(-1)[0]), 'can.vehicle.mileage'))) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')));
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('bc6315ac2726b292499170c40f7c02c8', Next_Load);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var Label, Next_Load, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Next_Load = ___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689');

  } catch (error) {

  }
  try {
    if ((getObjectProperty(Next_Load, 'Status')) == 'Planned') {
      Label = 'Start Load';
    } else if ((getObjectProperty(Next_Load, 'Status')) == 'Loaded') {
      Label = 'Deliver Load';
    } else if ((getObjectProperty(Next_Load, 'Status')) == 'Transferred ') {
      Label = 'Deliver Load';
    } else {
      Label = null;
    }

  } catch (error) {

  }

  return Label

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, Next_Load;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Next_Load = ___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689');

  } catch (error) {

  }
  try {
    if ((getObjectProperty(Next_Load, 'Status')) == 'Planned') {
      Viewer = true;
    } else if ((getObjectProperty(Next_Load, 'Status')) == 'Loaded') {
      Viewer = true;
    } else if ((getObjectProperty(Next_Load, 'Status')) == 'Transferred ') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/369640e21c33ea49a10b263fdef81ee4/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var List, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    List = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      List = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
      } else {
        List = (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Name')) });})));
      }
    }
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Load Form - Load Point Select'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFDRIVER/components/257915777882e5481eb691aeebe7c0f8/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    List = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      List = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
      } else {
        List = (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Name')) });})));
      }
    }
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8')['LDPID'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8')['Load Point (Delivery Name)'] = (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('257915777882e5481eb691aeebe7c0f8')), ___arguments.value));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFDRIVER/components/50febd767b04883cd80b6ab1580f6233/bundle.js', [], () => ({
  /* content */
  /* handler:onSaveSignatureClick */
  async ['onSaveSignatureClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Signature Load Depot'] = (await Backendless.Files.saveFile(encodePath((['users/',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'/','signatures'].join(''))), (String(generateUUID().long()) + String('.png')), ___arguments['signature'], false));
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aa391e954529709bb18988d6f407c9a6', false);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('56972e127876126bd3d527377dd22673');

  },
  /* handler:onSaveSignatureClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/2332ab25b99c04ae9b22b9a934fb89ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Reloaded_Loads, Loading_Transaction, error, Mass, item, Loaded_Product, j, Load_List, Date_Now, Loads, Counter, Next_Load, Next_Load_Step_1, Transaction, Last_Load, Created_Load__Transaction_, Trailers, Mass_List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Last_Load_Function(Loads) {
  Load_List = (await asyncListSort((await asyncListFilter(Loads, async (item) => {


   return ((getObjectProperty(item, 'Status')) == 'Delivered' || (getObjectProperty(item, 'Status')) == 'Loaded');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Sequence'));
  }));
  Date_Now = (new Date());
  for (var j_index2 in Load_List) {
    j = Load_List[j_index2];
    j['Time Differential Action Date'] = (Date_Now - (getObjectProperty(j, 'Sequence')));
  }
  return (await asyncListSort((await asyncListFilter(Load_List, async (item) => {


 return ((getObjectProperty(item, 'Time Differential Action Date')) > 0);
})), 1, async (item) => {


 return (getObjectProperty(item, 'Time Differential Action Date'));
}))[0]
}

/**
 * Describe this function...
 */
async function Error__Counter() {
  if ((getObjectProperty(___arguments.event, 'Error Counter')) == true) {
    Counter = Counter + 1;
    console.log(Counter);
  }
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function Driver_Capture() {
  try {
    Last_Load = await Last_Load_Function((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')));

  } catch (error) {
    console.log(error);

  }
  Loaded_Product = (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c658ed913b97ff2119318bd43699c20d')).map(async item => {; return ({ [`Mass`]: (getObjectProperty(item, 'Units')) * (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')),[`Units`]: (getObjectProperty(item, 'Units')),[`Product`]: (getObjectProperty(item, 'Product')),[`Unit mass`]: (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')) });})));
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  Mass_List = [];
  var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c658ed913b97ff2119318bd43699c20d'));
  for (var j_index3 in j_list2) {
    j = j_list2[j_index3];
    try {
      addItemToList(Mass_List, ((getObjectProperty((getObjectProperty(j, 'Product')), 'Mass')) * (getObjectProperty(j, 'Units'))));

    } catch (error) {
      console.log(error);

    }
  }
  await ( async () => {
    const _uow = Transaction;

    Created_Load__Transaction_ = (_uow.create('Loads', ({ [`DP_NAME`]: 'Driver To',[`Load_Product_JSON`]: ({ [`Planned`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c658ed913b97ff2119318bd43699c20d')).map(async item => {; return ({ [`Mass`]: (getObjectProperty(item, 'Units')) * (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')),[`Units`]: (getObjectProperty(item, 'Units')),[`Product`]: (getObjectProperty(item, 'Product')),[`Unit mass`]: (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')) });}))),[`Loaded`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c658ed913b97ff2119318bd43699c20d')).map(async item => {; return ({ [`Mass`]: (getObjectProperty(item, 'Units')) * (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')),[`Units`]: (getObjectProperty(item, 'Units')),[`Product`]: (getObjectProperty(item, 'Product')),[`Unit mass`]: (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')) });}))) }),[`Load_Product`]: (await BackendlessUI.Functions.Custom['fn_f4df84546016cedc7395d748e8d7078c']((JSON.stringify((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c658ed913b97ff2119318bd43699c20d')).map(async item => {; return ([(getObjectProperty(item, 'Units')),' ',' X ',' ',(getObjectProperty((getObjectProperty(item, 'Product')), 'Product')),'/n'].join(''));}))))))),[`Signature Load Driver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Signature Load Driver')),[`Signature Load Depot`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Signature Load Depot')),[`Date_Loaded`]: (new Date()),[`Date_Planned_Loading`]: (new Date()),[`Status`]: 'Loaded',[`Financial_Target_Ideal_Rate_Per_Km`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Rate_Per_Km')),[`Financial_Target_Ideal_Rate_Per_Tonne`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Rate_Per_Tonne')),[`Financial_Rate_Per_Km`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Rate_Per_Km')),[`Financial_Rate_Per_Tonne`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Rate_Per_Tonne')),[`ID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0]))) ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' ','00001'].join('') : ((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0] >= 10 ? ((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0] >= 100 ? ((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0] >= 1000 ? ((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0] >= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' ',(await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0] + 1].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' 0',(await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0] + 1].join('')) : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' 00',(await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0] + 1].join('')) : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' 000',(await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0] + 1].join('')) : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' 0000',(await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0] + 1].join('')),[`LLDPID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Last_Load)) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Last_Load, 'LDPID')))) ? null : (getObjectProperty(Last_Load, 'LDPID'))),[`LLPID`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('369640e21c33ea49a10b263fdef81ee4')), 'value')),[`Load Point (Load Name)`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('369640e21c33ea49a10b263fdef81ee4')), 'value')) == (getObjectProperty(item, 'objectId')));
    }))[0]), 'Name')),[`Load_Type`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Last_Load)) ? 'Standard' : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Last_Load, 'Status')))) ? 'Standard' : ((getObjectProperty(Last_Load, 'Status')) == 'Loaded' ? 'Split Load' : ((getObjectProperty(Last_Load, 'Status')) == 'Delivered' ? 'Standard' : ((getObjectProperty(Last_Load, 'Status')) == 'Planned' ? 'Standard' : 'Standard')))),[`Location_Captured_Load_Point`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Location')).length == 0 ? (new Backendless.Data.Point().setX((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Location')), 'lng'))).setY((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Location')), 'lat')))) : (new Backendless.Data.Point().setX((getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Location')).slice(-1)[0]), 'position.longitude'))).setY((getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Location')).slice(-1)[0]), 'position.latitude')))),[`Mileage_Load_Point`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Mileage')),[`Planned Rate Per Km`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Rate_Per_Km')),[`Planned Rate Per Unit`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Rate_Per_Tonne')),[`Load_Load_Image_1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Load_Image_1')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Load_Image_1'))[0],[`Load_Load_Image_2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Load_Image_2')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Load_Image_2'))[0],[`Load_Load_Image_3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Load_Image_3')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Load_Image_3'))[0],[`Rig_Cost_Per_Hour`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Cost Per Hour')),[`Rig_CPK`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Rig_CPK')),[`Rig_Payload`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload_Override')))) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload_Override')),[`Tonnage_Planned`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload_Override')))) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload_Override')),[`Tonnage_Loaded`]: Mass_List.reduce(function(x, y) {return x + y;}),[`Wages_Driver_Tonnage_Rate`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Wages_Rate_Contractor_Tonnage')),[`Wages_Driver_Tonnage_Target_Rate`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Wages_Rate_Target_Tonnage')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'ownerId')),[`TID`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')) })));
    _uow.addToRelation('Tractors', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads', [Created_Load__Transaction_]);
    _uow.addToRelation('Employees', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Driver_Transactions_Load', [Created_Load__Transaction_]);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1'))))) {
    } else {
      _uow.addToRelation('Trailers', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load', [Created_Load__Transaction_]);
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2'))))) {
    } else {
      _uow.addToRelation('Trailers', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Current Load', [Created_Load__Transaction_]);
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3'))))) {
    } else {
      _uow.addToRelation('Trailers', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Current Load', [Created_Load__Transaction_]);
    }
    _uow.setRelation('Loads', Created_Load__Transaction_, 'Rig_Tractor', [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId'))]);
    Trailers = (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'objectId'))], async (item) => {


     return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](item)));
    }));
    _uow.setRelation('Loads', Created_Load__Transaction_, 'Rig_Trailers', Trailers);
    _uow.setRelation('Loads', Created_Load__Transaction_, 'Location_Load_Point', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('369640e21c33ea49a10b263fdef81ee4')), 'value'))]);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Last_Load))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Last_Load, 'Status'))))) {
      } else {
        if ((getObjectProperty(Last_Load, 'Status')) == 'Loaded') {
          Last_Load['Load_Type'] = 'Split Load';
          delete Last_Load['Time Differential Action Date'];
          _uow.upsert('Loads', Last_Load);
        }
      }
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Last_Load))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Last_Load, 'LDPID'))))) {
        _uow.setRelation('Loads', Created_Load__Transaction_, 'Location_Last_Delivery_Point', [(getObjectProperty(Last_Load, 'LLPID'))]);
      } else {
        _uow.setRelation('Loads', Created_Load__Transaction_, 'Location_Last_Delivery_Point', [(getObjectProperty(Last_Load, 'LDPID'))]);
      }
    }

  })();

  Next_Load_Step_1 = (await Transaction.execute());
  console.log(Next_Load_Step_1);
  Next_Load = (getObjectProperty((getObjectProperty((getObjectProperty(Next_Load_Step_1, 'results')), 'createLoads1')), 'result'));
  try {
    addItemToList((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Loads')), Next_Load);

  } catch (error) {
    console.log(error);

  }
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Loads')), Next_Load);

  } catch (error) {
    console.log(error);

  }
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')), Next_Load);

  } catch (error) {
    console.log(error);

  }
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')), Next_Load);

  } catch (error) {
    console.log(error);

  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load'))))) {
      (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1'))['Current Load'] = [Next_Load];
    } else {
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load')), Next_Load);
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2'))))) {
      (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2'))['Current Load'] = [Next_Load];
    } else {
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Current Load')), Next_Load);
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3'))))) {
      (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3'))['Current Load'] = [Next_Load];
    } else {
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Current Load')), Next_Load);
    }
  }
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['New Load'];
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('bed46198bd14dda817628f44ec924a1a', undefined);
}

/**
 * Describe this function...
 */
async function Driver_Capture2() {
  Last_Load = await Last_Load_Function((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')));
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Created_Load__Transaction_ = (_uow.create('Loads', ({ [`Load_Product`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('85a933cae56991e34342df2635eefaca')),[`Signature Load Driver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Signature Load Driver')),[`Signature Load Depot`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Signature Load Depot')),[`Date_Loaded`]: (new Date()),[`Date_Planned_Loading`]: (new Date()),[`Status`]: 'Loaded',[`Financial_Target_Ideal_Rate_Per_Km`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Rate_Per_Km')),[`Financial_Target_Ideal_Rate_Per_Tonne`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Rate_Per_Tonne')),[`Financial_Rate_Per_Km`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Rate_Per_Km')),[`Financial_Rate_Per_Tonne`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Rate_Per_Tonne')),[`ID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0]))) ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' ','00001'].join('') : ((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0] >= 10 ? ((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0] >= 100 ? ((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0] >= 1000 ? ((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0] >= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' ',(await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0] + 1].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' 0',(await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0] + 1].join('')) : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' 00',(await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0] + 1].join('')) : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' 000',(await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0] + 1].join('')) : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' 0000',(await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')).map(async item => {; return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 4))));}))), -1, async (item) => {


     return item;
    }))[0] + 1].join('')),[`LLDPID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Last_Load, 'LDPID')))) ? null : (getObjectProperty(Last_Load, 'LDPID')),[`LLPID`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('369640e21c33ea49a10b263fdef81ee4')), 'value')),[`Load Point (Load Name)`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('369640e21c33ea49a10b263fdef81ee4')), 'value')) == (getObjectProperty(item, 'objectId')));
    }))[0]), 'Name')),[`Load_Type`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Last_Load, 'Status')))) ? 'Standard' : ((getObjectProperty(Last_Load, 'Status')) == 'Loaded' ? 'Split Load' : ((getObjectProperty(Last_Load, 'Status')) == 'Delivered' ? 'Standard' : ((getObjectProperty(Last_Load, 'Status')) == 'Planned' ? 'Standard' : 'Standard'))),[`Location_Captured_Load_Point`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Location')).length == 0 ? (new Backendless.Data.Point().setX((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Location')), 'lng'))).setY((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Location')), 'lat')))) : (new Backendless.Data.Point().setX((getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Location')).slice(-1)[0]), 'position.longitude'))).setY((getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Location')).slice(-1)[0]), 'position.latitude')))),[`Mileage_Load_Point`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Mileage')),[`Planned Rate Per Km`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Rate_Per_Km')),[`Planned Rate Per Unit`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Ideal_Rate_Per_Tonne')),[`Load_Load_Image_1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Load_Image_1')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Load_Image_1'))[0],[`Load_Load_Image_2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Load_Image_2')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Load_Image_2'))[0],[`Load_Load_Image_3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Load_Image_3')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Load_Image_3'))[0],[`Rig_Cost_Per_Hour`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Cost Per Hour')),[`Rig_CPK`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Rig_CPK')),[`Rig_Payload`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload_Override')))) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload_Override')),[`Tonnage_Planned`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload_Override')))) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Payload_Override')),[`Tonnage_Loaded`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Tonnage_Loaded')),[`Wages_Driver_Tonnage_Rate`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Wages_Rate_Contractor_Tonnage')),[`Wages_Driver_Tonnage_Target_Rate`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Wages_Rate_Target_Tonnage')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'ownerId')),[`TID`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')) })));
    _uow.addToRelation('Tractors', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads', [Created_Load__Transaction_]);
    _uow.addToRelation('Employees', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Driver_Transactions_Load', [Created_Load__Transaction_]);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1'))))) {
    } else {
      _uow.addToRelation('Trailers', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load', [Created_Load__Transaction_]);
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2'))))) {
    } else {
      _uow.addToRelation('Trailers', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Current Load', [Created_Load__Transaction_]);
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3'))))) {
    } else {
      _uow.addToRelation('Trailers', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Current Load', [Created_Load__Transaction_]);
    }
    _uow.setRelation('Loads', Created_Load__Transaction_, 'Rig_Tractor', [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId'))]);
    Trailers = (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'objectId'))], async (item) => {


     return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](item)));
    }));
    _uow.setRelation('Loads', Created_Load__Transaction_, 'Rig_Trailers', Trailers);
    _uow.setRelation('Loads', Created_Load__Transaction_, 'Location_Load_Point', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('369640e21c33ea49a10b263fdef81ee4')), 'value'))]);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Last_Load, 'Status'))))) {
    } else {
      if ((getObjectProperty(Last_Load, 'Status')) == 'Loaded') {
        Last_Load['Load_Type'] = 'Split Load';
        delete Last_Load['Time Differential Action Date'];
        _uow.upsert('Loads', Last_Load);
      }
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Last_Load, 'LDPID'))))) {
      _uow.setRelation('Loads', Created_Load__Transaction_, 'Location_Last_Delivery_Point', [(getObjectProperty(Last_Load, 'LLPID'))]);
    } else {
      _uow.setRelation('Loads', Created_Load__Transaction_, 'Location_Last_Delivery_Point', [(getObjectProperty(Last_Load, 'LDPID'))]);
    }

  })();

  Next_Load_Step_1 = (await Transaction.execute());
  Next_Load = (getObjectProperty((getObjectProperty((getObjectProperty(Next_Load_Step_1, 'results')), 'createLoads1')), 'result'));
  try {
    addItemToList((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Loads')), Next_Load);

  } catch (error) {
    console.log(error);

  }
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Wages')), 'Loads')), Next_Load);

  } catch (error) {
    console.log(error);

  }
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')), Next_Load);

  } catch (error) {
    console.log(error);

  }
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')), Next_Load);

  } catch (error) {
    console.log(error);

  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1'))))) {
  } else {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load')), Next_Load);
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2'))))) {
  } else {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Current Load')), Next_Load);
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3'))))) {
  } else {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Current Load')), Next_Load);
  }
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['New Load'];
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('bed46198bd14dda817628f44ec924a1a', undefined);
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('37ad3ef2d599972beb9890f3fe0b5e3d', true);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2332ab25b99c04ae9b22b9a934fb89ca'))['disabled'] = true;
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'New Load'))))) {
    Mass = [0];
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('224be73f2558c83276e980db05bdfd6f'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Loaded'))))) {
        addItemToList(Mass, 0);
      } else {
        addItemToList(Mass, ((getObjectProperty(j, 'Loaded')) * (getObjectProperty(j, 'Unit mass'))));
      }
    }
    Loaded_Product = (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('224be73f2558c83276e980db05bdfd6f')).map(async item => {; return ({ [`Mass`]: (getObjectProperty(item, 'Units')) * (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')),[`Units`]: (getObjectProperty(item, 'Units')),[`Product`]: (getObjectProperty(item, 'Product')),[`Unit mass`]: (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')) });})));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Product_JSON'))['Loaded'] = (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('224be73f2558c83276e980db05bdfd6f')).map(async item => {; return ({ [`Mass`]: (getObjectProperty(item, 'Units')) * (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')),[`Units`]: (getObjectProperty(item, 'Units')),[`Product`]: (getObjectProperty(item, 'Product')),[`Unit mass`]: (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')) });})));
    ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Load_Product'] = (await BackendlessUI.Functions.Custom['fn_f4df84546016cedc7395d748e8d7078c']((JSON.stringify((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('224be73f2558c83276e980db05bdfd6f')).map(async item => {; return ([(getObjectProperty(item, 'Units')),' ',' X ',' ',(getObjectProperty((getObjectProperty(item, 'Product')), 'Product')),'/n'].join(''));})))))));
    delete (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))['Loads'];
    ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Status'] = 'Loaded';
    ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Date_Loaded'] = (new Date());
    ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Mileage_Load_Point'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Mileage'));
    ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Tonnage_Loaded'] = (Mass.reduce(function(x, y) {return x + y;}));
    delete ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Mileage'];
    Loading_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    try {
      delete ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Load Point - Load Form Location'];

    } catch (error) {
      console.log(error);

    }
    try {
      delete ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Load Form - Load Point Select'];

    } catch (error) {
      console.log(error);

    }
    console.log(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'));
    await ( async () => {
      const _uow = Loading_Transaction;

      _uow.update('Loads', ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'));
      _uow.find('Loads', Backendless.DataQueryBuilder.create().setWhereClause((['TID = \'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')),'\''].join(''))).setPageSize(100));

    })();

    Reloaded_Loads = (await Loading_Transaction.execute());
    console.log(Reloaded_Loads);
    (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))['Loads'] = (getObjectProperty((getObjectProperty((getObjectProperty(Reloaded_Loads, 'results')), 'findLoads1')), 'result'));
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Load Initiated'];
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('bed46198bd14dda817628f44ec924a1a', undefined);
  } else {
    await Driver_Capture();
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Load Initiated'];
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('bed46198bd14dda817628f44ec924a1a', undefined);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('37ad3ef2d599972beb9890f3fe0b5e3d', false);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Signature Load Depot'))))) {
    Viewer = false;
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Signature Load Driver'))))) {
      Viewer = false;
    } else {
      Viewer = true;
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/2a056db9a916fae43ee80f960786f41d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, j, Load, Load_Return, Mass, Reloaded_Loads, Tractor, Trailer_List, Transactions;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function Load_Transaction() {
  console.log('1');
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2a056db9a916fae43ee80f960786f41d'))['disabled'] = true;
  console.log('2');
  Tractor = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Transfer_Planned')) == true) {
    Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Transfer_Rig_Details')), 'Offload Vehicle')), 'Vehicle')), Backendless.DataQueryBuilder.create().setRelated(['Trailer1', 'Trailer2', 'Trailer3'])));
  }
  console.log('3');
  Mass = [0];
  console.log('4');
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('beef64a3173f3eb6d4dd8df7ccd3a961'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Delivered'))))) {
      addItemToList(Mass, 0);
    } else {
      addItemToList(Mass, ((getObjectProperty(j, 'Delivered')) * (getObjectProperty(j, 'Unit mass'))));
    }
  }
  console.log('5');
  ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8')['Tonnage_Delivered'] = (Mass.reduce(function(x, y) {return x + y;}));
  ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8')['Date_Delivered'] = (new Date());
  console.log('6');
  ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8')['Status'] = 'Delivered';
  ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8')['Mileage_Delivery_Point'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Mileage'));
  console.log('7');
  delete ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8')['Mileage'];
  Transactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  console.log('8');
  Load = ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8');
  console.log(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId'));
  await ( async () => {
    const _uow = Transactions;

    console.log('8.1');
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Transfer_Rig_Details'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Transfer_Rig_Details')), 'Offload Vehicle'))))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Transfer_Rig_Details')), 'Offload Vehicle')), 'Vehicle'))))) {
        } else {
          ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8')['TID'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Transfer_Rig_Details')), 'Offload Vehicle')), 'Vehicle'));
        }
      }
    }
    console.log('9');
    Load_Return = (_uow.upsert('Loads', ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8')));
    try {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1'))))) {
      } else {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'objectId'))]);
        removeItemInList((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load')), ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'objectId');
      }

    } catch (error) {
      console.log(error);

    }
    try {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2'))))) {
      } else {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Current Load', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'objectId'))]);
        removeItemInList((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Current Load')), ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'objectId');
      }

    } catch (error) {
      console.log(error);

    }
    try {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3'))))) {
      } else {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Current Load', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'objectId'))]);
        removeItemInList((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Current Load')), ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'objectId');
      }

    } catch (error) {
      console.log(error);

    }
    console.log('10');
    _uow.find('Loads', Backendless.DataQueryBuilder.create().setWhereClause((['TID = \'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')),'\''].join(''))).setPageSize(100));
    console.log(Tractor);
    _uow.addToRelation('Tractors', Tractor, 'Loads', Load);
    console.log('12');
    _uow.setRelation('Loads', Load, 'Rig_Tractor', Tractor);
    Trailer_List = [];
    console.log('14');
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, ' Trailer1'))))) {
    } else {
      addItemToList(Trailer_List, (getObjectProperty((getObjectProperty(Tractor, ' Trailer1')), 'objectId')));
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, ' Trailer2'))))) {
    } else {
      addItemToList(Trailer_List, (getObjectProperty(Tractor, 'objectId')));
    }
    console.log('15');
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, ' Trailer3'))))) {
    } else {
      addItemToList(Trailer_List, (getObjectProperty(Tractor, 'objectId')));
    }
    try {
      _uow.setRelation('Loads', Load, 'Rig_Trailers', Trailer_List);

    } catch (error) {
      console.log(error);

    }
    console.log('16');
    _uow.update('Loads', Load);

  })();

  Reloaded_Loads = (await Transactions.execute());
  (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))['Loads'] = (getObjectProperty((getObjectProperty((getObjectProperty(Reloaded_Loads, 'results')), 'findLoads1')), 'result'));
  console.log('17');
  console.log((await BackendlessUI.Functions.Custom['fn_88481472e3e169797cae85c104751a08']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))));
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('37ad3ef2d599972beb9890f3fe0b5e3d', true);
  await Load_Transaction();
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Load Initiated'];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('37ad3ef2d599972beb9890f3fe0b5e3d', false);
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('bed46198bd14dda817628f44ec924a1a', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Signature Delivery Driver'))))) {
    Viewer = false;
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Signature Delivery Depot'))))) {
      Viewer = false;
    } else {
      Viewer = true;
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/c1ce6a625b7ad269c0fa3e07e5d53e15/bundle.js', [], () => ({
  /* content */
  /* handler:onSaveSignatureClick */
  async ['onSaveSignatureClick'](___arguments) {
    var Transactions, error, Trailer_List, Load, Tractor, Load_Return, Mass, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function Load_Transaction() {
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2a056db9a916fae43ee80f960786f41d'))['disabled'] = true;
  Tractor = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Transfer_Planned')) == true) {
    Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Transfer_Rig_Details')), 'Offload Vehicle')), 'Vehicle')), Backendless.DataQueryBuilder.create().setRelated(['Trailer1', 'Trailer2', 'Trailer3'])));
  }
  Mass = [0];
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('beef64a3173f3eb6d4dd8df7ccd3a961'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Delivered'))))) {
      addItemToList(Mass, 0);
    } else {
      addItemToList(Mass, ((getObjectProperty(j, 'Delivered')) * (getObjectProperty(j, 'Unit mass'))));
    }
  }
  ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8')['Tonnage_Delivered'] = (Mass.reduce(function(x, y) {return x + y;}));
  ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8')['Date_Delivered'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8')['Status'] = 'Delivered';
  ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8')['Mileage_Delivery_Point'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Mileage'));
  delete ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8')['Mileage'];
  Transactions = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  Load = ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8');
  await ( async () => {
    const _uow = Transactions;

    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Transfer_Rig_Details'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Transfer_Rig_Details')), 'Offload Vehicle'))))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Transfer_Rig_Details')), 'Offload Vehicle')), 'Vehicle'))))) {
        } else {
          ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8')['TID'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Transfer_Rig_Details')), 'Offload Vehicle')), 'Vehicle'));
        }
      }
    }
    Load_Return = (_uow.upsert('Loads', ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8')));
    try {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1'))))) {
      } else {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'objectId'))]);
        removeItemInList((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer1')), 'Current Load')), ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'objectId');
      }

    } catch (error) {
      console.log(error);

    }
    try {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2'))))) {
      } else {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Current Load', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'objectId'))]);
        removeItemInList((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer2')), 'Current Load')), ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'objectId');
      }

    } catch (error) {
      console.log(error);

    }
    try {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3'))))) {
      } else {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Current Load', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'objectId'))]);
        removeItemInList((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Trailer3')), 'Current Load')), ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'objectId');
      }

    } catch (error) {
      console.log(error);

    }
    _uow.addToRelation('Tractors', Tractor, 'Loads', Load);
    _uow.setRelation('Loads', Load, 'Rig_Tractor', Tractor);
    Trailer_List = [];
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, ' Trailer1'))))) {
    } else {
      addItemToList(Trailer_List, (getObjectProperty((getObjectProperty(Tractor, ' Trailer1')), 'objectId')));
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, ' Trailer2'))))) {
    } else {
      addItemToList(Trailer_List, (getObjectProperty(Tractor, 'objectId')));
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, ' Trailer3'))))) {
    } else {
      addItemToList(Trailer_List, (getObjectProperty(Tractor, 'objectId')));
    }
    try {
      _uow.setRelation('Loads', Load, 'Rig_Trailers', Trailer_List);

    } catch (error) {
      console.log(error);

    }

  })();

  console.log((await Transactions.execute()));
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  ___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8')['Signature Delivery Driver'] = (await Backendless.Files.saveFile(encodePath((['users/',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'/','signatures'].join(''))), (String(generateUUID().long()) + String('.png')), ___arguments['signature'], false));
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78a12987b14abf095924b0bb61dfa4f7', false);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('aa330efb11af8c9ad63d7e95b2148b33');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('37ad3ef2d599972beb9890f3fe0b5e3d', true);
  await Load_Transaction();
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Load Initiated'];
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('bed46198bd14dda817628f44ec924a1a', undefined);
  ___arguments.context.pageData['Flash'] = true;

  },
  /* handler:onSaveSignatureClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/2d217683bfdfe18d8cb7bb6e93ca8f44/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('ef1d26a4fe6963ae8b4b910f8c5cf64f');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/78a12987b14abf095924b0bb61dfa4f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('aa330efb11af8c9ad63d7e95b2148b33');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Signature Delivery Depot'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/85a933cae56991e34342df2635eefaca/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products'))))) {
        Options = [];
      } else {
        Options = (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'Product')),[`label`]: [(getObjectProperty(item, 'Product')),' (',(getObjectProperty(item, 'Unit')),')'].join(''),[`Product`]: item });})));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  ___arguments.context.getComponentDataStoreByUid('ab1c656ae8aacd47abcf30b91d31b84d')['Product'] = (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products')), async (item) => {


   return ((getObjectProperty(item, 'Product')) == ___arguments.value);
  }));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFDRIVER/components/14f6c2b2f8b3860b8082c8077d421b84/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('14f6c2b2f8b3860b8082c8077d421b84');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['users/',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'/','loads'].join(''))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    var fileExt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split(',').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/2c9cc0f33cd8b98c67d3e71b9bab2f88/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('2c9cc0f33cd8b98c67d3e71b9bab2f88');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['users/',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'/','loads'].join(''))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    var fileExt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split(',').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/778421a52dd4a91a2f5586afcf228254/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('778421a52dd4a91a2f5586afcf228254');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['users/',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'/','loads'].join(''))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    var fileExt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split(',').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/453e547d1df72f9b4d2677ac91fff3cd/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('453e547d1df72f9b4d2677ac91fff3cd');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['users/',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'/','loads'].join(''))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    var fileExt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split(',').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/72e8b7e39b7197e5ffb4ab7ca5170281/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('72e8b7e39b7197e5ffb4ab7ca5170281');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['users/',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'/','loads'].join(''))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    var fileExt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split(',').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/37bdcf7fa5be5ec6e54b17290f28b189/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('37bdcf7fa5be5ec6e54b17290f28b189');

  },
  /* handler:onUploadFail */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['users/',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'/','loads'].join(''))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    var fileExt;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  fileExt = (getObjectProperty(___arguments.file, 'name')).split(',').slice(-1)[0];

  return ([(generateUUID().long()),'.',fileExt].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/29ae1e281c24e093592351df353e62f9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.dataModel);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/dbad882c708b29617452d3636b4b2593/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, Location, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'Status')) == 'Planned') {
    Location = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'LLPID')));
    }))[0];
    Content = String(getObjectProperty(Location, 'Name')) + String('\n(Click For Directions)');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'Status')) == 'Loaded') {
    Location = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'LDPID')));
    }))[0];
    Content = String(getObjectProperty(Location, 'Name')) + String('\n(Click For Directions)');
  } else {
    Content = null;
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Location, Content, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'Status')) == 'Planned') {
    Location = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'LLPID')));
    }))[0];
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://maps.google.com/?q=') + String([(getObjectProperty((getObjectProperty(Location, 'Point')), 'lat')),',',(getObjectProperty((getObjectProperty(Location, 'Point')), 'lng'))].join(''))), true, undefined);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'Status')) == 'Loaded') {
    Location = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'LDPID')));
    }))[0];
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://maps.google.com/?q=') + String([(getObjectProperty((getObjectProperty(Location, 'Point')), 'lat')),',',(getObjectProperty((getObjectProperty(Location, 'Point')), 'lng'))].join(''))), true, undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/4dd94f75f509132a4b81a89dbbc34aed/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'Status')) == 'Planned') {
    Content = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'Load_Product')) + String(' (LOAD)');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'Status')) == 'Loaded') {
    Content = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'Load_Product')) + String(' (DELIVER)');
  } else {
    Content = null;
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/8c581989db617f48bcae5cb32a059777/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'Status')) == 'Planned') {
    Content = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'Tonnage_Planned')) + String(' kg');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'Status')) == 'Loaded') {
    Content = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'Tonnage_Loaded')) + String(' kg');
  } else {
    Content = null;
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/a8828e21853a31db10325ca4b027e1cb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, item, Location;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'Status')) == 'Planned') {
    Location = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'LLPID')));
    }))[0];
    Content = (getObjectProperty(Location, 'Contact_Name'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'Status')) == 'Loaded') {
    Location = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'LDPID')));
    }))[0];
    Content = (getObjectProperty(Location, 'Contact_Name'));
  } else {
    Content = null;
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/dd21886eac1777a43266ec77c60aceba/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, item, Location;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'Status')) == 'Planned') {
    Location = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'LLPID')));
    }))[0];
    Content = (getObjectProperty(Location, 'Phone'));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'Status')) == 'Loaded') {
    Location = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'LDPID')));
    }))[0];
    Content = (getObjectProperty(Location, 'Phone'));
  } else {
    Content = null;
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/cc974cceb4ce878fd78ac5b1d6dd18a2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    if ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) != 'Delivered');
    })).length == 0 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Instruction')) == 'New Load') {
      Viewer = false;
    } else {
      Viewer = true;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/fd853ab68db6498d0766ca6e0eb64aa3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeUnmount */
  ['onBeforeUnmount'](___arguments) {
    var j;


  var j_list = (Object.keys(___arguments.context.dataModel));
  for (var j_index in j_list) {
    j = j_list[j_index];
    delete ___arguments.context.dataModel[j];
  }

  },
  /* handler:onBeforeUnmount */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var List, item, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
      List = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
        List = [];
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
          List = [];
        } else {
          List = (getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), 1, async (item) => {


           return (getObjectProperty(item, 'Distance'));
          }))[0]), 'objectId'));
        }
      }
    }

  } catch (error) {
    console.log(error);

  }
  try {
    ___arguments.context.dataModel['Load Point - Load Form Location'] = List;

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/FIFDRIVER/components/cc4a6374de1e08b84e8480b73de1407e/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var List, j, item, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads'))))) {
      List = [];
    } else {
      List = (await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')), async (item) => {


       return ((getObjectProperty(item, 'Status')) != 'Delivered');
      })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Load Point (Load Name)')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });})));
      for (var j_index in List) {
        j = List[j_index];
        if ((await asyncListFilter(List, async (item) => {


         return ((getObjectProperty(item, 'value')) == (getObjectProperty(j, 'value')));
        })).length > 1) {
          removeItemInList(List, j, 'value');
        } else {
        }
      }
    }

  } catch (error) {
    console.log(error);

  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'Status')) != 'Delivered');
  })).length == 0) {
    Viewer = false;
  } else {
    if ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) != 'Loaded');
    })).length > 1) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Next_Load, Location_Data, j, Last_Point, item, Time_Now, Time_Start, Last_Load;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Load Initiated'] = true;
  Last_Load = (await asyncListSort((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'Status')) == 'Delivered');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  }))[0];
  Next_Load = (await asyncListSort((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == ___arguments.value);
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  }))[0];
  console.log(Next_Load);
  console.log(Last_Load);
  Time_Now = (new Date());
  Time_Start = (new Date((new Date()).getTime() - (2700 * 1000)));
  Location_Data = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Device ID')), Time_Start, Time_Now));
  if (Location_Data.length > 0) {
    Last_Point = (await Promise.all(Location_Data.map(async item => {; return ({ [`lat`]: (getObjectProperty(item, 'position.latitude')),[`lng`]: (getObjectProperty(item, 'position.longitude')) });}))).slice(-1)[0];
    var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['Distance'] = (await BackendlessUI.Functions.Custom['fn_24a626fc74c34a9805e7999658bdcfd6'](Last_Point, (getObjectProperty(j, 'Point'))));
    }
  } else {
    Last_Point = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Location'));
    var j_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      j['Distance'] = (await BackendlessUI.Functions.Custom['fn_24a626fc74c34a9805e7999658bdcfd6'](Last_Point, (getObjectProperty(j, 'Point'))));
    }
  }
  if ((getObjectProperty(Next_Load, 'Status')) == 'Planned') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd853ab68db6498d0766ca6e0eb64aa3', true);
    await new Promise(r => setTimeout(r, 500 || 0));
    Next_Load['Mileage'] = (Location_Data.length > 0 ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((Location_Data.slice(-1)[0]), 'can.vehicle.mileage')))) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')) : (getObjectProperty((Location_Data.slice(-1)[0]), 'can.vehicle.mileage'))) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')));
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('fd853ab68db6498d0766ca6e0eb64aa3', Next_Load);
  } else if ((getObjectProperty(Next_Load, 'Status')) == 'Loaded') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc6315ac2726b292499170c40f7c02c8', true);
    await new Promise(r => setTimeout(r, 500 || 0));
    Next_Load['Mileage'] = (Location_Data.length > 0 ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((Location_Data.slice(-1)[0]), 'can.vehicle.mileage')))) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')) : (getObjectProperty((Location_Data.slice(-1)[0]), 'can.vehicle.mileage'))) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')));
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('bc6315ac2726b292499170c40f7c02c8', Next_Load);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFDRIVER/components/a01f170585022317a8dd6677449cd7e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Check_Frequency'));
  console.log(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Fuel_Counter'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/aeece121734d7527a2a20e285ba90a26/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'ID'))))) {
    Content = 'No Refrence Supplied';
  } else {
    Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'ID'));
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/4d649fdb727c481d249d2fe1af7a97f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('bed46198bd14dda817628f44ec924a1a', undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d649fdb727c481d249d2fe1af7a97f6'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4d649fdb727c481d249d2fe1af7a97f6'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFDRIVER/components/812e38feb8bfbdf1af3dbc78e824c16c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'Status')) == 'Planned') {
    Content = 'Load';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('29ae1e281c24e093592351df353e62f9'), 'Status')) == 'Loaded') {
    Content = 'Deliver';
  } else {
    Content = null;
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/8a62d85cd167581c2807918d2fbaf7f5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('76945b97db95226206c71b41243153cc', undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8a62d85cd167581c2807918d2fbaf7f5'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8a62d85cd167581c2807918d2fbaf7f5'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFDRIVER/components/9bd1ee945283c01a13b1339103bd5821/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('97562143424d06870fda5b778e11d0aa'), 'Product')), 'Product')),' ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('97562143424d06870fda5b778e11d0aa'), 'Product')), 'Unit')),' Loaded'].join(''))

  },
  /* handler:onLabelAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('97562143424d06870fda5b778e11d0aa'), 'Product')), 'Unit')) == 't') {
    if (___arguments.value > 100) {
      ___arguments.context.getComponentDataStoreByUid('97562143424d06870fda5b778e11d0aa')['Loaded'] = (___arguments.value / 1000);
    } else {
      if (___arguments.value >= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('97562143424d06870fda5b778e11d0aa'), 'Units')) * 2) {
        ___arguments.context.getComponentDataStoreByUid('97562143424d06870fda5b778e11d0aa')['Loaded'] = (___arguments.value / 10);
      } else {
        ___arguments.context.getComponentDataStoreByUid('97562143424d06870fda5b778e11d0aa')['Loaded'] = ___arguments.value;
      }
    }
  } else {
    ___arguments.context.getComponentDataStoreByUid('97562143424d06870fda5b778e11d0aa')['Loaded'] = ___arguments.value;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('97562143424d06870fda5b778e11d0aa'), 'Loaded')) >= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('97562143424d06870fda5b778e11d0aa'), 'Units')) * 1.2 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('97562143424d06870fda5b778e11d0aa'), 'Loaded')) <= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('97562143424d06870fda5b778e11d0aa'), 'Units')) * 0.8) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c29902bafa6cd1f44147487e51c3d95d'))['color'] = 'rgb(255, 0, 0)';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c29902bafa6cd1f44147487e51c3d95d'))['color'] = 'rgb(0, 255, 0)';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFDRIVER/components/224be73f2558c83276e980db05bdfd6f/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    var Repeater_Data, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Repeater_Data = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Product_JSON')), 'Planned'));

  } catch (error) {
    if (error) {
      Repeater_Data = null;
    }

  }

  return Repeater_Data

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/c29902bafa6cd1f44147487e51c3d95d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['LOAD ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('97562143424d06870fda5b778e11d0aa'), 'Units')),(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('97562143424d06870fda5b778e11d0aa'), 'Product')), 'Unit')),'  X  ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('97562143424d06870fda5b778e11d0aa'), 'Product')), 'Product'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/df5a793f44efcaaf625b88bed919845a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var j, list, Mass;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Mass = [0];
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('224be73f2558c83276e980db05bdfd6f'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Loaded'))))) {
      addItemToList(Mass, 0);
    } else {
      addItemToList(Mass, ((getObjectProperty(j, 'Loaded')) * (getObjectProperty(j, 'Unit mass'))));
    }
  }

  return (String(Mass.reduce(function(x, y) {return x + y;})) + String('kg'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/8d2e7fe6a01a7475799c40016647bf5b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Tonnage_Planned'))))) {
    Content = '0kg';
  } else {
    Content = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Tonnage_Planned')) + String('kg');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/7611d0358168058c4f9314ed96e351b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'New Load')) == true) {
    Viewer = true;
  } else {
    try {
      if ((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('224be73f2558c83276e980db05bdfd6f')), async (item) => {


       return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Loaded')))));
      })).length == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('224be73f2558c83276e980db05bdfd6f')).length) {
        Viewer = true;
      } else {
        Viewer = false;
      }

    } catch (error) {

    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/86dee60bd89798122f332cccc36e67cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Viewer, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('224be73f2558c83276e980db05bdfd6f'));
  console.log(await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('224be73f2558c83276e980db05bdfd6f')), async (item) => {


   return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Loaded')))));
  }));
  console.log((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('224be73f2558c83276e980db05bdfd6f')), async (item) => {


   return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Loaded')))));
  })).length);
  console.log((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('224be73f2558c83276e980db05bdfd6f')), async (item) => {


   return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Loaded')))));
  })).length == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('224be73f2558c83276e980db05bdfd6f')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/26df9f26580a532f53e66719670282ca/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Load Initiated'))))) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var Waypoints, Counter, j, Delivery_Location, Load_Location;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Instruction')).indexOf('LOAD') !== -1) {
    console.log('1');
    Load_Location = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'PointList')), 'Waypoints'))[(((await (async function(List, Property, Value) {
    	/**
    	 * Finds the index of the first item in `list` for which item[property] === value.
    	 * Returns -1 if:
    	 *   - list is not an array
    	 *   - property is not a valid string
    	 *   - no item matches
    	 */
    	function run(list, property, value) {
    	  if (!Array.isArray(list) || typeof property !== "string" || !property) {
    	    return -1;
    	  }
    	  
    	  for (let i = 0; i < list.length; i++) {
    	    const item = list[i];
    	    
    	    // Skip null/undefined items
    	    if (item == null) {
    	      continue;
    	    }
    	    
    	    // Check if the item has the property and if it matches the value
    	    if (Object.prototype.hasOwnProperty.call(item, property) && item[property] === value) {
    	      return i;
    	    }
    	  }
    	  
    	  // No match found
    	  return -1;
    	}
    	
    	// The final line in your custom code block must return the result
    	return run(List, Property, Value);

    })((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'PointList')), 'Waypoints')), 'objectId', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'LLPID')))) + 1) - 1)];
    (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('af385dc3ebe2984f6847fb6c292554ac', ((getObjectProperty((getObjectProperty(Load_Location, 'Point')), 'coordinates')).slice(-1)[0]), ((getObjectProperty((getObjectProperty(Load_Location, 'Point')), 'coordinates'))[0]));
    Waypoints = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'PointList')), 'Waypoints')).slice(0, (await (async function(List, Property, Value) {
    	/**
    	 * Finds the index of the first item in `list` for which item[property] === value.
    	 * Returns -1 if:
    	 *   - list is not an array
    	 *   - property is not a valid string
    	 *   - no item matches
    	 */
    	function run(list, property, value) {
    	  if (!Array.isArray(list) || typeof property !== "string" || !property) {
    	    return -1;
    	  }
    	  
    	  for (let i = 0; i < list.length; i++) {
    	    const item = list[i];
    	    
    	    // Skip null/undefined items
    	    if (item == null) {
    	      continue;
    	    }
    	    
    	    // Check if the item has the property and if it matches the value
    	    if (Object.prototype.hasOwnProperty.call(item, property) && item[property] === value) {
    	      return i;
    	    }
    	  }
    	  
    	  // No match found
    	  return -1;
    	}
    	
    	// The final line in your custom code block must return the result
    	return run(List, Property, Value);

    })((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'PointList')), 'Waypoints')), 'objectId', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'LLPID')))) + 1);
    Counter = 0;
    for (var j_index in Waypoints) {
      j = Waypoints[j_index];
      Counter = Counter + 1;
      j['leg'] = ((getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'Route')), 'Start Leg')), 'Route')), 'routes'))[0]), 'legs'))[(Counter - 1)]);
    }
    await new Promise(r => setTimeout(r, 2000 || 0));
    await (async function(googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers, pointColor, pointScale, vehicleId, geofences, stations, stationIconSvg, canAddGeofences, polygonColor, appData) {
    	let existingMarkers = [];
    	let existingPolylines = [];
    	let existingGeofences = [];
    	let currentInfoWindow = null;
    	let selectedMarker = null;
    	let geofenceMarkers = [];
    	let geofencePolygon = null;
    	let addingGeofence = false;
    	
    	appData = appData || {};
    	
    	function addPolylineAndCustomMarkers(
    	  googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers,
    	  pointColor, pointScale, vehicleId, geofences, stations, stationIconSvg, enableGeofence, polygonColor, appData
    	) {
    	  if (!googleMapComponent || !googleMapComponent.map) {
    	    return;
    	  }
    	
    	  const mapInstance = googleMapComponent.map.map;
    	  if (!(mapInstance instanceof google.maps.Map)) {
    	    return;
    	  }
    	
    	  // Polyline logic
    	  const polylineCoordinates = markers.map(marker => ({
    	    lat: marker.lat,
    	    lng: marker.lng
    	  }));
    	
    	  const polyline = new google.maps.Polyline({
    	    path: polylineCoordinates,
    	    geodesic: true,
    	    strokeColor: polylineColor || '#FF0000',
    	    strokeOpacity: strokeOpacity || 1.0,
    	    strokeWeight: strokeWeight || 2
    	  });
    	
    	  polyline.setMap(mapInstance);
    	  existingPolylines.push(polyline);
    	
    	  function calculateHeading(lat1, lng1, lng2, lat2) {
    	    const toRadians = degrees => degrees * Math.PI / 180;
    	    const toDegrees = radians => degrees * 180 / Math.PI;
    	
    	    const dLng = toRadians(lng2 - lng1);
    	    const y = Math.sin(dLng) * Math.cos(toRadians(lat2));
    	    const x = Math.cos(toRadians(lat1)) * Math.sin(toRadians(lat2)) - Math.sin(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.cos(dLng);
    	    const bearing = toDegrees(Math.atan2(y, x));
    	    return (bearing + 360) % 360;
    	  }
    	
    	  // Add custom markers to the map
    	pointMarkers.forEach((marker, index) => {
    	  let icon;
    	  let markerOptions = {
    	    position: { lat: marker.lat, lng: marker.lng },
    	    map: mapInstance,
    	    draggable: false,
    	  };
    	
    	  // Check for Icon property and use it if available
    	  if (marker.Icon) {
    	    icon = {
    	      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(marker.Icon)}`,
    	      anchor: new google.maps.Point(25, 25),
    	      scaledSize: new google.maps.Size(50, 50) // Adjust size as needed
    	    };
    	
    	    // Set a high zIndex to ensure it sits on top of other markers
    	    markerOptions.zIndex = google.maps.Marker.MAX_ZINDEX + 1;
    	  } else {
    	    let iconColor = marker.color || pointColor || '#FF0000';
    	
    	    if (marker.Speed === 0) {
    	      icon = {
    	        path: google.maps.SymbolPath.CIRCLE,
    	        fillColor: iconColor,
    	        fillOpacity: 1,
    	        strokeColor: 'black',
    	        strokeWeight: 2,
    	        scale: marker.scale || pointScale || 8
    	      };
    	
    	      if (index === pointMarkers.length - 1 && vehicleId) {
    	        const crosshairSvg = `
    	        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    	        <circle cx="12" cy="12" r="10"></circle>
    	        <line x1="12" y1="2" x2="12" y2="6"></line>
    	        <line x1="12" y1="18" x2="12" y2="22"></line>
    	        <line x1="2" y1="12" x2="6" y2="12"></line>
    	        <line x1="18" y1="12" x2="22" y2="12"></line>
    	        </svg>
    	        `;
    	
    	        icon = {
    	          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(crosshairSvg)}`,
    	          anchor: new google.maps.Point(25, 25),
    	          scaledSize: new google.maps.Size(50, 50)
    	        };
    	      }
    	
    	    } else {
    	      let heading = marker.Direction !== undefined ? marker.Direction : 0;
    	      if (marker.Direction === undefined && index < pointMarkers.length - 1) {
    	        const nextMarker = pointMarkers[index + 1];
    	        heading = calculateHeading(marker.lat, marker.lng, nextMarker.lng, nextMarker.lat);
    	      }
    	
    	      heading = (heading - 90 + 360) % 360;
    	
    	      const iconPath = "M 0 0 L -1 -1 L 1 0 L -1 1 Z";
    	      if (iconColor.toLowerCase() === '#000000' || iconColor.toLowerCase() === 'black') {
    	        icon = {
    	          path: iconPath,
    	          fillColor: iconColor,
    	          fillOpacity: 1,
    	          strokeColor: 'white',
    	          strokeWeight: 3,
    	          rotation: heading,
    	          scale: marker.scale || pointScale || 8,
    	          anchor: new google.maps.Point(0, 0)
    	        };
    	      } else {
    	        icon = {
    	          path: iconPath,
    	          fillColor: iconColor,
    	          fillOpacity: 1,
    	          strokeColor: 'black',
    	          strokeWeight: 2,
    	          rotation: heading,
    	          scale: marker.scale || pointScale || 8,
    	          anchor: new google.maps.Point(0, 0)
    	        };
    	      }
    	    }
    	  }
    	
    	  // Apply the icon to the marker options
    	  markerOptions.icon = icon;
    	
    	  const pointMarker = new google.maps.Marker(markerOptions);
    	
    	  existingMarkers.push(pointMarker);
    	
    	  if (marker.Data) {
    	    const infowindow = new google.maps.InfoWindow({
    	      content: marker.Data
    	    });
    	
    	    pointMarker.addListener('click', function() {
    	      if (currentInfoWindow) {
    	        currentInfoWindow.close();
    	      }
    	      infowindow.open(mapInstance, pointMarker);
    	      currentInfoWindow = infowindow;
    	
    	      selectedMarker = pointMarker;
    	    });
    	  }
    	
    	  pointMarker.addListener('click', function() {
    	    selectedMarker = pointMarker;
    	  });
    	});
    	
    	
    	
    	  // Add Geofences
    	  if (geofences && Array.isArray(geofences)) {
    	    geofences.forEach(geofence => {
    	      if (geofence["Geo Fences"] && geofence["Geo Fences"].boundary && Array.isArray(geofence["Geo Fences"].boundary.points)) {
    	        const polygonCoords = geofence["Geo Fences"].boundary.points.map(point => ({
    	          lat: point.y,
    	          lng: point.x
    	        }));
    	
    	        const polygon = new google.maps.Polygon({
    	          paths: polygonCoords,
    	          strokeColor: geofence.Color,
    	          strokeOpacity: 0.9,
    	          strokeWeight: 4,
    	          fillColor: geofence.Color,
    	          fillOpacity: 0.25
    	        });
    	
    	        polygon.setMap(mapInstance);
    	        existingGeofences.push(polygon);
    	
    	        google.maps.event.addListener(polygon, 'click', function(event) {
    	          const infowindow = new google.maps.InfoWindow({
    	            content: createGeofencePopupContent(geofence, polygon, mapInstance, appData)
    	          });
    	
    	          infowindow.setPosition(event.latLng);
    	          infowindow.open(mapInstance);
    	          currentInfoWindow = infowindow;
    	        });
    	      }
    	    });
    	  }
    	
    	  // Add Stations
    	  if (stations && Array.isArray(stations)) {
    	    stations.forEach(station => {
    	      if (station["Geo Fence"] && station["Geo Fence"].boundary && station["Geo Fence"].boundary.points) {
    	        const stationCoords = station["Geo Fence"].boundary.points.map(point => ({
    	          lat: point.y,
    	          lng: point.x
    	        }));
    	
    	        const polygon = new google.maps.Polygon({
    	          paths: stationCoords,
    	          strokeColor: station.Color,
    	          strokeOpacity: 0.9,
    	          strokeWeight: 4,
    	          fillColor: station.Color,
    	          fillOpacity: 0.25
    	        });
    	
    	        polygon.setMap(mapInstance);
    	        existingGeofences.push(polygon);
    	
    	        // Check for station location
    	        if (station.Location && station.Location.x !== undefined && station.Location.y !== undefined) {
    	          const icon = {
    	            url: stationIconSvg,
    	            anchor: new google.maps.Point(25, 50),
    	            scaledSize: new google.maps.Size(50, 50)
    	          };
    	
    	          const stationCenter = {
    	            lat: station.Location.y,
    	            lng: station.Location.x
    	          };
    	          const stationMarker = new google.maps.Marker({
    	            position: stationCenter,
    	            map: mapInstance,
    	            icon: icon
    	          });
    	
    	          existingMarkers.push(stationMarker);
    	
    	          google.maps.event.addListener(stationMarker, 'click', function(event) {
    	            const infowindow = new google.maps.InfoWindow({
    	              content: createStationPopupContent(station)
    	            });
    	
    	            infowindow.open(mapInstance, stationMarker);
    	            currentInfoWindow = infowindow;
    	          });
    	        }
    	      }
    	    });
    	  }
    	
    	  if (pointMarkers.length > 0) {
    	    const latestMarker = pointMarkers[pointMarkers.length - 1];
    	    if (latestMarker) {
    	      mapInstance.setCenter({
    	        lat: latestMarker.lat, lng: latestMarker.lng
    	      });
    	    }
    	  }
    	
    	  // Adding Geofence Markers
    	  if (enableGeofence) {
    	    google.maps.event.addListener(mapInstance, 'click', function(event) {
    	      addGeofenceMarker(event.latLng);
    	    });
    	  }
    	
    	  function addGeofenceMarker(location) {
    	    const markerIndex = geofenceMarkers.length;
    	
    	    const icon = {
    	      path: google.maps.SymbolPath.CIRCLE,
    	      fillColor: markerIndex === geofenceMarkers.length - 1 ? '#FFFFFF' : polygonColor || '#FF0000',
    	      fillOpacity: 1,
    	      strokeColor: 'black',
    	      strokeWeight: 2,
    	      scale: 8
    	    };
    	
    	    const marker = new google.maps.Marker({
    	      position: location,
    	      map: mapInstance,
    	      icon: icon,
    	      draggable: true
    	    });
    	
    	    geofenceMarkers.push(marker);
    	
    	    marker.addListener('dragend', updateGeofencePolygon);
    	    marker.addListener('click', function() {
    	      marker.setMap(null);
    	      const markerIndex = geofenceMarkers.indexOf(marker);
    	      if (markerIndex !== -1) {
    	        geofenceMarkers.splice(markerIndex, 1);
    	        updateGeofencePolygon();
    	      }
    	    });
    	
    	    if (geofenceMarkers.length > 2) {
    	      const firstMarker = geofenceMarkers[0];
    	      if (location.equals(firstMarker.getPosition())) {
    	        createGeofencePolygon();
    	      }
    	    }
    	
    	    updateGeofencePolygon();
    	  }
    	
    	  function updateGeofencePolygon() {
    	    const path = geofenceMarkers.map(marker => marker.getPosition());
    	
    	    if (geofencePolygon) {
    	      geofencePolygon.setPath(path);
    	    } else {
    	      geofencePolygon = new google.maps.Polygon({
    	        paths: path,
    	        strokeColor: polygonColor || '#FF0000',
    	        strokeOpacity: 0.8,
    	        strokeWeight: 2,
    	        fillColor: polygonColor || '#FF0000',
    	        fillOpacity: 0.35
    	      });
    	
    	      geofencePolygon.setMap(mapInstance);
    	    }
    	
    	    // Save the created polygon to App Data, overriding the existing value
    	    appData.geofencePolygons = {
    	      path: path.map(latLng => ({
    	        lat: latLng.lat(), lng: latLng.lng()
    	      })),
    	      color: polygonColor || '#FF0000'
    	    };
    	  }
    	
    	  function createGeofencePolygon() {
    	    const path = geofenceMarkers.map(marker => marker.getPosition());
    	
    	    if (geofencePolygon) {
    	      geofencePolygon.setPath(path);
    	    } else {
    	      geofencePolygon = new google.maps.Polygon({
    	        paths: path,
    	        strokeColor: polygonColor || '#FF0000',
    	        strokeOpacity: 0.8,
    	        strokeWeight: 2,
    	        fillColor: polygonColor || '#FF0000',
    	        fillOpacity: 0.35
    	      });
    	
    	      geofencePolygon.setMap(mapInstance);
    	    }
    	  }
    	
    	  function createGeofencePopupContent(geofence, polygon, mapInstance, appData) {
    	    const geofences = appData.User.Company.Locations;
    	
    	    const content = document.createElement('div');
    	    content.style.padding = '10px';
    	    content.style.fontFamily = 'Arial, sans-serif';
    	    content.style.color = 'white';
    	
    	    const headerDiv = document.createElement('div');
    	    headerDiv.style.display = 'flex';
    	    headerDiv.style.justifyContent = 'space-between';
    	    headerDiv.style.alignItems = 'center';
    	
    	    const title = document.createElement('h3');
    	    title.style.margin = '0';
    	    title.textContent = geofence.Name;
    	
    	    const iconDiv = document.createElement('div');
    	    iconDiv.style.display = 'flex';
    	    iconDiv.style.gap = '10px';
    	
    	    // Edit Icon
    	    const editIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    	    editIcon.setAttribute('width', '24');
    	    editIcon.setAttribute('height', '24');
    	    editIcon.setAttribute('viewBox', '0 0 24 24');
    	    editIcon.setAttribute('fill', 'none');
    	    editIcon.setAttribute('stroke', 'white');
    	    editIcon.setAttribute('stroke-width', '2');
    	    editIcon.setAttribute('stroke-linecap', 'round');
    	    editIcon.setAttribute('stroke-linejoin', 'round');
    	    editIcon.style.cursor = 'pointer';
    	
    	    const editPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    	    editPath.setAttribute('d', 'M12 20h9');
    	    editIcon.appendChild(editPath);
    	
    	    const editPath2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    	    editPath2.setAttribute('d', 'M16.5 3.5a2.121 2.121 0 010 3l-10 10-4 1 1-4 10-10a2.121 2.121 0 013 0z');
    	    editIcon.appendChild(editPath2);
    	
    	    // Delete Icon
    	    const deleteIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    	    deleteIcon.setAttribute('width', '24');
    	    deleteIcon.setAttribute('height', '24');
    	    deleteIcon.setAttribute('viewBox', '0 0 24 24');
    	    deleteIcon.setAttribute('fill', 'none');
    	    deleteIcon.setAttribute('stroke', 'white');
    	    deleteIcon.setAttribute('stroke-width', '2');
    	    deleteIcon.setAttribute('stroke-linecap', 'round');
    	    deleteIcon.setAttribute('stroke-linejoin', 'round');
    	    deleteIcon.style.cursor = 'pointer';
    	
    	    const polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
    	    polyline.setAttribute('points', '3 6 5 6 21 6');
    	    deleteIcon.appendChild(polyline);
    	
    	    const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    	    path1.setAttribute('d', 'M19 6L17.707 18H6.293L5 6');
    	    deleteIcon.appendChild(path1);
    	
    	    // Add Icons to iconDiv
    	    iconDiv.appendChild(editIcon);
    	    iconDiv.appendChild(deleteIcon);
    	
    	    headerDiv.appendChild(title);
    	    headerDiv.appendChild(iconDiv);
    	
    	    content.appendChild(headerDiv);
    	
    	    const address = document.createElement('p');
    	    address.innerHTML = `<strong>Address:</strong> ${geofence.Address}`;
    	    content.appendChild(address);
    	
    	    const contactName = document.createElement('p');
    	    contactName.innerHTML = `<strong>Contact Name:</strong> ${geofence.Contact_Name}`;
    	    content.appendChild(contactName);
    	
    	    const phone = document.createElement('p');
    	    phone.innerHTML = `<strong>Phone:</strong> ${geofence.Phone}`;
    	    content.appendChild(phone);
    	
    	    const infowindow = new google.maps.InfoWindow({
    	      content: content,
    	      disableAutoPan: true
    	    });
    	
    	    // Add event listener to the polygon to handle the click
    	    polygon.addListener('click', function(event) {
    	      infowindow.setPosition(event.latLng);
    	      infowindow.open(mapInstance);
    	      currentInfoWindow = infowindow;
    	    });
    	
    	    editIcon.addEventListener('click',
    	      async function () {
    	        const isEditable = polygon.getEditable();
    	        polygon.setEditable(!isEditable);
    	
    	        if (!isEditable) {
    	          editIcon.innerHTML = ''; // Switch to save icon
    	          const checkPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    	          checkPath.setAttribute('d', 'M20 6L9 17l-5-5');
    	          editIcon.appendChild(checkPath);
    	        } else {
    	          const newPath = polygon.getPath().getArray().map(latLng => [latLng.lng(), latLng.lat()]);
    	
    	          const updatedGeofence = geofences.find(loc => loc.objectId === geofence.objectId);
    	
    	          updatedGeofence["Geo Fences"] = {
    	            type: "Polygon",
    	            coordinates: [newPath],
    	            srs: {
    	              srsId: 4326,
    	              name: 'WGS 84'
    	            },
    	            holes: [] // Add holes if applicable or leave as an empty array
    	          };
    	
    	          const sanitizedGeofence = JSON.parse(JSON.stringify(updatedGeofence, (key, value) => {
    	            if (typeof value === 'function' || value instanceof Element) {
    	              return undefined;
    	            }
    	            return value;
    	          }));
    	
    	          const result = await Backendless.Data.of('Locations').save(sanitizedGeofence, true);
    	
    	          const index = geofences.findIndex(loc => loc.objectId === geofence.objectId);
    	          if (index !== -1) {
    	            geofences[index] = result;
    	          }
    	
    	          editIcon.innerHTML = '';
    	          editIcon.appendChild(editPath);
    	          editIcon.appendChild(editPath2);
    	        }
    	      });
    	
    	    // Handling Delete Icon Click
    	    deleteIcon.addEventListener('click',
    	      async function() {
    	        const confirmation = confirm(`Are you sure you want to delete the location: ${geofence.Name}?`);
    	        if (confirmation) {
    	          await Backendless.Data.of('Locations').remove(geofence.objectId);
    	
    	          appData.User.Company.Locations = await asyncListFilter(geofences, async (item) => {
    	            return (geofence.objectId !== item.objectId);
    	          });
    	
    	          polygon.setMap(null);
    	          infowindow.close();
    	        }
    	      });
    	
    	    return content;
    	  }
    	
    	  // Supporting Functions
    	
    	  async function asyncListFilter(sourceList,
    	    callback) {
    	    const list = await Promise.all(sourceList.map(async source => ({
    	      source,
    	      value: await callback(source),
    	    })));
    	
    	    const resultList = list.filter(item => item.value);
    	
    	    return resultList.map(item => item.source);
    	  }
    	}
    	
    	// Helper function to create popup content for stations
    	function createStationPopupContent(station) {
    	  return `
    	  <div style="padding: 10px; font-family: Arial, sans-serif; color: white;">
    	  <table>
    	  <tr><td><strong>Station Name:</strong></td><td>${station.Station_Name}</td></tr>
    	  <tr><td><strong>Brand:</strong></td><td>${station.Brand}</td></tr>
    	  <tr><td><strong>Contact Name:</strong></td><td>${station.Contact_Name}</td></tr>
    	  <tr><td><strong>Phone:</strong></td><td>${station.Contact_Number}</td></tr>
    	  <tr><td><strong>Address:</strong></td><td>${station.Province}, ${station.Town}</td></tr>
    	  <tr><td><strong>Price:</strong></td><td>${station.Price}</td></tr>
    	  <tr><td><strong>Truck Stop:</strong></td><td>${station.Truck_Stop ? 'Yes': 'No'}</td></tr>
    	  </table>
    	  <p><strong>Services:</strong></p>
    	  <ul>
    	  ${(Array.isArray(station.Services) ? station.Services: []).map(service => `<li>${service}</li>`).join('')}
    	  </ul>
    	  </div>
    	  `;
    	}
    	
    	try {
    	  const googleMapComponent = arguments[0];
    	  const polylineColor = arguments[1];
    	  const markers = arguments[2];
    	  const strokeOpacity = arguments[3];
    	  const strokeWeight = arguments[4];
    	  const pointMarkers = arguments[5];
    	  const pointColor = arguments[6];
    	  const pointScale = arguments[7];
    	  const vehicleId = arguments[8];
    	  const geofences = arguments[9];
    	  const stations = arguments[10];
    	  const stationIconSvg = arguments[11];
    	  const enableGeofence = arguments[12];
    	  const polygonColor = arguments[13];
    	  const appData = arguments[14];
    	  addPolylineAndCustomMarkers(
    	    googleMapComponent,
    	    polylineColor,
    	    markers,
    	    strokeOpacity,
    	    strokeWeight,
    	    pointMarkers,
    	    pointColor,
    	    pointScale,
    	    vehicleId,
    	    geofences,
    	    stations,
    	    stationIconSvg,
    	    enableGeofence,
    	    polygonColor,
    	    appData// Pass the FuelLossSvg as the last argument
    	  );
    	} catch (error) {
    	  // No error handling
    	}
    })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('af385dc3ebe2984f6847fb6c292554ac')), '#FFFFFF', (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'Route')), 'Start Leg')), 'Polyline')), 1, 7, null, null, null, null, null, null, null, null, null, null);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Instruction')).indexOf('DELIVER') !== -1) {
    console.log('2');
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'Return'))))) {
      console.log('3');
      Delivery_Location = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'PointList')), '"Destination "'));
      (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('af385dc3ebe2984f6847fb6c292554ac', ((getObjectProperty((getObjectProperty(Delivery_Location, 'Point')), 'coordinates')).slice(-1)[0]), ((getObjectProperty((getObjectProperty(Delivery_Location, 'Point')), 'coordinates'))[0]));
      Waypoints = subsequenceFromStartLast((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'PointList')), 'Waypoints')), ((await (async function(List, Property, Value) {
      	/**
      	 * Finds the index of the first item in `list` for which item[property] === value.
      	 * Returns -1 if:
      	 *   - list is not an array
      	 *   - property is not a valid string
      	 *   - no item matches
      	 */
      	function run(list, property, value) {
      	  if (!Array.isArray(list) || typeof property !== "string" || !property) {
      	    return -1;
      	  }
      	  
      	  for (let i = 0; i < list.length; i++) {
      	    const item = list[i];
      	    
      	    // Skip null/undefined items
      	    if (item == null) {
      	      continue;
      	    }
      	    
      	    // Check if the item has the property and if it matches the value
      	    if (Object.prototype.hasOwnProperty.call(item, property) && item[property] === value) {
      	      return i;
      	    }
      	  }
      	  
      	  // No match found
      	  return -1;
      	}
      	
      	// The final line in your custom code block must return the result
      	return run(List, Property, Value);

      })((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'PointList')), 'Waypoints')), 'objectId', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'LLPID')))) - 1));
      Counter = 0;
      for (var j_index2 in Waypoints) {
        j = Waypoints[j_index2];
        Counter = Counter + 1;
        j['leg'] = ((getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'Route')), 'Loaded Leg')), 'Route')), 'routes'))[0]), 'legs'))[(Counter - 1)]);
      }
      await new Promise(r => setTimeout(r, 2000 || 0));
      await (async function(googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers, pointColor, pointScale, vehicleId, geofences, stations, stationIconSvg, canAddGeofences, polygonColor, appData) {
      	let existingMarkers = [];
      	let existingPolylines = [];
      	let existingGeofences = [];
      	let currentInfoWindow = null;
      	let selectedMarker = null;
      	let geofenceMarkers = [];
      	let geofencePolygon = null;
      	let addingGeofence = false;
      	
      	appData = appData || {};
      	
      	function addPolylineAndCustomMarkers(
      	  googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers,
      	  pointColor, pointScale, vehicleId, geofences, stations, stationIconSvg, enableGeofence, polygonColor, appData
      	) {
      	  if (!googleMapComponent || !googleMapComponent.map) {
      	    return;
      	  }
      	
      	  const mapInstance = googleMapComponent.map.map;
      	  if (!(mapInstance instanceof google.maps.Map)) {
      	    return;
      	  }
      	
      	  // Polyline logic
      	  const polylineCoordinates = markers.map(marker => ({
      	    lat: marker.lat,
      	    lng: marker.lng
      	  }));
      	
      	  const polyline = new google.maps.Polyline({
      	    path: polylineCoordinates,
      	    geodesic: true,
      	    strokeColor: polylineColor || '#FF0000',
      	    strokeOpacity: strokeOpacity || 1.0,
      	    strokeWeight: strokeWeight || 2
      	  });
      	
      	  polyline.setMap(mapInstance);
      	  existingPolylines.push(polyline);
      	
      	  function calculateHeading(lat1, lng1, lng2, lat2) {
      	    const toRadians = degrees => degrees * Math.PI / 180;
      	    const toDegrees = radians => degrees * 180 / Math.PI;
      	
      	    const dLng = toRadians(lng2 - lng1);
      	    const y = Math.sin(dLng) * Math.cos(toRadians(lat2));
      	    const x = Math.cos(toRadians(lat1)) * Math.sin(toRadians(lat2)) - Math.sin(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.cos(dLng);
      	    const bearing = toDegrees(Math.atan2(y, x));
      	    return (bearing + 360) % 360;
      	  }
      	
      	  // Add custom markers to the map
      	pointMarkers.forEach((marker, index) => {
      	  let icon;
      	  let markerOptions = {
      	    position: { lat: marker.lat, lng: marker.lng },
      	    map: mapInstance,
      	    draggable: false,
      	  };
      	
      	  // Check for Icon property and use it if available
      	  if (marker.Icon) {
      	    icon = {
      	      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(marker.Icon)}`,
      	      anchor: new google.maps.Point(25, 25),
      	      scaledSize: new google.maps.Size(50, 50) // Adjust size as needed
      	    };
      	
      	    // Set a high zIndex to ensure it sits on top of other markers
      	    markerOptions.zIndex = google.maps.Marker.MAX_ZINDEX + 1;
      	  } else {
      	    let iconColor = marker.color || pointColor || '#FF0000';
      	
      	    if (marker.Speed === 0) {
      	      icon = {
      	        path: google.maps.SymbolPath.CIRCLE,
      	        fillColor: iconColor,
      	        fillOpacity: 1,
      	        strokeColor: 'black',
      	        strokeWeight: 2,
      	        scale: marker.scale || pointScale || 8
      	      };
      	
      	      if (index === pointMarkers.length - 1 && vehicleId) {
      	        const crosshairSvg = `
      	        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      	        <circle cx="12" cy="12" r="10"></circle>
      	        <line x1="12" y1="2" x2="12" y2="6"></line>
      	        <line x1="12" y1="18" x2="12" y2="22"></line>
      	        <line x1="2" y1="12" x2="6" y2="12"></line>
      	        <line x1="18" y1="12" x2="22" y2="12"></line>
      	        </svg>
      	        `;
      	
      	        icon = {
      	          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(crosshairSvg)}`,
      	          anchor: new google.maps.Point(25, 25),
      	          scaledSize: new google.maps.Size(50, 50)
      	        };
      	      }
      	
      	    } else {
      	      let heading = marker.Direction !== undefined ? marker.Direction : 0;
      	      if (marker.Direction === undefined && index < pointMarkers.length - 1) {
      	        const nextMarker = pointMarkers[index + 1];
      	        heading = calculateHeading(marker.lat, marker.lng, nextMarker.lng, nextMarker.lat);
      	      }
      	
      	      heading = (heading - 90 + 360) % 360;
      	
      	      const iconPath = "M 0 0 L -1 -1 L 1 0 L -1 1 Z";
      	      if (iconColor.toLowerCase() === '#000000' || iconColor.toLowerCase() === 'black') {
      	        icon = {
      	          path: iconPath,
      	          fillColor: iconColor,
      	          fillOpacity: 1,
      	          strokeColor: 'white',
      	          strokeWeight: 3,
      	          rotation: heading,
      	          scale: marker.scale || pointScale || 8,
      	          anchor: new google.maps.Point(0, 0)
      	        };
      	      } else {
      	        icon = {
      	          path: iconPath,
      	          fillColor: iconColor,
      	          fillOpacity: 1,
      	          strokeColor: 'black',
      	          strokeWeight: 2,
      	          rotation: heading,
      	          scale: marker.scale || pointScale || 8,
      	          anchor: new google.maps.Point(0, 0)
      	        };
      	      }
      	    }
      	  }
      	
      	  // Apply the icon to the marker options
      	  markerOptions.icon = icon;
      	
      	  const pointMarker = new google.maps.Marker(markerOptions);
      	
      	  existingMarkers.push(pointMarker);
      	
      	  if (marker.Data) {
      	    const infowindow = new google.maps.InfoWindow({
      	      content: marker.Data
      	    });
      	
      	    pointMarker.addListener('click', function() {
      	      if (currentInfoWindow) {
      	        currentInfoWindow.close();
      	      }
      	      infowindow.open(mapInstance, pointMarker);
      	      currentInfoWindow = infowindow;
      	
      	      selectedMarker = pointMarker;
      	    });
      	  }
      	
      	  pointMarker.addListener('click', function() {
      	    selectedMarker = pointMarker;
      	  });
      	});
      	
      	
      	
      	  // Add Geofences
      	  if (geofences && Array.isArray(geofences)) {
      	    geofences.forEach(geofence => {
      	      if (geofence["Geo Fences"] && geofence["Geo Fences"].boundary && Array.isArray(geofence["Geo Fences"].boundary.points)) {
      	        const polygonCoords = geofence["Geo Fences"].boundary.points.map(point => ({
      	          lat: point.y,
      	          lng: point.x
      	        }));
      	
      	        const polygon = new google.maps.Polygon({
      	          paths: polygonCoords,
      	          strokeColor: geofence.Color,
      	          strokeOpacity: 0.9,
      	          strokeWeight: 4,
      	          fillColor: geofence.Color,
      	          fillOpacity: 0.25
      	        });
      	
      	        polygon.setMap(mapInstance);
      	        existingGeofences.push(polygon);
      	
      	        google.maps.event.addListener(polygon, 'click', function(event) {
      	          const infowindow = new google.maps.InfoWindow({
      	            content: createGeofencePopupContent(geofence, polygon, mapInstance, appData)
      	          });
      	
      	          infowindow.setPosition(event.latLng);
      	          infowindow.open(mapInstance);
      	          currentInfoWindow = infowindow;
      	        });
      	      }
      	    });
      	  }
      	
      	  // Add Stations
      	  if (stations && Array.isArray(stations)) {
      	    stations.forEach(station => {
      	      if (station["Geo Fence"] && station["Geo Fence"].boundary && station["Geo Fence"].boundary.points) {
      	        const stationCoords = station["Geo Fence"].boundary.points.map(point => ({
      	          lat: point.y,
      	          lng: point.x
      	        }));
      	
      	        const polygon = new google.maps.Polygon({
      	          paths: stationCoords,
      	          strokeColor: station.Color,
      	          strokeOpacity: 0.9,
      	          strokeWeight: 4,
      	          fillColor: station.Color,
      	          fillOpacity: 0.25
      	        });
      	
      	        polygon.setMap(mapInstance);
      	        existingGeofences.push(polygon);
      	
      	        // Check for station location
      	        if (station.Location && station.Location.x !== undefined && station.Location.y !== undefined) {
      	          const icon = {
      	            url: stationIconSvg,
      	            anchor: new google.maps.Point(25, 50),
      	            scaledSize: new google.maps.Size(50, 50)
      	          };
      	
      	          const stationCenter = {
      	            lat: station.Location.y,
      	            lng: station.Location.x
      	          };
      	          const stationMarker = new google.maps.Marker({
      	            position: stationCenter,
      	            map: mapInstance,
      	            icon: icon
      	          });
      	
      	          existingMarkers.push(stationMarker);
      	
      	          google.maps.event.addListener(stationMarker, 'click', function(event) {
      	            const infowindow = new google.maps.InfoWindow({
      	              content: createStationPopupContent(station)
      	            });
      	
      	            infowindow.open(mapInstance, stationMarker);
      	            currentInfoWindow = infowindow;
      	          });
      	        }
      	      }
      	    });
      	  }
      	
      	  if (pointMarkers.length > 0) {
      	    const latestMarker = pointMarkers[pointMarkers.length - 1];
      	    if (latestMarker) {
      	      mapInstance.setCenter({
      	        lat: latestMarker.lat, lng: latestMarker.lng
      	      });
      	    }
      	  }
      	
      	  // Adding Geofence Markers
      	  if (enableGeofence) {
      	    google.maps.event.addListener(mapInstance, 'click', function(event) {
      	      addGeofenceMarker(event.latLng);
      	    });
      	  }
      	
      	  function addGeofenceMarker(location) {
      	    const markerIndex = geofenceMarkers.length;
      	
      	    const icon = {
      	      path: google.maps.SymbolPath.CIRCLE,
      	      fillColor: markerIndex === geofenceMarkers.length - 1 ? '#FFFFFF' : polygonColor || '#FF0000',
      	      fillOpacity: 1,
      	      strokeColor: 'black',
      	      strokeWeight: 2,
      	      scale: 8
      	    };
      	
      	    const marker = new google.maps.Marker({
      	      position: location,
      	      map: mapInstance,
      	      icon: icon,
      	      draggable: true
      	    });
      	
      	    geofenceMarkers.push(marker);
      	
      	    marker.addListener('dragend', updateGeofencePolygon);
      	    marker.addListener('click', function() {
      	      marker.setMap(null);
      	      const markerIndex = geofenceMarkers.indexOf(marker);
      	      if (markerIndex !== -1) {
      	        geofenceMarkers.splice(markerIndex, 1);
      	        updateGeofencePolygon();
      	      }
      	    });
      	
      	    if (geofenceMarkers.length > 2) {
      	      const firstMarker = geofenceMarkers[0];
      	      if (location.equals(firstMarker.getPosition())) {
      	        createGeofencePolygon();
      	      }
      	    }
      	
      	    updateGeofencePolygon();
      	  }
      	
      	  function updateGeofencePolygon() {
      	    const path = geofenceMarkers.map(marker => marker.getPosition());
      	
      	    if (geofencePolygon) {
      	      geofencePolygon.setPath(path);
      	    } else {
      	      geofencePolygon = new google.maps.Polygon({
      	        paths: path,
      	        strokeColor: polygonColor || '#FF0000',
      	        strokeOpacity: 0.8,
      	        strokeWeight: 2,
      	        fillColor: polygonColor || '#FF0000',
      	        fillOpacity: 0.35
      	      });
      	
      	      geofencePolygon.setMap(mapInstance);
      	    }
      	
      	    // Save the created polygon to App Data, overriding the existing value
      	    appData.geofencePolygons = {
      	      path: path.map(latLng => ({
      	        lat: latLng.lat(), lng: latLng.lng()
      	      })),
      	      color: polygonColor || '#FF0000'
      	    };
      	  }
      	
      	  function createGeofencePolygon() {
      	    const path = geofenceMarkers.map(marker => marker.getPosition());
      	
      	    if (geofencePolygon) {
      	      geofencePolygon.setPath(path);
      	    } else {
      	      geofencePolygon = new google.maps.Polygon({
      	        paths: path,
      	        strokeColor: polygonColor || '#FF0000',
      	        strokeOpacity: 0.8,
      	        strokeWeight: 2,
      	        fillColor: polygonColor || '#FF0000',
      	        fillOpacity: 0.35
      	      });
      	
      	      geofencePolygon.setMap(mapInstance);
      	    }
      	  }
      	
      	  function createGeofencePopupContent(geofence, polygon, mapInstance, appData) {
      	    const geofences = appData.User.Company.Locations;
      	
      	    const content = document.createElement('div');
      	    content.style.padding = '10px';
      	    content.style.fontFamily = 'Arial, sans-serif';
      	    content.style.color = 'white';
      	
      	    const headerDiv = document.createElement('div');
      	    headerDiv.style.display = 'flex';
      	    headerDiv.style.justifyContent = 'space-between';
      	    headerDiv.style.alignItems = 'center';
      	
      	    const title = document.createElement('h3');
      	    title.style.margin = '0';
      	    title.textContent = geofence.Name;
      	
      	    const iconDiv = document.createElement('div');
      	    iconDiv.style.display = 'flex';
      	    iconDiv.style.gap = '10px';
      	
      	    // Edit Icon
      	    const editIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      	    editIcon.setAttribute('width', '24');
      	    editIcon.setAttribute('height', '24');
      	    editIcon.setAttribute('viewBox', '0 0 24 24');
      	    editIcon.setAttribute('fill', 'none');
      	    editIcon.setAttribute('stroke', 'white');
      	    editIcon.setAttribute('stroke-width', '2');
      	    editIcon.setAttribute('stroke-linecap', 'round');
      	    editIcon.setAttribute('stroke-linejoin', 'round');
      	    editIcon.style.cursor = 'pointer';
      	
      	    const editPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      	    editPath.setAttribute('d', 'M12 20h9');
      	    editIcon.appendChild(editPath);
      	
      	    const editPath2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      	    editPath2.setAttribute('d', 'M16.5 3.5a2.121 2.121 0 010 3l-10 10-4 1 1-4 10-10a2.121 2.121 0 013 0z');
      	    editIcon.appendChild(editPath2);
      	
      	    // Delete Icon
      	    const deleteIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      	    deleteIcon.setAttribute('width', '24');
      	    deleteIcon.setAttribute('height', '24');
      	    deleteIcon.setAttribute('viewBox', '0 0 24 24');
      	    deleteIcon.setAttribute('fill', 'none');
      	    deleteIcon.setAttribute('stroke', 'white');
      	    deleteIcon.setAttribute('stroke-width', '2');
      	    deleteIcon.setAttribute('stroke-linecap', 'round');
      	    deleteIcon.setAttribute('stroke-linejoin', 'round');
      	    deleteIcon.style.cursor = 'pointer';
      	
      	    const polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
      	    polyline.setAttribute('points', '3 6 5 6 21 6');
      	    deleteIcon.appendChild(polyline);
      	
      	    const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      	    path1.setAttribute('d', 'M19 6L17.707 18H6.293L5 6');
      	    deleteIcon.appendChild(path1);
      	
      	    // Add Icons to iconDiv
      	    iconDiv.appendChild(editIcon);
      	    iconDiv.appendChild(deleteIcon);
      	
      	    headerDiv.appendChild(title);
      	    headerDiv.appendChild(iconDiv);
      	
      	    content.appendChild(headerDiv);
      	
      	    const address = document.createElement('p');
      	    address.innerHTML = `<strong>Address:</strong> ${geofence.Address}`;
      	    content.appendChild(address);
      	
      	    const contactName = document.createElement('p');
      	    contactName.innerHTML = `<strong>Contact Name:</strong> ${geofence.Contact_Name}`;
      	    content.appendChild(contactName);
      	
      	    const phone = document.createElement('p');
      	    phone.innerHTML = `<strong>Phone:</strong> ${geofence.Phone}`;
      	    content.appendChild(phone);
      	
      	    const infowindow = new google.maps.InfoWindow({
      	      content: content,
      	      disableAutoPan: true
      	    });
      	
      	    // Add event listener to the polygon to handle the click
      	    polygon.addListener('click', function(event) {
      	      infowindow.setPosition(event.latLng);
      	      infowindow.open(mapInstance);
      	      currentInfoWindow = infowindow;
      	    });
      	
      	    editIcon.addEventListener('click',
      	      async function () {
      	        const isEditable = polygon.getEditable();
      	        polygon.setEditable(!isEditable);
      	
      	        if (!isEditable) {
      	          editIcon.innerHTML = ''; // Switch to save icon
      	          const checkPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      	          checkPath.setAttribute('d', 'M20 6L9 17l-5-5');
      	          editIcon.appendChild(checkPath);
      	        } else {
      	          const newPath = polygon.getPath().getArray().map(latLng => [latLng.lng(), latLng.lat()]);
      	
      	          const updatedGeofence = geofences.find(loc => loc.objectId === geofence.objectId);
      	
      	          updatedGeofence["Geo Fences"] = {
      	            type: "Polygon",
      	            coordinates: [newPath],
      	            srs: {
      	              srsId: 4326,
      	              name: 'WGS 84'
      	            },
      	            holes: [] // Add holes if applicable or leave as an empty array
      	          };
      	
      	          const sanitizedGeofence = JSON.parse(JSON.stringify(updatedGeofence, (key, value) => {
      	            if (typeof value === 'function' || value instanceof Element) {
      	              return undefined;
      	            }
      	            return value;
      	          }));
      	
      	          const result = await Backendless.Data.of('Locations').save(sanitizedGeofence, true);
      	
      	          const index = geofences.findIndex(loc => loc.objectId === geofence.objectId);
      	          if (index !== -1) {
      	            geofences[index] = result;
      	          }
      	
      	          editIcon.innerHTML = '';
      	          editIcon.appendChild(editPath);
      	          editIcon.appendChild(editPath2);
      	        }
      	      });
      	
      	    // Handling Delete Icon Click
      	    deleteIcon.addEventListener('click',
      	      async function() {
      	        const confirmation = confirm(`Are you sure you want to delete the location: ${geofence.Name}?`);
      	        if (confirmation) {
      	          await Backendless.Data.of('Locations').remove(geofence.objectId);
      	
      	          appData.User.Company.Locations = await asyncListFilter(geofences, async (item) => {
      	            return (geofence.objectId !== item.objectId);
      	          });
      	
      	          polygon.setMap(null);
      	          infowindow.close();
      	        }
      	      });
      	
      	    return content;
      	  }
      	
      	  // Supporting Functions
      	
      	  async function asyncListFilter(sourceList,
      	    callback) {
      	    const list = await Promise.all(sourceList.map(async source => ({
      	      source,
      	      value: await callback(source),
      	    })));
      	
      	    const resultList = list.filter(item => item.value);
      	
      	    return resultList.map(item => item.source);
      	  }
      	}
      	
      	// Helper function to create popup content for stations
      	function createStationPopupContent(station) {
      	  return `
      	  <div style="padding: 10px; font-family: Arial, sans-serif; color: white;">
      	  <table>
      	  <tr><td><strong>Station Name:</strong></td><td>${station.Station_Name}</td></tr>
      	  <tr><td><strong>Brand:</strong></td><td>${station.Brand}</td></tr>
      	  <tr><td><strong>Contact Name:</strong></td><td>${station.Contact_Name}</td></tr>
      	  <tr><td><strong>Phone:</strong></td><td>${station.Contact_Number}</td></tr>
      	  <tr><td><strong>Address:</strong></td><td>${station.Province}, ${station.Town}</td></tr>
      	  <tr><td><strong>Price:</strong></td><td>${station.Price}</td></tr>
      	  <tr><td><strong>Truck Stop:</strong></td><td>${station.Truck_Stop ? 'Yes': 'No'}</td></tr>
      	  </table>
      	  <p><strong>Services:</strong></p>
      	  <ul>
      	  ${(Array.isArray(station.Services) ? station.Services: []).map(service => `<li>${service}</li>`).join('')}
      	  </ul>
      	  </div>
      	  `;
      	}
      	
      	try {
      	  const googleMapComponent = arguments[0];
      	  const polylineColor = arguments[1];
      	  const markers = arguments[2];
      	  const strokeOpacity = arguments[3];
      	  const strokeWeight = arguments[4];
      	  const pointMarkers = arguments[5];
      	  const pointColor = arguments[6];
      	  const pointScale = arguments[7];
      	  const vehicleId = arguments[8];
      	  const geofences = arguments[9];
      	  const stations = arguments[10];
      	  const stationIconSvg = arguments[11];
      	  const enableGeofence = arguments[12];
      	  const polygonColor = arguments[13];
      	  const appData = arguments[14];
      	  addPolylineAndCustomMarkers(
      	    googleMapComponent,
      	    polylineColor,
      	    markers,
      	    strokeOpacity,
      	    strokeWeight,
      	    pointMarkers,
      	    pointColor,
      	    pointScale,
      	    vehicleId,
      	    geofences,
      	    stations,
      	    stationIconSvg,
      	    enableGeofence,
      	    polygonColor,
      	    appData// Pass the FuelLossSvg as the last argument
      	  );
      	} catch (error) {
      	  // No error handling
      	}
      })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('af385dc3ebe2984f6847fb6c292554ac')), '#FFFFFF', (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'Route')), 'Loaded Leg')), 'Polyline')), 1, 7, null, null, null, null, null, null, null, null, null, null);
      console.log(Waypoints);
    } else {
      console.log('4');
      Delivery_Location = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'PointList')), 'Waypoints'))[(((await (async function(List, Property, Value) {
      	/**
      	 * Finds the index of the first item in `list` for which item[property] === value.
      	 * Returns -1 if:
      	 *   - list is not an array
      	 *   - property is not a valid string
      	 *   - no item matches
      	 */
      	function run(list, property, value) {
      	  if (!Array.isArray(list) || typeof property !== "string" || !property) {
      	    return -1;
      	  }
      	  
      	  for (let i = 0; i < list.length; i++) {
      	    const item = list[i];
      	    
      	    // Skip null/undefined items
      	    if (item == null) {
      	      continue;
      	    }
      	    
      	    // Check if the item has the property and if it matches the value
      	    if (Object.prototype.hasOwnProperty.call(item, property) && item[property] === value) {
      	      return i;
      	    }
      	  }
      	  
      	  // No match found
      	  return -1;
      	}
      	
      	// The final line in your custom code block must return the result
      	return run(List, Property, Value);

      })((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'PointList')), 'Waypoints')), 'objectId', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'LDPID')))) + 1) - 1)];
      (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('af385dc3ebe2984f6847fb6c292554ac', ((getObjectProperty((getObjectProperty(Delivery_Location, 'Point')), 'coordinates')).slice(-1)[0]), ((getObjectProperty((getObjectProperty(Delivery_Location, 'Point')), 'coordinates'))[0]));
      Waypoints = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'PointList')), 'Waypoints')).slice(((await (async function(List, Property, Value) {
      	/**
      	 * Finds the index of the first item in `list` for which item[property] === value.
      	 * Returns -1 if:
      	 *   - list is not an array
      	 *   - property is not a valid string
      	 *   - no item matches
      	 */
      	function run(list, property, value) {
      	  if (!Array.isArray(list) || typeof property !== "string" || !property) {
      	    return -1;
      	  }
      	  
      	  for (let i = 0; i < list.length; i++) {
      	    const item = list[i];
      	    
      	    // Skip null/undefined items
      	    if (item == null) {
      	      continue;
      	    }
      	    
      	    // Check if the item has the property and if it matches the value
      	    if (Object.prototype.hasOwnProperty.call(item, property) && item[property] === value) {
      	      return i;
      	    }
      	  }
      	  
      	  // No match found
      	  return -1;
      	}
      	
      	// The final line in your custom code block must return the result
      	return run(List, Property, Value);

      })((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'PointList')), 'Waypoints')), 'objectId', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'LLPID')))) - 1), (await (async function(List, Property, Value) {
      	/**
      	 * Finds the index of the first item in `list` for which item[property] === value.
      	 * Returns -1 if:
      	 *   - list is not an array
      	 *   - property is not a valid string
      	 *   - no item matches
      	 */
      	function run(list, property, value) {
      	  if (!Array.isArray(list) || typeof property !== "string" || !property) {
      	    return -1;
      	  }
      	  
      	  for (let i = 0; i < list.length; i++) {
      	    const item = list[i];
      	    
      	    // Skip null/undefined items
      	    if (item == null) {
      	      continue;
      	    }
      	    
      	    // Check if the item has the property and if it matches the value
      	    if (Object.prototype.hasOwnProperty.call(item, property) && item[property] === value) {
      	      return i;
      	    }
      	  }
      	  
      	  // No match found
      	  return -1;
      	}
      	
      	// The final line in your custom code block must return the result
      	return run(List, Property, Value);

      })((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'PointList')), 'Waypoints')), 'objectId', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'LDPID')))) + 1);
      Counter = -1;
      for (var j_index3 in Waypoints) {
        j = Waypoints[j_index3];
        Counter = Counter + 1;
        j['leg'] = ((getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'Route')), 'Loaded Leg')), 'Route')), 'routes'))[0]), 'legs'))[(Counter - 1)]);
      }
      await new Promise(r => setTimeout(r, 2000 || 0));
    }
    console.log('5');
    await new Promise(r => setTimeout(r, 2000 || 0));
    await (async function(googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers, pointColor, pointScale, vehicleId, geofences, stations, stationIconSvg, canAddGeofences, polygonColor, appData) {
    	let existingMarkers = [];
    	let existingPolylines = [];
    	let existingGeofences = [];
    	let currentInfoWindow = null;
    	let selectedMarker = null;
    	let geofenceMarkers = [];
    	let geofencePolygon = null;
    	let addingGeofence = false;
    	
    	appData = appData || {};
    	
    	function addPolylineAndCustomMarkers(
    	  googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers,
    	  pointColor, pointScale, vehicleId, geofences, stations, stationIconSvg, enableGeofence, polygonColor, appData
    	) {
    	  if (!googleMapComponent || !googleMapComponent.map) {
    	    return;
    	  }
    	
    	  const mapInstance = googleMapComponent.map.map;
    	  if (!(mapInstance instanceof google.maps.Map)) {
    	    return;
    	  }
    	
    	  // Polyline logic
    	  const polylineCoordinates = markers.map(marker => ({
    	    lat: marker.lat,
    	    lng: marker.lng
    	  }));
    	
    	  const polyline = new google.maps.Polyline({
    	    path: polylineCoordinates,
    	    geodesic: true,
    	    strokeColor: polylineColor || '#FF0000',
    	    strokeOpacity: strokeOpacity || 1.0,
    	    strokeWeight: strokeWeight || 2
    	  });
    	
    	  polyline.setMap(mapInstance);
    	  existingPolylines.push(polyline);
    	
    	  function calculateHeading(lat1, lng1, lng2, lat2) {
    	    const toRadians = degrees => degrees * Math.PI / 180;
    	    const toDegrees = radians => degrees * 180 / Math.PI;
    	
    	    const dLng = toRadians(lng2 - lng1);
    	    const y = Math.sin(dLng) * Math.cos(toRadians(lat2));
    	    const x = Math.cos(toRadians(lat1)) * Math.sin(toRadians(lat2)) - Math.sin(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.cos(dLng);
    	    const bearing = toDegrees(Math.atan2(y, x));
    	    return (bearing + 360) % 360;
    	  }
    	
    	  // Add custom markers to the map
    	pointMarkers.forEach((marker, index) => {
    	  let icon;
    	  let markerOptions = {
    	    position: { lat: marker.lat, lng: marker.lng },
    	    map: mapInstance,
    	    draggable: false,
    	  };
    	
    	  // Check for Icon property and use it if available
    	  if (marker.Icon) {
    	    icon = {
    	      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(marker.Icon)}`,
    	      anchor: new google.maps.Point(25, 25),
    	      scaledSize: new google.maps.Size(50, 50) // Adjust size as needed
    	    };
    	
    	    // Set a high zIndex to ensure it sits on top of other markers
    	    markerOptions.zIndex = google.maps.Marker.MAX_ZINDEX + 1;
    	  } else {
    	    let iconColor = marker.color || pointColor || '#FF0000';
    	
    	    if (marker.Speed === 0) {
    	      icon = {
    	        path: google.maps.SymbolPath.CIRCLE,
    	        fillColor: iconColor,
    	        fillOpacity: 1,
    	        strokeColor: 'black',
    	        strokeWeight: 2,
    	        scale: marker.scale || pointScale || 8
    	      };
    	
    	      if (index === pointMarkers.length - 1 && vehicleId) {
    	        const crosshairSvg = `
    	        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    	        <circle cx="12" cy="12" r="10"></circle>
    	        <line x1="12" y1="2" x2="12" y2="6"></line>
    	        <line x1="12" y1="18" x2="12" y2="22"></line>
    	        <line x1="2" y1="12" x2="6" y2="12"></line>
    	        <line x1="18" y1="12" x2="22" y2="12"></line>
    	        </svg>
    	        `;
    	
    	        icon = {
    	          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(crosshairSvg)}`,
    	          anchor: new google.maps.Point(25, 25),
    	          scaledSize: new google.maps.Size(50, 50)
    	        };
    	      }
    	
    	    } else {
    	      let heading = marker.Direction !== undefined ? marker.Direction : 0;
    	      if (marker.Direction === undefined && index < pointMarkers.length - 1) {
    	        const nextMarker = pointMarkers[index + 1];
    	        heading = calculateHeading(marker.lat, marker.lng, nextMarker.lng, nextMarker.lat);
    	      }
    	
    	      heading = (heading - 90 + 360) % 360;
    	
    	      const iconPath = "M 0 0 L -1 -1 L 1 0 L -1 1 Z";
    	      if (iconColor.toLowerCase() === '#000000' || iconColor.toLowerCase() === 'black') {
    	        icon = {
    	          path: iconPath,
    	          fillColor: iconColor,
    	          fillOpacity: 1,
    	          strokeColor: 'white',
    	          strokeWeight: 3,
    	          rotation: heading,
    	          scale: marker.scale || pointScale || 8,
    	          anchor: new google.maps.Point(0, 0)
    	        };
    	      } else {
    	        icon = {
    	          path: iconPath,
    	          fillColor: iconColor,
    	          fillOpacity: 1,
    	          strokeColor: 'black',
    	          strokeWeight: 2,
    	          rotation: heading,
    	          scale: marker.scale || pointScale || 8,
    	          anchor: new google.maps.Point(0, 0)
    	        };
    	      }
    	    }
    	  }
    	
    	  // Apply the icon to the marker options
    	  markerOptions.icon = icon;
    	
    	  const pointMarker = new google.maps.Marker(markerOptions);
    	
    	  existingMarkers.push(pointMarker);
    	
    	  if (marker.Data) {
    	    const infowindow = new google.maps.InfoWindow({
    	      content: marker.Data
    	    });
    	
    	    pointMarker.addListener('click', function() {
    	      if (currentInfoWindow) {
    	        currentInfoWindow.close();
    	      }
    	      infowindow.open(mapInstance, pointMarker);
    	      currentInfoWindow = infowindow;
    	
    	      selectedMarker = pointMarker;
    	    });
    	  }
    	
    	  pointMarker.addListener('click', function() {
    	    selectedMarker = pointMarker;
    	  });
    	});
    	
    	
    	
    	  // Add Geofences
    	  if (geofences && Array.isArray(geofences)) {
    	    geofences.forEach(geofence => {
    	      if (geofence["Geo Fences"] && geofence["Geo Fences"].boundary && Array.isArray(geofence["Geo Fences"].boundary.points)) {
    	        const polygonCoords = geofence["Geo Fences"].boundary.points.map(point => ({
    	          lat: point.y,
    	          lng: point.x
    	        }));
    	
    	        const polygon = new google.maps.Polygon({
    	          paths: polygonCoords,
    	          strokeColor: geofence.Color,
    	          strokeOpacity: 0.9,
    	          strokeWeight: 4,
    	          fillColor: geofence.Color,
    	          fillOpacity: 0.25
    	        });
    	
    	        polygon.setMap(mapInstance);
    	        existingGeofences.push(polygon);
    	
    	        google.maps.event.addListener(polygon, 'click', function(event) {
    	          const infowindow = new google.maps.InfoWindow({
    	            content: createGeofencePopupContent(geofence, polygon, mapInstance, appData)
    	          });
    	
    	          infowindow.setPosition(event.latLng);
    	          infowindow.open(mapInstance);
    	          currentInfoWindow = infowindow;
    	        });
    	      }
    	    });
    	  }
    	
    	  // Add Stations
    	  if (stations && Array.isArray(stations)) {
    	    stations.forEach(station => {
    	      if (station["Geo Fence"] && station["Geo Fence"].boundary && station["Geo Fence"].boundary.points) {
    	        const stationCoords = station["Geo Fence"].boundary.points.map(point => ({
    	          lat: point.y,
    	          lng: point.x
    	        }));
    	
    	        const polygon = new google.maps.Polygon({
    	          paths: stationCoords,
    	          strokeColor: station.Color,
    	          strokeOpacity: 0.9,
    	          strokeWeight: 4,
    	          fillColor: station.Color,
    	          fillOpacity: 0.25
    	        });
    	
    	        polygon.setMap(mapInstance);
    	        existingGeofences.push(polygon);
    	
    	        // Check for station location
    	        if (station.Location && station.Location.x !== undefined && station.Location.y !== undefined) {
    	          const icon = {
    	            url: stationIconSvg,
    	            anchor: new google.maps.Point(25, 50),
    	            scaledSize: new google.maps.Size(50, 50)
    	          };
    	
    	          const stationCenter = {
    	            lat: station.Location.y,
    	            lng: station.Location.x
    	          };
    	          const stationMarker = new google.maps.Marker({
    	            position: stationCenter,
    	            map: mapInstance,
    	            icon: icon
    	          });
    	
    	          existingMarkers.push(stationMarker);
    	
    	          google.maps.event.addListener(stationMarker, 'click', function(event) {
    	            const infowindow = new google.maps.InfoWindow({
    	              content: createStationPopupContent(station)
    	            });
    	
    	            infowindow.open(mapInstance, stationMarker);
    	            currentInfoWindow = infowindow;
    	          });
    	        }
    	      }
    	    });
    	  }
    	
    	  if (pointMarkers.length > 0) {
    	    const latestMarker = pointMarkers[pointMarkers.length - 1];
    	    if (latestMarker) {
    	      mapInstance.setCenter({
    	        lat: latestMarker.lat, lng: latestMarker.lng
    	      });
    	    }
    	  }
    	
    	  // Adding Geofence Markers
    	  if (enableGeofence) {
    	    google.maps.event.addListener(mapInstance, 'click', function(event) {
    	      addGeofenceMarker(event.latLng);
    	    });
    	  }
    	
    	  function addGeofenceMarker(location) {
    	    const markerIndex = geofenceMarkers.length;
    	
    	    const icon = {
    	      path: google.maps.SymbolPath.CIRCLE,
    	      fillColor: markerIndex === geofenceMarkers.length - 1 ? '#FFFFFF' : polygonColor || '#FF0000',
    	      fillOpacity: 1,
    	      strokeColor: 'black',
    	      strokeWeight: 2,
    	      scale: 8
    	    };
    	
    	    const marker = new google.maps.Marker({
    	      position: location,
    	      map: mapInstance,
    	      icon: icon,
    	      draggable: true
    	    });
    	
    	    geofenceMarkers.push(marker);
    	
    	    marker.addListener('dragend', updateGeofencePolygon);
    	    marker.addListener('click', function() {
    	      marker.setMap(null);
    	      const markerIndex = geofenceMarkers.indexOf(marker);
    	      if (markerIndex !== -1) {
    	        geofenceMarkers.splice(markerIndex, 1);
    	        updateGeofencePolygon();
    	      }
    	    });
    	
    	    if (geofenceMarkers.length > 2) {
    	      const firstMarker = geofenceMarkers[0];
    	      if (location.equals(firstMarker.getPosition())) {
    	        createGeofencePolygon();
    	      }
    	    }
    	
    	    updateGeofencePolygon();
    	  }
    	
    	  function updateGeofencePolygon() {
    	    const path = geofenceMarkers.map(marker => marker.getPosition());
    	
    	    if (geofencePolygon) {
    	      geofencePolygon.setPath(path);
    	    } else {
    	      geofencePolygon = new google.maps.Polygon({
    	        paths: path,
    	        strokeColor: polygonColor || '#FF0000',
    	        strokeOpacity: 0.8,
    	        strokeWeight: 2,
    	        fillColor: polygonColor || '#FF0000',
    	        fillOpacity: 0.35
    	      });
    	
    	      geofencePolygon.setMap(mapInstance);
    	    }
    	
    	    // Save the created polygon to App Data, overriding the existing value
    	    appData.geofencePolygons = {
    	      path: path.map(latLng => ({
    	        lat: latLng.lat(), lng: latLng.lng()
    	      })),
    	      color: polygonColor || '#FF0000'
    	    };
    	  }
    	
    	  function createGeofencePolygon() {
    	    const path = geofenceMarkers.map(marker => marker.getPosition());
    	
    	    if (geofencePolygon) {
    	      geofencePolygon.setPath(path);
    	    } else {
    	      geofencePolygon = new google.maps.Polygon({
    	        paths: path,
    	        strokeColor: polygonColor || '#FF0000',
    	        strokeOpacity: 0.8,
    	        strokeWeight: 2,
    	        fillColor: polygonColor || '#FF0000',
    	        fillOpacity: 0.35
    	      });
    	
    	      geofencePolygon.setMap(mapInstance);
    	    }
    	  }
    	
    	  function createGeofencePopupContent(geofence, polygon, mapInstance, appData) {
    	    const geofences = appData.User.Company.Locations;
    	
    	    const content = document.createElement('div');
    	    content.style.padding = '10px';
    	    content.style.fontFamily = 'Arial, sans-serif';
    	    content.style.color = 'white';
    	
    	    const headerDiv = document.createElement('div');
    	    headerDiv.style.display = 'flex';
    	    headerDiv.style.justifyContent = 'space-between';
    	    headerDiv.style.alignItems = 'center';
    	
    	    const title = document.createElement('h3');
    	    title.style.margin = '0';
    	    title.textContent = geofence.Name;
    	
    	    const iconDiv = document.createElement('div');
    	    iconDiv.style.display = 'flex';
    	    iconDiv.style.gap = '10px';
    	
    	    // Edit Icon
    	    const editIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    	    editIcon.setAttribute('width', '24');
    	    editIcon.setAttribute('height', '24');
    	    editIcon.setAttribute('viewBox', '0 0 24 24');
    	    editIcon.setAttribute('fill', 'none');
    	    editIcon.setAttribute('stroke', 'white');
    	    editIcon.setAttribute('stroke-width', '2');
    	    editIcon.setAttribute('stroke-linecap', 'round');
    	    editIcon.setAttribute('stroke-linejoin', 'round');
    	    editIcon.style.cursor = 'pointer';
    	
    	    const editPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    	    editPath.setAttribute('d', 'M12 20h9');
    	    editIcon.appendChild(editPath);
    	
    	    const editPath2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    	    editPath2.setAttribute('d', 'M16.5 3.5a2.121 2.121 0 010 3l-10 10-4 1 1-4 10-10a2.121 2.121 0 013 0z');
    	    editIcon.appendChild(editPath2);
    	
    	    // Delete Icon
    	    const deleteIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    	    deleteIcon.setAttribute('width', '24');
    	    deleteIcon.setAttribute('height', '24');
    	    deleteIcon.setAttribute('viewBox', '0 0 24 24');
    	    deleteIcon.setAttribute('fill', 'none');
    	    deleteIcon.setAttribute('stroke', 'white');
    	    deleteIcon.setAttribute('stroke-width', '2');
    	    deleteIcon.setAttribute('stroke-linecap', 'round');
    	    deleteIcon.setAttribute('stroke-linejoin', 'round');
    	    deleteIcon.style.cursor = 'pointer';
    	
    	    const polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
    	    polyline.setAttribute('points', '3 6 5 6 21 6');
    	    deleteIcon.appendChild(polyline);
    	
    	    const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    	    path1.setAttribute('d', 'M19 6L17.707 18H6.293L5 6');
    	    deleteIcon.appendChild(path1);
    	
    	    // Add Icons to iconDiv
    	    iconDiv.appendChild(editIcon);
    	    iconDiv.appendChild(deleteIcon);
    	
    	    headerDiv.appendChild(title);
    	    headerDiv.appendChild(iconDiv);
    	
    	    content.appendChild(headerDiv);
    	
    	    const address = document.createElement('p');
    	    address.innerHTML = `<strong>Address:</strong> ${geofence.Address}`;
    	    content.appendChild(address);
    	
    	    const contactName = document.createElement('p');
    	    contactName.innerHTML = `<strong>Contact Name:</strong> ${geofence.Contact_Name}`;
    	    content.appendChild(contactName);
    	
    	    const phone = document.createElement('p');
    	    phone.innerHTML = `<strong>Phone:</strong> ${geofence.Phone}`;
    	    content.appendChild(phone);
    	
    	    const infowindow = new google.maps.InfoWindow({
    	      content: content,
    	      disableAutoPan: true
    	    });
    	
    	    // Add event listener to the polygon to handle the click
    	    polygon.addListener('click', function(event) {
    	      infowindow.setPosition(event.latLng);
    	      infowindow.open(mapInstance);
    	      currentInfoWindow = infowindow;
    	    });
    	
    	    editIcon.addEventListener('click',
    	      async function () {
    	        const isEditable = polygon.getEditable();
    	        polygon.setEditable(!isEditable);
    	
    	        if (!isEditable) {
    	          editIcon.innerHTML = ''; // Switch to save icon
    	          const checkPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    	          checkPath.setAttribute('d', 'M20 6L9 17l-5-5');
    	          editIcon.appendChild(checkPath);
    	        } else {
    	          const newPath = polygon.getPath().getArray().map(latLng => [latLng.lng(), latLng.lat()]);
    	
    	          const updatedGeofence = geofences.find(loc => loc.objectId === geofence.objectId);
    	
    	          updatedGeofence["Geo Fences"] = {
    	            type: "Polygon",
    	            coordinates: [newPath],
    	            srs: {
    	              srsId: 4326,
    	              name: 'WGS 84'
    	            },
    	            holes: [] // Add holes if applicable or leave as an empty array
    	          };
    	
    	          const sanitizedGeofence = JSON.parse(JSON.stringify(updatedGeofence, (key, value) => {
    	            if (typeof value === 'function' || value instanceof Element) {
    	              return undefined;
    	            }
    	            return value;
    	          }));
    	
    	          const result = await Backendless.Data.of('Locations').save(sanitizedGeofence, true);
    	
    	          const index = geofences.findIndex(loc => loc.objectId === geofence.objectId);
    	          if (index !== -1) {
    	            geofences[index] = result;
    	          }
    	
    	          editIcon.innerHTML = '';
    	          editIcon.appendChild(editPath);
    	          editIcon.appendChild(editPath2);
    	        }
    	      });
    	
    	    // Handling Delete Icon Click
    	    deleteIcon.addEventListener('click',
    	      async function() {
    	        const confirmation = confirm(`Are you sure you want to delete the location: ${geofence.Name}?`);
    	        if (confirmation) {
    	          await Backendless.Data.of('Locations').remove(geofence.objectId);
    	
    	          appData.User.Company.Locations = await asyncListFilter(geofences, async (item) => {
    	            return (geofence.objectId !== item.objectId);
    	          });
    	
    	          polygon.setMap(null);
    	          infowindow.close();
    	        }
    	      });
    	
    	    return content;
    	  }
    	
    	  // Supporting Functions
    	
    	  async function asyncListFilter(sourceList,
    	    callback) {
    	    const list = await Promise.all(sourceList.map(async source => ({
    	      source,
    	      value: await callback(source),
    	    })));
    	
    	    const resultList = list.filter(item => item.value);
    	
    	    return resultList.map(item => item.source);
    	  }
    	}
    	
    	// Helper function to create popup content for stations
    	function createStationPopupContent(station) {
    	  return `
    	  <div style="padding: 10px; font-family: Arial, sans-serif; color: white;">
    	  <table>
    	  <tr><td><strong>Station Name:</strong></td><td>${station.Station_Name}</td></tr>
    	  <tr><td><strong>Brand:</strong></td><td>${station.Brand}</td></tr>
    	  <tr><td><strong>Contact Name:</strong></td><td>${station.Contact_Name}</td></tr>
    	  <tr><td><strong>Phone:</strong></td><td>${station.Contact_Number}</td></tr>
    	  <tr><td><strong>Address:</strong></td><td>${station.Province}, ${station.Town}</td></tr>
    	  <tr><td><strong>Price:</strong></td><td>${station.Price}</td></tr>
    	  <tr><td><strong>Truck Stop:</strong></td><td>${station.Truck_Stop ? 'Yes': 'No'}</td></tr>
    	  </table>
    	  <p><strong>Services:</strong></p>
    	  <ul>
    	  ${(Array.isArray(station.Services) ? station.Services: []).map(service => `<li>${service}</li>`).join('')}
    	  </ul>
    	  </div>
    	  `;
    	}
    	
    	try {
    	  const googleMapComponent = arguments[0];
    	  const polylineColor = arguments[1];
    	  const markers = arguments[2];
    	  const strokeOpacity = arguments[3];
    	  const strokeWeight = arguments[4];
    	  const pointMarkers = arguments[5];
    	  const pointColor = arguments[6];
    	  const pointScale = arguments[7];
    	  const vehicleId = arguments[8];
    	  const geofences = arguments[9];
    	  const stations = arguments[10];
    	  const stationIconSvg = arguments[11];
    	  const enableGeofence = arguments[12];
    	  const polygonColor = arguments[13];
    	  const appData = arguments[14];
    	  addPolylineAndCustomMarkers(
    	    googleMapComponent,
    	    polylineColor,
    	    markers,
    	    strokeOpacity,
    	    strokeWeight,
    	    pointMarkers,
    	    pointColor,
    	    pointScale,
    	    vehicleId,
    	    geofences,
    	    stations,
    	    stationIconSvg,
    	    enableGeofence,
    	    polygonColor,
    	    appData// Pass the FuelLossSvg as the last argument
    	  );
    	} catch (error) {
    	  // No error handling
    	}
    })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('af385dc3ebe2984f6847fb6c292554ac')), '#FFFFFF', (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Route(Json)')), 'Route')), 'Loaded Leg')), 'Polyline')), 1, 7, null, null, null, null, null, null, null, null, null, null);
  } else {
  }
  console.log('6');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ffc171ee8f23c12b6d79d7fbc44bd2b2', Waypoints);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/FIFDRIVER/components/0c8419c446c298b572f8194e3608f2bc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c658ed913b97ff2119318bd43699c20d')), ({ [`Product`]: null }));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Status')) == 'Planned') {
    Viewer = true;
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'New load')) == true) {
      Viewer = false;
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/626dd02c856b35fc4b7d09bba4780754/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var List, error, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('ab1c656ae8aacd47abcf30b91d31b84d')['Units'] = ___arguments.value;
  List = [];
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c658ed913b97ff2119318bd43699c20d'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    try {
      addItemToList(List, ((getObjectProperty((getObjectProperty(j, 'Product')), 'Mass')) * (getObjectProperty(j, 'Units'))));

    } catch (error) {
      console.log(error);

    }
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('297b110de463078946277c3e0687cbd7'))['value'] = (List.reduce(function(x, y) {return x + y;}));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('297b110de463078946277c3e0687cbd7', false);
  await new Promise(r => setTimeout(r, 100 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('297b110de463078946277c3e0687cbd7', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFDRIVER/components/c79ff5af86357699813bf4b8809ab062/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('5fc4eca2ac78c652b563954142c9623a');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('5fc4eca2ac78c652b563954142c9623a');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var List, error, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  try {
    List = [];
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c658ed913b97ff2119318bd43699c20d'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      try {
        addItemToList(List, ((getObjectProperty((getObjectProperty(j, 'Product')), 'Mass')) * (getObjectProperty(j, 'Units'))));

      } catch (error) {
        console.log(error);

      }
    }
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('297b110de463078946277c3e0687cbd7'))['value'] = (List.reduce(function(x, y) {return x + y;}) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab1c656ae8aacd47abcf30b91d31b84d'), 'Product')), 'Mass')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab1c656ae8aacd47abcf30b91d31b84d'), 'Units')));

  } catch (error) {
    console.log(error);

  }
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c658ed913b97ff2119318bd43699c20d')), ___arguments.context.getComponentDataStoreByUid('ab1c656ae8aacd47abcf30b91d31b84d'), '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/beef64a3173f3eb6d4dd8df7ccd3a961/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    var Repeater_Data, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Repeater_Data = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Load_Product_JSON')), 'Loaded'));

  } catch (error) {
    if (error) {
      Repeater_Data = null;
    }

  }

  return Repeater_Data

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/bb951abff71fe3ef32122a9e1d3db3d6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['DELIVER ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('4918806142aaf519f21324ae1b6515a2'), 'Units')),(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4918806142aaf519f21324ae1b6515a2'), 'Product')), 'Unit')),'  X  ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4918806142aaf519f21324ae1b6515a2'), 'Product')), 'Product'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/2e8ab7e85b2d614d75567ca9e7aa1aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4918806142aaf519f21324ae1b6515a2'), 'Product')), 'Product')),' ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4918806142aaf519f21324ae1b6515a2'), 'Product')), 'Unit')),' Loaded'].join(''))

  },
  /* handler:onLabelAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4918806142aaf519f21324ae1b6515a2'), 'Product')), 'Unit')) == 't') {
    if (___arguments.value > 100) {
      ___arguments.context.getComponentDataStoreByUid('4918806142aaf519f21324ae1b6515a2')['Delivered'] = (___arguments.value / 1000);
    } else {
      if (___arguments.value >= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4918806142aaf519f21324ae1b6515a2'), 'Units')) * 2) {
        ___arguments.context.getComponentDataStoreByUid('4918806142aaf519f21324ae1b6515a2')['Delivered'] = (___arguments.value / 10);
      } else {
        ___arguments.context.getComponentDataStoreByUid('4918806142aaf519f21324ae1b6515a2')['Delivered'] = ___arguments.value;
      }
    }
  } else {
    ___arguments.context.getComponentDataStoreByUid('4918806142aaf519f21324ae1b6515a2')['Delivered'] = ___arguments.value;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4918806142aaf519f21324ae1b6515a2'), 'Delivered')) >= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4918806142aaf519f21324ae1b6515a2'), 'Units')) * 1.2 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4918806142aaf519f21324ae1b6515a2'), 'Delivered')) <= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4918806142aaf519f21324ae1b6515a2'), 'Units')) * 0.8) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bb951abff71fe3ef32122a9e1d3db3d6'))['color'] = 'rgb(255, 0, 0)';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bb951abff71fe3ef32122a9e1d3db3d6'))['color'] = 'rgb(0, 255, 0)';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFDRIVER/components/fc37ed85b91cd87bb719555d790afbb9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Mass, j, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Mass = [0];
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('beef64a3173f3eb6d4dd8df7ccd3a961'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Delivered'))))) {
      addItemToList(Mass, 0);
    } else {
      addItemToList(Mass, ((getObjectProperty(j, 'Delivered')) * (getObjectProperty(j, 'Unit mass'))));
    }
  }

  return (String(Mass.reduce(function(x, y) {return x + y;})) + String(' kg'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/737707a836ecdcebbb8865ba5ced5b9e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bc6315ac2726b292499170c40f7c02c8'), 'Tonnage_Loaded')) + String(' kg'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/45682d286af574b2f24a6cf4d5f95d32/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, item, List, error, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    if ((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('beef64a3173f3eb6d4dd8df7ccd3a961')), async (item) => {


     return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Delivered')))));
    })).length == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('beef64a3173f3eb6d4dd8df7ccd3a961')).length) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/85a794a24d2204aec7227ad9038b0597/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/be6e2cfd64195626a1b2b3239cd57dda/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var Load_List, item, Load_Intructions, Location_Data, Mileage, Time_Now, Time_Start, j, Last_Point, Last_ID;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  Time_Now = (new Date());
  Time_Start = (new Date((new Date()).getTime() - (2700 * 1000)));
  Location_Data = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Device ID')), Time_Start, Time_Now));
  Mileage = Location_Data.length > 0 ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((Location_Data.slice(-1)[0]), 'can.vehicle.mileage')))) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')) : (getObjectProperty((Location_Data.slice(-1)[0]), 'can.vehicle.mileage'))) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer'));
  Load_Intructions = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads'));
  addItemToList(Load_Intructions, ({ [`Mileage`]: Mileage,[`Location`]: Location_Data,[`TID`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')),[`New Load`]: true,[`Instruction`]: 'New Load',[`Status`]: 'Planned',[`Sequence`]: (new Date()) }));
  Load_List = (await asyncListSort((await asyncListFilter(Load_Intructions, async (item) => {


   return ((getObjectProperty(item, 'Status')) == 'Planned' || (getObjectProperty(item, 'Status')) == 'Loaded' || (getObjectProperty(item, 'Status')) == 'Depot' || (getObjectProperty(item, 'Status')) == 'Transferred ');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Sequence'));
  }));

  return (await (async function(List) {
	// The function accepts 'List' as input argument (your array)
	return List.reduce((acc, item) => {
	  acc.map[item.objectId] = item;
	  acc.array = Object.values(acc.map);
	  return acc;
	}, { map: {}, array: [] }).array;

})(Load_List))

  },
  /* handler:onDynamicItemsAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))))) {
        Visability = false;
      } else {
        Visability = true;
      }
    }
  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/45224cabf5c7a5e80144ee283dcd3689/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Second_Item, Mileage, Location_Data, Time_Now, Time_Start, First_Item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'Instruction')).slice(0, 13) == 'Load Transfer') {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('099d36a9817ec8430d09d033f9a2e7f7', undefined);
  } else {
    First_Item = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('be6e2cfd64195626a1b2b3239cd57dda'))[0];
    Second_Item = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('be6e2cfd64195626a1b2b3239cd57dda'))[1];
    if ((getObjectProperty(First_Item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')) || (getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Loaded' || (getObjectProperty(___arguments.context.dataModel, 'Instruction')) == 'New Load') {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('bed46198bd14dda817628f44ec924a1a', undefined);
    } else if ((getObjectProperty(Second_Item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')) || (getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Loaded' || (getObjectProperty(___arguments.context.dataModel, 'Instruction')) == 'New Load') {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('bed46198bd14dda817628f44ec924a1a', undefined);
    }
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var First_Item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'Instruction')).slice(0, 13) == 'Load Transfer' ? ({ [`backgroundColor`]: 'rgba(45, 85, 255, 0.6)' }) : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.dataModel, 'Status')))) ? ({ [`backgroundColor`]: 'rgba(204, 102, 51, 0.6)' }) : ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Planned' ? ({ [`backgroundColor`]: 'rgba(204, 102, 51, 0.4)' }) : ({ [`backgroundColor`]: 'rgba(0, 128, 0, 0.6)' }))))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/abe159740353364383db3a31b8b25855/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('76945b97db95226206c71b41243153cc', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/50fa1ee12e89081747fd8a53f8566cc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.dataModel);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/5aaa0d4ddcea4ff770d993cf6383c63c/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('50fa1ee12e89081747fd8a53f8566cc1'), 'leg'))))) {
    List = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('50fa1ee12e89081747fd8a53f8566cc1'), 'leg')), 'steps'))))) {
      List = [];
    } else {
      List = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('50fa1ee12e89081747fd8a53f8566cc1'), 'leg')), 'steps'));
    }
  }

  return List

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/a875932970af7c6dd8d89a997314af7b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('50fa1ee12e89081747fd8a53f8566cc1'), 'Data'))))) {
    Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Instruction'));
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('50fa1ee12e89081747fd8a53f8566cc1'), 'Data')), 'name'))))) {
      Content = String('Next Waypoint ') + String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('50fa1ee12e89081747fd8a53f8566cc1'), 'Data')), 'formatted_address'));
    } else {
      Content = String('Next Waypoint ') + String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('50fa1ee12e89081747fd8a53f8566cc1'), 'Data')), 'name'));
    }
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('50fa1ee12e89081747fd8a53f8566cc1'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/5d056a27ea6df74603289276a0c2ca66/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('38fb0fe2262450aff46382f855680221'), 'html_instructions')),((getObjectProperty(___arguments.context.getComponentDataStoreByUid('38fb0fe2262450aff46382f855680221'), 'html_instructions')).indexOf('Destination') !== -1) ? ' In ' : ' For ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('38fb0fe2262450aff46382f855680221'), 'distance')), 'text'))].join(''))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('38fb0fe2262450aff46382f855680221'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/642e7e7adbc49e2f9d8c0eacbfcc6658/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Location;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('50fa1ee12e89081747fd8a53f8566cc1'), 'Data'))))) {
    Location = ({ [`lat`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('50fa1ee12e89081747fd8a53f8566cc1'), 'Point')), 'coordinates')).slice(-1)[0],[`lng`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('50fa1ee12e89081747fd8a53f8566cc1'), 'Point')), 'coordinates'))[0] });
  } else {
    Location = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('50fa1ee12e89081747fd8a53f8566cc1'), 'Point'));
  }
  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String('https://maps.google.com/?q=') + String([(getObjectProperty(Location, 'lat')),',',(getObjectProperty(Location, 'lng'))].join(''))), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/ed25d7e829fb1aa530c41ea4394371dc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('099d36a9817ec8430d09d033f9a2e7f7', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/55958c7ddecb8cd28707249f690eb88c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    List = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      List = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
      } else {
        List = (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Name')) });})));
      }
    }
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/cf14a71a1c2e38f7bd84c40d89dd58c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('c4816da85fcd47dbe3288fc14364ab0f', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/9b6ca62c950c0d2ed9766ecfd8369582/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    var Repeater_Data, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Repeater_Data = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Load_Product_JSON')), 'Loaded'));

  } catch (error) {
    if (error) {
      Repeater_Data = null;
    }

  }

  return Repeater_Data

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/7f261fbfdc5e8bee12a2b80f8417dd31/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['TRANSFER  ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2814148243170db65379504b33836551'), 'Units')),(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2814148243170db65379504b33836551'), 'Product')), 'Unit')),'  X  ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2814148243170db65379504b33836551'), 'Product')), 'Product'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/15c649c8248497a21d595118c9067384/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2814148243170db65379504b33836551'), 'Product')), 'Unit')) == 't') {
    if (___arguments.value > 100) {
      ___arguments.context.getComponentDataStoreByUid('2814148243170db65379504b33836551')['Transferred'] = (___arguments.value / 1000);
    } else {
      if (___arguments.value >= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2814148243170db65379504b33836551'), 'Units')) * 2) {
        ___arguments.context.getComponentDataStoreByUid('2814148243170db65379504b33836551')['Transferred'] = (___arguments.value / 10);
      } else {
        ___arguments.context.getComponentDataStoreByUid('2814148243170db65379504b33836551')['Transferred'] = ___arguments.value;
      }
    }
  } else {
    ___arguments.context.getComponentDataStoreByUid('2814148243170db65379504b33836551')['Transferred'] = ___arguments.value;
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2814148243170db65379504b33836551'), 'Transferred')) >= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2814148243170db65379504b33836551'), 'Units')) * 1.2 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2814148243170db65379504b33836551'), 'Transferred')) <= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2814148243170db65379504b33836551'), 'Units')) * 0.8) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f261fbfdc5e8bee12a2b80f8417dd31'))['color'] = 'rgb(255, 0, 0)';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7f261fbfdc5e8bee12a2b80f8417dd31'))['color'] = 'rgb(0, 255, 0)';
  }

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2814148243170db65379504b33836551'), 'Product')), 'Product')),' ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2814148243170db65379504b33836551'), 'Product')), 'Unit')),' Transferred'].join(''))

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/7b7501f7ca93d562793d409d2169ed53/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var item, Next_Load, Location_Data, j, Last_Point, Time_Now, Time_Start, Last_Load;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  Last_Load = (await asyncListSort((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'Status')) == 'Delivered');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  }))[0];
  Next_Load = ___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689');
  Time_Now = (new Date());
  Time_Start = (new Date((new Date()).getTime() - (2700 * 1000)));
  Location_Data = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Device ID')), Time_Start, Time_Now));
  if (Location_Data.length > 0) {
    Last_Point = (await Promise.all(Location_Data.map(async item => {; return ({ [`lat`]: (getObjectProperty(item, 'position.latitude')),[`lng`]: (getObjectProperty(item, 'position.longitude')) });}))).slice(-1)[0];
    var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['Distance'] = (await BackendlessUI.Functions.Custom['fn_24a626fc74c34a9805e7999658bdcfd6'](Last_Point, (getObjectProperty(j, 'Point'))));
    }
  } else {
    Last_Point = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Location'));
    var j_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      j['Distance'] = (await BackendlessUI.Functions.Custom['fn_24a626fc74c34a9805e7999658bdcfd6'](Last_Point, (getObjectProperty(j, 'Point'))));
    }
  }
  if ((getObjectProperty(Next_Load, 'Status')) == 'Loaded') {
    await new Promise(r => setTimeout(r, 500 || 0));
    Next_Load['Mileage'] = (Location_Data.length > 0 ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((Location_Data.slice(-1)[0]), 'can.vehicle.mileage')))) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')) : (getObjectProperty((Location_Data.slice(-1)[0]), 'can.vehicle.mileage'))) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')));
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('7b7501f7ca93d562793d409d2169ed53', Next_Load);
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('55958c7ddecb8cd28707249f690eb88c', (getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), 1, async (item) => {


     return (getObjectProperty(item, 'Distance'));
    }))[0]), 'objectId')));
  } else if ((getObjectProperty(Next_Load, 'Status')) == 'Depot') {
    await new Promise(r => setTimeout(r, 500 || 0));
    Next_Load['Mileage'] = (Location_Data.length > 0 ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((Location_Data.slice(-1)[0]), 'can.vehicle.mileage')))) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')) : (getObjectProperty((Location_Data.slice(-1)[0]), 'can.vehicle.mileage'))) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Odometer')));
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('7b7501f7ca93d562793d409d2169ed53', Next_Load);
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('55958c7ddecb8cd28707249f690eb88c', (getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), 1, async (item) => {


     return (getObjectProperty(item, 'Distance'));
    }))[0]), 'objectId')));
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/FIFDRIVER/components/97ef947b35d8c276bd18a708c078ff84/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var item, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    if ((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9b6ca62c950c0d2ed9766ecfd8369582')), async (item) => {


     return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Transferred')))));
    })).length == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9b6ca62c950c0d2ed9766ecfd8369582')).length) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/ce989c8558dd108d676b33423bd1090f/bundle.js', [], () => ({
  /* content */
  /* handler:onSaveSignatureClick */
  async ['onSaveSignatureClick'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Status')) == 'Loaded') {
    ___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53')['Transfer_Driver_Signature_Offloading'] = (await Backendless.Files.saveFile(encodePath((['users/',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'/','signatures'].join(''))), (String(generateUUID().long()) + String('.png')), ___arguments['signature'], false));
    await new Promise(r => setTimeout(r, 500 || 0));
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('c4816da85fcd47dbe3288fc14364ab0f', undefined);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Status')) == 'Depot') {
    ___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53')['Transfer_Driver_Signature_Loading'] = (await Backendless.Files.saveFile(encodePath((['users/',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'/','signatures'].join(''))), (String(generateUUID().long()) + String('.png')), ___arguments['signature'], false));
    await new Promise(r => setTimeout(r, 500 || 0));
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('c4816da85fcd47dbe3288fc14364ab0f', undefined);
  }

  },
  /* handler:onSaveSignatureClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/07e347e2bbf87bc8b5882d7f8cec8bbc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Status')) == 'Loaded') {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Transfer_Driver_Signature_Offloading'))))) {
      Viewer = false;
    } else {
      Viewer = true;
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Status')) == 'Depot') {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Transfer_Driver_Signature_Loading'))))) {
      Viewer = false;
    } else {
      Viewer = true;
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Reloaded_Loads, Loading_Transaction, Loaded_Product, Mass, item, error, Trailer_List, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Mass = [0];
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9b6ca62c950c0d2ed9766ecfd8369582'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Transferred'))))) {
      addItemToList(Mass, 0);
    } else {
      addItemToList(Mass, ((getObjectProperty(j, 'Transferred')) * (getObjectProperty(j, 'Unit mass'))));
    }
  }
  Mass = (await asyncListFilter(Mass, async (item) => {


   return (item > 0);
  }));
  Loaded_Product = (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9b6ca62c950c0d2ed9766ecfd8369582')).map(async item => {; return ({ [`Mass`]: (getObjectProperty(item, 'Units')) * (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')),[`Units`]: (getObjectProperty(item, 'Units')),[`Product`]: (getObjectProperty(item, 'Product')),[`Unit mass`]: (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')) });})));
  delete ___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53')['Mileage'];
  Loading_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Loading_Transaction;

    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Status')) == 'Loaded') {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Load_Product_JSON'))['Transferred - Offload'] = (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9b6ca62c950c0d2ed9766ecfd8369582')).map(async item => {; return ({ [`Mass`]: (getObjectProperty(item, 'Units')) * (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')),[`Units`]: (getObjectProperty(item, 'Units')),[`Product`]: (getObjectProperty(item, 'Product')),[`Unit mass`]: (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')) });})));
      ___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53')['Status'] = 'Depot';
      ___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53')['Date_Transfer_Offload'] = (new Date());
      ___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53')['Transfer_Rig_Details'] = ({ [`Offload Vehicle`]: ({ [`Vehicle`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')),[`Mileage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Mileage')),[`Mass Transferred`]: Mass.reduce(function(x, y) {return x + y;}),[`Transferred Product`]: Loaded_Product }) });
      ___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53')['TID'] = null;
      _uow.deleteRelation('Tractors', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'Loads', ___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'));
      _uow.deleteRelation('Loads', ___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Rig_Tractor', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')));
      Trailer_List = [];
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), ' Trailer1'))))) {
      } else {
        addItemToList(Trailer_List, (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), ' Trailer1')), 'objectId')));
      }
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), ' Trailer2'))))) {
      } else {
        addItemToList(Trailer_List, (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), ' Trailer2')), 'objectId')));
      }
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), ' Trailer3'))))) {
      } else {
        addItemToList(Trailer_List, (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), ' Trailer3')), 'objectId')));
      }
      try {
        _uow.deleteRelation('Loads', ___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Rig_Trailers', Trailer_List);

      } catch (error) {
        console.log(error);

      }
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Status')) == 'Depot') {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Load_Product_JSON'))['Transferred - Load'] = (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9b6ca62c950c0d2ed9766ecfd8369582')).map(async item => {; return ({ [`Mass`]: (getObjectProperty(item, 'Units')) * (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')),[`Units`]: (getObjectProperty(item, 'Units')),[`Product`]: (getObjectProperty(item, 'Product')),[`Unit mass`]: (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')) });})));
      ___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53')['Status'] = 'Transferred ';
      ___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53')['Date_Transfer_Load'] = (new Date());
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Transfer_Rig_Details'))['Load Vehicle'] = ({ [`Vehicle`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')),[`Mileage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Mileage')),[`Mass Transferred`]: Mass.reduce(function(x, y) {return x + y;}),[`Transferred Product`]: Loaded_Product });
    }
    _uow.update('Loads', ___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'));
    _uow.find('Loads', Backendless.DataQueryBuilder.create().setWhereClause((['TID = \'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')),'\''].join(''))).setPageSize(100));

  })();

  Reloaded_Loads = (await Loading_Transaction.execute());
  (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))['Loads'] = (getObjectProperty((getObjectProperty((getObjectProperty(Reloaded_Loads, 'results')), 'findLoads1')), 'result'));
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Load Initiated'];
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('099d36a9817ec8430d09d033f9a2e7f7', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/c4816da85fcd47dbe3288fc14364ab0f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Status')) == 'Loaded') {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Transfer_Driver_Signature_Offloading'))))) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Status')) == 'Depot') {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7b7501f7ca93d562793d409d2169ed53'), 'Transfer_Driver_Signature_Loading'))))) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/4d98d1c89bf8e04879b8c1d88179e15a/bundle.js', [], () => ({
  /* content */
  /* handler:onDecodeSuccess */
  async ['onDecodeSuccess'](___arguments) {
    var Odometer_Check, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors'));
  console.log(___arguments['decodedQRCode']);
  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')) !== null && !Array.isArray((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))) && (typeof (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')) === 'object')) {
    delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Selected Tractor'];
    delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Step 2'];
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Selected Tractor'] = ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ___arguments['decodedQRCode']);
    }))[0]);
  } else {
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Selected Tractor'] = ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ___arguments['decodedQRCode']);
    }))[0]);
  }
  Odometer_Check = (getObjectProperty(((await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor')), 'Device ID')), (new Date((new Date()).getTime() - (6000 * 1000))), (new Date()))).slice(-1)[0]), 'can.vehicle.mileage'));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Odometer_Check))) {
  } else {
    (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Selected Tractor'))['New Odometer'] = Odometer_Check;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d7d2f1d8829a6f5190b3ace1411b5f7', false);
    ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['Step 2'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4d98d1c89bf8e04879b8c1d88179e15a', false);
  }

  },
  /* handler:onDecodeSuccess */
  /* content */
}))

define('./pages/FIFDRIVER/components/d57581b17d5a5dfe8fd662839c271da3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))))) {
        Visability = false;
      } else {
        Visability = true;
      }
    }
  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/8de619aeb1126adc21037a696aac05a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))))) {
        Visability = false;
      } else {
        Visability = true;
      }
    }
  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/103233a3b1e4ffd5c073adacd08f8dab/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))))) {
        Visability = false;
      } else {
        Visability = true;
      }
    }
  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFDRIVER/components/39789c94b42f1a084fdd335591e39766/bundle.js', [], () => ({
  /* content */
  /* handler:OnPropertyChange */
  async ['OnPropertyChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments['PropertyName'] == 'Flash') {
    delete ___arguments.context.pageData['Flash'];
    delete (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))['Loads'];
    (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))['Loads'] = (await Backendless.Data.of('Loads').find(Backendless.DataQueryBuilder.create().setWhereClause((['TID = \'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')),'\' AND (Status = \'Loaded\' OR Status = \'Planned\' OR Status = \'Transferred\' OR Status = \'Depot\')'].join(''))).setPageSize(100)));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b0080736167702cb4ed87a24dfa855b5', false);
    await new Promise(r => setTimeout(r, 2000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b0080736167702cb4ed87a24dfa855b5', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('37ad3ef2d599972beb9890f3fe0b5e3d', false);
    console.log((await BackendlessUI.Functions.Custom['fn_88481472e3e169797cae85c104751a08']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))));
  }

  },
  /* handler:OnPropertyChange */
  /* content */
}))

define('./pages/FIFDRIVER/components/d01a17744b980ab418886f74ccd8528d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Notes'))))) {
    ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Load_Notes'] = (String('(Driver Notes) - (Loading)\n') + String(getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Notes')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3')['Load_Notes'] = (['(Load Planner Notes)\n',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fd853ab68db6498d0766ca6e0eb64aa3'), 'Load_Notes')),'\n(Driver Notes) - (Loading)\n',(getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Notes'))].join(''));
  }
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('9ec8146f3138db58cdc8fb68f7e8d213', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFDRIVER/components/bc6315ac2726b292499170c40f7c02c8/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    List = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      List = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        List = [];
      } else {
        List = (getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), 1, async (item) => {


         return (getObjectProperty(item, 'Distance'));
        }))[0]), 'objectId'));
      }
    }
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('257915777882e5481eb691aeebe7c0f8', List);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/FIFDRIVER/components/a7a83088bfd38368d21d309c37887db8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Load_Notes'))))) {
    ___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689')['Load_Notes'] = (String('\n(Driver Notes) - (Delivery)\n') + String(getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Notes')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689')['Load_Notes'] = (['(Load Planner Notes)\n',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('45224cabf5c7a5e80144ee283dcd3689'), 'Load_Notes')),'\n(Driver Notes) - (Delivery)\n',(getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Notes'))].join(''));
  }
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('c9a6af4af0e8a3d993ef11c85ed284f8', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/63528a0a331c876df799faff6331827e/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('63528a0a331c876df799faff6331827e'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('63528a0a331c876df799faff6331827e'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('e97e3d4bdd01f07b4327e42bc27e1fb8', undefined);
  await new Promise(r => setTimeout(r, 300 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cbea0f239d6860ff11d95851956f5343', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/cf94581d4c9e1546f48f8b99068a6dd7/bundle.js', [], () => ({
  /* content */
  /* handler:themeLogic */
  ['themeLogic'](___arguments) {
      return ({ [`forecastIconColor`]: 'rgb(255, 95, 31)',[`todayIconColor`]: 'rgb(255, 95, 31)' })

  },
  /* handler:themeLogic */
  /* content */
}))

define('./pages/FIFOFFICE/components/b5ae0b0e84058609dce18402a42b1041/bundle.js', [], () => ({
  /* content */
  /* handler:onMarkerClick */
  async ['onMarkerClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, marker, popupContent) { ___arguments.context.getComponentByUid(componentUid).map.showInfoWindow(marker, { content: popupContent }) })('b5ae0b0e84058609dce18402a42b1041', ___arguments.point, (['<!DOCTYPE html> <html> <head>     <style>         body {             background-color: black;             color: #CC6633;         }         table {             width: 100%;             border-collapse: collapse;         }         th, td {             border: 1px solid #CC6633;             padding: 5px;             text-align: left;             background-color: black;         }         th {             color: #CC6633;         }     </style> </head> <body>  <table>     <tr>         <th>ID</th>         <td>',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'ID')))) ? null : (getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'ID'))),'</td>     </tr>     <tr>         <th>Registration</th>         <td>',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Registration')))) ? null : (getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Registration'))),'</td>     </tr>     <tr>         <th>Odometer</th>         <td>',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Odometer')))) ? null : (getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Odometer'))),'</td>     </tr>     <tr>         <th>Fuel</th>         <td>',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Tank_Litres')))) ? null : (getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Tank_Litres'))),'l</td>     </tr>     <tr>         <th>Driver</th>         <td>',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Driver1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Driver1')), 'Employee_Details_Nickname')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Driver1')), 'Employee_Details_Nickname')))),'</td>     </tr>     <tr>         <th>Mobile</th>         <td>',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Driver1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Driver1')), 'Employee_Details_Phone')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Driver1')), 'Employee_Details_Phone')))),'</a></td>     </tr>     <tr>         <th>Trailer1</th>         <td>',[(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer1')), 'ID')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer1')), 'ID')))),' - ',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer1')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer1')), 'Registration')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer1')), 'Registration'))))].join(''),'</td>     </tr>     <tr>         <th>Trailer2</th>         <td>',[(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer2')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer2')), 'ID')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer2')), 'ID')))),' - ',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer2')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer2')), 'Registration')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer2')), 'Registration'))))].join(''),'</td>     </tr>     <tr>         <th>Trailer3</th>         <td>',[(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer3')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer3')), 'ID')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer3')), 'ID')))),' - ',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.point, 'Tractor')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer3')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer3')), 'Registration')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.point, 'Tractor')), 'Trailer3')), 'Registration'))))].join(''),'</td>     </tr> </table>  </body> </html>'].join('')));

  },
  /* handler:onMarkerClick */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var Centre, error, item, j, Last_Location_Data, New_List, Tracking_Data, Zoom_Level;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors'))))) {
      } else {
        Last_Location_Data = (await BackendlessUI.Functions.Custom['fn_f93a70853ae43c949fdb97c43719532e']((await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


         return (getObjectProperty(item, 'Device ID'));
        })).map(async item => {; return (getObjectProperty(item, 'Device ID'));})))));
        var j_list = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


         return (getObjectProperty(item, 'Device ID'));
        }));
        for (var j_index in j_list) {
          j = j_list[j_index];
          try {
            Tracking_Data = (await asyncListFind(Last_Location_Data, async (item) => {


             return ((getObjectProperty(item, 'device.id')) == (getObjectProperty(j, 'Device ID')));
            }));

          } catch (error) {

          }
          try {
            j['Tracking Live'] = Tracking_Data;

          } catch (error) {

          }
          try {
            (getObjectProperty(j, 'Location'))['y'] = (getObjectProperty(Tracking_Data, 'position.latitude'));

          } catch (error) {

          }
          try {
            (getObjectProperty(j, 'Location'))['x'] = (getObjectProperty(Tracking_Data, 'position.longitude'));

          } catch (error) {

          }
          try {
            (getObjectProperty(j, 'Location'))['lat'] = (getObjectProperty(Tracking_Data, 'position.latitude'));

          } catch (error) {

          }
          try {
            (getObjectProperty(j, 'Location'))['lng'] = (getObjectProperty(Tracking_Data, 'position.longitude'));

          } catch (error) {

          }
          try {
            (getObjectProperty(j, 'Location'))['movement'] = (getObjectProperty(Tracking_Data, 'movement.status'));

          } catch (error) {

          }
        }
        New_List = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


         return (getObjectProperty(item, 'Device ID'));
        }));
        await new Promise(r => setTimeout(r, 5000 || 0));
        await (async function(googleMapComponent, locations) {
        	function addNumberPlateMarkers(googleMapComponent, locations) {
        	  // Check if the Google Map component and map instance are valid
        	  if (
        	    !googleMapComponent ||
        	    !googleMapComponent.map ||
        	    !(googleMapComponent.map.map instanceof google.maps.Map)
        	  ) {
        	    console.error('Invalid Google Map component.');
        	    return;
        	  }
        	
        	  const mapInstance = googleMapComponent.map.map; // Get the actual map instance
        	
        	  // Define a fixed size for the South African number plates
        	  const plateWidth = 150;  // Fixed width for all number plates
        	  const plateHeight = 40;  // Fixed height for all number plates
        	
        	  // Function to create the SVG for a South African number plate with an inverted triangle.
        	  // It now accepts a `color` parameter to dynamically set the color.
        	  function createNumberPlateSVG(id, color) {
        	    return `
        	      <svg xmlns="http://www.w3.org/2000/svg" width="${plateWidth}" height="${plateHeight + 30}" viewBox="0 0 ${plateWidth} ${plateHeight + 45}">
        	        <!-- Number plate box with dynamic color for the stroke -->
        	        <rect width="${plateWidth}" height="${plateHeight}" rx="8" ry="8" fill="white" stroke="${color}" stroke-width="4" />
        	        
        	        <!-- Bold dynamic text (vehicle ID) with proper centering -->
        	        <text x="${plateWidth / 2}" y="${plateHeight / 2 + 10}" font-family="Arial" font-size="20" fill="${color}" font-weight="bold" text-anchor="middle">
        	          ${id}
        	        </text>
        	        
        	        <!-- Inverted triangle below the number plate with dynamic color -->
        	        <polygon points="${plateWidth / 2},${plateHeight + 20} ${(plateWidth / 2) - 7.5},${plateHeight} ${(plateWidth / 2) + 7.5},${plateHeight}" fill="${color}" stroke="none" />
        	      </svg>
        	    `;
        	  }
        	
        	  // Loop through each location in the array and create a marker
        	  locations.forEach(location => {
        	    const { lat, lng, ID, movement } = location; // Extract lat, lng, ID, and movement from the location object
        	
        	    // Determine the color based on movement.status: if false, use '#EE4B2B', otherwise default to '#cc6633'
        	    const plateColor = movement === false ? '#cc6633' : '#006400' ;
        	
        	    // Create the custom SVG icon for the marker with fixed size
        	    const numberPlateIcon = {
        	      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(createNumberPlateSVG(ID, plateColor))}`,
        	      anchor: new google.maps.Point(plateWidth / 2, plateHeight + 20), // Adjusted anchor to the lower triangle position
        	      scaledSize: new google.maps.Size(plateWidth, plateHeight + 30) // Adjusted height to fit the inverted triangle and box
        	    };
        	
        	    // Create a new marker on the map with the custom SVG icon
        	    const marker = new google.maps.Marker({
        	      position: { lat, lng },
        	      map: mapInstance,
        	      icon: numberPlateIcon,
        	      draggable: false // Markers are static and not draggable
        	    });
        	
        	    // Set the `currentTracking` property in appData with the marker's Registration ID on click
        	    marker.addListener('click', () => {
        	      ___arguments.context.appData.currentTracking = ID;
        	      console.log(`currentTracking is now set to: ${ID}`);
        	    });
        	
        	    // Add hover event listeners to change the zIndex
        	    marker.addListener('mouseover', () => {
        	      marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1); // Bring the marker to the top on hover
        	    });
        	
        	    marker.addListener('mouseout', () => {
        	      marker.setZIndex(undefined); // Reset the zIndex to its default after hover
        	    });
        	  });
        	}
        	
        	// Example of how the function will be used in Backendless Custom Code Block
        	try {
        	  const googleMapComponent = arguments[0]; // Pass Google Map component
        	  const locations = arguments[1]; // Pass array of objects [{ lat, lng, ID, movement: { status: boolean } }, ... ]
        	
        	  // Call the function to add markers with fixed number plate size, dynamic color based on movement status, centered text, adjusted triangle, and zIndex on hover
        	  addNumberPlateMarkers(googleMapComponent, locations);
        	} catch (error) {
        	  console.error('Error adding number plate markers:', error);
        	}

        })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b5ae0b0e84058609dce18402a42b1041')), (await Promise.all(New_List.map(async item => {; return ({ [`lat`]: (getObjectProperty((getObjectProperty(item, 'Location')), 'lat')),[`lng`]: (getObjectProperty((getObjectProperty(item, 'Location')), 'lng')),[`ID`]: (getObjectProperty(item, 'Registration')),[`movement`]: (getObjectProperty((getObjectProperty(item, 'Location')), 'movement')) });}))));
        for (var count = 0; count < 100; count++) {
          await new Promise(r => setTimeout(r, 300000 || 0));
          Zoom_Level = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).zoom })('b5ae0b0e84058609dce18402a42b1041'));
          Centre = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('b5ae0b0e84058609dce18402a42b1041'));
          Last_Location_Data = (await BackendlessUI.Functions.Custom['fn_f93a70853ae43c949fdb97c43719532e']((await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


           return (getObjectProperty(item, 'Device ID'));
          })).map(async item => {; return (getObjectProperty(item, 'Device ID'));})))));
          var j_list2 = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


           return (getObjectProperty(item, 'Device ID'));
          }));
          for (var j_index2 in j_list2) {
            j = j_list2[j_index2];
            try {
              Tracking_Data = (await asyncListFind(Last_Location_Data, async (item) => {


               return ((getObjectProperty(item, 'device.id')) == (getObjectProperty(j, 'Device ID')));
              }));

            } catch (error) {
              console.log(error);

            }
            try {
              j['Tracking Live'] = Tracking_Data;

            } catch (error) {
              console.log(error);

            }
            try {
              (getObjectProperty(j, 'Location'))['y'] = (getObjectProperty(Tracking_Data, 'position.latitude'));

            } catch (error) {
              console.log(error);

            }
            try {
              (getObjectProperty(j, 'Location'))['x'] = (getObjectProperty(Tracking_Data, 'position.longitude'));

            } catch (error) {
              console.log(error);

            }
            try {
              (getObjectProperty(j, 'Location'))['lat'] = (getObjectProperty(Tracking_Data, 'position.latitude'));

            } catch (error) {
              console.log(error);

            }
            try {
              (getObjectProperty(j, 'Location'))['lng'] = (getObjectProperty(Tracking_Data, 'position.longitude'));

            } catch (error) {
              console.log(error);

            }
            try {
              (getObjectProperty(j, 'Location'))['movement'] = (getObjectProperty(Tracking_Data, 'movement.status'));

            } catch (error) {
              console.log(error);

            }
          }
          New_List = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


           return (getObjectProperty(item, 'Device ID'));
          }));
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5ae0b0e84058609dce18402a42b1041', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b5ae0b0e84058609dce18402a42b1041', true);
          (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('b5ae0b0e84058609dce18402a42b1041', Zoom_Level);
          (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('b5ae0b0e84058609dce18402a42b1041', (getObjectProperty(Centre, 'lat')), (getObjectProperty(Centre, 'lng')));
          await new Promise(r => setTimeout(r, 300 || 0));
          await (async function(googleMapComponent, locations) {
          	function addNumberPlateMarkers(googleMapComponent, locations) {
          	  // Check if the Google Map component and map instance are valid
          	  if (
          	    !googleMapComponent ||
          	    !googleMapComponent.map ||
          	    !(googleMapComponent.map.map instanceof google.maps.Map)
          	  ) {
          	    console.error('Invalid Google Map component.');
          	    return;
          	  }
          	
          	  const mapInstance = googleMapComponent.map.map; // Get the actual map instance
          	
          	  // Define a fixed size for the South African number plates
          	  const plateWidth = 150;  // Fixed width for all number plates
          	  const plateHeight = 40;  // Fixed height for all number plates
          	
          	  // Function to create the SVG for a South African number plate with an inverted triangle.
          	  // It now accepts a `color` parameter to dynamically set the color.
          	  function createNumberPlateSVG(id, color) {
          	    return `
          	      <svg xmlns="http://www.w3.org/2000/svg" width="${plateWidth}" height="${plateHeight + 30}" viewBox="0 0 ${plateWidth} ${plateHeight + 45}">
          	        <!-- Number plate box with dynamic color for the stroke -->
          	        <rect width="${plateWidth}" height="${plateHeight}" rx="8" ry="8" fill="white" stroke="${color}" stroke-width="4" />
          	        
          	        <!-- Bold dynamic text (vehicle ID) with proper centering -->
          	        <text x="${plateWidth / 2}" y="${plateHeight / 2 + 10}" font-family="Arial" font-size="20" fill="${color}" font-weight="bold" text-anchor="middle">
          	          ${id}
          	        </text>
          	        
          	        <!-- Inverted triangle below the number plate with dynamic color -->
          	        <polygon points="${plateWidth / 2},${plateHeight + 20} ${(plateWidth / 2) - 7.5},${plateHeight} ${(plateWidth / 2) + 7.5},${plateHeight}" fill="${color}" stroke="none" />
          	      </svg>
          	    `;
          	  }
          	
          	  // Loop through each location in the array and create a marker
          	  locations.forEach(location => {
          	    const { lat, lng, ID, movement } = location; // Extract lat, lng, ID, and movement from the location object
          	
          	    // Determine the color based on movement.status: if false, use '#EE4B2B', otherwise default to '#cc6633'
          	    const plateColor = movement === false ? '#cc6633' : '#006400' ;
          	
          	    // Create the custom SVG icon for the marker with fixed size
          	    const numberPlateIcon = {
          	      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(createNumberPlateSVG(ID, plateColor))}`,
          	      anchor: new google.maps.Point(plateWidth / 2, plateHeight + 20), // Adjusted anchor to the lower triangle position
          	      scaledSize: new google.maps.Size(plateWidth, plateHeight + 30) // Adjusted height to fit the inverted triangle and box
          	    };
          	
          	    // Create a new marker on the map with the custom SVG icon
          	    const marker = new google.maps.Marker({
          	      position: { lat, lng },
          	      map: mapInstance,
          	      icon: numberPlateIcon,
          	      draggable: false // Markers are static and not draggable
          	    });
          	
          	    // Set the `currentTracking` property in appData with the marker's Registration ID on click
          	    marker.addListener('click', () => {
          	      ___arguments.context.appData.currentTracking = ID;
          	      console.log(`currentTracking is now set to: ${ID}`);
          	    });
          	
          	    // Add hover event listeners to change the zIndex
          	    marker.addListener('mouseover', () => {
          	      marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 1); // Bring the marker to the top on hover
          	    });
          	
          	    marker.addListener('mouseout', () => {
          	      marker.setZIndex(undefined); // Reset the zIndex to its default after hover
          	    });
          	  });
          	}
          	
          	// Example of how the function will be used in Backendless Custom Code Block
          	try {
          	  const googleMapComponent = arguments[0]; // Pass Google Map component
          	  const locations = arguments[1]; // Pass array of objects [{ lat, lng, ID, movement: { status: boolean } }, ... ]
          	
          	  // Call the function to add markers with fixed number plate size, dynamic color based on movement status, centered text, adjusted triangle, and zIndex on hover
          	  addNumberPlateMarkers(googleMapComponent, locations);
          	} catch (error) {
          	  console.error('Error adding number plate markers:', error);
          	}

          })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b5ae0b0e84058609dce18402a42b1041')), (await Promise.all(New_List.map(async item => {; return ({ [`lat`]: (getObjectProperty((getObjectProperty(item, 'Location')), 'lat')),[`lng`]: (getObjectProperty((getObjectProperty(item, 'Location')), 'lng')),[`ID`]: (getObjectProperty(item, 'Registration')),[`movement`]: (getObjectProperty((getObjectProperty(item, 'Location')), 'movement')) });}))));
        }
      }
    }
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/FIFOFFICE/components/720178ef686ed0a2676436ca610d5137/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('50a47f3c60ef8698af8798187f726b12');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('50a47f3c60ef8698af8798187f726b12');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFOFFICE/components/e9327729d82a78cb8f8e49d586f7cacb/bundle.js', [], () => ({
  /* content */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    var j_list = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe63d7114a2242e76e3c1f3c973f0e57')), 'el')), 'children'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      ((getObjectProperty(j, 'children'))[4])['scrollLeft'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e9327729d82a78cb8f8e49d586f7cacb')), 'el')), 'scrollLeft'));
    }

  } catch (error) {

  }

  },
  /* handler:onScroll */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var Counter, j;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/FIFOFFICE/components/5a4731f51162cf49c58bc6858d77a8d7/bundle.js', [], () => ({
  /* content */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e9327729d82a78cb8f8e49d586f7cacb')), 'el'))['scrollLeft'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5a4731f51162cf49c58bc6858d77a8d7')), 'el')), 'scrollLeft'));

  } catch (error) {

  }
  try {
    var j_list = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe63d7114a2242e76e3c1f3c973f0e57')), 'el')), 'children'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      ((getObjectProperty(j, 'children'))[5])['scrollLeft'] = (getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e9327729d82a78cb8f8e49d586f7cacb')), 'el')), 'scrollLeft'));
    }

  } catch (error) {

  }

  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/FIFOFFICE/components/fe63d7114a2242e76e3c1f3c973f0e57/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item, Sorter, Tractors, Tractor_objectId, j, Fleetview, Tractor_Data, User, Counter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Old_Code_2() {
  Tractors = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors'));
  for (var j_index in Tractors) {
    j = Tractors[j_index];
    Tractor_Data = j;
    j['Tractor'] = (JSON.stringify(Tractor_Data));
  }
  for (var j_index2 in Tractors) {
    j = Tractors[j_index2];
    Tractor_objectId = (getObjectProperty(j, 'objectId'));
    Fleetview = (getObjectProperty(j, 'Fleetview_Current'));
    Fleetview['objectId (Fleetview)'] = (getObjectProperty(Fleetview, 'objectId'));
    delete Fleetview['objectId'];
    j = (Object.assign(j, Fleetview));
    j['objectId (Tractor)'] = Tractor_objectId;
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Fleetview Sorter'))))) {
    Sorter = 'ID';
  } else {
    Sorter = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Fleetview Sorter')), 'Property'));
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  Tractors = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors'));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Fleetview Sorter'))))) {
    Sorter = 'ID';
  } else {
    Sorter = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Fleetview Sorter')), 'Property'));
  }

  return ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Fleetview Sorter')))) ? (await asyncListSort(Tractors, 1, async (item) => {


 return (getObjectProperty(item, Sorter));
})) : ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Fleetview Sorter')), 'Direction')) == 'Up' ? (await asyncListSort(Tractors, -1, async (item) => {


 return (getObjectProperty(item, Sorter));
})) : (await asyncListSort(Tractors, 1, async (item) => {


 return (getObjectProperty(item, Sorter));
}))))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/93b872fa6eec6ff554271f7e75e4a6f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Image_Front')), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/e08c9c7419e9f1156c8806cfceb73651/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5a4731f51162cf49c58bc6858d77a8d7'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/f9b47c6585a48a4fe0bab28327772494/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Content = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + String(' km');

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/de451104a43493f757bc49f3f9417d3a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('023810ea19d611d8668de6cb90ac1585', undefined);
  console.log(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'));

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('d056f3514347c3cb0b761d24505d7495');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('d056f3514347c3cb0b761d24505d7495');

  },
  /* handler:onMouseOut */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/a8576f727141f44d9ad3af71c7dd40a7/bundle.js', [], () => ({
  /* content */
  /* handler:imagesDataLogic */
  ['imagesDataLogic'](___arguments) {
    var Image_Data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Image_Data = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Image_Front')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Image_Interior')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Image_Left')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Image_Rear')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Image_Right'))];

  return (Image_Data.join(','))

  },
  /* handler:imagesDataLogic */
  /* content */
}))

define('./pages/FIFOFFICE/components/98efecf200ce8372e8c7a079a8837814/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/ec1c059a2781de335f441a37553ca37c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/9aef0bf4680a7a17b335d677e27d7ccb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j;


  var j_list = (Object.keys(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')));
  for (var j_index in j_list) {
    j = j_list[j_index];
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')[j];
  }
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('023810ea19d611d8668de6cb90ac1585', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/62e19d2e3ddab64e57933eb624b28b22/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var View, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    View = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Status')).includes('Active'));

  } catch (error) {

  }

  return View

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/3ec16c62696de85f941cfd2d136a37aa/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var View, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    View = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Status')).includes('In For Service'));

  } catch (error) {

  }

  return View

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/47161524e7de0757c041ae5f1eac6728/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var View, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    View = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Status')).includes('Broken Down'));

  } catch (error) {

  }

  return View

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/0193f1885a7e98294446dc7e9eacc40f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var View, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    View = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Status')).includes('Decommissioned'));

  } catch (error) {

  }

  return View

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/ef96d5968592b8243e1749f994acd2bc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var View, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    View = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Status')).includes('For Sale'));

  } catch (error) {

  }

  return View

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/53c6424f97abaead2b33fad223c91e65/bundle.js', [], () => ({
  /* content */
  /* handler:MinLogic */
  ['MinLogic'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Input = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Profit_Target')) * 0.9;

  return Input

  },
  /* handler:MinLogic */
  /* handler:MaxLogic */
  ['MaxLogic'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Input = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Profit_Target')) * 3;

  return Input

  },
  /* handler:MaxLogic */
  /* handler:TargetLogic */
  ['TargetLogic'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Input = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Profit_Target'));

  return Input

  },
  /* handler:TargetLogic */
  /* handler:InputLogic */
  ['InputLogic'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Profit_Loss_Projected'));

  } catch (error) {

  }

  return Input

  },
  /* handler:InputLogic */
  /* handler:LeadLogic */
  ['LeadLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Profit_Loss_Projected')) < 0 ? '( R ' : 'R ')

  },
  /* handler:LeadLogic */
  /* handler:FollowLogic */
  ['FollowLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Profit_Loss_Projected')) < 0 ? ' )' : null)

  },
  /* handler:FollowLogic */
  /* content */
}))

define('./pages/FIFOFFICE/components/e32b6b2ffb2ad979b70c5101d012a701/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  ['InputLogic'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Distance_Travelled'));

  } catch (error) {

  }

  return Input

  },
  /* handler:InputLogic */
  /* handler:MaxLogic */
  ['MaxLogic'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * (new Date((new Date())).getDate()) * 1.1;

  } catch (error) {

  }

  return Input

  },
  /* handler:MaxLogic */
  /* handler:MinLogic */
  ['MinLogic'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * (new Date((new Date())).getDate()) * 0.95;

  } catch (error) {

  }

  return Input

  },
  /* handler:MinLogic */
  /* handler:TargetLogic */
  ['TargetLogic'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * (new Date((new Date())).getDate());

  } catch (error) {

  }

  return Input

  },
  /* handler:TargetLogic */
  /* content */
}))

define('./pages/FIFOFFICE/components/22bcbb1b99b8b6cda25421162561503c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8fa2ddba7c2d5c5d7eab08d2ce864b56', undefined);
  await new Promise(r => setTimeout(r, 200 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b2f6db22db758c1a86475775605eb8c3', true);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('22bcbb1b99b8b6cda25421162561503c');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('22bcbb1b99b8b6cda25421162561503c');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFOFFICE/components/20ea30b7d19a7e9c87659c1907c71d29/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('ccae1dcbcaf4892cdddddf977b919acd');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('ccae1dcbcaf4892cdddddf977b919acd');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('e9b3c46d01dbdf48702a683c74c9707c', undefined);
  await new Promise(r => setTimeout(r, 300 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fa2a9b712c4e546f68ddbbc501a3ade2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/dd4626f7cbf91d0fdc5bffb85a772cf5/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  ['InputLogic'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Consumption_Actual'));

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:InputLogic */
  /* handler:MinLogic */
  ['MinLogic'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Consumption_Ideal')) * 0.95;

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:MinLogic */
  /* handler:MaxLogic */
  ['MaxLogic'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Consumption_Ideal')) * 1.2;

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:MaxLogic */
  /* handler:TargetLogic */
  ['TargetLogic'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Consumption_Ideal'));

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:TargetLogic */
  /* content */
}))

define('./pages/FIFOFFICE/components/62bc3d5fe1ba731c46134bad6d020288/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('478885e5cc12094b1bc7f1579efbcedb');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('478885e5cc12094b1bc7f1579efbcedb');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('613cf84205d517eee86a85f97ef4da98', undefined);
  await new Promise(r => setTimeout(r, 200 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d5861392d64ba64bce6f38e591ebc467', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/57fea8da3d51d0ee43685be81deeb932/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  ['InputLogic'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Tonnage_Total'));

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:InputLogic */
  /* handler:TargetLogic */
  ['TargetLogic'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Tonnage_Projected_Ideal_For Today'));

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:TargetLogic */
  /* handler:MinLogic */
  ['MinLogic'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Tonnage_Projected_Ideal_For Today')) * 0.9;

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:MinLogic */
  /* handler:MaxLogic */
  ['MaxLogic'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Tonnage_Projected_Ideal_For Today')) * 1.3;

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:MaxLogic */
  /* handler:FollowLogic */
  ['FollowLogic'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = String(' ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Units'));

  } catch (error) {

  }

  return Input

  },
  /* handler:FollowLogic */
  /* content */
}))

define('./pages/FIFOFFICE/components/112c54a8154307d7fd03ad01766b21d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('12ffcd2a0f5af80bebf447edfaf53caf', undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('de1c4a0e7ec79398c89aa7bbdd889b09');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('de1c4a0e7ec79398c89aa7bbdd889b09');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFOFFICE/components/9ec83f542cc866282fbb5c3d74e1b2f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'License_Status')) == 'License Overdue' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'License_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f44a28e8f6f3fc877238de766fd33d18', undefined);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b6aae70451c6ec06f5a1a9a6bef954a3', ({ [`Item`]: ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'),[`Type`]: 'Tractor' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/0c558a0366c259cf3ff176e8e8139fd1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'License_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/5e4492bc1373d799729ff7126841eeed/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'License_Status')) == 'License Overdue') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/8da96b7652827102cb02a8d50f1cdfa5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'License_Status')) == 'License Overdue' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'License_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f44a28e8f6f3fc877238de766fd33d18', undefined);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b6aae70451c6ec06f5a1a9a6bef954a3', ({ [`Item`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')),[`Type`]: 'Trailer',[`Number`]: 'Trailer1' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/ca634544cb410fc150361a130d31a7ae/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'License_Status')) == 'License Overdue') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/b2939cb5553e1053cb389a2af3f9aca8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'License_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/83b6e7ba1aa220feb6c648e25754c678/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'License_Status')) == 'License Overdue' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'License_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f44a28e8f6f3fc877238de766fd33d18', undefined);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b6aae70451c6ec06f5a1a9a6bef954a3', ({ [`Item`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')),[`Type`]: 'Trailer',[`Number`]: 'Trailer2' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/76a434cd1db5864872ed2d9655c690ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'License_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/bfc562c97473f896bd938c83dcc2c49a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'License_Status')) == 'License Overdue') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/b39803a78df15f2ce0bb81c6616e10eb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'License_Status')) == 'License Overdue' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'License_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f44a28e8f6f3fc877238de766fd33d18', undefined);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b6aae70451c6ec06f5a1a9a6bef954a3', ({ [`Item`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')),[`Type`]: 'Trailer',[`Number`]: 'Trailer2' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/b49bd8f13e1cfc543314798a6932f2b5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'License_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/37b3bd8716ccdf58f02dbf662b192561/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'License_Status')) == 'License Overdue') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/eee7650841338caf805fede14d1858b5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_License_Expirey_Date_Status')) == 'License Overdue' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_License_Expirey_Date_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f44a28e8f6f3fc877238de766fd33d18', undefined);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b6aae70451c6ec06f5a1a9a6bef954a3', ({ [`Item`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')),[`Type`]: 'Driver' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/818860caf27c853a38d9028861f110ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_License_Expirey_Date_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/be7b322166bb75ae6aea8a557b85db38/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_License_Expirey_Date_Status')) == 'License Overdue') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/ce7ee0c78eb7c3fb79e92a82a53a9fee/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_PDP_Expiry_Date_Status')) == 'License Overdue' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_PDP_Expiry_Date_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f44a28e8f6f3fc877238de766fd33d18', undefined);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b6aae70451c6ec06f5a1a9a6bef954a3', ({ [`Item`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')),[`Type`]: 'PDP' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/52916abf60ee01dc1299a21fc48cd0b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_PDP_Expiry_Date_Status')) == 'License Due') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/64c80f023024f806216ab67ce1ac7024/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_PDP_Expiry_Date_Status')) == 'License Overdue') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/ff243b89c93b7b2a041d3f2991983fe1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service_Status')) == 'Service Due') {
      Viewer = true;
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service_Status')) == 'Scheduled') {
        if ((getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


         return ((getObjectProperty(item, 'Service_ID')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_ID')));
        }))[0]), 'Status')) == 'Delivered') {
          Viewer = true;
        } else {
          Viewer = false;
        }
      } else {
        Viewer = false;
      }
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Unscheduled Services')) == false) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_ID'))))) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f3e9c22366f902aef4819ddad8b9b81a', undefined);
    } else {
      await new Promise(r => setTimeout(r, 300 || 0));
      ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Service Item'] = ((await Backendless.Data.of('Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Service_ID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_ID')),'\''].join(''))).setPageSize(10)))[0]);
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Tractor',[`Vehicle`]: ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'),[`Odometer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) }));
    }
  } else {
    await new Promise(r => setTimeout(r, 300 || 0));
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Tractor',[`Vehicle`]: ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'),[`Odometer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/8a46254eda548eae2acbf8d91c48ffb9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Service_Status')) == 'Service Due' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Service_Status')) == 'Scheduled') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 300 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Trailer1',[`Vehicle`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')),[`Odometer`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Odometer')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/d55def9ccaa104ce0caf27cee21d7bf2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Service_Status')) == 'Service Due' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Service_Status')) == 'Scheduled') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 300 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Trailer2',[`Vehicle`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')),[`Odometer`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Odometer')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/0809a87a23b9414e11cd8fa66c22bc81/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Service_Status')) == 'Service Due' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Service_Status')) == 'Scheduled') {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 300 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Trailer3',[`Vehicle`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')),[`Odometer`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Odometer')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/e6eab1d960ba7b1f4b96a96a50a65755/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var item, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Current Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Current Load')).length)) > 0 == true || ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Current Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Current Load')).length)) > 0 == true || ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Current Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Current Load')).length)) > 0 == true || ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? 0 : (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) == 'Loaded');
    })).length) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('2df6d67298abaf23f0d613c201e151d7', true);
  try {
    await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('856f6a28c99b0a8403476af7237cad34', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/c6c928fd318663e8f5e9b3ba20d8c89f/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  async ['onContainerDataAssignment'](___arguments) {
    var Data_Model, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    Data_Model = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Axles_Data')), 1, async (item) => {


     return (getObjectProperty(item, 'Position Number'));
    }));

  } catch (error) {

  } finally {
    if (error) {
      Data_Model = null;
    }

  }

  return Data_Model

  },
  /* handler:onContainerDataAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
      Viewer = false;
    } else {
      Viewer = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/a89417b6d0668a1d1471a008db6be484/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Make'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Make'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/a66d3ba626acf5f2c5b74b8b01253c53/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.appData);
  console.log(___arguments.context.pageData);
  console.log(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'));
  console.log(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'));
  console.log(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'));
  console.log(___arguments.event);

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Model'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Model'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/fd9dd904fd4ccfb7782f198b3425892f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      delete ___arguments.context.appData['Network'];
  delete ___arguments.context.appData['User'];
  await Backendless.UserService.logout();
  console.log((function () { return window.location.href })());
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/ae6f79f55593fcf49f6d5fde6a6cb8bd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payloadview'))))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration'))))) {
        Content = '';
      } else {
        Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration'));
      }
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
        Content = [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload_Override')))) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload_Override')),'kg','\n','No Trailers'].join('');
      } else {
        if (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) && !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
          Content = [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload_Override')))) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload_Override')),'kg','\n',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Type')),'\n','(Superlink)'].join('');
        } else {
          Content = [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload_Override')))) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload_Override')),'kg','\n',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Type'))].join('');
        }
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('93b872fa6eec6ff554271f7e75e4a6f1', undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Payloadview'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('3b23308492819449e525edaab38fb7f8');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      delete ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Payloadview'];
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('3b23308492819449e525edaab38fb7f8');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFOFFICE/components/9dfca5496c0ae199f6e4868fbb64fcfb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var item, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Next Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Next Load')).length)) > 0 == true || ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Next Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Next Load')).length)) > 0 == true || ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Next Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Next Load')).length)) > 0 == true || ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? 0 : (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) == 'Planned');
    })).length) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('856f6a28c99b0a8403476af7237cad34', true);
  try {
    await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('2df6d67298abaf23f0d613c201e151d7', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/1a79f6851bf5eb241d92f5da73557e8b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('54a992b40b6d0efed5942c26ed6fb97b', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/076b52d3e4041543b4af8ac958dca3aa/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('9b8fefbb70dae96eab3e3732d53bf786');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('9b8fefbb70dae96eab3e3732d53bf786');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFOFFICE/components/d8c186fb87fe5bb74aaea30b3a818014/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('39b977aba67b2fae9fe845d6294de453');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('39b977aba67b2fae9fe845d6294de453');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('99f282ff0c2737e9f9837e2932fc5155', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/62fd2db16dc48499896efab14c1e4e44/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('1a5f10e9652a5288229acd221fb9b7fd');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('1a5f10e9652a5288229acd221fb9b7fd');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFOFFICE/components/852100c47438a0b1c81d9c34926a302e/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('852100c47438a0b1c81d9c34926a302e'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('852100c47438a0b1c81d9c34926a302e'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('d6fa4831d4b8222782da812481678bb4', undefined);
  ___arguments.context.pageData['Asset Drawer Data'] = 'Tractors';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/bb94094b79c8a35baf56f5c38151f29d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Time_Now, Time_Start, item, Points_List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  console.log(getObjectProperty((await (async function(to, from, Device) {
  	// Define the function to execute the HTTP request
  	async function fetchFlespiMessages(start, end, device) {
  	  console.log(`Fetching messages for device ${device} from ${start} to ${end}`);
  	
  	  // Construct the URL with query parameters
  	  const url = `https://flespi.io/gw/devices/${device}/messages?data=%7B%22to%22%3A${end}%2C%22from%22%3A${start}%7D`;
  	
  	  const headers = {
  	    'Content-Type': 'application/json',
  	    'Authorization': 'FlespiToken 1rSTqs5yHq64EsaPeiYKanXoP7VR0ru8GuoNJMVM0VUfWoen391ae0kGfdbOXocW'
  	  };
  	
  	  // Perform the HTTP GET request using fetch
  	  const response = await fetch(url, { headers });
  	  if (!response.ok) {
  	    throw new Error(`HTTP error! status: ${response.status}`);
  	  }
  	
  	  // Parse and return the JSON response
  	  const result = await response.json();
  	  return result;
  	}
  	
  	// Retrieve the parameters passed to the custom code block
  	const start = from;
  	const end = to;
  	const device = arguments[2]; // Retrieve the device number from arguments
  	
  	// Print the parameters for debugging
  	console.log(`Start (from): ${start}`);
  	console.log(`End (to): ${end}`);
  	console.log(`Device: ${device}`);
  	
  	// Call the function with the retrieved parameters
  	return fetchFlespiMessages(start, end, device);

  })((1 / 1000), (1 / 1000), null)), 'result'));
  await (async function(googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers, pointColor, pointScale) {
  	function addPolylineAndCustomMarkers(googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers) {
  	  // Ensure googleMapComponent is valid
  	  if (!googleMapComponent) {
  	    console.error("Invalid googleMapComponent.");
  	    return;
  	  }
  	
  	  // Retrieve the map instance from googleMapComponent
  	  const mapInstance = googleMapComponent.map.map;
  	
  	  // Ensure mapInstance is valid
  	  if (!(mapInstance instanceof google.maps.Map)) {
  	    console.error("Invalid map instance. Map is:", mapInstance);
  	    return;
  	  }
  	
  	  // Generate coordinates for the polyline from markers
  	  const polylineCoordinates = markers.map(marker => ({
  	    lat: marker.lat,
  	    lng: marker.lng
  	  }));
  	
  	  // Create a new Polyline object
  	  const polyline = new google.maps.Polyline({
  	    path: polylineCoordinates,
  	    geodesic: true,
  	    strokeColor: polylineColor || '#FF0000',
  	    strokeOpacity: strokeOpacity || 1.0,
  	    strokeWeight: strokeWeight || 2
  	  });
  	
  	  // Set the polyline on the map
  	  polyline.setMap(mapInstance);
  	
  	  // Function to calculate the bearing between two points
  	  function calculateHeading(lat1, lng1, lat2, lng2) {
  	    const toRadians = degrees => degrees * Math.PI / 180;
  	    const toDegrees = radians => radians * 180 / Math.PI;
  	
  	    const dLng = toRadians(lng2 - lng1);
  	    const y = Math.sin(dLng) * Math.cos(toRadians(lat2));
  	    const x = Math.cos(toRadians(lat1)) * Math.sin(toRadians(lat2)) - Math.sin(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.cos(dLng);
  	    const bearing = toDegrees(Math.atan2(y, x));
  	    return (bearing + 360) % 360;  // Normalize to 0-360
  	  }
  	
  	  // Add custom markers to the map
  	  pointMarkers.forEach((marker, index) => {
  	    let icon;
  	    if (marker.Speed === 0) {
  	      // Create a dot for the marker if Speed is 0
  	      icon = {
  	        path: google.maps.SymbolPath.CIRCLE,
  	        fillColor: marker.color || pointColor || '#FF0000',
  	        fillOpacity: 1,
  	        strokeColor: 'black',
  	        strokeWeight: 2,  // Increased stroke weight for better visibility
  	        scale: marker.scale || pointScale || 8,  // Increased scale for better visibility
  	      };
  	    } else {
  	      // Create an arrow for other markers
  	      let heading = marker.Direction !== undefined ? marker.Direction : 0;
  	      if (marker.Direction === undefined && index < pointMarkers.length - 1) {
  	        const nextMarker = pointMarkers[index + 1];
  	        heading = calculateHeading(marker.lat, marker.lng, nextMarker.lat, nextMarker.lng);
  	      }
  	
  	      // Adjust the heading by subtracting 90 degrees
  	      heading = (heading - 90 + 360) % 360;
  	
  	      icon = {
  	        path: "M 0 0 L -2 -2 L 1 0 L -2 2 Z",
  	        fillColor: marker.color || pointColor || '#FF0000',
  	        fillOpacity: 1,
  	        strokeColor: 'black', // Outline color
  	        strokeWeight: 2, // Increased stroke weight for better visibility
  	        rotation: heading,
  	        scale: marker.scale || pointScale || 8, // Increased scale for better visibility
  	        anchor: new google.maps.Point(0, 0),
  	      };
  	    }
  	
  	    const pointMarker = new google.maps.Marker({
  	      position: { lat: marker.lat, lng: marker.lng },
  	      map: mapInstance,
  	      icon: icon
  	    });
  	
  	    // Add an event listener for the marker to show a popup with the data
  	    if (marker.Data) {
  	      const infowindow = new google.maps.InfoWindow({
  	        content: marker.Data
  	      });
  	
  	      pointMarker.addListener('click', function() {
  	        infowindow.open(mapInstance, pointMarker);
  	      });
  	    }
  	  });
  	}
  	
  	try {
  	  const googleMapComponent = arguments[0]; // Retrieve the Google Map component from arguments
  	  const polylineColor = arguments[1]; // Retrieve the polyline color from arguments
  	  const markers = arguments[2]; // Retrieve the list of markers from arguments
  	  const strokeOpacity = arguments[3]; // Retrieve the stroke opacity from arguments
  	  const strokeWeight = arguments[4]; // Retrieve the stroke weight from arguments
  	  const pointMarkers = arguments[5]; // Retrieve the list of point markers from arguments
  	
  	  addPolylineAndCustomMarkers(googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers);
  	} catch (error) {
  	  console.error("Error adding polyline and custom markers:", error);
  	}

  })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), '#CC6633', (await Promise.all(Points_List.map(async item => {; return ({ [`lat`]: (getObjectProperty(item, 'position.latitude')),[`lng`]: (getObjectProperty(item, 'position.longitude')) });}))), 1, 8, (await Promise.all(Points_List.map(async item => {; return ({ [`lat`]: (getObjectProperty(item, 'position.latitude')),[`lng`]: (getObjectProperty(item, 'position.longitude')),[`Data`]: (await (async function(Headers, Rows) {
  	function createPopupDiv(Headers, Rows) {
  	    // Create the popup div
  	    let popupDiv = `
  	    <div class="popup" style="background-color: rgba(0, 0, 0, 0.8); border: 2px solid #CC6633; border-radius: 10px; padding: 10px; color: #ffffff; font-family: Arial, sans-serif; width: 350px;">
  	        <table style="width: 100%; border-collapse: collapse; table-layout: fixed;">
  	            <colgroup>
  	                <col style="width: 50%;">
  	                <col style="width: 50%;">
  	            </colgroup>
  	    `;
  	
  	    // Add the top part (unscrollable)
  	    Headers.forEach(header => {
  	        popupDiv += `
  	            <tr>
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left; background-color: ${header.Color};">${header.Label}</td>
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left; background-color: ${header.Color};">${header.Value}</td>
  	            </tr>
  	        `;
  	    });
  	
  	    popupDiv += `</table>
  	        <div class="scrollable-content" style="max-height: 200px; overflow-y: auto;">
  	            <table style="width: 100%; border-collapse: collapse; table-layout: fixed;">
  	                <colgroup>
  	                    <col style="width: 50%;">
  	                    <col style="width: 50%;">
  	                </colgroup>
  	    `;
  	
  	    // Add the scrollable part (rows)
  	    Rows.forEach(row => {
  	        popupDiv += `
  	            <tr style="background-color: ${row.Color};">
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left;">${row.Label}</td>
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left;">${row.Value}</td>
  	            </tr>
  	        `;
  	    });
  	
  	    // Close the tables and div
  	    popupDiv += `
  	            </table>
  	        </div>
  	    </div>
  	    `;
  	
  	    // Return the popup div HTML
  	    return popupDiv;
  	}
  	
  	try {
  	    const Headers = arguments[0]; // Retrieve the Headers from arguments
  	    const Rows = arguments[1]; // Retrieve the Rows from arguments
  	
  	    const popupHTML = createPopupDiv(Headers, Rows);
  	    return popupHTML;
  	} catch (error) {
  	    console.error("Error creating popup div:", error);
  	    return "Error creating popup div.";
  	}

  })([({ [`Label`]: 'Registration',[`Value`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), ({ [`Label`]: 'Fleet ID',[`Value`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID')),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), ({ [`Label`]: 'Driver',[`Value`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Nickname')),[`Color`]: 'rgba(204, 102, 51, 0.5)' }), ({ [`Label`]: 'Mobile',[`Value`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Phone')),[`Color`]: 'rgba(204, 102, 51, 0.5)' })], [({ [`Label`]: 'Odometer',[`Value`]: (getObjectProperty(item, 'can.vehicle.mileage')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), ({ [`Label`]: 'Speed',[`Value`]: (getObjectProperty(item, 'position.speed')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), ({ [`Label`]: 'Low Fuel',[`Value`]: (getObjectProperty(item, 'can.fuel.level.low.indicator.status')),[`Color`]: 'rgba(34, 139, 34, 0.5)' }), ({ [`Label`]: 'RPM',[`Value`]: (getObjectProperty(item, 'can.engine.rpm')),[`Color`]: 'rgba(70, 130, 180, 0.5)' }), ({ [`Label`]: 'Altitude',[`Value`]: (getObjectProperty(item, 'position.altitude')),[`Color`]: 'rgba(70, 130, 180, 0.5)' }), ({ [`Label`]: 'Lights Failure ',[`Value`]: (getObjectProperty(item, 'can.lights.failure.indicator.status')),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), ({ [`Label`]: 'Maintenance Req.',[`Value`]: (getObjectProperty(item, 'can.lights.failure.indicator.status')),[`Color`]: 'rgba(128, 0, 128, 0.5)' }), ({ [`Label`]: 'Oil Level Warning',[`Value`]: (getObjectProperty(item, 'can.maintenance.required.status')),[`Color`]: 'rgba(128, 0, 128, 0.5)' })])),[`color`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), 'position.speed')))) || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), 'position.speed')) == 0 ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), 'can.engine.rpm')))) || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), 'can.engine.rpm')) == 0 ? '#808080' : '#FFFF00') : '#CC6633',[`Speed`]: (getObjectProperty(item, 'position.speed')),[`Direction`]: (getObjectProperty(item, 'position.direction')) });}))), '#CC6633', 12);
  console.log((await (async function(Headers, Rows) {
  	function createPopupDiv(Headers, Rows) {
  	    // Create the popup div
  	    let popupDiv = `
  	    <div class="popup" style="background-color: rgba(0, 0, 0, 0.8); border: 2px solid #CC6633; border-radius: 10px; padding: 10px; color: #ffffff; font-family: Arial, sans-serif; width: 350px;">
  	        <table style="width: 100%; border-collapse: collapse; table-layout: fixed;">
  	            <colgroup>
  	                <col style="width: 50%;">
  	                <col style="width: 50%;">
  	            </colgroup>
  	    `;
  	
  	    // Add the top part (unscrollable)
  	    Headers.forEach(header => {
  	        const label = header.Label != null ? header.Label : '-';
  	        const value = header.Value != null ? header.Value : '-';
  	        const color = header.Color != null ? header.Color : '#000000'; // Default to black if color is not provided
  	        popupDiv += `
  	            <tr>
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left; background-color: ${color};">${label}</td>
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left; background-color: ${color};">${value}</td>
  	            </tr>
  	        `;
  	    });
  	
  	    popupDiv += `</table>
  	        <div class="scrollable-content" style="max-height: 200px; overflow-y: auto;">
  	            <table style="width: 100%; border-collapse: collapse; table-layout: fixed;">
  	                <colgroup>
  	                    <col style="width: 50%;">
  	                    <col style="width: 50%;">
  	                </colgroup>
  	    `;
  	
  	    // Add the scrollable part (rows)
  	    Rows.forEach(row => {
  	        const label = row.Label != null ? row.Label : '-';
  	        const value = row.Value != null ? row.Value : '-';
  	        const color = row.Color != null ? row.Color : '#000000'; // Default to black if color is not provided
  	        popupDiv += `
  	            <tr style="background-color: ${color};">
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left;">${label}</td>
  	                <td style="padding: 3px; border-bottom: 1px solid #000000; text-align: left;">${value}</td>
  	            </tr>
  	        `;
  	    });
  	
  	    // Close the tables and div
  	    popupDiv += `
  	            </table>
  	        </div>
  	    </div>
  	    `;
  	
  	    // Return the popup div HTML
  	    return popupDiv;
  	}
  	
  	try {
  	    const Headers = arguments[0]; // Retrieve the Headers from arguments
  	    const Rows = arguments[1]; // Retrieve the Rows from arguments
  	
  	    const popupHTML = createPopupDiv(Headers, Rows);
  	    return popupHTML;
  	} catch (error) {
  	    console.error("Error creating popup div:", error);
  	    return "Error creating popup div.";
  	}

  })(null, null)));
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7c844bedb74f9916e6928cd1a10ace5f');
  Time_Now = (new Date());
  Time_Start = (new Date((new Date()).getTime() - (900 * 1000)));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
  await new Promise(r => setTimeout(r, 500 || 0));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live'))], ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/7c844bedb74f9916e6928cd1a10ace5f/bundle.js', [], () => ({
  /* content */
  /* handler:modalVisibilityLogic */
  async ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'Track IT Close')) == true) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7c844bedb74f9916e6928cd1a10ace5f');
    delete ___arguments.context.appData['Track IT Close'];
  }

  },
  /* handler:modalVisibilityLogic */
  /* content */
}))

define('./pages/FIFOFFICE/components/1feb80e94055fb0653b5ac8571fe79dc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('91ce77bf29654236309c47e9151fd443');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('91ce77bf29654236309c47e9151fd443');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      delete ___arguments.context.appData['Current Tracking Data'];
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7c844bedb74f9916e6928cd1a10ace5f');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/e367b5edcff49236a58d5a3599cdd4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Points_List, Time_Now, Time_Start, Live_Start;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Track_It_Function() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live'))], ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  }
}


  if (___arguments.value == 'Historical') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('4857dff971b24802ce5833ad7e5b56c6');
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('e367b5edcff49236a58d5a3599cdd4d5', null);
  } else if (___arguments.value == '15 Minutes') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (900 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '30 Minutes') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (1800 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '1 Hour') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (3600 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '2 Hours') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (7200 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '4 Hours') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (14400 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '6 Hours') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (21600 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == 'Live') {
    Time_Now = (new Date());
    Live_Start = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (300 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
    while (___arguments.value == 'Live') {
      if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e367b5edcff49236a58d5a3599cdd4d5')) == 'Live') {
        await new Promise(r => setTimeout(r, 60000 || 0));
        Time_Now = (new Date());
        Time_Start = Live_Start;
        Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
        ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
        await Track_It_Function();
      } else {
      }
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/6ac7003b52d73c7b3f9db0ff9552622a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Points_List, To, From;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Day Select'))))) {
    From = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'From'));
    To = From + (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'To')) * 1000;
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), From, To));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warning Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4857dff971b24802ce5833ad7e5b56c6');
  } else {
    From = (await BackendlessUI.Functions.Custom['fn_43b4a3c52591b241ead73df1fc683a4b']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Day Select'))));
    To = From + 86400000;
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), From, To));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), 10, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4857dff971b24802ce5833ad7e5b56c6');
    console.log((await BackendlessUI.Functions.Custom['fn_43b4a3c52591b241ead73df1fc683a4b']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Day Select')))));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/7fb75eae7b7b411ea4549a4fe3812d6b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 100 || 0));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Density'] = ___arguments.value;
  await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points'))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')))) ? [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live'))] : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points'))), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/4707bc0a4ece663933c7175ba3875eef/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
    var Maximum;


  Maximum = (new Date((new Date()).getTime() - (21600 * 1000)));

  return Maximum

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/68c155d83df98ee44433d316e5a125d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Tags, error, Database, Data, Value, Tag, Property, j, item, Trigger, Execute;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Data_Corrector(Trigger, Database, Tag, Execute, Property) {
  if (Trigger) {
    Data = (await BackendlessUI.Functions.Custom['fn_1db2862f0f34c40826936d930b7ac8c1'](Database, (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\''].join('')), null, null, null));
    Data = (await asyncListSort(Data, 1, async (item) => {


     return (getObjectProperty(item, 'created'));
    }));
    Value = 0;
    for (var j_index in Data) {
      j = Data[j_index];
      Value = Value + 1;
      j[Property] = (Value >= 10 ? (Value >= 100 ? (Value >= 1000 ? (Value >= 10000 ? [Tag,' ',Value].join('') : [Tag,' 0',Value].join('')) : [Tag,' 00',Value].join('')) : [Tag,' 000',Value].join('')) : [Tag,' 0000',Value].join(''));
    }
    await BackendlessUI.Functions.Custom['fn_4e84132425b7748ee8adf3583323c24e'](Data, Database);
  }
}


  console.log(___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/fc96be21cf223812ebb3f1aa22b75653/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/30f560e713165cb86a236197f8ada466/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('170921392d8863bdc1263682b2041699');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('170921392d8863bdc1263682b2041699');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFOFFICE/components/a3831b4e28410e685174d8da9c366071/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('aabe2c13c4fd13c136c825ef9fe41209');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('aabe2c13c4fd13c136c825ef9fe41209');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Zoom, Centre, Time_Start;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e05ae79169330a652453cd9554b2a019', false);
  delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')['TrackIt - GeoFencing (Name)'];
  Zoom = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).zoom })('00a10794c3394968e50d921a03174098'));
  Centre = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('00a10794c3394968e50d921a03174098'));
  Time_Start = (new Date());
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']('5806738', (Time_Start - 900000), Time_Start));
  await new Promise(r => setTimeout(r, 100 || 0));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : 5)))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, null);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : 5)))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, null);
  }
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty(Centre, 'lat')), (getObjectProperty(Centre, 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', Zoom);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/8e7f5b851c869307b79fa534817e6f65/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Zoom, Centre, Time_Start;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Zoom = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).zoom })('00a10794c3394968e50d921a03174098'));
  Centre = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('00a10794c3394968e50d921a03174098'));
  Time_Start = (new Date());
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']('5806738', (Time_Start - 900000), Time_Start));
  await new Promise(r => setTimeout(r, 100 || 0));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live'))], ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), true, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f')), ___arguments.context.appData);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), true, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f')), ___arguments.context.appData);
  }
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty(Centre, 'lat')), (getObjectProperty(Centre, 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', Zoom);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/c677cffcef812bd62009ab82ffebc39f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var error;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'New Customer') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24713758b56f92727e7597b92b6ba90c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95478b25e6e94196eb632a0e6be7fe11', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dc48734547b319ff2a1d3af8d56d1f8', true);
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24713758b56f92727e7597b92b6ba90c', false);

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95478b25e6e94196eb632a0e6be7fe11', false);

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dc48734547b319ff2a1d3af8d56d1f8', false);

    } catch (error) {
      console.log(error);

    }
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) == 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0 && getValueLength(___arguments.value) > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
    } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) != 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);
    }
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Customer')) });}))), ({ [`value`]: 'New Customer',[`label`]: 'New Customer' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/d598fd450f8626b35e41e328909a87bc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'Load/Offload Point') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c677cffcef812bd62009ab82ffebc39f', true);
    if (___arguments.value == 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0 && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f'))) > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
    }
  } else if (___arguments.value != 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/47460d949ad29456821b4bf8d56d8f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) == 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength(___arguments.value) > 0) {
    if (getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f'))) > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c677cffcef812bd62009ab82ffebc39f', true);
    }
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) != 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength(___arguments.value) > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/e587223e046dab92231b76ac8107599f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) == 'Load/Offload Point' && getValueLength(___arguments.value) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0 && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f'))) > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) != 'Load/Offload Point' && getValueLength(___arguments.value) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/6756de42fd718227da45ff47f046b81d/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('7448c9eda24219d3805f149b160978d1');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('7448c9eda24219d3805f149b160978d1');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e05ae79169330a652453cd9554b2a019', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/bcfc8832cc1525e208a9606351c2b5b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'))))) {
      Content = '';
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'))) {
        Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration'));
      } else {
        Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'));
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/31a9a6d861969bf2e4e9e2bda371ab1d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'geofencePolygons'))))) {
    Viewer = false;
  } else {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path')).length >= 3) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Zoom, Centre, j, TrackitModal_Keys, error, Location, Results, New_Customer, Location_Transaction, Location_Refrence, Customer_Refrence, ID, ID_Number_Variable, ID_Start, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function do_something() {
  Zoom = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).zoom })('00a10794c3394968e50d921a03174098'));
  Centre = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('00a10794c3394968e50d921a03174098'));
  try {
    ID_Number_Variable = String((Number((subsequenceFromEndLast((getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), 1, async (item) => {


     return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 3))));
    })).slice(-1)[0]), 'ID')), 3)))) + 1);

  } catch (error) {
    console.log(error);

  } finally {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](ID_Number_Variable))) {
      ID_Number_Variable = 1;
    }

  }
  try {
    ID_Start = subsequenceFirstFromEnd((getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), 1, async (item) => {


     return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 3))));
    })).slice(-1)[0]), 'ID')), 4);

  } catch (error) {
    console.log(error);

  } finally {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](ID_Start))) {
      ID_Start = String((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')).slice(0, 5)) + String(' Lo ');
    }

  }
  ID = String(ID_Start) + String(getValueLength(ID_Number_Variable) == 1 ? String('000') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 2 ? String('00') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 3 ? String('0') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 4 ? ID_Number_Variable : ID_Number_Variable))));
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f')) == 'New Customer') {
    Location = ({ [`Address`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)')),[`Color`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f')),[`Contact_Name`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIT - GeoFence (Contact Name)')),[`Geo Fences`]: (new Backendless.Data.Polygon((await Promise.all((addItemToList((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path')), ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]))).map(async item => {; return (new Backendless.Data.Point().setX((getObjectProperty(item, 'lng'))).setY((getObjectProperty(item, 'lat'))));}))), )),[`ID`]: ID,[`Name`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)')),[`Phone`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIT - GeoFence (Contact Number)')),[`Point`]: (new Backendless.Data.Point().setX((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]), 'lng'))).setY((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]), 'lat')))),[`Type`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')) });
  } else {
    Location = ({ [`Address`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)')),[`Color`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f')),[`Contact_Name`]: '',[`Geo Fences`]: (new Backendless.Data.Polygon((await Promise.all((addItemToList((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path')), ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]))).map(async item => {; return (new Backendless.Data.Point().setX((getObjectProperty(item, 'lng'))).setY((getObjectProperty(item, 'lat'))));}))), )),[`ID`]: ID,[`Name`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)')),[`Phone`]: '',[`Point`]: (new Backendless.Data.Point().setX((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]), 'lng'))).setY((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]), 'lat')))),[`Type`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')) });
  }
  Location_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Location_Transaction;

    Location_Refrence = (_uow.create('Locations', Location));
    _uow.setRelation('Locations', Location_Refrence, 'Company', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')));
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations', [Location_Refrence]);
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) == 'Load/Offload Point') {
      if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f')) == 'New Customer') {
        try {
          ID_Number_Variable = String((Number((subsequenceFromEndLast((getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), 1, async (item) => {


           return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 3))));
          })).slice(-1)[0]), 'ID')), 3)))) + 1);

        } catch (error) {
          console.log(error);

        } finally {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](ID_Number_Variable))) {
            ID_Number_Variable = 1;
          }

        }
        try {
          ID_Start = subsequenceFirstFromEnd((getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), 1, async (item) => {


           return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 3))));
          })).slice(-1)[0]), 'ID')), 4);

        } catch (error) {
          console.log(error);

        } finally {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](ID_Start))) {
            ID_Start = String((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')).slice(0, 5)) + String(' C ');
          }

        }
        console.log(ID_Number_Variable);
        console.log(ID_Start);
        ID = String(ID_Start) + String(getValueLength(ID_Number_Variable) == 1 ? String('000') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 2 ? String('00') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 3 ? String('0') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 4 ? ID_Number_Variable : ID_Number_Variable))));
        New_Customer = ({ [`Customer`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIT - GeoFence (Customer Name)')),[`Contact_Name`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIT - GeoFence (Contact Name)')),[`Contact_Phone`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIT - GeoFence (Contact Number)')),[`ID`]: ID,[`Customer_Location`]: (new Backendless.Data.Point().setX((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]), 'lng'))).setY((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]), 'lat')))),[`Name`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIT - GeoFence (Customer Name)')),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')) });
        Customer_Refrence = (_uow.create('Customers', New_Customer));
        _uow.addToRelation('Customers', Customer_Refrence, 'Locations', [Location_Refrence]);
        _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers', [Customer_Refrence]);
      } else {
        _uow.addToRelation('Customers', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f')), 'Locations', [Location_Refrence]);
      }
    }

  })();

  Results = (await Location_Transaction.execute().then(function(result) {
      const error = result && result.error

      if (error) {
        throw error
      }

    return result
    }));
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f')) == 'New Customer') {
    try {
      New_Customer['objectId'] = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Results, 'results')), 'createCustomers1')), 'result')), 'objectId'));

    } catch (error) {
      console.log(error);

    }
    try {
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), New_Customer);

    } catch (error) {
      console.log(error);

    }
  }
  Location['objectId'] = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Results, 'results')), 'createLocations1')), 'result')), 'objectId'));
  addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), Location);
  delete ___arguments.context.appData['geofencePolygons'];
  delete ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['TrackIT - Geofence Add'];
  await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live'))], ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('e367b5edcff49236a58d5a3599cdd4d5', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('d598fd450f8626b35e41e328909a87bc', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('e587223e046dab92231b76ac8107599f', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('c677cffcef812bd62009ab82ffebc39f', null);

  } catch (error) {
    console.log(error);

  }
  TrackitModal_Keys = (Object.keys(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')));
  for (var j_index in TrackitModal_Keys) {
    j = TrackitModal_Keys[j_index];
    delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')[j];
  }
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty(Centre, 'lat')), (getObjectProperty(Centre, 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', Zoom);
}


  await do_something();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e05ae79169330a652453cd9554b2a019', false);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))['Locations'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ('geofence.objectId' != (getObjectProperty(item, 'objectId')));
  }));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/24713758b56f92727e7597b92b6ba90c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) == 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0 && getValueLength(___arguments.value) > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/4d9be81d318b5546859677df5fbb2eac/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('1a421334079fb8f535fdae14b0cfb104');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('1a421334079fb8f535fdae14b0cfb104');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFOFFICE/components/055ded3887ec3629f8d3cb828ea5ac07/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('b40de5e80bdca6cc712a33297d45c664');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('b40de5e80bdca6cc712a33297d45c664');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('ca6753afdf05f48744fa68bdba662cc2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/34e632d41bfbfee251dacad7b228e867/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, j;


  var j_list = (Object.keys(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234')));
  for (var j_index in j_list) {
    j = j_list[j_index];
    delete ___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234')[j];
  }
  await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('ca6753afdf05f48744fa68bdba662cc2', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/77628deda5ef5ad1c109a73bbb0d6b29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('ca6753afdf05f48744fa68bdba662cc2', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/3dcca805ba5e92f6ee45491e4a1dccc6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, item, Fuel_List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel'))))) {
    Content = ' - ';
  } else {
    Fuel_List = (await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel')), -1, async (item) => {


     return (getObjectProperty(item, 'Mileage'));
    })).slice(0, 5);
    ___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234')['CPK (Fuel)'] = (Math.round(((await Promise.all(Fuel_List.map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;}) / (await Promise.all(Fuel_List.map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;})) * 100) / 100);
    Content = String('R ') + String(Math.round(((await Promise.all(Fuel_List.map(async item => {; return (getObjectProperty(item, 'Cost'));}))).reduce(function(x, y) {return x + y;}) / (await Promise.all(Fuel_List.map(async item => {; return (getObjectProperty(item, 'Mileage_Differential'));}))).reduce(function(x, y) {return x + y;})) * 100) / 100);
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel'));
  console.log(await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel')), 1, async (item) => {


   return (getObjectProperty(item, 'Mileage'));
  }));
  console.log(await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel')), -1, async (item) => {


   return (getObjectProperty(item, 'Mileage'));
  }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/319387e1e4d4c605e0bef3df435453c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/0daa356c63e9f46c418e7e85a5872c46/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item, Trailer_1_Return, Trailer__, Trailer, Content, CPK_Breakdown_List, Driver_1_Varaibles, Trailer_3_Variables, Trailer_2_Variables, Trailer_1_Variables, Tractor_Varialbles;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Tractor() {
  return [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Annual_License_Fee')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Annual_License_Fee')) / 12) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Commission_Rate')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Turnover')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Commission_Rate')) / 100) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Turnover'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Depreciation')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Depreciation')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fixed_Maintenance_Plan_Cost')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fixed_Maintenance_Plan_Cost')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fixed_Monthly_Sundry_Cost')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fixed_Monthly_Sundry_Cost')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Instalment')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Instalment')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Insurance_Premium')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Insurance_Premium')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Maintenance_Plan_Rate_per_Km')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Maintenance_Plan_Rate_per_Km')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Profit_Target')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Profit_Target')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tyres')))) ? 0 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tyres')).length == 0 ? 0 : (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tyres')).map(async item => {; return (getObjectProperty(item, 'CPK_Expected'));}))).reduce(function(x, y) {return x + y;}))]
}

/**
 * Describe this function...
 */
async function Wages() {
  return [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Basic')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Basic')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Contractor_Mileage')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Contractor_Mileage')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Good_Driving')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Good_Driving')), null, null, null, null, null]
}

/**
 * Describe this function...
 */
async function Trailer_Function(Trailer) {
  Trailer__ = Trailer;
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__))))) {
    Trailer_1_Return = [0];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Tyres'))))) {
      Trailer_1_Return = [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Annual_License_Fee')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Annual_License_Fee')) / 12) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Depreciation')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Depreciation')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Fixed_Maintenance_Plan_Cost')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Fixed_Maintenance_Plan_Cost')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Installment')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Installment')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Insurance')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Insurance')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Tracking')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Tracking')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target'))];
    } else {
      Trailer_1_Return = [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Annual_License_Fee')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Annual_License_Fee')) / 12) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Depreciation')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Depreciation')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Fixed_Maintenance_Plan_Cost')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Fixed_Maintenance_Plan_Cost')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Installment')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Installment')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Insurance')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Insurance')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Tracking')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Tracking')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Tyres')))) ? 0 : ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Tyres')).length == 0 ? 0 : (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer__)), 'Tyres')).map(async item => {; return (getObjectProperty(item, 'CPK_Expected'));}))).reduce(function(x, y) {return x + y;}))];
    }
  }
  return Trailer_1_Return
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Tractor_Varialbles = await Tractor();
  CPK_Breakdown_List = Tractor_Varialbles;
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
  } else {
    Trailer_1_Variables = await Trailer_Function('Trailer1');
    CPK_Breakdown_List = (CPK_Breakdown_List.concat(Trailer_1_Variables));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
  } else {
    Trailer_2_Variables = await Trailer_Function('Trailer2');
    CPK_Breakdown_List = (CPK_Breakdown_List.concat(Trailer_2_Variables));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3'))))) {
  } else {
    Trailer_3_Variables = await Trailer_Function('Trailer3');
    CPK_Breakdown_List = (CPK_Breakdown_List.concat(Trailer_3_Variables));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))))) {
  } else {
    Driver_1_Varaibles = await Wages();
    CPK_Breakdown_List = (CPK_Breakdown_List.concat(Driver_1_Varaibles));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](CPK_Breakdown_List))) {
    Content = ' - ';
  } else {
    ___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234')['CPK (Fixed)'] = ((await asyncListFilter(CPK_Breakdown_List, async (item) => {


     return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](item)));
    })).reduce(function(x, y) {return x + y;}));
    Content = String('R ') + String(Math.round((await asyncListFilter(CPK_Breakdown_List, async (item) => {


     return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](item)));
    })).reduce(function(x, y) {return x + y;}) * 100) / 100);
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'CPK (Fixed)'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/600ecc76a12bcc017beea364a4e90b2d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, item, Fuel_List, CPK_Breakdown_List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CPK_Breakdown_List = (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'CPK (Fuel)')) + (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'CPK (Fixed)'));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](CPK_Breakdown_List)) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Trip'))))) {
    Content = 'R 0.00';
  } else {
    Content = String('R ') + String(Math.round((CPK_Breakdown_List * (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Trip')) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Profit')))) ? 0 : (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Profit'))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Tolls')))) ? 0 : (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Tolls')))) * 100) / 100);
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/ee088f5e935a0bcc877af4b53824f7bc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, CPK_Breakdown_List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CPK_Breakdown_List = (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'CPK (Fuel)')) + (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'CPK (Fixed)'));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](CPK_Breakdown_List))) {
    Content = ' - ';
  } else {
    Content = String('R ') + String(Math.round(CPK_Breakdown_List * 100) / 100);
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/9e6ce3a9b2eb3ece23181a6abf248ae7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, CPK_Breakdown_List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  CPK_Breakdown_List = (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'CPK (Fuel)')) + (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'CPK (Fixed)'));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](CPK_Breakdown_List)) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Trip'))))) {
    Content = 'R -';
  } else {
    Content = String('R ') + String((typeof (Math.round(((Math.round((CPK_Breakdown_List * (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Trip')) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Profit')))) ? 0 : (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Profit'))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Tolls')))) ? 0 : (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Tolls')))) * 100) / 100) / (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Trip'))) * 100) / 100) === 'number' && !isNaN((Math.round(((Math.round((CPK_Breakdown_List * (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Trip')) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Profit')))) ? 0 : (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Profit'))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Tolls')))) ? 0 : (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Tolls')))) * 100) / 100) / (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Trip'))) * 100) / 100))) ? Math.round(((Math.round((CPK_Breakdown_List * (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Trip')) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Profit')))) ? 0 : (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Profit'))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Tolls')))) ? 0 : (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Tolls')))) * 100) / 100) / (getObjectProperty(___arguments.context.getPodDataModelByUid('1aec8dec2faf84f92fd9b717e81db234'), 'Trip'))) * 100) / 100 : '-');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/d5861392d64ba64bce6f38e591ebc467/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    var error;


  try {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('1c0dfc47bd9b8ccc6f8df1239bfc6079', undefined);

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Selected Delivered Tonnage Record'] = ___arguments.selectedRecord;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('1c0dfc47bd9b8ccc6f8df1239bfc6079', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND TID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),'\' AND created >= ',(await (async function(Start) {
	function getStartOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const startOfMonth = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
	  startOfMonth.setHours(0, 0, 0, 0); // Set to the start of the day
	
	  return startOfMonth.getTime();
	}
	
	// Directly execute and return the result
	return getStartOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created')))),' AND created <= ',(await (async function(Start) {
	function getEndOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
	  endDate.setHours(23, 59, 59, 999); // Set to the end of the day
	
	  return endDate.getTime();
	}
	
	// Directly execute and return the result
	return getEndOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created'))))].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Delivered Tonnage - (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')),')'].join(''))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/fa2a9b712c4e546f68ddbbc501a3ade2/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    var error, Refuel_List, j, New_Refuel_List, End_Marker, Start_Marker, Selected_Record, Slected_Record_Position, Fuel_List, Previous_Record, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('d28223acefc220231951e14c341c8341', undefined);

  } catch (error) {
    console.log(error);

  }
  if ((getObjectProperty(___arguments.selectedRecord, 'Admin')) == true) {
    try {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('d28223acefc220231951e14c341c8341', undefined);

    } catch (error) {
      console.log(error);

    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Selected Fuel Consumption Record'] = ___arguments.selectedRecord;
    Selected_Record = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record'));
    await new Promise(r => setTimeout(r, 1000 || 0));
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('d28223acefc220231951e14c341c8341', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
  } else {
    try {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('d28223acefc220231951e14c341c8341', undefined);

    } catch (error) {
      console.log(error);

    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Selected Fuel Consumption Record'] = ___arguments.selectedRecord;
    Selected_Record = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record'));
    Fuel_List = (await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel')), -1, async (item) => {


     return (getObjectProperty(item, 'created'));
    }));
    Slected_Record_Position = Fuel_List.indexOf(Selected_Record) + 1;
    Previous_Record = Fuel_List[((Slected_Record_Position + 2) - 1)];
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), ((new Date((new Date((getObjectProperty(Selected_Record, 'created')))).getTime() - (1500 * 1000))).valueOf()), ((new Date((new Date((getObjectProperty(Selected_Record, 'created')))).getTime() + (3000 * 1000))).valueOf())));
    Refuel_List = [];
    var j_list = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      Start_Marker = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points'))[(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).indexOf(j) + 1) - 1)];
      try {
        End_Marker = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points'))[((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).indexOf(j) + 1) - 1) - 1)];

      } catch (error) {

      }
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](End_Marker))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(End_Marker, 'can.fuel.level'))))) {
        } else {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Start_Marker, 'can.fuel.level'))))) {
          } else {
            if ((getObjectProperty(End_Marker, 'can.fuel.level')) - (getObjectProperty(Start_Marker, 'can.fuel.level')) < -2) {
              Start_Marker['FuelGain'] = ((getObjectProperty(Start_Marker, 'can.fuel.level')) - (getObjectProperty(End_Marker, 'can.fuel.level')));
              addItemToList(Refuel_List, Start_Marker);
              addItemToList(Refuel_List, End_Marker);
            }
          }
        }
      }
    }
    try {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record'))['Refuel List'] = Refuel_List;

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
      }

    }
    try {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record'))['Available Capacity'] = (Math.ceil(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tank_Capacity')) / 100) * (100 - (getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Refuel List'))[1]), 'can.fuel.level'))) * 100) / 100);

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
      }

    }
    try {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record'))['Litres Filled'] = (Math.ceil((getObjectProperty(___arguments.selectedRecord, 'Litres')) * 100) / 100);

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
      }

    }
    try {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record'))['Detected Fill'] = (Math.ceil(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tank_Capacity')) / 100) * ((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Refuel List'))[0]), 'can.fuel.level')) - (getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Refuel List'))[1]), 'can.fuel.level'))) * 100) / 100);

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
      }

    }
    try {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record'))['Gain/Loss'] = (Math.ceil((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tank_Capacity')) / 100) * ((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Refuel List'))[0]), 'can.fuel.level')) - (getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Refuel List'))[1]), 'can.fuel.level'))) - (getObjectProperty(___arguments.selectedRecord, 'Litres'))) * -1 * 100) / 100);

    } catch (error) {
      console.log(error);

    } finally {
      if (error) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
      }

    }
    await new Promise(r => setTimeout(r, 1000 || 0));
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('d28223acefc220231951e14c341c8341', undefined);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    var Tractor;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND TObjectID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),'\' AND ((Date_Actual IS NULL AND created >= \'',(await (async function(Start) {
	function getStartOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const startOfMonth = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
	  startOfMonth.setHours(0, 0, 0, 0); // Set to the start of the day
	
	  return startOfMonth.getTime();
	}
	
	// Directly execute and return the result
	return getStartOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created')))),'\' AND created <= \'',(await (async function(Start) {
	function getEndOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
	  endDate.setHours(23, 59, 59, 999); // Set to the end of the day
	
	  return endDate.getTime();
	}
	
	// Directly execute and return the result
	return getEndOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created')))),'\') OR (Date_Actual IS NOT NULL AND Date_Actual >= \'',(await (async function(Start) {
	function getStartOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const startOfMonth = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
	  startOfMonth.setHours(0, 0, 0, 0); // Set to the start of the day
	
	  return startOfMonth.getTime();
	}
	
	// Directly execute and return the result
	return getStartOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created')))),'\' AND Date_Actual <= \'',(await (async function(Start) {
	function getEndOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
	  endDate.setHours(23, 59, 59, 999); // Set to the end of the day
	
	  return endDate.getTime();
	}
	
	// Directly execute and return the result
	return getEndOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created')))),'\'))'].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Fuel Consumption - (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')),')'].join(''))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/b2f6db22db758c1a86475775605eb8c3/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    var Time_Start, Time_Now, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('cbdbee8ccbdf727cef2540178c78f753', undefined);

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Selected Mileage Completion Record'] = ___arguments.selectedRecord;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('cbdbee8ccbdf727cef2540178c78f753', undefined);
  await new Promise(r => setTimeout(r, 1000 || 0));
  Time_Now = (new Date());
  Time_Start = (new Date((new Date()).getTime() - (900 * 1000)));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Date_Loaded')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Date_Delivered'))));
  await new Promise(r => setTimeout(r, 100 || 0));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ca66e348fff7cc79482ce628df861df')), [], 10, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), null, null, null, null, ___arguments.context.appData);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7ca66e348fff7cc79482ce628df861df')), [], 10, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), null, null, null, null, ___arguments.context.appData);
  }

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND TID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),'\' AND created >= ',(await (async function(Start) {
	function getStartOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const startOfMonth = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
	  startOfMonth.setHours(0, 0, 0, 0); // Set to the start of the day
	
	  return startOfMonth.getTime();
	}
	
	// Directly execute and return the result
	return getStartOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created')))),' AND created <= ',(await (async function(Start) {
	function getEndOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
	  endDate.setHours(23, 59, 59, 999); // Set to the end of the day
	
	  return endDate.getTime();
	}
	
	// Directly execute and return the result
	return getEndOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created'))))].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Mileage Completion (Load Based) - (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')),')'].join(''))

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/458bec9d41eb73f7fb15ea67239da244/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('e25fdd0e0d39a66b1713639f4af1fb5d');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('e25fdd0e0d39a66b1713639f4af1fb5d');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('cbdbee8ccbdf727cef2540178c78f753', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/d8e188b835a2c98344dd1d74cfd4dd8a/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('b7feb8b70eeb5a55a81136599685ff3f');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('b7feb8b70eeb5a55a81136599685ff3f');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('e97e3d4bdd01f07b4327e42bc27e1fb8', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/cbea0f239d6860ff11d95851956f5343/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
      ___arguments.context.pageData['HR - Selected Record'] = ___arguments.selectedRecord;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('46f43621a885b19fc42c9a22cc79360b', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['CID = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/a3ad3a9d9b9ed452197e729562af0fb6/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('6afe640fafbe4981859d1be2c26f749d');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('6afe640fafbe4981859d1be2c26f749d');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('46f43621a885b19fc42c9a22cc79360b', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/d084ff8472c4bef171a3800b60d8ed7f/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Company_ID'))))) {
  } else {
    Value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Company_ID'));
  }

  return Value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/0687cdd8ce752b67f6ef687564ece302/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Employee_Details_Nickname'))))) {
  } else {
    Value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Employee_Details_Nickname'));
  }

  return Value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/64935b970e66931dd21b49020b2f0d7b/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Employee_Details_Forenames'))))) {
  } else {
    Value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Employee_Details_Forenames'));
  }

  return Value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/e00428bd7c4f7c4e6f3d282d4df95d0d/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Employee_Details_Surname'))))) {
  } else {
    Value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Employee_Details_Surname'));
  }

  return Value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/f71571b4a1e7a64245c95ec5f9d9f72e/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Employee_Details_ID_Number'))))) {
  } else {
    Value = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Employee_Details_ID_Number'));
  }

  return Value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/edf36e685d891271cddffe64bb47d2b5/bundle.js', [], () => ({
  /* content */
  /* handler:imageUrlLogic */
  async ['imageUrlLogic'](___arguments) {
    var URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Avatar'))))) {
  } else {
    URL2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Avatar'));
  }

  return URL2

  },
  /* handler:imageUrlLogic */
  /* content */
}))

define('./pages/FIFOFFICE/components/84d24684f81da5a9f85e07e29aff6014/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var PDF_Data, File_Name, Wage_Data, Employee_Data, URL2, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function do_something() {
  Employee_Data = (getObjectProperty(___arguments.context.pageData, 'HR - Selected Record'));
  Wage_Data = 0;
  File_Name = ['Payslip','(',(getObjectProperty(Employee_Data, 'Employee_Details_ID_Number')),')'].join('');
  URL2 = ['https://backendlessappcontent.com/FB172318-89F2-E225-FF10-9AC9657A9000/15CB006B-69A7-477E-9D2F-3B75BC06A165/files/pdf/',['Payslip','%28',(getObjectProperty(Employee_Data, 'Employee_Details_ID_Number')),'%29'].join(''),'.pdf'].join('');
  console.log(URL2);
  PDF_Data = ({ [`DATE`]: undefined,[`START`]: undefined,[`QR`]: URL2,[`CLOGO`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Logo')),[`CNAME`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Registered_Name')),[`A1`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Physical_Address')),[`A2`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Postal_Code')),[`Phone`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Phone_1')),[`Email`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Email_Admin')),[`AVATAR`]: (getObjectProperty(Employee_Data, 'Avatar')),[`EFORE`]: (getObjectProperty(Employee_Data, 'Employee_Details_Forenames')),[`ESUR`]: (getObjectProperty(Employee_Data, 'Employee_Details_Surname')),[`NICKNAME`]: (getObjectProperty(Employee_Data, 'Employee_Details_Nickname')),[`CID`]: (getObjectProperty(Employee_Data, 'Company_ID')),[`ID`]: (getObjectProperty(Employee_Data, 'Employee_Details_ID_Number')),[`TAX`]: (getObjectProperty(Employee_Data, 'Employee_Details_Tax_Reference_Number')),[`CUIF`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_UIF_Number')),[`CPAYE`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_PAYE_Number')),[`ED1`]: undefined,[`ED2`]: (getObjectProperty(Wage_Data, 'Wages_Rate_Basic')),[`ED3`]: undefined,[`ED4`]: undefined,[`ED5`]: undefined,[`ED6`]: undefined,[`ED7`]: undefined,[`ED8`]: undefined,[`ED9`]: undefined,[`ED10`]: undefined,[`EU1`]: undefined,[`EU2`]: undefined,[`EU3`]: undefined,[`EU4`]: undefined,[`EU5`]: undefined,[`EU6`]: undefined,[`EU7`]: undefined,[`EU8`]: undefined,[`EU9`]: undefined,[`EU10`]: undefined,[`EV1`]: (getObjectProperty(Wage_Data, 'Wages_Rate_Basic')),[`EV2`]: undefined,[`EV3`]: undefined,[`EV4`]: undefined,[`EV5`]: undefined,[`EV6`]: undefined,[`EV7`]: undefined,[`EV8`]: undefined,[`EV9`]: undefined,[`EV10`]: undefined,[`DD1`]: undefined,[`DD2`]: undefined,[`DD3`]: undefined,[`DD4`]: undefined,[`DD5`]: undefined,[`DD6`]: undefined,[`DD7`]: undefined,[`DD8`]: undefined,[`DD9`]: undefined,[`DD10`]: undefined,[`DU1`]: undefined,[`DU2`]: undefined,[`DU3`]: undefined,[`DU4`]: undefined,[`DU5`]: undefined,[`DU6`]: undefined,[`DU7`]: undefined,[`DU8`]: undefined,[`DU9`]: undefined,[`DU10`]: undefined,[`DV1`]: undefined,[`DV2`]: undefined,[`DV3`]: undefined,[`DV4`]: undefined,[`DV5`]: undefined,[`DV6`]: undefined,[`DV7`]: undefined,[`DV8`]: undefined,[`DV9`]: undefined,[`DV10`]: undefined,[`ETOTAL`]: undefined,[`DTOTAL`]: undefined,[`NETT`]: undefined,[`TEARN`]: undefined,[`CCONTR`]: undefined,[`ADDDATA`]: undefined });
  ___arguments.context.pageData['PDF Test'] = (await Backendless.Request.post(`${Backendless.appPath}/services/PDFGeneratorAPI/${'1169565'}/data-output/${File_Name}`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'data': PDF_Data }));
  console.log(getObjectProperty(___arguments.context.pageData, 'PDF Test'));
}


  console.log((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


   return ((getObjectProperty(item, 'Company_ID')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Company_ID')));
  }))[0]);
  console.log(getObjectProperty(___arguments.context.pageData, 'HR - Selected Record'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/acbc7c6c62b1f72ac32a1ad7769254f1/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('4eaa957f1c4dbcc2a80d848f0b91fad3');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('4eaa957f1c4dbcc2a80d848f0b91fad3');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('8fa2ddba7c2d5c5d7eab08d2ce864b56', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/ebc56b675a5fae2b157eff618039c017/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('2333c2063288a3a30f6ff848f2926a7e');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('2333c2063288a3a30f6ff848f2926a7e');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('e9b3c46d01dbdf48702a683c74c9707c', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/7dcd6cc1891a095f2746cb9f3f2e007f/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('b2faca129bf92493b8adc3f3cc5fd6e3');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('b2faca129bf92493b8adc3f3cc5fd6e3');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('613cf84205d517eee86a85f97ef4da98', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/f74bc443a164aeda4ee5446b34788514/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('613cf84205d517eee86a85f97ef4da98', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/fd776ed34adbbf0c8d8db64ea14c7728/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('1c0dfc47bd9b8ccc6f8df1239bfc6079', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/0a2ffb5fbef908515ae4488f00cf95e4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('2df6d67298abaf23f0d613c201e151d7', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/7d9b8b418c4b1e96c2f85ecc4d8cb0e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('856f6a28c99b0a8403476af7237cad34', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/c093dd6e1362177865bd6dc559b4ba06/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Current Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Current Load')).length)) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/fea3580b3157223894bc5cd3fc564d7c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Current Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Current Load')).length)) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/8675b4a639b9a865201ecc890a37fa99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Current Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Current Load')).length)) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/800f21e9497811fd83477d7af86698a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Next Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Next Load')).length)) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/414466022103b71ef09b89e36b7f84cc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Next Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Next Load')).length)) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/9bab833834c511880794bf48e74ab4d3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Next Load')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Next Load')).length)) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/8a61925ed0adb1c64754a826b4781708/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var List, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Next Load'))))) {
      List = [];
    } else {
      List = (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Next Load')).map(async item => {; return ({ [`Customer`]: (getObjectProperty(item, 'Customer Name')),[`Tonnage`]: (getObjectProperty(item, 'Tonnage_Planned')),[`Product`]: (getObjectProperty(item, 'Load_Product')) });})));
    }

  } catch (error) {

  }

  return List

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/de0aa898f57a3836148f4d2ba58cc5bd/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var List, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Next Load'))))) {
      List = [];
    } else {
      List = (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Next Load')).map(async item => {; return ({ [`Customer`]: (getObjectProperty(item, 'Customer Name')),[`Tonnage`]: (getObjectProperty(item, 'Tonnage_Planned')),[`Product`]: (getObjectProperty(item, 'Load_Product')) });})));
    }

  } catch (error) {

  }

  return List

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/e19b47f1e5d678078fcb3e4198af831e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Next Load'))))) {
      List = [];
    } else {
      List = (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Next Load')).map(async item => {; return ({ [`Customer`]: (getObjectProperty(item, 'Customer Name')),[`Tonnage`]: (getObjectProperty(item, 'Tonnage_Planned')),[`Product`]: (getObjectProperty(item, 'Load_Product')) });})));
    }

  } catch (error) {

  }

  return List

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/24347ceab88984edf634962d45bbdf79/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Current Load'))))) {
      List = [];
    } else {
      List = (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Current Load')).map(async item => {; return ({ [`Customer`]: (getObjectProperty(item, 'Customer Name')),[`Tonnage`]: (getObjectProperty(item, 'Tonnage_Loaded')),[`Product`]: (getObjectProperty(item, 'Load_Product')) });})));
    }

  } catch (error) {

  }

  return List

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/f7936d9e62d98f4d743ddf36a01a9ae9/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Current Load'))))) {
      List = [];
    } else {
      List = (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Current Load')).map(async item => {; return ({ [`Customer`]: (getObjectProperty(item, 'Customer Name')),[`Tonnage`]: (getObjectProperty(item, 'Tonnage_Loaded')),[`Product`]: (getObjectProperty(item, 'Load_Product')) });})));
    }

  } catch (error) {

  }

  return List

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/41eb49d2373ce759b95563e2d1eee702/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Current Load'))))) {
      List = [];
    } else {
      List = (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Current Load')).map(async item => {; return ({ [`Customer`]: (getObjectProperty(item, 'Customer Name')),[`Tonnage`]: (getObjectProperty(item, 'Tonnage_Loaded')),[`Product`]: (getObjectProperty(item, 'Load_Product')) });})));
    }

  } catch (error) {

  }

  return List

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/6daecd654291f16dd3dae579e9036f61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Time_Start, Time_Now;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7c844bedb74f9916e6928cd1a10ace5f');
  Time_Now = (new Date());
  Time_Start = (new Date((new Date()).getTime() - (900 * 1000)));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Date_Loaded')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Date_Delivered'))));
  await new Promise(r => setTimeout(r, 100 || 0));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/5dab0315c8cd3eef16a2cf3fa5c994bc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Time_Start, Time_Now;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7c844bedb74f9916e6928cd1a10ace5f');
  Time_Now = (new Date());
  Time_Start = (new Date((new Date()).getTime() - (900 * 1000)));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Date_Loaded')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Date_Delivered'))));
  await new Promise(r => setTimeout(r, 100 || 0));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/b533fdbd6ef4edf2d3ac18d2ed96c248/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('2368b1fbce92bc7a219b211242bbc07b');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('2368b1fbce92bc7a219b211242bbc07b');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFOFFICE/components/d8f71a89a574ff8e9b6daeea1fa7144c/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('4e992e95c036c39ce2a88f72a44be41c');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('4e992e95c036c39ce2a88f72a44be41c');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFOFFICE/components/191764f4afe551f3037fd6eee5d7e769/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/dc2f00cc207f3d2b3c1ae74e24c666d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('d28223acefc220231951e14c341c8341', undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('03d7b70496a37067125378af1b254cc1');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('03d7b70496a37067125378af1b254cc1');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFOFFICE/components/25457f03e5a836b353536ee68efa04ff/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('4aceddf6f5435c5357a7ffbde732c5c4');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('4aceddf6f5435c5357a7ffbde732c5c4');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7c844bedb74f9916e6928cd1a10ace5f');
  await new Promise(r => setTimeout(r, 100 || 0));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Admin')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/efc66485baa4425eecafebae62cd8477/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Available Capacity'))))) {
    Content = null;
  } else {
    Content = String(Math.round((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Available Capacity')) * 1000) / 1000) + String(' L');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/2ad381f2c57e822ec3117f5737a505c1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Litres Filled'))))) {
    Content = null;
  } else {
    Content = String(Math.round((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Litres Filled')) * 1000) / 1000) + String(' L');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/6defb4fb7f7342050b9294944e31818a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Detected Fill'))))) {
    Content = null;
  } else {
    Content = String(Math.round((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Detected Fill')) * 1000) / 1000) + String(' L');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/bc4c0dc7304bef853b4bc54630fd240c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Gain/Loss'))))) {
    Content = null;
  } else {
    Content = String(Math.round((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Gain/Loss')) * 1000) / 1000) + String(' L');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/bef8d93676da228c63b90e9e526e6f12/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = ['(',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Fuel_Consumption')),'km/l)'].join('');

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/db73deedbf8e8e27224c5ab3e79298bc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = ['(',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target')),'km',')'].join('');

  } catch (error) {

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/f215fa5c40ce4803bf3d87991a2f6e0c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = ['(',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Tonnage_Target')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Units')),')'].join('');

  } catch (error) {

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/977d5d495aace08d26653e281613cb19/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Mileage_Target')) + String(' km');

  } catch (error) {

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/59698e373f5d6acd681ee9d552e7a0f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((new Date()))) == (await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created'))))) {
    try {
      Input = String(Math.ceil(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Mileage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * ((new Date((new Date())).getDate()) - 1))) + String(' km');

    } catch (error) {

    }
  } else {
    try {
      Input = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Mileage_Target')) + String(' km');

    } catch (error) {

    }
  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/acbe2d9a29b978789c5a727854b46458/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((new Date()))) == (await BackendlessUI.Functions.Custom['fn_6611957448e6393c2b3f73da5bb66bcd']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created'))))) {
    try {
      Input = String(Math.round((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Distance_Travelled')) - ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Mileage_Target')) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * ((new Date((new Date())).getDate()) - 1))) + String(' km');

    } catch (error) {

    }
  } else {
    try {
      Input = String((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Distance_Travelled')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Mileage_Target'))) + String(' km');

    } catch (error) {

    }
  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/1b947fd2e431cf6f0f3629ca0c92e5fc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Distance_Travelled'))))) + String(' km');

  } catch (error) {

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/2d0793b7bb9b4acf15982df88cd2970a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = [Math.round(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Tonnage_Target')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Units'))].join('');

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/2fbac1abf43fc0a9ba0a313b1695b8ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = [Math.round(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Tonnage_Projected_Ideal_For Today')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Units'))].join('');

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/ba1dcead5be6c1c8e565879862ff9236/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = [Math.round(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Tonnage_Total')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Units'))].join('');

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/23baec169d3da8a1a76b8ce256a9f82e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = [Math.round((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Tonnage_Total')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Tonnage_Projected_Ideal_For Today'))),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Units'))].join('');

  } catch (error) {
    console.log(error);

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/3e8309b241d185655467e7a8c82d5ac9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('a3f7a8b832570fb7c4515b28d5477cde', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/0ee1a9e62cab568976e6b4b1f4e29ab7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('a3f7a8b832570fb7c4515b28d5477cde', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/3a3288d2a60314b69fb24cfc00851318/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'))))) {
    } else {
      Content = String((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Mileage_Target'));}))).reduce(function(x, y) {return x + y;})) + String(' km');
    }

  } catch (error) {
    console.log(error);

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/c7c454c796c37b2eb23ab6162576b7d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'))))) {
    } else {
      Content = String((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Distance_Travelled'));}))).reduce(function(x, y) {return x + y;})) + String(' km');
    }

  } catch (error) {
    console.log(error);

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/79cf9cf6497a5722c30f9cabb0bee256/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Input, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'))))) {
    } else {
      Input = ['(',Math.round((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Distance_Travelled'));}))).reduce(function(x, y) {return x + y;}) - ((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Mileage_Target'));}))).reduce(function(x, y) {return x + y;}) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * ((new Date((new Date())).getDate()) - 1)),' km',')'].join('');
    }

  } catch (error) {

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/0876fa57db8e7bc82cb2a1acc09df495/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('f56e986ba15e5645842622c9ff3c8f36', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/ac2867592926e5e163eccd3c3b0c2614/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Input;


  await ( async function (componentUid, isOpen) {  ___arguments.context.getComponentByUid(componentUid).setIsOpen(isOpen) })('f56e986ba15e5645842622c9ff3c8f36', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/7ef6e00671c59fdc167ba0d20b36e65a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'))))) {
    } else {
      Content = String((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tonnage_Total'));}))).reduce(function(x, y) {return x + y;}));
    }

  } catch (error) {
    console.log(error);

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/e01f5068d6556f7e88eefc9ff3bd60ef/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'))))) {
    } else {
      Content = String((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tonnage_Target'));}))).reduce(function(x, y) {return x + y;}));
    }

  } catch (error) {
    console.log(error);

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/768879b7ae4f6592e9db75e30ee6e09f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Input, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'))))) {
    } else {
      Input = ['(',Math.round((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tonnage_Total'));}))).reduce(function(x, y) {return x + y;}) - ((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tonnage_Target'));}))).reduce(function(x, y) {return x + y;}) / (new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0).getDate())) * ((new Date((new Date())).getDate()) - 1)),')'].join('');
    }

  } catch (error) {

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/a4e2305a2a63db8be04c9722d68c4ade/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('9c34a73aec23ca58a2e22cd9409d62ad');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('9c34a73aec23ca58a2e22cd9409d62ad');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f3e9c22366f902aef4819ddad8b9b81a', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/b16784365653f91541e2e8185fab58c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  try {
    delete ___arguments.context.pageData['Admin Capture Load'];

  } catch (error) {

  }
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Quick Load'];

  } catch (error) {

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('318b7c7d84ce11ee39e9730176875287', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30e6591fbe6ca3bad316b55f32edf195', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64c99a9b58ffea63cdef471e3503be85', false);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('a33ad288329dce04e064dc9f21064b9c');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('a33ad288329dce04e064dc9f21064b9c');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFOFFICE/components/d51a38aa2a4acd1c7a3e9cffb8b7da6e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64c99a9b58ffea63cdef471e3503be85', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('318b7c7d84ce11ee39e9730176875287', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30e6591fbe6ca3bad316b55f32edf195', false);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('8a1d2416b60c7a4812c39a837f533a83');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('8a1d2416b60c7a4812c39a837f533a83');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFOFFICE/components/617d36f9b5c460c6206667e6e125aaa1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item, Transfer_Point, Products, Result, Transaction, Temp_Tractor, Created_Load, Trailers, Load_Variable, Rate_Per_Km, Load_Value, Mileage, Rate_Per_Unit, Mileage__Delivered_, Mileage__Load_, Units, Loaded_Seconds, Load_Time, Deliver_Time, Return_Seconds, Speed_Ratio, Trip_Seconds, Load_ID_Tag, Load_Counter_To_Text, Loads_Counter;

/**
 * Describe this function...
 */
async function Clear_Form() {
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('f2d16fe6a3be499586bb7fdc4543df79', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('b7fe71f8c531da3db4857a3ee4949857', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('63f67df81e19e45952c1293ae53fdacd', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('553b5e2755e9ca0c28314bbb81bda93c', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('4e6d0de6d6e12919048c9901804c1cd9', null);

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c51eb91741c7599e2dfd5ca19eeb4a69'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('870a5425bf92b9e2a7ba615516d1d9d2'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('987c655ea23a663398670f995087ec02'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  await new Promise(r => setTimeout(r, 200 || 0));
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('927a186b22a2cd4700a92c6daeff9ca7', false);

  } catch (error) {
    console.log(error);

  }
  await new Promise(r => setTimeout(r, 200 || 0));
  try {
    delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Products'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Delivery Date'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Load Date'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Route'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Dead Leg'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Loaded Leg'];

  } catch (error) {
    console.log(error);

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('927a186b22a2cd4700a92c6daeff9ca7', true);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Admin_Capture_Function() {
  Load_Value = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value')))) ? (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder')) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value'));
  Rate_Per_Km = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value'));
  Mileage__Load_ = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('870a5425bf92b9e2a7ba615516d1d9d2')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('870a5425bf92b9e2a7ba615516d1d9d2')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('870a5425bf92b9e2a7ba615516d1d9d2')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('870a5425bf92b9e2a7ba615516d1d9d2')), 'value'));
  Mileage__Delivered_ = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('987c655ea23a663398670f995087ec02')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('987c655ea23a663398670f995087ec02')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('987c655ea23a663398670f995087ec02')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('987c655ea23a663398670f995087ec02')), 'value'));
  Rate_Per_Unit = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value'));
  Mileage = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value'));
  Load_Variable = ({ [`Tonnage_Delivered`]: (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;}),[`Tonnage_Loaded`]: (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;}),[`Mileage_Load_Point`]: Mileage__Load_,[`Mileage_Delivery_Point`]: Mileage__Delivered_,[`Mileage_Last_Delivery_Point`]: undefined,[`Delivery (Client)`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]), 'Name')),[`Customer Name`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value')));
  }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value')));
  }))[0]), 'Name')),[`Date_Planned_Delivery`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Delivery Date')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Delivery Date')),[`Date_Delivered`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Delivery Date')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Delivery Date')),[`Date_Planned_Loading`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')),[`Date_Loaded`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')),[`Distance_Planned_LDP_To_DP`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Distance')) / 1000,[`Distance_Planned_LDP_To_LP`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Dead Leg')) / 1000,[`Distance_Planned_LP_To_DP`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Loaded Leg')) / 1000,[`Financial_Billing_Type`]: 'Per Km',[`Financial_Target_Ideal_Rate_Per_Km`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km')),[`Financial_Target_Ideal_Rate_Per_Tonne`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Tonne')),[`ID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c51eb91741c7599e2dfd5ca19eeb4a69')), 'value')))) ? (await BackendlessUI.Functions.Custom['fn_6fc870fc98c8afb7acb79fd769a3f969'](___arguments.context.appData, 'Load', false, ({ [`Customer`]: 0,[`Employee`]: 0,[`Fuel`]: 0,[`Load`]: 0,[`Location`]: 0,[`Tractor`]: 0,[`Trailer`]: 0,[`Tyre`]: 0 }))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c51eb91741c7599e2dfd5ca19eeb4a69')), 'value')),[`Load Planner Name`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name')),[`Load Point (Delivery Name)`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]), 'Contact_Name')),[`Load Point (Load Name)`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
  }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
  }))[0]), 'Contact_Name')),[`CID`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value')),[`LLPID`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
  }))[0]), 'objectId')),[`LDPID`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]), 'objectId')),[`LLDPID`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6')), 'value')));
  }))[0]), 'objectId')),[`Load_Broker`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')),[`Load_Notes`]: undefined,[`Load_Product`]: Products,[`Load_Type`]: 'Standard',[`Rig_Cost_Per_Hour`]: undefined,[`Rig_CPK`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Rig_CPK')),[`Rig_Payload`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')),[`Status`]: 'Delivered',[`Tonnage_Planned`]: (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;}),[`Planned Rate Per Unit`]: Rate_Per_Unit,[`Planned Mileage`]: Mileage,[`Planned_Load_Value`]: Load_Value,[`Planned Rate Per Km`]: Rate_Per_Km,[`ownerId`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')));
  }))[0]), 'ownerId')),[`objectId`]: (generateUUID().long()),[`TID`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) });
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Created_Load = (_uow.create('Loads', Load_Variable));
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')));
    }))[0])))) {
    } else {
      _uow.setRelation('Loads', Created_Load, 'Load_Planner', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')));
      }))[0]), 'objectId'))]);
    }
    console.log('2');
    _uow.setRelation('Loads', Created_Load, 'Location_Delivery_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
    }))[0]), 'objectId'))]);
    console.log('3');
    _uow.setRelation('Loads', Created_Load, 'Location_Last_Delivery_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6')), 'value')));
    }))[0]), 'objectId'))]);
    console.log('4');
    _uow.setRelation('Loads', Created_Load, 'Location_Load_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
    }))[0]), 'objectId'))]);
    console.log('5');
    _uow.setRelation('Loads', Created_Load, 'Rig_Tractor', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'))]);
    console.log('6');
    Trailers = (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'objectId'))], async (item) => {


     return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](item)));
    }));
    try {
      _uow.setRelation('Loads', Created_Load, 'Rig_Trailers', Trailers);

    } catch (error) {
      console.log(error);

    }
    console.log('7');
    _uow.setRelation('Loads', Created_Load, 'Customer', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value'))]);
    console.log(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value'));
    _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), 'Loads', [Created_Load]);

  })();

  Result = (await Transaction.execute());
  console.log(Result);
  addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')));
  }))[0]), 'Loads')), (getObjectProperty((getObjectProperty((getObjectProperty(Result, 'results')), 'createLoads1')), 'result')));
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? [] : (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'Status')) != 'Delivered');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  }))));
  delete ___arguments.context.pageData['Admin Capture Load'];
}

/**
 * Describe this function...
 */
async function Load_Planner() {
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route'))))) {
    Trip_Seconds = 0;
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('a13a790952de1b1c1d7d2cdc9dce8d79'))))) {
      Load_Time = 0;
    } else {
      Load_Time = (Number(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('a13a790952de1b1c1d7d2cdc9dce8d79'))));
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('afc8038b258ee9fd9b4741e478d21e4d'))))) {
      Deliver_Time = 0;
    } else {
      Deliver_Time = (Number(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('afc8038b258ee9fd9b4741e478d21e4d'))));
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed'))))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration'))))) {
        Trip_Seconds = 0;
      } else {
        Trip_Seconds = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) * 1.5;
        Loaded_Seconds = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'Loaded Leg')), 'Duration')) * 1.5;
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'Return Leg'))))) {
        } else {
          Return_Seconds = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'Return Leg')), 'Duration')) * 1.5;
        }
      }
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration'))))) {
        Trip_Seconds = 0;
      } else {
        Speed_Ratio = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120;
        Trip_Seconds = ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) * 1.5) / Speed_Ratio;
        Loaded_Seconds = ((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'Loaded Leg')), 'Duration')) * 1.5) / Speed_Ratio;
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'Return Leg'))))) {
        } else {
          Return_Seconds = ((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'Return Leg')), 'Duration')) * 1.5) / Speed_Ratio;
        }
      }
    }
  }
  Load_Value = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value')))) ? (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder')) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value'));
  Rate_Per_Km = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value'));
  Rate_Per_Unit = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value'));
  Mileage = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value'));
  Load_Variable = ({ [`TP_NAME`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Transfer_Point)) ? null : (getObjectProperty(Transfer_Point, 'Name')),[`TPID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Transfer_Point)) ? null : (getObjectProperty(Transfer_Point, 'objectId')),[`Transfer_Planned`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Transfer_Point)) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Planner - Planned Load Transfer')),[`Transfer_Rig_Details`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Transfer_Point)) ? null : ({ [`Primary Rig Data`]: ({ [`Tractor Id`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),[`Driver Id`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'objectId')),[`Trailer 1`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'objectId')),[`Trailer 2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'objectId')),[`Trailer 3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'objectId')) }),[`Secondary Rig Data`]: ({ [`Tractor Id`]: undefined,[`Driver Id`]: undefined,[`Trailer 1`]: undefined,[`Trailer 2`]: undefined,[`Trailer 3`]: undefined }) }),[`Time_Delivering`]: Deliver_Time,[`Time_Loading`]: Load_Time,[`Date_Planned_Return`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Return')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de8e8f4bbb67b6b91e39d5ee272b6c7a')), 'value')) + (Loaded_Seconds + Return_Seconds + Load_Time + Deliver_Time) * 1000,[`Distance_Planned_DP_To_RP`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'Return Leg')))) ? 0 : (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'Return Leg')), 'Distance')) / 1000,[`LRPID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Return')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Return')), 'objectId')),[`RP_NAME`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Return')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Return')), 'Name')),[`Route(Json)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')),[`BilledRoute(Json)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route')),[`Geoline(Billed)`]: (new Backendless.Data.LineString((await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route')), 'Polyline')).map(async item => {; return (new Backendless.Data.Point().setX((getObjectProperty(item, 'lng'))).setY((getObjectProperty(item, 'lat'))));}))))),[`Geoline(Route)`]: (new Backendless.Data.LineString((await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Polyline')).map(async item => {; return (new Backendless.Data.Point().setX((getObjectProperty(item, 'lng'))).setY((getObjectProperty(item, 'lat'))));}))))),[`Mileage(Billed)`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route')), 'Distance')) / 1000,[`LDP_NAME`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6')), 'value')));
  }))[0]), 'Name')),[`LP_NAME`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
  }))[0]), 'Name')),[`DP_NAME`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]), 'Name')),[`Load_Product_JSON`]: ({ [`Planned`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')) }),[`Delivery (Client)`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]), 'Name')),[`Customer Name`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value')));
  }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value')));
  }))[0]), 'Name')),[`Date_Planned_Delivery`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de8e8f4bbb67b6b91e39d5ee272b6c7a')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de8e8f4bbb67b6b91e39d5ee272b6c7a')), 'value')) + (Load_Time + Loaded_Seconds) * 1000,[`Date_Planned_Loading`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de8e8f4bbb67b6b91e39d5ee272b6c7a')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de8e8f4bbb67b6b91e39d5ee272b6c7a')), 'value')),[`Distance_Planned_LDP_To_DP`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Distance')) / 1000,[`Distance_Planned_LDP_To_LP`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Dead Leg')) / 1000,[`Distance_Planned_LP_To_DP`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Loaded Leg')) / 1000,[`Financial_Billing_Type`]: 'Per Km',[`Financial_Target_Ideal_Rate_Per_Km`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km')),[`Financial_Target_Ideal_Rate_Per_Tonne`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Tonne')),[`ID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c51eb91741c7599e2dfd5ca19eeb4a69')), 'value')))) ? (await BackendlessUI.Functions.Custom['fn_6fc870fc98c8afb7acb79fd769a3f969'](___arguments.context.appData, 'Load', false, ({ [`Customer`]: 0,[`Employee`]: 0,[`Fuel`]: 0,[`Load`]: 0,[`Location`]: 0,[`Tractor`]: 0,[`Trailer`]: 0,[`Tyre`]: 0 }))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c51eb91741c7599e2dfd5ca19eeb4a69')), 'value')),[`Load Planner Name`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name')),[`Load Point (Delivery Name)`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]), 'Contact_Name')),[`Load Point (Load Name)`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
  }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
  }))[0]), 'Contact_Name')),[`CID`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value')),[`LLPID`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
  }))[0]), 'objectId')),[`LDPID`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
  }))[0]), 'objectId')),[`LLDPID`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6')), 'value')));
  }))[0]), 'objectId')),[`Load_Broker`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')),[`Load_Notes`]: undefined,[`Load_Product`]: Products,[`Load_Type`]: 'Standard',[`Rig_Cost_Per_Hour`]: undefined,[`Rig_CPK`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Rig_CPK')),[`Rig_Payload`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')),[`Status`]: 'Planned',[`Tonnage_Planned`]: (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;}),[`Planned Rate Per Unit`]: Rate_Per_Unit,[`Planned Mileage`]: Mileage,[`Planned_Load_Value`]: Load_Value,[`Planned Rate Per Km`]: Rate_Per_Km,[`ownerId`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')));
  }))[0]), 'ownerId')),[`objectId`]: (generateUUID().long()),[`TID`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) });
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Created_Load = (_uow.create('Loads', Load_Variable));
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')));
    }))[0])))) {
    } else {
      _uow.setRelation('Loads', Created_Load, 'Load_Planner', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')));
      }))[0]), 'objectId'))]);
    }
    _uow.setRelation('Loads', Created_Load, 'Location_Delivery_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
    }))[0]), 'objectId'))]);
    _uow.setRelation('Loads', Created_Load, 'Location_Last_Delivery_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6')), 'value')));
    }))[0]), 'objectId'))]);
    _uow.setRelation('Loads', Created_Load, 'Location_Load_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
    }))[0]), 'objectId'))]);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'Return Leg'))))) {
    } else {
      _uow.setRelation('Loads', Created_Load, 'Location_Return_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aa02e8765bcb0dfd35ad2daad32f98a9')), 'value')));
      }))[0]), 'objectId'))]);
    }
    _uow.setRelation('Loads', Created_Load, 'Rig_Tractor', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'))]);
    Trailers = (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'objectId'))], async (item) => {


     return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](item)));
    }));
    _uow.setRelation('Loads', Created_Load, 'Rig_Trailers', Trailers);
    _uow.setRelation('Loads', Created_Load, 'Customer', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value'))]);
    _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), 'Loads', [Created_Load]);

  })();

  Result = (await Transaction.execute());
  console.log(Result);
  addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')));
  }))[0]), 'Loads')), (getObjectProperty((getObjectProperty((getObjectProperty(Result, 'results')), 'createLoads1')), 'result')));
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? [] : (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'Status')) != 'Delivered');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  }))));
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function Old_Code() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('617d36f9b5c460c6206667e6e125aaa1'))['disabled'] = true;
  Products = (await BackendlessUI.Functions.Custom['fn_f4df84546016cedc7395d748e8d7078c']((JSON.stringify((await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return ([(getObjectProperty(item, 'Mass')) / (getObjectProperty(item, 'Unit mass')),' ',' X ',' ',(getObjectProperty((getObjectProperty(item, 'Product')), 'Product')),'/n'].join(''));})))))));
  try {
    Transfer_Point = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('1ce8981b151814f7e4ae27a8a551bfb1')));
    }))[0];

  } catch (error) {
    console.log(error);

  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Admin Capture Load'))))) {
    await Load_Planner();
  } else {
    await Admin_Capture_Function();
  }
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Clear_Form();
  Loads_Counter = (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Load Ref Counter')) + 1;
  Load_Counter_To_Text = getValueLength(String(Loads_Counter)) == 1 ? String('000000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 2 ? String('00000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 3 ? String('0000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 4 ? String('000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 5 ? String('00') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 6 ? String('0') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 7 ? String(Loads_Counter) : 'Hidden Easter Egg'))))));
  await new Promise(r => setTimeout(r, 1000 || 0));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads'))))) {
    Load_ID_Tag = [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Registered_Name')).slice(0, 3),' L ',Load_Counter_To_Text].join('');
  } else {
    Load_ID_Tag = [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' ',Load_Counter_To_Text].join('');
  }
  await new Promise(r => setTimeout(r, 1000 || 0));
  ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Load Ref'] = Load_ID_Tag;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('617d36f9b5c460c6206667e6e125aaa1'))['disabled'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('927a186b22a2cd4700a92c6daeff9ca7', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('927a186b22a2cd4700a92c6daeff9ca7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('617d36f9b5c460c6206667e6e125aaa1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4ad1276182a224733317d57e58ceb38', true);
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Transferred Order'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Transferred Order')), 'Rig Select'))))) {
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Transferred Order')), 'Rig Select'))) {
        removeItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Orders')), (getObjectProperty(___arguments.context.pageData, 'Transferred Order')), '');
        await Backendless.Data.of('Companies').save((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), true);
        delete ___arguments.context.pageData['Transferred Order'];
      }
    }
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('617d36f9b5c460c6206667e6e125aaa1'))['disabled'] = true;
  Products = (await BackendlessUI.Functions.Custom['fn_f4df84546016cedc7395d748e8d7078c']((JSON.stringify((await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return ([(getObjectProperty(item, 'Mass')) / (getObjectProperty(item, 'Unit mass')),' ',' X ',' ',(getObjectProperty((getObjectProperty(item, 'Product')), 'Product')),'/n'].join(''));})))))));
  try {
    Transfer_Point = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('1ce8981b151814f7e4ae27a8a551bfb1')));
    }))[0];

  } catch (error) {
    console.log(error);

  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Admin Capture Load'))))) {
    await Load_Planner();
  } else {
    await Admin_Capture_Function();
  }
  await new Promise(r => setTimeout(r, 1000 || 0));
  await Clear_Form();
  await new Promise(r => setTimeout(r, 1000 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('617d36f9b5c460c6206667e6e125aaa1'))['disabled'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('927a186b22a2cd4700a92c6daeff9ca7', false);
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('927a186b22a2cd4700a92c6daeff9ca7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('617d36f9b5c460c6206667e6e125aaa1', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b4ad1276182a224733317d57e58ceb38', true);
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Transferred Order'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Transferred Order')), 'Rig Select'))))) {
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Transferred Order')), 'Rig Select'))) {
        removeItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Orders')), (getObjectProperty(___arguments.context.pageData, 'Transferred Order')), '');
        await Backendless.Data.of('Companies').save((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), true);
        delete ___arguments.context.pageData['Transferred Order'];
      }
    }
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/6bcdc7fa9a4f7f6e44535a7c13afbcd4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'));
  console.log(___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/4f21871ae8df6043181f3985d821f9e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/a0914ba91547234f9717b59ffc85bb97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Type'))))) {
        Content = '';
      } else {
        Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Type'));
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/14da434b89292c1e31e90bcc413b58b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload'))))) {
        Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload'));
      } else {
        Content = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')),' ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Units'))].join('');
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/7d251fd885cb18bac8cfdf5aad5a408f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Nickname'))))) {
        Content = '';
      } else {
        Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Nickname'));
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/d8367fe4547cdbbee9b5a5619a367ad7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Phone'))))) {
        Content = '';
      } else {
        Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Phone'));
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/79649812af4e5728727f2de97fa6d475/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Company'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Company')), 'Name'))))) {
        Content = '';
      } else {
        Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Company')), 'Name'));
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/d066840de59da8347c661b2ed6cf6001/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Company'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Company')), 'Contact_Phone'))))) {
        Content = '';
      } else {
        Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Company')), 'Contact_Phone'));
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/d87cd6ca309b23bbb6010ba380cbfd73/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Tonne'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Tonne'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/0d5d94d4fef9e1d4668ce4498206d0fe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/f3f81bce376325c2eb220b9932d6b5ad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function mathMean(myList) {
  return myList.reduce(function(x, y) {return x + y;}) / myList.length;
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads'))))) {
      Content = '';
    } else {
      Content = Math.round(mathMean(await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')).map(async item => {; return (getObjectProperty(item, 'Financial_Rate_Per_Km'));}))) * 100) / 100;
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/71089fa2e5c583b1798c164546a55d84/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads'))))) {
      Content = '';
    } else {
      Content = Math.round(((await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')).map(async item => {; return (getObjectProperty(item, 'Financial_Load_Value'));}))).reduce(function(x, y) {return x + y;}) / (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')).map(async item => {; return (getObjectProperty(item, 'Distance_Last_Delivery_To_Delivery_Point'));}))).reduce(function(x, y) {return x + y;})) * 100) / 100;
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/427d58a66c462a6cd874e96902a6b4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Tonnage_Target'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Tonnage_Target'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/b141704c93e18616ed9f00b385cb201b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads'))))) {
      Content = '';
    } else {
      Content = (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')).map(async item => {; return ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Tonnage_Delivered')))) ? 0 : ((getObjectProperty(item, 'Tonnage_Delivered')) >= 0 ? (getObjectProperty(item, 'Tonnage_Delivered')) : 0));}))).reduce(function(x, y) {return x + y;});
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/9405fb0c911f58379e0f18c280948515/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function roundDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tonnage_Target'))))) {
        Content = '';
      } else {
        Content = String(roundDecimals((((await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')).map(async item => {; return (getObjectProperty(item, 'Tonnage_Delivered'));}))).reduce(function(x, y) {return x + y;}) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tonnage_Target'))) * 100),2)) + String(' %');
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/ec5131e9e596fd42ab789278b21423f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tonnage_Target_Completion'))))) {
      Content = '';
    } else {
      Content = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tonnage_Target_Completion')) + String(' %');
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/7fa7345db61d2ae7be11b5ec55d790c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Target'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Target'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/c7853c710497869de66b680f43af6b2a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Distance_Travelled'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Distance_Travelled'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/25c4f5b23a97f7838e9c0e42abd2acd1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Target')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Distance_Travelled')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Target')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Distance_Travelled'))))) {
      Content = '';
    } else {
      Content = String(Math.round(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Distance_Travelled')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Target'))) * 100 * 100) / 100) + String(' %');
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/8d5c1973e6efc1ffc3c6564457339207/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Completion'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Mileage_Completion'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/a714dfe565d68e11dabe9b49688fd578/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Turnover'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Turnover'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/de8e8f4bbb67b6b91e39d5ee272b6c7a/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Last_Location_ID, Last_Load, item, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968b3289c278ef666606e2f7c75a8bfb', false);

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Load Date'] = ___arguments.value;
  Last_Load = (await asyncListFilter((await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Loads')), -1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  })), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')) > (getObjectProperty(item, 'Action Date')));
  })).slice(-1)[0];
  if ((getObjectProperty(Last_Load, 'Status')) == 'Delivered') {
    Last_Location_ID = (getObjectProperty(Last_Load, 'LDPID'));
  } else if ((getObjectProperty(Last_Load, 'Status')) == 'Loaded') {
    Last_Location_ID = (getObjectProperty(Last_Load, 'LLPID'));
  } else if ((getObjectProperty(Last_Load, 'Status')) == 'Planned') {
    Last_Location_ID = (getObjectProperty(Last_Load, 'LLDPID'));
  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6', Last_Location_ID);

  } catch (error) {

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/15114357cfe123ca1b0df1992faaf3db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Last_Location_ID, Last_Load, item;

/**
 * Describe this function...
 */
async function Old_Code() {
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).collapse() })('d61f789cbe5390a5384b6ff24a317035');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('73e16762de28a8a6d036f699f32180c4', true);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).expand() })('73e16762de28a8a6d036f699f32180c4');
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968b3289c278ef666606e2f7c75a8bfb', true);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('968b3289c278ef666606e2f7c75a8bfb')));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date'))))) {
    ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Load Date'] = ((getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')).length == 0 ? (await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), 1, async (item) => {


     return ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(item, 'Date_Planned_Return')))) ? (getObjectProperty(item, 'Date_Planned_Delivery')) : (getObjectProperty(item, 'Date_Planned_Return')));
    })).slice(-1)[0] : ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')).slice(-1)[0]), 'Date_Planned_Delivery')) + 900000);
  }
  Last_Load = (await asyncListFilter((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')).length == 0 ? (await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), 1, async (item) => {


   return (getObjectProperty(item, 'Sequence'));
  })) : ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34'))), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')) > (getObjectProperty(item, 'Sequence')));
  })).slice(-1)[0];
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Last_Load))) {
    Last_Load = (await asyncListFilter((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')).length == 0 ? (await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), 1, async (item) => {


     return (getObjectProperty(item, 'Sequence'));
    })) : ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34'))), async (item) => {


     return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')) < (getObjectProperty(item, 'Sequence')));
    }))[0];
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Last_Load, 'Date_Planned_Return'))))) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')) > (getObjectProperty(Last_Load, 'Date_Planned_Loading'))) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')) > (getObjectProperty(Last_Load, 'Date_Planned_Delivery'))) {
        Last_Location_ID = (getObjectProperty(Last_Load, 'LDPID'));
      } else {
        Last_Location_ID = (getObjectProperty(Last_Load, 'LLPID'));
      }
    } else {
      Last_Location_ID = (getObjectProperty(Last_Load, 'LLDPID'));
    }
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')) > (getObjectProperty(Last_Load, 'Date_Planned_Loading'))) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')) > (getObjectProperty(Last_Load, 'Date_Planned_Delivery'))) {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')) > (getObjectProperty(Last_Load, 'Date_Planned_Return'))) {
          Last_Location_ID = (getObjectProperty(Last_Load, 'LRPID'));
        } else {
          Last_Location_ID = (getObjectProperty(Last_Load, 'LDPID'));
        }
      } else {
        Last_Location_ID = (getObjectProperty(Last_Load, 'LLPID'));
      }
    } else {
      Last_Location_ID = (getObjectProperty(Last_Load, 'LLDPID'));
    }
  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6', Last_Location_ID);

  } catch (error) {

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/70d48a227277558475b891578278b33a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Load_ID_Tag, Load_Counter_To_Text, Loads_Counter, item, Result, Transaction, Created_Load, Trailers, Load_Variable, Rate_Per_Km, Load_Value, Mileage, Rate_Per_Unit, Products, Units;

/**
 * Describe this function...
 */
async function Old_Code() {
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).collapse() })('73e16762de28a8a6d036f699f32180c4');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6b646888bea5a3add178e38e5bbea6b8', true);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).expand() })('6b646888bea5a3add178e38e5bbea6b8');
}

/**
 * Describe this function...
 */
async function Clear_Form() {
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('397cc61daa269e6aeaee6ff2d5364dcd', true);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('397cc61daa269e6aeaee6ff2d5364dcd')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/8b0751df4ceaba4475b9dcfd53a1d4d7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Load_ID_Tag, Load_Counter_To_Text, Loads_Counter, item, Result, Transaction, Created_Load, Trailers, Load_Variable, Rate_Per_Km, Load_Value, Mileage, Rate_Per_Unit, Products;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function do_something() {
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).collapse() })('6b646888bea5a3add178e38e5bbea6b8');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9dce7182539aedbd1062b9ddf0cf6ddd', true);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).expand() })('9dce7182539aedbd1062b9ddf0cf6ddd');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('617d36f9b5c460c6206667e6e125aaa1', true);
}

/**
 * Describe this function...
 */
async function Clear_Form() {
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Quick Load'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a9fd41eaa5e8cbd930cffcfb77be20fe', true);
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('617d36f9b5c460c6206667e6e125aaa1', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a9fd41eaa5e8cbd930cffcfb77be20fe', true);
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('617d36f9b5c460c6206667e6e125aaa1', true);
    Products = (await BackendlessUI.Functions.Custom['fn_f4df84546016cedc7395d748e8d7078c']((JSON.stringify((await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return ([(getObjectProperty(item, 'Mass')) / (getObjectProperty(item, 'Unit mass')),' ',' X ',' ',(getObjectProperty((getObjectProperty(item, 'Product')), 'Product')),'/n'].join(''));})))))));
    Load_Value = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value')))) ? (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder')) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value'));
    Rate_Per_Km = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value'));
    Rate_Per_Unit = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value'));
    Mileage = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value'));
    Load_Variable = ({ [`Load_Product_JSON`]: ({ [`Planned`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')) }),[`Delivery (Client)`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
    }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
    }))[0]), 'Name')),[`Customer Name`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value')));
    }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value')));
    }))[0]), 'Name')),[`Date_Planned_Delivery`]: (new Date((new Date()).getTime() + (((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Distance')) / 1000) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed'))) * 2.5 * 60 * 60) * 1000))),[`Date_Planned_Loading`]: (new Date()),[`Distance_Planned_LDP_To_DP`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Distance')) / 1000,[`Distance_Planned_LDP_To_LP`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Dead Leg')) / 1000,[`Distance_Planned_LP_To_DP`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Loaded Leg')) / 1000,[`Financial_Billing_Type`]: 'Per Km',[`Financial_Target_Ideal_Rate_Per_Km`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km')),[`Financial_Target_Ideal_Rate_Per_Tonne`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Tonne')),[`ID`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c51eb91741c7599e2dfd5ca19eeb4a69')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c51eb91741c7599e2dfd5ca19eeb4a69')), 'value')),[`Load Planner Name`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name')),[`Load Point (Delivery Name)`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
    }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
    }))[0]), 'Contact_Name')),[`Load Point (Load Name)`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
    }))[0]))) ? null : (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
    }))[0]), 'Contact_Name')),[`CID`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value')),[`LLPID`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
    }))[0]), 'objectId')),[`LDPID`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
    }))[0]), 'objectId')),[`LLDPID`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6')), 'value')));
    }))[0]), 'objectId')),[`Load_Broker`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')),[`Load_Notes`]: undefined,[`Load_Product`]: Products,[`Load_Type`]: 'Standard',[`Rig_Cost_Per_Hour`]: undefined,[`Rig_CPK`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Rig_CPK')),[`Rig_Payload`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')),[`Status`]: 'Planned',[`Tonnage_Planned`]: (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;}),[`Planned Rate Per Unit`]: Rate_Per_Unit,[`Planned Mileage`]: Mileage,[`Planned_Load_Value`]: Load_Value,[`Planned Rate Per Km`]: Rate_Per_Km,[`ownerId`]: (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(item, 'Registration')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')));
    }))[0]), 'ownerId')),[`objectId`]: (generateUUID().long()),[`TID`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) });
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Transaction;

      Created_Load = (_uow.create('Loads', Load_Variable));
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')));
      }))[0])))) {
      } else {
        _uow.setRelation('Loads', Created_Load, 'Load_Planner', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


         return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')));
        }))[0]), 'objectId'))]);
      }
      _uow.setRelation('Loads', Created_Load, 'Location_Delivery_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('553b5e2755e9ca0c28314bbb81bda93c')), 'value')));
      }))[0]), 'objectId'))]);
      _uow.setRelation('Loads', Created_Load, 'Location_Last_Delivery_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6')), 'value')));
      }))[0]), 'objectId'))]);
      _uow.setRelation('Loads', Created_Load, 'Location_Load_Point', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b7fe71f8c531da3db4857a3ee4949857')), 'value')));
      }))[0]), 'objectId'))]);
      _uow.setRelation('Loads', Created_Load, 'Rig_Tractor', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'))]);
      Trailers = (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'objectId'))], async (item) => {


       return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](item)));
      }));
      _uow.setRelation('Loads', Created_Load, 'Rig_Trailers', Trailers);
      _uow.setRelation('Loads', Created_Load, 'Customer', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f2d16fe6a3be499586bb7fdc4543df79')), 'value'))]);
      _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), 'Loads', [Created_Load]);

    })();

    Result = (await Transaction.execute());
    addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')));
    }))[0]), 'Loads')), (getObjectProperty((getObjectProperty((getObjectProperty(Result, 'results')), 'createLoads1')), 'result')));
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? [] : (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) != 'Delivered');
    })), 1, async (item) => {


     return (getObjectProperty(item, 'Action Date'));
    }))));
    await new Promise(r => setTimeout(r, 1000 || 0));
    await Clear_Form();
    Loads_Counter = (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Load Ref Counter')) + 1;
    Load_Counter_To_Text = getValueLength(String(Loads_Counter)) == 1 ? String('000000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 2 ? String('00000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 3 ? String('0000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 4 ? String('000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 5 ? String('00') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 6 ? String('0') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 7 ? String(Loads_Counter) : 'Hidden Easter Egg'))))));
    await new Promise(r => setTimeout(r, 1000 || 0));
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads'))))) {
      Load_ID_Tag = [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Registered_Name')).slice(0, 3),' L ',Load_Counter_To_Text].join('');
    } else {
      Load_ID_Tag = [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' ',Load_Counter_To_Text].join('');
    }
    await new Promise(r => setTimeout(r, 1000 || 0));
    ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Load Ref'] = Load_ID_Tag;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('617d36f9b5c460c6206667e6e125aaa1'))['disabled'] = false;
    await new Promise(r => setTimeout(r, 1000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('318b7c7d84ce11ee39e9730176875287', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30e6591fbe6ca3bad316b55f32edf195', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64c99a9b58ffea63cdef471e3503be85', false);
    try {
      delete ___arguments.context.pageData['Admin Capture Load'];

    } catch (error) {

    }
    try {
      delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Quick Load'];

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/d61e6a7afbfa7a89b177f9da477b5786/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Delivery Date'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onMinDateAssignment */
  async ['onMinDateAssignment'](___arguments) {
    var Minimum_Date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date'))))) {
    Minimum_Date = (new Date());
  } else {
    Minimum_Date = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date'));
  }

  return Minimum_Date

  },
  /* handler:onMinDateAssignment */
  /* handler:onMaxDateAssignment */
  async ['onMaxDateAssignment'](___arguments) {
    var Maximum_Date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Admin Capture Load'))))) {
    Maximum_Date = (new Date((new Date()).getTime() + (31536000 * 1000)));
  } else {
    Maximum_Date = (new Date());
  }

  return Maximum_Date

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/6ff5a7aa2a75a83cbe53dbbd19fa9bc6/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Customer'))))) {
          Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


           return (getObjectProperty(item, 'label'));
          }));
        } else {
          Options = (await (async function(List, Property) {
          	// The function accepts 'List' (array) and 'Property' (key to deduplicate by)
          	return List.reduce((acc, item) => {
          	  const key = item[Property];
          	  acc.map[key] = item;
          	  acc.array = Object.values(acc.map);
          	  return acc;
          	}, { map: {}, array: [] }).array;
          })((await (async function(List, Property) {
          	// The function accepts 'List' (array) and 'Property' (key to deduplicate by)
          	return List.reduce((acc, item) => {
          	  const key = item[Property];
          	  acc.map[key] = item;
          	  acc.array = Object.values(acc.map);
          	  return acc;
          	}, { map: {}, array: [] }).array;
          })(((await asyncListSort((await Promise.all((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


           return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Customer')));
          }))[0]), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


           return (getObjectProperty(item, 'label'));
          })).concat((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


           return (getObjectProperty(item, 'label'));
          })))), 'value')), 'label'));
        }
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;


  try {
    delete ___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb')['Load Planner - Markers'];

  } catch (error) {
    console.log(error);

  }
  delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Route'];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', false);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/b7fe71f8c531da3db4857a3ee4949857/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Customer'))))) {
          Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


           return (getObjectProperty(item, 'label'));
          }));
        } else {
          Options = (await (async function(List, Property) {
          	// The function accepts 'List' (array) and 'Property' (key to deduplicate by)
          	return List.reduce((acc, item) => {
          	  const key = item[Property];
          	  acc.map[key] = item;
          	  acc.array = Object.values(acc.map);
          	  return acc;
          	}, { map: {}, array: [] }).array;
          })((await (async function(List, Property) {
          	// The function accepts 'List' (array) and 'Property' (key to deduplicate by)
          	return List.reduce((acc, item) => {
          	  const key = item[Property];
          	  acc.map[key] = item;
          	  acc.array = Object.values(acc.map);
          	  return acc;
          	}, { map: {}, array: [] }).array;
          })(((await asyncListSort((await Promise.all((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


           return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Customer')));
          }))[0]), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


           return (getObjectProperty(item, 'label'));
          })).concat((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


           return (getObjectProperty(item, 'label'));
          })))), 'value')), 'label'));
        }
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0912818df2b8801947d841fff760a19', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9082295322d43c95bbfa1421d3ebd436', true);
  try {
    delete ___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb')['Load Planner - Markers'];

  } catch (error) {
    console.log(error);

  }
  delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Route'];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', false);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/553b5e2755e9ca0c28314bbb81bda93c/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Customer'))))) {
          Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


           return (getObjectProperty(item, 'label'));
          }));
        } else {
          Options = (await (async function(List, Property) {
          	// The function accepts 'List' (array) and 'Property' (key to deduplicate by)
          	return List.reduce((acc, item) => {
          	  const key = item[Property];
          	  acc.map[key] = item;
          	  acc.array = Object.values(acc.map);
          	  return acc;
          	}, { map: {}, array: [] }).array;
          })((await (async function(List, Property) {
          	// The function accepts 'List' (array) and 'Property' (key to deduplicate by)
          	return List.reduce((acc, item) => {
          	  const key = item[Property];
          	  acc.map[key] = item;
          	  acc.array = Object.values(acc.map);
          	  return acc;
          	}, { map: {}, array: [] }).array;
          })(((await asyncListSort((await Promise.all((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


           return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Customer')));
          }))[0]), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


           return (getObjectProperty(item, 'label'));
          })).concat((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


           return (getObjectProperty(item, 'label'));
          })))), 'value')), 'label'));
        }
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77c2acaabc1c6cdf2d5d2ee31b71b636', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8db14e45528d50c13893adeb675a641c', true);
  try {
    delete ___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb')['Load Planner - Markers'];

  } catch (error) {
    console.log(error);

  }
  delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Route'];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', false);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/20ff94828c490151c41885ce733dce8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Rate_Per_Unit, Load_Value, Rate_Per_Km, Loaded_Leg, Start_Leg, Route, Billing_Route, item, Waypoints_Deliver_to_Return, Delivery_Point, Waypoints_Load_To_Deliver, Load_Point, Waypoints_Start_To_Load, Return_Point, Start_Point, Return_Leg, j, Transfer_Point, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function Waypoint_Processing() {
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('75b2c06d94c8b6b4491d6763d22d18ef'))))) {
    Waypoints_Start_To_Load = [];
  } else {
    Waypoints_Start_To_Load = [];
    var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('75b2c06d94c8b6b4491d6763d22d18ef'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      addItemToList(Waypoints_Start_To_Load, j);
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('75b2c06d94c8b6b4491d6763d22d18ef'))))) {
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c73ededba8ad18875b317c46b82b4d46'))))) {
    Waypoints_Load_To_Deliver = [];
  } else {
    Waypoints_Load_To_Deliver = [];
    var j_list3 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c73ededba8ad18875b317c46b82b4d46'));
    for (var j_index3 in j_list3) {
      j = j_list3[j_index3];
      addItemToList(Waypoints_Load_To_Deliver, j);
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ac6af178b324c6c1d70518e72bd48a63'))))) {
    Waypoints_Deliver_to_Return = [];
  } else {
    Waypoints_Deliver_to_Return = [];
    var j_list4 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ac6af178b324c6c1d70518e72bd48a63'));
    for (var j_index4 in j_list4) {
      j = j_list4[j_index4];
      addItemToList(Waypoints_Deliver_to_Return, j);
    }
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', false);
  await new Promise(r => setTimeout(r, 200 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', true);
  Route = null;
  Start_Point = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6')));
  }))[0];
  console.log(Start_Point);
  Load_Point = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('b7fe71f8c531da3db4857a3ee4949857')));
  }))[0];
  console.log(Load_Point);
  try {
    Transfer_Point = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('1ce8981b151814f7e4ae27a8a551bfb1')));
    }))[0];

  } catch (error) {
    console.log(error);

  }
  Delivery_Point = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('553b5e2755e9ca0c28314bbb81bda93c')));
  }))[0];
  console.log(Delivery_Point);
  Return_Point = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('aa02e8765bcb0dfd35ad2daad32f98a9')));
  }))[0];
  await Waypoint_Processing();
  Start_Leg = (await BackendlessUI.Functions.Custom['fn_b91213ddd54e86f99f851edb9dc3c82a']((getObjectProperty(Start_Point, 'Point')), (getObjectProperty(Load_Point, 'Point')), (Waypoints_Start_To_Load.length == 0 ? [] : (await Promise.all(Waypoints_Start_To_Load.map(async item => {; return (getObjectProperty(item, 'Point'));})))), null, null, null, null, null, null, null, true));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Transfer_Point))) {
    Loaded_Leg = (await BackendlessUI.Functions.Custom['fn_b91213ddd54e86f99f851edb9dc3c82a']((getObjectProperty(Load_Point, 'Point')), (getObjectProperty(Delivery_Point, 'Point')), (Waypoints_Load_To_Deliver.length == 0 ? [] : (await Promise.all(Waypoints_Load_To_Deliver.map(async item => {; return (getObjectProperty(item, 'Point'));})))), null, null, null, null, null, null, null, true));
  } else {
    addItemToList(Waypoints_Load_To_Deliver, Transfer_Point);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f4a1b7c9b564070c02c96854e93e00d5'))))) {
    } else {
      var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f4a1b7c9b564070c02c96854e93e00d5'));
      for (var j_index in j_list) {
        j = j_list[j_index];
        addItemToList(Waypoints_Load_To_Deliver, j);
      }
    }
    Loaded_Leg = (await BackendlessUI.Functions.Custom['fn_b91213ddd54e86f99f851edb9dc3c82a']((getObjectProperty(Load_Point, 'Point')), (getObjectProperty(Delivery_Point, 'Point')), (Waypoints_Load_To_Deliver.length == 0 ? [] : (await Promise.all(Waypoints_Load_To_Deliver.map(async item => {; return (getObjectProperty(item, 'Point'));})))), null, null, null, null, null, null, null, true));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Return_Point))) {
    Route = ({ [`Distance`]: (getObjectProperty(Start_Leg, 'Distance')) + (getObjectProperty(Loaded_Leg, 'Distance')),[`Duration`]: (getObjectProperty(Start_Leg, 'Duration')) + (getObjectProperty(Loaded_Leg, 'Duration')),[`Polyline`]: ((getObjectProperty(Start_Leg, 'Polyline')).concat((getObjectProperty(Loaded_Leg, 'Polyline')))),[`Route`]: ({ [`Start Leg`]: Start_Leg,[`Loaded Leg`]: Loaded_Leg }),[`PointList`]: ({ [`Origin`]: Start_Point,[`Waypoints`]: ((Waypoints_Start_To_Load.length == 0 ? [] : Waypoints_Start_To_Load).concat(([Load_Point].concat(((Waypoints_Load_To_Deliver.length == 0 ? [] : Waypoints_Load_To_Deliver).concat(([Delivery_Point].concat((Waypoints_Deliver_to_Return.length == 0 ? [] : Waypoints_Deliver_to_Return))))))))),[`Destination `]: Delivery_Point }) });
  } else {
    Return_Leg = (await BackendlessUI.Functions.Custom['fn_b91213ddd54e86f99f851edb9dc3c82a']((getObjectProperty(Delivery_Point, 'Point')), (getObjectProperty(Return_Point, 'Point')), (Waypoints_Deliver_to_Return.length == 0 ? [] : (await Promise.all(Waypoints_Deliver_to_Return.map(async item => {; return (getObjectProperty(item, 'Point'));})))), null, null, null, null, null, null, null, true));
    Route = ({ [`Distance`]: (getObjectProperty(Start_Leg, 'Distance')) + (getObjectProperty(Loaded_Leg, 'Distance')) + (getObjectProperty(Return_Leg, 'Distance')),[`Duration`]: (getObjectProperty(Start_Leg, 'Duration')) + (getObjectProperty(Loaded_Leg, 'Duration')) + (getObjectProperty(Return_Leg, 'Duration')),[`Polyline`]: ((getObjectProperty(Start_Leg, 'Polyline')).concat(((getObjectProperty(Loaded_Leg, 'Polyline')).concat((getObjectProperty(Return_Leg, 'Polyline')))))),[`Route`]: ({ [`Start Leg`]: Start_Leg,[`Loaded Leg`]: Loaded_Leg,[`Return Leg`]: Return_Leg }),[`PointList`]: ({ [`Origin`]: Start_Point,[`Waypoints`]: ((Waypoints_Start_To_Load.length == 0 ? [] : Waypoints_Start_To_Load).concat(([Load_Point].concat(((Waypoints_Load_To_Deliver.length == 0 ? [] : Waypoints_Load_To_Deliver).concat(([Delivery_Point].concat((Waypoints_Deliver_to_Return.length == 0 ? [] : Waypoints_Deliver_to_Return))))))))),[`Destination `]: Return_Point }),[`Return`]: Return_Point });
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(1)') {
    Billing_Route = ({ [`Distance`]: (getObjectProperty(Start_Leg, 'Distance')) + (getObjectProperty(Loaded_Leg, 'Distance')),[`Duration`]: (getObjectProperty(Start_Leg, 'Duration')) + (getObjectProperty(Loaded_Leg, 'Duration')),[`Polyline`]: ((getObjectProperty(Start_Leg, 'Polyline')).concat((getObjectProperty(Loaded_Leg, 'Polyline')))),[`Route`]: ({ [`Start Leg`]: Start_Leg,[`Loaded Leg`]: Loaded_Leg }) });
    Billing_Route['PointList'] = ({ [`Origin`]: Start_Point,[`Waypoints`]: ((Waypoints_Start_To_Load.length == 0 ? [] : Waypoints_Start_To_Load).concat(([Load_Point].concat((Waypoints_Load_To_Deliver.length == 0 ? [] : Waypoints_Load_To_Deliver))))),[`Destination `]: Delivery_Point });
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(2)') {
    Billing_Route = Loaded_Leg;
    Billing_Route['PointList'] = ({ [`Origin`]: Load_Point,[`Waypoints`]: Waypoints_Load_To_Deliver.length == 0 ? [] : Waypoints_Load_To_Deliver,[`Destination `]: Delivery_Point });
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(3)') {
    Billing_Route = ({ [`Distance`]: (getObjectProperty(Loaded_Leg, 'Distance')) + (getObjectProperty(Return_Leg, 'Distance')),[`Duration`]: (getObjectProperty(Loaded_Leg, 'Duration')) + (getObjectProperty(Return_Leg, 'Duration')),[`Polyline`]: ((getObjectProperty(Loaded_Leg, 'Polyline')).concat((getObjectProperty(Return_Leg, 'Polyline')))),[`Route`]: ({ [`Loaded Leg`]: Loaded_Leg,[`Return Leg`]: Return_Leg }) });
    Billing_Route['PointList'] = ({ [`Origin`]: Load_Point,[`Waypoints`]: ((Waypoints_Load_To_Deliver.length == 0 ? [] : Waypoints_Load_To_Deliver).concat(([Delivery_Point].concat((Waypoints_Deliver_to_Return.length == 0 ? [] : Waypoints_Deliver_to_Return))))),[`Destination `]: Return_Point });
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(4)') {
    Billing_Route = ({ [`Distance`]: (getObjectProperty(Start_Leg, 'Distance')) + (getObjectProperty(Loaded_Leg, 'Distance')) + (getObjectProperty(Return_Leg, 'Distance')),[`Duration`]: (getObjectProperty(Start_Leg, 'Duration')) + (getObjectProperty(Loaded_Leg, 'Duration')) + (getObjectProperty(Return_Leg, 'Duration')),[`Polyline`]: ((getObjectProperty(Start_Leg, 'Polyline')).concat(((getObjectProperty(Loaded_Leg, 'Polyline')).concat((getObjectProperty(Return_Leg, 'Polyline')))))),[`Route`]: ({ [`Start Leg`]: Start_Leg,[`Loaded Leg`]: Loaded_Leg,[`Return Leg`]: Return_Leg }) });
    Billing_Route['PointList'] = ({ [`Origin`]: Start_Point,[`Waypoints`]: ((Waypoints_Start_To_Load.length == 0 ? [] : Waypoints_Start_To_Load).concat(([Load_Point].concat(((Waypoints_Load_To_Deliver.length == 0 ? [] : Waypoints_Load_To_Deliver).concat(([Delivery_Point].concat((Waypoints_Deliver_to_Return.length == ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Return_Point)) ? Delivery_Point : null) ? [] : Waypoints_Deliver_to_Return))))))))),[`Destination `]: Return_Point });
  }
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('ecf24f5838fdd0b26cecd573c5c2e6c9', (getObjectProperty(((getObjectProperty(Route, 'Polyline'))[0]), 'lat')), (getObjectProperty(((getObjectProperty(Route, 'Polyline'))[0]), 'lng')));
  ___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb')['Load Planner - Markers'] = (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Return_Point)) ? ((Waypoints_Start_To_Load.length == 0 ? [] : (await Promise.all(Waypoints_Start_To_Load.map(async item => {; return (getObjectProperty(item, 'Point'));})))).concat(([(getObjectProperty(Load_Point, 'Point'))].concat((Waypoints_Load_To_Deliver.length == 0 ? [] : (await Promise.all(Waypoints_Load_To_Deliver.map(async item => {; return (getObjectProperty(item, 'Point'));})))))))) : ((Waypoints_Start_To_Load.length == 0 ? [] : (await Promise.all(Waypoints_Start_To_Load.map(async item => {; return (getObjectProperty(item, 'Point'));})))).concat(([(getObjectProperty(Load_Point, 'Point'))].concat(((Waypoints_Load_To_Deliver.length == 0 ? [] : (await Promise.all(Waypoints_Load_To_Deliver.map(async item => {; return (getObjectProperty(item, 'Point'));})))).concat(([(getObjectProperty(Delivery_Point, 'Point'))].concat((Waypoints_Deliver_to_Return.length == 0 ? [] : (await Promise.all(Waypoints_Deliver_to_Return.map(async item => {; return (getObjectProperty(item, 'Point'));}))))))))))))).concat([(getObjectProperty(Route, 'Polyline'))[0], (getObjectProperty(Route, 'Polyline')).slice(-1)[0]]));
  await (async function(googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers, pointColor, pointScale, vehicleId, geofences, stations, stationIconSvg, canAddGeofences, polygonColor, appData) {
  	let existingMarkers = [];
  	let existingPolylines = [];
  	let existingGeofences = [];
  	let currentInfoWindow = null;
  	let selectedMarker = null;
  	let geofenceMarkers = [];
  	let geofencePolygon = null;
  	let addingGeofence = false;
  	
  	appData = appData || {};
  	
  	function addPolylineAndCustomMarkers(
  	  googleMapComponent, polylineColor, markers, strokeOpacity, strokeWeight, pointMarkers,
  	  pointColor, pointScale, vehicleId, geofences, stations, stationIconSvg, enableGeofence, polygonColor, appData
  	) {
  	  if (!googleMapComponent || !googleMapComponent.map) {
  	    return;
  	  }
  	
  	  const mapInstance = googleMapComponent.map.map;
  	  if (!(mapInstance instanceof google.maps.Map)) {
  	    return;
  	  }
  	
  	  // Polyline logic
  	  const polylineCoordinates = markers.map(marker => ({
  	    lat: marker.lat,
  	    lng: marker.lng
  	  }));
  	
  	  const polyline = new google.maps.Polyline({
  	    path: polylineCoordinates,
  	    geodesic: true,
  	    strokeColor: polylineColor || '#FF0000',
  	    strokeOpacity: strokeOpacity || 1.0,
  	    strokeWeight: strokeWeight || 2
  	  });
  	
  	  polyline.setMap(mapInstance);
  	  existingPolylines.push(polyline);
  	
  	  function calculateHeading(lat1, lng1, lng2, lat2) {
  	    const toRadians = degrees => degrees * Math.PI / 180;
  	    const toDegrees = radians => degrees * 180 / Math.PI;
  	
  	    const dLng = toRadians(lng2 - lng1);
  	    const y = Math.sin(dLng) * Math.cos(toRadians(lat2));
  	    const x = Math.cos(toRadians(lat1)) * Math.sin(toRadians(lat2)) - Math.sin(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.cos(dLng);
  	    const bearing = toDegrees(Math.atan2(y, x));
  	    return (bearing + 360) % 360;
  	  }
  	
  	  // Add custom markers to the map
  	pointMarkers.forEach((marker, index) => {
  	  let icon;
  	  let markerOptions = {
  	    position: { lat: marker.lat, lng: marker.lng },
  	    map: mapInstance,
  	    draggable: false,
  	  };
  	
  	  // Check for Icon property and use it if available
  	  if (marker.Icon) {
  	    icon = {
  	      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(marker.Icon)}`,
  	      anchor: new google.maps.Point(25, 25),
  	      scaledSize: new google.maps.Size(50, 50) // Adjust size as needed
  	    };
  	
  	    // Set a high zIndex to ensure it sits on top of other markers
  	    markerOptions.zIndex = google.maps.Marker.MAX_ZINDEX + 1;
  	  } else {
  	    let iconColor = marker.color || pointColor || '#FF0000';
  	
  	    if (marker.Speed === 0) {
  	      icon = {
  	        path: google.maps.SymbolPath.CIRCLE,
  	        fillColor: iconColor,
  	        fillOpacity: 1,
  	        strokeColor: 'black',
  	        strokeWeight: 2,
  	        scale: marker.scale || pointScale || 8
  	      };
  	
  	      if (index === pointMarkers.length - 1 && vehicleId) {
  	        const crosshairSvg = `
  	        <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
  	        <circle cx="12" cy="12" r="10"></circle>
  	        <line x1="12" y1="2" x2="12" y2="6"></line>
  	        <line x1="12" y1="18" x2="12" y2="22"></line>
  	        <line x1="2" y1="12" x2="6" y2="12"></line>
  	        <line x1="18" y1="12" x2="22" y2="12"></line>
  	        </svg>
  	        `;
  	
  	        icon = {
  	          url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(crosshairSvg)}`,
  	          anchor: new google.maps.Point(25, 25),
  	          scaledSize: new google.maps.Size(50, 50)
  	        };
  	      }
  	
  	    } else {
  	      let heading = marker.Direction !== undefined ? marker.Direction : 0;
  	      if (marker.Direction === undefined && index < pointMarkers.length - 1) {
  	        const nextMarker = pointMarkers[index + 1];
  	        heading = calculateHeading(marker.lat, marker.lng, nextMarker.lng, nextMarker.lat);
  	      }
  	
  	      heading = (heading - 90 + 360) % 360;
  	
  	      const iconPath = "M 0 0 L -1 -1 L 1 0 L -1 1 Z";
  	      if (iconColor.toLowerCase() === '#000000' || iconColor.toLowerCase() === 'black') {
  	        icon = {
  	          path: iconPath,
  	          fillColor: iconColor,
  	          fillOpacity: 1,
  	          strokeColor: 'white',
  	          strokeWeight: 3,
  	          rotation: heading,
  	          scale: marker.scale || pointScale || 8,
  	          anchor: new google.maps.Point(0, 0)
  	        };
  	      } else {
  	        icon = {
  	          path: iconPath,
  	          fillColor: iconColor,
  	          fillOpacity: 1,
  	          strokeColor: 'black',
  	          strokeWeight: 2,
  	          rotation: heading,
  	          scale: marker.scale || pointScale || 8,
  	          anchor: new google.maps.Point(0, 0)
  	        };
  	      }
  	    }
  	  }
  	
  	  // Apply the icon to the marker options
  	  markerOptions.icon = icon;
  	
  	  const pointMarker = new google.maps.Marker(markerOptions);
  	
  	  existingMarkers.push(pointMarker);
  	
  	  if (marker.Data) {
  	    const infowindow = new google.maps.InfoWindow({
  	      content: marker.Data
  	    });
  	
  	    pointMarker.addListener('click', function() {
  	      if (currentInfoWindow) {
  	        currentInfoWindow.close();
  	      }
  	      infowindow.open(mapInstance, pointMarker);
  	      currentInfoWindow = infowindow;
  	
  	      selectedMarker = pointMarker;
  	    });
  	  }
  	
  	  pointMarker.addListener('click', function() {
  	    selectedMarker = pointMarker;
  	  });
  	});
  	
  	
  	
  	  // Add Geofences
  	  if (geofences && Array.isArray(geofences)) {
  	    geofences.forEach(geofence => {
  	      if (geofence["Geo Fences"] && geofence["Geo Fences"].boundary && Array.isArray(geofence["Geo Fences"].boundary.points)) {
  	        const polygonCoords = geofence["Geo Fences"].boundary.points.map(point => ({
  	          lat: point.y,
  	          lng: point.x
  	        }));
  	
  	        const polygon = new google.maps.Polygon({
  	          paths: polygonCoords,
  	          strokeColor: geofence.Color,
  	          strokeOpacity: 0.9,
  	          strokeWeight: 4,
  	          fillColor: geofence.Color,
  	          fillOpacity: 0.25
  	        });
  	
  	        polygon.setMap(mapInstance);
  	        existingGeofences.push(polygon);
  	
  	        google.maps.event.addListener(polygon, 'click', function(event) {
  	          const infowindow = new google.maps.InfoWindow({
  	            content: createGeofencePopupContent(geofence, polygon, mapInstance, appData)
  	          });
  	
  	          infowindow.setPosition(event.latLng);
  	          infowindow.open(mapInstance);
  	          currentInfoWindow = infowindow;
  	        });
  	      }
  	    });
  	  }
  	
  	  // Add Stations
  	  if (stations && Array.isArray(stations)) {
  	    stations.forEach(station => {
  	      if (station["Geo Fence"] && station["Geo Fence"].boundary && station["Geo Fence"].boundary.points) {
  	        const stationCoords = station["Geo Fence"].boundary.points.map(point => ({
  	          lat: point.y,
  	          lng: point.x
  	        }));
  	
  	        const polygon = new google.maps.Polygon({
  	          paths: stationCoords,
  	          strokeColor: station.Color,
  	          strokeOpacity: 0.9,
  	          strokeWeight: 4,
  	          fillColor: station.Color,
  	          fillOpacity: 0.25
  	        });
  	
  	        polygon.setMap(mapInstance);
  	        existingGeofences.push(polygon);
  	
  	        // Check for station location
  	        if (station.Location && station.Location.x !== undefined && station.Location.y !== undefined) {
  	          const icon = {
  	            url: stationIconSvg,
  	            anchor: new google.maps.Point(25, 50),
  	            scaledSize: new google.maps.Size(50, 50)
  	          };
  	
  	          const stationCenter = {
  	            lat: station.Location.y,
  	            lng: station.Location.x
  	          };
  	          const stationMarker = new google.maps.Marker({
  	            position: stationCenter,
  	            map: mapInstance,
  	            icon: icon
  	          });
  	
  	          existingMarkers.push(stationMarker);
  	
  	          google.maps.event.addListener(stationMarker, 'click', function(event) {
  	            const infowindow = new google.maps.InfoWindow({
  	              content: createStationPopupContent(station)
  	            });
  	
  	            infowindow.open(mapInstance, stationMarker);
  	            currentInfoWindow = infowindow;
  	          });
  	        }
  	      }
  	    });
  	  }
  	
  	  if (pointMarkers.length > 0) {
  	    const latestMarker = pointMarkers[pointMarkers.length - 1];
  	    if (latestMarker) {
  	      mapInstance.setCenter({
  	        lat: latestMarker.lat, lng: latestMarker.lng
  	      });
  	    }
  	  }
  	
  	  // Adding Geofence Markers
  	  if (enableGeofence) {
  	    google.maps.event.addListener(mapInstance, 'click', function(event) {
  	      addGeofenceMarker(event.latLng);
  	    });
  	  }
  	
  	  function addGeofenceMarker(location) {
  	    const markerIndex = geofenceMarkers.length;
  	
  	    const icon = {
  	      path: google.maps.SymbolPath.CIRCLE,
  	      fillColor: markerIndex === geofenceMarkers.length - 1 ? '#FFFFFF' : polygonColor || '#FF0000',
  	      fillOpacity: 1,
  	      strokeColor: 'black',
  	      strokeWeight: 2,
  	      scale: 8
  	    };
  	
  	    const marker = new google.maps.Marker({
  	      position: location,
  	      map: mapInstance,
  	      icon: icon,
  	      draggable: true
  	    });
  	
  	    geofenceMarkers.push(marker);
  	
  	    marker.addListener('dragend', updateGeofencePolygon);
  	    marker.addListener('click', function() {
  	      marker.setMap(null);
  	      const markerIndex = geofenceMarkers.indexOf(marker);
  	      if (markerIndex !== -1) {
  	        geofenceMarkers.splice(markerIndex, 1);
  	        updateGeofencePolygon();
  	      }
  	    });
  	
  	    if (geofenceMarkers.length > 2) {
  	      const firstMarker = geofenceMarkers[0];
  	      if (location.equals(firstMarker.getPosition())) {
  	        createGeofencePolygon();
  	      }
  	    }
  	
  	    updateGeofencePolygon();
  	  }
  	
  	  function updateGeofencePolygon() {
  	    const path = geofenceMarkers.map(marker => marker.getPosition());
  	
  	    if (geofencePolygon) {
  	      geofencePolygon.setPath(path);
  	    } else {
  	      geofencePolygon = new google.maps.Polygon({
  	        paths: path,
  	        strokeColor: polygonColor || '#FF0000',
  	        strokeOpacity: 0.8,
  	        strokeWeight: 2,
  	        fillColor: polygonColor || '#FF0000',
  	        fillOpacity: 0.35
  	      });
  	
  	      geofencePolygon.setMap(mapInstance);
  	    }
  	
  	    // Save the created polygon to App Data, overriding the existing value
  	    appData.geofencePolygons = {
  	      path: path.map(latLng => ({
  	        lat: latLng.lat(), lng: latLng.lng()
  	      })),
  	      color: polygonColor || '#FF0000'
  	    };
  	  }
  	
  	  function createGeofencePolygon() {
  	    const path = geofenceMarkers.map(marker => marker.getPosition());
  	
  	    if (geofencePolygon) {
  	      geofencePolygon.setPath(path);
  	    } else {
  	      geofencePolygon = new google.maps.Polygon({
  	        paths: path,
  	        strokeColor: polygonColor || '#FF0000',
  	        strokeOpacity: 0.8,
  	        strokeWeight: 2,
  	        fillColor: polygonColor || '#FF0000',
  	        fillOpacity: 0.35
  	      });
  	
  	      geofencePolygon.setMap(mapInstance);
  	    }
  	  }
  	
  	  function createGeofencePopupContent(geofence, polygon, mapInstance, appData) {
  	    const geofences = appData.User.Company.Locations;
  	
  	    const content = document.createElement('div');
  	    content.style.padding = '10px';
  	    content.style.fontFamily = 'Arial, sans-serif';
  	    content.style.color = 'white';
  	
  	    const headerDiv = document.createElement('div');
  	    headerDiv.style.display = 'flex';
  	    headerDiv.style.justifyContent = 'space-between';
  	    headerDiv.style.alignItems = 'center';
  	
  	    const title = document.createElement('h3');
  	    title.style.margin = '0';
  	    title.textContent = geofence.Name;
  	
  	    const iconDiv = document.createElement('div');
  	    iconDiv.style.display = 'flex';
  	    iconDiv.style.gap = '10px';
  	
  	    // Edit Icon
  	    const editIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  	    editIcon.setAttribute('width', '24');
  	    editIcon.setAttribute('height', '24');
  	    editIcon.setAttribute('viewBox', '0 0 24 24');
  	    editIcon.setAttribute('fill', 'none');
  	    editIcon.setAttribute('stroke', 'white');
  	    editIcon.setAttribute('stroke-width', '2');
  	    editIcon.setAttribute('stroke-linecap', 'round');
  	    editIcon.setAttribute('stroke-linejoin', 'round');
  	    editIcon.style.cursor = 'pointer';
  	
  	    const editPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  	    editPath.setAttribute('d', 'M12 20h9');
  	    editIcon.appendChild(editPath);
  	
  	    const editPath2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  	    editPath2.setAttribute('d', 'M16.5 3.5a2.121 2.121 0 010 3l-10 10-4 1 1-4 10-10a2.121 2.121 0 013 0z');
  	    editIcon.appendChild(editPath2);
  	
  	    // Delete Icon
  	    const deleteIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  	    deleteIcon.setAttribute('width', '24');
  	    deleteIcon.setAttribute('height', '24');
  	    deleteIcon.setAttribute('viewBox', '0 0 24 24');
  	    deleteIcon.setAttribute('fill', 'none');
  	    deleteIcon.setAttribute('stroke', 'white');
  	    deleteIcon.setAttribute('stroke-width', '2');
  	    deleteIcon.setAttribute('stroke-linecap', 'round');
  	    deleteIcon.setAttribute('stroke-linejoin', 'round');
  	    deleteIcon.style.cursor = 'pointer';
  	
  	    const polyline = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
  	    polyline.setAttribute('points', '3 6 5 6 21 6');
  	    deleteIcon.appendChild(polyline);
  	
  	    const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  	    path1.setAttribute('d', 'M19 6L17.707 18H6.293L5 6');
  	    deleteIcon.appendChild(path1);
  	
  	    // Add Icons to iconDiv
  	    iconDiv.appendChild(editIcon);
  	    iconDiv.appendChild(deleteIcon);
  	
  	    headerDiv.appendChild(title);
  	    headerDiv.appendChild(iconDiv);
  	
  	    content.appendChild(headerDiv);
  	
  	    const address = document.createElement('p');
  	    address.innerHTML = `<strong>Address:</strong> ${geofence.Address}`;
  	    content.appendChild(address);
  	
  	    const contactName = document.createElement('p');
  	    contactName.innerHTML = `<strong>Contact Name:</strong> ${geofence.Contact_Name}`;
  	    content.appendChild(contactName);
  	
  	    const phone = document.createElement('p');
  	    phone.innerHTML = `<strong>Phone:</strong> ${geofence.Phone}`;
  	    content.appendChild(phone);
  	
  	    const infowindow = new google.maps.InfoWindow({
  	      content: content,
  	      disableAutoPan: true
  	    });
  	
  	    // Add event listener to the polygon to handle the click
  	    polygon.addListener('click', function(event) {
  	      infowindow.setPosition(event.latLng);
  	      infowindow.open(mapInstance);
  	      currentInfoWindow = infowindow;
  	    });
  	
  	    editIcon.addEventListener('click',
  	      async function () {
  	        const isEditable = polygon.getEditable();
  	        polygon.setEditable(!isEditable);
  	
  	        if (!isEditable) {
  	          editIcon.innerHTML = ''; // Switch to save icon
  	          const checkPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  	          checkPath.setAttribute('d', 'M20 6L9 17l-5-5');
  	          editIcon.appendChild(checkPath);
  	        } else {
  	          const newPath = polygon.getPath().getArray().map(latLng => [latLng.lng(), latLng.lat()]);
  	
  	          const updatedGeofence = geofences.find(loc => loc.objectId === geofence.objectId);
  	
  	          updatedGeofence["Geo Fences"] = {
  	            type: "Polygon",
  	            coordinates: [newPath],
  	            srs: {
  	              srsId: 4326,
  	              name: 'WGS 84'
  	            },
  	            holes: [] // Add holes if applicable or leave as an empty array
  	          };
  	
  	          const sanitizedGeofence = JSON.parse(JSON.stringify(updatedGeofence, (key, value) => {
  	            if (typeof value === 'function' || value instanceof Element) {
  	              return undefined;
  	            }
  	            return value;
  	          }));
  	
  	          const result = await Backendless.Data.of('Locations').save(sanitizedGeofence, true);
  	
  	          const index = geofences.findIndex(loc => loc.objectId === geofence.objectId);
  	          if (index !== -1) {
  	            geofences[index] = result;
  	          }
  	
  	          editIcon.innerHTML = '';
  	          editIcon.appendChild(editPath);
  	          editIcon.appendChild(editPath2);
  	        }
  	      });
  	
  	    // Handling Delete Icon Click
  	    deleteIcon.addEventListener('click',
  	      async function() {
  	        const confirmation = confirm(`Are you sure you want to delete the location: ${geofence.Name}?`);
  	        if (confirmation) {
  	          await Backendless.Data.of('Locations').remove(geofence.objectId);
  	
  	          appData.User.Company.Locations = await asyncListFilter(geofences, async (item) => {
  	            return (geofence.objectId !== item.objectId);
  	          });
  	
  	          polygon.setMap(null);
  	          infowindow.close();
  	        }
  	      });
  	
  	    return content;
  	  }
  	
  	  // Supporting Functions
  	
  	  async function asyncListFilter(sourceList,
  	    callback) {
  	    const list = await Promise.all(sourceList.map(async source => ({
  	      source,
  	      value: await callback(source),
  	    })));
  	
  	    const resultList = list.filter(item => item.value);
  	
  	    return resultList.map(item => item.source);
  	  }
  	}
  	
  	// Helper function to create popup content for stations
  	function createStationPopupContent(station) {
  	  return `
  	  <div style="padding: 10px; font-family: Arial, sans-serif; color: white;">
  	  <table>
  	  <tr><td><strong>Station Name:</strong></td><td>${station.Station_Name}</td></tr>
  	  <tr><td><strong>Brand:</strong></td><td>${station.Brand}</td></tr>
  	  <tr><td><strong>Contact Name:</strong></td><td>${station.Contact_Name}</td></tr>
  	  <tr><td><strong>Phone:</strong></td><td>${station.Contact_Number}</td></tr>
  	  <tr><td><strong>Address:</strong></td><td>${station.Province}, ${station.Town}</td></tr>
  	  <tr><td><strong>Price:</strong></td><td>${station.Price}</td></tr>
  	  <tr><td><strong>Truck Stop:</strong></td><td>${station.Truck_Stop ? 'Yes': 'No'}</td></tr>
  	  </table>
  	  <p><strong>Services:</strong></p>
  	  <ul>
  	  ${(Array.isArray(station.Services) ? station.Services: []).map(service => `<li>${service}</li>`).join('')}
  	  </ul>
  	  </div>
  	  `;
  	}
  	
  	try {
  	  const googleMapComponent = arguments[0];
  	  const polylineColor = arguments[1];
  	  const markers = arguments[2];
  	  const strokeOpacity = arguments[3];
  	  const strokeWeight = arguments[4];
  	  const pointMarkers = arguments[5];
  	  const pointColor = arguments[6];
  	  const pointScale = arguments[7];
  	  const vehicleId = arguments[8];
  	  const geofences = arguments[9];
  	  const stations = arguments[10];
  	  const stationIconSvg = arguments[11];
  	  const enableGeofence = arguments[12];
  	  const polygonColor = arguments[13];
  	  const appData = arguments[14];
  	  addPolylineAndCustomMarkers(
  	    googleMapComponent,
  	    polylineColor,
  	    markers,
  	    strokeOpacity,
  	    strokeWeight,
  	    pointMarkers,
  	    pointColor,
  	    pointScale,
  	    vehicleId,
  	    geofences,
  	    stations,
  	    stationIconSvg,
  	    enableGeofence,
  	    polygonColor,
  	    appData// Pass the FuelLossSvg as the last argument
  	  );
  	} catch (error) {
  	  // No error handling
  	}
  })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ecf24f5838fdd0b26cecd573c5c2e6c9')), '#FFFFFF', (getObjectProperty(Route, 'Polyline')), 1, 7, null, null, null, null, null, null, null, null, null, null);
  ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Billing Route'] = Billing_Route;
  ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Route'] = Route;
  ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Dead Leg'] = (getObjectProperty(Start_Leg, 'Distance'));
  ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Loaded Leg'] = (getObjectProperty(Loaded_Leg, 'Distance'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('397cc61daa269e6aeaee6ff2d5364dcd', true);
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('83d5b29d01583bf8c39eb277734e949a')));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c51eb91741c7599e2dfd5ca19eeb4a69'))['value'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Ref'));
  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload'))))) {
      Rate_Per_Unit = null;
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))))) {
        Rate_Per_Unit = null;
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route'))))) {
          Rate_Per_Unit = null;
        } else {
          Rate_Per_Unit = Math.round(((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route')), 'Distance')) / 1000) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload'))) * 100) / 100;
        }
      }
    }

  } catch (error) {

  }
  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))))) {
      Rate_Per_Km = null;
    } else {
      Rate_Per_Km = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'));
    }

  } catch (error) {

  }
  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))))) {
      Load_Value = null;
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route'))))) {
        Load_Value = null;
      } else {
        Load_Value = Math.round(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route')), 'Distance')) / 1000) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km')) * 100) / 100;
      }
    }

  } catch (error) {

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = Rate_Per_Km;

  } catch (error) {

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2'))['value'] = Load_Value;

  } catch (error) {

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = Rate_Per_Unit;

  } catch (error) {

  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Transferred Order')), 'Rig Select'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8b0751df4ceaba4475b9dcfd53a1d4d7', true);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Start')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Delivery')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Customer'))))) {
    Viewer = false;
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(1)' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(2)') {
      Viewer = true;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(3)' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(4)') {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Return'))))) {
        Viewer = false;
      } else {
        Viewer = true;
      }
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/ecf24f5838fdd0b26cecd573c5c2e6c9/bundle.js', [], () => ({
  /* content */
  /* handler:onPointsAssignment */
  async ['onPointsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Planner - Markers')))) ? [] : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Planner - Markers')))

  },
  /* handler:onPointsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/f2d16fe6a3be499586bb7fdc4543df79/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Customer')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      console.log(___arguments.value);
  console.log('1');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e322a9ca88f8cc21a789b4eaf4862cc7', true);
  console.log('2');
  delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Route'];
  console.log('3');
  console.log('4');
  await new Promise(r => setTimeout(r, 500 || 0));
  console.log('5');

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/b00978c234091f93502f72fc23f34b9c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route'))))) {
    Content = '-';
  } else {
    Content = String((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Distance')) / 1000) + String(' km');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/170dab069a0e87796e9c4c2cb6039dce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route'))))) {
    Content = '-';
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed'))))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration'))))) {
        Content = '-';
      } else {
        Content = Math.round(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / 60);
      }
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration'))))) {
        Content = '-';
      } else {
        Content = [Math.floor(Math.round((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120)) / 60) / 60) < 10 ? String('0') + String(Math.floor(Math.round((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120)) / 60) / 60)) : Math.floor(Math.round((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120)) / 60) / 60),'hh : ',Math.ceil((Math.round((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120)) / 60) / 60 - Math.floor(Math.round((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120)) / 60) / 60)) * 60) < 10 ? String('0') + String(Math.ceil((Math.round((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120)) / 60) / 60 - Math.floor(Math.round((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120)) / 60) / 60)) * 60)) : Math.ceil((Math.round((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120)) / 60) / 60 - Math.floor(Math.round((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Duration')) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load Duration'))))) + (Number(((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))) ? '0' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Offload Duration')))))) / ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed')) / 120)) / 60) / 60)) * 60),'mm'].join('');
      }
    }
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/b1ab76f29f18941905fcc838ce857fb9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7c844bedb74f9916e6928cd1a10ace5f');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/4b1cccf17476c13b43ad10d99d8fb755/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  async ['onPlaceholderAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route'))))) {
    Content = null;
  } else {
    Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Distance')) / 1000;
  }

  return Content

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Mileage, Load_Value, Units, Rate_Per_Km, Rate_Per_Unit;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2'))['value'] = null;
  Load_Value = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value'));
  Rate_Per_Km = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value'));
  Rate_Per_Unit = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value'));
  Mileage = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.value)) ? (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder')) : ___arguments.value;
  Units = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Rate_Per_Km * Mileage)));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3'](((Rate_Per_Km * Mileage) / Units)));
  if ((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Load_Value / Mileage))) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba(255, 0, 0, 0.8)';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba(100, 100, 100, 0.5)';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/8b9a9cdf470fd7766e140edd727775de/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, list, Load_Value, Mileage, Product, Product__Selected_, Rate_Per_Km, Rate_Per_Unit, Units, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something2() {
  Load_Value = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value'));
  Rate_Per_Km = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value'));
  Rate_Per_Unit = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value'));
  Mileage = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value'));
  Units = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['placeholder'] = (Load_Value / Mileage);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['placeholder'] = (Load_Value / Units);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = null;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Product__Selected_ = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products')), async (item) => {


   return ((getObjectProperty(item, 'Product')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('4e6d0de6d6e12919048c9901804c1cd9')));
  }))[0];
  console.log(Product__Selected_);
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  try {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2'))['value'] = null;

  } catch (error) {
    console.log(error);

  }
  Load_Value = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value'));
  Rate_Per_Km = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value'));
  Rate_Per_Unit = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value'));
  Mileage = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value'));
  Units = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.value)) ? (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'placeholder')) : ___arguments.value;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Load_Value / Units)));
  if ((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Load_Value / Mileage))) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba(255, 0, 0, 0.8)';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba(100, 100, 100, 0.5)';
  }

  },
  /* handler:onChange */
  /* handler:onPlaceholderAssignment */
  async ['onPlaceholderAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload'))))) {
    Content = null;
  } else {
    Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload'));
  }

  return Content

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var item, Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b9f9523fe84ee598f7862a8e9a83b3c3')).length == 0) {
    Value = 0;
  } else {
    Value = (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;});
  }

  return Value

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/c24b02f58ea9319a54b7187fa795f487/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  async ['onPlaceholderAssignment'](___arguments) {
    var Content, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload'))))) {
    Content = null;
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))))) {
      Content = null;
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route'))))) {
        Content = null;
      } else {
        Content = Math.round(((Math.round(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route')), 'Distance')) / 1000) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km')) * 100) / 100) / ((await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;}) / 1000)) * 100) / 100;
      }
    }
  }

  return Content

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Mileage, Load_Value, Units, Rate_Per_Unit, Rate_Per_Km;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2'))['value'] = null;
  Load_Value = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value'));
  Rate_Per_Km = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value'));
  Rate_Per_Unit = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.value)) ? (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder')) : ___arguments.value;
  Mileage = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'value'));
  Units = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3'](((Rate_Per_Unit * (Units / 1000)) / Mileage)));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Rate_Per_Unit * (Units / 1000))));
  if ((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Load_Value / Mileage))) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba (255, 0, 0, 0.8)';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba(100, 100, 100, 0.5)';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/f38cc5c9d03ac407dcb285c5f8cec9da/bundle.js', [], () => ({
  /* content */
  /* handler:onPlaceholderAssignment */
  async ['onPlaceholderAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))))) {
    Content = null;
  } else {
    Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'));
  }

  return Content

  },
  /* handler:onPlaceholderAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Mileage, Load_Value, Units, Rate_Per_Km, Rate_Per_Unit, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2'))['value'] = null;
  Load_Value = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'value'));
  Rate_Per_Km = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.value)) ? (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder')) : ___arguments.value;
  Rate_Per_Unit = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value'));
  Mileage = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'value'));
  Units = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;}) / 1000))) ? 0 : (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;}) / 1000;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Rate_Per_Km * Mileage)));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3'](((Rate_Per_Km * Mileage) / Units)));
  if ((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Load_Value / Mileage))) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba (255, 0, 0, 0.8)';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba(100, 100, 100, 0.5)';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/793178d98ab737baa9abac4267f6add2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Mileage, Load_Value, Units, Rate_Per_Unit, Rate_Per_Km, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value'))))) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder'))))) {
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((___arguments.value / (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'placeholder')))));
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value'))))) {
        ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((___arguments.value / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')))));
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((___arguments.value / (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value')))));
      }
    }
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = (___arguments.value / (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4b1cccf17476c13b43ad10d99d8fb755')), 'value')));
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value'))))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((___arguments.value / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')))));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((___arguments.value / (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b9a9cdf470fd7766e140edd727775de')), 'value')))));
    }
  }
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = null;
  Load_Value = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.value)) ? (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2')), 'placeholder')) : ___arguments.value;
  Rate_Per_Km = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da')), 'value'));
  Rate_Per_Unit = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487')), 'value'));
  Mileage = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'value')))) ? ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'placeholder')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'placeholder'))) : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a32e2b289ee5bf7257873e7a1efec907')), 'value'));
  Units = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;}) / 1000))) ? 0 : (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;}) / 1000;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Load_Value / Mileage)));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = (await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Load_Value / Units)));
  if ((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Load_Value / Mileage))) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba (255, 0, 0, 0.8)';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a9fd41eaa5e8cbd930cffcfb77be20fe'))['backgroundColor'] = 'rgba(100, 100, 100, 0.5)';
  }

  },
  /* handler:onChange */
  /* handler:onPlaceholderAssignment */
  async ['onPlaceholderAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))))) {
    Content = null;
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route'))))) {
      Content = null;
    } else {
      Content = Math.round(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route')), 'Distance')) / 1000) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km')) * 100) / 100;
    }
  }

  return Content

  },
  /* handler:onPlaceholderAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/87e71a09d57a8136b39f799de8ae7f1a/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'Load_Type')) == 'Service' ? ({ [`backgroundColor`]: 'rgba(255, 255, 0, 0.25)' }) : ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Loaded' ? ({ [`backgroundColor`]: 'rgba(255, 0, 0, 0.25)' }) : ((getObjectProperty(___arguments.context.dataModel, 'Status')) == 'Depot' ? ({ [`backgroundColor`]: 'rgba(0, 0, 255, 0.25)' }) : ({ [`backgroundColor`]: 'rgb(0, 0, 0)' }))))

  },
  /* handler:onStyleAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('0b075fa4a8c36ad9b91b0f94a7527d45', (getObjectProperty(___arguments.context.dataModel, 'LDPID')));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/FIFOFFICE/components/d0c24cea931ac6d606a94e3a8d55616a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/2c422ad8ca445c067e789945fd4649e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Date_Planned_Loading')))).toDateString())

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/b5473a4d815c49e618e46584af19ce26/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/0b075fa4a8c36ad9b91b0f94a7527d45/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Route, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['Rerouted'] = true;
  Route = (await BackendlessUI.Functions.Custom['fn_b91213ddd54e86f99f851edb9dc3c82a']((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b5473a4d815c49e618e46584af19ce26')), 'value')));
  }))[0]), 'Point')), (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0b075fa4a8c36ad9b91b0f94a7527d45')), 'value')));
  }))[0]), 'Point')), [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b5473a4d815c49e618e46584af19ce26')), 'value')));
  }))[0]), 'Point'))], null, null, null, null, null, null, null, true));
  ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['Planned_Load_Value'] = (((getObjectProperty(Route, 'Distance')) / 1000) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Planned Rate Per Km')));
  ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['Planned_Load_Value'] = (((getObjectProperty(Route, 'Distance')) / 1000) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Planned Rate Per Km')));
  ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['Planned Rate Per Unit'] = ((((getObjectProperty(Route, 'Distance')) / 1000) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Planned Rate Per Km'))) / (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Load_Product_JSON')), 'Planned')).map(async item => {; return (getObjectProperty(item, 'Units'));}))).reduce(function(x, y) {return x + y;}));
  ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['Planned Mileage'] = ((getObjectProperty(Route, 'Distance')) / 1000);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/a009b6edcf3da17d812b4964164b8596/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Transaction, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'));
  if ('edit' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a009b6edcf3da17d812b4964164b8596')), 'icon'))) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0b075fa4a8c36ad9b91b0f94a7527d45'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7a3d4cd6cd8dd56b3a38abec6a425ee9'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d0c24cea931ac6d606a94e3a8d55616a'))['disabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b8cf711e16a3a39de9ec1629b26cfcc1'))['display'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('43786d5dcd18a798b09cd38232f80acd'))['display'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a009b6edcf3da17d812b4964164b8596'))['icon'] = 'check';
  } else {
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['LDPID'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0b075fa4a8c36ad9b91b0f94a7527d45')), 'value'));
    ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['DP_NAME'] = (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0b075fa4a8c36ad9b91b0f94a7527d45')), 'value')));
    }))[0]), 'Name'));
    ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['Customer Name'] = (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d0c24cea931ac6d606a94e3a8d55616a')), 'value')));
    }))[0]), 'Customer'));
    await ( async () => {
      const _uow = Transaction;

      _uow.upsert('Loads', ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'));
      _uow.setRelation('Loads', ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Location_Delivery_Point', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0b075fa4a8c36ad9b91b0f94a7527d45')), 'value'))]);
      _uow.setRelation('Loads', ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Customer', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d0c24cea931ac6d606a94e3a8d55616a')), 'value'))]);

    })();

    console.log((await Transaction.execute()));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0b075fa4a8c36ad9b91b0f94a7527d45'))['disabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7a3d4cd6cd8dd56b3a38abec6a425ee9'))['disabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b8cf711e16a3a39de9ec1629b26cfcc1'))['display'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('43786d5dcd18a798b09cd38232f80acd'))['display'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a009b6edcf3da17d812b4964164b8596'))['icon'] = 'edit';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/7a3d4cd6cd8dd56b3a38abec6a425ee9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['Planned Load Value'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Planned Mileage')) * ___arguments.value);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/28c7c5c42a02a1938d76a09caf08b319/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'DELETE') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('27f47492a5a39b264b8c95ce5a744f0f', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('27f47492a5a39b264b8c95ce5a744f0f', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/b8cf711e16a3a39de9ec1629b26cfcc1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Status')) == 'Loaded') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('74e3173ac4597894b2bc3012ce47e98f');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Status')) == 'Planned') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('e319ea6acf9a6477338b64b409e3b82c');
  }

  },
  /* handler:onClick */
  /* handler:onIconAssignment */
  ['onIconAssignment'](___arguments) {
    var Icon;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Status')) == 'Loaded') {
    Icon = 'playlist add check';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Status')) == 'Planned') {
    Icon = 'delete outline';
  }

  return Icon

  },
  /* handler:onIconAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/209c1a52519d6e9e7b1d77b1f6692b82/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('e319ea6acf9a6477338b64b409e3b82c');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/27f47492a5a39b264b8c95ce5a744f0f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Delete_Transaction, Maintenance_Item, Trailer, Tractor;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('27f47492a5a39b264b8c95ce5a744f0f', false);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Load_Type')) == 'Service') {
    Maintenance_Item = (await Backendless.Data.of('Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Service_ID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Service_ID')),'\''].join(''))).setPageSize(10)))[0];
    if ((getObjectProperty(Maintenance_Item, 'Vehicle Type')) == 'Tractor') {
      Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(Maintenance_Item, 'Tractor ID')), ));
      Tractor['Last_Service_Scheduled'] = ((getObjectProperty(Tractor, 'Last_Service_Scheduled')) - (getObjectProperty(Tractor, 'Service_Interval')));
      ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Last_Service_Scheduled'));
    } else {
      Trailer = (await Backendless.Data.of('Trailers').findById((getObjectProperty(Maintenance_Item, 'Trailer ID')), ));
      Trailer['Last_Service_Scheduled'] = ((getObjectProperty(Trailer, 'Last_Service_Scheduled')) - (getObjectProperty(Tractor, 'Service_Interval')));
    }
    Delete_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Delete_Transaction;

      if ((getObjectProperty(Maintenance_Item, 'Vehicle Type')) == 'Tractor') {
        _uow.update('Tractors', Tractor);
      } else {
        _uow.update('Trailers', Trailer);
      }
      _uow.delete('Loads', ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'));
      _uow.delete('Maintenance', Maintenance_Item);

    })();

    console.log((await Delete_Transaction.execute()));
  } else {
    Delete_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Delete_Transaction;

      _uow.delete('Loads', ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'));

    })();

    console.log((await Delete_Transaction.execute()));
  }
  removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), '');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'Status')) != 'Delivered');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  })));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('e319ea6acf9a6477338b64b409e3b82c');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/fbaf1ddcacca5443d75cc29830c2e0bd/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('14e218dc02fd2c57dcace34701b2d85b');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('14e218dc02fd2c57dcace34701b2d85b');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('f3e9c22366f902aef4819ddad8b9b81a', undefined);
  try {
    delete ___arguments.context.pageData['Admin Capture Load'];

  } catch (error) {

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/8059d0fc723c18a6b09dd354a0ce3cd3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Location;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Location = (await Backendless.Request.get(`${Backendless.appPath}/services/GoogleAPI/PlaceDetails`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'placeId': JSON.stringify((getObjectProperty(___arguments.value, 'place_id'))) }).send());
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Location, 'result')), 'geometry')), 'location')), 'lat')), (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Location, 'result')), 'geometry')), 'location')), 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', 18);
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('00a10794c3394968e50d921a03174098', [(getObjectProperty((getObjectProperty((getObjectProperty(Location, 'result')), 'geometry')), 'location'))]);
  console.log(Location);

  },
  /* handler:onChange */
  /* handler:onPlacesPredictionsAssignment */
  ['onPlacesPredictionsAssignment'](___arguments) {
      return ({ [`componentRestrictions`]: ({ [`country`]: ['za'] }) })

  },
  /* handler:onPlacesPredictionsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/1d543af3cf028fdd8705e2b7dcb3495d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/FIFOFFICE/components/f3e9c22366f902aef4819ddad8b9b81a/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  getRTSubscriptions().remove((getObjectProperty(___arguments.context.pageData, 'Loads Update Listener')));
  getRTSubscriptions().remove((getObjectProperty(___arguments.context.pageData, 'Loads Upsert Listener')));

  },
  /* handler:onClose */
  /* handler:isOpenLogic */
  async ['isOpenLogic'](___arguments) {
    var Open, item, Load_ID_Tag, Load_Counter_To_Text, Loads_Counter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Transferred Order'))))) {
    Open = false;
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Transferred Order')), 'Rig Select'))))) {
      Open = false;
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Transferred Order')), 'Rig Select'))) {
        Open = true;
        ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Load Ref Counter'] = (1 + (await Backendless.Data.of('Loads').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ownerId')),'\''].join(''))))));
        Loads_Counter = (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Load Ref Counter'));
        Load_Counter_To_Text = getValueLength(String(Loads_Counter)) == 1 ? String('000000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 2 ? String('00000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 3 ? String('0000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 4 ? String('000') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 5 ? String('00') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 6 ? String('0') + String(Loads_Counter) : (getValueLength(String(Loads_Counter)) == 7 ? String(Loads_Counter) : 'Hidden Easter Egg'))))));
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads'))))) {
          Load_ID_Tag = [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Registered_Name')).slice(0, 3),' L ',Load_Counter_To_Text].join('');
        } else {
          Load_ID_Tag = [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Loads')),' ',Load_Counter_To_Text].join('');
        }
        ;(async () => {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64c99a9b58ffea63cdef471e3503be85', true);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('318b7c7d84ce11ee39e9730176875287', false);
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30e6591fbe6ca3bad316b55f32edf195', false);

        })();
        ;(async () => {
            (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('64c99a9b58ffea63cdef471e3503be85', ({ [`Load Date`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Transferred Order')), 'Load Date')),[`Products`]: (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Transferred Order')), 'Products')).map(async item => {; return ({ [`Mass`]: (Number((getObjectProperty(item, 'Units')))) * (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')),[`Product Select`]: (getObjectProperty(item, 'Product Select')),[`Units`]: (Number((getObjectProperty(item, 'Units')))),[`Unit mass`]: (getObjectProperty((getObjectProperty(item, 'Product')), 'Mass')),[`Product`]: (getObjectProperty(item, 'Product')) });}))),[`Load Ref`]: Load_ID_Tag }));

        })();
        ;(async () => {
            (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('968b3289c278ef666606e2f7c75a8bfb', ({ [`Customer`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Transferred Order')), 'Customer')),[`Delivery`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Transferred Order')), 'Delivery Point')),[`Load`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Transferred Order')), 'Load Point')) }));

        })();
      } else {
        Open = false;
      }
    }
  }

  return Open

  },
  /* handler:isOpenLogic */
  /* content */
}))

define('./pages/FIFOFFICE/components/4e6d0de6d6e12919048c9901804c1cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'Product')),[`label`]: (getObjectProperty(item, 'Product')) });}))), 1, async (item) => {


         return (getObjectProperty(item, 'value'));
        }));
      }
    }
  }

  return ([({ [`value`]: 'Other',[`label`]: 'Other' })].concat(Options))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Product, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log(___arguments.value);
  if (___arguments.value == 'Other') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('6abff288f7d8597852116f7943c2b088');
  } else {
    Product = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products')), async (item) => {


     return ((getObjectProperty(item, 'Product')) == ___arguments.value);
    }))[0];
    ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Product'] = Product;
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6'), 'Units'))))) {
      ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Unit mass'] = (getObjectProperty(Product, 'Mass'));
      if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).length == 1) {
        ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f1179b2329bd3782ae820f91603f29e4'))['value'] = (Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')) / (getObjectProperty(Product, 'Mass'))));
        ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Units'] = (Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')) / (getObjectProperty(Product, 'Mass'))));
        ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Mass'] = ((getObjectProperty(Product, 'Mass')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6'), 'Units')));
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f1179b2329bd3782ae820f91603f29e4'))['value'] = (Math.floor(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')) - (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;})) / (getObjectProperty(Product, 'Mass'))));
        ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Units'] = (Math.floor(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')) - (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;})) / (getObjectProperty(Product, 'Mass'))));
        ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Mass'] = ((getObjectProperty(Product, 'Mass')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6'), 'Units')));
      }
    } else {
      ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Mass'] = ((getObjectProperty(Product, 'Mass')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6'), 'Units')));
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/0bebf7c60731fc54b03d64640424f93a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var PDF_Data, File_Name, Delivery_Location, Load_Location, Customer, URL2, Load_Data, item, Last_Delivery_Location;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function PDF_Generation() {
  Load_Data = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record'));
  Last_Delivery_Location = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'LLDPID')));
  }))[0];
  Load_Location = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'LLPID')));
  }))[0];
  console.log(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'));
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record'));
  Delivery_Location = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'LDPID')));
  }))[0];
  Customer = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'CID')));
  }))[0];
  File_Name = ['deliverynote','(',(getObjectProperty(Load_Data, 'ID')),')'].join('');
  URL2 = ['https://backendlessappcontent.com/FB172318-89F2-E225-FF10-9AC9657A9000/15CB006B-69A7-477E-9D2F-3B75BC06A165/files/pdf/',['deliverynote','%28',(encodeURIComponent((getObjectProperty(Load_Data, 'ID')))),'%29'].join(''),'.pdf'].join('');
  console.log(Delivery_Location);
  console.log(Load_Location);
  PDF_Data = ({ [`DATE`]: ((new Date((getObjectProperty(Load_Data, 'Date_Delivered')))).toLocaleDateString()),[`DID`]: (getObjectProperty(Load_Data, 'ID')),[`QR`]: URL2,[`CLOGO`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Logo')),[`CNAME`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Registered_Name')),[`A1`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Physical_Address')),[`A2`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Postal_Code')),[`Phone`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Phone_1')),[`Email`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Email_Admin')),[`CUSLOGO`]: (getObjectProperty(Customer, 'Customer Logo')),[`CID`]: (getObjectProperty(Customer, 'ID')),[`CUST`]: (getObjectProperty(Customer, 'Customer_Registered_Name')),[`CA1`]: (getObjectProperty(Customer, 'Address Line 1')),[`CA2`]: (getObjectProperty(Customer, 'Address Line 2')),[`CEMAIL`]: (getObjectProperty(Customer, 'Customer_Admin_Email')),[`CLAND`]: (getObjectProperty(Customer, 'Customer_Phone')),[`CMOBILE`]: (getObjectProperty(Customer, 'Contact_Phone')),[`CVAT`]: (getObjectProperty(Customer, 'Customer_Vat_Number')),[`ED1`]: 'Vehicle Registration:',[`ED2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? null : 'Trailer 1 Registration:',[`ED3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? null : 'Trailer 2 Registration:',[`ED4`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? null : 'Trailer 3 Registration:',[`ED5`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')))) ? null : 'Driver:',[`ED6`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')))) ? null : 'Driver ID#:',[`ED7`]: 'Product:',[`ED8`]: 'Mass Loaded:',[`ED9`]: 'Load Time:',[`ED10`]: 'Load Location:',[`ED11`]: 'Location Contact:',[`ED12`]: 'Location Contact Phone:',[`EV1`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')),[`EV2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Registration')),[`EV3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Registration')),[`EV4`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Registration')),[`EV5`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')))) ? null : [(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Nickname')),' ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Surname'))].join(''),[`EV6`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_ID_Number')),[`EV7`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Product')),[`EV8`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Tonnage_Loaded')),[`EV9`]: (new Date((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Date_Loaded')))),[`EV10`]: (getObjectProperty(Load_Location, 'Name')),[`EV11`]: (getObjectProperty(Load_Location, 'Contact_Name')),[`EV12`]: (getObjectProperty(Load_Location, 'Phone')),[`DD1`]: 'Vehicle Registration:',[`DD2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? null : 'Trailer 1 Registration:',[`DD3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? null : 'Trailer 2 Registration:',[`DD4`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? null : 'Trailer 3 Registration:',[`DD5`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')))) ? null : 'Driver:',[`DD6`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')))) ? null : 'Driver ID#:',[`DD7`]: 'Product:',[`DD8`]: 'Mass Delivered:',[`DD9`]: 'Delivery Time:',[`DD10`]: 'Delivery Location:',[`DD11`]: 'Location Contact:',[`DD12`]: 'Location Contact Phone:',[`DV1`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')),[`DV2`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Registration')),[`DV3`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Registration')),[`DV4`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Registration')),[`DV5`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')))) ? null : [(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Nickname')),' ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Surname'))].join(''),[`DV6`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_ID_Number')),[`DV7`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Product')),[`DV8`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Tonnage_Delivered')),[`DV9`]: (new Date((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Date_Delivered')))),[`DV10`]: (getObjectProperty(Delivery_Location, 'Name')),[`DV11`]: (getObjectProperty(Delivery_Location, 'Contact_Name')),[`DV12`]: (getObjectProperty(Delivery_Location, 'Phone')),[`LI1`]: undefined,[`LI2`]: undefined,[`LI3`]: undefined,[`DI1`]: undefined,[`DI2`]: undefined,[`DI3`]: undefined,[`DSL`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Signature Load Driver')),[`DSD`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Signature Delivery Driver')),[`LSL`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Signature Load Depot')),[`RSD`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Signature Delivery Depot')) });
  ___arguments.context.pageData['PDF Test'] = (await Backendless.Request.post(`${Backendless.appPath}/services/PDFGeneratorAPI/${'1186526'}/data-output/${File_Name}`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'data': PDF_Data }));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record'))['Delivery Noted'] = true;
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record'))['Delivery Note'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'PDF Test')), 'fileUrl'));
  await Backendless.Data.of('Loads').save((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), true);
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  await PDF_Generation();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('344e413bcfa345643b7aae6ed6426c15', false);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('344e413bcfa345643b7aae6ed6426c15', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Delivery Note'))))) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Status')) == 'Delivered') {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'CID'))))) {
        Viewer = false;
      } else {
        Viewer = true;
      }
    } else {
      Viewer = false;
    }
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/d3235b339e6e127d61b43af82adb14f9/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('8c4784111a8c65c7992b2fc432dde829');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('8c4784111a8c65c7992b2fc432dde829');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('b60663c4b5eb29e9c2dc2d7f8097446c', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/61912e7d62cd56249f5eaacc60c9a0d4/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('c46daa3a211d8887e3632556d2dd7ff8');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('c46daa3a211d8887e3632556d2dd7ff8');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['Admin Capture Load'] = true;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f3e9c22366f902aef4819ddad8b9b81a', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64c99a9b58ffea63cdef471e3503be85', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('318b7c7d84ce11ee39e9730176875287', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/b96a8582ecb3383616c5179d0f83a325/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('96d5aa1c285d30648f6103b4de798a03');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('96d5aa1c285d30648f6103b4de798a03');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('5365d977708581532eba1f2c1e4df6ed', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))))) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/bf5a2f066b83fe23bb9ef5ad17cfa95e/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('1aa9ea644fab97e59be83971d4df16c2');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('1aa9ea644fab97e59be83971d4df16c2');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('395ad40c1f2ebd1c06742226703b6e28', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/395ad40c1f2ebd1c06742226703b6e28/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
      ___arguments.context.pageData['Fleet Data (Selected Item)'] = ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd');

  },
  /* handler:onOpen */
  /* handler:onClose */
  ['onClose'](___arguments) {
      delete ___arguments.context.pageData['Fleet Data (Selected Item)'];

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/FIFOFFICE/components/5365d977708581532eba1f2c1e4df6ed/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
      ___arguments.context.pageData['Fleet Data (Selected Item)'] = ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd');

  },
  /* handler:onOpen */
  /* handler:onClose */
  ['onClose'](___arguments) {
      delete ___arguments.context.pageData['Fleet Data (Selected Item)'];

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/FIFOFFICE/components/2873a923fb3f187cad255927c462c267/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
      ___arguments.context.pageData['Fleet Data (Selected Item)'] = ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd');

  },
  /* handler:onOpen */
  /* handler:onClose */
  ['onClose'](___arguments) {
      delete ___arguments.context.pageData['Fleet Data (Selected Item)'];

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/FIFOFFICE/components/b60663c4b5eb29e9c2dc2d7f8097446c/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
      ___arguments.context.pageData['Fleet Data (Selected Item)'] = ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd');

  },
  /* handler:onOpen */
  /* handler:onClose */
  ['onClose'](___arguments) {
      delete ___arguments.context.pageData['Fleet Data (Selected Item)'];

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/FIFOFFICE/components/2bcc437cab5a1a6e06e2fcc88fae33ba/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('6d23d369c1225d2c3d2ee0d5fffaf176', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/ac7f451cd45d74f1dd3cb49db27bf22d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Delivery Note'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:pdfUrlLogic */
  ['pdfUrlLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Delivery Note'))

  },
  /* handler:pdfUrlLogic */
  /* content */
}))

define('./pages/FIFOFFICE/components/12ffcd2a0f5af80bebf447edfaf53caf/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  async ['onOpen'](___arguments) {
    var error;


  try {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('54e46ad5dd540d7d78dfc97bb49bf491', undefined);

  } catch (error) {
    console.log(error);

  }
  try {
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('f10bd64cc129f88548e7cbe1e2c695a4', undefined);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onOpen */
  /* content */
}))

define('./pages/FIFOFFICE/components/edeb83e1a80ce4f5742876fa8c0605bf/bundle.js', [], () => ({
  /* content */
  /* handler:isOpenLogic */
  async ['isOpenLogic'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'currentTracking'))))) {
    Viewer = false;
  } else {
    console.log('abc');
    Viewer = true;
  }

  return Viewer

  },
  /* handler:isOpenLogic */
  /* content */
}))

define('./pages/FIFOFFICE/components/863620f21f2b7c16616f20380861aba2/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('863620f21f2b7c16616f20380861aba2'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('863620f21f2b7c16616f20380861aba2'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('5a14f32994e6caf42a31da219928469c', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/188332f3e6750b1abf98b8b841aa75ef/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('188332f3e6750b1abf98b8b841aa75ef'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('188332f3e6750b1abf98b8b841aa75ef'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('85d5161ed299299a8631f2b2be646e4f', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/cc5af7767f4ee0f487f6dad487b70ec6/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectDelete */
  async ['onObjectDelete'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('fbe84704f143bc58201b77e88998d409');
  try {
    removeItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), ___arguments.deletedObject, 'objectId');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onObjectDelete */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onObjectCreate */
  async ['onObjectCreate'](___arguments) {
    var error, Customer_Result, Transaction, New_Customer, ID, ID_Number_Variable, ID_Start, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    ID_Number_Variable = String((Number((subsequenceFromEndLast((getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), 1, async (item) => {


     return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 3))));
    })).slice(-1)[0]), 'ID')), 3)))) + 1);

  } catch (error) {
    console.log(error);

  } finally {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](ID_Number_Variable))) {
      ID_Number_Variable = 1;
    }

  }
  try {
    ID_Start = subsequenceFirstFromEnd((getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), 1, async (item) => {


     return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 3))));
    })).slice(-1)[0]), 'ID')), 4);

  } catch (error) {
    console.log(error);

  } finally {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](ID_Start))) {
      ID_Start = String((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')).slice(0, 5)) + String(' C ');
    }

  }
  ID = String(ID_Start) + String(getValueLength(ID_Number_Variable) == 1 ? String('000') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 2 ? String('00') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 3 ? String('0') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 4 ? ID_Number_Variable : ID_Number_Variable))));
  New_Customer = ___arguments.newObject;
  New_Customer['ownerId'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId'));
  New_Customer['Name'] = (getObjectProperty(___arguments.newObject, 'Customer'));
  New_Customer['ID'] = ID;
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    _uow.upsert('Customers', New_Customer);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers', [New_Customer]);

  })();

  Customer_Result = (getObjectProperty((getObjectProperty((getObjectProperty((await Transaction.execute()), 'results')), 'upsertCustomers1')), 'result'));
  console.log(Customer_Result);
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), Customer_Result);

  } catch (error) {
    console.log(error);

  }
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('cc5af7767f4ee0f487f6dad487b70ec6');

  },
  /* handler:onObjectCreate */
  /* handler:onObjectUpdate */
  async ['onObjectUpdate'](___arguments) {
    var error, item, New_Customer, Updated_Customer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    Updated_Customer = (Object.assign(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.newObject, 'objectId')));
    }))[0]), ___arguments.newObject));

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onObjectUpdate */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('b9f8637c63ef5b32c86cfeb9ee97c0a6', undefined);
  await new Promise(r => setTimeout(r, 1000 || 0));
  ___arguments.context.pageData['Selected Location'] = ___arguments.selectedRecord;
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('34aca988f40595ba76791abfd6474c42', (getObjectProperty((getObjectProperty(___arguments.selectedRecord, 'Point')), 'y')), (getObjectProperty((getObjectProperty(___arguments.selectedRecord, 'Point')), 'x')));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/FIFOFFICE/components/a5e27ab8d29f802997a689db551fbc2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Add'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/aeefc82aed02445d3ad24a5c936b97f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7e6344e80f63fee1c27a29e135d8f3da', (removeItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products')), ___arguments.context.getComponentDataStoreByUid('0afd2daf30efd41463d4f84b0ea3da4c'), 'Product')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Edit'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/f05b94c73b1cca3dfd1a9e5efdeec0ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Edit'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/d4447d1339666adea5427303c2d4505c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products'))))) {
    (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))['Products'] = [];
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7e6344e80f63fee1c27a29e135d8f3da', (addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products')), (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product')))));
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['New Product'];
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6e6c7b4ffab7f4feaf0ec6a4e115387f'))['value'] = 0;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('626fc977a4e98e5df10dcb9ae13c8255'))['value'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9e7252e717740cc82f31260fe3719aa9'))['value'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e6344e80f63fee1c27a29e135d8f3da', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e6344e80f63fee1c27a29e135d8f3da', true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product'))))) {
    Viewer = false;
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product')), 'Product'))))) {
      Viewer = false;
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product')), 'Mass'))))) {
        Viewer = false;
      } else {
        Viewer = true;
      }
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/c46483291b3508e59064ee84fcfc4ede/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('85d5161ed299299a8631f2b2be646e4f', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/626fc977a4e98e5df10dcb9ae13c8255/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product'))))) {
    ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['New Product'] = ({ [`Product`]: ___arguments.value });
  } else {
    (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product'))['Product'] = ___arguments.value;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/85d5161ed299299a8631f2b2be646e4f/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  async ['onOpen'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    List = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      List = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products'))))) {
        List = [];
      } else {
        List = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products'));
      }
    }
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7e6344e80f63fee1c27a29e135d8f3da', (await asyncListSort(List, 1, async (item) => {


   return (getObjectProperty(item, 'Product'));
  })));

  },
  /* handler:onOpen */
  /* content */
}))

define('./pages/FIFOFFICE/components/c51eb91741c7599e2dfd5ca19eeb4a69/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      console.log(___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/6bcfe306c83bf336c5d377bd4a474c34/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? [] : (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'Status')) != 'Delivered');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Sequence'));
  }))));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/FIFOFFICE/components/05a35c369a85e4fc3136c775d0e78beb/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('c738c7870c59eb12b8e39a1bab335683');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('c738c7870c59eb12b8e39a1bab335683');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('1737c0e26f8e706cbad9f399d099912f', undefined);
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailer (Unhitch)'] = 'Trailer1';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/4d24ea755c2988676d42c73d36fc014f/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      await new Promise(r => setTimeout(r, 100 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5b89c33aa35935fcf14c2517974cad48', true);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/FIFOFFICE/components/a82a71555895d0a85b45d9f151c8f0e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('b60663c4b5eb29e9c2dc2d7f8097446c', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/8046e538a0fd7681824fb7c6576e5278/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      await new Promise(r => setTimeout(r, 100 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7a1d4ba21383765d555b14c5a027f713', true);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/FIFOFFICE/components/d9191f1cb10c03430e8cfde1e6542e2b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('2873a923fb3f187cad255927c462c267', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/207cccbb4d4d1a7be6f6bfa125959bf5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('5365d977708581532eba1f2c1e4df6ed', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/063e6166a8f451ecf5ad5416d7d691de/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      await new Promise(r => setTimeout(r, 100 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5d18abed0dbd0076da3f21ee6fd333cb', true);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/FIFOFFICE/components/82b25d28e054a2f3b05d0eceb078f14b/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      await new Promise(r => setTimeout(r, 100 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5098edb6b468e14e6c9122bd51552a07', undefined);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/FIFOFFICE/components/17a63fce61d3bf5597bf72843edf132c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('395ad40c1f2ebd1c06742226703b6e28', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/e1a210fc708f554b9eaabeaece02dbc3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Transaction_Step_1, Transaction_Step_2, Tyres, Fuel_Transaction, Tractor, Fuel, item, Fleetview_Current, ObjectId, Mileage_Differential, Axle_List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

/**
 * Describe this function...
 */
async function Fuel_Transaction2() {
  Mileage_Differential = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'));
  Tractor = (await Backendless.Data.of('Tractors').findById(ObjectId, ));
  Fuel = ({ [`Admin`]: true,[`Location_Submitted`]: undefined,[`Fuel_Consumption_Ideal`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Consumption_Ideal')),[`TObjectID`]: ObjectId,[`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost')),[`Description`]: ((new Date()).toDateString()),[`Fuel_Count`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))),[`Litres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres')),[`Mileage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')),[`Mileage_last`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Fuel_Transaction_Mileage')),[`Station_Unknown`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other')),[`Station`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other')))) ? (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('c9a8d33d1d9b9b0bb095331ba6ddee7f')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c9a8d33d1d9b9b0bb095331ba6ddee7f')))) : null,[`Wages_Contractor_Km_Rate`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Contractor_Mileage')),[`Wages_Good_Driving_Rate`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Good_Driving')),[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ownerId')) });
  Fleetview_Current = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current'));
  Fleetview_Current['Current_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  Fleetview_Current['Distance_Travelled'] = ((getObjectProperty(Fleetview_Current, 'Distance_Travelled')) + ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Fuel_Transaction_Mileage'))));
  Fleetview_Current['Fuel_Cost'] = ((getObjectProperty(Fleetview_Current, 'Fuel_Cost')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost')));
  Fleetview_Current['Fuel_Litres'] = ((Number((getObjectProperty(Fleetview_Current, 'Fuel_Litres')))) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres')));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Now'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Odometer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Fuel_Transaction_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Fuel_Counter'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))));
  (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty(item, 'objectId')));
  }))['Now'] = (new Date());
  (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty(item, 'objectId')));
  }))['Odometer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty(item, 'objectId')));
  }))['Last_Fuel_Transaction_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty(item, 'objectId')));
  }))['Fuel_Counter'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))));
  Tractor['Now'] = (new Date());
  Tractor['Odometer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  Tractor['Last_Fuel_Transaction_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  Tractor['Fuel_Counter'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))));
  Fuel_Transaction = (await Backendless.Data.of('Fuel').save( Fuel ));
  Transaction_Step_1 = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction_Step_1;

    _uow.upsert('Tractors', Tractor);
    _uow.addToRelation('Tractors', Tractor, 'Fuel', [Fuel_Transaction]);
    _uow.setRelation('Tractors', Tractor, 'Fuel_Last', [Fuel_Transaction]);
    _uow.addToRelation('Employees', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_Transactions_Fuel', [Fuel_Transaction]);
    _uow.addToRelation('Employees', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_Transactions_Fuel', [Fuel_Transaction]);
    _uow.setRelation('Fuel', Fuel_Transaction, 'Company', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')));
    _uow.setRelation('Fuel', Fuel_Transaction, 'Tractor', Tractor);
    _uow.addToRelation('Fuel', Fuel_Transaction, 'Driver', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')));
    _uow.bulkUpsert('Tyres', Tyres);

  })();

  Transaction_Step_2 = (await Transaction_Step_1.execute());
}

/**
 * Describe this function...
 */
async function Tyre_Function() {
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Axles_Data'))))) {
    Axle_List = [];
  } else {
    Axle_List = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Axles_Data'));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
  } else {
    Axle_List = (Axle_List.concat((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Axles_Data'))));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
  } else {
    Axle_List = (Axle_List.concat((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Axles_Data'))));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3'))))) {
  } else {
    Axle_List = (Axle_List.concat((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Axles_Data'))));
  }
  Tyres = (await BackendlessUI.Functions.Custom['fn_c8249d71574777eb2a08c21c7e28faee'](Axle_List, ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')))));
}

/**
 * Describe this function...
 */
async function Form_Terms() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Mileage'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station'))))) {
        try {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

        } catch (error) {

        }
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost'))))) {
          try {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

          } catch (error) {

          }
        } else {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres'))))) {
            try {
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

            } catch (error) {

            }
          } else {
            if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'))))) {
              try {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

              } catch (error) {

              }
            } else {
              if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c8fcfc52fa25fba8393a975589bf0e6')), 'display')) == true) {
                if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other'))))) {
                  try {
                    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

                  } catch (error) {

                  }
                }
              } else {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
              }
            }
          }
        }
      }
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

      } catch (error) {

      }
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4852d7ed351145bad171b1acc629153', false);

      } catch (error) {

      }
    }
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

    } catch (error) {

    }
  }
}

/**
 * Describe this function...
 */
async function Clear_Form() {
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('c9a8d33d1d9b9b0bb095331ba6ddee7f', null);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea62b7b7a6950b8e6fe481f980059575'))['value'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('72654496dd632229449b515574ee7ead'))['value'] = null;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e006439ffb574701488344546dbe8137'))['value'] = null;
  await new Promise(r => setTimeout(r, 200 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('800fe80c414539252fbae03db5de918b', false);
  await new Promise(r => setTimeout(r, 200 || 0));
  delete ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Cost'];
  delete ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Mileage'];
  delete ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Litres'];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('800fe80c414539252fbae03db5de918b', true);
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4852d7ed351145bad171b1acc629153', false);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e1a210fc708f554b9eaabeaece02dbc3'))['disabled'] = true;
  ObjectId = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'));
  await Tyre_Function();
  await Fuel_Transaction2();
  console.log((await BackendlessUI.Functions.Custom['fn_88481472e3e169797cae85c104751a08']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'))));
  await Clear_Form();
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e1a210fc708f554b9eaabeaece02dbc3'))['disabled'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4852d7ed351145bad171b1acc629153', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/a72258bd0e8e322ec511ea54048e7b02/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Tractor, Driver_TX, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Driver_Disembark() {
  Driver_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Driver_TX;

    console.log('abc');
    (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'objectId')) == (getObjectProperty(item, 'objectId')));
    }))['Driver_Warehouse_Status'] = 'In';
    _uow.update('Employees', (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'objectId')) == (getObjectProperty(item, 'objectId')));
    }))).setOpResultId('Driver Update Details');
    console.log('abc');
    _uow.deleteRelation('Employees', (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'objectId')) == (getObjectProperty(item, 'objectId')));
    })), 'Driver_Tractor', [Tractor]).setOpResultId('Employee Tractor Delete Operation');
    ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(Tractor, 'objectId')) == (getObjectProperty(item, 'objectId')));
    }))[0])['Warehouse'] = 'In';
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Warehouse'] = 'In';
    console.log('abc');
    Tractor['Warehouse'] = 'In';
    _uow.update('Tractors', Tractor).setOpResultId('Tractor Warehouse Update');
    console.log('abc');
    _uow.deleteRelation('Tractors', Tractor, 'Driver1', (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'objectId')) == (getObjectProperty(item, 'objectId')));
    }))).setOpResultId('Driver  Tractor Delete Operation');
    try {
      (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty(item, 'objectId')));
      }))['Driver1'] = null;

    } catch (error) {
      console.log(error);

    }
    console.log('abc');
    try {
      ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Driver1'] = null;

    } catch (error) {
      console.log(error);

    }

  })();

  console.log((await Driver_TX.execute()));
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a72258bd0e8e322ec511ea54048e7b02'))['disabled'] = true;
  delete ___arguments.context.getComponentDataStoreByUid('5098edb6b468e14e6c9122bd51552a07')['Mileage'];
  Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), ));
  await Driver_Disembark();
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('395ad40c1f2ebd1c06742226703b6e28', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/b6d383a8cecf3111daedc6e2c1116e5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Tractor, Driver_TX, Employee_TX, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

/**
 * Describe this function...
 */
async function Driver_Board() {
  Driver_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Driver_TX;

    ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('f947aaa106414ff718daf48ad2ea595d')));
    }))[0])['Driver_Warehouse_Status'] = 'Out';
    Employee_TX = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('f947aaa106414ff718daf48ad2ea595d')));
    }))[0];
    delete Employee_TX['Tractor'];
    _uow.update('Employees', Employee_TX).setOpResultId('Driver Update Details');
    _uow.setRelation('Employees', ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('f947aaa106414ff718daf48ad2ea595d')));
    }))[0]), 'Driver_Tractor', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'))]).setOpResultId('Employee Tractor Set Operation');
    (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')));
    }))['Warehouse'] = 'Out';
    Tractor['Warehouse'] = 'Out';
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Warehouse'] = 'Out';
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Driver1'] = Employee_TX;
    (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')));
    }))['Driver1'] = Employee_TX;
    _uow.update('Tractors', Tractor).setOpResultId('Tractor Warehouse Update');
    _uow.setRelation('Tractors', Tractor, 'Driver1', [((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('f947aaa106414ff718daf48ad2ea595d'))]).setOpResultId('Driver  Tractor Set Operation');

  })();

  console.log((await Driver_TX.execute()));
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b6d383a8cecf3111daedc6e2c1116e5d'))['disabled'] = true;
  Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), ));
  await Driver_Board();
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('5365d977708581532eba1f2c1e4df6ed', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/f947aaa106414ff718daf48ad2ea595d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees'))))) {
        Options = [];
      } else {
        Options = (await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


         return ((getObjectProperty(item, 'Employee_Details_Position')) == 'Driver' && (getObjectProperty(item, 'Driver_Warehouse_Status')) == 'In');
        })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Employee_Details_Nickname')),'  - (',(getObjectProperty(item, 'Company_ID')),')'].join('') });})));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var List_Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb')['Driver'] = ___arguments.value;
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb'), 'Odometer'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc74e843e6b696d498c194ba5b5aa1f', false);
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb'), 'Odometer')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc74e843e6b696d498c194ba5b5aa1f', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb'), 'Odometer')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc74e843e6b696d498c194ba5b5aa1f', true);
    } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb'), 'Mileage'))))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc74e843e6b696d498c194ba5b5aa1f', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc74e843e6b696d498c194ba5b5aa1f', false);
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb'), 'Odometer')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb'), 'Odometer')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb'), 'Driver'))))) {
          try {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d383a8cecf3111daedc6e2c1116e5d', false);

          } catch (error) {

          }
        } else {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d383a8cecf3111daedc6e2c1116e5d', true);
        }
      } else {
        try {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d383a8cecf3111daedc6e2c1116e5d', false);

        } catch (error) {

        }
      }
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d383a8cecf3111daedc6e2c1116e5d', false);

      } catch (error) {

      }
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/7ccd445ef12702e15a8d811e883faa8d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec59abf5a54e06ed1345d4a340677077', true);
  } else if (___arguments.value > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec59abf5a54e06ed1345d4a340677077', true);
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Mileage'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec59abf5a54e06ed1345d4a340677077', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ec59abf5a54e06ed1345d4a340677077', false);
  }
  if (___arguments.value > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a72258bd0e8e322ec511ea54048e7b02', true);
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a72258bd0e8e322ec511ea54048e7b02', false);

      } catch (error) {

      }
    }
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('a72258bd0e8e322ec511ea54048e7b02', false);

    } catch (error) {

    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/9c5d62098833038ff1167cdf678b56e9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var List_Value;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb')['Odometer'] = ___arguments.value;
  if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc74e843e6b696d498c194ba5b5aa1f', true);
  } else if (___arguments.value > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc74e843e6b696d498c194ba5b5aa1f', true);
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb'), 'Mileage'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc74e843e6b696d498c194ba5b5aa1f', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8bc74e843e6b696d498c194ba5b5aa1f', false);
  }
  if (___arguments.value > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5d18abed0dbd0076da3f21ee6fd333cb'), 'Driver'))))) {
        try {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d383a8cecf3111daedc6e2c1116e5d', false);

        } catch (error) {

        }
      } else {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d383a8cecf3111daedc6e2c1116e5d', true);
      }
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d383a8cecf3111daedc6e2c1116e5d', false);

      } catch (error) {

      }
    }
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6d383a8cecf3111daedc6e2c1116e5d', false);

    } catch (error) {

    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/c9a8d33d1d9b9b0bb095331ba6ddee7f/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))) {
        Options = [];
      } else {
        Options = (addItemToList((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Province')),'  - (',(getObjectProperty(item, 'Station_Name')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        })), ({ [`value`]: 'Other Station',[`label`]: 'Other Station' })));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Form_Terms() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Mileage'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station'))))) {
        try {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

        } catch (error) {

        }
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost'))))) {
          try {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

          } catch (error) {

          }
        } else {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres'))))) {
            try {
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

            } catch (error) {

            }
          } else {
            if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'))))) {
              try {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

              } catch (error) {

              }
            } else {
              if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c8fcfc52fa25fba8393a975589bf0e6')), 'display')) == true) {
                if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other'))))) {
                  try {
                    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

                  } catch (error) {

                  }
                } else {
                  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
                }
              } else {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
              }
            }
          }
        }
      }
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

      } catch (error) {

      }
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4852d7ed351145bad171b1acc629153', false);

      } catch (error) {

      }
    }
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

    } catch (error) {

    }
  }
}


  if (___arguments.value == 'Other Station') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c8fcfc52fa25fba8393a975589bf0e6', true);
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5c8fcfc52fa25fba8393a975589bf0e6', false);

    } catch (error) {

    }
  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4852d7ed351145bad171b1acc629153', false);

  } catch (error) {

  }
  ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Station'] = ___arguments.value;
  await Form_Terms();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/e006439ffb574701488344546dbe8137/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4852d7ed351145bad171b1acc629153', false);

  } catch (error) {

  }
  ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Mileage'] = ___arguments.value;
  if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if (___arguments.value > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Mileage'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  }
  if (___arguments.value > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station'))))) {
        try {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

        } catch (error) {

        }
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost'))))) {
          try {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

          } catch (error) {

          }
        } else {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres'))))) {
            try {
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

            } catch (error) {

            }
          } else {
            if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'))))) {
              try {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

              } catch (error) {

              }
            } else {
              if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c8fcfc52fa25fba8393a975589bf0e6')), 'display')) == true) {
                if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other'))))) {
                  try {
                    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

                  } catch (error) {

                  }
                } else {
                  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
                }
              } else {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
              }
            }
          }
        }
      }
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

      } catch (error) {

      }
    }
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

    } catch (error) {

    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/72654496dd632229449b515574ee7ead/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Station, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function roundDecimals(number, decimals) {
  const factor = Math.pow(10, decimals);
  return Math.round(number * factor) / factor;
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4852d7ed351145bad171b1acc629153', false);

  } catch (error) {

  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other'))))) {
    Station = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c9a8d33d1d9b9b0bb095331ba6ddee7f')));
    }))[0];
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ea62b7b7a6950b8e6fe481f980059575'))['value'] = (roundDecimals((___arguments.value * (getObjectProperty(Station, 'Price'))),2));
    ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Cost'] = (roundDecimals((___arguments.value * (getObjectProperty(Station, 'Price'))),2));
    ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Litres'] = ___arguments.value;
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
    } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Mileage'))))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station'))))) {
          try {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

          } catch (error) {

          }
        } else {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost'))))) {
            try {
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

            } catch (error) {

            }
          } else {
            if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres'))))) {
              try {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

              } catch (error) {

              }
            } else {
              if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'))))) {
                try {
                  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

                } catch (error) {

                }
              } else {
                if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c8fcfc52fa25fba8393a975589bf0e6')), 'display')) == true) {
                  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other'))))) {
                    try {
                      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

                    } catch (error) {

                    }
                  } else {
                    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
                  }
                } else {
                  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
                }
              }
            }
          }
        }
      } else {
        try {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

        } catch (error) {

        }
      }
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

      } catch (error) {

      }
    }
  } else {
    ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Litres'] = ___arguments.value;
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
    } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Mileage'))))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station'))))) {
          try {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

          } catch (error) {

          }
        } else {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost'))))) {
            try {
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

            } catch (error) {

            }
          } else {
            if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres'))))) {
              try {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

              } catch (error) {

              }
            } else {
              if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'))))) {
                try {
                  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

                } catch (error) {

                }
              } else {
                if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c8fcfc52fa25fba8393a975589bf0e6')), 'display')) == true) {
                  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other'))))) {
                    try {
                      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

                    } catch (error) {

                    }
                  }
                } else {
                  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
                }
              }
            }
          }
        }
      } else {
        try {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

        } catch (error) {

        }
      }
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

      } catch (error) {

      }
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/ea62b7b7a6950b8e6fe481f980059575/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4852d7ed351145bad171b1acc629153', false);

  } catch (error) {

  }
  ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Cost'] = ___arguments.value;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Mileage'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station'))))) {
        try {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

        } catch (error) {

        }
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost'))))) {
          try {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

          } catch (error) {

          }
        } else {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres'))))) {
            try {
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

            } catch (error) {

            }
          } else {
            if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'))))) {
              try {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

              } catch (error) {

              }
            } else {
              if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c8fcfc52fa25fba8393a975589bf0e6')), 'display')) == true) {
                if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other'))))) {
                  try {
                    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

                  } catch (error) {

                  }
                } else {
                  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
                }
              } else {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
              }
            }
          }
        }
      }
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

      } catch (error) {

      }
    }
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

    } catch (error) {

    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/11f3192f32f514bfec1d7301319cc547/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var Next_Load, error, Next_Load_Step_1, Transaction, Last_Load, Created_Load__Transaction_, Trailers, item, Loads;

/**
 * Describe this function...
 */
async function Last_Load_Function(Loads) {
}


  console.log(___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/1b25478b9c9c973ec4bae2053bb51565/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Customer'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/3f4a753e67d77774526f0f0ddf6d9a1b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Delivery (Units)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/1768476b2666130ce9cf65554b0d7765/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Delivery (Point)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/d3f34c0b43268ebcb18b6cff2c763833/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Delivery (Mileage)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/24c3cc71f9650437e487b2415126cf3e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Delivery (Date)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/384fc76acd1db82351e875bc257239d9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Invoice (Load Reference)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/c5bec1c6d2e7de5a799bb2a70e8567c8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Invoice (Product)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/3945cba3f8f556fcadb2626e93d92bd1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Loading (Point)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/a47a99cc64971b743af262b260d8271e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Loading (Mileage)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/34c39d75c55f95b9b2a85bb85036be08/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Loading (Date)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/c3d22f3c7bb22bee487ec33bbb215595/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('7a1d4ba21383765d555b14c5a027f713')['Loading (Units)'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/53216099bfcebd1abae17dce3de958e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b25478b9c9c973ec4bae2053bb51565'));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('384fc76acd1db82351e875bc257239d9'));
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c5bec1c6d2e7de5a799bb2a70e8567c8'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).collapse() })('72fb3673b8d68b375f2f40296684cf96');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('034aff73e9a8d4533827c9497d19af8a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('72fb3673b8d68b375f2f40296684cf96', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/37d950a1fd299f07c2dbfb3d83bd6dae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2e2e9d66be7c6886f2891b67956f025c', true);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).collapse() })('034aff73e9a8d4533827c9497d19af8a');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/61bc15fe8afd29a6515b87f32bede60a/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('61bc15fe8afd29a6515b87f32bede60a'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('61bc15fe8afd29a6515b87f32bede60a'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('d6fa4831d4b8222782da812481678bb4', undefined);
  ___arguments.context.pageData['Asset Drawer Data'] = 'Trailers';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/d8d8ab464126405ce189515e68266c4b/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8d8ab464126405ce189515e68266c4b'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d8d8ab464126405ce189515e68266c4b'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('d6fa4831d4b8222782da812481678bb4', undefined);
  ___arguments.context.pageData['Asset Drawer Data'] = 'Tyres';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/fade00ef4ac3039fb35f8cb90e3f57a6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Asset Drawer Data')) == 'Tractors') {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onObjectUpdate */
  async ['onObjectUpdate'](___arguments) {
    var item, objectId, Tractor, Updated_Data;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Updater(objectId) {
  Tractor = (await Backendless.Data.of('Tractors').findById(objectId, Backendless.DataQueryBuilder.create().setRelated(['Other', 'Trailer1.Maintenance', 'Trailer2.Maintenance', 'Trailer3.Maintenance', 'Current_Fleetview', 'Current_Fleetview.Fuel', 'Current_Fleetview.Loads', 'Company', 'Trailer1', 'Trailer2', 'Trailer3', 'Trailer1.Axles_Data.Tyre L1.Transactions', 'Trailer1.Axles_Data.Tyre L2.Transactions', 'Trailer1.Axles_Data.Tyre L3.Transactions', 'Trailer1.Axles_Data.Tyre L4.Transactions', 'Trailer1.Axles_Data.Tyre R1.Transactions', 'Trailer1.Axles_Data.Tyre R2.Transactions', 'Trailer1.Axles_Data.Tyre R3.Transactions', 'Trailer1.Axles_Data.Tyre R4.Transactions', 'Trailer2.Axles_Data.Tyre L1.Transactions', 'Trailer2.Axles_Data.Tyre L2.Transactions', 'Trailer2.Axles_Data.Tyre L3.Transactions', 'Trailer2.Axles_Data.Tyre L4.Transactions', 'Trailer2.Axles_Data.Tyre R1.Transactions', 'Trailer2.Axles_Data.Tyre R2.Transactions', 'Trailer2.Axles_Data.Tyre R3.Transactions', 'Trailer2.Axles_Data.Tyre R4.Transactions', 'Trailer3.Axles_Data.Tyre L1.Transactions', 'Trailer3.Axles_Data.Tyre L2.Transactions', 'Trailer3.Axles_Data.Tyre L3.Transactions', 'Trailer3.Axles_Data.Tyre L4.Transactions', 'Trailer3.Axles_Data.Tyre R1.Transactions', 'Trailer3.Axles_Data.Tyre R2.Transactions', 'Trailer3.Axles_Data.Tyre R3.Transactions', 'Trailer3.Axles_Data.Tyre R4.Transactions', 'Axles_Data', 'Axles_Data.Tyre L1', 'Axles_Data.Tyre L2', 'Axles_Data.Tyre L3', 'Axles_Data.Tyre L4', 'Axles_Data.Tyre R1', 'Axles_Data.Tyre R2', 'Axles_Data.Tyre R3', 'Axles_Data.Tyre R4', 'Trailer1.Axles_Data', 'Trailer2.Axles_Data', 'Trailer3.Axles_Data', 'Breakdowns', 'Driver1', 'Conductor1', 'Conductor2', 'Driver1.Wages_Current', 'Conductor1.Wages_Current', 'Conductor2.Wages_Current', 'Fuel', 'Loads', 'Maintenance', 'Other', 'Tyres', 'Driver1.Wages_Current.Fuel', 'Driver1.Wages_Current.Loads'])));
  Updated_Data = (await BackendlessUI.Functions.Custom['fn_88481472e3e169797cae85c104751a08']((getObjectProperty(Tractor, 'objectId')), Tractor));
  console.log(Updated_Data);
  ((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(Tractor, 'objectId')));
  }))[0])['Current_Fleetview'] = (getObjectProperty(Updated_Data, 'Fleetview'));
  ((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(Tractor, 'objectId')));
  }))[0])['Current_Fleetview'] = (getObjectProperty(Updated_Data, 'Fleetview'));
  ((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(Tractor, 'objectId')));
  }))[0])['Fleetview_Current'] = (getObjectProperty(Updated_Data, 'Fleetview'));
  Object.assign(((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(Tractor, 'objectId')));
  }))[0]), (getObjectProperty(Updated_Data, 'Tractor')));
}


  await Updater((getObjectProperty(___arguments.newObject, 'objectId')));

  },
  /* handler:onObjectUpdate */
  /* content */
}))

define('./pages/FIFOFFICE/components/fddd48f147591336f036f652e48e5c5b/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Status = \'All In Order\' AND Warehouse = \'Out\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    var item, j, Vehicle;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.selectedRecord, 'Tractor_ObjectId'))))) {
    Vehicle = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return ((getObjectProperty(___arguments.selectedRecord, 'Trailer_ObjectId')) == (getObjectProperty(item, 'objectId')));
    }))[0];
  } else {
    Vehicle = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(___arguments.selectedRecord, 'Tractor_ObjectId')) == (getObjectProperty(item, 'objectId')));
    }))[0];
  }
  ___arguments.context.pageData['Assets Drawer - Selected Tyre Vehicle'] = Vehicle;
  ___arguments.context.pageData['Assets Drawer - Selected Tyre objectId'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));
  await new Promise(r => setTimeout(r, 1000 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('0d79046be1317947dd77a45864f33585', undefined);

  },
  /* handler:onRecordSelect */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Road')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/d007637a200c7a7b00e7a7f8effa9352/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Asset Drawer Data')) == 'Trailers') {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/123e913ad49ef847d58b813578987293/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Viewer;


  delete ___arguments.context.pageData['Asset Drawer Data'];
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('d6fa4831d4b8222782da812481678bb4', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/f45ceee83cb71f76dac6684e57e89779/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service_Status')) == 'Service Due' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Service_Status')) == 'Service Due' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Service_Status')) == 'Service Due' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Service_Status')) == 'Service Due') {
      await new Promise(r => setTimeout(r, 100 || 0));
      if (1 <= (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')), async (item) => {


       return ((getObjectProperty(item, 'Load_Type')) == 'Service');
      })).length) {
        Viewer = false;
      } else {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Unscheduled Services')) == true) {
          if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? true : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Unscheduled Services'))) == true) {
            if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? true : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Unscheduled Services'))) == true) {
              if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? true : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Unscheduled Services'))) == true) {
                Viewer = false;
              } else {
                Viewer = false;
              }
            } else {
              Viewer = true;
            }
          } else {
            Viewer = true;
          }
        } else {
          Viewer = true;
        }
      }
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Service Schedule')) == true) {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Service Schedule'];
  } else {
    ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Service Schedule'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/626126ee345973bebff79412d554483d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Service Schedule')) == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/0e0e41ad2c9fd751a88e531855ba39bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Result, Transaction, Created_Load, Create_Service, Trailer, Trailers, Service, Load_Variable, Service_ID, Trailer_Position, Tractor, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Trailer_Service_Function(Trailer, Trailer_Position) {
  Load_Variable = ({ [`Service_ID`]: Service_ID,[`Delivery (Client)`]: undefined,[`Customer Name`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('bb84aeddef21b0140a946968e896f37d')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')))),[`Date_Planned_Delivery`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')),[`Date_Planned_Loading`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')),[`Distance_Planned_LDP_To_DP`]: undefined,[`Distance_Planned_LDP_To_LP`]: undefined,[`Distance_Planned_LP_To_DP`]: undefined,[`Financial_Billing_Type`]: undefined,[`Financial_Target_Ideal_Rate_Per_Km`]: undefined,[`Financial_Target_Ideal_Rate_Per_Tonne`]: undefined,[`ID`]: 'Service',[`Load Planner Name`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name')),[`Load Point (Delivery Name)`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('bb84aeddef21b0140a946968e896f37d')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')))),[`Load Point (Load Name)`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('bb84aeddef21b0140a946968e896f37d')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')))),[`CID`]: undefined,[`LLPID`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')),[`LDPID`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')),[`LLDPID`]: undefined,[`Load_Broker`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')),[`Load_Notes`]: 'Service',[`Load_Product`]: 'Service',[`Load_Type`]: 'Service',[`Rig_Cost_Per_Hour`]: undefined,[`Rig_CPK`]: undefined,[`Rig_Payload`]: undefined,[`Status`]: 'Planned',[`Tonnage_Planned`]: undefined,[`Planned Rate Per Unit`]: undefined,[`Planned Mileage`]: undefined,[`Planned Load Value`]: undefined,[`Planned Rate Per Km`]: undefined,[`ownerId`]: (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')));
  }))[0],[`TID`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId (Tractor)')) });
  Service = ({ [`Service_ID`]: Service_ID,[`Vehicle Type`]: 'Trailer',[`Date_Scheduled`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')),[`Status`]: 'Scheduled',[`Supplier`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('bb84aeddef21b0140a946968e896f37d')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')))),[`Type`]: 'Service',[`Trailer ID`]: (getObjectProperty(Trailer, 'objectId')),[`ownerId`]: (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')));
  }))[0] });
  Trailer = (await Backendless.Data.of('Trailers').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId (Tractor)')), ));
  Trailer['Last_Service_Scheduled'] = (getObjectProperty(Trailer, 'Next_Service'));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), Trailer_Position))['Last_Service_ID'] = Service_ID;
  Trailer['Last_Service_ID'] = Service_ID;
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Created_Load = (_uow.create('Loads', Load_Variable));
    Create_Service = (_uow.create('Maintenance', Service));
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')));
    }))[0])))) {
    } else {
      _uow.setRelation('Loads', Created_Load, 'Load_Planner', [(getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')));
      }))[0]), 'objectId'))]);
    }
    _uow.setRelation('Loads', Created_Load, 'Location_Delivery_Point', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value'))]);
    _uow.setRelation('Loads', Created_Load, 'Location_Load_Point', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value'))]);
    _uow.setRelation('Loads', Created_Load, 'Rig_Tractor', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId (Tractor)'))]);
    Trailers = (await asyncListFilter([(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'objectId')), (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'objectId'))], async (item) => {


     return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](item)));
    }));
    _uow.setRelation('Loads', Created_Load, 'Rig_Trailers', Trailers);
    _uow.addToRelation('Trailers', (getObjectProperty(Trailer, 'objectId')), 'Maintenance', [Create_Service]);
    _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId (Tractor)')), 'Loads', [Created_Load]);

  })();

  Result = (await Transaction.execute());
  addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')));
  }))[0]), 'Loads')), (getObjectProperty((getObjectProperty((getObjectProperty(Result, 'results')), 'createLoads1')), 'result')));
  await new Promise(r => setTimeout(r, 500 || 0));
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Service Schedule'];
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? [] : (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'Status')) != 'Delivered');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  }))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('318b7c7d84ce11ee39e9730176875287', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64c99a9b58ffea63cdef471e3503be85', false);
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

/**
 * Describe this function...
 */
async function Tractor_Service_Function() {
  Service_ID = (generateUUID().long());
  Load_Variable = ({ [`Delivery (Client)`]: undefined,[`Customer Name`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('bb84aeddef21b0140a946968e896f37d')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')))),[`Date_Planned_Delivery`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')),[`Date_Planned_Loading`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')),[`Distance_Planned_LDP_To_DP`]: undefined,[`Distance_Planned_LDP_To_LP`]: undefined,[`Distance_Planned_LP_To_DP`]: undefined,[`Financial_Billing_Type`]: undefined,[`Financial_Target_Ideal_Rate_Per_Km`]: undefined,[`Financial_Target_Ideal_Rate_Per_Tonne`]: undefined,[`ID`]: 'Service',[`Load Planner Name`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name')),[`Load Point (Delivery Name)`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('bb84aeddef21b0140a946968e896f37d')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')))),[`Load Point (Load Name)`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('bb84aeddef21b0140a946968e896f37d')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')))),[`CID`]: undefined,[`LLPID`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')),[`LDPID`]: (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')),[`LLDPID`]: undefined,[`Load_Broker`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')),[`Load_Notes`]: 'Service',[`Load_Product`]: 'Service',[`Load_Type`]: 'Service',[`Rig_Cost_Per_Hour`]: undefined,[`Rig_CPK`]: undefined,[`Rig_Payload`]: undefined,[`Status`]: 'Planned',[`Tonnage_Planned`]: undefined,[`Planned Rate Per Unit`]: undefined,[`Planned Mileage`]: undefined,[`Planned Load Value`]: undefined,[`Planned Rate Per Km`]: undefined,[`ownerId`]: (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')));
  }))[0],[`TID`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId (Tractor)')),[`Service_ID`]: Service_ID });
  Service = ({ [`Vehicle Type`]: 'Tractor',[`Date_Scheduled`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')))) ? null : (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('732f58e94933631c86ecb948a187ae9b')), 'value')),[`Status`]: 'Scheduled',[`Supplier`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('bb84aeddef21b0140a946968e896f37d')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value')))),[`Type`]: 'Service',[`TractorId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),[`Service_ID`]: Service_ID,[`ownerId`]: (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')));
  }))[0] });
  Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), ));
  Tractor['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Next_Service'));
  Tractor['Last_Service_ID'] = Service_ID;
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Created_Load = (_uow.create('Loads', Load_Variable));
    Create_Service = (_uow.create('Maintenance', Service));
    try {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loadplanner_ID'))))) {
      } else {
        _uow.setRelation('Loads', Created_Load, 'Load_Planner', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loadplanner_ID'))]);
      }

    } catch (error) {
      console.log(error);

    }
    _uow.setRelation('Loads', Created_Load, 'Location_Delivery_Point', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value'))]);
    _uow.setRelation('Loads', Created_Load, 'Location_Load_Point', [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bb84aeddef21b0140a946968e896f37d')), 'value'))]);
    _uow.setRelation('Loads', Created_Load, 'Rig_Tractor', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'))]);
    _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), 'Loads', [Created_Load]);
    _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), 'Maintenance', [Create_Service]);
    _uow.update('Tractors', Tractor);

  })();

  Result = (await Transaction.execute());
  addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')));
  }))[0]), 'Loads')), (getObjectProperty((getObjectProperty((getObjectProperty(Result, 'results')), 'createLoads1')), 'result')));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Next_Service'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Service_ID'] = Service_ID;
  await new Promise(r => setTimeout(r, 500 || 0));
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Service Schedule'];
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? [] : (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'Status')) != 'Delivered');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  }))));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('318b7c7d84ce11ee39e9730176875287', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64c99a9b58ffea63cdef471e3503be85', false);
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service_Status')) == 'Service Due') {
      await Tractor_Service_Function();
    }

  } catch (error) {
    console.log(error);

  }
  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
    } else {
      if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Service_Status')) == 'Service Due') {
        await Trailer_Service_Function((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Trailer1');
      }
    }

  } catch (error) {
    console.log(error);

  }
  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
    } else {
      if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Service_Status')) == 'Service Due') {
        await Trailer_Service_Function((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Trailer2');
      }
    }

  } catch (error) {
    console.log(error);

  }
  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3'))))) {
    } else {
      if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Service_Status')) == 'Service Due') {
        await Trailer_Service_Function((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Trailer3');
      }
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/bb84aeddef21b0140a946968e896f37d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
      } else {
        List = (await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


         return ((getObjectProperty(item, 'Type')) == 'Service Centre');
        })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Name')) });})));
      }
    }
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/7b8d908ad42a1b66e3ad2293a64a5989/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Trailer, Transaction, Financial_Transaction, Create_Service, Trans, Service, Tractor, Load, Trailer_Position;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Trailer_Service_Function(Trailer, Trailer_Position) {
  Service = ({ [`CapturedBy`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name')),[`Vehicle Type`]: 'Trailer',[`Date_Scheduled`]: (new Date()),[`Date_Started`]: (new Date()),[`Date_Completed`]: (new Date()),[`Status`]: 'Completed',[`Supplier`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('06f5b14abd6aea05bcc6c64ad3f45589')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06f5b14abd6aea05bcc6c64ad3f45589')), 'value')))),[`Type`]: 'Service',[`Mileage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Odometer')),[`Mileage Due`]: (getObjectProperty(Trailer, 'Last_Service_Scheduled')),[`Notes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Comment')),[`TrailerId`]: (getObjectProperty(Trailer, 'objectId')),[`Invoice`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Invoice')),[`ownerId`]: (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')));
  }))[0] });
  Trans = ({ [`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Cost')),[`Description`]: ['Service - (',(getObjectProperty(Trailer, 'objectId')),')'].join(''),[`ownerId`]: (getObjectProperty(Trailer, 'ownerId')) });
  Trailer['Last_Service_Scheduled'] = (getObjectProperty(Trailer, 'Next_Service'));
  Trailer['Last_Service_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Odometer'));
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Create_Service = (_uow.create('Maintenance', Service));
    Financial_Transaction = (_uow.create('Transactions', Trans));
    _uow.addToRelation('Trailers', (getObjectProperty(Trailer, 'objectId')), 'Maintenance', [Create_Service]);
    _uow.addToRelation('Maintenance', Create_Service, 'Transaction', [Financial_Transaction]);

  })();

  console.log((await Transaction.execute()));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type'))))['Last_Service_Scheduled'] = (getObjectProperty(Trailer, 'Next_Service'));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type'))))['Last_Service_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Odometer'));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type'))))['Service_Status'] = 'All In Order';
}

/**
 * Describe this function...
 */
async function Tractor_Service_Function____Service_Item_(Load) {
  console.log('1');
  Trans = ({ [`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Cost')),[`Description`]: ['Service - (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId (Tractor)')),')'].join(''),[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ownerId')) });
  console.log('2');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))['CapturedBy'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name'));
  console.log('3');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))['Date_Scheduled'] = (getObjectProperty(Load, 'Date_Planned_Loading'));
  console.log('4');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))['Date_Started'] = (getObjectProperty(Load, 'Date_Loaded'));
  console.log('5');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))['Date_Completed'] = (getObjectProperty(Load, 'Date_Delivered'));
  console.log('6');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))['Status'] = 'Completed';
  console.log('7');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))['Mileage'] = (getObjectProperty(Load, 'Mileage_Load_Point'));
  console.log('8');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))['Mileage Due'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_Scheduled'));
  console.log('9');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))['Notes'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Comment'));
  console.log('1');
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))['Invoice'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Invoice'));
  console.log('2');
  Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), ));
  console.log('3');
  Tractor['Last_Service_ID'] = null;
  console.log('4');
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Service_ID'] = null;
  console.log('5');
  Tractor['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Next_Service'));
  console.log('6');
  Tractor['Last_Service_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Odometer'));
  console.log('7');
  Tractor['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Next_Service'));
  console.log('8');
  console.log(Tractor);
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  console.log('9');
  await ( async () => {
    const _uow = Transaction;

    Financial_Transaction = (_uow.create('Transactions', Trans));
    _uow.addToRelation('Maintenance', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item')), 'Transaction', [Financial_Transaction]);
    _uow.update('Tractors', Tractor);
    _uow.update('Maintenance', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item')));

  })();

  console.log((await Transaction.execute()));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Next_Service'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Service_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Odometer'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Service_Status'] = 'All In Order';
}

/**
 * Describe this function...
 */
async function Tractor_Service_Function() {
  console.log('1');
  Service = ({ [`CapturedBy`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name')),[`Vehicle Type`]: 'Tractor',[`Date_Scheduled`]: (new Date()),[`Date_Started`]: (new Date()),[`Date_Completed`]: (new Date()),[`Status`]: 'Completed',[`Supplier`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('06f5b14abd6aea05bcc6c64ad3f45589')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('06f5b14abd6aea05bcc6c64ad3f45589')), 'value')))),[`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Cost')),[`Type`]: 'Service',[`Mileage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Odometer')),[`Mileage Due`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_Scheduled')),[`Notes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Comment')),[`TractorId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),[`Images`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Invoice')),[`Invoice`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Invoice')),[`ownerId`]: (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')));
  }))[0] });
  console.log('2');
  Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), ));
  console.log('3');
  Trans = ({ [`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Cost')),[`Description`]: ['Service - (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),')'].join(''),[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ownerId')) });
  console.log('4');
  Tractor['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Next_Service'));
  console.log('5');
  Tractor['Last_Service_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Odometer'));
  console.log('6');
  Tractor['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Next_Service'));
  console.log('7');
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  console.log('8');
  await ( async () => {
    const _uow = Transaction;

    Create_Service = (_uow.create('Maintenance', Service));
    Financial_Transaction = (_uow.create('Transactions', Trans));
    _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), 'Maintenance', [Create_Service]);
    _uow.addToRelation('Maintenance', Create_Service, 'Transaction', [Financial_Transaction]);
    _uow.update('Tractors', Tractor);

  })();

  console.log('9');
  console.log((await Transaction.execute()));
  console.log('10');
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Next_Service'));
  console.log('11');
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Service_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Odometer'));
  console.log('12');
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Service_Status'] = 'All In Order';
  console.log('13');
}


  console.log('1');
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type')) == 'Tractor') {
    console.log('2');
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))))) {
      console.log('3');
      await Tractor_Service_Function();
    } else {
      console.log('4');
      await Tractor_Service_Function____Service_Item_((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


       return ((getObjectProperty(item, 'Service_ID')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_ID')));
      }))[0]);
    }
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type')) == 'Trailer1') {
    console.log('5');
    await Trailer_Service_Function((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Trailer1');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type')) == 'Trailer2') {
    console.log('6');
    await Trailer_Service_Function((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Trailer2');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type')) == 'Trailer3') {
    console.log('7');
    await Trailer_Service_Function((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Trailer3');
  }
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/48ef96f430c7d032be6ccdf44d58a10e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/5217d211b7e3b874aff5186195cc1c36/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/8a0bebc3c37233918e89c8247e02694b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/e499d3836633ec150465ef049a814831/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/e96cc43573bcce37609bde165107b32c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3'))))) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
      Viewer = false;
    } else {
      if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'FIF_Leader_Select')) == true || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'FIF_Dolly_Select')) == true) {
        Viewer = true;
      }
    }
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('3219e54f18daa02c098161bb21b7aaf3', undefined);
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailer (HItch)'] = 'Trailer3';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/0c4c49b1cb3eb50fe4770223df65ceb6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
      Viewer = false;
    } else {
      if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'FIF_Leader_Select')) == true || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'FIF_Dolly_Select')) == true) {
        Viewer = true;
      }
    }
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('3219e54f18daa02c098161bb21b7aaf3', undefined);
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailer (HItch)'] = 'Trailer2';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/4dcb755e1beeb2cbe6c38f371c71f1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('3219e54f18daa02c098161bb21b7aaf3', undefined);
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailer (HItch)'] = 'Trailer1';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/e6faa40caf032f81ae079ad6cbbda283/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Year'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Year'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/39f2280e63e1b4d52c9fd553d6bb98bf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'VIN'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'VIN'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/447b716416f29af38cead1abaf69aa1c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Engine_Number'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Engine_Number'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/69d5a4d357d9157a99e5e2cb8cb9dbdd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'));
    }

  } catch (error) {

  }

  return (String(Content) + String(' km'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/d0ce0a61b4cf801e45e550fa550f47ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Registration'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Registration'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/6b8e29fcbfd77cce233aa72ff8849851/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'ID'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'ID'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/af94c7080f11351266743708107d778c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Make'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Make'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/3d45726240d327a48b9ca72e6285f43b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Model'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Model'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/ebbf52fb35b4d8010c76329525492f2c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Year'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Year'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/2c4a18abe0c7e23111a7185bd58278c9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'VIN'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'VIN'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/8d03147713447a876c1e536434aab86d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Type'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Type'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/b802dd64af5c3399ca788f311d51f279/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Odometer'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Odometer'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/e14d9a0d789f3b0f9a47c2c6e465e8ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Odometer'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Odometer'));
    }

  } catch (error) {

  }

  return (String(Content) + String(' km'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/61e69d7a3a167f916b6e800c5a5330b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Nickname'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Nickname'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/08725f6db21f457b507a068e347cd16c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Company_ID'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Company_ID'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/30bcf656bc9f8605f2eafb933637f8c6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Forenames'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Forenames'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/f18e8779217bafa89f7261add48f96d2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Surname'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Surname'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/ee4e7236088d2af146ea99cc0c1bc093/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_ID_Number'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_ID_Number'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/1fec8f38b4293518ee49d74cea2dce6a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Phone'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Employee_Details_Phone'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/4d4985af4fafda64d70d5a5bc4b7aa0a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Emergency_ICE_Name'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Emergency_ICE_Name'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/80fe3d1ae9fe3a26f041fdacda1be533/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Emergency_ICE_Phone'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Emergency_ICE_Phone'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/bd87e2987cf84027f5252b5fb6975185/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Registration'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Registration'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/7c9f892cde7c6937ade43d8c1605c2f6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'ID'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'ID'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/c47164fc3908f11241c4be4644f6a26a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Make'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Make'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/2fc28c0ac8611d886f3f74baa3cd3622/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Model'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Model'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/be2299e8f2fbe22a40d23b0734ea7b6a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Year'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Year'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/288a539ef5b16f7950c7d5b952531036/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'VIN'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'VIN'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/2e1b9b87bd5ee2bd8335cc22c49377c5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Type'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Type'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/abaf7c17668189cfc4b70d8d523a163f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Registration'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Registration'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/f69609116f593e1c47ddb8a5cdf75699/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'ID'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'ID'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/1bf8af6639db112c79a2b543c32efd4e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Make'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Make'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/a073d098c42af506c2e2389243195bd9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Model'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Model'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/1bb5e9b95fb17d667e92881262034c0a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Year'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Year'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/a9f661ddaa8a030664fd328ffe362c53/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'VIN'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'VIN'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/12d6eb3a09dc3dea30e41e81b80eccab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Type'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Type'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/4dc786ac8e3e8bd5584961fd9b13739c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Odometer'))))) {
      Content = '';
    } else {
      Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Odometer'));
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/162873332045e32ee6898ae8f8484c9e/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var List, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function listsGetSortCompare(type, direction) {
  var compareFuncs = {
    "NUMERIC": function(a, b) {
        return parseFloat(a) - parseFloat(b); },
    "TEXT": function(a, b) {
        return a.toString() > b.toString() ? 1 : -1; },
    "IGNORE_CASE": function(a, b) {
        return a.toString().toLowerCase() > b.toString().toLowerCase() ? 1 : -1; },
  };
  var compare = compareFuncs[type];
  return function(a, b) { return compare(a, b) * direction; }
}


  console.log(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers'));
  console.log((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Dropside');
  })).length);
  List = (await asyncListFilter([0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Abnormal' && 'In' == (getObjectProperty(item, 'Warehouse')));
  })).length ? 'Abnormal' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Dropside' && 'In' == (getObjectProperty(item, 'Warehouse')));
  })).length ? 'Dropside' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Dropside Side Tipper' && 'In' == (getObjectProperty(item, 'Warehouse')));
  })).length ? 'Dropside Side Tipper' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Side Tipper' && 'In' == (getObjectProperty(item, 'Warehouse')));
  })).length ? 'Side Tipper' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Flat Deck' && 'In' == (getObjectProperty(item, 'Warehouse')));
  })).length ? 'Flat Deck' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Hopper Bottom' && 'In' == (getObjectProperty(item, 'Warehouse')));
  })).length ? 'Hopper Bottom' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Tanker' && 'In' == (getObjectProperty(item, 'Warehouse')));
  })).length ? 'Tanker' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Skeletal' && 'In' == (getObjectProperty(item, 'Warehouse')));
  })).length ? 'Skeletal' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Live Stock' && 'In' == (getObjectProperty(item, 'Warehouse')));
  })).length ? 'Live Stock' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Automotive' && 'In' == (getObjectProperty(item, 'Warehouse')));
  })).length ? 'Automotive' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Sloper Tipper' && 'In' == (getObjectProperty(item, 'Warehouse')));
  })).length ? 'Sloper Tipper' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Dry Van' && 'In' == (getObjectProperty(item, 'Warehouse')));
  })).length ? 'Dry Van' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Refrigerated' && 'In' == (getObjectProperty(item, 'Warehouse')));
  })).length ? 'Refrigerated' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Tautliner' && 'In' == (getObjectProperty(item, 'Warehouse')));
  })).length ? 'Tautliner' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Dry Bulk Tanker' && 'In' == (getObjectProperty(item, 'Warehouse')));
  })).length ? 'Dry Bulk Tanker' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Cargo Floor' && 'In' == (getObjectProperty(item, 'Warehouse')));
  })).length ? 'Cargo Floor' : '-', 0 < (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'Type')) == 'Other' && 'In' == (getObjectProperty(item, 'Warehouse')));
  })).length ? 'Other' : '-'], async (item) => {


   return (item != '-');
  })).slice().sort(listsGetSortCompare("IGNORE_CASE", -1));
  List = (await Promise.all(List.map(async item => {; return ({ [`value`]: item,[`label`]: item });})));

  return List

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var List, item, Verdict, Position;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  List = [];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('32666ab6d0631fa30775fa62f8d207c4', false);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('32666ab6d0631fa30775fa62f8d207c4', true);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (HItch)')) == 'Trailer1') {
    Position = 'T1';
    List = (await asyncListFilter((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return (___arguments.value == (getObjectProperty(item, 'Type')) && 'In' == (getObjectProperty(item, 'Warehouse')));
    })), async (item) => {
       Verdict = ((getObjectProperty(item, 'Position')).indexOf(Position) !== -1);


     return (Verdict == true ? item : null);
    }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('32666ab6d0631fa30775fa62f8d207c4', List);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (HItch)')) == 'Trailer2') {
    Position = 'T2';
    List = (await asyncListFilter((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return (___arguments.value == (getObjectProperty(item, 'Type')) && 'In' == (getObjectProperty(item, 'Warehouse')));
    })), async (item) => {
       Verdict = ((getObjectProperty(item, 'Position')).indexOf(Position) !== -1);


     return (Verdict == true ? item : null);
    }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('32666ab6d0631fa30775fa62f8d207c4', List);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (HItch)')) == 'Trailer3') {
    Position = 'T3';
    List = (await asyncListFilter((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return (___arguments.value == (getObjectProperty(item, 'Type')) && 'In' == (getObjectProperty(item, 'Warehouse')));
    })), async (item) => {
       Verdict = ((getObjectProperty(item, 'Position')).indexOf(Position) !== -1);


     return (Verdict == true ? item : null);
    }));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('32666ab6d0631fa30775fa62f8d207c4', List);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/ebc924cdf01ad7f37aefaacb2a2579fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('54a992b40b6d0efed5942c26ed6fb97b', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/e42859c265f75e35e56540e923898d5e/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('3c29a70b17d832044f5c88d13482f6bf');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('3c29a70b17d832044f5c88d13482f6bf');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFOFFICE/components/d536225493d801fe4394c153028a72d8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Odometer'] = ___arguments.value;
  if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f4b5657441e76d6909e5d9459f035cb8', true);
  } else if (___arguments.value > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f4b5657441e76d6909e5d9459f035cb8', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f4b5657441e76d6909e5d9459f035cb8', false);
  }
  if (___arguments.value >= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f50e6e8668d4e13ab7a322a88fdbae33', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f50e6e8668d4e13ab7a322a88fdbae33', false);
    }
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f50e6e8668d4e13ab7a322a88fdbae33', false);

    } catch (error) {

    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/f50e6e8668d4e13ab7a322a88fdbae33/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Tractor, Transaction, Trailer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Trailer = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (Unhitch)'))));
  Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), ));
  await new Promise(r => setTimeout(r, 750 || 0));
  Tractor['Trailers_Tare'] = (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Tare')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Tare')))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Tare')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Tare')))) + (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Tare')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Tare')))) - ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Trailer, 'Tare')))) ? 0 : (getObjectProperty(Trailer, 'Tare')))));
  Tractor['Trailers_GVM'] = (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'GVM')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'GVM')))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'GVM')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'GVM')))) + (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'GVM')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'GVM')))) - ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Trailer, 'GVM')))) ? 0 : (getObjectProperty(Trailer, 'GVM')))));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailers_Tare'] = (getObjectProperty(Tractor, 'Trailers_Tare'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailers_GVM'] = (getObjectProperty(Tractor, 'Trailers_GVM'));
  Trailer['Warehouse'] = 'In';
  Trailer['Now'] = (new Date());
  Trailer['Odometer'] = ((getObjectProperty(Trailer, 'Odometer')) + ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Fuel_Transaction_Mileage'))));
  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (Unhitch)'));
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (Unhitch)')), [(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (Unhitch)')))), 'objectId'))]);
    _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (Unhitch)')))), 'objectId')), 'Tractor', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'))]);
    _uow.upsert('Trailers', Trailer);
    _uow.upsert('Tractors', Tractor);
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')[(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (Unhitch)'))] = null;

  })();

  console.log((await Transaction.execute()));
  console.log((await BackendlessUI.Functions.Custom['fn_88481472e3e169797cae85c104751a08']((getObjectProperty(Tractor, 'objectId')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'))));
  delete ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailer (Unhitch)'];
  await BackendlessUI.Functions.Custom['fn_1084738faafcc22540e6efb456550d03'](((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('023810ea19d611d8668de6cb90ac1585')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('023810ea19d611d8668de6cb90ac1585')), 0.1);
  await BackendlessUI.Functions.Custom['fn_035fa71f751b1ddc93f5f9520f1c1dba'](((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('023810ea19d611d8668de6cb90ac1585')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('023810ea19d611d8668de6cb90ac1585')), 0.1);
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('3219e54f18daa02c098161bb21b7aaf3', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/4c22de9d21d62341059826d3910d2e3a/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var error, item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    List = (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Registration')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });})));

  } catch (error) {
    console.log(error);

  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Trailer Id'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/3cc4e08fa32bd305d518605fbc049252/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Odometer'] = ___arguments.value;
  if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aaa4019ed44e318174cdd0f330fcb4e2', true);
  } else if (___arguments.value > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aaa4019ed44e318174cdd0f330fcb4e2', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('aaa4019ed44e318174cdd0f330fcb4e2', false);
  }
  if (___arguments.value >= (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    if (___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e314b6aaa4de26b251ceb4388a5930ee', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e314b6aaa4de26b251ceb4388a5930ee', false);
    }
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e314b6aaa4de26b251ceb4388a5930ee', false);

    } catch (error) {

    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/e314b6aaa4de26b251ceb4388a5930ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Tractor, Trailer, Transaction, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Trailer = (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Trailer Id')));
  }));
  Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), ));
  await new Promise(r => setTimeout(r, 750 || 0));
  Tractor['Trailers_Tare'] = (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Tare')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Tare')))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Tare')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Tare')))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Tare')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Tare')))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Trailer, 'Tare')))) ? 0 : (getObjectProperty(Trailer, 'Tare'))));
  Tractor['Trailers_GVM'] = (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'GVM')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'GVM')))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'GVM')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'GVM')))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')))) ? 0 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'GVM')))) ? 0 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'GVM')))) + ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Trailer, 'GVM')))) ? 0 : (getObjectProperty(Trailer, 'GVM'))));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailers_Tare'] = (getObjectProperty(Tractor, 'Trailers_Tare'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailers_GVM'] = (getObjectProperty(Tractor, 'Trailers_GVM'));
  Trailer['Warehouse'] = 'Out';
  Trailer['Now'] = (new Date());
  Trailer['Odometer'] = ((getObjectProperty(Trailer, 'Odometer')) + ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Odometer')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Fuel_Transaction_Mileage'))));
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (HItch)')), [(getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Trailer Id'))]);
    _uow.addToRelation('Trailers', (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Trailer Id')), 'Tractor', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'))]);
    delete Trailer['Item Select'];
    _uow.upsert('Trailers', Trailer);
    _uow.upsert('Tractors', Tractor);

  })();

  console.log((await Transaction.execute()));
  await new Promise(r => setTimeout(r, 500 || 0));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')[(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer (HItch)'))] = Trailer;
  delete ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailer (HItch)'];
  console.log((await BackendlessUI.Functions.Custom['fn_88481472e3e169797cae85c104751a08']((getObjectProperty(Tractor, 'objectId')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'))));
  await BackendlessUI.Functions.Custom['fn_1084738faafcc22540e6efb456550d03'](((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('023810ea19d611d8668de6cb90ac1585')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('023810ea19d611d8668de6cb90ac1585')), 0.1);
  await BackendlessUI.Functions.Custom['fn_035fa71f751b1ddc93f5f9520f1c1dba'](((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('023810ea19d611d8668de6cb90ac1585')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('023810ea19d611d8668de6cb90ac1585')), 0.1);
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('3219e54f18daa02c098161bb21b7aaf3', undefined);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/04839cafca3e57ed1b79fb49f7552202/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('1737c0e26f8e706cbad9f399d099912f', undefined);
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailer (Unhitch)'] = 'Trailer2';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/99cd506433f3a2e2a877169c84a4b92d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await new Promise(r => setTimeout(r, 500 || 0));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('1737c0e26f8e706cbad9f399d099912f', undefined);
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Trailer (Unhitch)'] = 'Trailer3';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/2d61ce751d85f3af3c9732b5f23b7f6d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var item;


  ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Registration',[`Direction`]: 'Down' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/ff742e095dd7028c0c1c0bc167d27cd9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var item;


  ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Registration',[`Direction`]: 'Up' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/f258040bf06d425308e84b11ea4723a2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'ID',[`Direction`]: 'Up' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/b3c3f8764e36d84d9e3cd6e896321e1a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'ID',[`Direction`]: 'Down' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/70165c2a6f7a060d6d6cf7b3d52f48fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Odometer',[`Direction`]: 'Down' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/affd7be5992ca4eec38fc9249161ac1e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Odometer',[`Direction`]: 'Up' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/8fd3a93307c379ab2e78717d89487669/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Distance_Travelled',[`Direction`]: 'Up' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/e6095cd7c06d7e04951fd22c0459c345/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Distance_Travelled',[`Direction`]: 'Down' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/f6ffd89d79f4829e6c74822b5bff5efc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Fuel_Consumption_Actual',[`Direction`]: 'Up' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/e3bae3235c4aa95e32e80e3c8208fd65/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Fuel_Consumption_Actual',[`Direction`]: 'Down' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/f7c45f63303f136881e9d47807382eeb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Tonnage_Total',[`Direction`]: 'Down' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/0ca99284016efcd2d4622518638d2554/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Tonnage_Total',[`Direction`]: 'Up' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/8f53aa752134cd1255ffb6a481d8334f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Profit_Loss',[`Direction`]: 'Up' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/51c2d0320471372e97c71517abee4ed5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['Fleetview Sorter'] = ({ [`Property`]: 'Profit_Loss',[`Direction`]: 'Down' });

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/2c68263b95328b2f1713439e3ca6414d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var error, Text2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Text2 = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('cbdcc6bf0f487e0ece36b58566754bed'), 'Registration')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('cbdcc6bf0f487e0ece36b58566754bed'), 'ID'))].join('');

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Text2 = '';
    }

  }

  return Text2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/cbdcc6bf0f487e0ece36b58566754bed/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, Repeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.dataModel, 'Item Select'))))) {
    Repeater = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'));
    for (var j_index in Repeater) {
      j = Repeater[j_index];
      try {
        delete j['Item Select'];

      } catch (error) {

      }
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('32666ab6d0631fa30775fa62f8d207c4', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('32666ab6d0631fa30775fa62f8d207c4', true);
    ___arguments.context.dataModel['Item Select'] = true;
    ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Trailer Id'] = (getObjectProperty(___arguments.context.dataModel, 'objectId'));
  } else {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Trailer Id'];
    delete ___arguments.context.dataModel['Item Select'];
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('32666ab6d0631fa30775fa62f8d207c4', false);
    await new Promise(r => setTimeout(r, 1000 || 0));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('32666ab6d0631fa30775fa62f8d207c4', true);
  }

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var j, Repeater, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Style = ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('cbdcc6bf0f487e0ece36b58566754bed'));
  if ((getObjectProperty(___arguments.context.dataModel, 'Item Select')) == true) {
    Style['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';
  } else {
    Style['boxShadow'] = null;
  }

  return Style

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/aed9f88b7a17d7119e867c74a0b508d6/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var object, item;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Fleetview - Load Planner (Listener Update) '] = (generateUUID().long());
  await new Promise(r => setTimeout(r, 1000 || 0));

  ;(function(whereClause) {
    const callback = async object => {
        console.log('abc');
    replaceItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), object, 'objectId');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) != 'Delivered');
    })), 1, async (item) => {


     return (getObjectProperty(item, 'Action Date'));
    })));
    console.log(object);

    };

    const rtHandlers = Backendless.Data.of('Loads').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpdateListener.apply(rtHandlers, options);

    getRTSubscriptions().add((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - Load Planner (Listener Update) ')), () => rtHandlers.removeUpdateListener(callback));

  })((['TID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),'\''].join('')));
    console.log(getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - Load Planner (Listener Update) '));
  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Fleetview - Load Planner (Listener Upsert) '] = (generateUUID().long());
  await new Promise(r => setTimeout(r, 1000 || 0));

  ;(function(whereClause) {
    const callback = async object => {
        console.log('abc');
    replaceItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), object, 'objectId');
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) != 'Delivered');
    })), 1, async (item) => {


     return (getObjectProperty(item, 'Action Date'));
    })));
    console.log(object);

    };

    const rtHandlers = Backendless.Data.of('Loads').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpsertListener.apply(rtHandlers, options);

    getRTSubscriptions().add((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - Load Planner (Listener Upsert) ')), () => rtHandlers.removeUpsertListener(callback));

  })((['TID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),'\''].join('')));
    console.log(getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - Load Planner (Listener Upsert) '));

  },
  /* handler:onMounted */
  /* handler:onBeforeUnmount */
  ['onBeforeUnmount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  getRTSubscriptions().remove((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - Load Planner (Listener Update) ')));
  getRTSubscriptions().remove((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - Load Planner (Listener Upsert) ')));

  },
  /* handler:onBeforeUnmount */
  /* content */
}))

define('./pages/FIFOFFICE/components/23cd61ab0f96d7dded927dcf7be6f7e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? 0 : (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) == 'Planned');
    })).length) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/b6db8091ad43822cccb69f76a06373a7/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var List, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads'))))) {
      List = [];
    } else {
      List = (await Promise.all((await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


       return ((getObjectProperty(item, 'Status')) == 'Planned');
      })), 1, async (item) => {


       return (getObjectProperty(item, 'Action Date'));
      })).map(async item => {; return ({ [`Customer`]: (getObjectProperty(item, 'Customer Name')),[`Tonnage`]: (getObjectProperty(item, 'Tonnage_Planned')),[`Product`]: (getObjectProperty(item, 'Load_Product')) });})));
    }

  } catch (error) {

  }

  return List

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/0c7e0c0beb824cacb711210e038c2008/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var item, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  try {
    if (((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')))) ? 0 : (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


     return ((getObjectProperty(item, 'Status')) == 'Loaded');
    })).length) > 0 == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/202e6f381478a79b838edf74751aa2af/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads'))))) {
      List = [];
    } else {
      List = (await Promise.all((await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


       return ((getObjectProperty(item, 'Status')) == 'Loaded');
      })), 1, async (item) => {


       return (getObjectProperty(item, 'Action Date'));
      })).map(async item => {; return ({ [`Customer`]: (getObjectProperty(item, 'Customer Name')),[`Tonnage`]: (getObjectProperty(item, 'Tonnage_Planned')),[`Product`]: (getObjectProperty(item, 'Load_Product')) });})));
    }

  } catch (error) {

  }

  return List

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/df25f1ce96461ed6fd8c75fe6ed69ec3/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
    
  },
  /* handler:onOpen */
  /* content */
}))

define('./pages/FIFOFFICE/components/db2229c1f443cd9b599ae117b1ee22b9/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      console.log(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/FIFOFFICE/components/06f5b14abd6aea05bcc6c64ad3f45589/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
      } else {
        List = (await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


         return ((getObjectProperty(item, 'Type')) == 'Service Centre');
        })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Name')) });})));
      }
    }
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type')) == 'Tractor') {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))))) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/ed029dab54290ec4675e42a6144f6f0e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/d5dff5c6720ea4ad32b1f104708ea4fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Directory')) + String('/Invoices'))

  },
  /* handler:onDirectoryAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/ed46e734f0cff692570fa7b718f18d66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Transaction, Tractor;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Type')) == 'Tractor') {
    Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item')), 'objectId')), ));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['License_Expiry_Date'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Date'));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['License_Status'] = 'All In Order';
    Tractor['License_Expiry_Date'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Date'));
    Tractor['Annual_License_Fee'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Cost'));
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Transaction;

      _uow.upsert('Tractors', Tractor);
      _uow.create('Transactions', ({ [`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Cost')),[`Description`]: ['License Renewal - (',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item')), 'ID')),')'].join(''),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item')), 'ownerId')) }));

    })();

    console.log((await Transaction.execute()));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Type')) == 'Trailer') {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item'))['License_Expiry_Date'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Date'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item'))['Annual_License_Fee'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Cost'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Number'))))['License_Expiry_Date'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Date'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Number'))))['License_Status'] = 'All In Order';
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Transaction;

      _uow.upsert('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item')));
      _uow.create('Transactions', ({ [`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Cost')),[`Description`]: ['License Renewal - (',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item')), 'ID')),')'].join(''),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item')), 'ownerId')) }));

    })();

    console.log((await Transaction.execute()));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Type')) == 'Driver') {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item'))['Driver_License_Expiry_Date'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Date'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))['Driver_License_Expiry_Date'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Date'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))['Driver_License_Expirey_Date_Status'] = 'All In Order';
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Transaction;

      _uow.upsert('Employees', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item')));

    })();

    console.log((await Transaction.execute()));
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Type')) == 'PDP') {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item'))['Driver_PDP_Expiry_Date'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Date'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))['Driver_PDP_Expiry_Date'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Date'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1'))['Driver_PDP_Expiry_Date_Status'] = 'All In Order';
    Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Transaction;

      _uow.upsert('Employees', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aae70451c6ec06f5a1a9a6bef954a3'), 'Item')));

    })();

    console.log((await Transaction.execute()));
  }
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('f44a28e8f6f3fc877238de766fd33d18', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/58d9626f5a3152ce3ce5dd1ba7ca4b8b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('f44a28e8f6f3fc877238de766fd33d18', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/e08f14d99aec84b58434fc6dc7d7c358/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/67132021793ba0afdb38e1057477d3dc/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var error, list, Options_List, Trailer_List, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Options_List = [];
  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Trailer List'] = [];
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service_Status')) == 'Service Due') {
    addItemToList(Options_List, ({ [`label`]: [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')),' (Tractor)'].join(''),[`value`]: 'Tractor' }));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
  } else {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Service_Status')) == 'Service Due') {
      addItemToList(Options_List, ({ [`label`]: [(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'ID')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Registration')),' (Trailer 1)'].join(''),[`value`]: 'Tailer1' }));
      addItemToList((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Trailer List')), 'Tailer1');
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
  } else {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Service_Status')) == 'Service Due') {
      addItemToList(Options_List, ({ [`label`]: [(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'ID')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Registration')),' (Trailer 2)'].join(''),[`value`]: 'Tailer2' }));
      addItemToList((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Trailer List')), 'Tailer2');
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
  } else {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Service_Status')) == 'Service Due') {
      addItemToList(Options_List, ({ [`label`]: [(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'ID')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Registration')),' (Trailer 3)'].join(''),[`value`]: 'Tailer3' }));
      addItemToList((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Trailer List')), 'Tailer3');
    }
  }
  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Trailer List')).length > 0) {
    addItemToList(Options_List, ({ [`label`]: 'All Trailers',[`value`]: 'All Trailers' }));
  }

  return Options_List

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/9701b0799f7e018274e5ba646626a0e6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type')) == 'Tractor') {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))))) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/a3659f8763b7b164af4ba798ad1f5901/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a9fb2519d23f5b8201cc6f756ec64c1f'), 'Vehicle Type')) == 'Tractor') {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Service Item'))))) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/9e7252e717740cc82f31260fe3719aa9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var List;


  List = [({ [`value`]: 'kg',[`label`]: 'kg' }), ({ [`value`]: 'l',[`label`]: 'l' }), ({ [`value`]: 'm³',[`label`]: 'm³' }), ({ [`value`]: 't',[`label`]: 't' })];

  return List

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product'))))) {
    ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['New Product'] = ({ [`Unit`]: ___arguments.value });
  } else {
    (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product'))['Unit'] = ___arguments.value;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/bb53dfa268cf640b407d5f438858526d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Company;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Company = (await Backendless.Data.of('Companies').findById((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'objectId')), ));
  Company['Products'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products'));
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Edit'];
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Add'];
  await Backendless.Data.of('Companies').save(Company, true);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Edit')) == true || (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Add')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/6e6c7b4ffab7f4feaf0ec6a4e115387f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product'))))) {
    ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['New Product'] = ({ [`Mass`]: ___arguments.value });
  } else {
    (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'New Product'))['Mass'] = ___arguments.value;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/6898e321c38c9cd7a5e28fc8331acdf6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8b0751df4ceaba4475b9dcfd53a1d4d7', true);
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products'))))) {
    ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Products'] = [({ [`Mass`]: 0 })];
  } else {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')), ({ [`Mass`]: 0 }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/f1179b2329bd3782ae820f91603f29e4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6'), 'Unit mass'))))) {
    ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Units'] = ___arguments.value;
  } else {
    ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Units'] = ___arguments.value;
    ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Mass'] = (___arguments.value * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6'), 'Unit mass')));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/64b7d4030788f5b8140edb6e30540fec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')), ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6'), '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/b05e3abc4ae446a18da2861449799845/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Admin Capture Load'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/d6557f66205c502c58c2718b3e6fd268/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Admin Capture Load'))))) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de8e8f4bbb67b6b91e39d5ee272b6c7a'))['value'] = (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')).length == 0 ? ((new Date()).valueOf()) + 900000 : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')).slice(-1)[0]), 'Date_Planned_Return')))) ? (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')).slice(-1)[0]), 'Date_Planned_Delivery')) : (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')).slice(-1)[0]), 'Date_Planned_Return'))) + 900000);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/FIFOFFICE/components/7c89faf9084b806d4d2bb4ec8e6604c6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, Last_Load, Last_Location_ID, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Load Date'] = ___arguments.value;
  Last_Load = (await asyncListFilter((await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Loads')), -1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  })), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date')) > (getObjectProperty(item, 'Action Date')));
  })).slice(-1)[0];
  if ((getObjectProperty(Last_Load, 'Status')) == 'Delivered') {
    Last_Location_ID = (getObjectProperty(Last_Load, 'LDPID'));
  } else if ((getObjectProperty(Last_Load, 'Status')) == 'Loaded') {
    Last_Location_ID = (getObjectProperty(Last_Load, 'LLPID'));
  } else if ((getObjectProperty(Last_Load, 'Status')) == 'Planned') {
    Last_Location_ID = (getObjectProperty(Last_Load, 'LLDPID'));
  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6', Last_Location_ID);

  } catch (error) {

  }

  },
  /* handler:onChange */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date((new Date()).getTime() - (5256000 * 1000)))

  },
  /* handler:onMinDateAssignment */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/677480d417bccc03f44eca6619cbba16/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Delivery Date'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Load Date'))

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/8549715c2ed49c6dd4535947b02ccfd6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route'));
  console.log(getObjectProperty(((getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'routes'))[0]), 'legs'))[0]), 'distance'));
  console.log(getObjectProperty(((getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route')), 'Route')), 'routes'))[0]), 'legs')).slice(-1)[0]), 'distance'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/fd6cd4a18a419db763ef7692e597efa6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Turnover'))))))))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('99a457935c8e264aa892775f6b25d371', undefined);
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('12ffcd2a0f5af80bebf447edfaf53caf', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/521746a3f3726607f3c2b28bc2a8fe7c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Turnover'))))))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('99a457935c8e264aa892775f6b25d371', undefined);
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('12ffcd2a0f5af80bebf447edfaf53caf', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/48225d4b23a414d57afedb776b69624c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Fuel_Cost'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/9dd2ce2fff414cfb156e79f83cd471e6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb'](((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Toll_Fees')) + (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Toll_Fees_Per_Km_Total')))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/1341b09b5522cb727781f7821df3383f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Profit_Target'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/b942ed4940a97b3a9365f822d8276e85/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb'](((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Maintenance_Repairs_Trailers')) + (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Maintenance_Repairs_Tractor')))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/115726132571ea5a4d6a1c7bfe12e0a8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Salary_Wages'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/00cdbf7ab1f5a88b29f64a39271527cf/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Turnover')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Total_Expenses')) < 0 ? ['( R ',(await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Turnover')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Total_Expenses'))) * -1))))),' )'].join('') : String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb'](((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Turnover')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Total_Expenses')))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/c7ee8cdeb0ed5c7ad557facbc2fdd9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('12ffcd2a0f5af80bebf447edfaf53caf', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/52bea79387ae26d4d73775c8aea21107/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Product')), ''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/cb51e55b87071d627f63f40fea92159e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Rig_Payload')) + String(' kg')), ''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/d08f91b94c120ed2e2884e2fcadf250a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Tonnage_Planned')) + String(' kg')), ''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/ca4649afcc8acca75714c726b67aaaa8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Tonnage_Loaded')) + String(' kg')), ''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/8ba54673e044a57f20147299d88d544d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Tonnage_Delivered')) + String(' kg')), ''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/fcc68773c305c8e37c6c66fe5bb6dcc4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String((await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Tonnage_Differential_Planned_To_Loaded')), 0))) + String(' kg'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/0645ff4f9cb390e58dc40e92377b92b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((Number.parseFloat((((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Financial_Gain_Loss_Tonnage_Differential')) * 100 + 1) / 100)).toFixed(2)), 0))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/3afdce2c3d6e4d497f7d81a923769def/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Broker')), ''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/8e24e4749b081679795b04b587ee49b4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load Planner Name')), ''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/b75a686d743812a466331f9d154a35ba/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var Note_Length, Notes;


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd4de9f714144bc16e6aff4d68e4e9dc', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/cd4de9f714144bc16e6aff4d68e4e9dc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Notes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Notes = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Notes'));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Notes))) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record'))['Load_Notes'] = (String('● ') + String(getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Notes')));
  } else {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record'))['Load_Notes'] = ([Notes,'\n','● ',(getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Notes'))].join(''));
  }
  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Notes'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('325807b83c25e78b816ae7a87ba98c06', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cd4de9f714144bc16e6aff4d68e4e9dc', false);
  await Backendless.Data.of('Loads').save((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('325807b83c25e78b816ae7a87ba98c06', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/1c0dfc47bd9b8ccc6f8df1239bfc6079/bundle.js', [], () => ({
  /* content */
  /* handler:onOpen */
  ['onOpen'](___arguments) {
    
  },
  /* handler:onOpen */
  /* content */
}))

define('./pages/FIFOFFICE/components/344e413bcfa345643b7aae6ed6426c15/bundle.js', [], () => ({
  /* content */
  /* handler:onAfterRender */
  ['onAfterRender'](___arguments) {
    
  },
  /* handler:onAfterRender */
  /* content */
}))

define('./pages/FIFOFFICE/components/228732b4d85fd0236a09771fee89694f/bundle.js', [], () => ({
  /* content */
  /* handler:imagesDataLogic */
  async ['imagesDataLogic'](___arguments) {
    var Images, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Images = (await Promise.all((await asyncListFilter([(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Load_Image_1')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Load_Image_2')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Load_Image_3')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Delivery_Image_1')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Delivery_Image_2')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Delivery_Image_3'))], async (item) => {


   return (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](item)));
  })).map(async item => {; return ({ [`url`]: item,[`title`]: undefined,[`content`]: undefined });})));

  return Images

  },
  /* handler:imagesDataLogic */
  /* content */
}))

define('./pages/FIFOFFICE/components/4d3789a3e3c908e9c0e8522183222c9a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record'));

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Fuel_Consumption_Ideal')) + String(' km/l')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/c232a6388ec3013988c856d4684c3406/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Fuel_Consumption_Actual')) + String(' km/l')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/d109bac322a80d156ee726b320a4e859/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Mileage')) + String(' km')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/d003b8010592a3173b85f49c0b9fd3b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Mileage_Differential')) + String(' km')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/496a1f85d639d4564c88f1dde0e328b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String('R ') + String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Cost'))), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/68491e9dd57919637662440de884dafe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String('R ') + String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Cost_Ideal'))), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/0ee42f4a64e2648c8fca6d3e7b6fef8e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String('R ') + String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Cost_Fuel_Per_Km'))), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/60f1d022ae8c8c12cdf4b5b3fd2a5e37/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(Number.parseFloat((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tank_Capacity')) - Math.round((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Available Capacity')) * 1000) / 1000) * (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Fuel_Consumption_Ideal')))).toFixed(2)) + String(' km')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/541f9dd30e7b597aeafb6cdca9f855d8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Closest_Station_Distance')) + String(' km')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/7d1f23262d7747256d76cf01c4179f19/bundle.js', [], () => ({
  /* content */
  /* handler:onMapCenterAssignment */
  async ['onMapCenterAssignment'](___arguments) {
    var Location;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Admin')) == true) {
    Location = null;
  } else {
    Location = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Location_Submitted')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Location_Submitted'));
  }

  return Location

  },
  /* handler:onMapCenterAssignment */
  /* handler:onPointsAssignment */
  async ['onPointsAssignment'](___arguments) {
    var Location;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Admin')) == true) {
    Location = null;
  } else {
    Location = (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Location_Submitted')))) ? [] : [(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Location_Submitted'))];
  }

  return Location

  },
  /* handler:onPointsAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Admin')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/dd5604188936a015c24c2f8dd7b9a9fc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Fuel_Consumption')) + String(' km/l')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/151cd2ad1f5308d6a2ca3c42b3f5d7df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Consumption_Actual')) + String(' km/l')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/48ea13b9d3129dc8791d024e07ea1673/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(Number.parseFloat((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Litres'))).toFixed(2)) + String(' l')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/77f465e71b87db0c63d2956c14cad4a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String('R ') + String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Cost'))), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/6e6e463621575b39ef7e345142b6aa87/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String('R ') + String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Price_Per_Litre'))), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/989590ee9f2b6fc7a6b7d4f2d5b43436/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Consumption_5Tanks')) + String(' km/l')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/de8951d1330858482c1c8a1c7cd80015/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Image'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/dae53fcd87ac26abe238df72c6f843c8/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var Image2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Image'))))) {
  } else {
    Image2 = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Image'));
  }

  return Image2

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/3e5e7579755f988eb78bba88086a9619/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/640654114287f343125bb2226bfafc5f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Mileage_Last_Delivery_Point'))))) {
    Content = '';
  } else {
    Content = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Mileage_Last_Delivery_Point')) + String(' km');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/909a2be929459e6aba59f3dad886a817/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Mileage_Load_Point'))))) {
    Content = '';
  } else {
    Content = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Mileage_Load_Point')) + String(' km');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/aa28786cf8895645260af4b9b95afef5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Mileage_Delivery_Point'))))) {
    Content = '';
  } else {
    Content = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Mileage_Delivery_Point')) + String(' km');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/9de6b67b620e644393380384191dca7b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Planned Mileage'))))) {
    Content = '';
  } else {
    Content = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Planned Mileage')) + String(' km');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/5a1f859b5153db6dcd3122d4d5d34176/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Distance_Last_Delivery_To_Delivery_Point'))))) {
    Content = '';
  } else {
    Content = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Distance_Last_Delivery_To_Delivery_Point')) + String(' km');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/bc8d004de601b2d3503f4212f92a14f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Distance_Differential_LDP_To_LP'))))) {
    Content = '';
  } else {
    Content = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Distance_Differential_LDP_To_LP')) + String(' km');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/cb0ce90325cc1de584a54a087e53ba43/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Distance_Differential_LP_To_DP'))))) {
    Content = '';
  } else {
    Content = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Distance_Differential_LP_To_DP')) + String(' km');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/e45a09ea1b5acd82b6472a9d96d28ec9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Distance_Differential_LDP_To_DP'))))) {
    Content = '';
  } else {
    Content = String('R') + String((await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b'](((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Mileage Completion Record')), 'Distance_Differential_LDP_To_DP')) * (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Cost Per Km (Variables)'))), null, null)));
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/fdae0c99d6f6d3861ed4b5e2c1fbc17f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('98ba53adc16ea73716acbe6a98bbf982', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/2955543dd4af818bc80e40576e2a5649/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('5872de4f15ebcbf90d7d677c1de9e0b2', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/f61dd8c12da2ada204b1eb53868d0d45/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  async ['onContainerDataAssignment'](___arguments) {
    var item, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  var j_list = (await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Axles_Data')), 1, async (item) => {


   return (getObjectProperty(item, 'Position Number'));
  }));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['Vehicle Id '] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectid'));
  }

  return (await asyncListSort((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Axles_Data')), 1, async (item) => {


 return (getObjectProperty(item, 'Position Number'));
}))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/d4852d7ed351145bad171b1acc629153/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Fleetview, ObjectId, Axle_List, Tyres, Transaction_Step_1, Transaction_Step_2, Fuel_Transaction, Tractor, Fuel, item, Fleetview_Current, Mileage_Differential;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Tyre_Function() {
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Axles_Data'))))) {
    Axle_List = [];
  } else {
    Axle_List = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Axles_Data'));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
  } else {
    Axle_List = (Axle_List.concat((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Axles_Data'))));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2'))))) {
  } else {
    Axle_List = (Axle_List.concat((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Axles_Data'))));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3'))))) {
  } else {
    Axle_List = (Axle_List.concat((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer3')), 'Axles_Data'))));
  }
  Tyres = (await BackendlessUI.Functions.Custom['fn_c8249d71574777eb2a08c21c7e28faee'](Axle_List, ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')))));
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

/**
 * Describe this function...
 */
async function Fuel_Transaction2() {
  Mileage_Differential = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'));
  Tractor = (await Backendless.Data.of('Tractors').findById(ObjectId, ));
  Fuel = ({ [`Fuel_Consumption_Ideal`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Fuel_Consumption_Ideal')),[`TObjectID`]: ObjectId,[`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost')),[`Description`]: ((new Date()).toDateString()),[`Fuel_Count`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))),[`Litres`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres')),[`Mileage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')),[`Mileage_last`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Fuel_Transaction_Mileage')),[`Station_Unknown`]: (getObjectProperty(___arguments.context.appData, 'Garage - Other')) == true ? (getObjectProperty(___arguments.context.appData, 'Garage')) : null,[`Wages_Contractor_Km_Rate`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Contractor_Mileage')),[`Wages_Good_Driving_Rate`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Wages_Rate_Good_Driving')),[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'ownerId')) });
  Fleetview_Current = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current'));
  Fleetview_Current['Current_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  Fleetview_Current['Distance_Travelled'] = ((getObjectProperty(Fleetview_Current, 'Distance_Travelled')) + ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Fuel_Transaction_Mileage'))));
  Fleetview_Current['Fuel_Cost'] = ((getObjectProperty(Fleetview_Current, 'Fuel_Cost')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost')));
  Fleetview_Current['Fuel_Litres'] = ((Number((getObjectProperty(Fleetview_Current, 'Fuel_Litres')))) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres')));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Now'] = (new Date());
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Odometer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Fuel_Transaction_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Fuel_Counter'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))));
  (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty(item, 'objectId')));
  }))['Now'] = (new Date());
  (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty(item, 'objectId')));
  }))['Odometer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty(item, 'objectId')));
  }))['Last_Fuel_Transaction_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty(item, 'objectId')));
  }))['Fuel_Counter'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))));
  Tractor['Now'] = (new Date());
  Tractor['Odometer'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  Tractor['Last_Fuel_Transaction_Mileage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'));
  Tractor['Fuel_Counter'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 1 ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 2 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : 1) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 3 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 1 : null))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 4 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 1 : null)))) : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Check_Frequency')) == 5 ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 1 ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 2 ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 3 ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 4 ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fuel_Counter')) == 5 ? 1 : null))))) : null)))));
  Fuel_Transaction = (await Backendless.Data.of('Fuel').save( Fuel ));
  Transaction_Step_1 = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction_Step_1;

    _uow.upsert('Tractors', Tractor);
    _uow.addToRelation('Tractors', Tractor, 'Fuel', [Fuel_Transaction]);
    _uow.setRelation('Tractors', Tractor, 'Fuel_Last', [Fuel_Transaction]);
    _uow.addToRelation('Employees', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_Transactions_Fuel', [Fuel_Transaction]);
    _uow.addToRelation('Employees', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')), 'Driver_Transactions_Fuel', [Fuel_Transaction]);
    _uow.setRelation('Fuel', Fuel_Transaction, 'Company', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')));
    _uow.setRelation('Fuel', Fuel_Transaction, 'Tractor', Tractor);
    _uow.addToRelation('Fuel', Fuel_Transaction, 'Driver', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Driver1')));
    _uow.bulkUpsert('Tyres', Tyres);

  })();

  Transaction_Step_2 = (await Transaction_Step_1.execute());
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('800fe80c414539252fbae03db5de918b', false);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d4852d7ed351145bad171b1acc629153'))['disabled'] = true;
  ObjectId = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'));
  Fleetview = (getObjectProperty((await BackendlessUI.Functions.Custom['fn_88481472e3e169797cae85c104751a08'](ObjectId)), 'Fleetview'));
  console.log(Fleetview);
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Current_Fleetview'] = Fleetview;
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Fleetview_Current'] = Fleetview;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('b60663c4b5eb29e9c2dc2d7f8097446c', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/5c8fcfc52fa25fba8393a975589bf0e6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Form_Terms() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', true);
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Mileage'))))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6f4d6342065d90ae48134cd158db380d', false);
  }
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer'))) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage')) < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range'))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station'))))) {
        try {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

        } catch (error) {

        }
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Cost'))))) {
          try {
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

          } catch (error) {

          }
        } else {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Litres'))))) {
            try {
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

            } catch (error) {

            }
          } else {
            if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Mileage'))))) {
              try {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

              } catch (error) {

              }
            } else {
              if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5c8fcfc52fa25fba8393a975589bf0e6')), 'display')) == true) {
                if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48'), 'Station - Other'))))) {
                  try {
                    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

                  } catch (error) {

                  }
                } else {
                  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
                }
              } else {
                (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', true);
              }
            }
          }
        }
      }
    } else {
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

      } catch (error) {

      }
      try {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4852d7ed351145bad171b1acc629153', false);

      } catch (error) {

      }
    }
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e1a210fc708f554b9eaabeaece02dbc3', false);

    } catch (error) {

    }
  }
}


  ___arguments.context.getComponentDataStoreByUid('5b89c33aa35935fcf14c2517974cad48')['Station - Other'] = ___arguments.value;
  await Form_Terms();

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/b4ad1276182a224733317d57e58ceb38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Fleetview, ObjectId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4ad1276182a224733317d57e58ceb38'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4ad1276182a224733317d57e58ceb38'))['disabled'] = true;
  await new Promise(r => setTimeout(r, 400 || 0));
  ObjectId = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'));
  Fleetview = (getObjectProperty((await BackendlessUI.Functions.Custom['fn_88481472e3e169797cae85c104751a08'](ObjectId, ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'))), 'Fleetview'));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Current_Fleetview'] = Fleetview;
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Fleetview_Current'] = Fleetview;
  console.log(Fleetview);
  await new Promise(r => setTimeout(r, 400 || 0));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b4ad1276182a224733317d57e58ceb38'))['disabled'] = false;
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('f3e9c22366f902aef4819ddad8b9b81a', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/e6d42ad792dc2d07daafbde7b6c4735d/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Contracts'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/72c1a84a9203610cb2ccff4a7a7937bb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('8e311797ed6c3552dd0784037dcb8d8b', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/f172f71b051402655953065849412c33/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((await BackendlessUI.Functions.Custom['fn_88481472e3e169797cae85c104751a08']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/aee18d9611e77efd62fb75e42fee60c9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var j, item, k, List, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.appData['Month'] = ___arguments.value;
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    try {
      delete j['View'];

    } catch (error) {
      console.log(error);

    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Current_Fleetview_Save'))))) {
      j['Current_Fleetview_Save'] = (getObjectProperty(j, 'Fleetview_Current'));
    } else {
      j['Fleetview_Current'] = (getObjectProperty(j, 'Current_Fleetview_Save'));
    }
    if (((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4']((new Date()))).valueOf()) == ___arguments.value) {
      j['Current_Fleetview'] = (getObjectProperty(j, 'Fleetview_Current'));
    } else {
      List = (await asyncListFilter((getObjectProperty(j, 'Fleetview_Historical')), async (item) => {


       return ((getObjectProperty(item, 'created')) >= ___arguments.value && (getObjectProperty(item, 'created')) <= (await (async function(Start) {
      	function getEndOfMonthTimestamp(Start) {
      	  const startDate = new Date(Start);
      	  const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
      	  endDate.setHours(23, 59, 59, 999); // Set to the end of the day
      	
      	  return endDate.getTime();
      	}
      	
      	// Directly execute and return the result
      	return getEndOfMonthTimestamp(Start);
      })(___arguments.value)));
      }));
      if (List.length > 0) {
        j['Current_Fleetview'] = (List[0]);
        j['Fleetview_Current'] = (List[0]);
      } else {
        j['View'] = false;
      }
    }
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fe63d7114a2242e76e3c1f3c973f0e57', false);
  await new Promise(r => setTimeout(r, 200 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fe63d7114a2242e76e3c1f3c973f0e57', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(Start, End) {
	function generateMonthList(Start, End) {
	  const resultList = [];
	  const startDate = new Date(Start);
	  const endDate = new Date(End);
	
	  let current = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
	
	  while (current <= endDate) {
	    const value = current.getTime();
	    const label = current.toLocaleString('default', { month: 'long', year: 'numeric' });
	
	    resultList.push({ value, label });
	
	    // Move to the next month
	    current.setMonth(current.getMonth() + 1);
	  }
	
	  return resultList;
	}
	
	// Ensure to invoke the function correctly and capture the results
	const monthList = generateMonthList(Start, End);
	return monthList;
})((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'created')), (new Date())))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/21bcac8bbbd7ed3b8b7e9bde738d92f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Current_Month, Current_Year, Date_Select_List, End_Month, End_Year, Start_Month, Start_Year, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  Date_Select_List = [];
  Start_Year = (new Date((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'created'))).getFullYear());
  End_Year = (new Date((new Date())).getFullYear());
  Current_Year = Start_Year;
  console.log('abc');
  console.log('abc');
  console.log(new Date((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'created'))).getMonth());
  console.log(new Date((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'created'))));
}


  console.log((await (async function(Start, End) {
  	function generateMonthList(Start, End) {
  	  const resultList = [];
  	  const startDate = new Date(Start);
  	  const endDate = new Date(End);
  	
  	  let current = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
  	
  	  while (current <= endDate) {
  	    const value = current.getTime();
  	    const label = current.toLocaleString('default', { month: 'long', year: 'numeric' });
  	
  	    resultList.push({ value, label });
  	
  	    // Move to the next month
  	    current.setMonth(current.getMonth() + 1);
  	  }
  	
  	  return resultList;
  	}
  	
  	// Ensure to invoke the function correctly and capture the results
  	const monthList = generateMonthList(Start, End);
  	return monthList;
  })((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'created')), (new Date()))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/f464d5d69fa415ca6c74204ee7f881cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.dataModel, 'View'))))) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/36bfd6de388fa4c2b4aec47f80d638ac/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['TractorId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),'\' AND Type = \'Service\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
      ___arguments.context.pageData['Tractor - Service Images'] = ___arguments.selectedRecord;
  ;(async () => {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('99fa3318b10872d811a338a8bca8dc18');

  })();

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/FIFOFFICE/components/b6771da64fea415bd3e2d08913f79b1d/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Type = \'Repair\' AND TractorId = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),'\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
      ___arguments.context.pageData['Selected Repair Record'] = ___arguments.selectedRecord;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('971c994f6865a048aedc327eede1ff2a');

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/FIFOFFICE/components/3fb22dd6000819bccae9ae3a3d2895f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('4d18d34d2b471c9918d3340864b9ab53', undefined);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3fb22dd6000819bccae9ae3a3d2895f8'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3fb22dd6000819bccae9ae3a3d2895f8'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFOFFICE/components/d50b33f98d7b3139170bea669054c0f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getComponentDataStoreByUid('72c1a84a9203610cb2ccff4a7a7937bb')))) {
    Content = '';
  } else {
    Content = [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('72c1a84a9203610cb2ccff4a7a7937bb'), 'id')),' - ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('72c1a84a9203610cb2ccff4a7a7937bb'), 'customer'))].join('');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/94895df400aff3ed1b4fbaf10b0f0152/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
    Content = '';
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'Current Tracking Data'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Distance'))))) {
        Content = '';
      } else {
        Content = String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Distance')) + String(' km');
      }
    }
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/19583bb76fd7c7f3a05df892db1bc933/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
    Content = '';
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'Current Tracking Data'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Speed'))))) {
        Content = '';
      } else {
        Content = String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Speed')), 'Value')) + String(' kph');
        if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Speed')), 'Value')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Speed'))) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19583bb76fd7c7f3a05df892db1bc933'))['color'] = 'rgb(255, 165, 0)';
        } else {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19583bb76fd7c7f3a05df892db1bc933'))['color'] = 'rgb(255, 255, 255)';
        }
      }
    }
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var Content, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'Current Tracking Data'))))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Speed'))))) {
        } else {
          if ((getObjectProperty((getObjectProperty(AppData, 'Current Tracking Data')), 'Max Speed')) > (getObjectProperty(VehicleData, 'Can Max Speed'))) {
            Content = ({ [`color`]: 'rgb(255, 0, 0)' });
          } else {
            Content = ({ [`color`]: 'rgb(255, 255, 255)' });
          }
        }
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/0816922d47abeb786133d728b7ed93f1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
    Content = '';
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'Current Tracking Data'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max RPM'))))) {
        Content = '';
      } else {
        Content = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max RPM')), 'Value'));
        if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max RPM')), 'Value')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max RPM'))) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0816922d47abeb786133d728b7ed93f1'))['color'] = 'rgb(255, 165, 0)';
        } else {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0816922d47abeb786133d728b7ed93f1'))['color'] = 'rgb(255, 255, 255)';
        }
      }
    }
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/d349b0f47f75d121cc434ad3d9898713/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
    Content = '';
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'Current Tracking Data'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Temp'))))) {
        Content = '';
      } else {
        Content = String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Temp')), 'Value')) + String('°C');
        if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Temp')), 'Value')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Can Max Temp'))) {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d349b0f47f75d121cc434ad3d9898713'))['color'] = 'rgb(255, 165, 0)';
        } else {
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d349b0f47f75d121cc434ad3d9898713'))['color'] = 'rgb(255, 255, 255)';
        }
      }
    }
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/fd27b5e77e1cb4ded88a09fdd383e333/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Distance'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/a9740276b4a4396fa63648c3e00c09f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('19583bb76fd7c7f3a05df892db1bc933'));
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Speed')), 'Item')), 'position.latitude')), (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Speed')), 'Item')), 'position.longitude')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', 18);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/8615911897f633bcaad59bde0de4ea5e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max RPM')), 'Item')), 'position.latitude')), (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max RPM')), 'Item')), 'position.longitude')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', 18);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/2371a6e40222902ea267cb0c4bfd0e8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Temp')), 'Item')), 'position.latitude')), (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Max Temp')), 'Item')), 'position.longitude')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', 18);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/787e874e6a5bb793c51d269786c7b94b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('013f31913099c835aaa7b3e9bb839aca', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/571f248a4d288a73408147380ab4a7d6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Transaction, Repair, Financial_Transaction, objectId;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function New_Repair_Function() {
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    objectId = (generateUUID().long());
    Repair = (_uow.create('Maintenance', ({ [`CapturedBy`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name')),[`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Cost')),[`EarningsPerHour`]: ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Mileage_Target'))) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Target_Driving_Hours')),[`Date_Completed`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Date')),[`Date_Scheduled`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'DateSch')),[`Date_Started`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'DateStart')),[`Description`]: ['Repair (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Component')),')'].join(''),[`Invoice`]: undefined,[`Images`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'File')),[`Mileage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Mileage')),[`Mileage Due`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Mileage')),[`Notes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Notes')),[`Repair_Component`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Component')),[`Status`]: 'Completed',[`Supplier`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('1c3e26f8092b560aa158d5a903273868')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c3e26f8092b560aa158d5a903273868')), 'value')))),[`TractorId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),[`TrailerId`]: undefined,[`Type`]: 'Repair',[`Vehicle Type`]: 'Tractor',[`objectId`]: objectId,[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ownerId')) })));
    Financial_Transaction = (_uow.create('Transactions', ({ [`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Cost')),[`Description`]: ['Repair (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Component')),') - ',objectId].join(''),[`objectId`]: objectId,[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ownerId')) })));
    _uow.setRelation('Maintenance', Repair, 'Transaction', [Financial_Transaction]);
    _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), 'Maintenance', [Repair]);

  })();

  return (await Transaction.execute())
}


  console.log(await New_Repair_Function());
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('013f31913099c835aaa7b3e9bb839aca', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0bcad0c4c147b7d2435a3ccfd35f2fe4')), 'value')))) && !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('853ddd6acc6f5ccdc61948140a4b1ebd')), 'value')))) && !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bbbaa52e73fc704c2fcdc68b0e531b5b')), 'value')))) && !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('64defe47907a9f9baf4e7f96a20fb7fe')), 'value')))) && !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4a8d26cc2f99d65bd092dc2cf4e283f')), 'value')))) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('057a1472ad9d2f6f840174e8ec49f2e5')), 'display')) == false) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/853ddd6acc6f5ccdc61948140a4b1ebd/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/bbbaa52e73fc704c2fcdc68b0e531b5b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tractor_Range')) || ___arguments.value < (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) - 5000) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('057a1472ad9d2f6f840174e8ec49f2e5', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('057a1472ad9d2f6f840174e8ec49f2e5', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/d2364cfe77d9529e1659e353ee73748c/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tanks'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/ab36dfab509650711dc842cc072eaac7/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`height`]: 200 * ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3e3dc51578caefef68326f05f6d5eefa'), 'Level')) / 100) })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/2f388c265d1be50c9bb302d37972646f/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`backgroundColor`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3e3dc51578caefef68326f05f6d5eefa'), 'Color')) })

  },
  /* handler:onStyleAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2f388c265d1be50c9bb302d37972646f'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/2f15adf52a6f741ab6c8fb412385dccd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('99f282ff0c2737e9f9837e2932fc5155', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/502de53da6dfd035e7f390217196542f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('99f282ff0c2737e9f9837e2932fc5155', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/1c3e26f8092b560aa158d5a903273868/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
      } else {
        List = (await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


         return ((getObjectProperty(item, 'Type')) == 'Service Centre');
        })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Name')) });})));
      }
    }
  }

  return ([({ [`value`]: 'In House',[`label`]: 'In House' })].concat(List))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/7b91288aa6dd47a1228e1bb7d7fba318/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/52fae095c4b1c574dfb7b96ef353491a/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/746112dd8af8b83be97e23c2a449dd2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Unscheduled Services')) == false) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_ID'))))) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f3e9c22366f902aef4819ddad8b9b81a', undefined);
    } else {
      await new Promise(r => setTimeout(r, 300 || 0));
      ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Service Item'] = ((await Backendless.Data.of('Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Service_ID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_ID')),'\''].join(''))).setPageSize(10)))[0]);
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Tractor',[`Vehicle`]: ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'),[`Odometer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) }));
    }
  } else {
    await new Promise(r => setTimeout(r, 300 || 0));
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Tractor',[`Vehicle`]: ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'),[`Odometer`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Odometer')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/61ac86def8c54d1cb399ca223973a45a/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  async ['onContainerDataAssignment'](___arguments) {
    var item, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  var j_list = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Assets Drawer - Selected Tyre Vehicle')), 'Axles_Data')), 1, async (item) => {


   return (getObjectProperty(item, 'Position Number'));
  }));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['Vehicle Id '] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Assets Drawer - Selected Tyre Vehicle')), 'objectid'));
  }

  return (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Assets Drawer - Selected Tyre Vehicle')), 'Axles_Data')), 1, async (item) => {


 return (getObjectProperty(item, 'Position Number'));
}))

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/8072aef91067aa86d66c855f221a650b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Unscheduled Services')) == false) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Last_Service_ID'))))) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f3e9c22366f902aef4819ddad8b9b81a', undefined);
    } else {
      await new Promise(r => setTimeout(r, 300 || 0));
      ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Service Item'] = ((await Backendless.Data.of('Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Service_ID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_ID')),'\''].join(''))).setPageSize(10)))[0]);
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Trailer1',[`Vehicle`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')),[`Odometer`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Odometer')) }));
    }
  } else {
    await new Promise(r => setTimeout(r, 300 || 0));
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Trailer1',[`Vehicle`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')),[`Odometer`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'Odometer')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/93c6c4767b98a228e3aed8f441e5a90c/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['TrailerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'objectId')),'\' AND Type = \'Service\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/1dffe62541f10f45400dfa130391d9d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Unscheduled Services')) == false) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Last_Service_ID'))))) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f3e9c22366f902aef4819ddad8b9b81a', undefined);
    } else {
      await new Promise(r => setTimeout(r, 300 || 0));
      ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Service Item'] = ((await Backendless.Data.of('Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Service_ID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Last_Service_ID')),'\''].join(''))).setPageSize(10)))[0]);
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Trailer',[`Vehicle`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')),[`Odometer`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Odometer')) }));
    }
  } else {
    await new Promise(r => setTimeout(r, 300 || 0));
    await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('df25f1ce96461ed6fd8c75fe6ed69ec3', undefined);
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('a9fb2519d23f5b8201cc6f756ec64c1f', ({ [`Vehicle Type`]: 'Trailer',[`Vehicle`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')),[`Odometer`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer2')), 'Odometer')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/bbf57a4d28ae11aa80679d38929fe3ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('6c0c70c60321bbe1081cec3d9873d795', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/160246081a7efe03b909109a85b4d45d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('869b391ff70a54fcd53832025a3c7a85', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/66096308fbdad78fe78d9c338c260c16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('ac14a4d75a16a708740c4a175513728b', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/f62acc4a838defe856eb77e637549c56/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('51bce592fcaee421316c7753054507b9', undefined);
  ___arguments.context.appData['Trailer Repair Data'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/10b1229e8784cb6bfabba6d7d25c9adf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('51bce592fcaee421316c7753054507b9', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/6b4557f2538a229ac9795e5c3ef4f831/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['TrailerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1')), 'objectId')),'\' AND Type = \'Repair\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/48343fb5b3030e1e3d3ff3e6326dba19/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'Asset Drawer Data')) == 'Tyres') {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/fc02ba775a55a0b219030d66faff0309/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Road'] = true;
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['House'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Retread'];

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/b013a1833365e719232fb03973284167/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'House')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Status = \'All In Order\' AND Warehouse = \'In\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/06f6535726c19eb2611a6d8946712956/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Retread')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Status = \'In For Retread\''].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
      ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Retread Tyre'] = ___arguments.selectedRecord;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('d6b4c70246e4305a053c674ed16e94d9');

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/FIFOFFICE/components/e1471dcb75a1a0a611d1fce8cb85856a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['House'] = true;
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Road'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Retread'];

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/cbd7fd23544b22ee8b7bdd5e2e139443/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Retread'] = true;
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['House'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Road'];

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/85c3d4b9fde675b92857f0248c81cf21/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('d6b4c70246e4305a053c674ed16e94d9');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/d409a0d297652997669f2aaef735e2dc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Tyre = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Retread Tyre')), 'objectId')), ));
  if ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Retread Tyre')), 'State')) == 'Cap 1') {
    Tyre['Cost_Cap1'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7e57b29c7c97671d139e968677f4c6fb')), 'value'));
    Tyre['Mileage_Expected'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b8afaa6e651e3182186880cbe4b5b9ee')), 'value'));
    Tyre['Status'] = 'All In Order';
    Tyre['Warehouse'] = 'In';
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Retread Tyre')), 'State')) == 'Cap 2') {
    Tyre['Cost_Cap2'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7e57b29c7c97671d139e968677f4c6fb')), 'value'));
    Tyre['Mileage_Expected'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b8afaa6e651e3182186880cbe4b5b9ee')), 'value'));
    Tyre['Status'] = 'All In Order';
    Tyre['Warehouse'] = 'In';
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Retread Tyre')), 'State')) == 'Cap 3') {
    Tyre['Cost_Cap3'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7e57b29c7c97671d139e968677f4c6fb')), 'value'));
    Tyre['Mileage_Expected'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b8afaa6e651e3182186880cbe4b5b9ee')), 'value'));
    Tyre['Status'] = 'All In Order';
    Tyre['Warehouse'] = 'In';
  }
  await Backendless.Data.of('Tyres').save( Tyre );
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('06f6535726c19eb2611a6d8946712956');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('b013a1833365e719232fb03973284167');
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('d6b4c70246e4305a053c674ed16e94d9');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/7265fec2bd6f39c8ca73bb6660543fcd/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var error;


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Road'] = true;
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['House'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Retread'];

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onMounted */
  /* handler:onBeforeUnmount */
  ['onBeforeUnmount'](___arguments) {
    var error;


  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Road'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['House'];

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Retread'];

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onBeforeUnmount */
  /* content */
}))

define('./pages/FIFOFFICE/components/25642d33cef2bbd45843b5fc49464034/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  var repeat_end = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fc9e678e1659eeae97c20b3d138e6f9b')), 'value'));
  for (var count = 0; count < repeat_end; count++) {
    await BackendlessUI.Functions.Custom['fn_b3cdf4a3ed5a52efed2ea82b1ec2cb92'](___arguments.context.appData, null, null, 'Steer', (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('640329050f47c54f50b7596f467f6e1c')), 'value')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0edce35130418084cb7bdb773db8cb91')), 'value')));
  }
  var repeat_end2 = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9fcfef8d30f930e463b57425ce738d74')), 'value'));
  for (var count2 = 0; count2 < repeat_end2; count2++) {
    await BackendlessUI.Functions.Custom['fn_b3cdf4a3ed5a52efed2ea82b1ec2cb92'](___arguments.context.appData, null, null, 'Drive', (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a2ea461f751ca335f1a75c660ce6357a')), 'value')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ab72353e108c6138c897f795340dbbb4')), 'value')));
  }
  var repeat_end3 = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c276669585d5193152042a77a868d34b')), 'value'));
  for (var count3 = 0; count3 < repeat_end3; count3++) {
    await BackendlessUI.Functions.Custom['fn_b3cdf4a3ed5a52efed2ea82b1ec2cb92'](___arguments.context.appData, null, null, 'Trailer', (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('106fcf5158bd592f5438548ab0414e19')), 'value')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56a578fb1c7d81b9102e3057e12562f3')), 'value')));
  }
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('06f6535726c19eb2611a6d8946712956');
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('b013a1833365e719232fb03973284167');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7e94eb266677922f143fd0e412b2797c');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/fae1946bb9353d06d049d40a84ec5c27/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7e94eb266677922f143fd0e412b2797c');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/366a1ddb107df96c9e6a0e714e1fad59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('7e94eb266677922f143fd0e412b2797c');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/847d796244369b94e1f3efbdb7bdd5d5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Admin')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/192c87edffbab503c7bd2ae20c4c5b35/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('99a457935c8e264aa892775f6b25d371', undefined);
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('12ffcd2a0f5af80bebf447edfaf53caf', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/14557f87afd9edb143b71d23f35513ad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Tractor_Fixed_Expenses'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/f9173e45b5dbfb11396be3d3b87d617f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Tractor_Fixed_Expenses'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/8f1c31582c87db11f66a5569583d87e8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Trailer_Fixed_Expenses'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/7f8fb7a6e20629b1aed83fc3bf5b3a65/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Trailer_Fixed_Expenses'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/4106b032e6188a1636ef765f9c8b1c36/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Total_Expenses'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/2934715d06446c22520f5fbbc5fd7e6a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb'](((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Tyre_CPK_Estimated')) * (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Distance_Travelled_Mileage')))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/a22e6ec71565610242645e7c3a896484/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Fleetview_Current')), 'Projected_Commission'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/201c780c0df7bd0821e373cf5adf3f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item, j, list, Maint__Item, Trailer_Cost_List, Trailer_Maint__Cost, Trailer_Maint__List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  Trailer_Maint__List = (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')).map(async item => {; return (getObjectProperty(item, 'Maintenance'));})));
  Trailer_Cost_List = [];
  for (var j_index in Trailer_Maint__List) {
    j = Trailer_Maint__List[j_index];
    try {
      if (0 <= (getObjectProperty(j, 'Cost'))) {
        addItemToList(Trailer_Cost_List, (getObjectProperty(j, 'Cost')));
      }

    } catch (error) {

    }
  }
  if (Trailer_Cost_List.length == 0) {
    Trailer_Maint__Cost = 0;
  } else {
    Trailer_Maint__Cost = Trailer_Maint__List.reduce(function(x, y) {return x + y;});
  }
  ___arguments.context.pageData['Finances'] = ({ [`Turnover`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Turnover'));}))).reduce(function(x, y) {return x + y;}),[`Tractor_Fixed_Expenses`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tractor_Fixed_Expenses'));}))).reduce(function(x, y) {return x + y;}),[`Trailer_Fixed_Expenses`]: true ? (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')).map(async item => {; return (getObjectProperty(item, 'Cost Fixed'));}))).reduce(function(x, y) {return x + y;}) : (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Trailer_Fixed_Expenses'));}))).reduce(function(x, y) {return x + y;}),[`Fuel_Cost`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Fuel_Cost'));}))).reduce(function(x, y) {return x + y;}),[`Toll_Fees`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Toll_Fees'));}))).reduce(function(x, y) {return x + y;}),[`Toll_Fees_Per_Km_Total`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Toll_Fees_Per_Km_Total'));}))).reduce(function(x, y) {return x + y;}),[`Maintenance_Plan_Per_Km_Total`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Maintenance_Plan_Per_Km_Total'));}))).reduce(function(x, y) {return x + y;}),[`Maintenance_Repairs_Tractor`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Maintenance_Repairs_Tractor'));}))).reduce(function(x, y) {return x + y;}),[`Maintenance_Repairs_Trailers`]: Trailer_Maint__Cost,[`Tyres`]: true ? (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tyre_Expenses_Actual'));}))).reduce(function(x, y) {return x + y;}) : (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return ((getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Distance_Travelled_Mileage')) * (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tyre_CPK_Estimated')));}))).reduce(function(x, y) {return x + y;}),[`Salary_Wages`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Salary_Wages'));}))).reduce(function(x, y) {return x + y;}),[`Profit_Target`]: true ? 0 : (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Profit_Target'));}))).reduce(function(x, y) {return x + y;}),[`Projected_Commission`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Projected_Commission'));}))).reduce(function(x, y) {return x + y;}),[`Total_Costs`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tractor_Fixed_Expenses'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Trailer_Fixed_Expenses'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Fuel_Cost'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Toll_Fees'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Toll_Fees_Per_Km_Total'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Maintenance_Plan_Per_Km_Total'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Maintenance_Repairs_Tractor'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Maintenance_Repairs_Trailers'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return ((getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Distance_Travelled_Mileage')) * (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tyre_CPK_Estimated')));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Salary_Wages'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Profit_Target'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Projected_Commission'));}))).reduce(function(x, y) {return x + y;}),[`Profit_Loss`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Turnover'));}))).reduce(function(x, y) {return x + y;}) - ((await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tractor_Fixed_Expenses'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Trailer_Fixed_Expenses'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Fuel_Cost'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Toll_Fees'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Toll_Fees_Per_Km_Total'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Maintenance_Plan_Per_Km_Total'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Maintenance_Repairs_Tractor'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Maintenance_Repairs_Trailers'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return ((getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Distance_Travelled_Mileage')) * (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Tyre_CPK_Estimated')));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Salary_Wages'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Profit_Target'));}))).reduce(function(x, y) {return x + y;}) + (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).map(async item => {; return (getObjectProperty((getObjectProperty(item, 'Current_Fleetview')), 'Projected_Commission'));}))).reduce(function(x, y) {return x + y;})) });
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f813fb43f2122249c3b3202a6f0b4ede', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/8f02235da2375e9add26df83fe141b7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('f813fb43f2122249c3b3202a6f0b4ede', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/2de26ebd615a90e7bed2029aa664854c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Turnover'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/4ab8e7af9cae6fac98634a030e1e3d4f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Tractor_Fixed_Expenses'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/48d5f955fefad0b1a33fc319fc582f02/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Trailer_Fixed_Expenses'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/891a306c7ca2f02d42a3e366f93d3d05/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Fuel_Cost'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/ddcf8662c8bbf492627c1511fdb2ef8e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3'](((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Toll_Fees')) + (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Toll_Fees_Per_Km_Total')))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/5b8f32d160141f4244c607b12bfa2ebc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3'](((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Maintenance_Plan_Per_Km_Total')) + (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Maintenance_Repairs_Tractor')) + (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Maintenance_Repairs_Trailers')))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/635f6eab79b7951b97fe3b0410464f8a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Tyres'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/3c0740245c0912f954ae918c265cf8d3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Salary_Wages'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/1e8a2709c56ea76f856c12f6cd927dfd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Profit_Target'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/508559aa1da6b7d5f66b2959309eca6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Projected_Commission'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/44fb297ae51581e63279fb53e5a6f586/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Total_Costs'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/c17c32e4f98bf4d137916cea51b51c91/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Profit_Loss')) < 0 ? ['( R ',(await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3'](((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Profit_Loss')) * -1))))),' )'].join('') : String('R ') + String((await BackendlessUI.Functions.Custom['fn_4c94c282f3fa96b6ee1128b33a8969cb']((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Finances')), 'Profit_Loss'))))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/a87518aa0381d35961abedec014e3c84/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Employee;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  Employee = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


   return ((getObjectProperty(item, 'Company_ID')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Company_ID')));
  }))[0];

  return ([({ [`value`]: (getObjectProperty((getObjectProperty(Employee, 'Wages_Current')), 'objectId')),[`label`]: (getObjectProperty((getObjectProperty(Employee, 'Wages_Current')), 'Month_Year')),[`Data`]: (getObjectProperty(Employee, 'Wages_Current')) })].concat((await Promise.all((await asyncListSort((getObjectProperty(Employee, 'Wages_Historical')), 1, async (item) => {


 return (getObjectProperty(item, 'created'));
})).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Month_Year')),[`Data`]: item });})))))

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Salary, Payslip, PDF_Data, File_Name, item, Employee, Employee_Data, URL2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  Salary = (getObjectProperty(((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('a87518aa0381d35961abedec014e3c84')), async (item) => {


   return ((getObjectProperty(item, 'value')) == ___arguments.value);
  }))[0]), 'Data'));
  Employee = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


   return ((getObjectProperty(item, 'Company_ID')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Company_ID')));
  }))[0];
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Salary, 'Payslip'))))) {
    Employee_Data = (getObjectProperty(___arguments.context.pageData, 'HR - Selected Record'));
    File_Name = ['Payslip','(',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](([(getObjectProperty(Employee_Data, 'Employee_Details_ID_Number')),'(',(getObjectProperty(Salary, 'created')),')'].join('')))),')'].join('');
    URL2 = ['https://backendlessappcontent.com/FB172318-89F2-E225-FF10-9AC9657A9000/15CB006B-69A7-477E-9D2F-3B75BC06A165/files/pdf/',['Payslip','%28',(getObjectProperty(Salary, 'objectId')),'%29'].join(''),'.pdf'].join('');
    PDF_Data = ({ [`DATE`]: ((new Date((await BackendlessUI.Functions.Custom['fn_7b787368d76d5cd2f383609f56ef4594']((getObjectProperty(Salary, 'created')))))).toLocaleDateString()),[`START`]: ((new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Commencement')))).toLocaleDateString()),[`QR`]: URL2,[`CLOGO`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Logo')),[`CNAME`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Registered_Name')),[`A1`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Physical_Address')),[`A2`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Postal_Code')),[`Phone`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Phone_1')),[`Email`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_Email_Admin')),[`AVATAR`]: (getObjectProperty(Employee_Data, 'Avatar')),[`EFORE`]: (getObjectProperty(Employee_Data, 'Employee_Details_Forenames')),[`ESUR`]: (getObjectProperty(Employee_Data, 'Employee_Details_Surname')),[`NICKNAME`]: (getObjectProperty(Employee_Data, 'Employee_Details_Nickname')),[`CID`]: (getObjectProperty(Employee_Data, 'Company_ID')),[`ID`]: (getObjectProperty(Employee_Data, 'Employee_Details_ID_Number')),[`TAX`]: (getObjectProperty(Employee_Data, 'Employee_Details_Tax_Reference_Number')),[`CUIF`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_UIF_Number')),[`CPAYE`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Company_PAYE_Number')),[`ED1`]: 'Basic Salary',[`ED2`]: 'Per Km',[`ED3`]: 'Per Unit',[`ED4`]: 'Good Driving Bonus',[`ED5`]: 'Target Mileage Bonus',[`ED6`]: 'Target Unit Bonus',[`ED7`]: 'Sleep Out Pay',[`ED8`]: undefined,[`ED9`]: 'Medical Aid',[`ED10`]: 'Provident Fund (Emplorer)',[`EU1`]: undefined,[`EU2`]: [(getObjectProperty(Salary, 'Distance Traveled')),'km @ R',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Wages_Rate_Contractor_Mileage')))) ? '0.00' : (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Wages_Rate_Contractor_Mileage')), null, null))].join(''),[`EU3`]: [(getObjectProperty(Salary, 'Tonnage Moved')),' @ R',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Wages_Rate_Contractor_Tonnage')))) ? '0.00' : (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Wages_Rate_Contractor_Tonnage')), null, null))].join(''),[`EU4`]: undefined,[`EU5`]: [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Salary, 'Wages_Rate_Target_Mileage_Start')))) ? '0' : (getObjectProperty(Salary, 'Distance Traveled')) - (getObjectProperty(Salary, 'Wages_Rate_Target_Mileage_Start')),' @ R',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Wages_Rate_Target_Mileage')))) ? '0.00' : (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Wages_Rate_Target_Mileage')), null, null))].join(''),[`EU6`]: [(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Salary, 'Wages_Rate_Target_Tonnage_Start')))) ? '0' : (getObjectProperty(Salary, 'Distance Traveled')) - (getObjectProperty(Salary, 'Wages_Rate_Target_Tonnage_Start')),' @ R',(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Wages_Rate_Target_Tonnage')))) ? '0.00' : (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'HR - Selected Record')), 'Wages_Rate_Target_Tonnage')), null, null))].join(''),[`EU7`]: undefined,[`EU8`]: undefined,[`EU9`]: undefined,[`EU10`]: undefined,[`EV1`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Basic_Salary')), 'R', null)),[`EV2`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Contractor_Per_Km')), 'R', null)),[`EV3`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Contractor_Tonnage')), 'R', null)),[`EV4`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Good_Driving_Bonus')), 'R', null)),[`EV5`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Target_Mileage_Bonus')), 'R', null)),[`EV6`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Target_Tonnage_Bonus')), 'R', null)),[`EV7`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Sleep_Out_Pay')), 'R', null)),[`EV8`]: undefined,[`EV9`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Medical_Aid')), 'R', null)),[`EV10`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b'](((getObjectProperty(Salary, 'Provident_Pension_Fund')) * 0.5161), 'R', null)),[`DD1`]: 'Provident Fund',[`DD2`]: 'UIF',[`DD3`]: 'Council & Union Levies',[`DD4`]: undefined,[`DD5`]: 'Calculated Tax',[`DD6`]: undefined,[`DD7`]: undefined,[`DD8`]: undefined,[`DD9`]: undefined,[`DD10`]: undefined,[`DU1`]: undefined,[`DU2`]: undefined,[`DU3`]: undefined,[`DU4`]: undefined,[`DU5`]: undefined,[`DU6`]: undefined,[`DU7`]: undefined,[`DU8`]: undefined,[`DU9`]: undefined,[`DU10`]: undefined,[`DV1`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Provident_Pension_Fund')), 'R', null)),[`DV2`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b'](((getObjectProperty(Salary, 'UIF_EMPLOYEE')) * 1), 'R', null)),[`DV3`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b'](((getObjectProperty(Salary, 'Bargaining_Council_and_Union_Levies')) * 1), 'R', null)),[`DV4`]: undefined,[`DV5`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b'](((getObjectProperty(Salary, 'Tax')) * 1), 'R', null)),[`DV6`]: undefined,[`DV7`]: undefined,[`DV8`]: undefined,[`DV9`]: undefined,[`DV10`]: undefined,[`ETOTAL`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Taxable')), 'R', null)),[`DTOTAL`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Deductions')), 'R', null)),[`NETT`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((getObjectProperty(Salary, 'Nett')), 'R', null)),[`TEARN`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((([(getObjectProperty((getObjectProperty(Employee, 'Wages_Current')), 'Taxable'))].concat((await Promise.all((await asyncListSort((getObjectProperty(Employee, 'Wages_Historical')), 1, async (item) => {


     return (getObjectProperty(item, 'created'));
    })).map(async item => {; return (getObjectProperty(item, 'Taxable'));}))))).reduce(function(x, y) {return x + y;})), 'R', null)),[`CCONTR`]: (await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((([(getObjectProperty((getObjectProperty(Employee, 'Wages_Current')), 'Company_Contribution'))].concat((await Promise.all((await asyncListSort((getObjectProperty(Employee, 'Wages_Historical')), 1, async (item) => {


     return (getObjectProperty(item, 'created'));
    })).map(async item => {; return (getObjectProperty(item, 'Company_Contribution'));}))))).reduce(function(x, y) {return x + y;})), 'R', null)),[`ADDDATA`]: undefined });
    console.log(PDF_Data);
    ___arguments.context.pageData['PDF Test'] = (await Backendless.Request.post(`${Backendless.appPath}/services/PDFGeneratorAPI/${'1169565'}/data-output/${File_Name}`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'data': PDF_Data }));
    console.log(getObjectProperty(___arguments.context.pageData, 'PDF Test'));
    Salary['Payslip'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'PDF Test')), 'fileUrl'));
    await Backendless.Data.of('Salaries').save(Salary, true);
    ___arguments.context.pageData['Payslip_PDF'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'PDF Test')), 'fileUrl'));
  } else {
    ___arguments.context.pageData['Payslip_PDF'] = (getObjectProperty(Salary, 'Payslip'));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/4076ef5f73d9a3c54c1b6f928d55fe12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Payslip_PDF'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:pdfUrlLogic */
  ['pdfUrlLogic'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Payslip_PDF'))

  },
  /* handler:pdfUrlLogic */
  /* content */
}))

define('./pages/FIFOFFICE/components/b085b36aaa41d90c2ea457b9fa09e664/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Admin')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/29349af3a54c1bea4a565902c1e5ec55/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Admin')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/62d42f136808620cffeebaa2e72457dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Admin')) == true) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/8084fe54cf25f761165b327de312a32a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Admin')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/919998ef469e8d657ab8c57dfdea4a0c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Fuel Consumption Record')), 'Litres')) + String(' l')), null))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/e553964d7aa94eaccb879f14e3710654/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'FIF')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('103b3004da69835bc0b3e0e9f2e54c71', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/934b5c16dfde1dfb644420b91dd66057/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectCreate */
  async ['onObjectCreate'](___arguments) {
    var Axles, Bulk_Created_Axles, Created_Fleet_View, Double_Wheel_Axles, Double_Wheel_Text, ID, Single_Wheel_Axles, Single_Wheel_Text, Steer_Wheel_Axles, Steer_Wheel_Text, Transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Axles = [];
  Steer_Wheel_Axles = [];
  Single_Wheel_Axles = [];
  Double_Wheel_Axles = [];
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Steer1'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Steer1'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 1,[`Type`]: 'Steer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Steer1')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      addItemToList(Steer_Wheel_Axles, true);
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Steer2'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Steer2'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 2,[`Type`]: 'Steer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Steer2')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      addItemToList(Steer_Wheel_Axles, true);
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Drive1'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Drive1'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 3,[`Type`]: 'Drive',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Drive1')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Drive1')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Drive1')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Drive2'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Drive2'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 4,[`Type`]: 'Drive',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Drive2')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Drive2')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Drive2')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Drive3'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Drive3'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 5,[`Type`]: 'Drive',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Drive3')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Drive3')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Drive3')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Spare_1'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Spare_1'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 7,[`Type`]: 'Spare',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Spare_1')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Spare_2'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Spare_2'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 8,[`Type`]: 'Spare',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Spare_2')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Spare_3'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Spare_3'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 9,[`Type`]: 'Spare',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Spare_3')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
    }
  }
  if (Steer_Wheel_Axles.length == 0) {
    Steer_Wheel_Text = null;
  } else if (Steer_Wheel_Axles.length == 1) {
    Steer_Wheel_Text = 'Steer Axle (1)';
  } else if (Steer_Wheel_Axles.length == 2) {
    Steer_Wheel_Text = 'Steer Axle (2)';
  }
  if (Single_Wheel_Axles.length == 0) {
    Single_Wheel_Text = null;
  } else if (Single_Wheel_Axles.length == 1) {
    Single_Wheel_Text = 'Drive Axle Single Wheel (1)';
  } else if (Single_Wheel_Axles.length == 2) {
    Single_Wheel_Text = 'Drive Axle Single Wheel (2)';
  } else if (Single_Wheel_Axles.length == 3) {
    Single_Wheel_Text = 'Drive Axle Single Wheel (3)';
  }
  if (Double_Wheel_Axles.length == 0) {
    Double_Wheel_Text = null;
  } else if (Double_Wheel_Axles.length == 1) {
    Double_Wheel_Text = 'Drive Axle Double Wheel (1)';
  } else if (Double_Wheel_Axles.length == 2) {
    Double_Wheel_Text = 'Drive Axle Double Wheel (2)';
  } else if (Double_Wheel_Axles.length == 3) {
    Double_Wheel_Text = 'Drive Axle Double Wheel (3)';
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Steer_Wheel_Text))) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Single_Wheel_Text))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Double_Wheel_Text))) {
      } else {
        ___arguments.newObject['Axles'] = Double_Wheel_Text;
      }
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Single_Wheel_Text))) {
      } else {
        ___arguments.newObject['Axles'] = ([Single_Wheel_Text,',',Double_Wheel_Text].join(''));
      }
    }
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Single_Wheel_Text))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Double_Wheel_Text))) {
        ___arguments.newObject['Axles'] = Steer_Wheel_Text;
      } else {
        ___arguments.newObject['Axles'] = ([Steer_Wheel_Text,',',Double_Wheel_Text].join(''));
      }
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Double_Wheel_Text))) {
        ___arguments.newObject['Axles'] = ([Steer_Wheel_Text,',',Single_Wheel_Text].join(''));
      } else {
        ___arguments.newObject['Axles'] = ([Steer_Wheel_Text,',',Single_Wheel_Text,',',Double_Wheel_Text].join(''));
      }
    }
  }
  ___arguments.newObject['ownerId'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId'));
  ID = (generateUUID().short());
  ___arguments.newObject['ID'] = ID;
  ___arguments.newObject['Registration'] = ID;
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Bulk_Created_Axles = (_uow.bulkCreate('Axles', Axles));
    _uow.update('Tractors', ___arguments.newObject);
    _uow.setRelation('Tractors', ___arguments.newObject, 'Axles_Data', Bulk_Created_Axles);
    _uow.setRelation('Tractors', ___arguments.newObject, 'Company', [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'objectId'))]);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors', [___arguments.newObject]);
    Created_Fleet_View = (_uow.create('Fleetview', ({ [`Current_Mileage`]: 0,[`Distance_Travelled`]: 0,[`Distance_Travelled_Mileage`]: 0,[`Fuel_Consumption_Ideal`]: 0,[`Fuel_Cost`]: 0,[`Fuel_Litres`]: 0,[`Gain_Loss_On_Loading_Delays`]: 0,[`Gain_Loss_On_Loading_Mileage`]: 0,[`Gain_Loss_On_Loading_Tonnage`]: 0,[`Licenses_Due`]: undefined,[`Maintenance_Plan_Per_Km_Total`]: 0,[`Maintenance_Repairs_Tractor`]: 0,[`Maintenance_Repairs_Trailers`]: 0,[`Mileage_Target`]: 0,[`Now`]: (new Date()),[`Profit_Target`]: 0,[`Projected_Commission`]: 0,[`Salary_Wages`]: 0,[`Service_Notices`]: undefined,[`Toll_Fees`]: 0,[`Toll_Fees_Per_Km_Total`]: 0,[`Tonnage_Average`]: 0,[`Tonnage_Permissible`]: 0,[`Tonnage_Target`]: 0,[`Tonnage_Total`]: 0,[`Tractor_Fixed_Expenses`]: 0,[`Trailer_Fixed_Expenses`]: 0,[`Turnover`]: 0,[`Tyre_CPK_Estimated`]: 0,[`Tyre_Expenses_Actual`]: 0,[`Tyre_Expenses_Estimated`]: 0,[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) })));
    _uow.setRelation('Tractors', ___arguments.newObject, 'Fleetview_Current', [Created_Fleet_View]);
    _uow.setRelation('Tractors', ___arguments.newObject, 'Current_Fleetview', [Created_Fleet_View]);
    _uow.addToRelation('Tractors', ___arguments.newObject, 'Fleetview_Historical', [Created_Fleet_View]);

  })();

  console.log((await Transaction.execute()));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);

  },
  /* handler:onObjectCreate */
  /* content */
}))

define('./pages/FIFOFFICE/components/d199b4da0198f033af7edb25813bfd04/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var j, object, error;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Fleetview - (Listener Update)'] = (generateUUID().long());
  try {

    ;(function(whereClause) {
      const callback = async object => {
          console.log(object);
      var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if ((getObjectProperty(object, 'objectId')) == (getObjectProperty((getObjectProperty(j, 'Current_Fleetview')), 'objectId'))) {
          Object.assign((getObjectProperty(j, 'Current_Fleetview')), object);
          Object.assign((getObjectProperty(j, 'Fleetview_Current')), object);
        }
      }

      };

      const rtHandlers = Backendless.Data.of('Fleetview').rt();

      const options = [callback];

      if (whereClause) {
         options.unshift(whereClause);
      }

      rtHandlers.addUpdateListener.apply(rtHandlers, options);

      getRTSubscriptions().add((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - (Listener Update)')), () => rtHandlers.removeUpdateListener(callback));

    })((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\''].join('')));

  } catch (error) {

  }
  await new Promise(r => setTimeout(r, 1000 || 0));
  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Fleetview - (Listener Upsert)'] = (generateUUID().long());
  await new Promise(r => setTimeout(r, 1000 || 0));
  try {

    ;(function(whereClause) {
      const callback = async object => {
          console.log(object);
      var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'));
      for (var j_index2 in j_list2) {
        j = j_list2[j_index2];
        if ((getObjectProperty(object, 'objectId')) == (getObjectProperty((getObjectProperty(j, 'Current_Fleetview')), 'objectId'))) {
          Object.assign((getObjectProperty(j, 'Current_Fleetview')), object);
          Object.assign((getObjectProperty(j, 'Fleetview_Current')), object);
        }
      }

      };

      const rtHandlers = Backendless.Data.of('Fleetview').rt();

      const options = [callback];

      if (whereClause) {
         options.unshift(whereClause);
      }

      rtHandlers.addUpsertListener.apply(rtHandlers, options);

      getRTSubscriptions().add((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - (Listener Upsert)')), () => rtHandlers.removeUpsertListener(callback));

    })((['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\''].join('')));

  } catch (error) {

  }

  },
  /* handler:onMounted */
  /* handler:onBeforeUnmount */
  ['onBeforeUnmount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  getRTSubscriptions().remove((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - Load Planner (Listener Update) ')));
  getRTSubscriptions().remove((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Fleetview - (Listener Upsert)')));

  },
  /* handler:onBeforeUnmount */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fe63d7114a2242e76e3c1f3c973f0e57', false);
  await new Promise(r => setTimeout(r, 200 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fe63d7114a2242e76e3c1f3c973f0e57', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/4856c30fd8fe6206aabb2098a2cc5df3/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectCreate */
  async ['onObjectCreate'](___arguments) {
    var Axles, Bulk_Created_Axles, Double_Wheel_Axles, Double_Wheel_Text, ID, Single_Wheel_Axles, Single_Wheel_Text, Transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Axles = [];
  Single_Wheel_Axles = [];
  Double_Wheel_Axles = [];
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer1'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer1'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 1,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer1')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer1')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer1')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer2'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer2'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 2,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer2')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer2')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer2')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer3'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer3'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 3,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer3')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer3')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer3')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer4'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer4'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 4,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer4')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer4')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer4')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer5'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer5'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 5,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer5')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer5')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer5')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer6'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer6'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 6,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer6')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer6')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer6')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer7'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer7'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 7,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer7')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer7')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer7')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer8'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer8'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 8,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer8')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer8')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer8')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer9'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer9'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 9,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer9')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer9')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer9')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer10'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer10'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 10,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer10')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer10')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer10')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare1'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare1'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 11,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare1')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare2'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare2'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 12,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare2')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare3'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare3'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 13,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare3')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
    }
  }
  if (Single_Wheel_Axles.length == 0) {
    Single_Wheel_Text = null;
  } else if (Single_Wheel_Axles.length == 1) {
    Single_Wheel_Text = 'Single Wheel (1)';
  } else if (Single_Wheel_Axles.length == 2) {
    Single_Wheel_Text = 'Single Wheel (2)';
  } else if (Single_Wheel_Axles.length == 3) {
    Single_Wheel_Text = 'Single Wheel (3)';
  } else if (Single_Wheel_Axles.length == 4) {
    Single_Wheel_Text = 'Single Wheel (4)';
  } else if (Single_Wheel_Axles.length == 5) {
    Single_Wheel_Text = 'Single Wheel (5)';
  } else if (Single_Wheel_Axles.length == 6) {
    Single_Wheel_Text = 'Single Wheel (6)';
  } else if (Single_Wheel_Axles.length == 7) {
  } else if (Single_Wheel_Axles.length == 8) {
  } else if (Single_Wheel_Axles.length == 9) {
  } else if (Single_Wheel_Axles.length == 10) {
  }
  if (Double_Wheel_Axles.length == 0) {
    Double_Wheel_Axles = null;
  } else if (Double_Wheel_Axles.length == 1) {
    Double_Wheel_Text = 'Double Wheel (1)';
  } else if (Double_Wheel_Axles.length == 2) {
    Double_Wheel_Text = 'Double Wheel (2)';
  } else if (Double_Wheel_Axles.length == 3) {
    Double_Wheel_Text = 'Double Wheel (3)';
  } else if (Double_Wheel_Axles.length == 4) {
    Double_Wheel_Text = 'Double Wheel (4)';
  } else if (Double_Wheel_Axles.length == 5) {
    Double_Wheel_Text = 'Double Wheel (5)';
  } else if (Double_Wheel_Axles.length == 6) {
    Double_Wheel_Text = 'Double Wheel (6)';
  } else if (Single_Wheel_Axles.length == 7) {
  } else if (Single_Wheel_Axles.length == 8) {
  } else if (Single_Wheel_Axles.length == 9) {
  } else if (Single_Wheel_Axles.length == 10) {
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Single_Wheel_Text))) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Double_Wheel_Axles))) {
    } else {
      ___arguments.newObject['Axles'] = Double_Wheel_Axles;
    }
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Double_Wheel_Axles))) {
    } else {
      ___arguments.newObject['Axles'] = ([Single_Wheel_Text,',',Double_Wheel_Text].join(''));
    }
  }
  if ((getObjectProperty(___arguments.newObject, 'FIF_Dolly_Select')) == true) {
    ___arguments.newObject['Position'] = 'T2';
  }
  if ((getObjectProperty(___arguments.newObject, 'FIF_Follower_Select')) == true) {
    ___arguments.newObject['Position'] = 'T1,T2,T3';
  }
  if ((getObjectProperty(___arguments.newObject, 'FIF_Leader_Select')) == true) {
    ___arguments.newObject['Position'] = ['T1'];
  }
  ___arguments.newObject['ownerId'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId'));
  ID = (generateUUID().short());
  ___arguments.newObject['ID'] = ID;
  ___arguments.newObject['Registration'] = ID;
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Bulk_Created_Axles = (_uow.bulkCreate('Axles', Axles));
    _uow.update('Trailers', ___arguments.newObject);
    _uow.setRelation('Trailers', ___arguments.newObject, 'Axles_Data', Bulk_Created_Axles);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers', [___arguments.newObject]);

  })();

  console.log((await Transaction.execute()));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);

  },
  /* handler:onObjectCreate */
  /* content */
}))

define('./pages/FIFOFFICE/components/6861900d258c4b88706e5c87c799f649/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectCreate */
  async ['onObjectCreate'](___arguments) {
    var Axles, Bowser, Bowsers, Bulk_Created_Bowsers, ID, list, Transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Bowsers = [];
  var repeat_end = (getObjectProperty(___arguments.newObject, 'BowserNumber'));
  for (var count = 0; count < repeat_end; count++) {
    Bowser = ({ [`Name`]: (generateUUID().short()),[`Meter`]: 0,[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')),[`objectId`]: (generateUUID().long()) });
    addItemToList(Bowsers, Bowser);
  }
  ___arguments.newObject['ownerId'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId'));
  ID = (generateUUID().short());
  ___arguments.newObject['Name'] = ID;
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Bulk_Created_Bowsers = (_uow.bulkCreate('Bowsers', Bowsers));
    _uow.update('Tanks', ___arguments.newObject);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tanks', [___arguments.newObject]);
    _uow.setRelation('Tanks', ___arguments.newObject, 'Bowsers', Bulk_Created_Bowsers);

  })();

  console.log((await Transaction.execute()));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);

  },
  /* handler:onObjectCreate */
  /* content */
}))

define('./pages/FIFOFFICE/components/3c5758390996eca3a9354351427b0d67/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Employee_ID, Employee_Email, Employee_Number, Transaction, Employee_Details, User;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Conductor() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Employee_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')).length;
  Employee_ID = Employee_Number <= 10 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0000',Employee_Number].join('') : (Employee_Number <= 100 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 000',Employee_Number].join('') : (Employee_Number <= 1000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 00',Employee_Number].join('') : (Employee_Number <= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0',Employee_Number].join('') : (Employee_Number <= 100000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('')))));
  Employee_Email = [(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Employee_ID)),'@',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name'))))].join('');
}

/**
 * Describe this function...
 */
async function Admin() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Employee_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')).length;
  Employee_ID = Employee_Number <= 10 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0000',Employee_Number].join('') : (Employee_Number <= 100 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 000',Employee_Number].join('') : (Employee_Number <= 1000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 00',Employee_Number].join('') : (Employee_Number <= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0',Employee_Number].join('') : (Employee_Number <= 100000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('')))));
  Employee_Email = [(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Employee_ID)),'@',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name'))))].join('');
}

/**
 * Describe this function...
 */
async function Load_Planner() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Employee_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')).length;
  Employee_ID = Employee_Number <= 10 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0000',Employee_Number].join('') : (Employee_Number <= 100 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 000',Employee_Number].join('') : (Employee_Number <= 1000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 00',Employee_Number].join('') : (Employee_Number <= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0',Employee_Number].join('') : (Employee_Number <= 100000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('')))));
  Employee_Email = [(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Employee_ID)),'@',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name'))))].join('');
}

/**
 * Describe this function...
 */
async function Mechanic() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Employee_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')).length;
  Employee_ID = Employee_Number <= 10 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0000',Employee_Number].join('') : (Employee_Number <= 100 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 000',Employee_Number].join('') : (Employee_Number <= 1000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 00',Employee_Number].join('') : (Employee_Number <= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0',Employee_Number].join('') : (Employee_Number <= 100000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('')))));
  Employee_Email = [(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Employee_ID)),'@',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name'))))].join('');
}

/**
 * Describe this function...
 */
async function Attendant() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Employee_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')).length;
  Employee_ID = Employee_Number <= 10 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0000',Employee_Number].join('') : (Employee_Number <= 100 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 000',Employee_Number].join('') : (Employee_Number <= 1000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 00',Employee_Number].join('') : (Employee_Number <= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0',Employee_Number].join('') : (Employee_Number <= 100000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('')))));
  Employee_Email = [(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Employee_ID)),'@',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name'))))].join('');
}

/**
 * Describe this function...
 */
async function Driver() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Employee_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')).length;
  Employee_ID = Employee_Number <= 10 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0000',Employee_Number].join('') : (Employee_Number <= 100 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 000',Employee_Number].join('') : (Employee_Number <= 1000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 00',Employee_Number].join('') : (Employee_Number <= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0',Employee_Number].join('') : (Employee_Number <= 100000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('')))));
  Employee_Email = [(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Employee_ID)),'@',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')))),'.co.za'].join('').toLowerCase();
  console.log(Employee_Email);
  User = (await Backendless.UserService.register( new Backendless.User({ 'Email': Employee_Email,'password': '12345','App': 'Commercial','Level': 'Road','Name': Employee_ID,'Now': (new Date()),'Username': Employee_Email,'ownerId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }) ));
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    _uow.setRelation('Users', User, 'Company', [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))]);
    Employee_Details = (_uow.create('Employees', ({ [`Commencement`]: (new Date()),[`CID`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')),[`Company_ID`]: Employee_ID,[`Driver Ratings`]: ['Monthly Tonnage', 'Monthly Mileage', 'Fuel Consumption', 'Ideal Garages', 'Correct Loading'],[`Driver Target Mileage`]: 0,[`Driver Target Tonnage`]: 0,[`Driver_License_Code`]: 'EB',[`Driver_License_Expiry_Date`]: (new Date()),[`Driver_PDP_Expiry_Date`]: (new Date()),[`Driver_Warehouse_Status`]: 'In',[`Employee_Details_Nickname`]: Employee_ID,[`Employee_Details_Position`]: 'Driver',[`Now`]: (new Date()),[`Wages_Rate_Basic`]: 0,[`Wages_Rate_Contractor_Mileage`]: 0,[`Wages_Rate_Contractor_Tonnage`]: 0,[`Wages_Rate_Good_Driving`]: 0,[`Wages_Rate_Good_Planning_Mileage`]: 0,[`Wages_Rate_Good_Planning_Tonnage`]: 0,[`Wages_Rate_Sleep_Out`]: 0,[`Wages_Rate_Target_Mileage`]: 0,[`Wages_Rate_Target_Mileage_Start`]: 0,[`Wages_Rate_Target_Tonnage`]: 0,[`Wages_Rate_Target_Tonnage_Start`]: 0,[`ownerId`]: (getObjectProperty(User, 'objectId')) })));
    _uow.setRelation('Employees', Employee_Details, 'Company', [(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))]);
    _uow.setRelation('Users', User, 'Details', [Employee_Details]);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees', [Employee_Details]);

  })();

  console.log((await Transaction.execute()));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);
}


  if ('Driver' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c38359b6b32a2eb91939164745d67a2e')), 'value'))) {
    await Driver();
  } else if ('Conductor' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c38359b6b32a2eb91939164745d67a2e')), 'value'))) {
    await Conductor();
  } else if ('Load Planner' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c38359b6b32a2eb91939164745d67a2e')), 'value'))) {
    await Load_Planner();
  } else if ('Admin' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c38359b6b32a2eb91939164745d67a2e')), 'value'))) {
    await Admin();
  } else if ('Mechanic' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c38359b6b32a2eb91939164745d67a2e')), 'value'))) {
    await Mechanic();
  } else if ('Attendant' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c38359b6b32a2eb91939164745d67a2e')), 'value'))) {
    await Attendant();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/f0bc1b77c4e2b07e3083e2dc7e041175/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Profit_Loss_Projected')) < 0) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/f07872789a9af38f5ecca54dcd46ae33/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Profit_Loss_Projected')) > (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Profit_Target')) * 1.5) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/7aea89598cfaaafeb48d77cfffdf1fdb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Profit_Target'))))) {
    Content = 'No Target Set';
  } else {
    Content = ['(R ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Monthly_Profit_Target')),')'].join('');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/70ba960fb4f21f47f2d7d24d6ad36cd4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('99a457935c8e264aa892775f6b25d371', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/5882489891b8b06153186b63b17b88fa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Distance_Actual')) + String(' km');

  } catch (error) {
    if (error) {
      Input = '0 km';
    }

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/eef77f316ba162a9887725ecf06bc7d3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Distance_Unplanned')) + String(' km');

  } catch (error) {

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/14c8be2367b28de91d9ba874ad077ddd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))))) {
    Content = 'No Ideal Rate Set';
  } else {
    Content = String('R ') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'));
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/7282a2b99e92ff48fe668ad49f21bb28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, error, Unplanned_Mileage_Cost, k;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    Unplanned_Mileage_Cost = [];
    var k_list = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Loads'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      if ((getObjectProperty(k, 'Status')) == 'Delivered') {
        addItemToList(Unplanned_Mileage_Cost, ((getObjectProperty(k, 'Distance_Differential_LDP_To_DP')) * (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Cost Per Km (Variables)'))));
      }
    }
    Content = String('R ') + String((await BackendlessUI.Functions.Custom['fn_d1490e4c930834a26d0815f4661fa18b']((Unplanned_Mileage_Cost.reduce(function(x, y) {return x + y;})), null, null)));

  } catch (error) {
    console.log(error);

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/2ff2a8380042d96e1bd587bba75c1797/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Unplanned_Mileage_Cost, error, Content, j, k;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  try {
    Unplanned_Mileage_Cost = [];
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      var k_list = (getObjectProperty((getObjectProperty(j, 'Current_Fleetview')), 'Loads'));
      for (var k_index in k_list) {
        k = k_list[k_index];
        if ((getObjectProperty(k, 'Status')) == 'Delivered') {
          addItemToList(Unplanned_Mileage_Cost, ((getObjectProperty(k, 'Distance_Differential_LDP_To_DP')) * (getObjectProperty((getObjectProperty(j, 'Current_Fleetview')), 'Cost Per Km (Variables)'))));
        }
      }
    }
    Content = String('R ') + String((await BackendlessUI.Functions.Custom['fn_59242243104f0143a8cfead51a28beb3']((Unplanned_Mileage_Cost.reduce(function(x, y) {return x + y;})))));

  } catch (error) {
    console.log(error);

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/30e6591fbe6ca3bad316b55f32edf195/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Last_Location_ID, Last_Load, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Quick Load'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('64c99a9b58ffea63cdef471e3503be85', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('30e6591fbe6ca3bad316b55f32edf195', false);
  await new Promise(r => setTimeout(r, 200 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2fe7d4153d2a8742bcc1be3a9978b527', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('968b3289c278ef666606e2f7c75a8bfb', true);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('968b3289c278ef666606e2f7c75a8bfb')));
  Last_Load = (await asyncListFilter((await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'Loads')), -1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  })), async (item) => {


   return ((new Date()) > (getObjectProperty(item, 'Action Date')));
  })).slice(-1)[0];
  if ((getObjectProperty(Last_Load, 'Status')) == 'Delivered') {
    Last_Location_ID = (getObjectProperty(Last_Load, 'LDPID'));
  } else if ((getObjectProperty(Last_Load, 'Status')) == 'Loaded') {
    Last_Location_ID = (getObjectProperty(Last_Load, 'LLPID'));
  } else if ((getObjectProperty(Last_Load, 'Status')) == 'Planned') {
    Last_Location_ID = (getObjectProperty(Last_Load, 'LLDPID'));
  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('6ff5a7aa2a75a83cbe53dbbd19fa9bc6', Last_Location_ID);

  } catch (error) {

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('664377fad813557d34317e83353fed92');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('664377fad813557d34317e83353fed92');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFOFFICE/components/325807b83c25e78b816ae7a87ba98c06/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await BackendlessUI.Functions.Custom['fn_91894a831f2a6a0b26cbd0bea5bbaef8']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Load_Notes')), ''))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/572ad1ce59198071b015ab120f8cd87a/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('e94dd6878423bcafa2b99aa1c3573869');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('e94dd6878423bcafa2b99aa1c3573869');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('e3390c24d856e493716ad361d0896502', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/573e39ba835cbede34b34b5d9593e779/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b44c14361f47de7c7d87142cc9d351f7')), ({ [`New Delivery`]: (generateUUID().short()) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/0d177aaf43b7f14ac3bbfa2bc00bd0e4/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/4c0b8487d6ce981359966ade78114cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/05e69e4ed89121be124244774811b26d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/ecf14b0776f8f5c902ac3e156d577a9d/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/12d24b66f551ff3b7f0d6607a86e3539/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Open AI Session'] = (getObjectProperty((await Backendless.Request.post(`${Backendless.appPath}/services/OpenAI/session`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'aiModel': 'gpt-3.5-turbo' })), 'sessionId'));
  ___arguments.event['Start Point'] = ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ecf14b0776f8f5c902ac3e156d577a9d')));
  }))[0]);
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b44c14361f47de7c7d87142cc9d351f7'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['Customer Data'] = ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'Customer')));
    }))[0]);
    j['Load Point Data'] = ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'Load')));
    }))[0]);
    j['Delivery Point Data'] = ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(j, 'Delivery')));
    }))[0]);
    console.log(j);
  }
  console.log({ [`Start Point`]: ({ [`Name`]: (getObjectProperty((getObjectProperty(___arguments.event, 'Start Point')), 'Name')),[`Location`]: (getObjectProperty((getObjectProperty(___arguments.event, 'Start Point')), 'Point')),[`objectId`]: (getObjectProperty((getObjectProperty(___arguments.event, 'Start Point')), 'objectId')) }),[`Loads`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b44c14361f47de7c7d87142cc9d351f7')).map(async item => {; return ({ [`Load`]: ({ [`Name`]: (getObjectProperty((getObjectProperty(item, 'Load Point Data')), 'Name')),[`Location`]: (getObjectProperty((getObjectProperty(item, 'Load Point Data')), 'Point')),[`objectId`]: (getObjectProperty((getObjectProperty(item, 'Load Point Data')), 'objectId')) }),[`Delivery`]: ({ [`Name`]: (getObjectProperty((getObjectProperty(item, 'Delivery Point Data')), 'Name')),[`Location`]: (getObjectProperty((getObjectProperty(item, 'Delivery Point Data')), 'Point')),[`objectId`]: (getObjectProperty((getObjectProperty(item, 'Delivery Point Data')), 'objectId')) }) });}))) });
  console.log((await (async function(message, apiKey) {
  	async function reorderLocations(apiKey, promptMessage) {
  	  try {
  	    // Call the Chat Completions endpoint
  	    const response = await fetch('https://api.openai.com/v1/chat/completions', {
  	      method: 'POST',
  	      headers: {
  	        'Content-Type': 'application/json',
  	        // Use apiKey in Bearer token
  	        'Authorization': `Bearer ${apiKey}`
  	      },
  	      body: JSON.stringify({
  	        model: 'gpt-4-turbo',  // Chat model
  	        messages: [
  	          {
  	            role: 'user',
  	            content: promptMessage // The prompt text we pass in
  	          }
  	        ],
  	        max_tokens: 1500,
  	        temperature: 0.5
  	      })
  	    });
  	
  	    if (!response.ok) {
  	      throw new Error(`OpenAI request failed: ${response.status} ${response.statusText}`);
  	    }
  	
  	    // Parse response JSON
  	    const data = await response.json();
  	
  	    // Chat Completions store output in data.choices[0].message.content
  	    const resultText = data.choices?.[0]?.message?.content?.trim() ?? '';
  	    return resultText;
  	
  	  } catch (error) {
  	    console.error('Error in reorderLocations:', error);
  	    throw error;
  	  }
  	}
  	
  	// In Backendless Codeless, you define two input variables: apiKey and message.
  	// Then reference them directly:
  	return await reorderLocations(apiKey, message);

  })(([' Instruction Message: You are given a JSON dataset containing multiple locations. Your task is to reorder these locations into the most logically efficient travel sequence while maintaining key constraints.  🔹 Input Data Contains: One Start Point (always appears first). Multiple Load locations (places where items are picked up). Multiple Delivery locations (places where items are dropped off). A location can be both a Load and a Delivery. If a location plays both roles, it must appear each time it is required. Each Load must occur before any Delivery that depends on it. A single Load location may be the source for multiple Deliveries. A single Delivery location may receive goods from multiple Loads. A location may appear multiple times in the route if necessary, but avoid unnecessary backtracking.','Strict Rules for Reordering the Locations: 1️⃣ Start at the designated "Start Point"  The first entry in the final JSON must be the Start Point exactly as provided in the input. 2️⃣ Maintain Logical Order of Loads and Deliveries  Each Load location must be visited before its corresponding Delivery location(s). If multiple Loads are required before certain Deliveries, optimize the sequence to minimize distance. 3️⃣ Handling Locations that Serve as Both Load & Delivery  If a location is both a Load and a Delivery, it must appear twice: Once as a Delivery (for a previous Load). Once as a Load (for a future Delivery). Example: If "Location A" is a Delivery from a previous Load AND a Load for another Delivery, it must appear in the list two times in the correct sequence. 4️⃣ Avoid Unnecessary Backtracking  The travel sequence must be as geographically efficient as possible. The solution should not return to a location unless absolutely required to pick up a Load before a necessary Delivery. 5️⃣ Ensure the Correct Total Number of Objects in the JSON  The total number of objects in the returned JSON must be: (Total Load-Delivery Pairs × 2) + 1 (Start Point) = Total Objects Example: If the input contains 5 Load-Delivery pairs, the output must contain 11 locations. 6️⃣ Maintain the Original "Type" Labels  The "Type" of each location must remain unchanged: The Start Point stays "Start Point" Loads remain "Load" Deliveries remain "Delivery" Example Output Format:','{    "Name": "Location Name",     "Coordinates": [Latitude, Longitude],     "Type": "Start Point / Load / Delivery",     "objectId": "objectId" }',(JSON.stringify(({ [`Start Point`]: ({ [`Name`]: (getObjectProperty((getObjectProperty(___arguments.event, 'Start Point')), 'Name')),[`Location`]: (getObjectProperty((getObjectProperty(___arguments.event, 'Start Point')), 'Point')),[`objectId`]: (getObjectProperty((getObjectProperty(___arguments.event, 'Start Point')), 'objectId')) }),[`Loads`]: (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('b44c14361f47de7c7d87142cc9d351f7')).map(async item => {; return ({ [`Load`]: ({ [`Name`]: (getObjectProperty((getObjectProperty(item, 'Load Point Data')), 'Name')),[`Location`]: (getObjectProperty((getObjectProperty(item, 'Load Point Data')), 'Point')),[`objectId`]: (getObjectProperty((getObjectProperty(item, 'Load Point Data')), 'objectId')) }),[`Delivery`]: ({ [`Name`]: (getObjectProperty((getObjectProperty(item, 'Delivery Point Data')), 'Name')),[`Location`]: (getObjectProperty((getObjectProperty(item, 'Delivery Point Data')), 'Point')),[`objectId`]: (getObjectProperty((getObjectProperty(item, 'Delivery Point Data')), 'objectId')) }) });}))) })))].join('')), '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')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/0c8493f3df69b3a61cf5bdc66f32d3e7/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND TID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')),'\' AND created >= ',(await (async function(Start) {
	function getStartOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const startOfMonth = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
	  startOfMonth.setHours(0, 0, 0, 0); // Set to the start of the day
	
	  return startOfMonth.getTime();
	}
	
	// Directly execute and return the result
	return getStartOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created')))),' AND created <= ',(await (async function(Start) {
	function getEndOfMonthTimestamp(Start) {
	  const startDate = new Date(Start);
	  const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
	  endDate.setHours(23, 59, 59, 999); // Set to the end of the day
	
	  return endDate.getTime();
	}
	
	// Directly execute and return the result
	return getEndOfMonthTimestamp(Start);
})((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Current_Fleetview')), 'created'))))].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/e8aeeabb35e345512e272c1fbc32e45a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Deliver, Maintenance_Item, Trailer, Tractor;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Service() {
  Maintenance_Item = (await Backendless.Data.of('Maintenance').find(Backendless.DataQueryBuilder.create().setWhereClause((['Service_ID = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Service_ID')),'\''].join(''))).setPageSize(10)))[0];
  if ((getObjectProperty(Maintenance_Item, 'Vehicle Type')) == 'Tractor') {
    Tractor = (await Backendless.Data.of('Tractors').findById((getObjectProperty(Maintenance_Item, 'Tractor ID')), ));
    Tractor['Last_Service_Scheduled'] = ((getObjectProperty(Tractor, 'Last_Service_Scheduled')) - (getObjectProperty(Tractor, 'Service_Interval')));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Last_Service_Scheduled'] = (getObjectProperty(Tractor, 'Last_Service_Scheduled'));
  } else {
    Trailer = (await Backendless.Data.of('Trailers').findById((getObjectProperty(Maintenance_Item, 'Trailer ID')), ));
    Trailer['Last_Service_Scheduled'] = ((getObjectProperty(Trailer, 'Last_Service_Scheduled')) - (getObjectProperty(Tractor, 'Service_Interval')));
  }
  Deliver = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Deliver;

    if ((getObjectProperty(Maintenance_Item, 'Vehicle Type')) == 'Tractor') {
      _uow.update('Tractors', Tractor);
    } else {
      _uow.update('Trailers', Trailer);
    }
    _uow.delete('Loads', ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'));
    _uow.delete('Maintenance', Maintenance_Item);

  })();

  console.log((await Deliver.execute()));
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8aeeabb35e345512e272c1fbc32e45a', false);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Load_Type')) == 'Service') {
    await Service();
  } else {
    Deliver = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    console.log(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'));
    ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['Status'] = 'Delivered';
    ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['Mileage_Delivery_Point'] = (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Mileage_Load_Point')) + (getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Planned Mileage'))) - (getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Distance_Last_Delivery_Point_To_Load_Point')));
    await Backendless.Data.of('Loads').save(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), true);
  }
  removeItemInList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), '');
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6bcfe306c83bf336c5d377bd4a474c34', (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Loads')), async (item) => {


   return ((getObjectProperty(item, 'Status')) != 'Delivered');
  })), 1, async (item) => {


   return (getObjectProperty(item, 'Action Date'));
  })));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('e319ea6acf9a6477338b64b409e3b82c');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/8b312a145f429d646c13cc7ef8decd79/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'DELIVER') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8aeeabb35e345512e272c1fbc32e45a', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e8aeeabb35e345512e272c1fbc32e45a', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/0629424d0ba703623f740d5f2951e4fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('74e3173ac4597894b2bc3012ce47e98f');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/b92afe52281f1db72a2391f12c1c1c94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('75b2c06d94c8b6b4491d6763d22d18ef')), ({ [`ID`]: (generateUUID().short()) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/18a316eac50536d9d81f7c32925444ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c73ededba8ad18875b317c46b82b4d46')), ({ [`ID`]: (generateUUID().short()) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/e63c7882d917983a7159969a1ecee5cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ac6af178b324c6c1d70518e72bd48a63')), ({ [`ID`]: (generateUUID().short()) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/1cc9068975aadeddb4e6ed04486e0a2d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('75b2c06d94c8b6b4491d6763d22d18ef')), ___arguments.context.getComponentDataStoreByUid('898356667d73f03a20971ce35c080171'), '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/63346022e592d1cf37ab13fa323f0ceb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c73ededba8ad18875b317c46b82b4d46')), ___arguments.context.getComponentDataStoreByUid('865c87375549ff4750dfe37b7a4d4661'), '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/2c246ec8bd61a8c56336182eb0aa9ba6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ac6af178b324c6c1d70518e72bd48a63')), ___arguments.context.getComponentDataStoreByUid('3eaf86a7f3b4c8749c4c193e3c5bb9b3'), '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/aa02e8765bcb0dfd35ad2daad32f98a9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Customer'))))) {
          Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


           return (getObjectProperty(item, 'label'));
          }));
        } else {
          Options = (await (async function(List, Property) {
          	// The function accepts 'List' (array) and 'Property' (key to deduplicate by)
          	return List.reduce((acc, item) => {
          	  const key = item[Property];
          	  acc.map[key] = item;
          	  acc.array = Object.values(acc.map);
          	  return acc;
          	}, { map: {}, array: [] }).array;
          })((await (async function(List, Property) {
          	// The function accepts 'List' (array) and 'Property' (key to deduplicate by)
          	return List.reduce((acc, item) => {
          	  const key = item[Property];
          	  acc.map[key] = item;
          	  acc.array = Object.values(acc.map);
          	  return acc;
          	}, { map: {}, array: [] }).array;
          })(((await asyncListSort((await Promise.all((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


           return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Customer')));
          }))[0]), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


           return (getObjectProperty(item, 'label'));
          })).concat((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


           return (getObjectProperty(item, 'label'));
          })))), 'value')), 'label'));
        }
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;


  try {
    delete ___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb')['Load Planner - Markers'];

  } catch (error) {
    console.log(error);

  }
  delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Route'];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', false);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', true);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/f7c75b76c869c166dd4e68f293e95109/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Point;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Point = (await ( async function (placeId, fields) {
   if (!window.google || !window.google.maps || !window.google.maps.places) {
     return Promise.reject('Google Maps library was not initialized')
   }

   if (!placeId) {
     return Promise.reject('Place ID is empty')
   }

   const Status = google.maps.places.PlacesServiceStatus
   const StatusMessages = {
     [Status.INVALID_REQUEST] : 'The API request was malformed',
     [Status.NOT_FOUND]       : 'The referenced location, place ID, was not found in the Places database.',
     [Status.OVER_QUERY_LIMIT]: 'Any of the following:\n - You have exceeded the QPS limits.\n - Billing has not been enabled on your account.\n - The monthly $200 credit, or a self-imposed usage cap, has been exceeded.\n - The provided method of payment is no longer valid (for example, a credit card has expired).',
     [Status.REQUEST_DENIED]  : 'Your request was denied, generally because:\n - The request is missing an API key.\n - The key parameter is invalid.',
     [Status.UNKNOWN_ERROR]   : 'An unknown error.',
     [Status.ZERO_RESULTS]    : 'The referenced location, place ID , was valid but no longer refers to a valid result. This may occur if the establishment is no longer in business.',
   }

   const enrichPlaceWithLocation = place => {
     if (place.geometry) {
       const lat = place.geometry.location.lat()
       const lng = place.geometry.location.lng()

       place.location = { lat, lng }
     }

     return place
   }

   const service = new google.maps.places.PlacesService(document.createElement('div'))
   const request = { placeId, fields }

   return new Promise((resolve, reject) => {
     service.getDetails(request, callback)

     function callback(place, status) {
       if (status === Status.OK) {
         resolve(enrichPlaceWithLocation(place))
       } else {
         const errorLocationMessage = 'An error occurred while retrieving Google Place Details.\n'
         const errorMessage = StatusMessages[status] ? errorLocationMessage + StatusMessages[status] : errorLocationMessage + 'An unknown error.'

         reject(new Error(errorMessage))
       }
     }
   })
   })((getObjectProperty(___arguments.value, 'place_id')), ['geometry.location', 'name', 'place_id', 'formatted_address']));
  ___arguments.context.getComponentDataStoreByUid('898356667d73f03a20971ce35c080171')['Point'] = (getObjectProperty(Point, 'location'));
  ___arguments.context.getComponentDataStoreByUid('898356667d73f03a20971ce35c080171')['Data'] = Point;

  },
  /* handler:onChange */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('f7c75b76c869c166dd4e68f293e95109', undefined, ({ [`country`]: ['za'] }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/FIFOFFICE/components/0437c27d47cfb775f8ded47573b57bb2/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('0437c27d47cfb775f8ded47573b57bb2', undefined, ({ [`country`]: ['za'] }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

  },
  /* handler:onMounted */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Point;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Point = (await ( async function (placeId, fields) {
   if (!window.google || !window.google.maps || !window.google.maps.places) {
     return Promise.reject('Google Maps library was not initialized')
   }

   if (!placeId) {
     return Promise.reject('Place ID is empty')
   }

   const Status = google.maps.places.PlacesServiceStatus
   const StatusMessages = {
     [Status.INVALID_REQUEST] : 'The API request was malformed',
     [Status.NOT_FOUND]       : 'The referenced location, place ID, was not found in the Places database.',
     [Status.OVER_QUERY_LIMIT]: 'Any of the following:\n - You have exceeded the QPS limits.\n - Billing has not been enabled on your account.\n - The monthly $200 credit, or a self-imposed usage cap, has been exceeded.\n - The provided method of payment is no longer valid (for example, a credit card has expired).',
     [Status.REQUEST_DENIED]  : 'Your request was denied, generally because:\n - The request is missing an API key.\n - The key parameter is invalid.',
     [Status.UNKNOWN_ERROR]   : 'An unknown error.',
     [Status.ZERO_RESULTS]    : 'The referenced location, place ID , was valid but no longer refers to a valid result. This may occur if the establishment is no longer in business.',
   }

   const enrichPlaceWithLocation = place => {
     if (place.geometry) {
       const lat = place.geometry.location.lat()
       const lng = place.geometry.location.lng()

       place.location = { lat, lng }
     }

     return place
   }

   const service = new google.maps.places.PlacesService(document.createElement('div'))
   const request = { placeId, fields }

   return new Promise((resolve, reject) => {
     service.getDetails(request, callback)

     function callback(place, status) {
       if (status === Status.OK) {
         resolve(enrichPlaceWithLocation(place))
       } else {
         const errorLocationMessage = 'An error occurred while retrieving Google Place Details.\n'
         const errorMessage = StatusMessages[status] ? errorLocationMessage + StatusMessages[status] : errorLocationMessage + 'An unknown error.'

         reject(new Error(errorMessage))
       }
     }
   })
   })((getObjectProperty(___arguments.value, 'place_id')), ['geometry.location', 'name', 'place_id', 'formatted_address']));
  ___arguments.context.getComponentDataStoreByUid('865c87375549ff4750dfe37b7a4d4661')['Point'] = (getObjectProperty(Point, 'location'));
  ___arguments.context.getComponentDataStoreByUid('865c87375549ff4750dfe37b7a4d4661')['Data'] = Point;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/41dab0ab05413bef10e18bf5400ed315/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('41dab0ab05413bef10e18bf5400ed315', undefined, ({ [`country`]: ['za'] }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

  },
  /* handler:onMounted */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Point;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Point = (await ( async function (placeId, fields) {
   if (!window.google || !window.google.maps || !window.google.maps.places) {
     return Promise.reject('Google Maps library was not initialized')
   }

   if (!placeId) {
     return Promise.reject('Place ID is empty')
   }

   const Status = google.maps.places.PlacesServiceStatus
   const StatusMessages = {
     [Status.INVALID_REQUEST] : 'The API request was malformed',
     [Status.NOT_FOUND]       : 'The referenced location, place ID, was not found in the Places database.',
     [Status.OVER_QUERY_LIMIT]: 'Any of the following:\n - You have exceeded the QPS limits.\n - Billing has not been enabled on your account.\n - The monthly $200 credit, or a self-imposed usage cap, has been exceeded.\n - The provided method of payment is no longer valid (for example, a credit card has expired).',
     [Status.REQUEST_DENIED]  : 'Your request was denied, generally because:\n - The request is missing an API key.\n - The key parameter is invalid.',
     [Status.UNKNOWN_ERROR]   : 'An unknown error.',
     [Status.ZERO_RESULTS]    : 'The referenced location, place ID , was valid but no longer refers to a valid result. This may occur if the establishment is no longer in business.',
   }

   const enrichPlaceWithLocation = place => {
     if (place.geometry) {
       const lat = place.geometry.location.lat()
       const lng = place.geometry.location.lng()

       place.location = { lat, lng }
     }

     return place
   }

   const service = new google.maps.places.PlacesService(document.createElement('div'))
   const request = { placeId, fields }

   return new Promise((resolve, reject) => {
     service.getDetails(request, callback)

     function callback(place, status) {
       if (status === Status.OK) {
         resolve(enrichPlaceWithLocation(place))
       } else {
         const errorLocationMessage = 'An error occurred while retrieving Google Place Details.\n'
         const errorMessage = StatusMessages[status] ? errorLocationMessage + StatusMessages[status] : errorLocationMessage + 'An unknown error.'

         reject(new Error(errorMessage))
       }
     }
   })
   })((getObjectProperty(___arguments.value, 'place_id')), ['geometry.location', 'name', 'place_id', 'formatted_address']));
  ___arguments.context.getComponentDataStoreByUid('3eaf86a7f3b4c8749c4c193e3c5bb9b3')['Point'] = (getObjectProperty(Point, 'location'));
  ___arguments.context.getComponentDataStoreByUid('3eaf86a7f3b4c8749c4c193e3c5bb9b3')['Data'] = Point;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/0e2168af68225154ffa1e11f33d43963/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route'))))) {
    Content = '-';
  } else {
    Content = String((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route')), 'Distance')) / 1000) + String(' km');
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/a32e2b289ee5bf7257873e7a1efec907/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route'))))) {
    Content = null;
  } else {
    Content = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route')), 'Distance')) / 1000;
  }

  return Content

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/300e31c30712e2a66b967384cc7e8c7e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Rate_Per_Unit, Load_Value, Rate_Per_Km, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload'))))) {
    Rate_Per_Unit = null;
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))))) {
      Rate_Per_Unit = null;
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route'))))) {
        Rate_Per_Unit = null;
      } else {
        Rate_Per_Unit = Math.round(((Math.round(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route')), 'Distance')) / 1000) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km')) * 100) / 100) / ((await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;}) / 1000)) * 100) / 100;
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))))) {
    Rate_Per_Km = null;
  } else {
    Rate_Per_Km = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'));
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km'))))) {
    Load_Value = null;
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Route'))))) {
      Load_Value = null;
    } else {
      Load_Value = Math.round(((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Billing Route')), 'Distance')) / 1000) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Ideal_Rate_Per_Km')) * 100) / 100;
    }
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f38cc5c9d03ac407dcb285c5f8cec9da'))['value'] = Rate_Per_Km;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('793178d98ab737baa9abac4267f6add2'))['value'] = Load_Value;
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c24b02f58ea9319a54b7187fa795f487'))['value'] = Rate_Per_Unit;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/e38cb464ff7e3467728cec4eb40200c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('feb7d29982a61a734854ea44ffd81387', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/d06d4c33efedda0183061e2d333242bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('c687853ebaaad57e297f28fd5c2ce049', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/1edaaeec22be2c7975d52cdcd6ee68e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('5003930539c116f895381c7e8144bb93', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/c5dbc07b8e47153420f30b779aa44637/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Road')) == true) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/22cbcffba4e9c1f5c4cc042c853be0e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'Delivery Note'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/e4e781eae406a12c4e56990925ebaea8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('3219e54f18daa02c098161bb21b7aaf3', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/f78fb9fb5723f1ea5b8fdc1eefc1d68b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('0d79046be1317947dd77a45864f33585', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/5025c68d825164ca5b47095836d950e4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      console.log('1');
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('a5d8c89860b5bddb3948760869c8778b', undefined);
  console.log('2');

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5025c68d825164ca5b47095836d950e4'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5025c68d825164ca5b47095836d950e4'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/FIFOFFICE/components/c6d13ba3a3d97bc9c3298d24be489692/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/78b463e4b85c0cca255e066f0af24a5c/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78b463e4b85c0cca255e066f0af24a5c'))['boxShadow'] = 'rgba(94, 47, 24, 0.5) 0px 0px 30px 20px inset';

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('78b463e4b85c0cca255e066f0af24a5c'))['boxShadow'] = null;

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('2ea610b7a51c52645d041524eac7c522', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/5d52cb1d96b61d27cebf7a1cfb6dec74/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('f1ff1848a2e81ecbf18b2068aa287d08', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/1ce8981b151814f7e4ae27a8a551bfb1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;


  ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Transfer ID'] = ___arguments.value;
  try {
    delete ___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb')['Load Planner - Markers'];

  } catch (error) {
    console.log(error);

  }
  delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Route'];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', false);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', true);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Customer'))))) {
          Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


           return (getObjectProperty(item, 'label'));
          }));
        } else {
          Options = (await (async function(List, Property) {
          	// The function accepts 'List' (array) and 'Property' (key to deduplicate by)
          	return List.reduce((acc, item) => {
          	  const key = item[Property];
          	  acc.map[key] = item;
          	  acc.array = Object.values(acc.map);
          	  return acc;
          	}, { map: {}, array: [] }).array;
          })((await (async function(List, Property) {
          	// The function accepts 'List' (array) and 'Property' (key to deduplicate by)
          	return List.reduce((acc, item) => {
          	  const key = item[Property];
          	  acc.map[key] = item;
          	  acc.array = Object.values(acc.map);
          	  return acc;
          	}, { map: {}, array: [] }).array;
          })(((await asyncListSort((await Promise.all((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


           return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Customer')));
          }))[0]), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


           return (getObjectProperty(item, 'label'));
          })).concat((await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


           return (getObjectProperty(item, 'label'));
          })))), 'value')), 'label'));
        }
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/83d5b29d01583bf8c39eb277734e949a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Start')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Load')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Delivery')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Customer'))))) {
    Viewer = false;
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(1)' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(2)') {
      Viewer = true;
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(3)' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Billing')) == 'Bill(4)') {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb'), 'Return'))))) {
        Viewer = false;
      } else {
        Viewer = true;
      }
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/cc0e441ebfb838412c0fb2eef5ce17ce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f4a1b7c9b564070c02c96854e93e00d5')), ({ [`ID`]: (generateUUID().short()) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/b1fdd13acb0c8b2bd9bba889f8a6ec6b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('f4a1b7c9b564070c02c96854e93e00d5')), ___arguments.context.getComponentDataStoreByUid('a164c3cb664578c7c0a2fc6484a74093'), '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/f2045869a31319eead1f5187bccf049f/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('f2045869a31319eead1f5187bccf049f', undefined, ({ [`country`]: ['za'] }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

  },
  /* handler:onMounted */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Point;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Point = (await ( async function (placeId, fields) {
   if (!window.google || !window.google.maps || !window.google.maps.places) {
     return Promise.reject('Google Maps library was not initialized')
   }

   if (!placeId) {
     return Promise.reject('Place ID is empty')
   }

   const Status = google.maps.places.PlacesServiceStatus
   const StatusMessages = {
     [Status.INVALID_REQUEST] : 'The API request was malformed',
     [Status.NOT_FOUND]       : 'The referenced location, place ID, was not found in the Places database.',
     [Status.OVER_QUERY_LIMIT]: 'Any of the following:\n - You have exceeded the QPS limits.\n - Billing has not been enabled on your account.\n - The monthly $200 credit, or a self-imposed usage cap, has been exceeded.\n - The provided method of payment is no longer valid (for example, a credit card has expired).',
     [Status.REQUEST_DENIED]  : 'Your request was denied, generally because:\n - The request is missing an API key.\n - The key parameter is invalid.',
     [Status.UNKNOWN_ERROR]   : 'An unknown error.',
     [Status.ZERO_RESULTS]    : 'The referenced location, place ID , was valid but no longer refers to a valid result. This may occur if the establishment is no longer in business.',
   }

   const enrichPlaceWithLocation = place => {
     if (place.geometry) {
       const lat = place.geometry.location.lat()
       const lng = place.geometry.location.lng()

       place.location = { lat, lng }
     }

     return place
   }

   const service = new google.maps.places.PlacesService(document.createElement('div'))
   const request = { placeId, fields }

   return new Promise((resolve, reject) => {
     service.getDetails(request, callback)

     function callback(place, status) {
       if (status === Status.OK) {
         resolve(enrichPlaceWithLocation(place))
       } else {
         const errorLocationMessage = 'An error occurred while retrieving Google Place Details.\n'
         const errorMessage = StatusMessages[status] ? errorLocationMessage + StatusMessages[status] : errorLocationMessage + 'An unknown error.'

         reject(new Error(errorMessage))
       }
     }
   })
   })((getObjectProperty(___arguments.value, 'place_id')), ['geometry.location', 'name', 'place_id', 'formatted_address']));
  ___arguments.context.getComponentDataStoreByUid('a164c3cb664578c7c0a2fc6484a74093')['Point'] = (getObjectProperty(Point, 'location'));
  ___arguments.context.getComponentDataStoreByUid('a164c3cb664578c7c0a2fc6484a74093')['Data'] = Point;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/9082295322d43c95bbfa1421d3ebd436/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Load Planner - Planned Load Transfer'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/0caf15c115d4e20bb5fa7a6e16639ee8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_9e6128abb3b88ef952f18155d3c2eb8a']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0c8493f3df69b3a61cf5bdc66f32d3e7')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/b2826876337f93fb5f0b03921337ec87/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('b9f8637c63ef5b32c86cfeb9ee97c0a6', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/f7280ad80d7b120349782956a2ea170c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
    Content = '';
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'Current Tracking Data'))))) {
      Content = '';
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Idle'))))) {
        Content = '';
      } else {
        Content = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Idle'));
      }
    }
  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/95f6d7d71688dc6823f8ea53dc386418/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('473a6ff8cf18659855582578ddb86938', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/39d8df98183887e8b558e6f8fe88e318/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('473a6ff8cf18659855582578ddb86938', true);
  console.log(getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Idle Events'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/d662c13eaacc588939183555ffc8182d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d398e06cf18893b5e54d0481a78de7f'), 'Idle')) + String('m'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/23d878fd7468c458e74811b8e40e5c58/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var Repeater;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.appData))) {
    Repeater = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'Current Tracking Data'))))) {
      Repeater = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Idle Events'))))) {
        Repeater = [];
      } else {
        Repeater = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Current Tracking Data')), 'Idle Events'));
      }
    }
  }

  return Repeater

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/a92d97f50dcbdeee742f61b7dcb1b0e7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('f1ff1848a2e81ecbf18b2068aa287d08', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/363832a8ff97ed5659d8513b26a89438/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  ['onWhereClauseAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND TID IS NULL'].join(''))

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
      ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Load'] = ___arguments.selectedRecord;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('ffc76628c5c495d81cb407386568e744');

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/FIFOFFICE/components/31447aa88ec80bf6ef254d86b6ae635e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('ffc76628c5c495d81cb407386568e744');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/cea80cf16812a3c22ba5e7681b3d5a68/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    List = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      List = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors'))))) {
        List = [];
      } else {
        List = (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: ['(',(getObjectProperty(item, 'ID')),') - ',(getObjectProperty(item, 'Registration'))].join('') });})));
      }
    }
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/e6288de8b1f4c5580d883448e1e8e221/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Load, Loading_Transaction, Tractor, Trailer_List, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e6288de8b1f4c5580d883448e1e8e221'))['disabled'] = true;
  Load = (getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Load'));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Tractor = null;
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Tractor = null;
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors'))))) {
        Tractor = null;
      } else {
        Tractor = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


         return ((getObjectProperty(item, 'objectId')) == ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('cea80cf16812a3c22ba5e7681b3d5a68')));
        }))[0];
      }
    }
  }
  Load['TID'] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('cea80cf16812a3c22ba5e7681b3d5a68'));
  Loading_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Loading_Transaction;

    _uow.addToRelation('Tractors', Tractor, 'Loads', Load);
    _uow.setRelation('Loads', Load, 'Rig_Tractor', Tractor);
    Trailer_List = [];
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, ' Trailer1'))))) {
    } else {
      addItemToList(Trailer_List, (getObjectProperty((getObjectProperty(Tractor, ' Trailer1')), 'objectId')));
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, ' Trailer2'))))) {
    } else {
      addItemToList(Trailer_List, (getObjectProperty(Tractor, 'objectId')));
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Tractor, ' Trailer3'))))) {
    } else {
      addItemToList(Trailer_List, (getObjectProperty(Tractor, 'objectId')));
    }
    _uow.setRelation('Loads', Load, 'Rig_Trailers', Trailer_List);
    _uow.update('Loads', Load);

  })();

  console.log((await Loading_Transaction.execute()));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('363832a8ff97ed5659d8513b26a89438');
  ;(async () => {
      addItemToList((getObjectProperty(((await asyncListFind(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(Tractor, 'objectId')));
    }))[0]), 'Loads')), Load);

  })();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('ffc76628c5c495d81cb407386568e744');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/d71b61e65fa8229dcf8557a86eb8ff28/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Date2, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Date2 = [((new Date(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d398e06cf18893b5e54d0481a78de7f'), 'time')) * 1000))).toLocaleDateString()),'  ',((new Date(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d398e06cf18893b5e54d0481a78de7f'), 'time')) * 1000))).toLocaleTimeString())].join('');

  } catch (error) {
    console.log(error);

  } finally {
    if (error) {
      Date2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8d398e06cf18893b5e54d0481a78de7f'), 'time'));
    }

  }

  return Date2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/8d398e06cf18893b5e54d0481a78de7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty(___arguments.context.dataModel, 'lat')), (getObjectProperty(___arguments.context.dataModel, 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', 18);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/2ea610b7a51c52645d041524eac7c522/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      delete ___arguments.context.pageData['Order Book - Close'];

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/FIFOFFICE/components/7d0734a87098c8e7bf1816017fbf27c8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == 'TRANSFER') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a9a6ee8f4758558c498aed80bb75228', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a9a6ee8f4758558c498aed80bb75228', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/43786d5dcd18a798b09cd38232f80acd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('b238a8c4365aece8057278686cd846e5');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/9b0fa0f84e48e56792e80e883d38b04b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b238a8c4365aece8057278686cd846e5');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/6a9a6ee8f4758558c498aed80bb75228/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Reloaded_Loads, Loading_Transaction, error, Trailer_List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  Loading_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a')['TID'] = null;
  await ( async () => {
    const _uow = Loading_Transaction;

    _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), 'Loads', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'objectId'))]);
    _uow.deleteRelation('Loads', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'objectId')), 'Rig_Tractor', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId'))]);
    _uow.update('Loads', ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'));
    Trailer_List = [];
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Trailer1'))))) {
    } else {
      addItemToList(Trailer_List, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ' Trailer1')), 'objectId')));
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), ' Trailer2'))))) {
    } else {
      addItemToList(Trailer_List, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Trailer2')), 'objectId')));
    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Trailer3'))))) {
    } else {
      addItemToList(Trailer_List, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Trailer3')), 'objectId')));
    }
    try {
      _uow.deleteRelation('Loads', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')), 'Rig_Trailers', Trailer_List);

    } catch (error) {
      console.log(error);

    }

  })();

  Reloaded_Loads = (await Loading_Transaction.execute());
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('b238a8c4365aece8057278686cd846e5');
  ;(async () => {
      removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6bcfe306c83bf336c5d377bd4a474c34')), ___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'objectId');

  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/1c2c66e8f08841bdef2e1488e0e941e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected Repair Record')), 'Images'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/2489179d3f8e939e8163e42338d85914/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('0bf8b9de7cbda778df4ffd8878f746f8')

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(___arguments.context.getComponentDataStoreByUid('0bf8b9de7cbda778df4ffd8878f746f8'), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/4d4830b6d7d66898e0c863ebef0198f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.pageData, 'Selected Repair Record'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('971c994f6865a048aedc327eede1ff2a');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/c1fa9108b8e7f8a8b8952aed2872a288/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_9e6128abb3b88ef952f18155d3c2eb8a']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b6771da64fea415bd3e2d08913f79b1d')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/824727984fe8c8774844eff8f2b83941/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_9e6128abb3b88ef952f18155d3c2eb8a']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('36bfd6de388fa4c2b4aec47f80d638ac')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/2904f1e85b89273ff9d8fa381eb8bb76/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('99fa3318b10872d811a338a8bca8dc18');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/7e68e358dac8c7bbf15862f8a348da62/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Tractor - Service Images')), 'Images'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/3f5484a825c86198ec438b6814b5ddc6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
      return ___arguments.context.getComponentDataStoreByUid('1b73973859dd0ab33638bfe847f8d008')

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(___arguments.context.getComponentDataStoreByUid('1b73973859dd0ab33638bfe847f8d008'), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/3835f0d896c29f730738df75560c22b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('2ea610b7a51c52645d041524eac7c522', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/519782789588d57e42a8bd16e2584988/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Transferred Order'))))) {
    Viewer = false;
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Transferred Order')), 'Rig Select'))))) {
      Viewer = false;
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Transferred Order')), 'Rig Select'))) {
        Viewer = true;
      } else {
        Viewer = false;
      }
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Transferred Order')), 'Rig Select'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e322a9ca88f8cc21a789b4eaf4862cc7', true);
    delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Route'];
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d0912818df2b8801947d841fff760a19', true);

    } catch (error) {
      console.log(error);

    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9082295322d43c95bbfa1421d3ebd436', true);
    try {
      delete ___arguments.context.getComponentDataStoreByUid('968b3289c278ef666606e2f7c75a8bfb')['Load Planner - Markers'];

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8db14e45528d50c13893adeb675a641c', true);

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('77c2acaabc1c6cdf2d5d2ee31b71b636', true);

    } catch (error) {
      console.log(error);

    }
    try {
      delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Route'];

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', false);

    } catch (error) {
      console.log(error);

    }
    ;(async () => {
        try {
        await new Promise(r => setTimeout(r, 500 || 0));
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ecf24f5838fdd0b26cecd573c5c2e6c9', true);

      } catch (error) {
        console.log(error);

      }

    })();
    delete ___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85')['Route'];
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('519782789588d57e42a8bd16e2584988', false);
  } else {
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/a13a790952de1b1c1d7d2cdc9dce8d79/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Transferred Order'))))) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Transferred Order')), 'Rig Select'))))) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Transferred Order')), 'Rig Select'))) {
        Viewer = true;
      } else {
        Viewer = false;
      }
    } else {
      Viewer = false;
    }
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/e72f00a531c4f2eb279ec5da24866127/bundle.js', [], () => ({
  /* content */
  /* handler:heightLogic */
  ['heightLogic'](___arguments) {
      return '100%'

  },
  /* handler:heightLogic */
  /* content */
}))

define('./pages/FIFOFFICE/components/a4b90a597df4c0d157c6e0fa19b37a38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('5a14f32994e6caf42a31da219928469c', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/c25883c7241877078448eda719e80558/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('a5d8c89860b5bddb3948760869c8778b', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/35f8fdd8011e5cf8ee084dd809c6b568/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e483f965f0a0d68ccd80ce4270823b4'), 'Customer'))

  },
  /* handler:onLabelAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ___arguments.context.getComponentDataStoreByUid('7e483f965f0a0d68ccd80ce4270823b4')['Add Location'] = ___arguments.value;
  } else {
    delete ___arguments.context.getComponentDataStoreByUid('7e483f965f0a0d68ccd80ce4270823b4')['Add Location'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/FIFOFFICE/components/7e38f6e3567975181d386264a1f8eb98/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var Customer_List, error, j, Location_Counter, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Customer_List = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers'));
  for (var j_index in Customer_List) {
    j = Customer_List[j_index];
    console.log(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected Location')), 'objectId'));
    console.log(getObjectProperty(j, 'Locations'));
    Location_Counter = (await asyncListFilter((getObjectProperty(j, 'Locations')), async (item) => {
       console.log(getObjectProperty(item, 'objectId'));


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'Selected Location')), 'objectId')));
    }));
    console.log(Location_Counter);
    if (Location_Counter.length > 0) {
      j['Add Location'] = true;
    }
  }

  return Customer_List

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/273863885895c608edd33fc8e228f442/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Customer')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'CID'))))) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/0a982ff854287dbe384844e8e764de98/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Customer'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Customer, Transaction, Load, item, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Load_Updater() {
  Load['CID'] = (getObjectProperty(Customer, 'objectId'));
  Load['Customer Name'] = (getObjectProperty(Customer, 'Customer_Registered_Name'));
}


  Load = (await Backendless.Data.of('Loads').findById((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record')), 'objectId')), ));
  Customer = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), async (item) => {


   return ((getObjectProperty(___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f'), 'Customer')) == (getObjectProperty(item, 'objectId')));
  }))[0];
  await Load_Updater();
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    _uow.upsert('Loads', Load);
    _uow.setRelation('Loads', Load, 'Customer', [Customer]);

  })();

  await Transaction.execute();
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record'))['CID'] = (getObjectProperty(Customer, 'objectId'));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Selected Delivered Tonnage Record'))['Customer Name'] = (getObjectProperty(Customer, 'Customer_Registered_Name'));
  delete ___arguments.context.getPodDataModelByUid('3a710d8262c201bdc66fcf9a29ffe89f')['Customer'];
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0a982ff854287dbe384844e8e764de98', false);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('273863885895c608edd33fc8e228f442', false);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/FIFOFFICE/components/21b835e246010db35749b08895583718/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('87e71a09d57a8136b39f799de8ae7f1a'), 'Planned_BY')) == 'Driver') {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/fa4a82281268b0e8e5f8d058b7a8c508/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer;


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('4e6d0de6d6e12919048c9901804c1cd9')) == 'Other') {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/FIFOFFICE/components/fd38b49876f842291d89384dc8083748/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Product, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (0 == 'Other') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('6abff288f7d8597852116f7943c2b088');
  } else {
    Product = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products')), async (item) => {


     return ((getObjectProperty(item, 'Product')) == 0);
    }))[0];
    ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Product'] = Product;
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6'), 'Units'))))) {
      ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Unit mass'] = (getObjectProperty(Product, 'Mass'));
      if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('fe63d7114a2242e76e3c1f3c973f0e57')).length == 1) {
        ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f1179b2329bd3782ae820f91603f29e4'))['value'] = (Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')) / (getObjectProperty(Product, 'Mass'))));
        ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Units'] = (Math.floor((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')) / (getObjectProperty(Product, 'Mass'))));
        ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Mass'] = ((getObjectProperty(Product, 'Mass')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6'), 'Units')));
      } else {
        ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f1179b2329bd3782ae820f91603f29e4'))['value'] = (Math.floor(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')) - (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;})) / (getObjectProperty(Product, 'Mass'))));
        ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Units'] = (Math.floor(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Payload')) - (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('64c99a9b58ffea63cdef471e3503be85'), 'Products')).map(async item => {; return (getObjectProperty(item, 'Mass'));}))).reduce(function(x, y) {return x + y;})) / (getObjectProperty(Product, 'Mass'))));
        ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Mass'] = ((getObjectProperty(Product, 'Mass')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6'), 'Units')));
      }
    } else {
      ___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6')['Mass'] = ((getObjectProperty(Product, 'Mass')) * (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8baecc3968ac07aa769930596bede1c6'), 'Units')));
    }
  }
  console.log(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'));
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('6abff288f7d8597852116f7943c2b088');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Product')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Units')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'Mass'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/Home/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      console.log((await Backendless.Request.post(`${Backendless.appPath}/services/OpenAIImageService/createImage`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'prompt': 'A Skinny mcu Hulk','numberOfImages': 1,'responseFormat': 'url','size': '256x256' })));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/Playground/components/3528d1342956a08aff6af32d0cf86517/bundle.js', [], () => ({
  /* content */
  /* handler:onDecodeSuccess */
  ['onDecodeSuccess'](___arguments) {
      console.log(___arguments['decodedCode']);

  },
  /* handler:onDecodeSuccess */
  /* handler:onDecodeError */
  async ['onDecodeError'](___arguments) {
      console.log((await (async function(rawbinary) {
  	// Argument: rawbinary (type: string with binary characters)
  	
  	const buffer = Buffer.from(rawbinary, 'latin1'); // ISO_8859_1-safe decoding
  	const base64 = buffer.toString('base64');
  	
  	return base64;

  })('›	E��À}<ˆ!·@XwHü¾nj(Îý2Ô|Øâ¨$KWœ¦ö†Îk¸(]­Éî¢bÛQöI8öl¢ò§RVÙì¯´¸Î÷)‰Úé4ºpo«ðÙñÚa —·SÛ.yÌtÿ¿Ä[¶Ï]5³Ì±£Jöp¡³÷¨ot²³éB–2§(«i*Ë+ÚÝëÚ™‡Þ}PøRùaåºUµ·q1ÄµDu ¿¢µûl™«{Â·¢¦v¦	îîq†ß!3®÷{þA\\·BqÞÈ‚à÷¬%wD0 %yTI@³ž}9â»ùÚ4!va­d3L%%hB¸j›Òh¸_Üè©gmiw.ÐoÊ÷Ìžï¬Ø:ÄÉhÞIl+°ELòK°R–^Ýgq2šÕ!Ë;•¦¯j®�ÃƒrÂÝq—áKA)*Í/äÏËDyÆ÷û‰òþmTÅÚ®%C_$qæ˜+±å\'6ðÇ üUOPªðp:>\'i”oz@	{8GæÕ\\éÿÒÐ÷Û:%kvïô:uAJˆ ‰xí€¿HïPŽjËŒ²åœDd”³0ÈÎšíü™Ùõ\'¬W÷cJ	bÄWn]$ê?‘i3ltzõ!êZÏîÌmtãÞ¢ø0R•†Ô_Aã€\'iéÇœNÉæ*A5Ãë@•¬§@v3Óiß©ÂMÕR|¬©ï&�)ïB<öQ#Äüàâ?KþÂ·qTïH”ûnûÒˆ7Å“Í[ˆ„ëƒÏWb‹•ˆežE¨ÅX-ø£©™Ï“ñT!?#9	˜DRçZÁœ1À~k,pÕl@$Üú[ŽgÍÛ-ÈAY0Ê:-À\'Få§i?Ìv·…2½yËé…™(6ˆå¦;ú¶(µ\'ü÷³—%:]Þ:>(ÔÝ¤·ÁZö±t{5Ò%')));

  },
  /* handler:onDecodeError */
  /* handler:onScannerClick */
  async ['onScannerClick'](___arguments) {
      console.log((await (async function(rawbinary) {
  	// Accepts: rawbinary (binary-like string with control characters)
  	// Returns: Base64-encoded string
  	
  	// Step 1: Convert string to Uint8Array, preserving ISO-8859-1 / Latin1 bytes
  	const bytes = new Uint8Array([...rawbinary].map(c => c.charCodeAt(0)));
  	
  	// Step 2: Convert to binary string
  	let binaryString = '';
  	for (let i = 0; i < bytes.length; i++) {
  	  binaryString += String.fromCharCode(bytes[i]);
  	}
  	
  	// Step 3: Convert binary string to base64 using browser-safe method
  	const base64 = btoa(binaryString);
  	
  	// Return result
  	return base64;
  })('›	E��À}<ˆ!·@XwHü¾nj(Îý2Ô|Øâ¨$KWœ¦ö†Îk¸(]­Éî¢bÛQöI8öl¢ò§RVÙì¯´¸Î÷)‰Úé4ºpo«ðÙñÚa —·SÛ.yÌtÿ¿Ä[¶Ï]5³Ì±£Jöp¡³÷¨ot²³éB–2§(«i*Ë+ÚÝëÚ™‡Þ}PøRùaåºUµ·q1ÄµDu ¿¢µûl™«{Â·¢¦v¦	îîq†ß!3®÷{þA\\·BqÞÈ‚à÷¬%wD0 %yTI@³ž}9â»ùÚ4!va­d3L%%hB¸j›Òh¸_Üè©gmiw.ÐoÊ÷Ìžï¬Ø:ÄÉhÞIl+°ELòK°R–^Ýgq2šÕ!Ë;•¦¯j®�ÃƒrÂÝq—áKA)*Í/äÏËDyÆ÷û‰òþmTÅÚ®%C_$qæ˜+±å\'6ðÇ üUOPªðp:>\'i”oz@	{8GæÕ\\éÿÒÐ÷Û:%kvïô:uAJˆ ‰xí€¿HïPŽjËŒ²åœDd”³0ÈÎšíü™Ùõ\'¬W÷cJ	bÄWn]$ê?‘i3ltzõ!êZÏîÌmtãÞ¢ø0R•†Ô_Aã€\'iéÇœNÉæ*A5Ãë@•¬§@v3Óiß©ÂMÕR|¬©ï&�)ïB<öQ#Äüàâ?KþÂ·qTïH”ûnûÒˆ7Å“Í[ˆ„ëƒÏWb‹•ˆežE¨ÅX-ø£©™Ï“ñT!?#9	˜DRçZÁœ1À~k,pÕl@$Üú[ŽgÍÛ-ÈAY0Ê:-À\'Få§i?Ìv·…2½yËé…™(6ˆå¦;ú¶(µ\'ü÷³—%:]Þ:>(ÔÝ¤·ÁZö±t{5Ò%')));

  },
  /* handler:onScannerClick */
  /* content */
}))

define('./pages/Playground/components/b6018d0281d86aac5f895679aeeb6102/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(await Backendless.Data.describe( (getObjectProperty(___arguments.context.pageData, 'Table')) ));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/Whiteboard/components/0a09b3cd1b2edbb800da52140a0f8f4c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Tables_List, New_Object, j, Tables;


  console.log((await (async function() {
  	// Backendless Custom Code block
  	return Backendless.Data.getTableNames()
  	  .then(async (tables) => {
  	    const schemaDescriptions = {};
  	
  	    for (const table of tables) {
  	      const schema = await Backendless.Data.describe(table);
  	      schemaDescriptions[table] = schema;
  	    }
  	
  	    return schemaDescriptions;
  	  })
  	  .catch(error => {
  	    console.error("Error retrieving schema descriptions:", error);
  	    throw error;
  	  });

  })()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/change-password/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  onEnter(___arguments) {
      ___arguments.context.pageData['error'] = null;
  ___arguments.context.pageData['result'] = null;

  },  
/* handler:onEnter *//* content */
}));

define('./pages/change-password/components/58ecb77e91b7d9dd5c99075111c91c64/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async onSubmit(___arguments) {
    var error;


  ___arguments.context.pageData['result'] = '';
  ___arguments.context.pageData['error'] = '';
  if ((___arguments.context.dataModel['password']) == (___arguments.context.dataModel['confirm_password'])) {
    try {
      ___arguments.context.pageData['result'] = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(([(Backendless.appPath),'/change_password/',(___arguments.context.pageData['token'])].join('')))).setEncoding('utf8').send(({ 'password': (___arguments.context.dataModel['password']) })));

    } catch (error) {
      ___arguments.context.pageData['error'] = ((typeof (error['message']) === 'string') ? (error['message']) : error);

    }
  } else {
    ___arguments.context.pageData['error'] = 'Passwords do not match';
  }

  },  
  /* handler:onSubmit *//* content */
}));

define('./pages/change-password/components/9c0e75137e04bad6e50940e30ee54426/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['error'] = null;
  ___arguments.context.pageData['result'] = null;

  },  
/* handler:onChange *//* content */
}));

define('./pages/change-password/components/1e3bdf67c1f295ed344408cd7f1dba1d/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['error'] = null;
  ___arguments.context.pageData['result'] = null;

  },  
/* handler:onChange *//* content */
}));

define('./pages/login/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var redirectData, redirectToPageName, stayLoggedIn, user, sendUserTokenAndId, redirectToUrl, Initial_Data, error, password, username, logging, buttonLogin;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Network_True() {
  redirectToUrl = (getObjectProperty(___arguments.context.pageData, 'redirectToUrl'));
  redirectToPageName = (getObjectProperty(___arguments.context.pageData, 'redirectToPageName'));
  redirectData = (getObjectProperty(___arguments.context.pageData, 'redirectData'));
  sendUserTokenAndId = (getObjectProperty(___arguments.context.pageData, 'sendUserTokenAndId'));
  await setError(null);
  username = (getObjectProperty(___arguments.context.dataModel, 'username'));
  password = (getObjectProperty(___arguments.context.dataModel, 'password'));
  stayLoggedIn = (getObjectProperty(___arguments.context.dataModel, 'stayLoggedIn'));
  if (username && password) {
    await updateButtonLogin(true);
    try {
      Initial_Data = (await Backendless.UserService.login( username, password, stayLoggedIn  ));

    } catch (error) {
      if (error) {
        ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = ({ [`message`]: error });
        await updateButtonLogin(false);
      } else {
      }

    } finally {
      if ((getObjectProperty(Initial_Data, 'Level')) == 'Road') {
        try {
          user = (await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Initial_Data, 'objectId')),'\''].join(''))).setRelated((((['Details.Driver_Transactions_Fuel', 'Details.Driver_Transactions_Load', 'Details.Driver_Tractor.Fleetview_Current.Fuel', 'Details.Driver_Tractor.Fleetview_Current.Loads', 'Details.Driver_Tractor.Fleetview_Current.Other', 'Details.Driver_Tractor.Current_Fleetview.Fuel', 'Details.Driver_Tractor.Current_Fleetview.Loads', 'Details.Driver_Tractor.Current_Fleetview.Other', 'Details.Driver_Tractor.Fuel', 'Details.Driver_Tractor.Loads', 'Details.Driver_Tractor.Other', 'Details.Driver_Tractor.Driver1', 'Details.Driver_Tractor.Conductor1', 'Details.Driver_Tractor.Conductor2', 'Details.Wages_Current.Fuel', 'Details.Wages_Current.Loads'].concat(['Company.Company_Admin', 'Company.Customers', 'Company.Locations', 'Company.Stations', 'Company.Tanks'])).concat(['Details.Driver_Tractor.Maintenance', 'Details.Driver_Tractor.Axles_Data.Tyre L1.Axle', 'Details.Driver_Tractor.Axles_Data.Tyre L2.Axle', 'Details.Driver_Tractor.Axles_Data.Tyre L3.Axle', 'Details.Driver_Tractor.Axles_Data.Tyre L4.Axle', 'Details.Driver_Tractor.Axles_Data.Tyre R1.Axle', 'Details.Driver_Tractor.Axles_Data.Tyre R2.Axle', 'Details.Driver_Tractor.Axles_Data.Tyre R3.Axle', 'Details.Driver_Tractor.Axles_Data.Tyre R4.Axle'])).concat((['Details.Driver_Tractor.Trailer1.Maintenance', 'Details.Driver_Tractor.Trailer1.Tyres', 'Details.Driver_Tractor.Trailer1.Axles_Data.Tyre L1.Axle', 'Details.Driver_Tractor.Trailer1.Axles_Data.Tyre L2.Axle', 'Details.Driver_Tractor.Trailer1.Axles_Data.Tyre L3.Axle', 'Details.Driver_Tractor.Trailer1.Axles_Data.Tyre L4.Axle', 'Details.Driver_Tractor.Trailer1.Axles_Data.Tyre R1.Axle', 'Details.Driver_Tractor.Trailer1.Axles_Data.Tyre R2.Axle', 'Details.Driver_Tractor.Trailer1.Axles_Data.Tyre R3.Axle', 'Details.Driver_Tractor.Trailer1.Axles_Data.Tyre R4.Axle'].concat((['Details.Driver_Tractor.Trailer2.Maintenance', 'Details.Driver_Tractor.Trailer2.Tyres', 'Details.Driver_Tractor.Trailer2.Axles_Data.Tyre L1.Axle', 'Details.Driver_Tractor.Trailer2.Axles_Data.Tyre L2.Axle', 'Details.Driver_Tractor.Trailer2.Axles_Data.Tyre L3.Axle', 'Details.Driver_Tractor.Trailer2.Axles_Data.Tyre L4.Axle', 'Details.Driver_Tractor.Trailer2.Axles_Data.Tyre R1.Axle', 'Details.Driver_Tractor.Trailer2.Axles_Data.Tyre R2.Axle', 'Details.Driver_Tractor.Trailer2.Axles_Data.Tyre R3.Axle', 'Details.Driver_Tractor.Trailer2.Axles_Data.Tyre R4.Axle'].concat(['Details.Driver_Tractor.Trailer3.Maintenance', 'Details.Driver_Tractor.Trailer3.Tyres', 'Details.Driver_Tractor.Trailer3.Axles_Data.Tyre L1.Axle', 'Details.Driver_Tractor.Trailer3.Axles_Data.Tyre L2.Axle', 'Details.Driver_Tractor.Trailer3.Axles_Data.Tyre L3.Axle', 'Details.Driver_Tractor.Trailer3.Axles_Data.Tyre L4.Axle', 'Details.Driver_Tractor.Trailer3.Axles_Data.Tyre R1.Axle', 'Details.Driver_Tractor.Trailer3.Axles_Data.Tyre R2.Axle', 'Details.Driver_Tractor.Trailer3.Axles_Data.Tyre R3.Axle', 'Details.Driver_Tractor.Trailer3.Axles_Data.Tyre R4.Axle']))))))).setRelationsDepth(10).setRelationsPageSize(100).setPageSize(100)))[0];

        } catch (error) {
          console.log(error);

        }
        try {
          (getObjectProperty(user, 'Company'))['Locations'] = (await BackendlessUI.Functions.Custom['fn_1db2862f0f34c40826936d930b7ac8c1']('Locations', (['ownerId = \'',(getObjectProperty(user, 'ownerId')),'\''].join('')), null, null, null));

        } catch (error) {
          console.log(error);

        }
        console.log(user);
        try {
          user['Tractor'] = (getObjectProperty((getObjectProperty(user, 'Details')), 'Driver_Tractor'));

        } catch (error) {
          console.log(error);

        }
        try {
          user['Fleetview Current'] = (getObjectProperty((getObjectProperty((getObjectProperty(user, 'Details')), 'Driver_Tractor')), 'Fleetview_Current'));

        } catch (error) {
          console.log(error);

        }
        try {
          user['Fuel'] = (getObjectProperty((getObjectProperty(user, 'Details')), 'Driver_Transactions_Fuel'));

        } catch (error) {

        }
        try {
          user['Loads'] = (getObjectProperty((getObjectProperty(user, 'Details')), 'Driver_Transactions_Load'));

        } catch (error) {

        }
        try {
          user['Wages'] = (getObjectProperty((getObjectProperty(user, 'Details')), 'Wages_Current'));

        } catch (error) {

        }
      } else if ((getObjectProperty(Initial_Data, 'Level')) == 'Office') {
        try {
          user = (await Backendless.Data.of('users').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId = \'',(getObjectProperty(Initial_Data, 'objectId')),'\''].join(''))).setRelated(((((['Company.Tractors.Company', 'Company.Tractors.Tyres', 'Company.Tractors.Current_Fleetview.Fuel', 'Company.Tractors.Current_Fleetview.Loads', 'Company.Tractors.Current_Fleetview.Other'].concat(((['Company.Tractors.Fleetview_Current.Fuel', 'Company.Tractors.Fleetview_Current.Loads', 'Company.Tractors.Fleetview_Current.Other'].concat(['Company.Tractors.Fleetview_Historical.Fuel', 'Company.Tractors.Fleetview_Historical.Loads', 'Company.Tractors.Fleetview_Historical.Other'])).concat((['Company.Trailers.Axles_Data.Tyre L1.Axle', 'Company.Trailers.Axles_Data.Tyre L2.Axle', 'Company.Trailers.Axles_Data.Tyre L3.Axle', 'Company.Trailers.Axles_Data.Tyre L4.Axle', 'Company.Trailers.Axles_Data.Tyre R1.Axle', 'Company.Trailers.Axles_Data.Tyre R2.Axle', 'Company.Trailers.Axles_Data.Tyre R3.Axle', 'Company.Trailers.Axles_Data.Tyre R4.Axle'].concat((['Company.Trailers.Axles_Data.Tyre L1.Axle', 'Company.Trailers.Axles_Data.Tyre L2.Axle', 'Company.Trailers.Axles_Data.Tyre L3.Axle', 'Company.Trailers.Axles_Data.Tyre L4.Axle', 'Company.Trailers.Axles_Data.Tyre R1.Axle', 'Company.Trailers.Axles_Data.Tyre R2.Axle', 'Company.Trailers.Axles_Data.Tyre R3.Axle', 'Company.Trailers.Axles_Data.Tyre R4.Axle'].concat(['Company.Trailers.Next Load', 'Company.Trailers.Current Load', 'Company.Trailers.Maintenance', 'Company.Trailers.Transactions', 'Company.Trailers.Tyres'])))))))).concat(['Company.Tractors.Axles_Data.Tyre L1.Axle', 'Company.Tractors.Axles_Data.Tyre L2.Axle', 'Company.Tractors.Axles_Data.Tyre L3.Axle', 'Company.Tractors.Axles_Data.Tyre L4.Axle', 'Company.Tractors.Axles_Data.Tyre R1.Axle', 'Company.Tractors.Axles_Data.Tyre R2.Axle', 'Company.Tractors.Axles_Data.Tyre R3.Axle', 'Company.Tractors.Axles_Data.Tyre R4.Axle'])).concat((['Company.Tractors.Trailer1.Tyres', 'Company.Tractors.Trailer1.Axles_Data.Tyre L1.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre L2.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre L3.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre L4.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre R1.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre R2.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre R3.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre R4.Axle'].concat(['Company.Tractors.Trailer1.Next Load', 'Company.Tractors.Trailer2.Next Load', 'Company.Tractors.Trailer3.Next Load', 'Company.Tractors.Trailer1.Current Load', 'Company.Tractors.Trailer2.Current Load', 'Company.Tractors.Trailer3.Current Load'])))).concat(((['Company.Tractors.Trailer2.Tyres', 'Company.Tractors.Trailer2.Axles_Data.Tyre L1.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre L2.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre L3.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre L4.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre R1.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre R2.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre R3.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre R4.Axle'].concat(['Company.Tractors.Trailer3.Tyres', 'Company.Tractors.Trailer3.Axles_Data.Tyre L1.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre L2.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre L3.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre L4.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre R1.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre R2.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre R3.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre R4.Axle'])).concat(((['Company.Tractors.Driver1.Wages_Current', 'Company.Tractors.Driver1.Wages_Historical', 'Company.Tractors.Driver1.Driver_Transactions_Load', 'Company.Tractors.Driver1.Driver_Transactions_Fuel'].concat((['Company.Tractors.Conductor1.Wages_Current', 'Company.Tractors.Conductor1.Wages_Historical', 'Company.Tractors.Conductor1.Driver_Transactions_Load', 'Company.Tractors.Conductor1.Driver_Transactions_Fuel'].concat(['Company.Tractors.Conductor2.Wages_Current', 'Company.Tractors.Conductor2.Wages_Historical', 'Company.Tractors.Conductor2.Driver_Transactions_Load', 'Company.Tractors.Conductor2.Driver_Transactions_Fuel'])))).concat((['Company.Tractors.Planner', 'Company.Tractors.Other', 'Company.Tractors.Maintenance', 'Company.Tractors.Breakdowns', 'Company.Tractors.Fuel', 'Company.Tractors.Loads'].concat((['Company.Employees.Wages_Current', 'Company.Employees.Wages_Historical', 'Company.Employees.Driver_Transactions_Load', 'Company.Employees.Driver_Transactions_Fuel'].concat(['Company.Company_Admin', 'Company.Customers.Locations', 'Company.Locations', 'Company.Stations', 'Company.Tanks.Bowsers']))))))))))).setRelationsDepth(10).setRelationsPageSize(100).setPageSize(100)))[0];

        } catch (error) {
          console.log(error);

        }
        try {
          (getObjectProperty(user, 'Company'))['Locations'] = (await BackendlessUI.Functions.Custom['fn_1db2862f0f34c40826936d930b7ac8c1']('Locations', (['ownerId = \'',(getObjectProperty(user, 'ownerId')),'\''].join('')), null, null, null));

        } catch (error) {
          console.log(error);

        }
        try {
          (getObjectProperty(user, 'Company'))['Customers'] = (await BackendlessUI.Functions.Custom['fn_1db2862f0f34c40826936d930b7ac8c1']('Customers', (['ownerId = \'',(getObjectProperty(user, 'ownerId')),'\''].join('')), ['Locations'], null, null));

        } catch (error) {
          console.log(error);

        }
        ___arguments.context.appData['Month'] = ((await BackendlessUI.Functions.Custom['fn_143fc5aa9049a496f3f2f6656ab5e7a4'](null)).valueOf());
      } else if ((getObjectProperty(Initial_Data, 'Level')) == 'Fleet In Form') {
      }

    }
  } else {
    await setError((new Error('Username and Password must be filled')));
    await updateButtonLogin(false);
  }
  if (user) {
    ___arguments.context.appData['User'] = user;
    if (redirectToUrl) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(redirectToUrl, false, (sendUserTokenAndId ? ({ [`userToken`]: (getObjectProperty(user, 'user-token')),[`userId`]: (getObjectProperty(user, 'objectId')),[`stayLoggedIn`]: stayLoggedIn }) : ''));
    } else if (redirectToPageName) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(redirectToPageName, (redirectData ? (JSON.parse(redirectData)) : null));
    } else {
      if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Level')) == 'Fleet In Form') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('FIF', undefined);
      } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Level')) == 'Road') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('FIFDRIVER', undefined);
      } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Level')) == 'Office') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('FIFOFFICE', undefined);
      }
    }
  }
}

/**
 * Describe this function...
 */
async function Old_List() {
  console.log(['Details', null, null, 'Details.Driver_Transactions_Fuel', 'Details.Driver_Transactions_Load', null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null]);
  console.log(['Details.Driver_Transactions_Fuel', 'Details.Driver_Transactions_Load', 'Details.Driver_Tractor.Fleetview_Current.Fuel', 'Details.Driver_Tractor.Fleetview_Current.Loads', 'Details.Driver_Tractor.Fleetview_Historical.Fuel', 'Details.Driver_Tractor.Fleetview_Historical.Loads', 'Details.Wages_Current', 'Company.Tractors.Current_Fleetview.Fuel', 'Company.Tractors.Current_Fleetview.Loads', 'Company.Tractors.Current_Fleetview.Other', 'Company.Tractors.Company', 'Company.Tractors.Trailer1.Next Load', 'Company.Tractors.Trailer2.Next Load', 'Company.Tractors.Trailer3.Next Load', 'Company.Tractors.Trailer1.Current Load', 'Company.Tractors.Trailer2.Current Load', 'Company.Tractors.Trailer3.Current Load', 'Company.Tractors.Axles_Data.Tyre L1.Axle', 'Company.Tractors.Axles_Data.Tyre L2.Axle', 'Company.Tractors.Axles_Data.Tyre L3.Axle', 'Company.Tractors.Axles_Data.Tyre L4.Axle', 'Company.Tractors.Axles_Data.Tyre R1.Axle', 'Company.Tractors.Axles_Data.Tyre R2.Axle', 'Company.Tractors.Axles_Data.Tyre R3.Axle', 'Company.Tractors.Axles_Data.Tyre R4.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre L1.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre L2.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre L3.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre L4.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre R1.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre R2.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre R3.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre R4.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre L1.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre L2.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre L3.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre L4.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre R1.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre R2.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre R3.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre R4.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre L1.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre L2.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre L3.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre L4.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre R1.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre R2.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre R3.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre R4.Axle', 'Company.Tractors.Planner', 'Company.Tractors.Other', 'Company.Tractors.Maintenance', 'Company.Tractors.Breakdowns', 'Company.Tractors.Driver1', 'Company.Tractors.Conductor1', 'Company.Tractors.Conductor2', 'Company.Tractors.Fuel', 'Company.Tractors.Loads', 'Company.Company_Admin', 'Company.Customers', 'Company.Locations', 'Company.Stations', 'Company.Tanks', null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null]);
  console.log(['Details.Driver_Transactions_Fuel', 'Details.Driver_Transactions_Load', 'Details.Driver_Tractor.Fleetview_Current.Fuel', 'Details.Driver_Tractor.Fleetview_Current.Loads', 'Details.Driver_Tractor.Fleetview_Historical.Fuel', 'Details.Driver_Tractor.Fleetview_Historical.Loads', 'Details.Wages_Current'].concat((['Company.Tractors.Company', 'Company.Tractors.Current_Fleetview.Fuel', 'Company.Tractors.Current_Fleetview.Loads', 'Company.Tractors.Current_Fleetview.Other'].concat((['Company.Tractors.Trailer1.Next Load', 'Company.Tractors.Trailer2.Next Load', 'Company.Tractors.Trailer3.Next Load', 'Company.Tractors.Trailer1.Current Load', 'Company.Tractors.Trailer2.Current Load', 'Company.Tractors.Trailer3.Current Load'].concat((['Company.Tractors.Axles_Data.Tyre L1.Axle', 'Company.Tractors.Axles_Data.Tyre L2.Axle', 'Company.Tractors.Axles_Data.Tyre L3.Axle', 'Company.Tractors.Axles_Data.Tyre L4.Axle', 'Company.Tractors.Axles_Data.Tyre R1.Axle', 'Company.Tractors.Axles_Data.Tyre R2.Axle', 'Company.Tractors.Axles_Data.Tyre R3.Axle', 'Company.Tractors.Axles_Data.Tyre R4.Axle'].concat((['Company.Tractors.Trailer1.Axles_Data.Tyre L1.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre L2.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre L3.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre L4.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre R1.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre R2.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre R3.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre R4.Axle'].concat((['Company.Tractors.Trailer2.Axles_Data.Tyre L1.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre L2.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre L3.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre L4.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre R1.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre R2.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre R3.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre R4.Axle'].concat((['Company.Tractors.Trailer3.Axles_Data.Tyre L1.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre L2.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre L3.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre L4.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre R1.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre R2.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre R3.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre R4.Axle'].concat((['Company.Tractors.Driver1', 'Company.Tractors.Conductor1', 'Company.Tractors.Conductor2'].concat((['Company.Tractors.Planner', 'Company.Tractors.Other', 'Company.Tractors.Maintenance', 'Company.Tractors.Breakdowns', 'Company.Tractors.Fuel', 'Company.Tractors.Loads'].concat((['Company.Company_Admin', 'Company.Customers', 'Company.Locations', 'Company.Stations', 'Company.Tanks'].concat([null, null, null, null, null, null, null, null, null, null]))))))))))))))))))));
  console.log((((['Company.Tractors.Company', 'Company.Tractors.Current_Fleetview.Fuel', 'Company.Tractors.Current_Fleetview.Loads', 'Company.Tractors.Current_Fleetview.Other'].concat(((['Company.Tractors.Fleetview_Current.Fuel', 'Company.Tractors.Fleetview_Current.Loads', 'Company.Tractors.Fleetview_Current.Other'].concat(['Company.Tractors.Fleetview_Historical.Fuel', 'Company.Tractors.Fleetview_Historical.Loads', 'Company.Tractors.Fleetview_Historical.Other'])).concat((['Company.Trailers.Axles_Data.Tyre L1.Axle', 'Company.Trailers.Axles_Data.Tyre L2.Axle', 'Company.Trailers.Axles_Data.Tyre L3.Axle', 'Company.Trailers.Axles_Data.Tyre L4.Axle', 'Company.Trailers.Axles_Data.Tyre R1.Axle', 'Company.Trailers.Axles_Data.Tyre R2.Axle', 'Company.Trailers.Axles_Data.Tyre R3.Axle', 'Company.Trailers.Axles_Data.Tyre R4.Axle'].concat((['Company.Trailers.Axles_Data.Tyre L1.Axle', 'Company.Trailers.Axles_Data.Tyre L2.Axle', 'Company.Trailers.Axles_Data.Tyre L3.Axle', 'Company.Trailers.Axles_Data.Tyre L4.Axle', 'Company.Trailers.Axles_Data.Tyre R1.Axle', 'Company.Trailers.Axles_Data.Tyre R2.Axle', 'Company.Trailers.Axles_Data.Tyre R3.Axle', 'Company.Trailers.Axles_Data.Tyre R4.Axle'].concat(['Company.Trailers.Next Load', 'Company.Trailers.Current Load', 'Company.Trailers.Maintenance', 'Company.Trailers.Transactions', 'Company.Trailers.Tyres'])))))))).concat(['Company.Tractors.Axles_Data.Tyre L1.Axle', 'Company.Tractors.Axles_Data.Tyre L2.Axle', 'Company.Tractors.Axles_Data.Tyre L3.Axle', 'Company.Tractors.Axles_Data.Tyre L4.Axle', 'Company.Tractors.Axles_Data.Tyre R1.Axle', 'Company.Tractors.Axles_Data.Tyre R2.Axle', 'Company.Tractors.Axles_Data.Tyre R3.Axle', 'Company.Tractors.Axles_Data.Tyre R4.Axle'])).concat((['Company.Tractors.Trailer1.Axles_Data.Tyre L1.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre L2.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre L3.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre L4.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre R1.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre R2.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre R3.Axle', 'Company.Tractors.Trailer1.Axles_Data.Tyre R4.Axle'].concat(['Company.Tractors.Trailer1.Next Load', 'Company.Tractors.Trailer2.Next Load', 'Company.Tractors.Trailer3.Next Load', 'Company.Tractors.Trailer1.Current Load', 'Company.Tractors.Trailer2.Current Load', 'Company.Tractors.Trailer3.Current Load'])))).concat(((['Company.Tractors.Trailer2.Axles_Data.Tyre L1.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre L2.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre L3.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre L4.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre R1.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre R2.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre R3.Axle', 'Company.Tractors.Trailer2.Axles_Data.Tyre R4.Axle'].concat(['Company.Tractors.Trailer3.Axles_Data.Tyre L1.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre L2.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre L3.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre L4.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre R1.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre R2.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre R3.Axle', 'Company.Tractors.Trailer3.Axles_Data.Tyre R4.Axle'])).concat((['Company.Tractors.Driver1', 'Company.Tractors.Conductor1', 'Company.Tractors.Conductor2'].concat((['Company.Tractors.Planner', 'Company.Tractors.Other', 'Company.Tractors.Maintenance', 'Company.Tractors.Breakdowns', 'Company.Tractors.Fuel', 'Company.Tractors.Loads'].concat(['Company.Company_Admin', 'Company.Customers', 'Company.Locations', 'Company.Stations', 'Company.Tanks']))))))));
}

/**
 * Describe this function...
 */
async function Redundant_Code() {
}

/**
 * Describe this function...
 */
async function updateButtonLogin(logging) {
  buttonLogin = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('db5546014b7940ad8771a98d85f83036'));
  buttonLogin['label'] = (logging ? 'Please wait...' : 'Login');
  buttonLogin['disabled'] = logging;
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}

/**
 * Describe this function...
 */
async function Network_False() {
  ___arguments.context.appData['User'] = (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('Key123')), 'User'));
  if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Level')) == 'Fleet In Form') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('FIF', undefined);
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Level')) == 'Road') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('FIFDRIVER', undefined);
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Level')) == 'Office') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('FIFOFFICE', undefined);
  }
}


  if (getObjectProperty(___arguments.context.appData, 'Network')) {
    await Network_True();
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('Key123')), 'User'))))) {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = ({ [`message`]: 'Device Offline Please Check Your Connection' });
    await Network_False();
  } else {
  }

  },
  /* handler:onSubmit *//* content */
}));

define('./pages/login/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var redirectData, redirectToPageName, currentUser, sendUserTokenAndId, redirectToUrl;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (getObjectProperty(___arguments.context.appData, 'User')) ? (getObjectProperty(___arguments.context.appData, 'User')) : (await Backendless.UserService.getCurrentUser(false));
  redirectToUrl = (getObjectProperty(___arguments.context.pageData, 'redirectToUrl'));
  redirectToPageName = (getObjectProperty(___arguments.context.pageData, 'redirectToPageName'));
  redirectData = (getObjectProperty(___arguments.context.pageData, 'redirectData'));
  sendUserTokenAndId = (getObjectProperty(___arguments.context.pageData, 'sendUserTokenAndId'));
  if (currentUser) {
    if (redirectToUrl) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(redirectToUrl, false, (sendUserTokenAndId ? ({ [`userToken`]: (await (async function() {
      	return Backendless.UserService.getCurrentUserToken()
      })()),[`userId`]: (getObjectProperty(currentUser, 'objectId')),[`stayLoggedIn`]: true }) : ''));
    } else if (redirectToPageName) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(redirectToPageName, (redirectData ? (JSON.parse(redirectData)) : null));
    } else {
      if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Level')) == 'Fleet In Form') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('FIF', undefined);
      } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Level')) == 'Road') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('FIFDRIVER', undefined);
      } else if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Level')) == 'Office') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('FIFOFFICE', undefined);
      }
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/login/components/ccb626a452fecb28b16dce75c0d33791/bundle.js', [], () => ({
  /* content */
  /* handler:On Network Change */
  ['On Network Change'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['Network'] = ___arguments['Network'];
  console.log(getObjectProperty(___arguments.context.appData, 'Network'));

  },
  /* handler:On Network Change */
  /* content */
}))

define('./pages/login/components/33118fbc402234e9957a187741b5c3c9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log((function () { return BackendlessUI.Navigator.getCurrentPageName() })());

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/9f8ed0ebf408dcb1034a86a7fe69c047/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c9210b38952eacbca1ba53638aa857fc')), ({ [`objectId`]: (generateUUID().short()) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/4cd1b8aa39eab7ed09efcef8eb5a302b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('259fc04590cc26819782f51faa391c62', true);
  delete ___arguments.context.pageData['Order Book - Close'];
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('259fc04590cc26819782f51faa391c62')));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    List = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      List = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors'))))) {
        List = [];
      } else {
        List = (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: ['(',(getObjectProperty(item, 'ID')),') - ',(getObjectProperty(item, 'Registration'))].join('') });})));
      }
    }
  }

  return List

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/80d1406512571aa8d72d07b14cd4cc8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var Temp_List;

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  Temp_List = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c9210b38952eacbca1ba53638aa857fc'));
  console.log((removeItemInList(Temp_List, ___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8'), 'objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/c49e5827237440563e7ab47e638bffba/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8'), 'Products'))))) {
    console.log(___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8'));
    ___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8')['Products'] = [];
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8'), 'Products')), ({ [`ID`]: (generateUUID().short()) }));
  } else {
    console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8'), 'Products'));
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8'), 'Products')), ({ [`ID`]: (generateUUID().short()) }));
  }
  delete ___arguments.context.pageData['Order Book - Close'];

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/3fa61d9cd6aceeb7641473936799a13e/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var error;


  try {
    ___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8')['Load Date'] = ___arguments.value;

  } catch (error) {
    console.log(error);

  }
  try {
    delete ___arguments.context.pageData['Order Book - Close'];

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/2a68707e0d94612f8c2c4f7fadcab8c3/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('56410ef40bfcf63649a3737898b2a396')['Customer'] = ___arguments.value;
  delete ___arguments.context.pageData['Order Book - Close'];

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/4735156b908c430d48a7e56f07751794/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await (async function(List) {
        	/**
        	 * Removes duplicates by `label` from a list of objects.
        	 * Returns a clean array.
        	 */
        	
        	const deduped = List.filter((item, index, self) => {
        	  return index === self.findIndex(other => other.label === item.label);
        	});
        	
        	return deduped;

        })((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'Type')),[`label`]: (getObjectProperty(item, 'Type')) });}))))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('56410ef40bfcf63649a3737898b2a396')['Trailer Type'] = ___arguments.value;
  delete ___arguments.context.pageData['Order Book - Close'];

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/c015eaa2fa3abf93985aaa02c3cc52b2/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('56410ef40bfcf63649a3737898b2a396')['Load Point'] = ___arguments.value;
  delete ___arguments.context.pageData['Order Book - Close'];

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/8dccc769fd3c6d98ac9fa34e8b1dafbd/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: [(getObjectProperty(item, 'Name')),' - (',(getObjectProperty(item, 'ID')),')'].join('') });}))), 1, async (item) => {


         return (getObjectProperty(item, 'label'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('56410ef40bfcf63649a3737898b2a396')['Delivery Point'] = ___arguments.value;
  delete ___arguments.context.pageData['Order Book - Close'];

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/82ea80f41c4ad0513fe24aa7993b23a9/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var item, Orders;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Orders = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Orders = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Orders'))))) {
        Orders = [];
      } else {
        Orders = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Orders'));
      }
    }
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c9210b38952eacbca1ba53638aa857fc', Orders);

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/db08abb820229bc8a1c8b5a80c516568/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Company;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c9210b38952eacbca1ba53638aa857fc'));
  ___arguments.context.pageData['Order Book - Close'] = true;
  (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))['Orders'] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c9210b38952eacbca1ba53638aa857fc'));
  Company = (await Backendless.Data.of('Companies').findById((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'objectId')), ));
  Company['Orders'] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c9210b38952eacbca1ba53638aa857fc'));
  console.log((await Backendless.Data.of('Companies').save(Company, true)));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, 'Order Book - Close'))))) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/3d25da2adb868d4f0dcb99c59f583081/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('56410ef40bfcf63649a3737898b2a396')['Planned By'] = ___arguments.value;
  delete ___arguments.context.pageData['Order Book - Close'];

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/f243b2faf62c20a6290aa87cce9e5e0c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      delete ___arguments.context.pageData['Order Book - Close'];

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/3903ee112e34bf87b96f05b16ecb23de/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8'), 'Total Mass'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Total_Mass;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8'), 'Total Mass'))))) {
    Total_Mass = 'Total Mass: 0kg';
  } else {
    Total_Mass = ['Total Mass: ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8'), 'Total Mass')),'kg'].join('');
  }

  return Total_Mass

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/a0ddf85bad68b768ad18a218fba8ebba/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, Options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Options = [];
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products'))))) {
        Options = [];
      } else {
        Options = (await asyncListSort((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'Product')),[`label`]: (getObjectProperty(item, 'Product')) });}))), 1, async (item) => {


         return (getObjectProperty(item, 'value'));
        }));
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Total_Mass_List, j, Selected_Product, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('dbe8abd86091394832da6466eaa82111')['Product Select'] = ___arguments.value;
  delete ___arguments.context.pageData['Order Book - Close'];
  Total_Mass_List = [];
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
    Selected_Product = null;
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
      Selected_Product = null;
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products'))))) {
        Selected_Product = null;
      } else {
        Selected_Product = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Products')), async (item) => {


         return ((getObjectProperty(item, 'Product')) == ___arguments.value);
        }))[0];
      }
    }
  }
  ___arguments.context.getComponentDataStoreByUid('dbe8abd86091394832da6466eaa82111')['Product'] = Selected_Product;
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dbe8abd86091394832da6466eaa82111'), 'Units'))))) {
    ___arguments.context.getComponentDataStoreByUid('dbe8abd86091394832da6466eaa82111')['Units'] = 0;
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('cf935bf37bd68d6741f4282c42d8a341'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      addItemToList(Total_Mass_List, ((getObjectProperty(j, 'Units')) * (getObjectProperty((getObjectProperty(j, 'Product')), 'Mass'))));
    }
  } else {
    var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('cf935bf37bd68d6741f4282c42d8a341'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      addItemToList(Total_Mass_List, ((getObjectProperty(j, 'Units')) * (getObjectProperty((getObjectProperty(j, 'Product')), 'Mass'))));
    }
  }
  ___arguments.context.getComponentDataStoreByUid('56410ef40bfcf63649a3737898b2a396')['Total Mass'] = (Total_Mass_List.reduce(function(x, y) {return x + y;}));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/48f8a8c8a598a6770fbb9e5884f8c8a9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Total_Mass_List, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  delete ___arguments.context.pageData['Order Book - Close'];
  Total_Mass_List = [];
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dbe8abd86091394832da6466eaa82111'), 'Product Select'))))) {
    ___arguments.context.getComponentDataStoreByUid('dbe8abd86091394832da6466eaa82111')['Product'] = ({ [`Mass`]: 0 });
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('cf935bf37bd68d6741f4282c42d8a341'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      addItemToList(Total_Mass_List, ((getObjectProperty(j, 'Units')) * (getObjectProperty((getObjectProperty(j, 'Product')), 'Mass'))));
    }
  } else {
    var j_list2 = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('cf935bf37bd68d6741f4282c42d8a341'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      addItemToList(Total_Mass_List, ((getObjectProperty(j, 'Units')) * (getObjectProperty((getObjectProperty(j, 'Product')), 'Mass'))));
    }
  }
  ___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8')['Total Mass'] = (Total_Mass_List.reduce(function(x, y) {return x + y;}));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/09686e5b3398b278a64580378aabd211/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('cf935bf37bd68d6741f4282c42d8a341')), ___arguments.context.getComponentDataStoreByUid('dbe8abd86091394832da6466eaa82111'), '');
  delete ___arguments.context.pageData['Order Book - Close'];

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/259fc04590cc26819782f51faa391c62/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Company;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log('1');
  ___arguments.context.pageData['Transferred Order'] = ___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8');
  console.log('2');
  ___arguments.context.pageData['Order Book - Close'] = true;
  console.log('3');
  (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))['Orders'] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c9210b38952eacbca1ba53638aa857fc'));
  console.log('4');
  Company = (await Backendless.Data.of('Companies').findById((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'objectId')), ));
  console.log(Company);
  console.log((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c9210b38952eacbca1ba53638aa857fc'));
  Company['Orders'] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('c9210b38952eacbca1ba53638aa857fc'));
  console.log(Company);
  await Backendless.Data.of('Companies').save(Company, true);
  console.log(getObjectProperty(___arguments.context.pageData, 'Transferred Order'));
  await (async function() {
  	await (async function () {
  	  await ___arguments.context.getComponentByUid('2ea610b7a51c52645d041524eac7c522').close();
  	})();

  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_565da759ef7ac1916ad346ae080ef111/logic/3718ad38b96c2d68ee58ef28ecc82918/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8'), 'Customer')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8'), 'Delivery Point')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8'), 'Load Date')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8'), 'Load Point')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8'), 'Planned By')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8'), 'Products')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8'), 'Trailer Type')))) || (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b1bf9d08776e5342767860980f9e75e8'), 'objectId'))))) {
    Viewer = false;
  } else {
    Viewer = true;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_067e9b36d17dd711d089e6b2a4291bf9/logic/472f5ad621b351ecc0e617abbbf5db28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_067e9b36d17dd711d089e6b2a4291bf9/logic/9d7d2f1d8829a6f5190b3ace1411b5f7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['New Odometer'] = ___arguments.value;
  if (___arguments.value > (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Odometer')) + (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Tractor_Range')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('49d2d389fb2642edd5d6af26ce55bd73', true);
  } else {
    if (___arguments.value < (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Odometer')) == true) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('49d2d389fb2642edd5d6af26ce55bd73', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('49d2d389fb2642edd5d6af26ce55bd73', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4a91253b2e824f97819ec5ca944bf2f', true);
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_067e9b36d17dd711d089e6b2a4291bf9/logic/d4a91253b2e824f97819ec5ca944bf2f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('472f5ad621b351ecc0e617abbbf5db28', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('de4f76bf8237c3e81ed17ba8989210e4', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_067e9b36d17dd711d089e6b2a4291bf9/logic/ef167ac920154df2d9d21a092421893b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3'))))) {
          Viewer = true;
        } else {
          Viewer = false;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_067e9b36d17dd711d089e6b2a4291bf9/logic/8246883d627f6fdb1cea1f1c18831707/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1'))))) {
          Viewer = false;
        } else {
          Viewer = true;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_067e9b36d17dd711d089e6b2a4291bf9/logic/38ee6f8d945dea3dc312000ced5e28ca/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Conent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1'))))) {
      Conent = '';
    } else {
      Conent = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1')), 'Registration'));
    }
  }

  return Conent

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_067e9b36d17dd711d089e6b2a4291bf9/logic/18a68fcc34bc35687c588388d47dd774/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2'))))) {
          Viewer = false;
        } else {
          Viewer = true;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_067e9b36d17dd711d089e6b2a4291bf9/logic/d09e53c1b7be2fdfa467e287d94d9c5d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Conent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2'))))) {
      Conent = '';
    } else {
      Conent = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2')), 'Registration'));
    }
  }

  return Conent

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_067e9b36d17dd711d089e6b2a4291bf9/logic/705d7f614cfcc07c6a776417c0df79b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))))) {
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3'))))) {
          Viewer = false;
        } else {
          Viewer = true;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_067e9b36d17dd711d089e6b2a4291bf9/logic/1915977f1eae041d2b44eb55ed7f86b9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Conent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3'))))) {
      Conent = '';
    } else {
      Conent = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3')), 'Registration'));
    }
  }

  return Conent

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_067e9b36d17dd711d089e6b2a4291bf9/logic/880a6ea2e0b458feb01f5efbc87e01dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Board Truck Form - Is This Correct Select'))))) {
      } else {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Board Truck Form - Is This Correct Select')) == 'Yes') {
          Viewer = false;
        } else {
          Viewer = true;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.value == 'None') {
    delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T1'];
  } else {
    ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T1'] = ((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1 Options List')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ___arguments.value);
    }))[0]);
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1 Options List'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'))))) {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))))) {
          Options = (addItemToList((await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1 Options List')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        } else {
          Options = (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1 Options List')), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        }
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))))) {
          Options = (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1 Options List')), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        } else {
          Options = (addItemToList((await Promise.all((await asyncListFilter((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1 Options List')), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        }
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./components/reusable/r_067e9b36d17dd711d089e6b2a4291bf9/logic/43967ffb9228e9a1e4669df829d30e91/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Board Truck Form - Is This Correct Select'))))) {
      } else {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Board Truck Form - Is This Correct Select')) == 'Yes') {
          Viewer = false;
        } else {
          Viewer = true;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2 Options List'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'))))) {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))))) {
          Options = (addItemToList((await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2 Options List')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        } else {
          Options = (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2 Options List')), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        }
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))))) {
          Options = (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2 Options List')), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        } else {
          Options = (addItemToList((await Promise.all((await asyncListFilter((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2 Options List')), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        }
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.value == 'None') {
    delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T2'];
  } else {
    ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T2'] = ((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2 Options List')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ___arguments.value);
    }))[0]);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_067e9b36d17dd711d089e6b2a4291bf9/logic/ab36c4638d6ca39ce9bb1868ac1993dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Board Truck Form - Is This Correct Select'))))) {
      } else {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Board Truck Form - Is This Correct Select')) == 'Yes') {
          Viewer = false;
        } else {
          Viewer = true;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var Options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3 Options List'))))) {
      Options = [];
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'))))) {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'))))) {
          Options = (addItemToList((await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3 Options List')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        } else {
          Options = (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3 Options List')), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        }
      } else {
        if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'))))) {
          Options = (addItemToList((await Promise.all((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3 Options List')), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        } else {
          Options = (addItemToList((await Promise.all((await asyncListFilter((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3 Options List')), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })), async (item) => {


           return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2')), 'objectId')) != (getObjectProperty(item, 'objectId')));
          })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Registration')) });}))), ({ [`value`]: 'None',[`label`]: 'None' })));
        }
      }
    }
  }

  return Options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.value == 'None') {
    delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T3'];
  } else {
    ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T3'] = ((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3 Options List')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ___arguments.value);
    }))[0]);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_067e9b36d17dd711d089e6b2a4291bf9/logic/e3b306e7abda0eda37fe7e962b4e7389/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Board Truck Form - Is This Correct Select'))))) {
      } else {
        if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Board Truck Form - Is This Correct Select')) == 'Yes') {
          Viewer = false;
        } else {
          Viewer = true;
        }
      }
    }

  } catch (error) {

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, Tractor_TX, Tractor_TX_Result, T1_TX, T1_TX_Result, Tractor;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function T4() {
  try {
    Tractor_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tractor_TX;

      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 1 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'))).setOpResultId('Trailers Operation 1');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'))).setOpResultId('Trailer 1 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        Tractor_TX_Result = (await Tractor_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['Trailer1'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'));

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}

/**
 * Describe this function...
 */
async function T1() {
  try {
    T1_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = T1_TX;

      Tractor = ({ [`Trailers_Tare`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1')), '')),[`Trailers_GVM`]: undefined });
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))[''] = undefined;
      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 1 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'))).setOpResultId('Trailers Operation 1');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'))).setOpResultId('Trailer 1 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        T1_TX_Result = (await T1_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['Trailer1'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'));

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}

/**
 * Describe this function...
 */
async function Clear_Function() {
  try {
    Tractor_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tractor_TX;

      try {
        _uow.setRelation('Employees', ((getObjectProperty(___arguments.context.appData, 'Details'))[0]), 'Driver_Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Employee Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Driver1', ((getObjectProperty(___arguments.context.appData, 'Details'))[0])).setOpResultId('Driver  Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 1 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1'))).setOpResultId('Trailers Operation 1');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        Tractor_TX_Result = (await Tractor_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    console.log(Tractor_TX_Result);

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}

/**
 * Describe this function...
 */
async function T2() {
  try {
    Tractor_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tractor_TX;

      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Employees', ((getObjectProperty(___arguments.context.appData, 'Details'))[0]), 'Driver_Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Employee Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Driver1', ((getObjectProperty(___arguments.context.appData, 'Details'))[0])).setOpResultId('Driver  Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'))).setOpResultId('Trailer 2 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        Tractor_TX_Result = (await Tractor_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    console.log(Tractor_TX_Result);
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['Trailer2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'));

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}

/**
 * Describe this function...
 */
async function T3() {
  try {
    Tractor_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tractor_TX;

      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Employees', ((getObjectProperty(___arguments.context.appData, 'Details'))[0]), 'Driver_Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Employee Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Driver1', ((getObjectProperty(___arguments.context.appData, 'Details'))[0])).setOpResultId('Driver  Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))).setOpResultId('Trailer 3 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        Tractor_TX_Result = (await Tractor_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    console.log(Tractor_TX_Result);
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['Trailer3'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'));

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}

/**
 * Describe this function...
 */
async function T1T2() {
  try {
    Tractor_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tractor_TX;

      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 1 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Employees', ((getObjectProperty(___arguments.context.appData, 'Details'))[0]), 'Driver_Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Employee Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Driver1', ((getObjectProperty(___arguments.context.appData, 'Details'))[0])).setOpResultId('Driver  Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'))).setOpResultId('Trailers Operation 1');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'))).setOpResultId('Trailer 1 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'))).setOpResultId('Trailer 2 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        Tractor_TX_Result = (await Tractor_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    console.log(Tractor_TX_Result);
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['Trailer1'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['Trailer2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'));

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}

/**
 * Describe this function...
 */
async function T1T3() {
  try {
    Tractor_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tractor_TX;

      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Employees', ((getObjectProperty(___arguments.context.appData, 'Details'))[0]), 'Driver_Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Employee Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Driver1', ((getObjectProperty(___arguments.context.appData, 'Details'))[0])).setOpResultId('Driver  Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 1 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'))).setOpResultId('Trailers Operation 1');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'))).setOpResultId('Trailer 1 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))).setOpResultId('Trailer 3 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        Tractor_TX_Result = (await Tractor_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    console.log(Tractor_TX_Result);
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['Trailer1'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['Trailer3'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'));

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}

/**
 * Describe this function...
 */
async function T2T3() {
  try {
    Tractor_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tractor_TX;

      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Employees', ((getObjectProperty(___arguments.context.appData, 'Details'))[0]), 'Driver_Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Employee Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Driver1', ((getObjectProperty(___arguments.context.appData, 'Details'))[0])).setOpResultId('Driver  Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'))).setOpResultId('Trailer 2 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))).setOpResultId('Trailer 3 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        Tractor_TX_Result = (await Tractor_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    console.log(Tractor_TX_Result);
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['Trailer2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['Trailer3'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'));

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}

/**
 * Describe this function...
 */
async function T1T2T3() {
  try {
    Tractor_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tractor_TX;

      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 1 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Employees', ((getObjectProperty(___arguments.context.appData, 'Details'))[0]), 'Driver_Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Employee Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Driver1', ((getObjectProperty(___arguments.context.appData, 'Details'))[0])).setOpResultId('Driver  Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Set Operation');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'))).setOpResultId('Trailers Operation 1');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'))).setOpResultId('Trailer 1 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'))).setOpResultId('Trailer 2 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))['Warehouse'] = 'Out';
        _uow.update('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))).setOpResultId('Trailer 3 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        Tractor_TX_Result = (await Tractor_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    console.log(Tractor_TX_Result);
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['Trailer1'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['Trailer2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['Trailer3'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'));

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}

/**
 * Describe this function...
 */
async function Reset_Function() {
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['Board Truck Form'];
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['Board Truck Form - Is This Correct Select'];
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['Selected Tractor'];
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['Step 2'];
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T1'];
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T1 Options List'];
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T2'];
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T2 Options List'];
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T3'];
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T3 Options List'];
}


  console.log(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'));
  console.log(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('880a6ea2e0b458feb01f5efbc87e01dd')));
  console.log(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('43967ffb9228e9a1e4669df829d30e91')));
  console.log(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ab36c4638d6ca39ce9bb1868ac1993dc')));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))))) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3'))))) {
    } else {
      await Clear_Function();
    }
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))))) {
    await T1();
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'))))) {
    await T3();
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))))) {
    await T2();
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T1'))))) {
    await T2T3();
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T2'))))) {
    await T1T3();
  } else if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'T3'))))) {
    await T1T2();
  } else {
    await T1T2T3();
  }
  ___arguments.context.appData['Trailer Swap Model (Close)'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_067e9b36d17dd711d089e6b2a4291bf9/logic/f85b034ea6d426ecc72cb66f895a77c3/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.dataModel, 'Selected Tractor'))))) {
    ___arguments.context.dataModel['Selected Tractor'] = ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))));
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'Selected Tractor')), 'imei'))))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('472f5ad621b351ecc0e617abbbf5db28', true);
    } else {
      (getObjectProperty(___arguments.context.dataModel, 'Selected Tractor'))['New Odometer'] = (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'Selected Tractor')), 'Odometer'));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('472f5ad621b351ecc0e617abbbf5db28', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('de4f76bf8237c3e81ed17ba8989210e4', true);
    }
  } else {
    delete ___arguments.context.dataModel['Selected Tractor'];
    ___arguments.context.dataModel['Selected Tractor'] = ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor')))) ? null : (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Tractor'))));
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'Selected Tractor')), 'imei'))))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('472f5ad621b351ecc0e617abbbf5db28', true);
    } else {
      (getObjectProperty(___arguments.context.dataModel, 'Selected Tractor'))['New Odometer'] = (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'Selected Tractor')), 'Odometer'));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('472f5ad621b351ecc0e617abbbf5db28', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('de4f76bf8237c3e81ed17ba8989210e4', true);
    }
  }

  },
  /* handler:onMounted */
  /* handler:onBeforeUnmount */
  ['onBeforeUnmount'](___arguments) {
    var error, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    delete (getObjectProperty(___arguments.context.dataModel, 'Selected Tractor'))['New Odometer'];

  } catch (error) {

  }
  try {
    delete ___arguments.context.dataModel['Selected Tractor'];

  } catch (error) {

  }
  try {
    var j_list = (Object.keys(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('f85b034ea6d426ecc72cb66f895a77c3'))));
    for (var j_index in j_list) {
      j = j_list[j_index];
      try {
        delete ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('f85b034ea6d426ecc72cb66f895a77c3'))[j];

      } catch (error) {

      }
    }

  } catch (error) {

  }
  try {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('f85b034ea6d426ecc72cb66f895a77c3', null);

  } catch (error) {

  }

  },
  /* handler:onBeforeUnmount */
  /* content */
}))

define('./components/reusable/r_067e9b36d17dd711d089e6b2a4291bf9/logic/768b7c3a672faf1c5041a9a9da389d8a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, error, Driver_TX, Tractor_TX, Tractor_TX_Result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Reset_Function() {
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['Board Truck Form'];
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['Board Truck Form - Is This Correct Select'];
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['Selected Tractor'];
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['Step 2'];
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T1'];
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T1 Options List'];
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T2'];
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T2 Options List'];
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T3'];
  delete ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T3 Options List'];
}

function replaceItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l[index] = i; }  return l;}

/**
 * Describe this function...
 */
async function Yes_Function() {
  try {
    Driver_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Driver_TX;

      try {
        (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details'))['Driver_Warehouse_Status'] = 'Out';
        replaceItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'objectId');

      } catch (error) {
        console.log(error);

      }
      try {
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['Warehouse'] = 'Out';
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['Odometer'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'New Odometer'));
        (getObjectProperty(___arguments.context.appData, 'User'))['Tractor'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'));
        delete (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['New Odometer'];
        replaceItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'objectId');

      } catch (error) {
        console.log(error);

      }
      _uow.update('Employees', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details'))).setOpResultId('Driver Update Details');
      _uow.setRelation('Employees', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Details')), 'Driver_Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Employee Tractor Set Operation');
      _uow.update('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Tractor Warehouse Update');
      _uow.setRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Driver1', ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')), async (item) => {


       return ((getObjectProperty(item, 'ownerId')) == (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'objectId')));
      }))[0])).setOpResultId('Driver  Tractor Set Operation');
      await Driver_TX.execute().then(function(result) {
          const error = result && result.error

          if (error) {
            throw error
          }

        return result
        });

    })();


  } catch (error) {
    console.log(error);

  }
}

/**
 * Describe this function...
 */
async function Clear_Function() {
  try {
    Tractor_TX = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tractor_TX;

      try {
        (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1'))['Warehouse'] = 'In';
        (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1'))['Odometer'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1')), 'Odometer')) + ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'New Odometer')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Odometer'))));
        replaceItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1')), 'objectId');
        console.log(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1'));
        _uow.update('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1'))).setOpResultId('Trailer 1 Tractor Warehouse Operation');
        _uow.bulkUpsert('Tyres', [null, null, null]).setOpResultId('Trailer 1 Tyre Mileage Update Operation');

      } catch (error) {

      }
      try {
        (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2'))['Warehouse'] = 'In';
        (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2'))['Odometer'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2')), 'Odometer')) + ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'New Odometer')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Odometer'))));
        replaceItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2')), 'objectId');
        _uow.update('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2'))).setOpResultId('Trailer 2 Tractor WarehouseOperation');

      } catch (error) {
        console.log(error);

      }
      try {
        (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3'))['Warehouse'] = 'In';
        (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3'))['Odometer'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3')), 'Odometer')) + ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'New Odometer')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Odometer'))));
        replaceItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3')), 'objectId');
        _uow.update('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailer 3 Tractor WarehouseOperation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 1 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 2 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3')), 'Tractor', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))).setOpResultId('Trailer 3 Tractor Delete Operation');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer1'))).setOpResultId('Trailers Operation 1');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer2'))).setOpResultId('Trailers Operation 2');

      } catch (error) {

      }
      try {
        _uow.deleteRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor')), 'Trailer3'))).setOpResultId('Trailers Operation 3');

      } catch (error) {

      }
      try {
        Tractor_TX_Result = (await Tractor_TX.execute().then(function(result) {
            const error = result && result.error

            if (error) {
              throw error
            }

          return result
          }));

      } catch (error) {

      }

    })();

    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['Trailer1'] = null;
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['Trailer2'] = null;
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'))['Trailer3'] = null;

  } catch (error) {

  } finally {
    if (error) {
      console.log(error);
    }

  }
}


  if (___arguments.value == 'No') {
    await Clear_Function();
    ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['Board Truck Form - Is This Correct Select'] = ___arguments.value;
    ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T1 Options List'] = (await asyncListFilter((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return (((getObjectProperty(item, 'Position')).indexOf('T1') !== -1) == true);
    })), async (item) => {


     return ((getObjectProperty(item, 'Warehouse')) == 'In');
    }));
    ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T2 Options List'] = (await asyncListFilter((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return (((getObjectProperty(item, 'Position')).indexOf('T2') !== -1) == true);
    })), async (item) => {


     return ((getObjectProperty(item, 'Warehouse')) == 'In');
    }));
    ___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3')['T3 Options List'] = (await asyncListFilter((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return (((getObjectProperty(item, 'Position')).indexOf('T3') !== -1) == true);
    })), async (item) => {


     return ((getObjectProperty(item, 'Warehouse')) == 'In');
    }));
  } else {
    await Reset_Function();
    ___arguments.context.appData['Trailer Swap Model (Close)'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_067e9b36d17dd711d089e6b2a4291bf9/logic/add226685a57da7abc5840ea68a15439/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'), 'Selected Tractor'));
  console.log(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'));
  console.log(___arguments.context.pageData);
  console.log(___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_067e9b36d17dd711d089e6b2a4291bf9/logic/4a34b478a1dfb261c03e1e17d6154a58/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.getComponentDataStoreByUid('f85b034ea6d426ecc72cb66f895a77c3'));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_cdee07663cde4b1a6d8c5b263d08e342/logic/c616ad3f339af02ecd71929eae712802/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Whereclause'] = (['ownerid = \'',___arguments.value,'\''].join(''));
  ___arguments.context.pageData['ownerId'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_cdee07663cde4b1a6d8c5b263d08e342/logic/f6c7c2ab482c8d324f19d24743c99e6e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData[___arguments.value] = true;
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.pageData, ___arguments.prevValue))))) {
  } else {
    if ((getObjectProperty(___arguments.context.pageData, ___arguments.prevValue)) == true) {
      delete ___arguments.context.pageData[___arguments.prevValue];
    }
    ___arguments.context.pageData[___arguments.value] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_cdee07663cde4b1a6d8c5b263d08e342/logic/e128e954bdf214963bfeab657c75ea24/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('deb854a746c60005f89a1d3d0ae335f7', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0ce36813e5871443a01e99a77d6f6b9c/logic/934b5c16dfde1dfb644420b91dd66057/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectCreate */
  async ['onObjectCreate'](___arguments) {
    var Transaction, Created_Fleet_View, Bulk_Created_Axles, Axles, ID, Double_Wheel_Text, Single_Wheel_Text, Steer_Wheel_Text, Double_Wheel_Axles, Single_Wheel_Axles, Steer_Wheel_Axles;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Axles = [];
  Steer_Wheel_Axles = [];
  Single_Wheel_Axles = [];
  Double_Wheel_Axles = [];
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Steer1'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Steer1'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 1,[`Type`]: 'Steer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Steer1')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      addItemToList(Steer_Wheel_Axles, true);
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Steer2'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Steer2'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 2,[`Type`]: 'Steer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Steer2')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      addItemToList(Steer_Wheel_Axles, true);
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Drive1'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Drive1'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 3,[`Type`]: 'Drive',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Drive1')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Drive1')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Drive1')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Drive2'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Drive2'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 4,[`Type`]: 'Drive',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Drive2')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Drive2')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Drive2')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Drive3'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Drive3'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 5,[`Type`]: 'Drive',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Drive3')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Drive3')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Drive3')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Spare_1'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Spare_1'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 7,[`Type`]: 'Spare',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Spare_1')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Spare_2'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Spare_2'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 8,[`Type`]: 'Spare',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Spare_2')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Spare_3'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Spare_3'))) {
      addItemToList(Axles, ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 9,[`Type`]: 'Spare',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Spare_3')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
    }
  }
  if (Steer_Wheel_Axles.length == 0) {
    Steer_Wheel_Text = null;
  } else if (Steer_Wheel_Axles.length == 1) {
    Steer_Wheel_Text = 'Steer Axle (1)';
  } else if (Steer_Wheel_Axles.length == 2) {
    Steer_Wheel_Text = 'Steer Axle (2)';
  }
  if (Single_Wheel_Axles.length == 0) {
    Single_Wheel_Text = null;
  } else if (Single_Wheel_Axles.length == 1) {
    Single_Wheel_Text = 'Drive Axle Single Wheel (1)';
  } else if (Single_Wheel_Axles.length == 2) {
    Single_Wheel_Text = 'Drive Axle Single Wheel (2)';
  } else if (Single_Wheel_Axles.length == 3) {
    Single_Wheel_Text = 'Drive Axle Single Wheel (3)';
  }
  if (Double_Wheel_Axles.length == 0) {
    Double_Wheel_Text = null;
  } else if (Double_Wheel_Axles.length == 1) {
    Double_Wheel_Text = 'Drive Axle Double Wheel (1)';
  } else if (Double_Wheel_Axles.length == 2) {
    Double_Wheel_Text = 'Drive Axle Double Wheel (2)';
  } else if (Double_Wheel_Axles.length == 3) {
    Double_Wheel_Text = 'Drive Axle Double Wheel (3)';
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Steer_Wheel_Text))) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Single_Wheel_Text))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Double_Wheel_Text))) {
      } else {
        ___arguments.newObject['Axles'] = Double_Wheel_Text;
      }
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Single_Wheel_Text))) {
      } else {
        ___arguments.newObject['Axles'] = ([Single_Wheel_Text,',',Double_Wheel_Text].join(''));
      }
    }
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Single_Wheel_Text))) {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Double_Wheel_Text))) {
        ___arguments.newObject['Axles'] = Steer_Wheel_Text;
      } else {
        ___arguments.newObject['Axles'] = ([Steer_Wheel_Text,',',Double_Wheel_Text].join(''));
      }
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Double_Wheel_Text))) {
        ___arguments.newObject['Axles'] = ([Steer_Wheel_Text,',',Single_Wheel_Text].join(''));
      } else {
        ___arguments.newObject['Axles'] = ([Steer_Wheel_Text,',',Single_Wheel_Text,',',Double_Wheel_Text].join(''));
      }
    }
  }
  ___arguments.newObject['ownerId'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId'));
  ID = (generateUUID().short());
  ___arguments.newObject['ID'] = ID;
  ___arguments.newObject['Registration'] = ID;
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Bulk_Created_Axles = (_uow.bulkCreate('Axles', Axles));
    _uow.update('Tractors', ___arguments.newObject);
    _uow.setRelation('Tractors', ___arguments.newObject, 'Axles_Data', Bulk_Created_Axles);
    _uow.setRelation('Tractors', ___arguments.newObject, 'Company', [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'objectId'))]);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors', [___arguments.newObject]);
    Created_Fleet_View = (_uow.create('Fleetview', ({ [`Current_Mileage`]: 0,[`Distance_Travelled`]: 0,[`Distance_Travelled_Mileage`]: 0,[`Fuel_Consumption_Ideal`]: 0,[`Fuel_Cost`]: 0,[`Fuel_Litres`]: 0,[`Gain_Loss_On_Loading_Delays`]: 0,[`Gain_Loss_On_Loading_Mileage`]: 0,[`Gain_Loss_On_Loading_Tonnage`]: 0,[`Licenses_Due`]: undefined,[`Maintenance_Plan_Per_Km_Total`]: 0,[`Maintenance_Repairs_Tractor`]: 0,[`Maintenance_Repairs_Trailers`]: 0,[`Mileage_Target`]: 0,[`Now`]: (new Date()),[`Profit_Target`]: 0,[`Projected_Commission`]: 0,[`Salary_Wages`]: 0,[`Service_Notices`]: undefined,[`Toll_Fees`]: 0,[`Toll_Fees_Per_Km_Total`]: 0,[`Tonnage_Average`]: 0,[`Tonnage_Permissible`]: 0,[`Tonnage_Target`]: 0,[`Tonnage_Total`]: 0,[`Tractor_Fixed_Expenses`]: 0,[`Trailer_Fixed_Expenses`]: 0,[`Turnover`]: 0,[`Tyre_CPK_Estimated`]: 0,[`Tyre_Expenses_Actual`]: 0,[`Tyre_Expenses_Estimated`]: 0,[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) })));
    _uow.setRelation('Tractors', ___arguments.newObject, 'Fleetview_Current', [Created_Fleet_View]);
    _uow.setRelation('Tractors', ___arguments.newObject, 'Current_Fleetview', [Created_Fleet_View]);
    _uow.addToRelation('Tractors', ___arguments.newObject, 'Fleetview_Historical', [Created_Fleet_View]);

  })();

  console.log((await Transaction.execute()));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);

  },
  /* handler:onObjectCreate */
  /* content */
}))

define('./components/reusable/r_0ce36813e5871443a01e99a77d6f6b9c/logic/4856c30fd8fe6206aabb2098a2cc5df3/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectCreate */
  async ['onObjectCreate'](___arguments) {
    var Axles, Bulk_Created_Axles, Double_Wheel_Axles, Double_Wheel_Text, ID, Single_Wheel_Axles, Single_Wheel_Text, Transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Axles = [];
  Single_Wheel_Axles = [];
  Double_Wheel_Axles = [];
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer1'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer1'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 1,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer1')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer1')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer1')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer2'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer2'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 2,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer2')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer2')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer2')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer3'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer3'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 3,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer3')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer3')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer3')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer4'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer4'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 4,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer4')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer4')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer4')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer5'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer5'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 5,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer5')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer5')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer5')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer6'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer6'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 6,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer6')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer6')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer6')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer7'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer7'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 7,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer7')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer7')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer7')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer8'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer8'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 8,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer8')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer8')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer8')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer9'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer9'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 9,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer9')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer9')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer9')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer10'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer10'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 10,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer10')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
      if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer10')) == 2) {
        addItemToList(Single_Wheel_Axles, true);
      } else if ((getObjectProperty(___arguments.newObject, 'FIF_Trailer10')) == 4) {
        addItemToList(Double_Wheel_Axles, true);
      }
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare1'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare1'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 11,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare1')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare2'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare2'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 12,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare2')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
    }
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare3'))))) {
  } else {
    if (0 < (getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare3'))) {
      addItemToList(Axles, ({ [`Parent ID (Trailer)`]: (getObjectProperty(___arguments.newObject, 'objectId')),[`Position Number`]: 13,[`Type`]: 'Trailer',[`Tyres Per Axle`]: (getObjectProperty(___arguments.newObject, 'FIF_Trailer_Spare3')),[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')) }));
    }
  }
  if (Single_Wheel_Axles.length == 0) {
    Single_Wheel_Text = null;
  } else if (Single_Wheel_Axles.length == 1) {
    Single_Wheel_Text = 'Single Wheel (1)';
  } else if (Single_Wheel_Axles.length == 2) {
    Single_Wheel_Text = 'Single Wheel (2)';
  } else if (Single_Wheel_Axles.length == 3) {
    Single_Wheel_Text = 'Single Wheel (3)';
  } else if (Single_Wheel_Axles.length == 4) {
    Single_Wheel_Text = 'Single Wheel (4)';
  } else if (Single_Wheel_Axles.length == 5) {
    Single_Wheel_Text = 'Single Wheel (5)';
  } else if (Single_Wheel_Axles.length == 6) {
    Single_Wheel_Text = 'Single Wheel (6)';
  } else if (Single_Wheel_Axles.length == 7) {
  } else if (Single_Wheel_Axles.length == 8) {
  } else if (Single_Wheel_Axles.length == 9) {
  } else if (Single_Wheel_Axles.length == 10) {
  }
  if (Double_Wheel_Axles.length == 0) {
    Double_Wheel_Axles = null;
  } else if (Double_Wheel_Axles.length == 1) {
    Double_Wheel_Text = 'Double Wheel (1)';
  } else if (Double_Wheel_Axles.length == 2) {
    Double_Wheel_Text = 'Double Wheel (2)';
  } else if (Double_Wheel_Axles.length == 3) {
    Double_Wheel_Text = 'Double Wheel (3)';
  } else if (Double_Wheel_Axles.length == 4) {
    Double_Wheel_Text = 'Double Wheel (4)';
  } else if (Double_Wheel_Axles.length == 5) {
    Double_Wheel_Text = 'Double Wheel (5)';
  } else if (Double_Wheel_Axles.length == 6) {
    Double_Wheel_Text = 'Double Wheel (6)';
  } else if (Single_Wheel_Axles.length == 7) {
  } else if (Single_Wheel_Axles.length == 8) {
  } else if (Single_Wheel_Axles.length == 9) {
  } else if (Single_Wheel_Axles.length == 10) {
  }
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Single_Wheel_Text))) {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Double_Wheel_Axles))) {
    } else {
      ___arguments.newObject['Axles'] = Double_Wheel_Axles;
    }
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Double_Wheel_Axles))) {
    } else {
      ___arguments.newObject['Axles'] = ([Single_Wheel_Text,',',Double_Wheel_Text].join(''));
    }
  }
  if ((getObjectProperty(___arguments.newObject, 'FIF_Dolly_Select')) == true) {
    ___arguments.newObject['Position'] = 'T2';
  }
  if ((getObjectProperty(___arguments.newObject, 'FIF_Follower_Select')) == true) {
    ___arguments.newObject['Position'] = 'T1,T2,T3';
  }
  if ((getObjectProperty(___arguments.newObject, 'FIF_Leader_Select')) == true) {
    ___arguments.newObject['Position'] = ['T1'];
  }
  ___arguments.newObject['ownerId'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId'));
  ID = (generateUUID().short());
  ___arguments.newObject['ID'] = ID;
  ___arguments.newObject['Registration'] = ID;
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Bulk_Created_Axles = (_uow.bulkCreate('Axles', Axles));
    _uow.update('Trailers', ___arguments.newObject);
    _uow.setRelation('Trailers', ___arguments.newObject, 'Axles_Data', Bulk_Created_Axles);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers', [___arguments.newObject]);

  })();

  console.log((await Transaction.execute()));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);

  },
  /* handler:onObjectCreate */
  /* content */
}))

define('./components/reusable/r_0ce36813e5871443a01e99a77d6f6b9c/logic/6861900d258c4b88706e5c87c799f649/bundle.js', [], () => ({
  /* content */
  /* handler:onObjectCreate */
  async ['onObjectCreate'](___arguments) {
    var Axles, Bowser, Bowsers, Bulk_Created_Bowsers, ID, list, Transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Bowsers = [];
  var repeat_end = (getObjectProperty(___arguments.newObject, 'BowserNumber'));
  for (var count = 0; count < repeat_end; count++) {
    Bowser = ({ [`Name`]: (generateUUID().short()),[`Meter`]: 0,[`ownerId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId')),[`objectId`]: (generateUUID().long()) });
    addItemToList(Bowsers, Bowser);
  }
  ___arguments.newObject['ownerId'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ownerId'));
  ID = (generateUUID().short());
  ___arguments.newObject['Name'] = ID;
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Bulk_Created_Bowsers = (_uow.bulkCreate('Bowsers', Bowsers));
    _uow.update('Tanks', ___arguments.newObject);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tanks', [___arguments.newObject]);
    _uow.setRelation('Tanks', ___arguments.newObject, 'Bowsers', Bulk_Created_Bowsers);

  })();

  console.log((await Transaction.execute()));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', false);

  },
  /* handler:onObjectCreate */
  /* content */
}))

define('./components/reusable/r_0ce36813e5871443a01e99a77d6f6b9c/logic/3c5758390996eca3a9354351427b0d67/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Employee_ID, Employee_Email, Employee_Number, Transaction, Employee_Details, Company, User;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Conductor() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Employee_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')).length;
  Employee_ID = Employee_Number <= 10 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0000',Employee_Number].join('') : (Employee_Number <= 100 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 000',Employee_Number].join('') : (Employee_Number <= 1000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 00',Employee_Number].join('') : (Employee_Number <= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0',Employee_Number].join('') : (Employee_Number <= 100000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('')))));
  Employee_Email = [(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Employee_ID)),'@',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name'))))].join('');
}

/**
 * Describe this function...
 */
async function Admin() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Employee_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')).length;
  Employee_ID = Employee_Number <= 10 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0000',Employee_Number].join('') : (Employee_Number <= 100 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 000',Employee_Number].join('') : (Employee_Number <= 1000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 00',Employee_Number].join('') : (Employee_Number <= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0',Employee_Number].join('') : (Employee_Number <= 100000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('')))));
  Employee_Email = [(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Employee_ID)),'@',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name'))))].join('');
}

/**
 * Describe this function...
 */
async function Load_Planner() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Employee_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')).length;
  Employee_ID = Employee_Number <= 10 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0000',Employee_Number].join('') : (Employee_Number <= 100 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 000',Employee_Number].join('') : (Employee_Number <= 1000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 00',Employee_Number].join('') : (Employee_Number <= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0',Employee_Number].join('') : (Employee_Number <= 100000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('')))));
  Employee_Email = [(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Employee_ID)),'@',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name'))))].join('');
}

/**
 * Describe this function...
 */
async function Mechanic() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Employee_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')).length;
  Employee_ID = Employee_Number <= 10 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0000',Employee_Number].join('') : (Employee_Number <= 100 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 000',Employee_Number].join('') : (Employee_Number <= 1000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 00',Employee_Number].join('') : (Employee_Number <= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0',Employee_Number].join('') : (Employee_Number <= 100000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('')))));
  Employee_Email = [(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Employee_ID)),'@',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name'))))].join('');
}

/**
 * Describe this function...
 */
async function Attendant() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1e16c9d5d4b1dabf21069d8f2a1e056a', true);
  Employee_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Employees')).length;
  Employee_ID = Employee_Number <= 10 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0000',Employee_Number].join('') : (Employee_Number <= 100 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 000',Employee_Number].join('') : (Employee_Number <= 1000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 00',Employee_Number].join('') : (Employee_Number <= 10000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' 0',Employee_Number].join('') : (Employee_Number <= 100000 ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('') : [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Employees')),' ',Employee_Number].join('')))));
  Employee_Email = [(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Employee_ID)),'@',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name'))))].join('');
}

/**
 * Describe this function...
 */
async function Driver() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('362e2c1707cd5248462f0d36753be889', true);
  Employee_ID = Employee_Number <= 10 ? [(getObjectProperty(Company, 'ID Tag Employees')),' 0000',Employee_Number].join('') : (Employee_Number <= 100 ? [(getObjectProperty(Company, 'ID Tag Employees')),' 000',Employee_Number].join('') : (Employee_Number <= 1000 ? [(getObjectProperty(Company, 'ID Tag Employees')),' 00',Employee_Number].join('') : (Employee_Number <= 10000 ? [(getObjectProperty(Company, 'ID Tag Employees')),' 0',Employee_Number].join('') : (Employee_Number <= 100000 ? [(getObjectProperty(Company, 'ID Tag Employees')),' ',Employee_Number].join('') : [(getObjectProperty(Company, 'ID Tag Employees')),' ',Employee_Number].join('')))));
  Employee_Email = [(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273'](Employee_ID)),'@',(await BackendlessUI.Functions.Custom['fn_d1ef11f72ed2119bde5d1ddb12b64273']((getObjectProperty(Company, 'Name')))),'.co.za'].join('').toLowerCase();
  console.log(Employee_Email);
  User = (await Backendless.UserService.register( new Backendless.User({ 'Email': Employee_Email,'password': '12345','App': 'Commercial','Level': 'Road','Name': Employee_ID,'Now': (new Date()),'Username': Employee_Email,'ownerId': (getObjectProperty(Company, 'ownerId')) }) ));
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    _uow.setRelation('Users', User, 'Company', [Company]);
    Employee_Details = (_uow.create('Employees', ({ [`Commencement`]: (new Date()),[`CID`]: (getObjectProperty(Company, 'ownerId')),[`Company_ID`]: Employee_ID,[`Driver Ratings`]: ['Monthly Tonnage', 'Monthly Mileage', 'Fuel Consumption', 'Ideal Garages', 'Correct Loading'],[`Driver Target Mileage`]: 0,[`Driver Target Tonnage`]: 0,[`Driver_License_Code`]: 'EB',[`Driver_License_Expiry_Date`]: (new Date()),[`Driver_PDP_Expiry_Date`]: (new Date()),[`Driver_Warehouse_Status`]: 'In',[`Employee_Details_Nickname`]: Employee_ID,[`Employee_Details_Position`]: 'Driver',[`Now`]: (new Date()),[`Wages_Rate_Basic`]: 0,[`Wages_Rate_Contractor_Mileage`]: 0,[`Wages_Rate_Contractor_Tonnage`]: 0,[`Wages_Rate_Good_Driving`]: 0,[`Wages_Rate_Good_Planning_Mileage`]: 0,[`Wages_Rate_Good_Planning_Tonnage`]: 0,[`Wages_Rate_Sleep_Out`]: 0,[`Wages_Rate_Target_Mileage`]: 0,[`Wages_Rate_Target_Mileage_Start`]: 0,[`Wages_Rate_Target_Tonnage`]: 0,[`Wages_Rate_Target_Tonnage_Start`]: 0,[`ownerId`]: (getObjectProperty(User, 'objectId')) })));
    _uow.setRelation('Employees', Employee_Details, 'Company', [Company]);
    _uow.setRelation('Users', User, 'Details', [Employee_Details]);
    _uow.addToRelation('Companies', Company, 'Employees', [Employee_Details]);

  })();

  console.log((await Transaction.execute()));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('362e2c1707cd5248462f0d36753be889', false);
}


  Employee_Number = (await Backendless.Data.of('Users').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(___arguments.context.pageData, 'ownerId')),'\''].join('')))));
  Company = (await Backendless.Data.of('Companies').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId = \'',(getObjectProperty(___arguments.context.pageData, 'ownerId')),'\''].join(''))).setPageSize(10)))[0];
  if ('Driver' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c38359b6b32a2eb91939164745d67a2e')), 'value'))) {
    await Driver();
  } else if ('Conductor' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c38359b6b32a2eb91939164745d67a2e')), 'value'))) {
    await Conductor();
  } else if ('Load Planner' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c38359b6b32a2eb91939164745d67a2e')), 'value'))) {
    await Load_Planner();
  } else if ('Admin' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c38359b6b32a2eb91939164745d67a2e')), 'value'))) {
    await Admin();
  } else if ('Mechanic' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c38359b6b32a2eb91939164745d67a2e')), 'value'))) {
    await Mechanic();
  } else if ('Attendant' == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c38359b6b32a2eb91939164745d67a2e')), 'value'))) {
    await Attendant();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_e45f5557c664d65c079c40e156f46fdf/logic/b2f3dd83296fd85f4fa795d33b436779/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('516c228a75d2debadc15e93f76f1bd15');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('516c228a75d2debadc15e93f76f1bd15');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/7c844bedb74f9916e6928cd1a10ace5f/bundle.js', [], () => ({
  /* content */
  /* handler:modalVisibilityLogic */
  async ['modalVisibilityLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'Track IT Close')) == true) {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7c844bedb74f9916e6928cd1a10ace5f');
    delete ___arguments.context.appData['Track IT Close'];
  }

  },
  /* handler:modalVisibilityLogic */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/fc96be21cf223812ebb3f1aa22b75653/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/e367b5edcff49236a58d5a3599cdd4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Points_List, Time_Now, Time_Start, Live_Start;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Track_It_Function() {
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live'))], ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  }
}


  if (___arguments.value == 'Historical') {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('4857dff971b24802ce5833ad7e5b56c6');
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('e367b5edcff49236a58d5a3599cdd4d5', null);
  } else if (___arguments.value == '15 Minutes') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (900 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '30 Minutes') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (1800 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '1 Hour') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (3600 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '2 Hours') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (7200 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '4 Hours') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (14400 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '6 Hours') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (21600 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == 'Live') {
    Time_Now = (new Date());
    Live_Start = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (300 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
    ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
    await Track_It_Function();
    while (___arguments.value == 'Live') {
      if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e367b5edcff49236a58d5a3599cdd4d5')) == 'Live') {
        await new Promise(r => setTimeout(r, 60000 || 0));
        Time_Now = (new Date());
        Time_Start = Live_Start;
        Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), Time_Start, Time_Now));
        ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
        await Track_It_Function();
      } else {
      }
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/7fb75eae7b7b411ea4549a4fe3812d6b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 100 || 0));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Density'] = ___arguments.value;
  await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')))) ? null : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points'))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')))) ? [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live'))] : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points'))), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, null);

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/1feb80e94055fb0653b5ac8571fe79dc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('91ce77bf29654236309c47e9151fd443');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('91ce77bf29654236309c47e9151fd443');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('7c844bedb74f9916e6928cd1a10ace5f');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/bcfc8832cc1525e208a9606351c2b5b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'))))) {
      Content = '';
    } else {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'))) {
        Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Registration'));
      } else {
        Content = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'ID'));
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/1d543af3cf028fdd8705e2b7dcb3495d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/8059d0fc723c18a6b09dd354a0ce3cd3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Location;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Location = (await Backendless.Request.get(`${Backendless.appPath}/services/GoogleAPI/PlaceDetails`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'placeId': JSON.stringify((getObjectProperty(___arguments.value, 'place_id'))) }).send());
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Location, 'result')), 'geometry')), 'location')), 'lat')), (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Location, 'result')), 'geometry')), 'location')), 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', 18);
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('00a10794c3394968e50d921a03174098', [(getObjectProperty((getObjectProperty((getObjectProperty(Location, 'result')), 'geometry')), 'location'))]);
  console.log(Location);

  },
  /* handler:onChange */
  /* handler:onPlacesPredictionsAssignment */
  ['onPlacesPredictionsAssignment'](___arguments) {
      return ({ [`componentRestrictions`]: ({ [`country`]: ['za'] }) })

  },
  /* handler:onPlacesPredictionsAssignment */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/6756de42fd718227da45ff47f046b81d/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('7448c9eda24219d3805f149b160978d1');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('7448c9eda24219d3805f149b160978d1');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e05ae79169330a652453cd9554b2a019', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/a3831b4e28410e685174d8da9c366071/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('aabe2c13c4fd13c136c825ef9fe41209');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('aabe2c13c4fd13c136c825ef9fe41209');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Zoom, Centre, Time_Start;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e05ae79169330a652453cd9554b2a019', false);
  Zoom = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).zoom })('00a10794c3394968e50d921a03174098'));
  Centre = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('00a10794c3394968e50d921a03174098'));
  Time_Start = (new Date());
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']('5806738', (Time_Start - 900000), Time_Start));
  await new Promise(r => setTimeout(r, 100 || 0));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : 5)))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, null);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : 5)))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, null);
  }
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty(Centre, 'lat')), (getObjectProperty(Centre, 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', Zoom);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/30f560e713165cb86a236197f8ada466/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('170921392d8863bdc1263682b2041699');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('170921392d8863bdc1263682b2041699');

  },
  /* handler:onMouseOut */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/47460d949ad29456821b4bf8d56d8f4b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) == 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength(___arguments.value) > 0) {
    if (getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f'))) > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c677cffcef812bd62009ab82ffebc39f', true);
    }
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) != 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength(___arguments.value) > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/d598fd450f8626b35e41e328909a87bc/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'Load/Offload Point') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c677cffcef812bd62009ab82ffebc39f', true);
    if (___arguments.value == 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0 && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f'))) > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
    }
  } else if (___arguments.value != 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/e587223e046dab92231b76ac8107599f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) == 'Load/Offload Point' && getValueLength(___arguments.value) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0 && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f'))) > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
  } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) != 'Load/Offload Point' && getValueLength(___arguments.value) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/c677cffcef812bd62009ab82ffebc39f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var error;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == 'New Customer') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24713758b56f92727e7597b92b6ba90c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95478b25e6e94196eb632a0e6be7fe11', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dc48734547b319ff2a1d3af8d56d1f8', true);
  } else {
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('24713758b56f92727e7597b92b6ba90c', false);

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('95478b25e6e94196eb632a0e6be7fe11', false);

    } catch (error) {
      console.log(error);

    }
    try {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0dc48734547b319ff2a1d3af8d56d1f8', false);

    } catch (error) {
      console.log(error);

    }
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) == 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0 && getValueLength(___arguments.value) > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
    } else if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) != 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);
    }
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}



  return (addItemToList((await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Customer')) });}))), ({ [`value`]: 'New Customer',[`label`]: 'New Customer' })))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/24713758b56f92727e7597b92b6ba90c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) == 'Load/Offload Point' && getValueLength(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f'))) > 0 && getValueLength((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)'))) > 0 && getValueLength(___arguments.value) > 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/8e7f5b851c869307b79fa534817e6f65/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Zoom, Centre, Time_Start;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Zoom = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).zoom })('00a10794c3394968e50d921a03174098'));
  Centre = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('00a10794c3394968e50d921a03174098'));
  Time_Start = (new Date());
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']('5806738', (Time_Start - 900000), Time_Start));
  await new Promise(r => setTimeout(r, 100 || 0));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live'))], ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), true, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f')), ___arguments.context.appData);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), true, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f')), ___arguments.context.appData);
  }
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty(Centre, 'lat')), (getObjectProperty(Centre, 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', Zoom);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8e7f5b851c869307b79fa534817e6f65', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/31a9a6d861969bf2e4e9e2bda371ab1d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'geofencePolygons'))))) {
    Viewer = false;
  } else {
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path')).length >= 3) {
      Viewer = true;
    } else {
      Viewer = false;
    }
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Zoom, Centre, j, TrackitModal_Keys, error, Location, Results, New_Customer, Location_Transaction, Location_Refrence, Customer_Refrence, ID, ID_Number_Variable, ID_Start, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function do_something() {
  Zoom = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).zoom })('00a10794c3394968e50d921a03174098'));
  Centre = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).center })('00a10794c3394968e50d921a03174098'));
  try {
    ID_Number_Variable = String((Number((subsequenceFromEndLast((getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), 1, async (item) => {


     return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 3))));
    })).slice(-1)[0]), 'ID')), 3)))) + 1);

  } catch (error) {
    console.log(error);

  } finally {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](ID_Number_Variable))) {
      ID_Number_Variable = 1;
    }

  }
  try {
    ID_Start = subsequenceFirstFromEnd((getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), 1, async (item) => {


     return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 3))));
    })).slice(-1)[0]), 'ID')), 4);

  } catch (error) {
    console.log(error);

  } finally {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](ID_Start))) {
      ID_Start = String((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')).slice(0, 5)) + String(' Lo ');
    }

  }
  ID = String(ID_Start) + String(getValueLength(ID_Number_Variable) == 1 ? String('000') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 2 ? String('00') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 3 ? String('0') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 4 ? ID_Number_Variable : ID_Number_Variable))));
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f')) == 'New Customer') {
    Location = ({ [`Address`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)')),[`Color`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f')),[`Contact_Name`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIT - GeoFence (Contact Name)')),[`Geo Fences`]: (new Backendless.Data.Polygon((await Promise.all((addItemToList((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path')), ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]))).map(async item => {; return (new Backendless.Data.Point().setX((getObjectProperty(item, 'lng'))).setY((getObjectProperty(item, 'lat'))));}))), )),[`ID`]: ID,[`Name`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)')),[`Phone`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIT - GeoFence (Contact Number)')),[`Point`]: (new Backendless.Data.Point().setX((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]), 'lng'))).setY((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]), 'lat')))),[`Type`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')) });
  } else {
    Location = ({ [`Address`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)')),[`Color`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e587223e046dab92231b76ac8107599f')),[`Contact_Name`]: '',[`Geo Fences`]: (new Backendless.Data.Polygon((await Promise.all((addItemToList((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path')), ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]))).map(async item => {; return (new Backendless.Data.Point().setX((getObjectProperty(item, 'lng'))).setY((getObjectProperty(item, 'lat'))));}))), )),[`ID`]: ID,[`Name`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIt - GeoFencing (Name)')),[`Phone`]: '',[`Point`]: (new Backendless.Data.Point().setX((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]), 'lng'))).setY((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]), 'lat')))),[`Type`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')) });
  }
  Location_Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Location_Transaction;

    Location_Refrence = (_uow.create('Locations', Location));
    _uow.setRelation('Locations', Location_Refrence, 'Company', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')));
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations', [Location_Refrence]);
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('d598fd450f8626b35e41e328909a87bc')) == 'Load/Offload Point') {
      if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f')) == 'New Customer') {
        try {
          ID_Number_Variable = String((Number((subsequenceFromEndLast((getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), 1, async (item) => {


           return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 3))));
          })).slice(-1)[0]), 'ID')), 3)))) + 1);

        } catch (error) {
          console.log(error);

        } finally {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](ID_Number_Variable))) {
            ID_Number_Variable = 1;
          }

        }
        try {
          ID_Start = subsequenceFirstFromEnd((getObjectProperty(((await asyncListSort((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), 1, async (item) => {


           return (Number((subsequenceFromEndLast((getObjectProperty(item, 'ID')), 3))));
          })).slice(-1)[0]), 'ID')), 4);

        } catch (error) {
          console.log(error);

        } finally {
          if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](ID_Start))) {
            ID_Start = String((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Name')).slice(0, 5)) + String(' C ');
          }

        }
        console.log(ID_Number_Variable);
        console.log(ID_Start);
        ID = String(ID_Start) + String(getValueLength(ID_Number_Variable) == 1 ? String('000') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 2 ? String('00') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 3 ? String('0') + String(ID_Number_Variable) : (getValueLength(ID_Number_Variable) == 4 ? ID_Number_Variable : ID_Number_Variable))));
        New_Customer = ({ [`Customer`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIT - GeoFence (Customer Name)')),[`Contact_Name`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIT - GeoFence (Contact Name)')),[`Contact_Phone`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIT - GeoFence (Contact Number)')),[`ID`]: ID,[`Customer_Location`]: (new Backendless.Data.Point().setX((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]), 'lng'))).setY((getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.appData, 'geofencePolygons')), 'path'))[0]), 'lat')))),[`Name`]: (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'TrackIT - GeoFence (Customer Name)')),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')) });
        Customer_Refrence = (_uow.create('Customers', New_Customer));
        _uow.addToRelation('Customers', Customer_Refrence, 'Locations', [Location_Refrence]);
        _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers', [Customer_Refrence]);
      } else {
        _uow.addToRelation('Customers', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f')), 'Locations', [Location_Refrence]);
      }
    }

  })();

  Results = (await Location_Transaction.execute().then(function(result) {
      const error = result && result.error

      if (error) {
        throw error
      }

    return result
    }));
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('c677cffcef812bd62009ab82ffebc39f')) == 'New Customer') {
    try {
      New_Customer['objectId'] = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Results, 'results')), 'createCustomers1')), 'result')), 'objectId'));

    } catch (error) {
      console.log(error);

    }
    try {
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Customers')), New_Customer);

    } catch (error) {
      console.log(error);

    }
  }
  Location['objectId'] = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Results, 'results')), 'createLocations1')), 'result')), 'objectId'));
  addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), Location);
  delete ___arguments.context.appData['geofencePolygons'];
  delete ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['TrackIT - Geofence Add'];
  await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Warnings Only' ? 10 : 5))))))), [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Live'))], ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('e367b5edcff49236a58d5a3599cdd4d5', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('d598fd450f8626b35e41e328909a87bc', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('e587223e046dab92231b76ac8107599f', null);

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('c677cffcef812bd62009ab82ffebc39f', null);

  } catch (error) {
    console.log(error);

  }
  TrackitModal_Keys = (Object.keys(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')));
  for (var j_index in TrackitModal_Keys) {
    j = TrackitModal_Keys[j_index];
    delete ___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f')[j];
  }
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty(Centre, 'lat')), (getObjectProperty(Centre, 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', Zoom);
}


  await do_something();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e05ae79169330a652453cd9554b2a019', false);

  },
  /* handler:onClick */
  /* handler:onVisibilityChange */
  async ['onVisibilityChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))['Locations'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


   return ('geofence.objectId' != (getObjectProperty(item, 'objectId')));
  }));

  },
  /* handler:onVisibilityChange */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/4707bc0a4ece663933c7175ba3875eef/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  async ['onMaxDateAssignment'](___arguments) {
    var Maximum;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'To'))))) {
    Maximum = (new Date());
  } else {
    Maximum = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'To'));
  }

  return Maximum

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/5c27fccabc3e5062bda28148859fe1f1/bundle.js', [], () => ({
  /* content */
  /* handler:onMinDateAssignment */
  async ['onMinDateAssignment'](___arguments) {
    var Minimum;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'From'))))) {
  } else {
    Minimum = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'From'));
  }

  return Minimum

  },
  /* handler:onMinDateAssignment */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./components/reusable/r_9a0af1d5eb330d29e2327e7b407d1e3f/logic/6ac7003b52d73c7b3f9db0ff9552622a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, Points_List, To, From;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  To = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'To'));
  From = (getObjectProperty(___arguments.context.getPodDataModelByUid('6b6d2b798c040e21fdcbde3fe11b859f'), 'From'));
  Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Device ID')), From, To));
  ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd')['Tracking Points'] = Points_List;
  await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')))) ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == 'Full' ? 1 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/2' ? 2 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/4' ? 3 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/8' ? 4 : ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Density')) == '1/16' ? 5 : 5)))))), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), 'Tracking Points')), ___arguments.context.getComponentDataStoreByUid('f464d5d69fa415ca6c74204ee7f881cd'), null, null, null, null, null);
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('4857dff971b24802ce5833ad7e5b56c6');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_2deb88bafd6bf396d2084c1c6ee620d7/logic/fc96be21cf223812ebb3f1aa22b75653/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_2deb88bafd6bf396d2084c1c6ee620d7/logic/e367b5edcff49236a58d5a3599cdd4d5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Points_List, Data, Time_Now, Time_Start, Live_Start, item, Density;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Track_It_Function() {
  if ((getObjectProperty(Data, 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Density)) ? 5 : (Density == 'Full' ? 1 : (Density == '1/2' ? 2 : (Density == '1/4' ? 3 : (Density == '1/8' ? 4 : (Density == '1/16' ? 5 : (Density == 'Warnings Only' ? 10 : 5))))))), [(getObjectProperty(Data, 'Tracking Live'))], Data, ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), (getObjectProperty(Data, 'Tracking Points')), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Density)) ? 5 : (Density == 'Full' ? 1 : (Density == '1/2' ? 2 : (Density == '1/4' ? 3 : (Density == '1/8' ? 4 : (Density == '1/16' ? 5 : (Density == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(Data, 'Tracking Points')), Data, ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  }
}


  Data = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) == (getObjectProperty(___arguments.context.appData, 'currentTracking')));
  }))[0];
  if (___arguments.value == '15 Minutes') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (900 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(Data, 'Device ID')), Time_Start, Time_Now));
    Data['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '30 Minutes') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (1800 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(Data, 'Device ID')), Time_Start, Time_Now));
    Data['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '1 Hour') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (3600 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(Data, 'Device ID')), Time_Start, Time_Now));
    Data['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '2 Hours') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (7200 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(Data, 'Device ID')), Time_Start, Time_Now));
    Data['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '4 Hours') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (14400 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(Data, 'Device ID')), Time_Start, Time_Now));
    Data['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == '6 Hours') {
    Time_Now = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (21600 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(Data, 'Device ID')), Time_Start, Time_Now));
    Data['Tracking Points'] = Points_List;
    await Track_It_Function();
  } else if (___arguments.value == 'Live') {
    Time_Now = (new Date());
    Live_Start = (new Date());
    Time_Start = (new Date((new Date()).getTime() - (300 * 1000)));
    Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(Data, 'Device ID')), Time_Start, Time_Now));
    Data['Tracking Points'] = Points_List;
    await Track_It_Function();
    while (___arguments.value == 'Live') {
      if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('e367b5edcff49236a58d5a3599cdd4d5')) == 'Live') {
        await new Promise(r => setTimeout(r, 60000 || 0));
        Time_Now = (new Date());
        Time_Start = Live_Start;
        Points_List = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(Data, 'Device ID')), Time_Start, Time_Now));
        Data['Tracking Points'] = Points_List;
        await Track_It_Function();
      } else {
      }
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_2deb88bafd6bf396d2084c1c6ee620d7/logic/7fb75eae7b7b411ea4549a4fe3812d6b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Data, Density, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Data = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) == (getObjectProperty(___arguments.context.appData, 'currentTracking')));
  }))[0];
  Density = ___arguments.value;
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), (getObjectProperty(Data, 'Tracking Points')), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Density)) ? 5 : (Density == 'Full' ? 1 : (Density == '1/2' ? 2 : (Density == '1/4' ? 3 : (Density == '1/8' ? 4 : (Density == '1/16' ? 5 : (Density == 'Warnings Only' ? 10 : 5))))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Data, 'Tracking Points')))) ? [(getObjectProperty(Data, 'Tracking Live'))] : (getObjectProperty(Data, 'Tracking Points'))), Data, ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, null);

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_2deb88bafd6bf396d2084c1c6ee620d7/logic/1feb80e94055fb0653b5ac8571fe79dc/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  async ['onMouseOver'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).play() })('91ce77bf29654236309c47e9151fd443');

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  async ['onMouseOut'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).stop() })('91ce77bf29654236309c47e9151fd443');

  },
  /* handler:onMouseOut */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.appData['currentTracking'];

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_2deb88bafd6bf396d2084c1c6ee620d7/logic/bcfc8832cc1525e208a9606351c2b5b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var Content, Data, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Data = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) == (getObjectProperty(___arguments.context.appData, 'currentTracking')));
  }))[0];
  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Data, 'Registration')))) && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Data, 'ID'))))) {
      Content = '';
    } else {
      if ((getObjectProperty(Data, 'Registration')) == (getObjectProperty(Data, 'ID'))) {
        Content = (getObjectProperty(Data, 'Registration'));
      } else {
        Content = (getObjectProperty(Data, 'ID'));
      }
    }

  } catch (error) {

  }

  return Content

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_2deb88bafd6bf396d2084c1c6ee620d7/logic/1d543af3cf028fdd8705e2b7dcb3495d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_2deb88bafd6bf396d2084c1c6ee620d7/logic/8059d0fc723c18a6b09dd354a0ce3cd3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var Location;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Location = (await Backendless.Request.get(`${Backendless.appPath}/services/GoogleAPI/PlaceDetails`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'placeId': JSON.stringify((getObjectProperty(___arguments.value, 'place_id'))) }).send());
  (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('00a10794c3394968e50d921a03174098', (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Location, 'result')), 'geometry')), 'location')), 'lat')), (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(Location, 'result')), 'geometry')), 'location')), 'lng')));
  (function (componentUid, zoom) { ___arguments.context.getComponentByUid(componentUid).zoom = zoom })('00a10794c3394968e50d921a03174098', 18);
  (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('00a10794c3394968e50d921a03174098', [(getObjectProperty((getObjectProperty((getObjectProperty(Location, 'result')), 'geometry')), 'location'))]);
  console.log(Location);

  },
  /* handler:onChange */
  /* handler:onPlacesPredictionsAssignment */
  ['onPlacesPredictionsAssignment'](___arguments) {
      return ({ [`componentRestrictions`]: ({ [`country`]: ['za'] }) })

  },
  /* handler:onPlacesPredictionsAssignment */
  /* content */
}))

define('./components/reusable/r_2deb88bafd6bf396d2084c1c6ee620d7/logic/e0fe269fbf4e4cde4d0fdff4096eb87d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var Data_Model, Time_Now, Time_Start, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Data_Model = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


   return ((getObjectProperty(item, 'Registration')) == (getObjectProperty(___arguments.context.appData, 'currentTracking')));
  }))[0];
  Time_Now = (new Date());
  Time_Start = (new Date((new Date()).getTime() - (900 * 1000)));
  Data_Model['Tracking Points'] = (await BackendlessUI.Functions.Custom['fn_4a474301931c8896b0d8fc0d039f07d4']((getObjectProperty(Data_Model, 'Device ID')), Time_Start, Time_Now));
  console.log(Data_Model);
  await new Promise(r => setTimeout(r, 500 || 0));
  if ((getObjectProperty(Data_Model, 'Tracking Points')).length == 0) {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Data_Model, 'Density')))) ? 5 : ((getObjectProperty(Data_Model, 'Density')) == 'Full' ? 1 : ((getObjectProperty(Data_Model, 'Density')) == '1/2' ? 2 : ((getObjectProperty(Data_Model, 'Density')) == '1/4' ? 3 : ((getObjectProperty(Data_Model, 'Density')) == '1/8' ? 4 : ((getObjectProperty(Data_Model, 'Density')) == '1/16' ? 5 : ((getObjectProperty(Data_Model, 'Density')) == 'Warnings Only' ? 10 : 5))))))), [(getObjectProperty(Data_Model, 'Tracking Live'))], Data_Model, ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  } else {
    await BackendlessUI.Functions.Custom['fn_8f6c1b262de382fab417b0f5ce24fcab'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00a10794c3394968e50d921a03174098')), [], ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(Data_Model, 'Density')))) ? 5 : ((getObjectProperty(Data_Model, 'Density')) == 'Full' ? 1 : ((getObjectProperty(Data_Model, 'Density')) == '1/2' ? 2 : ((getObjectProperty(Data_Model, 'Density')) == '1/4' ? 3 : ((getObjectProperty(Data_Model, 'Density')) == '1/8' ? 4 : ((getObjectProperty(Data_Model, 'Density')) == '1/16' ? 5 : ((getObjectProperty(Data_Model, 'Density')) == 'Warnings Only' ? 10 : 5))))))), (getObjectProperty(Data_Model, 'Tracking Points')), Data_Model, ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')))) ? null : ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations')))) ? null : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Stations'))))), null, null, ___arguments.context.appData);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/75f7c99ba0de6505b305345b6318c8fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
      return ___arguments.context.rootComponentData

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/3c04e3f77aca376d0bc305fb7da52efe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Visability, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyres Per Axle')) == 1) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/10b2866f7848f54bfd1e7b01c9f2ae78/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L1')) == null) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L1'));
  Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre L1',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
  console.log(Selected_Tyre);
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
  await new Promise(r => setTimeout(r, 200 || 0));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var error, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Style = ({ [`backgroundColor`]: (await BackendlessUI.Functions.Custom['fn_90136c37dea4943c2e93237c0dc62f72'](0, 100, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L1')), 'Life')), 100)) });

  } catch (error) {

  } finally {
    if (error) {
      Style = null;
    }

  }

  return Style

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/7d4bd81b1e9294aaa13589ac19398cdf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L1')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Tyre, item, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence, j, k, New_Tyre_Number, Last_tyre_number_of_digits, Tyre_Sequence_List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Axle_Update_Code() {
  var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    var k_list = (getObjectProperty(j, 'Axles_Data'));
    for (var k_index in k_list) {
      k = k_list[k_index];
      k['Parent ID (Tractor)'] = (getObjectProperty(j, 'objectId'));
    }
    console.log((await Backendless.Data.of('Axles').bulkUpsert( (getObjectProperty(j, 'Axles_Data')) )));
  }
  var j_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    var k_list2 = (getObjectProperty(j, 'Axles_Data'));
    for (var k_index2 in k_list2) {
      k = k_list2[k_index2];
      k['Parent ID (Trailer)'] = (getObjectProperty(j, 'objectId'));
    }
    console.log((await Backendless.Data.of('Axles').bulkUpsert( (getObjectProperty(j, 'Axles_Data')) )));
  }
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function Tyre_ID() {
  Tyre_Sequence_List = [];
  var j_list3 = (Array.isArray((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres')))) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres')) : [({ [`ID`]: '000000' })];
  for (var j_index3 in j_list3) {
    j = j_list3[j_index3];
    addItemToList(Tyre_Sequence_List, (Number((subsequenceFromEndLast((getObjectProperty(j, 'ID')), 5)))));
  }
  New_Tyre_Number = (await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1;
  Last_tyre_number_of_digits = getValueLength(((await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1));
  return String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Tyres')) + String(Last_tyre_number_of_digits == 1 ? String('00000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 2 ? String('0000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 3 ? String('000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 4 ? String('00') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 5 ? String('0') + String(New_Tyre_Number) : New_Tyre_Number)))))
}


  Tyre_Creation_API_Call = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Tyre_Creation_API_Call;

    New_Tyre = ({ [`Cost_New`]: 5500,[`Cost_Total`]: 5500,[`ID`]: await Tyre_ID(),[`Make`]: 'System',[`Model`]: 'Generated',[`Mileage1`]: 0,[`Mileage2`]: 0,[`Mileage3`]: 0,[`Mileage4`]: 0,[`Mileage_Expected`]: 80000,[`State`]: 'New',[`Status`]: 'All In Order',[`Type`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')),[`Warehouse`]: 'Out',[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'ownerId')) });
    _uow.create('Tyres', New_Tyre).setOpResultId('New Tyre Operation Refrence');
    New_Tyre_Operation_Refrence = 'New Tyre Operation Refrence';
    _uow.setRelation('Tyres', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)), 'Axle', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId'))]);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)'))))) {
      _uow.addToRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    } else {
      _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    }
    _uow.setRelation('Axles', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')), 'Tyre L1', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)));

  })();

  New_Tyre = (await Tyre_Creation_API_Call.execute());
  console.log(New_Tyre);
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));

  } catch (error) {

  }
  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)'))))) {
      addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
    } else {
      addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
    }

  } catch (error) {

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41')['Tyre L1'] = (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result'));

  } catch (error) {

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/026fac2efd991afbee1c2b81324bd5d4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L2')) == null) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L2'));
  Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre L2',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
  await new Promise(r => setTimeout(r, 200 || 0));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var error, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Style = ({ [`backgroundColor`]: (await BackendlessUI.Functions.Custom['fn_90136c37dea4943c2e93237c0dc62f72'](0, 100, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L2')), 'Life')), 100)) });

  } catch (error) {

  } finally {
    if (error) {
      Style = null;
    }

  }

  return Style

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/45f95b6221c2af82af98985390d3089d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L2')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Tyre, item, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence, New_Tyre_Number, Last_tyre_number_of_digits, Tyre_Sequence_List, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function Tyre_ID() {
  Tyre_Sequence_List = [];
  var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList(Tyre_Sequence_List, (Number((subsequenceFromEndLast((getObjectProperty(j, 'ID')), 5)))));
  }
  New_Tyre_Number = (await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1;
  Last_tyre_number_of_digits = getValueLength(((await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1));
  return String(subsequenceFirstFromEnd((getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'))[0]), 'ID')), 6)) + String(Last_tyre_number_of_digits == 1 ? String('00000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 2 ? String('0000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 3 ? String('000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 4 ? String('00') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 5 ? String('0') + String(New_Tyre_Number) : New_Tyre_Number)))))
}


  Tyre_Creation_API_Call = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Tyre_Creation_API_Call;

    New_Tyre = ({ [`Cost_New`]: 5500,[`Cost_Total`]: 5500,[`ID`]: await Tyre_ID(),[`Make`]: 'System',[`Model`]: 'Generated',[`Mileage1`]: 0,[`Mileage2`]: 0,[`Mileage3`]: 0,[`Mileage4`]: 0,[`Mileage_Expected`]: 80000,[`State`]: 'New',[`Status`]: 'All In Order',[`Type`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')),[`Warehouse`]: 'Out',[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'ownerId')) });
    _uow.create('Tyres', New_Tyre).setOpResultId('New Tyre Operation Refrence');
    New_Tyre_Operation_Refrence = 'New Tyre Operation Refrence';
    _uow.setRelation('Tyres', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)), 'Axle', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId'))]);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)'))))) {
      _uow.addToRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    } else {
      _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    }
    _uow.setRelation('Axles', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')), 'Tyre L2', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)));

  })();

  New_Tyre = (await Tyre_Creation_API_Call.execute());
  console.log(New_Tyre);
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));

  } catch (error) {

  }
  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)'))))) {
      addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
    } else {
      addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
    }

  } catch (error) {

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41')['Tyre L2'] = (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result'));

  } catch (error) {

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/9d1e936d7873a6230d21e0c4fd6c1155/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L3')) == null) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L3'));
  Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre L3',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
  await new Promise(r => setTimeout(r, 200 || 0));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var error, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Style = ({ [`backgroundColor`]: (await BackendlessUI.Functions.Custom['fn_90136c37dea4943c2e93237c0dc62f72'](0, 100, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L3')), 'Life')), 100)) });

  } catch (error) {

  } finally {
    if (error) {
      Style = null;
    }

  }

  return Style

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/d14efe79915fb62b30f94522c66a4659/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L3')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Tyre, item, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence, New_Tyre_Number, Last_tyre_number_of_digits, Tyre_Sequence_List, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function Tyre_ID() {
  Tyre_Sequence_List = [];
  var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList(Tyre_Sequence_List, (Number((subsequenceFromEndLast((getObjectProperty(j, 'ID')), 5)))));
  }
  New_Tyre_Number = (await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1;
  Last_tyre_number_of_digits = getValueLength(((await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1));
  return String(subsequenceFirstFromEnd((getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'))[0]), 'ID')), 6)) + String(Last_tyre_number_of_digits == 1 ? String('00000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 2 ? String('0000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 3 ? String('000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 4 ? String('00') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 5 ? String('0') + String(New_Tyre_Number) : New_Tyre_Number)))))
}


  Tyre_Creation_API_Call = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Tyre_Creation_API_Call;

    New_Tyre = ({ [`Cost_New`]: 5500,[`Cost_Total`]: 5500,[`ID`]: await Tyre_ID(),[`Make`]: 'System',[`Model`]: 'Generated',[`Mileage1`]: 0,[`Mileage2`]: 0,[`Mileage3`]: 0,[`Mileage4`]: 0,[`Mileage_Expected`]: 80000,[`State`]: 'New',[`Status`]: 'All In Order',[`Type`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')),[`Warehouse`]: 'Out',[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'ownerId')) });
    _uow.create('Tyres', New_Tyre).setOpResultId('New Tyre Operation Refrence');
    New_Tyre_Operation_Refrence = 'New Tyre Operation Refrence';
    _uow.setRelation('Tyres', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)), 'Axle', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId'))]);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)'))))) {
      _uow.addToRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    } else {
      _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    }
    _uow.setRelation('Axles', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')), 'Tyre L1', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)));

  })();

  New_Tyre = (await Tyre_Creation_API_Call.execute());
  console.log(New_Tyre);
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));

  } catch (error) {

  }
  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)'))))) {
      addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
    } else {
      addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
    }

  } catch (error) {

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41')['Tyre L3'] = (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result'));

  } catch (error) {

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/cc558d4d15cbd1498986b71895e1681a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L4')) == null) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L4'));
  Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre L4',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
  await new Promise(r => setTimeout(r, 200 || 0));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var error, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Style = ({ [`backgroundColor`]: (await BackendlessUI.Functions.Custom['fn_90136c37dea4943c2e93237c0dc62f72'](0, 100, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L4')), 'Life')), 100)) });

  } catch (error) {

  } finally {
    if (error) {
      Style = null;
    }

  }

  return Style

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/ddb74d16fdab8556f997dc3fcadbb4ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L4')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Tyre, item, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence, New_Tyre_Number, Last_tyre_number_of_digits, Tyre_Sequence_List, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function Tyre_ID() {
  Tyre_Sequence_List = [];
  var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList(Tyre_Sequence_List, (Number((subsequenceFromEndLast((getObjectProperty(j, 'ID')), 5)))));
  }
  New_Tyre_Number = (await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1;
  Last_tyre_number_of_digits = getValueLength(((await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1));
  return String(subsequenceFirstFromEnd((getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'))[0]), 'ID')), 6)) + String(Last_tyre_number_of_digits == 1 ? String('00000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 2 ? String('0000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 3 ? String('000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 4 ? String('00') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 5 ? String('0') + String(New_Tyre_Number) : New_Tyre_Number)))))
}


  Tyre_Creation_API_Call = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Tyre_Creation_API_Call;

    New_Tyre = ({ [`Cost_New`]: 5500,[`Cost_Total`]: 5500,[`ID`]: await Tyre_ID(),[`Make`]: 'System',[`Model`]: 'Generated',[`Mileage1`]: 0,[`Mileage2`]: 0,[`Mileage3`]: 0,[`Mileage4`]: 0,[`Mileage_Expected`]: 80000,[`State`]: 'New',[`Status`]: 'All In Order',[`Type`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')),[`Warehouse`]: 'Out',[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'ownerId')) });
    _uow.create('Tyres', New_Tyre).setOpResultId('New Tyre Operation Refrence');
    New_Tyre_Operation_Refrence = 'New Tyre Operation Refrence';
    _uow.setRelation('Tyres', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)), 'Axle', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId'))]);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)'))))) {
      _uow.addToRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    } else {
      _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    }
    _uow.setRelation('Axles', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')), 'Tyre L1', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)));

  })();

  New_Tyre = (await Tyre_Creation_API_Call.execute());
  console.log(New_Tyre);
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));

  } catch (error) {

  }
  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)'))))) {
      addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
    } else {
      addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
    }

  } catch (error) {

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41')['Tyre L4'] = (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result'));

  } catch (error) {

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/f4979aa56d64aa949a27d53874d1dd32/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R4')) == null) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R4'));
  Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre R4',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
  await new Promise(r => setTimeout(r, 200 || 0));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var error, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Style = ({ [`backgroundColor`]: (await BackendlessUI.Functions.Custom['fn_90136c37dea4943c2e93237c0dc62f72'](0, 100, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R4')), 'Life')), 100)) });

  } catch (error) {

  } finally {
    if (error) {
      Style = null;
    }

  }

  return Style

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/5f46c76249a5e80ee83df6fadb614604/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R4')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Tyre, item, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence, New_Tyre_Number, Last_tyre_number_of_digits, Tyre_Sequence_List, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function Tyre_ID() {
  Tyre_Sequence_List = [];
  var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList(Tyre_Sequence_List, (Number((subsequenceFromEndLast((getObjectProperty(j, 'ID')), 5)))));
  }
  New_Tyre_Number = (await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1;
  Last_tyre_number_of_digits = getValueLength(((await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1));
  return String(subsequenceFirstFromEnd((getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'))[0]), 'ID')), 6)) + String(Last_tyre_number_of_digits == 1 ? String('00000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 2 ? String('0000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 3 ? String('000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 4 ? String('00') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 5 ? String('0') + String(New_Tyre_Number) : New_Tyre_Number)))))
}


  Tyre_Creation_API_Call = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Tyre_Creation_API_Call;

    New_Tyre = ({ [`Cost_New`]: 5500,[`Cost_Total`]: 5500,[`ID`]: await Tyre_ID(),[`Make`]: 'System',[`Model`]: 'Generated',[`Mileage1`]: 0,[`Mileage2`]: 0,[`Mileage3`]: 0,[`Mileage4`]: 0,[`Mileage_Expected`]: 80000,[`State`]: 'New',[`Status`]: 'All In Order',[`Type`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')),[`Warehouse`]: 'Out',[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'ownerId')) });
    _uow.create('Tyres', New_Tyre).setOpResultId('New Tyre Operation Refrence');
    New_Tyre_Operation_Refrence = 'New Tyre Operation Refrence';
    _uow.setRelation('Tyres', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)), 'Axle', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId'))]);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)'))))) {
      _uow.addToRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    } else {
      _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    }
    _uow.setRelation('Axles', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')), 'Tyre R4', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)));

  })();

  New_Tyre = (await Tyre_Creation_API_Call.execute());
  console.log(New_Tyre);
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));

  } catch (error) {

  }
  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)'))))) {
      addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
    } else {
      addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
    }

  } catch (error) {

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41')['Tyre R4'] = (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result'));

  } catch (error) {

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/0056e22560d5339b19d35b21bc0cf1b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R3')) == null) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R3'));
  Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre R3',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
  await new Promise(r => setTimeout(r, 200 || 0));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var error, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Style = ({ [`backgroundColor`]: (await BackendlessUI.Functions.Custom['fn_90136c37dea4943c2e93237c0dc62f72'](0, 100, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R3')), 'Life')), 100)) });

  } catch (error) {

  } finally {
    if (error) {
      Style = null;
    }

  }

  return Style

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/34c288ddf1ab92a2ab9c5e9740c4f649/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R3')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Tyre, item, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence, New_Tyre_Number, Last_tyre_number_of_digits, Tyre_Sequence_List, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function Tyre_ID() {
  Tyre_Sequence_List = [];
  var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList(Tyre_Sequence_List, (Number((subsequenceFromEndLast((getObjectProperty(j, 'ID')), 5)))));
  }
  New_Tyre_Number = (await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1;
  Last_tyre_number_of_digits = getValueLength(((await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1));
  return String(subsequenceFirstFromEnd((getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'))[0]), 'ID')), 6)) + String(Last_tyre_number_of_digits == 1 ? String('00000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 2 ? String('0000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 3 ? String('000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 4 ? String('00') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 5 ? String('0') + String(New_Tyre_Number) : New_Tyre_Number)))))
}


  Tyre_Creation_API_Call = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Tyre_Creation_API_Call;

    New_Tyre = ({ [`Cost_New`]: 5500,[`Cost_Total`]: 5500,[`ID`]: await Tyre_ID(),[`Make`]: 'System',[`Model`]: 'Generated',[`Mileage1`]: 0,[`Mileage2`]: 0,[`Mileage3`]: 0,[`Mileage4`]: 0,[`Mileage_Expected`]: 80000,[`State`]: 'New',[`Status`]: 'All In Order',[`Type`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')),[`Warehouse`]: 'Out',[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'ownerId')) });
    _uow.create('Tyres', New_Tyre).setOpResultId('New Tyre Operation Refrence');
    New_Tyre_Operation_Refrence = 'New Tyre Operation Refrence';
    _uow.setRelation('Tyres', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)), 'Axle', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId'))]);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)'))))) {
      _uow.addToRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    } else {
      _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    }
    _uow.setRelation('Axles', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')), 'Tyre R3', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)));

  })();

  New_Tyre = (await Tyre_Creation_API_Call.execute());
  console.log(New_Tyre);
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));

  } catch (error) {

  }
  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)'))))) {
      addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
    } else {
      addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
    }

  } catch (error) {

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41')['Tyre R3'] = (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result'));

  } catch (error) {

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/a643392164339d450d2cf32e2483e634/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R2')) == null) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R2'));
  Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre R2',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
  await new Promise(r => setTimeout(r, 200 || 0));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var error, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Style = ({ [`backgroundColor`]: (await BackendlessUI.Functions.Custom['fn_90136c37dea4943c2e93237c0dc62f72'](0, 100, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R2')), 'Life')), 100)) });

  } catch (error) {

  } finally {
    if (error) {
      Style = null;
    }

  }

  return Style

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/e534c5b6775be65a0a038f3f1026e4f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R2')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Tyre, item, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence, New_Tyre_Number, Last_tyre_number_of_digits, Tyre_Sequence_List, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function Tyre_ID() {
  Tyre_Sequence_List = [];
  var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList(Tyre_Sequence_List, (Number((subsequenceFromEndLast((getObjectProperty(j, 'ID')), 5)))));
  }
  New_Tyre_Number = (await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1;
  Last_tyre_number_of_digits = getValueLength(((await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1));
  return String(subsequenceFirstFromEnd((getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'))[0]), 'ID')), 6)) + String(Last_tyre_number_of_digits == 1 ? String('00000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 2 ? String('0000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 3 ? String('000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 4 ? String('00') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 5 ? String('0') + String(New_Tyre_Number) : New_Tyre_Number)))))
}


  Tyre_Creation_API_Call = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Tyre_Creation_API_Call;

    New_Tyre = ({ [`Cost_New`]: 5500,[`Cost_Total`]: 5500,[`ID`]: await Tyre_ID(),[`Make`]: 'System',[`Model`]: 'Generated',[`Mileage1`]: 0,[`Mileage2`]: 0,[`Mileage3`]: 0,[`Mileage4`]: 0,[`Mileage_Expected`]: 80000,[`State`]: 'New',[`Status`]: 'All In Order',[`Type`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')),[`Warehouse`]: 'Out',[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'ownerId')) });
    _uow.create('Tyres', New_Tyre).setOpResultId('New Tyre Operation Refrence');
    New_Tyre_Operation_Refrence = 'New Tyre Operation Refrence';
    _uow.setRelation('Tyres', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)), 'Axle', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId'))]);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)'))))) {
      _uow.addToRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    } else {
      _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    }
    _uow.setRelation('Axles', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')), 'Tyre R2', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)));

  })();

  New_Tyre = (await Tyre_Creation_API_Call.execute());
  console.log(New_Tyre);
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));

  } catch (error) {

  }
  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)'))))) {
      addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
    } else {
      addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
    }

  } catch (error) {

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41')['Tyre R2'] = (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result'));

  } catch (error) {

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/2641bff90cf9bb35806600f96bf7a9fb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R1')) == null) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R1'));
  Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre R1',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
  await new Promise(r => setTimeout(r, 200 || 0));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var error, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Style = ({ [`backgroundColor`]: (await BackendlessUI.Functions.Custom['fn_90136c37dea4943c2e93237c0dc62f72'](0, 100, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R1')), 'Life')), 100)) });

  } catch (error) {

  } finally {
    if (error) {
      Style = null;
    }

  }

  return Style

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/5348ab212ec52b8592f77e89eb96d86a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R1')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Tyre_Number, Last_tyre_number_of_digits, item, Tyre_Sequence_List, j, New_Tyre, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function Tyre_ID() {
  Tyre_Sequence_List = [];
  var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    addItemToList(Tyre_Sequence_List, (Number((subsequenceFromEndLast((getObjectProperty(j, 'ID')), 5)))));
  }
  New_Tyre_Number = (await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1;
  Last_tyre_number_of_digits = getValueLength(((await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1));
  return String(subsequenceFirstFromEnd((getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'))[0]), 'ID')), 6)) + String(Last_tyre_number_of_digits == 1 ? String('00000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 2 ? String('0000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 3 ? String('000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 4 ? String('00') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 5 ? String('0') + String(New_Tyre_Number) : New_Tyre_Number)))))
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Tyre_Creation_API_Call = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Tyre_Creation_API_Call;

    New_Tyre = ({ [`Cost_New`]: 5500,[`Cost_Total`]: 5500,[`ID`]: await Tyre_ID(),[`Make`]: 'System',[`Model`]: 'Generated',[`Mileage1`]: 0,[`Mileage2`]: 0,[`Mileage3`]: 0,[`Mileage4`]: 0,[`Mileage_Expected`]: 80000,[`State`]: 'New',[`Status`]: 'All In Order',[`Type`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')),[`Warehouse`]: 'Out',[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'ownerId')) });
    _uow.create('Tyres', New_Tyre).setOpResultId('New Tyre Operation Refrence');
    New_Tyre_Operation_Refrence = 'New Tyre Operation Refrence';
    _uow.setRelation('Tyres', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)), 'Axle', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId'))]);
    _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)'))))) {
      _uow.addToRelation('Trailers', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    } else {
      _uow.addToRelation('Tractors', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
    }
    _uow.setRelation('Axles', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')), 'Tyre R1', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)));

  })();

  New_Tyre = (await Tyre_Creation_API_Call.execute());
  console.log(New_Tyre);
  try {
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));

  } catch (error) {

  }
  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)'))))) {
      addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
    } else {
      addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
    }

  } catch (error) {

  }
  try {
    ___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41')['Tyre R1'] = (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result'));

  } catch (error) {

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/665d5741f5664a4b56317c6d16e7b42f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyres Per Axle')) > 2) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/7234dfd89afdb358d9cb7a99ea254305/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyres Per Axle')) > 4) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/56289e3dbae16ee95a3cb43fa1a9486d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyres Per Axle')) > 6) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/7b1b6d18296af70b5d48da3e11683a98/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyres Per Axle')) > 6) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/b2ae7601e43e76852d6425cfc6a953b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyres Per Axle')) > 4) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/16c4254a375b8043968cd4dd841fb5ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyres Per Axle')) > 2) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/bad8806dd5a12b16b7e865254834ffc4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')) == 'Spare') {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/c2a2e07e943a927e3b2123fd74c934fd/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var Object2, item, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    if ((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5842d09917c4ccae6ec24c4aeb681b41')), 'dataStore')), 'objectId')) == (getObjectProperty(((await asyncListSort((await asyncListFilter(___arguments.context.rootComponentData, async (item) => {


     return ((getObjectProperty(item, 'Type')) == 'Steer');
    })), 1, async (item) => {


     return (getObjectProperty(item, 'Position Number'));
    })).slice(-1)[0]), 'objectId'))) {
      Object2 = ({ [`marginRight`]: '50px' });
    }

  } catch (error) {

  }

  return Object2

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/3282fc0d905eb5bff0dfd5821d53fcca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      try {
    delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'];

  } catch (error) {

  }
  try {
    delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'];

  } catch (error) {

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/e65e326df2da8f08140924986638102b/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  ['InputLogic'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Life'));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:InputLogic */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/ab93966195bd1056ed9c0d5634dc728e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'ID'));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/08011b25c33261bde27d246dcfd2846e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Make'));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/cd3365f8266ecfe90199bea2a6fa0dfa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Model'));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/afa599411c97c525b5c7140e15b9ad5a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Type'));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/09b92a4bbaba839ff694f047f1d3121a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'State'));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/faeaadb79fd20bc1b255e4333be527da/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Mileage_Current')) + String(' km');

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/8b27eb5abd88bebcc7f1bfacfb242ca3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Mileage_Expected')) + String(' km');

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/74d20be63b9a36cdc66a961761f3e851/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6')['Edit'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Visability, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Edit')) == true) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/e30601632f96bfcf7e16b5930fb5719a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Edit')) == true) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/4562ae5b90134b6d23c437f9e4aa1cad/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Edit')) == true) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/4f4ce37f269e174fff5773d6e61231a9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Edit')) == true) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/cd0d7f46b75c96ee85691b08b8fd97cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Edit')) == true) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/06db96e24c437fe2d5a943d3b9a3e9b4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Edit')) == true) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6')['Edit'];

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/897c440f4bb815ddebbb6b63b70fba98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      console.log(___arguments.context.rootComponentData);
  console.log(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'));
  console.log(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/994a2c437649d4f173e40b7797bd76f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Tyre Data View')) == true) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onContainerDataAssignment */
  async ['onContainerDataAssignment'](___arguments) {
    var Data_Model, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.rootComponentData, 'Selected Tyre'))))) {
      Data_Model = null;
    } else {
      Data_Model = (getObjectProperty(___arguments.context.rootComponentData, 'Selected Tyre'));
    }

  } catch (error) {

  } finally {
    if (error) {
      Data_Model = null;
    }

  }

  return Data_Model

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/5d99edafce6ef5abda992892cd7b67d8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L1')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/c102645f75165fa90c5201125aec8bc1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L2')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/45be6b4a84bddd6ba21312c17896b70b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L3')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/b21eec1e10d459ebed1a547ca4fb1f6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L4')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/bce2a0312a359b21a76f37a577027cce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R4')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/20b32f5d6366993d4927c6cd8a14300a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R3')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/b3d46b3a9e920b5620dfed46235e90ff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R2')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/740db42f383259ef56210892813cbff2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R1')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/ef2c370f0666633f4393c33e4b8c68c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, New_Tyre_Number, Last_tyre_number_of_digits, item, Tyre_Sequence_List, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence, New_Tyre, Tyre_Position;

/**
 * Describe this function...
 */
async function Variable_Reset() {
  item = null;
  j = null;
  Last_tyre_number_of_digits = null;
  New_Tyre = null;
  New_Tyre_Number = null;
  New_Tyre_Operation_Refrence = null;
  Tyre_Creation_API_Call = null;
  Tyre_Sequence_List = null;
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Bulk_Creator_Logic(j) {
  if ((getObjectProperty(j, 'Tyres Per Axle')) == 1) {
    await Actual_Code('Tyre L1', j);
  } else if ((getObjectProperty(j, 'Tyres Per Axle')) == 2) {
    await Actual_Code('Tyre L1', j);
    await Actual_Code('Tyre R1', j);
  } else if ((getObjectProperty(j, 'Tyres Per Axle')) == 4) {
    await Actual_Code('Tyre L1', j);
    await Actual_Code('Tyre R1', j);
    await Actual_Code('Tyre L2', j);
    await Actual_Code('Tyre R2', j);
  } else if ((getObjectProperty(j, 'Tyres Per Axle')) == 6) {
    await Actual_Code('Tyre L1', j);
    await Actual_Code('Tyre R1', j);
    await Actual_Code('Tyre L2', j);
    await Actual_Code('Tyre R2', j);
    await Actual_Code('Tyre L3', j);
    await Actual_Code('Tyre R3', j);
  } else if ((getObjectProperty(j, 'Tyres Per Axle')) == 8) {
    await Actual_Code('Tyre L1', j);
    await Actual_Code('Tyre R1', j);
    await Actual_Code('Tyre L2', j);
    await Actual_Code('Tyre R2', j);
    await Actual_Code('Tyre L3', j);
    await Actual_Code('Tyre R3', j);
    await Actual_Code('Tyre L4', j);
    await Actual_Code('Tyre R4', j);
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Actual_Code(Tyre_Position, j) {
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, Tyre_Position))))) {
    Tyre_Creation_API_Call = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tyre_Creation_API_Call;

      New_Tyre = ({ [`Cost_New`]: 5500,[`Cost_Total`]: 5500,[`ID`]: await Tyre_ID(),[`Make`]: 'System',[`Model`]: 'Generated',[`Mileage1`]: 0,[`Mileage2`]: 0,[`Mileage3`]: 0,[`Mileage4`]: 0,[`Mileage_Expected`]: 80000,[`State`]: 'New',[`Status`]: 'All In Order',[`Type`]: (getObjectProperty(j, 'Type')),[`Warehouse`]: 'Out',[`ownerId`]: (getObjectProperty(j, 'ownerId')) });
      _uow.create('Tyres', New_Tyre).setOpResultId('New Tyre Operation Refrence');
      New_Tyre_Operation_Refrence = 'New Tyre Operation Refrence';
      _uow.setRelation('Tyres', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)), 'Axle', [(getObjectProperty(j, 'objectId'))]);
      _uow.setRelation('Tyres', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Parent ID (Tractor)')))) ? 'Currently_On_Trailer' : 'Currently_On_Tractor'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Parent ID (Tractor)')))) ? [(getObjectProperty(j, 'Parent ID (Trailer)'))] : [(getObjectProperty(j, 'Parent ID (Tractor)'))]));
      _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Parent ID (Tractor)'))))) {
        _uow.addToRelation('Trailers', (getObjectProperty(j, 'Parent ID (Trailer)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
      } else {
        _uow.addToRelation('Tractors', (getObjectProperty(j, 'Parent ID (Tractor)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
      }
      _uow.setRelation('Axles', (getObjectProperty(j, 'objectId')), Tyre_Position, (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)));

    })();

    New_Tyre = (await Tyre_Creation_API_Call.execute());
    console.log(New_Tyre);
    try {
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));

    } catch (error) {

    }
    try {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Parent ID (Tractor)'))))) {
        addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


         return ((getObjectProperty(j, 'Parent ID (Trailer)')) == (getObjectProperty(item, 'objectId')));
        }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
      } else {
        addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


         return ((getObjectProperty(j, 'Parent ID (Tractor)')) == (getObjectProperty(item, 'objectId')));
        }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
      }

    } catch (error) {

    }
    try {
      j[Tyre_Position] = (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result'));

    } catch (error) {

    }
  }
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function Tyre_ID() {
  Tyre_Sequence_List = [];
  var j_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    addItemToList(Tyre_Sequence_List, (Number((subsequenceFromEndLast((getObjectProperty(j, 'ID')), 5)))));
  }
  New_Tyre_Number = (await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1;
  Last_tyre_number_of_digits = getValueLength(((await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1));
  return String(subsequenceFirstFromEnd((getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'))[0]), 'ID')), 6)) + String(Last_tyre_number_of_digits == 1 ? String('00000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 2 ? String('0000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 3 ? String('000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 4 ? String('00') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 5 ? String('0') + String(New_Tyre_Number) : New_Tyre_Number)))))
}


  var j_list = ___arguments.context.rootComponentData;
  for (var j_index in j_list) {
    j = j_list[j_index];
    await Bulk_Creator_Logic(j);
  }
  await Variable_Reset();

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/4e858c4e05e6908ab47f902182ba091f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, New_Tyre_Number, Last_tyre_number_of_digits, item, Tyre_Sequence_List, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence, New_Tyre, Tyre_Position;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Bulk_Creator_Logic(j) {
  if ((getObjectProperty(j, 'Tyres Per Axle')) == 1) {
    await Actual_Code('Tyre L1', j);
  } else if ((getObjectProperty(j, 'Tyres Per Axle')) == 2) {
    await Actual_Code('Tyre L1', j);
    await Actual_Code('Tyre R1', j);
  } else if ((getObjectProperty(j, 'Tyres Per Axle')) == 4) {
    await Actual_Code('Tyre L1', j);
    await Actual_Code('Tyre R1', j);
    await Actual_Code('Tyre L2', j);
    await Actual_Code('Tyre R2', j);
  } else if ((getObjectProperty(j, 'Tyres Per Axle')) == 6) {
    await Actual_Code('Tyre L1', j);
    await Actual_Code('Tyre R1', j);
    await Actual_Code('Tyre L2', j);
    await Actual_Code('Tyre R2', j);
    await Actual_Code('Tyre L3', j);
    await Actual_Code('Tyre R3', j);
  } else if ((getObjectProperty(j, 'Tyres Per Axle')) == 8) {
    await Actual_Code('Tyre L1', j);
    await Actual_Code('Tyre R1', j);
    await Actual_Code('Tyre L2', j);
    await Actual_Code('Tyre R2', j);
    await Actual_Code('Tyre L3', j);
    await Actual_Code('Tyre R3', j);
    await Actual_Code('Tyre L4', j);
    await Actual_Code('Tyre R4', j);
  }
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function Tyre_ID() {
  Tyre_Sequence_List = [];
  console.log((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres')).length);
  if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres')).length == 0) {
    Last_tyre_number_of_digits = 1;
    New_Tyre_Number = 1;
  } else {
    var j_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      addItemToList(Tyre_Sequence_List, (Number((subsequenceFromEndLast((getObjectProperty(j, 'ID')), 5)))));
    }
    New_Tyre_Number = (await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


     return item;
    })).slice(-1)[0] + 1;
    Last_tyre_number_of_digits = getValueLength(((await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


     return item;
    })).slice(-1)[0] + 1));
  }
  return String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Tyres')) + String(Last_tyre_number_of_digits == 1 ? String('00000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 2 ? String('0000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 3 ? String('000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 4 ? String('00') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 5 ? String('0') + String(New_Tyre_Number) : New_Tyre_Number)))))
}

/**
 * Describe this function...
 */
async function Variable_Reset() {
  item = null;
  j = null;
  Last_tyre_number_of_digits = null;
  New_Tyre = null;
  New_Tyre_Number = null;
  New_Tyre_Operation_Refrence = null;
  Tyre_Creation_API_Call = null;
  Tyre_Sequence_List = null;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Actual_Code(Tyre_Position, j) {
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, Tyre_Position))))) {
    Tyre_Creation_API_Call = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tyre_Creation_API_Call;

      New_Tyre = ({ [`Cost_New`]: 5500,[`Cost_Total`]: 5500,[`ID`]: await Tyre_ID(),[`Make`]: 'System',[`Model`]: 'Generated',[`Mileage1`]: 0,[`Mileage2`]: 0,[`Mileage3`]: 0,[`Mileage4`]: 0,[`Mileage_Expected`]: 80000,[`State`]: 'New',[`Status`]: 'All In Order',[`Type`]: (getObjectProperty(j, 'Type')),[`Warehouse`]: 'Out',[`ownerId`]: (getObjectProperty(j, 'ownerId')) });
      _uow.create('Tyres', New_Tyre).setOpResultId('New Tyre Operation Refrence');
      New_Tyre_Operation_Refrence = 'New Tyre Operation Refrence';
      _uow.setRelation('Tyres', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)), 'Axle', [(getObjectProperty(j, 'objectId'))]);
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Parent ID (Tractor)'))))) {
        _uow.addToRelation('Trailers', (getObjectProperty(j, 'Parent ID (Trailer)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
      } else {
        _uow.addToRelation('Tractors', (getObjectProperty(j, 'Parent ID (Tractor)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
      }
      _uow.setRelation('Axles', (getObjectProperty(j, 'objectId')), Tyre_Position, (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)));

    })();

    New_Tyre = (await Tyre_Creation_API_Call.execute());
    console.log(New_Tyre);
    try {
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));

    } catch (error) {

    }
    try {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Parent ID (Tractor)'))))) {
        addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


         return ((getObjectProperty(j, 'Parent ID (Trailer)')) == (getObjectProperty(item, 'objectId')));
        }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
      } else {
        addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


         return ((getObjectProperty(j, 'Parent ID (Tractor)')) == (getObjectProperty(item, 'objectId')));
        }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
      }

    } catch (error) {

    }
    try {
      j[Tyre_Position] = (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result'));

    } catch (error) {

    }
  }
}


  var j_list = ___arguments.context.rootComponentData;
  for (var j_index in j_list) {
    j = j_list[j_index];
    await Bulk_Creator_Logic(j);
  }
  await Variable_Reset();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, error, Counter, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Counter = 0;
  try {
    var j_list = ___arguments.context.rootComponentData;
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Tyre L1')))) == true && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Tyre L2')))) == true && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Tyre L3')))) == true && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Tyre L4')))) == true && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Tyre R4')))) == true && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Tyre R3')))) == true && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Tyre R2')))) == true && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Tyre R1')))) == true) {
        Counter = Counter + 1;
      }
    }

  } catch (error) {

  }
  try {
    if (Counter == 0) {
      Viewer = false;
    } else {
      Viewer = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/c4b95e1a0b620dc9d8380ba1cbe43bde/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Transaction, item, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2dad3ea7640fedd333fbaafd7dc76f75');
  while (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Delete Approval')) == true)) {
    await new Promise(r => setTimeout(r, 500 || 0));
  }
  removeItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId');
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Parent ID (Tractor)'))))) {
    try {
      removeItemInList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


       return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Parent ID (Trailer)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId');

    } catch (error) {
      console.log(error);

    }
    ((await asyncListFilter((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Parent ID (Trailer)')) == (getObjectProperty(item, 'objectId')));
    }))[0]), 'Axles_Data')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Axle objectId')));
    }))[0])[(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Selected Tyre Position'))] = null;
  } else {
    try {
      removeItemInList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


       return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Parent ID (Tractor)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId');

    } catch (error) {
      console.log(error);

    }
  }
  ((await asyncListFilter(___arguments.context.rootComponentData, async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Axle objectId')));
  }))[0])[(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Selected Tyre Position'))] = null;
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    _uow.deleteRelation('Axles', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Axle objectId')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Selected Tyre Position')), [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'))]);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Parent ID (Tractor)'))))) {
      _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Parent ID (Trailer)')), 'Tyres', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'))]);
    } else {
      _uow.deleteRelation('Tractors', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Parent ID (Tractor)')), 'Tyres', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'))]);
    }
    _uow.deleteRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'))]);
    _uow.delete('Tyres', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId')));

  })();

  console.log((await Transaction.execute()));
  delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'];
  delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Delete Approval'];
  delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'];

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_7f1cbb7df771bf4dce4db83507e7359c/logic/2dad3ea7640fedd333fbaafd7dc76f75/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  ['onSubmit'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Delete Approval'] = true;

  },
  /* handler:onSubmit */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2dad3ea7640fedd333fbaafd7dc76f75');

  },
  /* handler:onClose */
  /* content */
}))

define('./components/reusable/r_ea1c50bb238f5df17ea327ddfffad059/logic/1c3e26f8092b560aa158d5a903273868/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, List;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.appData, 'User'))))) {
  } else {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))))) {
    } else {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations'))))) {
      } else {
        List = (await Promise.all((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Locations')), async (item) => {


         return ((getObjectProperty(item, 'Type')) == 'Service Centre');
        })).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'Name')) });})));
      }
    }
  }

  return ([({ [`value`]: 'In House',[`label`]: 'In House' })].concat(List))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./components/reusable/r_ea1c50bb238f5df17ea327ddfffad059/logic/7b91288aa6dd47a1228e1bb7d7fba318/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./components/reusable/r_ea1c50bb238f5df17ea327ddfffad059/logic/52fae095c4b1c574dfb7b96ef353491a/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./components/reusable/r_ea1c50bb238f5df17ea327ddfffad059/logic/853ddd6acc6f5ccdc61948140a4b1ebd/bundle.js', [], () => ({
  /* content */
  /* handler:onMaxDateAssignment */
  ['onMaxDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMaxDateAssignment */
  /* content */
}))

define('./components/reusable/r_ea1c50bb238f5df17ea327ddfffad059/logic/bbbaa52e73fc704c2fcdc68b0e531b5b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value > (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Trailer Repair Data')), 'Odometer')) + 1000 || ___arguments.value < (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Trailer Repair Data')), 'Odometer')) - 5000) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('057a1472ad9d2f6f840174e8ec49f2e5', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('057a1472ad9d2f6f840174e8ec49f2e5', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_ea1c50bb238f5df17ea327ddfffad059/logic/571f248a4d288a73408147380ab4a7d6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Transaction, Repair, Financial_Transaction, objectId;

function generateUUID() {
   const chr4 = () => Math.random().toString(16).slice(-4);
   const chr8 = () => `${chr4()}${chr4()}`;
   const short = () => chr8();
   const long = () => `${chr8()}-${chr4()}-${chr4()}-${chr4()}-${chr8()}${chr4()}`;

   return { short, long, }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function New_Repair_Function() {
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    objectId = (generateUUID().long());
    Repair = (_uow.create('Maintenance', ({ [`CapturedBy`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Name')),[`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Cost')),[`Date_Completed`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Date')),[`Date_Scheduled`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'DateSch')),[`Date_Started`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'DateStart')),[`Description`]: ['Repair (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Component')),')'].join(''),[`Invoice`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'File')),[`Mileage`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Mileage')),[`Mileage Due`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Mileage')),[`Notes`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Notes')),[`Repair_Component`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Component')),[`Status`]: 'Completed',[`Supplier`]: (await BackendlessUI.Functions.Custom['fn_82aff119219bba741c2f252f9c283851'](((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).options })('1c3e26f8092b560aa158d5a903273868')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c3e26f8092b560aa158d5a903273868')), 'value')))),[`TractorId`]: undefined,[`TrailerId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Trailer Repair Data')), 'objectId')),[`Type`]: 'Repair',[`Vehicle Type`]: 'Trailer',[`objectId`]: objectId,[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Trailer Repair Data')), 'ownerId')) })));
    Financial_Transaction = (_uow.create('Transactions', ({ [`Cost`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Cost')),[`Description`]: ['Repair (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('210db72be6299c97bd8ecc1faf8ce1d7'), 'Component')),') - ',objectId].join(''),[`objectId`]: objectId,[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Trailer Repair Data')), 'ownerId')) })));
    _uow.setRelation('Maintenance', Repair, 'Transaction', [Financial_Transaction]);
    _uow.setRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'Trailer Repair Data')), 'objectId')), 'Maintenance', [Repair]);

  })();

  return (await Transaction.execute())
}


  console.log(await New_Repair_Function());
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('51bce592fcaee421316c7753054507b9', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0bcad0c4c147b7d2435a3ccfd35f2fe4')), 'value')))) && !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('853ddd6acc6f5ccdc61948140a4b1ebd')), 'value')))) && !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('bbbaa52e73fc704c2fcdc68b0e531b5b')), 'value')))) && !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('64defe47907a9f9baf4e7f96a20fb7fe')), 'value')))) && !(await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c4a8d26cc2f99d65bd092dc2cf4e283f')), 'value')))) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('057a1472ad9d2f6f840174e8ec49f2e5')), 'display')) == false) {
    Viewer = true;
  } else {
    Viewer = false;
  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/75f7c99ba0de6505b305345b6318c8fa/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
      return ___arguments.context.rootComponentData

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/3c04e3f77aca376d0bc305fb7da52efe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Visability, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyres Per Axle')) == 1) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/10b2866f7848f54bfd1e7b01c9f2ae78/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L1')) == null) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L1'));
  Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre L1',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.pageData, 'Assets Drawer - Selected Tyre objectId')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
  console.log(Selected_Tyre);
  await new Promise(r => setTimeout(r, 200 || 0));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var error, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Style = ({ [`backgroundColor`]: (await BackendlessUI.Functions.Custom['fn_90136c37dea4943c2e93237c0dc62f72'](0, 100, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L1')), 'Life')), 100)) });

  } catch (error) {

  } finally {
    if (error) {
      Style = null;
    }

  }

  return Style

  },
  /* handler:onStyleAssignment */
  /* handler:onLoad */
  async ['onLoad'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L1')), 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'Assets Drawer - Selected Tyre objectId'))) {
    Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L1'));
    Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre L1',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.pageData, 'Assets Drawer - Selected Tyre objectId')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
    console.log(Selected_Tyre);
    ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
    await new Promise(r => setTimeout(r, 200 || 0));
    ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;
  }

  },
  /* handler:onLoad */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/7d4bd81b1e9294aaa13589ac19398cdf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L1')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Tyre, error, item, Transaction_Result, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence, New_Tyre_Number, Last_tyre_number_of_digits, Tyre_Sequence_List, j, k;


  await BackendlessUI.Functions.Custom['fn_b3cdf4a3ed5a52efed2ea82b1ec2cb92'](___arguments.context.appData, 'Tyre L1', ___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/026fac2efd991afbee1c2b81324bd5d4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L2')) == null) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L2'));
  Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre L2',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
  await new Promise(r => setTimeout(r, 200 || 0));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var error, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Style = ({ [`backgroundColor`]: (await BackendlessUI.Functions.Custom['fn_90136c37dea4943c2e93237c0dc62f72'](0, 100, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L2')), 'Life')), 100)) });

  } catch (error) {

  } finally {
    if (error) {
      Style = null;
    }

  }

  return Style

  },
  /* handler:onStyleAssignment */
  /* handler:onLoad */
  async ['onLoad'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L2')), 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'Assets Drawer - Selected Tyre objectId'))) {
    Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L2'));
    Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre L2',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
    ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
    await new Promise(r => setTimeout(r, 200 || 0));
    ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;
  }

  },
  /* handler:onLoad */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/45f95b6221c2af82af98985390d3089d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L2')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Tyre, item, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence, New_Tyre_Number, Last_tyre_number_of_digits, Tyre_Sequence_List, j;


  await BackendlessUI.Functions.Custom['fn_b3cdf4a3ed5a52efed2ea82b1ec2cb92'](___arguments.context.appData, 'Tyre L2', ___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/9d1e936d7873a6230d21e0c4fd6c1155/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L3')) == null) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L3'));
  Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre L3',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
  await new Promise(r => setTimeout(r, 200 || 0));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var error, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Style = ({ [`backgroundColor`]: (await BackendlessUI.Functions.Custom['fn_90136c37dea4943c2e93237c0dc62f72'](0, 100, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L3')), 'Life')), 100)) });

  } catch (error) {

  } finally {
    if (error) {
      Style = null;
    }

  }

  return Style

  },
  /* handler:onStyleAssignment */
  /* handler:onLoad */
  async ['onLoad'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L3')), 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'Assets Drawer - Selected Tyre objectId'))) {
    Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L3'));
    Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre L3',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
    ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
    await new Promise(r => setTimeout(r, 200 || 0));
    ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;
  }

  },
  /* handler:onLoad */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/d14efe79915fb62b30f94522c66a4659/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L3')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b3cdf4a3ed5a52efed2ea82b1ec2cb92'](___arguments.context.appData, 'Tyre L3', ___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/cc558d4d15cbd1498986b71895e1681a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L4')) == null) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L4'));
  Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre L4',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
  await new Promise(r => setTimeout(r, 200 || 0));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var error, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Style = ({ [`backgroundColor`]: (await BackendlessUI.Functions.Custom['fn_90136c37dea4943c2e93237c0dc62f72'](0, 100, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L4')), 'Life')), 100)) });

  } catch (error) {

  } finally {
    if (error) {
      Style = null;
    }

  }

  return Style

  },
  /* handler:onStyleAssignment */
  /* handler:onLoad */
  async ['onLoad'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L4')), 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'Assets Drawer - Selected Tyre objectId'))) {
    Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L4'));
    Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre L4',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
    ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
    await new Promise(r => setTimeout(r, 200 || 0));
    ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;
  }

  },
  /* handler:onLoad */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/ddb74d16fdab8556f997dc3fcadbb4ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L4')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Tyre, item, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence, New_Tyre_Number, Last_tyre_number_of_digits, Tyre_Sequence_List, j;


  await BackendlessUI.Functions.Custom['fn_b3cdf4a3ed5a52efed2ea82b1ec2cb92'](___arguments.context.appData, 'Tyre L4', ___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/f4979aa56d64aa949a27d53874d1dd32/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R4')) == null) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R4'));
  Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre R4',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
  await new Promise(r => setTimeout(r, 200 || 0));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var error, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Style = ({ [`backgroundColor`]: (await BackendlessUI.Functions.Custom['fn_90136c37dea4943c2e93237c0dc62f72'](0, 100, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R4')), 'Life')), 100)) });

  } catch (error) {

  } finally {
    if (error) {
      Style = null;
    }

  }

  return Style

  },
  /* handler:onStyleAssignment */
  /* handler:onLoad */
  async ['onLoad'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R4')), 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'Assets Drawer - Selected Tyre objectId'))) {
    Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R4'));
    Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre R4',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
    ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
    await new Promise(r => setTimeout(r, 200 || 0));
    ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;
  }

  },
  /* handler:onLoad */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/5f46c76249a5e80ee83df6fadb614604/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R4')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Tyre, item, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence, New_Tyre_Number, Last_tyre_number_of_digits, Tyre_Sequence_List, j;


  await BackendlessUI.Functions.Custom['fn_b3cdf4a3ed5a52efed2ea82b1ec2cb92'](___arguments.context.appData, 'Tyre R4', ___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/0056e22560d5339b19d35b21bc0cf1b8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R3')) == null) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R3'));
  Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre R3',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
  await new Promise(r => setTimeout(r, 200 || 0));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var error, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Style = ({ [`backgroundColor`]: (await BackendlessUI.Functions.Custom['fn_90136c37dea4943c2e93237c0dc62f72'](0, 100, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R3')), 'Life')), 100)) });

  } catch (error) {

  } finally {
    if (error) {
      Style = null;
    }

  }

  return Style

  },
  /* handler:onStyleAssignment */
  /* handler:onLoad */
  async ['onLoad'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R3')), 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'Assets Drawer - Selected Tyre objectId'))) {
    Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R3'));
    Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre R3',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
    ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
    await new Promise(r => setTimeout(r, 200 || 0));
    ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;
  }

  },
  /* handler:onLoad */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/34c288ddf1ab92a2ab9c5e9740c4f649/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R3')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_b3cdf4a3ed5a52efed2ea82b1ec2cb92'](___arguments.context.appData, 'Tyre R3', ___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/a643392164339d450d2cf32e2483e634/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R2')) == null) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R2'));
  Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre R2',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
  await new Promise(r => setTimeout(r, 200 || 0));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var error, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Style = ({ [`backgroundColor`]: (await BackendlessUI.Functions.Custom['fn_90136c37dea4943c2e93237c0dc62f72'](0, 100, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R2')), 'Life')), 100)) });

  } catch (error) {

  } finally {
    if (error) {
      Style = null;
    }

  }

  return Style

  },
  /* handler:onStyleAssignment */
  /* handler:onLoad */
  async ['onLoad'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R2')), 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'Assets Drawer - Selected Tyre objectId'))) {
    Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R2'));
    Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre R2',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
    ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
    await new Promise(r => setTimeout(r, 200 || 0));
    ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;
  }

  },
  /* handler:onLoad */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/e534c5b6775be65a0a038f3f1026e4f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R2')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Tyre, item, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence, New_Tyre_Number, Last_tyre_number_of_digits, Tyre_Sequence_List, j;


  await BackendlessUI.Functions.Custom['fn_b3cdf4a3ed5a52efed2ea82b1ec2cb92'](___arguments.context.appData, 'Tyre R2', ___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/2641bff90cf9bb35806600f96bf7a9fb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R1')) == null) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R1'));
  Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre R1',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
  await new Promise(r => setTimeout(r, 200 || 0));
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;

  },
  /* handler:onClick */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var error, Style;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Style = ({ [`backgroundColor`]: (await BackendlessUI.Functions.Custom['fn_90136c37dea4943c2e93237c0dc62f72'](0, 100, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R1')), 'Life')), 100)) });

  } catch (error) {

  } finally {
    if (error) {
      Style = null;
    }

  }

  return Style

  },
  /* handler:onStyleAssignment */
  /* handler:onLoad */
  async ['onLoad'](___arguments) {
    var Selected_Tyre;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R1')), 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'Assets Drawer - Selected Tyre objectId'))) {
    Selected_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R1'));
    Selected_Tyre = (Object.assign(Selected_Tyre, ({ [`Selected Tyre Position`]: 'Tyre R1',[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Axle objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')) })));
    ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = Selected_Tyre;
    await new Promise(r => setTimeout(r, 200 || 0));
    ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'] = true;
  }

  },
  /* handler:onLoad */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/5348ab212ec52b8592f77e89eb96d86a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R1')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var New_Tyre_Number, Last_tyre_number_of_digits, item, Tyre_Sequence_List, j, New_Tyre, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence;


  await BackendlessUI.Functions.Custom['fn_b3cdf4a3ed5a52efed2ea82b1ec2cb92'](___arguments.context.appData, 'Tyre R1', ___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/665d5741f5664a4b56317c6d16e7b42f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyres Per Axle')) > 2) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/7234dfd89afdb358d9cb7a99ea254305/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyres Per Axle')) > 4) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/56289e3dbae16ee95a3cb43fa1a9486d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyres Per Axle')) > 6) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/7b1b6d18296af70b5d48da3e11683a98/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyres Per Axle')) > 6) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/b2ae7601e43e76852d6425cfc6a953b2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyres Per Axle')) > 4) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/16c4254a375b8043968cd4dd841fb5ef/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyres Per Axle')) > 2) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/bad8806dd5a12b16b7e865254834ffc4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')) == 'Spare') {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/c2a2e07e943a927e3b2123fd74c934fd/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* handler:onStyleAssignment */
  async ['onStyleAssignment'](___arguments) {
    var Object2, item, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  try {
    if ((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5842d09917c4ccae6ec24c4aeb681b41')), 'dataStore')), 'objectId')) == (getObjectProperty(((await asyncListSort((await asyncListFilter(___arguments.context.rootComponentData, async (item) => {


     return ((getObjectProperty(item, 'Type')) == 'Steer');
    })), 1, async (item) => {


     return (getObjectProperty(item, 'Position Number'));
    })).slice(-1)[0]), 'objectId'))) {
      Object2 = ({ [`marginRight`]: '50px' });
    }

  } catch (error) {

  }

  return Object2

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/3282fc0d905eb5bff0dfd5821d53fcca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      try {
    delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'];

  } catch (error) {

  }
  try {
    delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'];

  } catch (error) {

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/e65e326df2da8f08140924986638102b/bundle.js', [], () => ({
  /* content */
  /* handler:InputLogic */
  ['InputLogic'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Life'));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:InputLogic */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/ab93966195bd1056ed9c0d5634dc728e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'ID'));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/08011b25c33261bde27d246dcfd2846e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Make'));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/cd3365f8266ecfe90199bea2a6fa0dfa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Model'));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/afa599411c97c525b5c7140e15b9ad5a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Type'));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/09b92a4bbaba839ff694f047f1d3121a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'State'));

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/faeaadb79fd20bc1b255e4333be527da/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Mileage_Current')) + String(' km');

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/8b27eb5abd88bebcc7f1bfacfb242ca3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var Input, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    Input = String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Mileage_Expected')) + String(' km');

  } catch (error) {

  } finally {
    if (error) {
      Input = null;
    }

  }

  return Input

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/74d20be63b9a36cdc66a961761f3e851/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6')['Edit'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Visability, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Edit')) == true) {
      Visability = false;
    } else {
      Visability = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/e30601632f96bfcf7e16b5930fb5719a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Visability, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Edit')) == true) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/4562ae5b90134b6d23c437f9e4aa1cad/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Edit')) == true) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/4f4ce37f269e174fff5773d6e61231a9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Edit')) == true) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/cd0d7f46b75c96ee85691b08b8fd97cd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Visability, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Edit')) == true) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/06db96e24c437fe2d5a943d3b9a3e9b4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var Visability, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Edit')) == true) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  delete ___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6')['Edit'];
  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'State')) == 'New') {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'))['Cost_New'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'New Cost'));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'State')) == 'Cap 1') {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'))['Cost_Cap1'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'New Cost'));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'State')) == 'Cap 2') {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'))['Cost_Cap2'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'New Cost'));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'State')) == 'Cap 3') {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'))['Cost_Cap3'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'New Cost'));
  }
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'))['Mileage_Expected'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'New Mileage'));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'))['Make'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Make'));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'))['Model'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Model'));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'))['Type'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Type'));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'))['Mileage_Remaining'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'New Mileage')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Mileage_Current')));
  console.log((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'New Mileage')) - (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Mileage_Current')));
  console.log(100 - ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Mileage_Current')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'New Mileage'))) * 100);
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'))['Life'] = (100 - ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Mileage_Current')) / (getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'New Mileage'))) * 100);
  await Backendless.Data.of('Tyres').save( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')) );
  console.log(___arguments.context.rootComponentData);
  console.log(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'));
  console.log(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/897c440f4bb815ddebbb6b63b70fba98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6')['Swap Clause'] = (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Tractor_ObjectId IS NULL AND Trailer_ObjectId IS NULL AND Type = \'',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Type')),'\' AND State = \'',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'State')),'\' AND Status = \'All In Order\''].join(''));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('3e2f88ae2cec706d258dd5440ff862de', undefined);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('960f9de120e9f96db1a4e98b40c1cdc1', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Type')));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('fd7e51a3f544ed289fc123ee7571c5e4', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'State')));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/994a2c437649d4f173e40b7797bd76f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Tyre Data View')) == true) {
      if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Swap')) == true) {
        await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('3e2f88ae2cec706d258dd5440ff862de', undefined);
      }
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* handler:onContainerDataAssignment */
  async ['onContainerDataAssignment'](___arguments) {
    var Data_Model, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.rootComponentData, 'Selected Tyre'))))) {
      Data_Model = null;
    } else {
      Data_Model = (getObjectProperty(___arguments.context.rootComponentData, 'Selected Tyre'));
    }

  } catch (error) {

  } finally {
    if (error) {
      Data_Model = null;
    }

  }

  return Data_Model

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/5d99edafce6ef5abda992892cd7b67d8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L1')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/c102645f75165fa90c5201125aec8bc1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L2')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/45be6b4a84bddd6ba21312c17896b70b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L3')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/b21eec1e10d459ebed1a547ca4fb1f6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L4')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/bce2a0312a359b21a76f37a577027cce/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R4')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/20b32f5d6366993d4927c6cd8a14300a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R3')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/b3d46b3a9e920b5620dfed46235e90ff/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R2')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/740db42f383259ef56210892813cbff2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Viewer;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R1')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId'))) {
      Viewer = true;
    } else {
      Viewer = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/ef2c370f0666633f4393c33e4b8c68c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, New_Tyre_Number, Last_tyre_number_of_digits, item, Tyre_Sequence_List, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence, New_Tyre, Tyre_Position;

/**
 * Describe this function...
 */
async function Variable_Reset() {
  item = null;
  j = null;
  Last_tyre_number_of_digits = null;
  New_Tyre = null;
  New_Tyre_Number = null;
  New_Tyre_Operation_Refrence = null;
  Tyre_Creation_API_Call = null;
  Tyre_Sequence_List = null;
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function Bulk_Creator_Logic(j) {
  if ((getObjectProperty(j, 'Tyres Per Axle')) == 1) {
    await Actual_Code('Tyre L1', j);
  } else if ((getObjectProperty(j, 'Tyres Per Axle')) == 2) {
    await Actual_Code('Tyre L1', j);
    await Actual_Code('Tyre R1', j);
  } else if ((getObjectProperty(j, 'Tyres Per Axle')) == 4) {
    await Actual_Code('Tyre L1', j);
    await Actual_Code('Tyre R1', j);
    await Actual_Code('Tyre L2', j);
    await Actual_Code('Tyre R2', j);
  } else if ((getObjectProperty(j, 'Tyres Per Axle')) == 6) {
    await Actual_Code('Tyre L1', j);
    await Actual_Code('Tyre R1', j);
    await Actual_Code('Tyre L2', j);
    await Actual_Code('Tyre R2', j);
    await Actual_Code('Tyre L3', j);
    await Actual_Code('Tyre R3', j);
  } else if ((getObjectProperty(j, 'Tyres Per Axle')) == 8) {
    await Actual_Code('Tyre L1', j);
    await Actual_Code('Tyre R1', j);
    await Actual_Code('Tyre L2', j);
    await Actual_Code('Tyre R2', j);
    await Actual_Code('Tyre L3', j);
    await Actual_Code('Tyre R3', j);
    await Actual_Code('Tyre L4', j);
    await Actual_Code('Tyre R4', j);
  }
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Actual_Code(Tyre_Position, j) {
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, Tyre_Position))))) {
    Tyre_Creation_API_Call = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tyre_Creation_API_Call;

      New_Tyre = ({ [`Cost_New`]: 5500,[`Cost_Total`]: 5500,[`ID`]: await Tyre_ID(),[`Make`]: 'System',[`Model`]: 'Generated',[`Mileage1`]: 0,[`Mileage2`]: 0,[`Mileage3`]: 0,[`Mileage4`]: 0,[`Mileage_Expected`]: 80000,[`State`]: 'New',[`Status`]: 'All In Order',[`Type`]: (getObjectProperty(j, 'Type')),[`Warehouse`]: 'Out',[`ownerId`]: (getObjectProperty(j, 'ownerId')) });
      _uow.create('Tyres', New_Tyre).setOpResultId('New Tyre Operation Refrence');
      New_Tyre_Operation_Refrence = 'New Tyre Operation Refrence';
      _uow.setRelation('Tyres', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)), 'Axle', [(getObjectProperty(j, 'objectId'))]);
      _uow.setRelation('Tyres', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Parent ID (Tractor)')))) ? 'Currently_On_Trailer' : 'Currently_On_Tractor'), ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Parent ID (Tractor)')))) ? [(getObjectProperty(j, 'Parent ID (Trailer)'))] : [(getObjectProperty(j, 'Parent ID (Tractor)'))]));
      _uow.addToRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Parent ID (Tractor)'))))) {
        _uow.addToRelation('Trailers', (getObjectProperty(j, 'Parent ID (Trailer)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
      } else {
        _uow.addToRelation('Tractors', (getObjectProperty(j, 'Parent ID (Tractor)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
      }
      _uow.setRelation('Axles', (getObjectProperty(j, 'objectId')), Tyre_Position, (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)));

    })();

    New_Tyre = (await Tyre_Creation_API_Call.execute());
    console.log(New_Tyre);
    try {
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));

    } catch (error) {

    }
    try {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Parent ID (Tractor)'))))) {
        addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


         return ((getObjectProperty(j, 'Parent ID (Trailer)')) == (getObjectProperty(item, 'objectId')));
        }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
      } else {
        addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


         return ((getObjectProperty(j, 'Parent ID (Tractor)')) == (getObjectProperty(item, 'objectId')));
        }))[0]), 'Tyres')), (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result')));
      }

    } catch (error) {

    }
    try {
      j[Tyre_Position] = (getObjectProperty((getObjectProperty((getObjectProperty(New_Tyre, 'results')), 'New Tyre Operation Refrence')), 'result'));

    } catch (error) {

    }
  }
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function Tyre_ID() {
  Tyre_Sequence_List = [];
  var j_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    addItemToList(Tyre_Sequence_List, (Number((subsequenceFromEndLast((getObjectProperty(j, 'ID')), 5)))));
  }
  New_Tyre_Number = (await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1;
  Last_tyre_number_of_digits = getValueLength(((await asyncListSort(Tyre_Sequence_List, 1, async (item) => {


   return item;
  })).slice(-1)[0] + 1));
  return String(subsequenceFirstFromEnd((getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres'))[0]), 'ID')), 6)) + String(Last_tyre_number_of_digits == 1 ? String('00000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 2 ? String('0000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 3 ? String('000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 4 ? String('00') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 5 ? String('0') + String(New_Tyre_Number) : New_Tyre_Number)))))
}


  var j_list = ___arguments.context.rootComponentData;
  for (var j_index in j_list) {
    j = j_list[j_index];
    await Bulk_Creator_Logic(j);
  }
  await Variable_Reset();

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/4e858c4e05e6908ab47f902182ba091f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, Returned_ID, New_Tyre_Number, Last_tyre_number_of_digits, Tyre_Sequence_List, Tyre_Creation_API_Call, New_Tyre_Operation_Refrence, New_Tyre, item, Tyre_Position, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function Tyre_ID() {
  if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'TyreAvailable')) === null) {
    New_Tyre_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'TyreNext'));
    (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))['TyreNext'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'TyreNext')) + 1);
  } else {
    New_Tyre_Number = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'TyreAvailable'));
    (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))['TyreAvailable'] = null;
  }
  Last_tyre_number_of_digits = getValueLength(New_Tyre_Number);
  Returned_ID = String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'ID Tag Tyres')) + String(Last_tyre_number_of_digits == 1 ? String('00000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 2 ? String('0000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 3 ? String('000') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 4 ? String('00') + String(New_Tyre_Number) : (Last_tyre_number_of_digits == 5 ? String('0') + String(New_Tyre_Number) : New_Tyre_Number)))));
  return Returned_ID
}

/**
 * Describe this function...
 */
async function Bulk_Creator_Logic(j) {
  if ((getObjectProperty(j, 'Tyres Per Axle')) == 1) {
    await Actual_Code('Tyre L1', j);
  } else if ((getObjectProperty(j, 'Tyres Per Axle')) == 2) {
    await Actual_Code('Tyre L1', j);
    await Actual_Code('Tyre R1', j);
  } else if ((getObjectProperty(j, 'Tyres Per Axle')) == 4) {
    await Actual_Code('Tyre L1', j);
    await Actual_Code('Tyre R1', j);
    await Actual_Code('Tyre L2', j);
    await Actual_Code('Tyre R2', j);
  } else if ((getObjectProperty(j, 'Tyres Per Axle')) == 6) {
    await Actual_Code('Tyre L1', j);
    await Actual_Code('Tyre R1', j);
    await Actual_Code('Tyre L2', j);
    await Actual_Code('Tyre R2', j);
    await Actual_Code('Tyre L3', j);
    await Actual_Code('Tyre R3', j);
  } else if ((getObjectProperty(j, 'Tyres Per Axle')) == 8) {
    await Actual_Code('Tyre L1', j);
    await Actual_Code('Tyre R1', j);
    await Actual_Code('Tyre L2', j);
    await Actual_Code('Tyre R2', j);
    await Actual_Code('Tyre L3', j);
    await Actual_Code('Tyre R3', j);
    await Actual_Code('Tyre L4', j);
    await Actual_Code('Tyre R4', j);
  }
}

/**
 * Describe this function...
 */
async function Variable_Reset() {
  item = null;
  j = null;
  Last_tyre_number_of_digits = null;
  New_Tyre = null;
  New_Tyre_Number = null;
  New_Tyre_Operation_Refrence = null;
  Tyre_Creation_API_Call = null;
  Tyre_Sequence_List = null;
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function Actual_Code(Tyre_Position, j) {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b0d124c3ec732705405e1ea200734e5a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('75f7c99ba0de6505b305345b6318c8fa', false);
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, Tyre_Position))))) {
    Tyre_Creation_API_Call = (new Backendless.UnitOfWork('REPEATABLE_READ'));
    await ( async () => {
      const _uow = Tyre_Creation_API_Call;

      New_Tyre = ({ [`Cost_New`]: 5500,[`Cost_Total`]: 5500,[`ID`]: await Tyre_ID(),[`Make`]: 'System',[`Model`]: 'Generated',[`Mileage1`]: 0,[`Mileage2`]: 0,[`Mileage3`]: 0,[`Mileage4`]: 0,[`Mileage_Expected`]: 80000,[`Selected Tyre Position`]: Tyre_Position,[`State`]: 'New',[`Status`]: 'All In Order',[`Type`]: (getObjectProperty(j, 'Type')),[`Tractor_ObjectId`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Parent ID (Tractor)')))) ? null : (getObjectProperty(j, 'Parent ID (Tractor)')),[`Trailer_ObjectId`]: (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Parent ID (Trailer)')))) ? null : (getObjectProperty(j, 'Parent ID (Trailer)')),[`Warehouse`]: 'Out',[`ownerId`]: (getObjectProperty(j, 'ownerId')) });
      _uow.create('Tyres', New_Tyre).setOpResultId('New Tyre Operation Refrence');
      New_Tyre_Operation_Refrence = 'New Tyre Operation Refrence';
      _uow.setRelation('Tyres', (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)), 'Axle', [(getObjectProperty(j, 'objectId'))]);
      _uow.update('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')));
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Parent ID (Tractor)'))))) {
        _uow.addToRelation('Trailers', (getObjectProperty(j, 'Parent ID (Trailer)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
      } else {
        _uow.addToRelation('Tractors', (getObjectProperty(j, 'Parent ID (Tractor)')), 'Tyres', [(Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence))]);
      }
      _uow.setRelation('Axles', (getObjectProperty(j, 'objectId')), Tyre_Position, (Tyre_Creation_API_Call.getOpResultById(New_Tyre_Operation_Refrence)));

    })();

    New_Tyre = (getObjectProperty((getObjectProperty((getObjectProperty((await Tyre_Creation_API_Call.execute()), 'results')), 'New Tyre Operation Refrence')), 'result'));
    try {
      New_Tyre['Axle'] = ({ [`Parent ID (Tractor)`]: (getObjectProperty(j, 'Parent ID (Tractor)')),[`Parent ID (Trailer)`]: (getObjectProperty(j, 'Parent ID (Trailer)')),[`Position Number`]: (getObjectProperty(j, 'Position Number')),[`Tag`]: (getObjectProperty(j, 'Tag')),[`Tag Rate`]: (getObjectProperty(j, 'Tag Rate')),[`Type`]: (getObjectProperty(j, 'Type')),[`Tyres Per Axle`]: (getObjectProperty(j, 'Tyres Per Axle')),[`created`]: (getObjectProperty(j, 'created')),[`objectId`]: (getObjectProperty(j, 'objectId')),[`ownerId`]: (getObjectProperty(j, 'ownerId')),[`updated`]: (getObjectProperty(j, 'updated')) });

    } catch (error) {
      console.log(error);

    }
    console.log(New_Tyre);
    try {
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres')), New_Tyre);

    } catch (error) {

    }
    try {
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Parent ID (Tractor)'))))) {
        addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


         return ((getObjectProperty(j, 'Parent ID (Trailer)')) == (getObjectProperty(item, 'objectId')));
        }))[0]), 'Tyres')), New_Tyre);
      } else {
        addItemToList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


         return ((getObjectProperty(j, 'Parent ID (Tractor)')) == (getObjectProperty(item, 'objectId')));
        }))[0]), 'Tyres')), New_Tyre);
      }

    } catch (error) {

    }
    try {
      j[Tyre_Position] = New_Tyre;

    } catch (error) {

    }
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('75f7c99ba0de6505b305345b6318c8fa', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b0d124c3ec732705405e1ea200734e5a', false);
}


  var j_list = ___arguments.context.rootComponentData;
  for (var j_index in j_list) {
    j = j_list[j_index];
    await Bulk_Creator_Logic(j);
  }
  await Variable_Reset();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var Viewer, error, Counter, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  Counter = 0;
  try {
    var j_list = ___arguments.context.rootComponentData;
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Tyre L1')))) == true && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Tyre L2')))) == true && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Tyre L3')))) == true && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Tyre L4')))) == true && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Tyre R4')))) == true && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Tyre R3')))) == true && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Tyre R2')))) == true && (await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(j, 'Tyre R1')))) == true) {
        Counter = Counter + 1;
      }
    }

  } catch (error) {

  }
  try {
    if (Counter == 0) {
      Viewer = false;
    } else {
      Viewer = true;
    }

  } catch (error) {

  } finally {
    if (error) {
      Viewer = false;
    }

  }

  return Viewer

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/c4b95e1a0b620dc9d8380ba1cbe43bde/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var Transaction, item, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function do_something() {
  while (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Delete Approval')) == true)) {
    await new Promise(r => setTimeout(r, 500 || 0));
  }
  removeItemInList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId');
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Parent ID (Tractor)'))))) {
    try {
      removeItemInList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


       return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Parent ID (Trailer)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId');

    } catch (error) {
      console.log(error);

    }
    ((await asyncListFilter((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Parent ID (Trailer)')) == (getObjectProperty(item, 'objectId')));
    }))[0]), 'Axles_Data')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Axle objectId')));
    }))[0])[(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Selected Tyre Position'))] = null;
  } else {
    try {
      removeItemInList((getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


       return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Parent ID (Tractor)')) == (getObjectProperty(item, 'objectId')));
      }))[0]), 'Tyres')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId');

    } catch (error) {
      console.log(error);

    }
  }
  ((await asyncListFilter(___arguments.context.rootComponentData, async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Axle objectId')));
  }))[0])[(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Selected Tyre Position'))] = null;
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    _uow.deleteRelation('Axles', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Axle objectId')), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Selected Tyre Position')), [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'))]);
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Parent ID (Tractor)'))))) {
      _uow.deleteRelation('Trailers', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Parent ID (Trailer)')), 'Tyres', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'))]);
    } else {
      _uow.deleteRelation('Tractors', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Parent ID (Tractor)')), 'Tyres', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'))]);
    }
    _uow.deleteRelation('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tyres', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'))]);
    _uow.delete('Tyres', (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'objectId')));

  })();

  console.log((await Transaction.execute()));
  delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'];
  delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Delete Approval'];
  delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'];
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('2dad3ea7640fedd333fbaafd7dc76f75');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/2dad3ea7640fedd333fbaafd7dc76f75/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var Position, Changed_Axle, Axle, item, Changed_Trailer, Trailer, Changed_Tractor, Tractor, Transaction, Old_Tyre, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Old_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'));
  Tractor = (getObjectProperty(Old_Tyre, 'Tractor_ObjectId'));
  Trailer = (getObjectProperty(Old_Tyre, 'Trailer_ObjectId'));
  Axle = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Axle'));
  Position = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Selected Tyre Position'));
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Old_Tyre['Tractor_ObjectId'] = null;
    Old_Tyre['Warehouse'] = 'In';
    Old_Tyre['Trailer_ObjectId'] = null;
    Old_Tyre['Status'] = 'Scrapped';
    delete Old_Tyre['Parent ID (Trailer)'];
    delete Old_Tyre['Parent ID (Tractor)'];
    delete Old_Tyre['Axle objectId'];
    (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company'))['TyreAvailable'] = (getObjectProperty(Old_Tyre, 'IDNumber'));
    _uow.update('Companies', (getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')));
    _uow.deleteRelation('Tyres', Old_Tyre, 'Axle', [Axle]);
    try {
      _uow.deleteRelation('Tractors', Tractor, 'Tyres', [Old_Tyre]);

    } catch (error) {
      console.log(error);

    }
    try {
      _uow.deleteRelation('Tractors', Trailer, 'Tyres', [Old_Tyre]);

    } catch (error) {
      console.log(error);

    }
    _uow.deleteRelation('Axles', Axle, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Selected Tyre Position')), [Old_Tyre]);
    _uow.delete('Tyres', Old_Tyre);
    delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'];

  })();

  console.log((await Transaction.execute()));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Trailer))) {
    Changed_Tractor = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == Tractor);
    }))[0];
    Changed_Axle = (await asyncListFilter((getObjectProperty(Changed_Tractor, 'Axles_Data')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(Axle, 'objectId')));
    }))[0];
    Changed_Axle[Position] = null;
  } else {
    Changed_Trailer = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == Trailer);
    }))[0];
    Changed_Axle = (await asyncListFilter((getObjectProperty(Changed_Trailer, 'Axles_Data')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(Axle, 'objectId')));
    }))[0];
    Changed_Axle[Position] = null;
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2dad3ea7640fedd333fbaafd7dc76f75');
  delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'];
  await new Promise(r => setTimeout(r, 200 || 0));
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('06f6535726c19eb2611a6d8946712956');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('b013a1833365e719232fb03973284167');

  } catch (error) {
    console.log(error);

  }
  delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'];

  },
  /* handler:onSubmit */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2dad3ea7640fedd333fbaafd7dc76f75');

  },
  /* handler:onClose */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/b5fe0cc31d5742a8db7341623c072b8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('3e2f88ae2cec706d258dd5440ff862de', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/fdaa7e8963d83a780b983707fa948291/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    var Clause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Swap Clause'))))) {
    Clause = ['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Tractor_ObjectId IS NULL AND Trailer_ObjectId IS NULL AND Status = \'All In Order\''].join('');
  } else {
    Clause = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Swap Clause'));
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('28972f87ac11bdd25692964bcfada81c');
  ___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6')['Selected Tyre For Swap'] = ___arguments.selectedRecord;

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/960f9de120e9f96db1a4e98b40c1cdc1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6')['Swap Clause'] = (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Tractor_ObjectId IS NULL AND Trailer_ObjectId IS NULL AND Type = \'',___arguments.value,'\' AND State = \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fd7e51a3f544ed289fc123ee7571c5e4')), 'value')),'\' AND Status = \'All In Order\''].join(''));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/28972f87ac11bdd25692964bcfada81c/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('28972f87ac11bdd25692964bcfada81c');

  },
  /* handler:onClose */
  /* handler:contentLogic */
  async ['contentLogic'](___arguments) {
    var Content;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Selected Tyre For Swap'))))) {
    Content = '';
  } else {
    Content = ['Tyre ID:','\t\t',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Selected Tyre For Swap')), 'Tyre_ID')),'\n','Serial Number:',' (',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Selected Tyre For Swap')), 'Serial_Number')),')'].join('');
  }

  return Content

  },
  /* handler:contentLogic */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var Axle, New_Tyre, Position, Changed_Axle, item, Changed_Trailer, Trailer, Changed_Tractor, Tractor, Transaction, Old_Tyre, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  New_Tyre = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Selected Tyre For Swap')), 'objectId')), ));
  Old_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'));
  Tractor = (getObjectProperty(Old_Tyre, 'Tractor_ObjectId'));
  Trailer = (getObjectProperty(Old_Tyre, 'Trailer_ObjectId'));
  Axle = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Axle'));
  Position = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Selected Tyre Position'));
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  try {
    New_Tyre['Tractor_ObjectId'] = Tractor;

  } catch (error) {
    console.log(error);

  }
  try {
    New_Tyre['Trailer_ObjectId'] = Trailer;

  } catch (error) {
    console.log(error);

  }
  New_Tyre['Warehouse'] = 'Out';
  Old_Tyre['Tractor_ObjectId'] = null;
  Old_Tyre['Trailer_ObjectId'] = null;
  delete Old_Tyre['Axle objectId'];
  delete Old_Tyre['Parent ID (Trailer)'];
  delete Old_Tyre['Parent ID (Tractor)'];
  Old_Tyre['Warehouse'] = 'In';
  await ( async () => {
    const _uow = Transaction;

    try {
      _uow.deleteRelation('Tractors', Tractor, 'Tyres', [Old_Tyre]);

    } catch (error) {
      console.log(error);

    }
    try {
      _uow.deleteRelation('Trailers', Tractor, 'Tyres', [Old_Tyre]);

    } catch (error) {
      console.log(error);

    }
    try {
      _uow.addToRelation('Tractors', Tractor, 'Tyres', [New_Tyre]);

    } catch (error) {
      console.log(error);

    }
    if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Trailer))) {
    } else {
      try {
        _uow.addToRelation('Trailers', Trailer, 'Tyres', [New_Tyre]);

      } catch (error) {
        console.log(error);

      }
    }
    _uow.setRelation('Axles', Axle, Position, [New_Tyre]);
    _uow.deleteRelation('Tyres', Old_Tyre, 'Axle', [Axle]);
    _uow.setRelation('Tyres', New_Tyre, 'Axle', [Axle]);
    _uow.update('Tyres', Old_Tyre);
    _uow.update('Tyres', New_Tyre);

  })();

  console.log((await Transaction.execute()));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Trailer))) {
    Changed_Tractor = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == Tractor);
    }))[0];
    Changed_Axle = (await asyncListFilter((getObjectProperty(Changed_Tractor, 'Axles_Data')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(Axle, 'objectId')));
    }))[0];
    Changed_Axle[Position] = New_Tyre;
  } else {
    Changed_Trailer = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == Trailer);
    }))[0];
    Changed_Axle = (await asyncListFilter((getObjectProperty(Changed_Trailer, 'Axles_Data')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(Axle, 'objectId')));
    }))[0];
    Changed_Axle[Position] = New_Tyre;
  }
  New_Tyre['Axle'] = Axle;
  delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'];
  delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'];
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('28972f87ac11bdd25692964bcfada81c');
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('3e2f88ae2cec706d258dd5440ff862de', undefined);

  },
  /* handler:onSubmit */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/d37d3edf8ae2119c74a364b21c8bd458/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('17a1ea2f28289f23db1477a52de4491e');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/17a1ea2f28289f23db1477a52de4491e/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('17a1ea2f28289f23db1477a52de4491e');

  },
  /* handler:onClose */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var Axle, Changed_Axle, Changed_Tractor, Changed_Trailer, error, item, Old_Tyre, Position, Tractor, Trailer, Transaction;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  Old_Tyre = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre'));
  Tractor = (getObjectProperty(Old_Tyre, 'Tractor_ObjectId'));
  Trailer = (getObjectProperty(Old_Tyre, 'Trailer_ObjectId'));
  Axle = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Axle'));
  Position = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre')), 'Selected Tyre Position'));
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    Old_Tyre['Tractor_ObjectId'] = null;
    Old_Tyre['Warehouse'] = 'In';
    Old_Tyre['Trailer_ObjectId'] = null;
    Old_Tyre['Status'] = 'In For Retread';
    Old_Tyre['State'] = ((getObjectProperty(Old_Tyre, 'State')) == 'New' ? 'Cap 1' : ((getObjectProperty(Old_Tyre, 'State')) == 'Cap 1' ? 'Cap 2' : ((getObjectProperty(Old_Tyre, 'State')) == 'Cap 2' ? 'Cap 3' : 'Cap 3')));
    delete Old_Tyre['Parent ID (Trailer)'];
    delete Old_Tyre['Parent ID (Tractor)'];
    delete Old_Tyre['Axle objectId'];
    _uow.deleteRelation('Tyres', Old_Tyre, 'Axle', [Axle]);
    _uow.deleteRelation('Axles', Axle, Position, [Old_Tyre]);
    try {
      _uow.deleteRelation('Tractors', Tractor, 'Tyres', [Old_Tyre]);

    } catch (error) {
      console.log(error);

    }
    try {
      _uow.deleteRelation('Tractors', Trailer, 'Tyres', [Old_Tyre]);

    } catch (error) {
      console.log(error);

    }
    _uow.update('Tyres', Old_Tyre);
    delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'];

  })();

  console.log((await Transaction.execute()));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Trailer))) {
    Changed_Tractor = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == Tractor);
    }))[0];
    Changed_Axle = (await asyncListFilter((getObjectProperty(Changed_Tractor, 'Axles_Data')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(Axle, 'objectId')));
    }))[0];
    Changed_Axle[Position] = null;
  } else {
    Changed_Trailer = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == Trailer);
    }))[0];
    Changed_Axle = (await asyncListFilter((getObjectProperty(Changed_Trailer, 'Axles_Data')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(Axle, 'objectId')));
    }))[0];
    Changed_Axle[Position] = null;
  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('2dad3ea7640fedd333fbaafd7dc76f75');
  delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'];
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('06f6535726c19eb2611a6d8946712956');

  } catch (error) {
    console.log(error);

  }
  try {
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reloadData() })('b013a1833365e719232fb03973284167');

  } catch (error) {
    console.log(error);

  }
  await new Promise(r => setTimeout(r, 200 || 0));
  delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'];

  },
  /* handler:onSubmit */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/94c168c968a53d6860a7538d89c39332/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L1')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Simple Swap - Position'] = 'Tyre L1';
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Swap Clause'] = (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Tractor_ObjectId IS NULL AND Trailer_ObjectId IS NULL AND Type = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')) == 'Spare' ? 'Steer' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')),'\' AND State = \'','New','\' AND Status = \'All In Order\''].join(''));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('787de487560ab828a7b50cff246c7437', undefined);
  await new Promise(r => setTimeout(r, 300 || 0));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('a697b6a217d585c5930d9ea88117417a', ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')) == 'Spare' ? 'Steer' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type'))));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('8565814cd89f0c97d5b7d362f7767b47', 'New');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/3f680cb663f5cb56475a5afa18bcc5dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L2')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Simple Swap - Position'] = 'Tyre L2';
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Swap Clause'] = (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Tractor_ObjectId IS NULL AND Trailer_ObjectId IS NULL AND Type = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')) == 'Spare' ? 'Steer' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')),'\' AND State = \'','New','\' AND Status = \'All In Order\''].join(''));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('787de487560ab828a7b50cff246c7437', undefined);
  await new Promise(r => setTimeout(r, 300 || 0));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('a697b6a217d585c5930d9ea88117417a', ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')) == 'Spare' ? 'Steer' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type'))));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('8565814cd89f0c97d5b7d362f7767b47', 'New');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/9c280df950ef160bd03c71eede71d20f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L3')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Simple Swap - Position'] = 'Tyre L3';
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Swap Clause'] = (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Tractor_ObjectId IS NULL AND Trailer_ObjectId IS NULL AND Type = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')) == 'Spare' ? 'Steer' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')),'\' AND State = \'','New','\' AND Status = \'All In Order\''].join(''));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('787de487560ab828a7b50cff246c7437', undefined);
  await new Promise(r => setTimeout(r, 300 || 0));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('a697b6a217d585c5930d9ea88117417a', ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')) == 'Spare' ? 'Steer' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type'))));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('8565814cd89f0c97d5b7d362f7767b47', 'New');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/1d797a9b2b39728d6138df0791031632/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre L4')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Simple Swap - Position'] = 'Tyre L4';
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Swap Clause'] = (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Tractor_ObjectId IS NULL AND Trailer_ObjectId IS NULL AND Type = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')) == 'Spare' ? 'Steer' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')),'\' AND State = \'','New','\' AND Status = \'All In Order\''].join(''));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('787de487560ab828a7b50cff246c7437', undefined);
  await new Promise(r => setTimeout(r, 300 || 0));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('a697b6a217d585c5930d9ea88117417a', ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')) == 'Spare' ? 'Steer' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type'))));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('8565814cd89f0c97d5b7d362f7767b47', 'New');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/694776efc1ffa5b449acd2fc52d2ebf1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R4')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Simple Swap - Position'] = 'Tyre R4';
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Swap Clause'] = (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Tractor_ObjectId IS NULL AND Trailer_ObjectId IS NULL AND Type = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')) == 'Spare' ? 'Steer' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')),'\' AND State = \'','New','\' AND Status = \'All In Order\''].join(''));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('787de487560ab828a7b50cff246c7437', undefined);
  await new Promise(r => setTimeout(r, 300 || 0));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('a697b6a217d585c5930d9ea88117417a', ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')) == 'Spare' ? 'Steer' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type'))));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('8565814cd89f0c97d5b7d362f7767b47', 'New');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/a7534e7d81cff172db44a0b43928106c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R3')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Simple Swap - Position'] = 'Tyre R3';
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Swap Clause'] = (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Tractor_ObjectId IS NULL AND Trailer_ObjectId IS NULL AND Type = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')) == 'Spare' ? 'Steer' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')),'\' AND State = \'','New','\' AND Status = \'All In Order\''].join(''));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('787de487560ab828a7b50cff246c7437', undefined);
  await new Promise(r => setTimeout(r, 300 || 0));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('a697b6a217d585c5930d9ea88117417a', ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')) == 'Spare' ? 'Steer' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type'))));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('8565814cd89f0c97d5b7d362f7767b47', 'New');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/39a7979c064b935f5fa9aebf5dd8dcf9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R2')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Simple Swap - Position'] = 'Tyre R2';
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Swap Clause'] = (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Tractor_ObjectId IS NULL AND Trailer_ObjectId IS NULL AND Type = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')) == 'Spare' ? 'Steer' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')),'\' AND State = \'','New','\' AND Status = \'All In Order\''].join(''));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('787de487560ab828a7b50cff246c7437', undefined);
  await new Promise(r => setTimeout(r, 300 || 0));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('a697b6a217d585c5930d9ea88117417a', ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')) == 'Spare' ? 'Steer' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type'))));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('8565814cd89f0c97d5b7d362f7767b47', 'New');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/f0b582a7126407cc605a2dfeb39b357f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyre R1')) == null) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Simple Swap - Position'] = 'Tyre R1';
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Swap Clause'] = (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Tractor_ObjectId IS NULL AND Trailer_ObjectId IS NULL AND Type = \'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')) == 'Spare' ? 'Steer' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')),'\' AND State = \'','New','\' AND Status = \'All In Order\''].join(''));
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).open(event) })('787de487560ab828a7b50cff246c7437', undefined);
  await new Promise(r => setTimeout(r, 300 || 0));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('a697b6a217d585c5930d9ea88117417a', ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')) == 'Spare' ? 'Steer' : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type'))));
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('8565814cd89f0c97d5b7d362f7767b47', 'New');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/656b89f839fc9eb3bb54d6b5709dc1ec/bundle.js', [], () => ({
  /* content */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var Axle, New_Tyre, Position, Changed_Axle, item, Changed_Trailer, Trailer, Changed_Tractor, Tractor, Transaction, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  New_Tyre = (await Backendless.Data.of('Tyres').findById((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Selected Tyre For Swap')), 'objectId')), ));
  Axle = ({ [`Parent ID (Tractor)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Tractor)')),[`Parent ID (Trailer)`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Parent ID (Trailer)')),[`Position Number`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Position Number')),[`Tag`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tag')),[`Tag Rate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tag Rate')),[`Type`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Type')),[`Tyres Per Axle`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'Tyres Per Axle')),[`created`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'created')),[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'objectId')),[`ownerId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5842d09917c4ccae6ec24c4aeb681b41'), 'ownerId')) });
  Tractor = (getObjectProperty(Axle, 'Parent ID (Tractor)'));
  Trailer = (getObjectProperty(Axle, 'Parent ID (Trailer)'));
  Position = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Simple Swap - Position'));
  Transaction = (new Backendless.UnitOfWork('REPEATABLE_READ'));
  await ( async () => {
    const _uow = Transaction;

    try {
      New_Tyre['Tractor_ObjectId'] = Tractor;

    } catch (error) {
      console.log(error);

    }
    try {
      New_Tyre['Trailer_ObjectId'] = Trailer;

    } catch (error) {
      console.log(error);

    }
    New_Tyre['Warehouse'] = 'Out';
    _uow.setRelation('Axles', Axle, Position, [New_Tyre]);
    _uow.setRelation('Tyres', New_Tyre, 'Axle', [Axle]);
    _uow.update('Tyres', New_Tyre);
    ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'] = New_Tyre;

  })();

  console.log((await Transaction.execute()));
  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192'](Trailer))) {
    Changed_Tractor = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Tractors')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == Tractor);
    }))[0];
    Changed_Axle = (await asyncListFilter((getObjectProperty(Changed_Tractor, 'Axles_Data')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(Axle, 'objectId')));
    }))[0];
    Changed_Axle[Position] = New_Tyre;
  } else {
    Changed_Trailer = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'Company')), 'Trailers')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == Trailer);
    }))[0];
    Changed_Axle = (await asyncListFilter((getObjectProperty(Changed_Trailer, 'Axles_Data')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(Axle, 'objectId')));
    }))[0];
    Changed_Axle[Position] = New_Tyre;
  }
  New_Tyre['Axle'] = Axle;
  delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre'];
  await new Promise(r => setTimeout(r, 200 || 0));
  delete ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Tyre Data View'];
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('656b89f839fc9eb3bb54d6b5709dc1ec');
  await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('787de487560ab828a7b50cff246c7437', undefined);

  },
  /* handler:onSubmit */
  /* handler:onClose */
  async ['onClose'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('656b89f839fc9eb3bb54d6b5709dc1ec');

  },
  /* handler:onClose */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/fd7e51a3f544ed289fc123ee7571c5e4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6')['Swap Clause'] = (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Tractor_ObjectId IS NULL AND Trailer_ObjectId IS NULL AND Type = \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('960f9de120e9f96db1a4e98b40c1cdc1')), 'value')),'\' AND State = \'',___arguments.value,'\' AND Status = \'All In Order\''].join(''));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/1b5766fc6b4bff1c7c316817195b2eca/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('656b89f839fc9eb3bb54d6b5709dc1ec');
  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Selected Tyre For Swap'] = ___arguments.selectedRecord;

  },
  /* handler:onRecordSelect */
  /* handler:onWhereClauseAssignment */
  async ['onWhereClauseAssignment'](___arguments) {
    var Clause;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e6b811bbecc5e5fc06b8a6eb4f360192']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Swap Clause'))))) {
    Clause = ['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' ','AND Tractor_ObjectId IS NULL ','AND Trailer_ObjectId IS NULL ','AND Status = \'All In Order\''].join('');
  } else {
    Clause = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85'), 'Swap Clause'));
  }

  return Clause

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/a697b6a217d585c5930d9ea88117417a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Swap Clause'] = (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Tractor_ObjectId IS NULL AND Trailer_ObjectId IS NULL AND Type = \'',___arguments.value,'\' AND State = \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8565814cd89f0c97d5b7d362f7767b47')), 'value')),'\' AND Status = \'All In Order\''].join(''));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/8565814cd89f0c97d5b7d362f7767b47/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('f4b8be495e245cc421d318de0494ab85')['Swap Clause'] = (['ownerId = \'',(getObjectProperty((getObjectProperty(___arguments.context.appData, 'User')), 'ownerId')),'\' AND Tractor_ObjectId IS NULL AND Trailer_ObjectId IS NULL AND Type = \'',(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a697b6a217d585c5930d9ea88117417a')), 'value')),'\' AND State = \'',___arguments.value,'\' AND Status = \'All In Order\''].join(''));

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/acbcd5d965d8ad18d3f96d991eafc47d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await ( async function (componentUid, event) {  ___arguments.context.getComponentByUid(componentUid).close(event) })('787de487560ab828a7b50cff246c7437', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_515222efdc7bcc8b2901912c0a7f56d5/logic/e16d976746f2bcccecbcd88b18383cd4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var error, Visability;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('994a2c437649d4f173e40b7797bd76f6'), 'Edit')) == true) {
      Visability = true;
    } else {
      Visability = false;
    }

  } catch (error) {

  } finally {
    if (error) {
      Visability = false;
    }

  }

  return Visability

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

